var fz = Object.defineProperty;
var pz = (e, t, n) => t in e ? fz(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var It = (e, t, n) => pz(e, typeof t != "symbol" ? t + "" : t, n);
import { ref as $, shallowRef as xa, watch as Xe, computed as E, getCurrentInstance as bl, inject as Hi, onMounted as Wt, onBeforeUnmount as Ot, shallowReactive as hz, toRaw as mz, defineComponent as lt, openBlock as p, createElementBlock as h, normalizeStyle as Yt, normalizeClass as Fe, Fragment as Ce, createTextVNode as Ht, toDisplayString as y, createCommentVNode as D, renderList as ot, createVNode as tt, createElementVNode as c, createBlock as Je, unref as u, nextTick as Zt, Teleport as hi, Transition as kr, withCtx as gt, withModifiers as vt, withKeys as $a, renderSlot as En, resolveDynamicComponent as Ii, withDirectives as un, vModelText as bn, provide as wr, useSlots as vz, mergeProps as Qm, h as yz, resolveComponent as gz, vModelCheckbox as tp, getCurrentScope as k0, onScopeDispose as ny, createStaticVNode as w0, reactive as _0, defineAsyncComponent as x0, watchEffect as bz, createSlots as kz, isRef as wz, vShow as _z } from "vue";
import { Popover as xz, PopoverButton as Sz, PopoverPanel as $z, Menu as Tz, MenuButton as Az, MenuItems as Ez, MenuItem as Cz } from "@headlessui/vue";
import { ChevronDown as zz, Check as Mz } from "lucide-vue-next";
function ev(e) {
  return !!e && e.enabled && e.state === "ok";
}
const Bs = {
  "toolbar.new_folder": "New folder",
  "toolbar.upload": "Upload",
  "toolbar.search": "Search",
  "toolbar.search.placeholder": "Search by name or tag:…",
  "toolbar.view.list": "List",
  "toolbar.view.grid": "Grid",
  "toolbar.refresh": "Refresh",
  "toolbar.go_up": "Up one level",
  "ctx.open": "Open",
  "ctx.preview": "Preview",
  "ctx.download": "Download",
  "ctx.archive_create": "Create archive…",
  "ctx.archive_extract": "Extract archive…",
  "ctx.rename": "Rename",
  "ctx.delete": "Delete",
  "ctx.delete_perm": "Delete permanently",
  "ctx.restore": "Restore",
  "ctx.share": "Share",
  "ctx.move": "Move",
  "ctx.copy": "Copy",
  "ctx.cut": "Cut",
  "ctx.show_hidden": "Show hidden files",
  "ctx.hide_hidden": "Hide hidden files",
  "ctx.keep_local": "Keep on this computer",
  "ctx.keep_online": "Keep online only",
  "ctx.keep_reveal": "Open local folder",
  "ctx.keep_inherited": "Kept on this computer with its parent",
  "keep.started": "Will be kept on this computer - sync started",
  "keep.failed": "Could not keep on this computer",
  "keep.badge_kept": "On this computer",
  "keep.badge_syncing": "Syncing…",
  "keep.badge_cloud": "Online only",
  "keep.badge_partial": "Contains items kept on this computer",
  "keep.strip_transfer": "Syncing {name} - {done}/{total} ({pct}%)",
  "keep.strip_inventory": "Syncing {name} - scanning the server…",
  "keep.strip_settling": "Syncing {name} - settling…",
  "ctx.paste": "Paste",
  "ctx.info": "Info",
  "ctx.duplicate": "Duplicate",
  "ctx.new_file": "New file",
  "modal.delete.title": "Delete?",
  "modal.delete.message": "{count} items will be moved to trash.",
  "modal.delete.message_one": "{count} item will be moved to trash.",
  "modal.delete.confirm": "Move to Trash",
  "modal.delete.working": "Moving to Trash…",
  "modal.delete.cancel": "Cancel",
  "modal.delete.permanent_title": "Delete permanently?",
  "modal.delete.permanent_message": "{count} items will be deleted for good. This cannot be undone.",
  "modal.delete.permanent_message_one": "{count} item will be deleted for good. This cannot be undone.",
  "modal.delete.permanent_confirm": "Delete permanently",
  "modal.delete.permanent_working": "Deleting…",
  "modal.rename.title": "Rename",
  "modal.rename.save": "Save",
  "modal.rename.saving": "Renaming…",
  "modal.rename.cancel": "Cancel",
  "modal.newfolder.title": "New folder",
  "modal.newfolder.placeholder": "Folder name",
  "modal.newfolder.create": "Create",
  "modal.newfolder.creating": "Creating…",
  "modal.newfolder.cancel": "Cancel",
  "modal.share.title": "Share link",
  "archive.create_title": "Create archive",
  "archive.extract_title": "Extract archive",
  "archive.create_count": "{count} selected items",
  "archive.create_count_one": "{count} selected item",
  "archive.filename": "Archive name",
  "archive.format": "Format",
  "archive.password_optional": "Password (optional)",
  "archive.password_confirm": "Confirm password",
  "archive.password_mismatch": "Passwords do not match.",
  "archive.encrypt_names": "Encrypt file names",
  "archive.compression": "Compression",
  "archive.solid": "Create solid archive",
  "archive.dictionary_size": "Dictionary size",
  "archive.dictionary_size_value": "{n} MiB",
  "archive.dictionary_hint": "Larger dictionaries can improve compression but use more memory while creating and extracting.",
  "archive.destination_folder": "Extract to folder",
  "archive.create": "Create",
  "archive.creating": "Creating…",
  "archive.extract": "Extract",
  "archive.extract_here": "Extract here",
  "archive.extract_to_folder": "Extract to folder",
  "archive.extracting": "Extracting…",
  "archive.cancel": "Cancel",
  "archive.invalid_name": "Enter a file name without slashes.",
  "archive.invalid_extension": "Archive name must use one of the available format extensions.",
  "archive.invalid_folder": "Enter a folder name without slashes.",
  "archive.password_required": "This archive requires a password.",
  "archive.password_title": "Archive password",
  "archive.continue": "Continue",
  "archive.opening": "Opening…",
  "archive.bad_password": "The archive password is incorrect.",
  "archive.target_exists": "An item with that name already exists. Choose another name or remove it first.",
  "archive.password_charset": "A ZIP password can use only ASCII characters: unaccented letters, digits and ordinary punctuation. Choose 7z to use any characters.",
  "archive.error_unsupported": "This archive cannot be extracted: this server cannot read its format, or it holds something filex does not extract (a link, a special file, or a file whose size it does not state).",
  "archive.error_limit": "This archive is larger than the server allows to extract.",
  "archive.error_unavailable": "This server cannot open this kind of archive right now.",
  "archive.created": "Archive created",
  "archive.queued": "Archive creation is running in the background",
  "archive.extracted": "Extracted {count} files",
  "archive.extracted_one": "Extracted {count} file",
  "archive.extraction_queued": "Archive extraction is running in the background",
  "archive.preparing_extract": "Reading {name}… the whole archive is read before it can be extracted.",
  "archive.already_preparing": "Still reading {name} - it is extracted once that is done",
  "archive.extraction_completed": "Extraction completed",
  "archive.extraction_cancelled": "Extraction cancelled after {count} files",
  "archive.extraction_cancelled_one": "Extraction cancelled after {count} file",
  "modal.share.pin": "PIN protected",
  "modal.share.expires": "Expires at",
  "modal.share.max_downloads": "Download limit",
  "modal.share.create": "Share",
  "modal.share.cancel": "Cancel",
  "modal.share.close": "Close",
  "modal.share.limit_applied": "(server limit applied)",
  "modal.share.copy": "Copy",
  "modal.share.url_copied": "Link copied",
  "modal.share.pin_copied": "PIN copied",
  "modal.share.cli_copied": "CLI command copied",
  "upload.progress": "Uploading",
  "upload.done": "Done",
  "upload.error": "Error",
  "upload.failed": "Could not upload “{name}”",
  "upload.aborted": "Aborted",
  "upload.cancel": "Cancel",
  "upload.resuming": "Resuming “{name}” from {percent}%",
  "upload.saving": "Saving to the storage…",
  "empty.folder": "This folder is empty",
  "empty.search": "No results",
  loading: "Loading…",
  "notFound.title": "Folder not found",
  "notFound.desc": "This folder does not exist, was moved, or you do not have access to it.",
  "notFound.goRoot": "Go to root folder",
  "col.name": "Name",
  "col.size": "Size",
  "col.modified": "Modified",
  "col.type": "Type",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Root",
  "breadcrumb.copy_path": "Copy path",
  "breadcrumb.go_to_path": "Go to path",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Copying",
  "ops.move": "Moving",
  "ops.delete": "Deleting",
  "ops.queued": "queued",
  "ops.done": "done",
  "ops.error": "error",
  "node.trash": "Trash",
  /* gorunum:v1 - the singular kind, printed under a folder's name on a card
   * and beside it in the list. The plural section heading is a different
   * string on purpose. */
  "node.folder": "Folder",
  // --- Rich viewer chrome ---
  "viewer.open_in_new_tab": "Open in new tab",
  "viewer.loading": "Loading…",
  "viewer.failed_to_load": "Failed to load file",
  /* ⚠ Said to a PERSON: it used to tell them to "install the peer dependency". */
  "viewer.peer_not_installed": "This kind of file cannot be shown here. Download it to open it on your device.",
  "viewer.format_unsupported_3d": "The preview shows 3D models in .glb, .gltf and .usdz only. Download the file to open it in a 3D program.",
  "viewer.zoom_in": "Zoom in",
  "viewer.zoom_out": "Zoom out",
  "viewer.fit_width": "Fit width",
  "viewer.next_page": "Next page",
  "viewer.prev_page": "Previous page",
  "viewer.page_n_of_m": "Page {n} of {m}",
  "viewer.tags": "Tags",
  "viewer.layers": "Layers",
  "viewer.toc": "Contents",
  "viewer.font_smaller": "Smaller text",
  "viewer.font_larger": "Larger text",
  "viewer.search": "Search",
  "viewer.download": "Download",
  "viewer.saving": "Saving…",
  "viewer.save": "Save (Ctrl+S)",
  "viewer.saved": "Saved",
  "viewer.save_error": "Error",
  "viewer.editor_loading": "Loading editor…",
  "viewer.no_preview": "No preview for this file type yet.",
  "viewer.edit": "Edit",
  "viewer.close": "Close",
  "presence.expand": "Show names",
  "presence.collapse": "Collapse",
  "viewer.save_annotations": "Save annotations",
  "viewer.annotations_on": "Annotations: on",
  "viewer.annotations_off": "Annotations: off",
  "viewer.read_only": "Read only",
  "viewer.csv_first_row_header": "First row as header",
  "viewer.csv_filter": "Filter rows…",
  "viewer.epub_prev": "Previous",
  "viewer.epub_next": "Next",
  /* ⚠ The old sentence named an ENVIRONMENT VARIABLE to every reader
     ("operator must wire FILEX_DRAWIO_URL"). A person who only wanted to look
     at a diagram is told what they can do; `_admin` - someone who can fix it -
     is told where. */
  "viewer.drawio.disabled": "Diagrams cannot be opened here: this server has no draw.io. Download the file to open it elsewhere.",
  "viewer.drawio.disabled_admin": "draw.io is not set up on this server. Set it up in the admin panel under External services.",
  "viewer.drawio.load_failed": "This diagram could not be read. Download it to open it elsewhere.",
  "viewer.drawio.save_failed": "The diagram could not be saved. Your changes are still in the editor - try again.",
  "viewer.archive.entries": "{n} files",
  "viewer.archive.entries_one": "{n} file",
  "viewer.archive.empty": "Archive is empty.",
  "viewer.archive.error": "Could not read archive contents.",
  "viewer.archive.unsupported": "This kind of archive cannot be listed here. Download it to see what is inside.",
  "viewer.archive.too_large": "This archive is too large to list here. Download it to see what is inside.",
  "viewer.archive.open": "Open archive",
  "viewer.archive.root": "Archive",
  "viewer.archive.location": "Archive location",
  "viewer.archive.reading": "Still reading… the whole archive is read before its contents can be listed, which takes a while for a large one.",
  "viewer.name": "Name",
  "viewer.size": "Size",
  // --- cila:a - sorting / date groups / density ---
  "col.sort": "Sort",
  "group.today": "Today",
  "group.yesterday": "Yesterday",
  "group.this_week": "This week",
  "group.this_month": "This month",
  "group.no_date": "No date",
  "toolbar.density.compact": "Compact view",
  "toolbar.density.comfortable": "Comfortable view",
  // --- cila:c - command palette + shortcuts help + breadcrumb ---
  "palette.placeholder": "Search files, folders or commands…",
  "palette.files": "Files",
  "palette.commands": "Commands",
  "palette.goto": "Go to path",
  "palette.empty": "No results",
  "palette.hint": "↑↓ navigate · Enter select · Esc close",
  "cmd.view_toggle": "Toggle view (list ⇄ grid)",
  "cmd.trash": "Open trash",
  "shortcuts.title": "Keyboard shortcuts",
  "shortcuts.group.nav": "Navigation",
  "shortcuts.group.selection": "Selection",
  "shortcuts.group.file": "File operations",
  "shortcuts.palette": "Command palette",
  "shortcuts.search": "Focus search",
  "shortcuts.go_up": "Go up one level",
  "shortcuts.open": "Open selected item",
  "shortcuts.close": "Close / cancel",
  "shortcuts.toggle_hidden": "Show/hide hidden files",
  "shortcuts.help": "This help dialog",
  "shortcuts.select_all": "Select all",
  "shortcuts.star": "Star / unstar",
  "shortcuts.rename": "Rename",
  "shortcuts.delete": "Delete",
  "shortcuts.cut": "Cut",
  "shortcuts.copy": "Copy",
  "shortcuts.paste": "Paste",
  "breadcrumb.more": "Folders in between",
  // --- State screens + undo snackbar + connection badge (cila:b) ---
  "empty.hint": "Drag and drop files here",
  "empty.upload": "Upload files",
  "empty.search.title": "No files match your search",
  "empty.search.hint": "Try a different search term",
  "empty.trash.title": "Trash is empty",
  "error.title": "Could not load this folder",
  "error.retry": "Try again",
  "toast.undo": "Undo",
  "toast.undone": "Undone",
  "toast.undoing": "Undoing…",
  "toast.undo_queued": "The undo is queued - the operations panel shows when it is done",
  "toast.undo_failed": "Could not undo",
  "toast.renamed": "Renamed",
  "toast.rename_queued": "Renaming to “{name}”…",
  "toast.moved": "Moved",
  "toast.trashed": "Moved to trash",
  /* i18n:hardcoded - toast copy that used to be Turkish string literals in
     FileExplorer.vue, unreachable by any locale. */
  "toast.failed": "Operation failed",
  /* ── errorWords (lib/errorWords): how a failure is SAID. ⚠ No status code,
     no JSON, no environment variable ever reaches these; an administrator
     sees the raw words on a second line, nobody else does. ── */
  "err.status.400": "Bad request",
  "err.status.401": "Sign-in required",
  "err.status.403": "You are not allowed to do this",
  "err.status.404": "Not found",
  "err.status.409": "Already exists / conflict",
  "err.status.413": "File too large",
  "err.status.415": "Unsupported file type",
  "err.status.422": "Invalid data",
  "err.status.429": "Too many requests",
  "err.status.500": "Server error",
  "err.status.501": "Not supported",
  "err.status.502": "A connected service reported an error",
  "err.status.503": "Service unavailable",
  "err.status.504": "A connected service took too long to answer",
  "err.status.other": "The server refused this request.",
  "err.upload_stalled": "The upload stopped making progress. Try again - it continues where it stopped.",
  "err.network": "The server could not be reached. Check your connection and try again.",
  /* 0.54 (audit A1/A2): a refusal the server names is said in the SERVER's
     words (`message`, backend internal/apierr `server.error.*`); the copies
     that stood here (err.read_only, err.quota, err.e2e_*, err.name_taken,
     opc.err.*…) are gone with the tables of lib/errorWords that used them. */
  "err.save_failed": "Your changes could not be saved.",
  "err.load_failed": "This file could not be loaded.",
  "err.viewer_failed": "The viewer for this file could not be started. Download the file to open it.",
  "err.detail": "Details",
  "toast.copied": "Copied",
  "toast.deleted": "Deleted",
  "toast.cut": "Cut",
  "toast.cut_ready": "Cut - ready to paste",
  "toast.copy_ready": "Copied - ready to paste",
  "toast.same_folder_cut": "Cannot cut into the same folder",
  "toast.restored": "{n} items restored",
  "toast.restored_one": "{n} item restored",
  "toast.delete_queued": "Delete queued",
  "toast.trash_retention": "Items in the trash are removed automatically once the retention window ends. Permanent deletion is done from the admin panel.",
  /* The Trash row a permanent delete is on its way for (the admin Trash
     page's words: one sentence, both catalogues - lesson #447). */
  "trash.purging": "Deleting permanently…",
  "trash.row_busy": "Something is already being done to this item",
  "dropzone.hint": "Drop files here",
  "modal.newfolder.invalid": "Invalid character",
  "names.reserved": "“{name}” is reserved for filex’s own use. Choose another name.",
  /* ⚠ A missing or broken document server is said in words, never as the
     HTTP layer (it used to read `Config fetch 503: {"error":"onlyoffice not
     configured"}`). `_admin` is what someone who can fix it reads - where to
     fix it; everybody else reads how to get the file anyway. */
  "viewer.office_unconfigured": "Office documents cannot be opened here: this server has no ONLYOFFICE document server. Download the file to open it on your computer.",
  "viewer.office_unconfigured_admin": "ONLYOFFICE is not set up on this server, so office documents cannot be opened here. Set it up in the admin panel under External services.",
  "viewer.office_unreachable": "The document server is not answering right now. Try again later, or download the file.",
  "viewer.office_unreachable_admin": "The ONLYOFFICE document server is not answering. Check it in the admin panel under External services.",
  /* Task #92: the editor runs in a frame on another origin (the document
     server's own, or the interface origin), and that page never answered -
     the address does not reach this filex. */
  "viewer.office_frame_unreachable_admin": "The ONLYOFFICE editor frame did not load from {origin}. Check that the reverse proxy there sends the frame to filex ({env}).",
  "viewer.office_failed": "This document could not be opened in ONLYOFFICE. Download it to open it on your computer.",
  "viewer.csv_office_note": "Saved as CSV: only the values of the active sheet are kept. Formatting, formulas and other sheets are not saved.",
  "viewer.office_forbidden": "You do not have permission to open this document in ONLYOFFICE.",
  /* After ONLYOFFICE's "Download failed": which of its two failures it was,
     as filex saw it (lib/officeDiagnosis, issue #80). */
  "viewer.office_download_served": "The document server downloaded this file from filex, but your browser could not load the converted copy from the document server. Check the X-Forwarded-Proto and X-Forwarded-Host headers on the reverse proxy in front of the document server.",
  "viewer.office_download_not_requested": "The document server never asked filex for this file. If the file was opened before, the document server may be using its own copy of it.",
  "viewer.office_download_refused": "filex refused the document server’s request for this file: {reason}.",
  "viewer.office_fetch_reason.bad_link": "the address was malformed",
  "viewer.office_fetch_reason.signature_expired": "the address had expired",
  "viewer.office_fetch_reason.signature_bad": "its signature did not match (the JWT secret changed, or the address was altered)",
  "viewer.office_fetch_reason.not_found": "the file no longer exists",
  "viewer.office_fetch_reason.storage_unavailable": "the storage could not be opened",
  "viewer.office_fetch_reason.body_unavailable": "the file’s contents could not be found",
  "viewer.office_fetch_reason.object_missing": "the file is missing from the storage",
  "viewer.office_fetch_reason.read_failed": "reading the file from the storage failed",
  /* The explorer's Open on a document the document server would open, when
     there is none - shown to an administrator only (everyone else is not
     offered the entry at all; lib/serviceGate). */
  "ctx.needs_onlyoffice": "ONLYOFFICE is not set up - set it up in the admin panel under External services.",
  "ctx.needs_drawio": "draw.io is not set up - set it up in the admin panel under External services.",
  "viewer.pdf_inline_failed": "Your browser could not display this PDF inline.",
  "viewer.too_large": "File is too large (>1 MB).",
  "viewer.csv_rows": "{n} rows",
  "viewer.csv_rows_one": "{n} row",
  "presence.others": "{n} people",
  "presence.others_one": "{n} person",
  "conn.offline": "No live connection - changes may be delayed",
  "conn.tooltip": "Live connection to the server is unavailable; the list refreshes periodically. This notice disappears once the connection is back.",
  /* === bul:s3 === */
  "palette.everywhere": "Everywhere",
  "palette.searching": "Searching…",
  "palette.everywhere_failed": "The search could not be done. Try again.",
  "palette.saved": "Saved searches",
  "palette.save": "Save search",
  "palette.saved.delete": "Delete saved search",
  /* #168 - the admin panel's search (components/PanelSearch.vue). */
  "panelsearch.label": "Search the admin panel",
  "panelsearch.trigger": "Search",
  "panelsearch.placeholder": "Search pages, settings, people, apps…",
  "panelsearch.close": "Close search",
  "panelsearch.clear": "Clear the search",
  "panelsearch.results": "Search results",
  "panelsearch.group.page": "Pages",
  "panelsearch.group.setting": "Settings",
  "panelsearch.group.app": "Apps",
  "panelsearch.group.user": "Users",
  "panelsearch.group.group": "Groups",
  "panelsearch.group.key": "API keys",
  "panelsearch.group.storage": "Storages",
  "panelsearch.group.share": "Shares",
  "panelsearch.group.file": "Files",
  "panelsearch.group.recent": "Recent searches",
  "panelsearch.files_all": "Search files: {q}",
  "panelsearch.recent_remove": "Remove from recent searches",
  "panelsearch.recent_clear": "Clear recent searches",
  "panelsearch.empty": "Nothing matches “{q}”.",
  "panelsearch.searching": "Searching…",
  "panelsearch.failed": "Some results could not be loaded. The rest are shown.",
  "panelsearch.prefixes": "Narrow to one kind:",
  "panelsearch.count_one": "{n} result",
  "panelsearch.count": "{n} results",
  "search.in_content": "In content",
  "search.truncated": "More results than shown - narrow your search",
  "nav.more_shown": "Showing {shown} of {total}",
  "nav.load_more": "Load more",
  /* Catalog coverage (docs/LAZY-CATALOGUE.md, lib/catalogCoverage). One
     sentence per reason; the banner sits over a listing and over search
     results, and says what is left out and why. */
  "coverage.first_scan": "This storage’s first sync has not finished. Until it does, search, folder sizes and usage leave part of it out.",
  "coverage.lazy_filling": "filex is still cataloging this storage ({pct}% of the folders found so far). Until it finishes, search, folder sizes and usage leave part of it out.",
  "coverage.lazy_on_open": "Only the folders people open on this storage are cataloged. Search, folder sizes and usage cover those folders only.",
  "coverage.search_some": "Not everything on these storages is cataloged yet: {names}. This search may miss files there.",
  "coverage.catalog_all": "Catalog everything",
  "coverage.catalog_started": "Sync started - the whole storage is being cataloged.",
  "coverage.catalog_running": "Cataloging…",
  "coverage.cataloging": "Cataloging {storage}… this runs in the background, and this page says when it is done.",
  "coverage.catalog_done": "{storage} is cataloged in full",
  "coverage.catalog_failed": "Cataloging {storage} failed. The admin panel shows why, under the storage’s sync runs.",
  "coverage.catalog_stopped": "Cataloging {storage} was stopped before it finished",
  "coverage.catalog_joined": "A scan of {storage} was already running - this page says when it is done.",
  "coverage.catalog_gone": "{storage} was removed while it was being cataloged",
  "coverage.catalog_unfollowed": "Cataloging {storage} goes on in the background; the admin panel shows how it ends, under the storage’s sync runs",
  "size.at_least": "≥ {size}",
  "size.partial_hint": "Part of this folder is not cataloged yet, so its size is at least this.",
  "size.unknown_hint": "This folder is not cataloged yet, so its size is not known.",
  /* === bag:b4 === */
  "toolbar.more": "More actions",
  "toolbar.search.close": "Close search",
  "sheet.menu": "Actions",
  "sheet.close": "Close",
  /* === koru:k1 === */
  "toolbar.inspector": "Details",
  "ctx.details": "Details",
  /* yildiz:s1 - starring is an action, so it has a verb in the menu. */
  "ctx.star": "Star",
  "ctx.unstar": "Unstar",
  "star.failed": "Could not change the star",
  "shortcuts.inspector": "Toggle details panel",
  "inspector.title": "Details",
  "inspector.copy_name": "Copy name",
  "inspector.items": "{n} items",
  "inspector.items_one": "{n} item",
  "inspector.type": "Type",
  "inspector.select_hint": "Select an item to see its details.",
  /* pane:p1 - the panel HOLDS the last selected thing (owner's ruling,
     2026-09-13), so it can be describing an item in the half of a split
     window nobody is looking at. This line says which one and where. */
  "inspector.held": "Last selected - in {where}",
  "inspector.close": "Close",
  "inspector.section.general": "General",
  "inspector.section.tags": "Tags",
  /* etiket:t1 - TagPicker's own chrome. It printed these three in English
     regardless of the catalogue until 2026-09-13; `tags.open` is the chip's new
     "show me everything with this tag". */
  "tags.open": "Open tag: {tag}",
  "tags.add": "+ Add tag",
  "tags.name": "Tag name",
  "tags.remove": "Remove tag",
  /* etiket:k2 (v0.43.0) - the two KINDS of tag. Every place a tag is drawn
     says which kind it is, in words as well as the icon, because until this
     release a tag was silently shared with every account on the server. */
  "tags.kind.label": "Who sees this tag",
  "tags.kind.personal": "Personal",
  "tags.kind.team": "Team",
  "tags.kind.personal_help": "Only you see it",
  "tags.kind.team_help": "Everyone on your team who can see this file",
  "tags.kind.team_locked": "Adding or removing a team tag needs edit permission on this file.",
  "tags.chip.personal": "Personal tag “{tag}” - only you see it",
  "tags.chip.team": "Team tag “{tag}” - everyone on your team who can see this file sees it",
  "tags.add_submit": "Add",
  "inspector.section.versions": "Versions",
  "inspector.section.permissions": "Permissions",
  "inspector.section.shares": "Shares",
  "inspector.path": "Path",
  "inspector.size": "Size",
  "inspector.modified": "Modified",
  "inspector.mime": "MIME type",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Node ID",
  "inspector.copy": "Copy",
  "inspector.copied": "Copied",
  "inspector.error": "Could not load",
  "inspector.items_summary": "{n} items, {size} total",
  "inspector.items_summary_one": "{n} item, {size} total",
  "inspector.folder_items": "{n} items",
  "inspector.folder_items_one": "{n} item",
  "inspector.versions.empty": "No version history",
  "inspector.versions.v": "Version {n}",
  "inspector.versions.restore": "Restore",
  "inspector.versions.restore_confirm": "Restore this version?",
  "inspector.versions.snapshot_current": "Snapshot the current state first",
  "inspector.versions.confirm": "Confirm",
  "inspector.versions.restoring": "Restoring…",
  "inspector.versions.cancel": "Cancel",
  "inspector.versions.take_snapshot": "Snapshot current state",
  "inspector.versions.snapshotting": "Taking a snapshot…",
  "inspector.versions.restored": "Version restored",
  "inspector.versions.snapshotted": "Snapshot taken",
  "inspector.versions.unsupported": "The server does not support this operation",
  "inspector.perm.none": "No access",
  "inspector.perm.viewer": "Viewer",
  "inspector.perm.editor": "Editor",
  "inspector.perm.owner": "Owner",
  "inspector.perm.manage": "Manage permissions",
  "inspector.shares.empty": "No share links",
  "inspector.shares.copy": "Copy link",
  /* wiring:c1 - theme gallery */
  "theme.menu": "Theme",
  "theme.title": "Theme gallery",
  "theme.hint": "A theme only changes the color palette - day or night is the choice above.",
  "theme.mode.label": "Appearance",
  "theme.mode.light": "Day",
  "theme.mode.dark": "Night",
  "theme.mode.auto": "Automatic",
  "theme.reset": "Reset to default",
  "theme.close": "Close",
  "theme.selected": "Selected",
  "theme.name.default": "Default",
  "theme.name.night": "Night blue",
  "theme.name.forest": "Forest",
  "theme.name.amber": "Amber",
  "theme.name.lilac": "Lilac",
  "theme.name.contrast": "High contrast",
  "theme.name.gray": "Soft gray",
  "theme.name.terminal": "Terminal green",
  /* === zaman:z3 - the time-zone picker (embed dialog + web settings) === */
  "tz.menu": "Time zone",
  "tz.title": "Time zone",
  "tz.label": "Show dates in",
  "tz.search": 'Search a city, country or offset - try "Istanbul" or "GMT+3"',
  "tz.default.device": "Use this device's zone ({zone})",
  "tz.default.account": "Use the account's zone ({zone})",
  "tz.default.host": "Use this site's default ({zone})",
  "tz.no_match": "No zone matches “{query}”. Try a city, a country, or an offset like GMT+3.",
  "tz.more": "{n} more - keep typing to narrow the list.",
  "tz.hint": "Saved in this browser only. Every date is stored as one moment in time and shown on the clock you pick here.",
  "tz.now": "Right now in {zone}: {time}",
  /* === wiring:c2 - customizable shortcuts + quick look === */
  "shortcuts.quicklook": "Quick look",
  "shortcuts.customize": "Customize",
  "shortcuts.settings.menu": "Shortcuts",
  "shortcuts.settings.title": "Shortcut settings",
  "shortcuts.settings.hint": 'To remap a shortcut, press "Change" and then the new key combination. Changes are stored in this browser only.',
  "shortcuts.settings.change": "Change",
  "shortcuts.settings.capture": "Press keys… (Esc cancels)",
  "shortcuts.settings.reset": "Reset to default",
  "shortcuts.settings.reset_all": "Reset all",
  "shortcuts.settings.unbound": "Not set",
  "shortcuts.settings.fixed": "Fixed",
  "shortcuts.settings.customized": "Customized",
  "shortcuts.settings.conflict": 'is already used by "{name}".',
  "shortcuts.settings.conflict_fixed": 'is reserved by the fixed shortcut "{name}" - it cannot be used.',
  "shortcuts.settings.conflict_take": "Unassign old and use here",
  "shortcuts.settings.conflict_cancel": "Cancel",
  "quicklook.hint_close": "close",
  "quicklook.hint_nav": "previous/next",
  "quicklook.hint_open": "open",
  /* === /wiring:c2 === */
  /* === wiring:c3 - operations center === */
  "opc.title": "Operations",
  "opc.aria_badge": "{n} operations - toggle operations center",
  "opc.aria_badge_one": "{n} operation - toggle operations center",
  "opc.close": "Close",
  "opc.active": "In progress",
  "opc.history": "History",
  "opc.clear": "Clear",
  "opc.empty": "No operations",
  "opc.cancel": "Cancel",
  "opc.retry": "Retry",
  "opc.dismiss": "Dismiss",
  "opc.queued": "Queued",
  "opc.cancelling": "Cancel requested…",
  "opc.percent": "{n}%",
  "opc.items": "{done} of {total} items",
  "opc.trash_items": "{n} items from the trash",
  "opc.trash_items_one": "{n} item from the trash",
  "opc.status.running": "In progress",
  "opc.status.done": "Done",
  "opc.status.error": "Failed",
  "opc.status.aborted": "Cancelled",
  "opc.kind.upload": "Upload",
  "opc.kind.copy": "Copy",
  "opc.kind.move": "Move",
  "opc.kind.delete": "Delete",
  "opc.kind.rename": "Rename",
  "opc.kind.restore": "Restore",
  "opc.kind.purge": "Delete permanently",
  "opc.kind.convert": "Convert",
  "opc.kind.archive": "Archive",
  "opc.kind.plugin": "App",
  "opc.kind.trash": "Empty trash",
  "opc.kind.thumbs": "Thumbnail repair",
  /* A folder's contents on hover (FolderPeek, useFolderPeek). */
  "peek.items": "{n} items",
  "peek.items_one": "{n} item",
  "peek.more": "+{n} more",
  "peek.empty": "Empty",
  "peek.loading": "Looking inside…",
  "opc.open": "Open",
  /* App plugins - rows a WebAssembly plugin adds to the file menu, and the
     jobs they queue (docs/APP-PLUGINS-API.md). "App" is what the feature is
     called on every surface; "plugin" is the wire word. */
  "plugin.queued": "{label} queued",
  "plugin.done": "{label} finished",
  "plugin.failed": "{label} failed",
  "plugin.cancel_failed": "Could not cancel the job",
  "plugin.not_applicable": "This action does not apply to the selection",
  "plugin.needs_engine": "{name} is not installed on this server - install it and restart filex.",
  "plugin.needs_other": "{name} is not available on this server.",
  "plugin.needs_office": "Office documents need {name}, which is not connected to this server - connect it under External services.",
  "plugin.confirm.title": "Confirm",
  "plugin.confirm.cancel": "Cancel",
  "plugin.confirm.run": "Run",
  "plugin.view.close": "Close",
  "appframe.confirm_title": "Confirm",
  "appframe.consent_clipboard": "{app} wants to copy text to your clipboard.",
  "appframe.consent_download": "{app} wants to save “{name}” to your computer.",
  "appframe.consent_print": "{app} wants to print “{name}”.",
  "appframe.consent_job": "{app} wants to start “{action}”.",
  "appframe.consent_allow": "Allow",
  "appframe.consent_deny": "Don’t allow",
  "appframe.unsaved_title": "Unsaved changes",
  "appframe.unsaved_text": "{app} has changes that are not saved. Close it anyway?",
  "appframe.state_no_account": "The app’s settings for an encrypted file are kept sealed for the account you are signed in as, and this page could not tell which account that is, so nothing was kept. Sign in again, or open the file where you are signed in.",
  "appframe.discard": "Close without saving",
  "appframe.keep_open": "Keep editing",
  "appframe.save_close": "Save and close",
  "appframe.updated": "{app} was updated to {version}.",
  "appframe.updated_reload": "An administrator approved a new version of {app}. Reload it to use the new version - save your work first.",
  "appframe.reload": "Reload",
  "appframe.dismiss": "Dismiss",
  "appframe.not_connected": "{app} did not start. Close it and open it again; if it keeps happening, tell your administrator.",
  "appframe.save_as_title": "{app}: save “{name}” to",
  "plugin.view.busy": "Working…",
  "plugin.view.unsupported": "This screen uses a component this version cannot draw ({type})",
  "plugin.view.error": "The app answered with an error",
  "plugin.output_missing": "The output is no longer where it was",
  /* M2 - surface components (components/plugin/nodes/*) */
  "plugin.view.loading": "Loading…",
  "plugin.view.preview_failed": "The preview could not be loaded",
  "plugin.steps.label": "Steps",
  "plugin.list.empty": "Nothing here yet",
  "plugin.list.actions": "Actions",
  /* The label on a table row's ONE action control (core RowActions.vue).
     The explorer's handle is the ⋮ glyph; a panel row's says what it is.
     Owner, 2026-09-20: "adminde 'Aksiyon' diye yazmalı". */
  "row.actions": "Actions",
  "plugin.people.placeholder": "Name or email",
  "plugin.people.placeholder_email": "Email address",
  "plugin.people.add": "Add",
  "plugin.people.remove": "Remove {name}",
  "plugin.people.invalid_email": "Enter a valid email address",
  "plugin.people.external_off": "Only people with an account can be added",
  "plugin.pin.label": "PIN",
  "plugin.file.choose": "Choose…",
  "plugin.file.clear": "Clear",
  "plugin.file.none": "Nothing chosen",
  /* M3 - the sign track: signature-pad + pdf-fields nodes, and the outside
     participant's public page (views/PublicSurface.vue via usePublicPage). */
  "plugin.sig.mode_draw": "Draw",
  "plugin.sig.mode_type": "Type",
  "plugin.sig.mode_upload": "Upload",
  "plugin.sig.draw_hint": "Sign here with your finger or mouse",
  "plugin.sig.type_placeholder": "Type your name",
  "plugin.sig.upload_pick": "Choose a picture…",
  "plugin.sig.upload_hint": "PNG or JPEG, at most {kb} KB",
  "plugin.sig.upload_too_big": "The picture is larger than {kb} KB",
  "plugin.sig.upload_bad_type": "Only PNG or JPEG pictures can be used",
  "plugin.sig.upload_unreadable": "The picture could not be read",
  "plugin.sig.clear": "Clear signature",
  "plugin.sig.signed": "Signature captured",
  "plugin.pdf.load_failed": "The document could not be loaded",
  "plugin.pdf.palette": "Field types",
  "plugin.pdf.pending": "Boxes waiting for a place",
  "plugin.pdf.place_box_hint": "Tap the page where “{name}” goes, or drag to size it",
  "plugin.pdf.all_placed": "Every box has a place",
  "plugin.pdf.place_idle": "Choose one of the boxes above, then tap the page where it goes.",
  "plugin.pdf.place_idle_done": "Tap a box on the page to take it off or copy it; drag it to move it.",
  "plugin.pdf.no_boxes": "No boxes yet. Add one below: give it a name, say whose it is, and place it on the document in the next step.",
  "plugin.pdf.add_box": "Add a box",
  "plugin.pdf.unplace": "Take off the page",
  "plugin.pdf.place_hint": "Tap the page where the {type} field goes, or drag to size it",
  "plugin.pdf.type_signature": "Signature",
  "plugin.pdf.type_initials": "Initials",
  "plugin.pdf.type_date": "Date",
  "plugin.pdf.type_text": "Text",
  "plugin.pdf.type_checkbox": "Checkbox",
  "plugin.pdf.tap_signature": "Tap to sign",
  "plugin.pdf.tap_initials": "Tap to initial",
  "plugin.pdf.tap_date": "Tap for today",
  "plugin.pdf.tap_text": "Text",
  "plugin.pdf.tap_checkbox": "Tap to tick",
  "plugin.pdf.label": "Name",
  "plugin.pdf.assignee": "Signer",
  "plugin.pdf.unassigned": "Anyone",
  "plugin.pdf.filled_by": "Filled by",
  "plugin.pdf.style": "How it is signed",
  "plugin.pdf.style_drawn": "Drawn",
  "plugin.pdf.style_typed": "Typed",
  "plugin.pdf.lines": "Printed under it",
  "plugin.pdf.lines_preview": "Under the signature:",
  "plugin.pdf.lines_none": "Nothing is printed under this signature.",
  "plugin.pdf.required": "Required",
  "plugin.pdf.copy_to_page": "Copy to page",
  "plugin.pdf.copy": "Copy",
  "plugin.pdf.delete": "Delete field",
  "plugin.pdf.zoom_in": "Zoom in",
  "plugin.pdf.zoom_out": "Zoom out",
  "plugin.pdf.zoom_fit": "Fit to width",
  "plugin.pdf.zoom_fit_page": "Fit the page to the screen",
  "plugin.pdf.pad_for": "Your {type}",
  "plugin.pdf.pad_done": "Done",
  "plugin.page.loading": "Loading…",
  "plugin.page.pin_title": "This page is protected",
  "plugin.page.pin_hint": "Enter the PIN you were given to continue",
  "plugin.page.pin_submit": "Continue",
  "plugin.page.pin_wrong": "That PIN is not right",
  "plugin.page.pin_locked": "Too many wrong PINs - wait a few minutes and try again",
  "plugin.page.unavailable_title": "This link is not available",
  "plugin.page.unavailable_text": "It may have expired, been used up or been withdrawn. Ask the person who sent it for a new one.",
  "plugin.page.accepted_title": "Received, thank you",
  "plugin.page.accepted_text": "Your answer has been recorded. You can close this page.",
  "plugin.page.done_title": "All done",
  "plugin.page.done_text": "There is nothing more to do here. You can close this page.",
  "plugin.page.error_title": "Something went wrong",
  "plugin.page.retry": "Try again",
  "plugin.page.files": "Documents",
  "plugin.page.open_file": "Open {name} in a new tab",
  "plugin.page.footer": "Served by filex",
  /* The public pages' own sentences (share, file request) are the SERVER's
     `server.public.*` (composables/usePublicText) - not keys of this file. */
  /* === App plugins v2 - a `page` view, an app's lock on a file, the output
     mode a job wrote in, and the faces + rules a signature field carries. === */
  "plugin.page_view.back": "Back to the files",
  "plugin.page_view.queued_title": "The job is queued",
  "plugin.page_view.queued_text": "filex is working on it. This page says when it is done, and its progress is in the operations tray too.",
  "plugin.page_view.finished_title": "The job is done",
  "plugin.page_view.finished_text": "There is nothing more to do here. You can go back to the files or close this tab.",
  "plugin.page_view.failed_title": "The job did not finish",
  "plugin.page_view.opening_title": "Opening the result",
  "plugin.page_view.open_ops": "Open the operations tray",
  "plugin.page_view.done_title": "All done",
  "plugin.page_view.done_text": "There is nothing more to do here. You can close this tab.",
  "plugin.page_view.error_title": "This screen could not be opened",
  "plugin.page_view.retry": "Try again",
  "plugin.page_view.blocked": "The new tab was blocked - allow pop-ups for this site, or the screen will open in a dialog",
  "plugin.output.sibling": "new file",
  "plugin.output.version": "new version",
  "plugin.output.sibling_title": "The result lands as a new file beside the original",
  "plugin.output.version_title": "The result replaces the file as a new version of it",
  "plugin.sign.font_label": "Handwriting",
  "plugin.pdf.font": "Font",
  "plugin.pdf.rule_number": "Numbers only",
  "plugin.pdf.rule_email": "Email address",
  "plugin.pdf.rule_length": "Between {min} and {max} characters",
  "plugin.pdf.rule_min": "At least {min} characters",
  "plugin.pdf.rule_max": "At most {max} characters",
  "plugin.pdf.err_number": "Enter a number",
  "plugin.pdf.err_email": "Enter a valid email address",
  "plugin.pdf.err_min": "Too short - at least {min} characters",
  "plugin.pdf.err_max": "Too long - at most {max} characters",
  "applock.badge": "Locked",
  "applock.some_app": "an app",
  "applock.held": "{app} locked this file",
  "applock.held_reason": "{app} locked this file: {reason}",
  "applock.until": "- until {date}",
  "applock.inspector": "Held by an app",
  /* issue #34 - a symlink the server will NOT follow (lib/symlink). The badge
     is the short word on the row; `why` is the sentence behind it, shown on
     hover, in the details panel and in the toast when somebody tries to open
     one. ⚠ Broken and outside-of-root are DIFFERENT states and must read
     differently: only one has an administrator remedy, and offering that
     remedy for a target that has been deleted sends the person to a settings
     screen that cannot help them. */
  "symlink.badge.outside_root": "Outside storage",
  "symlink.badge.broken": "Broken link",
  "symlink.badge.unresolved": "Remote link",
  "symlink.badge.unknown": "Link",
  "symlink.why.outside_root": `A link whose target lies outside this storage, which is why it cannot be opened. An administrator can allow it with "Follow symlinks that leave this folder" in the storage's settings.`,
  "symlink.why.broken": "A link whose target no longer exists, so there is nothing to open. It has to be repaired or removed on the server - no setting can bring the target back.",
  "symlink.why.unresolved": "A link on a remote server. filex cannot tell whether its target is inside this storage, so it does not follow it and cannot open it.",
  "symlink.why.unknown": "A link filex will not follow, so it cannot be opened. Its target is either outside this storage, missing, or on a remote server filex cannot resolve.",
  "symlink.inspector": "A link that cannot be opened",
  /* Issue #104 - an entry the storage could not answer for (lib/unavailable).
     The sentence says what it means and what happens next; the storage's own
     answer follows it ({reason}), usually in English. */
  "unavailable.why.file": "The storage could not say whether this file still exists. It cannot be opened or changed until the storage answers for it again; the next scan checks.",
  "unavailable.why.dir": "The storage could not say whether this folder still exists. Neither the folder nor anything inside it can be opened or changed until the storage answers for it again; the next scan checks.",
  "unavailable.withReason": "{why} The storage answered: {reason}",
  "unavailable.inspector": "Unavailable",
  /* 0.50 - why a file has no thumbnail, on the file itself (lib/thumbNote):
     the marker's name and the sentence a resting pointer or a tap shows. */
  "thumbNote.corrupt": "Damaged",
  "thumbNote.corrupt_why": "No thumbnail: the file could not be read. It may be damaged or incomplete.",
  "thumbNote.encrypted": "Encrypted",
  "thumbNote.encrypted_why": "No thumbnail: the file is encrypted or protected by a password.",
  "thumbNote.too_large": "Too large",
  "thumbNote.too_large_why": "No thumbnail: the file is larger than the thumbnail size limit.",
  "thumbNote.full": "{label}. {why}",
  "plugin.pdf.rule": "Accepts",
  "plugin.pdf.rule_kind_any": "Any text",
  "plugin.pdf.rule_kind_number": "Numbers only",
  "plugin.pdf.rule_kind_email": "Email address",
  "plugin.pdf.rule_min_label": "Min length",
  "plugin.pdf.rule_max_label": "Max length",
  "plugin.pdf.format": "Date layout",
  "plugin.pdf.date_order": "Date order",
  "plugin.pdf.date_separator": "Separator",
  "plugin.pdf.date_example": "Example",
  "opc.kind.archive-create": "Creating archive",
  "opc.kind.archive-extract": "Extracting archive",
  /* === wiring:c4 - onboarding tour + accessibility + error card === */
  "tour.aria": "Onboarding tour",
  "tour.restart": "Restart the tour",
  "tour.skip": "Skip tour",
  "tour.back": "Back",
  "tour.next": "Next",
  "tour.done": "Done",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Storages & views",
  "tour.step.nav.desc": "Home, Shared with me, Recent, Starred and Trash are always in this panel, with your storages and connections underneath. The button in the top-left corner collapses it to a rail and brings it back.",
  "tour.step.nav.desc_closed": "This button opens the navigation panel: Home, Shared with me, Recent, Starred and Trash, with your storages and connections underneath.",
  "tour.step.new.title": "Add something",
  "tour.step.new.desc": "Everything new starts here - upload from this device, create a folder, or ask somebody else for a file. Dropping files onto the window uploads them as well.",
  "tour.step.new.desc_fab": "This button uploads files from this device. Dropping files onto the window works as well.",
  "tour.step.search.title": "Search",
  "tour.step.search.desc": 'This field searches the whole storage by name - separators and one typo are forgiven, so "invoice 2026" finds invoice_2026.pdf. Add tag:invoice to filter by tag. The sliders button opens advanced search, and {palette} opens the command palette, which runs commands too.',
  "tour.step.crumb.title": "Where you are",
  "tour.step.crumb.desc": "This trail is the address of the folder on screen. Click any step to go back up, and the chevron beside the last one lists the folders inside it.",
  "tour.step.filters.title": "Narrow the list",
  "tour.step.filters.desc": "Type, Owner, Modified and Size filter the folder you are in, the box beside them matches names as you type, and the control at the end of the row sorts.",
  "tour.step.view.title": "Switch views",
  "tour.step.view.desc": "Change how this folder is drawn; your choice is remembered.",
  "tour.step.details.title": "Details & sharing",
  "tour.step.details.desc": 'Select a file and open this panel for its details, its activity and its share links. For the full menu, right-click the file or use the button at the end of its row - "Share" there creates a link with an optional PIN and expiry.',
  "tour.step.help.title": "Shortcuts",
  "tour.step.help.desc": 'Press {help} for the shortcut cheat-sheet and {palette} for the command palette. Theme and "Restart the tour" are in the "More actions" menu at the top right; your account and sign-out are behind the avatar beside it.',
  "error.hint": "This may be a temporary network or server problem. Please try again.",
  "error.details": "Technical details",
  "col.star": "Star",
  "toolbar.view_label": "View",
  "list.aria": "File list",
  "grid.aria": "File grid",
  /* === wiring:d1 - tabs + split pane === */
  "tabs.strip": "Tabs",
  "tabs.new": "New tab",
  "tabs.close": "Close tab",
  "tabs.split": "Split view",
  "tabs.split_off": "Close split",
  "ctx.open_new_tab": "Open in new tab",
  "ctx.open_with": "Open with {app}",
  "ctx.open_with_builtin": "Open with the built-in viewer",
  "ctx.open_with_choose": "Choose an app…",
  "openWith.title": "Open with",
  "openWith.lead": "Which app should open {name}?",
  "openWith.builtin": "filex viewer (built-in)",
  "openWith.onlyoffice": "ONLYOFFICE (spreadsheet editor)",
  "openWith.now": "Opens it now",
  "openWith.always": "Always use this app for {ext} files",
  "openWith.hint": "Kept on your account. You can change it in Settings, Default apps.",
  "openWith.open": "Open",
  "shortcuts.group.tabs": "Tabs",
  "shortcuts.tab_new": "New tab",
  "shortcuts.tab_close": "Close tab",
  "shortcuts.tab_next": "Next tab",
  "shortcuts.tab_prev": "Previous tab",
  /* tus:t1 - the menu verbs */
  "shortcuts.new_folder": "New folder",
  "shortcuts.upload": "Upload files",
  "shortcuts.refresh": "Refresh the listing",
  "shortcuts.download": "Download",
  "shortcuts.preview": "Preview",
  "shortcuts.share": "Share",
  "shortcuts.tags": "Tags",
  "shortcuts.open_tab": "Open in a new tab",
  "shortcuts.copy_path": "Copy path",
  "shortcuts.copy_id": "Copy id",
  "shortcuts.restore": "Restore from trash",
  "shortcuts.settings.reserved": "is taken by the browser before the page sees it, so it would do nothing here. Pick another key.",
  "shortcuts.settings.reserved_badge": "Desktop app only",
  "shortcuts.settings.reserved_title": "The browser handles this combination itself. It fires in the desktop app and in an installed PWA, not in a browser tab.",
  "cmd.tab_new": "Open a new tab",
  "cmd.split_toggle": "Toggle split view",
  "split.pane": "Secondary pane",
  "split.close": "Close the side pane",
  "split.error": "Could not load the listing",
  "split.retry": "Retry",
  "split.copy_queued": "Copy queued",
  "split.move_queued": "Move queued",
  "toast.move_kept_both": "Move queued. A name was already taken there, so that item will be kept beside the existing one with “-copy” added. This move cannot be undone.",
  "split.cross_copy": "Different storages - copy queued instead",
  "dragout.downloading": "Downloading into the folder you dropped on…",
  "dragout.downloading_n": "Downloading into the folder you dropped on - {n} files so far…",
  "dragout.downloading_n_one": "Downloading into the folder you dropped on - {n} file so far…",
  "dragout.stop": "Stop",
  "dragout.stopping": "Stopping…",
  "dragout.stopped": "Stopped - what had arrived stays in the folder",
  "dragout.not_found": "Could not find where it was dropped - a drop onto an application (rather than a folder) cannot be filled in",
  "dragout.done": "Download finished",
  "dragout.ready": "Files are ready - drag them to your desktop",
  "dragout.preparing": "Getting them ready to drag…",
  "split.cross_move": "Different storages - move queued (bytes travel, then the original is removed)",
  /* === /wiring:d1 === */
  /* wiring:d2 - gallery view */
  "toolbar.view.gallery": "Gallery",
  "gallery.aria": "File gallery",
  /* /wiring:d2 */
  /* wiring:d3 - inspector node comments */
  "inspector.section.comments": "Comments",
  "inspector.comments.empty": "No comments yet.",
  "inspector.comments.placeholder": "Write a comment…",
  "inspector.comments.send": "Send",
  "inspector.comments.delete": "Delete comment",
  /* wiring:e2 - end-to-end encrypted folders */
  "e2e.create.title": "Create encrypted folder",
  "e2e.create.option": "Create encrypted folder…",
  "e2e.create.pw_label": "Folder password",
  "e2e.create.pw_placeholder": "At least 8 characters",
  "e2e.create.pw2_label": "Repeat the password",
  "e2e.create.warn_title": "NO WAY BACK",
  "e2e.create.warn_body": "Files in this folder can only be opened with this password or the recovery key shown once when the folder is created. The password is NEVER stored on the server, and filex keeps no copy of the recovery key either. Lose both and the contents are gone for good.",
  "e2e.create.ack": "I understand: if I lose both the password and the recovery key, my data cannot be recovered.",
  "e2e.create.ack_required": "Please confirm the warning to continue.",
  "e2e.create.pw_short": "Password must be at least 8 characters.",
  "e2e.create.pw_mismatch": "Passwords do not match.",
  "e2e.create.bad_name": "Invalid folder name.",
  "e2e.create.create": "Create encrypted folder",
  "e2e.create.busy": "Creating…",
  "e2e.create.done": "Encrypted folder created",
  "e2e.create.failed": "Could not create the encrypted folder",
  "e2e.create.nested": "You cannot create an encrypted folder inside another one.",
  /* wiring:e2 policy - asking an administrator to allow one encryption
     (E2eRequestModal), where the tenant's policy wants an approval first. */
  "e2e.request.ctx": "Request encryption…",
  "e2e.request.option": "Request an encrypted folder…",
  "e2e.request.title": "Request encryption for “{name}”",
  "e2e.request.lead": "Making an encrypted folder here needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and this folder: it can be used once, to make one new encrypted folder directly inside it.",
  "e2e.request.lead_folder": "Encrypting this folder needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and this folder: it can be used once, to encrypt this folder where it is, and not a folder inside it.",
  "e2e.request.lead_file": "Encrypting this file needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and the folder this file is in: it can be used once, for one new encrypted file there.",
  "e2e.request.reason": "Reason",
  "e2e.request.reason_placeholder": "What it holds, and why it must be encrypted",
  "e2e.request.reason_required": "Write a reason for the administrator.",
  "e2e.request.send": "Send request",
  "e2e.request.sending": "Sending…",
  "e2e.request.sent": "Request sent. You will be notified when an administrator answers.",
  "e2e.request.already": "You already asked for this; it is waiting for an administrator.",
  "e2e.request.failed": "The request could not be sent.",
  "e2e.locked.title": "This folder is end-to-end encrypted",
  "e2e.locked.hint": "Enter the folder password to see its contents. The password stays in this tab’s memory only.",
  "e2e.locked.pw_placeholder": "Folder password",
  "e2e.locked.unlock": "Unlock",
  "e2e.locked.busy": "Verifying…",
  "e2e.unlock.wrong": "Wrong password.",
  "e2e.unlock.damaged": "The password is right, but the folder key in the key file (.filex-e2e.json) does not open: the file is damaged. Try the recovery key.",
  "e2e.unlock.marker_missing": "Could not read the key file (.filex-e2e.json).",
  /* ikon:emoji - the listing marker's accessible name. The row used to print
     a 🔒 and nothing else; the padlock that replaced it is aria-hidden inside
     the tile, so the span that carries it says this instead. */
  "e2e.badge": "Encrypted folder",
  "e2e.strip.label": "Encrypted folder - unlocked",
  "e2e.strip.lock": "Lock",
  /* wiring:e2 password - changing a folder's password */
  "e2e.password.strip_action": "Change password…",
  "e2e.password.title": "Change the folder password",
  "e2e.password.reset_title": "Set a new password for this folder",
  "e2e.password.reset_lead": "You opened this folder with its recovery key, so its password was lost or may be known to someone. Set a new one now. Closing this dialog locks the folder again.",
  "e2e.password.current": "Current password",
  "e2e.password.recovery": "Recovery key",
  "e2e.password.use_recovery": "I do not remember it - use the recovery key",
  "e2e.password.use_current": "Use the current password instead",
  "e2e.password.new": "New password",
  "e2e.password.current_required": "Enter the current password, or use the recovery key.",
  "e2e.password.bad_recovery": "That is not a recovery key (32 characters, in groups of four).",
  "e2e.password.same": "The new password is the same as the current one.",
  "e2e.password.cheap_note": "Only the folder’s key file changes. No file is re-encrypted, and the recovery key and any escrow key keep working.",
  "e2e.password.old_copies": "Someone who knows the old password and has an old copy of the key file (a version, a backup) can still open the folder with it. If that is a risk, tick “Also replace the folder key”.",
  "e2e.password.rotate_label": "Also replace the folder key (re-wraps every file’s key; use this if the old password may be known)",
  "e2e.password.rekey_title": "This folder is from before v0.31: its key comes from its password",
  "e2e.password.rekey_body": "A new password therefore needs a new folder key, and the key of every file in the folder is re-wrapped under it. The contents are not re-encrypted. It can take a while, and if it is interrupted it continues where it stopped; the files open throughout.",
  "e2e.password.rotate_title": "The folder key is replaced too",
  "e2e.password.rotate_body": "Every file’s key is re-wrapped under a new folder key. The contents are not re-encrypted. If it is interrupted it continues where it stopped; the files open throughout.",
  "e2e.password.rekey_rk_new": "You get a new recovery key, shown once; the old one stops working.",
  "e2e.password.rekey_rk_kept": "The recovery key you used keeps working.",
  "e2e.password.rekey_escrow": "The operator’s escrow key keeps working: its slot is sealed to the new folder key.",
  "e2e.password.rekey_ack": "I understand: this re-wraps the key of every file in the folder.",
  "e2e.password.submit": "Change password",
  "e2e.password.busy": "Changing…",
  "e2e.password.lock_instead": "Lock the folder instead",
  "e2e.password.wrong_current": "Wrong password.",
  "e2e.password.wrong_recovery": "Wrong recovery key.",
  "e2e.password.escrow_blocked": "This folder has an escrow slot for a key this installation does not have, and replacing the folder key would lose it. Nothing was changed.",
  "e2e.password.failed": "Could not change the password. Nothing was changed.",
  "e2e.password.done": "Password changed. The old password no longer opens this folder.",
  "e2e.password.resume_title": "File keys are still being re-wrapped",
  "e2e.password.resume_body": "The password was changed and a new folder key issued. Some files still have their key under the previous one; they open either way. Continue to finish.",
  "e2e.password.progress": "{n} files re-wrapped so far · {failed} failed",
  "e2e.password.progress_one": "{n} file re-wrapped so far · {failed} failed",
  "e2e.password.rekey_partial": "{n} files could not be re-wrapped. They still open with the previous key; continue to try again.",
  "e2e.password.rekey_partial_one": "{n} file could not be re-wrapped. It still opens with the previous key; continue to try again.",
  "e2e.password.rekey_done": "New folder key in place ({n} files re-wrapped). The old password opens nothing here any more.",
  "e2e.password.rekey_done_one": "New folder key in place ({n} file re-wrapped). The old password opens nothing here any more.",
  "e2e.recovery.lead_replaced": "The folder has a new key, so it has a new recovery key too - the old one no longer opens it. Shown once; filex keeps no copy.",
  /* wiring:e2 names - encrypted file and folder names */
  "e2e.unlock.unsupported": "This folder needs a newer filex: it uses {features}, which this version does not understand. Nothing was changed.",
  "e2e.settings.open": "Encryption settings…",
  "e2e.settings.title": "Encryption settings",
  "e2e.settings.level": "Encryption level",
  "e2e.settings.password": "Password",
  "e2e.settings.escrow": "Escrow key",
  "e2e.settings.close": "Close",
  "e2e.level.content": "Contents only",
  "e2e.level.names": "Contents and names",
  "e2e.level.content_hint": "File contents are encrypted. File and folder names stay readable to the server, so WebDAV, the command line and desktop sync keep working with them, and every filex since 0.31 opens the folder.",
  "e2e.level.names_hint": "Contents and file and folder names are encrypted: the server sees only scrambled names. WebDAV, the command line and desktop sync see them scrambled too, and filex 0.47 and older will not open the folder.",
  "e2e.level.pending": "the change of level has not finished",
  "e2e.level.change": "Change level…",
  "e2e.level.raise_title": "Move this folder to “Contents and names”?",
  "e2e.level.raise_body": "filex gives every file and folder in here an encrypted name, in this browser. The contents are not touched, and if it is interrupted it continues where it stopped. filex does not offer the way back to readable names.",
  "e2e.level.raise_ack": "I understand what changes",
  "e2e.level.raise_go": "Encrypt the names",
  /* wiring:e2 vault - level 3, the vault (docs/E2E-VAULT-FORMAT.md) */
  "e2e.level.vault": "Vault",
  "e2e.level.vault_hint": "Contents, names and the whole tree are encrypted: the server keeps only packs of one size, and does not see how many files there are, their names, their sizes or their dates.",
  "e2e.level.vault_cost": "What it costs: one person writes at a time, and only filex opens it (the web app, the desktop app, filex decrypt and filex vault mount). WebDAV, folder sync, share links and previews on the server do not reach inside.",
  "e2e.vault.pack_label": "Pack size",
  "e2e.vault.pack_4": "4 MiB",
  "e2e.vault.pack_4_help": "The default. The smallest change uploads 4 MiB.",
  "e2e.vault.pack_16": "16 MiB",
  "e2e.vault.pack_16_help": "Fewer, larger files on the server. Every change uploads at least 16 MiB.",
  "e2e.vault.pack_hint": "Chosen now and never again. Every pack on the server is this size, and what it does not use is filled with random bytes.",
  "e2e.vault.read_only": "Read-only. An upload, a new folder or any other change takes the write lock, when nobody else holds it.",
  "e2e.vault.writing": "You are writing to this vault. If you do nothing for {left}, it goes back to read-only.",
  "e2e.vault.lock_countdown": "If nothing is done in it for {left}, the vault locks and asks for the password again.",
  "e2e.vault.held_by": "{name} has been writing since {since}. The vault is read-only for you.",
  "e2e.vault.someone": "Someone",
  "e2e.vault.take_over": "Take over",
  "e2e.vault.lost_idle": "You did nothing for {n} minutes, so this vault went back to read-only. Nothing was lost.",
  "e2e.vault.lost_idle_one": "You did nothing for {n} minute, so this vault went back to read-only. Nothing was lost.",
  "e2e.vault.lost_taken": "Someone else took over writing. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_taken_by": "{name} took over writing. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_broken_by": "{name} ended your write lock. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_connection": "The connection was lost, so this vault went back to read-only.",
  "e2e.vault.lost_expired": "The write lock ran out, so this vault went back to read-only.",
  "e2e.vault.unsaved": "Not saved: {names}. Do it again when the vault is free.",
  "e2e.vault.saving": "Saving…",
  "e2e.vault.saving_progress": "Saving: {done} of {total}",
  "e2e.vault.dismiss": "OK",
  "e2e.vault.continue": "Continue from this state",
  "e2e.vault.ro_damaged": "The newest state of this vault is damaged. You are looking at the one from {when}, read-only.",
  "e2e.vault.ro_damaged_short": "The newest state of this vault is damaged. You are looking at an older one, read-only.",
  "e2e.vault.ro_rollback": "The server offers an older state of this vault than this tab has already seen. It stays read-only here.",
  "e2e.vault.ro_newer": "A newer filex wrote this vault. This version reads it and does not change it.",
  "e2e.vault.unreadable": "No state of this vault can be read: nothing can be shown, and nothing is written.",
  "e2e.vault.limit_warn": "This vault holds {held} of at most {max} files and folders.",
  "e2e.vault.cross": "Nothing moves between a vault and the folders outside it on the server: download it from one, then upload it into the other.",
  "e2e.vault.dl_too_big": "This browser cannot save a file this large from memory. Use a browser that saves straight to disk (Chrome, Edge), or filex decrypt.",
  "e2e.vault.damaged_file": "This file is damaged in the vault and could not be read.",
  "e2e.vault.level_fixed": "A vault stays a vault: its level does not change and its key is not replaced. To start again with a new key, make a new vault and move the files into it.",
  "e2e.vault.locked_idle_toast": "Nothing was done in “{name}” for 15 minutes, so the vault locked itself. Enter the password to open it again.",
  "e2e.vault.open_failed": "The vault could not be opened.",
  "e2e.vault.err.parent_missing": "The folder it was going into is not there any more.",
  "e2e.vault.err.parent_not_folder": "“{name}” is a file, not a folder.",
  "e2e.vault.err.name_taken": "“{name}” is already taken there.",
  "e2e.vault.err.bad_name": "“{name}” cannot be a name in a vault: 1 to 255 bytes, without slashes or control characters, and not . or ..",
  "e2e.vault.err.too_deep": "Folders in a vault go at most 256 deep.",
  "e2e.vault.err.not_found": "“{name}” is not in the vault any more.",
  "e2e.vault.err.is_folder": "“{name}” is a folder.",
  "e2e.vault.err.into_itself": "A folder cannot go into itself.",
  "e2e.vault.err.too_many_entries": "This vault is full: it holds at most 250 000 files and folders. Nothing was changed.",
  "e2e.vault.err.index_too_large": "This vault's index has reached its limit. Nothing was changed.",
  "e2e.vault.err.newer_format": "A newer filex wrote this vault. This version reads it and does not change it.",
  "e2e.vault.err.size_mismatch": "A file changed while it was being uploaded. Upload it again.",
  "e2e.vault.err.changed": "“{name}” changed in the vault since it was opened, so it was not saved over. Open it again to see the newer version.",
  "e2e.vault.err.failed": "The change could not be saved.",
  "userSettings.vault.idle": "Vault: back to read-only after",
  "userSettings.vault.idle_help": "How long a vault you write to stays yours while you do nothing in it. Then others may write; your vault goes back to read-only, and 15 minutes later it locks.",
  "userSettings.vault.minutes": "{n} minutes",
  "userSettings.vault.minutes_one": "{n} minute",
  "userSettings.vault.saved": "Saved",
  "userSettings.vault.failed": "Could not save the vault setting.",
  "e2e.names.move_unreadable": "Not moved: the name of one of the items cannot be read.",
  "e2e.names.move_taken": "Not moved: “{name}” is already taken in that folder. Rename one of the two first.",
  "e2e.convert.ctx": "Encrypt with E2EE…",
  "e2e.convert.title": "Encrypt “{name}”",
  "e2e.convert.lead": "Every file in this folder is encrypted where it is, in this browser, with the password below. Nothing moves; at level 1 the names stay as they are. If it is interrupted, opening the folder again continues it.",
  "e2e.convert.past_title": "What the server already has",
  "e2e.convert.past_body": "Encrypting protects these files from now on. Until now the server has had them in the clear, and some copies remain: filex drops its thumbnails and the text it extracted for search, and can delete older versions and trash entries from this folder.",
  "e2e.convert.drop_versions": "Delete the older versions of these files (they are plaintext)",
  "e2e.convert.drop_trash": "Delete the trash entries that came from this folder",
  "e2e.convert.past_outside": "Backups, replicas and copies anyone already made are outside filex and stay as they are.",
  "e2e.convert.submit": "Encrypt folder",
  "e2e.convert.nested": "This folder holds an encrypted folder. Encrypted folders cannot be nested, so nothing was changed.",
  "e2e.convert.failed": "The folder could not be encrypted. Files already encrypted stay so; open the folder to continue.",
  "e2e.convert.stopped": "Stopped after {n} files. Continue from the strip above the folder.",
  "e2e.convert.stopped_one": "Stopped after {n} file. Continue from the strip above the folder.",
  "e2e.convert.partial": "{n} files could not be encrypted (changed meanwhile, too large, or not writable). They are still plaintext; try again to continue.",
  "e2e.convert.partial_one": "{n} file could not be encrypted (changed meanwhile, too large, or not writable). It is still plaintext; try again to continue.",
  "e2e.convert.too_large_here": "{n} files are too large for this browser to send in one piece, and this server takes no upload in pieces, so they could not be encrypted where they are. They are still plaintext, and the folder stays unfinished until they are encrypted.",
  "e2e.convert.too_large_here_one": "{n} file is too large for this browser to send in one piece, and this server takes no upload in pieces, so it could not be encrypted where it is. It is still plaintext, and the folder stays unfinished until it is encrypted.",
  "e2e.convert.large_progress": "Encrypting “{name}”: {percent}%",
  "e2e.convert.busy": "Encrypting the folder…",
  "e2e.convert.resume_title": "Finish encrypting this folder",
  "e2e.convert.resume_body": "Encrypting this folder started and did not finish. Files it has not reached yet are still plaintext on the server. Continuing picks up where it stopped.",
  "e2e.convert.progress": "{n} of {total} files encrypted · {failed} not done",
  "e2e.convert.progress_one": "{n} of {total} files encrypted · {failed} not done",
  "e2e.convert.done": "Folder encrypted ({n} files). Old versions deleted: {versions}; trash entries deleted: {trash}.",
  "e2e.convert.done_one": "Folder encrypted ({n} file). Old versions deleted: {versions}; trash entries deleted: {trash}.",
  "e2e.convert.cleanup_failed": "The folder is encrypted, but its old versions and trash entries could not be deleted - only the folder’s owner or an administrator can.",
  "e2e.names.locked_item": "🔒 Encrypted item",
  "e2e.names.unreadable_item": "🔒 Unreadable name",
  "e2e.names.key_failed": "The key file says the names in this folder are encrypted, but their key does not open with this one. Nothing was changed.",
  "e2e.names.write_failed": "Could not write the name file of a long name, so nothing was uploaded.",
  "e2e.names.bad_name": "“{name}” cannot be used in an encrypted folder: a name must be 1-255 bytes, with no slash, backslash or control character.",
  "e2e.names.offer_cost": "What changes: WebDAV, the command line and desktop sync will see scrambled names, and filex 0.47 and older will refuse to open this folder. The server still sees how many items there are and how big they are.",
  "e2e.names.resume_title": "Finish encrypting the names",
  "e2e.names.resume_body": "Encrypting the names in this folder started and did not finish. Items it has not reached yet still have readable names. Continuing picks up where it stopped.",
  "e2e.names.resume": "Continue",
  "e2e.names.stop": "Stop",
  "e2e.names.busy": "Encrypting names…",
  "e2e.names.progress": "{n} names encrypted so far · {failed} could not be renamed",
  "e2e.names.progress_one": "{n} name encrypted so far · {failed} could not be renamed",
  "e2e.names.done": "Names encrypted ({n} items renamed). The server no longer sees them.",
  "e2e.names.done_one": "Names encrypted ({n} item renamed). The server no longer sees them.",
  "e2e.names.stopped": "Stopped after {n} names. The rest keep their readable names until you continue.",
  "e2e.names.stopped_one": "Stopped after {n} name. The rest keep their readable names until you continue.",
  "e2e.names.partial": "{n} items could not be renamed (no permission, or a name a disk cannot hold). Their names stay readable; try again to continue.",
  "e2e.names.partial_one": "{n} item could not be renamed (no permission, or a name a disk cannot hold). Its name stays readable; try again to continue.",
  "e2e.names.failed": "Could not encrypt the names. Nothing already renamed is lost; try again to continue.",
  "e2e.names.strip_fix": "Fix {n} names (readable, or moved in from outside filex)",
  "e2e.names.strip_fix_one": "Fix {n} name (readable, or moved in from outside filex)",
  "e2e.create.names_root_hint": "The folder’s own name stays readable either way - it sits in a folder that is not encrypted. Pick a name that gives nothing away.",
  "e2e.locked_toast": "Folder locked",
  "e2e.app_closed_unsaved": "The changes to “{name}” that were not saved are gone: the app closed when the folder locked.",
  "e2e.upload.locked": "Unlock the folder first",
  "e2e.decrypting": "Decrypting…",
  "e2e.decrypt_failed": "Could not decrypt the file (password changed or file corrupted).",
  /* wiring:e2 recovery - recovery keys + operator escrow */
  "e2e.create.escrow_title": "This server holds a second key",
  "e2e.create.escrow_body": "Key escrow is enabled on this installation, so its operator can open this folder without your password. Using that key notifies you. Escrow is fixed when the server is installed and cannot be turned off for a folder.",
  "e2e.locked.use_recovery": "Lost the password? Use a recovery key",
  "e2e.recovery.title": "Save your recovery key",
  "e2e.recovery.title_upgraded": "Your recovery key",
  "e2e.recovery.lead": "This key opens the folder without its password. It is shown once - filex does not store it and cannot show it again.",
  "e2e.recovery.lead_upgraded": "This folder now has a recovery key. It opens the folder without its password, is shown once, and is not stored by filex.",
  "e2e.recovery.copy": "Copy",
  "e2e.recovery.copied": "Copied",
  "e2e.recovery.download": "Download as a file",
  "e2e.recovery.warn_title": "TREAT THIS LIKE A PASSWORD",
  "e2e.recovery.warn_body": "Anyone holding this key can read the folder. Keep it somewhere separate from the password - a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.escrow_title": "This server also holds a key",
  "e2e.recovery.escrow_body": "Key escrow is enabled here, so the operator of this installation can open this folder without your password. You are notified when that key is used.",
  "e2e.recovery.escrow_kid": "Escrow key",
  "e2e.recovery.ack": "I have saved this key somewhere safe.",
  "e2e.recovery.done": "Done",
  "e2e.recover.title": "Unlock without the password",
  "e2e.recover.none": "This folder was created before recovery keys existed, so it has none. Its password is the only way in. Unlock it with the password once and filex will offer to add a recovery key.",
  "e2e.recover.tab_recovery": "Recovery key",
  "e2e.recover.tab_escrow": "Escrow key",
  "e2e.recover.recovery_hint": "The key shown once when this folder was created.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "The owner will be told",
  "e2e.recover.escrow_warn_body": "Opening a folder with the escrow key notifies its owner. Use it only when you are entitled to.",
  "e2e.recover.escrow_kid": "Escrow key",
  "e2e.recover.escrow_predates": "This installation has an escrow key, but this folder does not. It was created before escrow was turned on here, so its master key was never wrapped to the escrow identity. The escrow key will not open it. Nothing the operator can do changes that - adding a slot needs this folder’s password, which the server has never had. The folder’s owner can grant it: unlock with the password, then choose to give the operator a key. Until they do, use the password or the recovery key.",
  "e2e.recover.escrow_other_key": "This folder carries an escrow key from a DIFFERENT installation. It was created elsewhere and restored here, so this installation’s escrow key does not open it. Only the private key belonging to the escrow key it was sealed to can.",
  "e2e.recover.escrow_placeholder": "Paste the escrow private key (PKCS#8, base64 or PEM)",
  "e2e.recover.bad_format": "That does not look like a recovery key. It is 32 characters in eight groups of four.",
  "e2e.recover.escrow_required": "Paste the escrow private key.",
  "e2e.recover.wrong_recovery": "That recovery key does not open this folder.",
  "e2e.recover.wrong_escrow": "That escrow key does not open this folder. A folder created before escrow was turned on has no escrow slot until its owner grants one - until then, use the password or the recovery key.",
  "e2e.recover.bad_escrow_key": "That is not a readable private key (expected PKCS#8, base64 or PEM).",
  "e2e.recover.notify_failed": "Could not notify the folder owner, so the folder was not unlocked. Escrow use is always announced.",
  "e2e.recover.recovery_done": "Unlocked with the recovery key",
  "e2e.recover.escrow_done": "Unlocked with the escrow key - the owner has been notified",
  "e2e.recover.unlock": "Unlock",
  "e2e.recover.busy": "Unlocking…",
  "e2e.escrowoffer.title": "Give the operator a key to this folder?",
  "e2e.escrowoffer.body": "This folder was created before key escrow was turned on here, so the operator of this installation cannot open it. Right now - while your password is in memory - filex can seal this folder to the escrow key. Your files are not re-encrypted or moved; only the key file changes.",
  "e2e.escrowoffer.consequence": "What this means: the operator gains a second, permanent way into this folder, without your password. You are notified when that key is used, but that notification is an announcement rather than a control.",
  "e2e.escrowoffer.learn_more": "What escrow can and cannot do",
  "e2e.escrowoffer.password_label": "Folder password",
  "e2e.escrowoffer.password_required": "Enter the folder password.",
  "e2e.escrowoffer.wrong_password": "That is not this folder’s password.",
  "e2e.escrowoffer.accept": "Give the operator a key",
  "e2e.escrowoffer.decline": "No, keep it to myself",
  "e2e.escrowoffer.cancel": "Cancel",
  "e2e.escrowoffer.busy": "Sealing…",
  "e2e.escrowoffer.done": "The operator can now open this folder with the escrow key",
  "e2e.escrowoffer.declined_toast": "Kept to yourself. filex will not ask again for this folder.",
  "e2e.escrowoffer.decline_failed": "Could not record your answer, so filex will ask again next time. Nothing about the folder changed.",
  "e2e.escrowoffer.failed": "Could not give the operator a key to this folder",
  "e2e.escrowoffer.strip_action": "Escrow key…",
  "e2e.upgrade.title": "This folder has no recovery key",
  "e2e.upgrade.body": "It was created before recovery keys existed, so its password is the only way in. Right now - and only right now, while the password is in memory - filex can add one. Your files are not re-encrypted or moved.",
  "e2e.upgrade.escrow_note": "Note: this installation has key escrow enabled, so adding a recovery key also lets its operator open this folder without your password.",
  "e2e.upgrade.accept": "Create a recovery key",
  "e2e.upgrade.decline": "Not now",
  "e2e.upgrade.busy": "Creating…",
  "e2e.upgrade.failed": "Could not add a recovery key to this folder",
  "e2e.download.failed": "Could not download the encrypted file.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Storage connections",
  "conn.subtitle": "How to reach {host} from your own computer: mount it, or point a client at it.",
  "conn.close": "Close",
  "conn.list.disabled": "Disabled",
  "conn.form.required": "Required",
  "conn.form.advanced": "Advanced settings",
  /* A two-button decision's own words, when the declaration did not name them. */
  "conn.form.yes": "Yes",
  "conn.form.no": "No",
  "conn.form.noFields": "This server did not describe any settings for this driver.",
  "conn.form.reveal": "Show",
  "conn.form.hide": "Hide",
  "conn.guide.protocol": "Protocol",
  "conn.guide.storage": "Storage",
  "conn.guide.allStorages": "All storages",
  "conn.guide.copy": "Copy",
  "conn.guide.copied": "Copied",
  "conn.guide.goodToKnow": "Good to know",
  "conn.guide.userPlaceholder": "your-email@example.com",
  "conn.guide.secretPlaceholder": "your-password-or-api-key",
  "conn.guide.fact.url": "Address",
  "conn.guide.fact.urlRootHint": "Every storage you can see appears as a folder under this address.",
  "conn.guide.fact.urlStorageHint": "Mounts “{storage}” directly. Drop the last segment to see every storage.",
  "conn.guide.fact.user": "Username",
  "conn.guide.fact.password": "Password",
  "conn.guide.webdav.summary": "WebDAV mounts filex as a drive: Windows Explorer, macOS Finder, Linux, rclone and Cyberduck all speak it, and every change is mirrored back into filex.",
  "conn.guide.webdav.userHint": "Your username or your email - not your display name.",
  "conn.guide.webdav.passwordHint": "Your account password, or an API key (API keys, in the navigation panel). An account with two-factor authentication MUST use an API key: Basic auth has no second-factor slot.",
  "conn.guide.webdav.win.s1": "Open File Explorer, right-click This PC and choose “Map network drive…”.",
  "conn.guide.webdav.win.s2": "Pick a drive letter and enter {url} as the folder.",
  "conn.guide.webdav.win.s3": "Tick “Connect using different credentials” and sign in with the username and password above.",
  "conn.guide.webdav.win.cmdCaption": "Command Prompt (same thing, without the wizard)",
  "conn.guide.webdav.win.limits": "Windows has three built-in limits that look exactly like filex bugs: transfers stop at ~47.7 MB, folders with about a thousand files refuse to open (“Disk is not formatted”), and the WebClient service must be restarted after changing either.",
  "conn.guide.webdav.win.regCaption": "Run as administrator, then reconnect the drive",
  "conn.guide.webdav.win.https": "HTTPS is mandatory. Windows sends Basic credentials over TLS only, and over plain http:// it silently refuses with no useful message. Do not set BasicAuthLevel to 2 - use TLS.",
  "conn.guide.webdav.win.persist": "The mapped drive does not survive a sign-out: since Windows 7 Basic credentials cannot be stored in Credential Manager, and /persistent:yes does not change that. Re-run the command from a logon script if you need it back automatically.",
  "conn.guide.webdav.win.service": "If nothing mounts at all, make sure the WebClient service is running: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "In Finder choose Go → Connect to Server… (⌘K).",
  "conn.guide.webdav.mac.s2": "Enter {url} and connect.",
  "conn.guide.webdav.mac.s3": "Authenticate with the username and password above.",
  "conn.guide.webdav.mac.note": "The drive appears under Locations; each storage is a top-level folder.",
  "conn.guide.webdav.linux.mountCaption": "davfs2, or the desktop file manager (GNOME Files, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "or paste this address into GNOME Files / Dolphin",
  "conn.guide.webdav.linux.locks": "davfs2 needs locking turned off. filex keeps WebDAV locks in process memory, so they do not survive a restart and are not shared between replicas - davfs2 assumes otherwise and hangs.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone stores an obscured password - run this first and paste the output below",
  "conn.guide.webdav.rclone.passPlaceholder": "<output of rclone obscure>",
  "conn.guide.webdav.rclone.useCaption": "Using it",
  "conn.guide.webdav.duck.s1": "New Bookmark → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Server {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Path {path}.",
  "conn.guide.webdav.duck.s4": "Username {user}, password as above.",
  "conn.guide.webdav.note.delete": "A WebDAV delete is permanent. The web UI moves files to the filex trash; a client delete removes the object from the backing storage directly.",
  "conn.guide.webdav.note.locks": "Locks live in server memory: they do not survive a restart and are not shared between replicas. They exist to satisfy Windows and Office, not to arbitrate concurrent edits.",
  "conn.guide.webdav.note.permissions": "You see exactly what you see in the web UI. The root lists only the storages you may open, and a path outside your grants answers 404 rather than 403, so the tree never leaks what exists.",
  "conn.guide.webdav.note.http": "This server is reachable over plain http://. Windows will refuse to send your credentials at all, and every other client sends your password in the clear. Put filex behind TLS before mounting it.",
  // ── S3 endpoint: keys and the guide ──────────────────────────────
  "conn.s3keys.title": "S3 access keys",
  "conn.s3keys.lead": "An access key lets any S3 client - rclone, restic, the AWS CLI, mc, s3fs, Cyberduck - connect to filex. It carries your own permissions and nothing more.",
  "conn.s3keys.disabled": "The S3 endpoint is switched off on this server (FILEX_S3). A key minted here will not connect until an operator turns it back on.",
  "conn.s3keys.cannotMint": "You are not signed in with an account that can mint access keys. The instructions below still apply - ask for a key and paste it in.",
  "conn.s3keys.label": "What is it for? (laptop backup, CI, …)",
  "conn.s3keys.defaultLabel": "access key",
  "conn.s3keys.everyBucket": "Every bucket I can see",
  "conn.s3keys.prefix": "Folder inside the bucket (optional)",
  "conn.s3keys.mint": "Create key",
  "conn.s3keys.inheritNote": "A key can only ever narrow what you already have: your grants and your role. Confining it to one bucket or folder is the difference between a laptop backup and a credential that can read everything.",
  "conn.s3keys.once": "Copy the secret now - this is the only time it is shown.",
  "conn.s3keys.accessKeyID": "Access key ID",
  "conn.s3keys.secret": "Secret key",
  "conn.s3keys.dismiss": "I have copied it",
  "conn.s3keys.col.label": "Label",
  "conn.s3keys.col.key": "Access key ID",
  "conn.s3keys.col.scope": "Limited to",
  "conn.s3keys.col.lastUsed": "Last used",
  "conn.s3keys.scopeAll": "everything you can see",
  "conn.s3keys.noLabel": "(no label)",
  "conn.s3keys.neverUsed": "never",
  "conn.s3keys.enable": "Enable",
  "conn.s3keys.disable": "Disable",
  "conn.s3keys.revoke": "Revoke",
  "conn.s3keys.confirm": "Sure?",
  "conn.s3keys.empty": "No access keys yet.",
  "conn.guide.s3.summary": "The S3 endpoint makes filex the destination for anything that speaks S3 - backups, sync tools, SDKs - using the storages you already have.",
  "conn.guide.s3.keyPlaceholder": "create a key above",
  "conn.guide.s3.secretPlaceholder": "shown once, when you create the key",
  "conn.guide.s3.fact.endpoint": "Endpoint",
  "conn.guide.s3.fact.endpointHint": "Point the client here, not at the web address of filex.",
  "conn.guide.s3.fact.bucket": "Bucket",
  "conn.guide.s3.fact.bucketHint": "A bucket is a filex storage. Buckets are created by an administrator, not by the client.",
  "conn.guide.s3.fact.key": "Access key ID",
  "conn.guide.s3.fact.keyHint": "The public half. It travels in every request.",
  "conn.guide.s3.fact.secret": "Secret key",
  "conn.guide.s3.fact.secretHint": "Shown once, when the key is created. filex cannot show it again - create a new key if it is lost.",
  "conn.guide.s3.fact.region": "Region",
  "conn.guide.s3.fact.regionHint": "filex has no regions; any value works and is echoed back. Clients still insist on one.",
  "conn.guide.s3.fact.addressing": "Addressing",
  "conn.guide.s3.fact.pathStyle": "path-style (required)",
  "conn.guide.s3.fact.pathStyleHint": "There is no dedicated S3 host on this install, so bucket.host does not resolve.",
  "conn.guide.s3.fact.virtualHosted": "virtual-hosted or path-style",
  "conn.guide.s3.fact.virtualHostedHint": "This install has its own S3 host, so both styles work.",
  "conn.guide.s3.rclone.useCaption": "Use it",
  "conn.guide.s3.rclone.mtime": "filex carries the file modification time (x-amz-meta-mtime), so rclone sync settles after the first run instead of re-uploading everything.",
  "conn.guide.s3.aws.configureCaption": "Configure once",
  "conn.guide.s3.aws.useCaption": "Use it",
  "conn.guide.s3.aws.pathStyle": "Add path addressing to your AWS config, or every command fails at DNS.",
  "conn.guide.s3.restic.envCaption": "Environment",
  "conn.guide.s3.restic.useCaption": "Back up, verify, prune",
  "conn.guide.s3.restic.verified": "Verified against this endpoint: restic check --read-data reads every pack byte for byte and reports no errors.",
  "conn.guide.s3.mc.aliasCaption": "Add the alias",
  "conn.guide.s3.mc.useCaption": "Use it",
  "conn.guide.s3.s3fs.credsCaption": "Credentials file",
  "conn.guide.s3.s3fs.mountCaption": "Mount it",
  "conn.guide.s3.s3fs.note": "Editing a file over s3fs rewrites the whole object, and a delete goes to the filex trash. Good for a shared folder, not for a database.",
  "conn.guide.s3.duck.s1": "New bookmark → Amazon S3.",
  "conn.guide.s3.duck.s2": "Server: {host}.",
  "conn.guide.s3.duck.s3": "Access key ID: {key}, secret as above.",
  "conn.guide.s3.duck.s4": "Open the bookmark; the buckets are your filex storages.",
  "conn.guide.s3.duck.pathStyle": 'In Preferences → S3, turn OFF "Use virtual host style" - this install has no wildcard S3 host.',
  "conn.guide.s3.sdk.note": "Any SigV4 client works the same way: endpoint, key, secret, and path addressing when this install has no S3 host of its own.",
  "conn.guide.s3.note.buckets": "A bucket is a filex storage. A client can create folders and objects inside one, but not the bucket itself - that needs a driver and a path, which an S3 request cannot express.",
  "conn.guide.s3.note.permissions": 'The key sees exactly what you see. A bucket you may not open answers "no such bucket" rather than "forbidden", so the endpoint never reveals what exists.',
  "conn.guide.s3.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.s3.note.mtime": "Uploads carry their modification time, and the checksums clients send (Content-MD5, x-amz-checksum-*) are verified - a corrupted upload is refused rather than stored.",
  "conn.guide.s3.note.pathStyle": "This install has no dedicated S3 host, so clients must be told to use path-style addressing. Without it a current SDK fails at DNS with an error that names neither filex nor the cause.",
  "conn.guide.s3.note.http": "This endpoint is plain http://. Signatures still protect the request, but the objects travel in the clear. Put filex behind TLS before pointing a backup at it.",
  // ── SFTP endpoint: keys and the guide ────────────────────────────
  "conn.sshkeys.title": "SSH keys",
  "conn.sshkeys.lead": "Register a public key and every SSH client - sftp, scp, WinSCP, FileZilla, rclone, sshfs - can connect without sending your password.",
  "conn.sshkeys.disabled": "The SFTP endpoint is switched off on this server (FILEX_SFTP). A key registered here will not connect until an operator turns it back on.",
  "conn.sshkeys.cannotAdd": "You are not signed in with an account that can register keys.",
  "conn.sshkeys.paste": "Paste the contents of ~/.ssh/id_ed25519.pub",
  "conn.sshkeys.name": "Name (optional - the key comment is used otherwise)",
  "conn.sshkeys.add": "Add key",
  "conn.sshkeys.noCopyId": "ssh-copy-id cannot work here: it appends to ~/.ssh/authorized_keys over a shell, and filex has none. This box is the way in.",
  "conn.sshkeys.col.name": "Name",
  "conn.sshkeys.col.fingerprint": "Fingerprint",
  "conn.sshkeys.col.added": "Added",
  "conn.sshkeys.col.lastUsed": "Last used",
  "conn.sshkeys.noName": "(no name)",
  "conn.sshkeys.neverUsed": "never",
  "conn.sshkeys.enable": "Enable",
  "conn.sshkeys.disable": "Disable",
  "conn.sshkeys.remove": "Remove",
  "conn.sshkeys.confirm": "Sure?",
  "conn.sshkeys.empty": "No keys yet. Without one, clients sign in with your account password.",
  "conn.guide.sftp.summary": "SFTP makes filex reachable by anything that already speaks SSH - a backup job, a scanner, WinSCP, rclone, or a mounted folder.",
  "conn.guide.sftp.fact.host": "Host",
  "conn.guide.sftp.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Not 22 and not 443: SFTP is raw TCP and cannot go through the web proxy.",
  "conn.guide.sftp.fact.userHint": "Your username. An @ in it would have to be quoted in most client config files, which is what the username avoids.",
  "conn.guide.sftp.fact.auth": "Sign in with",
  "conn.guide.sftp.fact.authKey": "your registered SSH key (or your password)",
  "conn.guide.sftp.fact.authPassword": "your account password - or register a key above",
  "conn.guide.sftp.fact.authHint": "An API key works as a password too, and is revocable on its own. An account with two-factor sign-in must use an SSH key or an API key.",
  "conn.guide.sftp.fact.path": "Path",
  "conn.guide.sftp.fact.pathHint": "The first folder is a storage; the root lists the ones you may open.",
  "conn.guide.sftp.openssh.connectCaption": "Connect, put, get",
  "conn.guide.sftp.openssh.noShell": "There is no shell here - only the SFTP subsystem. `ssh host command` is refused on purpose, and scp works because OpenSSH 9 speaks SFTP for it.",
  "conn.guide.sftp.key.tab": "Set up a key",
  "conn.guide.sftp.key.s1": "Generate a key pair on the machine that will connect (skip if you already have one).",
  "conn.guide.sftp.key.s2": "Copy the PUBLIC half - the .pub file, never the other one.",
  "conn.guide.sftp.key.s3": "Paste it into the box above and connect; no password is sent from then on.",
  "conn.guide.sftp.key.genCaption": "On your own machine",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id will NOT work against filex: it needs a shell to append to ~/.ssh/authorized_keys, and there is none. Paste the key above instead.",
  "conn.guide.sftp.winscp.s1": "New site → File protocol: SFTP.",
  "conn.guide.sftp.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "User name: {user}. For a key: Advanced → SSH → Authentication → private key file.",
  "conn.guide.sftp.winscp.s4": "WinSCP needs a .ppk private key - use its own tool (Tools → PuTTYgen) to convert an OpenSSH key once.",
  "conn.guide.sftp.filezilla.s1": "File → Site Manager → New site, Protocol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "User: {user}. Logon type: Normal for a password, or Key file for a key.",
  "conn.guide.sftp.rclone.useCaption": "Use it",
  "conn.guide.sftp.sshfs.mountCaption": "Mount and unmount",
  "conn.guide.sftp.sshfs.note": "A mounted folder rewrites the whole file on every save. Good for documents, not for a database or a video you are editing in place.",
  "conn.guide.sftp.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.sftp.note.permissions": "The permission bits your client draws come from your access level here, so a file shown as read-only really is one for you.",
  "conn.guide.sftp.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.sftp.note.totp": "If your account has two-factor sign-in, the password will not work here - SSH has no way to ask for the code. Register an SSH key, or use an API key as the password.",
  "conn.guide.sftp.note.disabled": "The SFTP endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS is here for the equipment that only ever learned FTP - scan-to-folder printers, EDI counterparties, older lab and industrial software. Always over TLS.",
  "conn.guide.ftps.fact.host": "Host",
  "conn.guide.ftps.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "The control channel. Data moves on a separate port from the passive range below.",
  "conn.guide.ftps.fact.mode": "Encryption",
  "conn.guide.ftps.fact.modeValue": "FTPS - explicit TLS (AUTH TLS), required",
  "conn.guide.ftps.fact.modeHint": 'Plain FTP is refused before the password is read. Choose "Require explicit FTP over TLS", never "plain FTP" and never "implicit".',
  "conn.guide.ftps.fact.userHint": "Your username, or your email. An API key works as the password too and can be revoked on its own.",
  "conn.guide.ftps.fact.passwordHint": "Your account password, or an API key. An account with two-factor sign-in must use an API key - FTP has no way to ask for the code.",
  "conn.guide.ftps.fact.pasv": "Passive ports",
  "conn.guide.ftps.fact.pasvHint": "Data connections land here. If your firewall blocks this range the transfer HANGS with no error on either side - that is the classic FTP failure.",
  "conn.guide.ftps.filezilla.s1": "File → Site Manager → New site, Protocol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Encryption: "Require explicit FTP over TLS". Logon type: Normal, user: {user}.',
  "conn.guide.ftps.filezilla.s4": "Transfer settings → Passive. Active mode is refused by this server.",
  "conn.guide.ftps.winscp.s1": "New site → File protocol: FTP, Encryption: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "User name: {user}, password as above.",
  "conn.guide.ftps.curl.caption": "Upload and download",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd is not optional: it makes curl REQUIRE TLS instead of falling back to plaintext. This server refuses plaintext anyway, but the habit protects you against the servers that do not.",
  "conn.guide.ftps.lftp.caption": "Connect",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data encrypts the FILE as well as the sign-in. Without it lftp signs in over TLS and then sends your file in the clear - which is the FTPS misconfiguration people actually ship.",
  "conn.guide.ftps.rclone.useCaption": "Use it",
  "conn.guide.ftps.printer.tab": "Scanner / printer",
  "conn.guide.ftps.printer.s1": "In the device's scan-to-FTP settings: server {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "User: {user}, password as above. Create an API key for the device rather than using your own password - it can be revoked without changing anything else.",
  "conn.guide.ftps.printer.s3": "Path: {path} - or a folder inside it that you created first. The device cannot create a storage.",
  "conn.guide.ftps.printer.s4": 'Turn ON "SSL/TLS" or "FTPS explicit", and PASSIVE mode.',
  "conn.guide.ftps.printer.noTLS": "Plenty of scan-to-FTP firmware cannot do TLS at all. This server will not talk to such a device, and that is deliberate - the alternative is your documents and your password crossing the office network in the clear.",
  "conn.guide.ftps.note.tls": "TLS is mandatory and there is no switch to turn it off. Plain FTP sends your password in the clear and your file after it.",
  "conn.guide.ftps.note.passive": "Passive mode only. Active mode has the server dial back to the client, which does not survive NAT and is blocked by most firewalls.",
  "conn.guide.ftps.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.ftps.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.ftps.note.prefer": "If the client can speak SFTP, prefer it: one connection, one port, no passive-mode surprises.",
  "conn.guide.ftps.note.selfSigned": "This server is using a self-signed certificate. It encrypts the channel but proves nothing about who is on the other end - most clients will ask you to accept it once. Supply a real certificate for anything that matters.",
  "conn.guide.ftps.note.disabled": "The FTPS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS exports",
  "conn.nfs.lead": "An export lets a machine on your network mount filex as a drive - a media player, a build server, a backup box.",
  "conn.nfs.pathIsSecret": "⚠ The export path IS the password. NFS cannot ask a client who it is without Kerberos, so filex puts 32 random bytes in the path instead: whoever knows it can mount as you. Treat the mount line like a credential - /etc/fstab is world-readable on most systems.",
  "conn.nfs.disabled": "The NFS endpoint is switched off on this server (FILEX_NFS). An export created here will not mount until an operator turns it back on.",
  "conn.nfs.cannotMint": "You are not signed in with an account that can create exports.",
  "conn.nfs.label": "What is it for? (media player, backup box, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Every storage I can see",
  "conn.nfs.prefix": "Folder inside the storage (optional)",
  "conn.nfs.allowCidrs": "Allowed addresses, e.g. 192.168.1.0/24 (optional)",
  "conn.nfs.readOnly": "Read-only",
  "conn.nfs.readOnlyHint": "Read-only is the safer default for a machine: it refuses every write through this mount whatever your own permissions are. An address list narrows it further - outside it, the mount is refused.",
  "conn.nfs.mint": "Create export",
  "conn.nfs.once": "Copy this now - the path is shown only once and cannot be recovered.",
  "conn.nfs.dismiss": "I have copied it",
  "conn.nfs.col.label": "Label",
  "conn.nfs.col.scope": "Limited to",
  "conn.nfs.col.mode": "Mode",
  "conn.nfs.col.lastUsed": "Last mounted",
  "conn.nfs.scopeAll": "everything you can see",
  "conn.nfs.modeRead": "read-only",
  "conn.nfs.modeWrite": "read/write",
  "conn.nfs.noLabel": "(no label)",
  "conn.nfs.neverUsed": "never",
  "conn.nfs.enable": "Enable",
  "conn.nfs.disable": "Disable",
  "conn.nfs.revoke": "Revoke",
  "conn.nfs.confirm": "Sure?",
  "conn.nfs.empty": "No exports yet.",
  "conn.guide.nfs.summary": "NFS mounts filex as a drive on a machine in your own network - the NAS protocol, for the devices that expect one.",
  "conn.guide.nfs.pathPlaceholder": "create an export above",
  "conn.guide.nfs.fact.host": "Host",
  "conn.guide.nfs.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Both port= and mountport= must be set to this; filex serves the mount and NFS services on one port.",
  "conn.guide.nfs.fact.export": "Export path",
  "conn.guide.nfs.fact.exportHint": "This is the credential. It is shown once, when you create the export, and is stored hashed - filex cannot show it again.",
  "conn.guide.nfs.fact.options": "Mount options",
  "conn.guide.nfs.fact.optionsHint": "nolock because filex does not run the NFS lock manager; nfsvers=3 because that is what this server speaks.",
  "conn.guide.nfs.linux.mountCaption": "Mount it",
  "conn.guide.nfs.linux.fstabSecret": "An /etc/fstab line containing this path is a password in a world-readable file. Use a credentials-protected automount, or keep the mount in a root-only unit, if that matters where you are.",
  "conn.guide.nfs.mac.mountCaption": "Mount it",
  "conn.guide.nfs.mac.resvport": "macOS needs resvport: its client insists on a privileged source port and refuses the mount without it.",
  "conn.guide.nfs.win.s1": 'Turn on "Services for NFS" → "Client for NFS" in Windows Features (Pro and Enterprise only; Home does not have it).',
  "conn.guide.nfs.win.s2": "Open a Command Prompt as administrator.",
  "conn.guide.nfs.win.s3": "Map the export to a drive letter with the command below.",
  "conn.guide.nfs.win.cmdCaption": "Map it to Z:",
  "conn.guide.nfs.win.port": "Windows has no way to say which port the mount service is on, so it can only reach an NFS server on the standard port 2049. If this server is on another port, use SFTP or the filex desktop app instead.",
  "conn.guide.nfs.nas.tab": "NAS / media player",
  "conn.guide.nfs.nas.s1": "In the device's NFS settings: server {host}, port {port} (set both the NFS and the mount port if it asks for them separately).",
  "conn.guide.nfs.nas.s2": "Remote path: the export path above, exactly as shown.",
  "conn.guide.nfs.nas.s3": "NFS version 3, no locking. Create the export read-only unless the device genuinely needs to write.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 is not encrypted. Anyone who can read the traffic sees your files, and anyone who learns the path can mount them. Use it on a home or office network, or over a VPN - never across the internet.",
  "conn.guide.nfs.note.pathIsSecret": "The export path is the whole credential. Revoke it from the list above if it leaks; there is nothing else to change.",
  "conn.guide.nfs.note.noPortmapper": "There is no portmapper on port 111, so a client that is not told the port cannot find the server. That is why every command here carries port= and mountport=.",
  "conn.guide.nfs.note.uid": "The user and group ids your client sends are ignored: the mount already knows whose it is. The permissions you see come from your access in filex.",
  "conn.guide.nfs.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.nfs.note.revoke": "Revoking takes effect on the next request, not instantly: NFS has no session to end, so a client with the mount open sees its next operation fail.",
  "conn.guide.nfs.note.disabled": "The NFS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  "conn.tokens.title": "API keys",
  "conn.tokens.lead": "FTPS, WebDAV and filex mount all sign in with an API key instead of your account password. Create one here - it can be revoked on its own, and an account with two-factor sign-in cannot use its password on these at all.",
  "conn.tokens.mint": "Create API key",
  "conn.tokens.once": "Copy it now - this is the only time it is shown. Only a hash is stored, so it cannot be shown again.",
  "conn.tokens.dismiss": "I have copied it",
  "conn.tokens.cannotMint": "This session cannot create API keys. Sign in with your own account to create one.",
  "conn.tokens.empty": "No API keys yet.",
  "conn.tokens.neverUsed": "never",
  "conn.tokens.revoke": "Revoke",
  "conn.tokens.confirm": "Sure?",
  "conn.tokens.col.label": "Name",
  "conn.tokens.col.scopes": "Permissions",
  "conn.tokens.col.comments": "Comments",
  "conn.tokens.col.used": "Last used",
  "conn.tokens.revokeHint": "Revoking stops a connection that is already open, not just the next sign-in: an SFTP or FTPS session is cut and a mount stops working within about half a minute.",
  "conn.guide.mount.summary": "filex mount attaches a remote filex server to a folder on this machine, over the same HTTPS the browser uses. It is the only one of these that works from anywhere - no LAN, no extra server, no third-party client.",
  "conn.guide.mount.fact.url": "Server URL",
  "conn.guide.mount.fact.urlHint": "The same address you use in the browser. Nothing else has to be reachable.",
  "conn.guide.mount.fact.token": "API key",
  "conn.guide.mount.fact.tokenPlaceholder": "create one under API keys",
  "conn.guide.mount.fact.tokenHint": "An API key, not your password - it can be revoked on its own, and an account with 2FA cannot use its password here at all.",
  "conn.guide.mount.fact.remote": "What to mount",
  "conn.guide.mount.fact.remoteHint": "Leave --remote off to see every storage as a folder, or name one storage - or a folder inside it - to mount just that.",
  "conn.guide.mount.linux.mountCaption": "Mount it",
  "conn.guide.mount.linux.umountCaption": "Unmount it",
  "conn.guide.mount.linux.umountWarn": "Unmount with fusermount, not by killing the process. A mount whose process died without detaching leaves a folder where every ls hangs until somebody runs fusermount by hand.",
  "conn.guide.mount.linux.systemdCaption": "Mount it at sign-in (systemd user unit)",
  "conn.guide.mount.win.winfsp": "Windows needs WinFsp installed once - it is free and open source: https://winfsp.dev. Nothing else, and no administrator rights after that.",
  "conn.guide.mount.win.mountCaption": "Mount it as a drive",
  "conn.guide.mount.win.freeLetter": "Pick a drive letter that is FREE. The letter is created by the mount, not attached to something that already exists, and pointing it at one that is in use fails with a message that does not say so.",
  "conn.guide.mount.win.stop": "Stop it with Ctrl-C in that window. The drive disappears and nothing is left behind on this machine.",
  "conn.guide.mount.mac.unsupported": "filex mount does not work on macOS. It needs macFUSE, whose license does not allow a program like filex to install it for you, and whose Go binding needs a C compiler filex deliberately does not require. The command refuses here rather than appearing to work and doing nothing.",
  "conn.guide.mount.mac.alternatives": "On macOS, use the filex desktop app with folder sync (keeps the files on disk), or SFTP with a client that mounts drives.",
  "conn.guide.mount.note.notASync": "This is not a sync. Nothing is copied to this machine except a small read cache, so a mount opens one file out of a hundred thousand without downloading the rest. If you want the files when you are offline, use folder sync instead.",
  "conn.guide.mount.note.reachable": "It reaches the server through whatever proxy or tunnel the browser goes through, because underneath it is the same API. Your permissions and your storages come with it.",
  "conn.guide.mount.note.wholeFileWrites": "A file you write through the mount is uploaded when the program closes it, not while it is being written. Editing a very large file in place is slower here than a local disk; copying it in and out is not.",
  "conn.guide.mount.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.mount.note.revoke": "Revoke the API key to stop a mount. It stops serving within half a minute, even if the mount is still attached.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Local filesystem",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "The share name alone, without the server: `media`, not `\\\\nas\\media`.",
  "storages.fieldHelp.smbDomain": "Only for a Windows domain account. Leave empty for a NAS.",
  "storages.fieldHelp.smbRoot": "Sub-folder inside the share. Leave empty for the whole share.",
  "storages.fields.share": "Share",
  "storages.fields.domain": "Domain / workgroup",
  "storages.fieldHelp.disablePresign": "On by default: uploads and the downloads behind public share links stream through filex, so the bucket endpoint never has to be reachable from a browser (a LAN-only MinIO just works). Turn it off only when the endpoint is reachable from your users' browsers (AWS, a public MinIO) and you want them to talk to the bucket directly - faster for very large files, and the store must accept SDK-signed URLs (Ceph RGW / some Hetzner setups answer SignatureDoesNotMatch).",
  "storages.fieldHelp.endpoint": "Leave empty for AWS S3. Any S3-compatible store needs its endpoint.",
  "storages.fieldHelp.hostKey": "A single public key in authorized_keys / known_hosts line form.",
  "storages.fieldHelp.insecureSkipHostKey": "Accepts any host key. Only for throwaway hosts.",
  "storages.fieldHelp.keyPath": "Path to a key file on the server, read when the storage starts. Used when the PEM field is empty.",
  "storages.fieldHelp.knownHosts": "OpenSSH known_hosts path for strict host-key checking. Default is trust-on-first-use in ~/.filex/known_hosts.",
  "storages.fieldHelp.passive": "Off switches to active mode, which needs the server to dial back into this host.",
  "storages.fieldHelp.path": "Directory on the server. It is created if missing; filex never mounts /.",
  "storages.fieldHelp.pathStyle": "On for every non-AWS store. It is turned on automatically when an endpoint is set and this was never touched.",
  "storages.fieldHelp.prefix": "Sub-folder inside the bucket. Required: filex never takes ownership of the bucket root.",
  "storages.fieldHelp.region": 'Defaults to "auto" when left empty.',
  "storages.fieldHelp.root": "Sub-folder on the backend. Required: filex never mounts the account root.",
  "storages.fieldHelp.sftpAuth": "Either a password or a private key is required.",
  "storages.fieldHelp.tls": "Plain FTP sends credentials in the clear - turn this on whenever the server supports it.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Base path",
  "storages.fields.bucket": "Bucket",
  "storages.fields.disablePresign": "Stream transfers through filex",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Host",
  "storages.fields.hostKey": "Pinned host key",
  "storages.fields.insecureSkipHostKey": "Skip host-key verification (insecure)",
  "storages.fields.keyPath": "Private key file",
  "storages.fields.knownHosts": "known_hosts file",
  "storages.fields.name": "Display name",
  "storages.fields.namePlaceholder": "Personal photos",
  "storages.fields.passive": "Passive mode (PASV)",
  "storages.fields.password": "Password",
  "storages.fields.path": "Filesystem path",
  "storages.fields.pathStyle": "Use path-style URLs (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Prefix",
  "storages.fields.privateKey": "Private key (PEM)",
  "storages.fields.rbac": "Per-item access control (RBAC)",
  "storages.fields.rbacHint": "When on, non-admins see only the files and folders granted to them (listed under Folder access). When off, everyone opens the storage according to their role.",
  "storages.fields.readOnly": "Read-only mount",
  "storages.fields.region": "Region",
  "storages.fields.root": "Base path",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (explicit AUTH TLS)",
  "storages.fields.url": "Base URL",
  "storages.fields.user": "User",
  "storages.fields.s3AttemptTimeout": "Attempt timeout (seconds)",
  "storages.fields.s3MaxAttempts": "Attempts per request",
  "storages.fields.s3TotalTimeout": "Give up after (seconds)",
  "storages.fieldHelp.s3AttemptTimeout": "How long one attempt may wait for a sign of life from the store: connecting, the TLS handshake, the answer after the request is sent, and each next piece of the answer. A transfer that keeps moving is never cut, however long it takes; an upload the store stops taking is cut after 60 seconds, or after this if it is longer. Copies and renames wait up to 10 minutes for the answer, because the store answers them only when the copy is done.",
  "storages.fieldHelp.s3MaxAttempts": "How many times a request is tried in all when the failure can pass: a network error, a timeout, a 5xx answer, throttling. 1 turns retrying off. A refusal (403, a missing bucket, a host name that does not resolve) is never retried.",
  "storages.fieldHelp.s3TotalTimeout": "No new attempt starts unless it could finish within this many seconds of the first, so an upload or a listing on a store that is down reports the outage within this time. A transfer that is under way is not cut. A request that timed out is tried again only when this is at least twice the attempt timeout.",
  "storages.fields.attemptTimeout": "Attempt timeout (seconds)",
  "storages.fields.maxAttempts": "Attempts per request",
  "storages.fields.totalTimeout": "Give up after (seconds)",
  "storages.fieldHelp.attemptTimeout": "How long one attempt may wait for a sign of life from the server: connecting, logging in, the answer to each request, and each next piece of a transfer. A transfer that keeps moving is never cut, however long it takes; an upload the server stops taking is cut after 60 seconds, or after this if it is longer.",
  "storages.fieldHelp.webdavAttemptTimeout": "How long one attempt may wait for a sign of life from the server: connecting, logging in, the answer to each request, and each next piece of a transfer. A transfer that keeps moving is never cut, however long it takes; an upload the server stops taking is cut after 60 seconds, or after this if it is longer. Copies, moves and deletes wait up to 10 minutes for the answer, because the server answers them only when the work is done.",
  "storages.fieldHelp.maxAttempts": "How many times a request is tried in all when the failure can pass: the connection is refused or drops, no answer comes in time, the server answers that it is unavailable (5xx). 1 turns retrying off. A refusal (a wrong password, a missing folder, a certificate that does not verify) is never retried, and neither is an upload that has started sending.",
  "storages.fieldHelp.totalTimeout": "No new attempt starts unless it could finish within this many seconds of the first, so a server that is down is reported within this time. A transfer that is under way is not cut. A request that timed out is tried again only when this is at least twice the attempt timeout.",
  /* === gezinti:g1 - navigation panel (SideNav) === */
  "sidenav.title": "Navigation",
  "sidenav.views": "Views",
  "sidenav.storages": "Storages",
  "sidenav.home": "Home",
  "sidenav.myfiles": "My files",
  "sidenav.recent": "Recent",
  "sidenav.starred": "Starred",
  "sidenav.shared": "Shared with me",
  // The mirror of the row above, and it sits right under it: what came in,
  // and what went out. ⚠ "My shares", not "Shared by me" - the page lists
  // LINKS the person minted, not files they granted somebody access to.
  "sidenav.myshares": "My shares",
  "sidenav.trash": "Trash",
  "sidenav.collapse": "Collapse navigation",
  "sidenav.expand": "Expand navigation",
  "sidenav.close": "Close navigation",
  // ⚠ `open`/`close` are the DRAWER's pair, `expand`/`collapse` the docked
  // panel's, and they are not interchangeable - see the note on
  // `navToggleLabel` in Toolbar.vue. Below 560px the panel is a drawer over
  // the listing: it is not narrowed to a rail, it is not on screen at all, so
  // "expand" would promise a width change to something that has no width.
  "sidenav.open": "Open navigation",
  "sidenav.storage.shared": "Shared",
  "sidenav.storage.readOnly": "Read-only",
  // #57 - a storage row's order menu (right click, a long press, Shift+F10).
  // "Sort by name" writes an order the person can keep adjusting; it is not a
  // mode. "Use default order" lets the person's own order go: the panel then
  // follows the administrator's order (or, with none, the server's). The two
  // `.done`/`.none` lines are the reason a greyed row gives.
  "sidenav.storage.moveUp": "Move up",
  "sidenav.storage.moveDown": "Move down",
  "sidenav.storage.sortName": "Sort by name",
  "sidenav.storage.sortName.done": "Already sorted by name",
  "sidenav.storage.defaultOrder": "Use default order",
  "sidenav.storage.defaultOrder.none": "Already in the default order",
  // ⚠ `toolbar.nav` is GONE, and nothing replaced it. It was the one label on
  // the panel's collapse control, first as the noun "Navigation" - which names
  // the panel and never says the button does anything to it, so the owner
  // could not find how to collapse the panel (2026-09-13: "yan menüyü kısıp
  // açabilir olalım ya bence") - and then as the static stopgap "Show or hide
  // navigation". The four `sidenav.*` verbs above are the real fix: the label
  // is bound to `navOpen`, so it says *collapse* when it will collapse and
  // *expand* when it will expand.
  "node.home": "Home",
  "node.recent": "Recent",
  "node.starred": "Starred",
  "node.shared": "Shared with me",
  "empty.recent.title": "Nothing opened yet",
  "empty.recent.hint": "Files you open show up here",
  "empty.starred.title": "Nothing starred yet",
  "empty.starred.hint": "Star a file to find it here",
  "empty.shared.title": "Nothing has been shared with you",
  "empty.shared.hint": "Folders and files other people share appear here",
  /* etiket:t1 */
  "sidenav.tags": "Tags",
  "sidenav.tags.empty": "No tags yet - add one from a file’s right-click menu.",
  "sidenav.tags.more": "Show {count} more",
  "sidenav.tags.less": "Show fewer",
  "sidenav.tags.personal": "Personal",
  "sidenav.tags.team": "Team",
  "empty.tag.title": "Nothing is tagged “{tag}”",
  "empty.tag.hint": "Right-click a file and choose Tags to put it here",
  "sidenav.connections": "Connections",
  "sidenav.apps": "Apps",
  // #162 - the store screen: the catalog of the stores an administrator turned
  // on, where a person asks for an app.
  "sidenav.appstore": "App store",
  "sidenav.connect": "How to connect",
  "sidenav.apikeys": "API keys",
  "overlay.close": "Close",
  "conn.tokens.scopes": "Permissions",
  "conn.tokens.root": "Limit to one folder (optional)",
  "conn.tokens.rootPlaceholder": "storage://folder",
  "conn.tokens.expiry": "Expires in (days)",
  "conn.tokens.expiryNever": "never",
  "conn.tokens.defaultName": "API key {date}",
  "conn.tokens.namePlaceholder": "Name - e.g. backup script",
  "conn.tokens.capNote": "Your own access is the ceiling - a permission you do not have is refused, not granted.",
  "conn.tokens.scopesRequired": "Choose at least one permission - an API key is never issued with none.",
  "conn.tokens.comments": "Comments",
  "conn.tokens.commentsRead": "Read",
  "conn.tokens.commentsRw": "Read and write",
  "conn.tokens.commentsHint": "Adding and deleting comments is a permission of its own - “write” does not include it. Every API key reads them.",
  "conn.tokens.commentsToRw": "Comments: allow writing",
  "conn.tokens.commentsToRead": "Comments: read only",
  /* === /gezinti:g1 === */
  /* === surucu:d1 - the shell (GitHub #14); every profile, no longer a
     `uiProfile: 'drive'` opt-in === */
  "drive.new": "New",
  "drive.new.upload": "Upload files",
  "drive.new.folder": "New folder",
  "drive.new.request": "Request files",
  "drive.new.document": "New document",
  /* === belge:n1 - "New document": the picker under + New =================
     Type names are NOT listed here. A tile reads its words from
     lib/fileIcons `typeLabelFor`, the same table the listing's Type column
     uses, so ".docx" is called the same thing in both places and a new type
     needs no string at all. Only this dialog's own chrome lives below. */
  "newdoc.title": "New document",
  "newdoc.type.label": "Document type",
  "newdoc.group.document": "Documents",
  "newdoc.group.text": "Text and code",
  "newdoc.group.diagram": "Diagrams",
  "newdoc.group.app": "Apps",
  /* ⚠ One name per service, the name its own project uses: draw.io (not
     "drawio", not "diagrams.net") and ONLYOFFICE - the QA sweep of
     2026-09-21 found draw.io called three things on three screens. */
  "newdoc.empty.title": "No document types are available",
  "newdoc.empty.body": "This server did not offer any type this app can create.",
  "newdoc.empty.blocked": "Every type this server can create needs an editor service that is not configured here.",
  "newdoc.name": "Name",
  "newdoc.name.placeholder": "File name, e.g. notes.txt or LICENSE",
  "newdoc.untitled": "Untitled",
  "newdoc.err.slash": "A name cannot contain a slash.",
  "newdoc.err.exists": "{name} is already here. Choose another name.",
  "newdoc.err.bare_ext": "Give the file a name, not only an extension.",
  "newdoc.err.ext_needs_type": "A .{ext} file has to be created as its own type - an empty one would not open. Choose that type, or another extension.",
  "newdoc.hint.ext_added": "This type keeps its extension, so the file will be created as {name}.",
  // Drafts (issue #71): a new document is a draft until its first save.
  "sidenav.drafts": "Drafts",
  "sidenav.drafts.count": "{n} drafts",
  "sidenav.drafts.count_one": "{n} draft",
  "node.drafts": "Drafts",
  "empty.drafts.title": "No drafts",
  "empty.drafts.hint": "A new document waits here until you save it where it belongs.",
  "drafts.lead": "New documents that have not been saved yet. Only you can see them.",
  "drafts.count_of": "{n} of {limit} drafts",
  "drafts.col.target": "Save to",
  "drafts.col.storage": "Storage",
  "drafts.action.save": "Save to disk",
  "drafts.open_hint": "Open {name}",
  "drafts.no_match": "No draft matches the filter.",
  "draft.badge": "Draft",
  "draft.bar.target": "will be saved to {folder}",
  "draft.save": "Save",
  "draft.saved_to": "{name} was saved to {folder}.",
  "draft.discarded": "{name} was moved to the trash.",
  "draft.kept": "Kept in Drafts",
  "draft.editing": "Editing…",
  "draft.close.title": "Close this draft?",
  "draft.close.body": "{name} is a draft for {folder} and has not been saved there yet.",
  "draft.close.hint": "A kept draft waits in Drafts. Discard moves it to the trash.",
  "draft.close.save": "Save to disk",
  "draft.close.keep": "Keep in Drafts",
  "draft.close.discard": "Discard",
  "outside.title": "This file changed outside filex",
  "outside.body": "{name} was changed somewhere else while it was open here, and this editor has changes of its own. Which version should stay?",
  "outside.theirs": "Keep the outside version",
  "outside.theirs_hint": "the changes made here are dropped and the outside version is loaded.",
  "outside.mine": "Write mine",
  "outside.mine_hint": "your version replaces the outside one when it is saved.",
  "outside.both": "Keep both",
  "outside.both_hint": "the outside version stays where it is, and yours is saved beside it as a separate copy (name.filex-conflict-time).",
  "outside.hint": "Until you choose, nothing is written over either version.",
  "outside.pending": "This file changed outside filex. Nothing is written over either version until you choose which one stays.",
  "outside.choose": "Choose…",
  "outside.note.reloaded": "The file was updated outside filex; the new version is loaded.",
  "outside.note.theirs": "The outside version is loaded; the changes made here were dropped.",
  "outside.note.mine": "Your version will replace the outside one when it is saved.",
  "outside.note.both": "The outside version stays; yours will be saved beside it as a separate copy.",
  "draft.taken.title": "A file with this name is already there",
  "draft.taken.body": "{folder} already has a file called {name}. Save the draft as {suggested} instead?",
  "draft.taken.confirm": "Save as {name}",
  "upload.taken.body": "{folder} already has something called {name}, and a vault keeps no earlier version. Upload it as {suggested} instead?",
  "upload.taken.confirm": "Upload as {name}",
  "newdoc.hint.draft": "It opens as a draft: nothing is created in the folder until you save it.",
  "newdoc.err.draft_limit": "You already keep as many drafts as this server allows ({limit}). Save or delete some in Drafts first.",
  "newdoc.err.draft_limit_any": "You already keep as many drafts as this server allows. Save or delete some in Drafts first.",
  "newdoc.open_drafts": "Open Drafts",
  "newdoc.location": "Location",
  "newdoc.location.none": "Choose a folder",
  "newdoc.location.change": "Change",
  "newdoc.location.noaccess": "You cannot save into this folder.",
  "newdoc.create": "Create",
  "newdoc.creating": "Creating…",
  "newdoc.cancel": "Cancel",
  // ⚠ The top search field searches the WHOLE storage (and every storage at
  // the root) - never only the open folder. The scope named here is therefore
  // the storage, not the folder; "Filter in this folder…" (FilterBar) is the
  // folder-scoped one. It used to say "Search in Photos" for a folder called
  // Photos, which was a lie (2026-09-19).
  "drive.search.placeholder": "Search in {scope}",
  "drive.search.placeholder_all": "Search all storages",
  "drive.search.hint_title": "Search everywhere and run commands ({combo})",
  "drive.storage.used": "{used} of {total} used",
  "drive.storage.used_unlimited": "{used} used",
  "drive.storage.used_partial": "at least {used} used",
  "drive.storage.label": "Storage",
  /* === gorunum:v3-shell - the Home view (the overview, inside the shell) ==
   * The section headings are `sidenav.storages` / `sidenav.recent` /
   * `sidenav.starred` and the two empty states are `empty.recent.*` /
   * `empty.starred.*`, on purpose: the block headed "Recent" on Home and the
   * panel row labelled "Recent" beside it are the same thing, and a second
   * string for it is how the two drift apart one translation at a time. Only
   * what exists nowhere else is below. */
  "home.title": "Home",
  "home.storages.empty": "No storages yet",
  "home.storages.hint": "A storage is a place filex reads and writes - an administrator adds them.",
  "drive.section.folders": "Folders",
  "drive.section.files": "Files",
  "filter.aria": "Filters",
  "filter.type": "Type",
  "filter.type.any": "Any type",
  "filter.type.folder": "Folders",
  "filter.type.document": "Documents",
  "filter.type.spreadsheet": "Spreadsheets",
  "filter.type.presentation": "Presentations",
  "filter.type.pdf": "PDFs",
  "filter.type.image": "Images",
  "filter.type.video": "Videos",
  "filter.type.audio": "Audio",
  "filter.type.archive": "Archives",
  "filter.type.code": "Code",
  "filter.modified": "Modified",
  "filter.modified.any": "Any time",
  "filter.modified.today": "Today",
  "filter.modified.7d": "Last 7 days",
  "filter.modified.30d": "Last 30 days",
  "filter.modified.year": "This year",
  "filter.size": "Size",
  "filter.size.any": "Any size",
  "filter.size.lt1": "Under 1 MB",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "Over 100 MB",
  /* surucu:d1-actions - the ⋮ menu at the end of the filter row. Only its own
     NAME is new: every row inside it reuses the string that verb already has
     (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`, `shortcuts.select_all`,
     `selection.clear`), because a menu that renames a command is a menu the
     reader has to learn twice. */
  "filter.actions": "Listing actions",
  "filter.clear": "Clear filters",
  "filter.empty.title": "Nothing here matches those filters",
  "filter.empty.hint": "Clear a filter, or search everywhere with the field above.",
  "filter.count": "{shown} of {total}",
  "inspector.tab.details": "Details",
  "inspector.tab.activity": "Activity",
  "inspector.people": "People with access",
  "inspector.people.you": "You",
  "inspector.people.inherited": "from a parent folder",
  "inspector.people.empty": "Only you, and anyone with a link below.",
  "inspector.people.manage": "Manage access",
  "inspector.link": "Shared link",
  "inspector.link.none": "Not shared",
  "inspector.link.create": "Create link",
  "inspector.link.copy": "Copy link",
  "inspector.activity.empty": "No activity recorded for this item yet.",
  "inspector.activity.hint": "Versions are written when a file changes; comments are written by people.",
  "inspector.activity.version": "Version {n} saved",
  "inspector.activity.comment": "Comment by {who}",
  "inspector.activity.select": "Select a file or folder to see its activity.",
  /* === /surucu:d1 === */
  /* === gorunum:v1-chrome - the filter row's name box === */
  "filter.find": "Filter in this folder…",
  /* surucu:d1-scope - the same box where the rows are not a folder's contents.
     It has to say what it narrows: at the drive list "this folder" names
     nothing, and on Home it would name three blocks at once. */
  "filter.find.storages": "Filter storages…",
  "filter.find.home": "Filter Home…",
  /* === gorunum:v1-viewer - the full-bleed overlay's own chrome === */
  "viewer.share": "Share",
  "viewer.nav_prev": "Previous file",
  "viewer.nav_next": "Next file",
  /* The counter in the top bar's meta line: "246.3 KB • Sep 9, 2026 • 1 of 9". */
  "viewer.counter": "{i} of {n}",
  "viewer.zoom_reset": "Reset zoom",
  "viewer.fullscreen": "Full screen",
  "viewer.exit_fullscreen": "Exit full screen",
  "viewer.md_placeholder": "# Markdown here…",
  /* === gorunum:v1-selbar - the selection bar that replaces the filter row === */
  "selection.count": "{n} selected",
  "selection.clear": "Clear selection",
  /* === gorunum:v1-preview - the kind, said in words ======================
     The Type column used to print the extension in caps. These are what it
     prints instead; the table that picks one is in `lib/fileIcons.ts`
     (`typeLabelKey`), so this list and that one are the only two places a
     kind is named. Anything unmapped still falls back to the uppercased
     extension - these names improve on that fallback, they do not replace
     it. `Folder` is NOT here: it is `node.folder`, which the grid card's
     caption already prints. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue component",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C source",
  "ftype.cpp": "C++ source",
  "ftype.csharp": "C# source",
  "ftype.stylesheet": "Stylesheet",
  "ftype.html": "HTML document",
  "ftype.json": "JSON data",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Shell script",
  "ftype.powershell": "PowerShell script",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Plain text",
  "ftype.log": "Log file",
  "ftype.config": "Configuration",
  "ftype.sheet": "Spreadsheet",
  "ftype.figma": "Figma design",
  "ftype.drawio": "draw.io diagram",
  "ftype.design": "Design file",
  "ftype.image": "Image",
  "ftype.video": "Video",
  "ftype.audio": "Audio",
  "ftype.pdf": "PDF document",
  "ftype.document": "Document",
  "ftype.slides": "Presentation",
  "ftype.archive": "Archive",
  "ftype.code": "Code",
  /* === gorunum:v1-advsearch - the Advanced search dialog ==================
   * Two `filter.*` keys are added here rather than beside their siblings
   * because they are new members of shared unions the dialog introduced
   * (`modified: 'around'`, `size: 'range'`); the filter row never selects
   * them, but `chipLabel` would print the raw key if one ever reached it. */
  "filter.modified.around": "Around a date",
  "filter.size.range": "Custom range",
  "advsearch.open": "Advanced search",
  "advsearch.title": "Advanced search",
  "advsearch.subtitle": "Find files by name, content, path, or tags.",
  "advsearch.close": "Close",
  "advsearch.content.heading": "Content search",
  "advsearch.viewall": "View all results",
  "advsearch.where.any_short": "Anywhere",
  "advsearch.where.here_short": "Only here",
  "advsearch.where.skip_short": "Skip this",
  "advsearch.server.legend": "What the server searches",
  "advsearch.client.legend": "Narrow the results that come back",
  "advsearch.query.label": "Words",
  "advsearch.query.placeholder": "Part of a name, or words inside a file",
  "advsearch.scope.label": "Look in",
  "advsearch.scope.name": "Names and paths",
  "advsearch.scope.content": "File contents",
  "advsearch.scope.all": "Both",
  "advsearch.scope.hint": "Contents are searched from the index, which covers text-like files up to 200 KB.",
  "advsearch.people.name_only": "Owner is read off the rows that come back, and only a name search returns rows that carry one.",
  "advsearch.scope.name_only": "Only names and paths here: a content hit reaches the explorer without the storage it came from, so content search is offered on single-storage deployments only.",
  "advsearch.tags.label": "Tags",
  "advsearch.tags.placeholder": "invoice, quarterly report",
  "advsearch.tags.exclude": "Without tags",
  "advsearch.tags.exclude_placeholder": "archive",
  "advsearch.tags.hint": "Separate with commas. Tags narrow: several tags means files carrying all of them, and a tag nobody has applied returns nothing. A name matches your personal tag and your team’s tag of that name alike.",
  "advsearch.where.label": "Folder",
  "advsearch.where.any": "Anywhere in this storage",
  "advsearch.where.here": "Only in {folder}",
  "advsearch.where.skip": "Everywhere except {folder}",
  "advsearch.around.label": "Within",
  "advsearch.around.date": "Date and time",
  "advsearch.around.h1": "1 hour",
  "advsearch.around.d1": "1 day",
  "advsearch.around.w1": "1 week",
  "advsearch.size.range_label": "Between",
  "advsearch.size.from": "From",
  "advsearch.size.to": "To",
  "advsearch.count.idle": "Type something, or pick a tag.",
  "advsearch.count.counting": "Counting…",
  "advsearch.count.result": "{n} matching items",
  "advsearch.count.capped": "{n} matching items in the first page of hits",
  "advsearch.count.result_one": "{n} matching item",
  "advsearch.count.capped_one": "{n} matching item in the first page of hits",
  "advsearch.count.error": "The count could not be run.",
  "advsearch.count.cost": "The count runs this search. Type, owner, date, size and folder narrow the results it finds.",
  "advsearch.wire": "Type this in the search box next time:",
  "advsearch.reset": "Reset",
  "advsearch.cancel": "Cancel",
  "advsearch.submit": "Search",
  /* === gorunum:v2-topbar - the page bar is gone; the explorer's own header
     and breadcrumb row carry what it used to. === */
  "breadcrumb.subfolders": "Subfolders",
  "breadcrumb.subfolders.empty": "No subfolders here",
  "header.admin": "Admin panel",
  "header.settings": "Settings",
  "header.signout": "Sign out",
  "ai.assistant": "AI assistant",
  "ai.soon": "Coming soon",
  "ai.assistant.soon": "AI assistant - coming soon",
  /* gorunum:v2-share - the Share / Permissions dialog's own chrome. The
     controls inside it keep the strings they already had; these are the new
     shell: the title, the one switch, the sentence that says who can open the
     item right now, and the three named sections it all folds into. */
  "access.title": 'Share "{name}"',
  "access.close": "Close",
  "access.done": "Done",
  "access.copy": "Copy",
  "access.copied": "Copied",
  "access.link.switch": "Link sharing",
  "access.who.private": "Only people with access can open it.",
  "access.who.link": "Anyone with the link can open it.",
  "access.who.pin": "Anyone with the link and the PIN can open it.",
  "access.who.existing": "Link sharing is on - {n} links already exist.",
  "access.who.existing_one": "Link sharing is on - {n} link already exists.",
  "access.section.link": "Link options",
  "access.section.people": "People with access",
  "access.section.drop": "Request files",
  "access.sum.pin_on": "PIN on",
  "access.sum.pin_off": "No PIN",
  "access.sum.people": "{n} people",
  "access.sum.people_one": "{n} person",
  "access.sum.people_none": "No one yet",
  "access.sum.groups": "{n} groups",
  "access.sum.groups_one": "{n} group",
  "access.sum.drop": "{n} upload links",
  "access.sum.drop_one": "{n} upload link",
  "access.sum.drop_none": "No upload link",
  /* Ownership - the Owner column and the People chip. "System" is the honest
     word for a row nobody put here through filex (the scanner found it, or it
     was written straight into the bucket); it is a real answer, not a blank. */
  "col.owner": "Owner",
  "owner.you": "You",
  "owner.system": "System",
  "owner.unknown": "Unknown",
  "owner.external": "Uploaded through an upload link",
  "owner.last_actor": "Last changed by {who}",
  "filter.people": "Owner",
  "filter.people.any": "Anyone",
  "filter.people.me": "You",
  "filter.people.system": "System",
  "filter.people.someone": "Someone else",
  /* surucu:d1-sort - the listing sort control at the trailing edge of the
     filter row. The four key names are `col.*`: the menu offers exactly the
     words the list view's own column headers carry, so the two controls that
     drive one sort cannot name it differently. */
  "sort.by": "Sort by",
  "sort.asc": "Ascending",
  "sort.desc": "Descending",
  /* The order a SEARCH RESULT is in. It is not a fifth sort key - it is what
     the control prints instead of a key while the rows on screen were ranked
     by the server, so the button stops claiming a sort it is not performing.
     `_why` is the reason the control is closed, and the owner asked for the
     reason to be written rather than for the control to go quietly inert. */
  "sort.relevance": "Relevance",
  "sort.relevance_why": "Search results are listed by how well they match. Your sort comes back when you leave the search.",
  /* === tablo:t1 - the table's own configuration ==========================
     Since v0.43 everything about how a folder looks - view, sort AND columns -
     belongs to the folder it was changed in; a folder nobody changed opens
     with the person's default (their settings), else the instance's.
     `folder_hint` is that rule in one sentence, written where the person who
     is about to be surprised by it can read it. */
  "col.location": "Location",
  "col.deleted": "Deleted",
  "col.deleted_from": "Deleted from",
  "col.deleted_by": "Deleted by",
  "col.remaining": "Time left",
  "cols.menu": "Column options",
  "cols.title": "Columns",
  "cols.resize": "Resize {col}",
  "cols.sort_by": "Sort by {col}",
  "cols.move_left": "Move {col} left",
  "cols.move_right": "Move {col} right",
  "cols.reset": "Reset columns",
  "cols.folder_title": "Folder view",
  "cols.folder_hint": "A change you make here stays in this folder. Folders you have never changed open with your default view (Settings → Default folder view).",
  "cols.forget_folder": "Forget this folder's view",
  "cols.apply_all": "Make this my default for all folders ({count} remembered)",
  /* === tablo:t3 - THE ONE TABLE (components/DataTable.vue) ================
     Every table in the product speaks these, so a column menu or a pager is
     never the one English thing on a Turkish page. */
  "table.empty": "Nothing here yet",
  "table.prev": "Previous page",
  "table.next": "Next page",
  "table.sort_paged": "This list is split into pages. Sorting would only re-order the page on screen, so it is off here - narrow the list with the search or filters instead.",
  /* === tablo:t1 - the trash banner ======================================
     ⚠ `retention` is only used when the deployment has TOLD us the number
     (GET /api/admin/protection). Everywhere else `retention_unknown` says the
     same thing without naming a period we cannot verify: a banner that states
     the wrong retention is worse than no banner, because people act on it. */
  "trash.retention": "Items in the trash are permanently deleted after {days} days.",
  "trash.retention_one": "Items in the trash are permanently deleted after {days} day.",
  "trash.retention_unknown": "Items in the trash are permanently deleted after a retention period set by your administrator.",
  "trash.empty_action": "Empty trash",
  "trash.empty_confirm_title": "Empty the trash?",
  /* 0.54 (finding D1): the confirmation waits for the server's count of
     what "Empty trash" deletes, and the Trash view is paged. Every
     sentence about the trash itself is the server's (server.trash.*). */
  "trash.empty_counting": "Counting what is in the trash…",
  "trash.show_more": "Show more",
  "trash.shown_of": "{shown} of {total} shown",
  "trash.days_remaining": "{n} days",
  "trash.days_remaining_one": "{n} day",
  "trash.days_remaining_due": "Due for deletion",
  "trash.deleted_by_nobody": "Not recorded: quarantined by the virus scan, or deleted before filex kept this",
  "empty.trash.hint": "Files you delete land here first, so you can put them back.",
  /* tasi:m1 - the destination picker (modals/DestinationPickerModal.vue) and
     the two selection verbs built on it. */
  "destpicker.title.move": "Move to",
  "destpicker.title.copy": "Copy to",
  "destpicker.title.choose": "Choose a folder",
  "destpicker.confirm.move": "Move here",
  "destpicker.confirm.copy": "Copy here",
  "destpicker.confirm.choose": "Choose this folder",
  "destpicker.title.choose_file": "Choose a file",
  "destpicker.confirm.choose_file": "Choose this file",
  "destpicker.title.save": "Save to",
  "destpicker.confirm.save": "Save here",
  "destpicker.pick_a_file": "Select a file from the list.",
  "destpicker.empty_files": "This folder is empty",
  "destpicker.cancel": "Cancel",
  "destpicker.up": "Up one level",
  "destpicker.crumbs": "Location",
  "destpicker.drives": "Storages",
  "destpicker.loading": "Loading…",
  "destpicker.empty": "No subfolders here",
  "destpicker.unreadable": "This folder cannot be opened.",
  "destpicker.readonly": "Read-only",
  "destpicker.readonly_here": "You cannot write into this folder.",
  "destpicker.pick_a_drive": "Open a storage to choose a folder inside it.",
  "destpicker.target": "Destination: {name}",
  "destpicker.tag.blocked": "Not allowed",
  "destpicker.blocked.self": "A folder cannot be moved into itself.",
  "destpicker.blocked.descendant": "A folder cannot be moved into one of its own subfolders.",
  "destpicker.tag.vault": "Vault",
  "destpicker.blocked.vault_in": "Nothing goes into a vault from here: upload into it from inside the vault.",
  "destpicker.blocked.vault_out": "What is in a vault moves only inside that vault. Download it to take it out.",
  "ctx.move_to": "Move to…",
  "ctx.copy_to": "Copy to…",
  "ctx.access.one_only": "Sharing works on one item at a time.",
  "toast.archive.preparing": "Preparing the archive…",
  "toast.archive.started": "Downloading {name} ({count} files)",
  "toast.archive.started_one": "Downloading {name} ({count} file)",
  "toast.archive.empty": "Nothing to download - the selection contains no readable file.",
  "toast.moved_to": "Move to {name} queued",
  "toast.copied_to": "Copy to {name} queued",
  "toast.already_there": "The selected items are already in {name} - nothing was sent",
  /* ── dil:paket - strings that used to be inline `en ? … : …` pairs in
     FileExplorer / RecentlyOpened, where no language pack could reach them
     (and where a pack's language fell through to TURKISH). */
  "ctx.tags_menu": "Tags…",
  "toast.node_id_copied": "Node id {id} copied",
  "toast.read_only_here": "Read-only here",
  "recents.title": "Recently opened",
  "recents.refresh": "Refresh",
  "recents.empty": "Nothing here yet.",
  "recents.loading": "Loading…",
  "recents.close": "Close",
  "tags.title": "Tags",
  "tags.close": "Close",
  "share.ttl.never": "This link does not expire.",
  "share.ttl.until": "This link is valid until {when}.",
  "share.ttl.ceiling": "Links can be valid for at most {days} days (server setting).",
  "share.ttl.ceiling_one": "Links can be valid for at most {days} day (server setting).",
  /* ── dil:paket - the share / access dialog (modals/PermissionsModal.vue). These were ~90 inline (tr, en) pairs: no language pack could reach them, and under any third language the dialog spoke TURKISH. access.ui.emails_comma_separated / access.ui.send / access.ui.mail_not_set_up are the mail-row lines another branch rewrote in the same release, converted at the v0.43.0 merge. */
  "access.ui.level_viewer": "Viewer",
  "access.ui.level_viewer_desc": "view + download",
  "access.ui.level_editor": "Editor",
  "access.ui.level_editor_desc": "read + write + delete",
  "access.ui.level_owner": "Owner",
  "access.ui.level_owner_desc": "edit + manage access",
  "access.ui.never": "Never",
  "access.ui.days": "{days} days",
  "access.ui.days_one": "{days} day",
  "access.ui.unlimited": "Unlimited",
  "access.ui.downloads": "{count} downloads",
  "access.ui.downloads_one": "{count} download",
  "access.ui.inherited_from": "Inherited from",
  "access.ui.access_granted": "Access granted.",
  "access.ui.enter_a_valid_email": "Enter a valid email.",
  "access.ui.recipient_lang": "Recipient's language",
  "access.ui.recipient_lang_server": "The server's language",
  "access.ui.user_created_invite_emailed": "User created, invite emailed.",
  "access.ui.user_created_share_the_temp_password": "User created. Share the temp password.",
  "access.ui.server_limit_applied": "(server limit applied)",
  "access.ui.protect_with_a_pin": "Protect with a PIN",
  "access.ui.expiry": "Expiry",
  "access.ui.download_limit": "Download limit",
  "access.ui.create_link": "Create link",
  "access.ui.replace_link": "Replace the link with these settings",
  "access.ui.replace_link_hint": "The address changes: the current link stops working.",
  "access.ui.create_then_send": "Create a link, then it will be sent to {email}.",
  "access.ui.command_line": "Command line",
  "access.ui.share": "Share",
  "access.ui.existing_links": "Existing links",
  "access.ui.rbac_off_here": "Per-item access control is off on this storage - everyone opens it according to their role, so people added here would change nothing. Turn it on in the admin panel under Storages (this storage → Per-item access control).",
  "access.ui.other_links": "Other links",
  "access.ui.revoke": "Revoke",
  "access.ui.loading": "Loading…",
  "access.ui.name_or_email": "Name or email",
  "access.ui.add": "Add",
  "access.ui.no_account_for_this_email_what_next": "No account for this email - what next?",
  "access.ui.user": "User",
  "access.ui.viewer": "Viewer",
  "access.ui.create_user_grant": "Create user + grant",
  "access.ui.just_send_a_share_link": "Just send a share link →",
  "access.ui.temp_password": "Temp password:",
  "access.ui.people_with_access": "Who has access",
  "access.ui.group": "Group",
  "access.ui.group_title": "The group “{name}” - everyone in it",
  "access.ui.group_owner_confirm": "Owner lets everyone in “{name}” manage who has access here - including sharing it with other people and groups. Give the group Owner?",
  "access.ui.group_owner_give": "Give owner access",
  "access.ui.not_shared_with_anyone_yet": "Not shared with anyone yet.",
  "access.ui.remove": "Remove",
  "access.ui.a_public_link_that_lets_anyone_upload_fi": "A public link that lets anyone UPLOAD files into this folder. Uploaders never see the folder's existing files.",
  "access.ui.hide_upload_limits": "Hide upload limits",
  "access.ui.upload_limits": "Upload limits",
  "access.ui.max_files": "Max files",
  "access.ui.mb_file": "MB / file",
  "access.ui.allowed_types": "Allowed types",
  "access.ui.all_e_g_pdf_jpg": "all (e.g. pdf, jpg)",
  "access.ui.ask_uploader_name": "Ask uploader name",
  "access.ui.emails_comma_separated": "email(s) - comma separated",
  "access.ui.send": "Send",
  "access.ui.mail_not_set_up": "Email is not set up - set it up in the admin panel under Settings (Email / SMTP).",
  /* ── wiring:e2 fxe - single encrypted files (.fxe), streamed downloads ── */
  "e2e.fxe.type": "Encrypted file",
  "e2e.fxe.ctx_encrypt": "Encrypt with E2EE…",
  "e2e.fxe.ctx_download_raw": "Download encrypted file",
  "e2e.fxe.ctx_password": "Change password…",
  "e2e.fxe.ctx_remove": "Remove encryption…",
  "e2e.fxe.encrypt_title": "Encrypt this file",
  "e2e.fxe.encrypt_lead": "“{name}” is encrypted in this browser with a password of its own. The server keeps only ciphertext. The password or the recovery key opens it - here, or offline with filex decrypt.",
  "e2e.fxe.pw_label": "File password",
  "e2e.fxe.hide_label": "Hide the file name too",
  "e2e.fxe.hide_on_hint": "Stored as “{stored}”: the server sees neither the name nor the type. The real name is sealed inside the file and shown once you open it here.",
  "e2e.fxe.hide_off_hint": "Stored as “{stored}”: the name stays readable to the server; the content does not.",
  "e2e.fxe.seen_title": "What the server has already seen",
  "e2e.fxe.seen_lead": "Until now this file was stored in the clear, and encrypting it cannot take that back:",
  "e2e.fxe.seen_trash": "The original goes to the trash and stays there until the trash retention period ends or an administrator empties it. You cannot delete it for good yourself.",
  "e2e.fxe.seen_versions": "Its earlier versions stay in its version history; only an administrator can delete them.",
  "e2e.fxe.seen_thumb": "A thumbnail made from it stays on the server until the original is deleted for good. Its search-index entry is removed when it goes to the trash.",
  "e2e.fxe.seen_backups": "Backups, copies and downloads made before now still hold it.",
  "e2e.fxe.warn_body": "This file opens only with this password or the recovery key shown once after it is encrypted. filex keeps neither. Lose both and the contents are gone for good.",
  "e2e.fxe.escrow_body": "Key escrow is enabled on this installation: its operator holds a key that opens this file without your password.",
  "e2e.fxe.encrypt_submit": "Encrypt",
  "e2e.fxe.encrypt_busy": "Encrypting and uploading… {percent}%",
  "e2e.fxe.size_unknown": "The size of this file is not known yet. Refresh the folder and try again.",
  "e2e.fxe.bad_name": "This name cannot be sealed into an encrypted file (it is over 255 bytes, or holds a slash or a control character). Rename the file first.",
  "e2e.fxe.name_too_long": "The name is too long to add “.fxe” to it. Tick “Hide the file name too”, or rename the file first.",
  "e2e.fxe.encrypted": "“{name}” is encrypted. The original is in the trash.",
  "e2e.fxe.original_kept": "The encrypted copy is saved, but “{name}” could not be moved to the trash. Delete the original yourself.",
  "e2e.fxe.upload_too_big": "This server has no chunked upload, and the file is too large to send in one piece from this browser.",
  "e2e.fxe.unlock_title_open": "Open an encrypted file",
  "e2e.fxe.unlock_title_download": "Download decrypted",
  "e2e.fxe.unlock_title_remove": "Remove encryption",
  "e2e.fxe.unlock_lead": "“{name}” is encrypted. Its password is checked here, in this browser, and is never sent to the server.",
  "e2e.fxe.known_note": "Already opened in this tab - no password needed.",
  "e2e.fxe.use_password": "Use the password instead",
  "e2e.fxe.remove_warn_title": "The plaintext goes back to the server",
  "e2e.fxe.remove_warn_body": "The file is decrypted here and uploaded as a plain file under its original name: the server, its administrators, thumbnails, search and backups can read it again. The encrypted file goes to the trash.",
  "e2e.fxe.unlock_open": "Open",
  "e2e.fxe.unlock_download": "Download",
  "e2e.fxe.unlock_remove": "Remove encryption",
  "e2e.fxe.unlock_busy": "Working…",
  "e2e.fxe.save_again": "Unlocked. Your browser wants one more click before it asks where to save the file.",
  "e2e.fxe.save_button": "Save…",
  "e2e.fxe.progress": "{percent}% done",
  "e2e.fxe.wrong_password": "Wrong password.",
  "e2e.fxe.wrong_recovery": "That recovery key does not open this file.",
  "e2e.fxe.damaged": "This file is damaged or was tampered with (or it changed since it was opened). Nothing was saved.",
  "e2e.fxe.not_readable": "This is not a filex encrypted file, or its header is damaged.",
  "e2e.fxe.unsupported": "This file needs a newer filex (it requires: {features}).",
  "e2e.fxe.downloaded": "“{name}” saved.",
  "e2e.fxe.removed": "Encryption removed: “{name}” is a plain file again. The encrypted file is in the trash.",
  "e2e.fxe.password_title": "Change the file password",
  "e2e.fxe.password_cost": "Only the file’s header changes: the content is sent back byte for byte, and the recovery key keeps working.",
  "e2e.fxe.password_old_copies": "An earlier version of this file - its version history, a backup, a copy someone downloaded - still opens with the OLD password.",
  "e2e.fxe.password_done": "Password changed. The old password no longer opens this file.",
  "e2e.recovery.warn_body_file": "Anyone holding this key can read the file. Keep it somewhere separate from the password - a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.lead_file": "This key opens the file without its password. It is shown once - filex does not store it and cannot show it again.",
  "e2e.dl.ctx_encrypted_copy": "Download encrypted copy",
  "e2e.dl.too_big": "This browser can save at most {limit} of decrypted data at once, and this is {size}. Use Chrome or Edge (they save straight to disk), the filex desktop app, or download the encrypted file and run filex decrypt.",
  "e2e.dl.click_again": "Click Download again to choose where to save it.",
  "e2e.dl.zip_started": "Decrypting into “{name}”…",
  "e2e.dl.zip_done": "“{name}” saved - decrypted, with the real names.",
  "e2e.dl.zip_done_plain": "“{name}” saved. {n} files in it were never encrypted and are in it as they were.",
  "e2e.dl.zip_done_plain_one": "“{name}” saved. {n} file in it was never encrypted and is in it as it was.",
  "e2e.dl.zip_damaged": "A file in the folder is damaged or was tampered with. The download stopped and nothing was saved.",
  "e2e.upload.streaming_unsupported": "This file is over 200 MB, and this server has no chunked upload to send it encrypted piece by piece.",
  /* wiring:e2 fxe escrow - the escrow key opens a single file, and its owner is told */
  "e2e.fxe.use_escrow": "Use the escrow key",
  "e2e.fxe.escrow_warn_title": "The file’s owner will be told",
  "e2e.fxe.escrow_warn_body": "Opening a file with the escrow key notifies its owner, before the file is opened. Use it only when you are entitled to.",
  "e2e.fxe.escrow_predates": "This installation has an escrow key, but this file was encrypted without it (before escrow was turned on here), so the escrow key does not open it. Use the password or the recovery key.",
  "e2e.fxe.escrow_other_key": "This file is sealed to the escrow key of a DIFFERENT installation, so this installation’s escrow key does not open it.",
  "e2e.fxe.wrong_escrow": "That escrow key does not open this file.",
  "e2e.fxe.escrow_notify_failed": "Could not notify the file’s owner, so the file was not opened. Escrow use is always announced.",
  "e2e.fxe.escrow_done": "Opened with the escrow key - the owner has been notified",
  /* wiring:e2 fxe purge - an administrator deletes the original for good */
  "e2e.fxe.seen_trash_admin": "The original goes to the trash and stays there until the trash retention period ends - unless you delete it for good below.",
  "e2e.fxe.seen_versions_admin": "Its earlier versions stay in its version history - unless you delete them for good below.",
  "e2e.fxe.purge_label": "Delete the original for good (administrator)",
  "e2e.fxe.purge_hint": "Its earlier versions and its trash entry are deleted as soon as the encrypted copy is saved, so no plaintext of it stays on this server. There is no undo. Backups and copies made before now are not reached.",
  "e2e.fxe.purge_others": "This file belongs to {owner}, not to you. Delete their original and its versions for good.",
  "e2e.fxe.purge_others_unknown": "This file has no recorded owner - it is not yours. Delete the original and its versions for good.",
  "e2e.fxe.purge_others_required": "Confirm that you are deleting someone else’s file for good.",
  "e2e.fxe.purge_no_id": "This file is not in the catalog yet, so it cannot be deleted for good. Refresh the folder and try again.",
  "e2e.fxe.purged": "“{name}” is encrypted. The original, its versions and its trash entry are deleted for good.",
  "e2e.fxe.purge_failed": "The encrypted copy of “{name}” is saved, but the original could not be deleted for good ({reason}). Delete it from the trash and its version history.",
  /* wiring:e2 fxe big - a decrypted download too large for this browser's memory */
  "e2e.big.title": "Too large to decrypt in this browser",
  "e2e.big.lead": "“{name}” is {size} once decrypted. This browser decrypts a download in its memory and can hold at most {limit} of it, so nothing was downloaded.",
  "e2e.big.lead_grew": "“{name}” grew past {limit} while it was being decrypted. This browser decrypts a download in its memory and cannot hold more, so nothing was saved.",
  "e2e.big.instead": "Decrypt it on your own computer instead:",
  "e2e.big.step_file": "Download the encrypted file, as it is (the button below).",
  "e2e.big.step_folder": "Download the encrypted folder as a zip (the button below) - it carries the folder’s key file.",
  "e2e.big.step_run": "In the folder you saved it to, run filex decrypt and give it the password:",
  "e2e.big.copy": "Copy",
  "e2e.big.copied": "Copied",
  "e2e.big.other_ways": "Chrome, Edge and the filex desktop app decrypt straight to disk, whatever the size.",
  "e2e.big.close": "Close",
  "e2e.big.download_file": "Download encrypted file",
  "e2e.big.download_folder": "Download encrypted folder (zip)",
  /* /wiring:e2 fxe */
  /* ── dil:paket - accessible names that were English literals */
  "breadcrumb.aria": "Breadcrumb",
  "e2e.recovery_key_aria": "Recovery key",
  "modal.close": "Close",
  "modal.busy_close.keep": "Keep going",
  "modal.busy_close.confirm": "Stop and close",
  /* ── the bell and the account menu (2026-09-27: moved here from the admin
     app so the desktop app's explorer draws the same ones). ⚠ SHARED keys:
     the admin app's catalogue has every one of them under the same name, with
     the same English and Turkish (web/tests/i18n/langPackCatalogue.test.ts),
     so a language pack translates each once for both screens. */
  "notifications.bell": "Notifications",
  "notifications.unreadCount": "{n} unread",
  "notifications.title": "Notifications",
  "notifications.markAllRead": "Mark all read",
  "notifications.markRead": "Mark read",
  "notifications.empty": "No notifications yet",
  "notifications.viewAll": "View all",
  "notifications.manageAdmin": "Manage notifications",
  "notifications.openTarget": "Open what this is about",
  "notifications.unreadOnly": "Unread only",
  "notifications.pageOf": "Page {page} of {pages} · {total} in total",
  "notifications.severity.info": "Info",
  "notifications.severity.warning": "Warning",
  "notifications.severity.error": "Error",
  "notifications.severity.critical": "Critical",
  "common.prev": "Previous",
  "common.next": "Next",
  "explore.account": "Account",
  /* ── the user settings dialog (2026-09-27: moved here from the admin app
     so the desktop app opens the same dialog inside its window). ⚠ SHARED
     keys: the admin app's catalogue has each under the same name with the same
     English and Turkish (web/tests/i18n/langPackCatalogue.test.ts). An
     account field's refusal is the server's sentence (POST
     /api/auth/account/check, lib/accountRules), not a key here. */
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.currentPassword": "Current password",
  "common.email": "Email",
  "common.loading": "Loading…",
  "common.newPassword": "New password",
  "common.remove": "Remove",
  "common.save": "Save",
  "common.saving": "Saving…",
  "errors.generic": "Something went wrong",
  "errors.validationFailed": "Please check the highlighted fields",
  "install.desktopAllDownloads": "All downloads and release notes",
  "install.desktopSubtitle": "Sync folders to this computer and keep them up to date in the background. Available for {platform}.",
  "install.install": "Install",
  "install.menuInstructions": "Open your browser's menu and choose “Install app” or “Add to Home screen”.",
  "install.iosInstructions": "Tap Share (on iOS 26: ⋯, then Share), then “Add to Home Screen” and Add.",
  "nav.themeAuto": "Auto",
  "nav.themeDark": "Dark",
  "nav.themeLight": "Light",
  "notifications.prefs.browser": "Browser notifications",
  "notifications.prefs.browserHint": "Raise a notification outside the tab when something new arrives. Clicking it opens the file, folder or share it is about.",
  "notifications.prefs.desktopHandled": "The desktop app shows these itself",
  "notifications.prefs.enableBrowser": "Allow notifications",
  "notifications.prefs.inApp": "In-app bell",
  "notifications.prefs.inAppHint": "Turning this off empties your bell. Nothing stops being recorded - an admin still sees every event.",
  "notifications.prefs.iosHomeScreen": "On an iPhone or iPad, notifications work in {name} added to the Home Screen (iOS 16.4 or later), not in a browser tab.",
  "notifications.prefs.movedToSettings": "Your own notification settings - the bell, browser pop-ups, which events - are in your user settings.",
  "notifications.prefs.openSettings": "Open my notification settings",
  "notifications.prefs.permDefault": "Permission not asked yet",
  "notifications.prefs.permDenied": "Blocked by this browser",
  "notifications.prefs.permDeniedHint": "Re-allow notifications for this site in your browser settings.",
  "notifications.prefs.permGranted": "Allowed by this browser",
  "notifications.prefs.permUnsupported": "This browser cannot show notifications",
  "notifications.prefs.push": "Push notifications on this device",
  "notifications.prefs.pushAdded": "Added {date}",
  "notifications.prefs.pushDevices": "Devices that receive push notifications",
  "notifications.prefs.pushDisabled": "Turned off on the server (FILEX_PUSH_ENABLED).",
  "notifications.prefs.pushFailed": "Push notifications could not be turned on for this device.",
  "notifications.prefs.pushHint": "What your bell tells you reaches this phone or browser even while {name} is closed - the same notifications, at the same moment.",
  "notifications.prefs.pushKeyUnreadable": "The server's push key no longer opens (FILEX_SECRET_KEY changed). Rotate it under Admin → Notifications.",
  "notifications.prefs.pushNoSecretKey": "Push notifications need FILEX_SECRET_KEY on the server: the key they are signed with is stored encrypted with it.",
  "notifications.prefs.pushOn": "On for this device",
  "notifications.prefs.pushRemove": "Remove",
  "notifications.prefs.pushRemoveLabel": "Remove {device}",
  "notifications.prefs.pushTest": "Send a test",
  "notifications.prefs.pushTestNone": "No device took the test.",
  "notifications.prefs.pushTestSent": "Test sent to {count} devices",
  "notifications.prefs.pushTestSent_one": "Test sent to {count} device",
  "notifications.prefs.pushThisDevice": "This device",
  "notifications.prefs.pushUnavailable": "Not available on this server",
  "notifications.prefs.pushUnnamed": "A device",
  "notifications.prefs.pushUnsupported": "This browser cannot receive push notifications",
  "notifications.prefs.saved": "Preference saved",
  "notifications.prefs.title": "Your notifications",
  "profile.avatar.change": "Change photo",
  "profile.avatar.failed": "That image could not be processed - try another one.",
  "profile.avatar.help": "Shown next to your name, and in the file explorer's collaboration bar - on every client signed in as you. Resized to 160px automatically.",
  "profile.avatar.label": "Profile picture",
  "profile.avatar.notImage": "Please choose an image file.",
  "profile.locale": "Language",
  "profile.passwordChanged": "Password changed",
  "profile.saved": "Profile saved",
  "profile.totp.code": "Verification code",
  "profile.totp.disable": "Disable 2FA",
  "profile.totp.disabled": "Disabled",
  "profile.totp.enable": "Enable 2FA",
  "profile.totp.enabled": "Enabled",
  "profile.totp.recoveryHint": "Save these now - each one signs you in once if you lose your authenticator. They are shown only this time.",
  "profile.totp.recoveryTitle": "Recovery codes",
  "profile.totp.scanHint": "Scan this QR code with your authenticator app, then enter the 6-digit code.",
  "profile.totp.title": "Two-factor authentication",
  "profile.username.label": "Username",
  "quota.title": "Storage quota",
  "quota.tooltip": "{used} of {limit} used ({percent})",
  "quota.unlimitedTooltip": "{used} used · unlimited",
  "userSettings.adminBadge": "Admin",
  "userSettings.ai.body": "This release has no per-user assistant settings. The AI features filex does ship are configured for the whole instance by an administrator, so there is nothing here for you to turn on or off yet.",
  "userSettings.ai.soon": "Coming soon",
  "userSettings.demoReadOnly": "This is a shared demo account, so its profile, password and second factor cannot be changed.",
  "userSettings.footNote.ai": "There is nothing on this tab to save.",
  "userSettings.footNote.notifications": "Saved as you change them.",
  "userSettings.footNote.preferences": "Saved as you change them.",
  "userSettings.footNote.profile": "Changes on this tab are saved when you press Save.",
  "userSettings.footNote.security": "Each action here applies on its own.",
  "userSettings.heading": "User settings",
  "userSettings.headingSub": "Manage your profile, preferences, and security.",
  "userSettings.notifications.adminAlerts": "Administrator alerts",
  "userSettings.notifications.adminAlertsHint": "Updates, replicas, sign-in providers, tenant domains and the other alerts for administrators",
  "userSettings.notifications.digestHint": "Kinds marked urgent reach you at once. The rest are held for {minutes} min and arrive as one summary, folder by folder.",
  "userSettings.notifications.digestOffHint": "Every kind reaches you at once. Turn Urgent off for a kind to get it in one summary instead, folder by folder.",
  "userSettings.notifications.events.archive_created": "An archive finishes being created",
  "userSettings.notifications.events.archive_extracted": "An archive finishes extracting",
  "userSettings.notifications.events.comment_added": "Someone comments on a file",
  "userSettings.notifications.events.drop_received": "A file arrives through a request link",
  "userSettings.notifications.events.e2e_escrow_used": "An encrypted folder is opened with the escrow key",
  "userSettings.notifications.events.e2e_password_changed": "The password of your encrypted folder is changed",
  "userSettings.notifications.events.e2e_request_created": "Someone asks to encrypt a folder or a file",
  "userSettings.notifications.events.e2e_request_decided": "Your encryption request is answered",
  "userSettings.notifications.events.file_deleted": "A file is deleted for good",
  "userSettings.notifications.events.file_infected": "A virus is found in a file",
  "userSettings.notifications.events.file_moved": "A file is moved or renamed",
  "userSettings.notifications.events.file_trashed": "A file goes to the trash",
  "userSettings.notifications.events.file_updated": "A file is changed",
  "userSettings.notifications.events.file_upload_failed": "An upload does not finish",
  "userSettings.notifications.events.file_uploaded": "A new file arrives",
  "userSettings.notifications.events.notification_digest": "A summary of the notifications I did not mark urgent",
  "userSettings.notifications.events.plugin_notice": "An installed app sends you a message",
  "userSettings.notifications.events.share_created": "Someone creates a share link",
  "userSettings.notifications.eventsHint": "Turning one off keeps it out of your bell. Nothing stops being recorded - an administrator still sees every event.",
  "userSettings.notifications.eventsTitle": "What to tell me about",
  "userSettings.notifications.urgent": "Urgent",
  "userSettings.notifications.urgentFor": "Tell me at once: {event}",
  "userSettings.open": "User settings",
  "userSettings.prefs.appearance": "Appearance",
  "userSettings.prefs.compact": "Use compact file list",
  "userSettings.prefs.compactHint": "Tighter rows in the file explorer.",
  "userSettings.prefs.desktopApp": "Desktop app",
  "userSettings.prefs.desktopAppHint": "The reminder in the corner of the app can be closed for good - these downloads stay here.",
  "userSettings.prefs.folderView": "Default folder view",
  "userSettings.prefs.folderViewHint": "How a folder you have never changed opens. A folder you have changed keeps its own view - changing this does not touch it.",
  "userSettings.prefs.fvColumns": "Your default columns are customized (set with “Make this my default for all folders”).",
  "userSettings.prefs.fvColumnsReset": "Reset them",
  "userSettings.prefs.fvDir": "Direction",
  "userSettings.prefs.fvDir_asc": "Ascending",
  "userSettings.prefs.fvDir_desc": "Descending",
  "userSettings.prefs.fvForget": "Forget them all",
  "userSettings.prefs.fvInherit": "Server default ({value})",
  "userSettings.prefs.fvMode": "View",
  "userSettings.prefs.fvSort": "Sort by",
  "userSettings.prefs.fvSort_modified": "Modified",
  "userSettings.prefs.fvSort_name": "Name",
  "userSettings.prefs.fvSort_size": "Size",
  "userSettings.prefs.fvSort_type": "Type",
  "userSettings.prefs.fvView_gallery": "Gallery",
  "userSettings.prefs.fvView_grid": "Grid",
  "userSettings.prefs.fvView_list": "List",
  "userSettings.prefs.installApp": "Install as a web app",
  "userSettings.prefs.installAppLead": "Put {name} on this device's home screen: it opens in a window of its own, like an app.",
  "userSettings.prefs.languageHint": "Applies here right away, and is saved on your account for the next browser you sign in from.",
  "userSettings.prefs.mode": "Light or dark",
  "userSettings.prefs.modeHint": "Which variant is painted. Auto follows your operating system.",
  "userSettings.prefs.openTrigger": "Open files with",
  "userSettings.prefs.openTriggerDouble": "Double-click",
  "userSettings.prefs.openTriggerHint": "How a mouse opens a file. On a touchscreen a tap always opens, and the checkbox always selects.",
  "userSettings.prefs.openTriggerSingle": "Single-click",
  "userSettings.prefs.palette": "Color palette",
  "userSettings.prefs.paletteHint": "Which colors that variant is made of. Every palette has a light and a dark version, so this and the setting above work together.",
  "userSettings.prefs.startPage": "Start page",
  "userSettings.prefs.startPageHint": "Where filex opens when you sign in or go to the front door. Following a link straight to a page still takes you there.",
  "userSettings.prefs.startPage_admin": "Admin panel",
  "userSettings.prefs.startPage_files": "Files",
  "userSettings.prefs.startPage_home": "Home",
  "userSettings.prefs.timezone": "Time zone",
  "userSettings.prefs.timezoneHint": "Dates are stored as a moment in time and shown on the clock you pick here, so everyone sees the same instant on their own clock. Saved to your account, so it follows you to another browser.",
  "userSettings.prefs.timezoneNow": "Right now in {zone}: {time}",
  "userSettings.saveChanges": "Save changes",
  "userSettings.security.passwordTitle": "Change password",
  "userSettings.security.totpDisabled": "Two-factor authentication is off",
  "userSettings.security.totpEnabled": "Two-factor authentication is on",
  "userSettings.subtitle.ai": "Nothing for you to set here yet.",
  "userSettings.subtitle.notifications": "What reaches your bell, and what reaches your desktop.",
  "userSettings.subtitle.preferences": "How this app looks and reads on your devices.",
  "userSettings.subtitle.profile": "Your name, email and picture - what other people see.",
  "userSettings.subtitle.security": "Your password and second factor.",
  "userSettings.tabs.ai": "AI assistant",
  "userSettings.tabs.notifications": "Notifications",
  "userSettings.tabs.preferences": "Preferences",
  "userSettings.tabs.profile": "Profile",
  "userSettings.tabs.security": "Security",
  "userSettings.apps.title": "Default apps",
  "userSettings.apps.lead": `Choose one in a file's menu: Open with, Choose an app…, then tick "Always use this app". Only the apps your administrator left on for a kind are offered.`,
  "userSettings.apps.empty": "You have not chosen an app for any kind of file yet: every file opens with what your administrator put first.",
  "userSettings.apps.reset": "Reset",
  "userSettings.apps.resetAll": "Reset all",
  "userSettings.apps.unavailable": "No longer available: it opens with {app} until you choose again.",
  "userSettings.apps.change": "The app that opens {ext} files",
  "userSettings.title": "Settings",
  "users.fields.displayName": "Display name",
  "profile.username.helpText": "Your username. You can sign in with it or with your email - and connection clients (SFTP, FTP) need it, because an @ in the name they sign in with has to be escaped in their config files.",
  "userSettings.prefs.fvKeptCount": "{count} folders keep a view of their own.",
  "userSettings.prefs.fvKeptCount_one": "{count} folder keeps a view of its own."
}, S0 = {
  "toolbar.new_folder": "Yeni klasör",
  "toolbar.upload": "Yükle",
  "toolbar.search": "Ara",
  "toolbar.search.placeholder": "Ada ya da tag: ile ara…",
  "toolbar.view.list": "Liste",
  "toolbar.view.grid": "Izgara",
  "toolbar.refresh": "Yenile",
  "toolbar.go_up": "Üst klasör",
  "ctx.open": "Aç",
  "ctx.preview": "Önizle",
  "ctx.download": "İndir",
  "ctx.archive_create": "Arşiv oluştur…",
  "ctx.archive_extract": "Arşivi çıkar…",
  "ctx.rename": "Yeniden adlandır",
  "ctx.delete": "Sil",
  "ctx.delete_perm": "Kalıcı olarak sil",
  "ctx.restore": "Geri getir",
  "ctx.share": "Paylaş",
  "ctx.move": "Taşı",
  "ctx.copy": "Kopyala",
  "ctx.cut": "Kes",
  "ctx.show_hidden": "Gizli dosyaları göster",
  "ctx.hide_hidden": "Gizli dosyaları gizle",
  "ctx.keep_local": "Bilgisayarda tut",
  "ctx.keep_online": "Yalnızca çevrimiçi tut",
  "ctx.keep_reveal": "Yerel klasörü aç",
  "ctx.keep_inherited": "Üst klasörle bilgisayarda tutuluyor",
  "keep.started": "Bilgisayarda tutulacak - eşitleme başladı",
  "keep.failed": "Bilgisayarda tutulamadı",
  "keep.badge_kept": "Bilgisayarda",
  "keep.badge_syncing": "Eşitleniyor…",
  "keep.badge_cloud": "Yalnızca çevrimiçi",
  "keep.badge_partial": "İçinde bilgisayarda tutulanlar var",
  "keep.strip_transfer": "{name} eşitleniyor - {done}/{total} (%{pct})",
  "keep.strip_inventory": "{name} eşitleniyor - sunucu taranıyor…",
  "keep.strip_settling": "{name} eşitleniyor - son durum kaydediliyor…",
  "ctx.paste": "Yapıştır",
  "ctx.info": "Bilgi",
  "ctx.duplicate": "Kopyasını oluştur",
  "ctx.new_file": "Yeni dosya",
  "modal.delete.title": "Silinsin mi?",
  "modal.delete.message": "{count} öğe çöpe atılacak.",
  "modal.delete.message_one": "{count} öğe çöpe atılacak.",
  "modal.delete.confirm": "Çöpe at",
  "modal.delete.working": "Çöpe taşınıyor…",
  "modal.delete.cancel": "Vazgeç",
  "modal.delete.permanent_title": "Kalıcı olarak silinsin mi?",
  "modal.delete.permanent_message": "{count} öğe kalıcı olarak silinecek. Bu geri alınamaz.",
  "modal.delete.permanent_message_one": "{count} öğe kalıcı olarak silinecek. Bu geri alınamaz.",
  "modal.delete.permanent_confirm": "Kalıcı olarak sil",
  "modal.delete.permanent_working": "Siliniyor…",
  "modal.rename.title": "Yeniden adlandır",
  "modal.rename.save": "Kaydet",
  "modal.rename.saving": "Yeniden adlandırılıyor…",
  "modal.rename.cancel": "Vazgeç",
  "modal.newfolder.title": "Yeni klasör",
  "modal.newfolder.placeholder": "Klasör adı",
  "modal.newfolder.create": "Oluştur",
  "modal.newfolder.creating": "Oluşturuluyor…",
  "modal.newfolder.cancel": "Vazgeç",
  "modal.share.title": "Paylaşım bağlantısı",
  "archive.create_title": "Arşiv oluştur",
  "archive.extract_title": "Arşivi çıkar",
  "archive.create_count": "{count} öğe seçildi",
  "archive.create_count_one": "{count} öğe seçildi",
  "archive.filename": "Arşiv adı",
  "archive.format": "Biçim",
  "archive.password_optional": "Parola (isteğe bağlı)",
  "archive.password_confirm": "Parolayı doğrula",
  "archive.password_mismatch": "Parolalar birbiriyle eşleşmiyor.",
  "archive.encrypt_names": "Dosya adlarını şifrele",
  "archive.compression": "Sıkıştırma",
  "archive.solid": "Katı arşiv oluştur",
  "archive.dictionary_size": "Sözlük boyutu",
  "archive.dictionary_size_value": "{n} MiB",
  "archive.dictionary_hint": "Daha büyük sözlükler sıkıştırmayı iyileştirebilir ancak oluşturma ve çıkarma sırasında daha fazla bellek kullanır.",
  "archive.destination_folder": "Çıkarılacak klasör",
  "archive.create": "Oluştur",
  "archive.creating": "Oluşturuluyor…",
  "archive.extract": "Çıkar",
  "archive.extract_here": "Buraya çıkar",
  "archive.extract_to_folder": "Klasöre çıkar",
  "archive.extracting": "Çıkarılıyor…",
  "archive.cancel": "Vazgeç",
  "archive.invalid_name": "Eğik çizgi içermeyen bir dosya adı girin.",
  "archive.invalid_extension": "Arşiv adı kullanılabilir biçim uzantılarından biriyle bitmelidir.",
  "archive.invalid_folder": "Eğik çizgi içermeyen bir klasör adı girin.",
  "archive.password_required": "Bu arşiv için parola gerekiyor.",
  "archive.password_title": "Arşiv parolası",
  "archive.continue": "Devam et",
  "archive.opening": "Açılıyor…",
  "archive.bad_password": "Arşiv parolası yanlış.",
  "archive.target_exists": "Bu ada sahip bir öğe zaten var. Başka bir ad seçin veya önce mevcut öğeyi kaldırın.",
  "archive.password_charset": "ZIP parolasında yalnızca ASCII karakterler kullanılabilir; ç, ğ, ı, İ, ö, ş, ü gibi harfler kullanılamaz. Her karakteri kullanmak için 7z biçimini seçin.",
  "archive.error_unsupported": "Bu arşiv çıkarılamıyor: bu sunucu biçimini okuyamıyor ya da içinde filex’in çıkarmadığı bir şey var (bağlantı, özel dosya ya da boyutunu belirtmeyen bir dosya).",
  "archive.error_limit": "Bu arşiv, sunucunun çıkarmaya izin verdiği boyutu aşıyor.",
  "archive.error_unavailable": "Bu sunucu şu anda bu tür bir arşivi açamıyor.",
  "archive.created": "Arşiv oluşturuldu",
  "archive.queued": "Arşiv oluşturma arka planda çalışıyor",
  "archive.extracted": "{count} dosya çıkarıldı",
  "archive.extracted_one": "{count} dosya çıkarıldı",
  "archive.extraction_queued": "Arşiv çıkarma arka planda çalışıyor",
  "archive.preparing_extract": "{name} okunuyor… çıkarılmadan önce arşivin tamamı okunur.",
  "archive.already_preparing": "{name} hâlâ okunuyor - okuma bitince bir kez çıkarılacak",
  "archive.extraction_completed": "Çıkarma tamamlandı",
  "archive.extraction_cancelled": "Çıkarma {count} dosyadan sonra iptal edildi",
  "archive.extraction_cancelled_one": "Çıkarma {count} dosyadan sonra iptal edildi",
  "modal.share.pin": "PIN koruması",
  "modal.share.expires": "Son kullanma",
  "modal.share.max_downloads": "İndirme limiti",
  "modal.share.create": "Paylaş",
  "modal.share.cancel": "Vazgeç",
  "modal.share.close": "Kapat",
  "modal.share.limit_applied": "(sunucu sınırı uygulandı)",
  "modal.share.copy": "Kopyala",
  "modal.share.url_copied": "Bağlantı kopyalandı",
  "modal.share.pin_copied": "PIN kopyalandı",
  "modal.share.cli_copied": "CLI komutu kopyalandı",
  "upload.progress": "Yükleniyor",
  "upload.done": "Tamamlandı",
  "upload.error": "Hata",
  "upload.failed": "“{name}” yüklenemedi",
  "upload.aborted": "İptal edildi",
  "upload.cancel": "İptal",
  "upload.resuming": "“{name}” %{percent} noktasından devam ediyor",
  "upload.saving": "Depoya kaydediliyor…",
  "empty.folder": "Bu klasör boş",
  "empty.search": "Sonuç bulunamadı",
  loading: "Yükleniyor…",
  "notFound.title": "Klasör bulunamadı",
  "notFound.desc": "Bu klasör mevcut değil, taşınmış ya da erişim yetkiniz yok.",
  "notFound.goRoot": "Kök klasöre dön",
  "col.name": "Ad",
  "col.size": "Boyut",
  "col.modified": "Değiştirilme",
  "col.type": "Tür",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Kök",
  "breadcrumb.copy_path": "Yolu kopyala",
  "breadcrumb.go_to_path": "Yola git",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Kopyalanıyor",
  "ops.move": "Taşınıyor",
  "ops.delete": "Siliniyor",
  "ops.queued": "sırada",
  "ops.done": "tamamlandı",
  "ops.error": "hata",
  "node.trash": "Çöp kutusu",
  "node.folder": "Klasör",
  // --- Zengin önizleyici chrome ---
  "viewer.open_in_new_tab": "Yeni sekmede aç",
  "viewer.loading": "Yükleniyor…",
  "viewer.failed_to_load": "Dosya yüklenemedi",
  "viewer.peer_not_installed": "Bu tür bir dosya burada gösterilemiyor. Cihazınızda açmak için indirin.",
  "viewer.format_unsupported_3d": "Önizleme yalnızca .glb, .gltf ve .usdz biçimindeki 3B modelleri gösterir. Dosyayı indirip bir 3B programında açın.",
  "viewer.zoom_in": "Yakınlaştır",
  "viewer.zoom_out": "Uzaklaştır",
  "viewer.fit_width": "Sayfa genişliğine sığdır",
  "viewer.next_page": "Sonraki sayfa",
  "viewer.prev_page": "Önceki sayfa",
  "viewer.page_n_of_m": "Sayfa {n} / {m}",
  "viewer.tags": "Etiketler",
  "viewer.layers": "Katmanlar",
  "viewer.toc": "İçindekiler",
  "viewer.font_smaller": "Yazıyı küçült",
  "viewer.font_larger": "Yazıyı büyüt",
  "viewer.search": "Ara",
  "viewer.download": "İndir",
  "viewer.saving": "Kaydediliyor…",
  "viewer.save": "Kaydet (Ctrl+S)",
  "viewer.saved": "Kaydedildi",
  "viewer.save_error": "Hata",
  "viewer.editor_loading": "Editör yükleniyor…",
  "viewer.no_preview": "Bu dosya tipi için önizleme henüz yok.",
  "viewer.edit": "Düzenle",
  "viewer.close": "Kapat",
  "presence.expand": "Adları göster",
  "presence.collapse": "Küçült",
  "viewer.save_annotations": "Açıklamaları kaydet",
  "viewer.annotations_on": "Açıklamalar: açık",
  "viewer.annotations_off": "Açıklamalar: kapalı",
  "viewer.read_only": "Salt okunur",
  "viewer.csv_first_row_header": "İlk satır başlık olsun",
  "viewer.csv_filter": "Satır filtrele…",
  "viewer.epub_prev": "Önceki",
  "viewer.epub_next": "Sonraki",
  /* ⚠ Eski cümle her okuyucuya bir ORTAM DEĞİŞKENİ söylüyordu ("yönetici
     FILEX_DRAWIO_URL'yi ayarlamalı"). Yalnızca bir diyagrama bakmak isteyen
     kişiye ne yapabileceği; `_admin` - düzeltebilecek kişiye - nereden
     düzelteceği söylenir. */
  "viewer.drawio.disabled": "Diyagramlar burada açılamıyor: bu sunucuda draw.io yok. Başka bir yerde açmak için dosyayı indirin.",
  "viewer.drawio.disabled_admin": "Bu sunucuda draw.io kurulu değil. Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "viewer.drawio.load_failed": "Bu diyagram okunamadı. Başka bir yerde açmak için indirin.",
  "viewer.drawio.save_failed": "Diyagram kaydedilemedi. Değişiklikleriniz hâlâ düzenleyicide - yeniden deneyin.",
  "viewer.archive.entries": "{n} dosya",
  "viewer.archive.entries_one": "{n} dosya",
  "viewer.archive.empty": "Arşiv boş.",
  "viewer.archive.error": "Arşiv okunamadı.",
  "viewer.archive.unsupported": "Bu tür bir arşiv burada listelenemiyor. İçinde ne olduğunu görmek için indirin.",
  "viewer.archive.too_large": "Bu arşiv burada listelenemeyecek kadar büyük. İçinde ne olduğunu görmek için indirin.",
  "viewer.archive.open": "Arşivi aç",
  "viewer.archive.root": "Arşiv",
  "viewer.archive.location": "Arşiv konumu",
  "viewer.archive.reading": "Hâlâ okunuyor… İçeriği listelenmeden önce arşivin tamamı okunur; büyük bir arşivde bu biraz sürer.",
  "viewer.name": "Ad",
  "viewer.size": "Boyut",
  // --- cila:a - sıralama / tarih grupları / yoğunluk ---
  "col.sort": "Sırala",
  "group.today": "Bugün",
  "group.yesterday": "Dün",
  "group.this_week": "Bu hafta",
  "group.this_month": "Bu ay",
  "group.no_date": "Tarihsiz",
  "toolbar.density.compact": "Sıkışık görünüm",
  "toolbar.density.comfortable": "Rahat görünüm",
  // --- cila:c - komut paleti + kısayol yardımı + breadcrumb ---
  "palette.placeholder": "Dosya, klasör veya komut ara…",
  "palette.files": "Dosyalar",
  "palette.commands": "Komutlar",
  "palette.goto": "Yola git",
  "palette.empty": "Sonuç bulunamadı",
  "palette.hint": "↑↓ gezin · Enter seç · Esc kapat",
  "cmd.view_toggle": "Görünümü değiştir (liste ⇄ ızgara)",
  "cmd.trash": "Çöp kutusunu aç",
  "shortcuts.title": "Klavye kısayolları",
  "shortcuts.group.nav": "Gezinme",
  "shortcuts.group.selection": "Seçim",
  "shortcuts.group.file": "Dosya işlemleri",
  "shortcuts.palette": "Komut paleti",
  "shortcuts.search": "Aramaya odaklan",
  "shortcuts.go_up": "Üst klasöre çık",
  "shortcuts.open": "Seçili öğeyi aç",
  "shortcuts.close": "Kapat / vazgeç",
  "shortcuts.toggle_hidden": "Gizli dosyaları göster/gizle",
  "shortcuts.help": "Bu yardım penceresi",
  "shortcuts.select_all": "Tümünü seç",
  "shortcuts.star": "Yıldızla / yıldızı kaldır",
  "shortcuts.rename": "Yeniden adlandır",
  "shortcuts.delete": "Sil",
  "shortcuts.cut": "Kes",
  "shortcuts.copy": "Kopyala",
  "shortcuts.paste": "Yapıştır",
  "breadcrumb.more": "Aradaki klasörler",
  // --- State screens + undo snackbar + connection badge (cila:b) ---
  "empty.hint": "Dosyaları buraya sürükleyip bırakın",
  "empty.upload": "Dosya yükle",
  "empty.search.title": "Aramanızla eşleşen dosya yok",
  "empty.search.hint": "Farklı bir arama terimi deneyin",
  "empty.trash.title": "Çöp kutusu boş",
  "error.title": "Liste yüklenemedi",
  "error.retry": "Yeniden dene",
  "toast.undo": "Geri al",
  "toast.undone": "Geri alındı",
  "toast.undoing": "Geri alınıyor…",
  "toast.undo_queued": "Geri alma kuyruğa alındı - bittiğini işlemler paneli gösterecek",
  "toast.undo_failed": "Geri alınamadı",
  "toast.renamed": "Yeniden adlandırıldı",
  "toast.rename_queued": "“{name}” olarak yeniden adlandırılıyor…",
  "toast.moved": "Taşındı",
  "toast.trashed": "Çöpe taşındı",
  /* i18n:hardcoded - FileExplorer.vue'da düz string olarak duran, hiçbir dilin
     değiştiremediği bildirim metinleri. */
  "toast.failed": "İşlem başarısız",
  "err.status.400": "Geçersiz istek",
  "err.status.401": "Oturum açmanız gerekiyor",
  "err.status.403": "Bu işlem için yetkiniz yok",
  "err.status.404": "Bulunamadı",
  "err.status.409": "Zaten var / çakışma",
  "err.status.413": "Dosya çok büyük",
  "err.status.415": "Bu dosya türü desteklenmiyor",
  "err.status.422": "Geçersiz veri",
  "err.status.429": "Çok fazla istek, biraz bekleyin",
  "err.status.500": "Sunucu hatası",
  "err.status.501": "Bu işlem desteklenmiyor",
  "err.status.502": "Bağlı bir servis hata verdi",
  "err.status.503": "Servis şu an kullanılamıyor",
  "err.status.504": "Bağlı bir servis zamanında yanıt vermedi",
  "err.status.other": "Sunucu bu isteği kabul etmedi.",
  "err.upload_stalled": "Yükleme ilerlemeyi bıraktı. Yeniden deneyin - kaldığı yerden devam eder.",
  "err.network": "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip yeniden deneyin.",
  /* 0.54: sunucunun adını verdiği ret, sunucunun cümlesiyle söylenir (`message`, server.error.*). */
  "err.save_failed": "Değişiklikleriniz kaydedilemedi.",
  "err.load_failed": "Bu dosya yüklenemedi.",
  "err.viewer_failed": "Bu dosyanın görüntüleyicisi başlatılamadı. Açmak için dosyayı indirin.",
  "err.detail": "Ayrıntı",
  "toast.copied": "Kopyalandı",
  "toast.deleted": "Silindi",
  "toast.cut": "Kesildi",
  "toast.cut_ready": "Kes → Yapıştır hazır",
  "toast.copy_ready": "Kopyala → Yapıştır hazır",
  "toast.same_folder_cut": "Aynı klasöre kesilemez",
  "toast.restored": "{n} öğe geri getirildi",
  "toast.restored_one": "{n} öğe geri getirildi",
  "toast.delete_queued": "Silme kuyruğa alındı",
  "toast.trash_retention": "Çöpteki öğeler saklama süresi sonunda otomatik silinir. Kalıcı silme yönetici panelinden yapılır.",
  /* Kalıcı silinmesi yolda olan çöp satırı (yönetici Çöp sayfasının sözleri:
     iki katalogda tek cümle - ders #447). */
  "trash.purging": "Kalıcı olarak siliniyor…",
  "trash.row_busy": "Bu öğe üzerinde zaten bir iş sürüyor",
  "dropzone.hint": "Dosyaları buraya bırak",
  "modal.newfolder.invalid": "Geçersiz karakter",
  "names.reserved": "“{name}” adı filex’in kendi kullanımına ayrılmış. Başka bir ad seçin.",
  /* ⚠ Eksik ya da bozuk belge sunucusu kelimelerle söylenir, asla HTTP
     katmanıyla değil (eskiden `Config fetch 503: {"error":"onlyoffice not
     configured"}` yazıyordu). `_admin`, düzeltebilecek kişinin okuduğu -
     nereden düzelteceği; diğer herkes dosyayı yine de nasıl alacağını okur. */
  "viewer.office_unconfigured": "Ofis belgeleri burada açılamıyor: bu sunucuda ONLYOFFICE belge sunucusu yok. Dosyayı bilgisayarınızda açmak için indirin.",
  "viewer.office_unconfigured_admin": "Bu sunucuda ONLYOFFICE kurulu değil, bu yüzden ofis belgeleri burada açılamıyor. Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "viewer.office_unreachable": "Belge sunucusu şu anda yanıt vermiyor. Daha sonra yeniden deneyin ya da dosyayı indirin.",
  "viewer.office_unreachable_admin": "ONLYOFFICE belge sunucusu yanıt vermiyor. Yönetim panelinde Dış servisler altından kontrol edin.",
  /* Görev #92: düzenleyici başka bir kökendeki (belge sunucusunun kendi
     kökeni ya da arayüz kökeni) bir çerçevede çalışır ve o sayfa hiç yanıt
     vermedi - adres bu filex'e ulaşmıyor. */
  "viewer.office_frame_unreachable_admin": "ONLYOFFICE düzenleyici çerçevesi {origin} adresinden yüklenmedi. Oradaki vekil sunucunun çerçeveyi filex'e yönlendirdiğini kontrol edin ({env}).",
  "viewer.office_failed": "Bu belge ONLYOFFICE ile açılamadı. Bilgisayarınızda açmak için indirin.",
  "viewer.csv_office_note": "CSV olarak kaydedilir: yalnızca etkin sayfanın değerleri kalır. Biçimlendirme, formüller ve diğer sayfalar kaydedilmez.",
  "viewer.office_forbidden": "Bu belgeyi ONLYOFFICE ile açma izniniz yok.",
  /* ONLYOFFICE'in "Download failed" (İndirme başarısız) hatasından sonra:
     iki durumdan hangisi olduğu, filex'in gördüğüyle (lib/officeDiagnosis,
     #80). */
  "viewer.office_download_served": "Belge sunucusu bu dosyayı filex’ten indirdi, ancak tarayıcınız dönüştürülmüş kopyayı belge sunucusundan yükleyemedi. Belge sunucusunun önündeki vekil sunucunun X-Forwarded-Proto ve X-Forwarded-Host başlıklarına bakın.",
  "viewer.office_download_not_requested": "Belge sunucusu bu dosyayı filex’ten hiç istemedi. Dosya daha önce açıldıysa belge sunucusu kendi kopyasını kullanıyor olabilir.",
  "viewer.office_download_refused": "filex, belge sunucusunun bu dosya için yaptığı isteği şu nedenle reddetti: {reason}.",
  "viewer.office_fetch_reason.bad_link": "adres bozuktu",
  "viewer.office_fetch_reason.signature_expired": "adresin süresi dolmuştu",
  "viewer.office_fetch_reason.signature_bad": "imzası eşleşmedi (JWT sırrı değişti ya da adres değiştirildi)",
  "viewer.office_fetch_reason.not_found": "dosya artık yok",
  "viewer.office_fetch_reason.storage_unavailable": "depo açılamadı",
  "viewer.office_fetch_reason.body_unavailable": "dosyanın içeriği bulunamadı",
  "viewer.office_fetch_reason.object_missing": "dosya depoda yok",
  "viewer.office_fetch_reason.read_failed": "dosya depodan okunamadı",
  /* Gezginin "Aç" girdisi, belge sunucusu yokken - yalnızca yöneticiye
     gösterilir (diğer herkese girdi hiç sunulmaz; lib/serviceGate). */
  "ctx.needs_onlyoffice": "ONLYOFFICE kurulu değil - yönetim panelinde Dış servisler altından kurun.",
  "ctx.needs_drawio": "draw.io kurulu değil - yönetim panelinde Dış servisler altından kurun.",
  "viewer.pdf_inline_failed": "Tarayıcı PDF'i inline açamadı.",
  "viewer.too_large": "Dosya çok büyük (>1 MB).",
  "viewer.csv_rows": "{n} satır",
  "viewer.csv_rows_one": "{n} satır",
  "presence.others": "{n} kişi",
  "presence.others_one": "{n} kişi",
  "conn.offline": "Canlı bağlantı yok - değişiklikler gecikebilir",
  "conn.tooltip": "Sunucuyla canlı bağlantı kurulamadı; liste belirli aralıklarla otomatik yenilenir. Bağlantı geri gelince bu uyarı kaybolur.",
  /* === bul:s3 === */
  "palette.everywhere": "Her yerde",
  "palette.searching": "Aranıyor…",
  "palette.everywhere_failed": "Arama yapılamadı. Yeniden deneyin.",
  "palette.saved": "Kayıtlı aramalar",
  "palette.save": "Aramayı kaydet",
  "palette.saved.delete": "Kayıtlı aramayı sil",
  /* #168 - yönetim panelinin araması (components/PanelSearch.vue). */
  "panelsearch.label": "Yönetim panelinde ara",
  "panelsearch.trigger": "Ara",
  "panelsearch.placeholder": "Sayfa, ayar, kişi, uygulama ara…",
  "panelsearch.close": "Aramayı kapat",
  "panelsearch.clear": "Aramayı temizle",
  "panelsearch.results": "Arama sonuçları",
  "panelsearch.group.page": "Sayfalar",
  "panelsearch.group.setting": "Ayarlar",
  "panelsearch.group.app": "Uygulamalar",
  "panelsearch.group.user": "Kullanıcılar",
  "panelsearch.group.group": "Gruplar",
  "panelsearch.group.key": "API anahtarları",
  "panelsearch.group.storage": "Depolar",
  "panelsearch.group.share": "Paylaşımlar",
  "panelsearch.group.file": "Dosyalar",
  "panelsearch.group.recent": "Son aramalar",
  "panelsearch.files_all": "Dosyalarda ara: {q}",
  "panelsearch.recent_remove": "Son aramalardan kaldır",
  "panelsearch.recent_clear": "Son aramaları temizle",
  "panelsearch.empty": "“{q}” ile eşleşen bir şey yok.",
  "panelsearch.searching": "Aranıyor…",
  "panelsearch.failed": "Sonuçların bir kısmı yüklenemedi. Gelenler gösteriliyor.",
  "panelsearch.prefixes": "Tek bir türe daraltın:",
  "panelsearch.count_one": "{n} sonuç",
  "panelsearch.count": "{n} sonuç",
  "search.in_content": "İçerikte",
  "search.truncated": "Gösterilenden daha fazla sonuç var - aramanızı daraltın",
  "nav.more_shown": "{total} öğeden {shown} tanesi gösteriliyor",
  "nav.load_more": "Daha fazla yükle",
  /* Katalog kapsamı (docs/LAZY-CATALOGUE.md, lib/catalogCoverage). */
  "coverage.first_scan": "Bu deponun ilk senkronu henüz bitmedi. Bitene kadar arama, klasör boyutları ve kullanım deponun bir kısmını kapsamaz.",
  "coverage.lazy_filling": "filex bu depoyu hâlâ kataloglıyor (şimdiye kadar bulunan klasörlerin %{pct} kadarı tamam). Bitene kadar arama, klasör boyutları ve kullanım deponun bir kısmını kapsamaz.",
  "coverage.lazy_on_open": "Bu depoda yalnız açılan klasörler kataloglanır. Arama, klasör boyutları ve kullanım yalnız bu klasörleri kapsar.",
  "coverage.search_some": "Şu depoların tamamı henüz kataloglanmadı: {names}. Bu arama oradaki bazı dosyaları bulamayabilir.",
  "coverage.catalog_all": "Tümünü katalogla",
  "coverage.catalog_started": "Senkron başladı - deponun tamamı kataloglanıyor.",
  "coverage.catalog_running": "Kataloglanıyor…",
  "coverage.cataloging": "{storage} kataloglanıyor… arka planda sürüyor, bittiğinde bu sayfa söyleyecek.",
  "coverage.catalog_done": "{storage} baştan sona kataloglandı",
  "coverage.catalog_failed": "{storage} kataloglanamadı. Nedenini yönetim panelinde, deponun senkron geçmişinde görebilirsiniz.",
  "coverage.catalog_stopped": "{storage} kataloglaması bitmeden durduruldu",
  "coverage.catalog_joined": "{storage} zaten taranıyordu - bittiğinde bu sayfa haber verecek.",
  "coverage.catalog_gone": "{storage} kataloglanırken kaldırıldı",
  "coverage.catalog_unfollowed": "{storage} arka planda kataloglanmaya devam ediyor; nasıl bittiğini yönetim panelinde deponun senkron geçmişi gösterir",
  "size.at_least": "≥ {size}",
  "size.partial_hint": "Bu klasörün bir kısmı henüz kataloglanmadı; boyutu en az bu kadar.",
  "size.unknown_hint": "Bu klasör henüz kataloglanmadı; boyutu bilinmiyor.",
  /* === bag:b4 === */
  "toolbar.more": "Diğer işlemler",
  "toolbar.search.close": "Aramayı kapat",
  "sheet.menu": "İşlemler",
  "sheet.close": "Kapat",
  /* === koru:k1 === */
  "toolbar.inspector": "Ayrıntılar",
  "ctx.details": "Ayrıntılar",
  /* yildiz:s1 - yıldızlamak bir eylem, menüde de öyle görünür. */
  "ctx.star": "Yıldızla",
  "ctx.unstar": "Yıldızı kaldır",
  "star.failed": "Yıldız değiştirilemedi",
  "shortcuts.inspector": "Ayrıntılar panelini aç/kapat",
  "inspector.title": "Ayrıntılar",
  "inspector.copy_name": "Adı kopyala",
  "inspector.items": "{n} öğe",
  "inspector.items_one": "{n} öğe",
  "inspector.type": "Tür",
  "inspector.select_hint": "Ayrıntılarını görmek için bir öğe seçin.",
  /* pane:p1 - panel SON seçilen şeyi tutar (bakımcının kararı, 2026-09-13);
     dolayısıyla bölünmüş pencerenin bakılmayan yarısındaki bir öğeyi
     anlatıyor olabilir. Bu satır hangisi olduğunu ve nerede durduğunu söyler. */
  "inspector.held": "Son seçilen - {where} içinde",
  "inspector.close": "Kapat",
  "inspector.section.general": "Genel",
  "inspector.section.tags": "Etiketler",
  /* etiket:t1 - TagPicker'ın kendi çerçevesi. 2026-09-13'e kadar bu üçü
     katalogdan bağımsız olarak İngilizce basılıyordu; `tags.open` ise çipin
     yeni "bu etiketi taşıyan her şeyi göster" kapısı. */
  "tags.open": "Etiketi aç: {tag}",
  "tags.add": "+ Etiket ekle",
  "tags.name": "Etiket adı",
  "tags.remove": "Etiketi kaldır",
  /* etiket:k2 (v0.43.0) - etiketin iki TÜRÜ. Etiket nerede çiziliyorsa türünü
     simgeyle birlikte sözcükle de söyler: bu sürüme kadar her etiket sessizce
     sunucudaki herkesle paylaşılıyordu. */
  "tags.kind.label": "Bu etiketi kim görür",
  "tags.kind.personal": "Kişisel",
  "tags.kind.team": "Ekip",
  "tags.kind.personal_help": "Yalnızca siz görürsünüz",
  "tags.kind.team_help": "Bu dosyayı görebilen ekibindeki herkes görür",
  "tags.kind.team_locked": "Ekip etiketi eklemek ya da kaldırmak için bu dosyada düzenleme yetkiniz olmalı.",
  "tags.chip.personal": "Kişisel etiket “{tag}” - yalnızca siz görürsünüz",
  "tags.chip.team": "Ekip etiketi “{tag}” - bu dosyayı görebilen ekibindeki herkes görür",
  "tags.add_submit": "Ekle",
  "inspector.section.versions": "Sürümler",
  "inspector.section.permissions": "İzinler",
  "inspector.section.shares": "Paylaşımlar",
  "inspector.path": "Yol",
  "inspector.size": "Boyut",
  "inspector.modified": "Değiştirilme",
  "inspector.mime": "MIME türü",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Düğüm kimliği",
  "inspector.copy": "Kopyala",
  "inspector.copied": "Kopyalandı",
  "inspector.error": "Yüklenemedi",
  "inspector.items_summary": "{n} öğe, toplam {size}",
  "inspector.items_summary_one": "{n} öğe, toplam {size}",
  "inspector.folder_items": "{n} öğe",
  "inspector.folder_items_one": "{n} öğe",
  "inspector.versions.empty": "Sürüm geçmişi yok",
  "inspector.versions.v": "Sürüm {n}",
  "inspector.versions.restore": "Geri yükle",
  "inspector.versions.restore_confirm": "Bu sürüm geri yüklensin mi?",
  "inspector.versions.snapshot_current": "Önce şimdiki halin sürümünü al",
  "inspector.versions.confirm": "Onayla",
  "inspector.versions.restoring": "Geri yükleniyor…",
  "inspector.versions.cancel": "Vazgeç",
  "inspector.versions.take_snapshot": "Şimdiki halin sürümünü al",
  "inspector.versions.snapshotting": "Sürüm alınıyor…",
  "inspector.versions.restored": "Sürüm geri yüklendi",
  "inspector.versions.snapshotted": "Sürüm alındı",
  "inspector.versions.unsupported": "Sunucu bu işlemi desteklemiyor",
  "inspector.perm.none": "Erişim yok",
  "inspector.perm.viewer": "Görüntüleyen",
  "inspector.perm.editor": "Düzenleyen",
  "inspector.perm.owner": "Sahip",
  "inspector.perm.manage": "İzinleri yönet",
  "inspector.shares.empty": "Paylaşım bağlantısı yok",
  "inspector.shares.copy": "Bağlantıyı kopyala",
  /* wiring:c1 - tema galerisi */
  "theme.menu": "Tema",
  "theme.title": "Tema galerisi",
  "theme.hint": "Tema yalnız renk paletini değiştirir; gündüz mü gece mi olduğu yukarıdaki seçim.",
  "theme.mode.label": "Görünüm",
  "theme.mode.light": "Gündüz",
  "theme.mode.dark": "Gece",
  "theme.mode.auto": "Otomatik",
  "theme.reset": "Varsayılana dön",
  "theme.close": "Kapat",
  "theme.selected": "Seçili",
  "theme.name.default": "Varsayılan",
  "theme.name.night": "Gece mavisi",
  "theme.name.forest": "Orman",
  "theme.name.amber": "Kehribar",
  "theme.name.lilac": "Leylak",
  "theme.name.contrast": "Yüksek kontrast",
  "theme.name.gray": "Yumuşak gri",
  "theme.name.terminal": "Terminal yeşili",
  /* === zaman:z3 - saat dilimi seçici (gömme penceresi + web ayarları) === */
  "tz.menu": "Saat dilimi",
  "tz.title": "Saat dilimi",
  "tz.label": "Tarihleri şu saatle göster",
  "tz.search": "Şehir, ülke ya da saat farkı arayın - “İstanbul” veya “GMT+3” deneyin",
  "tz.default.device": "Bu cihazın saat dilimini kullan ({zone})",
  "tz.default.account": "Hesabınızın saat dilimini kullan ({zone})",
  "tz.default.host": "Bu sitenin varsayılanını kullan ({zone})",
  "tz.no_match": "“{query}” ile eşleşen saat dilimi yok. Bir şehir, bir ülke ya da GMT+3 gibi bir fark deneyin.",
  "tz.more": "{n} kayıt daha var - listeyi daraltmak için yazmayı sürdürün.",
  "tz.hint": "Yalnızca bu tarayıcıda saklanır. Her tarih tek bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir.",
  "tz.now": "{zone} bölgesinde şu an: {time}",
  /* === wiring:c2 - özelleştirilebilir kısayollar + hızlı bakış === */
  "shortcuts.quicklook": "Hızlı bakış",
  "shortcuts.customize": "Özelleştir",
  "shortcuts.settings.menu": "Kısayollar",
  "shortcuts.settings.title": "Kısayol ayarları",
  "shortcuts.settings.hint": 'Bir kısayolu değiştirmek için "Değiştir"e basıp yeni tuş kombinasyonuna basın. Değişiklikler yalnızca bu tarayıcıda saklanır.',
  "shortcuts.settings.change": "Değiştir",
  "shortcuts.settings.capture": "Tuşlara basın… (Esc iptal)",
  "shortcuts.settings.reset": "Varsayılana dön",
  "shortcuts.settings.reset_all": "Tümünü sıfırla",
  "shortcuts.settings.unbound": "Atanmadı",
  "shortcuts.settings.fixed": "Sabit",
  "shortcuts.settings.customized": "Özelleştirildi",
  "shortcuts.settings.conflict": 'kombinasyonu "{name}" kısayolunda kullanılıyor.',
  "shortcuts.settings.conflict_fixed": 'kombinasyonu "{name}" sabit kısayoluna ayrılmış - kullanılamaz.',
  "shortcuts.settings.conflict_take": "Eskisini boşa çıkar ve ata",
  "shortcuts.settings.conflict_cancel": "Vazgeç",
  "quicklook.hint_close": "kapat",
  "quicklook.hint_nav": "önceki/sonraki",
  "quicklook.hint_open": "aç",
  /* === /wiring:c2 === */
  /* === wiring:c3 - işlem merkezi === */
  "opc.title": "İşlemler",
  "opc.aria_badge": "{n} işlem - işlem merkezini aç/kapat",
  "opc.aria_badge_one": "{n} işlem - işlem merkezini aç/kapat",
  "opc.close": "Kapat",
  "opc.active": "Sürüyor",
  "opc.history": "Geçmiş",
  "opc.clear": "Temizle",
  "opc.empty": "İşlem yok",
  "opc.cancel": "İptal",
  "opc.retry": "Yeniden dene",
  "opc.dismiss": "Kapat",
  "opc.queued": "Sırada",
  "opc.cancelling": "İptal isteniyor…",
  "opc.percent": "%{n}",
  "opc.items": "{total} öğeden {done}",
  "opc.trash_items": "Çöpten {n} öğe",
  "opc.trash_items_one": "Çöpten {n} öğe",
  "opc.status.running": "Sürüyor",
  "opc.status.done": "Bitti",
  "opc.status.error": "Hata",
  "opc.status.aborted": "İptal edildi",
  "opc.kind.upload": "Yükleme",
  "opc.kind.copy": "Kopyalama",
  "opc.kind.move": "Taşıma",
  "opc.kind.delete": "Silme",
  "opc.kind.rename": "Yeniden adlandırma",
  "opc.kind.restore": "Geri getirme",
  "opc.kind.purge": "Kalıcı silme",
  "opc.kind.convert": "Dönüştürme",
  "opc.kind.archive": "Arşiv",
  "opc.kind.plugin": "Uygulama",
  "opc.kind.trash": "Çöp kutusunu boşaltma",
  "opc.kind.thumbs": "Küçük resim onarımı",
  /* A folder's contents on hover (FolderPeek, useFolderPeek). */
  "peek.items": "{n} öğe",
  "peek.items_one": "{n} öğe",
  "peek.more": "+{n} tane daha",
  "peek.empty": "Boş",
  "peek.loading": "İçine bakılıyor…",
  "opc.open": "Aç",
  /* Uygulama eklentileri - dosya menüsüne eklenen satırlar ve kuyruğa
     aldıkları işler (docs/APP-PLUGINS-API.md). */
  "plugin.queued": "{label} kuyruğa alındı",
  "plugin.done": "{label} tamamlandı",
  "plugin.failed": "{label} başarısız",
  "plugin.cancel_failed": "İş iptal edilemedi",
  "plugin.not_applicable": "Bu işlem seçime uygulanamaz",
  "plugin.needs_engine": "{name} bu sunucuda kurulu değil - sunucuya kurup filex'i yeniden başlatın.",
  "plugin.needs_other": "{name} bu sunucuda kullanılamıyor.",
  "plugin.needs_office": "Ofis belgeleri için {name} gerekiyor ve bu sunucuya bağlı değil - Dış servisler sayfasından bağlayın.",
  "plugin.confirm.title": "Onayla",
  "plugin.confirm.cancel": "Vazgeç",
  "plugin.confirm.run": "Çalıştır",
  "plugin.view.close": "Kapat",
  "appframe.confirm_title": "Onay",
  "appframe.consent_clipboard": "{app} panonuza metin kopyalamak istiyor.",
  "appframe.consent_download": "{app}, “{name}” dosyasını bilgisayarınıza kaydetmek istiyor.",
  "appframe.consent_print": "{app}, “{name}” belgesini yazdırmak istiyor.",
  "appframe.consent_job": "{app} “{action}” işini başlatmak istiyor.",
  "appframe.consent_allow": "İzin ver",
  "appframe.consent_deny": "İzin verme",
  "appframe.unsaved_title": "Kaydedilmemiş değişiklikler",
  "appframe.state_no_account": "Uygulamanın şifreli bir dosya için ayarları, oturum açtığınız hesaba göre mühürlenerek saklanır; bu sayfa hangi hesap olduğunu öğrenemedi, bu yüzden hiçbir şey saklanmadı. Yeniden oturum açın ya da dosyayı oturum açtığınız yerde açın.",
  "appframe.unsaved_text": "{app} içinde kaydedilmemiş değişiklikler var. Yine de kapatılsın mı?",
  "appframe.discard": "Kaydetmeden kapat",
  "appframe.keep_open": "Düzenlemeye devam et",
  "appframe.save_close": "Kaydet ve kapat",
  "appframe.updated": "{app}, {version} sürümüne güncellendi.",
  "appframe.updated_reload": "Bir yönetici {app} uygulamasının yeni sürümünü onayladı. Yeni sürümü kullanmak için yeniden yükleyin - önce çalışmanızı kaydedin.",
  "appframe.reload": "Yeniden yükle",
  "appframe.dismiss": "Kapat",
  "appframe.not_connected": "{app} başlamadı. Kapatıp yeniden açın; tekrar ederse yöneticinize haber verin.",
  "appframe.save_as_title": "{app}: “{name}” nereye kaydedilsin?",
  "plugin.view.busy": "Çalışıyor…",
  "plugin.view.unsupported": "Bu ekran, bu sürümün çizemediği bir bileşen kullanıyor ({type})",
  "plugin.view.error": "Uygulama hata döndürdü",
  "plugin.output_missing": "Çıktı artık eski yerinde değil",
  /* M2 - surface components (components/plugin/nodes/*) */
  "plugin.view.loading": "Yükleniyor…",
  "plugin.view.preview_failed": "Önizleme yüklenemedi",
  "plugin.steps.label": "Adımlar",
  "plugin.list.empty": "Henüz bir şey yok",
  "plugin.list.actions": "İşlemler",
  /* The label on a table row's ONE action control (core RowActions.vue).
     The explorer's handle is the ⋮ glyph; a panel row's says what it is.
     Owner, 2026-09-20: "adminde 'Aksiyon' diye yazmalı". */
  "row.actions": "Aksiyon",
  "plugin.people.placeholder": "Ad veya e-posta",
  "plugin.people.placeholder_email": "E-posta adresi",
  "plugin.people.add": "Ekle",
  "plugin.people.remove": "{name} kişisini kaldır",
  "plugin.people.invalid_email": "Geçerli bir e-posta adresi girin",
  "plugin.people.external_off": "Yalnızca hesabı olan kişiler eklenebilir",
  "plugin.pin.label": "PIN",
  "plugin.file.choose": "Seç…",
  "plugin.file.clear": "Temizle",
  "plugin.file.none": "Seçim yok",
  /* M3 - imza yolu: signature-pad + pdf-fields düğümleri ve dış katılımcının
     herkese açık sayfası (views/PublicSurface.vue, usePublicPage). */
  "plugin.sig.mode_draw": "Çiz",
  "plugin.sig.mode_type": "Yaz",
  "plugin.sig.mode_upload": "Yükle",
  "plugin.sig.draw_hint": "Parmağınızla ya da fareyle buraya imzalayın",
  "plugin.sig.type_placeholder": "Adınızı yazın",
  "plugin.sig.upload_pick": "Görsel seç…",
  "plugin.sig.upload_hint": "PNG ya da JPEG, en çok {kb} KB",
  "plugin.sig.upload_too_big": "Görsel {kb} KB sınırından büyük",
  "plugin.sig.upload_bad_type": "Yalnızca PNG ya da JPEG görsel kullanılabilir",
  "plugin.sig.upload_unreadable": "Görsel okunamadı",
  "plugin.sig.clear": "İmzayı temizle",
  "plugin.sig.signed": "İmza alındı",
  "plugin.pdf.load_failed": "Belge yüklenemedi",
  "plugin.pdf.palette": "Alan türleri",
  "plugin.pdf.pending": "Yeri bekleyen kutular",
  "plugin.pdf.place_box_hint": "“{name}” kutusunun gideceği yere dokunun ya da boyutlandırmak için sürükleyin",
  "plugin.pdf.all_placed": "Her kutunun bir yeri var",
  "plugin.pdf.place_idle": "Yukarıdaki kutulardan birini seçin, sonra sayfada gideceği yere dokunun.",
  "plugin.pdf.place_idle_done": "Kaldırmak ya da kopyalamak için sayfadaki bir kutuya dokunun; taşımak için sürükleyin.",
  "plugin.pdf.no_boxes": "Henüz kutu yok. Aşağıdan ekleyin: adını verin, kimin olduğunu söyleyin; yerini bir sonraki adımda belgede seçeceksiniz.",
  "plugin.pdf.add_box": "Kutu ekle",
  "plugin.pdf.unplace": "Sayfadan kaldır",
  "plugin.pdf.place_hint": "{type} alanının gideceği yere dokunun ya da boyutlandırmak için sürükleyin",
  "plugin.pdf.type_signature": "İmza",
  "plugin.pdf.type_initials": "Paraf",
  "plugin.pdf.type_date": "Tarih",
  "plugin.pdf.type_text": "Metin",
  "plugin.pdf.type_checkbox": "Onay kutusu",
  "plugin.pdf.tap_signature": "İmzalamak için dokunun",
  "plugin.pdf.tap_initials": "Paraflamak için dokunun",
  "plugin.pdf.tap_date": "Bugünün tarihi için dokunun",
  "plugin.pdf.tap_text": "Metin",
  "plugin.pdf.tap_checkbox": "İşaretlemek için dokunun",
  "plugin.pdf.label": "Ad",
  "plugin.pdf.assignee": "İmzacı",
  "plugin.pdf.unassigned": "Herkes",
  "plugin.pdf.filled_by": "Dolduran",
  "plugin.pdf.style": "Nasıl imzalanır",
  "plugin.pdf.style_drawn": "Çizerek",
  "plugin.pdf.style_typed": "Yazarak",
  "plugin.pdf.lines": "Altına yazılanlar",
  "plugin.pdf.lines_preview": "İmzanın altında:",
  "plugin.pdf.lines_none": "Bu imzanın altına bir şey yazılmaz.",
  "plugin.pdf.required": "Zorunlu",
  "plugin.pdf.copy_to_page": "Sayfaya kopyala",
  "plugin.pdf.copy": "Kopyala",
  "plugin.pdf.delete": "Alanı sil",
  "plugin.pdf.zoom_in": "Yakınlaştır",
  "plugin.pdf.zoom_out": "Uzaklaştır",
  "plugin.pdf.zoom_fit": "Genişliğe sığdır",
  "plugin.pdf.zoom_fit_page": "Sayfayı ekrana sığdır",
  "plugin.pdf.pad_for": "{type} alanınız",
  "plugin.pdf.pad_done": "Tamam",
  "plugin.page.loading": "Yükleniyor…",
  "plugin.page.pin_title": "Bu sayfa korumalı",
  "plugin.page.pin_hint": "Devam etmek için size verilen PIN'i girin",
  "plugin.page.pin_submit": "Devam et",
  "plugin.page.pin_wrong": "Bu PIN doğru değil",
  "plugin.page.pin_locked": "Çok fazla yanlış PIN girildi - birkaç dakika bekleyip yeniden deneyin",
  "plugin.page.unavailable_title": "Bu bağlantı kullanılamıyor",
  "plugin.page.unavailable_text": "Süresi dolmuş, hakkı tükenmiş ya da geri çekilmiş olabilir. Gönderen kişiden yeni bir bağlantı isteyin.",
  "plugin.page.accepted_title": "Alındı, teşekkürler",
  "plugin.page.accepted_text": "Yanıtınız kaydedildi. Bu sayfayı kapatabilirsiniz.",
  "plugin.page.done_title": "Tamamlandı",
  "plugin.page.done_text": "Burada yapılacak başka bir şey kalmadı. Bu sayfayı kapatabilirsiniz.",
  "plugin.page.error_title": "Bir sorun oluştu",
  "plugin.page.retry": "Yeniden dene",
  "plugin.page.files": "Belgeler",
  "plugin.page.open_file": "{name} dosyasını yeni sekmede aç",
  "plugin.page.footer": "filex ile sunuldu",
  /* Herkese açık sayfaların (paylaşım, dosya isteği) kendi cümleleri
     sunucunundur: `server.public.*` (composables/usePublicText). */
  /* === Uygulama eklentileri v2 - `page` görünümü, uygulamanın dosya kilidi,
     işin yazdığı çıktı kipi, imza alanının yazı tipleri ve kuralları. === */
  "plugin.page_view.back": "Dosyalara dön",
  "plugin.page_view.queued_title": "İş kuyruğa alındı",
  "plugin.page_view.queued_text": "filex işi yürütüyor. Bittiğinde bu sayfa söyler; ilerleyişi işlemler tepsisinde de görünür.",
  "plugin.page_view.finished_title": "İş bitti",
  "plugin.page_view.finished_text": "Burada yapılacak başka bir şey kalmadı. Dosyalara dönebilir ya da bu sekmeyi kapatabilirsiniz.",
  "plugin.page_view.failed_title": "İş tamamlanamadı",
  "plugin.page_view.opening_title": "Sonuç açılıyor",
  "plugin.page_view.open_ops": "İşlemler tepsisini aç",
  "plugin.page_view.done_title": "Tamamlandı",
  "plugin.page_view.done_text": "Burada yapılacak başka bir şey kalmadı. Bu sekmeyi kapatabilirsiniz.",
  "plugin.page_view.error_title": "Bu ekran açılamadı",
  "plugin.page_view.retry": "Yeniden dene",
  "plugin.page_view.blocked": "Yeni sekme engellendi - bu site için açılır pencerelere izin verin, yoksa ekran pencere içinde açılır",
  "plugin.output.sibling": "yeni dosya",
  "plugin.output.version": "yeni sürüm",
  "plugin.output.sibling_title": "Sonuç, aslının yanına yeni bir dosya olarak iner",
  "plugin.output.version_title": "Sonuç, dosyanın yerine yeni bir sürümü olarak geçer",
  "plugin.sign.font_label": "El yazısı",
  "plugin.pdf.font": "Yazı tipi",
  "plugin.pdf.rule_number": "Yalnızca sayı",
  "plugin.pdf.rule_email": "E-posta adresi",
  "plugin.pdf.rule_length": "{min} ile {max} karakter arasında",
  "plugin.pdf.rule_min": "En az {min} karakter",
  "plugin.pdf.rule_max": "En çok {max} karakter",
  "plugin.pdf.err_number": "Bir sayı girin",
  "plugin.pdf.err_email": "Geçerli bir e-posta adresi girin",
  "plugin.pdf.err_min": "Çok kısa - en az {min} karakter",
  "plugin.pdf.err_max": "Çok uzun - en çok {max} karakter",
  "applock.badge": "Kilitli",
  "applock.some_app": "bir uygulama",
  "applock.held": "{app} bu dosyayı kilitledi",
  "applock.held_reason": "{app} bu dosyayı kilitledi: {reason}",
  "applock.until": "- {date} tarihine kadar",
  "applock.inspector": "Uygulama kilidi",
  /* issue #34 - sunucunun İZLEMEDİĞİ sembolik bağ (lib/symlink). Rozet satırdaki
     kısa söz; `why` ise arkasındaki cümle - üzerine gelince, ayrıntılar panelinde
     ve biri açmaya kalkıştığında çıkan bildirimde. ⚠ Kırık bağ ile depo dışına
     çıkan bağ AYRI durumlardır ve ayrı okunmalıdır: yalnızca birinin yönetici
     çaresi vardır; silinmiş bir hedef için o çareyi önermek insanı işe yaramayacak
     bir ayar ekranına yollar. */
  "symlink.badge.outside_root": "Depo dışında",
  "symlink.badge.broken": "Kırık bağ",
  "symlink.badge.unresolved": "Uzak bağ",
  "symlink.badge.unknown": "Bağlantı",
  "symlink.why.outside_root": 'Hedefi bu deponun dışında kalan bir bağ; bu yüzden açılamıyor. Bir yönetici, deponun ayarlarındaki "Bu klasörün dışına çıkan sembolik bağları izle" seçeneğiyle buna izin verebilir.',
  "symlink.why.broken": "Hedefi artık var olmayan bir bağ; açılacak bir şey yok. Sunucuda onarılması ya da kaldırılması gerekir - hiçbir ayar silinmiş hedefi geri getirmez.",
  "symlink.why.unresolved": "Uzak sunucudaki bir bağ. filex hedefinin bu deponun içinde olup olmadığını bilemediği için bağı izlemez ve açamaz.",
  "symlink.why.unknown": "filex'in izlemediği bir bağ, bu yüzden açılamıyor. Hedefi ya bu deponun dışında, ya kayıp, ya da filex'in çözümleyemediği uzak bir sunucuda.",
  "symlink.inspector": "Açılamayan bir bağ",
  "unavailable.why.file": "Depo bu dosyanın hâlâ var olup olmadığını söyleyemedi. Depo yeniden yanıt verene kadar dosya açılamaz ve değiştirilemez; bir sonraki tarama yeniden denetler.",
  "unavailable.why.dir": "Depo bu klasörün hâlâ var olup olmadığını söyleyemedi. Depo yeniden yanıt verene kadar ne klasör ne de içindekiler açılabilir ya da değiştirilebilir; bir sonraki tarama yeniden denetler.",
  "unavailable.withReason": "{why} Deponun yanıtı: {reason}",
  "unavailable.inspector": "Kullanılamıyor",
  /* 0.50 - why a file has no thumbnail, on the file itself (lib/thumbNote). */
  "thumbNote.corrupt": "Bozuk",
  "thumbNote.corrupt_why": "Küçük resim yok: dosya okunamadı. Bozuk ya da eksik olabilir.",
  "thumbNote.encrypted": "Şifreli",
  "thumbNote.encrypted_why": "Küçük resim yok: dosya şifreli ya da parolayla korunuyor.",
  "thumbNote.too_large": "Çok büyük",
  "thumbNote.too_large_why": "Küçük resim yok: dosya, küçük resim boyut sınırından büyük.",
  "thumbNote.full": "{label}. {why}",
  "plugin.pdf.rule": "Kabul ettiği",
  "plugin.pdf.rule_kind_any": "Serbest metin",
  "plugin.pdf.rule_kind_number": "Yalnızca sayı",
  "plugin.pdf.rule_kind_email": "E-posta adresi",
  "plugin.pdf.rule_min_label": "En az uzunluk",
  "plugin.pdf.rule_max_label": "En çok uzunluk",
  "plugin.pdf.format": "Tarih biçimi",
  "plugin.pdf.date_order": "Tarih sırası",
  "plugin.pdf.date_separator": "Ayraç",
  "plugin.pdf.date_example": "Örnek",
  "opc.kind.archive-create": "Arşiv oluşturuluyor",
  "opc.kind.archive-extract": "Arşiv çıkarılıyor",
  /* === wiring:c4 - onboarding turu + erişilebilirlik + hata kartı === */
  "tour.aria": "Tanıtım turu",
  "tour.restart": "Turu tekrar başlat",
  "tour.skip": "Turu atla",
  "tour.back": "Geri",
  "tour.next": "İleri",
  "tour.done": "Bitti",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Depolar ve görünümler",
  "tour.step.nav.desc": "Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp kutusu hep bu panelde durur; altında da depolarınız ve bağlantılarınız. Sol üst köşedeki düğme paneli ince bir şeride indirir ve geri açar.",
  "tour.step.nav.desc_closed": "Bu düğme gezinti panelini açar: Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp kutusu; altında da depolarınız ve bağlantılarınız.",
  "tour.step.new.title": "Yeni bir şey ekle",
  "tour.step.new.desc": "Yeni olan her şey buradan başlar: bu cihazdan dosya yükleyebilir, klasör oluşturabilir ya da birinden dosya isteyebilirsiniz. Dosyaları pencereye sürükleyip bırakmak da yükler.",
  "tour.step.new.desc_fab": "Bu düğme bu cihazdan dosya yükler. Dosyaları pencereye sürükleyip bırakmak da çalışır.",
  "tour.step.search.title": "Arama",
  "tour.step.search.desc": 'Bu alan deponun tamamında ada göre arar; ayraçları ve bir harflik yazım hatasını affeder, yani "fatura 2026" yazdığınızda fatura_2026.pdf gelir. tag:fatura yazarak etikete göre filtreleyebilirsiniz. Yanındaki sürgü düğmesi gelişmiş aramayı, {palette} ise komut paletini açar; palet komut da çalıştırır.',
  "tour.step.crumb.title": "Bulunduğunuz yer",
  "tour.step.crumb.desc": "Bu iz, ekrandaki klasörün adresidir. Adımlardan birine tıklayarak üste çıkabilir, sonuncusunun yanındaki oktan içindeki klasörleri görebilirsiniz.",
  "tour.step.filters.title": "Listeyi daralt",
  "tour.step.filters.desc": "Tür, Sahibi, Değiştirilme ve Boyut bulunduğunuz klasörü filtreler; yanındaki kutu siz yazdıkça adlara göre eşleşir, satırın sonundaki denetim ise sıralar.",
  "tour.step.view.title": "Görünümü değiştir",
  "tour.step.view.desc": "Bu klasörün nasıl çizildiğini değiştirir; seçiminiz hatırlanır.",
  "tour.step.details.title": "Ayrıntılar ve paylaşım",
  "tour.step.details.desc": 'Bir dosyayı seçip bu paneli açtığınızda ayrıntılarını, hareketlerini ve paylaşım bağlantılarını görürsünüz. Tam menü için dosyaya sağ tıklayın ya da satırının sonundaki düğmeyi kullanın: oradaki "Paylaş" ile PIN ve son kullanma süresi verilebilen bir bağlantı oluşturulur.',
  "tour.step.help.title": "Kısayollar",
  "tour.step.help.desc": '{help} tuşu kısayol kartını, {palette} komut paletini açar. Tema ve "Turu tekrar başlat" sağ üstteki "Diğer işlemler" menüsünde; hesabınız ve oturumu kapatma ise yanındaki avatarın arkasında.',
  "error.hint": "Bağlantı ya da sunucu kaynaklı geçici bir sorun olabilir. Yeniden deneyin.",
  "error.details": "Teknik ayrıntılar",
  "col.star": "Yıldız",
  "toolbar.view_label": "Görünüm",
  "list.aria": "Dosya listesi",
  "grid.aria": "Dosya ızgarası",
  /* === wiring:d1 - sekmeler + split panel === */
  "tabs.strip": "Sekmeler",
  "tabs.new": "Yeni sekme",
  "tabs.close": "Sekmeyi kapat",
  "tabs.split": "Görünümü böl",
  "tabs.split_off": "Bölmeyi kapat",
  "ctx.open_new_tab": "Yeni sekmede aç",
  "ctx.open_with": "{app} ile aç",
  "ctx.open_with_builtin": "Yerleşik görüntüleyiciyle aç",
  "ctx.open_with_choose": "Uygulama seç…",
  "openWith.title": "Birlikte aç",
  "openWith.lead": "{name} hangi uygulamayla açılsın?",
  "openWith.builtin": "filex görüntüleyicisi (yerleşik)",
  "openWith.onlyoffice": "ONLYOFFICE (tablo düzenleyici)",
  "openWith.now": "Şu an bununla açılıyor",
  "openWith.always": "{ext} dosyalarını her zaman bu uygulamayla aç",
  "openWith.hint": "Hesabınızda saklanır. Ayarlar, Varsayılan uygulamalar bölümünden değiştirebilirsiniz.",
  "openWith.open": "Aç",
  "shortcuts.group.tabs": "Sekmeler",
  "shortcuts.tab_new": "Yeni sekme",
  "shortcuts.tab_close": "Sekmeyi kapat",
  "shortcuts.tab_next": "Sonraki sekme",
  "shortcuts.tab_prev": "Önceki sekme",
  /* tus:t1 - menü fiilleri */
  "shortcuts.new_folder": "Yeni klasör",
  "shortcuts.upload": "Dosya yükle",
  "shortcuts.refresh": "Listeyi yenile",
  "shortcuts.download": "İndir",
  "shortcuts.preview": "Önizle",
  "shortcuts.share": "Paylaş",
  "shortcuts.tags": "Etiketler",
  "shortcuts.open_tab": "Yeni sekmede aç",
  "shortcuts.copy_path": "Yolu kopyala",
  "shortcuts.copy_id": "Kimliği kopyala",
  "shortcuts.restore": "Çöp kutusundan geri al",
  "shortcuts.settings.reserved": "tarayıcı tarafından sayfaya ulaşmadan yakalanıyor, burada hiçbir şey yapmaz. Başka bir tuş seçin.",
  "shortcuts.settings.reserved_badge": "Yalnız masaüstü uygulamasında",
  "shortcuts.settings.reserved_title": "Bu kombinasyonu tarayıcının kendisi işliyor. Masaüstü uygulamasında ve kurulu PWA’da çalışır, tarayıcı sekmesinde çalışmaz.",
  "cmd.tab_new": "Yeni sekme aç",
  "cmd.split_toggle": "Görünümü böl / birleştir",
  "split.pane": "İkincil panel",
  "split.close": "Yan paneli kapat",
  "split.error": "Liste yüklenemedi",
  "split.retry": "Yeniden dene",
  "split.copy_queued": "Kopyalama kuyruğa alındı",
  "split.move_queued": "Taşıma kuyruğa alındı",
  "toast.move_kept_both": "Taşıma kuyruğa alındı. Hedefte aynı adla bir öğe vardı, taşınan öğe onun yanına “-copy” ekiyle konacak. Bu taşıma geri alınamaz.",
  "split.cross_copy": "Depolar farklı - kopyalama kuyruğa alındı",
  "dragout.downloading": "Bırakılan klasöre indiriliyor…",
  "dragout.downloading_n": "Bırakılan klasöre indiriliyor - şimdiye dek {n} dosya…",
  "dragout.downloading_n_one": "Bırakılan klasöre indiriliyor - şimdiye dek {n} dosya…",
  "dragout.stop": "Durdur",
  "dragout.stopping": "Durduruluyor…",
  "dragout.stopped": "Durduruldu - gelenler klasörde kalıyor",
  "dragout.not_found": "Bırakılan yer bulunamadı - dosya bir klasöre değil bir uygulamaya bırakıldıysa indirme yapılamaz",
  "dragout.done": "İndirme tamamlandı",
  "dragout.ready": "Dosyalar hazır - masaüstüne sürükleyebilirsiniz",
  "dragout.preparing": "Sürükleme için hazırlanıyor…",
  "split.cross_move": "Depolar farklı - taşıma kuyruğa alındı (baytlar aktarılıp kaynak silinir)",
  /* === /wiring:d1 === */
  /* wiring:d2 - galeri görünümü */
  "toolbar.view.gallery": "Galeri",
  "gallery.aria": "Dosya galerisi",
  /* /wiring:d2 */
  /* wiring:d3 - Yorumlar (inspector node comments) */
  "inspector.section.comments": "Yorumlar",
  "inspector.comments.empty": "Henüz yorum yok.",
  "inspector.comments.placeholder": "Yorum yaz…",
  "inspector.comments.send": "Gönder",
  "inspector.comments.delete": "Yorumu sil",
  /* wiring:e2 - uçtan uca şifreli klasörler */
  "e2e.create.title": "Şifreli klasör oluştur",
  "e2e.create.option": "Şifreli klasör oluştur…",
  "e2e.create.pw_label": "Klasör parolası",
  "e2e.create.pw_placeholder": "En az 8 karakter",
  "e2e.create.pw2_label": "Parolayı tekrar girin",
  "e2e.create.warn_title": "GERİ DÖNÜŞÜ YOK",
  "e2e.create.warn_body": "Bu klasördeki dosyalar yalnız bu parolayla ya da klasör oluşturulurken bir kez gösterilen kurtarma anahtarıyla açılır. Parola sunucuda TUTULMAZ; kurtarma anahtarının da filex'te kopyası kalmaz. İkisini de kaybederseniz içerik sonsuza dek gider.",
  "e2e.create.ack": "Anladım: parolayı da kurtarma anahtarını da kaybedersem verilerim kurtarılamaz.",
  "e2e.create.ack_required": "Devam etmek için uyarıyı onaylayın.",
  "e2e.create.pw_short": "Parola en az 8 karakter olmalı.",
  "e2e.create.pw_mismatch": "Parolalar birbirini tutmuyor.",
  "e2e.create.bad_name": "Geçersiz klasör adı.",
  "e2e.create.create": "Şifreli klasörü oluştur",
  "e2e.create.busy": "Oluşturuluyor…",
  "e2e.create.done": "Şifreli klasör oluşturuldu",
  "e2e.create.failed": "Şifreli klasör oluşturulamadı",
  "e2e.create.nested": "Şifreli klasörün içine ikinci bir şifreli klasör açılamaz.",
  /* wiring:e2 policy - bir yöneticiden şifreleme izni istemek. */
  "e2e.request.ctx": "Şifreleme iste…",
  "e2e.request.option": "Şifreli klasör iste…",
  "e2e.request.title": "“{name}” için şifreleme iste",
  "e2e.request.lead": "Burada şifreli klasör oluşturmak için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu klasör içindir: hemen içinde yeni bir şifreli klasör oluşturmak için bir kez kullanılabilir.",
  "e2e.request.lead_folder": "Bu klasörü şifrelemek için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu klasör içindir: bu klasörü olduğu yerde şifrelemek için bir kez kullanılabilir, içindeki bir klasör için kullanılamaz.",
  "e2e.request.lead_file": "Bu dosyayı şifrelemek için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu dosyanın bulunduğu klasör içindir: orada yeni bir şifreli dosya için bir kez kullanılabilir.",
  "e2e.request.reason": "Gerekçe",
  "e2e.request.reason_placeholder": "İçinde ne var, neden şifrelenmesi gerekiyor",
  "e2e.request.reason_required": "Yönetici için bir gerekçe yazın.",
  "e2e.request.send": "İsteği gönder",
  "e2e.request.sending": "Gönderiliyor…",
  "e2e.request.sent": "İstek gönderildi. Bir yönetici yanıtladığında size bildirilecek.",
  "e2e.request.already": "Bunu zaten istediniz; bir yöneticinin yanıtını bekliyor.",
  "e2e.request.failed": "İstek gönderilemedi.",
  "e2e.locked.title": "Bu klasör uçtan uca şifreli",
  "e2e.locked.hint": "İçeriği görmek için klasör parolasını girin. Parola yalnız bu sekmede, bellekte tutulur.",
  "e2e.locked.pw_placeholder": "Klasör parolası",
  "e2e.locked.unlock": "Kilidi aç",
  "e2e.locked.busy": "Doğrulanıyor…",
  "e2e.unlock.wrong": "Parola yanlış.",
  "e2e.unlock.damaged": "Parola doğru ama anahtar dosyasındaki (.filex-e2e.json) klasör anahtarı açılmıyor: dosya bozulmuş. Kurtarma anahtarını deneyin.",
  "e2e.unlock.marker_missing": "Anahtar dosyası (.filex-e2e.json) okunamadı.",
  /* ikon:emoji - listedeki işaretin erişilebilir adı. Satır eskiden yalnız
     bir 🔒 basıyordu; onun yerini alan asma kilit kutunun içinde
     aria-hidden, dolayısıyla adı taşıyan yer bu. */
  "e2e.badge": "Şifreli klasör",
  "e2e.strip.label": "Şifreli klasör - kilit açık",
  "e2e.strip.lock": "Kilitle",
  /* wiring:e2 password - klasör parolasını değiştirme */
  "e2e.password.strip_action": "Parolayı değiştir…",
  "e2e.password.title": "Klasör parolasını değiştir",
  "e2e.password.reset_title": "Bu klasör için yeni bir parola belirleyin",
  "e2e.password.reset_lead": "Bu klasörü kurtarma anahtarıyla açtınız; parolası kaybolmuş ya da başkası tarafından biliniyor olabilir. Şimdi yeni bir parola belirleyin. Bu pencereyi kapatmak klasörü yeniden kilitler.",
  "e2e.password.current": "Mevcut parola",
  "e2e.password.recovery": "Kurtarma anahtarı",
  "e2e.password.use_recovery": "Hatırlamıyorum - kurtarma anahtarını kullan",
  "e2e.password.use_current": "Bunun yerine mevcut parolayı kullan",
  "e2e.password.new": "Yeni parola",
  "e2e.password.current_required": "Mevcut parolayı girin ya da kurtarma anahtarını kullanın.",
  "e2e.password.bad_recovery": "Bu bir kurtarma anahtarı değil (dörderli gruplar hâlinde 32 karakter).",
  "e2e.password.same": "Yeni parola mevcut parolayla aynı.",
  "e2e.password.cheap_note": "Yalnız klasörün anahtar dosyası değişir. Hiçbir dosya yeniden şifrelenmez; kurtarma anahtarı ve varsa emanet anahtarı çalışmaya devam eder.",
  "e2e.password.old_copies": "Eski parolayı bilen ve anahtar dosyasının eski bir kopyasına (bir sürüm, bir yedek) sahip olan biri klasörü onunla hâlâ açabilir. Bu bir risk ise “Klasör anahtarını da değiştir”i işaretleyin.",
  "e2e.password.rotate_label": "Klasör anahtarını da değiştir (her dosyanın anahtarı yeniden sarılır; eski parola başkasınca biliniyor olabilirse kullanın)",
  "e2e.password.rekey_title": "Bu klasör v0.31 öncesinden: anahtarı parolasından türetiliyor",
  "e2e.password.rekey_body": "Bu yüzden yeni bir parola yeni bir klasör anahtarı gerektirir ve klasördeki her dosyanın anahtarı onunla yeniden sarılır. İçerik yeniden şifrelenmez. Biraz sürebilir; yarıda kalırsa kaldığı yerden devam eder, dosyalar bu sırada da açılır.",
  "e2e.password.rotate_title": "Klasör anahtarı da değişir",
  "e2e.password.rotate_body": "Her dosyanın anahtarı yeni bir klasör anahtarıyla yeniden sarılır. İçerik yeniden şifrelenmez. Yarıda kalırsa kaldığı yerden devam eder; dosyalar bu sırada da açılır.",
  "e2e.password.rekey_rk_new": "Yeni bir kurtarma anahtarı alırsınız, bir kez gösterilir; eskisi artık çalışmaz.",
  "e2e.password.rekey_rk_kept": "Kullandığınız kurtarma anahtarı çalışmaya devam eder.",
  "e2e.password.rekey_escrow": "İşletmecinin emanet anahtarı çalışmaya devam eder: yuvası yeni klasör anahtarına mühürlenir.",
  "e2e.password.rekey_ack": "Anlıyorum: bu, klasördeki her dosyanın anahtarını yeniden sarar.",
  "e2e.password.submit": "Parolayı değiştir",
  "e2e.password.busy": "Değiştiriliyor…",
  "e2e.password.lock_instead": "Bunun yerine klasörü kilitle",
  "e2e.password.wrong_current": "Parola yanlış.",
  "e2e.password.wrong_recovery": "Kurtarma anahtarı yanlış.",
  "e2e.password.escrow_blocked": "Bu klasörün, bu kurulumda bulunmayan bir anahtar için emanet yuvası var; klasör anahtarını değiştirmek onu kaybettirir. Hiçbir şey değiştirilmedi.",
  "e2e.password.failed": "Parola değiştirilemedi. Hiçbir şey değiştirilmedi.",
  "e2e.password.done": "Parola değişti. Eski parola bu klasörü artık açmıyor.",
  "e2e.password.resume_title": "Dosya anahtarları hâlâ yeniden sarılıyor",
  "e2e.password.resume_body": "Parola değişti ve yeni bir klasör anahtarı verildi. Bazı dosyaların anahtarı hâlâ öncekinin altında; her iki durumda da açılırlar. Bitirmek için devam edin.",
  "e2e.password.progress": "Şu ana kadar {n} dosya yeniden sarıldı · {failed} başarısız",
  "e2e.password.progress_one": "Şu ana kadar {n} dosya yeniden sarıldı · {failed} başarısız",
  "e2e.password.rekey_partial": "{n} dosya yeniden sarılamadı. Önceki anahtarla hâlâ açılıyorlar; yeniden denemek için devam edin.",
  "e2e.password.rekey_partial_one": "{n} dosya yeniden sarılamadı. Önceki anahtarla hâlâ açılıyor; yeniden denemek için devam edin.",
  "e2e.password.rekey_done": "Yeni klasör anahtarı yerinde ({n} dosya yeniden sarıldı). Eski parola burada artık hiçbir şey açmıyor.",
  "e2e.password.rekey_done_one": "Yeni klasör anahtarı yerinde ({n} dosya yeniden sarıldı). Eski parola burada artık hiçbir şey açmıyor.",
  "e2e.recovery.lead_replaced": "Klasörün yeni bir anahtarı var, bu yüzden yeni bir kurtarma anahtarı da var - eskisi artık açmıyor. Bir kez gösterilir; filex kopyasını tutmaz.",
  /* wiring:e2 names - şifreli dosya ve klasör adları */
  "e2e.unlock.unsupported": "Bu klasör daha yeni bir filex istiyor: bu sürümün tanımadığı bir özellik kullanıyor ({features}). Hiçbir şey değiştirilmedi.",
  "e2e.settings.open": "Şifreleme ayarları…",
  "e2e.settings.title": "Şifreleme ayarları",
  "e2e.settings.level": "Şifreleme seviyesi",
  "e2e.settings.password": "Parola",
  "e2e.settings.escrow": "Emanet anahtarı",
  "e2e.settings.close": "Kapat",
  "e2e.level.content": "Yalnız içerik",
  "e2e.level.names": "İçerik ve adlar",
  "e2e.level.content_hint": "Dosya içerikleri şifrelenir. Dosya ve klasör adları sunucuya açık kalır; böylece WebDAV, komut satırı ve masaüstü senkronu adlarla çalışmayı sürdürür ve 0.31'den beri her filex klasörü açar.",
  "e2e.level.names_hint": "İçerik de dosya ve klasör adları da şifrelenir: sunucu yalnız karıştırılmış adlar görür. WebDAV, komut satırı ve masaüstü senkronu da adları karıştırılmış görür; filex 0.47 ve öncesi klasörü açmaz.",
  "e2e.level.pending": "seviye değişikliği bitmedi",
  "e2e.level.change": "Seviyeyi değiştir…",
  "e2e.level.raise_title": "Bu klasör “İçerik ve adlar” seviyesine geçsin mi?",
  "e2e.level.raise_body": "filex buradaki her dosya ve klasöre bu tarayıcıda şifreli bir ad verir. İçeriğe dokunulmaz; yarıda kalırsa kaldığı yerden devam eder. filex açık adlara geri dönüş yolu sunmaz.",
  "e2e.level.raise_ack": "Neyin değiştiğini anladım",
  "e2e.level.raise_go": "Adları şifrele",
  /* wiring:e2 vault - 3. seviye, kasa (docs/E2E-VAULT-FORMAT.md) */
  "e2e.level.vault": "Kasa",
  "e2e.level.vault_hint": "İçerik, adlar ve bütün ağaç şifrelenir: sunucu yalnız aynı boyda paketler tutar; kaç dosya olduğunu, adlarını, boyutlarını ve tarihlerini görmez.",
  "e2e.level.vault_cost": "Bedeli: aynı anda yalnız bir kişi yazar ve kasayı yalnız filex açar (web, masaüstü, filex decrypt ve filex vault mount). WebDAV, klasör eşitleme, paylaşım bağlantıları ve sunucudaki önizlemeler içine ulaşmaz.",
  "e2e.vault.pack_label": "Paket boyutu",
  "e2e.vault.pack_4": "4 MiB",
  "e2e.vault.pack_4_help": "Varsayılan. En küçük değişiklik 4 MiB yükler.",
  "e2e.vault.pack_16": "16 MiB",
  "e2e.vault.pack_16_help": "Sunucuda daha az ve daha büyük dosya. Her değişiklik en az 16 MiB yükler.",
  "e2e.vault.pack_hint": "Yalnız şimdi seçilir, sonra değişmez. Sunucudaki her paket bu boydadır; kullanılmayan yeri rastgele baytlarla doldurulur.",
  "e2e.vault.read_only": "Salt okunur. Bir yükleme, yeni bir klasör ya da başka bir değişiklik, kimse tutmuyorsa yazma kilidini alır.",
  "e2e.vault.writing": "Bu kasaya şu an siz yazıyorsunuz. {left} boyunca hiçbir şey yapmazsanız salt okunura döner.",
  "e2e.vault.lock_countdown": "{left} boyunca içinde hiçbir şey yapılmazsa kasa kilitlenir ve parolayı yeniden sorar.",
  "e2e.vault.held_by": "{name} {since} tarihinden beri yazıyor. Kasa sizin için salt okunur.",
  "e2e.vault.someone": "Biri",
  "e2e.vault.take_over": "Devral",
  "e2e.vault.lost_idle": "{n} dakika boyunca hiçbir şey yapmadığınız için kasa salt okunura döndü. Hiçbir şey kaybolmadı.",
  "e2e.vault.lost_idle_one": "{n} dakika boyunca hiçbir şey yapmadığınız için kasa salt okunura döndü. Hiçbir şey kaybolmadı.",
  "e2e.vault.lost_taken": "Yazmayı başka biri devraldı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_taken_by": "{name} yazmayı devraldı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_broken_by": "{name} yazma kilidinizi kaldırdı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_connection": "Bağlantı koptuğu için kasa salt okunura döndü.",
  "e2e.vault.lost_expired": "Yazma kilidinin süresi dolduğu için kasa salt okunura döndü.",
  "e2e.vault.unsaved": "Kaydedilmedi: {names}. Kasa boşalınca yeniden yapın.",
  "e2e.vault.saving": "Kaydediliyor…",
  "e2e.vault.saving_progress": "Kaydediliyor: {total} içinden {done}",
  "e2e.vault.dismiss": "Tamam",
  "e2e.vault.continue": "Bu durumdan devam et",
  "e2e.vault.ro_damaged": "Bu kasanın en yeni durumu bozuk. {when} tarihli durumu görüyorsunuz, salt okunur.",
  "e2e.vault.ro_damaged_short": "Bu kasanın en yeni durumu bozuk. Daha eski bir durumu görüyorsunuz, salt okunur.",
  "e2e.vault.ro_rollback": "Sunucu bu kasanın, bu sekmenin daha önce gördüğünden eski bir durumunu sunuyor. Kasa burada salt okunur kalır.",
  "e2e.vault.ro_newer": "Bu kasayı daha yeni bir filex yazmış. Bu sürüm onu okur ama değiştirmez.",
  "e2e.vault.unreadable": "Bu kasanın hiçbir durumu okunamıyor: hiçbir şey gösterilemez ve hiçbir şey yazılmaz.",
  "e2e.vault.limit_warn": "Bu kasa en fazla {max} dosya ve klasör tutabilir; şu an {held} tane tutuyor.",
  "e2e.vault.cross": "Sunucuda kasa ile dışındaki klasörler arasında hiçbir şey taşınmaz: birinden indirin, sonra ötekine yükleyin.",
  "e2e.vault.dl_too_big": "Bu tarayıcı bu kadar büyük bir dosyayı bellekten kaydedemez. Doğrudan diske kaydeden bir tarayıcı (Chrome, Edge) ya da filex decrypt kullanın.",
  "e2e.vault.damaged_file": "Bu dosya kasada bozuk ve okunamadı.",
  "e2e.vault.level_fixed": "Kasa kasa olarak kalır: seviyesi değişmez, anahtarı yenilenmez. Yeni bir anahtarla baştan başlamak için yeni bir kasa oluşturup dosyaları içine taşıyın.",
  "e2e.vault.locked_idle_toast": "“{name}” içinde 15 dakika hiçbir şey yapılmadığı için kasa kendini kilitledi. Yeniden açmak için parolayı girin.",
  "e2e.vault.open_failed": "Kasa açılamadı.",
  "e2e.vault.err.parent_missing": "İçine gideceği klasör artık yok.",
  "e2e.vault.err.parent_not_folder": "“{name}” bir klasör değil, bir dosya.",
  "e2e.vault.err.name_taken": "Orada “{name}” adı zaten var.",
  "e2e.vault.err.bad_name": "“{name}” kasada ad olamaz: 1 ile 255 bayt arası olmalı, eğik çizgi ya da denetim karakteri içermemeli, . ya da .. olmamalı.",
  "e2e.vault.err.too_deep": "Kasada klasörler en fazla 256 düzey iç içe olabilir.",
  "e2e.vault.err.not_found": "“{name}” artık kasada yok.",
  "e2e.vault.err.is_folder": "“{name}” bir klasör.",
  "e2e.vault.err.into_itself": "Bir klasör kendi içine taşınamaz.",
  "e2e.vault.err.too_many_entries": "Bu kasa dolu: en fazla 250 000 dosya ve klasör tutar. Hiçbir şey değiştirilmedi.",
  "e2e.vault.err.index_too_large": "Bu kasanın dizini sınırına ulaştı. Hiçbir şey değiştirilmedi.",
  "e2e.vault.err.newer_format": "Bu kasayı daha yeni bir filex yazmış. Bu sürüm onu okur ama değiştirmez.",
  "e2e.vault.err.size_mismatch": "Bir dosya yüklenirken değişti. Yeniden yükleyin.",
  "e2e.vault.err.changed": "“{name}” açıldığından beri kasada değişti, bu yüzden üzerine kaydedilmedi. Yeni sürümü görmek için yeniden açın.",
  "e2e.vault.err.failed": "Değişiklik kaydedilemedi.",
  "userSettings.vault.idle": "Kasa: salt okunura dönme süresi",
  "userSettings.vault.idle_help": "Yazdığınız bir kasada hiçbir şey yapmadığınızda kasanın ne kadar süre sizde kalacağı. Sonra başkaları yazabilir; kasanız salt okunura döner ve 15 dakika sonra kilitlenir.",
  "userSettings.vault.minutes": "{n} dakika",
  "userSettings.vault.minutes_one": "{n} dakika",
  "userSettings.vault.saved": "Kaydedildi",
  "userSettings.vault.failed": "Kasa ayarı kaydedilemedi.",
  "e2e.names.move_unreadable": "Taşınmadı: öğelerden birinin adı okunamıyor.",
  "e2e.names.move_taken": "Taşınmadı: o klasörde “{name}” adı zaten var. Önce ikisinden birinin adını değiştirin.",
  "e2e.convert.ctx": "E2EE ile şifrele…",
  "e2e.convert.title": "“{name}” klasörünü şifrele",
  "e2e.convert.lead": "Bu klasördeki her dosya bulunduğu yerde, bu tarayıcıda, aşağıdaki parolayla şifrelenir. Hiçbir şey yer değiştirmez; 1. seviyede adlar olduğu gibi kalır. Yarıda kalırsa klasörü yeniden açınca devam eder.",
  "e2e.convert.past_title": "Sunucuda zaten olanlar",
  "e2e.convert.past_body": "Şifreleme bu dosyaları bundan sonrası için korur. Şimdiye kadar sunucu onları açık hâlde tuttu ve bazı kopyalar kalır: filex küçük resimlerini ve arama için çıkardığı metni siler; bu klasörün eski sürümlerini ve çöp kutusundaki kayıtlarını da silebilir.",
  "e2e.convert.drop_versions": "Bu dosyaların eski sürümlerini sil (şifresizdirler)",
  "e2e.convert.drop_trash": "Bu klasörden çöp kutusuna gidenleri sil",
  "e2e.convert.past_outside": "Yedekler, kopya sunucular ve birinin önceden aldığı kopyalar filex'in dışındadır ve olduğu gibi kalır.",
  "e2e.convert.submit": "Klasörü şifrele",
  "e2e.convert.nested": "Bu klasörün içinde şifreli bir klasör var. Şifreli klasörler iç içe olamaz; hiçbir şey değiştirilmedi.",
  "e2e.convert.failed": "Klasör şifrelenemedi. Şifrelenmiş dosyalar öyle kalır; devam etmek için klasörü açın.",
  "e2e.convert.stopped": "{n} dosyadan sonra durduruldu. Klasörün üstündeki şeritten devam edebilirsiniz.",
  "e2e.convert.stopped_one": "{n} dosyadan sonra durduruldu. Klasörün üstündeki şeritten devam edebilirsiniz.",
  "e2e.convert.partial": "{n} dosya şifrelenemedi (bu arada değişti, çok büyük ya da yazılamıyor). Hâlâ şifresizler; devam etmek için yeniden deneyin.",
  "e2e.convert.partial_one": "{n} dosya şifrelenemedi (bu arada değişti, çok büyük ya da yazılamıyor). Hâlâ şifresiz; devam etmek için yeniden deneyin.",
  "e2e.convert.too_large_here": "{n} dosya bu tarayıcının tek parçada gönderebileceğinden büyük ve bu sunucu parça parça yükleme almıyor; bu yüzden yerlerinde şifrelenemediler. Hâlâ şifresizler ve onlar şifrelenene kadar klasörün şifrelenmesi tamamlanmış sayılmaz.",
  "e2e.convert.too_large_here_one": "{n} dosya bu tarayıcının tek parçada gönderebileceğinden büyük ve bu sunucu parça parça yükleme almıyor; bu yüzden yerinde şifrelenemedi. Hâlâ şifresiz ve o şifrelenene kadar klasörün şifrelenmesi tamamlanmış sayılmaz.",
  "e2e.convert.large_progress": "“{name}” şifreleniyor: %{percent}",
  "e2e.convert.busy": "Klasör şifreleniyor…",
  "e2e.convert.resume_title": "Bu klasörü şifrelemeyi bitirin",
  "e2e.convert.resume_body": "Bu klasörü şifreleme işi başladı ama bitmedi. Henüz ulaşılmayan dosyalar sunucuda hâlâ şifresiz. Devam ederseniz kaldığı yerden sürer.",
  "e2e.convert.progress": "{total} dosyanın {n} tanesi şifrelendi · {failed} dosya kaldı",
  "e2e.convert.progress_one": "{total} dosyanın {n} tanesi şifrelendi · {failed} dosya kaldı",
  "e2e.convert.done": "Klasör şifrelendi ({n} dosya). Silinen eski sürüm: {versions}; silinen çöp kaydı: {trash}.",
  "e2e.convert.done_one": "Klasör şifrelendi ({n} dosya). Silinen eski sürüm: {versions}; silinen çöp kaydı: {trash}.",
  "e2e.convert.cleanup_failed": "Klasör şifrelendi ama eski sürümleri ve çöp kayıtları silinemedi - bunu yalnız klasörün sahibi ya da bir yönetici yapabilir.",
  "e2e.names.locked_item": "🔒 Şifreli öğe",
  "e2e.names.unreadable_item": "🔒 Adı okunamıyor",
  "e2e.names.key_failed": "Anahtar dosyası bu klasördeki adların şifreli olduğunu söylüyor ama ad anahtarı bu anahtarla açılmıyor. Hiçbir şey değiştirilmedi.",
  "e2e.names.write_failed": "Uzun bir adın ad dosyası yazılamadı, bu yüzden hiçbir şey yüklenmedi.",
  "e2e.names.bad_name": "“{name}” şifreli klasörde kullanılamaz: ad 1-255 bayt olmalı; bölü, ters bölü ya da kontrol karakteri içeremez.",
  "e2e.names.offer_cost": "Ne değişir: WebDAV, komut satırı ve masaüstü senkronu adları karıştırılmış görür; filex 0.47 ve öncesi bu klasörü açmayı reddeder. Sunucu kaç öğe olduğunu ve boyutlarını hâlâ görür.",
  "e2e.names.resume_title": "Adları şifrelemeyi bitirin",
  "e2e.names.resume_body": "Bu klasördeki adları şifreleme işi başladı ama bitmedi. Henüz ulaşılmayan öğelerin adları hâlâ açık. Devam ederseniz kaldığı yerden sürer.",
  "e2e.names.resume": "Devam et",
  "e2e.names.stop": "Durdur",
  "e2e.names.busy": "Adlar şifreleniyor…",
  "e2e.names.progress": "Şu ana kadar {n} ad şifrelendi · {failed} öğe yeniden adlandırılamadı",
  "e2e.names.progress_one": "Şu ana kadar {n} ad şifrelendi · {failed} öğe yeniden adlandırılamadı",
  "e2e.names.done": "Adlar şifrelendi ({n} öğe yeniden adlandırıldı). Sunucu artık adları göremiyor.",
  "e2e.names.done_one": "Adlar şifrelendi ({n} öğe yeniden adlandırıldı). Sunucu artık adları göremiyor.",
  "e2e.names.stopped": "{n} addan sonra durduruldu. Kalanlar siz devam edene kadar açık adlarını korur.",
  "e2e.names.stopped_one": "{n} addan sonra durduruldu. Kalanlar siz devam edene kadar açık adlarını korur.",
  "e2e.names.partial": "{n} öğe yeniden adlandırılamadı (izin yok ya da ad bir diskte tutulamıyor). Adları açık kalıyor; devam etmek için yeniden deneyin.",
  "e2e.names.partial_one": "{n} öğe yeniden adlandırılamadı (izin yok ya da ad bir diskte tutulamıyor). Adı açık kalıyor; devam etmek için yeniden deneyin.",
  "e2e.names.failed": "Adlar şifrelenemedi. Zaten yeniden adlandırılanlar kaybolmaz; devam etmek için yeniden deneyin.",
  "e2e.names.strip_fix": "{n} adı düzelt (açık kalmış ya da filex dışından taşınmış)",
  "e2e.names.strip_fix_one": "{n} adı düzelt (açık kalmış ya da filex dışından taşınmış)",
  "e2e.create.names_root_hint": "Klasörün kendi adı her durumda açık kalır - şifresiz bir klasörün içinde durur. Hiçbir şey ele vermeyen bir ad seçin.",
  "e2e.locked_toast": "Klasör kilitlendi",
  "e2e.app_closed_unsaved": "“{name}” dosyasında kaydedilmemiş değişiklikler kayboldu: klasör kilitlenince uygulama kapandı.",
  "e2e.upload.locked": "Önce klasörün kilidini açın",
  "e2e.decrypting": "Çözülüyor…",
  "e2e.decrypt_failed": "Dosya çözülemedi (parola değişmiş ya da dosya bozulmuş olabilir).",
  /* wiring:e2 recovery - kurtarma anahtarı + yönetici escrow'u */
  "e2e.create.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.create.escrow_body": "Bu kurulumda anahtar emaneti (escrow) açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir. Escrow sunucu kurulurken sabitlenir; bir klasör için kapatılamaz.",
  "e2e.locked.use_recovery": "Parolayı mı kaybettiniz? Kurtarma anahtarı kullanın",
  "e2e.recovery.title": "Kurtarma anahtarınızı saklayın",
  "e2e.recovery.title_upgraded": "Kurtarma anahtarınız",
  "e2e.recovery.lead": "Bu anahtar klasörü parolasız açar. Yalnız bir kez gösterilir - filex bu anahtarı saklamaz ve bir daha gösteremez.",
  "e2e.recovery.lead_upgraded": "Bu klasörün artık bir kurtarma anahtarı var. Klasörü parolasız açar, yalnız bir kez gösterilir ve filex'te kopyası kalmaz.",
  "e2e.recovery.copy": "Kopyala",
  "e2e.recovery.copied": "Kopyalandı",
  "e2e.recovery.download": "Dosya olarak indir",
  "e2e.recovery.warn_title": "BUNU PAROLA GİBİ SAKLAYIN",
  "e2e.recovery.warn_body": "Bu anahtarı eline geçiren herkes klasörü okuyabilir. Parolanızdan ayrı bir yerde tutun - parolanın yanında duran bir anahtar sizi unutmaya karşı korur, başkasına karşı değil.",
  "e2e.recovery.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.recovery.escrow_body": "Bu kurulumda anahtar emaneti açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir.",
  "e2e.recovery.escrow_kid": "Emanet anahtarı",
  "e2e.recovery.ack": "Bu anahtarı güvenli bir yere kaydettim.",
  "e2e.recovery.done": "Tamam",
  "e2e.recover.title": "Parolasız kilit açma",
  "e2e.recover.none": "Bu klasör kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden anahtarı yok. Tek giriş yolu parolası. Bir kez parolayla açın, filex kurtarma anahtarı eklemeyi önerecek.",
  "e2e.recover.tab_recovery": "Kurtarma anahtarı",
  "e2e.recover.tab_escrow": "Emanet anahtarı",
  "e2e.recover.recovery_hint": "Klasör oluşturulurken bir kez gösterilen anahtar.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "Klasörün sahibine haber gidecek",
  "e2e.recover.escrow_warn_body": "Emanet anahtarıyla açılan klasörün sahibine bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.recover.escrow_kid": "Emanet anahtarı",
  "e2e.recover.escrow_predates": "Bu kurulumun emanet anahtarı var ama bu klasörün yok. Klasör, emanet burada açılmadan önce oluşturulmuş; ana anahtarı emanet kimliğine hiç sarmalanmadı. Emanet anahtarı bu klasörü açmaz. İşletmecinin yapabileceği hiçbir şey bunu değiştirmez - sarmalama için klasörün parolası gerekir ve sunucu onu hiçbir zaman görmedi. Klasörün sahibi verebilir: parolayla kilidi açıp işletmeciye anahtar vermeyi seçebilir. O yapılana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.escrow_other_key": "Bu klasör BAŞKA bir kurulumun emanet anahtarını taşıyor. Başka yerde oluşturulup buraya geri yüklenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz. Yalnızca sarmalandığı emanet anahtarının özel yarısı açabilir.",
  "e2e.recover.escrow_placeholder": "Emanet özel anahtarını yapıştırın (PKCS#8, base64 ya da PEM)",
  "e2e.recover.bad_format": "Bu bir kurtarma anahtarına benzemiyor. Dörtlü sekiz grup, toplam 32 karakter olmalı.",
  "e2e.recover.escrow_required": "Emanet özel anahtarını yapıştırın.",
  "e2e.recover.wrong_recovery": "Bu kurtarma anahtarı bu klasörü açmıyor.",
  "e2e.recover.wrong_escrow": "Bu emanet anahtarı bu klasörü açmıyor. Emanet açılmadan önce oluşturulmuş bir klasörün, sahibi izin verene kadar emanet anahtarı yoktur - o zamana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.bad_escrow_key": "Bu okunabilir bir özel anahtar değil (PKCS#8, base64 ya da PEM bekleniyor).",
  "e2e.recover.notify_failed": "Klasör sahibine bildirim gönderilemedi, bu yüzden kilit açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.recover.recovery_done": "Kurtarma anahtarıyla açıldı",
  "e2e.recover.escrow_done": "Emanet anahtarıyla açıldı - klasör sahibine bildirildi",
  "e2e.recover.unlock": "Kilidi aç",
  "e2e.recover.busy": "Açılıyor…",
  "e2e.escrowoffer.title": "İşletmeciye bu klasörün anahtarı verilsin mi?",
  "e2e.escrowoffer.body": "Bu klasör, burada anahtar emaneti açılmadan önce oluşturulmuş; bu yüzden kurulumun işletmecisi onu açamıyor. Şu anda - parolanız bellekteyken - filex bu klasörü emanet anahtarına sarmalayabilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz; yalnızca anahtar dosyası değişir.",
  "e2e.escrowoffer.consequence": "Bunun anlamı: işletmeci, parolanız olmadan bu klasöre giren ikinci ve kalıcı bir yol kazanır. O anahtar kullanıldığında size bildirim gelir, ama bu bildirim bir denetim değil yalnızca bir duyurudur.",
  "e2e.escrowoffer.learn_more": "Emanet anahtarı neyi yapar, neyi yapamaz",
  "e2e.escrowoffer.password_label": "Klasör parolası",
  "e2e.escrowoffer.password_required": "Klasör parolasını girin.",
  "e2e.escrowoffer.wrong_password": "Bu, bu klasörün parolası değil.",
  "e2e.escrowoffer.accept": "İşletmeciye anahtar ver",
  "e2e.escrowoffer.decline": "Hayır, bende kalsın",
  "e2e.escrowoffer.cancel": "Vazgeç",
  "e2e.escrowoffer.busy": "Sarmalanıyor…",
  "e2e.escrowoffer.done": "İşletmeci artık bu klasörü emanet anahtarıyla açabilir",
  "e2e.escrowoffer.declined_toast": "Sizde kaldı. filex bu klasör için bir daha sormayacak.",
  "e2e.escrowoffer.decline_failed": "Cevabınız kaydedilemedi, bu yüzden filex bir dahakine yine soracak. Klasörde hiçbir şey değişmedi.",
  "e2e.escrowoffer.failed": "İşletmeciye bu klasörün anahtarı verilemedi",
  "e2e.escrowoffer.strip_action": "Emanet anahtarı…",
  "e2e.upgrade.title": "Bu klasörün kurtarma anahtarı yok",
  "e2e.upgrade.body": "Kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden tek giriş yolu parolası. Şu anda - ve yalnız şu anda, parola bellekteyken - filex bir tane ekleyebilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz.",
  "e2e.upgrade.escrow_note": "Not: bu kurulumda anahtar emaneti açık; kurtarma anahtarı eklemek aynı zamanda işletmecinin bu klasörü parolanız olmadan açabilmesi demektir.",
  "e2e.upgrade.accept": "Kurtarma anahtarı oluştur",
  "e2e.upgrade.decline": "Şimdi değil",
  "e2e.upgrade.busy": "Oluşturuluyor…",
  "e2e.upgrade.failed": "Bu klasöre kurtarma anahtarı eklenemedi",
  "e2e.download.failed": "Şifreli dosya indirilemedi.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Depo bağlantıları",
  "conn.subtitle": "{host} sunucusuna kendi bilgisayarınızdan nasıl erişilir: bağlayın ya da bir istemciyi buraya yönlendirin.",
  "conn.close": "Kapat",
  "conn.list.disabled": "Kapalı",
  "conn.form.required": "Zorunlu",
  "conn.form.advanced": "Gelişmiş ayarlar",
  "conn.form.yes": "Evet",
  "conn.form.no": "Hayır",
  "conn.form.noFields": "Bu sunucu bu sürücü için hiçbir ayar tanımlamadı.",
  "conn.form.reveal": "Göster",
  "conn.form.hide": "Gizle",
  "conn.guide.protocol": "Protokol",
  "conn.guide.storage": "Depo",
  "conn.guide.allStorages": "Tüm depolar",
  "conn.guide.copy": "Kopyala",
  "conn.guide.copied": "Kopyalandı",
  "conn.guide.goodToKnow": "Bilmekte fayda var",
  "conn.guide.userPlaceholder": "eposta@ornek.com",
  "conn.guide.secretPlaceholder": "parolanız-ya-da-api-anahtarınız",
  "conn.guide.fact.url": "Adres",
  "conn.guide.fact.urlRootHint": "Görebildiğiniz her depo bu adresin altında bir klasör olarak görünür.",
  "conn.guide.fact.urlStorageHint": "Doğrudan “{storage}” deposunu bağlar. Son parçayı silerseniz tüm depoları görürsünüz.",
  "conn.guide.fact.user": "Kullanıcı adı",
  "conn.guide.fact.password": "Parola",
  "conn.guide.webdav.summary": "WebDAV, filex’i bir sürücü gibi bağlar: Windows Gezgini, macOS Finder, Linux, rclone ve Cyberduck bu protokolü konuşur ve yapılan her değişiklik filex’e yansır.",
  "conn.guide.webdav.userHint": "Kullanıcı adınız ya da e-postanız - görünen adınız değil.",
  "conn.guide.webdav.passwordHint": "Hesap parolanız ya da bir API anahtarı (gezinti panelindeki API anahtarları bölümü). İki adımlı doğrulaması açık bir hesap ZORUNLU olarak API anahtarı kullanır: Basic kimlik doğrulamasında ikinci adım için yer yoktur.",
  "conn.guide.webdav.win.s1": "Dosya Gezgini’ni açın, Bu bilgisayar’a sağ tıklayın ve “Ağ sürücüsü bağla…” deyin.",
  "conn.guide.webdav.win.s2": "Bir sürücü harfi seçin ve klasör olarak {url} adresini girin.",
  "conn.guide.webdav.win.s3": "“Farklı kimlik bilgileri kullanarak bağlan” kutusunu işaretleyin ve yukarıdaki kullanıcı adı/parola ile girin.",
  "conn.guide.webdav.win.cmdCaption": "Komut İstemi (sihirbaz olmadan aynı iş)",
  "conn.guide.webdav.win.limits": "Windows’un tam olarak filex hatası gibi görünen üç yerleşik sınırı vardır: aktarımlar ~47,7 MB’ta durur, yaklaşık bin dosyalı klasörler açılmaz (“Disk biçimlendirilmemiş”) ve her iki ayarı değiştirdikten sonra WebClient hizmeti yeniden başlatılmalıdır.",
  "conn.guide.webdav.win.regCaption": "Yönetici olarak çalıştırın, sonra sürücüyü yeniden bağlayın",
  "conn.guide.webdav.win.https": "HTTPS zorunludur. Windows Basic kimlik bilgilerini yalnızca TLS üzerinden gönderir; düz http:// üzerinde hiçbir açıklama vermeden reddeder. BasicAuthLevel değerini 2 yapmayın - TLS kullanın.",
  "conn.guide.webdav.win.persist": "Bağlanan sürücü oturum kapatmayı atlatamaz: Windows 7’den beri Basic kimlik bilgileri Kimlik Bilgisi Yöneticisi’nde saklanamaz ve /persistent:yes bunu değiştirmez. Kendiliğinden geri gelsin istiyorsanız komutu bir oturum açma betiğinden yeniden çalıştırın.",
  "conn.guide.webdav.win.service": "Hiç bağlanamıyorsa WebClient hizmetinin çalıştığından emin olun: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "Finder’da Git → Sunucuya Bağlan… (⌘K) yolunu izleyin.",
  "conn.guide.webdav.mac.s2": "{url} adresini girip bağlanın.",
  "conn.guide.webdav.mac.s3": "Yukarıdaki kullanıcı adı ve parolayla kimliğinizi doğrulayın.",
  "conn.guide.webdav.mac.note": "Sürücü Konumlar altında görünür; her depo en üst düzeyde bir klasördür.",
  "conn.guide.webdav.linux.mountCaption": "davfs2 ya da masaüstü dosya yöneticisi (GNOME Dosyalar, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "ya da bu adresi GNOME Dosyalar / Dolphin icine yapistirin",
  "conn.guide.webdav.linux.locks": "davfs2 için kilitler kapatılmalıdır. filex WebDAV kilitlerini süreç belleğinde tutar; yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar - davfs2 tersini varsayar ve takılır.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone parolayı gizlenmiş biçimde saklar - önce bunu çalıştırıp çıktısını aşağıya yapıştırın",
  "conn.guide.webdav.rclone.passPlaceholder": "<rclone obscure çıktısı>",
  "conn.guide.webdav.rclone.useCaption": "Kullanımı",
  "conn.guide.webdav.duck.s1": "Yeni Yer İmi → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Sunucu {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Yol {path}.",
  "conn.guide.webdav.duck.s4": "Kullanıcı adı {user}, parola yukarıdaki gibi.",
  "conn.guide.webdav.note.delete": "WebDAV üzerinden silme kalıcıdır. Web arayüzü dosyaları filex çöp kutusuna taşır; istemciden silme ise nesneyi doğrudan arka uçtan kaldırır.",
  "conn.guide.webdav.note.locks": "Kilitler sunucu belleğinde durur: yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar. Windows ile Office’i memnun etmek için varlar, eşzamanlı düzenlemeyi hakemlemek için değil.",
  "conn.guide.webdav.note.permissions": "Web arayüzünde ne görüyorsanız burada da onu görürsünüz. Kök yalnızca açabildiğiniz depoları listeler; yetkiniz dışındaki bir yol 403 değil 404 döner, böylece ağaç neyin var olduğunu sızdırmaz.",
  "conn.guide.webdav.note.http": "Bu sunucuya düz http:// ile erişiliyor. Windows kimlik bilgilerinizi hiç göndermez, diğer tüm istemciler ise parolanızı açık metin olarak yollar. Bağlamadan önce filex’i TLS arkasına alın.",
  // ── S3 ucu: anahtarlar ve rehber ─────────────────────────────────
  "conn.s3keys.title": "S3 erişim anahtarları",
  "conn.s3keys.lead": "Bir erişim anahtarı, S3 konuşan her istemcinin - rclone, restic, AWS CLI, mc, s3fs, Cyberduck - filex’e bağlanmasını sağlar. Anahtar sizin yetkinizi taşır, bir fazlasını değil.",
  "conn.s3keys.disabled": "Bu sunucuda S3 ucu kapalı (FILEX_S3). Burada üretilen anahtar, yönetici ucu tekrar açana kadar bağlanmaz.",
  "conn.s3keys.cannotMint": "Erişim anahtarı üretebilecek bir hesapla oturum açmış değilsiniz. Aşağıdaki talimatlar yine geçerli - bir anahtar isteyip yapıştırmanız yeter.",
  "conn.s3keys.label": "Ne için? (dizüstü yedeği, CI, …)",
  "conn.s3keys.defaultLabel": "erişim anahtarı",
  "conn.s3keys.everyBucket": "Görebildiğim tüm kovalar",
  "conn.s3keys.prefix": "Kova içindeki klasör (isteğe bağlı)",
  "conn.s3keys.mint": "Anahtar oluştur",
  "conn.s3keys.inheritNote": "Bir anahtar sahip olduğunuz yetkiyi yalnızca DARALTABİLİR: yetkileriniz ve rolünüz. Anahtarı tek bir kovaya ya da klasöre kısıtlamak, bir dizüstü yedeği ile her şeyi okuyabilen bir kimlik arasındaki farktır.",
  "conn.s3keys.once": "Gizli anahtarı şimdi kopyalayın - bir daha gösterilmeyecek.",
  "conn.s3keys.accessKeyID": "Erişim anahtarı kimliği",
  "conn.s3keys.secret": "Gizli anahtar",
  "conn.s3keys.dismiss": "Kopyaladım",
  "conn.s3keys.col.label": "Etiket",
  "conn.s3keys.col.key": "Erişim anahtarı kimliği",
  "conn.s3keys.col.scope": "Kapsam",
  "conn.s3keys.col.lastUsed": "Son kullanım",
  "conn.s3keys.scopeAll": "görebildiğiniz her şey",
  "conn.s3keys.noLabel": "(etiketsiz)",
  "conn.s3keys.neverUsed": "hiç",
  "conn.s3keys.enable": "Aç",
  "conn.s3keys.disable": "Kapat",
  "conn.s3keys.revoke": "İptal et",
  "conn.s3keys.confirm": "Emin misiniz?",
  "conn.s3keys.empty": "Henüz erişim anahtarı yok.",
  "conn.guide.s3.summary": "S3 ucu, S3 konuşan her şeyin - yedekleme, eşitleme araçları, SDK’lar - hedefi olarak filex’i kullanmanızı sağlar; hem de zaten sahip olduğunuz depolarla.",
  "conn.guide.s3.keyPlaceholder": "yukarıdan bir anahtar oluşturun",
  "conn.guide.s3.secretPlaceholder": "anahtarı oluştururken bir kez gösterilir",
  "conn.guide.s3.fact.endpoint": "Uç adresi",
  "conn.guide.s3.fact.endpointHint": "İstemciyi buraya yöneltin, filex’in web adresine değil.",
  "conn.guide.s3.fact.bucket": "Kova",
  "conn.guide.s3.fact.bucketHint": "Kova = filex deposu. Kovaları istemci değil yönetici oluşturur.",
  "conn.guide.s3.fact.key": "Erişim anahtarı kimliği",
  "conn.guide.s3.fact.keyHint": "Genel yarısı; her istekte gider.",
  "conn.guide.s3.fact.secret": "Gizli anahtar",
  "conn.guide.s3.fact.secretHint": "Yalnızca anahtar oluşturulurken bir kez gösterilir. filex bir daha gösteremez - kaybolduysa yeni anahtar üretin.",
  "conn.guide.s3.fact.region": "Bölge",
  "conn.guide.s3.fact.regionHint": "filex’te bölge yok; hangi değeri verirseniz aynen geri döner. Yine de istemciler bir değer ister.",
  "conn.guide.s3.fact.addressing": "Adresleme",
  "conn.guide.s3.fact.pathStyle": "yol tabanlı (zorunlu)",
  "conn.guide.s3.fact.pathStyleHint": "Bu kurulumda S3’e ayrılmış bir alan adı yok, yani kova.host çözülmez.",
  "conn.guide.s3.fact.virtualHosted": "sanal-host ya da yol tabanlı",
  "conn.guide.s3.fact.virtualHostedHint": "Bu kurulumun kendi S3 alan adı var, iki adresleme de çalışır.",
  "conn.guide.s3.rclone.useCaption": "Kullanımı",
  "conn.guide.s3.rclone.mtime": "filex dosyanın değişiklik zamanını taşır (x-amz-meta-mtime); böylece rclone sync ilk turdan sonra oturur, her seferinde her şeyi yeniden yüklemez.",
  "conn.guide.s3.aws.configureCaption": "Bir kez ayarlayın",
  "conn.guide.s3.aws.useCaption": "Kullanımı",
  "conn.guide.s3.aws.pathStyle": "AWS yapılandırmanıza yol tabanlı adreslemeyi ekleyin; yoksa her komut DNS aşamasında düşer.",
  "conn.guide.s3.restic.envCaption": "Ortam değişkenleri",
  "conn.guide.s3.restic.useCaption": "Yedekle, doğrula, buda",
  "conn.guide.s3.restic.verified": "Bu uca karşı ölçüldü: restic check --read-data her pack’i bayt bayt okuyor ve hata bulmuyor.",
  "conn.guide.s3.mc.aliasCaption": "Takma adı ekleyin",
  "conn.guide.s3.mc.useCaption": "Kullanımı",
  "conn.guide.s3.s3fs.credsCaption": "Kimlik dosyası",
  "conn.guide.s3.s3fs.mountCaption": "Bağlayın",
  "conn.guide.s3.s3fs.note": "s3fs üzerinden bir dosyayı düzenlemek nesnenin tamamını yeniden yazar; silme ise filex çöp kutusuna gider. Paylaşılan bir klasör için iyi, veritabanı için değil.",
  "conn.guide.s3.duck.s1": "Yeni yer imi → Amazon S3.",
  "conn.guide.s3.duck.s2": "Sunucu: {host}.",
  "conn.guide.s3.duck.s3": "Erişim anahtarı kimliği: {key}, gizli anahtar yukarıdaki.",
  "conn.guide.s3.duck.s4": "Yer imini açın; kovalar sizin filex depolarınızdır.",
  "conn.guide.s3.duck.pathStyle": 'Tercihler → S3 altında "Use virtual host style" seçeneğini KAPATIN - bu kurulumda joker S3 alan adı yok.',
  "conn.guide.s3.sdk.note": "SigV4 konuşan her istemci aynı şekilde çalışır: uç adresi, anahtar, gizli anahtar ve bu kurulumun kendi S3 alan adı yoksa yol tabanlı adresleme.",
  "conn.guide.s3.note.buckets": "Kova = filex deposu. İstemci kovanın İÇİNDE klasör ve nesne oluşturabilir, ama kovanın kendisini oluşturamaz: kova bir sürücü ve bir yol ister, bunu bir S3 isteği ifade edemez.",
  "conn.guide.s3.note.permissions": 'Anahtar tam olarak sizin gördüğünüzü görür. Açamayacağınız bir kova "yasak" değil "böyle bir kova yok" der; böylece uç, neyin var olduğunu sızdırmaz.',
  "conn.guide.s3.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.s3.note.mtime": "Yüklemeler değişiklik zamanını taşır; istemcinin gönderdiği sağlama toplamları (Content-MD5, x-amz-checksum-*) doğrulanır - bozulmuş bir yükleme saklanmaz, reddedilir.",
  "conn.guide.s3.note.pathStyle": "Bu kurulumda S3’e ayrılmış alan adı yok; istemcilere yol tabanlı adresleme söylenmeli. Söylenmezse güncel bir SDK, ne filex’i ne de sebebi anan bir DNS hatasıyla düşer.",
  "conn.guide.s3.note.http": "Bu uç düz http://. İmzalar isteği yine korur ama nesneler açık metin gider. Bir yedeği buraya yöneltmeden önce filex’i TLS arkasına alın.",
  // ── SFTP ucu: anahtarlar ve rehber ───────────────────────────────
  "conn.sshkeys.title": "SSH anahtarları",
  "conn.sshkeys.lead": "Bir açık anahtar kaydedin; SSH konuşan her istemci - sftp, scp, WinSCP, FileZilla, rclone, sshfs - parolanızı göndermeden bağlansın.",
  "conn.sshkeys.disabled": "Bu sunucuda SFTP ucu kapalı (FILEX_SFTP). Burada kaydedilen anahtar, yönetici ucu açana kadar bağlanmaz.",
  "conn.sshkeys.cannotAdd": "Anahtar kaydedebilecek bir hesapla oturum açmış değilsiniz.",
  "conn.sshkeys.paste": "~/.ssh/id_ed25519.pub dosyasının içeriğini yapıştırın",
  "conn.sshkeys.name": "Ad (isteğe bağlı - boşsa anahtarın kendi yorumu kullanılır)",
  "conn.sshkeys.add": "Anahtar ekle",
  "conn.sshkeys.noCopyId": "ssh-copy-id burada çalışamaz: kabuk üzerinden ~/.ssh/authorized_keys dosyasına ekler, filex’in kabuğu yoktur. Anahtar eklemenin yolu bu kutudur.",
  "conn.sshkeys.col.name": "Ad",
  "conn.sshkeys.col.fingerprint": "Parmak izi",
  "conn.sshkeys.col.added": "Eklendi",
  "conn.sshkeys.col.lastUsed": "Son kullanım",
  "conn.sshkeys.noName": "(adsız)",
  "conn.sshkeys.neverUsed": "hiç",
  "conn.sshkeys.enable": "Aç",
  "conn.sshkeys.disable": "Kapat",
  "conn.sshkeys.remove": "Sil",
  "conn.sshkeys.confirm": "Emin misiniz?",
  "conn.sshkeys.empty": "Henüz anahtar yok. Anahtarsız istemciler hesap parolanızla oturum açar.",
  "conn.guide.sftp.summary": "SFTP, filex’i SSH konuşan her şeyin erişebileceği hâle getirir: bir yedekleme işi, bir tarayıcı, WinSCP, rclone ya da bağlanmış bir klasör.",
  "conn.guide.sftp.fact.host": "Sunucu",
  "conn.guide.sftp.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Ne 22 ne 443: SFTP ham TCP’dir, web vekilinin içinden geçemez.",
  "conn.guide.sftp.fact.userHint": "Kullanıcı adınız. İçinde @ işareti olsaydı çoğu istemcinin ayar dosyasında tırnaklanması gerekirdi; kullanıcı adı tam da bunu ortadan kaldırır.",
  "conn.guide.sftp.fact.auth": "Oturum açma yöntemi",
  "conn.guide.sftp.fact.authKey": "kayıtlı SSH anahtarınız (ya da parolanız)",
  "conn.guide.sftp.fact.authPassword": "hesap parolanız - ya da yukarıdan bir anahtar kaydedin",
  "conn.guide.sftp.fact.authHint": "API anahtarı da parola yerine geçer ve tek başına iptal edilebilir. İki adımlı doğrulaması açık bir hesap SSH anahtarı ya da API anahtarı kullanmalıdır.",
  "conn.guide.sftp.fact.path": "Yol",
  "conn.guide.sftp.fact.pathHint": "İlk klasör bir depodur; kök, açabildiğiniz depoları listeler.",
  "conn.guide.sftp.openssh.connectCaption": "Bağlan, gönder, al",
  "conn.guide.sftp.openssh.noShell": "Burada kabuk yok, yalnız SFTP alt sistemi var. `ssh sunucu komut` bilerek reddedilir; scp çalışır çünkü OpenSSH 9 onun için de SFTP konuşur.",
  "conn.guide.sftp.key.tab": "Anahtar kurulumu",
  "conn.guide.sftp.key.s1": "Bağlanacak makinede bir anahtar çifti üretin (zaten varsa atlayın).",
  "conn.guide.sftp.key.s2": "AÇIK yarısını kopyalayın - .pub dosyası, asla diğeri değil.",
  "conn.guide.sftp.key.s3": "Yukarıdaki kutuya yapıştırıp bağlanın; o andan sonra parola gönderilmez.",
  "conn.guide.sftp.key.genCaption": "Kendi makinenizde",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id filex’e karşı ÇALIŞMAZ: ~/.ssh/authorized_keys dosyasına eklemek için kabuğa ihtiyacı var, filex’te kabuk yok. Anahtarı yukarıdan yapıştırın.",
  "conn.guide.sftp.winscp.s1": "Yeni site → Dosya protokolü: SFTP.",
  "conn.guide.sftp.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "Kullanıcı adı: {user}. Anahtar için: Gelişmiş → SSH → Kimlik Doğrulama → özel anahtar dosyası.",
  "conn.guide.sftp.winscp.s4": "WinSCP .ppk biçiminde özel anahtar ister - OpenSSH anahtarını kendi aracıyla (Araçlar → PuTTYgen) bir kez dönüştürün.",
  "conn.guide.sftp.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "Kullanıcı: {user}. Giriş türü: parola için Normal, anahtar için Anahtar dosyası.",
  "conn.guide.sftp.rclone.useCaption": "Kullanımı",
  "conn.guide.sftp.sshfs.mountCaption": "Bağla ve çöz",
  "conn.guide.sftp.sshfs.note": "Bağlanmış bir klasörde her kayıt dosyanın tamamını yeniden yazar. Belgeler için iyi; veritabanı ya da yerinde düzenlediğiniz bir video için değil.",
  "conn.guide.sftp.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.sftp.note.permissions": "İstemcinizin çizdiği izin bitleri buradaki erişim seviyenizden gelir; yani salt-okunur görünen bir dosya sizin için gerçekten öyledir.",
  "conn.guide.sftp.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.sftp.note.totp": "Hesabınızda iki adımlı doğrulama açıksa parola burada çalışmaz - SSH’ın kodu soracak bir kanalı yok. Bir SSH anahtarı kaydedin ya da parola yerine API anahtarı kullanın.",
  "conn.guide.sftp.note.disabled": "Bu sunucuda SFTP ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS, yalnızca FTP öğrenmiş ekipman için var: tarayıp-klasöre-atan yazıcılar, EDI muhatapları, eski laboratuvar ve endüstri yazılımları. Her zaman TLS üzerinden.",
  "conn.guide.ftps.fact.host": "Sunucu",
  "conn.guide.ftps.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "Kontrol kanalı. Veri, aşağıdaki pasif aralıktan ayrı bir porttan akar.",
  "conn.guide.ftps.fact.mode": "Şifreleme",
  "conn.guide.ftps.fact.modeValue": "FTPS - açık (explicit) TLS, zorunlu",
  "conn.guide.ftps.fact.modeHint": 'Düz FTP, parola okunmadan reddedilir. "Require explicit FTP over TLS" seçin; "plain FTP" ya da "implicit" asla.',
  "conn.guide.ftps.fact.userHint": "Kullanıcı adınız ya da e-postanız. Parola yerine bir API anahtarı da kullanılabilir ve tek başına iptal edilebilir.",
  "conn.guide.ftps.fact.passwordHint": "Hesap parolanız ya da bir API anahtarı. İki adımlı doğrulaması açık bir hesap API anahtarı kullanmalıdır - FTP'nin kodu soracak bir yolu yok.",
  "conn.guide.ftps.fact.pasv": "Pasif portlar",
  "conn.guide.ftps.fact.pasvHint": "Veri bağlantıları buraya düşer. Güvenlik duvarınız bu aralığı kapatıyorsa aktarım iki tarafta da hata vermeden ASILI KALIR - FTP'nin klasik arızası budur.",
  "conn.guide.ftps.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Şifreleme: "Require explicit FTP over TLS". Giriş türü: Normal, kullanıcı: {user}.',
  "conn.guide.ftps.filezilla.s4": "Aktarım ayarları → Pasif. Bu sunucu aktif modu reddeder.",
  "conn.guide.ftps.winscp.s1": "Yeni site → Dosya protokolü: FTP, Şifreleme: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "Kullanıcı adı: {user}, parola yukarıdaki.",
  "conn.guide.ftps.curl.caption": "Gönder ve al",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd isteğe bağlı değil: curl'ün düz metne geri düşmek yerine TLS'i ZORUNLU kılmasını sağlar. Bu sunucu zaten düz metni reddediyor, ama alışkanlık sizi reddetmeyen sunuculara karşı korur.",
  "conn.guide.ftps.lftp.caption": "Bağlan",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data yalnız oturum açmayı değil DOSYAYI da şifreler. Olmazsa lftp TLS ile oturum açar ve dosyayı açık metin gönderir - sahada en sık yapılan FTPS yanlışı budur.",
  "conn.guide.ftps.rclone.useCaption": "Kullanımı",
  "conn.guide.ftps.printer.tab": "Tarayıcı / yazıcı",
  "conn.guide.ftps.printer.s1": "Cihazın tara-ve-FTP'ye-gönder ayarlarında: sunucu {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "Kullanıcı: {user}, parola yukarıdaki. Cihaz için kendi parolanız yerine bir API anahtarı oluşturun - başka hiçbir şeyi değiştirmeden iptal edilebilir.",
  "conn.guide.ftps.printer.s3": "Yol: {path} - ya da önceden oluşturduğunuz bir alt klasör. Cihaz depo oluşturamaz.",
  "conn.guide.ftps.printer.s4": '"SSL/TLS" ya da "FTPS explicit" seçeneğini AÇIN ve PASİF modu seçin.',
  "conn.guide.ftps.printer.noTLS": "Tara-ve-gönder yazılımlarının önemli bir kısmı TLS konuşamıyor. Bu sunucu öyle bir cihazla konuşmayacak ve bu bilinçli: alternatifi, belgelerinizin ve parolanızın ofis ağında açık metin dolaşması.",
  "conn.guide.ftps.note.tls": "TLS zorunludur ve kapatan bir düğme yoktur. Düz FTP parolanızı açık metin gönderir, ardından dosyanızı da.",
  "conn.guide.ftps.note.passive": "Yalnızca pasif mod. Aktif modda sunucu istemciyi geri arar; bu NAT arkasında çalışmaz ve çoğu güvenlik duvarı tarafından engellenir.",
  "conn.guide.ftps.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.ftps.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.ftps.note.prefer": "İstemci SFTP konuşabiliyorsa onu tercih edin: tek bağlantı, tek port, pasif mod sürprizi yok.",
  "conn.guide.ftps.note.selfSigned": "Bu sunucu kendinden imzalı bir sertifika kullanıyor. Kanalı şifreler ama karşı tarafın kim olduğunu kanıtlamaz; çoğu istemci bir kez onay ister. Önemli bir iş için gerçek sertifika koyun.",
  "conn.guide.ftps.note.disabled": "Bu sunucuda FTPS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS export'ları",
  "conn.nfs.lead": "Bir export, ağınızdaki bir makinenin filex'i sürücü olarak bağlamasını sağlar - medya oynatıcı, derleme sunucusu, yedek kutusu.",
  "conn.nfs.pathIsSecret": "⚠ Export yolu PAROLANIN TA KENDİSİDİR. NFS, Kerberos olmadan istemciye kim olduğunu soramaz; bu yüzden filex yola 32 rastgele bayt koyar: yolu bilen sizin adınıza bağlanır. Bağlama satırını bir kimlik bilgisi gibi saklayın - /etc/fstab çoğu sistemde herkes tarafından okunabilir.",
  "conn.nfs.disabled": "Bu sunucuda NFS ucu kapalı (FILEX_NFS). Burada oluşturulan export, yönetici ucu açana kadar bağlanmaz.",
  "conn.nfs.cannotMint": "Export oluşturabilecek bir hesapla oturum açmış değilsiniz.",
  "conn.nfs.label": "Ne için? (medya oynatıcı, yedek kutusu, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Görebildiğim tüm depolar",
  "conn.nfs.prefix": "Depo içindeki klasör (isteğe bağlı)",
  "conn.nfs.allowCidrs": "İzinli adresler, örn. 192.168.1.0/24 (isteğe bağlı)",
  "conn.nfs.readOnly": "Salt okunur",
  "conn.nfs.readOnlyHint": "Bir makine için güvenli varsayılan salt okunurdur: sizin yetkiniz ne olursa olsun bu bağlantı üzerinden her yazmayı reddeder. Adres listesi daha da daraltır - listenin dışından gelen bağlanamaz.",
  "conn.nfs.mint": "Export oluştur",
  "conn.nfs.once": "Şimdi kopyalayın - yol yalnızca bir kez gösterilir ve geri alınamaz.",
  "conn.nfs.dismiss": "Kopyaladım",
  "conn.nfs.col.label": "Etiket",
  "conn.nfs.col.scope": "Kapsam",
  "conn.nfs.col.mode": "Mod",
  "conn.nfs.col.lastUsed": "Son bağlanma",
  "conn.nfs.scopeAll": "görebildiğiniz her şey",
  "conn.nfs.modeRead": "salt okunur",
  "conn.nfs.modeWrite": "okuma/yazma",
  "conn.nfs.noLabel": "(etiketsiz)",
  "conn.nfs.neverUsed": "hiç",
  "conn.nfs.enable": "Aç",
  "conn.nfs.disable": "Kapat",
  "conn.nfs.revoke": "İptal et",
  "conn.nfs.confirm": "Emin misiniz?",
  "conn.nfs.empty": "Henüz export yok.",
  "conn.guide.nfs.summary": "NFS, filex'i kendi ağınızdaki bir makinede sürücü olarak bağlar - NAS protokolü, onu bekleyen cihazlar için.",
  "conn.guide.nfs.pathPlaceholder": "yukarıdan bir export oluşturun",
  "conn.guide.nfs.fact.host": "Sunucu",
  "conn.guide.nfs.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Hem port= hem mountport= buna ayarlanmalı; filex mount ve NFS servislerini tek portta veriyor.",
  "conn.guide.nfs.fact.export": "Export yolu",
  "conn.guide.nfs.fact.exportHint": "Kimlik bilgisi budur. Export oluşturulurken bir kez gösterilir ve hash'li saklanır - filex bir daha gösteremez.",
  "conn.guide.nfs.fact.options": "Bağlama seçenekleri",
  "conn.guide.nfs.fact.optionsHint": "nolock, çünkü filex NFS kilit yöneticisini çalıştırmıyor; nfsvers=3, çünkü bu sunucunun konuştuğu sürüm bu.",
  "conn.guide.nfs.linux.mountCaption": "Bağla",
  "conn.guide.nfs.linux.fstabSecret": "Bu yolu içeren bir /etc/fstab satırı, herkesin okuyabildiği bir dosyadaki paroladır. Ortamınızda önemliyse kimlik korumalı automount kullanın ya da bağlamayı yalnız root'un okuyabildiği bir unit dosyasında tutun.",
  "conn.guide.nfs.mac.mountCaption": "Bağla",
  "conn.guide.nfs.mac.resvport": "macOS resvport ister: istemcisi ayrıcalıklı bir kaynak portta ısrar eder ve olmadan bağlantıyı reddeder.",
  "conn.guide.nfs.win.s1": `Windows Özellikleri'nden "Services for NFS" → "Client for NFS" bileşenini açın (yalnız Pro ve Enterprise; Home'da yok).`,
  "conn.guide.nfs.win.s2": "Komut İstemi'ni yönetici olarak açın.",
  "conn.guide.nfs.win.s3": "Aşağıdaki komutla export'u bir sürücü harfine bağlayın.",
  "conn.guide.nfs.win.cmdCaption": "Z: sürücüsüne bağla",
  "conn.guide.nfs.win.port": "Windows'un mount servisinin portunu söyleme imkânı yok; yalnızca standart 2049 portundaki bir NFS sunucusuna erişebilir. Bu sunucu başka bir porttaysa SFTP'yi ya da filex masaüstü uygulamasını kullanın.",
  "conn.guide.nfs.nas.tab": "NAS / medya oynatıcı",
  "conn.guide.nfs.nas.s1": "Cihazın NFS ayarlarında: sunucu {host}, port {port} (ayrı ayrı soruyorsa hem NFS hem mount portunu ayarlayın).",
  "conn.guide.nfs.nas.s2": "Uzak yol: yukarıdaki export yolu, birebir.",
  "conn.guide.nfs.nas.s3": "NFS sürüm 3, kilitleme kapalı. Cihazın gerçekten yazması gerekmiyorsa export'u salt okunur oluşturun.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 şifreli değildir. Trafiği okuyabilen dosyalarınızı görür, yolu öğrenen bağlanabilir. Ev/ofis ağında ya da VPN üzerinden kullanın - internet üzerinden asla.",
  "conn.guide.nfs.note.pathIsSecret": "Export yolu kimlik bilgisinin tamamıdır. Sızarsa yukarıdaki listeden iptal edin; değiştirilecek başka bir şey yok.",
  "conn.guide.nfs.note.noPortmapper": "111 portunda portmapper yok; portu söylenmeyen istemci sunucuyu bulamaz. Buradaki her komutun port= ve mountport= taşımasının sebebi bu.",
  "conn.guide.nfs.note.uid": "İstemcinizin gönderdiği kullanıcı ve grup kimlikleri yok sayılır: bağlantı zaten kime ait olduğunu biliyor. Gördüğünüz izinler filex'teki erişiminizden gelir.",
  "conn.guide.nfs.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.nfs.note.revoke": "İptal anında değil, bir sonraki istekte etkili olur: NFS'te sonlandırılacak bir oturum yok, bağlantısı açık olan istemci sıradaki işleminde hata alır.",
  "conn.guide.nfs.note.disabled": "Bu sunucuda NFS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  "conn.tokens.title": "API anahtarları",
  "conn.tokens.lead": "FTPS, WebDAV ve filex mount hesap parolanız yerine bir API anahtarıyla oturum açar. Buradan oluşturun - tek başına iptal edilebilir, ayrıca iki adımlı doğrulaması açık bir hesap bunlarda parolasını zaten kullanamaz.",
  "conn.tokens.mint": "API anahtarı oluştur",
  "conn.tokens.once": "Şimdi kopyalayın - yalnızca bir kez gösterilir. Sunucuda yalnız özeti saklandığı için bir daha gösterilemez.",
  "conn.tokens.dismiss": "Kopyaladım",
  "conn.tokens.cannotMint": "Bu oturum API anahtarı oluşturamıyor. Kendi hesabınızla oturum açıp oluşturun.",
  "conn.tokens.empty": "Henüz API anahtarı yok.",
  "conn.tokens.neverUsed": "hiç",
  "conn.tokens.revoke": "İptal et",
  "conn.tokens.confirm": "Emin misiniz?",
  "conn.tokens.col.label": "Ad",
  "conn.tokens.col.scopes": "İzinler",
  "conn.tokens.col.comments": "Yorumlar",
  "conn.tokens.col.used": "Son kullanım",
  "conn.tokens.revokeHint": "İptal, yalnız bir sonraki oturum açmayı değil AÇIK bağlantıyı da durdurur: SFTP ya da FTPS oturumu kesilir, bağlı bir sürücü yarım dakika içinde çalışmayı bırakır.",
  "conn.guide.mount.summary": "filex mount, uzaktaki bir filex sunucusunu bu makinede bir klasöre bağlar - tarayıcının kullandığı aynı HTTPS üzerinden. Buradakilerin her yerden çalışan tek yöntemi: yerel ağ da gerekmez, ek sunucu da, üçüncü parti bir istemci de.",
  "conn.guide.mount.fact.url": "Sunucu adresi",
  "conn.guide.mount.fact.urlHint": "Tarayıcıda kullandığınız adresin aynısı. Başka hiçbir şeye erişilebilir olması gerekmez.",
  "conn.guide.mount.fact.token": "API anahtarı",
  "conn.guide.mount.fact.tokenPlaceholder": "API anahtarları bölümünden oluşturun",
  "conn.guide.mount.fact.tokenHint": "Parolanız değil, bir API anahtarı - tek başına iptal edilebilir, ayrıca 2FA açık bir hesap burada parolasını zaten kullanamaz.",
  "conn.guide.mount.fact.remote": "Neyi bağlayacağınız",
  "conn.guide.mount.fact.remoteHint": "--remote vermezseniz her depo bir klasör olarak görünür; tek bir depoyu - ya da onun içindeki bir klasörü - adlandırırsanız yalnızca o bağlanır.",
  "conn.guide.mount.linux.mountCaption": "Bağlayın",
  "conn.guide.mount.linux.umountCaption": "Ayırın",
  "conn.guide.mount.linux.umountWarn": "Süreci öldürerek değil, fusermount ile ayırın. Ayrılmadan ölen bir bağlantı, birileri elle fusermount çalıştırana kadar her ls komutunun asılı kaldığı bir klasör bırakır.",
  "conn.guide.mount.linux.systemdCaption": "Oturum açılınca otomatik bağlansın (systemd kullanıcı birimi)",
  "conn.guide.mount.win.winfsp": "Windows'ta bir kez WinFsp kurulması gerekiyor - ücretsiz ve açık kaynak: https://winfsp.dev. Başka bir şey gerekmiyor, sonrasında yönetici hakkı da istemiyor.",
  "conn.guide.mount.win.mountCaption": "Sürücü olarak bağlayın",
  "conn.guide.mount.win.freeLetter": "BOŞ bir sürücü harfi seçin. Harf bağlama sırasında oluşturulur, var olan bir şeye eklenmez; kullanımdaki bir harfi verirseniz bunu söylemeyen bir hatayla başarısız olur.",
  "conn.guide.mount.win.stop": "O pencerede Ctrl-C ile durdurun. Sürücü kaybolur ve bu makinede hiçbir şey kalmaz.",
  "conn.guide.mount.mac.unsupported": "filex mount macOS'ta çalışmıyor. macFUSE gerekiyor; lisansı filex gibi bir programın onu sizin yerinize kurmasına izin vermiyor ve Go bağlaması filex'in bilinçli olarak kullanmadığı bir C derleyicisi istiyor. Komut burada çalışıyormuş gibi görünüp hiçbir şey yapmak yerine açıkça reddediyor.",
  "conn.guide.mount.mac.alternatives": "macOS'ta filex masaüstü uygulamasını klasör eşitlemesiyle kullanın (dosyalar diskte durur) ya da sürücü bağlayabilen bir istemciyle SFTP.",
  "conn.guide.mount.note.notASync": "Bu bir eşitleme değildir. Küçük bir okuma önbelleği dışında bu makineye hiçbir şey kopyalanmaz; yüz bin dosyanın içinden birini gerisini indirmeden açar. Dosyaları çevrimdışıyken istiyorsanız klasör eşitlemesini kullanın.",
  "conn.guide.mount.note.reachable": "Sunucuya, tarayıcının geçtiği hangi vekil ya da tünel varsa oradan ulaşır - çünkü altında aynı API vardır. İzinleriniz ve depolarınız da birlikte gelir.",
  "conn.guide.mount.note.wholeFileWrites": "Bağlantı üzerinden yazdığınız dosya, yazılırken değil, program onu kapattığında yüklenir. Çok büyük bir dosyayı yerinde düzenlemek burada yerel diskten yavaştır; içeri ve dışarı kopyalamak değildir.",
  "conn.guide.mount.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.mount.note.revoke": "Bir bağlantıyı durdurmak için API anahtarını iptal edin. Bağlantı hâlâ takılı olsa bile yarım dakika içinde hizmet vermeyi bırakır.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Yerel dosya sistemi",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "Sunucu adı olmadan yalnızca paylaşım adı: `\\\\nas\\media` değil, `media`.",
  "storages.fieldHelp.smbDomain": "Yalnızca Windows etki alanı hesabı için. NAS kullanıyorsanız boş bırakın.",
  "storages.fieldHelp.smbRoot": "Paylaşımın içindeki alt klasör. Paylaşımın tamamı için boş bırakın.",
  "storages.fields.share": "Paylaşım",
  "storages.fields.domain": "Etki alanı / çalışma grubu",
  "storages.fieldHelp.disablePresign": "Varsayılan olarak açık: yüklemeler ve herkese açık paylaşım bağlantılarındaki indirmeler filex üzerinden akar; kova endpoint'inin tarayıcıdan erişilebilir olması gerekmez (yalnız yerel ağdaki MinIO doğrudan çalışır). Yalnızca endpoint kullanıcıların tarayıcısından erişilebiliyorsa (AWS, herkese açık MinIO) ve tarayıcının kovayla doğrudan konuşmasını istiyorsanız kapatın - çok büyük dosyalarda daha hızlıdır, ama depo SDK'nın imzaladığı URL'leri kabul etmelidir (Ceph RGW / bazı Hetzner kurulumları SignatureDoesNotMatch döner).",
  "storages.fieldHelp.endpoint": "AWS S3 için boş bırakın. S3 uyumlu diğer tüm depolar kendi endpoint'ini ister.",
  "storages.fieldHelp.hostKey": "authorized_keys / known_hosts satır biçiminde tek bir açık anahtar.",
  "storages.fieldHelp.insecureSkipHostKey": "Her sunucu anahtarını kabul eder. Yalnızca geçici sunucular için.",
  "storages.fieldHelp.keyPath": "Sunucudaki anahtar dosyasının yolu; depo başlarken okunur. PEM alanı boşken kullanılır.",
  "storages.fieldHelp.knownHosts": "Katı sunucu anahtarı denetimi için OpenSSH known_hosts yolu. Varsayılan, ~/.filex/known_hosts içinde ilk bağlantıda güven.",
  "storages.fieldHelp.passive": "Kapatmak aktif moda geçirir; bu, sunucunun bu makineye geri bağlanmasını gerektirir.",
  "storages.fieldHelp.path": "Sunucudaki dizin. Yoksa oluşturulur; filex asla / dizinini mount etmez.",
  "storages.fieldHelp.pathStyle": "AWS dışındaki tüm depolarda açık olmalı. Endpoint girildiyse ve bu alana hiç dokunulmadıysa kendiliğinden açılır.",
  "storages.fieldHelp.prefix": "Kova içindeki alt klasör. Zorunlu: filex kova kökünün sahipliğini asla almaz.",
  "storages.fieldHelp.region": 'Boş bırakılırsa "auto" kullanılır.',
  "storages.fieldHelp.root": "Arka uçtaki alt klasör. Zorunlu: filex hesabın kökünü asla mount etmez.",
  "storages.fieldHelp.sftpAuth": "Parola ya da özel anahtardan biri zorunludur.",
  "storages.fieldHelp.tls": "Düz FTP kimlik bilgilerini açık metin gönderir - sunucu destekliyorsa açın.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Temel yol",
  "storages.fields.bucket": "Kova",
  "storages.fields.disablePresign": "Aktarımları filex üzerinden geçir",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Sunucu",
  "storages.fields.hostKey": "Sabitlenmiş sunucu anahtarı",
  "storages.fields.insecureSkipHostKey": "Sunucu anahtarı doğrulamasını atla (güvensiz)",
  "storages.fields.keyPath": "Özel anahtar dosyası",
  "storages.fields.knownHosts": "known_hosts dosyası",
  "storages.fields.name": "Görünen ad",
  "storages.fields.namePlaceholder": "Kişisel fotoğraflar",
  "storages.fields.passive": "Pasif mod (PASV)",
  "storages.fields.password": "Parola",
  "storages.fields.path": "Dizin yolu",
  "storages.fields.pathStyle": "Path-style URL kullan (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Önek (prefix)",
  "storages.fields.privateKey": "Özel anahtar (PEM)",
  "storages.fields.rbac": "Öğe bazlı erişim denetimi (RBAC)",
  "storages.fields.rbacHint": "Açıkken yönetici olmayanlar yalnızca kendilerine yetki verilen dosya ve klasörleri görür (Klasör erişimi sayfasında listelenir). Kapalıyken herkes depoyu rolüne göre açar.",
  "storages.fields.readOnly": "Salt okunur mount",
  "storages.fields.region": "Bölge",
  "storages.fields.root": "Temel yol",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (açık AUTH TLS)",
  "storages.fields.url": "Temel URL",
  "storages.fields.user": "Kullanıcı",
  "storages.fields.s3AttemptTimeout": "Deneme zaman aşımı (saniye)",
  "storages.fields.s3MaxAttempts": "İstek başına deneme sayısı",
  "storages.fields.s3TotalTimeout": "Vazgeçme süresi (saniye)",
  "storages.fieldHelp.s3AttemptTimeout": "Tek bir denemenin depodan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, TLS el sıkışması, istek gönderildikten sonraki cevap ve cevabın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; deponun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir. Kopyalama ve yeniden adlandırma cevap için 10 dakikaya kadar bekler, çünkü depo bunları ancak kopya bittiğinde cevaplar.",
  "storages.fieldHelp.s3MaxAttempts": "Hata geçebilecek türdeyse bir isteğin toplamda kaç kez deneneceği: ağ hatası, zaman aşımı, 5xx cevabı, hız sınırlaması. 1 yeniden denemeyi kapatır. Bir ret (403, bulunmayan bir kova, çözümlenmeyen bir sunucu adı) hiçbir zaman yeniden denenmez.",
  "storages.fieldHelp.s3TotalTimeout": "İlk denemeden itibaren bu kadar saniye içinde bitemeyecek yeni bir deneme başlatılmaz; böylece çalışmayan bir depoya yükleme ya da listeleme, kesintiyi bu süre içinde bildirir. Sürmekte olan bir aktarım kesilmez. Zaman aşımına uğrayan bir istek ancak bu değer deneme zaman aşımının en az iki katıysa yeniden denenir.",
  "storages.fields.attemptTimeout": "Deneme zaman aşımı (saniye)",
  "storages.fields.maxAttempts": "İstek başına deneme sayısı",
  "storages.fields.totalTimeout": "Vazgeçme süresi (saniye)",
  "storages.fieldHelp.attemptTimeout": "Tek bir denemenin sunucudan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, oturum açma, her isteğin cevabı ve bir aktarımın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; sunucunun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir.",
  "storages.fieldHelp.webdavAttemptTimeout": "Tek bir denemenin sunucudan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, oturum açma, her isteğin cevabı ve bir aktarımın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; sunucunun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir. Kopyalama, taşıma ve silme cevap için 10 dakikaya kadar bekler, çünkü sunucu bunları ancak iş bittiğinde cevaplar.",
  "storages.fieldHelp.maxAttempts": "Hata geçebilecek türdeyse bir isteğin toplamda kaç kez deneneceği: bağlantı reddedilir ya da kopar, cevap zamanında gelmez, sunucu şu an hizmet veremediğini söyler (5xx). 1 yeniden denemeyi kapatır. Bir ret (yanlış parola, bulunmayan bir klasör, doğrulanamayan bir sertifika) hiçbir zaman yeniden denenmez; gönderilmeye başlamış bir yükleme de yeniden denenmez.",
  "storages.fieldHelp.totalTimeout": "İlk denemeden itibaren bu kadar saniye içinde bitemeyecek yeni bir deneme başlatılmaz; böylece çalışmayan bir sunucu bu süre içinde bildirilir. Sürmekte olan bir aktarım kesilmez. Zaman aşımına uğrayan bir istek ancak bu değer deneme zaman aşımının en az iki katıysa yeniden denenir.",
  /* === gezinti:g1 - gezinti paneli (SideNav) === */
  "sidenav.title": "Gezinti",
  "sidenav.views": "Görünümler",
  "sidenav.storages": "Depolar",
  "sidenav.home": "Ana sayfa",
  "sidenav.myfiles": "Dosyalarım",
  "sidenav.recent": "Son kullanılanlar",
  "sidenav.starred": "Yıldızlılar",
  "sidenav.shared": "Benimle paylaşılanlar",
  // Üstteki satırın aynası ve tam altında durur: gelen ile giden.
  "sidenav.myshares": "Paylaştıklarım",
  "sidenav.trash": "Çöp kutusu",
  "sidenav.collapse": "Gezintiyi daralt",
  "sidenav.expand": "Gezintiyi genişlet",
  "sidenav.close": "Gezintiyi kapat",
  // ⚠ aç/kapat çifti ÇEKMECENİN, daralt/genişlet çifti yerleşik PANELİN -
  // ikisi birbirinin yerine kullanılamaz; bkz. en.ts'teki not ve Toolbar.vue
  // içindeki `navToggleLabel`. 560px altında panel listenin üzerine gelen bir
  // çekmecedir: raya inmez, hiç ekranda değildir; "genişlet" olmayan bir
  // genişliği büyütmeyi vaat ederdi.
  "sidenav.open": "Gezintiyi aç",
  "sidenav.storage.shared": "Paylaşılan",
  "sidenav.storage.readOnly": "Salt okunur",
  // #57 - depo satırının sıralama menüsü (sağ tık, uzun basış, Shift+F10).
  // "Ada göre sırala" bir mod değildir; kişinin elle düzeltmeye devam
  // edebileceği bir sıra yazar. "Varsayılan sırayı kullan" kişinin kendi
  // sırasını bırakır: panel yöneticinin sırasına (yoksa sunucununkine) döner.
  "sidenav.storage.moveUp": "Yukarı taşı",
  "sidenav.storage.moveDown": "Aşağı taşı",
  "sidenav.storage.sortName": "Ada göre sırala",
  "sidenav.storage.sortName.done": "Zaten ada göre sıralı",
  "sidenav.storage.defaultOrder": "Varsayılan sırayı kullan",
  "sidenav.storage.defaultOrder.none": "Zaten varsayılan sırada",
  // ⚠ `toolbar.nav` KALDIRILDI, yerine bir şey konmadı - bkz. en.ts'teki not.
  // Paneli daraltan tek denetimin etiketiydi; önce "Gezinti" (panelin adı,
  // düğmenin ne yaptığını söylemiyor), sonra "Gezintiyi göster/gizle" (sabit
  // geçici çözüm). Gerçek düzeltme yukarıdaki dört `sidenav.*` fiili:
  // etiket `navOpen`'a bağlı, daraltacaksa "daralt", genişletecekse
  // "genişlet" yazıyor.
  "node.home": "Ana sayfa",
  "node.recent": "Son kullanılanlar",
  "node.starred": "Yıldızlılar",
  "node.shared": "Benimle paylaşılanlar",
  "empty.recent.title": "Henüz hiçbir şey açılmadı",
  "empty.recent.hint": "Açtığınız dosyalar burada görünür",
  "empty.starred.title": "Henüz yıldızlı dosya yok",
  "empty.starred.hint": "Bir dosyayı yıldızlayın; burada bulursunuz",
  "empty.shared.title": "Sizinle henüz bir şey paylaşılmadı",
  "empty.shared.hint": "Başkalarının paylaştığı klasör ve dosyalar burada görünür",
  /* etiket:t1 */
  "sidenav.tags": "Etiketler",
  "sidenav.tags.empty": "Henüz etiket yok - bir dosyaya sağ tıklayıp Etiketler’den ekleyebilirsiniz.",
  "sidenav.tags.more": "{count} tane daha göster",
  "sidenav.tags.less": "Daha az göster",
  "sidenav.tags.personal": "Kişisel",
  "sidenav.tags.team": "Ekip",
  "empty.tag.title": "“{tag}” etiketli hiçbir şey yok",
  "empty.tag.hint": "Bir dosyaya sağ tıklayıp Etiketler’i seçin; dosya burada görünür",
  "sidenav.connections": "Bağlantılar",
  "sidenav.apps": "Uygulamalar",
  // #162 - mağaza ekranı: yöneticinin açtığı mağazaların kataloğu.
  "sidenav.appstore": "Uygulama mağazası",
  "sidenav.connect": "Nasıl bağlanılır",
  "sidenav.apikeys": "API anahtarları",
  "overlay.close": "Kapat",
  "conn.tokens.scopes": "İzinler",
  "conn.tokens.root": "Tek bir klasörle sınırla (isteğe bağlı)",
  "conn.tokens.rootPlaceholder": "depo://klasör",
  "conn.tokens.expiry": "Geçerlilik (gün)",
  "conn.tokens.expiryNever": "süresiz",
  "conn.tokens.defaultName": "API anahtarı {date}",
  "conn.tokens.namePlaceholder": "Ad - ör. yedekleme betiği",
  "conn.tokens.capNote": "Tavan kendi erişiminizdir - sahip olmadığınız bir izin reddedilir, verilmez.",
  "conn.tokens.scopesRequired": "En az bir izin seçin - hiçbir izni olmayan bir API anahtarı verilmez.",
  "conn.tokens.comments": "Yorumlar",
  "conn.tokens.commentsRead": "Okuma",
  "conn.tokens.commentsRw": "Okuma ve yazma",
  "conn.tokens.commentsHint": "Yorum eklemek ve silmek ayrı bir izindir - “write” bunu kapsamaz. Her API anahtarı yorumları okur.",
  "conn.tokens.commentsToRw": "Yorumlar: yazmaya izin ver",
  "conn.tokens.commentsToRead": "Yorumlar: yalnız okuma",
  /* === /gezinti:g1 === */
  /* === surucu:d1 - kabuk (GitHub #14); artık `uiProfile: 'drive'` ile
     gelen bir seçenek değil, her profilde çizilir === */
  "drive.new": "Yeni",
  "drive.new.upload": "Dosya yükle",
  "drive.new.folder": "Yeni klasör",
  "drive.new.request": "Dosya iste",
  "drive.new.document": "Yeni belge",
  /* === belge:n1 - "Yeni belge": + Yeni altındaki seçici ==================
     Tür adları BURADA durmuyor. Her kutucuk sözcüklerini lib/fileIcons
     `typeLabelFor`den okur - listedeki Tür sütununun okuduğu tablonun
     aynısı - böylece ".docx" iki yerde de aynı adla anılır ve yeni bir tür
     için hiç dizge gerekmez. Aşağıda yalnız bu pencerenin kendi metni var. */
  "newdoc.title": "Yeni belge",
  "newdoc.type.label": "Belge türü",
  "newdoc.group.document": "Belgeler",
  "newdoc.group.text": "Metin ve kod",
  "newdoc.group.diagram": "Çizimler",
  "newdoc.group.app": "Uygulamalar",
  /* ⚠ Her servisin tek adı, kendi projesinin kullandığı ad: draw.io
     ("drawio" ya da "diagrams.net" değil) ve ONLYOFFICE. */
  "newdoc.empty.title": "Kullanılabilir belge türü yok",
  "newdoc.empty.body": "Bu sunucu, bu uygulamanın oluşturabileceği bir tür sunmadı.",
  "newdoc.empty.blocked": "Bu sunucunun oluşturabildiği her tür, burada tanımlı olmayan bir düzenleyici servisine bağlı.",
  "newdoc.name": "Ad",
  "newdoc.name.placeholder": "Dosya adı, ör. notlar.txt ya da LICENSE",
  "newdoc.untitled": "Adsız",
  "newdoc.err.slash": "Ad eğik çizgi içeremez.",
  "newdoc.err.exists": "{name} burada zaten var. Başka bir ad seçin.",
  "newdoc.err.bare_ext": "Dosyaya yalnız bir uzantı değil, bir ad verin.",
  "newdoc.err.ext_needs_type": ".{ext} dosyası kendi türüyle oluşturulmalı - boş bir dosya açılmaz. O türü ya da başka bir uzantıyı seçin.",
  "newdoc.hint.ext_added": "Bu tür uzantısını korur; dosya {name} adıyla oluşturulacak.",
  // Drafts (issue #71): a new document is a draft until its first save.
  "sidenav.drafts": "Taslaklar",
  "sidenav.drafts.count": "{n} taslak",
  "sidenav.drafts.count_one": "{n} taslak",
  "node.drafts": "Taslaklar",
  "empty.drafts.title": "Taslak yok",
  "empty.drafts.hint": "Yeni bir belge, ait olduğu yere kaydedilene kadar burada bekler.",
  "drafts.lead": "Henüz kaydedilmemiş yeni belgeler. Bunları yalnızca siz görebilirsiniz.",
  "drafts.count_of": "{n} / {limit} taslak",
  "drafts.col.target": "Kaydedileceği yer",
  "drafts.col.storage": "Depo",
  "drafts.action.save": "Diske kaydet",
  "drafts.open_hint": "{name} dosyasını aç",
  "drafts.no_match": "Filtreye uyan taslak yok.",
  "draft.badge": "Taslak",
  "draft.bar.target": "{folder} konumuna kaydedilecek",
  "draft.save": "Kaydet",
  "draft.saved_to": "{name}, {folder} konumuna kaydedildi.",
  "draft.discarded": "{name} çöp kutusuna taşındı.",
  "draft.kept": "Taslaklarda tutuluyor",
  "draft.editing": "Düzenleniyor…",
  "draft.close.title": "Bu taslak kapatılsın mı?",
  "draft.close.body": "{name}, {folder} için bir taslak ve henüz oraya kaydedilmedi.",
  "draft.close.hint": "Tutulan taslak Taslaklar’da bekler. Çöpe at, taslağı çöp kutusuna taşır.",
  "draft.close.save": "Diske kaydet",
  "draft.close.keep": "Taslaklarda tut",
  "draft.close.discard": "Çöpe at",
  "outside.title": "Bu dosya dışarıda değişti",
  "outside.body": "{name} burada açıkken başka bir yerde değiştirildi ve bu düzenleyicide de değişiklikler var. Hangi sürüm kalsın?",
  "outside.theirs": "Dışarıdakini koru",
  "outside.theirs_hint": "burada yapılan değişiklikler atılır, dışarıdaki sürüm yüklenir.",
  "outside.mine": "Benimkini yaz",
  "outside.mine_hint": "kaydedildiğinde sizin sürümünüz dışarıdakinin üstüne yazılır.",
  "outside.both": "İkisini de tut",
  "outside.both_hint": "dışarıdaki sürüm yerinde kalır, sizinki yanına ayrı bir kopya olarak kaydedilir (ad.filex-conflict-zaman).",
  "outside.hint": "Siz seçene kadar hiçbir sürümün üstüne yazılmaz.",
  "outside.pending": "Bu dosya dışarıda değişti. Hangi sürümün kalacağını seçene kadar hiçbir sürümün üstüne yazılmaz.",
  "outside.choose": "Seç…",
  "outside.note.reloaded": "Dosya dışarıda güncellendi, yeni sürüm yüklendi.",
  "outside.note.theirs": "Dışarıdaki sürüm yüklendi; burada yapılan değişiklikler atıldı.",
  "outside.note.mine": "Sizin sürümünüz kaydedildiğinde dışarıdakinin üstüne yazılacak.",
  "outside.note.both": "Dışarıdaki sürüm yerinde kalıyor; sizinki kaydedildiğinde yanına ayrı bir kopya olarak yazılacak.",
  "draft.taken.title": "Bu adda bir dosya zaten var",
  "draft.taken.body": "{folder} konumunda {name} adında bir dosya zaten var. Taslak {suggested} olarak kaydedilsin mi?",
  "draft.taken.confirm": "{name} olarak kaydet",
  "upload.taken.body": "{folder} konumunda {name} adında bir öğe zaten var ve kasa eski sürümleri saklamaz. {suggested} olarak yüklensin mi?",
  "upload.taken.confirm": "{name} olarak yükle",
  "newdoc.hint.draft": "Taslak olarak açılır: siz kaydedene kadar klasörde hiçbir şey oluşturulmaz.",
  "newdoc.err.draft_limit": "Bu sunucunun izin verdiği kadar taslağınız var ({limit}). Önce Taslaklar’da bazılarını kaydedin ya da silin.",
  "newdoc.err.draft_limit_any": "Bu sunucunun izin verdiği sayıda taslağınız var. Önce Taslaklar’da bazılarını kaydedin ya da silin.",
  "newdoc.open_drafts": "Taslakları aç",
  "newdoc.location": "Konum",
  "newdoc.location.none": "Bir klasör seçin",
  "newdoc.location.change": "Değiştir",
  "newdoc.location.noaccess": "Bu klasöre kaydedemezsiniz.",
  "newdoc.create": "Oluştur",
  "newdoc.creating": "Oluşturuluyor…",
  "newdoc.cancel": "Vazgeç",
  "drive.search.placeholder": "{scope} deposunda ara",
  "drive.search.placeholder_all": "Tüm depolarda ara",
  "drive.search.hint_title": "Her yerde ara ve komut çalıştır ({combo})",
  "drive.storage.used": "{total} alanın {used} kadarı dolu",
  "drive.storage.used_unlimited": "{used} kullanılıyor",
  "drive.storage.used_partial": "en az {used} kullanılıyor",
  "drive.storage.label": "Depolama",
  /* === gorunum:v3-shell - Ana sayfa görünümü (kabuğun içindeki genel bakış)
   * Bölüm başlıkları `sidenav.storages` / `sidenav.recent` / `sidenav.starred`,
   * boş durumlar da `empty.recent.*` / `empty.starred.*` - bilerek: Ana
   * sayfadaki "Son kullanılanlar" başlığı ile yanındaki panel satırı aynı
   * şeydir, ikisine ayrı metin yazmak onları çeviri çeviri birbirinden
   * ayırmanın yoludur. Aşağıda yalnızca başka hiçbir yerde olmayanlar var. */
  "home.title": "Ana sayfa",
  "home.storages.empty": "Henüz depo yok",
  "home.storages.hint": "Depo, filex’in okuyup yazdığı yerdir - depoları yönetici ekler.",
  "drive.section.folders": "Klasörler",
  "drive.section.files": "Dosyalar",
  "filter.aria": "Filtreler",
  "filter.type": "Tür",
  "filter.type.any": "Her tür",
  "filter.type.folder": "Klasörler",
  "filter.type.document": "Belgeler",
  "filter.type.spreadsheet": "Hesap tabloları",
  "filter.type.presentation": "Sunumlar",
  "filter.type.pdf": "PDF’ler",
  "filter.type.image": "Görseller",
  "filter.type.video": "Videolar",
  "filter.type.audio": "Ses dosyaları",
  "filter.type.archive": "Arşivler",
  "filter.type.code": "Kod",
  "filter.modified": "Değiştirilme",
  "filter.modified.any": "Her zaman",
  "filter.modified.today": "Bugün",
  "filter.modified.7d": "Son 7 gün",
  "filter.modified.30d": "Son 30 gün",
  "filter.modified.year": "Bu yıl",
  "filter.size": "Boyut",
  "filter.size.any": "Her boyut",
  "filter.size.lt1": "1 MB altı",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "100 MB üstü",
  /* surucu:d1-actions - filtre satırının sonundaki ⋮ menüsü. Yalnızca menünün
     KENDİ adı yeni: içindeki her satır o eylemin zaten sahip olduğu metni
     kullanır (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`,
     `shortcuts.select_all`, `selection.clear`) - bir komutu yeniden adlandıran
     menü, okuyucuya aynı şeyi iki kez öğretir. */
  "filter.actions": "Liste işlemleri",
  "filter.clear": "Filtreleri temizle",
  "filter.empty.title": "Bu filtrelere uyan bir şey yok",
  "filter.empty.hint": "Bir filtreyi kaldırın ya da yukarıdaki alandan her yerde arayın.",
  "filter.count": "{total} öğeden {shown} tanesi",
  "inspector.tab.details": "Ayrıntılar",
  "inspector.tab.activity": "Etkinlik",
  "inspector.people": "Erişimi olan kişiler",
  "inspector.people.you": "Siz",
  "inspector.people.inherited": "üst klasörden",
  "inspector.people.empty": "Yalnızca siz ve aşağıdaki bağlantıya sahip olanlar.",
  "inspector.people.manage": "Erişimi yönet",
  "inspector.link": "Paylaşım bağlantısı",
  "inspector.link.none": "Paylaşılmadı",
  "inspector.link.create": "Bağlantı oluştur",
  "inspector.link.copy": "Bağlantıyı kopyala",
  "inspector.activity.empty": "Bu öğe için henüz etkinlik kaydı yok.",
  "inspector.activity.hint": "Sürümler dosya değiştikçe, yorumlar ise insanlar yazdıkça birikir.",
  "inspector.activity.version": "{n}. sürüm kaydedildi",
  "inspector.activity.comment": "{who} yorum yaptı",
  "inspector.activity.select": "Etkinliğini görmek için bir dosya ya da klasör seçin.",
  /* === /surucu:d1 === */
  /* === gorunum:v1-chrome - filtre satırındaki ad kutusu === */
  "filter.find": "Bu klasörde filtrele…",
  /* surucu:d1-scope - satırların bir klasörün içeriği olmadığı yerlerde aynı
     kutu. Neyi daralttığını söylemek zorunda: depo listesinde "bu klasör" hiçbir
     şeyi adlandırmaz, Ana sayfada ise üç bloğu birden adlandırırdı. */
  "filter.find.storages": "Depolarda filtrele…",
  "filter.find.home": "Ana sayfada filtrele…",
  /* === gorunum:v1-viewer - tam ekran görüntüleyicinin kendi çerçevesi === */
  "viewer.share": "Paylaş",
  "viewer.nav_prev": "Önceki dosya",
  "viewer.nav_next": "Sonraki dosya",
  /* Üst çubuğun künye satırındaki sayaç: "246,3 KB • 9 Eyl 2026 • 1 / 9". */
  "viewer.counter": "{i} / {n}",
  "viewer.zoom_reset": "Yakınlaştırmayı sıfırla",
  "viewer.fullscreen": "Tam ekran",
  "viewer.exit_fullscreen": "Tam ekrandan çık",
  "viewer.md_placeholder": "# Markdown buraya…",
  /* === gorunum:v1-selbar - filtre satırının yerini alan seçim çubuğu === */
  "selection.count": "{n} seçildi",
  "selection.clear": "Seçimi temizle",
  /* === gorunum:v1-preview - türün adı, kelimeyle =======================
     Tür sütunu eskiden uzantıyı büyük harfle yazıyordu; artık bunları
     yazıyor. Hangisinin seçileceğine `lib/fileIcons.ts` karar verir
     (`typeLabelKey`) - bir türü adlandıran yalnız iki yer var: o tablo ve bu
     liste. Eşleşmeyen her şey yine büyük harfli uzantıya düşer. `Klasör`
     burada DEĞİL: o `node.folder`, grid kartının alt yazısı zaten onu basar. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue bileşeni",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C kaynağı",
  "ftype.cpp": "C++ kaynağı",
  "ftype.csharp": "C# kaynağı",
  "ftype.stylesheet": "Stil dosyası",
  "ftype.html": "HTML belgesi",
  "ftype.json": "JSON verisi",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Kabuk betiği",
  "ftype.powershell": "PowerShell betiği",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Düz metin",
  "ftype.log": "Günlük dosyası",
  "ftype.config": "Ayar dosyası",
  "ftype.sheet": "Hesap tablosu",
  "ftype.drawio": "draw.io diyagramı",
  "ftype.figma": "Figma tasarımı",
  "ftype.design": "Tasarım dosyası",
  "ftype.image": "Görsel",
  "ftype.video": "Video",
  "ftype.audio": "Ses",
  "ftype.pdf": "PDF belgesi",
  "ftype.document": "Belge",
  "ftype.slides": "Sunum",
  "ftype.archive": "Arşiv",
  "ftype.code": "Kod",
  /* === gorunum:v1-advsearch - Gelişmiş arama penceresi ===================
   * İki `filter.*` anahtarı kardeşlerinin yanında değil burada: paylaşılan
   * birleşimlere pencerenin eklediği yeni üyeler (`modified: 'around'`,
   * `size: 'range'`). Filtre satırı bunları hiç seçmez ama biri oraya
   * ulaşırsa `chipLabel` ham anahtarı yazardı. */
  "filter.modified.around": "Bir tarihin çevresinde",
  "filter.size.range": "Özel aralık",
  "advsearch.open": "Gelişmiş arama",
  "advsearch.title": "Gelişmiş arama",
  "advsearch.subtitle": "Dosyaları ada, içeriğe, yola ya da etikete göre bulun.",
  "advsearch.close": "Kapat",
  "advsearch.content.heading": "İçerik araması",
  "advsearch.viewall": "Tüm sonuçları gör",
  "advsearch.where.any_short": "Her yerde",
  "advsearch.where.here_short": "Yalnız burada",
  "advsearch.where.skip_short": "Burayı atla",
  "advsearch.server.legend": "Sunucunun aradığı",
  "advsearch.client.legend": "Gelen sonuçları daralt",
  "advsearch.query.label": "Kelimeler",
  "advsearch.query.placeholder": "Adın bir parçası ya da dosyanın içindeki kelimeler",
  "advsearch.scope.label": "Nerede arasın",
  "advsearch.scope.name": "Ad ve yol",
  "advsearch.scope.content": "Dosya içeriği",
  "advsearch.scope.all": "İkisi de",
  "advsearch.scope.hint": "İçerik, dizinden aranır; dizin metin türü dosyaların ilk 200 KB’ını kapsar.",
  "advsearch.people.name_only": "Sahip, gelen satırlardan okunur; sahip bilgisi taşıyan satırları da yalnız ad araması döndürür.",
  "advsearch.scope.name_only": "Burada yalnız ad ve yol: içerik sonucu gezgine hangi depodan geldiği bilgisi olmadan ulaşır, bu yüzden içerik araması yalnız tek depolu kurulumlarda sunulur.",
  "advsearch.tags.label": "Etiketler",
  "advsearch.tags.placeholder": "fatura, üç aylık rapor",
  "advsearch.tags.exclude": "Şu etiketler hariç",
  "advsearch.tags.exclude_placeholder": "arşiv",
  "advsearch.tags.hint": "Virgülle ayırın. Etiket daraltır: birden çok etiket hepsini birden taşıyan dosyalar demektir, hiç kullanılmamış bir etiket ise hiçbir şey döndürmez. Bir ad, o adı taşıyan kişisel etiketinizi de ekibinizin etiketini de bulur.",
  "advsearch.where.label": "Klasör",
  "advsearch.where.any": "Bu deponun her yerinde",
  "advsearch.where.here": "Yalnız {folder} içinde",
  "advsearch.where.skip": "{folder} dışındaki her yerde",
  "advsearch.around.label": "Şu kadar içinde",
  "advsearch.around.date": "Tarih ve saat",
  "advsearch.around.h1": "1 saat",
  "advsearch.around.d1": "1 gün",
  "advsearch.around.w1": "1 hafta",
  "advsearch.size.range_label": "Şunun arasında",
  "advsearch.size.from": "En az",
  "advsearch.size.to": "En çok",
  "advsearch.count.idle": "Bir şeyler yazın ya da etiket seçin.",
  "advsearch.count.counting": "Sayılıyor…",
  "advsearch.count.result": "{n} eşleşen öğe",
  "advsearch.count.capped": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.result_one": "{n} eşleşen öğe",
  "advsearch.count.capped_one": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.error": "Sayım çalıştırılamadı.",
  "advsearch.count.cost": "Sayım bu aramayı çalıştırır. Tür, sahip, tarih, boyut ve klasör bulduğu sonuçları daraltır.",
  "advsearch.wire": "Bir dahaki sefere arama kutusuna şunu yazabilirsiniz:",
  "advsearch.reset": "Sıfırla",
  "advsearch.cancel": "Vazgeç",
  "advsearch.submit": "Ara",
  /* === gorunum:v2-topbar - sayfanın üst barı kalktı; onun taşıdıklarını
     artık gezginin kendi başlığı ve kırıntı satırı taşıyor. === */
  "breadcrumb.subfolders": "Alt klasörler",
  "breadcrumb.subfolders.empty": "Burada alt klasör yok",
  "header.admin": "Yönetim paneli",
  "header.settings": "Ayarlar",
  "header.signout": "Oturumu kapat",
  "ai.assistant": "AI asistanı",
  "ai.soon": "Yakında",
  "ai.assistant.soon": "AI asistanı - yakında",
  /* gorunum:v2-share - Paylaş / İzinler penceresinin kendi çerçevesi. İçindeki
     denetimler eski metinlerini koruyor; buradakiler yeni kabuk: başlık, tek
     anahtar, "şu anda kim açabilir" cümlesi ve her şeyin katlandığı üç adlı
     bölüm. */
  "access.title": '"{name}" paylaşımı',
  "access.close": "Kapat",
  "access.done": "Bitti",
  "access.copy": "Kopyala",
  "access.copied": "Kopyalandı",
  "access.link.switch": "Bağlantı paylaşımı",
  "access.who.private": "Yalnızca erişimi olan kişiler açabilir.",
  "access.who.link": "Bağlantıyı bilen herkes açabilir.",
  "access.who.pin": "Bağlantıyı ve PIN'i bilen herkes açabilir.",
  "access.who.existing": "Bağlantı paylaşımı açık - {n} bağlantı var.",
  "access.who.existing_one": "Bağlantı paylaşımı açık - {n} bağlantı var.",
  "access.section.link": "Bağlantı seçenekleri",
  "access.section.people": "Erişimi olanlar",
  "access.section.drop": "Dosya iste",
  "access.sum.pin_on": "PIN var",
  "access.sum.pin_off": "PIN yok",
  "access.sum.people": "{n} kişi",
  "access.sum.people_one": "{n} kişi",
  "access.sum.people_none": "Henüz kimse yok",
  "access.sum.groups": "{n} grup",
  "access.sum.groups_one": "{n} grup",
  "access.sum.drop": "{n} yükleme bağlantısı",
  "access.sum.drop_one": "{n} yükleme bağlantısı",
  "access.sum.drop_none": "Yükleme bağlantısı yok",
  /* Sahiplik - Sahibi sütunu ve Kişiler çipi. "Sistem", filex üzerinden kimsenin
     koymadığı satırın dürüst karşılığıdır (tarayıcı buldu ya da doğrudan kovaya
     yazıldı); boşluk değil, gerçek bir cevaptır. */
  "col.owner": "Sahibi",
  "owner.you": "Siz",
  "owner.system": "Sistem",
  "owner.unknown": "Bilinmiyor",
  "owner.external": "Yükleme bağlantısıyla geldi",
  "owner.last_actor": "Son değiştiren: {who}",
  "filter.people": "Sahibi",
  "filter.people.any": "Herkes",
  "filter.people.me": "Siz",
  "filter.people.system": "Sistem",
  "filter.people.someone": "Başka biri",
  /* surucu:d1-sort - filtre satırının sağ ucundaki sıralama denetimi. Dört
     ölçütün adı `col.*`: menü, liste görünümünün sütun başlıklarındaki
     sözcüklerin aynısını sunar - tek bir sıralamayı süren iki denetim onu
     farklı adlarla anamaz. */
  "sort.by": "Sıralama ölçütü",
  "sort.asc": "Artan",
  "sort.desc": "Azalan",
  /* Bir ARAMA SONUCUNUN sırası. Beşinci bir sıralama ölçütü değildir -
     ekrandaki satırları sunucu sıraladığında denetim, ölçüt adı yerine bunu
     yazar; böylece yapmadığı bir sıralamayı üstlenmez. `_why` denetimin neden
     kapalı olduğudur: bakımcı, denetimin sessizce işlevsizleşmesini değil
     nedeninin yazılmasını istedi. */
  "sort.relevance": "Alaka",
  "sort.relevance_why": "Arama sonuçları eşleşme yakınlığına göre listelenir. Seçtiğiniz sıralama, aramadan çıkınca geri gelir.",
  /* === tablo:t1 - tablonun kendi yapılandırması ==========================
     v0.43'ten beri bir klasörün görünüşüne dair her şey - görünüm, sıralama VE
     sütunlar - değiştirildiği klasöre aittir; kimsenin değiştirmediği klasör
     kişinin varsayılanıyla (ayarlarından), o yoksa kurulumunkiyle açılır.
     `folder_hint` bu kuralı tek cümlede, tam da ona şaşıracak kişinin
     okuyabileceği yerde söyler. */
  "col.location": "Konum",
  "col.deleted": "Silinme",
  "col.deleted_from": "Silindiği yer",
  "col.deleted_by": "Silen",
  "col.remaining": "Kalan süre",
  "cols.menu": "Sütun seçenekleri",
  "cols.title": "Sütunlar",
  "cols.resize": "{col} sütununu yeniden boyutlandır",
  "cols.sort_by": "{col} sütununa göre sırala",
  "cols.move_left": "{col} sütununu sola taşı",
  "cols.move_right": "{col} sütununu sağa taşı",
  "cols.reset": "Sütunları sıfırla",
  "cols.folder_title": "Klasör görünümü",
  "cols.folder_hint": "Burada yaptığınız değişiklik bu klasörde kalır. Hiç değiştirmediğiniz klasörler varsayılan görünümünüzle açılır (Ayarlar → Varsayılan klasör görünümü).",
  "cols.forget_folder": "Bu klasörün görünümünü unut",
  "cols.apply_all": "Bunu tüm klasörler için varsayılanım yap ({count} klasör hatırlanıyor)",
  /* === tablo:t3 - TEK TABLO (components/DataTable.vue) ====================
     Üründeki her tablo bunları konuşur; Türkçe bir sayfada sütun menüsü ya da
     sayfalayıcı İngilizce kalmasın. */
  "table.empty": "Henüz burada bir şey yok",
  "table.prev": "Önceki sayfa",
  "table.next": "Sonraki sayfa",
  "table.sort_paged": "Bu liste sayfalara bölünmüş. Sıralama yalnızca ekrandaki sayfayı yeniden dizerdi, bu yüzden burada kapalı - listeyi arama ya da filtrelerle daraltın.",
  /* === tablo:t1 - çöp kutusu bilgi şeridi ================================
     ⚠ `retention` yalnızca kurulum bize sayıyı SÖYLEDİĞİNDE kullanılır
     (GET /api/admin/protection). Diğer her durumda `retention_unknown` aynı
     şeyi, doğrulayamadığımız bir süreyi taahhüt etmeden söyler: yanlış saklama
     süresi yazan bir şerit, hiç şerit olmamasından kötüdür - insanlar ona
     bakıp karar verir. */
  "trash.retention": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_one": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_unknown": "Çöp kutusundaki öğeler, yöneticinizin belirlediği saklama süresi dolunca kalıcı olarak silinir.",
  "trash.empty_action": "Çöp kutusunu boşalt",
  "trash.empty_confirm_title": "Çöp kutusu boşaltılsın mı?",
  "trash.empty_counting": "Çöp kutusundakiler sayılıyor…",
  "trash.show_more": "Daha fazla göster",
  "trash.shown_of": "{total} öğenin {shown} tanesi gösteriliyor",
  "trash.days_remaining": "{n} gün",
  "trash.days_remaining_one": "{n} gün",
  "trash.days_remaining_due": "Silinmek üzere",
  "trash.deleted_by_nobody": "Kayıt yok: virüs taraması karantinaya almış ya da filex bunu tutmaya başlamadan önce silinmiş",
  "empty.trash.hint": "Sildiğiniz dosyalar önce buraya düşer, böylece geri alabilirsiniz.",
  /* tasi:m1 - hedef klasör seçici (modals/DestinationPickerModal.vue) ve
     üzerine kurulan iki seçim eylemi. */
  "destpicker.title.move": "Şuraya taşı",
  "destpicker.title.copy": "Şuraya kopyala",
  "destpicker.title.choose": "Klasör seç",
  "destpicker.confirm.move": "Buraya taşı",
  "destpicker.confirm.copy": "Buraya kopyala",
  "destpicker.confirm.choose": "Bu klasörü seç",
  "destpicker.title.choose_file": "Dosya seç",
  "destpicker.confirm.choose_file": "Bu dosyayı seç",
  "destpicker.title.save": "Şuraya kaydet",
  "destpicker.confirm.save": "Buraya kaydet",
  "destpicker.pick_a_file": "Listeden bir dosya seçin.",
  "destpicker.empty_files": "Bu klasör boş",
  "destpicker.cancel": "Vazgeç",
  "destpicker.up": "Bir üst klasör",
  "destpicker.crumbs": "Konum",
  "destpicker.drives": "Depolar",
  "destpicker.loading": "Yükleniyor…",
  "destpicker.empty": "Burada alt klasör yok",
  "destpicker.unreadable": "Bu klasör açılamıyor.",
  "destpicker.readonly": "Salt okunur",
  "destpicker.readonly_here": "Bu klasöre yazamazsınız.",
  "destpicker.pick_a_drive": "Bir klasör seçmek için önce bir depo açın.",
  "destpicker.target": "Hedef: {name}",
  "destpicker.tag.blocked": "Uygun değil",
  "destpicker.blocked.self": "Bir klasör kendi içine taşınamaz.",
  "destpicker.blocked.descendant": "Bir klasör kendi alt klasörlerinden birine taşınamaz.",
  "destpicker.tag.vault": "Kasa",
  "destpicker.blocked.vault_in": "Buradan kasaya bir şey konmaz: kasanın içinden yükleyin.",
  "destpicker.blocked.vault_out": "Kasadakiler yalnız o kasanın içinde taşınır. Dışarı almak için indirin.",
  "ctx.move_to": "Şuraya taşı…",
  "ctx.copy_to": "Şuraya kopyala…",
  "ctx.access.one_only": "Paylaşım aynı anda tek öğe için çalışır.",
  "toast.archive.preparing": "Arşiv hazırlanıyor…",
  "toast.archive.started": "{name} indiriliyor ({count} dosya)",
  "toast.archive.started_one": "{name} indiriliyor ({count} dosya)",
  "toast.archive.empty": "İndirilecek bir şey yok - seçimde okunabilir dosya bulunmuyor.",
  "toast.moved_to": "{name} klasörüne taşıma kuyruğa alındı",
  "toast.copied_to": "{name} klasörüne kopyalama kuyruğa alındı",
  "toast.already_there": "Seçilen öğeler zaten {name} içinde - hiçbir şey gönderilmedi",
  /* ── dil:paket - bkz. en.ts */
  "ctx.tags_menu": "Etiketler…",
  "toast.node_id_copied": "Node id {id} kopyalandı",
  "toast.read_only_here": "Burada yazma yetkiniz yok",
  "recents.title": "Son açılanlar",
  "recents.refresh": "Yenile",
  "recents.empty": "Henüz bir şey yok.",
  "recents.loading": "Yükleniyor…",
  "recents.close": "Kapat",
  "tags.title": "Etiketler",
  "tags.close": "Kapat",
  "share.ttl.never": "Bu bağlantının süresi yoktur.",
  "share.ttl.until": "Bu bağlantı {when} tarihine kadar geçerli.",
  "share.ttl.ceiling": "Bağlantılar en fazla {days} gün geçerli olabilir (sunucu ayarı).",
  "share.ttl.ceiling_one": "Bağlantılar en fazla {days} gün geçerli olabilir (sunucu ayarı).",
  /* ── dil:paket - paylaşım / erişim penceresi (bkz. en.ts) */
  "access.ui.level_viewer": "Görüntüleyen",
  "access.ui.level_viewer_desc": "görüntüle + indir",
  "access.ui.level_editor": "Düzenleyen",
  "access.ui.level_editor_desc": "oku + yaz + sil",
  "access.ui.level_owner": "Sahip",
  "access.ui.level_owner_desc": "düzenle + izin yönet",
  "access.ui.never": "Süresiz",
  "access.ui.days": "{days} gün",
  "access.ui.days_one": "{days} gün",
  "access.ui.unlimited": "Sınırsız",
  "access.ui.downloads": "{count} indirme",
  "access.ui.downloads_one": "{count} indirme",
  "access.ui.inherited_from": "Üst klasörden gelir",
  "access.ui.access_granted": "Yetki verildi.",
  "access.ui.enter_a_valid_email": "Geçerli bir e-posta girin.",
  "access.ui.recipient_lang": "Alıcının dili",
  "access.ui.recipient_lang_server": "Sunucunun dili",
  "access.ui.user_created_invite_emailed": "Kullanıcı açıldı, davet e-postası gönderildi.",
  "access.ui.user_created_share_the_temp_password": "Kullanıcı açıldı. Geçici parolayı iletin.",
  "access.ui.server_limit_applied": "(sunucu sınırı uygulandı)",
  "access.ui.protect_with_a_pin": "PIN ile koru",
  "access.ui.expiry": "Süre",
  "access.ui.download_limit": "İndirme limiti",
  "access.ui.create_link": "Bağlantı oluştur",
  "access.ui.replace_link": "Bağlantıyı bu ayarlarla yenile",
  "access.ui.replace_link_hint": "Adres değişir: şu anki bağlantı çalışmayı bırakır.",
  "access.ui.create_then_send": "Bir bağlantı oluşturun, ardından {email} adresine gönderin.",
  "access.ui.command_line": "Komut satırı",
  "access.ui.share": "Paylaş",
  "access.ui.existing_links": "Mevcut bağlantılar",
  "access.ui.rbac_off_here": "Bu depoda öğe bazlı erişim denetimi kapalı - herkes depoyu rolüne göre açar, burada eklenen kişiler bir şey değiştirmez. Yönetim panelinde Depolar altından (bu depo → Öğe bazlı erişim denetimi) açın.",
  "access.ui.other_links": "Diğer bağlantılar",
  "access.ui.revoke": "İptal",
  "access.ui.loading": "Yükleniyor…",
  "access.ui.name_or_email": "Ad ya da e-posta",
  "access.ui.add": "Ekle",
  "access.ui.no_account_for_this_email_what_next": "Bu e-postada hesap yok. Ne yapmak istersiniz?",
  "access.ui.user": "Kullanıcı",
  "access.ui.viewer": "Görüntüleyen",
  "access.ui.create_user_grant": "Kullanıcı oluştur + yetki ver",
  "access.ui.just_send_a_share_link": "Yalnızca paylaşım bağlantısı gönder →",
  "access.ui.temp_password": "Geçici parola:",
  "access.ui.people_with_access": "Erişimi olanlar",
  "access.ui.group": "Grup",
  "access.ui.group_title": "“{name}” grubu - içindeki herkes",
  "access.ui.group_owner_confirm": "Sahip düzeyi, “{name}” grubundaki herkesin buraya kimin erişebileceğini yönetmesine izin verir - başka kişi ve gruplarla paylaşmak dâhil. Gruba Sahip verilsin mi?",
  "access.ui.group_owner_give": "Sahip yap",
  "access.ui.not_shared_with_anyone_yet": "Henüz kimseyle paylaşılmadı.",
  "access.ui.remove": "Kaldır",
  "access.ui.a_public_link_that_lets_anyone_upload_fi": "Bu klasöre herkesin dosya YÜKLEYEBİLECEĞİ herkese açık bir bağlantı. Yükleyenler klasördeki mevcut dosyaları göremez.",
  "access.ui.hide_upload_limits": "Yükleme sınırlarını gizle",
  "access.ui.upload_limits": "Yükleme sınırları",
  "access.ui.max_files": "En fazla dosya",
  "access.ui.mb_file": "Dosya başı MB",
  "access.ui.allowed_types": "İzinli türler",
  "access.ui.all_e_g_pdf_jpg": "hepsi (örn. pdf, jpg)",
  "access.ui.ask_uploader_name": "Yükleyenin adını sor",
  "access.ui.emails_comma_separated": "e-posta(lar) - virgülle ayırın",
  "access.ui.send": "Gönder",
  "access.ui.mail_not_set_up": "E-posta kurulu değil - yönetim panelinde Ayarlar altından (E-posta / SMTP) kurun.",
  /* ── wiring:e2 fxe - tek şifreli dosyalar (.fxe), akışlı indirmeler ── */
  "e2e.fxe.type": "Şifreli dosya",
  "e2e.fxe.ctx_encrypt": "E2EE ile şifrele…",
  "e2e.fxe.ctx_download_raw": "Şifreli dosyayı indir",
  "e2e.fxe.ctx_password": "Parolayı değiştir…",
  "e2e.fxe.ctx_remove": "Şifrelemeyi kaldır…",
  "e2e.fxe.encrypt_title": "Bu dosyayı şifrele",
  "e2e.fxe.encrypt_lead": "“{name}” bu tarayıcıda, kendine ait bir parolayla şifrelenir. Sunucu yalnızca şifreli veriyi saklar. Dosyayı parola ya da kurtarma anahtarı açar - burada ya da çevrimdışı olarak filex decrypt ile.",
  "e2e.fxe.pw_label": "Dosya parolası",
  "e2e.fxe.hide_label": "Dosya adını da gizle",
  "e2e.fxe.hide_on_hint": "“{stored}” olarak saklanır: sunucu ne adı ne de türü görür. Gerçek ad dosyanın içinde mühürlüdür; dosyayı burada açınca görünür.",
  "e2e.fxe.hide_off_hint": "“{stored}” olarak saklanır: ad sunucu tarafından okunabilir kalır, içerik kalmaz.",
  "e2e.fxe.seen_title": "Sunucunun zaten gördükleri",
  "e2e.fxe.seen_lead": "Bu dosya şimdiye kadar şifresiz saklandı ve şifrelemek bunu geri almaz:",
  "e2e.fxe.seen_trash": "Asıl dosya çöp kutusuna gider ve çöp kutusunun saklama süresi dolana ya da bir yönetici boşaltana kadar orada kalır. Kalıcı olarak kendiniz silemezsiniz.",
  "e2e.fxe.seen_versions": "Önceki sürümleri sürüm geçmişinde kalır; onları yalnızca bir yönetici silebilir.",
  "e2e.fxe.seen_thumb": "Ondan üretilmiş bir küçük resim, asıl dosya kalıcı olarak silinene kadar sunucuda kalır. Arama dizinindeki kaydı, dosya çöp kutusuna gidince kaldırılır.",
  "e2e.fxe.seen_backups": "Bundan önce alınmış yedekler, kopyalar ve indirmeler onu hâlâ içerir.",
  "e2e.fxe.warn_body": "Bu dosya yalnızca bu parolayla ya da şifrelemeden sonra bir kez gösterilen kurtarma anahtarıyla açılır. filex ikisini de saklamaz. İkisini de kaybederseniz içerik kalıcı olarak kaybolur.",
  "e2e.fxe.escrow_body": "Bu kurulumda anahtar emaneti açık: işletmecisi, bu dosyayı parolanız olmadan açan bir anahtara sahip.",
  "e2e.fxe.encrypt_submit": "Şifrele",
  "e2e.fxe.encrypt_busy": "Şifreleniyor ve yükleniyor… %{percent}",
  "e2e.fxe.size_unknown": "Bu dosyanın boyutu henüz bilinmiyor. Klasörü yenileyip tekrar deneyin.",
  "e2e.fxe.bad_name": "Bu ad şifreli bir dosyanın içine mühürlenemez (255 baytı aşıyor ya da eğik çizgi veya denetim karakteri içeriyor). Önce dosyayı yeniden adlandırın.",
  "e2e.fxe.name_too_long": "Ad, sonuna “.fxe” eklenemeyecek kadar uzun. “Dosya adını da gizle” kutusunu işaretleyin ya da önce dosyayı yeniden adlandırın.",
  "e2e.fxe.encrypted": "“{name}” şifrelendi. Asıl dosya çöp kutusunda.",
  "e2e.fxe.original_kept": "Şifreli kopya kaydedildi, ancak “{name}” çöp kutusuna taşınamadı. Asıl dosyayı kendiniz silin.",
  "e2e.fxe.upload_too_big": "Bu sunucuda parçalı yükleme yok ve dosya bu tarayıcıdan tek parça gönderilemeyecek kadar büyük.",
  "e2e.fxe.unlock_title_open": "Şifreli dosyayı aç",
  "e2e.fxe.unlock_title_download": "Çözerek indir",
  "e2e.fxe.unlock_title_remove": "Şifrelemeyi kaldır",
  "e2e.fxe.unlock_lead": "“{name}” şifreli. Parolası burada, bu tarayıcıda denetlenir ve asla sunucuya gönderilmez.",
  "e2e.fxe.known_note": "Bu sekmede zaten açıldı - parola gerekmiyor.",
  "e2e.fxe.use_password": "Onun yerine parolayı kullan",
  "e2e.fxe.remove_warn_title": "Şifresiz içerik sunucuya geri döner",
  "e2e.fxe.remove_warn_body": "Dosya burada çözülür ve özgün adıyla şifresiz bir dosya olarak yüklenir: sunucu, yöneticileri, küçük resimler, arama ve yedekler onu yeniden okuyabilir. Şifreli dosya çöp kutusuna gider.",
  "e2e.fxe.unlock_open": "Aç",
  "e2e.fxe.unlock_download": "İndir",
  "e2e.fxe.unlock_remove": "Şifrelemeyi kaldır",
  "e2e.fxe.unlock_busy": "İşleniyor…",
  "e2e.fxe.save_again": "Kilit açıldı. Tarayıcınız, dosyanın nereye kaydedileceğini sormadan önce bir tıklama daha istiyor.",
  "e2e.fxe.save_button": "Kaydet…",
  "e2e.fxe.progress": "%{percent} tamamlandı",
  "e2e.fxe.wrong_password": "Parola yanlış.",
  "e2e.fxe.wrong_recovery": "Bu kurtarma anahtarı bu dosyayı açmıyor.",
  "e2e.fxe.damaged": "Bu dosya bozuk ya da kurcalanmış (veya açıldığından beri değişmiş). Hiçbir şey kaydedilmedi.",
  "e2e.fxe.not_readable": "Bu bir filex şifreli dosyası değil ya da başlığı bozuk.",
  "e2e.fxe.unsupported": "Bu dosya daha yeni bir filex gerektiriyor (gereken: {features}).",
  "e2e.fxe.downloaded": "“{name}” kaydedildi.",
  "e2e.fxe.removed": "Şifreleme kaldırıldı: “{name}” yeniden şifresiz bir dosya. Şifreli dosya çöp kutusunda.",
  "e2e.fxe.password_title": "Dosya parolasını değiştir",
  "e2e.fxe.password_cost": "Yalnızca dosyanın başlığı değişir: içerik bayt bayt aynen geri gönderilir ve kurtarma anahtarı çalışmaya devam eder.",
  "e2e.fxe.password_old_copies": "Bu dosyanın önceki bir sürümü - sürüm geçmişi, bir yedek, birinin indirdiği bir kopya - ESKİ parolayla açılmaya devam eder.",
  "e2e.fxe.password_done": "Parola değişti. Eski parola bu dosyayı artık açmıyor.",
  "e2e.recovery.warn_body_file": "Bu anahtara sahip olan herkes dosyayı okuyabilir. Onu paroladan ayrı bir yerde saklayın - parolanın yanında duran bir anahtar sizi unutmaktan korur, başkalarından değil.",
  "e2e.recovery.lead_file": "Bu anahtar dosyayı parolası olmadan açar. Yalnızca bir kez gösterilir - filex onu saklamaz ve bir daha gösteremez.",
  "e2e.dl.ctx_encrypted_copy": "Şifreli kopyayı indir",
  "e2e.dl.too_big": "Bu tarayıcı tek seferde en çok {limit} çözülmüş veri kaydedebilir, bu ise {size}. Chrome ya da Edge (doğrudan diske kaydeder), filex masaüstü uygulamasını kullanın ya da şifreli dosyayı indirip filex decrypt çalıştırın.",
  "e2e.dl.click_again": "Nereye kaydedileceğini seçmek için İndir’e bir kez daha tıklayın.",
  "e2e.dl.zip_started": "“{name}” içine çözülerek yazılıyor…",
  "e2e.dl.zip_done": "“{name}” kaydedildi - çözülmüş, gerçek adlarla.",
  "e2e.dl.zip_done_plain": "“{name}” kaydedildi. İçindeki {n} dosya hiç şifrelenmemişti ve olduğu gibi eklendi.",
  "e2e.dl.zip_done_plain_one": "“{name}” kaydedildi. İçindeki {n} dosya hiç şifrelenmemişti ve olduğu gibi eklendi.",
  "e2e.dl.zip_damaged": "Klasördeki bir dosya bozuk ya da kurcalanmış. İndirme durduruldu ve hiçbir şey kaydedilmedi.",
  "e2e.upload.streaming_unsupported": "Bu dosya 200 MB’tan büyük ve bu sunucuda onu parça parça şifreli göndermek için parçalı yükleme yok.",
  /* wiring:e2 fxe escrow - emanet anahtarı tek bir dosyayı açar, sahibine haber gider */
  "e2e.fxe.use_escrow": "Emanet anahtarını kullan",
  "e2e.fxe.escrow_warn_title": "Dosyanın sahibine haber gidecek",
  "e2e.fxe.escrow_warn_body": "Emanet anahtarıyla açılan dosyanın sahibine, dosya açılmadan önce bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.fxe.escrow_predates": "Bu kurulumun emanet anahtarı var, ama bu dosya onsuz şifrelenmiş (emanet burada açılmadan önce), bu yüzden emanet anahtarı onu açmaz. Parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.fxe.escrow_other_key": "Bu dosya BAŞKA bir kurulumun emanet anahtarına mühürlenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz.",
  "e2e.fxe.wrong_escrow": "Bu emanet anahtarı bu dosyayı açmıyor.",
  "e2e.fxe.escrow_notify_failed": "Dosyanın sahibine bildirim gönderilemedi, bu yüzden dosya açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.fxe.escrow_done": "Emanet anahtarıyla açıldı - dosya sahibine bildirildi",
  /* wiring:e2 fxe purge - yönetici aslını kalıcı olarak siler */
  "e2e.fxe.seen_trash_admin": "Asıl dosya çöp kutusuna gider ve çöp kutusunun saklama süresi dolana kadar orada kalır - aşağıda kalıcı olarak silmediğiniz sürece.",
  "e2e.fxe.seen_versions_admin": "Önceki sürümleri sürüm geçmişinde kalır - aşağıda kalıcı olarak silmediğiniz sürece.",
  "e2e.fxe.purge_label": "Aslını kalıcı olarak sil (yönetici)",
  "e2e.fxe.purge_hint": "Şifreli kopya kaydedilir kaydedilmez önceki sürümleri ve çöp kutusundaki kaydı silinir; açık hâlinden bu sunucuda hiçbir şey kalmaz. Geri alınamaz. Daha önce alınmış yedeklere ve kopyalara ulaşılmaz.",
  "e2e.fxe.purge_others": "Bu dosya sizin değil, {owner} adlı kullanıcının. Onun aslını ve sürümlerini kalıcı olarak sil.",
  "e2e.fxe.purge_others_unknown": "Bu dosyanın kayıtlı bir sahibi yok - sizin değil. Aslını ve sürümlerini kalıcı olarak sil.",
  "e2e.fxe.purge_others_required": "Başkasının dosyasını kalıcı olarak sildiğinizi onaylayın.",
  "e2e.fxe.purge_no_id": "Bu dosya henüz katalogda değil, bu yüzden kalıcı olarak silinemez. Klasörü yenileyip tekrar deneyin.",
  "e2e.fxe.purged": "“{name}” şifrelendi. Aslı, sürümleri ve çöp kutusundaki kaydı kalıcı olarak silindi.",
  "e2e.fxe.purge_failed": "“{name}” dosyasının şifreli kopyası kaydedildi, ama aslı kalıcı olarak silinemedi ({reason}). Çöp kutusundan ve sürüm geçmişinden silin.",
  /* wiring:e2 fxe big - bu tarayıcının belleğine sığmayan çözülmüş indirme */
  "e2e.big.title": "Bu tarayıcıda çözülemeyecek kadar büyük",
  "e2e.big.lead": "“{name}” çözüldüğünde {size}. Bu tarayıcı indirmeyi belleğinde çözer ve en çok {limit} tutabilir, bu yüzden hiçbir şey indirilmedi.",
  "e2e.big.lead_grew": "“{name}” çözülürken {limit} sınırını aştı. Bu tarayıcı indirmeyi belleğinde çözer ve daha fazlasını tutamaz, bu yüzden hiçbir şey kaydedilmedi.",
  "e2e.big.instead": "Bunun yerine kendi bilgisayarınızda çözün:",
  "e2e.big.step_file": "Şifreli dosyayı olduğu gibi indirin (aşağıdaki düğme).",
  "e2e.big.step_folder": "Şifreli klasörü zip olarak indirin (aşağıdaki düğme) - klasörün anahtar dosyası da içindedir.",
  "e2e.big.step_run": "Kaydettiğiniz klasörde filex decrypt komutunu çalıştırıp parolayı girin:",
  "e2e.big.copy": "Kopyala",
  "e2e.big.copied": "Kopyalandı",
  "e2e.big.other_ways": "Chrome, Edge ve filex masaüstü uygulaması, boyutu ne olursa olsun doğrudan diske çözer.",
  "e2e.big.close": "Kapat",
  "e2e.big.download_file": "Şifreli dosyayı indir",
  "e2e.big.download_folder": "Şifreli klasörü indir (zip)",
  /* /wiring:e2 fxe */
  /* ── dil:paket - İngilizce sabit yazılmış erişilebilir adlar */
  "breadcrumb.aria": "Konum yolu",
  "e2e.recovery_key_aria": "Kurtarma anahtarı",
  "modal.close": "Kapat",
  "modal.busy_close.keep": "Devam etsin",
  "modal.busy_close.confirm": "Durdur ve kapat",
  /* ── zil ve hesap menüsü (2026-09-27: masaüstü uygulamasının gezgini de
     aynılarını çizsin diye yönetim uygulamasından buraya taşındı). ⚠ ORTAK
     anahtarlar: yönetim uygulamasının kataloğunda her biri aynı adla, aynı
     İngilizce ve Türkçeyle durur (web/tests/i18n/langPackCatalogue.test.ts),
     bir dil paketi her birini iki ekran için bir kez çevirir. */
  "notifications.bell": "Bildirim çanı",
  "notifications.unreadCount": "{n} okunmamış",
  "notifications.title": "Bildirimler",
  "notifications.markAllRead": "Tümünü okundu işaretle",
  "notifications.markRead": "Okundu işaretle",
  "notifications.empty": "Henüz bildirim yok",
  "notifications.viewAll": "Tüm bildirimleri gör",
  "notifications.manageAdmin": "Bildirim yönetimi",
  "notifications.openTarget": "Bildirimin konusunu aç",
  "notifications.unreadOnly": "Sadece okunmamış",
  "notifications.pageOf": "Sayfa {page} / {pages} · toplam {total}",
  "notifications.severity.info": "Bilgi",
  "notifications.severity.warning": "Uyarı",
  "notifications.severity.error": "Hata",
  "notifications.severity.critical": "Kritik",
  "common.prev": "Önceki",
  "common.next": "İleri",
  "explore.account": "Hesap",
  /* ── kullanıcı ayarları penceresi (2026-09-27: masaüstü uygulaması aynı
     pencereyi kendi içinde açsın diye yönetim uygulamasından buraya taşındı).
     ⚠ ORTAK anahtarlar; ardından gelenler bu tablonun kendisinin (yönetim
     kataloğu onları yalnız vue-i18n'in anladığı sözdizimiyle yazar). */
  "common.cancel": "İptal",
  "common.close": "Kapat",
  "common.confirm": "Onayla",
  "common.currentPassword": "Mevcut parola",
  "common.email": "E-posta",
  "common.loading": "Yükleniyor…",
  "common.newPassword": "Yeni parola",
  "common.remove": "Kaldır",
  "common.save": "Kaydet",
  "common.saving": "Kaydediliyor…",
  "errors.generic": "Bir şeyler ters gitti",
  "errors.validationFailed": "Lütfen işaretli alanları kontrol edin",
  "install.desktopAllDownloads": "Tüm indirmeler ve sürüm notları",
  "install.desktopSubtitle": "Klasörleri bu bilgisayara eşitleyin, arka planda güncel kalsınlar. {platform} için mevcut.",
  "install.install": "Kur",
  "install.menuInstructions": "Tarayıcınızın menüsünü açıp “Uygulamayı yükle” ya da “Ana ekrana ekle”yi seçin.",
  "install.iosInstructions": "Paylaş'a dokunun (iOS 26'da önce ⋯, sonra Paylaş), ardından “Ana Ekrana Ekle” ve Ekle'ye dokunun.",
  "nav.themeAuto": "Otomatik",
  "nav.themeDark": "Karanlık",
  "nav.themeLight": "Aydınlık",
  "notifications.prefs.browser": "Tarayıcı bildirimleri",
  "notifications.prefs.browserHint": "Yeni bir şey geldiğinde sekmenin dışında bildirim göster. Bildirime tıklayınca konusu olan dosya, klasör ya da paylaşım açılır.",
  "notifications.prefs.desktopHandled": "Masaüstü uygulaması bunları kendisi gösteriyor",
  "notifications.prefs.enableBrowser": "Bildirimlere izin ver",
  "notifications.prefs.inApp": "Uygulama içi çan",
  "notifications.prefs.inAppHint": "Kapatırsanız çanınız boşalır. Hiçbir kayıt silinmez - yönetici tüm olayları görmeye devam eder.",
  "notifications.prefs.iosHomeScreen": "iPhone ve iPad'de bildirimler tarayıcı sekmesinde değil, ana ekrana eklenmiş {name} uygulamasında çalışır (iOS 16.4 ve sonrası).",
  "notifications.prefs.movedToSettings": "Kendi bildirim ayarlarınız - zil, tarayıcı bildirimleri, hangi olaylar - kullanıcı ayarlarınızda.",
  "notifications.prefs.openSettings": "Bildirim ayarlarımı aç",
  "notifications.prefs.permDefault": "İzin henüz istenmedi",
  "notifications.prefs.permDenied": "Bu tarayıcıda engellendi",
  "notifications.prefs.permDeniedHint": "Tarayıcı ayarlarından bu siteye bildirim iznini yeniden verin.",
  "notifications.prefs.permGranted": "Bu tarayıcıda izin verildi",
  "notifications.prefs.permUnsupported": "Bu tarayıcı bildirim gösteremiyor",
  "notifications.prefs.push": "Bu cihazda anlık bildirim",
  "notifications.prefs.pushAdded": "Eklendi: {date}",
  "notifications.prefs.pushDevices": "Anlık bildirim alan cihazlar",
  "notifications.prefs.pushDisabled": "Sunucuda kapatılmış (FILEX_PUSH_ENABLED).",
  "notifications.prefs.pushFailed": "Bu cihazda anlık bildirimler açılamadı.",
  "notifications.prefs.pushHint": "Zilinizin size söyledikleri, {name} kapalıyken de bu telefona ya da tarayıcıya ulaşır: aynı bildirimler, aynı anda.",
  "notifications.prefs.pushKeyUnreadable": "Sunucunun anlık bildirim anahtarı artık açılamıyor (FILEX_SECRET_KEY değişmiş). Yönetim → Bildirimler sayfasında anahtarı yenileyin.",
  "notifications.prefs.pushNoSecretKey": "Anlık bildirimler için sunucuda FILEX_SECRET_KEY tanımlı olmalı: bildirimleri imzalayan anahtar onunla şifrelenerek saklanır.",
  "notifications.prefs.pushOn": "Bu cihazda açık",
  "notifications.prefs.pushRemove": "Kaldır",
  "notifications.prefs.pushRemoveLabel": "Kaldır: {device}",
  "notifications.prefs.pushTest": "Deneme gönder",
  "notifications.prefs.pushTestNone": "Deneme hiçbir cihaza ulaşmadı.",
  "notifications.prefs.pushTestSent": "Deneme {count} cihaza gönderildi",
  "notifications.prefs.pushTestSent_one": "Deneme {count} cihaza gönderildi",
  "notifications.prefs.pushThisDevice": "Bu cihaz",
  "notifications.prefs.pushUnavailable": "Bu sunucuda kullanılamıyor",
  "notifications.prefs.pushUnnamed": "Bir cihaz",
  "notifications.prefs.pushUnsupported": "Bu tarayıcı anlık bildirim alamıyor",
  "notifications.prefs.saved": "Tercih kaydedildi",
  "notifications.prefs.title": "Bildirimleriniz",
  "profile.avatar.change": "Fotoğrafı değiştir",
  "profile.avatar.failed": "Bu görsel işlenemedi - başka bir tane deneyin.",
  "profile.avatar.help": "Adınızın yanında ve dosya yöneticisinin işbirliği çubuğunda görünür - hesabınızla açılan her istemcide. Otomatik olarak 160 piksele küçültülür.",
  "profile.avatar.label": "Profil fotoğrafı",
  "profile.avatar.notImage": "Lütfen bir görsel dosyası seçin.",
  "profile.locale": "Dil",
  "profile.passwordChanged": "Parola değiştirildi",
  "profile.saved": "Profil kaydedildi",
  "profile.totp.code": "Doğrulama kodu",
  "profile.totp.disable": "2FA'yı kapat",
  "profile.totp.disabled": "Pasif",
  "profile.totp.enable": "2FA'yı aç",
  "profile.totp.enabled": "Aktif",
  "profile.totp.recoveryHint": "Bunları şimdi kaydedin - doğrulayıcınızı kaybederseniz her biri bir kez oturum açmanızı sağlar. Yalnızca bu sefer gösterilir.",
  "profile.totp.recoveryTitle": "Kurtarma kodları",
  "profile.totp.scanHint": "Bu QR kodu doğrulayıcı uygulamanızla tarayın, sonra 6 haneli kodu girin.",
  "profile.totp.title": "İki adımlı doğrulama",
  "profile.username.label": "Kullanıcı adı",
  "quota.title": "Depolama kotası",
  "quota.tooltip": "{used} / {limit} kullanıldı ({percent})",
  "quota.unlimitedTooltip": "{used} kullanıldı · sınırsız",
  "userSettings.adminBadge": "Yönetici",
  "userSettings.ai.body": "Bu sürümde kullanıcıya özel asistan ayarı yok. filex'in sunduğu AI özellikleri tüm kurulum için yönetici tarafından yapılandırılır; bu yüzden burada sizin açıp kapatacağınız bir şey henüz bulunmuyor.",
  "userSettings.ai.soon": "Yakında",
  "userSettings.demoReadOnly": "Bu ortak bir demo hesabı; profili, parolası ve ikinci faktörü değiştirilemez.",
  "userSettings.footNote.ai": "Bu sekmede kaydedilecek bir şey yok.",
  "userSettings.footNote.notifications": "Değiştirdiğiniz anda kaydedilir.",
  "userSettings.footNote.preferences": "Değiştirdiğiniz anda kaydedilir.",
  "userSettings.footNote.profile": "Bu sekmedeki değişiklikler Kaydet'e bastığınızda kaydedilir.",
  "userSettings.footNote.security": "Buradaki her işlem kendi başına uygulanır.",
  "userSettings.heading": "Kullanıcı ayarları",
  "userSettings.headingSub": "Profilinizi, tercihlerinizi ve güvenliğinizi yönetin.",
  "userSettings.notifications.adminAlerts": "Yönetici uyarıları",
  "userSettings.notifications.adminAlertsHint": "Güncellemeler, kopyalar, oturum açma sağlayıcıları, kiracı alan adları ve yöneticilere yönelik diğer uyarılar",
  "userSettings.notifications.digestHint": "Acil olarak işaretlenen türler size hemen ulaşır. Diğerleri {minutes} dakika bekletilir ve klasör klasör tek bir özet olarak gelir.",
  "userSettings.notifications.digestOffHint": "Her tür size hemen ulaşır. Bir türün Acil anahtarını kapatırsanız o tür, klasör klasör tek bir özet olarak gelir.",
  "userSettings.notifications.events.archive_created": "Bir arşiv oluşturulduğunda",
  "userSettings.notifications.events.archive_extracted": "Bir arşiv çıkarıldığında",
  "userSettings.notifications.events.comment_added": "Biri bir dosyaya yorum yaptığında",
  "userSettings.notifications.events.drop_received": "İstek bağlantısıyla bir dosya geldiğinde",
  "userSettings.notifications.events.e2e_escrow_used": "Şifreli bir klasör emanet anahtarıyla açıldığında",
  "userSettings.notifications.events.e2e_password_changed": "Şifreli klasörünüzün parolası değiştiğinde",
  "userSettings.notifications.events.e2e_request_created": "Biri bir klasörü ya da dosyayı şifrelemek istediğinde",
  "userSettings.notifications.events.e2e_request_decided": "Şifreleme isteğiniz yanıtlandığında",
  "userSettings.notifications.events.file_deleted": "Bir dosya kalıcı olarak silindiğinde",
  "userSettings.notifications.events.file_infected": "Bir dosyada virüs bulunduğunda",
  "userSettings.notifications.events.file_moved": "Bir dosya taşındığında ya da adı değiştiğinde",
  "userSettings.notifications.events.file_trashed": "Bir dosya çöp kutusuna taşındığında",
  "userSettings.notifications.events.file_updated": "Bir dosya değiştiğinde",
  "userSettings.notifications.events.file_upload_failed": "Bir yükleme tamamlanmadığında",
  "userSettings.notifications.events.file_uploaded": "Yeni bir dosya geldiğinde",
  "userSettings.notifications.events.notification_digest": "Acil olarak işaretlemediğim bildirimlerin özeti",
  "userSettings.notifications.events.plugin_notice": "Kurulu bir uygulama size mesaj gönderdiğinde",
  "userSettings.notifications.events.share_created": "Biri paylaşım bağlantısı oluşturduğunda",
  "userSettings.notifications.eventsHint": "Birini kapatmak onu zilinizin dışında tutar. Hiçbir şey kaydedilmekten çıkmaz - yönetici her olayı görmeye devam eder.",
  "userSettings.notifications.eventsTitle": "Nelerden haberdar olayım",
  "userSettings.notifications.urgent": "Acil",
  "userSettings.notifications.urgentFor": "Hemen bildir: {event}",
  "userSettings.open": "Kullanıcı ayarları",
  "userSettings.prefs.appearance": "Görünüm",
  "userSettings.prefs.compact": "Sıkışık dosya listesi kullan",
  "userSettings.prefs.compactHint": "Dosya gezgininde daha dar satırlar.",
  "userSettings.prefs.desktopApp": "Masaüstü uygulaması",
  "userSettings.prefs.desktopAppHint": "Uygulamanın köşesindeki hatırlatmayı kapattığınızda bir daha çıkmaz - indirmeler burada kalır.",
  "userSettings.prefs.folderView": "Varsayılan klasör görünümü",
  "userSettings.prefs.folderViewHint": "Hiç değiştirmediğiniz bir klasörün nasıl açılacağı. Değiştirdiğiniz klasörler kendi görünümünü korur - bu ayar onlara dokunmaz.",
  "userSettings.prefs.fvColumns": "Varsayılan sütunlarınız özelleştirilmiş (“Bunu tüm klasörler için varsayılanım yap” ile ayarlandı).",
  "userSettings.prefs.fvColumnsReset": "Sıfırla",
  "userSettings.prefs.fvDir": "Yön",
  "userSettings.prefs.fvDir_asc": "Artan",
  "userSettings.prefs.fvDir_desc": "Azalan",
  "userSettings.prefs.fvForget": "Hepsini unut",
  "userSettings.prefs.fvInherit": "Sunucu varsayılanı ({value})",
  "userSettings.prefs.fvMode": "Görünüm",
  "userSettings.prefs.fvSort": "Sıralama",
  "userSettings.prefs.fvSort_modified": "Değiştirilme",
  "userSettings.prefs.fvSort_name": "Ad",
  "userSettings.prefs.fvSort_size": "Boyut",
  "userSettings.prefs.fvSort_type": "Tür",
  "userSettings.prefs.fvView_gallery": "Galeri",
  "userSettings.prefs.fvView_grid": "Izgara",
  "userSettings.prefs.fvView_list": "Liste",
  "userSettings.prefs.installApp": "Web uygulaması olarak kur",
  "userSettings.prefs.installAppLead": "Bu cihazın ana ekranına ekleyin: {name} bir uygulama gibi kendi penceresinde açılır.",
  "userSettings.prefs.languageHint": "Burada hemen uygulanır; bir sonraki tarayıcıda da açılsın diye hesabınıza kaydedilir.",
  "userSettings.prefs.mode": "Aydınlık ya da karanlık",
  "userSettings.prefs.modeHint": "Hangi sürümün çizileceği. Otomatik, işletim sisteminizi izler.",
  "userSettings.prefs.openTrigger": "Dosyaları açma",
  "userSettings.prefs.openTriggerDouble": "Çift tık",
  "userSettings.prefs.openTriggerHint": "Farenin dosyayı nasıl açtığı. Dokunmatik ekranda tek dokunuş her zaman açar, kutucuk her zaman seçer.",
  "userSettings.prefs.openTriggerSingle": "Tek tık",
  "userSettings.prefs.palette": "Renk paleti",
  "userSettings.prefs.paletteHint": "O sürümün hangi renklerden oluştuğu. Her paletin aydınlık ve karanlık bir sürümü vardır; bu ayarla üstteki ayar birlikte çalışır.",
  "userSettings.prefs.startPage": "Açılış sayfası",
  "userSettings.prefs.startPageHint": "Oturum açtığınızda ya da ana adrese geldiğinizde filex burayı açar. Doğrudan bir sayfanın bağlantısına tıkladığınızda yine o sayfaya gidersiniz.",
  "userSettings.prefs.startPage_admin": "Yönetim paneli",
  "userSettings.prefs.startPage_files": "Dosyalar",
  "userSettings.prefs.startPage_home": "Ana sayfa",
  "userSettings.prefs.timezone": "Saat dilimi",
  "userSettings.prefs.timezoneHint": "Tarihler bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir; böylece herkes aynı anı kendi saatiyle görür. Hesabınıza kaydedilir, başka bir tarayıcıda da geçerli olur.",
  "userSettings.prefs.timezoneNow": "{zone} bölgesinde şu an: {time}",
  "userSettings.saveChanges": "Değişiklikleri kaydet",
  "userSettings.security.passwordTitle": "Parolayı değiştir",
  "userSettings.security.totpDisabled": "İki adımlı doğrulama kapalı",
  "userSettings.security.totpEnabled": "İki adımlı doğrulama açık",
  "userSettings.subtitle.ai": "Burada henüz ayarlayabileceğiniz bir şey yok.",
  "userSettings.subtitle.notifications": "Zilinize ve masaüstünüze neyin ulaşacağı.",
  "userSettings.subtitle.preferences": "Uygulamanın cihazlarınızda nasıl göründüğü ve okunduğu.",
  "userSettings.subtitle.profile": "Adınız, e-postanız ve fotoğrafınız - başkalarının gördüğü bilgiler.",
  "userSettings.subtitle.security": "Parolanız ve ikinci faktörünüz.",
  "userSettings.tabs.ai": "AI asistanı",
  "userSettings.tabs.notifications": "Bildirimler",
  "userSettings.tabs.preferences": "Tercihler",
  "userSettings.tabs.profile": "Profil",
  "userSettings.tabs.security": "Güvenlik",
  "userSettings.apps.title": "Varsayılan uygulamalar",
  "userSettings.apps.lead": 'Bir dosyanın menüsünden seçin: Birlikte aç, Uygulama seç…, sonra "Her zaman bu uygulamayla aç" kutusunu işaretleyin. Yalnız yöneticinizin o tür için açık bıraktığı uygulamalar sunulur.',
  "userSettings.apps.empty": "Henüz hiçbir dosya türü için uygulama seçmediniz: her dosya, yöneticinizin ilk sıraya koyduğu uygulamayla açılır.",
  "userSettings.apps.reset": "Sıfırla",
  "userSettings.apps.resetAll": "Tümünü sıfırla",
  "userSettings.apps.unavailable": "Artık kullanılamıyor: siz yeniden seçene kadar {app} ile açılıyor.",
  "userSettings.apps.change": "{ext} dosyalarını açan uygulama",
  "userSettings.title": "Ayarlar",
  "users.fields.displayName": "Görünen ad",
  "profile.username.helpText": "Kullanıcı adınız. Oturum açarken bunu da e-postanızı da kullanabilirsiniz - bağlantı istemcileri (SFTP, FTP) için ise bu ad gerekir, çünkü oturum açtıkları addaki @ işareti onların ayar dosyalarında kaçış gerektirir.",
  "userSettings.prefs.fvKeptCount": "{count} klasör kendi görünümünü koruyor.",
  "userSettings.prefs.fvKeptCount_one": "{count} klasör kendi görünümünü koruyor."
}, Pz = "filex-base", Oz = /^(\/[A-Za-z0-9_~.-]+)+$/;
function Dz(e) {
  var a, i;
  const t = e ?? (typeof document < "u" ? document : null);
  if (!t) return "";
  let n = "";
  try {
    n = ((i = (a = t.querySelector(`meta[name="${Pz}"]`)) == null ? void 0 : a.getAttribute("content")) == null ? void 0 : i.trim()) ?? "";
  } catch {
    return "";
  }
  return !n || !Oz.test(n) || n.split("/").some((r) => r === "." || r === "..") ? "" : n;
}
function Ku() {
  return Dz();
}
function tue(e) {
  return Ku() + e;
}
function ay(e, t) {
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(t)) return t;
  const n = String(e ?? "").replace(/\/+$/, "");
  return !n || !t.startsWith("/") ? t : n + t;
}
function kl(e) {
  return String(e ?? Ku()).replace(/\/+$/, "");
}
const ei = $(0), np = $(!1), $0 = ["en", "tr"], vw = {
  en: "English",
  tr: "Türkçe",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  nl: "Nederlands",
  pt: "Português",
  pl: "Polski",
  ru: "Русский",
  uk: "Українська",
  ar: "العربية",
  fa: "فارسی",
  az: "Azərbaycanca",
  ja: "日本語",
  ko: "한국어",
  zh: "中文"
};
function T0(e) {
  if (vw[e]) return vw[e];
  try {
    const t = new Intl.DisplayNames([e], { type: "language" }).of(e);
    if (t && t.toLowerCase() !== e)
      return t.charAt(0).toLocaleUpperCase(e) + t.slice(1);
  } catch {
  }
  return e.toUpperCase();
}
const Pu = { en: Bs, tr: S0 }, va = /* @__PURE__ */ new Map(), Ou = /* @__PURE__ */ new Map(), ap = /^[a-z]{2,3}(-[a-z0-9]{2,8})*$/;
function Lz(e) {
  return ap.test(String(e ?? "").trim().toLowerCase().replace(/_/g, "-"));
}
function Ki(e) {
  const t = String(e ?? "").trim().toLowerCase().replace(/_/g, "-");
  if (!ap.test(t)) return "";
  if (va.has(t)) return t;
  const n = t.split("-")[0];
  if (wl(n) || va.has(n)) return n;
  for (const a of va.keys()) if (a.startsWith(`${n}-`)) return a;
  return t;
}
function wl(e) {
  return $0.includes(e);
}
function A0(e) {
  const t = {};
  for (const [n, a] of Object.entries(e ?? {}))
    typeof a != "string" || !a.trim() || !n || n.split(".").some((i) => i === "__proto__" || i === "constructor" || i === "prototype") || (t[n] = a);
  return t;
}
function Rz(e) {
  const t = String((e == null ? void 0 : e.code) ?? "").trim().toLowerCase().replace(/_/g, "-"), n = ap.test(t) ? t : "";
  n && (va.set(n, {
    code: n,
    label: String(e.label ?? "").trim() || T0(n),
    source: e.source === "plugin" ? "plugin" : e.source || "builtin",
    plugin: e.plugin,
    rtl: e.rtl === !0,
    strings: e.strings ? A0(e.strings) : null
  }), ei.value += 1);
}
function Nz(e) {
  va.clear(), Ou.clear();
  for (const t of e ?? []) Rz(t);
  ei.value += 1;
}
function nue(e) {
  let t = !1;
  for (const [n, a] of va)
    a.source === "plugin" && a.plugin === e && (va.delete(n), t = !0);
  t && (ei.value += 1);
}
function aue() {
  va.clear(), Ou.clear(), gr = {}, np.value = !1, ei.value += 1;
}
function _r() {
  ei.value;
  const e = $0.map((t) => ({
    code: t,
    label: T0(t),
    source: "builtin"
  }));
  for (const [t, n] of va)
    wl(t) || e.push({ code: t, label: n.label, source: n.source, plugin: n.plugin, rtl: n.rtl });
  return e;
}
function bf(e) {
  ei.value;
  const t = Ki(e);
  return !!t && (wl(t) || va.has(t));
}
function Iz(e) {
  return bf(e) ? !0 : !np.value && Lz(e);
}
function Bz(e) {
  const t = Ki(e), n = wl(t) ? Pu[t] : void 0, a = va.get(t);
  return a && a.strings === null && C0(t), !(a != null && a.strings) || !Object.keys(a.strings).length ? n ?? Pu.en : { ...Pu.en, ...n ?? {}, ...a.strings };
}
function E0(e) {
  const t = Ki(e), n = wl(t) ? Pu[t] : void 0, a = va.get(t);
  a && a.strings === null && C0(t);
  const i = a != null && a.strings && Object.keys(a.strings).length ? a.strings : null;
  return n ? { lang: t, strings: i ? { ...n, ...i } : n } : i ? { lang: t, strings: i } : { lang: "en", strings: Pu.en };
}
function iue(e) {
  var t;
  return { ...((t = va.get(Ki(e))) == null ? void 0 : t.strings) ?? {} };
}
let gr = {};
function C0(e) {
  const t = Ki(e), n = va.get(t);
  if (!n) return Promise.resolve(!1);
  if (n.strings !== null) return Promise.resolve(Object.keys(n.strings).length > 0);
  const a = Ou.get(t);
  if (a) return a;
  const i = gr.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!i) return Promise.resolve(!1);
  const r = kl(gr.base), l = (async () => {
    let d = {};
    try {
      const m = gr.headers ? await gr.headers() : {}, v = await i(`${r}/api/public/ui-locales/${encodeURIComponent(t)}`, {
        method: "GET",
        headers: { Accept: "application/json", ...m },
        credentials: "same-origin"
      });
      if (v.ok) {
        const b = await v.json();
        d = A0(b == null ? void 0 : b.strings);
      }
    } catch {
    }
    const f = va.get(t);
    return f === n && (f.strings = d, ei.value += 1), Ou.delete(t), Object.keys(d).length > 0;
  })();
  return Ou.set(t, l), l;
}
function z0(e, t) {
  if (t && (gr = t), !e) return _r();
  const n = Array.isArray(e.ui_locales) ? e.ui_locales : [], a = new Set(n.map((r) => String((r == null ? void 0 : r.code) ?? "").toLowerCase())), i = (e.locales ?? []).map((r) => String(r ?? "").trim().toLowerCase()).filter((r) => ap.test(r) && !wl(r) && !a.has(r)).map((r) => ({ code: r, source: "plugin" }));
  return Nz([...n, ...i]), np.value = !0, _r();
}
async function oue(e = {}) {
  gr = e;
  const t = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!t) return _r();
  const n = kl(e.base);
  try {
    const a = e.headers ? await e.headers() : {}, i = await t(`${n}/api/public/branding`, {
      method: "GET",
      headers: { Accept: "application/json", ...a },
      credentials: "same-origin"
    });
    if (i.ok)
      return z0(await i.json()), _r();
  } catch {
  }
  return np.value = !0, ei.value += 1, _r();
}
const yw = "en";
function Sa(e) {
  return e && Iz(e) ? Ki(e) : M0();
}
function M0() {
  try {
    const e = typeof navigator > "u" ? void 0 : navigator;
    if (!e) return yw;
    const t = e.languages && e.languages.length ? e.languages : [e.language];
    for (const n of t)
      if (n && bf(n))
        return Ki(n);
  } catch {
  }
  return yw;
}
const Fz = [".filex-trash", ".versions", ".thumbs", ".filex-open", ".filex-drafts"], Uz = ".filex-drafts", P0 = ".keepdir", O0 = new Set(Fz);
function D0(e) {
  let t = String(e ?? "").trim().replace(/\\/g, "/");
  const n = t.indexOf("://");
  return n >= 0 && (t = t.slice(n + 3)), t.split("/").filter((a) => a && a !== ".");
}
function ip(e) {
  const t = String(e ?? "").trim();
  return O0.has(t) || t === P0;
}
function kf(e) {
  const t = D0(e);
  return t.some((n) => O0.has(n)) ? !0 : t.length > 0 && t[t.length - 1] === P0;
}
function tv(e) {
  const t = String(e ?? "");
  if (!kf(t)) return t;
  const n = t.indexOf("://");
  return n >= 0 ? t.slice(0, n + 3) : "";
}
function gw(e) {
  const t = D0(e);
  return t.length !== 4 || t[0] !== Uz || !/^[1-9][0-9]*$/.test(t[1]) || !/^[0-9a-f]{8,32}$/.test(t[2]) || ip(t[3]) ? "" : t[2];
}
const wu = (e) => Array.isArray(e) ? e.filter((t) => typeof t == "string").map((t) => t.toLowerCase()) : [], dc = xa(null), L0 = xa({});
function Hz(e) {
  if (!e) return;
  const t = e.edit_kinds;
  t && typeof t == "object" && (dc.value = {
    office: new Set(wu(t.office)),
    text: new Set(wu(t.text)),
    names: new Set(wu(t.text_names)),
    prefixes: wu(t.text_mime_prefixes),
    mimes: new Set(wu(t.text_mimes))
  });
  const n = e.limits;
  n && typeof n == "object" && (L0.value = { ...n });
}
function rue() {
  return dc.value !== null;
}
function bw(e) {
  var t;
  return ((t = dc.value) == null ? void 0 : t.office.has(String(e ?? "").toLowerCase())) ?? !1;
}
function R0(e) {
  const t = dc.value;
  if (!t) return !1;
  const n = String(e ?? "").split(";")[0].trim().toLowerCase();
  return n ? t.mimes.has(n) || t.prefixes.some((a) => n.startsWith(a)) : !1;
}
function Kz(e) {
  const t = e.replace(/[\\/]+$/, "").split(/[\\/]/);
  return (t[t.length - 1] ?? "").toLowerCase();
}
function Vz(e) {
  const t = e.lastIndexOf(".");
  return t >= 0 ? e.slice(t + 1) : "";
}
function sue(e) {
  const t = dc.value;
  if (!t || !e) return !1;
  const n = Kz(String(e.basename ?? "")), a = String(e.extension ?? Vz(n)).toLowerCase();
  return a && t.text.has(a) || n && t.names.has(n) ? !0 : R0(e.mime_type);
}
function fc(e) {
  const t = L0.value[e];
  return typeof t == "number" && t > 0 ? t : void 0;
}
function lue(e) {
  return Array.from(e).length;
}
function iy(e, t) {
  if (!t) return e;
  const n = Array.from(e);
  return n.length > t ? n.slice(0, t).join("") : e;
}
const jz = E(() => {
  ei.value;
  const e = /* @__PURE__ */ new Set();
  for (const t of _r())
    t.rtl === !0 && e.add(t.code);
  return e;
});
function ol(e) {
  const t = Ki(e ?? "");
  return t && jz.value.has(t) ? "rtl" : "ltr";
}
function uue(e = typeof document < "u" ? document.documentElement : null) {
  if (!e) return () => {
  };
  const t = () => {
    const i = ol(e.getAttribute("lang"));
    e.getAttribute("dir") !== i && e.setAttribute("dir", i);
  };
  t();
  const n = typeof MutationObserver < "u" ? new MutationObserver(t) : null;
  n == null || n.observe(e, { attributes: !0, attributeFilter: ["lang"] });
  const a = Xe(ei, t);
  return () => {
    n == null || n.disconnect(), a();
  };
}
function Ga(e) {
  var n;
  const t = (n = e == null ? void 0 : e.closest) == null ? void 0 : n.call(e, '[dir="rtl"], [dir="ltr"]');
  return (t == null ? void 0 : t.getAttribute("dir")) === "rtl" ? "rtl" : "ltr";
}
function nv(e) {
  return e === "rtl" ? -1 : 1;
}
function wf(e, t) {
  const n = e === "ArrowRight" ? 1 : e === "ArrowLeft" ? -1 : 0;
  return n === 0 ? 0 : n * nv(t);
}
function Ar(e, t) {
  return t === "rtl" ? e.right : e.left;
}
function kw(e, t) {
  return t === "rtl" ? e.left : e.right;
}
function ww(e, t, n, a, i = 8) {
  const r = a === "rtl" ? n - e : e;
  let l = r;
  if (r + t > n - i) {
    const d = r - t;
    l = d >= i ? d : Math.max(i, n - t - i);
  }
  return a === "rtl" ? n - l - t : l;
}
function pc(e, t, n, a, i = 8) {
  const r = a === "rtl" ? n - e : e, l = r + t > n - i ? Math.max(i, n - i - t) : r;
  return a === "rtl" ? n - l - t : l;
}
const _f = "⁦", _w = "⁧", xf = "⁨", Vu = "⁩", qz = new RegExp("[\\u2066-\\u2069]?\\d[\\d.,]*(?:\\s?[A-Za-z%]{1,3})?[\\u2066-\\u2069]?\\s*\\/\\s*[\\u2066-\\u2069]?\\d[\\d.,]*(?:\\s?[A-Za-z%]{1,3})?[\\u2066-\\u2069]?|[A-Za-z][\\w+.-]*:[^\\s,\\u060C)\\u2066-\\u2069]+|\\/(?:[A-Za-z0-9_.~%+-]+\\/)+[A-Za-z0-9_.~%+-]*|(?<![A-Za-z0-9_.~%+:\\/-])\\/(?=[A-Za-z0-9_.~%+-]*[A-Za-z0-9])[A-Za-z0-9_.~%+-]*[A-Za-z0-9_~%+-](?!\\.?[A-Za-z0-9_~%+:-])", "g");
function Wz(e) {
  if (!(e[0] === _f || e[0] === xf || e[0] === _w) || e[e.length - 1] !== Vu) return !1;
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    if (a === _f || a === xf || a === _w ? t += 1 : a === Vu && (t -= 1), t === 0 && n < e.length - 1) return !1;
  }
  return t === 0;
}
function N0(e) {
  return e.replace(qz, (t, n, a) => {
    if (Wz(t)) return t;
    const i = a[n - 1], r = a[n + t.length];
    return (i === _f || i === xf) && r === Vu ? t : _f + t + Vu;
  });
}
function Vi(e, t) {
  return ol(e) === "rtl" ? N0(t) : t;
}
function Yz(e) {
  return xf + e + Vu;
}
function I0(e) {
  if (e === "code") return "ltr";
  if (e === "text") return "auto";
}
function Sf(e, t) {
  return typeof (e == null ? void 0 : e.foreign) == "function" ? e.foreign(t) : t;
}
function hc(e) {
  const t = (n, a = {}) => {
    const i = Bz(e)[n] ?? n, r = Object.entries(a).reduce((l, [d, f]) => l.replaceAll(`{${d}}`, String(f)), i);
    return Vi(e, r);
  };
  return t.foreign = (n) => Vi(e, n), t;
}
const B0 = {
  400: "err.status.400",
  401: "err.status.401",
  403: "err.status.403",
  404: "err.status.404",
  409: "err.status.409",
  413: "err.status.413",
  415: "err.status.415",
  422: "err.status.422",
  429: "err.status.429",
  500: "err.status.500",
  501: "err.status.501",
  /* ⚠ 502 and 504 are what an APP answers with (handlers/app_plugins.go
     callFail: any plugin error, and a plugin that ran out of time). */
  502: "err.status.502",
  503: "err.status.503",
  504: "err.status.504"
};
function cue(e, t) {
  return F0(e, hc(t));
}
function F0(e, t) {
  return t(B0[e] ?? (e >= 500 ? "err.status.500" : "err.status.other"));
}
function due(e) {
  return e >= 400 && e < 500 && e in B0;
}
function oy(e) {
  const t = e.message;
  return typeof t == "string" ? t.trim() : "";
}
function fue(e, t) {
  if (!e || typeof e != "object" || Array.isArray(e)) return "";
  const n = oy(e);
  return n ? Vi(t, n) : "";
}
function ry(e) {
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" && !Array.isArray(t) ? t : {};
  } catch {
    return {};
  }
}
function Gz(e) {
  const t = ry(e).error;
  return typeof t == "string" ? t : "";
}
function pue(e, t, n) {
  return sy(e, t, hc(n));
}
function sy(e, t, n, a = {}) {
  const i = a.server || oy(ry(t));
  return i ? Sf(n, i) : F0(e, n);
}
function pa(e, t, n) {
  const a = ry(t), i = oy(a), r = new Error(sy(e, t, hc(n), { server: i }));
  r.status = e, r.code = Gz(t), r.detail = t.slice(0, 300), r.said = !0, i && (r.server = i);
  const l = a.admin_hint;
  return typeof l == "string" && l && (r.hint = l), typeof a.reason == "string" && a.reason && (r.reason = a.reason), r;
}
function Er(e, t) {
  const n = (r) => Vi(t, r), a = e;
  if (!a || a.said !== !0) return n(a instanceof Error ? a.message : e ? String(e) : "");
  if (a.server) return n(a.server);
  const i = a.code ?? "";
  return i && !ly(i) && !/^[a-z0-9_]+$/.test(i) ? n(i) : n(a.message ?? "");
}
function av(e, t) {
  const n = new Error(hc(e)("err.network"));
  return n.detail = t instanceof Error ? t.message : t ? String(t) : "", n.said = !0, n;
}
function ly(e) {
  const t = e.trim();
  return t ? /^[[{]/.test(t) || // a JSON body
  /\b[1-5]\d\d\b\s+[A-Z][a-z]+/.test(t) || // "500 Internal Server Error"
  /\b[A-Z][A-Z0-9]+_[A-Z0-9_]+\b/.test(t) || // FILEX_SECRET_KEY
  /\b(panic|goroutine|stack trace|Traceback|at [\w$.]+ \()/i.test(t) || /^[\w.-]+: [\w.-]+(: |$)/.test(t) || // "protocolauth: no secret key…"
  /(^|\s)\/(?:[\w.-]+\/){2,}/.test(t) || // /var/lib/filex/…
  /\b[a-z][\w.-]*: [^:()]{1,60}: [a-z][\w.-]*: /i.test(t) || // a Go error chain "a: b: c: d"
  /\b(ECONNREFUSED|ETIMEDOUT|EOF|nil pointer|dial tcp|x509|context deadline exceeded)\b/i.test(t) : !1;
}
function Xz(e) {
  const t = /^(.*\S)\s*\(([^()]*)\)\s*$/.exec(e);
  return t && ly(t[2]) ? [t[1], t[2]] : [e, ""];
}
function U0(e, t, n = {}) {
  const a = e, i = (a == null ? void 0 : a.said) === !0, r = i ? (a == null ? void 0 : a.detail) ?? "" : a instanceof Error ? a.message : e ? String(e) : "", l = i ? n.t && typeof (a == null ? void 0 : a.status) == "number" ? sy(a.status, a.detail ?? "", n.t, { server: a.server }) : (a == null ? void 0 : a.message) || t : t;
  !i && r && typeof console < "u" && console.warn("[filex]", r);
  const d = Sf(n.t, l), f = Sf(n.t, r);
  return n.callerAdmin && r && r !== l ? { text: d, detail: f } : { text: d };
}
function $f(e, t, n = {}) {
  const i = e.op_type === "plugin" || e.op_type === "plugin-action" ? t("plugin.failed", { label: e.label || e.action || t("opc.kind.plugin") }) : t("toast.failed");
  return Jz(
    { error: e.error_message, error_code: e.error_code, error_engine: e.error_engine, error_text: e.error_text },
    i,
    t,
    n
  );
}
function Jz(e, t, n, a = {}) {
  const i = (e.error ?? "").trim(), r = a.callerAdmin === !0, l = (m) => Sf(n, m), d = (m) => r && i && i !== m ? { text: l(m), detail: l(i) } : { text: l(m) }, f = (e.error_text ?? "").trim();
  if (f) return d(f);
  switch (e.error_code) {
    case "cancelled":
      return { text: n("opc.status.aborted") };
    case "app": {
      const [m, v] = Xz(i);
      return m && !ly(m) ? v && r ? { text: l(m), detail: l(i) } : { text: l(m) } : d(t);
    }
  }
  return d(t);
}
const Zz = "DRAFT_LIMIT", Qz = "TARGET_TAKEN", eM = "FOLDER_GONE";
function uy(e, t) {
  const n = e == null ? void 0 : e.detail;
  if (n)
    try {
      const a = JSON.parse(n);
      return a && typeof a == "object" ? a[t] : void 0;
    } catch {
      return;
    }
}
function hue(e) {
  return uy(e, "code") === Zz;
}
function mue(e) {
  return uy(e, "code") === eM;
}
function vue(e) {
  const t = uy(e, "limit");
  return typeof t == "number" && t > 0 ? t : null;
}
function tM(e, t) {
  const n = e.replace(/\/+$/, ""), a = (l) => `${n}/${encodeURIComponent(l)}`;
  async function i(l, d = {}) {
    const f = await t.request(l, {
      ...d,
      headers: { "Content-Type": "application/json", ...d.headers ?? {} }
    }), m = await f.text().catch(() => "");
    let v = null;
    if (m)
      try {
        v = JSON.parse(m);
      } catch {
        v = null;
      }
    return { status: f.status, body: v, text: m };
  }
  function r(l, d) {
    throw pa(l, d, t.locale);
  }
  return {
    /**
     * New document, as a draft (the New document dialog's request): the same
     * body as `action=newfile`, answered with the same fields — `path` is the
     * draft's — plus the draft itself. A refusal throws; DRAFT_LIMIT is the
     * one the dialog says in its own words (isDraftLimit).
     */
    async create(l, d, f, m = {}) {
      var b;
      const v = await i(n, {
        method: "POST",
        body: JSON.stringify(m.exactName ? { path: l, name: d, type: f, exact_name: !0 } : { path: l, name: d, type: f })
      });
      return (v.status !== 201 || !((b = v.body) != null && b.draft)) && r(v.status, v.text), v.body;
    },
    /** Every draft of the caller's, across every storage they can see. */
    async list() {
      const l = await i(n);
      return (l.status !== 200 || !l.body) && r(l.status, l.text), { drafts: l.body.drafts ?? [], count: l.body.count ?? 0, limit: l.body.limit ?? 0 };
    },
    /** How many — the navigation panel's badge. */
    async count() {
      const l = await i(`${n}/count`);
      return (l.status !== 200 || !l.body) && r(l.status, l.text), { count: l.body.count ?? 0, limit: l.body.limit ?? 0 };
    },
    /** One draft — what an editor on a draft's path asks. */
    async get(l) {
      const d = await i(a(l));
      return (d.status !== 200 || !d.body) && r(d.status, d.text), d.body;
    },
    /**
     * Save the draft where it is meant to go — under `as` when given (only
     * ever the `suggested` name a taken answer offered).
     */
    async save(l, d) {
      var m, v;
      const f = await i(`${a(l)}/save`, { method: "POST", body: JSON.stringify(d ? { as: d } : {}) });
      if (f.status === 200 && ((m = f.body) != null && m.path))
        return { saved: !0, path: f.body.path, name: f.body.name ?? "", targetDir: f.body.target_dir ?? "" };
      if (f.status === 409 && ((v = f.body) == null ? void 0 : v.code) === Qz && f.body.suggested)
        return {
          saved: !1,
          taken: !0,
          name: f.body.name ?? "",
          suggested: f.body.suggested,
          targetDir: f.body.target_dir ?? ""
        };
      r(f.status, f.text);
    },
    /** Discard it: the draft goes to the trash (restorable until it ages out). */
    async discard(l) {
      const d = await i(a(l), { method: "DELETE" });
      d.status !== 200 && r(d.status, d.text);
    }
  };
}
function H0(e) {
  const t = e.indexOf("://"), n = t >= 0 ? e.slice(0, t) : "", a = (t >= 0 ? e.slice(t + 3) : e).replace(/^\/+|\/+$/g, "");
  return [n, ...a.split("/").filter(Boolean)].filter(Boolean).join(" / ");
}
const nM = ["zero", "one", "two", "few", "many", "other"], xw = ["one", "other"], Sw = /* @__PURE__ */ new Map();
function K0(e) {
  const t = String(e ?? ""), n = Sw.get(t);
  if (n !== void 0) return n;
  let a = null;
  if (typeof Intl < "u" && typeof Intl.PluralRules == "function")
    try {
      a = new Intl.PluralRules(t || "en");
    } catch {
      try {
        a = new Intl.PluralRules("en");
      } catch {
        a = null;
      }
    }
  return Sw.set(t, a), a;
}
const $w = /* @__PURE__ */ new Map(), aM = 999;
function iM(e) {
  const t = String(e ?? ""), n = $w.get(t);
  if (n) return n;
  let a = xw;
  const i = K0(t);
  if (i)
    try {
      const r = /* @__PURE__ */ new Set(["other"]);
      for (let l = 0; l <= aM; l++) r.add(i.select(l));
      a = nM.filter((l) => r.has(l));
    } catch {
      a = xw;
    }
  return $w.set(t, a), a;
}
function cy(e, t) {
  if (!Number.isFinite(t)) return "other";
  const n = Math.abs(t), a = K0(e);
  if (!a) return n === 1 ? "one" : "other";
  try {
    return a.select(n);
  } catch {
    return n === 1 ? "one" : "other";
  }
}
function yue(e, t, n) {
  const a = Math.abs(t), i = iM(e), r = cy(e, a);
  if (n === i.length && n > 1) {
    const l = i.indexOf(r);
    return l >= 0 ? l : n - 1;
  }
  return n === 1 ? 0 : n === 2 ? r === "one" ? 0 : 1 : n === 3 ? a === 0 ? 0 : r === "one" ? 1 : 2 : n - 1;
}
const oM = Object.freeze([
  "viewer",
  "host",
  "account",
  "device"
]);
function V0(e) {
  for (const t of oM) {
    if (t === "device") break;
    const n = e[t];
    if (typeof n == "string" && n && Ur(n)) return { zone: n, tier: t };
  }
  return { zone: void 0, tier: "device" };
}
const Du = "filex.timezone.viewer", Tf = "filex.timezone", rM = [
  "UTC",
  "Europe/Istanbul",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Paris",
  "Europe/Madrid",
  "Europe/Moscow",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Sao_Paulo",
  "Africa/Cairo",
  "Africa/Lagos",
  "Asia/Dubai",
  "Asia/Karachi",
  "Asia/Kolkata",
  "Asia/Shanghai",
  "Asia/Tokyo",
  "Asia/Seoul",
  "Asia/Singapore",
  "Australia/Sydney",
  "Pacific/Auckland"
];
function j0() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
function Ur(e) {
  if (!e) return !1;
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: e }), !0;
  } catch {
    return !1;
  }
}
function gue() {
  try {
    const e = Intl.supportedValuesOf;
    if (typeof e == "function") {
      const t = e("timeZone");
      if (Array.isArray(t) && t.length)
        return t.includes("UTC") ? [...t] : ["UTC", ...t];
    }
  } catch {
  }
  return [...rM];
}
function Tw(e, t) {
  const n = t ?? sM();
  try {
    const a = new Intl.DateTimeFormat("en-CA", {
      timeZone: n,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(e), i = (f) => {
      var m;
      return Number((m = a.find((v) => v.type === f)) == null ? void 0 : m.value);
    }, r = i("year"), l = i("month"), d = i("day");
    if (!Number.isFinite(r) || !Number.isFinite(l) || !Number.isFinite(d))
      throw new Error("unparsable");
    return Math.floor(Date.UTC(r, l - 1, d) / 864e5);
  } catch {
    return Math.floor(
      Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()) / 864e5
    );
  }
}
function Lu(e) {
  try {
    const t = localStorage.getItem(e);
    return t && Ur(t) ? t : "";
  } catch {
    return "";
  }
}
function q0(e, t) {
  try {
    t ? localStorage.setItem(e, t) : localStorage.removeItem(e);
  } catch {
  }
}
const dy = typeof window < "u", Cr = $(dy ? Lu(Du) : "");
function W0() {
  const e = $([]);
  return {
    set(t, n) {
      const a = e.value.find((i) => i.owner === t);
      if (n === null) {
        a && (e.value = e.value.filter((i) => i !== a));
        return;
      }
      a && a.zone === n || (e.value = [...e.value.filter((i) => i.owner !== t), { owner: t, zone: n }]);
    },
    of(t) {
      var n;
      return ((n = e.value.find((a) => a.owner === t)) == null ? void 0 : n.zone) ?? null;
    },
    current() {
      const t = e.value;
      return t.length ? t[t.length - 1].zone : "";
    },
    /** The newest answer among the owners `pick` accepts. */
    currentWhere(t) {
      const n = e.value.filter((a) => t(a.owner));
      return n.length ? n[n.length - 1].zone : "";
    }
  };
}
const mc = W0(), fo = W0(), op = /* @__PURE__ */ new Set(), fy = E(
  () => V0({
    viewer: Cr.value,
    host: mc.current(),
    account: fo.current()
  })
);
function sM() {
  return fy.value.zone;
}
function bue() {
  return fy.value;
}
const Y0 = Symbol("filex-explorer-clock");
function lM(e) {
  return e ? {
    viewer: Cr.value,
    host: mc.of(e) ?? "",
    account: fo.of(e) ?? fo.currentWhere((t) => op.has(t))
  } : cM();
}
function uM(e) {
  return e ? V0(lM(e)) : fy.value;
}
function G0(e) {
  return uM(e).zone;
}
function cM() {
  return {
    viewer: Cr.value,
    host: mc.current(),
    account: fo.current()
  };
}
function kue() {
  return Cr.value;
}
function dM(e) {
  const t = e && Ur(e) ? e : "";
  Cr.value = t, q0(Du, t);
  try {
    window.dispatchEvent(new CustomEvent("filex:timezone", { detail: t }));
  } catch {
  }
}
function fM(e, t) {
  mc.set(e, t && Ur(t) ? t : null);
}
function Qd(e, t, n = {}) {
  if (t == null) {
    fo.set(e, null);
    return;
  }
  const a = t && Ur(t) ? t : "";
  fo.set(e, a), n.remember && (op.add(e), q0(Tf, a));
}
function pM(e) {
  return fo.of(e);
}
function hM(e) {
  return {
    get: () => pM(e) ?? "",
    set: (t) => {
      Qd(e, t && Ur(t) ? t : "", { remember: !0 }), dM("");
    }
  };
}
function wue() {
  return dy ? Lu(Tf) : "";
}
function mM(e) {
  mc.set(e, null), fo.set(e, null), op.delete(e);
}
if (dy)
  try {
    window.addEventListener("storage", (e) => {
      if ((e.key === null || e.key === Du) && (Cr.value = Lu(Du)), e.key === null || e.key === Tf) {
        const t = Lu(Tf);
        for (const n of op) fo.set(n, t);
      }
    }), window.addEventListener("filex:timezone", (e) => {
      const t = e.detail;
      Cr.value = typeof t == "string" ? t && Ur(t) ? t : "" : Lu(Du);
    });
  } catch {
  }
const Aw = /* @__PURE__ */ new Map();
function fi(e) {
  if (!e || e === "en") return "en-US";
  if (e === "tr") return "tr-TR";
  let t = Aw.get(e);
  if (!t) {
    try {
      t = Intl.getCanonicalLocales(e)[0] || "en-US";
    } catch {
      t = "en-US";
    }
    Aw.set(e, t);
  }
  return t;
}
const Ew = [
  "unit.bytes",
  "unit.kb",
  "unit.mb",
  "unit.gb",
  "unit.tb",
  "unit.pb"
], vM = {
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB"
};
function yM(e, t = {}) {
  const n = t.empty ?? "-";
  if (e == null || !Number.isFinite(e) || e < 0) return n;
  const a = t.base ?? 1e3, i = t.unit ?? ((m) => vM[m]);
  let r = 0, l = e;
  for (; l >= a && r < Ew.length - 1; )
    l /= a, r += 1;
  const d = r === 0 ? 0 : t.digits === "fixed1" ? 1 : l < 10 ? 2 : 1;
  let f;
  if (t.numberLocale == null)
    f = l.toFixed(d);
  else {
    const m = gM(t.numberLocale, d, t.digits === "fixed1" ? d : 0);
    f = m ? m.format(l) : l.toFixed(d);
  }
  return `${f} ${i(Ew[r])}`;
}
const Id = /* @__PURE__ */ new Map();
function gM(e, t, n) {
  const a = `${e}|${t}|${n}`;
  if (!Id.has(a))
    try {
      Id.set(a, new Intl.NumberFormat(e, {
        maximumFractionDigits: t,
        minimumFractionDigits: n
      }));
    } catch {
      Id.set(a, null);
    }
  return Id.get(a) ?? null;
}
const Cw = /* @__PURE__ */ new Map();
function X0(e, t, n) {
  const a = G0(n), i = `${e}|${a ?? `device:${j0()}`}|${JSON.stringify(t)}`;
  let r = Cw.get(i);
  return r || (r = new Intl.DateTimeFormat(e, { ...t, timeZone: a }), Cw.set(i, r)), r;
}
function Af(e, t, n, a) {
  try {
    return X0(fi(t), n, a).format(e);
  } catch {
    return e.toISOString();
  }
}
const bM = /^(\d{4})-(\d{2})-(\d{2})$/, zw = /* @__PURE__ */ new Map();
function kM(e, t) {
  const n = bM.exec(e.trim());
  if (!n) return "";
  const a = new Date(Date.UTC(Number(n[1]), Number(n[2]) - 1, Number(n[3])));
  if (Number.isNaN(a.getTime())) return "";
  const i = fi(t);
  let r = zw.get(i);
  try {
    return r || (r = new Intl.DateTimeFormat(i, { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }), zw.set(i, r)), r.format(a);
  } catch {
    return "";
  }
}
function ef(e) {
  if (!e) return null;
  const t = new Date(e * (e < 1e12 ? 1e3 : 1));
  return Number.isNaN(t.getTime()) ? null : t;
}
function J0(e) {
  if (e == null || e === "") return null;
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  if (typeof e == "number") return ef(e);
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? null : t;
}
const wM = { month: "short", day: "numeric", year: "numeric" }, _M = { timeStyle: "short" };
function Z0(e, t, n = {}, a) {
  const i = J0(e);
  if (!i) return "";
  const r = Af(i, t, wM, a);
  return n.time ? `${r}, ${Af(i, t, _M, a)}` : r;
}
function xM(e, t, n) {
  const a = J0(e);
  if (!a) return "";
  const i = G0(n) ?? j0();
  return `${Af(a, t, { dateStyle: "full", timeStyle: "long" }, n)} (${i})`;
}
const Q0 = Symbol("filex-explorer-locale"), SM = ["count", "n", "days"];
function Mw(e, t, n, a = "en") {
  const i = SM.find((d) => d in t);
  if (i === void 0) return e;
  const r = cy(a, Number(t[i]));
  if (r === "other") return e;
  const l = `${e}_${r}`;
  return n(l) ? l : e;
}
function Cs(e, t) {
  const n = e[t];
  return typeof n == "string" && n ? n : void 0;
}
function $M(e, t, n = {}) {
  const a = e.strings, i = Mw(t, n, (d) => Cs(a, d) !== void 0, e.lang), r = Cs(a, i) ?? Cs(a, t);
  if (r !== void 0) return r;
  if (a === Bs) return t;
  const l = Mw(t, n, (d) => Cs(Bs, d) !== void 0, "en");
  return Cs(Bs, l) ?? Cs(Bs, t) ?? t;
}
function Pw(e, t) {
  return Object.entries(t).reduce(
    (n, [a, i]) => n.replaceAll(`{${a}}`, String(i)),
    e
  );
}
function e2(e, t, n, a) {
  const i = $M(e, t, n);
  if (!a) return Pw(i, n);
  const r = {};
  for (const [l, d] of Object.entries(n)) r[l] = typeof d == "string" ? Yz(d) : d;
  return N0(Pw(i, r));
}
function _ue(e, t, n = {}) {
  return e2(E0(e), t, n, ol(e) === "rtl");
}
function yt(e) {
  const t = () => typeof e == "function" ? e() : e.value, n = E(() => (ei.value, E0(t()))), a = bl() ? Hi(Y0, void 0) : void 0, i = E(() => ol(t()));
  function r(k, x = {}) {
    return e2(n.value, k, x, i.value === "rtl");
  }
  r.foreign = (k) => Vi(t(), k);
  function l(k) {
    return yM(k, {
      unit: (x) => r(x),
      numberLocale: fi(t())
    });
  }
  function d(k) {
    return k ? k.size_partial ? typeof k.size == "number" && k.size > 0 ? r("size.at_least", { size: l(k.size) }) : "-" : l(k.size) : l(null);
  }
  function f(k) {
    if (k != null && k.size_partial)
      return typeof k.size == "number" && k.size > 0 ? r("size.partial_hint") : r("size.unknown_hint");
  }
  function m(k) {
    if (k.basename === ".trash") return r("node.trash");
    if (typeof k.fxe_name == "string" && k.fxe_name) return k.fxe_name;
    const x = k.basename.match(/^\d{8}-\d{6}-[A-Za-z0-9]+__(.+)$/);
    return x ? x[1] : k.basename;
  }
  function v(k, x = {}) {
    return Z0(k, t(), x, a);
  }
  function b(k) {
    return xM(k, t(), a);
  }
  function _(k) {
    const x = k instanceof Date ? k : ef(k);
    return x ? Af(x, t(), { month: "long", year: "numeric" }, a) : "";
  }
  function w(k) {
    const x = k instanceof Date ? k : ef(k);
    if (!x) return "";
    try {
      return X0("en-CA", { year: "numeric", month: "2-digit" }, a).format(x);
    } catch {
      return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}`;
    }
  }
  return {
    t: r,
    formatSize: l,
    formatNodeSize: d,
    nodeSizeHint: f,
    formatDate: v,
    formatDateFull: b,
    formatMonthYear: _,
    zonedYearMonth: w,
    /**
     * zaman:z1 — the wire's `last_modified` as a `Date`, or null.
     *
     * Handed out because "seconds or milliseconds" is a fact about the WIRE,
     * not about formatting, and every caller that needs the instant itself
     * (rather than a string) was otherwise re-typing `v * (v < 1e12 ? 1000 :
     * 1)`. ListView had the third copy and used it to group rows by day — so
     * the grouping and the cell four pixels away were reading the same number
     * through two different converters.
     */
    toDate: ef,
    nodeDisplayName: m,
    /**
     * ⚠ RTL — which way this surface's language is written (`lib/direction`,
     * the server's one list). Bind it as `dir` on anything Teleported out of
     * the explorer's root: under `<body>` a menu inherits the HOST page's
     * direction, not the language its own words are in.
     */
    dir: i
  };
}
const zr = $(0), ju = $(0), TM = E(() => zr.value !== 0), xue = E(() => zr.value), Sue = E(() => ju.value);
function iv(e, t = Date.now()) {
  return zr.value === 0 && (zr.value = t || 1), e === "background" ? (ju.value += 1, "folded") : "say";
}
function ov() {
  zr.value === 0 && ju.value === 0 || (zr.value = 0, ju.value = 0);
}
function $ue() {
  zr.value = 0, ju.value = 0;
}
function AM(e) {
  const t = String(e ?? "get").toLowerCase();
  return t === "get" || t === "head" || t === "options" ? "background" : "action";
}
function t2(e) {
  const t = e.apiBase != null ? e.apiBase.replace(/\/+$/, "") : null;
  function n(i, r) {
    return i || (t === null ? null : `${t}${r}`);
  }
  const a = e.endpoint ?? (t !== null ? `${t}/api/files/manager` : null);
  if (!a)
    throw new Error(
      "[@brftech/filex-core] config requires either `apiBase` or `endpoint`"
    );
  return {
    manager: a,
    // Staged (chunked + resumable) uploads — what useUploadChunked speaks on
    // every driver. The {id} routes are derived from this one.
    uploadBegin: n(e.uploadBegin, "/api/files/upload/begin"),
    shareCreate: n(e.shareCreate, "/api/files/share"),
    shareList: n(e.shareList, "/api/files/share"),
    shareDelete: n(e.shareDelete, "/api/files/share/{uuid}"),
    limits: n(e.limits, "/api/files/limits"),
    capabilities: n(e.capabilities, "/api/files/capabilities"),
    me: n(e.me, "/api/auth/me"),
    archiveList: n(e.archiveList, "/api/files/archive/list"),
    archiveExtract: n(e.archiveExtract, "/api/files/archive/extract"),
    archiveCreate: n(e.archiveCreate, "/api/files/archive/create"),
    archiveAdd: n(e.archiveAdd, "/api/files/archive/add"),
    copy: n(e.copy, "/api/files/copy"),
    moveAsync: n(e.moveAsync, "/api/files/move"),
    deleteAsync: n(e.deleteAsync, "/api/files/delete"),
    opsList: n(e.opsList, "/api/files/ops"),
    opsShow: n(e.opsShow, "/api/files/ops/{id}"),
    onlyOfficeConfig: n(e.onlyOfficeConfig, "/api/files/onlyoffice/config"),
    saveText: n(e.saveText, "/api/files/save-text"),
    restore: n(e.restore, "/api/files/restore"),
    // filex trash: list soft-deleted nodes + restore one by node id.
    trashList: n(e.trashList, "/api/files/manager/trash"),
    trashRestore: n(e.trashRestore, "/api/files/manager/restore"),
    /* An operator's "Delete permanently" of one trash entry (`{id}`). */
    trashPurge: n(e.trashPurge, "/api/admin/trash/{id}"),
    /* An operator's permanent delete of a selection, in one request. */
    trashPurgeBatch: n(e.trashPurgeBatch, "/api/admin/trash/purge"),
    /* An operator's "Empty trash": POST starts it, GET follows it,
       `/preview` counts what it would delete. */
    trashEmpty: n(e.trashEmpty, "/api/admin/trash/empty"),
    /* An operator's hard delete of one version (`{id}`). */
    versionPurge: n(e.versionPurge, "/api/admin/versions/{id}"),
    /* wiring:e2 — escrow proof-of-possession, then the owner is told. */
    e2eEscrowChallenge: n(e.e2eEscrowChallenge, "/api/files/e2e/escrow/challenge"),
    e2eEscrowUsed: n(e.e2eEscrowUsed, "/api/files/e2e/escrow/used"),
    /* wiring:e2 convert — after a folder is encrypted in place. */
    e2eCleanup: n(e.e2eCleanup, "/api/files/e2e/cleanup"),
    /* wiring:e2 policy — may this account encrypt here, and asking for it. */
    e2eAllowed: n(e.e2eAllowed, "/api/files/e2e/allowed"),
    e2eRequests: n(e.e2eRequests, "/api/files/e2e/requests"),
    /* App plugins — docs/APP-PLUGINS-API.md. */
    pluginActions: n(e.pluginActions, "/api/files/plugins/actions"),
    pluginActionRun: n(e.pluginActionRun, "/api/files/plugins/actions/{plugin}/{action}/run"),
    pluginView: n(e.pluginView, "/api/files/plugins/views/{plugin}/{view}"),
    pluginViewEvent: n(e.pluginViewEvent, "/api/files/plugins/views/{plugin}/{view}/event"),
    pluginUsers: n(e.pluginUsers, "/api/files/plugins/users"),
    opsCancel: n(e.opsCancel, "/api/files/ops/{id}/cancel"),
    /* v4 — an app's own interface (AppFrame): its module, and its saves. */
    pluginUICall: n(e.pluginUICall, "/api/files/plugins/ui/{plugin}/{view}/call"),
    pluginUISave: n(e.pluginUISave, "/api/files/plugins/ui/{plugin}/{view}/save"),
    /* 0.54 - what an interface reads of its file, checked by the server (#211). */
    pluginUIRead: n(e.pluginUIRead, "/api/files/plugins/ui/{plugin}/{view}/read"),
    /* 0.56 - editing together (files:co-edit): the relay's routes (#189). */
    pluginUICoEdit: n(e.pluginUICoEdit, "/api/files/plugins/ui/{plugin}/{view}/coedit"),
    /* 0.52.0 - a paid app's license, as the app itself reads it (fx.license.get()). */
    pluginLicense: n(e.pluginLicense, "/api/files/plugins/license/{plugin}")
  };
}
const EM = ["allowed", "request", "denied"];
function CM(e) {
  return typeof e == "string" && EM.includes(e) ? e : "allowed";
}
async function zM(e) {
  if (typeof e == "function") {
    const t = e();
    return t instanceof Promise ? await t : t;
  }
  return e;
}
function MM(e) {
  return e ? "kind" in e ? e : e.type === "bearer" ? { kind: "bearer", token: e.token } : e.type === "csrf" ? { kind: "csrf", csrf: e.csrf } : { kind: "none" } : { kind: "none" };
}
const PM = 8 << 20;
function _l(e) {
  const t = t2(e), n = MM(e.auth);
  let a = null;
  async function i(ee = {}) {
    const he = { Accept: "application/json", ...ee };
    if (n.kind === "bearer") {
      const Oe = await zM(n.token);
      Oe && (he.Authorization = `Bearer ${Oe}`, a = Oe);
    } else if (n.kind === "csrf")
      he["X-CSRF-TOKEN"] = n.csrf, he["X-Requested-With"] = "XMLHttpRequest";
    else if (n.kind === "basic") {
      const Oe = btoa(`${n.user}:${n.pass}`);
      he.Authorization = `Basic ${Oe}`;
    }
    return he;
  }
  function r(ee = {}) {
    const he = { Accept: "application/json", ...ee };
    if (n.kind === "bearer") {
      const Oe = typeof n.token == "string" ? n.token : a;
      Oe && (he.Authorization = `Bearer ${Oe}`);
    } else if (n.kind === "csrf")
      he["X-CSRF-TOKEN"] = n.csrf, he["X-Requested-With"] = "XMLHttpRequest";
    else if (n.kind === "basic") {
      const Oe = btoa(`${n.user}:${n.pass}`);
      he.Authorization = `Basic ${Oe}`;
    }
    return he;
  }
  function l() {
    return n.kind === "csrf" ? "include" : "same-origin";
  }
  const d = () => Sa(e.locale);
  async function f(ee, he = {}) {
    const Oe = await m(ee, he);
    if (!Oe.ok) {
      const rt = await Oe.text().catch(() => "");
      throw pa(Oe.status, rt, d());
    }
    if (Oe.status === 204 || Oe.status === 205) return;
    const Ye = await Oe.text();
    if (Ye)
      return JSON.parse(Ye);
  }
  async function m(ee, he = {}) {
    const Oe = {
      // ⚠⚠ The language on SCREEN, not the one the browser was installed in.
      // Everything the server writes for a person — a plugin's surface, the
      // labels inside it, the message on a queued job — is rendered with the
      // request's `Accept-Language`. Chrome sends `en-US` whatever filex is
      // set to, so a Turkish window asked a signing wizard for its screens
      // and got "Identity" and an English help line in the middle of Turkish
      // ones. The window's own language is the only right answer here.
      "Accept-Language": fi(Sa(e.locale)),
      ...await i(),
      ...he.headers ?? {}
    };
    let Ye;
    try {
      Ye = await fetch(ee, {
        ...he,
        headers: Oe,
        credentials: l()
      });
    } catch (rt) {
      throw (rt == null ? void 0 : rt.name) === "AbortError" ? rt : (iv(AM(he.method)), av(d(), rt));
    }
    return ov(), Ye;
  }
  const v = t.manager.replace(/\/manager(\?.*)?$/, "/drafts"), b = tM(v, {
    request: m,
    get locale() {
      return d();
    }
  });
  function _(ee = "") {
    return t.manager.replace(/\/manager(\?.*)?$/, "/permissions") + ee;
  }
  async function w(ee) {
    return f(_() + "?path=" + encodeURIComponent(ee));
  }
  async function k(ee) {
    return f(_("/resolve") + "?email=" + encodeURIComponent(ee));
  }
  async function x(ee) {
    return f(_("/users") + "?q=" + encodeURIComponent(ee));
  }
  async function M(ee) {
    try {
      return await f(_("/groups") + "?q=" + encodeURIComponent(ee));
    } catch {
      return { groups: [] };
    }
  }
  async function A(ee, he) {
    return f(_("/groups/" + ee), { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level: he }) });
  }
  async function T(ee) {
    return f(_("/groups/" + ee), { method: "DELETE" });
  }
  async function N(ee) {
    return f(_(), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(ee) });
  }
  async function z(ee, he) {
    return f(_("/" + ee), { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level: he }) });
  }
  async function L(ee) {
    return f(_("/" + ee), { method: "DELETE" });
  }
  async function B(ee) {
    return f(_("/invite"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(ee) });
  }
  async function O(ee) {
    return f(_("/share-mail"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(ee) });
  }
  async function U(ee, he) {
    const Oe = new URLSearchParams({ share: ee });
    return he && Oe.set("lang", he), f(_("/share-message") + "?" + Oe.toString());
  }
  function S(ee) {
    const he = new URLSearchParams();
    for (const [Oe, Ye] of Object.entries(ee))
      Ye != null && he.set(Oe, String(Ye));
    return he.toString();
  }
  function F(ee, he = {}) {
    const Oe = t.manager.includes("?") ? "&" : "?";
    return `${t.manager}${Oe}${S({ q: ee, action: ee, ...he })}`;
  }
  async function I(ee) {
    return f(F("index", { path: tv(ee) }));
  }
  async function G(ee, he, Oe) {
    return f(F("search", { ...Oe ?? {}, path: tv(ee), filter: he }));
  }
  async function Y(ee, he = {}) {
    return (await ie(ee, he)).hits;
  }
  async function ie(ee, he = {}) {
    const Oe = t.manager.replace(/\/manager(\?.*)?$/, "/search"), Ye = Oe.includes("?") ? "&" : "?", rt = `${Oe}${Ye}${S({ ...he.narrow ?? {}, q: ee, limit: he.limit, scope: he.scope })}`, St = await f(rt);
    return {
      hits: Array.isArray(St == null ? void 0 : St.results) ? St.results : [],
      truncated: typeof (St == null ? void 0 : St.truncated) == "boolean" ? St.truncated : void 0,
      total: typeof (St == null ? void 0 : St.total) == "number" ? St.total : void 0
    };
  }
  async function me(ee, he, Oe) {
    const Ye = t.manager.replace(/\/manager(\?.*)?$/, "/search/match"), rt = await f(Ye, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ q: ee, names: he }),
      signal: Oe
    });
    return Array.isArray(rt == null ? void 0 : rt.matches) ? rt.matches : [];
  }
  async function q() {
    const ee = t.manager.replace(/\/manager(\?.*)?$/, "/quota/me");
    try {
      const he = await f(ee);
      return he && typeof he.used_bytes == "number" ? he : null;
    } catch {
      return null;
    }
  }
  async function C() {
    const ee = t.manager.replace(/\/manager(\?.*)?$/, "/quota/storages");
    try {
      const he = await f(ee);
      return Array.isArray(he == null ? void 0 : he.storages) ? he.storages : null;
    } catch {
      return null;
    }
  }
  async function re() {
    const ee = t.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "");
    try {
      const he = await f(`${ee}/api/app-store`);
      return {
        visible: (he == null ? void 0 : he.visible) === !0,
        stores: Array.isArray(he == null ? void 0 : he.stores) ? he.stores.filter((Oe) => typeof Oe == "string") : []
      };
    } catch {
      return null;
    }
  }
  async function de(ee) {
    return f(F("subfolders", { path: ee }));
  }
  async function V(ee, he) {
    return f(F("newfolder"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ee, name: he })
    });
  }
  async function W(ee, he, Oe, Ye = {}) {
    return f(F("newfile"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Ye.exactName ? { path: ee, name: he, type: Oe, exact_name: !0 } : { path: ee, name: he, type: Oe })
    });
  }
  async function ne(ee, he, Oe) {
    return f(F("newfile"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ee, name: he, type: Oe, exact_name: !0, dry_run: !0 })
    });
  }
  async function K(ee, he, Oe) {
    return f(F("rename"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ee, item: he, name: Oe })
    });
  }
  async function ce(ee, he, Oe) {
    return f(F("rename", { queued: 1 }), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ee, item: he, name: Oe })
    });
  }
  async function J(ee, he, Oe) {
    return f(F("move"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ee, item: Oe, items: he.map((Ye) => ({ path: Ye })) })
    });
  }
  async function H(ee, he) {
    return f(F("delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ee, items: he.map((Oe) => ({ path: Oe })) })
    });
  }
  async function X(ee, he) {
    const Oe = [];
    for (let Ye = 0; Ye < ee.length; Ye += 1e3) {
      const rt = ee.slice(Ye, Ye + 1e3), St = await f(F("allowed"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ permissions: he, items: rt.map((Q) => ({ path: Q })) })
      });
      rt.forEach((Q, te) => {
        var ke;
        return Oe.push(((ke = St.allowed) == null ? void 0 : ke[te]) ?? []);
      });
    }
    return Oe;
  }
  async function we(ee, he) {
    if (!t.copy) throw new Error("copy endpoint not configured");
    return f(t.copy, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ee, target: he })
    });
  }
  async function it(ee, he, Oe, Ye, rt) {
    const St = ee === "copy" ? t.copy : t.moveAsync;
    if (!St) throw new Error(`${ee} endpoint not configured`);
    return f(St, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: [he], target: Oe, name: Ye, ...rt ? { sourceDir: rt } : {} })
    });
  }
  async function Re(ee, he, Oe) {
    if (!t.moveAsync) throw new Error("moveAsync endpoint not configured");
    return f(t.moveAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ee, target: he, sourceDir: Oe })
    });
  }
  async function Be(ee, he) {
    if (!t.deleteAsync) throw new Error("deleteAsync endpoint not configured");
    return f(t.deleteAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ee, sourceDir: he })
    });
  }
  async function We(ee) {
    if (!t.restore) throw new Error("restore endpoint not configured");
    return f(t.restore, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ee })
    });
  }
  async function bt(ee) {
    if (!t.trashRestore) throw new Error("trashRestore endpoint not configured");
    const he = t.trashRestore.includes("?") ? "&" : "?", Oe = await f(
      Ne(`${t.trashRestore}${he}queued=1`),
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ node_ids: ee })
      }
    );
    return { ops: Oe.ops ?? [], summary: Oe.summary ?? "" };
  }
  async function at(ee, he = {}) {
    if (!t.trashList) throw new Error("trashList endpoint not configured");
    const Oe = [];
    ee && Oe.push(`storage=${encodeURIComponent(ee)}`), he.limit && Oe.push(`limit=${he.limit}`), he.offset && Oe.push(`offset=${he.offset}`);
    const Ye = t.trashList, rt = Oe.length ? `${Ye}${Ye.includes("?") ? "&" : "?"}${Oe.join("&")}` : Ye;
    return f(Ne(rt));
  }
  async function Ie(ee) {
    const he = t.trashRestore;
    if (!he) throw new Error("trashRestore endpoint not configured");
    return f(Ne(he), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_ids: ee })
    });
  }
  async function nt(ee, he = {}) {
    const Oe = t.trashPurgeBatch;
    if (!Oe) throw new Error("trashPurgeBatch endpoint not configured");
    const Ye = he.queued ? `${Oe}${Oe.includes("?") ? "&" : "?"}queued=1` : Oe;
    return f(Ne(Ye), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_ids: ee })
    });
  }
  async function dt() {
    const ee = t.trashEmpty;
    if (!ee) throw new Error("trashEmpty endpoint not configured");
    return f(Ne(`${ee.replace(/\/+$/, "")}/preview`));
  }
  async function Me(ee, he = {}) {
    const Oe = t.trashPurge;
    if (!Oe) throw new Error("trashPurge endpoint not configured");
    let Ye = Oe.replace("{id}", encodeURIComponent(String(ee)));
    he.queued && (Ye += `${Ye.includes("?") ? "&" : "?"}queued=1`);
    const rt = await f(Ye, { method: "DELETE" });
    return rt != null && rt.op ? { op: rt.op } : {};
  }
  async function be(ee) {
    const he = t.versionPurge;
    if (!he) throw new Error("versionPurge endpoint not configured");
    await f(he.replace("{id}", encodeURIComponent(String(ee))), { method: "DELETE" });
  }
  async function Ve(ee, he, Oe, Ye) {
    const rt = new FormData();
    rt.append("path", ee);
    for (const [Q, te] of Object.entries(Ye ?? {})) rt.append(Q, te);
    for (const Q of he)
      rt.append("file[]", Q, Q.name);
    const St = await i();
    return new Promise((Q, te) => {
      const ke = new XMLHttpRequest();
      ke.open("POST", F("upload"));
      for (const [Ge, pt] of Object.entries(St))
        Ge !== "Content-Type" && ke.setRequestHeader(Ge, pt);
      ke.withCredentials = l() === "include", ke.upload.onprogress = (Ge) => {
        Oe && Ge.lengthComputable && Oe(Math.round(Ge.loaded / Ge.total * 100));
      }, ke.onload = () => {
        if (ov(), ke.status >= 200 && ke.status < 300)
          try {
            Q(JSON.parse(ke.responseText));
          } catch (Ge) {
            te(Ge);
          }
        else
          te(pa(ke.status, ke.responseText || "", d()));
      }, ke.onerror = () => {
        iv("action"), te(av(d()));
      }, ke.send(rt);
    });
  }
  function Te(ee) {
    return F("download", { path: ee });
  }
  function qe(ee) {
    return F("preview", { path: ee });
  }
  async function De(ee, he = {}) {
    const Oe = await i(), Ye = await fetch(qe(ee), {
      headers: Oe,
      credentials: l(),
      // ⚠ The preview endpoint answers `Cache-Control: private, max-age=60`,
      // which is right for the thing it was built for — a viewer re-opening
      // an image — and wrong for anything the client treats as CONTROL data.
      // `.filex-e2e.json` is control data: after the client rewrites it
      // (recovery upgrade, escrow slot, escrow refusal) the next read inside
      // that minute came back PRE-write, so the folder looked un-upgraded
      // and the question filex had just been answered was asked again.
      // Measured 2026-09-05 in a real browser: decline the escrow offer,
      // reopen the folder, and the offer was back.
      cache: he.fresh ? "no-store" : "default"
    });
    if (!Ye.ok) {
      const te = await Ye.text().catch(() => "");
      throw pa(Ye.status, te, d());
    }
    const rt = await Ye.blob(), St = rt.type || Ye.headers.get("content-type") || "";
    return { url: URL.createObjectURL(rt), blob: rt, mime: St };
  }
  async function mt(ee) {
    const he = await i(), Oe = await fetch(qe(ee), {
      headers: he,
      credentials: l()
    });
    if (!Oe.ok) {
      const Ye = await Oe.text().catch(() => "");
      throw pa(Oe.status, Ye, d());
    }
    return Oe.arrayBuffer();
  }
  async function $t() {
    return t.limits ? f(t.limits) : { max_upload_mb: 1024 };
  }
  async function kt() {
    if (!t.capabilities)
      return {
        ffmpeg: !1,
        ghostscript: !1,
        max_chunk_mb: 5,
        upload_limit_mb: 1024,
        onlyoffice_url: e.onlyOfficeBase ?? null,
        drawio_url: e.drawioBase ?? null
      };
    const ee = await f(t.capabilities);
    return Hz(ee), ee;
  }
  async function Tt() {
    var he;
    if (!t.me) return null;
    const ee = await f(t.me);
    return !ee || !Array.isArray(ee.permissions) ? null : {
      admin: ((he = ee.user) == null ? void 0 : he.role) === "admin",
      permissions: [...ee.permissions, ...ee.permissions_in_folders ?? []],
      byFolder: ee.permissions_by_folder ?? []
    };
  }
  function xe(ee, he) {
    return Object.entries(he).reduce(
      (Oe, [Ye, rt]) => Oe.replaceAll(`{${Ye}}`, encodeURIComponent(String(rt))),
      ee
    );
  }
  function Ne(ee) {
    return `${ee}${ee.includes("?") ? "&" : "?"}lang=${encodeURIComponent(d())}`;
  }
  function fe(ee) {
    return /^https?:\/\//i.test(ee) ? ee : t.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "") + (ee.startsWith("/") ? ee : `/${ee}`);
  }
  function Se() {
    return t.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "") + "/_print/";
  }
  async function Z(ee) {
    if (!t.pluginLicense) throw new Error("pluginLicense endpoint not configured");
    return f(xe(t.pluginLicense, { plugin: ee }));
  }
  async function ge(ee, he, Oe) {
    if (!t.pluginUICall) throw new Error("pluginUICall endpoint not configured");
    return f(Ne(xe(t.pluginUICall, { plugin: ee, view: he })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Oe)
    });
  }
  async function ae(ee, he, Oe, Ye, rt) {
    if (!t.pluginUISave) throw new Error("pluginUISave endpoint not configured");
    const St = rt != null && rt.extra ? Object.entries(rt.extra).map(([se, ye]) => `&${encodeURIComponent(se)}=${encodeURIComponent(ye)}`).join("") : "", Q = ("path" in Oe ? `path=${encodeURIComponent(Oe.path)}` : `dir=${encodeURIComponent(Oe.dir)}&name=${encodeURIComponent(Oe.name)}`) + St, te = `${rt != null && rt.e2e ? "&e2e=1" : ""}${rt != null && rt.expect ? `&expect=${encodeURIComponent(rt.expect)}` : ""}`, ke = xe(t.pluginUISave, { plugin: ee, view: he }), Ge = `${ke}${ke.includes("?") ? "&" : "?"}${Q}${te}`, pt = fc("app_ui_save_chunk_bytes") ?? PM, Rt = (se, ye) => f(se, { method: "PUT", headers: { "Content-Type": "application/octet-stream" }, body: ye });
    if (Ye instanceof Blob && Ye.size <= pt)
      return f(Ge, {
        method: "PUT",
        headers: { "Content-Type": Ye.type || "application/octet-stream" },
        body: Ye
      });
    let Kt = "", Ft = 0;
    const dn = async (se, ye) => {
      const Pe = Kt ? `${Ge}&session=${encodeURIComponent(Kt)}&offset=${Ft}${ye ? "&final=1" : ""}` : `${Ge}&chunk=start${ye ? "&final=1" : ""}`, ut = await Rt(Pe, se);
      return ye || (Kt = ut.session ?? Kt, Ft = ut.received ?? Ft + se.size), ut;
    };
    if (Ye instanceof Blob)
      for (let se = 0; ; se += pt) {
        const ye = Math.min(se + pt, Ye.size), Pe = Ye.slice(se, ye);
        if (ye >= Ye.size) return await dn(Pe, !0);
        await dn(Pe, !1);
      }
    const Jt = Ye.getReader();
    let $n = [], Bn = 0;
    for (; ; ) {
      const { done: se, value: ye } = await Jt.read();
      for (ye && ye.byteLength && ($n.push(ye), Bn += ye.byteLength); Bn >= pt && !se; ) {
        const Pe = new Blob($n);
        await dn(Pe.slice(0, pt), !1);
        const ut = new Uint8Array(await Pe.slice(pt).arrayBuffer());
        $n = ut.byteLength ? [ut] : [], Bn = ut.byteLength;
      }
      if (se) {
        const Pe = new Blob($n);
        return !Kt && Pe.size <= pt ? f(Ge, { method: "PUT", headers: { "Content-Type": "application/octet-stream" }, body: Pe }) : await dn(Pe, !0);
      }
    }
  }
  async function ve(ee) {
    const he = await i(), Oe = await fetch(qe(ee), { headers: he, credentials: l(), cache: "no-store" });
    if (!Oe.ok) {
      const Ye = await Oe.text().catch(() => "");
      throw pa(Oe.status, Ye, d());
    }
    return Oe;
  }
  async function le(ee, he, Oe, Ye) {
    if (!t.pluginUIRead) {
      if (Ye != null && Ye.e2e) throw new Error("pluginUIRead endpoint not configured");
      return ve(Oe);
    }
    const rt = xe(t.pluginUIRead, { plugin: ee, view: he }), St = await i(), Q = Ye != null && Ye.e2e ? "&e2e=1" : "", te = await fetch(`${rt}${rt.includes("?") ? "&" : "?"}path=${encodeURIComponent(Oe)}${Q}`, {
      headers: St,
      credentials: l(),
      cache: "no-store"
    });
    if (!te.ok) {
      const ke = await te.text().catch(() => "");
      throw pa(te.status, ke, d());
    }
    return te;
  }
  function _e(ee, he) {
    if (!t.pluginUICoEdit) throw new Error("pluginUICoEdit endpoint not configured");
    return xe(t.pluginUICoEdit, { plugin: ee, view: he });
  }
  async function Ee(ee, he, Oe, Ye = {}) {
    return f(`${_e(ee, he)}/join`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: Oe, ...Ye })
    });
  }
  async function ht(ee, he, Oe, Ye, rt, St = {}) {
    const Q = `${_e(ee, he)}/${encodeURIComponent(Oe)}/${Ye}`;
    return St.keepalive === !0 && jt(Q, JSON.stringify(rt)) ? {} : f(Q, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(rt),
      keepalive: St.keepalive === !0
    });
  }
  function jt(ee, he) {
    if (n.kind !== "none") return !1;
    const Oe = typeof navigator > "u" ? void 0 : navigator;
    if (typeof (Oe == null ? void 0 : Oe.sendBeacon) != "function") return !1;
    try {
      return Oe.sendBeacon(ee, he);
    } catch {
      return !1;
    }
  }
  function tn(ee, he, Oe, Ye, rt) {
    return `${_e(ee, he)}/${encodeURIComponent(Oe)}/blob/${encodeURIComponent(Ye)}?client=${encodeURIComponent(rt.client)}&token=${encodeURIComponent(rt.token)}`;
  }
  async function Cn(ee, he, Oe, Ye, rt, St) {
    await f(tn(ee, he, Oe, Ye, rt), {
      method: "PUT",
      headers: { "Content-Type": "application/octet-stream" },
      body: new Blob([St])
    });
  }
  async function Lt(ee, he, Oe, Ye, rt) {
    const St = await m(tn(ee, he, Oe, Ye, rt), { cache: "no-store" });
    if (!St.ok) {
      const Q = await St.text().catch(() => "");
      throw pa(St.status, Q, d());
    }
    return St.arrayBuffer();
  }
  async function At() {
    if (!t.pluginActions) return { actions: [], views: [] };
    const ee = await f(t.pluginActions);
    return {
      actions: (ee == null ? void 0 : ee.actions) ?? [],
      views: (ee == null ? void 0 : ee.views) ?? [],
      ...ee != null && ee.open_rules ? { open_rules: ee.open_rules } : {}
    };
  }
  async function zn(ee, he, Oe) {
    if (!t.pluginActionRun) throw new Error("pluginActionRun endpoint not configured");
    return f(Ne(xe(t.pluginActionRun, { plugin: ee, action: he })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Oe)
    });
  }
  async function Bt(ee, he, Oe, Ye) {
    if (!t.pluginView) throw new Error("pluginView endpoint not configured");
    const rt = xe(t.pluginView, { plugin: ee, view: he }), St = [
      Oe ? `path=${encodeURIComponent(Oe)}` : "",
      Ye ? `section=${encodeURIComponent(Ye)}` : ""
    ].filter(Boolean);
    return f(Ne(rt + (St.length ? `?${St.join("&")}` : "")));
  }
  async function ft(ee, he, Oe) {
    if (!t.pluginViewEvent) throw new Error("pluginViewEvent endpoint not configured");
    return f(Ne(xe(t.pluginViewEvent, { plugin: ee, view: he })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Oe)
    });
  }
  async function Dn(ee, he) {
    if (!t.pluginUsers) throw Object.assign(new Error("pluginUsers endpoint not configured"), { status: 404 });
    const Oe = `${t.pluginUsers}?plugin=${encodeURIComponent(ee)}&q=${encodeURIComponent(he)}`, Ye = await f(Oe);
    return { users: (Ye == null ? void 0 : Ye.users) ?? [] };
  }
  async function Qn(ee) {
    if (!t.opsCancel) throw new Error("opsCancel endpoint not configured");
    await f(xe(t.opsCancel, { id: ee }), { method: "POST" });
  }
  async function Ln(ee) {
    if (!t.e2eEscrowChallenge) throw new Error("e2e escrow endpoint not configured");
    return f(t.e2eEscrowChallenge, {
      method: "POST",
      body: JSON.stringify({ path: ee })
    });
  }
  async function on(ee) {
    if (!t.e2eEscrowUsed) throw new Error("e2e escrow endpoint not configured");
    return f(t.e2eEscrowUsed, {
      method: "POST",
      body: JSON.stringify(ee)
    });
  }
  async function In(ee, he = 16) {
    const Oe = { ...await i(), Range: `bytes=0-${he - 1}` }, Ye = await fetch(qe(ee), { headers: Oe, credentials: l(), cache: "no-store" });
    if (!Ye.ok) {
      const te = await Ye.text().catch(() => "");
      throw pa(Ye.status, te, d());
    }
    if (!Ye.body) return new Uint8Array(await Ye.arrayBuffer()).slice(0, he);
    const rt = Ye.body.getReader(), St = new Uint8Array(he);
    let Q = 0;
    try {
      for (; Q < he; ) {
        const { done: te, value: ke } = await rt.read();
        if (te || !ke) break;
        const Ge = Math.min(ke.length, he - Q);
        St.set(ke.subarray(0, Ge), Q), Q += Ge;
      }
    } finally {
      rt.cancel().catch(() => {
      });
    }
    return St.slice(0, Q);
  }
  async function la(ee) {
    if (!t.e2eCleanup) throw new Error("e2e cleanup endpoint not configured");
    return f(t.e2eCleanup, { method: "POST", body: JSON.stringify(ee) });
  }
  async function vn(ee, he = {}) {
    var rt;
    const Oe = t.e2eAllowed;
    if (!Oe || !ee.length) return ee.map(() => "allowed");
    const Ye = [];
    try {
      for (let St = 0; St < ee.length; St += 1e3) {
        const Q = ee.slice(St, St + 1e3), te = await f(Oe, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: Q.map((ke) => typeof ke == "string" ? { path: ke } : ke.kind ? { path: ke.path, kind: ke.kind } : { path: ke.path })
          })
        });
        Q.forEach((ke, Ge) => {
          var pt;
          return Ye.push(CM((pt = te == null ? void 0 : te.encrypt) == null ? void 0 : pt[Ge]));
        });
      }
    } catch (St) {
      return console.warn("[filex] could not ask who may encrypt here; offering encryption as before", St), (rt = he.onFailed) == null || rt.call(he), ee.map(() => "allowed");
    }
    return Ye;
  }
  async function nn(ee) {
    if (!t.e2eRequests) throw new Error("e2e requests endpoint not configured");
    return f(t.e2eRequests, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ee)
    });
  }
  async function ln(ee) {
    if (!t.shareCreate) throw new Error("shareCreate endpoint not configured");
    return f(t.shareCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ee)
    });
  }
  async function kn(ee) {
    if (!t.shareList) return { shares: [] };
    const he = t.shareList.includes("?") ? "&" : "?";
    return f(`${t.shareList}${he}path=${encodeURIComponent(ee)}`);
  }
  async function Mn(ee) {
    if (!t.shareDelete) throw new Error("shareDelete endpoint not configured");
    const he = t.shareDelete.replace("{uuid}", encodeURIComponent(ee));
    return f(he, { method: "DELETE" });
  }
  async function Hn(ee, he) {
    if (!t.archiveList) throw new Error("archiveList endpoint not configured");
    return {
      entries: (await f(
        t.archiveList,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ path: ee, password: he })
        }
      )).entries.map((Ye) => ({
        name: Ye.name,
        size: Ye.size,
        isDir: Ye.is_dir,
        lastModified: Ye.mtime
      }))
    };
  }
  async function rn(ee, he = {}) {
    if (!t.archiveExtract) throw new Error("archiveExtract endpoint not configured");
    return f(t.archiveExtract, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ee, ...he })
    });
  }
  async function Ea(ee) {
    if (!t.archiveCreate) throw new Error("archiveCreate endpoint not configured");
    return f(t.archiveCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ee)
    });
  }
  async function pe(ee, he) {
    if (!t.archiveAdd) throw new Error("archiveAdd endpoint not configured");
    return f(t.archiveAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ee, files: he })
    });
  }
  function Le(ee = "") {
    return t.manager.replace(/\/manager(\?.*)?$/, "/versions") + ee;
  }
  async function Ue(ee) {
    const he = await f(
      Le() + "?node_id=" + encodeURIComponent(String(ee))
    );
    return Array.isArray(he == null ? void 0 : he.versions) ? he.versions : [];
  }
  async function He(ee, he, Oe = !0) {
    await f(Le("/restore"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        node_id: ee,
        version_id: he,
        snapshot_current: Oe
      })
    });
  }
  async function wt(ee) {
    await f(Le("/snapshot"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: ee })
    });
  }
  function et(ee = "") {
    return t.manager.replace(/\/manager(\?.*)?$/, "/comments") + ee;
  }
  async function oe(ee) {
    const he = await f(
      et() + "?node_id=" + encodeURIComponent(String(ee))
    );
    return Array.isArray(he == null ? void 0 : he.comments) ? he.comments : [];
  }
  async function je(ee, he) {
    return (await f(et(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: ee, body: he })
    })).comment;
  }
  async function Ke(ee) {
    await f(et("/" + encodeURIComponent(String(ee))), {
      method: "DELETE"
    });
  }
  async function _t() {
    const ee = t.manager.replace(/\/manager(\?.*)?$/, "/ws-ticket");
    try {
      return await f(ee, { method: "POST" });
    } catch {
      return null;
    }
  }
  return {
    // Realtime
    wsTicket: _t,
    // Manager
    index: I,
    search: G,
    globalSearch: Y,
    globalSearchPage: ie,
    matchNames: me,
    quotaMe: q,
    storageUsage: C,
    appStoreStatus: re,
    subfolders: de,
    newFolder: V,
    newFile: W,
    newFileCheck: ne,
    drafts: b,
    draftsBase: v,
    rename: K,
    renameQueued: ce,
    move: J,
    copy: we,
    moveAsync: Re,
    deleteAsync: Be,
    deleteItems: H,
    allowedAt: X,
    myPermissions: Tt,
    restore: We,
    listTrash: at,
    restoreBatch: Ie,
    restoreQueued: bt,
    purgeTrash: Me,
    purgeBatch: nt,
    trashEmptyPreview: dt,
    purgeVersion: be,
    uploadMultipart: Ve,
    downloadUrl: Te,
    previewUrl: qe,
    fetchBlob: De,
    fetchArrayBuffer: mt,
    // Peripheral
    limits: $t,
    capabilities: kt,
    /* wiring:e2 */
    e2eEscrowChallenge: Ln,
    e2eEscrowUsed: on,
    e2eCleanup: la,
    /* wiring:e2 policy */
    e2eAllowedAt: vn,
    e2eRequest: nn,
    fetchHead: In,
    transferNamed: it,
    /* App plugins */
    pluginActions: At,
    pluginActionRun: zn,
    pluginView: Bt,
    pluginViewEvent: ft,
    pluginUsers: Dn,
    opsCancel: Qn,
    appUIUrl: fe,
    printFrameUrl: Se,
    pluginUICall: ge,
    pluginUISave: ae,
    pluginUIRead: le,
    pluginLicense: Z,
    coeditJoin: Ee,
    coeditCall: ht,
    coeditBlobPut: Cn,
    coeditBlobGet: Lt,
    fetchResponse: ve,
    createShare: ln,
    listShares: kn,
    revokeShare: Mn,
    archiveList: Hn,
    archiveExtract: rn,
    archiveCreate: Ea,
    archiveAdd: pe,
    // Version history (koru:k1 inspector)
    listVersions: Ue,
    restoreVersion: He,
    snapshotVersion: wt,
    // Node comments (calisma:d3 inspector)
    listComments: oe,
    addComment: je,
    deleteComment: Ke,
    // Permissions (RBAC panel)
    listPermissions: w,
    resolveEmail: k,
    searchUsers: x,
    searchGroups: M,
    addPermission: N,
    updatePermission: z,
    deletePermission: L,
    updateGroupPermission: A,
    deleteGroupPermission: T,
    invitePermission: B,
    shareMail: O,
    shareMessage: U,
    // Internals (exposed for useUploadChunked + PreviewModal)
    endpoints: t,
    authHeaders: i,
    authHeadersSync: r,
    credentialsMode: l,
    jsonFetch: f,
    withScreenLang: Ne
  };
}
function Gs() {
  const e = globalThis.crypto;
  if (typeof (e == null ? void 0 : e.randomUUID) == "function") return e.randomUUID();
  const t = new Uint8Array(16);
  if (typeof (e == null ? void 0 : e.getRandomValues) == "function") e.getRandomValues(t);
  else for (let a = 0; a < t.length; a++) t[a] = Math.floor(Math.random() * 256);
  t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128;
  const n = Array.from(t, (a) => a.toString(16).padStart(2, "0")).join("");
  return `${n.slice(0, 8)}-${n.slice(8, 12)}-${n.slice(12, 16)}-${n.slice(16, 20)}-${n.slice(20)}`;
}
const py = "filex:uploads:v1";
function cm(e) {
  if (!e) return;
  const t = Date.parse(e);
  return Number.isFinite(t) ? t : void 0;
}
function dm(e, t) {
  return [e, t.name, t.size, t.lastModified ?? 0].join("\0");
}
function OM() {
  try {
    return typeof localStorage > "u" ? null : (localStorage.getItem(py), localStorage);
  } catch {
    return null;
  }
}
function hy(e) {
  if (!e) return {};
  try {
    const t = e.getItem(py);
    if (!t) return {};
    const n = JSON.parse(t);
    return n && typeof n == "object" ? n : {};
  } catch {
    return {};
  }
}
function my(e, t) {
  if (e)
    try {
      e.setItem(py, JSON.stringify(t));
    } catch {
    }
}
function n2(e, t = Date.now()) {
  const n = hy(e);
  let a = !1;
  for (const [i, r] of Object.entries(n)) {
    const l = r == null ? void 0 : r.expiresAt;
    (!(r != null && r.uploadId) || typeof l != "number" || !Number.isFinite(l) || t >= l) && (delete n[i], a = !0);
  }
  return a && my(e, n), n;
}
function Ow(e, t, n = Date.now()) {
  return n2(e, n)[t] ?? null;
}
function Dw(e, t, n, a = Date.now()) {
  const i = hy(e);
  i[t] = { ...n, updatedAt: a }, my(e, i);
}
function _u(e, t) {
  const n = hy(e);
  t in n && (delete n[t], my(e, n));
}
function DM(e, t = Date.now()) {
  return Object.values(n2(e, t)).sort((n, a) => a.updatedAt - n.updatedAt);
}
function LM(e) {
  return !e || e === "staging";
}
function Lw(e) {
  return e.stagedUnsupported = !0, e;
}
function vy(e) {
  return !!(e != null && e.stagedUnsupported);
}
function RM(e, t, n = OM()) {
  const a = e.chunkSize ?? 8388608;
  function i() {
    const w = t.endpoints.uploadBegin;
    return w ? w.replace(/\/begin$/, "") : t.endpoints.manager.replace(/\/manager(\?.*)?$/, "/upload");
  }
  function r() {
    return !!i();
  }
  function l() {
    return a;
  }
  function d(w) {
    return r() && w.size > l();
  }
  function f(w, k) {
    return Ow(n, dm(w, k));
  }
  function m() {
    return DM(n);
  }
  async function v(w) {
    _u(n, dm(w.path, { name: w.name, size: w.size, lastModified: w.lastModified }));
    try {
      await t.jsonFetch(`${i()}/${encodeURIComponent(w.uploadId)}`, { method: "DELETE" });
    } catch {
    }
  }
  async function b(w) {
    return t.jsonFetch(`${i()}/${encodeURIComponent(w)}`);
  }
  async function _(w) {
    var F, I, G;
    const k = dm(w.path, w.file), x = w.source ?? null, M = x ? x.size : w.file.size, A = x ? null : n, T = {
      id: Gs(),
      file: w.file,
      path: w.path,
      totalBytes: M,
      uploadedBytes: 0,
      percent: 0,
      status: "initializing",
      cancel: () => {
      }
    };
    let N = !1, z = null, L;
    T.cancel = () => {
      var Y;
      N = !0, z == null || z.abort(), (Y = x == null ? void 0 : x.cancel) == null || Y.call(x);
    };
    let B = 0;
    function O(Y = 0) {
      var ie;
      T.uploadedBytes = Math.min(T.totalBytes, B + Y), T.percent = T.totalBytes > 0 ? Math.min(100, Math.round(T.uploadedBytes / T.totalBytes * 100)) : T.status === "done" ? 100 : 0, (ie = w.onProgress) == null || ie.call(w, T);
    }
    try {
      if (!r())
        throw Lw(new Error("staged upload endpoint not configured"));
      const Y = i();
      let ie = "", me = w.chunkSize ?? a, q;
      L = void 0;
      const C = Ow(A, k);
      if (C)
        try {
          const W = await b(C.uploadId);
          LM(W.state) && (W.total_size ?? 0) === M ? (ie = C.uploadId, q = cm(W.expires_at) ?? C.expiresAt, me = W.chunk_size ?? W.chunkSize ?? C.chunkSize, B = W.offset ?? 0, T.resumedFrom = B) : _u(A, k);
        } catch {
          _u(A, k);
        }
      if (!ie) {
        let W;
        try {
          W = await t.jsonFetch(`${Y}/begin`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              path: w.path,
              name: w.file.name,
              size: M,
              mime: w.file.type || "application/octet-stream",
              // Asked for, not imposed: the server clamps this to its own
              // limits and its answer is what the loop below uses.
              chunk_size: w.chunkSize ?? a
            })
          });
        } catch (ne) {
          const K = ne.status;
          throw (K === 404 || K === 501) && Lw(ne), ne;
        }
        if (!(W != null && W.id)) throw new Error("begin returned no upload id");
        ie = W.id, q = cm(W.expires_at), me = W.chunk_size ?? W.chunkSize ?? me, B = W.offset ?? 0;
      }
      T.uploadId = ie, T.status = "uploading", Dw(A, k, {
        uploadId: ie,
        path: w.path,
        name: w.file.name,
        size: M,
        lastModified: w.file.lastModified,
        chunkSize: me,
        offset: B,
        expiresAt: q
      }), O();
      const re = 4;
      for (; B < M; ) {
        if (N) throw new DOMException("Aborted by user", "AbortError");
        const W = Math.min(B + me, M), ne = x ? await x.read(B, W) : w.file.slice(B, W);
        let K = -1, ce = null;
        for (let J = 0; J < re; J++) {
          if (J > 0) {
            if (await Nw(300 * J + Math.floor(Math.random() * 150)), N) throw new DOMException("Aborted by user", "AbortError");
            try {
              const H = await b(ie);
              if ((H.offset ?? 0) >= W) {
                K = H.offset ?? W;
                break;
              }
              if ((H.offset ?? 0) !== B) {
                B = H.offset ?? B, O(), K = -2;
                break;
              }
            } catch {
            }
          }
          try {
            K = await U(ie, ne, B, W, M);
            break;
          } catch (H) {
            const X = H instanceof Error ? H : new Error(String(H));
            if (N || X.name === "AbortError") throw X;
            const we = X.status;
            if (we && we !== 400 && we !== 409 && we < 500) throw X;
            ce = X;
          }
        }
        if (K !== -2) {
          if (K < 0) throw ce ?? new Error("chunk upload failed");
          if (K <= B)
            throw console.warn("[filex] upload stalled at byte", B), new Error(hc(Sa(e.locale))("err.upload_stalled"));
          B = K, L !== void 0 && (q = L), O(), Dw(A, k, {
            uploadId: ie,
            path: w.path,
            name: w.file.name,
            size: M,
            lastModified: w.file.lastModified,
            chunkSize: me,
            offset: B,
            expiresAt: q
          });
        }
      }
      if (N) throw new DOMException("Aborted by user", "AbortError");
      T.status = "committing", O();
      const de = new URLSearchParams(w.commitQuery ?? {}).toString(), V = await t.jsonFetch(
        `${Y}/${encodeURIComponent(ie)}/commit${de ? `?${de}` : ""}`,
        { method: "POST" }
      );
      return _u(A, k), T.opId = V == null ? void 0 : V.op_id, T.nodeId = V == null ? void 0 : V.node_id, w.waitForTransfer !== !1 && (V != null && V.op_id) && t.endpoints.opsShow && (T.status = "transferring", O(), await S(V.op_id)), T.status = "done", B = T.totalBytes, O(), (F = w.onDone) == null || F.call(w, T, V), V;
    } catch (Y) {
      const ie = Y instanceof Error ? Y : new Error(String(Y));
      if (T.status = ie.name === "AbortError" ? "aborted" : "error", T.error = ie.message, O(), vy(ie) || (I = x == null ? void 0 : x.cancel) == null || I.call(x), T.uploadId && (T.status === "aborted" || x)) {
        _u(A, k);
        try {
          await t.jsonFetch(`${i()}/${encodeURIComponent(T.uploadId)}`, {
            method: "DELETE"
          });
        } catch {
        }
      }
      throw (G = w.onError) == null || G.call(w, T, ie), ie;
    }
    function U(Y, ie, me, q, C) {
      return new Promise((re, de) => {
        const V = new XMLHttpRequest();
        z = V, V.open("PUT", `${i()}/${encodeURIComponent(Y)}`);
        const W = t.authHeadersSync({
          "Content-Type": "application/octet-stream",
          "Content-Range": `bytes ${me}-${q - 1}/${C}`
        });
        for (const [ne, K] of Object.entries(W)) V.setRequestHeader(ne, K);
        V.withCredentials = t.credentialsMode() === "include", V.upload.onprogress = (ne) => {
          ne.lengthComputable && O(ne.loaded);
        }, V.onload = () => {
          if (z = null, ov(), V.status >= 200 && V.status < 300) {
            try {
              const ne = JSON.parse(V.responseText);
              L = cm(ne.expires_at) ?? L, re(ne.offset ?? q);
            } catch {
              re(q);
            }
            return;
          }
          de(pa(V.status, V.responseText || "", Sa(e.locale)));
        }, V.onerror = () => {
          z = null, iv("action"), de(av(Sa(e.locale)));
        }, V.onabort = () => {
          z = null, de(new DOMException("Aborted", "AbortError"));
        }, V.send(ie);
      });
    }
    async function S(Y) {
      const ie = t.endpoints.opsShow;
      if (!ie) return;
      const me = ie.replace("{id}", String(Y));
      let q = 200, C = 0;
      for (; ; ) {
        if (N) throw new DOMException("Aborted by user", "AbortError");
        try {
          const re = await t.jsonFetch(me);
          if ((re == null ? void 0 : re.status) === "ok") return;
          if ((re == null ? void 0 : re.status) === "failed" || (re == null ? void 0 : re.status) === "partial")
            throw new Rw(re.error || "transfer failed");
          C = 0;
        } catch (re) {
          if (re instanceof Rw || re.name === "AbortError") throw re;
          if (++C >= NM) return;
        }
        await Nw(q), q = Math.min(q * 2, 2e3);
      }
    }
  }
  return {
    uploadFile: _,
    /** True when this file is big enough (and the endpoints exist) to chunk. */
    shouldChunk: d,
    /** The size at which chunking kicks in. */
    threshold: l,
    resumableFor: f,
    listResumable: m,
    discardResumable: v
  };
}
const NM = 6;
class Rw extends Error {
  constructor(t) {
    super(t), this.name = "TransferFailedError";
  }
}
function Nw(e) {
  return new Promise((t) => setTimeout(t, e));
}
function Iw(e) {
  const t = $(/* @__PURE__ */ new Set()), n = $(null);
  function a(_, w = {}) {
    if (w.shift && n.value) {
      const k = e(), x = k.findIndex((z) => z.path === n.value), M = k.findIndex((z) => z.path === _);
      if (x === -1 || M === -1) {
        t.value = /* @__PURE__ */ new Set([_]), n.value = _;
        return;
      }
      const [A, T] = x < M ? [x, M] : [M, x], N = /* @__PURE__ */ new Set();
      for (let z = A; z <= T; z++) N.add(k[z].path);
      t.value = N;
      return;
    }
    if (w.ctrl) {
      const k = new Set(t.value);
      k.has(_) ? k.delete(_) : k.add(_), t.value = k, n.value = _;
      return;
    }
    t.value = /* @__PURE__ */ new Set([_]), n.value = _;
  }
  function i() {
    t.value = /* @__PURE__ */ new Set(), n.value = null;
  }
  function r() {
    t.value = new Set(e().map((_) => _.path));
  }
  function l(_) {
    return t.value.has(_);
  }
  function d(_) {
    const w = new Set(t.value);
    w.add(_), t.value = w;
  }
  function f(_) {
    const w = new Set(t.value);
    w.delete(_), t.value = w;
  }
  const m = E(() => t.value.size), v = E(() => t.value.size === 0), b = E(() => e().filter((w) => t.value.has(w.path)));
  return { selected: t, anchor: n, click: a, clear: i, selectAll: r, has: l, add: d, remove: f, size: m, isEmpty: v, nodes: b };
}
function a2(e) {
  var n;
  const t = e;
  return !t || typeof t.tagName != "string" ? !1 : t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable || ((n = t.getAttribute) == null ? void 0 : n.call(t, "role")) === "textbox" ? !0 : typeof t.closest == "function" && !!t.closest(".monaco-editor");
}
const IM = /* @__PURE__ */ new Set([
  "Ctrl+N",
  "Ctrl+Shift+N",
  "Ctrl+T",
  "Ctrl+Shift+T",
  "Ctrl+W",
  "Ctrl+Shift+W",
  "Ctrl+Tab",
  "Ctrl+Shift+Tab",
  "Ctrl+Q",
  "Ctrl+Shift+I",
  "Ctrl+Shift+J",
  "Ctrl+Shift+C",
  "F11",
  "F12"
]);
function Tue(e) {
  return IM.has(e);
}
const Hr = [
  // Navigation
  { id: "palette", defaultCombo: "Ctrl+K", labelKey: "shortcuts.palette", groupKey: "shortcuts.group.nav" },
  { id: "search", defaultCombo: "/", labelKey: "shortcuts.search", groupKey: "shortcuts.group.nav" },
  { id: "go-up", defaultCombo: "Alt+↑", fixedCombos: ["Backspace"], labelKey: "shortcuts.go_up", groupKey: "shortcuts.group.nav" },
  { id: "open", defaultCombo: "Enter", prevent: !1, labelKey: "shortcuts.open", groupKey: "shortcuts.group.nav" },
  { id: "quicklook", defaultCombo: "Space", labelKey: "shortcuts.quicklook", groupKey: "shortcuts.group.nav" },
  { id: "close", defaultCombo: "Esc", customizable: !1, prevent: !1, inForms: !0, labelKey: "shortcuts.close", groupKey: "shortcuts.group.nav" },
  { id: "inspector", defaultCombo: "I", labelKey: "shortcuts.inspector", groupKey: "shortcuts.group.nav" },
  { id: "help", defaultCombo: "?", labelKey: "shortcuts.help", groupKey: "shortcuts.group.nav" },
  { id: "toggle-hidden", defaultCombo: "Ctrl+Shift+.", labelKey: "shortcuts.toggle_hidden", groupKey: "shortcuts.group.nav" },
  /* yildiz:s1 — starring is an action, so it belongs where the other verbs
   * are. A bare letter like the inspector's `I`; the handler ignores events
   * from form controls, so it never eats a keystroke meant for a filename. */
  { id: "star", defaultCombo: "S", labelKey: "shortcuts.star", groupKey: "shortcuts.group.file" },
  // Selection
  { id: "select-all", defaultCombo: "Ctrl+A", labelKey: "shortcuts.select_all", groupKey: "shortcuts.group.selection" },
  // File operations
  { id: "rename", defaultCombo: "F2", labelKey: "shortcuts.rename", groupKey: "shortcuts.group.file" },
  { id: "delete", defaultCombo: "Del", labelKey: "shortcuts.delete", groupKey: "shortcuts.group.file" },
  { id: "cut", defaultCombo: "Ctrl+X", labelKey: "shortcuts.cut", groupKey: "shortcuts.group.file" },
  { id: "copy", defaultCombo: "Ctrl+C", labelKey: "shortcuts.copy", groupKey: "shortcuts.group.file" },
  { id: "paste", defaultCombo: "Ctrl+V", labelKey: "shortcuts.paste", groupKey: "shortcuts.group.file" },
  /* wiring:d1 — tabs. Note: browsers reserve Ctrl+T/W/Tab in normal pages
   * (preventDefault can't stop them there); they work in webcomponent/PWA/
   * kiosk contexts and stay remappable through the settings modal. */
  { id: "tab-new", defaultCombo: "Ctrl+T", labelKey: "shortcuts.tab_new", groupKey: "shortcuts.group.tabs" },
  { id: "tab-close", defaultCombo: "Ctrl+W", labelKey: "shortcuts.tab_close", groupKey: "shortcuts.group.tabs" },
  { id: "tab-next", defaultCombo: "Ctrl+Tab", labelKey: "shortcuts.tab_next", groupKey: "shortcuts.group.tabs" },
  { id: "tab-prev", defaultCombo: "Ctrl+Shift+Tab", labelKey: "shortcuts.tab_prev", groupKey: "shortcuts.group.tabs" },
  /* /wiring:d1 */
  /* tus:t1 — the rest of the menu verbs. Until now these were reachable only
   * by right-clicking, and the right-click menu named no keys at all, so 16 of
   * the registry's actions were invisible unless somebody opened the `?` sheet
   * on their own. The ones with no default are deliberate: they are rare
   * enough that taking a key from the user by default is the wrong trade, and
   * they are in the registry so the user can take one. */
  { id: "new-folder", defaultCombo: "Shift+N", labelKey: "shortcuts.new_folder", groupKey: "shortcuts.group.file" },
  { id: "upload", defaultCombo: "U", labelKey: "shortcuts.upload", groupKey: "shortcuts.group.file" },
  { id: "refresh", defaultCombo: "R", labelKey: "shortcuts.refresh", groupKey: "shortcuts.group.nav" },
  { id: "download", defaultCombo: "D", labelKey: "shortcuts.download", groupKey: "shortcuts.group.file" },
  { id: "preview", defaultCombo: "P", labelKey: "shortcuts.preview", groupKey: "shortcuts.group.nav" },
  { id: "share", defaultCombo: "Shift+S", labelKey: "shortcuts.share", groupKey: "shortcuts.group.file" },
  { id: "tags", defaultCombo: "T", labelKey: "shortcuts.tags", groupKey: "shortcuts.group.file" },
  { id: "open-tab", defaultCombo: "", labelKey: "shortcuts.open_tab", groupKey: "shortcuts.group.tabs" },
  { id: "copy-path", defaultCombo: "", labelKey: "shortcuts.copy_path", groupKey: "shortcuts.group.file" },
  { id: "copy-id", defaultCombo: "", labelKey: "shortcuts.copy_id", groupKey: "shortcuts.group.file" },
  { id: "restore", defaultCombo: "", labelKey: "shortcuts.restore", groupKey: "shortcuts.group.file" }
  /* /tus:t1 */
], BM = {
  palette: "onPathJump",
  search: "onFocusSearch",
  "go-up": "onGoUp",
  open: "onOpen",
  quicklook: "onQuickLook",
  close: "onClose",
  inspector: "onToggleInspector",
  "toggle-hidden": "onToggleHidden",
  star: "onStar",
  help: "onShowHelp",
  "select-all": "onSelectAll",
  rename: "onRename",
  delete: "onDelete",
  cut: "onCut",
  copy: "onCopy",
  paste: "onPaste",
  /* wiring:d1 */
  "tab-new": "onTabNew",
  "tab-close": "onTabClose",
  "tab-next": "onTabNext",
  "tab-prev": "onTabPrev",
  /* tus:t1 */
  "new-folder": "onNewFolder",
  upload: "onUpload",
  refresh: "onRefresh",
  download: "onDownload",
  preview: "onPreview",
  share: "onShare",
  tags: "onTags",
  "open-tab": "onOpenTab",
  "copy-path": "onCopyPath",
  "copy-id": "onCopyId",
  restore: "onRestore"
}, rv = "filex.shortcuts";
function FM() {
  try {
    const e = localStorage.getItem(rv);
    if (!e) return {};
    const t = JSON.parse(e);
    if (!t || typeof t != "object") return {};
    const n = {};
    for (const [a, i] of Object.entries(t))
      typeof i == "string" && Hr.some((r) => r.id === a) && (n[a] = i);
    return n;
  } catch {
    return {};
  }
}
const Bi = $(FM());
function yy() {
  try {
    Object.keys(Bi.value).length === 0 ? localStorage.removeItem(rv) : localStorage.setItem(rv, JSON.stringify(Bi.value));
  } catch {
  }
}
function gy(e) {
  return Hr.find((t) => t.id === e);
}
function vc(e) {
  var n;
  const t = Bi.value[e];
  return t !== void 0 ? t : ((n = gy(e)) == null ? void 0 : n.defaultCombo) ?? "";
}
function Aue(e, t) {
  const n = gy(e);
  if (!n || n.customizable === !1) return;
  const a = { ...Bi.value };
  t === n.defaultCombo ? delete a[e] : a[e] = t, Bi.value = a, yy();
}
function Eue(e) {
  if (!(e in Bi.value)) return;
  const t = { ...Bi.value };
  delete t[e], Bi.value = t, yy();
}
function Cue() {
  Bi.value = {}, yy();
}
function zue(e, t) {
  var n;
  if (!e) return null;
  for (const a of Hr)
    if (a.id !== t) {
      if ((n = a.fixedCombos) != null && n.includes(e)) return { id: a.id, fixed: !0 };
      if (vc(a.id) === e) return { id: a.id, fixed: a.customizable === !1 };
    }
  return null;
}
const UM = {
  " ": "Space",
  Spacebar: "Space",
  Escape: "Esc",
  Delete: "Del",
  ArrowUp: "↑",
  ArrowDown: "↓",
  ArrowLeft: "←",
  ArrowRight: "→",
  PageUp: "PgUp",
  PageDown: "PgDn"
}, HM = /* @__PURE__ */ new Set(["Control", "Alt", "Shift", "Meta", "AltGraph", "CapsLock", "NumLock", "ScrollLock", "Fn", "Dead"]);
function KM(e) {
  const t = e.key;
  if (!t || HM.has(t)) return null;
  const n = UM[t];
  return n || (t.length === 1 ? t.toUpperCase() : t);
}
function i2(e) {
  const t = KM(e);
  if (!t) return null;
  const n = [];
  (e.ctrlKey || e.metaKey) && n.push("Ctrl"), e.altKey && n.push("Alt");
  const a = t.length === 1 && t.toUpperCase() === t.toLowerCase();
  return e.shiftKey && !a && n.push("Shift"), n.push(t), n.join("+");
}
function VM() {
  return E(
    () => Hr.map((e) => {
      const t = vc(e.id), n = e.fixedCombos ?? [];
      return {
        id: e.id,
        combo: t,
        fixedCombos: n,
        keys: [t, ...n].filter((a) => !!a),
        labelKey: e.labelKey,
        groupKey: e.groupKey,
        customizable: e.customizable !== !1,
        overridden: Bi.value[e.id] !== void 0
      };
    })
  );
}
function jM() {
  return typeof navigator < "u" && /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent || "");
}
function qM(e) {
  return e ? jM() ? e.replace(/\bCtrl\b/g, "⌘") : e : "";
}
const WM = {
  open: "open",
  "open-tab": "open-tab",
  preview: "preview",
  download: "download",
  access: "share",
  details: "inspector",
  "copy-id": "copy-id",
  "copy-path": "copy-path",
  rename: "rename",
  cut: "cut",
  copy: "copy",
  paste: "paste",
  star: "star",
  tags: "tags",
  delete: "delete",
  restore: "restore",
  "new-folder": "new-folder",
  "toggle-hidden": "toggle-hidden",
  upload: "upload",
  refresh: "refresh"
};
function o2(e) {
  const t = WM[e] ?? e;
  return Hr.some((n) => n.id === t) ? by(t) : "";
}
function by(e) {
  return qM(vc(e));
}
function r2(e, t) {
  var i, r;
  const n = vc(t);
  if (!n) return !1;
  const a = i2(e);
  return a === n ? !0 : ((r = (i = gy(t)) == null ? void 0 : i.fixedCombos) == null ? void 0 : r.includes(a ?? "")) ?? !1;
}
Hr.map((e) => ({
  keys: [e.defaultCombo, ...e.fixedCombos ?? []].filter((t) => !!t),
  labelKey: e.labelKey,
  groupKey: e.groupKey
}));
function YM(e, t) {
  const n = E(() => {
    const i = /* @__PURE__ */ new Map();
    for (const r of Hr) {
      const l = vc(r.id);
      l && i.set(l, r);
    }
    return i;
  });
  function a(i) {
    var b;
    if (!e.value || i.key !== "Escape" && document.querySelector(".fe-ctx-backdrop")) return;
    const l = i.target, d = a2(l), f = i2(i);
    if (!f) return;
    if (f === "Backspace") {
      if (d) return;
      (b = t.hasSelection) != null && b.call(t) && t.onDelete ? (i.preventDefault(), t.onDelete()) : t.onGoUp && (i.preventDefault(), t.onGoUp());
      return;
    }
    const m = n.value.get(f);
    if (!m || d && !m.inForms || f === "Space" && l && typeof l.closest == "function" && l.closest('button, a, select, summary, [role="button"], [role="menuitem"]'))
      return;
    const v = t[BM[m.id]];
    v && (m.prevent !== !1 && i.preventDefault(), v());
  }
  Wt(() => window.addEventListener("keydown", a)), Ot(() => window.removeEventListener("keydown", a));
}
function xl() {
  let e;
  try {
    e = typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(prefers-color-scheme: dark)") : void 0;
  } catch {
    e = void 0;
  }
  const t = $(!!(e != null && e.matches)), n = (a) => {
    t.value = a.matches;
  };
  return Wt(() => {
    var a;
    return (a = e == null ? void 0 : e.addEventListener) == null ? void 0 : a.call(e, "change", n);
  }), Ot(() => {
    var a;
    return (a = e == null ? void 0 : e.removeEventListener) == null ? void 0 : a.call(e, "change", n);
  }), t;
}
const GM = "apps";
function XM(e) {
  const t = `${GM}/${encodeURIComponent(e.plugin)}/${encodeURIComponent(e.view)}`;
  return e.path ? `${t}?path=${encodeURIComponent(e.path)}` : t;
}
function s2(e, t) {
  return `${String(e ?? "").replace(/\/+$/, "")}/${XM(t)}`;
}
function Ef(e) {
  return e === "page";
}
function rp(e) {
  if (!e || typeof e != "object") return !1;
  const t = e;
  return typeof t.path == "string" && t.path.trim() !== "";
}
function JM(e) {
  const t = String(e ?? "").indexOf("://");
  if (t <= 0) return "";
  const n = e.slice(0, t), a = e.slice(t + 3).replace(/^\/+/, ""), i = a.lastIndexOf("/"), r = i > 0 ? a.slice(0, i) : "";
  return r ? `${n}/${r}` : n;
}
function Bw(e, t) {
  var r;
  if (!rp(e) || !t.plugin) return { href: "", newTab: !1 };
  const n = String(t.base ?? "").replace(/\/+$/, "");
  if (e.view && Ef((r = t.placementOf) == null ? void 0 : r.call(t, e.view)))
    return { href: s2(n, { plugin: t.plugin, view: e.view, path: e.path }), newTab: !0 };
  const a = [`select=${encodeURIComponent(e.path)}`, `app=${encodeURIComponent(t.plugin)}`];
  e.action ? a.push(`appAction=${encodeURIComponent(e.action)}`) : e.view && a.push(`appView=${encodeURIComponent(e.view)}`);
  const i = JM(e.path);
  return { href: `${n}/explore?${a.join("&")}${i ? `#${i}` : ""}`, newTab: !1 };
}
const ZM = 2e3, QM = 8e3;
function Fw(e) {
  const t = (...m) => {
    for (const v of m) if (typeof v == "number") return v;
    return 0;
  }, n = (...m) => {
    for (const v of m) if (typeof v == "string" && v !== "") return v;
    return null;
  }, a = String(e.status ?? "pending"), i = a === "ok" || a === "done" ? "done" : a === "failed" || a === "partial" || a === "error" ? "error" : a === "cancelled" ? "cancelled" : a === "cancelling" ? "cancelling" : a === "running" ? "running" : "pending", r = Array.isArray(e.sources) ? e.sources : [], l = n(e.op_type, e.kind) ?? "delete", d = Array.isArray(e.outputs) ? e.outputs.map((m) => m && typeof m == "object" ? n(m.path) : null).filter((m) => m !== null).map((m) => ({ path: m })) : void 0;
  let f;
  if (rp(e.open)) {
    const m = n(e.open.action), v = n(e.open.view);
    f = { path: e.open.path, ...m ? { action: m } : {}, ...v ? { view: v } : {} };
  }
  return {
    id: t(e.id),
    op_type: l === "plugin-action" ? "plugin" : l,
    status: i,
    progress_total: t(e.progress_total, e.total, r.length),
    progress_done: t(e.progress_done, e.done),
    bytes_total: t(e.bytes_total),
    bytes_done: t(e.bytes_done),
    objects_total: t(e.objects_total),
    objects_done: t(e.objects_done),
    target_path: n(e.target_path, e.dest),
    source_dir: n(e.source_dir),
    source_count: t(e.source_count, r.length),
    error_message: n(e.error_message, e.error),
    error_code: n(e.error_code) ?? void 0,
    error_engine: n(e.error_engine) ?? void 0,
    error_text: n(e.error_text) ?? void 0,
    cancellable: e.cancellable === !0,
    started_at: n(e.started_at),
    finished_at: n(e.finished_at),
    created_at: n(e.created_at),
    plugin: n(e.plugin) ?? void 0,
    action: n(e.action) ?? void 0,
    label: n(e.label) ?? void 0,
    message: n(e.message) ?? void 0,
    summary: n(e.summary) ?? void 0,
    outputs: d,
    ...f ? { open: f } : {}
  };
}
function l2(e, t, n = {}) {
  const a = $([]), i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Map();
  let d = !1;
  const f = E(
    () => a.value.some((x) => x.status === "pending" || x.status === "running" || x.status === "cancelling")
  );
  let m;
  function v() {
    m || t.endpoints.opsList && (m = setInterval(() => {
      _();
    }, ZM), _());
  }
  function b() {
    m && (clearInterval(m), m = void 0);
  }
  async function _() {
    var x;
    if (t.endpoints.opsList)
      try {
        const A = ((await t.jsonFetch(t.withScreenLang(t.endpoints.opsList))).ops || []).map(Fw);
        for (const S of A)
          (S.status === "done" || S.status === "error" || S.status === "cancelled") && !i.has(S.id) && (i.add(S.id), l.set(S.id, Date.now()), r.delete(S.id) && ((x = n.onSettled) == null || x.call(n, S)));
        const T = new Set(a.value.map((S) => S.id)), N = A.filter((S) => S.status === "pending" || S.status === "running" || S.status === "cancelling" ? !0 : d ? T.has(S.id) : !1), z = new Set(N.map((S) => S.id)), L = a.value.filter((S) => !z.has(S.id)), B = [...N, ...L];
        d = !0;
        const O = Date.now(), U = B.filter((S) => {
          if (S.status === "pending" || S.status === "running" || S.status === "cancelling") return !0;
          const F = l.get(S.id);
          return F !== void 0 && O - F < QM;
        });
        a.value = U, !f.value && U.length === 0 && b();
      } catch (M) {
        console.warn("[usePendingOps] poll failed:", M);
      }
  }
  function w(x) {
    const M = Fw(x);
    i.has(M.id) || r.add(M.id), a.value.some((T) => T.id === M.id) || (a.value = [M, ...a.value]), v();
  }
  function k(x) {
    a.value = a.value.filter((M) => M.id !== x), l.delete(x);
  }
  return Ot(() => {
    b();
  }), {
    ops: a,
    hasActive: f,
    register: w,
    dismiss: k,
    poll: _,
    startPolling: v,
    stopPolling: b
  };
}
function Ru(e) {
  return e === "folder" || e === "vault" || e === "file";
}
function ky(e) {
  return e ? e.e2e === !0 || e.encrypted === "folder" || e.encrypted === "vault" || typeof e.e2e_root == "string" && e.e2e_root !== "" : !1;
}
function u2(e) {
  return e ? ky(e) || e.encrypted === "file" : !1;
}
function c2(e, t) {
  if (!t || !Array.isArray(e.app_state)) return [];
  const n = `${t}:`;
  return e.app_state.filter((a) => typeof a == "string" && a.startsWith(n)).map((a) => a.slice(n.length));
}
function wy(e, t) {
  let n = String(e.extension ?? "").toLowerCase();
  if (!n && e.basename) {
    const a = e.basename.lastIndexOf(".");
    a > 0 && (n = e.basename.slice(a + 1).toLowerCase());
  }
  return {
    kind: e.type === "dir" ? "dir" : "file",
    ext: n,
    mime: e.mime_type ?? "",
    state: c2(e, t)
  };
}
function eP(e, t) {
  return e === t ? !0 : e.endsWith("/*") ? t.startsWith(e.slice(0, -1)) : !1;
}
function _y(e, t) {
  const n = e ?? {}, a = t.length;
  if (a === 0 || a > 1 && !n.multi) return !1;
  const i = n.min ?? 0, r = n.max ?? 0;
  if (i > 0 && a < i || r > 0 && a > r) return !1;
  const l = n.kind || "file", d = (n.ext ?? []).map((b) => b.toLowerCase()), f = (n.mime ?? []).map((b) => b.toLowerCase()), m = n.state ?? [], v = n.no_state ?? [];
  for (const b of t) {
    if (l !== "any" && l !== b.kind) return !1;
    const _ = b.state ?? [];
    if (m.length > 0 && !m.some((x) => _.includes(x)) || v.some((x) => _.includes(x))) return !1;
    if (d.length === 0 && f.length === 0) continue;
    const w = String(b.ext ?? "").toLowerCase();
    let k = d.includes(w);
    if (!k) {
      const x = String(b.mime ?? "").toLowerCase();
      k = f.some((M) => eP(M, x));
    }
    if (!k) return !1;
  }
  return !0;
}
function xy(e, t, n) {
  return _y(e, t.map((a) => wy(a, n)));
}
function Gt(e, t) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const n = String(t || "en").toLowerCase().split("-")[0], a = e[n];
  if (typeof a == "string" && a !== "") return a;
  const i = e.en;
  if (typeof i == "string" && i !== "") return i;
  for (const r of Object.values(e))
    if (typeof r == "string" && r !== "") return r;
  return "";
}
function tP(e, t) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const n = String(t || "en").toLowerCase().split("-")[0], a = e[n];
  return typeof a == "string" && a !== "" ? a : "";
}
function Sy(e, t, n) {
  const a = tP(e, t);
  if (a) return a;
  const i = n();
  return i || Gt(e, t);
}
function nP(e, t) {
  switch (e.kind) {
    case "engine":
      return t("plugin.needs_engine", { name: e.name });
    case "office":
      return t("plugin.needs_office", { name: e.name });
  }
  return t("plugin.needs_other", { name: e.name });
}
function $y(e) {
  return e.key || `plugin:${e.plugin}/${e.id}`;
}
function aP(e) {
  return e.startsWith("plugin:");
}
function iP(e) {
  var t;
  return e.output_mode === "sibling" || e.output_mode === "version" || ((t = e.applies) == null ? void 0 : t.writable) === !0;
}
function oP(e) {
  return e.read_only_ok === !1;
}
const fm = { none: 0, viewer: 1, editor: 2, owner: 3 };
function rP(e) {
  return e.min_role === "owner" ? "owner" : e.min_role === "editor" || iP(e) ? "editor" : "viewer";
}
function sP(e, t, n) {
  var i;
  if ((i = t.lock) != null && i.plugin && t.lock.plugin === e.plugin) return !0;
  const a = n(t);
  return a === void 0 || !(a in fm) ? !0 : fm[a] >= fm[rP(e)];
}
function d2(e, t) {
  return t.length === 0 ? [] : e.filter((n) => xy(n.applies, t, n.plugin));
}
function lP(e, t, n) {
  var _;
  if (n.trash || n.e2e) return [];
  if (t.some((w) => u2(w) || w.mime_type === "inode/storage")) return [];
  const a = n.permOf, i = (w) => !(n.readOnly && oP(w)) && (!a || t.every((k) => sP(w, k, a))), r = d2(e, t).filter(i), l = /* @__PURE__ */ new Map();
  if (n.needWords)
    for (const w of e) {
      if (r.includes(w) || !((_ = w.gated) != null && _.length) || !i(w)) continue;
      const k = w.gated.find(
        (x) => xy({ ...w.applies, ext: x.ext ?? [], mime: [] }, t, w.plugin)
      );
      k && l.set(w, n.needWords(k.needs));
    }
  const d = e.filter((w) => r.includes(w) || l.has(w));
  if (d.length === 0) return [];
  const f = n.hasIcon ?? (() => !1), m = /* @__PURE__ */ new Map();
  for (const w of d) {
    const k = m.get(w.plugin);
    k ? k.push(w) : m.set(w.plugin, [w]);
  }
  const v = [];
  let b = !0;
  for (const [w, k] of m) {
    v.push({ divider: !0, key: b ? "sep-plugins" : `sep-plugin:${w}`, label: "" }), b = !1;
    for (const x of k) {
      const M = l.get(x);
      v.push({
        key: $y(x),
        label: Gt(x.label, n.locale),
        icon: x.icon && f(x.icon) ? x.icon : "plugin",
        danger: x.danger === !0,
        ...M ? { disabled: !0, title: M } : {}
      });
    }
  }
  return v;
}
const uP = 5 * 60 * 1e3, sv = /* @__PURE__ */ new Map();
function cP() {
  sv.clear();
}
function dP(e) {
  let t = sv.get(e);
  return t || (t = { at: 0, data: $({ actions: [], views: [] }), inflight: null }, sv.set(e, t)), t;
}
function fP(e, t) {
  const n = e.endpoints.pluginActions ?? "", a = dP(n || "(none)"), i = $(!1), r = $(null), l = E(() => t() && n !== ""), d = E(() => l.value ? a.data.value.actions : []), f = E(() => l.value ? a.data.value.views : []), m = E(() => l.value ? a.data.value.open_rules ?? {} : {});
  async function v(k = !1) {
    return l.value ? a.at > 0 && Date.now() - a.at < uP && !k ? (i.value = !0, a.data.value) : (a.inflight || (a.inflight = e.pluginActions().then((M) => (a.data.value = { actions: M.actions ?? [], views: M.views ?? [], open_rules: M.open_rules ?? {} }, a.at = Date.now(), r.value = null, a.data.value)).catch((M) => (r.value = String((M == null ? void 0 : M.message) ?? M), a.data.value)).finally(() => {
      a.inflight = null, i.value = !0;
    })), a.inflight) : { actions: [], views: [] };
  }
  Xe(
    l,
    (k) => {
      k && v();
    },
    { immediate: !0 }
  );
  function b(k) {
    return d2(d.value, k);
  }
  function _(k) {
    return d.value.find((x) => $y(x) === k);
  }
  function w(k, x, M) {
    return e.pluginActionRun(k.plugin, k.id, {
      paths: x.map((A) => A.path),
      params: M
    });
  }
  return { enabled: l, actions: d, views: f, openRules: m, loaded: i, error: r, refresh: v, actionsFor: b, byKey: _, run: w };
}
const pP = 25e3, hP = 15e3, mP = 6;
class vP {
  constructor(t) {
    It(this, "ws", null);
    It(this, "opts");
    It(this, "closed", !1);
    It(this, "connecting", !1);
    It(this, "retries", 0);
    It(this, "fallback", !1);
    It(this, "pingTimer", null);
    It(this, "reconnectTimer", null);
    // Last-known intent, replayed on (re)connect.
    It(this, "currentPath", null);
    It(this, "currentFocus", null);
    this.opts = t, this.connect();
  }
  /** Subscribe to a folder ("<adapter>://<dir>"). Swaps the active room and
   *  resets focus. Passing null unsubscribes (drive list / trash have no room). */
  subscribe(t) {
    this.currentPath = t, this.currentFocus = null, t && this.send({ type: "subscribe", path: t });
  }
  /** Report the file the user is focused on (or null to clear). */
  setFocus(t) {
    this.currentFocus = t, this.send({ type: "focus", file: t });
  }
  /** Tear down permanently — call on unmount. */
  close() {
    this.closed = !0, this.clearTimers(), this.dropSocket();
  }
  async connect() {
    if (this.closed || this.connecting || this.ws) return;
    this.connecting = !0;
    let t = null;
    try {
      t = await this.opts.getTicket();
    } catch {
      t = null;
    }
    if (this.connecting = !1, this.closed) return;
    if (!t || !t.ticket || !t.ws_url) {
      this.fail();
      return;
    }
    const n = t.ws_url.includes("?") ? "&" : "?";
    let a;
    try {
      a = new WebSocket(`${t.ws_url}${n}ticket=${encodeURIComponent(t.ticket)}`);
    } catch {
      this.fail();
      return;
    }
    this.ws = a, a.onopen = () => {
      var i, r;
      this.retries = 0, this.setFallback(!1), (r = (i = this.opts.handlers).onStatus) == null || r.call(i, !0), this.currentPath && this.send({ type: "subscribe", path: this.currentPath }), this.currentFocus !== null && this.send({ type: "focus", file: this.currentFocus }), this.startPing();
    }, a.onmessage = (i) => {
      var d, f, m, v, b, _, w, k, x, M;
      let r;
      try {
        r = JSON.parse(typeof i.data == "string" ? i.data : "");
      } catch {
        return;
      }
      const l = r;
      if ((l == null ? void 0 : l.type) === "change") (f = (d = this.opts.handlers).onChange) == null || f.call(d, r);
      else if ((l == null ? void 0 : l.type) === "presence") (v = (m = this.opts.handlers).onPresence) == null || v.call(m, r);
      else if ((l == null ? void 0 : l.type) === "app.updated") {
        const A = r;
        typeof A.app == "string" && typeof A.version == "string" && ((_ = (b = this.opts.handlers).onAppUpdated) == null || _.call(b, A));
      } else if ((l == null ? void 0 : l.type) === "vault.generation" || (l == null ? void 0 : l.type) === "vault.lock") {
        const A = r;
        typeof A.path == "string" && ((k = (w = this.opts.handlers).onVault) == null || k.call(w, A));
      } else (l == null ? void 0 : l.type) === "access.changed" && ((M = (x = this.opts.handlers).onAccessChanged) == null || M.call(x, { all: r.scope === "all" }));
    }, a.onerror = () => {
    }, a.onclose = () => {
      var i, r;
      this.stopPing(), this.ws = null, (r = (i = this.opts.handlers).onStatus) == null || r.call(i, !1), this.fail();
    };
  }
  // fail schedules a capped reconnect; after MAX_RETRIES it gives up on the live
  // socket and flips to fallback (polling) mode.
  fail() {
    if (this.closed || this.reconnectTimer) return;
    if (this.retries >= mP) {
      this.setFallback(!0);
      return;
    }
    const t = Math.min(1e3 * 2 ** this.retries, hP);
    this.retries += 1, this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, this.connect();
    }, t);
  }
  setFallback(t) {
    var n, a;
    this.fallback !== t && (this.fallback = t, (a = (n = this.opts.handlers).onFallback) == null || a.call(n, t));
  }
  send(t) {
    const n = this.ws;
    if (!(!n || n.readyState !== WebSocket.OPEN))
      try {
        n.send(JSON.stringify(t));
      } catch {
      }
  }
  startPing() {
    this.stopPing(), this.pingTimer = setInterval(() => this.send({ type: "ping" }), pP);
  }
  stopPing() {
    this.pingTimer && (clearInterval(this.pingTimer), this.pingTimer = null);
  }
  dropSocket() {
    if (this.ws) {
      try {
        this.ws.onclose = null, this.ws.close();
      } catch {
      }
      this.ws = null;
    }
  }
  clearTimers() {
    this.stopPing(), this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null);
  }
}
function yP(e, t) {
  const n = t.now ?? (() => Date.now());
  let a = null, i = null;
  const r = () => {
    const l = n();
    i === null && (i = l);
    const d = i + t.maxWait - l, f = Math.max(0, Math.min(t.wait, d));
    a && clearTimeout(a), a = setTimeout(() => {
      a = null, i = null, e();
    }, f);
  };
  return r.cancel = () => {
    a && clearTimeout(a), a = null, i = null;
  }, r;
}
const lv = /* @__PURE__ */ new Set();
function gP(e, t) {
  for (const n of [...lv])
    try {
      n(e, t);
    } catch {
    }
}
function bP(e) {
  return lv.add(e), () => {
    lv.delete(e);
  };
}
const kP = 200, wP = 2e3, _P = 12e3;
function xP(e, t) {
  const n = $([]), a = $(!1), i = $(!1);
  let r = null, l = null, d = !1;
  const f = yP(() => t.reload(), {
    wait: kP,
    maxWait: wP
  });
  let m = null;
  function v(A) {
    l && A.path && A.path !== l || (n.value = Array.isArray(A.users) ? A.users : []);
  }
  function b(A) {
    cP(), gP(A.app, A.version);
  }
  function _(A) {
    i.value = A, A ? (n.value = [], m || (m = setInterval(() => t.reload(), _P))) : m && (clearInterval(m), m = null);
  }
  function w() {
    r || (r = new vP({
      getTicket: () => e.wsTicket(),
      handlers: {
        onChange: f,
        onPresence: v,
        onAppUpdated: b,
        onVault: (A) => {
          var T;
          return (T = t.onVault) == null ? void 0 : T.call(t, A);
        },
        onAccessChanged: (A) => {
          var T;
          return (T = t.onAccess) == null ? void 0 : T.call(t, { all: A.all, resync: !1 });
        },
        onFallback: _,
        onStatus: (A) => {
          var T;
          a.value = A, A && d && ((T = t.onAccess) == null || T.call(t, { all: !1, resync: !0 })), A && (d = !0);
        }
      }
    }));
  }
  function k(A) {
    n.value = [], l = A, r == null || r.subscribe(A);
  }
  function x(A) {
    r == null || r.setFocus(A);
  }
  function M() {
    f.cancel(), m && (clearInterval(m), m = null), r == null || r.close(), r = null, d = !1, i.value = !1;
  }
  return { presenceUsers: n, connected: a, degraded: i, start: w, subscribe: k, setFocus: x, stop: M };
}
const SP = 500;
function $P(e) {
  const t = e.thumb_url;
  if (!t) return null;
  const n = t.indexOf("?");
  if (n === -1) return `${t}||${e.last_modified ?? ""}`;
  const a = new URLSearchParams(t.slice(n + 1)).get("v") ?? "";
  return `${t.slice(0, n)}|${a}|${e.last_modified ?? ""}`;
}
function TP(e, t) {
  const n = hz(/* @__PURE__ */ new Map()), a = [], i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), l = (m) => ay(e, m);
  function d(m) {
    const v = m.thumb_url, b = $P(m);
    if (!v || !b) return null;
    const _ = n.get(b);
    return _ || (!i.has(v) && !r.has(b) && f(v, b), null);
  }
  async function f(m, v) {
    r.add(v);
    try {
      const b = await fetch(l(m), {
        headers: await t.authHeaders({ Accept: "*/*" }),
        credentials: t.credentialsMode()
      });
      if (!b.ok) throw new Error(String(b.status));
      const _ = await b.blob();
      if (a.length >= SP) {
        const w = a.shift(), k = mz(n), x = w ? k.get(w) : void 0;
        w && x && (URL.revokeObjectURL(x), k.delete(w));
      }
      a.push(v), n.set(v, URL.createObjectURL(_));
    } catch {
      i.add(m);
    } finally {
      r.delete(v);
    }
  }
  return { src: d };
}
let Cf = null, zf = null, tf = null, nf = null;
function sp() {
  Cf || (Cf = import(
    /* @vite-ignore */
    "monaco-editor"
  ).then((e) => (tf = e.default ?? e, tf)).catch(() => (tf = null, null))), zf || (zf = import(
    /* @vite-ignore */
    "./common-xdTjul80.js"
  ).then((e) => (nf = e.default ?? e, nf)).catch(() => (nf = null, null)));
}
async function AP() {
  return Cf || sp(), Cf;
}
async function EP() {
  return zf || sp(), zf;
}
function CP() {
  return tf;
}
function zP() {
  return nf;
}
function Mue() {
  return sp(), {
    ensureMonaco: AP,
    ensureHighlight: EP,
    getMonaco: CP,
    getHighlight: zP
  };
}
const MP = ["title"], PP = ["src", "alt"], OP = {
  key: 2,
  class: "fx-presence-dot",
  "aria-hidden": "true"
}, Uw = /* @__PURE__ */ lt({
  __name: "PresenceAvatar",
  props: {
    user: {},
    title: {}
  },
  setup(e) {
    const t = e, n = E(() => {
      const d = (t.user.avatar ?? "").trim();
      return /^(data:image\/|https?:\/\/|\/)/.test(d) ? d : "";
    }), a = $(!1), i = E(() => !!n.value && !a.value), r = E(() => {
      const d = t.user.name.trim().split(/\s+/).filter(Boolean);
      return d.length === 0 ? "?" : d.length === 1 ? d[0].slice(0, 2).toUpperCase() : (d[0][0] + d[d.length - 1][0]).toUpperCase();
    }), l = E(() => {
      const d = t.user.uid ?? String(t.user.id);
      let f = 0;
      for (let m = 0; m < d.length; m++) f = f * 31 + d.charCodeAt(m) >>> 0;
      return f % 360;
    });
    return (d, f) => (p(), h("span", {
      class: Fe(["fx-presence-avatar", { "fx-presence-avatar--photo": i.value }]),
      style: Yt({ backgroundColor: `hsl(${l.value} 60% 45%)` }),
      title: e.title
    }, [
      i.value ? (p(), h("img", {
        key: 0,
        class: "fx-presence-photo",
        src: n.value,
        alt: e.user.name,
        onError: f[0] || (f[0] = (m) => a.value = !0)
      }, null, 40, PP)) : (p(), h(Ce, { key: 1 }, [
        Ht(y(r.value), 1)
      ], 64)),
      e.user.file ? (p(), h("span", OP)) : D("", !0)
    ], 14, MP));
  }
}), DP = {
  key: 0,
  class: "fx-presence-chips"
}, LP = ["title"], RP = { class: "fx-presence-chip-name" }, NP = {
  key: 0,
  class: "fx-presence-chip-file"
}, IP = ["title"], BP = {
  key: 0,
  class: "fx-presence-more"
}, FP = ["title"], UP = { class: "fx-presence-file" }, HP = ["title", "aria-expanded"], Hw = "filex.presence.expanded", KP = /* @__PURE__ */ lt({
  __name: "PresenceBar",
  props: {
    users: {},
    selfId: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = yt(() => Sa(t.locale)), a = E(
      () => (t.users ?? []).filter((f) => t.selfId == null || f.id !== t.selfId)
    ), i = $((() => {
      try {
        return localStorage.getItem(Hw) === "1";
      } catch {
        return !1;
      }
    })());
    function r() {
      i.value = !i.value;
      try {
        localStorage.setItem(Hw, i.value ? "1" : "0");
      } catch {
      }
    }
    function l(f) {
      return f.uid ?? String(f.id);
    }
    function d(f) {
      return f.file ? `${f.name} · ${f.file}` : f.name;
    }
    return (f, m) => a.value.length ? (p(), h("div", {
      key: 0,
      class: Fe(["fx-presence", { "fx-presence--wide": i.value }])
    }, [
      i.value ? (p(), h("div", DP, [
        (p(!0), h(Ce, null, ot(a.value, (v) => (p(), h("span", {
          key: l(v),
          class: "fx-presence-chip",
          title: d(v)
        }, [
          tt(Uw, { user: v }, null, 8, ["user"]),
          c("span", RP, [
            c("bdi", null, y(v.name), 1)
          ]),
          v.file ? (p(), h("span", NP, "· " + y(v.file), 1)) : D("", !0)
        ], 8, LP))), 128))
      ])) : (p(), h(Ce, { key: 1 }, [
        c("div", {
          class: "fx-presence-avatars",
          title: a.value.map(d).join(", ")
        }, [
          (p(!0), h(Ce, null, ot(a.value.slice(0, 5), (v) => (p(), Je(Uw, {
            key: l(v),
            user: v,
            title: d(v)
          }, null, 8, ["user", "title"]))), 128)),
          a.value.length > 5 ? (p(), h("span", BP, "+" + y(a.value.length - 5), 1)) : D("", !0)
        ], 8, IP),
        c("span", {
          class: "fx-presence-text",
          title: a.value.map(d).join(", ")
        }, [
          Ht(y(a.value.length === 1 ? a.value[0].name : u(n)("presence.others", { n: a.value.length })) + " ", 1),
          a.value.length === 1 && a.value[0].file ? (p(), h(Ce, { key: 0 }, [
            m[0] || (m[0] = Ht(" · ", -1)),
            c("span", UP, y(a.value[0].file), 1)
          ], 64)) : D("", !0)
        ], 8, FP)
      ], 64)),
      c("button", {
        type: "button",
        class: "fx-presence-toggle",
        title: i.value ? u(n)("presence.collapse") : u(n)("presence.expand"),
        "aria-expanded": i.value,
        onClick: r
      }, y(i.value ? "‹" : "›"), 9, HP)
    ], 2)) : D("", !0);
  }
}), VP = '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/>', jP = '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>', Kw = "M12 3.6l2.6 5.3 5.85.85-4.23 4.12 1 5.83L12 16.97l-5.22 2.73 1-5.83L3.55 9.75l5.85-.85z", Vw = '<path d="M8 3.5h8"/><path d="M9.6 3.5v6.1L7.2 12.3v1.7h9.6v-1.7L14.4 9.6V3.5"/><path d="M12 14v6.5"/>', pm = '<rect x="3.5" y="4.5" width="17" height="15" rx="2"/>', jw = '<path d="M4 6.5h16"/><path d="M9.5 6.5V4.9a1.4 1.4 0 0 1 1.4-1.4h2.2a1.4 1.4 0 0 1 1.4 1.4v1.6"/><path d="M6.6 6.5l.85 12.1a2 2 0 0 0 2 1.9h5.1a2 2 0 0 0 2-1.9l.85-12.1"/><path d="M10.3 10.3v6.4"/><path d="M13.7 10.3v6.4"/>', qw = '<path d="M6.8 3.5h10.4a1.6 1.6 0 0 1 1.6 1.6v15.4l-6.8-3.9-6.8 3.9V5.1A1.6 1.6 0 0 1 6.8 3.5z"/>', f2 = {
  /* ── opening ─────────────────────────────────────────────────────────── */
  open: '<path d="M14 3.5h6.5V10"/><path d="M20.5 3.5L12 12"/><path d="M18 13.5v5a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5"/>',
  "open-tab": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/>',
  preview: jP,
  download: VP + '<path d="M12 4v11.5"/><path d="M7.5 11L12 15.5 16.5 11"/>',
  "archive-create": '<path d="M5 8.5h14v11H5z"/><path d="M4 4h16v4.5H4z"/><path d="M12 11v5"/><path d="M9.5 13.5h5"/>',
  "archive-extract": '<path d="M5 8.5h14v11H5z"/><path d="M4 4h16v4.5H4z"/><path d="M12 10.5v6"/><path d="M9.5 14l2.5 2.5 2.5-2.5"/>',
  upload: '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/><path d="M12 15.5V4"/><path d="M7.5 8.5L12 4l4.5 4.5"/>',
  convert: '<path d="M4 8.5h13"/><path d="M13.5 5L17 8.5 13.5 12"/><path d="M20 15.5H7"/><path d="M10.5 12L7 15.5 10.5 19"/>',
  /* "Paylaş / İzinler" — the three-node share, not a chain link: this row
     opens permissions as well as a link, and people are the subject. */
  access: '<circle cx="17.5" cy="6" r="2.5"/><circle cx="6.5" cy="12" r="2.5"/><circle cx="17.5" cy="18" r="2.5"/><path d="M8.75 10.8l6.5-3.6"/><path d="M8.75 13.2l6.5 3.6"/>',
  details: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11.2v5.6"/><circle cx="12" cy="7.7" r="0.9" fill="currentColor" stroke="none"/>',
  /* ── identity / clipboard ────────────────────────────────────────────── */
  "copy-id": '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><circle cx="8.5" cy="10.8" r="2"/><path d="M5.3 16.2c.5-1.5 1.75-2.4 3.2-2.4s2.7.9 3.2 2.4"/><path d="M14.8 10h4.2"/><path d="M14.8 13.6h4.2"/>',
  /* A clipboard carrying a path separator — this copies the location, not the
     thing that lives at it. */
  "copy-path": '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/><path d="M10 11.2l2.4 2.4-2.4 2.4"/>',
  rename: '<path d="M4 20l.9-4.1 11-11a2.05 2.05 0 0 1 2.9 2.9l-11 11z"/><path d="M14 7l3 3"/>',
  cut: '<circle cx="6.5" cy="17.5" r="2.5"/><circle cx="6.5" cy="6.5" r="2.5"/><path d="M8.6 8.3L19 19"/><path d="M8.6 15.7L19 5"/>',
  copy: '<rect x="9" y="9" width="11.5" height="11.5" rx="2"/><path d="M15 6v-.5a2 2 0 0 0-2-2H5.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2H6"/>',
  paste: '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/>',
  /* ── metadata ────────────────────────────────────────────────────────── */
  /* star = "not starred yet, do it" (outline); unstar = the state you are in
     (filled). The renderer picks between them by name, see FileExplorer. */
  star: `<path d="${Kw}"/>`,
  unstar: `<path d="${Kw}" fill="currentColor"/>`,
  tags: '<path d="M3.5 11.4V5.2a1.7 1.7 0 0 1 1.7-1.7h6.2a1.7 1.7 0 0 1 1.2.5l7.2 7.2a1.7 1.7 0 0 1 0 2.4l-6.2 6.2a1.7 1.7 0 0 1-2.4 0L4 12.6a1.7 1.7 0 0 1-.5-1.2z"/><circle cx="8" cy="8" r="1.3"/>',
  /* ── destructive / recovery ──────────────────────────────────────────── */
  delete: jw,
  "open-trash": jw,
  /* The undo arrow, not a rotating one: "Geri Yükle" puts a thing back where
     it was, and that is the gesture people already read as undo. */
  restore: '<path d="M9 6L5 10l4 4"/><path d="M5 10h9a5 5 0 0 1 0 10h-3.5"/>',
  /* ── folder-level ────────────────────────────────────────────────────── */
  "new-folder": '<path d="M3 7.5a2 2 0 0 1 2-2h4.2a2 2 0 0 1 1.4.6l1.4 1.4H19a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M12 11.3v5"/><path d="M9.5 13.8h5"/>',
  /* belge:n1 — a page with a plus: "make me a new document of some type".
     Keyed by the action's own key, so the menu row carries no icon of its
     own and no emoji enters the markup. */
  "new-document": '<path d="M13.5 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5"/><path d="M13.5 3l5 5"/><path d="M13.5 3v5h5"/><path d="M17.5 14.5v6"/><path d="M14.5 17.5h6"/>',
  refresh: '<path d="M20.5 12a8.5 8.5 0 1 1-2.49-6.01"/><path d="M18 1.5V6h-4.5"/>',
  /* ── desktop sync ("keep on this device") ────────────────────────────── */
  "keep-local": Vw,
  "keep-online": '<path d="M7 18.5h10a3.5 3.5 0 0 0 0-7 5 5 0 0 0-9.6-1.2A4.2 4.2 0 0 0 7 18.5z"/>',
  /* Kept because a parent folder is kept — the pin, with the branch it came
     down. The row is disabled; the glyph says why. */
  "keep-inherited": Vw + '<path d="M2.5 20.5h3.6a1.6 1.6 0 0 0 1.6-1.6V17"/>',
  "keep-reveal": '<path d="M2.5 17.5V6.5a2 2 0 0 1 2-2h3.8a2 2 0 0 1 1.4.6l1.4 1.4h4.4a2 2 0 0 1 2 2v1.8"/><path d="M4 19.5h13.4a2 2 0 0 0 1.9-1.37l2-6A1.4 1.4 0 0 0 20 10.3H9.4a2 2 0 0 0-1.9 1.37L5.5 18"/>',
  /* ── view preferences ────────────────────────────────────────────────── */
  "toggle-hidden": '<path d="M3.5 3.5l17 17"/><path d="M9.9 6A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17.3 17.3 0 0 1-3.35 4.15"/><path d="M6.55 7.7A17.4 17.4 0 0 0 2.5 12S6 18.5 12 18.5a9.7 9.7 0 0 0 3.95-.85"/><path d="M10.2 10.3a2.9 2.9 0 0 0 3.9 4.1"/>',
  density: '<path d="M8.5 8L12 4.5 15.5 8"/><path d="M8.5 16L12 19.5 15.5 16"/><path d="M12 4.5v15"/>',
  "view-list": '<path d="M8.5 6.5h12"/><path d="M8.5 12h12"/><path d="M8.5 17.5h12"/><path d="M4 6.5h.01"/><path d="M4 12h.01"/><path d="M4 17.5h.01"/>',
  "view-grid": '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
  "view-gallery": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="8.3" cy="9.6" r="1.5"/><path d="M4.3 17l4.7-4.7 3 3 3-3 5 4.7"/>',
  nav: pm + '<path d="M9.5 4.5v15"/>',
  inspector: pm + '<path d="M14.5 4.5v15"/>',
  /* ── explorer settings ───────────────────────────────────────────────── */
  "shortcut-settings": '<rect x="2.5" y="6" width="19" height="12" rx="2.5"/><path d="M6.5 9.8h.01"/><path d="M10 9.8h.01"/><path d="M13.5 9.8h.01"/><path d="M17 9.8h.01"/><path d="M6.5 12.9h.01"/><path d="M10 12.9h.01"/><path d="M13.5 12.9h.01"/><path d="M17 12.9h.01"/><path d="M8.6 15.6h6.8"/>',
  /* Light/dark as the thing it actually switches: one disc, half of it inked. */
  theme: '<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" stroke="none"/>',
  /* zaman:z3 — a clock face, for the Time zone row. */
  timezone: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.2V12l3.2 2"/>',
  tour: '<path d="M2.5 9L12 4.5 21.5 9 12 13.5z"/><path d="M6.6 11.1v4.4c0 1.6 2.4 2.9 5.4 2.9s5.4-1.3 5.4-2.9v-4.4"/>',
  /* "Dosya İste" — the public drop link. A chain, because what this makes is
     a URL to hand somebody. */
  "request-files": '<path d="M10.2 13.8a4.2 4.2 0 0 0 6.1 0l2.3-2.3a4.3 4.3 0 0 0-6.1-6.1l-1.35 1.35"/><path d="M13.8 10.2a4.2 4.2 0 0 0-6.1 0l-2.3 2.3a4.3 4.3 0 0 0 6.1 6.1l1.35-1.35"/>',
  /* ── toolbar chrome that is not a ContextAction ──────────────────────── */
  "go-up": '<path d="M12 20V5"/><path d="M5.5 11.5L12 5l6.5 6.5"/>',
  /* #57 — the storage row's order menu (SideNav). One step up or down is a
     SHORT arrow, so it does not read as `go-up`'s "to the parent folder";
     "Sort by name" is the A→Z mark every file manager uses; "Use default order" is
     the refresh circle turning back. All vertical or rotational, so none of
     them is mirrored in a right-to-left interface. */
  "move-up": '<path d="M12 18V7"/><path d="M7.5 11.5L12 7l4.5 4.5"/>',
  "move-down": '<path d="M12 6v11"/><path d="M7.5 12.5L12 17l4.5-4.5"/>',
  "sort-name": '<path d="M3.5 10.5L6.5 3.5l3 7"/><path d="M4.7 8h3.6"/><path d="M4 13.5h5l-5 7h5"/><path d="M17 4v16"/><path d="M13.5 16.5L17 20l3.5-3.5"/>',
  "reset-order": '<path d="M3.5 12a8.5 8.5 0 1 0 2.49-6.01"/><path d="M6 1.5V6h4.5"/>',
  /* === gorunum:v2-topbar — the breadcrumb row's own controls ============
     The crumb trail gained the reference shell's three affordances: a home
     crumb in place of the bare "/" root, a chevron on the last crumb that
     lists what is inside it, and the path editor we already had (its glyph
     moves here from Breadcrumb.vue so every mark in the row comes from one
     file). */
  home: '<path d="M3.5 10.6L12 3.5l8.5 7.1"/><path d="M5.6 9.4V19a1.5 1.5 0 0 0 1.5 1.5h9.8a1.5 1.5 0 0 0 1.5-1.5V9.4"/><path d="M9.9 20.5v-5.2h4.2v5.2"/>',
  subfolders: '<path d="M6.8 9.8L12 15l5.2-5.2"/>',
  "edit-path": '<path d="M4 20h4l10-10a2.1 2.1 0 0 0-3-3L5 17z"/><path d="M14.5 6.5l3 3"/>',
  /* === gorunum:v2-topbar — the header's trailing cluster ================
     The page chrome around the explorer is gone, so the account-level doors
     are drawn by the header itself (the host fills them through the
     `header-actions` slot). The glyphs live here so an embedder's cluster
     comes out the same weight and colour as everything beside it. */
  admin: '<rect x="3" y="3.5" width="7.4" height="7.4" rx="1.6"/><rect x="13.6" y="3.5" width="7.4" height="4.6" rx="1.6"/><rect x="13.6" y="10.7" width="7.4" height="9.8" rx="1.6"/><rect x="3" y="13.6" width="7.4" height="6.9" rx="1.6"/>',
  /* ⚠ A PERSON, not a cog. The first draft drew the gear as a ringed disc with
     eight spokes and at 16px it came out as a SUN — sitting in the very row
     the light/dark toggle had just been removed from, which is the one thing
     the mark must not be mistaken for (measured at 1440 and 390: it read as a
     theme switch in both). The account bust is what the reference hangs this
     menu on, and the tooltip says which settings. */
  account: '<circle cx="12" cy="8.2" r="3.6"/><path d="M4.9 20.3a7.35 7.35 0 0 1 14.2 0"/>',
  "sign-out": '<path d="M9.5 20.5H6a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h3.5"/><path d="M15.5 16.5L20 12l-4.5-4.5"/><path d="M20 12H9"/>',
  /* The AI assistant, drawn but not yet wired — a spark, the mark every
     assistant in this class of product wears, so the day it does something
     the icon does not have to change under people's fingers. */
  ai: '<path d="M12 3.2l1.75 4.3 4.3 1.75-4.3 1.75L12 15.3l-1.75-4.3L5.95 9.25l4.3-1.75z"/><path d="M18.2 15.1l.8 1.95 1.95.8-1.95.8-.8 1.95-.8-1.95-1.95-.8 1.95-.8z"/>',
  /* The notification bell, for the host's header cluster (web/src
     NotificationBell.vue). ⚠ Drawn HERE, not taken from the app's icon
     library: it sits in the same row as refresh, the spark and the avatar,
     and a glyph at a foreign stroke weight in that row is the exact mismatch
     this set exists to prevent. A dome on a flared rim, the clapper below. */
  bell: '<path d="M6.2 16.6V11a5.8 5.8 0 0 1 11.6 0v5.6l1.7 1.9H4.5z"/><path d="M10.1 21a2.1 2.1 0 0 0 3.8 0"/>',
  /* === /gorunum:v2-topbar === */
  search: '<circle cx="10.8" cy="10.8" r="6.3"/><path d="M15.4 15.4l5.1 5.1"/>',
  /* gorunum:v1-advsearch — sliders, not a funnel. A funnel says "throw rows
     away"; this control opens a dialog where you SET things, and two of its
     three rows are exactly a slider's job (a size range, a time window). */
  filter: '<path d="M4 7.5h4"/><path d="M13 7.5h7"/><circle cx="10.5" cy="7.5" r="2.4"/><path d="M4 16.5h7"/><path d="M16 16.5h4"/><circle cx="13.5" cy="16.5" r="2.4"/>',
  more: '<circle cx="5.5" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="18.5" cy="12" r="1.2" fill="currentColor" stroke="none"/>',
  close: '<path d="M5.5 5.5l13 13"/><path d="M18.5 5.5l-13 13"/>',
  /* A share link. Two half-chains, which is what a link IS. The details
     panel's "Not shared / Create link" row used to draw a chain EMOJI
     there, i.e. whatever glyph the OS happened to ship, full-colour,
     beside a column of stroked grey ones. */
  link: '<path d="M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5"/><path d="M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53"/>',
  /* baglan:b1 — "How to connect". A PLUG, deliberately not the chain above:
     the empty screen's account menu draws both rows one under the other
     ("Paylaştıklarım", then "Bağlantılar"), and one mark on two adjacent rows
     is the misreading this set exists to stop. It is also the mark the admin
     panel's own Connections entry already wears (web lib/adminNav.ts, lucide `Cable`),
     so the two ways into the same screen agree on what it looks like. */
  connect: '<path d="M9 8.5V3"/><path d="M15 8.5V3"/><path d="M6 8.5h12v4.5a4.5 4.5 0 0 1-4.5 4.5h-3A4.5 4.5 0 0 1 6 13z"/><path d="M12 17.5V21"/>',
  /* === ikon:emoji — the command palette's own rows =======================
   * The palette printed `{{ it.icon }}` as TEXT: `➜ 📁 ⬆ ▦ 🗑 ⟳ ↑ 🎨 ⌨ 🎓 ⧉ ◫
   * 💾 🔖`. Thirteen marks from four different type families, in a list whose
   * neighbours — the context menu it duplicates and the toolbar it launches —
   * had already moved here. Most of the keys it needed were drawn already
   * (`tour` is the mortarboard, `shortcut-settings` the keyboard, the three
   * `view-*` the mode chips); these six are what was genuinely missing. */
  /* "Go to path" — the arrow goes INTO the box, the mirror of `sign-out`.
     A bare arrow would have said "next", which this row is not. */
  goto: '<path d="M13.5 4.5h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4"/><path d="M10 8.2L13.8 12 10 15.8"/><path d="M4.5 12h9.3"/>',
  /* A second pane opened beside the first — `nav`/`inspector`'s panel with the
     divider down the middle, because that is literally what split view is. */
  split: pm + '<path d="M12 4.5v15"/>',
  /* A new tab: `open-tab`'s window, with the plus in the body rather than on
     the tab strip (at 16px a plus up there merges into the tab). */
  "tab-new": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/><path d="M12 12.1v5"/><path d="M9.5 14.6h5"/>',
  bookmark: qw,
  "save-search": qw + '<path d="M12 7.2v5.2"/><path d="M9.4 9.8h5.2"/>',
  /* The padlock, for the rows and strips that talk ABOUT encryption ("create
     an encrypted folder", "this one is unlocked"). The listing marker is a
     different drawing on purpose — there the lock is cut out of the folder,
     because the row still has to read as a folder. */
  lock: '<rect x="4.5" y="10.3" width="15" height="10.2" rx="2.2"/><path d="M7.9 10.3V7.6a4.1 4.1 0 0 1 8.2 0v2.7"/><circle cx="12" cy="15.4" r="1.5"/>',
  /* === ikon:emoji — states the viewers and modals report ================
   * `✓ ✗ ⚠️ ⏳` in the viewer chrome. The first two are typographic and came
   * out at whatever weight the UI font had; the last two are colour emoji, so
   * a fallback screen's 48px mark was the only full-colour thing on a grey
   * page. `progress` is drawn as an open ring because it is SPUN by CSS
   * (`@keyframes fe-spin`) — an hourglass cannot say "still going". */
  /* An app plugin's row when its manifest names no glyph this set draws: a
     puzzle piece, the mark every extension surface already wears. Rows whose
     manifest icon IS a key here (`convert`, `lock`, …) get that glyph instead
     — lib/pluginMenu decides, this only draws. */
  plugin: '<path d="M9.5 4.5a2 2 0 1 1 4 0h3a1.5 1.5 0 0 1 1.5 1.5v3a2 2 0 1 1 0 4v3a1.5 1.5 0 0 1-1.5 1.5h-3a2 2 0 1 1-4 0h-3A1.5 1.5 0 0 1 5 16v-3a2 2 0 1 1 0-4V6a1.5 1.5 0 0 1 1.5-1.5z"/>',
  /* A pen signing on a line — the e-signature app's own icon (manifest
     `icon: "sign"`). ⚠ Drawn here because a key the catalogue does not know
     falls back to the generic plugin piece: the sidebar and every menu showed
     the Signatures app as "some app" until it was (2026-09-21, a tester). */
  sign: '<path d="M12.5 20.5h8"/><path d="M16.2 3.9a2.05 2.05 0 0 1 2.9 2.9L8 17.9l-3.9 1 1-3.9z"/><path d="M14.6 5.5l2.9 2.9"/>',
  check: '<path d="M4.8 12.6l4.7 4.7L19.2 6.9"/>',
  alert: '<path d="M10.7 4.6L2.9 18.2a1.5 1.5 0 0 0 1.3 2.25h15.6a1.5 1.5 0 0 0 1.3-2.25L13.3 4.6a1.5 1.5 0 0 0-2.6 0z"/><path d="M12 9.9v4.3"/><circle cx="12" cy="17.4" r="0.9" fill="currentColor" stroke="none"/>',
  progress: '<path d="M20.5 12a8.5 8.5 0 1 1-8.5-8.5"/>'
}, qP = /* @__PURE__ */ new Set(["restore", "goto", "sign-out", "copy-path", "nav", "inspector"]), Ww = /* @__PURE__ */ new Map();
function zt(e) {
  if (!e) return "";
  const t = Ww.get(e);
  if (t !== void 0) return t;
  const n = f2[e], a = n ? `<svg class="${qP.has(e) ? "fe-aicon fe-aicon--dir" : "fe-aicon"}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${n}</svg>` : "";
  return Ww.set(e, a), a;
}
function Pue() {
  return Object.keys(f2);
}
const WP = "__fe-ctx-late";
function uv(e) {
  const t = [];
  for (const n of e)
    n.hidden || n.divider && (t.length === 0 || t[t.length - 1].divider) || t.push(n);
  for (; t.length > 0 && t[t.length - 1].divider; ) t.pop();
  return t;
}
function YP(e, t) {
  const n = /* @__PURE__ */ new Map();
  for (const d of uv(t))
    !d.divider && !n.has(d.key) && n.set(d.key, d);
  const a = /* @__PURE__ */ new Set(), i = e.map((d) => d.divider ? d : (a.add(d.key), n.get(d.key) ?? { ...d, disabled: !0 })), r = [...n.values()].filter((d) => !a.has(d.key));
  if (!r.length) return i;
  const l = { key: WP, label: "", divider: !0 };
  return [...i, l, ...r];
}
const Ty = 80;
function yc(e, t = Ty) {
  var i;
  if (typeof window > "u" || typeof document > "u") return t;
  const n = Array.isArray(e) ? e : [e];
  let a = t;
  for (const r of n) {
    let l = r ?? null;
    for (let d = 0; l && d < 200 && !(l === document.body || l === document.documentElement); d++) {
      let f = Number.NaN, m = !1;
      try {
        const v = window.getComputedStyle(l);
        m = (v.position || "static") !== "static", f = Number.parseInt(v.zIndex, 10);
      } catch {
      }
      m && Number.isFinite(f) && f + 1 > a && (a = f + 1), l = l.parentElement ?? /* Out the top of a shadow tree, if the host put us in one. */
      ((i = l.getRootNode()) == null ? void 0 : i.host) ?? null;
    }
  }
  return a;
}
function GP(e, t) {
  if (typeof document > "u") return [];
  const n = [document.activeElement];
  if (typeof e == "number" && typeof t == "number" && document.elementFromPoint)
    try {
      n.push(document.elementFromPoint(e, t));
    } catch {
    }
  return n;
}
const XP = ["dir", "data-prefers-dark"], JP = ["aria-label"], ZP = ["aria-label", "onKeydown"], QP = { class: "fe-sheet__items" }, eO = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, tO = ["disabled", "title", "data-testid", "onClick"], nO = ["innerHTML"], aO = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, iO = { class: "fe-ctx__label" }, oO = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, rO = ["aria-label"], sO = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, lO = ["disabled", "title", "data-testid", "onClick"], uO = ["innerHTML"], cO = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, dO = { class: "fe-ctx__label" }, fO = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, rl = /* @__PURE__ */ lt({
  __name: "ContextMenu",
  props: {
    locale: {},
    actions: {},
    theme: {},
    sheet: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r, dir: l } = yt(() => a.locale);
    function d(K) {
      return o2(K.shortcutId ?? K.key);
    }
    function f(K) {
      return zt(K.icon || K.key);
    }
    const m = $(!1), v = $(0), b = $(0), _ = $(Ty), w = $([]), k = $(null);
    let x = 0, M = 0, A = null;
    async function T(K, ce) {
      var J, H;
      if (A = document.activeElement ?? null, _.value = yc(GP(K.clientX, K.clientY)), de.value = null, me.value = null, m.value = !0, v.value = K.clientX, b.value = K.clientY, x = K.clientX, M = K.clientY, w.value = ce, await Zt(), m.value && (de.value = uv(a.actions)), a.sheet) {
        const X = (J = U.value) == null ? void 0 : J.getBoundingClientRect().height;
        X && (me.value = X), (H = U.value) == null || H.focus();
        return;
      }
      N(), B(0);
    }
    function N() {
      const K = k.value;
      if (!K || typeof window > "u") return;
      K.style.maxHeight = "", K.style.overflowY = "";
      const ce = K.getBoundingClientRect(), J = 8, H = window.innerWidth, X = window.innerHeight, we = X - 2 * J;
      if (ce.height > we) {
        K.style.maxHeight = we + "px", K.style.overflowY = "auto", b.value = J, v.value = ww(x, ce.width, H, l.value, J);
        return;
      }
      if (M + ce.height > X - J) {
        const it = M - ce.height;
        b.value = it >= J ? it : Math.max(J, X - ce.height - J);
      }
      v.value = ww(x, ce.width, H, l.value, J);
    }
    function z() {
      var K;
      m.value = !1, de.value = null, me.value = null, S.value = !1, F.value = 0, (K = A == null ? void 0 : A.focus) == null || K.call(A), A = null;
    }
    function L() {
      const K = a.sheet ? U.value : k.value;
      return K ? Array.from(
        K.querySelectorAll(".fe-ctx__item:not(:disabled)")
      ) : [];
    }
    function B(K) {
      var H;
      const ce = L();
      if (ce.length === 0) return;
      const J = (K % ce.length + ce.length) % ce.length;
      (H = ce[J]) == null || H.focus();
    }
    function O(K) {
      const ce = L();
      if (ce.length === 0) return;
      const J = document.activeElement, H = J ? ce.indexOf(J) : -1;
      if (H === -1) {
        B(K > 0 ? 0 : ce.length - 1);
        return;
      }
      B(H + K);
    }
    const U = $(null), S = $(!1), F = $(0);
    let I = 0;
    function G(K) {
      const ce = K.touches[0];
      ce && (S.value = !0, I = ce.clientY, F.value = 0);
    }
    function Y(K) {
      if (!S.value) return;
      const ce = K.touches[0];
      ce && (F.value = Math.max(0, ce.clientY - I));
    }
    function ie() {
      if (!S.value) return;
      const K = F.value > 72;
      S.value = !1, K ? z() : F.value = 0;
    }
    const me = $(null), q = E(() => {
      const K = {};
      return me.value !== null && (K.height = `${me.value}px`), F.value > 0 && (K.transform = `translateY(${F.value}px)`, K.transition = "none"), Object.keys(K).length ? K : void 0;
    });
    function C(K) {
      K.disabled || (i("select", K, w.value), z());
    }
    function re(K) {
      if (K.key === "Escape") {
        K.stopPropagation(), z();
        return;
      }
      if (K.key === "Enter" || K.key === " ") {
        K.stopPropagation();
        return;
      }
      K.key === "ArrowDown" ? (K.preventDefault(), K.stopPropagation(), O(1)) : K.key === "ArrowUp" ? (K.preventDefault(), K.stopPropagation(), O(-1)) : K.key === "Home" ? (K.preventDefault(), B(0)) : K.key === "End" ? (K.preventDefault(), B(-1)) : K.key === "Tab" && (K.preventDefault(), z());
    }
    const de = $(null), V = E(
      () => de.value ? YP(de.value, a.actions) : uv(a.actions)
    );
    Xe(
      () => V.value.length,
      async () => {
        if (!m.value || !de.value || a.sheet) return;
        await Zt();
        const K = k.value;
        if (!K || typeof window > "u") return;
        const ce = K.getBoundingClientRect(), J = window.innerHeight - 8 - ce.top;
        J > 0 && ce.height > J && (K.style.maxHeight = J + "px", K.style.overflowY = "auto");
      }
    );
    const W = xl(), ne = E(() => `fe-ctx-backdrop--theme-${a.theme || "auto"}`);
    return t({ show: T, hide: z }), (K, ce) => (p(), Je(hi, { to: "body" }, [
      tt(kr, {
        name: e.sheet ? "fe-sheet" : "fe-ctx"
      }, {
        default: gt(() => [
          m.value ? (p(), h("div", {
            key: 0,
            class: Fe(["fe-ctx-backdrop", [ne.value, { "fe-ctx-backdrop--sheet": e.sheet }]]),
            dir: u(l),
            style: Yt({
              zIndex: _.value
              /* katman:z1 */
            }),
            "data-prefers-dark": u(W) ? "1" : "0",
            onClick: z,
            onContextmenu: vt(z, ["prevent"]),
            onKeydown: re
          }, [
            e.sheet ? (p(), h("div", {
              key: 0,
              ref_key: "sheetEl",
              ref: U,
              class: "fe-sheet",
              role: "menu",
              "aria-label": u(r)("sheet.menu"),
              tabindex: "-1",
              style: Yt(q.value),
              onClick: ce[0] || (ce[0] = vt(() => {
              }, ["stop"]))
            }, [
              c("div", {
                class: "fe-sheet__handle",
                role: "button",
                tabindex: "0",
                "aria-label": u(r)("sheet.close"),
                onClick: z,
                onKeydown: $a(vt(z, ["prevent"]), ["enter"]),
                onTouchstartPassive: G,
                onTouchmovePassive: Y,
                onTouchend: ie,
                onTouchcancel: ie
              }, null, 40, ZP),
              c("div", QP, [
                (p(!0), h(Ce, null, ot(V.value, (J, H) => (p(), h(Ce, {
                  key: J.key || H
                }, [
                  J.divider ? (p(), h("div", eO)) : (p(), h("button", {
                    key: 1,
                    type: "button",
                    class: Fe(["fe-ctx__item fe-sheet__item", { "is-danger": J.danger, "is-disabled": J.disabled }]),
                    disabled: J.disabled,
                    title: J.title,
                    "data-testid": J.testid,
                    role: "menuitem",
                    onClick: (X) => C(J)
                  }, [
                    f(J) ? (p(), h("span", {
                      key: 0,
                      class: "fe-ctx__icon",
                      "aria-hidden": "true",
                      innerHTML: f(J)
                    }, null, 8, nO)) : J.icon ? (p(), h("span", aO, y(J.icon), 1)) : D("", !0),
                    c("span", iO, y(J.label), 1),
                    d(J) ? (p(), h("span", oO, y(d(J)), 1)) : D("", !0)
                  ], 10, tO))
                ], 64))), 128))
              ])
            ], 12, JP)) : (p(), h("div", {
              key: 1,
              ref_key: "menuEl",
              ref: k,
              class: "fe-ctx",
              role: "menu",
              "aria-orientation": "vertical",
              "aria-label": u(r)("sheet.menu"),
              style: Yt({ top: b.value + "px", left: v.value + "px" }),
              onClick: ce[1] || (ce[1] = vt(() => {
              }, ["stop"]))
            }, [
              (p(!0), h(Ce, null, ot(V.value, (J, H) => (p(), h(Ce, {
                key: J.key || H
              }, [
                J.divider ? (p(), h("div", sO)) : (p(), h("button", {
                  key: 1,
                  type: "button",
                  class: Fe(["fe-ctx__item", { "is-danger": J.danger, "is-disabled": J.disabled }]),
                  disabled: J.disabled,
                  title: J.title,
                  "data-testid": J.testid,
                  role: "menuitem",
                  onClick: (X) => C(J)
                }, [
                  f(J) ? (p(), h("span", {
                    key: 0,
                    class: "fe-ctx__icon",
                    "aria-hidden": "true",
                    innerHTML: f(J)
                  }, null, 8, uO)) : J.icon ? (p(), h("span", cO, y(J.icon), 1)) : D("", !0),
                  c("span", dO, y(J.label), 1),
                  d(J) ? (p(), h("span", fO, y(d(J)), 1)) : D("", !0)
                ], 10, lO))
              ], 64))), 128))
            ], 12, rO))
          ], 46, XP)) : D("", !0)
        ]),
        _: 1
      }, 8, ["name"])
    ]));
  }
}), pO = ["aria-pressed", "title", "aria-label"], hO = {
  key: 1,
  class: "fe-toolbar__mark"
}, mO = ["src"], vO = { key: 1 }, yO = { class: "fe-toolbar__primary" }, gO = ["title"], bO = ["innerHTML"], kO = { class: "fe-btn__label" }, wO = ["title", "aria-label"], _O = ["innerHTML"], xO = ["title"], SO = ["innerHTML"], $O = { class: "fe-btn__label" }, TO = { class: "fe-toolbar__search-group fe-toolbar__search-group--drive" }, AO = {
  class: "fe-search fe-drivesearch",
  "data-testid": "drive-search"
}, EO = ["placeholder", "value", "aria-label"], CO = ["title", "aria-label"], zO = ["innerHTML"], MO = ["title", "aria-label"], PO = { class: "fe-toolbar__tail" }, OO = ["title", "aria-label"], DO = ["innerHTML"], LO = { class: "fe-toolbar__soon-wrap" }, RO = ["aria-label"], NO = ["innerHTML"], IO = {
  class: "fe-toolbar__soon-tip",
  "aria-hidden": "true",
  "data-testid": "header-ai-tip"
}, BO = ["title", "aria-label"], FO = ["innerHTML"], UO = {
  class: "fe-drivesearch",
  "data-testid": "drive-search"
}, HO = ["placeholder", "value", "aria-label"], KO = ["title", "aria-label"], VO = ["innerHTML"], jO = ["title", "aria-label"], qO = { class: "fe-toolbar__tail" }, WO = { class: "fe-toolbar__soon-wrap" }, YO = ["aria-label"], GO = ["innerHTML"], XO = {
  class: "fe-toolbar__soon-tip",
  "aria-hidden": "true",
  "data-testid": "header-ai-tip"
}, JO = ["title", "aria-label"], ZO = ["innerHTML"], QO = ["aria-label"], e3 = {
  class: "fe-selbar__count",
  role: "status",
  "data-testid": "selection-count"
}, t3 = ["disabled", "title", "aria-label", "data-key", "data-testid", "onClick"], n3 = ["innerHTML"], a3 = ["title", "aria-label"], i3 = ["innerHTML"], o3 = ["data-key"], r3 = ["innerHTML"], s3 = ["title", "aria-label"], l3 = ["innerHTML"], Bd = "filex.density", u3 = 32, Yw = "fe:header-menu", c3 = /* @__PURE__ */ lt({
  __name: "Toolbar",
  props: {
    viewMode: {},
    searchQuery: {},
    trashActive: { type: Boolean },
    actions: {},
    selectionMode: {},
    selectionCount: {},
    selectionPane: {},
    pasteEnabled: { type: Boolean },
    canGoUp: { type: Boolean },
    atVirtualRoot: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    narrow: { type: Boolean },
    theme: {},
    inspectorOpen: { type: Boolean },
    navOpen: { type: Boolean },
    navEnabled: { type: Boolean },
    viewModes: {},
    scopeLabel: {},
    brandName: {},
    brandMarkUrl: {},
    searchEscalates: { type: Boolean }
  },
  emits: ["update:viewMode", "update:searchQuery", "open-advanced-search", "new-folder", "upload", "refresh", "go-up", "action", "open-recents", "update:density", "toggle-inspector", "toggle-nav", "open-theme", "open-shortcut-settings", "open-timezone", "open-palette"],
  setup(e, { expose: t, emit: n }) {
    function a(ae) {
      return zt(ae.icon || ae.key);
    }
    const i = e, r = n, l = $(
      (() => {
        try {
          return localStorage.getItem(Bd) === "compact" ? "compact" : "comfortable";
        } catch {
          return "comfortable";
        }
      })()
    );
    function d() {
      try {
        const ae = localStorage.getItem(Bd) === "compact" ? "compact" : "comfortable";
        ae !== l.value && (l.value = ae, r("update:density", ae));
      } catch {
      }
    }
    function f(ae) {
      (ae.key === null || ae.key === Bd) && d();
    }
    Wt(() => {
      r("update:density", l.value), window.addEventListener("storage", f), window.addEventListener("filex:density", d);
    }), Ot(() => {
      window.removeEventListener("storage", f), window.removeEventListener("filex:density", d);
    });
    function m() {
      l.value = l.value === "compact" ? "comfortable" : "compact";
      try {
        localStorage.setItem(Bd, l.value);
      } catch {
      }
      r("update:density", l.value);
    }
    const { t: v, dir: b } = yt(() => i.locale), _ = $(null), w = $(i.searchQuery);
    Xe(() => i.searchQuery, (ae) => {
      w.value = ae;
    });
    let k;
    function x(ae) {
      const ve = ae.target.value;
      w.value = ve, k && clearTimeout(k), k = setTimeout(() => r("update:searchQuery", ve), 200);
    }
    async function M() {
      var ae, ve;
      await Zt(), (ae = _.value) == null || ae.focus(), (ve = _.value) == null || ve.select();
    }
    t({ focusSearch: M });
    const A = E(() => i.selectionMode ?? "none"), T = E(() => i.actions.filter((ae) => !ae.divider && !ae.hidden)), N = /* @__PURE__ */ new Set(["download", "access", "cut", "copy", "star", "restore", "delete"]), z = E(() => A.value !== "none"), L = E(() => {
      const ae = [], ve = [];
      let le = 0;
      for (const _e of i.actions)
        if (!_e.hidden) {
          if (_e.divider) {
            ve.push(_e);
            continue;
          }
          N.has(_e.key) && a(_e) ? ae.push(_e) : (ve.push(_e), le++);
        }
      return { icons: ae, rest: le ? ve : [], restCount: le };
    }), B = $(null), O = $(null), U = $(null), S = $(null), F = $(Number.MAX_SAFE_INTEGER), I = E(() => L.value.icons.slice(0, F.value)), G = E(() => L.value.icons.slice(F.value)), Y = E(() => {
      const ae = G.value, ve = L.value.rest;
      return ae.length && ve.length ? [...ae, { divider: !0, key: "selbar-sep", label: "" }, ...ve] : [...ae, ...ve];
    });
    function ie() {
      var At;
      const ae = B.value, ve = O.value, le = L.value.icons.length;
      if (!ae || !ve) {
        F.value = le;
        return;
      }
      const _e = parseFloat(getComputedStyle(ae).gap) || 4, Ee = Array.from(ve.children).map((zn) => zn.offsetWidth + _e), ht = Ee.reduce((zn, Bt) => zn + Bt, 0), jt = ae.clientWidth, tn = (((At = U.value) == null ? void 0 : At.offsetWidth) || u3) + _e;
      if (ht <= jt - (L.value.rest.length ? tn : 0)) {
        F.value = Ee.length;
        return;
      }
      let Cn = tn, Lt = 0;
      for (const zn of Ee) {
        if (Cn + zn > jt) break;
        Cn += zn, Lt += 1;
      }
      F.value = Lt;
    }
    let me;
    Xe(B, (ae) => {
      me == null || me.disconnect(), me = void 0, ae && typeof ResizeObserver < "u" && (me = new ResizeObserver(() => ie()), me.observe(ae)), Zt(ie);
    }), Ot(() => me == null ? void 0 : me.disconnect()), Xe(
      () => [T.value, i.narrow, i.trashActive, A.value],
      () => void Zt(ie),
      { deep: !1 }
    );
    function q() {
      var ve, le;
      const ae = (ve = U.value) == null ? void 0 : ve.getBoundingClientRect();
      (le = S.value) == null || le.show({ clientX: ae ? kw(ae, b.value) : 0, clientY: ae ? ae.bottom + 4 : 0 }, []);
    }
    const C = $(null), re = xa(null), de = $(!1), V = xa(null), W = xa(null);
    function ne() {
      var le;
      const ae = (le = C.value) == null ? void 0 : le.closest(".fe");
      if (!ae) return null;
      const ve = i.selectionPane;
      if (ve && /^[A-Za-z][\w-]*$/.test(ve)) {
        const _e = ae.querySelector(`.fe__primary[data-pane="${ve}"]`);
        if (_e) return _e;
      }
      return ae.querySelector(".fe__primary");
    }
    function K() {
      const ae = re.value;
      ae && (ae.classList.remove("is-active"), de.value && ae.remove()), re.value = null, de.value = !1;
    }
    function ce() {
      var le;
      const ae = ne();
      if (!ae) {
        K(), W.value = null, V.value = null;
        return;
      }
      if (W.value === ae && ((le = re.value) != null && le.isConnected)) return;
      K(), W.value = ae, V.value = ae.querySelector(":scope > .fe__body");
      const ve = ae.querySelector(":scope > .fe-selbar-slot");
      if (ve)
        re.value = ve, de.value = !1;
      else {
        const _e = document.createElement("div");
        _e.className = "fe-selbar-slot";
        const Ee = ae.querySelector(":scope > .fe-tabs") ?? ae.querySelector(":scope > .fe-subhead, :scope > .fe-subhead--plain");
        Ee ? Ee.insertAdjacentElement("afterend", _e) : ae.prepend(_e), re.value = _e, de.value = !0;
      }
      J(), Be();
    }
    Wt(ce), Ot(K);
    function J() {
      var ae;
      (ae = re.value) == null || ae.classList.toggle("is-active", z.value);
    }
    Xe(z, J, { immediate: !0 }), Xe([() => i.selectionPane, z], () => ce());
    const H = $(0);
    let X, we = !1;
    function it() {
      const ae = W.value;
      ae && (H.value = ae.querySelectorAll('[data-fe-path][aria-selected="true"]').length);
    }
    function Re() {
      if (we) return;
      we = !0, ((ve) => typeof requestAnimationFrame == "function" ? requestAnimationFrame(ve) : setTimeout(ve, 16))(() => {
        we = !1, it();
      });
    }
    function Be() {
      if (X == null || X.disconnect(), X = void 0, !z.value) {
        H.value = 0;
        return;
      }
      it(), !(typeof MutationObserver > "u" || !W.value) && (X = new MutationObserver(Re), X.observe(W.value, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: ["aria-selected"]
      }));
    }
    Xe(z, Be), Ot(() => X == null ? void 0 : X.disconnect());
    const We = E(() => typeof i.selectionCount == "number" ? i.selectionCount : A.value === "none" ? 0 : Math.max(H.value, A.value === "multi" ? 2 : 1)), bt = E(() => v("selection.count", { n: String(We.value) }));
    function at() {
      var ae;
      r("action", "clear-selection"), (ae = V.value) == null || ae.dispatchEvent(new MouseEvent("click", { bubbles: !0 }));
    }
    function Ie(ae) {
      r("action", ae);
    }
    const nt = $(!1);
    let dt;
    function Me(ae) {
      nt.value = !!(ae && "matches" in ae && ae.matches);
    }
    Wt(() => {
      var ae;
      typeof window > "u" || !window.matchMedia || (dt = window.matchMedia("(pointer: coarse)"), Me(dt), (ae = dt.addEventListener) == null || ae.call(dt, "change", Me));
    }), Ot(() => {
      var ae;
      (ae = dt == null ? void 0 : dt.removeEventListener) == null || ae.call(dt, "change", Me);
    });
    const be = $(null), Ve = $(null);
    function Te(ae) {
      return !i.viewModes || i.viewModes.includes(ae);
    }
    const qe = E(() => {
      const ae = [];
      return i.narrow && ae.push({ key: "refresh", label: v("toolbar.refresh") }), ae.push({
        key: "density",
        label: l.value === "compact" ? v("toolbar.density.comfortable") : v("toolbar.density.compact")
      }), i.viewMode !== "list" && Te("list") && ae.push({ key: "view-list", label: v("toolbar.view.list") }), i.viewMode !== "grid" && Te("grid") && ae.push({ key: "view-grid", label: v("toolbar.view.grid") }), i.viewMode !== "gallery" && Te("gallery") && ae.push({ key: "view-gallery", label: v("toolbar.view.gallery") }), ae.push({ key: "inspector", label: v("toolbar.inspector") }), ae.push({ key: "theme", label: v("theme.menu") }), ae.push({ key: "timezone", label: v("tz.menu") }), ae.push({ key: "shortcut-settings", label: v("shortcuts.settings.menu") }), ae.push({ key: "tour", label: v("tour.restart") }), ae;
    });
    function De(ae) {
      const ve = [], le = !i.trashActive && !i.atVirtualRoot && i.canWrite !== !1;
      return A.value === "none" && le && (ve.push({ key: "new-folder", label: v("toolbar.new_folder") }), i.pasteEnabled && ve.push({ key: "paste", label: v("ctx.paste") })), z.value || ve.push(...T.value), ae.length && (ve.length && ve.push({ divider: !0, key: "bag-sep", label: "" }), ve.push(...ae)), ve;
    }
    const mt = E(() => by("palette"));
    function $t(ae, ve) {
      const le = o2(ve);
      return le ? `${ae} (${le})` : ae;
    }
    const kt = E(() => i.narrow ? i.navOpen ? v("sidenav.close") : v("sidenav.open") : i.navOpen ? v("sidenav.collapse") : v("sidenav.expand")), Tt = E(
      () => i.scopeLabel ? v("drive.search.placeholder", { scope: i.scopeLabel }) : v("drive.search.placeholder_all")
    );
    function xe(ae) {
      if (r2(ae, "palette")) {
        ae.preventDefault(), ae.stopPropagation(), r("open-palette", w.value);
        return;
      }
      i.searchEscalates && ae.key === "Enter" && w.value && (ae.preventDefault(), ae.stopPropagation(), r("open-palette", w.value));
    }
    const Ne = $(!1);
    function fe() {
      const ae = C.value;
      if (!ae) return;
      const ve = {
        items: qe.value.map((le) => ({ ...le })),
        run: (le) => ge({ key: le }),
        claimed: !1
      };
      ae.dispatchEvent(
        new CustomEvent(Yw, { detail: ve, bubbles: !0, composed: !0 })
      ), Ne.value = !!ve.claimed;
    }
    Wt(() => void Zt(fe)), Xe(qe, () => void Zt(fe), { deep: !1 }), Ot(() => {
      typeof document > "u" || document.dispatchEvent(
        new CustomEvent(Yw, {
          detail: { items: [], run: () => {
          }, claimed: !1 }
        })
      );
    });
    const Se = E(() => {
      const ae = Ne.value ? [] : qe.value;
      return i.narrow ? De(ae) : ae;
    });
    function Z() {
      var ve, le;
      const ae = (ve = be.value) == null ? void 0 : ve.getBoundingClientRect();
      (le = Ve.value) == null || le.show({ clientX: ae ? kw(ae, b.value) : 0, clientY: ae ? ae.bottom + 4 : 0 }, []);
    }
    function ge(ae) {
      var ve;
      switch (ae.key) {
        case "new-folder":
          r("new-folder");
          break;
        case "refresh":
          r("refresh");
          break;
        case "density":
          m();
          break;
        case "view-list":
          r("update:viewMode", "list");
          break;
        case "view-grid":
          r("update:viewMode", "grid");
          break;
        case "view-gallery":
          r("update:viewMode", "gallery");
          break;
        case "inspector":
          r("toggle-inspector");
          break;
        case "nav":
          r("toggle-nav");
          break;
        case "theme":
          r("open-theme");
          break;
        case "shortcut-settings":
          r("open-shortcut-settings");
          break;
        case "timezone":
          r("open-timezone");
          break;
        case "tour":
          (ve = C.value) == null || ve.dispatchEvent(new CustomEvent("fe:tour-restart", { bubbles: !0 }));
          break;
        default:
          Ie(ae.key);
      }
    }
    return (ae, ve) => (p(), h("div", {
      ref_key: "rootEl",
      ref: C,
      class: Fe(["fe-toolbar", {
        "fe-toolbar--narrow": e.narrow,
        /* surucu:d1 — ALWAYS on. It is no longer a variant: this is the only
           header filex has, and the modifier survives as the hook the one
           visual definition in styles/base.css was written against. Dropping it
           would mean moving those rules, not deleting a state. */
        "fe-toolbar--drive": !0
      }])
    }, [
      e.navEnabled !== !1 || ae.$slots.brand || e.brandName || e.brandMarkUrl ? (p(), h("div", {
        key: 0,
        class: Fe(["fe-toolbar__brand", {
          "fe-toolbar__brand--gutter": e.navEnabled !== !1,
          /* gezinti:g3 — the panel collapsed to its rail, so this gutter has to
             collapse with it. `navOpen === false`, never `!navOpen`: the prop is
             optional, and an embedder that does not pass it must keep the
             expanded layout rather than lose its wordmark to a `undefined`. */
          "fe-toolbar__brand--rail": !e.narrow && e.navEnabled !== !1 && e.navOpen === !1
        }])
      }, [
        e.navEnabled !== !1 ? (p(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--icon-only fe-toolbar__nav",
          "aria-pressed": !!e.navOpen,
          title: kt.value,
          "aria-label": kt.value,
          "data-testid": "toolbar-nav",
          onClick: ve[0] || (ve[0] = (le) => r("toggle-nav"))
        }, [...ve[12] || (ve[12] = [
          c("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            c("path", { d: "M4 7h16M4 12h16M4 17h16" })
          ], -1)
        ])], 8, pO)) : D("", !0),
        !e.narrow && e.navOpen !== !1 ? (p(), h("div", hO, [
          En(ae.$slots, "brand", {}, () => [
            e.brandMarkUrl ? (p(), h("img", {
              key: 0,
              class: "fe-toolbar__markimg",
              src: e.brandMarkUrl,
              alt: ""
            }, null, 8, mO)) : D("", !0),
            e.brandName ? (p(), h("span", vO, y(e.brandName), 1)) : D("", !0)
          ])
        ])) : D("", !0)
      ], 2)) : D("", !0),
      e.narrow ? (p(), h(Ce, { key: 2 }, [
        c("div", UO, [
          ve[14] || (ve[14] = c("svg", {
            class: "fe-ficon fe-drivesearch__glass",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.9",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            c("circle", {
              cx: "11",
              cy: "11",
              r: "6.5"
            }),
            c("path", { d: "M16 16l4.5 4.5" })
          ], -1)),
          c("input", {
            ref_key: "searchEl",
            ref: _,
            type: "search",
            class: "fe-drivesearch__input",
            placeholder: Tt.value,
            value: w.value,
            "aria-label": u(v)("toolbar.search"),
            onInput: x,
            onKeydown: xe
          }, null, 40, HO),
          c("button", {
            type: "button",
            class: "fe-drivesearch__tune",
            title: u(v)("advsearch.open"),
            "aria-label": u(v)("advsearch.open"),
            "data-testid": "drive-search-advanced",
            onClick: ve[8] || (ve[8] = (le) => r("open-advanced-search", w.value))
          }, [
            c("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("filter")
            }, null, 8, VO)
          ], 8, KO),
          c("button", {
            type: "button",
            class: "fe-drivesearch__kbd",
            title: u(v)("drive.search.hint_title", { combo: mt.value }),
            "aria-label": u(v)("drive.search.hint_title", { combo: mt.value }),
            "data-testid": "drive-search-palette",
            onClick: ve[9] || (ve[9] = (le) => r("open-palette", w.value))
          }, y(mt.value), 9, jO)
        ]),
        c("div", qO, [
          c("span", WO, [
            c("button", {
              type: "button",
              class: "fe-btn fe-btn--icon-only fe-toolbar__soon",
              disabled: "",
              "aria-label": u(v)("ai.assistant.soon"),
              "aria-disabled": "true",
              "data-testid": "header-ai",
              onClick: ve[10] || (ve[10] = vt(() => {
              }, ["prevent"]))
            }, [
              c("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: u(zt)("ai")
              }, null, 8, GO)
            ], 8, YO),
            c("span", XO, y(u(v)("ai.assistant.soon")), 1)
          ]),
          Se.value.length > 0 ? (p(), h("button", {
            key: 0,
            ref_key: "moreBtnEl",
            ref: be,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: u(v)("toolbar.more"),
            "aria-label": u(v)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: Z
          }, [
            c("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("more")
            }, null, 8, ZO)
          ], 8, JO)) : D("", !0),
          En(ae.$slots, "header-actions")
        ])
      ], 64)) : (p(), h(Ce, { key: 1 }, [
        c("div", yO, [
          e.navEnabled === !1 && A.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (p(), h("button", {
            key: 0,
            type: "button",
            class: "fe-btn fe-btn--primary",
            title: $t(u(v)("toolbar.new_folder"), "new-folder"),
            onClick: ve[1] || (ve[1] = (le) => r("new-folder"))
          }, [
            c("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("new-folder")
            }, null, 8, bO),
            c("span", kO, y(u(v)("toolbar.new_folder")), 1)
          ], 8, gO)) : D("", !0),
          e.navEnabled === !1 && !e.atVirtualRoot && e.canWrite !== !1 ? (p(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: $t(u(v)("toolbar.upload"), "upload"),
            "aria-label": u(v)("toolbar.upload"),
            onClick: ve[2] || (ve[2] = (le) => r("upload"))
          }, [
            c("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("upload")
            }, null, 8, _O)
          ], 8, wO)) : D("", !0),
          e.pasteEnabled && A.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (p(), h("button", {
            key: 2,
            type: "button",
            class: "fe-btn",
            title: $t(u(v)("ctx.paste"), "paste"),
            onClick: ve[3] || (ve[3] = (le) => Ie("paste"))
          }, [
            c("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("paste")
            }, null, 8, SO),
            c("span", $O, y(u(v)("ctx.paste")), 1)
          ], 8, xO)) : D("", !0)
        ]),
        c("div", TO, [
          c("div", AO, [
            ve[13] || (ve[13] = c("svg", {
              class: "fe-ficon fe-drivesearch__glass",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              c("circle", {
                cx: "11",
                cy: "11",
                r: "6.5"
              }),
              c("path", { d: "M16 16l4.5 4.5" })
            ], -1)),
            c("input", {
              ref_key: "searchEl",
              ref: _,
              type: "search",
              class: "fe-search__input fe-drivesearch__input",
              placeholder: Tt.value,
              value: w.value,
              "aria-label": u(v)("toolbar.search"),
              onInput: x,
              onKeydown: xe
            }, null, 40, EO),
            c("button", {
              type: "button",
              class: "fe-drivesearch__tune",
              title: u(v)("advsearch.open"),
              "aria-label": u(v)("advsearch.open"),
              "data-testid": "drive-search-advanced",
              onClick: ve[4] || (ve[4] = (le) => r("open-advanced-search", w.value))
            }, [
              c("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: u(zt)("filter")
              }, null, 8, zO)
            ], 8, CO),
            c("button", {
              type: "button",
              class: "fe-drivesearch__kbd",
              title: u(v)("drive.search.hint_title", { combo: mt.value }),
              "aria-label": u(v)("drive.search.hint_title", { combo: mt.value }),
              "data-testid": "drive-search-palette",
              onClick: ve[5] || (ve[5] = (le) => r("open-palette", w.value))
            }, y(mt.value), 9, MO)
          ])
        ]),
        c("div", PO, [
          c("button", {
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: $t(u(v)("toolbar.refresh"), "refresh"),
            "aria-label": u(v)("toolbar.refresh"),
            onClick: ve[6] || (ve[6] = (le) => r("refresh"))
          }, [
            c("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("refresh")
            }, null, 8, DO)
          ], 8, OO),
          c("span", LO, [
            c("button", {
              type: "button",
              class: "fe-btn fe-btn--icon-only fe-toolbar__soon",
              disabled: "",
              "aria-label": u(v)("ai.assistant.soon"),
              "aria-disabled": "true",
              "data-testid": "header-ai",
              onClick: ve[7] || (ve[7] = vt(() => {
              }, ["prevent"]))
            }, [
              c("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: u(zt)("ai")
              }, null, 8, NO)
            ], 8, RO),
            c("span", IO, y(u(v)("ai.assistant.soon")), 1)
          ]),
          Se.value.length > 0 ? (p(), h("button", {
            key: 0,
            ref_key: "moreBtnEl",
            ref: be,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: u(v)("toolbar.more"),
            "aria-label": u(v)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: Z
          }, [
            c("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("more")
            }, null, 8, FO)
          ], 8, BO)) : D("", !0),
          En(ae.$slots, "header-actions")
        ])
      ], 64)),
      tt(rl, {
        ref_key: "moreRef",
        ref: Ve,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: nt.value,
        actions: Se.value,
        onSelect: ge
      }, null, 8, ["locale", "theme", "sheet", "actions"]),
      (p(), Je(hi, {
        to: re.value || "body",
        disabled: !re.value
      }, [
        z.value ? (p(), h("div", {
          key: 0,
          class: Fe(["fe-selbar", { "fe-selbar--inline": !re.value }]),
          role: "toolbar",
          "aria-label": bt.value,
          "data-testid": "selection-bar"
        }, [
          c("span", e3, y(bt.value), 1),
          c("div", {
            ref_key: "selBarEl",
            ref: B,
            class: "fe-selbar__actions"
          }, [
            (p(!0), h(Ce, null, ot(I.value, (le) => (p(), h("button", {
              key: le.key,
              type: "button",
              class: Fe(["fe-selbar__btn", { "fe-selbar__btn--danger": le.danger, "is-disabled": le.disabled }]),
              disabled: le.disabled,
              title: le.title || $t(le.label, le.key),
              "aria-label": le.label,
              "data-key": le.key,
              "data-testid": `selbar-${le.key}`,
              onClick: (_e) => Ie(le.key)
            }, [
              c("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: a(le)
              }, null, 8, n3)
            ], 10, t3))), 128)),
            Y.value.length > 0 ? (p(), h("button", {
              key: 0,
              ref_key: "selMoreBtnEl",
              ref: U,
              type: "button",
              class: "fe-selbar__btn",
              title: u(v)("toolbar.more"),
              "aria-label": u(v)("toolbar.more"),
              "aria-haspopup": "menu",
              "data-testid": "selbar-more",
              onClick: q
            }, [
              c("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: u(zt)("more")
              }, null, 8, i3)
            ], 8, a3)) : D("", !0),
            c("div", {
              ref_key: "measureEl",
              ref: O,
              class: "fe-selbar__measure",
              "aria-hidden": "true"
            }, [
              (p(!0), h(Ce, null, ot(L.value.icons, (le) => (p(), h("button", {
                key: "m-" + le.key,
                type: "button",
                class: "fe-selbar__btn",
                "data-key": le.key,
                tabindex: "-1"
              }, [
                c("span", {
                  class: "fe-icon",
                  "aria-hidden": "true",
                  innerHTML: a(le)
                }, null, 8, r3)
              ], 8, o3))), 128))
            ], 512)
          ], 512),
          c("button", {
            type: "button",
            class: "fe-selbar__close",
            title: u(v)("selection.clear"),
            "aria-label": u(v)("selection.clear"),
            "data-testid": "selection-clear",
            onClick: at
          }, [
            c("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("close")
            }, null, 8, l3)
          ], 8, s3)
        ], 10, QO)) : D("", !0)
      ], 8, ["to", "disabled"])),
      tt(rl, {
        ref_key: "selMoreRef",
        ref: S,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: nt.value,
        actions: Y.value,
        onSelect: ve[11] || (ve[11] = (le) => Ie(le.key))
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 2));
  }
}), d3 = 6e4;
function f3(e) {
  return e === "personal" || e === "team";
}
function Oue(e, t) {
  var n;
  return (n = e.find((a) => a.name === t)) == null ? void 0 : n.key;
}
function cv(e) {
  const t = e ?? {};
  return Array.isArray(t.items) ? t.items.filter(
    (n) => !!n && typeof n.name == "string" && n.name !== "" && f3(n.kind)
  ) : Array.isArray(t.tags) ? t.tags.filter((n) => typeof n == "string" && n !== "").map((n) => ({ name: n, kind: "team" })) : [];
}
const dv = /* @__PURE__ */ new Map(), af = /* @__PURE__ */ new Map();
function p3() {
  dv.clear(), af.clear();
}
const fv = /* @__PURE__ */ new Set();
function h3(e) {
  return fv.add(e), () => {
    fv.delete(e);
  };
}
function m3() {
  p3();
  for (const e of [...fv])
    try {
      e();
    } catch {
    }
}
async function Gw(e = {}) {
  const t = e.apiBase ?? "", n = t || "(same-origin)";
  if (!e.force) {
    const i = dv.get(n);
    if (i && Date.now() - i.at < d3) return i.tags;
    const r = af.get(n);
    if (r) return r;
  }
  const a = (async () => {
    try {
      const i = await fetch(`${t}/api/files/manager/tags/all`, {
        headers: await (e.authHeaders ?? (() => ({})))(),
        credentials: e.authCredentials ?? "same-origin"
      });
      if (!i.ok) return [];
      const r = cv(await i.json());
      return dv.set(n, { at: Date.now(), tags: r }), r;
    } catch {
      return [];
    } finally {
      af.delete(n);
    }
  })();
  return af.set(n, a), a;
}
async function v3(e, t = {}, n = {}) {
  const a = t.apiBase ?? "", i = new URLSearchParams({ tag: e, limit: String(n.limit ?? 100), offset: String(n.offset ?? 0) });
  n.kind && i.set("kind", n.kind), n.sort && i.set("sort", n.sort);
  const r = await fetch(`${a}/api/files/manager/tagged?${i}`, {
    headers: await (t.authHeaders ?? (() => ({})))(),
    credentials: t.authCredentials ?? "same-origin"
  });
  if (!r.ok) throw new Error(String(r.status));
  const l = await r.json(), d = Array.isArray(l == null ? void 0 : l.nodes) ? l.nodes : [];
  return {
    rows: d,
    total: typeof (l == null ? void 0 : l.total) == "number" ? l.total : (n.offset ?? 0) + d.length,
    truncated: (l == null ? void 0 : l.truncated) === !0
  };
}
const y3 = ["width", "height", "data-tag-kind"], pv = /* @__PURE__ */ lt({
  __name: "TagKindIcon",
  props: {
    kind: {},
    size: {}
  },
  setup(e) {
    return (t, n) => (p(), h("svg", {
      class: Fe(["fe-tagkind", `fe-tagkind--${e.kind}`]),
      width: e.size ?? 12,
      height: e.size ?? 12,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      focusable: "false",
      "data-tag-kind": e.kind
    }, [
      e.kind === "team" ? (p(), h(Ce, { key: 0 }, [
        n[0] || (n[0] = c("circle", {
          cx: "9",
          cy: "8",
          r: "3.2"
        }, null, -1)),
        n[1] || (n[1] = c("path", { d: "M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" }, null, -1)),
        n[2] || (n[2] = c("circle", {
          cx: "17",
          cy: "9",
          r: "2.6"
        }, null, -1)),
        n[3] || (n[3] = c("path", { d: "M16.5 14.2c2.6.3 4.5 2.6 4.5 5.3" }, null, -1))
      ], 64)) : (p(), h(Ce, { key: 1 }, [
        n[4] || (n[4] = c("circle", {
          cx: "12",
          cy: "8",
          r: "3.6"
        }, null, -1)),
        n[5] || (n[5] = c("path", { d: "M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" }, null, -1))
      ], 64))
    ], 10, y3));
  }
}), g3 = ["role", "aria-labelledby", "aria-label", "data-testid"], b3 = { class: "fe-choice__strip" }, k3 = ["role", "aria-checked", "aria-pressed", "aria-label", "aria-describedby", "tabindex", "disabled", "data-testid", "onClick", "onKeydown"], w3 = {
  key: 1,
  class: "fe-choice__label"
}, _3 = {
  key: 2,
  class: "fe-choice__help"
}, x3 = ["id", "data-testid"], S3 = ["data-testid"], ui = /* @__PURE__ */ lt({
  __name: "ChoiceButtons",
  props: {
    options: {},
    modelValue: {},
    multi: { type: Boolean },
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    segmented: { type: Boolean },
    iconOnly: { type: Boolean },
    ariaLabelledby: {},
    ariaLabel: {},
    testidPrefix: {},
    testid: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => !!n.segmented || !!n.iconOnly), r = `fe-choice-${Math.random().toString(36).slice(2, 10)}`, l = (M) => `${r}-tip-${M}`;
    function d(M) {
      return i.value ? M.help || (n.iconOnly ? M.label : "") : "";
    }
    const f = E(() => {
      var M;
      return !i.value || n.multi ? "" : ((M = n.options.find((A) => v(A.value))) == null ? void 0 : M.help) ?? "";
    }), m = E(() => {
      const M = n.modelValue;
      return Array.isArray(M) ? M.map((A) => String(A)) : M == null || M === "" ? [] : [String(M)];
    });
    function v(M) {
      return m.value.includes(M);
    }
    function b(M) {
      var A;
      return !!n.disabled || !!((A = n.options.find((T) => T.value === M)) != null && A.disabled);
    }
    function _(M) {
      if (!b(M)) {
        if (n.multi) {
          const A = v(M) ? m.value.filter((N) => N !== M) : [...m.value, M], T = n.options.map((N) => N.value);
          a("update:modelValue", T.filter((N) => A.includes(N)));
          return;
        }
        a("update:modelValue", M);
      }
    }
    function w(M) {
      const A = n.options.length;
      for (let T = 0; T < A; T++) {
        const N = M === 1 ? T : A - 1 - T;
        if (!n.options[N].disabled) return N;
      }
      return -1;
    }
    function k(M, A) {
      var B;
      if (n.multi || n.disabled) return;
      const T = n.options.length;
      let N;
      if (M.key === "Home" || M.key === "End") {
        if (M.preventDefault(), N = w(M.key === "Home" ? 1 : -1), N < 0) return;
      } else {
        if (!["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp"].includes(M.key)) return;
        M.preventDefault();
        const U = M.key === "ArrowDown" ? 1 : M.key === "ArrowUp" ? -1 : wf(M.key, Ga(M.currentTarget));
        if (!T || (N = (A + U + T) % T, n.options[N].disabled)) return;
      }
      _(n.options[N].value);
      const z = M.currentTarget.closest(".fe-choice"), L = z == null ? void 0 : z.querySelectorAll("[data-choice]");
      (B = L == null ? void 0 : L[N]) == null || B.focus();
    }
    function x(M, A) {
      return n.multi ? 0 : m.value.length ? v(M) ? 0 : -1 : A === 0 ? 0 : -1;
    }
    return (M, A) => (p(), h("div", {
      class: Fe(["fe-choice", {
        "is-invalid": e.invalid,
        "is-disabled": e.disabled,
        "fe-choice--segmented": i.value,
        "fe-choice--icons": e.iconOnly
      }]),
      role: e.multi ? "group" : "radiogroup",
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "data-testid": e.testid ?? "choice-buttons"
    }, [
      c("div", b3, [
        (p(!0), h(Ce, null, ot(e.options, (T, N) => (p(), h("span", {
          key: T.value,
          class: "fe-choice__cell"
        }, [
          c("button", {
            type: "button",
            "data-choice": "",
            class: Fe(["fe-choice__btn", { "is-on": v(T.value) }]),
            role: e.multi ? void 0 : "radio",
            "aria-checked": e.multi ? void 0 : v(T.value) ? "true" : "false",
            "aria-pressed": e.multi ? v(T.value) ? "true" : "false" : void 0,
            "aria-label": e.iconOnly ? T.label : void 0,
            "aria-describedby": i.value && T.help ? l(N) : void 0,
            tabindex: x(T.value, N),
            disabled: e.disabled || T.disabled,
            "data-testid": e.testidPrefix ? `${e.testidPrefix}-${T.value}` : void 0,
            onClick: (z) => _(T.value),
            onKeydown: (z) => k(z, N)
          }, [
            T.icon ? (p(), Je(Ii(T.icon), {
              key: 0,
              class: "fe-choice__icon",
              "aria-hidden": "true"
            })) : D("", !0),
            e.iconOnly ? D("", !0) : (p(), h("span", w3, y(T.label), 1)),
            T.help && !i.value ? (p(), h("span", _3, y(T.help), 1)) : D("", !0)
          ], 42, k3),
          d(T) ? (p(), h("span", {
            key: 0,
            id: l(N),
            class: "fe-choice__tip",
            "aria-hidden": "true",
            "data-testid": e.testidPrefix ? `${e.testidPrefix}-${T.value}-tip` : void 0
          }, y(d(T)), 9, x3)) : D("", !0)
        ]))), 128))
      ]),
      f.value ? (p(), h("p", {
        key: 0,
        class: "fe-choice__note",
        "aria-hidden": "true",
        "data-testid": e.testidPrefix ? `${e.testidPrefix}-note` : void 0
      }, y(f.value), 9, S3)) : D("", !0)
    ], 10, g3));
  }
}), $3 = ["data-tag-kind"], T3 = ["title", "aria-label", "data-testid", "onClick"], A3 = ["aria-label", "onClick"], E3 = ["placeholder", "aria-label"], p2 = /* @__PURE__ */ lt({
  __name: "TagPicker",
  props: {
    nodeId: {},
    locale: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    palette: {}
  },
  emits: ["change", "error", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale ?? "en");
    function r(G) {
      return `${i("tags.open", { tag: G.name })} · ${i(`tags.chip.${G.kind}`, { tag: G.name })}`;
    }
    const l = $([]), d = $(!0), f = $(!1), m = $(!1), v = $(!1), b = $(""), _ = $("personal"), w = $(null), k = E(() => [
      ...l.value.filter((G) => G.kind === "personal"),
      ...l.value.filter((G) => G.kind === "team")
    ]), x = E(() => [
      { value: "personal", label: i("tags.kind.personal"), help: i("tags.kind.personal_help") },
      {
        value: "team",
        label: i("tags.kind.team"),
        help: d.value ? i("tags.kind.team_help") : i("tags.kind.team_locked"),
        disabled: !d.value
      }
    ]), M = E(() => n.palette ?? [
      "#ef4444",
      "#f59e0b",
      "#10b981",
      "#3b82f6",
      "#8b5cf6",
      "#ec4899",
      "#14b8a6",
      "#f97316"
    ]);
    function A(G) {
      let Y = 0;
      for (let me = 0; me < G.length; me++) Y = Y * 31 + G.charCodeAt(me) | 0;
      const ie = M.value;
      return ie[Math.abs(Y) % ie.length];
    }
    function T(G) {
      return G.kind === "personal" || d.value;
    }
    async function N(G = {}) {
      return { ...await (n.authHeaders ?? (() => ({})))(), ...G };
    }
    function z(G) {
      const Y = G ?? {};
      f.value = !Array.isArray(Y.items), l.value = cv(G), typeof Y.can_edit_team == "boolean" && (d.value = Y.can_edit_team);
    }
    async function L() {
      m.value = !0;
      try {
        const G = n.apiBase ?? "", Y = await fetch(`${G}/api/files/manager/tags?node_id=${n.nodeId}`, {
          headers: await N(),
          credentials: n.authCredentials ?? "same-origin"
        });
        Y.ok && z(await Y.json());
      } catch (G) {
        a("error", G instanceof Error ? G.message : String(G));
      } finally {
        m.value = !1;
      }
    }
    async function B(G) {
      const Y = [...l.value];
      l.value = G;
      try {
        const ie = n.apiBase ?? "", me = f.value ? { node_id: n.nodeId, tags: G.map((re) => re.name) } : { node_id: n.nodeId, items: G }, q = await fetch(`${ie}/api/files/manager/tags`, {
          method: "POST",
          headers: await N({ "Content-Type": "application/json" }),
          credentials: n.authCredentials ?? "same-origin",
          body: JSON.stringify(me)
        });
        if (!q.ok) throw pa(q.status, await q.text().catch(() => ""), n.locale);
        const C = await q.json().catch(() => null);
        !f.value && C && Array.isArray(C.items) && (l.value = cv(C)), m3(), a("change", l.value.map((re) => re.name), l.value);
      } catch (ie) {
        l.value = Y, a("error", ie instanceof Error ? ie.message : String(ie));
      }
    }
    function O() {
      b.value = "", _.value = "personal", v.value = !1;
    }
    const U = E(() => fc("tag_max_runes"));
    Xe(b, (G) => {
      const Y = iy(G, U.value);
      Y !== G && (b.value = Y);
    });
    function S() {
      const G = b.value.trim(), Y = f.value ? "team" : _.value;
      if (!G || l.value.some((ie) => ie.kind === Y && ie.name === G)) {
        O();
        return;
      }
      B([...l.value, { name: G, kind: Y }]), O();
    }
    function F(G) {
      var ie;
      if (f.value) {
        S();
        return;
      }
      const Y = G.relatedTarget;
      Y && ((ie = w.value) != null && ie.contains(Y)) || b.value.trim() || O();
    }
    function I(G) {
      B(l.value.filter((Y) => Y !== G));
    }
    return Wt(L), Xe(() => n.nodeId, L), (G, Y) => (p(), h("div", {
      class: Fe(["filex-tag-picker", { "is-loading": m.value }])
    }, [
      (p(!0), h(Ce, null, ot(k.value, (ie) => (p(), h("span", {
        key: `${ie.kind}:${ie.name}`,
        class: Fe(["filex-tag", `filex-tag--${ie.kind}`]),
        "data-tag-kind": ie.kind,
        style: Yt({ "--filex-tag-color": A(ie.name) })
      }, [
        tt(pv, {
          kind: ie.kind
        }, null, 8, ["kind"]),
        c("button", {
          class: "filex-tag-open",
          type: "button",
          title: r(ie),
          "aria-label": r(ie),
          "data-testid": `tag-open-${ie.name}`,
          onClick: (me) => a("open", ie.name, ie.kind)
        }, y(ie.name), 9, T3),
        T(ie) ? (p(), h("button", {
          key: 0,
          class: "filex-tag-x",
          type: "button",
          "aria-label": `${u(i)("tags.remove")}: ${ie.name}`,
          onClick: (me) => I(ie)
        }, "×", 8, A3)) : D("", !0)
      ], 14, $3))), 128)),
      v.value ? (p(), h("form", {
        key: 0,
        ref_key: "addForm",
        ref: w,
        class: "filex-tag-add",
        onSubmit: vt(S, ["prevent"])
      }, [
        un(c("input", {
          "onUpdate:modelValue": Y[0] || (Y[0] = (ie) => b.value = ie),
          autofocus: "",
          placeholder: u(i)("tags.name"),
          "aria-label": u(i)("tags.name"),
          onBlur: F,
          onKeydown: $a(O, ["escape"])
        }, null, 40, E3), [
          [bn, b.value]
        ]),
        f.value ? D("", !0) : (p(), h("div", {
          key: 0,
          class: "filex-tag-kindwrap",
          onMousedown: Y[2] || (Y[2] = vt(() => {
          }, ["prevent"]))
        }, [
          tt(ui, {
            "model-value": _.value,
            options: x.value,
            "aria-label": u(i)("tags.kind.label"),
            "testid-prefix": "tag-kind",
            "onUpdate:modelValue": Y[1] || (Y[1] = (ie) => _.value = ie === "team" ? "team" : "personal")
          }, null, 8, ["model-value", "options", "aria-label"])
        ], 32)),
        c("button", {
          class: "filex-tag-add-submit",
          type: "submit",
          onMousedown: Y[3] || (Y[3] = vt(() => {
          }, ["prevent"]))
        }, y(u(i)("tags.add_submit")), 33)
      ], 544)) : (p(), h("button", {
        key: 1,
        class: "filex-tag-add-btn",
        type: "button",
        onClick: Y[4] || (Y[4] = (ie) => v.value = !0)
      }, y(u(i)("tags.add")), 1))
    ], 2));
  }
}), Xw = { tr: S0, en: Bs }, h2 = {};
function mi(e, t) {
  for (const n of t) h2[n] = e;
}
mi("image", ["jpg", "jpeg", "png", "webp", "gif", "bmp", "avif", "heic", "svg", "ico", "tiff", "tif"]);
mi("video", ["mp4", "webm", "mov", "mkv", "avi", "ogv", "m4v"]);
mi("audio", ["mp3", "wav", "flac", "ogg", "m4a", "aac", "opus"]);
mi("pdf", ["pdf"]);
mi("doc", ["doc", "docx", "odt", "rtf"]);
mi("sheet", ["xls", "xlsx", "ods", "csv", "tsv"]);
mi("slides", ["ppt", "pptx", "odp"]);
mi("archive", ["zip", "tar", "gz", "bz2", "7z", "rar", "xz", "zst"]);
const m2 = /* @__PURE__ */ new Set([
  "jar",
  "war",
  "ear",
  "aar",
  "apk",
  "aab",
  "apks",
  "xapk",
  "ipa",
  "whl",
  "egg",
  "vsix",
  "nupkg",
  "snupkg",
  "xpi",
  "crx",
  "appx",
  "appxbundle",
  "msix",
  "msixbundle",
  "deb",
  "rpm",
  "snap",
  "gem",
  "crate"
]);
mi("archive", [...m2]);
mi("code", [
  "js",
  "ts",
  "jsx",
  "tsx",
  "mjs",
  "cjs",
  "vue",
  "py",
  "go",
  "rs",
  "php",
  "rb",
  "java",
  "kt",
  "swift",
  "c",
  "cpp",
  "h",
  "hpp",
  "cs",
  "css",
  "scss",
  "less",
  "html",
  "htm",
  "json",
  "yml",
  "yaml",
  "xml",
  "sh",
  "bash",
  "ps1",
  "sql",
  "toml"
]);
mi("text", ["txt", "md", "markdown", "log", "ini", "conf", "cfg", "env"]);
function qu(e) {
  return e.mime_type === "inode/storage";
}
function vi(e) {
  if (qu(e)) return "storage";
  if (e.basename === ".trash") return "trash";
  if (e.type === "dir") return "folder";
  const t = (e.extension || "").toLowerCase();
  return t ? h2[t] ?? "unknown" : R0(e.mime_type) ? "text" : "unknown";
}
const Oo = '<path d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3z"/><path d="M13.5 3v5h5"/>', C3 = {
  // Folder is the one "filled" member — a soft currentColor wash keeps it
  // visually anchored without breaking the line style.
  /**
   * gorunum:v1 — the folder is SOLID, and it is the one glyph that never
   * gets a tile. A folder is the most common thing in a listing; drawn as an
   * outline in the same weight as the file glyphs it disappears into them,
   * and the eye has to read the label to tell a folder from a document. Filled
   * and in its own colour it is recognisable before the name is read.
   */
  folder: '<path d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5z" fill="currentColor" stroke="none"/>',
  image: '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.6" cy="10" r="1.6"/><path d="M5.2 16.6l4.3-4.3 3 3 2.4-2.4 3.9 3.7"/>',
  video: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M10.2 9.3v5.4l4.8-2.7z" fill="currentColor" stroke="none"/>',
  audio: '<path d="M9 17.5V7.2l9-2.2v10.4"/><circle cx="6.8" cy="17.6" r="2.2"/><circle cx="15.8" cy="15.5" r="2.2"/>',
  pdf: Oo + '<rect x="7.5" y="12" width="9" height="5" rx="1" fill="currentColor" fill-opacity="0.14"/>',
  doc: Oo + '<path d="M8.5 13h7M8.5 16h7"/>',
  sheet: Oo + '<path d="M8 12.5h8M8 15.5h8M8 18h8M12 12.5V18"/>',
  slides: Oo + '<rect x="8" y="12.5" width="8" height="5" rx="0.8"/>',
  archive: Oo + '<path d="M10 3v1.6M10 6.6v1.6M10 10.2v1.6"/><rect x="8.6" y="14" width="2.8" height="3.4" rx="0.8"/>',
  code: Oo + '<path d="M10.4 12.5L8.3 15l2.1 2.5M13.6 12.5l2.1 2.5-2.1 2.5"/>',
  text: Oo + '<path d="M8.5 12h7M8.5 15h7M8.5 18h4.5"/>',
  // The two-bay drive the sidebar already draws for the same storages, so a
  // drive is one shape across the panel rather than one per surface.
  storage: '<rect x="3" y="5" width="18" height="6" rx="1.6"/><rect x="3" y="13" width="18" height="6" rx="1.6"/><path d="M6.5 8h.01M6.5 16h.01"/>',
  trash: '<path d="M4 7h16"/><path d="M9.5 7V5.6A1.6 1.6 0 0 1 11.1 4h1.8a1.6 1.6 0 0 1 1.6 1.6V7"/><path d="M6.2 7l.85 11.6A1.6 1.6 0 0 0 8.65 20h6.7a1.6 1.6 0 0 0 1.6-1.4L17.8 7"/><path d="M10.2 10.8v5.6M13.8 10.8v5.6"/>',
  unknown: Oo + '<path d="M10.3 13.1a1.8 1.8 0 1 1 2.5 1.9c-.6.3-.8.7-.8 1.4"/><circle cx="12" cy="18.4" r="0.9" fill="currentColor" stroke="none"/>'
}, Jw = /* @__PURE__ */ new Map();
function Zw(e) {
  let t = Jw.get(e);
  return t || (t = `<svg class="fe-ficon fe-ficon--${e}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${C3[e]}</svg>`, Jw.set(e, t)), t;
}
const Qw = /* @__PURE__ */ new Map();
function v2(e) {
  if (e === "folder")
    return `<span class="fe-ftile fe-ftile--folder">${Zw(e)}</span>`;
  let t = Qw.get(e);
  return t || (t = `<span class="fe-ftile fe-ftile--${e}">${Zw(e)}</span>`, Qw.set(e, t)), t;
}
function ya(e) {
  return z3(e) ? P3() : v2(vi(e));
}
function z3(e) {
  return e.type === "dir" ? !1 : (e.extension || "").toLowerCase() === "fxe" ? !0 : typeof e.basename == "string" && e.basename.toLowerCase().endsWith(".fxe") && e.basename.length > 4;
}
const M3 = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3zM9.7 12.2a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12.2h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1v-3.6a1 1 0 0 1 1-1z"/>';
let hm = "";
function P3() {
  return hm || (hm = `<span class="fe-ftile fe-ftile--unknown fe-ftile--file-locked"><svg class="fe-ficon fe-ficon--file-locked" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${M3}</svg></span>`), hm;
}
function Mr(e) {
  return e.type === "dir" && e.e2e === !0;
}
const O3 = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5zM9.7 12a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1z"/>';
let mm = "";
function sl() {
  return mm || (mm = `<span class="fe-ftile fe-ftile--folder fe-ftile--folder-locked"><svg class="fe-ficon fe-ficon--folder" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${O3}</svg></span>`), mm;
}
const D3 = {
  // Languages the person reading the column thinks of by name.
  ts: "ftype.typescript",
  tsx: "ftype.typescript",
  mts: "ftype.typescript",
  cts: "ftype.typescript",
  js: "ftype.javascript",
  jsx: "ftype.javascript",
  mjs: "ftype.javascript",
  cjs: "ftype.javascript",
  vue: "ftype.vue",
  py: "ftype.python",
  go: "ftype.go",
  rs: "ftype.rust",
  php: "ftype.php",
  rb: "ftype.ruby",
  java: "ftype.java",
  kt: "ftype.kotlin",
  swift: "ftype.swift",
  c: "ftype.c",
  h: "ftype.c",
  cpp: "ftype.cpp",
  hpp: "ftype.cpp",
  cs: "ftype.csharp",
  // Structured text that is code by family but not a language.
  css: "ftype.stylesheet",
  scss: "ftype.stylesheet",
  less: "ftype.stylesheet",
  html: "ftype.html",
  htm: "ftype.html",
  json: "ftype.json",
  yml: "ftype.yaml",
  yaml: "ftype.yaml",
  xml: "ftype.xml",
  toml: "ftype.toml",
  sql: "ftype.sql",
  sh: "ftype.shell",
  bash: "ftype.shell",
  zsh: "ftype.shell",
  ps1: "ftype.powershell",
  // Plain-text family members that are each their own thing.
  md: "ftype.markdown",
  markdown: "ftype.markdown",
  txt: "ftype.plaintext",
  log: "ftype.log",
  ini: "ftype.config",
  conf: "ftype.config",
  cfg: "ftype.config",
  env: "ftype.config",
  // Tabular: a `.csv` IS a spreadsheet to the person looking at the column,
  // whatever the program that wrote it was.
  csv: "ftype.sheet",
  tsv: "ftype.sheet",
  // Design files. No icon family of their own (they fall to `unknown`, which
  // is a decision for the GLYPH, not for the word) — naming them still beats
  // printing "FIG".
  fig: "ftype.figma",
  // ⚠ Named, not "DRAWIO": the uppercased extension was a fourth spelling of
  // draw.io beside "Drawio", "drawio" and "diagrams.net" (QA, 2026-09-21).
  drawio: "ftype.drawio",
  dio: "ftype.drawio",
  sketch: "ftype.design",
  xd: "ftype.design",
  psd: "ftype.design",
  ai: "ftype.design"
}, L3 = {
  folder: "node.folder",
  image: "ftype.image",
  video: "ftype.video",
  audio: "ftype.audio",
  pdf: "ftype.pdf",
  doc: "ftype.document",
  sheet: "ftype.sheet",
  slides: "ftype.slides",
  archive: "ftype.archive",
  code: "ftype.code",
  text: "ftype.plaintext"
};
function y2(e) {
  if (e.type === "dir") return "node.folder";
  const t = (e.extension || "").trim().toLowerCase();
  if (t === "fxe") return "e2e.fxe.type";
  const n = D3[t];
  return n || (m2.has(t) ? null : L3[vi(e)] ?? null);
}
function hv(e, t) {
  const n = y2(e);
  return n ? t(n) : g2(e) || "-";
}
function g2(e) {
  return (e.extension || "").trim().toUpperCase();
}
const Rn = 16, lp = new Uint8Array(Rn);
class e_ extends Error {
  constructor(t = "aes-siv: authentication failed") {
    super(t), this.name = "SivAuthError";
  }
}
function Bo(e) {
  return new Uint8Array(e).buffer;
}
function Mf(e) {
  const t = new Uint8Array(Rn);
  let n = 0;
  for (let a = Rn - 1; a >= 0; a--) {
    const i = e[a];
    t[a] = (i << 1 | n) & 255, n = i >>> 7;
  }
  return e[0] & 128 && (t[Rn - 1] ^= 135), t;
}
function mv(e, t, n) {
  for (let a = 0; a < n.length; a++) e[t + a] ^= n[a];
}
function t_(e, t) {
  const n = new Uint8Array(Rn);
  for (let a = 0; a < Rn; a++) n[a] = e[a] ^ t[a];
  return n;
}
async function R3(e, t) {
  const n = await crypto.subtle.encrypt({ name: "AES-CBC", iv: Bo(lp) }, e, Bo(t));
  return new Uint8Array(n).slice(0, Rn);
}
async function vm(e, t) {
  const n = Math.max(1, Math.ceil(t.length / Rn)), a = t.length > 0 && t.length % Rn === 0, i = new Uint8Array(n * Rn);
  i.set(t);
  const r = (n - 1) * Rn;
  return a ? mv(i, r, e.k1) : (i[t.length] = 128, mv(i, r, e.k2)), new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-CBC", iv: Bo(lp) }, e.mac, Bo(i))
  ).slice(r, r + Rn);
}
async function b2(e, t, n) {
  let a = await vm(e, lp);
  for (const r of t) a = t_(Mf(a), await vm(e, r));
  let i;
  if (n.length >= Rn)
    i = n.slice(), mv(i, n.length - Rn, a);
  else {
    const r = new Uint8Array(Rn);
    r.set(n), r[n.length] = 128, i = t_(Mf(a), r);
  }
  return vm(e, i);
}
function N3(e) {
  const t = e.slice();
  return t[8] &= 127, t[12] &= 127, t;
}
async function k2(e, t, n) {
  if (n.length === 0) return new Uint8Array(0);
  const a = await crypto.subtle.encrypt(
    { name: "AES-CTR", counter: Bo(N3(t)), length: 32 },
    e.ctr,
    Bo(n)
  );
  return new Uint8Array(a);
}
async function I3(e) {
  if (e.length !== 32 && e.length !== 64)
    throw new Error("aes-siv: key must be 32 or 64 bytes");
  const t = e.length / 2, n = await crypto.subtle.importKey("raw", Bo(e.slice(0, t)), { name: "AES-CBC" }, !1, [
    "encrypt"
  ]), a = await crypto.subtle.importKey("raw", Bo(e.slice(t)), { name: "AES-CTR" }, !1, [
    "encrypt",
    "decrypt"
  ]), i = await R3(n, lp), r = Mf(i), l = Mf(r);
  return { mac: n, ctr: a, k1: r, k2: l };
}
async function w2(e, t, n = []) {
  const a = await b2(e, n, t), i = await k2(e, a, t), r = new Uint8Array(Rn + i.length);
  return r.set(a, 0), r.set(i, Rn), r;
}
async function B3(e, t, n = []) {
  if (t.length < Rn) throw new e_("aes-siv: ciphertext too short");
  const a = t.slice(0, Rn), i = await k2(e, a, t.slice(Rn)), r = await b2(e, n, i);
  let l = 0;
  for (let d = 0; d < Rn; d++) l |= r[d] ^ a[d];
  if (l !== 0)
    throw i.fill(0), new e_();
  return i;
}
const _2 = "AES-SIV-512", x2 = "b64url", F3 = 220, U3 = 255, S2 = 64, ll = 16, H3 = ".fxl", $2 = ".fxl.name", K3 = new TextEncoder().encode("filex-e2e-dir-id"), V3 = 16, T2 = /^[A-Za-z0-9_-]+$/, Ay = "[A-Za-z0-9_-]{43}", A2 = "[A-Za-z0-9_-]{22}", j3 = new RegExp(`^(${Ay})\\.fxl\\.name$`), q3 = new RegExp(`^(${Ay})\\.fxl$`), W3 = new RegExp(`^(${Ay})\\.fxl\\.(${A2})$`), Y3 = new RegExp(`^([A-Za-z0-9_-]{23,})\\.(${A2})$`), G3 = 23;
function Fo(e) {
  let t = "";
  for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
  return btoa(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function po(e) {
  if (!e || !T2.test(e) || e.length % 4 === 1) return null;
  const t = e.replace(/-/g, "+").replace(/_/g, "/"), n = t + "===".slice((t.length + 3) % 4);
  let a;
  try {
    a = atob(n);
  } catch {
    return null;
  }
  const i = new Uint8Array(a.length);
  for (let r = 0; r < a.length; r++) i[r] = a.charCodeAt(r);
  return Fo(i) !== e ? null : i;
}
function Ey(e) {
  return (e ?? "").normalize("NFC");
}
function ji(e) {
  const t = Ey(e);
  return t ? t === "." || t === ".." ? "dot" : t.includes("/") || t.includes("\\") ? "slash" : /[\u0000-\u001f\u007f]/.test(t) ? "control" : new TextEncoder().encode(t).length > U3 ? "too_long" : null : "empty";
}
function X3() {
  return crypto.getRandomValues(new Uint8Array(S2));
}
function E2() {
  return crypto.getRandomValues(new Uint8Array(ll));
}
const J3 = E2;
async function Cy(e, t, n) {
  if (e.length !== S2) throw new Error("e2e: name key must be 64 bytes");
  if (n.length !== ll) throw new Error("e2e: a folder id is 16 bytes");
  return { siv: await I3(e), long: t, rootId: n.slice() };
}
async function C2(e) {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e));
  return Fo(new Uint8Array(t));
}
async function Z3(e, t, n) {
  return (await w2(e.siv, new TextEncoder().encode(Ey(n)), [
    t,
    K3
  ])).slice(0, ll);
}
function Sl(e) {
  let t = j3.exec(e);
  if (t) return { kind: "sidecar", hash: t[1] };
  if (t = W3.exec(e), t) {
    const n = po(t[2]);
    if (n && n.length === ll) return { kind: "longdir", hash: t[1], dirId: n };
  }
  if (t = q3.exec(e), t) return { kind: "long", hash: t[1] };
  if (t = Y3.exec(e), t) {
    const n = po(t[2]);
    if (n && n.length === ll) return { kind: "dir", encoded: t[1], dirId: n };
  }
  return e.length >= G3 && T2.test(e) ? { kind: "file", encoded: e } : { kind: "plain" };
}
function Q3(e) {
  return Sl(e).dirId ?? null;
}
async function vv(e, t, n) {
  return Q3(n) ?? Z3(e, t, n);
}
async function yv(e, t, n, a = {}) {
  const i = ji(t);
  if (i) throw new Error(`e2e: invalid name (${i})`);
  const r = new TextEncoder().encode(Ey(t)), l = Fo(await w2(e.siv, r, [n])), f = a.isDir || !!a.dirId ? a.dirId ?? E2() : void 0, m = f ? `.${Fo(f)}` : "";
  if (l.length + m.length <= e.long)
    return { stored: l + m, encoded: l, ...f ? { dirId: f } : {} };
  const v = await C2(l);
  return {
    stored: `${v}${H3}${m}`,
    encoded: l,
    ...f ? { dirId: f } : {},
    sidecar: { name: `${v}${$2}`, content: l }
  };
}
async function z2(e, t, n) {
  const a = po(t);
  if (!a || a.length <= V3) return null;
  try {
    const i = await B3(e.siv, a, [n]);
    return new TextDecoder("utf-8", { fatal: !0 }).decode(i);
  } catch {
    return null;
  }
}
async function n_(e, t, n) {
  const a = await z2(e, t, n);
  return a === null ? null : ji(a) ? "unsafe" : a;
}
async function M2(e, t, n, a) {
  const i = Sl(t);
  if (i.kind === "sidecar") return { name: null, state: "sidecar" };
  if (i.kind === "plain") return { name: t, state: "plain" };
  if (i.kind === "long" || i.kind === "longdir") {
    const d = ((a ? await a(`${i.hash}${$2}`) : null) ?? "").trim();
    if (!d || await C2(d) !== i.hash)
      return { name: null, state: "unreadable" };
    const f = await n_(e, d, n);
    return f === null || f === "unsafe" ? { name: null, state: "unreadable" } : { name: f, state: "enc" };
  }
  const r = await n_(e, i.encoded, n);
  return r === "unsafe" ? { name: null, state: "unreadable" } : r !== null ? { name: r, state: "enc" } : i.kind === "dir" ? { name: null, state: "unreadable" } : { name: t, state: "plain" };
}
function Pf(e) {
  const t = e.lastIndexOf(".");
  return t <= 0 || t === e.length - 1 ? "" : e.slice(t + 1).toLowerCase();
}
const mo = 20, eD = 10, tD = 24, Pr = 7, Ni = 16, gc = 2, nD = 4294967295, Wu = 12, di = 97, gv = 9, bv = 21, P2 = 48, kv = 69, O2 = 76, D2 = 32, Of = new TextEncoder().encode("filexe2e");
function bc(e) {
  return typeof e == "number" && Number.isInteger(e) && e >= eD && e <= tD;
}
function kc(e) {
  if (!bc(e)) throw new Error(`e2e: unsupported chunk size 2^${e}`);
  return 2 ** e;
}
function L2(e, t, n) {
  if (e.length !== Pr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  if (!Number.isInteger(t) || t < 0 || t > nD)
    throw new Error("e2e: too many chunks for one stream");
  const a = new Uint8Array(Wu);
  return a.set(e, 0), new DataView(a.buffer).setUint32(Pr, t, !1), a[Wu - 1] = n ? 1 : 0, a;
}
function R2(e, t = mo) {
  if (!Number.isSafeInteger(e) || e < 0) throw new Error("e2e: bad plaintext size");
  return e === 0 ? 1 : Math.ceil(e / kc(t));
}
function zy(e, t = mo) {
  return e + Ni * R2(e, t);
}
function aD(e, t = mo) {
  if (!bc(t) || !Number.isSafeInteger(e) || e < Ni) return null;
  const n = 2 ** t + Ni, a = Math.ceil(e / n), i = e - (a - 1) * n;
  return i < Ni || a > 1 && i === Ni ? null : e - Ni * a;
}
function N2() {
  return crypto.getRandomValues(new Uint8Array(Pr));
}
class up {
  constructor() {
    It(this, "parts", []);
    It(this, "head", 0);
    It(this, "length", 0);
  }
  push(t) {
    t.length !== 0 && (this.parts.push(t), this.length += t.length);
  }
  /** The next `n` bytes (n ≤ length), as a fresh buffer. */
  take(t) {
    if (t > this.length) throw new Error("ByteQueue: not enough bytes");
    const n = new Uint8Array(t);
    let a = 0;
    for (; a < t; ) {
      const i = this.parts[0], r = Math.min(i.length - this.head, t - a);
      n.set(i.subarray(this.head, this.head + r), a), a += r, this.head += r, this.head === i.length && (this.parts.shift(), this.head = 0);
    }
    return this.length -= t, n;
  }
}
function ul(e) {
  if (e instanceof Uint8Array) return e;
  if (e instanceof ArrayBuffer) return new Uint8Array(e);
  if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  throw new TypeError("e2e: a stream carried something that is not bytes");
}
class cp {
  constructor(t) {
    It(this, "reader");
    It(this, "q", new up());
    It(this, "done", !1);
    this.reader = t.getReader();
  }
  /** Up to `n` bytes; fewer only when the stream ended. */
  async read(t) {
    for (; this.q.length < t && !this.done; ) {
      const { done: n, value: a } = await this.reader.read();
      n ? this.done = !0 : this.q.push(ul(a));
    }
    return this.q.take(Math.min(t, this.q.length));
  }
  /** Everything not read yet, as a stream. The reader is spent afterwards. */
  rest() {
    const t = this.q.take(this.q.length), n = this.reader;
    let a = t.length > 0 ? t : null;
    const i = this.done;
    return new ReadableStream({
      async pull(r) {
        if (a) {
          r.enqueue(a), a = null;
          return;
        }
        if (i) {
          r.close();
          return;
        }
        const { done: l, value: d } = await n.read();
        l ? r.close() : r.enqueue(ul(d));
      },
      cancel(r) {
        return n.cancel(r);
      }
    });
  }
  cancel(t) {
    return this.reader.cancel(t);
  }
}
function wc(e, t) {
  const n = t.getReader();
  let a = !1;
  return new ReadableStream({
    async pull(i) {
      if (!a && (a = !0, e.length > 0)) {
        i.enqueue(e);
        return;
      }
      const { done: r, value: l } = await n.read();
      r ? i.close() : i.enqueue(ul(l));
    },
    cancel(i) {
      return n.cancel(i);
    }
  });
}
async function iD(e, t = Number.MAX_SAFE_INTEGER) {
  const n = new up(), a = e.getReader();
  for (; ; ) {
    const { done: i, value: r } = await a.read();
    if (i) break;
    if (n.push(ul(r)), n.length > t)
      throw await a.cancel(), new Error("e2e: more data than expected");
  }
  return n.take(n.length);
}
async function a_(e, t, n, a, i) {
  return new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: L2(t, n, a) }, e, i)
  );
}
async function wv(e, t, n, a, i) {
  try {
    return new Uint8Array(
      await crypto.subtle.decrypt({ name: "AES-GCM", iv: L2(t, n, a) }, e, i)
    );
  } catch {
    throw new sn(
      a ? "e2e: the last chunk failed authentication (the file is truncated, extended or damaged)" : `e2e: chunk ${n} failed authentication (the file is damaged, reordered or truncated)`
    );
  }
}
function I2(e, t, n = mo, a = {}) {
  const i = kc(n);
  if (t.length !== Pr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  const r = new up();
  let l = 0, d = 0;
  return new TransformStream({
    async transform(f, m) {
      var b;
      const v = ul(f);
      if (d += v.length, a.expectSize !== void 0 && d > a.expectSize)
        throw new Error("e2e: the file is longer than it said it was");
      for (r.push(v); r.length > i; )
        m.enqueue(await a_(e, t, l++, !1, r.take(i))), (b = a.onProgress) == null || b.call(a, l * i);
    },
    async flush(f) {
      var m;
      if (a.expectSize !== void 0 && d !== a.expectSize)
        throw new Error("e2e: the file is shorter than it said it was");
      f.enqueue(await a_(e, t, l++, !0, r.take(r.length))), (m = a.onProgress) == null || m.call(a, d);
    }
  });
}
function B2(e, t, n = mo, a = {}) {
  const i = kc(n) + Ni;
  if (t.length !== Pr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  const r = new up();
  let l = 0, d = 0;
  const f = (m) => {
    if (d += m.length, a.expectSize !== void 0 && d > a.expectSize)
      throw new sn("e2e: the file holds more than its header says");
    return m;
  };
  return new TransformStream({
    async transform(m, v) {
      for (r.push(ul(m)); r.length > i; ) v.enqueue(f(await wv(e, t, l++, !1, r.take(i))));
    },
    async flush(m) {
      if (r.length < Ni) throw new sn("e2e: the encrypted content is truncated");
      if (l > 0 && r.length === Ni)
        throw new sn("e2e: the encrypted content ends in an empty chunk no writer produces");
      if (m.enqueue(f(await wv(e, t, l++, !0, r.take(r.length)))), a.expectSize !== void 0 && d !== a.expectSize)
        throw new sn("e2e: the file holds less than its header says");
    }
  });
}
async function oD(e, t, n, a = mo) {
  const i = kc(a), r = i + Ni, l = aD(n.length, a);
  if (l === null) throw new sn("e2e: the encrypted content has an impossible length");
  const d = new Uint8Array(l), f = R2(l, a);
  for (let m = 0; m < f; m++) {
    const v = m === f - 1, b = n.slice(m * r, v ? n.length : (m + 1) * r);
    d.set(await wv(e, t, m, v, b), m * i);
  }
  return d;
}
function F2() {
  return crypto.getRandomValues(new Uint8Array(D2));
}
async function dp(e) {
  if (e.length !== D2) throw new sn("e2e: a file key must be 32 bytes");
  return crypto.subtle.importKey("raw", e, { name: "AES-GCM" }, !1, ["encrypt", "decrypt"]);
}
function rD(e) {
  if (e.wrapIV.length !== Wu || e.wrappedDek.length !== P2)
    throw new Error("e2e: bad wrapped key");
  kc(e.log2);
  const t = new Uint8Array(di);
  return t.set(Of, 0), t[8] = gc, t.set(e.wrapIV, gv), t.set(e.wrappedDek, bv), t.set(e.prefix, kv), t[O2] = e.log2, t;
}
function U2(e) {
  if (e.length < di) throw new Error("e2e: not an encrypted file");
  for (let n = 0; n < Of.length; n++)
    if (e[n] !== Of[n]) throw new Error("e2e: not an encrypted file");
  if (e[8] !== gc) throw new Error(`e2e: unsupported version ${e[8]}`);
  const t = e[O2];
  if (!bc(t)) throw new Error(`e2e: unsupported chunk size 2^${t}`);
  return {
    wrapIV: e.slice(gv, gv + Wu),
    wrappedDek: e.slice(bv, bv + P2),
    prefix: e.slice(kv, kv + Pr),
    log2: t
  };
}
function sD(e, t = mo) {
  return di + zy(e, t);
}
async function H2(e, t, n, a) {
  for (const i of t ? [e, t] : [e]) {
    let r;
    try {
      r = new Uint8Array(await crypto.subtle.decrypt({ name: "AES-GCM", iv: n }, i, a));
    } catch {
      continue;
    }
    try {
      return await dp(r);
    } finally {
      r.fill(0);
    }
  }
  throw new sn("e2e: DEK unwrap failed (wrong key?)");
}
async function i_(e, t, n, a = {}) {
  const i = a.chunkLog2 ?? mo, r = F2(), l = crypto.getRandomValues(new Uint8Array(Wu));
  let d, f;
  try {
    f = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: l }, e, r)), d = await dp(r);
  } finally {
    r.fill(0);
  }
  const m = N2(), v = rD({ wrapIV: l, wrappedDek: f, prefix: m, log2: i }), b = n.pipeThrough(
    I2(d, m, i, { expectSize: t, onProgress: a.onProgress })
  );
  return { stream: wc(v, b), size: sD(t, i) };
}
async function lD(e, t, n) {
  const a = U2(t), i = await H2(e, n, a.wrapIV, a.wrappedDek);
  return (await oD(i, a.prefix, t.subarray(di), a.log2)).buffer;
}
const uD = 200 * 1024 * 1024 + di + 16;
function _v(e, t, n, a = {}) {
  const i = new cp(n);
  let r = null;
  return new ReadableStream({
    async start(l) {
      var _;
      const d = await i.read(di);
      if (!(d.length >= 8 && Of.every((w, k) => d[k] === w))) {
        if (!a.passPlain) throw new Error("e2e: not an encrypted file");
        (_ = a.onPlain) == null || _.call(a), r = wc(d, i.rest()).getReader();
        return;
      }
      if (d.length < di) throw new sn("e2e: the encrypted file is truncated");
      if (d[8] === gc) {
        const w = U2(d), k = await H2(e, t, w.wrapIV, w.wrappedDek);
        r = i.rest().pipeThrough(B2(k, w.prefix, w.log2)).getReader();
        return;
      }
      if (d[8] !== 1) throw new Error(`e2e: unsupported version ${d[8]}`);
      const m = await iD(i.rest(), uD - di), v = new Uint8Array(di + m.length);
      v.set(d, 0), v.set(m, di);
      let b;
      try {
        b = await Rf(e, v.buffer);
      } catch (w) {
        if (!t || !(w instanceof sn)) throw w;
        b = await Rf(t, v.buffer);
      }
      l.enqueue(new Uint8Array(b)), l.close();
    },
    async pull(l) {
      if (!r) return;
      const { done: d, value: f } = await r.read();
      d ? l.close() : l.enqueue(f);
    },
    cancel(l) {
      return r ? r.cancel(l) : i.cancel(l);
    }
  });
}
const cD = di, Yu = "vault", K2 = 1, dD = 16, fD = 24, V2 = 22, pD = 24, hD = [V2, pD], My = 16, Due = 25e4;
function mD(e) {
  return typeof e == "number" && Number.isInteger(e) && e >= dD && e <= fD;
}
function j2() {
  return import("./keys-Dj5q9nTl.js");
}
const ha = ".filex-e2e.json", vD = "filexe2e", Py = 1, fp = 2, vo = 3, yD = ["names", "rekey", "conv", Yu], pp = 6e5, hp = 6e5, q2 = 1e8, Nu = 200 * 1024 * 1024, Df = 8, of = 20, W2 = "RSA-OAEP-256", Ko = "filex-e2e-verify-v1", rf = new TextEncoder().encode(vD), Gu = 97, Xs = 9, Js = 21, Y2 = 48, xv = 69, Fi = 12, pi = 32, gD = "filex-e2e-recovery-v1", bD = 16;
class sn extends Error {
  constructor(t = "e2e: decrypt failed") {
    super(t), this.name = "E2eDecryptError";
  }
}
function Aa(e) {
  let t = "";
  for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
  return btoa(t);
}
function Zn(e) {
  const t = atob(e), n = new Uint8Array(t.length);
  for (let a = 0; a < t.length; a++) n[a] = t.charCodeAt(a);
  return n;
}
function hn(e) {
  return new Uint8Array(e).buffer;
}
function kD(e, t) {
  const n = new Uint8Array(e.length + t.length);
  return n.set(e, 0), n.set(t, e.length), Aa(n);
}
async function Ja(e, t) {
  const n = crypto.getRandomValues(new Uint8Array(Fi)), a = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: hn(n) }, e, hn(t))
  );
  return kD(n, a);
}
function o_(e, t) {
  return Ja(e, t);
}
function r_(e, t) {
  return Da(e, t);
}
async function Da(e, t) {
  let n;
  try {
    n = Zn(t);
  } catch {
    return null;
  }
  if (n.length <= Fi) return null;
  try {
    const a = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: hn(n.slice(0, Fi)) },
      e,
      hn(n.slice(Fi))
    );
    return new Uint8Array(a);
  } catch {
    return null;
  }
}
async function Vo(e, t, n) {
  const a = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveKey"]
  );
  return crypto.subtle.deriveKey(
    { name: "PBKDF2", salt: hn(t), iterations: n, hash: "SHA-256" },
    a,
    { name: "AES-GCM", length: 256 },
    !1,
    // non-extractable
    ["encrypt", "decrypt"]
  );
}
async function Oy(e, t, n) {
  const a = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveBits"]
  ), i = await crypto.subtle.deriveBits(
    { name: "PBKDF2", salt: hn(t), iterations: n, hash: "SHA-256" },
    a,
    pi * 8
  );
  return new Uint8Array(i);
}
async function Xu(e) {
  return crypto.subtle.importKey("raw", hn(e), { name: "AES-GCM" }, !1, [
    "encrypt",
    "decrypt"
  ]);
}
async function Dy(e, t) {
  return Or(e) ? (await j2()).importVaultFmk(t) : Xu(t);
}
const Sv = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
function wD(e) {
  let t = 0, n = 0, a = "";
  for (let i = 0; i < e.length; i++)
    for (n = n << 8 | e[i], t += 8; t >= 5; )
      a += Sv[n >>> t - 5 & 31], t -= 5;
  return t > 0 && (a += Sv[n << 5 - t & 31]), (a.match(/.{1,4}/g) || []).join("-");
}
function mp() {
  return wD(crypto.getRandomValues(new Uint8Array(of)));
}
function Ly(e) {
  const t = (e || "").toUpperCase().replace(/[\s-]/g, "").replace(/O/g, "0").replace(/[IL]/g, "1"), n = Math.ceil(of * 8 / 5);
  if (t.length !== n) return null;
  const a = new Uint8Array(of);
  let i = 0, r = 0, l = 0;
  for (const d of t) {
    const f = Sv.indexOf(d);
    if (f < 0) return null;
    i = i << 5 | f, r += 5, r >= 8 && (a[l++] = i >>> r - 8 & 255, r -= 8);
  }
  return l === of ? a : null;
}
async function Ry(e, t) {
  const n = await crypto.subtle.importKey("raw", hn(e), "HKDF", !1, ["deriveKey"]);
  return crypto.subtle.deriveKey(
    {
      name: "HKDF",
      hash: "SHA-256",
      salt: hn(t),
      info: hn(new TextEncoder().encode(gD))
    },
    n,
    { name: "AES-GCM", length: 256 },
    !1,
    ["encrypt", "decrypt"]
  );
}
async function vp(e, t) {
  const n = Ly(t);
  if (!n) throw new Error("e2e: malformed recovery key");
  const a = crypto.getRandomValues(new Uint8Array(bD)), i = await Ry(n, a), r = { salt: Aa(a), blob: await Ja(i, e) };
  return n.fill(0), r;
}
async function _D(e) {
  return crypto.subtle.importKey(
    "spki",
    hn(Zn(e)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !0,
    ["encrypt"]
  );
}
async function G2(e) {
  const t = (e || "").replace(/-----[A-Z ]+-----/g, "").replace(/\s+/g, "");
  return crypto.subtle.importKey(
    "pkcs8",
    hn(Zn(t)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !1,
    ["decrypt"]
  );
}
async function X2(e) {
  const t = new Uint8Array(await crypto.subtle.digest("SHA-256", hn(Zn(e))));
  return Array.from(t.slice(0, 8)).map((n) => n.toString(16).padStart(2, "0")).join("");
}
async function _c(e, t) {
  const n = await _D(t), a = new Uint8Array(await crypto.subtle.encrypt({ name: "RSA-OAEP" }, n, hn(e)));
  return { kid: await X2(t), alg: W2, blob: Aa(a) };
}
async function Lue(e, t = pp) {
  const n = Math.max(hp, t), a = crypto.getRandomValues(new Uint8Array(16)), i = await Vo(e, a, n), r = await Ja(i, new TextEncoder().encode(Ko));
  return { marker: { v: 1, salt: Aa(a), iter: n, verify: r }, kek: i };
}
async function J2(e, t) {
  const n = X3(), a = J3(), i = {
    alg: _2,
    enc: x2,
    long: F3,
    key: await Ja(e, n),
    root_id: Fo(a)
  };
  t && (i.pending = !0);
  const r = await Cy(n, i.long, a);
  return n.fill(0), { slot: i, key: r };
}
async function $v(e, t = {}) {
  const n = Math.max(hp, t.iterations ?? pp), a = crypto.getRandomValues(new Uint8Array(16)), i = await Vo(e, a, n), r = crypto.getRandomValues(new Uint8Array(pi)), l = mp(), d = {
    v: fp,
    salt: Aa(a),
    iter: n,
    verify: await Ja(i, new TextEncoder().encode(Ko)),
    fmk: "wrapped",
    fmk_pw: await Ja(i, r),
    rk: await vp(r, l)
  };
  t.escrowPublicKey && (d.esc = await _c(r, t.escrowPublicKey));
  const f = await Xu(r);
  if (r.fill(0), !t.encryptNames) return { marker: d, fmk: f, recoveryKey: l };
  const m = await J2(f, !1);
  return d.v = vo, d.req = ["names"], d.names = m.slot, { marker: d, fmk: f, recoveryKey: l, names: m.key };
}
async function xD(e, t = {}) {
  const n = t.packLog2 ?? V2;
  if (!hD.includes(n)) throw new Error(`e2e: a vault's packs are 2^22 or 2^24 bytes, not 2^${n}`);
  const [{ importVaultFmk: a }, { cryptoRandom: i, sealIndexFile: r }, { encodeIndexBody: l }] = await Promise.all([
    j2(),
    import("./writer-B5VFMZLL.js").then((M) => M.w),
    import("./vindex-C_iRjHFp.js")
  ]), d = Math.max(hp, t.iterations ?? pp), f = crypto.getRandomValues(new Uint8Array(16)), m = await Vo(e, f, d), v = crypto.getRandomValues(new Uint8Array(pi)), b = mp(), _ = crypto.getRandomValues(new Uint8Array(My)), w = {
    v: vo,
    req: [Yu],
    salt: Aa(f),
    iter: d,
    verify: await Ja(m, new TextEncoder().encode(Ko)),
    fmk: "wrapped",
    fmk_pw: await Ja(m, v),
    rk: await vp(v, b)
  };
  t.escrowPublicKey && (w.esc = await _c(v, t.escrowPublicKey)), w.vault = { v: K2, id: Fo(_), pack: n };
  const k = await a(v);
  v.fill(0);
  const x = await r(k, _, 1, l(/* @__PURE__ */ new Map(), []).body, i);
  return { marker: w, fmk: k, recoveryKey: b, vaultId: _, index: x };
}
async function SD(e, t, n = {}) {
  if (e.v !== 1) throw new Error("e2e: not a v1 marker");
  const a = Zn(e.salt), i = await Vo(t, a, e.iter), r = await Da(i, e.verify);
  if (!r || new TextDecoder().decode(r) !== Ko)
    throw new sn("e2e: wrong password");
  const l = await Oy(t, a, e.iter), d = mp(), f = {
    v: fp,
    salt: e.salt,
    iter: e.iter,
    verify: e.verify,
    fmk: "kek",
    rk: await vp(l, d)
  };
  return n.escrowPublicKey && (f.esc = await _c(l, n.escrowPublicKey)), l.fill(0), { marker: f, fmk: i, recoveryKey: d };
}
async function $D(e, t, n) {
  if (!qi(e)) throw new Error("e2e: not a v2 marker");
  if (e.esc) throw new Error("e2e: this folder already has an escrow slot");
  if (!n) throw new Error("e2e: no escrow public key");
  const a = Zn(e.salt), i = await Vo(t, a, e.iter), r = await Da(i, e.verify);
  if (!r || new TextDecoder().decode(r) !== Ko)
    throw new sn("e2e: wrong password");
  let l;
  if (e.fmk === "wrapped") {
    const m = e.fmk_pw ? await Da(i, e.fmk_pw) : null;
    if (!m || m.length !== pi)
      throw new sn("e2e: could not unwrap the folder master key");
    l = m;
  } else
    l = await Oy(t, a, e.iter);
  const d = await _c(l, n);
  l.fill(0);
  const f = { ...e, esc: d };
  return delete f.esc_declined, f;
}
function TD(e, t) {
  return { ...e, esc_declined: t };
}
function s_(e, t) {
  return !t || !e || !qi(e) || e.esc ? "n/a" : e.esc_declined ? "declined" : "offer";
}
function qi(e) {
  return e.v === 2 || e.v === vo;
}
function Lf(e) {
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return null;
  }
  if (!t || typeof t != "object" || t.v !== 1 && !qi(t) || typeof t.salt != "string" || typeof t.verify != "string" || typeof t.iter != "number" || !Number.isInteger(t.iter) || t.iter < 1 || t.iter > q2 || qi(t) && (t.fmk !== "kek" && t.fmk !== "wrapped" || t.fmk === "wrapped" && typeof t.fmk_pw != "string"))
    return null;
  const n = [];
  if (t.v === vo) {
    if (!Array.isArray(t.req) || t.req.some((a) => typeof a != "string")) return null;
    for (const a of t.req) yD.includes(a) || n.push(a);
    if (t.req.includes(Yu)) {
      if (t.req.length !== 1 || t.fmk !== "wrapped" || typeof t.fmk_pw != "string" || t.names !== void 0 || t.rekey !== void 0 || t.conv !== void 0) return null;
      const a = AD(t.vault);
      if (a === "malformed") return null;
      a === "newer" && n.push(`${Yu} v${t.vault.v}`);
    } else if (t.vault !== void 0)
      return null;
    if (t.req.includes("names") && !ED(t.names)) return null;
    if (t.req.includes("rekey")) {
      if (t.fmk !== "wrapped" || !t.rekey || typeof t.rekey.from != "string") return null;
    } else if (t.rekey !== void 0)
      return null;
    if (t.req.includes("conv")) {
      if (!t.conv || typeof t.conv != "object" || t.conv.pending !== !0) return null;
    } else if (t.conv !== void 0)
      return null;
  } else if (t.req !== void 0 || t.names !== void 0 || t.rekey !== void 0 || t.conv !== void 0 || t.vault !== void 0)
    return null;
  return { marker: t, unsupported: n };
}
function AD(e) {
  var n;
  if (!e || typeof e != "object" || Array.isArray(e)) return "malformed";
  const t = e;
  return typeof t.v != "number" || !Number.isInteger(t.v) || t.v < 1 || typeof t.id != "string" || ((n = po(t.id)) == null ? void 0 : n.length) !== My || !mD(t.pack) ? "malformed" : t.v > K2 ? "newer" : null;
}
function Or(e) {
  return !!e && e.v === vo && Array.isArray(e.req) && e.req.length === 1 && e.req[0] === Yu && !!e.vault;
}
function Rue(e) {
  if (!Or(e)) return null;
  const t = po(e.vault.id);
  return t && t.length === My ? t : null;
}
function ED(e) {
  var t;
  return !!e && typeof e == "object" && e.alg === _2 && e.enc === x2 && typeof e.key == "string" && typeof e.long == "number" && Number.isInteger(e.long) && e.long >= 64 && e.long <= 255 && typeof e.root_id == "string" && ((t = po(e.root_id)) == null ? void 0 : t.length) === ll;
}
function Nue(e) {
  const t = Lf(e);
  return !t || t.unsupported.length > 0 ? null : t.marker;
}
function Ui(e) {
  return !!e && e.v === vo && Array.isArray(e.req) && e.req.includes("names") && !!e.names;
}
async function CD(e, t) {
  if (!Ui(e)) return null;
  const n = await Da(t, e.names.key);
  if (!n || n.length !== 64) return null;
  const a = await Cy(n, e.names.long, po(e.names.root_id));
  return n.fill(0), a;
}
async function l_(e, t) {
  if (e.v !== 2) throw new Error("e2e: only a v2 folder can switch to encrypted names");
  const n = await J2(t, !0);
  return { marker: {
    ...e,
    v: vo,
    req: ["names"],
    names: n.slot
  }, names: n.key };
}
function zD(e) {
  if (!Ui(e)) throw new Error("e2e: this folder has no encrypted names");
  const t = { ...e.names };
  return delete t.pending, { ...e, names: t };
}
const MD = ["content", "names", "vault"], Iue = "content";
function Bue(e = {}) {
  return MD.filter((t) => t !== "vault" || e.vault === !0);
}
function PD(e) {
  return Or(e) ? "vault" : e && Ui(e) ? e.names.pending ? "pending" : "names" : "content";
}
function OD(e) {
  return !!e && e.v === 2 && !Ui(e);
}
function u_(e) {
  return !!e && qi(e) && !!e.rk;
}
function Z2(e) {
  return !!e && qi(e) && !!e.esc;
}
function Q2(e, t) {
  return t ? Z2(e) ? e.esc.kid === t ? "available" : "other-key" : "predates" : "off";
}
async function ex(e, t) {
  const n = await Vo(t, Zn(e.salt), e.iter), a = await Da(n, e.verify);
  return !a || new TextDecoder().decode(a) !== Ko ? null : n;
}
async function tx(e, t) {
  if (e.v === 1 || e.fmk === "kek") return t;
  if (!e.fmk_pw) return null;
  const n = await Da(t, e.fmk_pw);
  if (!n || n.length !== pi) return null;
  const a = await Dy(e, n);
  return n.fill(0), a;
}
async function Fue(e, t) {
  const n = await ex(e, t);
  return n ? tx(e, n) : null;
}
async function nx(e, t) {
  const n = await ex(e, t);
  if (!n) return { error: "wrong" };
  const a = await tx(e, n);
  return a ? { fmk: a } : { error: "damaged" };
}
async function ax(e, t) {
  if (!qi(e) || !e.rk) return null;
  const n = Ly(t);
  if (!n) return null;
  let a;
  try {
    a = Zn(e.rk.salt);
  } catch {
    return null;
  }
  const i = await Ry(n, a);
  n.fill(0);
  const r = await Da(i, e.rk.blob);
  if (!r || r.length !== pi) return null;
  const l = await Dy(e, r);
  return r.fill(0), l;
}
async function ix(e, t) {
  if (!qi(e) || !e.esc || e.esc.alg !== W2) return null;
  let n;
  try {
    n = new Uint8Array(
      await crypto.subtle.decrypt(
        { name: "RSA-OAEP" },
        t,
        hn(Zn(e.esc.blob))
      )
    );
  } catch {
    return null;
  }
  if (n.length !== pi) return null;
  const a = await Dy(e, n);
  return n.fill(0), a;
}
function cl(e) {
  const t = e instanceof Uint8Array ? e : new Uint8Array(e);
  if (t.length < rf.length) return !1;
  for (let n = 0; n < rf.length; n++)
    if (t[n] !== rf[n]) return !1;
  return !0;
}
async function Tv(e, t) {
  if (t.byteLength > Nu)
    throw new Error("e2e: file exceeds the 200MB single-shot limit");
  const n = crypto.getRandomValues(new Uint8Array(32)), a = await crypto.subtle.importKey("raw", hn(n), { name: "AES-GCM" }, !1, [
    "encrypt"
  ]), i = crypto.getRandomValues(new Uint8Array(Fi)), r = crypto.getRandomValues(new Uint8Array(Fi)), l = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: hn(i) }, e, hn(n))
  ), d = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: hn(r) }, a, t)
  );
  n.fill(0);
  const f = new Uint8Array(Gu + d.length);
  return f.set(rf, 0), f[8] = Py, f.set(i, Xs), f.set(l, Js), f.set(r, xv), f.set(d, Gu), f.buffer;
}
async function Rf(e, t) {
  const n = new Uint8Array(t);
  if (!cl(n) || n.length < Gu)
    throw new Error("e2e: not an encrypted file");
  if (n[8] === gc) return lD(e, n);
  if (n[8] !== Py)
    throw new Error(`e2e: unsupported version ${n[8]}`);
  const a = n.slice(Xs, Xs + Fi), i = n.slice(Js, Js + Y2), r = n.slice(xv, xv + Fi);
  let l;
  try {
    l = await crypto.subtle.decrypt({ name: "AES-GCM", iv: hn(a) }, e, hn(i));
  } catch {
    throw new sn("e2e: DEK unwrap failed (wrong key?)");
  }
  const d = await crypto.subtle.importKey("raw", l, { name: "AES-GCM" }, !1, ["decrypt"]);
  try {
    return await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: hn(r) },
      d,
      hn(n.slice(Gu))
    );
  } catch {
    throw new sn("e2e: content decrypt failed");
  }
}
async function ox(e, t) {
  if ("recoveryKey" in t) {
    if (!qi(e) || !e.rk) throw new sn("e2e: this folder has no recovery key");
    const l = Ly(t.recoveryKey);
    if (!l) throw new sn("e2e: wrong recovery key");
    let d;
    try {
      d = Zn(e.rk.salt);
    } catch {
      throw new sn("e2e: damaged recovery slot");
    }
    const f = await Ry(l, d);
    l.fill(0);
    const m = await Da(f, e.rk.blob);
    if (!m || m.length !== pi) throw new sn("e2e: wrong recovery key");
    return m;
  }
  const n = Zn(e.salt), a = await Vo(t.password, n, e.iter), i = await Da(a, e.verify);
  if (!i || new TextDecoder().decode(i) !== Ko)
    throw new sn("e2e: wrong password");
  if (e.v === 1 || e.fmk === "kek") return Oy(t.password, n, e.iter);
  const r = e.fmk_pw ? await Da(a, e.fmk_pw) : null;
  if (!r || r.length !== pi) throw new sn("e2e: could not unwrap the folder master key");
  return r;
}
async function rx(e, t, n) {
  if ((e ?? "").length < Df)
    throw new Error(`e2e: the new password must be at least ${Df} characters`);
  const a = Math.max(hp, n ?? pp), i = crypto.getRandomValues(new Uint8Array(16)), r = await Vo(e, i, a);
  return {
    salt: Aa(i),
    iter: a,
    verify: await Ja(r, new TextEncoder().encode(Ko)),
    fmk: "wrapped",
    fmk_pw: await Ja(r, t)
  };
}
function sx(e) {
  return e.v === 1 || e.fmk === "kek";
}
function Zs(e) {
  return !!e && Array.isArray(e.req) && e.req.includes("rekey") && !!e.rekey;
}
async function lx(e, t, n, a = {}) {
  if (sx(e))
    throw new Error("e2e: this folder needs its file keys re-wrapped to change its password (startRekey)");
  if (Zs(e)) throw new Error("e2e: finish the re-key first");
  const i = await ox(e, t);
  try {
    return { ...e, ...await rx(n, i, a.iterations) };
  } finally {
    i.fill(0);
  }
}
class ux extends Error {
  constructor(t = "e2e: the escrow slot cannot be carried over to the new folder key") {
    super(t), this.name = "E2eRekeyEscrowError";
  }
}
async function DD(e, t, n, a = {}) {
  if (Zs(e)) throw new Error("e2e: a re-key is already in progress; resume it");
  if (Or(e)) throw new Error("e2e: a vault is not re-keyed; make a new vault instead");
  const i = await ox(e, t), r = crypto.getRandomValues(new Uint8Array(pi));
  try {
    const l = await Xu(i), d = await Xu(r);
    let f;
    if (qi(e) && e.esc) {
      const x = a.escrowPublicKey || null;
      if (!x || await X2(x) !== e.esc.kid) throw new ux();
      f = await _c(r, x);
    }
    const m = "recoveryKey" in t, v = m ? t.recoveryKey : mp();
    let b, _;
    if (Ui(e)) {
      const x = await Da(l, e.names.key);
      if (!x || x.length !== 64) throw new sn("e2e: could not open the name key");
      _ = { ...e.names, key: await Ja(d, x) }, b = await Cy(x, e.names.long, po(e.names.root_id)), x.fill(0);
    }
    const w = Array.from(/* @__PURE__ */ new Set([...e.req ?? [], "rekey"])), k = {
      ...e,
      v: vo,
      req: w,
      ...await rx(n, r, a.iterations),
      rk: await vp(r, v),
      rekey: { from: await Ja(d, i), pending: !0 }
    };
    return f && (k.esc = f), _ && (k.names = _), {
      marker: k,
      fmk: d,
      previous: l,
      recoveryKey: v,
      recoveryKeyIsNew: !m,
      ...b ? { names: b } : {}
    };
  } finally {
    i.fill(0), r.fill(0);
  }
}
async function LD(e, t) {
  if (!Zs(e)) return null;
  const n = await Da(t, e.rekey.from);
  if (!n || n.length !== pi) return null;
  const a = await Xu(n);
  return n.fill(0), a;
}
async function cx(e, t, n) {
  const a = new Uint8Array(e);
  if (!cl(a) || a.length < Gu) throw new Error("e2e: not an encrypted file");
  if (a[8] !== Py && a[8] !== gc) throw new Error(`e2e: unsupported version ${a[8]}`);
  const i = a.slice(Xs, Xs + Fi), r = a.slice(Js, Js + Y2);
  try {
    return await crypto.subtle.decrypt({ name: "AES-GCM", iv: hn(i) }, n, hn(r)), null;
  } catch {
  }
  let l;
  try {
    l = new Uint8Array(
      await crypto.subtle.decrypt({ name: "AES-GCM", iv: hn(i) }, t, hn(r))
    );
  } catch {
    throw new sn("e2e: this file opens under neither the new nor the previous folder key");
  }
  const d = crypto.getRandomValues(new Uint8Array(Fi)), f = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: hn(d) }, n, hn(l))
  );
  l.fill(0);
  const m = a.slice();
  return m.set(d, Xs), m.set(f, Js), m.buffer;
}
function c_(e) {
  var t;
  return !!e && Array.isArray(e.req) && e.req.includes("conv") && ((t = e.conv) == null ? void 0 : t.pending) === !0;
}
function RD(e, t = (/* @__PURE__ */ new Date()).toISOString(), n) {
  if (Or(e)) throw new Error("e2e: a vault is never converted");
  const a = Array.from(/* @__PURE__ */ new Set([...e.req ?? [], "conv"])), i = { pending: !0, started: t, ...n ? { cleanup: n } : {} };
  return { ...e, v: vo, req: a, conv: i };
}
function ND(e) {
  const t = { ...e };
  delete t.conv;
  const n = (e.req ?? []).filter((a) => a !== "conv");
  return n.length > 0 ? t.req = n : (delete t.req, t.v = fp), t;
}
function ID(e) {
  const t = { ...e };
  delete t.rekey;
  const n = (e.req ?? []).filter((a) => a !== "rekey");
  return n.length > 0 ? t.req = n : (delete t.req, t.v = fp), t;
}
async function BD(e, t, n) {
  try {
    return await Rf(e, n);
  } catch (a) {
    if (!t || !(a instanceof sn)) throw a;
    return Rf(t, n);
  }
}
function FD() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return {
    get(a) {
      return e.get(a);
    },
    set(a, i, r, l) {
      e.set(a, i), r ? t.set(a, r) : t.delete(a), l ? n.set(a, l) : n.delete(a);
    },
    /** The previous FMK of a folder mid re-key (files not re-wrapped yet). */
    previous(a) {
      return n.get(a);
    },
    /** A re-key finished: the previous FMK is no longer needed. */
    dropPrevious(a) {
      n.delete(a);
    },
    /** The folder's name key; undefined for a content-only folder or a locked one. */
    names(a) {
      return t.get(a);
    },
    setNames(a, i) {
      e.has(a) && t.set(a, i);
    },
    /** Every unlocked root, for resolving a path from any view. */
    roots() {
      return [...e.keys()];
    },
    /** Drop one folder's keys ("Lock"). */
    lock(a) {
      e.delete(a), t.delete(a), n.delete(a);
    },
    has(a) {
      return e.has(a);
    },
    clear() {
      e.clear(), t.clear(), n.clear();
    }
  };
}
function Ny(e) {
  const t = e.indexOf("://");
  return t === -1 ? e : e.slice(t + 3);
}
function UD(e) {
  const t = Ny(String(e ?? "")), n = t.lastIndexOf("/");
  return n === -1 ? "" : t.slice(0, n);
}
function xr(e) {
  return typeof e.e2e_display_dir == "string" ? e.e2e_display_dir : UD(e.path);
}
function HD(e) {
  return (e || []).filter((t) => !(ip(t.basename) || kf(t.path) || t.basename === ".trash" || t.basename === ha));
}
const dx = "filex.showHidden";
function KD() {
  try {
    return localStorage.getItem(dx) === "1";
  } catch {
    return !1;
  }
}
const Iu = $(KD());
function VD(e) {
  Iu.value = e;
  try {
    localStorage.setItem(dx, e ? "1" : "0");
  } catch {
  }
}
function jD(e, t) {
  return t ? e || [] : (e || []).filter((n) => !(n.basename || "").startsWith("."));
}
function yr(e) {
  return jD(HD(e), Iu.value);
}
function qD(e) {
  const t = Ny(e);
  return t === "fileman" || t === "";
}
function WD(e) {
  return Ny(e).startsWith("fileman/.trash");
}
function YD(e) {
  return {
    type: "dir",
    path: `${e}://fileman/.trash`,
    basename: ".trash",
    extension: "",
    storage: e,
    visibility: "private",
    size: 0,
    file_size: 0,
    mime_type: "inode/directory",
    extra_metadata: {}
  };
}
function fx(e, t, n, a, i = {}) {
  return !a || i.navOffersTrash || i.isSearchResult || WD(n) || !qD(n) ? !1 : (e.unshift(YD(t)), !0);
}
async function px(e, t, n) {
  try {
    const { storages: a } = await n.listTrash(t, { limit: 1 }), i = e.find((d) => d.basename === ".trash");
    if (!i) return;
    const r = (a ?? []).find((d) => d.storage_name === t);
    i.size = (r == null ? void 0 : r.bytes) ?? 0;
    const l = r != null && r.newest_deleted_at ? Date.parse(r.newest_deleted_at) : NaN;
    Number.isNaN(l) || (i.last_modified = l);
  } catch {
  }
}
const hx = {
  /* gorunum:v3-shell — Home is a destination like the rest, so it gets a
     sentinel like the rest: a restored tab, a reload and a pasted `#.home`
     all have to reopen the overview instead of asking the backend for a
     folder called `.home` and landing on "not found". */
  ".home": "node.home",
  ".trash": "node.trash",
  ".recent": "node.recent",
  ".starred": "node.starred",
  ".shared": "node.shared",
  /* Drafts (issue #71): a view like the rest — a reload on `#.drafts` opens
     it, instead of asking the backend for a folder called `.drafts`. */
  ".drafts": "node.drafts"
}, mx = ".tag~", vx = [
  [".mytag~", "personal"],
  [".teamtag~", "team"],
  [mx, ""]
];
function GD(e, t = "") {
  var a;
  return `${((a = vx.find(([, i]) => i === t)) == null ? void 0 : a[0]) ?? mx}${e}`;
}
function Iy(e) {
  for (const [t, n] of vx)
    if (e.startsWith(t)) {
      const a = e.slice(t.length);
      return a ? { tag: a, kind: n } : null;
    }
  return null;
}
function yx(e) {
  var t;
  return ((t = Iy(e)) == null ? void 0 : t.tag) ?? "";
}
function XD(e) {
  var n;
  const t = (e || "").replace(/^\/+|\/+$/g, "");
  return ((n = Iy(t.split("/").pop() || t)) == null ? void 0 : n.kind) ?? "";
}
function JD(e) {
  const t = (e || "").replace(/^\/+|\/+$/g, "");
  return yx(t.split("/").pop() || t);
}
function Nf(e, t) {
  const n = hx[e];
  if (n) return t(n);
  const a = Iy(e);
  return a ? a.kind ? `#${a.tag} · ${t(`tags.kind.${a.kind}`)}` : `#${a.tag}` : "";
}
function gx(e) {
  const t = String(e ?? "").replace(/^\/+|\/+$/g, "");
  return t ? !!hx[t] || !!yx(t) : !1;
}
function If(e, t) {
  const n = e.type === "dir" ? 0 : 1, a = t.type === "dir" ? 0 : 1;
  return n - a;
}
function yp() {
  return { w: {}, hidden: [] };
}
function gp(e, t) {
  const n = yp();
  if (!e || typeof e != "object" || Array.isArray(e)) return n;
  const a = (f) => t.find((m) => m.id === f), i = e, r = {};
  if (i.w && typeof i.w == "object")
    for (const [f, m] of Object.entries(i.w)) {
      const v = a(f);
      !v || typeof m != "number" || !Number.isFinite(m) || (r[v.id] = Math.min(v.max, Math.max(v.min, Math.round(m))));
    }
  const l = Array.isArray(i.hidden) ? [...new Set(i.hidden.filter((f) => {
    var m;
    return (m = a(f)) == null ? void 0 : m.hideable;
  }))] : [], d = Array.isArray(i.o) ? [...new Set(i.o.filter((f) => !!a(f)))] : void 0;
  return d && d.length ? { w: r, hidden: l, o: d } : { w: r, hidden: l };
}
function bx(e, t, n) {
  const a = [...e];
  if (t < 0 || t >= a.length) return a;
  const i = Math.max(0, Math.min(a.length - 1, n));
  if (i === t) return a;
  const [r] = a.splice(t, 1);
  return a.splice(i, 0, r), a;
}
function kx(e, t) {
  const n = (r) => {
    var l;
    return ((l = t.find((d) => d.id === r)) == null ? void 0 : l.hideable) === !0;
  };
  let a = 0;
  for (; a < e.length && !n(e[a]); ) a++;
  let i = e.length - 1;
  for (; i >= 0 && !n(e[i]); ) i--;
  return { lo: a, hi: Math.max(a, i) };
}
const ZD = 3;
function wx(e, t, n = {}) {
  var T;
  const a = n.lead ?? ((T = e()[0]) == null ? void 0 : T.id), i = E(() => gp(t.get(), e())), r = (N) => e().find((z) => z.id === N);
  function l(N) {
    t.set(N);
  }
  function d() {
    const N = e().map((B) => B.id), z = i.value.o;
    if (!z || z.length === 0)
      return [a, ...N.filter((B) => B !== a)];
    const L = z.filter((B) => N.includes(B) && B !== a);
    L.unshift(a);
    for (const B of N) L.includes(B) || L.push(B);
    return L;
  }
  function f(N) {
    const z = r(N);
    return z ? i.value.w[N] ?? z.width : 0;
  }
  function m(N, z) {
    const L = r(N);
    if (!L || !L.resizable) return;
    const B = Math.min(L.max, Math.max(L.min, Math.round(z)));
    i.value.w[N] !== B && l({ ...i.value, w: { ...i.value.w, [N]: B } });
  }
  function v() {
    return i.value.w[a] === void 0;
  }
  function b(N) {
    const z = { ...i.value.w };
    let L = !1;
    for (const [B, O] of Object.entries(N)) {
      if (typeof O != "number" || !Number.isFinite(O) || z[B] !== void 0) continue;
      const U = r(B);
      !U || !U.resizable || (z[B] = Math.min(U.max, Math.max(U.min, Math.round(O))), L = !0);
    }
    L && l({ ...i.value, w: z });
  }
  function _(N) {
    return i.value.hidden.includes(N);
  }
  function w(N, z) {
    const L = r(N);
    if (!L || !L.hideable || N === a || _(N) === z) return;
    const B = new Set(i.value.hidden);
    z ? B.add(N) : B.delete(N), l({ ...i.value, hidden: [...B] });
  }
  function k(N, z) {
    const L = r(N);
    if (!L || !L.hideable || N === a) return;
    const B = d(), O = B.indexOf(N);
    if (O === -1) return;
    const U = kx(B, e()), S = Math.max(U.lo, Math.min(U.hi, z)), F = bx(B, O, S);
    F.join() !== B.join() && l({ ...i.value, o: F });
  }
  function x() {
    l(yp());
  }
  function M() {
    var N;
    return t.customised ? t.customised() : Object.keys(i.value.w).length > 0 || i.value.hidden.length > 0 || (((N = i.value.o) == null ? void 0 : N.length) ?? 0) > 0;
  }
  function A(N, z, L = {}) {
    var W;
    const B = L.gap ?? 8, O = L.padding ?? 24, U = L.check ?? 0, S = L.menu ?? 28, F = r(a), I = d().filter((ne) => ne !== a && z.includes(ne) && !_(ne)), G = {};
    for (const ne of I) G[ne] = f(ne);
    G[a] = f(a);
    const Y = (ne) => {
      const K = (U > 0 ? 1 : 0) + 1 + ne + 1;
      return U + S + O + B * (K - 1);
    }, ie = Y(I.length), me = v(), q = L.leadAuto ?? (F == null ? void 0 : F.width) ?? G[a], C = F ? Math.min(q, F.min) : G[a], re = I.slice(0, ZD), de = Y(re.length) + C + re.reduce((ne, K) => {
      var ce;
      return ne + (((ce = r(K)) == null ? void 0 : ce.min) ?? G[K]);
    }, 0);
    if (me && N > 0 && F) {
      const ne = N - ie;
      let K = I.reduce((J, H) => J + G[H], 0);
      const ce = ne - q;
      if (K > ce) {
        const J = I.reduce((H, X) => {
          var we;
          return H + (G[X] - (((we = r(X)) == null ? void 0 : we.min) ?? G[X]));
        }, 0);
        if (J > 0) {
          const H = Math.min(1, (K - ce) / J);
          for (const X of I) {
            const we = ((W = r(X)) == null ? void 0 : W.min) ?? G[X];
            G[X] = Math.max(we, G[X] - Math.ceil((G[X] - we) * H));
          }
          K = I.reduce((X, we) => X + G[we], 0);
        }
      }
      G[a] = Math.round(Math.max(C, Math.min(F.max, ne - K)));
    }
    const V = ie + G[a] + I.reduce((ne, K) => ne + G[K], 0);
    return { visible: I, widths: G, total: V, auto: me, stackBelow: de };
  }
  return {
    lead: a,
    specs: e,
    spec: r,
    order: d,
    width: f,
    setWidth: m,
    hidden: _,
    setHidden: w,
    move: k,
    widthsAreAuto: v,
    freeze: b,
    reset: x,
    customised: M,
    state: () => i.value,
    layout: A
  };
}
function QD(e = yp()) {
  const t = xa(e);
  return {
    get: () => t.value,
    set: (n) => {
      t.value = n;
    }
  };
}
let Wi = null;
const Kr = $(!1), xc = $(!1);
function Ls() {
  return Kr.value;
}
function Uue() {
  return !0;
}
function Hue(e) {
}
function _x() {
  return Math.floor(Date.now() / 1e3);
}
function By(e) {
  return e === "list" || e === "grid" || e === "gallery";
}
function Fy(e) {
  return e === "name" || e === "type" || e === "modified" || e === "size";
}
function Uy(e) {
  return e === "asc" || e === "desc";
}
function Dr(e) {
  var t;
  return !!e && (Object.keys(e.w).length > 0 || e.hidden.length > 0 || (((t = e.o) == null ? void 0 : t.length) ?? 0) > 0);
}
const Nn = $({});
function eL(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = {};
  for (const [n, a] of Object.entries(e)) {
    if (!a || typeof a != "object") continue;
    const i = a, l = { t: typeof i.t == "number" && Number.isFinite(i.t) ? i.t : 0 };
    if (By(i.v) && (l.v = i.v), Fy(i.k) && (l.k = i.k), Uy(i.d) && (l.d = i.d), i.c !== void 0) {
      const d = gp(i.c, jo);
      Dr(d) && (l.c = d);
    }
    (l.v || l.k || l.c) && (t[n] = l);
  }
  return t;
}
const d_ = 300;
function tL() {
  const e = Object.entries(Nn.value);
  if (e.length <= d_) return;
  e.sort((n, a) => a[1].t - n[1].t);
  const t = {};
  for (const [n, a] of e.slice(0, d_)) t[n] = a;
  Nn.value = t;
}
function f_(e, t) {
  const n = String(e ?? "").trim(), a = String(t ?? "").replace(/^[a-z][a-z0-9+.-]*:\/\//i, "").replace(/\/{2,}/g, "/").replace(/^\/+|\/+$/g, "");
  return n ? a ? `${n}/${a}` : n : a;
}
const nL = ".root", ym = {};
function xx(e) {
  if (!e) return null;
  const t = Nn.value[e];
  if (t) {
    const { t: n, ...a } = t, i = ym[e];
    return i && !a.k ? { ...i, ...a } : a;
  }
  return ym[e] ? { ...ym[e] } : null;
}
function Av(e) {
  return !!e && !!Nn.value[e];
}
function aL() {
  return Object.keys(Nn.value).length;
}
function Sx(e, t) {
  if (!e) return;
  const n = Nn.value[e], a = { ...n ?? {}, ...t, t: _x() };
  if (t.c !== void 0 && !Dr(t.c) && delete a.c, !a.v && !a.k && !a.c) {
    n && $x(e);
    return;
  }
  Nn.value = { ...Nn.value, [e]: a }, tL(), ho();
}
function iL(e) {
  if (!e) return;
  const t = Nn.value[e];
  if (!t) return;
  const n = _x();
  t.t !== n && (Nn.value = { ...Nn.value, [e]: { ...t, t: n } }, ho());
}
function $x(e) {
  if (!e || !Nn.value[e]) return;
  const t = { ...Nn.value };
  delete t[e], Nn.value = t, ho();
}
function Kue() {
  Nn.value = {}, ho();
}
const Ta = $({}), Sc = $({});
function Hy(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = e, n = {};
  if (By(t.v) && (n.v = t.v), Fy(t.k) && (n.k = t.k, Uy(t.d) && (n.d = t.d)), t.c !== void 0) {
    const a = gp(t.c, jo);
    Dr(a) && (n.c = a);
  }
  return n;
}
function oL(e) {
  let t = e;
  if (typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      return {};
    }
  if (!t || typeof t != "object" || Array.isArray(t)) return {};
  const n = t, a = {};
  if (By(n.v) && (a.v = n.v), Fy(n.k) && (a.k = n.k, Uy(n.d) && (a.d = n.d)), Array.isArray(n.hidden)) {
    const i = n.hidden.filter(
      (r) => typeof r == "string" && jo.some((l) => l.id === r && l.hideable)
    );
    i.length && (a.hidden = [...new Set(i)]);
  }
  return a;
}
function Vue() {
  return Ta.value;
}
function Tx(e) {
  const t = { ...Ta.value };
  for (const [n, a] of Object.entries(e))
    a == null ? delete t[n] : t[n] = a;
  Ta.value = Hy(t), Ju(), ho();
}
function rL(e) {
  Ta.value = Hy({ ...Ta.value, ...e }), Nn.value = {}, Ju(), ho();
}
function jue() {
  return Sc.value;
}
function sL(e) {
  Sc.value = oL(e), Ju();
}
function bp() {
  const e = Ta.value, t = Sc.value, n = {}, a = e.v ?? t.v;
  return a && (n.v = a), e.k ? (n.k = e.k, e.d && (n.d = e.d)) : t.k && (n.k = t.k, t.d && (n.d = t.d)), n;
}
function lL(e) {
  const t = xx(e), n = bp(), a = {}, i = (t == null ? void 0 : t.v) ?? n.v;
  return i && (a.v = i), t != null && t.k ? (a.k = t.k, t.d && (a.d = t.d)) : n.k && (a.k = n.k, n.d && (a.d = n.d)), a;
}
const jo = [
  { id: "name", width: 260, min: 120, max: 900, hideable: !1, resizable: !0 },
  { id: "type", width: 88, min: 64, max: 220, hideable: !0, resizable: !0 },
  { id: "location", width: 160, min: 80, max: 420, hideable: !0, resizable: !0 },
  { id: "owner", width: 104, min: 72, max: 260, hideable: !0, resizable: !0 },
  { id: "modified", width: 160, min: 96, max: 300, hideable: !0, resizable: !0 },
  /* The Trash only: how long an item has left before it is purged. */
  { id: "remaining", width: 112, min: 80, max: 220, hideable: !0, resizable: !0 },
  { id: "size", width: 88, min: 64, max: 200, hideable: !0, resizable: !0 },
  { id: "star", width: 24, min: 24, max: 24, hideable: !1, resizable: !1 }
], p_ = { check: 28, menu: 28 }, que = 120, uL = 220, Ax = {
  gap: 8,
  padding: 24,
  check: p_.check,
  menu: p_.menu,
  leadAuto: uL
};
function h_() {
  if (Ta.value.c) return Ta.value.c;
  const e = Sc.value.hidden;
  return e && e.length ? { w: {}, hidden: [...e] } : yp();
}
function Ex(e) {
  return wx(
    () => jo,
    {
      get: () => {
        var n;
        const t = e();
        return t ? ((n = Nn.value[t]) == null ? void 0 : n.c) ?? h_() : h_();
      },
      set: (t) => {
        const n = e();
        if (!n) {
          Tx({ c: Dr(t) ? t : void 0 });
          return;
        }
        Sx(n, { c: t });
      },
      customised: () => {
        var n;
        const t = e();
        return t ? !!((n = Nn.value[t]) != null && n.c) : Dr(Ta.value.c);
      }
    },
    { lead: "name" }
  );
}
const ti = Ex(() => "");
function Ev() {
  return ti.order();
}
const Wue = bx;
function Yue(e) {
  return kx(e, jo);
}
function Gue(e, t) {
  ti.move(e, t);
}
function Xue(e, t) {
  const n = Ev().filter((l) => {
    var d;
    return (d = jo.find((f) => f.id === l)) == null ? void 0 : d.hideable;
  }), a = n.indexOf(e);
  if (a === -1) return;
  const i = a + t;
  if (i < 0 || i >= n.length) return;
  const r = n[i];
  ti.move(e, Ev().indexOf(r));
}
function Jue(e, t) {
  const n = Ev().filter((i) => {
    var r;
    return (r = jo.find((l) => l.id === i)) == null ? void 0 : r.hideable;
  }), a = n.indexOf(e);
  return a === -1 ? !1 : a + t >= 0 && a + t < n.length;
}
function Zue(e) {
  return ti.width(e);
}
function Que(e, t) {
  ti.setWidth(e, t);
}
function ece() {
  return ti.widthsAreAuto();
}
function tce(e) {
  ti.freeze(e);
}
function nce(e) {
  return ti.hidden(e);
}
function ace(e, t) {
  ti.setHidden(e, t);
}
function ice() {
  ti.reset();
}
function oce() {
  return ti.customised();
}
function rce(e, t, n = {}) {
  return ti.layout(e, t, { ...Ax, ...n });
}
const Fd = {
  sort: "filex.list-sort",
  view: "brf-file-explorer:view-mode"
};
function Ju() {
  const e = bp();
  try {
    if (e.k) {
      const t = e.d ?? (e.k === "modified" ? "desc" : "asc");
      localStorage.setItem(Fd.sort, JSON.stringify({ key: e.k, dir: t }));
    } else localStorage.removeItem(Fd.sort);
    e.v ? localStorage.setItem(Fd.view, e.v) : localStorage.removeItem(Fd.view);
  } catch {
  }
}
const Cx = ["on", "f", "p", "c", "g", "u"], Zu = $(0), ro = $({});
function cL(e) {
  const t = {};
  for (const [n, a] of Object.entries(e))
    Cx.includes(n) || (t[n] = a);
  return t;
}
function dL() {
  const e = {
    ...ro.value,
    on: !0,
    f: Nn.value,
    u: Zu.value
  };
  return Object.keys(Ta.value).length && (e.p = Ta.value), e;
}
function fL(e) {
  if (!e || Cx.includes(e))
    throw new Error(`viewPrefsSlot: "${e}" is reserved by lib/viewPrefs`);
  return {
    get: () => ro.value[e],
    set(t) {
      ro.value = { ...ro.value, [e]: t }, ho();
    },
    clear() {
      if (!(e in ro.value)) return;
      const t = { ...ro.value };
      delete t[e], ro.value = t, ho();
    },
    ready: () => Kr.value,
    persistable: () => xc.value
  };
}
const pL = 800;
let uo, Qu = !1;
function ho() {
  !Kr.value || !xc.value || !Wi || (Qu = !0, uo && clearTimeout(uo), uo = setTimeout(dl, pL));
}
function dl() {
  uo && clearTimeout(uo), uo = void 0, !(!Qu || !Wi || !xc.value) && (Qu = !1, Zu.value = Date.now(), Wi.save(dL()));
}
typeof window < "u" && (window.addEventListener("pagehide", dl), window.addEventListener("visibilitychange", () => {
  typeof document < "u" && document.visibilityState === "hidden" && dl();
}));
function hL(e) {
  Wi || (Wi = e, (async () => (await Mx(!0), Kr.value = !0, vL()))());
}
function sce() {
  dl(), Px();
}
function lce() {
  return Wi !== null;
}
const Bf = /* @__PURE__ */ new Set();
function zx(e) {
  return Bf.add(e), () => Bf.delete(e);
}
function m_() {
  for (const e of Bf)
    try {
      e();
    } catch {
    }
}
async function Mx(e) {
  if (!Wi) return;
  let t = null;
  try {
    t = await Wi.load();
  } catch {
    t = null;
  }
  if (!t || typeof t != "object" || Array.isArray(t)) {
    Ju(), m_();
    return;
  }
  const n = t, a = typeof n.u == "number" && Number.isFinite(n.u) ? n.u : 0;
  if (!e) {
    if (Qu) {
      dl();
      return;
    }
    if (a <= Zu.value) return;
  }
  Nn.value = eL(n.f);
  let i = !1;
  if (n.p !== void 0)
    Ta.value = Hy(n.p);
  else {
    const r = gp(n.c, jo);
    Ta.value = Dr(r) ? { c: r } : {}, i = Dr(r) || n.g !== void 0 || n.c !== void 0;
  }
  Zu.value = a, ro.value = cL(n), xc.value = !0, Ju(), i && (Kr.value = !0, ho()), m_();
}
const mL = 3e3;
let Cv = 0, v_ = !1;
function y_(e = !1) {
  if (!Wi || !Kr.value) return;
  const t = Date.now();
  !e && t - Cv < mL || (Cv = t, Mx(!1));
}
function vL() {
  v_ || typeof window > "u" || (v_ = !0, window.addEventListener("focus", () => y_()), typeof document < "u" && document.addEventListener("visibilitychange", () => {
    document.visibilityState === "visible" && y_();
  }));
}
function Px() {
  Wi = null, Kr.value = !1, xc.value = !1, Nn.value = {}, Ta.value = {}, Sc.value = {}, Zu.value = 0, Cv = 0, ro.value = {}, Qu = !1, uo && clearTimeout(uo), uo = void 0;
}
function uce() {
  Px(), Bf.clear();
}
function cce() {
  dl();
}
const Ky = ["name", "type", "modified", "size"], yL = "filex.list-sort", Bu = "name";
function fl(e) {
  return e === "modified" ? "desc" : "asc";
}
function gL(e) {
  return typeof e == "string" && Ky.includes(e);
}
function bL() {
  const e = { key: Bu, dir: fl(Bu) };
  if (typeof localStorage > "u") return e;
  try {
    const t = localStorage.getItem(yL);
    if (!t) return e;
    const n = JSON.parse(t), a = gL(n.key) ? n.key : Bu, i = n.dir === "asc" || n.dir === "desc" ? n.dir : fl(a);
    return { key: a, dir: i };
  } catch {
    return e;
  }
}
const Ox = $("en");
function Vy(e) {
  Ox.value = e;
}
function g_(e) {
  const t = e.last_modified;
  return t ? t * (t < 1e12 ? 1e3 : 1) : null;
}
function Dx(e, t) {
  return (e || "").localeCompare(t || "", void 0, {
    numeric: !0,
    sensitivity: "base"
  });
}
function b_(e, t) {
  return Dx(e.basename, t.basename);
}
function k_(e) {
  const t = y2(e);
  if (t)
    return (Xw[Ox.value] ?? Xw.en)[t] ?? t;
  const n = (e.extension || "").trim();
  return n ? n.toUpperCase() : "";
}
function kL(e, t, n, a) {
  const i = t === "asc" ? 1 : -1;
  switch (e) {
    case "name":
      return i * b_(n, a);
    case "size":
      return i * ((n.size ?? -1) - (a.size ?? -1));
    case "type": {
      const r = k_(n).localeCompare(k_(a), void 0, { sensitivity: "base" });
      return r !== 0 ? i * r : b_(n, a);
    }
    default: {
      const r = g_(n), l = g_(a);
      return r == null && l == null ? 0 : r == null ? 1 : l == null ? -1 : i * (r - l);
    }
  }
}
const Lx = /* @__PURE__ */ new Set(), zv = /* @__PURE__ */ new WeakMap();
function Rx() {
  const e = jy(), t = $(e.key), n = $(e.dir);
  function a(v, b) {
    t.value = v, n.value = b ?? fl(v);
  }
  function i(v, b) {
    t.value = v, n.value = b;
  }
  function r() {
    n.value = n.value === "asc" ? "desc" : "asc";
  }
  function l(v) {
    t.value === v ? r() : a(v);
  }
  function d(v, b) {
    return If(v, b) || kL(t.value, n.value, v, b);
  }
  function f(v) {
    return v === "relevance" ? If : d;
  }
  const m = {
    key: t,
    dir: n,
    setSort: a,
    applySort: i,
    toggleSortDir: r,
    chooseSortKey: l,
    compareNodes: d,
    compareInOrder: f,
    sortListing: (v, b = "sort") => [...v || []].sort(f(b))
  };
  return Lx.add(m), zv.set(m, { ...e }), m;
}
const kp = Rx(), Nx = Symbol("fe-sort-store");
function $c() {
  return Hi(Nx, kp);
}
function w_() {
  return kp.key.value;
}
function __() {
  return kp.dir.value;
}
function x_(e, t) {
  kp.applySort(e, t);
}
function jy() {
  const e = bp();
  return e.k ? { key: e.k, dir: e.d ?? fl(e.k) } : Ls() ? { key: Bu, dir: fl(Bu) } : bL();
}
zx(() => {
  const e = jy();
  for (const t of Lx) {
    const n = zv.get(t);
    !n || t.key.value !== n.key || t.dir.value !== n.dir || (t.applySort(e.key, e.dir), zv.set(t, { ...e }));
  }
});
function wL(e) {
  const t = `${(e.apiBase ?? "").replace(/\/+$/, "")}/api/files/manager/view-prefs`, n = e.credentials ?? "same-origin";
  return {
    async load() {
      var r;
      const a = await fetch(t, {
        headers: { ...await ((r = e.headers) == null ? void 0 : r.call(e)) ?? {} },
        credentials: n
      });
      if (!a.ok) return null;
      const i = await a.json();
      return sL((i == null ? void 0 : i.instance_default) ?? null), (i == null ? void 0 : i.prefs) ?? null;
    },
    save(a) {
      (async () => {
        var i;
        try {
          const r = JSON.stringify({ prefs: a });
          await fetch(t, {
            method: "PUT",
            headers: {
              ...await ((i = e.headers) == null ? void 0 : i.call(e)) ?? {},
              "Content-Type": "application/json"
            },
            credentials: n,
            body: r,
            /* ⚠ `keepalive` is what lets the save fired on `pagehide` outlive
             * the page — but browsers reject a keepalive body over 64 KB
             * outright, so the flag goes only on documents that fit. */
            keepalive: r.length < 6e4
          });
        } catch {
        }
      })();
    }
  };
}
function _L(e) {
  hL(wL(e));
}
const Ix = Symbol("fe-table-env");
function xL(e) {
  wr(Ix, e);
}
function SL() {
  return Hi(Ix, null);
}
function gm(e, t, n) {
  return e ? {} : t ? { disabled: !0, title: n } : { hidden: !0 };
}
function dce(e) {
  var n;
  if (!e) return !1;
  const t = (n = e.external) == null ? void 0 : n.onlyoffice;
  return t && !ev(t) ? !1 : !!e.onlyoffice_url;
}
const bm = {
  links: "share.links",
  uploadLinks: "share.upload_links",
  users: "share.users"
}, $L = Object.freeze({ links: !0, uploadLinks: !0, users: !0 });
function TL(e) {
  return {
    links: e(bm.links),
    uploadLinks: e(bm.uploadLinks),
    users: e(bm.users)
  };
}
function AL(e, t) {
  return e.links || e.users || t && e.uploadLinks;
}
function Bx(e, t) {
  return e && !t;
}
function S_(e, t, n) {
  return Bx(e, t) && (n == null ? void 0 : n.visible) === !0;
}
function Fx(e, t) {
  return t ? !0 : e.some(ky);
}
function Ux(e, t = {}) {
  return t.busy || e.op_type !== "plugin" || e.status !== "done" || !e.plugin || !rp(e.open) ? null : { plugin: e.plugin, open: e.open };
}
const EL = ["standard", "simple"], km = "standard", Mv = /* @__PURE__ */ new Set();
function CL(e) {
  if (e === "simple") return "simple";
  if (e === "standard" || e === void 0 || e === null || e === "")
    return km;
  const t = typeof e == "string" ? e : String(e);
  return !Mv.has(t) && typeof console < "u" && (Mv.add(t), console.warn(
    `[filex] unknown uiProfile ${JSON.stringify(t)} - using "${km}". Valid values: ${EL.map((n) => `"${n}"`).join(", ")}. (The former "drive" profile was removed; pass "simple" for the reduced explorer.)`
  )), km;
}
function fce() {
  Mv.clear();
}
function Fs(e, t) {
  return e ? e.endsWith("://") || e.endsWith("/") ? e + t : `${e}/${t}` : t;
}
function Oa(e) {
  const t = e.indexOf("://"), n = t === -1 ? "" : e.slice(0, t + 3), a = (t === -1 ? e : e.slice(t + 3)).replace(/\/+$/, ""), i = a.lastIndexOf("/");
  return i === -1 ? n : n + a.slice(0, i);
}
function Qs(e) {
  const t = e.indexOf("://"), n = (t === -1 ? e : e.slice(t + 3)).replace(/\/+$/, ""), a = n.lastIndexOf("/");
  return a === -1 ? n : n.slice(a + 1);
}
function An(e) {
  const t = e.indexOf("://");
  return t === -1 ? e.replace(/^\/+|\/+$/g, "") : e.slice(0, t + 3) + e.slice(t + 3).replace(/^\/+|\/+$/g, "");
}
function wm(e) {
  const t = e.indexOf("://");
  return t === -1 ? e : e.slice(t + 3);
}
function Us(e, t) {
  const n = An(e), a = An(t);
  if (!a) return !1;
  const i = a.endsWith("://") ? a : `${a}/`;
  return n.length > i.length && n.startsWith(i);
}
function $_(e, t) {
  const n = An(e), a = An(t), i = a.endsWith("://") ? a : `${a}/`;
  return n.slice(i.length).split("/").filter(Boolean);
}
function sf(e) {
  return typeof e.e2e_stored == "string" ? e.e2e_stored : e.basename;
}
function zL(e) {
  const { api: t, ring: n } = e, a = $(0), i = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Set();
  function f() {
    a.value++;
  }
  async function m(q) {
    try {
      const { blob: C, url: re } = await t.fetchBlob(Fs(q, ha), { fresh: !0 });
      URL.revokeObjectURL(re);
      const de = Lf(await C.text()), V = de ? { marker: de.marker, unsupported: de.unsupported } : { marker: null, unsupported: [] };
      return r.set(q, V.marker), V;
    } catch {
      return r.set(q, null), { marker: null, unsupported: [] };
    }
  }
  async function v(q) {
    const C = An(q);
    let re = i.get(C);
    return re || (re = m(C), i.set(C, re)), (await re).marker;
  }
  function b(q) {
    const C = An(q);
    return r.has(C) ? r.get(C) : void 0;
  }
  function _(q, C) {
    const re = An(q);
    r.set(re, C), i.set(re, Promise.resolve({ marker: C, unsupported: [] })), f();
  }
  function w(q) {
    const C = An(q);
    i.delete(C), r.delete(C), l.delete(C);
    for (const re of [...A.keys()]) re.startsWith(`${C}|`) && A.delete(re);
    f();
  }
  function k(q) {
    return Ui(b(q) ?? null);
  }
  function x(q, C) {
    if (C && Us(q, C)) return An(C);
    let re = null;
    const de = /* @__PURE__ */ new Set([...n.roots(), ...r.keys()]);
    for (const V of de)
      Us(q, V) && (!re || V.length > re.length) && (re = An(V));
    return re;
  }
  function M(q) {
    const C = An(q);
    let re = l.get(C);
    return re || (re = /* @__PURE__ */ new Map(), l.set(C, re)), re;
  }
  const A = /* @__PURE__ */ new Map();
  function T(q, C, re) {
    const de = An(re), V = An(C);
    if (de === V || !Us(de, V)) return Promise.resolve(q.rootId);
    const W = `${V}|${de}`;
    let ne = A.get(W);
    return ne || (ne = T(q, C, Oa(de)).then((K) => vv(q, K, Qs(de))), A.set(W, ne)), ne;
  }
  const N = /* @__PURE__ */ new Map();
  function z(q, C, re, de) {
    const V = M(C), W = `${An(re)}/${de}`, ne = V.get(W);
    if (ne) return Promise.resolve(ne);
    const K = `${An(C)}|${W}`, ce = N.get(K);
    if (ce) return ce;
    const J = T(q, C, re).then((H) => M2(q, de, H, async (X) => {
      try {
        const we = await t.fetchArrayBuffer(Fs(re, X));
        return new TextDecoder().decode(we);
      } catch {
        return null;
      }
    })).then((H) => (H.state !== "unreadable" && V.set(W, H), H)).finally(() => N.delete(K));
    return N.set(K, J), J;
  }
  function L(q, C, re, de) {
    M(q).set(`${An(C)}/${re.stored}`, { name: de, state: "enc" }), f();
  }
  async function B(q, C) {
    const re = n.names(q), de = $_(C, q);
    if (!re) return de.map(() => null);
    const V = [];
    let W = An(q);
    for (const ne of de) {
      const K = await z(re, q, W, ne);
      V.push(K.name), W = Fs(W, ne);
    }
    return V;
  }
  async function O(q) {
    const C = x(q);
    if (!C) return null;
    const re = n.names(C);
    return re ? z(re, C, Oa(q), Qs(q)) : null;
  }
  async function U(q, C) {
    const re = wm(An(q)), V = (await B(q, Oa(C))).map((W) => W === null ? e.lockedLabel() : W);
    return [re, ...V].filter(Boolean).join("/");
  }
  async function S(q, C = {}) {
    return C.root && await v(C.root), (await Promise.all(q.map((de) => F(de, C.root ?? null)))).filter((de) => de !== null);
  }
  async function F(q, C) {
    var we;
    const re = q.type === "file" ? (we = e.fileName) == null ? void 0 : we.call(e, q.path) : void 0;
    re && (q = { ...q, fxe_name: re });
    const de = typeof q.e2e_root == "string" && q.e2e_root || C, V = x(q.path, de);
    if (!V) return q;
    const W = await v(V);
    if (!Ui(W)) return q;
    const ne = sf(q);
    if (ne === ha || Sl(ne).kind === "sidecar") return null;
    const ce = n.names(V), J = await U(V, q.path), H = { ...q, e2e_stored: ne, e2e_root: V, e2e_display_dir: J };
    if (!ce)
      return { ...H, basename: e.lockedLabel(), extension: "", e2e_name_state: "locked" };
    const X = await z(ce, V, Oa(q.path), ne);
    return X.state === "enc" && X.name !== null ? {
      ...H,
      basename: X.name,
      extension: q.type === "dir" ? "" : Pf(X.name),
      e2e_name_state: "enc"
    } : X.state === "plain" ? { ...H, basename: ne, e2e_name_state: "plain" } : { ...H, basename: e.unreadableLabel(), extension: "", e2e_name_state: "unreadable" };
  }
  function I(q) {
    a.value;
    const C = x(q);
    if (!C) return null;
    const re = b(C);
    if (re === void 0)
      return v(C).then(f), null;
    if (!Ui(re)) return null;
    const de = n.names(C);
    if (!de) return e.lockedLabel();
    const V = Qs(q), W = Oa(q), ne = `${An(W)}/${V}`, K = M(C).get(ne);
    if (K) return K.name ?? e.unreadableLabel();
    const ce = `${C}|${ne}`;
    return d.has(ce) || (d.add(ce), z(de, C, W, V).finally(() => {
      d.delete(ce), f();
    })), "…";
  }
  function G(q) {
    a.value;
    const C = x(q);
    if (!C || !k(C)) return wm(An(q));
    const re = wm(An(C)), de = $_(q, C), V = [];
    let W = An(C);
    for (const ne of de)
      W = Fs(W, ne), V.push(I(W) ?? ne);
    return [re, ...V].filter(Boolean).join("/");
  }
  function Y(q) {
    const C = An(q);
    for (const re of /* @__PURE__ */ new Set([...n.roots(), ...r.keys()])) {
      const de = An(re);
      if ((C === de || Us(C, de)) && k(de)) return de;
    }
    return null;
  }
  async function ie(q, C, re = {}) {
    const de = Y(q);
    if (!de) return null;
    const V = n.names(de);
    if (!V) throw new Error("e2e: the folder is locked");
    const W = await T(V, de, q), ne = re.keepIdOf ? await T(V, de, re.keepIdOf) : void 0, K = await yv(V, C, W, { isDir: re.isDir, dirId: ne });
    return L(de, q, K, C.normalize("NFC")), K;
  }
  async function me(q) {
    const C = x(q) ?? Y(q);
    if (!C) return null;
    const re = n.names(C);
    return re ? T(re, C, q) : null;
  }
  return {
    version: a,
    markerFor: v,
    markerCached: b,
    setMarker: _,
    forget: w,
    namesOn: k,
    rootOf: x,
    decorate: S,
    decodePath: B,
    plainNameOf: O,
    segmentLabel: I,
    displayPath: G,
    writesEncrypted: Y,
    nameForWrite: ie,
    dirIdFor: me,
    remember: L,
    bump: f
  };
}
const Tc = Symbol("filex.e2eNameView"), ML = { class: "filex-recent" }, PL = ["title", "aria-label", "disabled"], OL = ["innerHTML"], DL = { key: 0 }, LL = ["data-fe-path"], RL = ["onClick", "onContextmenu"], NL = { class: "filex-recent-name" }, IL = { class: "filex-recent-meta" }, BL = {
  key: 1,
  class: "filex-recent-empty"
}, FL = {
  key: 2,
  class: "filex-recent-empty"
}, UL = /* @__PURE__ */ lt({
  __name: "RecentlyOpened",
  props: {
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    limit: {},
    refreshKey: {},
    locale: {}
  },
  emits: ["open", "context", "error"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = yt(() => n.locale ?? "en"), i = t, r = $([]), l = $(!1), d = Hi(Tc, null), f = $({});
    async function m(_) {
      if (!d) return;
      const w = _.map((A) => ({
        id: A.id,
        type: A.type === "dir" ? "dir" : "file",
        path: typeof A.storage == "string" && A.storage ? `${A.storage}://${String(A.path).replace(/^\/+/, "")}` : String(A.path),
        basename: A.name,
        ...typeof A.e2e_root == "string" && A.e2e_root ? { e2e_root: A.e2e_root } : {}
      })), k = await d.decorate(w), x = new Set(k.map((A) => A.id)), M = {};
      for (const A of k) typeof A.id == "number" && A.e2e_stored && (M[A.id] = A.basename);
      f.value = M, x.size !== _.length && (r.value = _.filter((A) => x.has(A.id)));
    }
    d && Xe(d.version, () => void m(r.value));
    async function v() {
      l.value = !0;
      try {
        const _ = await (n.authHeaders ?? (() => ({})))(), w = n.apiBase ?? "", k = n.limit ?? 20, x = await fetch(`${w}/api/files/manager/recent?limit=${k}`, {
          headers: _,
          credentials: n.authCredentials ?? "same-origin"
        });
        if (x.ok) {
          const M = await x.json();
          r.value = Array.isArray(M.nodes) ? M.nodes : Array.isArray(M.entries) ? M.entries : Array.isArray(M) ? M : [], await m(r.value);
        }
      } catch (_) {
        i("error", _ instanceof Error ? _.message : String(_));
      } finally {
        l.value = !1;
      }
    }
    function b(_) {
      if (!_) return "";
      const w = new Date(_).getTime();
      if (Number.isNaN(w)) return "";
      const k = Date.now() - w;
      try {
        const x = new Intl.RelativeTimeFormat(fi(n.locale), { numeric: "auto", style: "short" });
        return k < 6e4 ? x.format(0, "second") : k < 36e5 ? x.format(-Math.floor(k / 6e4), "minute") : k < 864e5 ? x.format(-Math.floor(k / 36e5), "hour") : x.format(-Math.floor(k / 864e5), "day");
      } catch {
        return new Date(w).toISOString().slice(0, 16).replace("T", " ");
      }
    }
    return Wt(v), Xe(() => n.refreshKey, v), (_, w) => (p(), h("div", ML, [
      c("header", null, [
        c("h3", null, y(u(a)("recents.title")), 1),
        c("button", {
          class: "filex-recent-refresh",
          type: "button",
          title: u(a)("recents.refresh"),
          "aria-label": u(a)("recents.refresh"),
          onClick: v,
          disabled: l.value
        }, [
          c("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("refresh")
          }, null, 8, OL)
        ], 8, PL)
      ]),
      r.value.length ? (p(), h("ul", DL, [
        (p(!0), h(Ce, null, ot(r.value, (k) => (p(), h("li", {
          key: k.id,
          "data-testid": "recent-tray-item",
          "data-fe-path": k.path
        }, [
          c("button", {
            type: "button",
            class: "filex-recent-item",
            onClick: (x) => i("open", k),
            onContextmenu: vt((x) => i("context", k, x), ["prevent"])
          }, [
            c("span", NL, [
              c("bdi", null, y(f.value[k.id] ?? k.name), 1)
            ]),
            c("span", IL, y(b(k.last_opened)), 1)
          ], 40, RL)
        ], 8, LL))), 128))
      ])) : l.value ? (p(), h("p", FL, y(u(a)("recents.loading")), 1)) : (p(), h("p", BL, y(u(a)("recents.empty")), 1))
    ]));
  }
}), Ro = {
  type: "any",
  modified: "any",
  size: "any",
  name: "",
  aroundDate: "",
  aroundSpan: "d1",
  sizeMin: null,
  sizeMax: null,
  pathMode: "any",
  pathBase: "",
  people: "any"
};
function lo(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{M}+", "gu"), "").toLowerCase().replace(/ı/g, "i");
}
function qy(e) {
  return (e.name ?? "").trim();
}
function Hx(e) {
  return (e.pathMode ?? "any") !== "any" && !!(e.pathBase ?? "");
}
function Wy(e) {
  return e.people ?? "any";
}
function Hs(e) {
  return e.type !== "any" || e.modified !== "any" || e.size !== "any" || qy(e) !== "" || Hx(e) || Wy(e) !== "any";
}
function HL(e) {
  return (e.type !== "any" ? 1 : 0) + (e.modified !== "any" ? 1 : 0) + (e.size !== "any" ? 1 : 0) + (qy(e) !== "" ? 1 : 0) + (Hx(e) ? 1 : 0) + (Wy(e) !== "any" ? 1 : 0);
}
const KL = {
  folder: ["folder"],
  document: ["doc", "text"],
  spreadsheet: ["sheet"],
  presentation: ["slides"],
  pdf: ["pdf"],
  image: ["image"],
  video: ["video"],
  audio: ["audio"],
  archive: ["archive"],
  code: ["code"]
};
function VL(e, t) {
  if (t === "any") return !0;
  if (t === "folder") return e.type === "dir";
  if (e.type === "dir") return !1;
  const n = e.kind;
  return typeof n == "string" && n !== "" ? n === t || t === "document" && n === "text" : KL[t].includes(vi(e));
}
const jL = {
  h1: 36e5,
  d1: 864e5,
  w1: 7 * 864e5
};
function qL(e) {
  const t = (e ?? "").trim();
  if (!t) return null;
  const n = Date.parse(t.includes("T") ? t : `${t}T00:00`);
  return Number.isNaN(n) ? null : n;
}
function Kx(e, t = Date.now()) {
  const n = e.modified;
  if (n === "any") return null;
  if (n === "around") {
    const i = qL(e.aroundDate);
    if (i === null) return null;
    const r = jL[e.aroundSpan ?? "d1"];
    return { after: i - r, before: i + r };
  }
  if (n === "year") {
    const i = new Date(t).getFullYear();
    return { after: new Date(i, 0, 1).getTime(), before: new Date(i + 1, 0, 1).getTime() - 1 };
  }
  if (n === "today") {
    const i = new Date(t);
    return i.setHours(0, 0, 0, 0), { after: i.getTime() };
  }
  return { after: t - (n === "7d" ? 7 : 30) * 864e5 };
}
function WL(e, t, n) {
  const a = Kx(t, n);
  if (!a) return !0;
  const i = typeof e.last_modified == "number" ? e.last_modified : 0;
  return !(!i || a.after !== void 0 && i < a.after || a.before !== void 0 && i > a.before);
}
const zs = 1024 * 1024;
function Vx(e) {
  switch (e.size) {
    case "any":
      return null;
    case "lt1":
      return { max: zs - 1 };
    case "1to10":
      return { min: zs, max: 10 * zs - 1 };
    case "10to100":
      return { min: 10 * zs, max: 100 * zs - 1 };
    case "gt100":
      return { min: 100 * zs };
    case "range": {
      const t = typeof e.sizeMin == "number" ? e.sizeMin : void 0, n = typeof e.sizeMax == "number" ? e.sizeMax : void 0;
      return { min: t, max: n };
    }
  }
  return null;
}
function YL(e, t) {
  const n = Vx(t);
  if (!n) return !0;
  if (e.type === "dir") return !1;
  const a = typeof e.size == "number" ? e.size : 0;
  return !(n.min !== void 0 && a < n.min || n.max !== void 0 && a > n.max);
}
function jx(e, t) {
  return t ? lo(e || "").includes(lo(t)) : !0;
}
function GL(e, t) {
  const n = t.pathMode ?? "any", a = (t.pathBase ?? "").replace(/\/+$/, "");
  if (n === "any" || !a) return !0;
  const i = e.path || "", r = i === a || i.startsWith(`${a}/`);
  return n === "here" ? r : !r;
}
function ec(e) {
  const t = e.owner_id;
  return typeof t == "number" && t > 0 ? t : null;
}
function wp(e) {
  return e.owner_self === !0;
}
function Yy(e) {
  const t = e.owner_name;
  return typeof t == "string" ? t : "";
}
function T_(e) {
  const t = e.deleted_by_id;
  return typeof t == "number" && t > 0 ? t : null;
}
function A_(e) {
  return e.deleted_by_self === !0;
}
function XL(e) {
  const t = e.deleted_by_name;
  return typeof t == "string" ? t : "";
}
function JL(e) {
  return e.external_upload === !0;
}
function ZL(e) {
  const t = [{ value: "any" }, { value: "me" }, { value: "system" }], n = /* @__PURE__ */ new Set();
  for (const r of e) {
    const l = ec(r);
    l === null || wp(r) || n.has(l) || (n.add(l), t.push({ value: `u:${l}`, name: Yy(r) }));
  }
  const a = t.slice(0, 3), i = t.slice(3).sort((r, l) => (r.name ?? "").localeCompare(l.name ?? "", void 0, { sensitivity: "base" }));
  return [...a, ...i];
}
function QL(e, t) {
  const n = Wy(t);
  if (n === "any") return !0;
  if (n === "me") return wp(e);
  if (n === "system") return ec(e) === null;
  const a = Number(n.slice(2));
  return Number.isFinite(a) && ec(e) === a;
}
function Pv(e, t, n = Date.now()) {
  return Hs({ ...t, name: "" }) ? e.filter(
    (a) => VL(a, t.type) && WL(a, t, n) && YL(a, t) && GL(a, t) && QL(a, t)
  ) : e;
}
const e4 = /* @__PURE__ */ lt({
  __name: "UploadProgress",
  props: {
    jobs: {},
    locale: {},
    center: {}
  },
  emits: ["cancel", "dismiss", "retry"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = yt(() => n.locale);
    function i(d) {
      return d === "committing" || d === "transferring";
    }
    const r = t;
    function l(d) {
      return d === "done" ? "done" : d === "error" ? "error" : d === "aborted" ? "aborted" : "running";
    }
    return Xe(
      () => n.jobs,
      (d) => {
        n.center.sync(
          "upload",
          d.map((f) => ({
            input: {
              id: f.id,
              kind: "upload",
              name: f.displayName ?? f.file.name,
              percent: i(f.status) ? null : f.totalBytes > 0 || f.status === "done" ? f.percent : null,
              message: i(f.status) ? a("upload.saving") : null,
              status: l(f.status),
              error: f.error ?? null,
              uploadedBytes: f.uploadedBytes,
              totalBytes: f.totalBytes,
              // Cancellable only while chunks are still moving: once the commit is
              // accepted the bytes are filex's and the ops worker owns the rest.
              cancellable: f.status === "uploading" || f.status === "initializing",
              retryable: f.status === "error"
            },
            actions: {
              cancel: () => r("cancel", f),
              dismiss: () => r("dismiss", f),
              retry: () => r("retry", f)
            }
          }))
        );
      },
      { immediate: !0 }
    ), (d, f) => D("", !0);
  }
});
function _m(e) {
  return Math.max(0, Math.min(100, Math.round(e)));
}
function qx(e) {
  if (e.progress_total > 1) return null;
  const t = e.objects_total ?? 0;
  return t > 0 ? { done: e.objects_done ?? 0, total: t } : null;
}
function t4(e) {
  if (e.status === "done") return 100;
  const t = e.bytes_total ?? 0, n = e.bytes_done ?? 0;
  if (t > 0) return _m(n / t * 100);
  if (n > 0) return null;
  if (e.progress_total <= 1) {
    const a = qx(e);
    return a ? _m(a.done / a.total * 100) : null;
  }
  return _m(e.progress_done / e.progress_total * 100);
}
const n4 = /* @__PURE__ */ lt({
  __name: "PendingOpsTray",
  props: {
    ops: {},
    locale: {},
    center: {},
    outputModeOf: { type: Function },
    callerAdmin: { type: Boolean }
  },
  emits: ["dismiss", "cancel", "open"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = yt(() => n.locale);
    function i(k) {
      return $f(k, a, { callerAdmin: n.callerAdmin === !0 });
    }
    const r = t;
    function l(k) {
      return k.status === "done" ? "done" : k.status === "cancelled" ? "aborted" : k.status === "error" ? "error" : "running";
    }
    const d = /* @__PURE__ */ new Set([
      "copy",
      "move",
      "delete",
      "rename",
      "restore",
      "purge",
      "plugin",
      "archive-create",
      "archive-extract"
    ]);
    function f(k) {
      return k.op_type === "trash-empty" ? "trash" : k.op_type === "thumb-repair" ? "thumbs" : d.has(k.op_type) ? k.op_type : "plugin";
    }
    function m(k) {
      return k.op_type === "plugin";
    }
    function v(k) {
      return k.status !== "pending" && k.status !== "running" ? !1 : k.op_type === "archive-create" || k.op_type === "archive-extract" ? k.cancellable : m(k) ? !0 : (k.op_type === "trash-empty" || k.op_type === "thumb-repair") && n.callerAdmin === !0;
    }
    const b = (k) => t4(k);
    function _(k) {
      if (k.op_type === "trash-empty" || k.op_type === "thumb-repair") return "";
      const x = k.label || k.target_path || k.source_dir || "";
      return x || (k.op_type === "restore" || k.op_type === "purge" ? a("opc.trash_items", { n: k.progress_total || k.source_count }) : "");
    }
    function w(k) {
      const x = qx(k);
      return x ? { itemsDone: x.done, itemsTotal: x.total } : {};
    }
    return Xe(
      () => n.ops,
      (k) => {
        n.center.sync(
          "ops",
          k.map((x) => {
            var M;
            return {
              input: {
                id: x.id,
                kind: f(x),
                name: _(x),
                percent: b(x),
                status: l(x),
                error: x.status === "error" ? i(x).text : null,
                errorDetail: x.status === "error" ? i(x).detail ?? null : null,
                queued: x.status === "pending",
                cancelling: x.status === "cancelling",
                doneCount: x.progress_done,
                totalCount: x.progress_total,
                ...w(x),
                cancellable: v(x),
                retryable: !1,
                message: x.message ?? null,
                outputs: (x.outputs ?? []).map((A) => A.path),
                outputMode: (m(x) ? (M = n.outputModeOf) == null ? void 0 : M.call(n, x) : void 0) ?? null
              },
              actions: {
                cancel: () => r("cancel", x.id),
                dismiss: () => r("dismiss", x.id),
                open: (A) => r("open", x.id, A)
              }
            };
          })
        );
      },
      { immediate: !0 }
    ), (k, x) => D("", !0);
  }
});
function Ac(e) {
  if (!e || e.locked !== !0) return null;
  const t = e.lock;
  return !t || typeof t != "object" || typeof t.plugin != "string" || !t.plugin ? null : t;
}
function pce(e) {
  return e.some((t) => Ac(t) !== null);
}
function Ov(e) {
  const t = e;
  if (!t || t.status !== 423) return null;
  const n = { plugin: "" };
  typeof t.server == "string" && t.server && (n.message = t.server);
  try {
    const a = JSON.parse(String(t.detail ?? ""));
    typeof a.plugin == "string" && (n.plugin = a.plugin), a.plugin_label && typeof a.plugin_label == "object" && (n.plugin_label = a.plugin_label), typeof a.path == "string" && (n.path = a.path), typeof a.reason == "string" && a.reason && (n.reason = a.reason), a.reason_text && typeof a.reason_text == "object" && (n.reason_text = a.reason_text), typeof a.until == "string" && a.until && (n.until = a.until), !n.message && typeof a.message == "string" && a.message && (n.message = a.message);
  } catch {
  }
  return n;
}
function a4(e, t) {
  return e && (Gt(e.reason_text, t || "en") || e.reason) || "";
}
function Lr(e, t) {
  if (!e) return "";
  const n = e.message;
  if (n) return Vi(t.locale, n);
  const a = Gt(e.plugin_label, t.locale || "en") || e.plugin || t.t("applock.some_app"), i = a4(e, t.locale), r = i ? t.t("applock.held_reason", { app: a, reason: i }) : t.t("applock.held", { app: a }), l = i4(e.until, t);
  return l ? `${r} ${l}` : r;
}
function i4(e, t) {
  if (!e) return "";
  const n = Date.parse(e);
  if (!Number.isFinite(n)) return "";
  const a = t.formatDate ? t.formatDate(n, { time: !0 }) : new Date(n).toISOString();
  return t.t("applock.until", { date: a });
}
const o4 = ["outside_root", "broken", "unresolved"];
function Wx(e) {
  if (!e || e.symlink !== !0) return null;
  const t = e.link_state;
  return typeof t == "string" && o4.includes(t) ? t : "unknown";
}
function r4(e, t) {
  switch (e) {
    case "outside_root":
      return { state: e, badge: t.t("symlink.badge.outside_root"), why: t.t("symlink.why.outside_root") };
    case "broken":
      return { state: e, badge: t.t("symlink.badge.broken"), why: t.t("symlink.why.broken") };
    case "unresolved":
      return { state: e, badge: t.t("symlink.badge.unresolved"), why: t.t("symlink.why.unresolved") };
    case "unknown":
      return { state: e, badge: t.t("symlink.badge.unknown"), why: t.t("symlink.why.unknown") };
    default:
      return null;
  }
}
function Ec(e, t) {
  return r4(Wx(e), t);
}
function hce(e) {
  return Wx(e) !== null;
}
function Yx(e) {
  return !!e && e.unavailable === !0;
}
function Cc(e, t) {
  if (!Yx(e)) return null;
  const n = e.type === "dir" ? t.t("unavailable.why.dir") : t.t("unavailable.why.file"), a = typeof e.unavailable_reason == "string" ? e.unavailable_reason.trim() : "", i = a ? t.t("unavailable.withReason", { why: n, reason: a }) : n;
  return { badge: "!", why: n, reason: a, full: i };
}
function _p(e) {
  if (!e) return "";
  for (const t of [e.name, e.display_name, e.username, e.email]) {
    const n = typeof t == "string" ? t.trim() : "";
    if (n) return n;
  }
  return "";
}
function s4(e, t) {
  const n = _p(e);
  return n ? [...n][0].toLocaleUpperCase(t) : "";
}
function Gy(e) {
  const t = Number(e);
  return Number.isFinite(t) ? (Math.round(t / 90) * 90 % 360 + 360) % 360 : 0;
}
const E_ = { w: 0.02, h: 0.01 }, Ff = (e) => Math.min(1, Math.max(0, e));
function el(e) {
  const t = Math.min(1, Math.max(E_.w, Number(e.w) || 0)), n = Math.min(1, Math.max(E_.h, Number(e.h) || 0)), a = Math.min(1 - t, Ff(Number(e.x) || 0)), i = Math.min(1 - n, Ff(Number(e.y) || 0));
  return { x: a, y: i, w: t, h: n };
}
function Ud(e, t) {
  return el({
    x: Math.min(e.x, t.x),
    y: Math.min(e.y, t.y),
    w: Math.abs(e.x - t.x),
    h: Math.abs(e.y - t.y)
  });
}
function mce(e, t) {
  return {
    left: e.x * t.width,
    top: e.y * t.height,
    width: e.w * t.width,
    height: e.h * t.height
  };
}
function vce(e, t) {
  const n = t.width || 1, a = t.height || 1;
  return { x: e.left / n, y: e.top / a, w: e.width / n, h: e.height / a };
}
function C_(e, t) {
  return { x: Ff(e.x / (t.width || 1)), y: Ff(e.y / (t.height || 1)) };
}
function Gx(e) {
  const t = Gy(e.rotation);
  return t === 90 || t === 270 ? { width: e.height, height: e.width } : { width: e.width, height: e.height };
}
function z_(e, t, n) {
  const a = Gy(n.rotation), i = n.width, r = n.height;
  switch (a) {
    case 90:
      return { x: t, y: i - e };
    case 180:
      return { x: i - e, y: r - t };
    case 270:
      return { x: r - t, y: e };
    default:
      return { x: e, y: t };
  }
}
function M_(e, t, n) {
  const a = Gy(n.rotation), i = n.width, r = n.height;
  switch (a) {
    case 90:
      return { X: i - t, Y: e };
    case 180:
      return { X: i - e, Y: r - t };
    case 270:
      return { X: t, Y: r - e };
    default:
      return { X: e, Y: t };
  }
}
function yce(e, t) {
  const n = z_(e.x * t.width, e.y * t.height, t), a = z_((e.x + e.w) * t.width, (e.y + e.h) * t.height, t), { height: i } = Gx(t), r = Math.min(n.x, a.x), l = Math.max(n.x, a.x), d = Math.min(n.y, a.y), f = Math.max(n.y, a.y);
  return Xx({ x: r, y: i - f, w: l - r, h: f - d });
}
function gce(e, t) {
  const { height: n } = Gx(t), a = { x: e.x, y: n - (e.y + e.h) }, i = { x: e.x + e.w, y: n - e.y }, r = M_(a.x, a.y, t), l = M_(i.x, i.y, t), d = t.width || 1, f = t.height || 1;
  return Xx({
    x: Math.min(r.X, l.X) / d,
    y: Math.min(r.Y, l.Y) / f,
    w: Math.abs(r.X - l.X) / d,
    h: Math.abs(r.Y - l.Y) / f
  });
}
function Xx(e) {
  const t = {};
  for (const [n, a] of Object.entries(e)) t[n] = Math.round(a * 1e6) / 1e6;
  return t;
}
function l4(e, t, n = 16) {
  const a = Math.max(0, e.width), i = Math.max(0, e.height) - n;
  if (!t.width || !t.height || i <= 0) return a;
  const r = i * t.width / t.height;
  return Math.max(120, Math.min(a, r));
}
const pl = [
  { key: "caveat", name: "Caveat", kind: "hand", className: "fe-signfont--caveat", stack: "'Caveat', cursive" },
  {
    key: "dancing-script",
    name: "Dancing Script",
    kind: "hand",
    className: "fe-signfont--dancing-script",
    stack: "'Dancing Script', cursive"
  },
  {
    key: "homemade-apple",
    name: "Homemade Apple",
    kind: "hand",
    className: "fe-signfont--homemade-apple",
    stack: "'Homemade Apple', cursive"
  },
  {
    key: "inter",
    name: "Inter",
    kind: "formal",
    className: "fe-signfont--inter",
    stack: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif'
  },
  {
    key: "source-serif",
    name: "Source Serif 4",
    kind: "formal",
    className: "fe-signfont--source-serif",
    stack: "'Source Serif 4', Georgia, 'Times New Roman', serif"
  }
], Jx = "caveat";
function Zx(e) {
  const t = String(e ?? "");
  return pl.find((n) => n.key === t) ?? pl.find((n) => n.key === Jx);
}
function tc(e) {
  return typeof e == "string" && pl.some((t) => t.key === e);
}
const Dv = ["any", "number", "email"];
function u4(e) {
  return typeof e == "string" && Dv.includes(e);
}
function c4(e) {
  if (!e || typeof e != "object") return null;
  const t = e, a = { kind: u4(t.kind) ? t.kind : "any" }, i = Math.trunc(Number(t.min)), r = Math.trunc(Number(t.max));
  return Number.isFinite(i) && i > 0 && (a.min = i), Number.isFinite(r) && r > 0 && (a.max = r), a.kind === "any" && a.min === void 0 && a.max === void 0 ? null : a;
}
function d4(e) {
  return e ? e.kind === "number" ? "numeric" : e.kind === "email" ? "email" : "text" : "text";
}
function Qx(e) {
  if (e)
    return e.max && e.max > 0 ? e.max : void 0;
}
function f4(e, t) {
  let n = String(e ?? "");
  if (!t) return n;
  if (t.kind === "number") {
    const i = n.startsWith("-");
    let r = !1;
    n = n.split("").filter((l) => l >= "0" && l <= "9" ? !0 : (l === "." || l === ",") && !r ? (r = !0, !0) : !1).join(""), i && (n = `-${n}`);
  } else t.kind === "email" && (n = n.replace(/\s+/g, ""));
  const a = Qx(t);
  return a && n.length > a && (n = n.slice(0, a)), n;
}
function p4(e, t) {
  const n = typeof e == "string" ? e.trim() : "";
  return !t || n === "" ? "" : t.min && n.length < t.min ? "min" : t.max && n.length > t.max ? "max" : t.kind === "number" ? /^-?\d+([.,]\d+)?$/.test(n) ? "" : "number" : t.kind === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(n) ? "" : "email" : "";
}
const lf = ["signature", "initials", "date", "text", "checkbox"];
function eS(e) {
  return e === "signature" || e === "initials";
}
function tS(e, t) {
  if (!Array.isArray(e)) return [];
  const n = [], a = /* @__PURE__ */ new Set();
  for (const i of e) {
    if (!i || typeof i != "object") continue;
    const r = typeof i.id == "string" ? i.id.trim() : "";
    if (!r || a.has(r)) continue;
    a.add(r);
    const l = { id: r, label: i.label ?? r };
    t(l, i), n.push(l);
  }
  return n;
}
function h4(e) {
  return tS(e, (t, n) => {
    n.examples && typeof n.examples == "object" && !Array.isArray(n.examples) && (t.examples = n.examples), n.default === !0 && (t.default = !0);
  });
}
function m4(e, t) {
  if (Array.isArray(e.lines)) {
    const n = new Set(e.lines);
    return t.filter((a) => n.has(a.id)).map((a) => a.id);
  }
  return t.filter((n) => n.default).map((n) => n.id);
}
function v4(e, t) {
  const n = e.examples ?? {};
  return n[t || "*"] ?? n["*"] ?? "";
}
const Uf = {
  signature: { w: 0.28, h: 0.06 },
  initials: { w: 0.1, h: 0.05 },
  date: { w: 0.16, h: 0.035 },
  text: { w: 0.26, h: 0.035 },
  checkbox: { w: 0.03, h: 0.022 }
}, xm = ["#2563eb", "#16a34a", "#d97706", "#9333ea", "#dc2626", "#0891b2"];
function nS(e) {
  return typeof e == "string" && lf.includes(e);
}
function y4(e) {
  if (!Array.isArray(e)) return [...lf];
  const t = e.filter(nS);
  return t.length ? lf.filter((n) => t.includes(n)) : [...lf];
}
function uf(e) {
  if (!Array.isArray(e)) return [];
  const t = [], n = /* @__PURE__ */ new Set();
  for (const a of e) {
    if (!a || typeof a != "object") continue;
    const i = String(a.id ?? "");
    if (!i || n.has(i) || !nS(a.type)) continue;
    n.add(i);
    const r = el({ x: Number(a.x), y: Number(a.y), w: Number(a.w), h: Number(a.h) }), l = Math.max(1, Math.trunc(Number(a.page) || 1)), d = { id: i, type: a.type, page: l, ...r };
    typeof a.label == "string" && a.label && (d.label = a.label), typeof a.assignee == "string" && a.assignee && (d.assignee = a.assignee), a.required === !0 && (d.required = !0), a.placed === !1 && (d.placed = !1), a.value !== void 0 && a.value !== null && (d.value = a.value);
    const f = c4(a.rule);
    f && (d.rule = f), typeof a.format == "string" && a.format.trim() && (d.format = a.format.trim()), tc(a.font) && (d.font = a.font), eS(a.type) && (a.style === "typed" && (d.style = "typed"), Array.isArray(a.lines) && (d.lines = [...new Set(a.lines.filter((m) => typeof m == "string" && !!m))].slice(0, 16))), t.push(d);
  }
  return t;
}
function Lv(e) {
  return e.placed !== !1;
}
function g4(e) {
  return e.filter((t) => !Lv(t));
}
function b4(e, t, n = {}) {
  var r;
  const a = Uf[t], i = {
    id: Xy(t, e),
    type: t,
    page: 1,
    x: 0.1,
    y: 0.1,
    w: a.w,
    h: a.h,
    placed: !1
  };
  return (r = n.label) != null && r.trim() && (i.label = n.label.trim()), n.assignee && (i.assignee = n.assignee), n.required && (i.required = !0), i;
}
function k4(e) {
  return tS(e, (t, n) => {
    typeof n.example == "string" && n.example.trim() && (t.example = n.example.trim()), typeof n.order == "string" && n.order.trim() && (t.order = n.order.trim()), n.order_label && (t.orderLabel = n.order_label), typeof n.separator == "string" && n.separator !== "" && (t.separator = n.separator), n.separator_label && (t.separatorLabel = n.separator_label);
  });
}
function w4(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = e, n = {};
  for (const a of ["order", "separator", "example"]) {
    const i = t[a];
    (typeof i == "string" ? i.trim() : i && typeof i == "object") && (n[a] = i);
  }
  return n;
}
function _4(e) {
  if (!e.length) return null;
  const t = [], n = [];
  for (const a of e) {
    if (a.order === void 0 || a.separator === void 0) return null;
    t.some((i) => i.id === a.order) || t.push({ id: a.order, label: a.orderLabel ?? a.order }), n.some((i) => i.id === a.separator) || n.push({ id: a.separator, label: a.separatorLabel ?? a.separator });
  }
  return t.length && n.length ? { orders: t, separators: n } : null;
}
function P_(e, t, n) {
  var i, r;
  const a = e.find((l) => l.order === t && l.separator === n);
  return a ? a.id : ((i = e.find((l) => l.order === t)) == null ? void 0 : i.id) ?? ((r = e[0]) == null ? void 0 : r.id) ?? "";
}
function x4(e, t) {
  const n = e.find((a) => a.id === t);
  return !n || n.order === void 0 || n.separator === void 0 ? null : { order: n.order, separator: n.separator };
}
function S4(e) {
  const t = [];
  let n = 0;
  for (; n < e.length; )
    e.startsWith("YYYY", n) ? (t.push("YYYY"), n += 4) : e.startsWith("YY", n) ? (t.push("YY"), n += 2) : e.startsWith("DD", n) ? (t.push("DD"), n += 2) : e.startsWith("MM", n) ? (t.push("MM"), n += 2) : n += 1;
  return t;
}
function $4(e, t, n) {
  return S4(e).map((i) => i === "YYYY" ? String(n.getFullYear()).padStart(4, "0") : i === "YY" ? String(n.getFullYear() % 100).padStart(2, "0") : i === "MM" ? String(n.getMonth() + 1).padStart(2, "0") : String(n.getDate()).padStart(2, "0")).join(t);
}
function T4(e) {
  return Array.isArray(e) ? e.filter((t) => t && typeof t == "object" && typeof t.id == "string" && t.id).map((t) => ({
    id: t.id,
    label: t.label ?? t.id,
    color: typeof t.color == "string" ? t.color : void 0
  })) : [];
}
function A4(e, t) {
  const n = e.findIndex((a) => a.id === t);
  return n < 0 ? xm[0] : e[n].color || xm[n % xm.length];
}
function aS(e, t) {
  return e.assignee ? !!t && e.assignee === t : !0;
}
function Rv(e) {
  const t = e.value;
  return e.type === "checkbox" ? t === !0 : typeof t == "string" ? t !== "" : t != null;
}
function iS(e, t) {
  return {
    fields: e.filter((n) => aS(n, t) && Rv(n)).map((n) => {
      const a = { id: n.id, value: n.value };
      return n.label && (a.label = n.label), n.font && (a.font = n.font), n.rule && (a.rule = n.rule), a;
    })
  };
}
function E4(e, t) {
  const n = t == null ? void 0 : t.fields;
  if (!Array.isArray(n)) return e;
  const a = /* @__PURE__ */ new Map();
  for (const i of n)
    i && typeof i.id == "string" && a.set(i.id, { value: i.value, font: tc(i.font) ? i.font : void 0 });
  return e.map((i) => {
    const r = a.get(i.id);
    return r ? { ...i, value: r.value, ...r.font ? { font: r.font } : {} } : i;
  });
}
function bce(e, t, n) {
  return e.map((a) => a.id === t ? { ...a, font: n } : a);
}
function C4(e, t, n) {
  return e.map((a) => {
    if (a.id !== t) return a;
    const i = { ...a };
    return n == null || n === "" || n === !1 ? delete i.value : i.value = n, i;
  });
}
function Xy(e, t) {
  const n = { signature: "sig", initials: "ini", date: "date", text: "text", checkbox: "chk" }[e], a = new Set(t.map((i) => i.id));
  for (let i = 1; ; i++) {
    const r = `${n}-${i}`;
    if (!a.has(r)) return r;
  }
}
function O_(e, t, n, a, i = Uf[t], r) {
  const l = el({ x: a.x, y: a.y, w: i.w, h: i.h }), d = { id: Xy(t, e), type: t, page: n, ...l };
  return r && (d.assignee = r), d;
}
function z4(e, t, n) {
  const a = e.find((r) => r.id === t);
  if (!a) return e;
  const i = { ...a, id: Xy(a.type, e), page: Math.max(1, Math.trunc(n)) };
  return delete i.value, [...e, i];
}
function M4(e = /* @__PURE__ */ new Date()) {
  const t = e.getFullYear(), n = String(e.getMonth() + 1).padStart(2, "0"), a = String(e.getDate()).padStart(2, "0");
  return `${t}-${n}-${a}`;
}
function zc(e, t) {
  var n;
  for (const a of e ?? [])
    t(a), (n = a.children) != null && n.length && zc(a.children, t);
}
function P4(e) {
  const t = {};
  return zc(e, (n) => {
    var i;
    const a = n.props ?? {};
    if (n.type === "form") {
      const r = a;
      for (const l of r.fields ?? []) {
        if (!(l != null && l.key)) continue;
        const d = (i = r.values) == null ? void 0 : i[l.key];
        d !== void 0 ? t[l.key] = D_(l, d) : l.default !== void 0 ? t[l.key] = D_(l, l.default) : l.multi === !0 && l.type === "select" && (t[l.key] = []);
      }
      return;
    }
    if (n.id) {
      if (n.type === "people-picker") {
        const r = a.value;
        t[n.id] = Array.isArray(r) ? r.filter((l) => l && typeof l.email == "string") : [];
      } else if (n.type === "file-chooser") {
        const r = a.value;
        t[n.id] = typeof r == "string" ? r : "";
      } else if (n.type === "pin-input")
        t[n.id] = "";
      else if (n.type === "signature-pad")
        t[n.id] = null;
      else if (n.type === "pdf-fields") {
        const r = a, l = uf(r.fields);
        t[n.id] = r.mode === "fill" ? iS(l, r.signer) : l;
      }
    }
  }), t;
}
function D_(e, t) {
  return e.multi !== !0 || e.type !== "select" ? t : Array.isArray(t) ? t.map((n) => String(n)) : t == null || t === "" ? [] : [String(t)];
}
const O4 = /* @__PURE__ */ new Set(["string", "int", "bool", "password", "select"]);
function D4(e) {
  const t = String(e.style ?? "").toLowerCase();
  return t === "choice" ? !0 : t === "switch" ? !1 : (e.options ?? []).length > 0 ? !0 : e.required === !0;
}
function L4(e, t) {
  const n = e.secret ? "password" : O4.has(String(e.type)) ? e.type : "string";
  return {
    key: e.key,
    type: n,
    label: Gt(e.label, t) || e.key,
    help: Gt(e.help, t) || void 0,
    i18n_key: "",
    required: e.required === !0,
    secret: e.secret === !0,
    default: e.default,
    placeholder: Gt(e.placeholder, t) || void 0,
    options: (e.options ?? []).map((a) => ({ value: String(a.value), label: Gt(a.label, t) || String(a.value) })),
    min: e.min,
    max: e.max,
    monospace: e.monospace === !0,
    // ⚠⚠ `text` IS the contract's long text (wire.Field: "string | password
    // | int | bool | select | text"), and the field renderer draws a textarea
    // only on `multiline`. Nothing mapped the two, so every long field a
    // plugin asked for arrived as a one-line box — including the signing
    // app's list of signers, under a help line that says "one per line".
    multiline: e.multiline === !0 || String(e.type) === "text",
    choice: n === "select" || n === "bool" && D4(e),
    multi: e.multi === !0
  };
}
function R4(e) {
  const t = e.trim(), n = t.indexOf("@");
  return n > 0 && n < t.length - 1 && !/\s/.test(t) && t.indexOf("@", n + 1) === -1;
}
function Nv(e) {
  return e == null ? !1 : typeof e == "string" ? e.trim() !== "" : Array.isArray(e) ? e.length > 0 : !0;
}
function N4(e) {
  return e == null ? [] : Array.isArray(e) ? e.map((t) => String(t)) : typeof e == "boolean" ? [e ? "true" : "false"] : [String(e)];
}
function oS(e, t) {
  if (!e || !e.key) return !0;
  const n = t == null ? void 0 : t[e.key], a = e.equals ?? [];
  if (!a.length) return Nv(n);
  if (!Nv(n)) return !1;
  const i = N4(n);
  return a.some((r) => i.includes(String(r)));
}
function Jy(e, t) {
  const n = (e ?? []).filter((i) => i && i.key);
  if (!n.length) return [];
  let a = n;
  for (let i = 0; i <= n.length; i++) {
    const r = rS(n, a, t), l = n.filter((d) => oS(d.show_when, r));
    if (l.length === a.length) return l;
    a = l;
  }
  return a;
}
function rS(e, t, n) {
  const a = new Set(t.map((r) => r.key)), i = { ...n };
  for (const r of e) a.has(r.key) || delete i[r.key];
  return i;
}
function sS(e, t) {
  return e.required === !0 ? !0 : e.required_when ? oS(e.required_when, t) : !1;
}
function lS(e) {
  const t = [];
  return zc(e, (n) => {
    var i;
    if (n.type !== "form") return;
    const a = (i = n.props) == null ? void 0 : i.fields;
    for (const r of a ?? []) r && r.key && t.push(r);
  }), t;
}
function I4(e, t) {
  const n = lS(e);
  if (!n.length) return [];
  const a = new Set(Jy(n, t).map((i) => i.key));
  return n.filter((i) => !a.has(i.key)).map((i) => i.key);
}
function B4(e, t) {
  const n = I4(e, t);
  if (!n.length) return { ...t };
  const a = { ...t };
  for (const i of n) delete a[i];
  return a;
}
function L_(e, t) {
  const n = lS(e);
  if (!n.length) return [];
  const a = Jy(n, t), i = rS(n, a, t);
  return a.filter((r) => sS(r, i) && !Nv(i[r.key]));
}
const F4 = 300;
function xp(e, t) {
  const n = $(null), a = $({}), i = $(!1), r = $(""), l = $([]), d = E(() => {
    var T;
    return ((T = n.value) == null ? void 0 : T.actions) ?? [];
  }), f = E(() => {
    var T;
    return (T = n.value) == null ? void 0 : T.errors;
  });
  function m(T, N = !1) {
    n.value = T, r.value = "", l.value = [];
    const z = P4(T == null ? void 0 : T.nodes);
    a.value = N ? { ...z, ...a.value } : z;
  }
  function v(T) {
    var N;
    if (a.value = T, l.value.length) {
      const z = L_((N = n.value) == null ? void 0 : N.nodes, T).map((L) => L.key);
      z.length !== l.value.length && (l.value = z);
    }
  }
  let b = null;
  function _() {
    b !== null && clearTimeout(b), b = null;
  }
  function w() {
    _(), b = setTimeout(() => {
      b = null, x("change");
    }, F4);
  }
  let k = 0;
  async function x(T, N, z = {}) {
    var U, S, F, I, G, Y;
    if (!n.value) return;
    const L = T !== "change";
    if (L) {
      if (_(), i.value) return;
      i.value = !0;
    }
    const B = ++k;
    r.value = "";
    const O = (U = e.paths) == null ? void 0 : U.call(e);
    try {
      const ie = await e.api.pluginViewEvent(e.plugin, e.view, {
        path: (S = e.path) == null ? void 0 : S.call(e),
        ...O != null && O.length ? { paths: [...O] } : {},
        state: ((F = n.value) == null ? void 0 : F.state) ?? {},
        event: T,
        action_id: N,
        // ⚠⚠ The values a HIDDEN field holds are dropped here, not blanked
        // (v3 §2.1: "a value belonging to a hidden field is dropped before
        // the job runs — it cannot arrive as a surprise"). The plugin is
        // re-asked the same question by the host at submit; this is the
        // client half of the same promise, and it also keeps a `change`
        // event from echoing back a field the step no longer shows.
        data: { values: B4((I = n.value) == null ? void 0 : I.nodes, a.value), ...z }
      });
      if (!L && B !== k) return;
      if (ie.op) {
        t.onOp(ie.op), t.onDone();
        return;
      }
      const me = ie.surface;
      if (!me) {
        r.value = e.errorText();
        return;
      }
      const q = Gt(me.toast, e.locale());
      q && t.onToast(q);
      const C = rp(me.open) ? me.open : null;
      if (me.done) {
        t.onDone(), C && ((G = t.onOpen) == null || G.call(t, C));
        return;
      }
      m(me, !L), C && ((Y = t.onOpen) == null || Y.call(t, C));
    } catch (ie) {
      if (!L && B !== k) return;
      r.value = Vi(e.locale(), String((ie == null ? void 0 : ie.message) ?? ie)) || e.errorText();
    } finally {
      L && (i.value = !1);
    }
  }
  function M(T) {
    var N;
    if (i.value || T.disabled) return Promise.resolve();
    if (T.primary) {
      const z = L_((N = n.value) == null ? void 0 : N.nodes, a.value);
      if (l.value = z.map((L) => L.key), z.length) return Promise.resolve();
    }
    return x(T.primary ? "submit" : "action", T.id);
  }
  function A(T) {
    return x("action", T.action_id, { row_id: T.row_id });
  }
  return bl() && Ot(_), {
    current: n,
    values: a,
    busy: i,
    failure: r,
    footer: d,
    errors: f,
    invalidKeys: l,
    setSurface: m,
    updateValues: v,
    scheduleChange: w,
    post: x,
    press: M,
    rowAction: A,
    dispose: _
  };
}
const cf = ["draw", "type", "upload"], U4 = 200 * 1024, uS = 600, cS = 200, H4 = 480, K4 = 160, R_ = "#111111", Iv = Jx;
function dS(e) {
  return typeof e == "string" && cf.includes(e);
}
function V4(e) {
  if (!Array.isArray(e)) return [...cf];
  const t = e.filter(dS);
  return t.length ? cf.filter((n) => t.includes(n)) : [...cf];
}
function Cu(e) {
  const t = e;
  return !!t && typeof t == "object" && typeof t.png_b64 == "string" && t.png_b64 !== "" && dS(t.mode);
}
function j4(e) {
  const t = e;
  return t && tc(t.font) ? t.font : Iv;
}
function q4(e, t) {
  const n = Number(e), a = Number(t);
  return {
    width: Number.isFinite(n) && n > 0 ? Math.min(uS, Math.max(120, Math.round(n))) : H4,
    height: Number.isFinite(a) && a > 0 ? Math.min(cS, Math.max(60, Math.round(a))) : K4
  };
}
function W4(e, t, n, a) {
  if (!(e > 0) || !(t > 0)) return { width: n, height: a };
  const i = Math.min(1, n / e, a / t);
  return { width: Math.max(1, Math.round(e * i)), height: Math.max(1, Math.round(t * i)) };
}
function Y4(e) {
  const t = e.indexOf("base64,");
  return t >= 0 ? e.slice(t + 7) : e;
}
function G4(e) {
  return e.type !== "image/png" && e.type !== "image/jpeg" ? "bad_type" : e.size > U4 ? "too_big" : "ok";
}
function X4(e, t, n) {
  let a = Math.min(96, Math.floor(n * 0.6));
  for (; a > 12 && e(a) > t; ) a -= 2;
  return a;
}
const J4 = 44;
function Z4(e, t, n, a) {
  const i = t.height - e.bottom - 8, r = e.top - 8, l = Math.min(320, a * J4 + 8), d = i < Math.min(l, 160) && r > i, f = Math.min(Math.max(e.width, 180), t.width - 16), m = pc(Ar(e, n), f, t.width, n);
  return {
    top: Math.round(e.bottom + 4),
    bottom: Math.round(t.height - e.top + 4),
    start: Math.round(n === "rtl" ? t.width - m - f : m),
    width: Math.round(f),
    maxHeight: Math.round(Math.max(120, Math.min(320, d ? r : i))),
    up: d
  };
}
const Q4 = ["id", "disabled", "aria-expanded", "aria-activedescendant", "aria-label", "aria-labelledby", "aria-describedby", "aria-required", "aria-invalid", "data-testid", "data-value"], e5 = ["name", "value", "required", "disabled"], t5 = ["dir", "aria-labelledby", "data-testid"], n5 = ["id", "aria-selected", "aria-disabled", "data-value", "data-testid", "onMousemove", "onClick"], a5 = { class: "fe-select__label" }, i5 = { class: "fe-select__text" }, o5 = {
  key: 0,
  class: "fe-select__help"
}, nc = /* @__PURE__ */ lt({
  __name: "ChoiceSelect",
  props: {
    modelValue: { default: null },
    options: {},
    id: { default: void 0 },
    name: { default: void 0 },
    placeholder: { default: "" },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    size: { default: "md" },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    requiredMessage: { default: "" },
    testid: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "invalid"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, r = `fe-sel-${Math.random().toString(36).slice(2, 10)}`, l = E(() => a.id ?? r), d = `${r}-list`, f = (H) => `${r}-opt-${H}`, m = $(!1), v = $(-1), b = $(null), _ = $(null), w = $(null), k = $(null), x = $({
      top: 0,
      bottom: 0,
      start: 0,
      width: 0,
      maxHeight: 280,
      up: !1,
      z: Ty,
      dir: "ltr"
    }), M = $({}), A = $(!1);
    let T = "", N = 0;
    const z = (H) => H == null || H === "", L = E(() => a.options.findIndex((H) => H.value === a.modelValue)), B = E(() => a.options[L.value]), O = E(() => {
      var H;
      return ((H = B.value) == null ? void 0 : H.label) ?? a.placeholder;
    }), U = E(() => a.invalid || A.value), S = E(() => a.required || !!a.name);
    function F() {
      var H;
      (H = w.value) == null || H.setCustomValidity(a.required && z(a.modelValue) ? a.requiredMessage || " " : "");
    }
    Xe(
      () => a.modelValue,
      (H) => {
        z(H) || (A.value = !1), Zt(F);
      },
      { immediate: !0 }
    ), Xe(() => a.required, () => void Zt(F)), Xe(
      () => a.disabled,
      (H) => {
        H && re(!1);
      }
    );
    function I(H, X) {
      const we = a.options.length;
      for (let it = 0, Re = H; it < we; it++, Re += X) {
        if (Re < 0 || Re >= we) return -1;
        if (!a.options[Re].disabled) return Re;
      }
      return -1;
    }
    const G = [
      "--fe-bg",
      "--fe-bg-hover",
      "--fe-border",
      "--fe-text",
      "--fe-text-muted",
      "--fe-primary",
      "--fe-primary-ink",
      "--fe-radius",
      "--fe-radius-sm",
      "--fe-shadow",
      "--fe-text-xs"
    ];
    function Y(H) {
      const X = {};
      try {
        const we = window.getComputedStyle(H);
        for (const it of G) {
          const Re = we.getPropertyValue(it).trim();
          Re && (X[it] = Re);
        }
        we.fontFamily && (X["font-family"] = we.fontFamily), we.fontSize && (X["font-size"] = we.fontSize);
      } catch {
      }
      return X;
    }
    function ie() {
      const H = b.value;
      if (!H) return;
      const X = Ga(H), we = Z4(
        H.getBoundingClientRect(),
        { width: window.innerWidth, height: window.innerHeight },
        X,
        a.options.length
      );
      x.value = { ...we, z: x.value.z, dir: X };
    }
    function me(H) {
      var we, it;
      const X = H.target;
      !X || (we = b.value) != null && we.contains(X) || (it = _.value) != null && it.contains(X) || re(!1);
    }
    function q(H) {
      H ? (window.addEventListener("resize", ie), window.addEventListener("scroll", ie, !0), document.addEventListener("pointerdown", me, !0)) : (window.removeEventListener("resize", ie), window.removeEventListener("scroll", ie, !0), document.removeEventListener("pointerdown", me, !0));
    }
    async function C(H) {
      if (a.disabled || m.value) return;
      const X = b.value;
      k.value = (X == null ? void 0 : X.closest("dialog[open]")) ?? document.body, X && (M.value = Y(X), x.value = { ...x.value, z: yc(X) }), ie(), m.value = !0, v.value = H ?? (L.value >= 0 ? L.value : I(0, 1)), q(!0), await Zt(), V();
    }
    function re(H = !0) {
      var X;
      m.value && (m.value = !1, T = "", q(!1), H && ((X = b.value) == null || X.focus()));
    }
    function de(H, X = !0) {
      const we = a.options[H];
      !we || we.disabled || (we.value !== a.modelValue && (i("update:modelValue", we.value), i("change", we.value)), re(X));
    }
    function V() {
      const H = document.getElementById(f(v.value));
      H && typeof H.scrollIntoView == "function" && H.scrollIntoView({ block: "nearest" });
    }
    function W(H) {
      H < 0 || (v.value = H, Zt(V));
    }
    function ne(H) {
      const X = Date.now();
      T = X - N > 600 ? H : T + H, N = X;
      const we = a.options.length, it = T.length > 1 ? Math.max(v.value, 0) : v.value + 1, Re = T.toLocaleLowerCase();
      for (let Be = 0; Be < we; Be++) {
        const We = (it + Be + we) % we, bt = a.options[We];
        if (!bt.disabled && bt.label.toLocaleLowerCase().startsWith(Re)) return We;
      }
      return -1;
    }
    function K(H) {
      if (a.disabled) return;
      const X = H.key;
      if (!m.value) {
        if (X === "ArrowDown" || X === "ArrowUp" || X === "Enter" || X === " ")
          H.preventDefault(), C();
        else if (X === "Home" || X === "End")
          H.preventDefault(), C(X === "Home" ? I(0, 1) : I(a.options.length - 1, -1));
        else if (X.length === 1 && !H.ctrlKey && !H.metaKey && !H.altKey) {
          const we = ne(X);
          we >= 0 && C(we);
        }
        return;
      }
      switch (X) {
        case "ArrowDown":
          if (H.preventDefault(), H.altKey) return;
          W(I(v.value + 1, 1));
          return;
        case "ArrowUp":
          if (H.preventDefault(), H.altKey) return de(v.value);
          W(I(v.value - 1, -1));
          return;
        case "Home":
          H.preventDefault(), W(I(0, 1));
          return;
        case "End":
          H.preventDefault(), W(I(a.options.length - 1, -1));
          return;
        case "PageDown":
          H.preventDefault(), W(I(Math.min(v.value + 10, a.options.length - 1), -1));
          return;
        case "PageUp":
          H.preventDefault(), W(I(Math.max(v.value - 10, 0), 1));
          return;
        case "Enter":
        case " ":
          H.preventDefault(), de(v.value);
          return;
        case "Escape":
          H.preventDefault(), H.stopPropagation(), re();
          return;
        case "Tab":
          de(v.value, !1);
          return;
      }
      if (X.length === 1 && !H.ctrlKey && !H.metaKey && !H.altKey) {
        const we = ne(X);
        we >= 0 && W(we);
      }
    }
    function ce() {
      m.value ? re() : C();
    }
    function J(H) {
      var we, it;
      H.preventDefault(), A.value = !0, i("invalid", H);
      const X = ((we = w.value) == null ? void 0 : we.form) ?? null;
      if (X) {
        if (X.dataset.fxInvalidFocus) return;
        X.dataset.fxInvalidFocus = "1", queueMicrotask(() => {
          delete X.dataset.fxInvalidFocus;
        });
      }
      (it = b.value) == null || it.focus();
    }
    return Ot(() => q(!1)), t({ focus: () => {
      var H;
      return (H = b.value) == null ? void 0 : H.focus();
    }, open: C, close: re }), (H, X) => (p(), h("span", {
      class: Fe(["fe-select", [
        e.size !== "md" ? `fe-select--${e.size}` : "",
        { "is-open": m.value, "is-disabled": e.disabled, "is-invalid": U.value }
      ]])
    }, [
      c("button", {
        id: l.value,
        ref_key: "trigger",
        ref: b,
        type: "button",
        class: "fe-select__trigger",
        role: "combobox",
        disabled: e.disabled,
        "aria-haspopup": "listbox",
        "aria-expanded": m.value ? "true" : "false",
        "aria-controls": d,
        "aria-activedescendant": m.value && v.value >= 0 ? f(v.value) : void 0,
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        "aria-describedby": e.ariaDescribedby,
        "aria-required": e.required ? "true" : void 0,
        "aria-invalid": U.value ? "true" : void 0,
        "data-testid": e.testid,
        "data-value": e.modelValue ?? "",
        onClick: ce,
        onKeydown: K,
        onKeyup: X[0] || (X[0] = $a(vt(() => {
        }, ["prevent"]), ["space"]))
      }, [
        c("span", {
          class: Fe(["fe-select__value", { "is-placeholder": !B.value }])
        }, y(O.value), 3),
        tt(u(zz), {
          class: "fe-select__chev",
          "aria-hidden": "true"
        })
      ], 40, Q4),
      S.value ? (p(), h("input", {
        key: 0,
        ref_key: "hidden",
        ref: w,
        class: "fe-select__native",
        tabindex: "-1",
        "aria-hidden": "true",
        name: e.name,
        value: e.modelValue ?? "",
        required: e.required,
        disabled: e.disabled,
        onInvalid: J
      }, null, 40, e5)) : D("", !0),
      m.value && k.value ? (p(), Je(hi, {
        key: 1,
        to: k.value
      }, [
        c("ul", {
          id: d,
          ref_key: "panel",
          ref: _,
          class: Fe(["fe-select__panel", { "is-up": x.value.up }]),
          dir: x.value.dir,
          role: "listbox",
          "aria-labelledby": e.ariaLabelledby ?? l.value,
          style: Yt([
            M.value,
            {
              insetInlineStart: x.value.start + "px",
              width: x.value.width + "px",
              maxHeight: x.value.maxHeight + "px",
              top: x.value.up ? void 0 : x.value.top + "px",
              bottom: x.value.up ? x.value.bottom + "px" : void 0,
              zIndex: x.value.z
            }
          ]),
          "data-testid": e.testid ? `${e.testid}-list` : void 0,
          onMousedown: X[1] || (X[1] = vt(() => {
          }, ["prevent"]))
        }, [
          (p(!0), h(Ce, null, ot(e.options, (we, it) => (p(), h("li", {
            id: f(it),
            key: String(we.value),
            class: Fe(["fe-select__option", { "is-active": it === v.value, "is-selected": we.value === e.modelValue }]),
            role: "option",
            "aria-selected": we.value === e.modelValue ? "true" : "false",
            "aria-disabled": we.disabled ? "true" : void 0,
            "data-value": we.value,
            "data-testid": e.testid ? `${e.testid}-option-${we.value === "" ? "none" : we.value}` : void 0,
            onMousemove: (Re) => !we.disabled && (v.value = it),
            onClick: (Re) => de(it)
          }, [
            c("span", a5, [
              c("span", i5, y(we.label), 1),
              we.help ? (p(), h("span", o5, y(we.help), 1)) : D("", !0)
            ]),
            we.value === e.modelValue ? (p(), Je(u(Mz), {
              key: 0,
              class: "fe-select__check",
              "aria-hidden": "true"
            })) : D("", !0)
          ], 42, n5))), 128))
        ], 46, t5)
      ], 8, ["to"])) : D("", !0)
    ], 2));
  }
}), r5 = { class: "fe-cfield" }, s5 = {
  key: 0,
  class: "fe-cfield__empty"
}, l5 = {
  key: 0,
  class: "fe-cfield__check"
}, u5 = ["checked", "disabled", "onChange"], c5 = ["for"], d5 = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, f5 = ["id", "value", "placeholder", "disabled", "onInput"], p5 = {
  key: 5,
  class: "fe-cfield__secret"
}, h5 = ["id", "type", "value", "placeholder", "disabled", "onInput"], m5 = ["title", "aria-label", "onClick"], v5 = ["innerHTML"], y5 = ["id", "type", "value", "placeholder", "min", "max", "disabled", "onInput"], g5 = {
  key: 7,
  class: "fe-cfield__help"
}, b5 = {
  key: 8,
  class: "fe-cfield__error"
}, k5 = {
  key: 1,
  class: "fe-cfield__adv"
}, w5 = {
  key: 0,
  class: "fe-cfield__advbody"
}, _5 = {
  key: 0,
  class: "fe-cfield__check"
}, x5 = ["checked", "disabled", "onChange"], S5 = ["for"], $5 = ["id", "type", "value", "placeholder", "disabled", "onInput"], T5 = {
  key: 2,
  class: "fe-cfield__help"
}, A5 = {
  key: 3,
  class: "fe-cfield__error"
}, E5 = /* @__PURE__ */ lt({
  __name: "StorageFields",
  props: {
    fields: {},
    modelValue: {},
    locale: {},
    invalid: {},
    errors: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(!1), l = $({}), d = E(() => n.fields.filter((S) => !S.advanced)), f = E(() => n.fields.filter((S) => S.advanced));
    function m(S) {
      const F = i(S.i18n_key);
      return F === S.i18n_key ? S.label : F;
    }
    function v(S) {
      if (!S.help_i18n_key) return S.help ?? "";
      const F = i(S.help_i18n_key);
      return F === S.help_i18n_key ? S.help ?? "" : F;
    }
    function b(S) {
      if (!S.i18n_key) return S.label;
      const F = i(S.i18n_key);
      return F === S.i18n_key ? S.label : F;
    }
    function _(S, F) {
      a("update:modelValue", { ...n.modelValue, [S]: F });
    }
    function w(S) {
      var I, G;
      const F = (I = n.modelValue) == null ? void 0 : I[S.key];
      if (F != null) return F;
      for (const Y of S.aliases ?? []) {
        const ie = (G = n.modelValue) == null ? void 0 : G[Y];
        if (ie != null) return ie;
      }
      return S.default ?? void 0;
    }
    function k(S) {
      const F = w(S);
      return F == null ? "" : String(F);
    }
    function x(S) {
      const F = w(S);
      return F === "" || F === void 0 || F === null ? "" : String(F);
    }
    function M(S) {
      return w(S) === !0;
    }
    function A(S) {
      var F;
      return (n.invalid ?? []).includes(S.key) || !!((F = n.errors) != null && F[S.key]);
    }
    function T(S) {
      var F;
      return ((F = n.errors) == null ? void 0 : F[S.key]) || (A(S) ? i("conn.form.required") : "");
    }
    function N(S) {
      if (S.type === "bool") {
        const F = (S.options ?? []).filter((Y) => Y.value === "true" || Y.value === "false"), I = F.find((Y) => Y.value === "true"), G = F.find((Y) => Y.value === "false");
        return [
          { value: "true", label: I ? b(I) : i("conn.form.yes") },
          { value: "false", label: G ? b(G) : i("conn.form.no") }
        ];
      }
      return (S.options ?? []).map((F) => ({ value: F.value, label: b(F) }));
    }
    function z(S) {
      const F = w(S);
      return S.type === "bool" ? F === !0 || F === "true" ? "true" : F === !1 || F === "false" ? "false" : "" : S.multi ? Array.isArray(F) ? F.map((I) => String(I)) : F == null || F === "" ? [] : [String(F)] : F == null ? "" : String(F);
    }
    function L(S, F) {
      if (S.type === "bool") {
        _(S.key, F === "true");
        return;
      }
      _(S.key, F);
    }
    function B(S) {
      return S.choice === !0 && (S.type === "select" || S.type === "bool");
    }
    function O(S) {
      return S.type === "int" ? "number" : S.type === "password" && !l.value[S.key] ? "password" : "text";
    }
    function U(S) {
      l.value = { ...l.value, [S]: !l.value[S] };
    }
    return (S, F) => (p(), h("div", r5, [
      e.fields.length ? D("", !0) : (p(), h("p", s5, y(u(i)("conn.form.noFields")), 1)),
      (p(!0), h(Ce, null, ot(d.value, (I) => (p(), h("div", {
        key: I.key,
        class: Fe(["fe-cfield__row", { "is-invalid": A(I) }])
      }, [
        I.type === "bool" && !B(I) ? (p(), h("label", l5, [
          c("input", {
            type: "checkbox",
            checked: M(I),
            disabled: e.disabled,
            onChange: (G) => _(I.key, G.target.checked)
          }, null, 40, u5),
          c("span", null, y(m(I)), 1)
        ])) : (p(), h("label", {
          key: 1,
          class: "fe-cfield__label",
          for: `fe-cf-${I.key}`
        }, [
          Ht(y(m(I)), 1),
          I.required ? (p(), h("span", d5, "*")) : D("", !0)
        ], 8, c5)),
        B(I) ? (p(), Je(ui, {
          key: 2,
          options: N(I),
          "model-value": z(I),
          multi: I.multi === !0,
          disabled: e.disabled,
          invalid: A(I),
          "aria-label": m(I),
          "testid-prefix": `fe-choice-${I.key}`,
          "onUpdate:modelValue": (G) => L(I, G)
        }, null, 8, ["options", "model-value", "multi", "disabled", "invalid", "aria-label", "testid-prefix", "onUpdate:modelValue"])) : I.type === "select" ? (p(), Je(nc, {
          key: 3,
          id: `fe-cf-${I.key}`,
          "model-value": k(I),
          options: N(I),
          disabled: e.disabled,
          invalid: A(I),
          "onUpdate:modelValue": (G) => _(I.key, String(G))
        }, null, 8, ["id", "model-value", "options", "disabled", "invalid", "onUpdate:modelValue"])) : I.multiline ? (p(), h("textarea", {
          key: 4,
          id: `fe-cf-${I.key}`,
          class: Fe(["fe-cfield__input fe-cfield__input--area", { "fe-cfield__input--mono": I.monospace }]),
          rows: "4",
          value: k(I),
          placeholder: I.placeholder,
          disabled: e.disabled,
          onInput: (G) => _(I.key, G.target.value)
        }, null, 42, f5)) : I.type === "password" ? (p(), h("div", p5, [
          c("input", {
            id: `fe-cf-${I.key}`,
            class: "fe-cfield__input fe-cfield__input--mono",
            type: O(I),
            autocomplete: "new-password",
            spellcheck: "false",
            value: k(I),
            placeholder: I.placeholder,
            disabled: e.disabled,
            onInput: (G) => _(I.key, G.target.value)
          }, null, 40, h5),
          c("button", {
            type: "button",
            class: "fe-cfield__eye",
            title: l.value[I.key] ? u(i)("conn.form.hide") : u(i)("conn.form.reveal"),
            "aria-label": l.value[I.key] ? u(i)("conn.form.hide") : u(i)("conn.form.reveal"),
            onClick: (G) => U(I.key)
          }, [
            c("span", {
              "aria-hidden": "true",
              innerHTML: u(zt)(l.value[I.key] ? "toggle-hidden" : "preview")
            }, null, 8, v5)
          ], 8, m5)
        ])) : I.type !== "bool" ? (p(), h("input", {
          key: 6,
          id: `fe-cf-${I.key}`,
          class: Fe(["fe-cfield__input", { "fe-cfield__input--mono": I.monospace }]),
          type: O(I),
          value: I.type === "int" ? x(I) : k(I),
          placeholder: I.placeholder,
          min: I.min,
          max: I.max,
          disabled: e.disabled,
          onInput: (G) => _(
            I.key,
            I.type === "int" ? G.target.value === "" ? null : Number(G.target.value) : G.target.value
          )
        }, null, 42, y5)) : D("", !0),
        v(I) ? (p(), h("p", g5, y(v(I)), 1)) : D("", !0),
        T(I) ? (p(), h("p", b5, y(T(I)), 1)) : D("", !0)
      ], 2))), 128)),
      f.value.length ? (p(), h("div", k5, [
        c("button", {
          type: "button",
          class: "fe-cfield__advtoggle",
          onClick: F[0] || (F[0] = (I) => r.value = !r.value)
        }, y(r.value ? "▾" : "▸") + " " + y(u(i)("conn.form.advanced")), 1),
        r.value ? (p(), h("div", w5, [
          (p(!0), h(Ce, null, ot(f.value, (I) => (p(), h("div", {
            key: I.key,
            class: "fe-cfield__row"
          }, [
            I.type === "bool" ? (p(), h("label", _5, [
              c("input", {
                type: "checkbox",
                checked: M(I),
                disabled: e.disabled,
                onChange: (G) => _(I.key, G.target.checked)
              }, null, 40, x5),
              c("span", null, y(m(I)), 1)
            ])) : (p(), h(Ce, { key: 1 }, [
              c("label", {
                class: "fe-cfield__label",
                for: `fe-cfa-${I.key}`
              }, y(m(I)), 9, S5),
              c("input", {
                id: `fe-cfa-${I.key}`,
                class: Fe(["fe-cfield__input", { "fe-cfield__input--mono": I.monospace }]),
                type: O(I),
                value: I.type === "int" ? x(I) : k(I),
                placeholder: I.placeholder,
                disabled: e.disabled,
                onInput: (G) => _(
                  I.key,
                  I.type === "int" ? G.target.value === "" ? null : Number(G.target.value) : G.target.value
                )
              }, null, 42, $5)
            ], 64)),
            v(I) ? (p(), h("p", T5, y(v(I)), 1)) : D("", !0),
            T(I) ? (p(), h("p", A5, y(T(I)), 1)) : D("", !0)
          ]))), 128))
        ])) : D("", !0)
      ])) : D("", !0)
    ]));
  }
}), C5 = {
  class: "fe-surface__form",
  "data-testid": "surface-form"
}, z5 = /* @__PURE__ */ lt({
  __name: "SurfaceForm",
  props: {
    fields: {},
    values: {},
    locale: {},
    errors: {},
    disabled: { type: Boolean },
    invalid: {}
  },
  emits: ["update:values"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Jy(n.fields, n.values)), r = E(
      () => i.value.map((d) => ({ ...L4(d, n.locale), required: sS(d, n.values) }))
    ), l = E(() => {
      var f;
      const d = {};
      for (const m of r.value) {
        const v = Gt((f = n.errors) == null ? void 0 : f[m.key], n.locale);
        v && (d[m.key] = v);
      }
      return d;
    });
    return (d, f) => (p(), h("div", C5, [
      tt(E5, {
        fields: r.value,
        "model-value": e.values,
        locale: e.locale,
        errors: l.value,
        invalid: e.invalid,
        disabled: e.disabled,
        "onUpdate:modelValue": f[0] || (f[0] = (m) => a("update:values", m))
      }, null, 8, ["fields", "model-value", "locale", "errors", "invalid", "disabled"])
    ]));
  }
}), M5 = ["aria-label"], P5 = ["aria-current", "data-step"], O5 = {
  class: "fe-steps__marker",
  "aria-hidden": "true"
}, D5 = {
  key: 0,
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  focusable: "false"
}, L5 = { class: "fe-steps__label" }, R5 = /* @__PURE__ */ lt({
  __name: "SurfaceSteps",
  props: {
    items: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = yt(() => t.locale);
    function a(i) {
      return i === "done" || i === "active" ? i : "todo";
    }
    return (i, r) => (p(), h("ol", {
      class: "fe-steps",
      "aria-label": u(n)("plugin.steps.label"),
      "data-testid": "surface-steps"
    }, [
      (p(!0), h(Ce, null, ot(e.items ?? [], (l, d) => (p(), h("li", {
        key: l.id || d,
        class: Fe(["fe-steps__item", `is-${a(l.state)}`]),
        "aria-current": a(l.state) === "active" ? "step" : void 0,
        "data-step": l.id
      }, [
        c("span", O5, [
          a(l.state) === "done" ? (p(), h("svg", D5, [...r[0] || (r[0] = [
            c("path", { d: "M4.8 12.6l4.7 4.7L19.2 6.9" }, null, -1)
          ])])) : (p(), h(Ce, { key: 1 }, [
            Ht(y(d + 1), 1)
          ], 64))
        ]),
        c("span", L5, y(u(Gt)(l.label, e.locale)), 1)
      ], 10, P5))), 128))
    ], 8, M5));
  }
});
let Sm = null;
function fS() {
  return Sm || (Sm = fL("t")), Sm;
}
function Zy() {
  const e = fS().get();
  return e && typeof e == "object" && !Array.isArray(e) ? e : {};
}
function pS(e, t) {
  const n = Zy(), a = { ...n[e] ?? {} };
  for (const [r, l] of Object.entries(t))
    l === void 0 ? delete a[r] : a[r] = l;
  const i = { ...n };
  Object.keys(a).length ? i[e] = a : delete i[e], fS().set(i);
}
function N5(e) {
  return {
    get: () => {
      var t;
      return (t = Zy()[e]) == null ? void 0 : t.c;
    },
    set: (t) => {
      var a;
      const n = Object.keys(t.w).length > 0 || t.hidden.length > 0 || (((a = t.o) == null ? void 0 : a.length) ?? 0) > 0;
      pS(e, { c: n ? t : void 0 });
    }
  };
}
function I5(e) {
  var n;
  const t = (n = Zy()[e]) == null ? void 0 : n.s;
  return !t || typeof t.k != "string" || t.d !== "asc" && t.d !== "desc" ? null : { key: t.k, dir: t.d };
}
function B5(e, t) {
  pS(e, { s: t ? { k: t.key, d: t.dir } : void 0 });
}
const $m = "data-fe-cut-title";
function N_(e) {
  const t = e;
  return t.scrollWidth > t.clientWidth;
}
function F5(e) {
  return (e.textContent ?? "").replace(/\s+/g, " ").trim();
}
function U5(e, t) {
  if (!t || typeof Element > "u" || !(e instanceof Element)) return;
  const n = e.closest(".tbl-pill");
  if (!n || !t.contains(n)) return;
  const a = n.getAttribute($m), i = n.getAttribute("title");
  if (i !== null && i !== a) return;
  const r = Array.from(n.querySelectorAll(".tbl-pill__text")), l = N_(n) || r.some(N_), d = F5(n);
  l && d ? (n.setAttribute("title", d), n.setAttribute($m, d)) : a !== null && (n.removeAttribute("title"), n.removeAttribute($m));
}
const H5 = ["aria-checked", "aria-label", "title"], Qy = /* @__PURE__ */ lt({
  __name: "ItemCheck",
  props: {
    on: { type: Boolean },
    label: {}
  },
  setup(e) {
    return (t, n) => (p(), h("button", {
      type: "button",
      class: Fe(["fe-list__check", { "is-on": e.on }]),
      role: "checkbox",
      "aria-checked": e.on ? "true" : "false",
      "aria-label": e.label,
      title: e.label,
      onMousedown: n[0] || (n[0] = vt(() => {
      }, ["prevent"]))
    }, null, 42, H5));
  }
}), K5 = ["disabled", "data-testid"], V5 = /* @__PURE__ */ lt({
  __name: "RowActions",
  props: {
    actions: {},
    locale: { default: "en" },
    label: {},
    disabled: { type: Boolean },
    theme: {},
    testid: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, dir: r } = yt(() => n.locale), l = $(
      null
    ), d = E(() => n.label || i("row.actions")), f = E(
      () => n.actions.filter((_) => !_.hidden).map((_) => ({
        ..._,
        shortcutId: _.shortcutId ?? "",
        testid: _.testid ?? (n.testid ? `${n.testid}-${_.key}` : void 0)
      }))
    ), m = E(() => f.value.some((_) => !_.divider && !_.disabled));
    function v(_) {
      var k, x;
      const w = (k = _.currentTarget) == null ? void 0 : k.getBoundingClientRect();
      (x = l.value) == null || x.show(
        // ⚠ RTL: the START corner (right in RTL), as ListView `onRowMenu` does.
        { clientX: w ? Ar(w, r.value) : _.clientX, clientY: w ? w.bottom : _.clientY },
        []
      );
    }
    function b(_) {
      a("select", _.key, _);
    }
    return (_, w) => (p(), h("div", {
      class: "tbl-rowactions",
      onClick: w[0] || (w[0] = vt(() => {
      }, ["stop"]))
    }, [
      c("button", {
        type: "button",
        class: "tbl-rowactions__btn",
        disabled: e.disabled || !m.value,
        "data-testid": e.testid,
        "data-fe-control": "",
        "aria-haspopup": "menu",
        onClick: vt(v, ["stop"])
      }, [
        c("span", null, y(d.value), 1),
        w[1] || (w[1] = c("span", {
          class: "tbl-rowactions__caret",
          "aria-hidden": "true"
        }, "▾", -1))
      ], 8, K5),
      tt(rl, {
        ref_key: "menu",
        ref: l,
        locale: e.locale,
        theme: e.theme,
        actions: f.value,
        onSelect: b
      }, null, 8, ["locale", "theme", "actions"])
    ]));
  }
}), j5 = {
  key: 0,
  class: "tbl-bar"
}, q5 = {
  key: 1,
  class: "fe-list__refreshing",
  role: "status"
}, W5 = { class: "fe-sr-only" }, Y5 = ["aria-label", "aria-busy", "data-table-id"], G5 = {
  key: 0,
  class: "fe-list__col fe-list__col--check",
  role: "columnheader"
}, X5 = ["aria-sort", "data-col"], J5 = ["disabled", "title"], Z5 = { class: "fe-list__sort-label" }, Q5 = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, eR = ["title"], tR = ["aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-label", "title"], nR = ["aria-sort", "aria-label", "data-col", "onPointerdown", "onKeydown"], aR = ["disabled", "title", "onClick"], iR = { class: "fe-list__sort-label" }, oR = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, rR = ["title"], sR = ["aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-label", "title", "onPointerdown", "onDblclick", "onKeydown"], lR = ["title", "aria-label", "aria-expanded"], uR = ["role"], cR = {
  key: 0,
  class: "fe-list__group",
  role: "presentation"
}, dR = ["aria-selected", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], fR = ["onClick"], pR = ["title"], hR = { class: "fe-list__cell-text" }, mR = ["data-col", "data-label", "title"], vR = { class: "fe-list__cell-text" }, yR = {
  key: 0,
  class: "fe-list__empty fe-list__empty--loading",
  role: "row"
}, gR = ["aria-colspan"], bR = {
  key: 1,
  class: "fe-list__empty",
  role: "row"
}, kR = ["aria-colspan"], wR = {
  key: 2,
  class: "tbl-foot"
}, _R = {
  key: 0,
  class: "tbl-pager"
}, xR = ["disabled", "aria-label", "title"], SR = {
  class: "tbl-pager__at",
  dir: "ltr"
}, $R = ["disabled", "aria-label", "title"], TR = ["dir", "data-prefers-dark"], AR = ["aria-label", "onKeydown"], ER = { class: "fe-colmenu__title" }, CR = ["aria-checked", "onClick"], zR = { class: "fe-colmenu__label" }, MR = ["disabled", "title", "aria-label", "onClick"], PR = { "aria-hidden": "true" }, OR = ["disabled", "title", "aria-label", "onClick"], DR = { "aria-hidden": "true" }, LR = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, RR = { class: "fe-colmenu__label" }, Tm = 8, Ms = 12, I_ = 28, NR = 160, IR = 160, BR = 5, FR = 300, Vr = /* @__PURE__ */ lt({
  inheritAttrs: !1,
  __name: "DataTable",
  props: {
    rows: {},
    columns: {},
    rowKey: { type: [String, Function], default: void 0 },
    tableId: { default: void 0 },
    columnStore: { default: void 0 },
    candidates: { default: void 0 },
    metrics: { default: void 0 },
    locale: { default: void 0 },
    theme: { default: void 0 },
    loading: { type: Boolean },
    empty: { default: void 0 },
    ariaLabel: { default: void 0 },
    selectable: { type: Boolean },
    isSelected: { type: Function, default: void 0 },
    sort: { default: void 0 },
    sortClosed: { default: void 0 },
    groups: { default: void 0 },
    rowClass: { type: Function, default: void 0 },
    rowAttrs: { type: Function, default: void 0 },
    rowActions: { type: Function, default: void 0 },
    rowActionsTestId: { type: Function, default: void 0 },
    actionsWidth: { default: void 0 },
    framed: { type: Boolean, default: !0 },
    page: { default: void 0 },
    pageSize: { default: void 0 },
    total: { default: void 0 },
    pages: { default: void 0 },
    footNote: { default: void 0 }
  },
  emits: ["sort", "row-click", "row-dblclick", "row-contextmenu", "check-click", "row-action", "row-dragstart", "row-dragover", "row-dragleave", "row-drop", "row-touchstart", "row-touchend", "row-touchmove", "page"],
  setup(e, { expose: t, emit: n }) {
    var Bn;
    const a = e, i = n, r = SL(), l = E(() => a.locale ?? (r == null ? void 0 : r.locale.value) ?? "en"), d = E(() => {
      var se;
      return a.theme ?? ((se = r == null ? void 0 : r.theme) == null ? void 0 : se.value);
    }), { t: f, dir: m } = yt(() => l.value), v = E(() => {
      const se = /* @__PURE__ */ new Map();
      for (const ye of a.columns) se.set(ye.id, ye);
      return se;
    }), b = E(() => {
      var se;
      return ((se = a.columns.find((ye) => ye.lead) ?? a.columns[0]) == null ? void 0 : se.id) ?? "";
    }), _ = E(
      () => a.columns.map((se) => {
        const ye = se.id === b.value, Pe = se.width ?? (ye ? 240 : 140);
        return {
          id: se.id,
          width: Pe,
          min: Math.min(se.min ?? (ye ? 120 : 56), Pe),
          max: Math.max(se.max ?? 900, Pe),
          hideable: ye ? !1 : se.hideable !== !1,
          resizable: se.resizable !== !1
        };
      })
    ), w = wx(
      () => _.value,
      a.tableId ? N5(a.tableId) : QD(),
      { lead: b.value }
    ), k = E(() => a.columnStore ?? w), x = E(
      () => (a.candidates ?? a.columns.map((se) => se.id)).filter((se) => se !== k.value.lead)
    ), M = I_ + Ms, A = E(() => a.actionsWidth ?? (a.rowActions ? 92 : 28)), T = E(() => ({
      gap: Tm,
      padding: Ms * 2,
      check: a.selectable ? I_ : 0,
      menu: A.value,
      ...a.metrics ?? {}
    })), N = $(null), z = $(0);
    let L = null, B = 0, O = 0;
    const U = $(!1), S = $(!1);
    function F(se) {
      if (!se) return;
      const ye = se.scrollWidth - se.clientWidth - Math.abs(se.scrollLeft) > 1;
      ye !== S.value && (S.value = ye);
    }
    function I(se) {
      const ye = se.currentTarget, Pe = Math.abs((ye == null ? void 0 : ye.scrollLeft) ?? 0) > 0;
      Pe !== U.value && (U.value = Pe), F(ye);
    }
    Xe(
      N,
      (se) => {
        L == null || L.disconnect(), L = null, O && cancelAnimationFrame(O), O = 0, !(!se || typeof ResizeObserver > "u") && (L = new ResizeObserver((ye) => {
          var ut, Pn;
          B = ((Pn = (ut = ye[0]) == null ? void 0 : ut.contentRect) == null ? void 0 : Pn.width) ?? 0, !O && (O = requestAnimationFrame(() => {
            O = 0, Math.abs(B - z.value) >= 1 && (z.value = B);
          }));
        }), L.observe(se));
      },
      { flush: "post" }
    );
    const G = E(() => k.value.layout(z.value, x.value, T.value)), Y = E(() => G.value.visible), ie = E(() => z.value > 0 && z.value < G.value.stackBelow);
    Xe(
      [() => G.value.total, z, ie],
      () => F(N.value),
      { flush: "post" }
    ), Xe(ie, (se) => {
      se && (U.value = !1);
    });
    const me = (se, { slots: ye }) => {
      var Pe, ut;
      return se.on ? yz("div", { class: "fe-list__stack-value" }, (Pe = ye.default) == null ? void 0 : Pe.call(ye)) : (ut = ye.default) == null ? void 0 : ut.call(ye);
    };
    me.props = ["on"];
    function q(se) {
      var ye;
      return ie.value && ((ye = v.value.get(se)) == null ? void 0 : ye.headerLabel) !== !1;
    }
    const C = E(() => {
      if (!ie.value) return null;
      const se = Y.value.filter((ye) => {
        var Pe;
        return ((Pe = v.value.get(ye)) == null ? void 0 : Pe.headerLabel) !== !1;
      });
      return se.length ? se[se.length - 1] : null;
    });
    function re(se) {
      U5(se.target, N.value);
    }
    const de = E(() => ie.value ? void 0 : { width: `${G.value.total}px` }), V = E(
      () => (a.selectable ? M + Tm : Ms) + (G.value.widths[k.value.lead] ?? k.value.width(k.value.lead))
    ), W = E(
      () => !ie.value && z.value > 0 && z.value - V.value >= NR
    ), ne = E(() => A.value + Ms), K = E(
      () => !ie.value && (z.value <= 0 || z.value - V.value - ne.value >= IR)
    ), ce = E(() => ({
      "--fe-list-lead": a.selectable ? `${M + Tm}px` : "0px"
    }));
    function J(se) {
      if (ie.value) return;
      let ye = G.value.widths[se] ?? k.value.width(se);
      return se === k.value.lead && W.value && !a.selectable && (ye += Ms), { flex: `0 0 ${ye}px` };
    }
    const H = E(
      () => ie.value || A.value === 28 ? void 0 : { flex: `0 0 ${A.value + Ms}px` }
    );
    function X(se) {
      const ye = v.value.get(se), Pe = ["fe-list__col", "fe-list__cell"];
      return ye != null && ye.class && Pe.push(ye.class), se === k.value.lead && Pe.push("fe-list__col--lead"), (ye == null ? void 0 : ye.align) === "right" ? Pe.push("is-right") : (ye == null ? void 0 : ye.align) === "center" && Pe.push("is-center"), Pe;
    }
    function we(se) {
      var ye;
      return ((ye = v.value.get(se)) == null ? void 0 : ye.label) ?? se;
    }
    const it = E(() => a.sort !== void 0), Re = $(
      a.tableId ? I5(a.tableId) : null
    ), Be = E(() => it.value ? a.sort ?? null : Re.value), We = E(
      () => (a.pages ?? 1) > 1 || a.total != null && a.total > a.rows.length
    ), bt = E(() => a.sortClosed ? a.sortClosed : !it.value && We.value ? f("table.sort_paged") : null);
    function at(se) {
      var ye;
      return ((ye = v.value.get(se)) == null ? void 0 : ye.sortable) === !0;
    }
    function Ie(se) {
      if (bt.value || !at(se)) return;
      const ye = Be.value, Pe = v.value.get(se), ut = ye && ye.key === se ? { key: se, dir: ye.dir === "asc" ? "desc" : "asc" } : { key: se, dir: (Pe == null ? void 0 : Pe.sortDir) ?? "asc" };
      it.value || (Re.value = ut, a.tableId && B5(a.tableId, ut)), i("sort", ut);
    }
    function nt(se) {
      const ye = Be.value;
      return bt.value || !ye || ye.key !== se ? "" : ye.dir === "asc" ? "↑" : "↓";
    }
    function dt(se) {
      if (!at(se)) return;
      const ye = Be.value;
      return bt.value || !ye || ye.key !== se ? "none" : ye.dir === "asc" ? "ascending" : "descending";
    }
    function Me(se) {
      return bt.value ?? f("cols.sort_by", { col: we(se) });
    }
    function be(se, ye) {
      const Pe = v.value.get(ye);
      return Pe != null && Pe.sortValue ? Pe.sortValue(se) : Pe != null && Pe.format ? Pe.format(se) : se == null ? void 0 : se[ye];
    }
    function Ve(se, ye) {
      const Pe = se == null || se === "", ut = ye == null || ye === "";
      return Pe && ut ? 0 : Pe ? 1 : ut ? -1 : typeof se == "number" && typeof ye == "number" ? se - ye : typeof se == "boolean" && typeof ye == "boolean" ? Number(se) - Number(ye) : String(se).localeCompare(String(ye), l.value, { numeric: !0, sensitivity: "base" });
    }
    const Te = E(() => {
      const se = Be.value;
      if (it.value || bt.value || !se || !v.value.has(se.key)) return a.rows;
      const ye = se.dir === "asc" ? 1 : -1;
      return a.rows.map((Pe, ut) => ({ row: Pe, i: ut, v: be(Pe, se.key) })).sort((Pe, ut) => {
        const Pn = Pe.v === null || Pe.v === void 0 || Pe.v === "", Mt = ut.v === null || ut.v === void 0 || ut.v === "";
        return Pn !== Mt ? Pn ? 1 : -1 : ye * Ve(Pe.v, ut.v) || Pe.i - ut.i;
      }).map((Pe) => Pe.row);
    }), qe = E(() => a.groups ?? [{ id: "all", items: Te.value }]), De = vz(), mt = E(() => a.empty === void 0 ? f("table.empty") : a.empty ?? ""), $t = E(() => !a.loading && xe.value === 0 && (!!De.empty || mt.value !== "")), kt = E(() => xe.value > 0 || a.loading && xe.value === 0 || $t.value), Tt = E(() => Y.value.length + 2 + (a.selectable ? 1 : 0)), xe = E(() => qe.value.reduce((se, ye) => se + ye.items.length, 0));
    function Ne(se, ye) {
      return typeof a.rowKey == "function" ? a.rowKey(se) : a.rowKey ? se == null ? void 0 : se[a.rowKey] : ye;
    }
    function fe(se) {
      return a.isSelected ? a.isSelected(se) : !1;
    }
    function Se(se, ye) {
      return se == null ? void 0 : se[ye];
    }
    function Z(se, ye) {
      const Pe = v.value.get(ye), ut = Pe != null && Pe.format ? Pe.format(se) : se == null ? void 0 : se[ye];
      return ut == null || ut === "" ? "-" : String(ut);
    }
    function ge(se, ye) {
      const Pe = v.value.get(ye);
      if (Pe != null && Pe.title) return Pe.title(se);
      const ut = Z(se, ye);
      return ut === "-" ? void 0 : ut;
    }
    function ae(se, ye) {
      var Pe;
      return [
        "fe-list__row",
        { "is-selected": fe(se), "is-clickable": !!ve.value },
        (Pe = a.rowClass) == null ? void 0 : Pe.call(a, se, ye)
      ];
    }
    const ve = $(!1);
    let le = null;
    function _e() {
      k.value.widthsAreAuto() && k.value.freeze(G.value.widths);
    }
    function Ee(se) {
      var ye;
      return ((ye = k.value.spec(se)) == null ? void 0 : ye.resizable) === !0;
    }
    function ht(se) {
      return Math.round(G.value.widths[se] ?? k.value.width(se));
    }
    function jt(se) {
      var ye;
      return (ye = k.value.spec(se)) == null ? void 0 : ye.min;
    }
    function tn(se) {
      var ye;
      return (ye = k.value.spec(se)) == null ? void 0 : ye.max;
    }
    function Cn(se, ye) {
      Ee(se) && (ye.preventDefault(), ye.stopPropagation(), _e(), le = { id: se, startX: ye.clientX, startW: k.value.width(se), sign: nv(Ga(N.value)) }, window.addEventListener("pointermove", Lt), window.addEventListener("pointerup", At));
    }
    function Lt(se) {
      le && k.value.setWidth(le.id, le.startW + le.sign * (se.clientX - le.startX));
    }
    function At() {
      le = null, window.removeEventListener("pointermove", Lt), window.removeEventListener("pointerup", At);
    }
    function zn(se, ye) {
      if (ye.ctrlKey || ye.metaKey) return;
      const Pe = 16 * wf(ye.key, Ga(N.value));
      Pe && (ye.preventDefault(), _e(), k.value.setWidth(se, k.value.width(se) + Pe));
    }
    function Bt(se) {
      const ye = k.value.spec(se);
      ye && (_e(), k.value.setWidth(se, ye.width));
    }
    let ft = null;
    const Dn = $(null), Qn = $(null);
    let Ln = 0;
    function on(se) {
      var ye;
      return se !== k.value.lead && ((ye = k.value.spec(se)) == null ? void 0 : ye.hideable) === !0;
    }
    function In(se, ye) {
      ye.button !== 0 || !on(se) || ie.value || (ft = { id: se, startX: ye.clientX, armed: !1 }, window.addEventListener("pointermove", nn), window.addEventListener("pointerup", ln), window.addEventListener("keydown", pe, !0), window.addEventListener("pointercancel", la), window.addEventListener("blur", la));
    }
    function la() {
      const se = (ft == null ? void 0 : ft.armed) === !0;
      Le(), se && (Ln = Date.now());
    }
    function vn() {
      const se = Y.value;
      let ye = 0;
      for (; ye < se.length && !on(se[ye]); ) ye++;
      let Pe = se.length;
      for (; Pe > ye && !on(se[Pe - 1]); ) Pe--;
      return { first: ye, last: Pe };
    }
    function nn(se) {
      var aa;
      if (!ft) return;
      if (!ft.armed) {
        if (Math.abs(se.clientX - ft.startX) < BR) return;
        ft.armed = !0, Dn.value = ft.id;
      }
      const ye = (aa = N.value) == null ? void 0 : aa.querySelector(".fe-list__head");
      if (!ye) return;
      const Pe = Array.from(ye.children).filter((mn) => mn.classList.contains("fe-list__col")), ut = a.selectable ? 2 : 1, Pn = Pe.slice(ut, ut + Y.value.length), Mt = nv(Ga(N.value));
      let yn = Pn.length;
      for (let mn = 0; mn < Pn.length; mn++) {
        const Tl = Pn[mn].getBoundingClientRect();
        if (Mt * (se.clientX - (Tl.left + Tl.width / 2)) < 0) {
          yn = mn;
          break;
        }
      }
      const { first: Ra, last: Yi } = vn();
      yn = Math.max(Ra, Math.min(Yi, yn));
      const yi = Y.value.indexOf(ft.id);
      Qn.value = yn === yi || yn === yi + 1 ? null : yn;
    }
    function ln() {
      const se = ft, ye = Qn.value;
      Le(), se != null && se.armed && (Ln = Date.now(), ye != null && kn(se.id, ye));
    }
    function kn(se, ye) {
      const Pe = Y.value, ut = Pe.indexOf(se);
      if (ut === -1 || ye === ut || ye === ut + 1) return;
      const Mt = Pe.filter((Yi) => Yi !== se)[ye > ut ? ye - 1 : ye], yn = k.value.order().filter((Yi) => Yi !== se), Ra = Mt ? yn.indexOf(Mt) : yn.length;
      Ra !== -1 && k.value.move(se, Ra);
    }
    function Mn() {
      return k.value.order().filter((se) => on(se) && x.value.includes(se));
    }
    function Hn(se, ye) {
      const Pe = Mn(), ut = Pe.indexOf(se), Pn = ut + ye;
      if (ut === -1 || Pn < 0 || Pn >= Pe.length) return;
      const Mt = Pe[Pn], Ra = k.value.order().filter((Yi) => Yi !== se).indexOf(Mt);
      Ra !== -1 && k.value.move(se, ye === -1 ? Ra : Ra + 1);
    }
    function rn(se, ye) {
      const Pe = Mn(), ut = Pe.indexOf(se);
      return ut !== -1 && ut + ye >= 0 && ut + ye < Pe.length;
    }
    function Ea(se, ye) {
      if (!ye.ctrlKey && !ye.metaKey) return;
      const Pe = wf(ye.key, Ga(N.value));
      !Pe || !on(se) || (ye.preventDefault(), ye.stopPropagation(), Hn(se, Pe));
    }
    function pe(se) {
      se.key === "Escape" && (se.stopPropagation(), la());
    }
    function Le() {
      ft = null, Dn.value = null, Qn.value = null, window.removeEventListener("pointermove", nn), window.removeEventListener("pointerup", ln), window.removeEventListener("keydown", pe, !0), window.removeEventListener("pointercancel", la), window.removeEventListener("blur", la);
    }
    function Ue(se) {
      Date.now() - Ln > FR || (Ln = 0, se.preventDefault(), se.stopPropagation());
    }
    const He = $(!1), wt = $(0), et = $(0);
    let oe = 0;
    const je = $(null), Ke = xl(), _t = E(() => `fe-ctx-backdrop--theme-${d.value || "auto"}`), ee = E(
      () => m.value === "rtl" ? { earlier: { key: "cols.move_right", arrow: "→" }, later: { key: "cols.move_left", arrow: "←" } } : { earlier: { key: "cols.move_left", arrow: "←" }, later: { key: "cols.move_right", arrow: "→" } }
    ), he = E(
      () => (
        /* In the person's OWN order, so the list reads as the table on screen. */
        k.value.order().filter((se) => on(se) && x.value.includes(se)).map((se) => ({
          id: se,
          label: we(se),
          on: !k.value.hidden(se),
          canEarlier: rn(se, -1),
          canLater: rn(se, 1)
        }))
      )
    ), Oe = E(() => k.value.customised());
    async function Ye(se) {
      var ut;
      se.preventDefault(), se.stopPropagation();
      const ye = se.currentTarget, Pe = ye == null ? void 0 : ye.getBoundingClientRect();
      oe = se.clientX || (Pe ? Ar(Pe, m.value) : 0), wt.value = oe, et.value = se.clientY || (Pe ? Pe.bottom : 0), He.value = !0, await Zt(), rt(), (ut = je.value) == null || ut.focus();
    }
    function rt() {
      const se = je.value;
      if (!se) return;
      const ye = se.getBoundingClientRect(), Pe = 8;
      wt.value = pc(oe, ye.width, window.innerWidth, m.value, Pe), ye.bottom > window.innerHeight - Pe && (et.value = Math.max(Pe, window.innerHeight - Pe - ye.height));
    }
    function St() {
      He.value = !1;
    }
    function Q(se) {
      se.key === "Escape" && (se.stopPropagation(), St());
    }
    Xe(He, (se) => {
      typeof window > "u" || (se ? window.addEventListener("keydown", Q, !0) : window.removeEventListener("keydown", Q, !0));
    });
    function te(se) {
      k.value.setHidden(se, !k.value.hidden(se));
    }
    function ke() {
      k.value.reset();
    }
    Ot(() => {
      L == null || L.disconnect(), L = null, O && cancelAnimationFrame(O), O = 0, At(), Le(), typeof window < "u" && window.removeEventListener("keydown", Q, !0);
    });
    const Ge = E(() => a.pages != null ? Math.max(1, a.pages) : !a.total || !a.pageSize ? 1 : Math.max(1, Math.ceil(a.total / a.pageSize))), pt = E(() => a.page ?? 1), Rt = E(() => Ge.value > 1), Kt = E(() => {
      if (a.total != null && a.pageSize != null && a.total > 0) {
        const se = (pt.value - 1) * a.pageSize + 1, ye = Math.min(pt.value * a.pageSize, a.total);
        return `${se} - ${ye} / ${a.total}`;
      }
      return "";
    });
    function Ft(se) {
      se < 1 || se > Ge.value || i("page", se);
    }
    const dn = bl();
    ve.value = !!((Bn = dn == null ? void 0 : dn.vnode.props) != null && Bn.onRowClick);
    function Jt(se, ye) {
      i("row-click", se, ye);
    }
    function $n(se, ye, Pe) {
      i("row-action", se, ye, Pe);
    }
    return t({ store: k, layout: G, pinLead: W, stacked: ie }), (se, ye) => (p(), h(Ce, null, [
      c("div", Qm(se.$attrs, {
        class: ["fe-table", { "fe-table--framed": e.framed, "fe-table--bare": !e.framed }]
      }), [
        se.$slots.toolbar ? (p(), h("div", j5, [
          En(se.$slots, "toolbar")
        ])) : D("", !0),
        e.loading && xe.value > 0 ? (p(), h("div", q5, [
          c("span", W5, y(u(f)("loading")), 1)
        ])) : D("", !0),
        c("div", {
          ref_key: "listEl",
          ref: N,
          class: Fe(["fe-list", {
            "is-loading": e.loading,
            "is-scrolled-x": U.value,
            "is-more-end": S.value,
            "is-pin-lead": W.value,
            "is-pin-menu": K.value,
            "is-stacked": ie.value,
            "fe-list--nocheck": !e.selectable
          }]),
          style: Yt(ce.value),
          role: "grid",
          "aria-label": e.ariaLabel,
          "aria-busy": e.loading ? "true" : void 0,
          "data-table-id": e.tableId,
          onScrollPassive: I
        }, [
          c("div", {
            class: Fe(["fe-list__head", { "is-dragging-col": !!Dn.value }]),
            role: "row",
            style: Yt(de.value),
            onContextmenu: Ye,
            onClickCapture: Ue
          }, [
            e.selectable ? (p(), h("div", G5)) : D("", !0),
            c("div", {
              class: Fe(X(k.value.lead)),
              role: "columnheader",
              style: Yt(J(k.value.lead)),
              "aria-sort": dt(k.value.lead),
              "data-col": k.value.lead
            }, [
              at(k.value.lead) ? (p(), h("button", {
                key: 0,
                type: "button",
                class: "fe-list__sort",
                disabled: !!bt.value,
                title: Me(k.value.lead),
                onClick: ye[0] || (ye[0] = (Pe) => Ie(k.value.lead))
              }, [
                c("span", Z5, y(we(k.value.lead)), 1),
                nt(k.value.lead) ? (p(), h("span", Q5, y(nt(k.value.lead)), 1)) : D("", !0)
              ], 8, J5)) : (p(), h("span", {
                key: 1,
                class: "fe-list__head-label",
                title: we(k.value.lead)
              }, y(we(k.value.lead)), 9, eR)),
              Ee(k.value.lead) && !ie.value ? (p(), h("span", {
                key: 2,
                class: "fe-list__resize",
                role: "separator",
                "aria-orientation": "vertical",
                tabindex: "0",
                "aria-valuenow": ht(k.value.lead),
                "aria-valuemin": jt(k.value.lead),
                "aria-valuemax": tn(k.value.lead),
                "aria-label": u(f)("cols.resize", { col: we(k.value.lead) }),
                title: u(f)("cols.resize", { col: we(k.value.lead) }),
                onPointerdown: ye[1] || (ye[1] = (Pe) => Cn(k.value.lead, Pe)),
                onDblclick: ye[2] || (ye[2] = vt((Pe) => Bt(k.value.lead), ["stop"])),
                onKeydown: ye[3] || (ye[3] = (Pe) => zn(k.value.lead, Pe))
              }, null, 40, tR)) : D("", !0)
            ], 14, X5),
            (p(!0), h(Ce, null, ot(Y.value, (Pe, ut) => {
              var Pn, Mt;
              return p(), h("div", {
                key: Pe,
                class: Fe([
                  X(Pe),
                  {
                    "is-col-dragging": Dn.value === Pe,
                    "is-drop-before": Qn.value === ut,
                    "is-drop-after": Qn.value === Y.value.length && ut === Y.value.length - 1,
                    "is-movable": on(Pe) && !ie.value
                  }
                ]),
                role: "columnheader",
                style: Yt(J(Pe)),
                "aria-sort": dt(Pe),
                "aria-label": ((Pn = v.value.get(Pe)) == null ? void 0 : Pn.headerLabel) === !1 ? we(Pe) : void 0,
                "data-col": Pe,
                onPointerdown: (yn) => In(Pe, yn),
                onKeydown: (yn) => Ea(Pe, yn)
              }, [
                at(Pe) ? (p(), h("button", {
                  key: 0,
                  type: "button",
                  class: "fe-list__sort",
                  disabled: !!bt.value,
                  title: Me(Pe),
                  onClick: (yn) => Ie(Pe)
                }, [
                  c("span", iR, y(we(Pe)), 1),
                  nt(Pe) ? (p(), h("span", oR, y(nt(Pe)), 1)) : D("", !0)
                ], 8, aR)) : ((Mt = v.value.get(Pe)) == null ? void 0 : Mt.headerLabel) !== !1 ? (p(), h("span", {
                  key: 1,
                  class: "fe-list__head-label",
                  title: we(Pe)
                }, y(we(Pe)), 9, rR)) : D("", !0),
                Ee(Pe) && !ie.value ? (p(), h("span", {
                  key: 2,
                  class: "fe-list__resize",
                  role: "separator",
                  "aria-orientation": "vertical",
                  tabindex: "0",
                  "aria-valuenow": ht(Pe),
                  "aria-valuemin": jt(Pe),
                  "aria-valuemax": tn(Pe),
                  "aria-label": u(f)("cols.resize", { col: we(Pe) }),
                  title: u(f)("cols.resize", { col: we(Pe) }),
                  onPointerdown: (yn) => Cn(Pe, yn),
                  onDblclick: vt((yn) => Bt(Pe), ["stop"]),
                  onKeydown: (yn) => zn(Pe, yn)
                }, null, 40, sR)) : D("", !0)
              ], 46, nR);
            }), 128)),
            c("div", {
              class: Fe(["fe-list__col fe-list__col--menu", { "is-wide": A.value !== 28 }]),
              style: Yt(H.value),
              role: "columnheader"
            }, [
              c("button", {
                type: "button",
                class: "fe-list__menu fe-list__colmenu-btn",
                title: u(f)("cols.menu"),
                "aria-label": u(f)("cols.menu"),
                "aria-haspopup": "dialog",
                "aria-expanded": He.value ? "true" : "false",
                onClick: Ye
              }, [...ye[12] || (ye[12] = [
                c("span", { "aria-hidden": "true" }, "⋮", -1)
              ])], 8, lR)
            ], 6)
          ], 38),
          c("div", {
            class: "fe-list__body",
            role: kt.value ? "rowgroup" : "presentation",
            onPointerover: re
          }, [
            (p(!0), h(Ce, null, ot(qe.value, (Pe) => (p(), h(Ce, {
              key: Pe.id
            }, [
              Pe.label ? (p(), h("div", cR, y(Pe.label), 1)) : D("", !0),
              (p(!0), h(Ce, null, ot(Pe.items, (ut, Pn) => (p(), h("div", Qm({
                key: Ne(ut, Pn),
                class: ae(ut, Pn),
                role: "row",
                style: de.value,
                "aria-selected": e.selectable ? fe(ut) ? "true" : "false" : void 0
              }, { ref_for: !0 }, e.rowAttrs ? e.rowAttrs(ut) : {}, {
                onClick: (Mt) => Jt(ut, Mt),
                onDblclick: (Mt) => i("row-dblclick", ut, Mt),
                onContextmenu: (Mt) => i("row-contextmenu", ut, Mt),
                onDragstart: (Mt) => i("row-dragstart", ut, Mt),
                onDragover: (Mt) => i("row-dragover", ut, Mt),
                onDragleave: (Mt) => i("row-dragleave", ut, Mt),
                onDrop: (Mt) => i("row-drop", ut, Mt),
                onTouchstartPassive: (Mt) => i("row-touchstart", ut, Mt),
                onTouchend: ye[7] || (ye[7] = (Mt) => i("row-touchend", Mt)),
                onTouchmovePassive: ye[8] || (ye[8] = (Mt) => i("row-touchmove", Mt))
              }), [
                e.selectable ? (p(), h("div", {
                  key: 0,
                  class: "fe-list__col fe-list__col--check",
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: vt((Mt) => i("check-click", ut, Mt), ["stop"]),
                  onDblclick: ye[4] || (ye[4] = vt(() => {
                  }, ["stop"]))
                }, [
                  tt(Qy, {
                    on: fe(ut),
                    label: Z(ut, k.value.lead)
                  }, null, 8, ["on", "label"])
                ], 40, fR)) : D("", !0),
                c("div", {
                  class: Fe(X(k.value.lead)),
                  role: "gridcell",
                  style: Yt(J(k.value.lead)),
                  title: se.$slots[`cell-${k.value.lead}`] ? void 0 : ge(ut, k.value.lead)
                }, [
                  En(se.$slots, `cell-${k.value.lead}`, {
                    row: ut,
                    value: Se(ut, k.value.lead)
                  }, () => [
                    c("span", hR, [
                      c("bdi", null, y(Z(ut, k.value.lead)), 1)
                    ])
                  ])
                ], 14, pR),
                (p(!0), h(Ce, null, ot(Y.value, (Mt) => (p(), h("div", {
                  key: Mt,
                  class: Fe([
                    X(Mt),
                    { "is-stack-fact": q(Mt), "is-stack-last": C.value === Mt, "is-stack-tail": ie.value && !q(Mt) }
                  ]),
                  role: "gridcell",
                  style: Yt(J(Mt)),
                  "data-col": Mt,
                  "data-label": q(Mt) ? we(Mt) : void 0,
                  title: se.$slots[`cell-${Mt}`] ? void 0 : ge(ut, Mt)
                }, [
                  tt(me, {
                    on: q(Mt)
                  }, {
                    default: gt(() => [
                      En(se.$slots, `cell-${Mt}`, {
                        row: ut,
                        value: Se(ut, Mt)
                      }, () => [
                        c("span", vR, [
                          c("bdi", null, y(Z(ut, Mt)), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["on"])
                ], 14, mR))), 128)),
                c("div", {
                  class: Fe(["fe-list__col fe-list__col--menu", { "is-wide": A.value !== 28 }]),
                  style: Yt(H.value),
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: ye[5] || (ye[5] = vt(() => {
                  }, ["stop"])),
                  onDblclick: ye[6] || (ye[6] = vt(() => {
                  }, ["stop"]))
                }, [
                  En(se.$slots, "actions", { row: ut }, () => {
                    var Mt;
                    return [
                      e.rowActions && e.rowActions(ut).length ? (p(), Je(V5, {
                        key: 0,
                        locale: l.value,
                        theme: d.value,
                        actions: e.rowActions(ut),
                        testid: (Mt = e.rowActionsTestId) == null ? void 0 : Mt.call(e, ut),
                        onSelect: (yn, Ra) => $n(yn, ut, Ra)
                      }, null, 8, ["locale", "theme", "actions", "testid", "onSelect"])) : D("", !0)
                    ];
                  })
                ], 38)
              ], 16, dR))), 128))
            ], 64))), 128)),
            e.loading && xe.value === 0 ? (p(), h("div", yR, [
              c("div", {
                role: "gridcell",
                "aria-colspan": Tt.value,
                "aria-live": "polite"
              }, y(u(f)("loading")), 9, gR)
            ])) : $t.value ? (p(), h("div", bR, [
              c("div", {
                role: "gridcell",
                "aria-colspan": Tt.value
              }, [
                En(se.$slots, "empty", {}, () => [
                  Ht(y(mt.value), 1)
                ])
              ], 8, kR)
            ])) : D("", !0)
          ], 40, uR)
        ], 46, Y5),
        Rt.value || e.footNote || se.$slots.foot ? (p(), h("div", wR, [
          c("span", null, [
            En(se.$slots, "foot", {}, () => [
              Ht(y(e.footNote || Kt.value), 1)
            ])
          ]),
          Rt.value ? (p(), h("div", _R, [
            c("button", {
              type: "button",
              class: "tbl-page",
              disabled: pt.value <= 1,
              "aria-label": u(f)("table.prev"),
              title: u(f)("table.prev"),
              onClick: ye[9] || (ye[9] = (Pe) => Ft(pt.value - 1))
            }, "‹", 8, xR),
            c("span", SR, y(pt.value) + " / " + y(Ge.value), 1),
            c("button", {
              type: "button",
              class: "tbl-page",
              disabled: pt.value >= Ge.value,
              "aria-label": u(f)("table.next"),
              title: u(f)("table.next"),
              onClick: ye[10] || (ye[10] = (Pe) => Ft(pt.value + 1))
            }, "›", 8, $R)
          ])) : D("", !0)
        ])) : D("", !0)
      ], 16),
      (p(), Je(hi, { to: "body" }, [
        He.value ? (p(), h("div", {
          key: 0,
          class: Fe(["fe-colmenu__backdrop", _t.value]),
          dir: u(m),
          "data-prefers-dark": u(Ke) ? "1" : "0",
          onClick: St,
          onContextmenu: vt(St, ["prevent"])
        }, [
          c("div", {
            ref_key: "colMenuEl",
            ref: je,
            class: "fe-colmenu",
            role: "dialog",
            tabindex: "-1",
            "aria-label": u(f)("cols.menu"),
            style: Yt({ top: et.value + "px", left: wt.value + "px" }),
            onClick: ye[11] || (ye[11] = vt(() => {
            }, ["stop"])),
            onKeydown: $a(vt(St, ["stop"]), ["esc"])
          }, [
            c("p", ER, y(u(f)("cols.title")), 1),
            (p(!0), h(Ce, null, ot(he.value, (Pe) => (p(), h("div", {
              key: Pe.id,
              class: "fe-colmenu__line"
            }, [
              c("button", {
                type: "button",
                class: "fe-colmenu__row",
                role: "checkbox",
                "aria-checked": Pe.on ? "true" : "false",
                onClick: (ut) => te(Pe.id)
              }, [
                c("span", {
                  class: Fe(["fe-list__check fe-colmenu__tick", { "is-on": Pe.on }]),
                  "aria-hidden": "true"
                }, null, 2),
                c("span", zR, y(Pe.label), 1)
              ], 8, CR),
              c("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !Pe.canEarlier,
                title: u(f)(ee.value.earlier.key, { col: Pe.label }),
                "aria-label": u(f)(ee.value.earlier.key, { col: Pe.label }),
                onClick: (ut) => Hn(Pe.id, -1)
              }, [
                c("span", PR, y(ee.value.earlier.arrow), 1)
              ], 8, MR),
              c("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !Pe.canLater,
                title: u(f)(ee.value.later.key, { col: Pe.label }),
                "aria-label": u(f)(ee.value.later.key, { col: Pe.label }),
                onClick: (ut) => Hn(Pe.id, 1)
              }, [
                c("span", DR, y(ee.value.later.arrow), 1)
              ], 8, OR)
            ]))), 128)),
            Oe.value ? (p(), h("div", LR)) : D("", !0),
            Oe.value ? (p(), h("button", {
              key: 1,
              type: "button",
              class: "fe-colmenu__row",
              onClick: ke
            }, [
              c("span", RR, y(u(f)("cols.reset")), 1)
            ])) : D("", !0),
            En(se.$slots, "colmenu-extra", { close: St })
          ], 44, AR)
        ], 42, TR)) : D("", !0)
      ]))
    ], 64));
  }
});
function UR(e, t, n, a) {
  if (!e || t !== "date" && t !== "datetime") return e;
  const i = kM(e, n);
  if (i) return i;
  const r = Date.parse(e.trim());
  return Number.isNaN(r) ? e : a(r, { time: t === "datetime" }) || e;
}
const HR = {
  class: "fe-slist",
  "data-testid": "surface-list"
}, KR = /* @__PURE__ */ lt({
  __name: "SurfaceList",
  props: {
    columns: {},
    rows: {},
    empty: {},
    locale: {},
    disabled: { type: Boolean },
    tableId: {}
  },
  emits: ["action"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r } = yt(() => n.locale), l = E(() => n.rows ?? []), d = E(() => l.value.some((_) => (_.actions ?? []).length > 0)), f = E(() => Sy(n.empty, n.locale, () => i("plugin.list.empty")));
    function m(_, w) {
      var k;
      return Gt((k = _.cells) == null ? void 0 : k[w], n.locale);
    }
    const v = E(
      () => (n.columns ?? []).map((_) => {
        const w = typeof _.width == "number" && Number.isFinite(_.width) ? Math.round(_.width) : void 0;
        return {
          id: _.key,
          label: Gt(_.label, n.locale),
          width: w === void 0 ? void 0 : Math.min(900, Math.max(60, w)),
          align: _.align,
          sortable: _.sortable !== !1,
          // A date column is printed the explorer's way, and sorted by the value.
          format: (k) => UR(m(k, _.key), _.format, n.locale, r),
          sortValue: (k) => {
            var M;
            const x = (M = k.sort) == null ? void 0 : M[_.key];
            return typeof x == "number" || typeof x == "string" ? x : m(k, _.key);
          }
        };
      })
    );
    function b(_) {
      return (_.actions ?? []).map((w) => ({
        key: w.id,
        label: Gt(w.label, n.locale),
        danger: w.danger,
        disabled: n.disabled,
        testid: `surface-list-action-${_.id}-${w.id}`
      }));
    }
    return (_, w) => (p(), h("div", HR, [
      tt(Vr, {
        "table-id": e.tableId,
        columns: v.value,
        rows: l.value,
        "row-key": "id",
        locale: e.locale,
        empty: f.value,
        "row-attrs": (k) => ({ "data-row": k.id }),
        "row-actions": d.value ? b : void 0,
        "row-actions-test-id": (k) => (k.actions ?? []).length ? `surface-list-actions-${k.id}` : void 0,
        onRowAction: w[0] || (w[0] = (k, x) => a("action", { action_id: k, row_id: x.id }))
      }, null, 8, ["table-id", "columns", "rows", "locale", "empty", "row-attrs", "row-actions", "row-actions-test-id"])
    ]));
  }
}), VR = {
  class: "fe-sprogress",
  "data-testid": "surface-progress"
}, jR = { class: "fe-sprogress__head" }, qR = { class: "fe-sprogress__label" }, WR = {
  key: 0,
  class: "fe-sprogress__pct"
}, YR = ["aria-label", "aria-valuenow"], GR = /* @__PURE__ */ lt({
  __name: "SurfaceProgress",
  props: {
    value: {},
    label: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = yt(() => t.locale), a = E(() => {
      const r = t.value;
      return r == null || !Number.isFinite(Number(r)) ? null : Math.min(100, Math.max(0, Math.round(Number(r))));
    }), i = E(() => Sy(t.label, t.locale, () => n("plugin.view.busy")));
    return (r, l) => (p(), h("div", VR, [
      c("div", jR, [
        c("span", qR, y(i.value), 1),
        a.value !== null ? (p(), h("span", WR, y(a.value) + "%", 1)) : D("", !0)
      ]),
      c("div", {
        class: Fe(["fe-sprogress__track", { "is-indeterminate": a.value === null }]),
        role: "progressbar",
        "aria-label": i.value,
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuenow": a.value === null ? void 0 : a.value
      }, [
        c("div", {
          class: "fe-sprogress__bar",
          style: Yt(a.value === null ? void 0 : { width: `${a.value}%` })
        }, null, 4)
      ], 10, YR)
    ]));
  }
}), hS = ",،、，", XR = ";؛；", B_ = /* @__PURE__ */ new Map();
function JR(e) {
  const t = `${e.spaces ? 1 : 0}${e.semicolons ? 1 : 0}${e.newlines ? 1 : 0}`;
  let n = B_.get(t);
  if (!n) {
    const a = hS + (e.semicolons ? XR : "") + (e.newlines ? "\\n\\r" : "") + (e.spaces ? "\\s" : "");
    n = new RegExp(`[${a}]+`, "u"), B_.set(t, n);
  }
  return n;
}
function ZR(e, t = {}) {
  return String(e ?? "").split(JR(t)).map((n) => n.trim()).filter((n) => n !== "");
}
function QR(e) {
  return e.length === 1 && hS.includes(e);
}
const eN = {
  key: 0,
  class: "fe-speople__chips",
  "data-testid": "surface-people-chips"
}, tN = ["title"], nN = {
  class: "fe-speople__av",
  "aria-hidden": "true"
}, aN = { class: "fe-speople__name" }, iN = ["disabled", "title", "aria-label", "data-testid", "onClick"], oN = {
  key: 1,
  class: "fe-speople__addwrap"
}, rN = ["placeholder", "disabled", "aria-invalid"], sN = ["disabled"], lN = {
  key: 1,
  class: "fe-share__suggest fe-speople__suggest",
  "data-testid": "surface-people-suggest"
}, uN = ["onMousedown"], cN = { class: "fe-share__av fe-share__av--sm" }, dN = { class: "fe-share__suggesttxt" }, fN = { class: "fe-share__suggestname" }, pN = { class: "fe-share__suggestmeta" }, hN = {
  key: 2,
  class: "fe-surface__error",
  role: "alert"
}, mN = /* @__PURE__ */ lt({
  __name: "SurfacePeoplePicker",
  props: {
    id: {},
    modelValue: {},
    multi: { type: Boolean },
    allowExternal: { type: Boolean },
    api: {},
    plugin: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(""), l = $([]), d = $(!1), f = $(!n.api || !n.plugin), m = $("");
    let v = null, b = 0;
    const _ = E(() => n.modelValue ?? []), w = E(() => n.allowExternal === !0 || f.value), k = E(() => n.multi !== !0 && _.value.length >= 1);
    function x(O) {
      return _p({ name: O.name, email: O.email });
    }
    function M(O) {
      const U = String(O.email ?? "").trim().toLowerCase();
      if (!U) return;
      const S = n.multi === !0 ? _.value.filter((F) => F.email.toLowerCase() !== U) : [];
      a("update:modelValue", [...S, { ...O, email: U }]), r.value = "", l.value = [], d.value = !1, m.value = "";
    }
    function A(O) {
      a("update:modelValue", _.value.filter((U) => U.email !== O));
    }
    function T() {
      m.value = "";
      const O = r.value.trim();
      if (v && clearTimeout(v), !O || f.value) {
        l.value = [], d.value = !1;
        return;
      }
      v = setTimeout(() => void N(O), 180);
    }
    async function N(O) {
      if (!n.api || !n.plugin || f.value) return;
      const U = ++b;
      try {
        const S = await n.api.pluginUsers(n.plugin, O);
        if (U !== b) return;
        l.value = (S.users ?? []).filter((F) => F && typeof F.email == "string"), d.value = l.value.length > 0;
      } catch (S) {
        if (U !== b) return;
        const F = S == null ? void 0 : S.status;
        (F === 403 || F === 404) && (f.value = !0), l.value = [], d.value = !1;
      }
    }
    function z() {
      const O = r.value.trim();
      if (O) {
        if (!w.value) {
          m.value = i("plugin.people.external_off");
          return;
        }
        if (!R4(O)) {
          m.value = i("plugin.people.invalid_email");
          return;
        }
        M({ email: O });
      }
    }
    function L(O) {
      O.key === "Enter" || QR(O.key) ? (O.preventDefault(), z()) : O.key === "Backspace" && r.value === "" && _.value.length ? A(_.value[_.value.length - 1].email) : O.key === "Escape" && (d.value = !1);
    }
    function B() {
      setTimeout(() => {
        d.value = !1;
      }, 120);
    }
    return Xe(
      () => [n.api, n.plugin],
      ([O, U]) => {
        O && U && (f.value = !1);
      }
    ), Ot(() => {
      v && clearTimeout(v);
    }), (O, U) => (p(), h("div", {
      class: Fe(["fe-speople", { "is-invalid": e.invalid }]),
      "data-testid": "surface-people"
    }, [
      _.value.length ? (p(), h("ul", eN, [
        (p(!0), h(Ce, null, ot(_.value, (S) => (p(), h("li", {
          key: S.email,
          class: "fe-speople__chip",
          title: S.email
        }, [
          c("span", nN, y(x(S).charAt(0).toUpperCase()), 1),
          c("span", aN, y(x(S)), 1),
          c("button", {
            type: "button",
            class: "fe-speople__remove",
            disabled: e.disabled,
            title: u(i)("plugin.people.remove", { name: x(S) }),
            "aria-label": u(i)("plugin.people.remove", { name: x(S) }),
            "data-testid": `surface-people-remove-${S.email}`,
            onClick: (F) => A(S.email)
          }, [...U[1] || (U[1] = [
            c("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              c("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, iN)
        ], 8, tN))), 128))
      ])) : D("", !0),
      k.value ? D("", !0) : (p(), h("div", oN, [
        un(c("input", {
          "onUpdate:modelValue": U[0] || (U[0] = (S) => r.value = S),
          class: "fe-cfield__input fe-speople__input",
          type: "email",
          autocomplete: "off",
          spellcheck: "false",
          placeholder: f.value ? u(i)("plugin.people.placeholder_email") : u(i)("plugin.people.placeholder"),
          disabled: e.disabled,
          "aria-invalid": e.invalid ? "true" : void 0,
          "data-testid": "surface-people-input",
          onInput: T,
          onKeydown: L,
          onFocus: T,
          onBlur: B
        }, null, 40, rN), [
          [bn, r.value]
        ]),
        w.value ? (p(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--sm",
          disabled: e.disabled || !r.value.trim(),
          "data-testid": "surface-people-add",
          onClick: z
        }, y(u(i)("plugin.people.add")), 9, sN)) : D("", !0),
        d.value ? (p(), h("ul", lN, [
          (p(!0), h(Ce, null, ot(l.value, (S) => (p(), h("li", {
            key: S.user_id ?? S.email,
            onMousedown: vt((F) => M(S), ["prevent"])
          }, [
            c("span", cN, y(x(S).charAt(0).toUpperCase()), 1),
            c("span", dN, [
              c("span", fN, y(x(S)), 1),
              c("span", pN, y(S.email), 1)
            ])
          ], 40, uN))), 128))
        ])) : D("", !0)
      ])),
      m.value ? (p(), h("p", hN, y(m.value), 1)) : D("", !0)
    ], 2));
  }
}), vN = {
  class: "fe-spin",
  "data-testid": "surface-pin"
}, yN = ["for"], gN = ["id", "maxlength", "size", "value", "disabled", "aria-invalid"], bN = /* @__PURE__ */ lt({
  __name: "SurfacePinInput",
  props: {
    id: {},
    length: {},
    modelValue: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = E(() => {
      const d = Number(n.length);
      return Number.isInteger(d) && d > 0 ? d : void 0;
    });
    function l(d) {
      const f = d.target.value.replace(/\s+/g, "").slice(0, r.value);
      d.target.value = f, a("update:modelValue", f);
    }
    return (d, f) => (p(), h("div", vN, [
      c("label", {
        class: "fe-cfield__label",
        for: `fe-spin-${e.id}`
      }, y(u(i)("plugin.pin.label")), 9, yN),
      c("input", {
        id: `fe-spin-${e.id}`,
        class: Fe(["fe-cfield__input fe-cfield__input--mono fe-spin__input", { "is-invalid": e.invalid }]),
        type: "text",
        inputmode: "numeric",
        autocomplete: "one-time-code",
        spellcheck: "false",
        maxlength: r.value,
        size: r.value,
        value: e.modelValue,
        disabled: e.disabled,
        "aria-invalid": e.invalid ? "true" : void 0,
        style: Yt({ "--spin-len": r.value }),
        onInput: l
      }, null, 46, gN)
    ]));
  }
}), Yn = "@@drives";
function hl(e) {
  const t = e.indexOf("://");
  return t < 0 ? ["", Bv(e)] : [e.slice(0, t), Bv(e.slice(t + 3))];
}
function ml(e, t) {
  const n = Bv(t);
  return n ? `${e}://${n}` : `${e}://`;
}
function Bv(e) {
  return e.replace(/^\/+|\/+$/g, "");
}
function eg(e, t) {
  if (e === Yn) return null;
  const [n, a] = hl(e);
  if (!n) return null;
  if (!a) return t ? Yn : null;
  const i = a.split("/");
  return i.pop(), ml(n, i.join("/"));
}
function tl(e, t) {
  if (e === Yn) return t;
  const [n, a] = hl(e);
  if (!a) return n || t;
  const i = a.split("/");
  return i[i.length - 1] || n;
}
function kN(e) {
  if (e === Yn || !e) return [];
  const [t, n] = hl(e);
  if (!t) return [];
  const a = [{ label: t, path: ml(t, "") }];
  if (!n) return a;
  let i = "";
  for (const r of n.split("/"))
    i = i ? `${i}/${r}` : r, a.push({ label: r, path: ml(t, i) });
  return a;
}
function mS(e) {
  return e == null || e === "" || e === "editor" || e === "owner";
}
function tg(e, t) {
  if (e === Yn || t === Yn) return !1;
  const [n, a] = hl(e), [i, r] = hl(t);
  return n !== i ? !1 : r === "" ? !0 : a === r || a.startsWith(r + "/");
}
function ng(e, t) {
  if (!t || t.length === 0 || e === Yn) return null;
  const n = (i) => {
    const [r, l] = hl(i);
    return ml(r, l);
  }, a = n(e);
  for (const i of t)
    if (i) {
      if (a === n(i)) return "self";
      if (tg(e, i)) return "descendant";
    }
  return null;
}
function wN(e, t) {
  if (!e || e === Yn) return null;
  for (const n of t) if (n && tg(e, n)) return n;
  return null;
}
function vS(e, t, n) {
  if (!e || e === Yn) return null;
  const a = n(e);
  return t ? a === t ? null : "out" : a ? "into" : null;
}
function _N(e, t, n) {
  return vS(e, t, n) ? !(t && tg(t, e)) : !1;
}
function xN(e, t, n = {}) {
  const a = [];
  for (const i of e ?? []) {
    if (i.type !== "dir") {
      n.files && i.type === "file" && a.push({ path: i.path, label: i.basename, writable: !0, blocked: null, kind: "file" });
      continue;
    }
    a.push({
      path: i.path,
      label: i.basename,
      writable: mS(i.perm),
      blocked: ng(i.path, t),
      kind: "dir"
    });
  }
  return a;
}
function SN(e, t) {
  return (e ?? []).map((n) => {
    const a = ml(n, "");
    return {
      path: a,
      label: n,
      // A storage root's own writability is not knowable from the drive list;
      // it is answered by the listing when the user opens it. Offering it as
      // writable here and letting the listing correct that is the honest
      // order — the alternative greys out every drive until each is opened.
      writable: !0,
      blocked: ng(a, t),
      kind: "dir"
    };
  });
}
function $N(e, t) {
  const n = ((t == null ? void 0 : t.length) ?? 0) > 1;
  if (e && e.includes("://")) return e;
  if (n) return Yn;
  const a = t == null ? void 0 : t[0];
  return a ? ml(a, "") : Yn;
}
const ac = [];
function TN(e) {
  ac.push(e);
}
function AN(e) {
  const t = ac.lastIndexOf(e);
  t >= 0 && ac.splice(t, 1);
}
function F_(e) {
  return ac[ac.length - 1] === e;
}
const EN = ["aria-labelledby", "aria-label", "aria-busy"], CN = {
  key: 0,
  class: "fe-modal__head"
}, zN = ["aria-label", "disabled"], MN = { class: "fe-modal__body" }, PN = {
  key: 1,
  class: "fe-modal__ask",
  role: "alert",
  "data-testid": "modal-busy-close"
}, ON = { class: "fe-modal__ask-text" }, DN = { class: "fe-modal__ask-actions" }, LN = {
  key: 2,
  class: "fe-modal__actions"
}, Am = 'input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])', na = /* @__PURE__ */ lt({
  __name: "Modal",
  props: {
    locale: {},
    open: { type: Boolean },
    title: {},
    size: {},
    closeOnBackdrop: { type: Boolean, default: !0 },
    chromeless: { type: Boolean },
    fullbleed: { type: Boolean },
    theme: {},
    busy: { type: Boolean },
    busyClose: { default: null },
    bare: { type: Boolean },
    labelledby: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, a = bl() ? Hi(Q0, void 0) : void 0, { t: i } = yt(() => n.locale ?? (a == null ? void 0 : a()) ?? "en"), r = t, l = $(null);
    let d = 0;
    const f = `fe-modal-title-${++d}-${Math.random().toString(36).slice(2, 7)}`;
    let m = null, v = null;
    const b = Symbol("fe-modal");
    let _ = !1, w;
    function k() {
      const S = l.value;
      if (!S) return;
      const F = S.querySelector("[data-fe-autofocus]");
      if (F) {
        F.focus();
        return;
      }
      const I = (Y) => {
        var ie;
        return ((ie = S.querySelector(Y)) == null ? void 0 : ie.querySelector(Am)) ?? null;
      }, G = I(".fe-modal__body") ?? I(".fe-modal__actions") ?? S.querySelector(Am);
      G == null || G.focus();
    }
    function x() {
      _ || (_ = !0, m = document.activeElement ?? null, v = null, TN(b), document.addEventListener("keydown", L), w = setTimeout(() => {
        var S;
        if (w = void 0, !(typeof document > "u") && _ && F_(b) && !((S = l.value) != null && S.contains(document.activeElement))) {
          const F = document.activeElement;
          v = F && F !== document.body && F !== m ? F : null, k();
        }
      }, 30));
    }
    function M() {
      var F;
      if (!_) return;
      _ = !1, w !== void 0 && (clearTimeout(w), w = void 0), document.removeEventListener("keydown", L), AN(b);
      const S = m != null && m.isConnected ? m : v != null && v.isConnected ? v : m;
      (F = S == null ? void 0 : S.focus) == null || F.call(S), m = null, v = null;
    }
    Xe(
      () => n.open,
      (S) => S ? x() : M(),
      { immediate: !0 }
    ), Ot(M);
    const A = $(!1), T = $(null);
    Xe(
      () => [n.busy, n.open],
      ([S, F]) => {
        (!S || !F) && (A.value = !1);
      }
    );
    function N() {
      if (!n.busy) {
        r("close");
        return;
      }
      n.busyClose && (A.value = !0, Zt(() => {
        var S;
        return (S = T.value) == null ? void 0 : S.focus();
      }));
    }
    function z() {
      A.value = !1, r("close");
    }
    function L(S) {
      if (F_(b)) {
        if (S.key === "Escape") {
          if (n.chromeless) return;
          if (A.value) {
            A.value = !1;
            return;
          }
          if (n.busy) return;
          r("close");
          return;
        }
        if (S.key === "Tab" && l.value) {
          const F = Array.from(l.value.querySelectorAll(Am)).filter(
            (ie) => ie.offsetParent !== null || ie === document.activeElement
          );
          if (F.length === 0) return;
          const I = F[0], G = F[F.length - 1], Y = document.activeElement;
          S.shiftKey && (Y === I || !l.value.contains(Y)) ? (S.preventDefault(), G.focus()) : !S.shiftKey && (Y === G || !l.value.contains(Y)) && (S.preventDefault(), I.focus());
        }
      }
    }
    let B = !1;
    function O(S) {
      B = S.target === S.currentTarget;
    }
    function U(S) {
      const F = B;
      B = !1, !(!n.closeOnBackdrop || n.chromeless || n.busy) && (S.target !== S.currentTarget || !F || r("close"));
    }
    return (S, F) => (p(), Je(kr, { name: "fe-modal" }, {
      default: gt(() => [
        e.open ? (p(), h("div", {
          key: 0,
          class: Fe(["fe fe-modal__backdrop", [
            { "fe-modal__backdrop--chromeless": e.chromeless },
            { "fe-modal__backdrop--fullbleed": e.fullbleed && !e.chromeless },
            e.theme === "light" ? "fe--theme-light" : "",
            e.theme === "dark" ? "fe--theme-dark" : ""
          ]]),
          role: "presentation",
          onPointerdown: O,
          onClick: U
        }, [
          c("div", {
            ref_key: "cardEl",
            ref: l,
            class: Fe(["fe-modal__card", [
              e.bare ? "fe-modal__card--bare" : `fe-modal__card--${e.size || "md"}`,
              e.chromeless && "fe-modal__card--chromeless",
              e.fullbleed && !e.chromeless && "fe-modal__card--fullbleed"
            ]]),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": e.labelledby || (e.title && !e.chromeless && !e.fullbleed && !e.bare ? f : void 0),
            "aria-label": e.labelledby ? void 0 : (!e.title || e.chromeless || e.fullbleed || e.bare) && e.title || void 0,
            "aria-busy": e.busy ? "true" : void 0,
            onClick: F[1] || (F[1] = vt(() => {
            }, ["stop"]))
          }, [
            e.title && !e.chromeless && !e.fullbleed && !e.bare ? (p(), h("header", CN, [
              c("h2", {
                id: f,
                class: "fe-modal__title"
              }, y(e.title), 1),
              c("button", {
                type: "button",
                class: "fe-modal__close",
                "aria-label": u(i)("modal.close"),
                disabled: e.busy && !e.busyClose,
                onClick: N
              }, "×", 8, zN)
            ])) : D("", !0),
            c("div", MN, [
              En(S.$slots, "default")
            ]),
            A.value && e.busyClose ? (p(), h("div", PN, [
              c("p", ON, y(e.busyClose.question), 1),
              c("div", DN, [
                c("button", {
                  ref_key: "keepEl",
                  ref: T,
                  type: "button",
                  class: "fe-btn",
                  "data-testid": "modal-busy-close-keep",
                  onClick: F[0] || (F[0] = (I) => A.value = !1)
                }, y(u(i)("modal.busy_close.keep")), 513),
                c("button", {
                  type: "button",
                  class: "fe-btn fe-btn--danger",
                  "data-testid": "modal-busy-close-confirm",
                  onClick: z
                }, y(e.busyClose.confirm || u(i)("modal.busy_close.confirm")), 1)
              ])
            ])) : D("", !0),
            S.$slots.actions && !e.chromeless && !e.fullbleed && !e.bare ? (p(), h("footer", LN, [
              En(S.$slots, "actions")
            ])) : D("", !0)
          ], 10, EN)
        ], 34)) : D("", !0)
      ]),
      _: 3
    }));
  }
}), RN = {
  class: "fe-destpick",
  "data-testid": "destpicker"
}, NN = { class: "fe-destpick__bar" }, IN = ["disabled", "title", "aria-label"], BN = ["aria-label"], FN = ["onClick"], UN = {
  key: 1,
  class: "fe-destpick__crumb is-current"
}, HN = {
  class: "fe-destpick__rows",
  "data-testid": "destpicker-rows"
}, KN = {
  key: 0,
  class: "fe-destpick__note"
}, VN = {
  key: 1,
  class: "fe-destpick__note"
}, jN = {
  key: 2,
  class: "fe-destpick__note"
}, qN = ["disabled", "title", "aria-pressed", "data-testid", "onClick"], WN = ["innerHTML"], YN = { class: "fe-destpick__rowname" }, GN = {
  key: 0,
  class: "fe-destpick__rowtag",
  "data-testid": "destpicker-vault-tag"
}, XN = {
  key: 1,
  class: "fe-destpick__rowtag"
}, JN = {
  key: 2,
  class: "fe-destpick__rowtag"
}, ZN = {
  key: 3,
  class: "fe-destpick__rowinto",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, QN = {
  key: 1,
  class: "fe-destpick__target",
  "data-testid": "destpicker-target"
}, eI = ["disabled"], ag = /* @__PURE__ */ lt({
  __name: "DestinationPickerModal",
  props: {
    open: { type: Boolean },
    api: {},
    locale: {},
    storages: {},
    startAt: {},
    moving: {},
    mode: {},
    title: {},
    theme: {},
    pick: {},
    busy: { type: Boolean },
    vaultRoots: {},
    vaultFrom: {}
  },
  emits: ["close", "pick"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(Yn), l = $([]), d = $(!1), f = $(void 0), m = $(!1), v = E(() => {
      var V;
      return (((V = n.storages) == null ? void 0 : V.length) ?? 0) > 1;
    }), b = E(() => i("destpicker.drives")), _ = E(() => n.pick === "file"), w = $(null);
    let k = /* @__PURE__ */ new Map();
    const x = $([]);
    function M(V) {
      const W = String(V ?? "").replace(/\/+$/, "");
      W && !x.value.includes(W) && (x.value = [...x.value, W]);
    }
    function A(V) {
      return wN(V, [...n.vaultRoots ?? [], ...x.value]);
    }
    Xe(
      () => n.open,
      (V) => {
        V && (k = /* @__PURE__ */ new Map(), x.value = [], z($N(n.startAt, n.storages)));
      },
      { immediate: !0 }
    );
    const T = Hi(Tc, null);
    async function N(V) {
      const W = k.get(V);
      if (W) return W;
      try {
        let ne = await n.api.index(V);
        typeof ne.e2e_vault_root == "string" && ne.e2e_vault_root && M(ne.e2e_vault_root);
        for (const K of ne.files ?? []) K.type === "dir" && K.e2e_vault && M(K.path);
        if (T) {
          const K = typeof ne.e2e_root == "string" && ne.e2e_root ? ne.e2e_root : null;
          ne = { ...ne, files: await T.decorate(ne.files ?? [], { root: K }) };
        }
        return k.set(V, ne), ne;
      } catch {
        return;
      }
    }
    async function z(V) {
      if (r.value = V, m.value = !1, w.value = null, V === Yn) {
        f.value = void 0, l.value = SN(n.storages, n.moving);
        return;
      }
      d.value = !0;
      const W = await N(V);
      if (r.value !== V) return;
      d.value = !1, f.value = W, m.value = !W;
      const ne = A(V), K = ne && ne !== (n.vaultFrom ?? null) ? [] : W == null ? void 0 : W.files;
      l.value = xN(K, n.moving, { files: _.value }).map((ce) => {
        if (ce.kind !== "dir") return ce;
        const J = A(ce.path) === ce.path.replace(/\/+$/, ""), H = !ce.blocked && _N(ce.path, n.vaultFrom ?? null, A);
        return { ...ce, vault: J, blocked: H ? "vault" : ce.blocked };
      });
    }
    const L = E(() => eg(r.value, v.value)), B = E(
      () => kN(r.value).map((V) => ({ ...V, label: (T == null ? void 0 : T.segmentLabel(V.path)) ?? V.label }))
    ), O = E(() => ng(r.value, n.moving)), U = E(() => (x.value, vS(r.value, n.vaultFrom ?? null, A))), S = E(() => r.value === Yn || !f.value || f.value.read_only ? !1 : mS(f.value.perm)), F = E(() => n.busy || r.value === Yn || U.value ? !1 : _.value ? w.value !== null : S.value && O.value === null), I = E(() => r.value !== Yn && !(_.value && !m.value)), G = E(() => r.value === Yn ? i("destpicker.pick_a_drive") : _.value ? m.value ? i("destpicker.unreadable") : U.value ? i("destpicker.blocked.vault_in") : w.value === null ? i("destpicker.pick_a_file") : "" : O.value === "self" ? i("destpicker.blocked.self") : O.value === "descendant" ? i("destpicker.blocked.descendant") : U.value === "into" ? i("destpicker.blocked.vault_in") : U.value === "out" ? i("destpicker.blocked.vault_out") : m.value ? i("destpicker.unreadable") : f.value && !S.value ? i("destpicker.readonly_here") : ""), Y = E(() => n.title ? n.title : n.mode === "move" ? i("destpicker.title.move") : n.mode === "copy" ? i("destpicker.title.copy") : n.mode === "save" ? i("destpicker.title.save") : _.value ? i("destpicker.title.choose_file") : i("destpicker.title.choose")), ie = E(() => n.mode === "move" ? i("destpicker.confirm.move") : n.mode === "copy" ? i("destpicker.confirm.copy") : n.mode === "save" ? i("destpicker.confirm.save") : _.value ? i("destpicker.confirm.choose_file") : i("destpicker.confirm.choose")), me = E(
      () => _.value && w.value !== null ? tl(w.value, b.value) : tl(r.value, b.value)
    );
    function q(V) {
      return V.kind === "file" ? ya({ type: "file", basename: V.label }) : v2("folder");
    }
    function C(V) {
      return V.kind === "file" ? V.label : V.blocked === "self" ? i("destpicker.blocked.self") : V.blocked === "descendant" ? i("destpicker.blocked.descendant") : V.blocked === "vault" ? i(n.vaultFrom ? "destpicker.blocked.vault_out" : "destpicker.blocked.vault_in") : V.writable ? V.label : i("destpicker.readonly");
    }
    function re(V) {
      if (V.kind === "file") {
        w.value = V.path;
        return;
      }
      V.blocked || z(V.path);
    }
    function de() {
      F.value && a("pick", _.value && w.value !== null ? w.value : r.value);
    }
    return (V, W) => (p(), Je(na, {
      open: e.open,
      title: Y.value,
      size: "md",
      locale: e.locale,
      theme: e.theme,
      busy: e.busy,
      onClose: W[3] || (W[3] = (ne) => a("close"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          onClick: W[2] || (W[2] = (ne) => a("close"))
        }, y(u(i)("destpicker.cancel")), 1),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !F.value,
          "data-testid": "destpicker-confirm",
          onClick: de
        }, y(ie.value), 9, eI)
      ]),
      default: gt(() => [
        c("div", RN, [
          c("div", NN, [
            c("button", {
              type: "button",
              class: "fe-destpick__up",
              disabled: !L.value,
              title: u(i)("destpicker.up"),
              "aria-label": u(i)("destpicker.up"),
              "data-testid": "destpicker-up",
              onClick: W[0] || (W[0] = (ne) => z(L.value))
            }, [...W[4] || (W[4] = [
              c("svg", {
                class: "fe-ficon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
                focusable: "false"
              }, [
                c("path", { d: "M12 19V5M5 12l7-7 7 7" })
              ], -1)
            ])], 8, IN),
            c("nav", {
              class: "fe-destpick__crumbs",
              "aria-label": u(i)("destpicker.crumbs")
            }, [
              v.value ? (p(), h("button", {
                key: 0,
                type: "button",
                class: Fe(["fe-destpick__crumb", { "is-current": r.value === u(Yn) }]),
                onClick: W[1] || (W[1] = (ne) => z(u(Yn)))
              }, y(b.value), 3)) : D("", !0),
              (p(!0), h(Ce, null, ot(B.value, (ne) => (p(), h(Ce, {
                key: ne.path
              }, [
                W[5] || (W[5] = c("span", {
                  class: "fe-destpick__sep",
                  "aria-hidden": "true"
                }, "/", -1)),
                c("button", {
                  type: "button",
                  class: Fe(["fe-destpick__crumb", { "is-current": ne.path === r.value }]),
                  onClick: (K) => z(ne.path)
                }, y(ne.label), 11, FN)
              ], 64))), 128)),
              !v.value && !B.value.length ? (p(), h("span", UN, y(u(tl)(r.value, b.value)), 1)) : D("", !0)
            ], 8, BN)
          ]),
          c("ul", HN, [
            d.value ? (p(), h("li", KN, y(u(i)("destpicker.loading")), 1)) : m.value ? (p(), h("li", VN, y(u(i)("destpicker.unreadable")), 1)) : l.value.length ? D("", !0) : (p(), h("li", jN, y(_.value ? u(i)("destpicker.empty_files") : u(i)("destpicker.empty")), 1)),
            (p(!0), h(Ce, null, ot(l.value, (ne) => (p(), h("li", {
              key: ne.path
            }, [
              c("button", {
                type: "button",
                class: Fe(["fe-destpick__row", {
                  "is-locked": !ne.writable,
                  "is-blocked": !!ne.blocked,
                  "is-file": ne.kind === "file",
                  "is-picked": ne.kind === "file" && w.value === ne.path
                }]),
                disabled: !!ne.blocked,
                title: C(ne),
                "aria-pressed": ne.kind === "file" ? w.value === ne.path : void 0,
                "data-testid": "destpicker-row-" + ne.label,
                onClick: (K) => re(ne)
              }, [
                c("span", {
                  class: "fe-destpick__rowicon",
                  "aria-hidden": "true",
                  innerHTML: q(ne)
                }, null, 8, WN),
                c("span", YN, [
                  c("bdi", null, y(ne.label), 1)
                ]),
                ne.vault ? (p(), h("span", GN, y(u(i)("destpicker.tag.vault")), 1)) : D("", !0),
                ne.blocked ? (p(), h("span", XN, y(u(i)("destpicker.tag.blocked")), 1)) : ne.writable ? D("", !0) : (p(), h("span", JN, y(u(i)("destpicker.readonly")), 1)),
                ne.kind === "dir" ? (p(), h("svg", ZN, [...W[6] || (W[6] = [
                  c("path", { d: "M9 5l7 7-7 7" }, null, -1)
                ])])) : D("", !0)
              ], 10, qN)
            ]))), 128))
          ]),
          G.value ? (p(), h("p", {
            key: 0,
            class: Fe(["fe-destpick__reason", { "is-hint": !I.value }]),
            "data-testid": "destpicker-reason"
          }, y(G.value), 3)) : (p(), h("p", QN, y(u(i)("destpicker.target", { name: me.value })), 1))
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "locale", "theme", "busy"]));
  }
}), tI = ["title"], nI = ["disabled"], aI = ["disabled"], iI = /* @__PURE__ */ lt({
  __name: "SurfaceFileChooser",
  props: {
    id: {},
    kind: {},
    modelValue: {},
    locale: {},
    theme: {},
    api: {},
    storages: {},
    startAt: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(!1), l = E(() => n.kind === "dir" ? "dir" : "file"), d = E(() => n.modelValue ? tl(n.modelValue, "") || n.modelValue : ""), f = E(() => n.modelValue ? l.value === "dir" ? n.modelValue : eg(n.modelValue, !1) ?? n.modelValue : n.startAt);
    function m(v) {
      r.value = !1, a("update:modelValue", v);
    }
    return (v, b) => (p(), h("div", {
      class: Fe(["fe-sfile", { "is-invalid": e.invalid }]),
      "data-testid": "surface-file-chooser"
    }, [
      c("span", {
        class: Fe(["fe-sfile__value", { "fe-sfile__value--empty": !e.modelValue }]),
        title: e.modelValue || void 0,
        "data-testid": "surface-file-chooser-value"
      }, y(d.value || u(i)("plugin.file.none")), 11, tI),
      c("button", {
        type: "button",
        class: "fe-btn fe-btn--sm",
        disabled: e.disabled || !e.api,
        "data-testid": "surface-file-chooser-open",
        onClick: b[0] || (b[0] = (_) => r.value = !0)
      }, y(u(i)("plugin.file.choose")), 9, nI),
      e.modelValue ? (p(), h("button", {
        key: 0,
        type: "button",
        class: "fe-btn fe-btn--sm",
        disabled: e.disabled,
        "data-testid": "surface-file-chooser-clear",
        onClick: b[1] || (b[1] = (_) => a("update:modelValue", ""))
      }, y(u(i)("plugin.file.clear")), 9, aI)) : D("", !0),
      e.api ? (p(), Je(ag, {
        key: 1,
        open: r.value,
        api: e.api,
        locale: e.locale,
        mode: "choose",
        pick: l.value,
        storages: e.storages,
        "start-at": f.value,
        onClose: b[2] || (b[2] = (_) => r.value = !1),
        onPick: m
      }, null, 8, ["open", "api", "locale", "pick", "storages", "start-at"])) : D("", !0)
    ], 2));
  }
}), oI = ["data-state"], rI = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, sI = {
  key: 1,
  class: "fe-surface__text fe-surface__text--muted"
}, lI = ["src", "alt"], uI = ["src"], cI = ["src"], dI = ["src", "type"], fI = ["innerHTML"], pI = ["title"], hI = /* @__PURE__ */ lt({
  __name: "SurfacePreview",
  props: {
    path: {},
    fileRef: {},
    fileUrl: { type: Function },
    locale: {},
    api: {}
  },
  setup(e) {
    const t = e, { t: n } = yt(() => t.locale), a = $(null), i = $(""), r = $("loading");
    let l = 0;
    const d = E(() => t.fileRef && t.fileUrl ? t.fileUrl(t.fileRef) : null), f = E(() => {
      var w;
      return ((w = d.value) == null ? void 0 : w.name) || tl(t.path, "") || t.path || t.fileRef || "";
    }), m = E(() => {
      const w = i.value;
      return w.startsWith("image/") ? "image" : w.startsWith("video/") ? "video" : w.startsWith("audio/") ? "audio" : "other";
    }), v = E(() => ya({ type: "file", basename: f.value }));
    function b() {
      a.value && a.value.startsWith("blob:") && URL.revokeObjectURL(a.value), a.value = null;
    }
    async function _() {
      const w = ++l;
      if (b(), i.value = "", t.fileRef) {
        if (!d.value) {
          r.value = "error";
          return;
        }
        a.value = d.value.url, i.value = d.value.mime || "", r.value = "ok";
        return;
      }
      if (!t.api || !t.path) {
        r.value = "error";
        return;
      }
      r.value = "loading";
      try {
        const k = await t.api.fetchBlob(t.path);
        if (w !== l) {
          URL.revokeObjectURL(k.url);
          return;
        }
        a.value = k.url, i.value = k.mime || "", r.value = "ok";
      } catch {
        if (w !== l) return;
        r.value = "error";
      }
    }
    return Xe([() => t.path, () => t.fileRef], () => void _(), { immediate: !0 }), Ot(() => {
      l++, b();
    }), (w, k) => (p(), h("figure", {
      class: "fe-spreview",
      "data-testid": "surface-preview",
      "data-state": r.value
    }, [
      r.value === "loading" ? (p(), h("p", rI, y(u(n)("plugin.view.loading")), 1)) : r.value === "error" ? (p(), h("p", sI, y(u(n)("plugin.view.preview_failed")), 1)) : (p(), h(Ce, { key: 2 }, [
        m.value === "image" && a.value ? (p(), h("img", {
          key: 0,
          class: "fe-spreview__media",
          src: a.value,
          alt: f.value
        }, null, 8, lI)) : m.value === "video" && a.value ? (p(), h("video", {
          key: 1,
          class: "fe-spreview__media",
          src: a.value,
          controls: "",
          preload: "metadata"
        }, null, 8, uI)) : m.value === "audio" && a.value ? (p(), h("audio", {
          key: 2,
          class: "fe-spreview__audio",
          src: a.value,
          controls: "",
          preload: "metadata"
        }, null, 8, cI)) : e.fileRef && a.value ? (p(), h("embed", {
          key: 3,
          class: "fe-spreview__media fe-spreview__embed",
          src: a.value,
          type: i.value || void 0
        }, null, 8, dI)) : (p(), h("span", {
          key: 4,
          class: "fe-spreview__tile",
          "aria-hidden": "true",
          innerHTML: v.value
        }, null, 8, fI))
      ], 64)),
      c("figcaption", {
        class: "fe-spreview__name",
        title: e.path
      }, y(f.value), 9, pI)
    ], 8, oI));
  }
}), mI = ["data-mode", "role", "aria-labelledby"], vI = ["id"], yI = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, gI = {
  key: 1,
  class: "fe-ssig__modes",
  role: "tablist"
}, bI = ["aria-selected", "disabled", "data-testid", "onClick"], kI = ["aria-label"], wI = {
  key: 0,
  class: "fe-ssig__hint"
}, _I = {
  key: 3,
  class: "fe-ssig__typewrap"
}, xI = ["id", "placeholder", "disabled", "value"], SI = ["aria-label"], $I = ["disabled", "title", "aria-pressed", "data-testid", "onClick"], TI = ["src"], AI = {
  key: 4,
  class: "fe-ssig__uploadwrap"
}, EI = { class: "fe-btn fe-btn--sm fe-ssig__pick" }, CI = ["disabled"], zI = { class: "fe-ssig__hint" }, MI = {
  key: 0,
  class: "fe-surface__error",
  role: "alert"
}, PI = ["src"], OI = { class: "fe-ssig__foot" }, DI = ["disabled"], LI = {
  key: 0,
  class: "fe-ssig__signed"
}, yS = /* @__PURE__ */ lt({
  __name: "SurfaceSignaturePad",
  props: {
    id: {},
    modes: {},
    width: {},
    height: {},
    modelValue: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    font: {},
    fonts: {},
    label: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = E(() => V4(n.modes)), l = E(() => q4(n.width, n.height)), d = $(Cu(n.modelValue) && r.value.includes(n.modelValue.mode) ? n.modelValue.mode : r.value[0]), f = E(() => {
      const de = Array.isArray(n.fonts) ? n.fonts.filter(tc) : [];
      return de.length ? pl.filter((V) => de.includes(V.key)) : pl;
    });
    function m() {
      const de = f.value.map((W) => W.key), V = Cu(n.modelValue) ? j4(n.modelValue) : void 0;
      return V && de.includes(V) ? V : tc(n.font) && de.includes(n.font) ? n.font : de.includes(Iv) ? Iv : de[0];
    }
    const v = $(null), b = $(""), _ = $(m()), w = $(""), k = $(""), x = E(() => Cu(n.modelValue)), M = E(() => Cu(n.modelValue) ? `data:image/png;base64,${n.modelValue.png_b64}` : "");
    function A(de) {
      if (!de) return null;
      try {
        return de.getContext("2d");
      } catch {
        return null;
      }
    }
    function T() {
      return typeof window < "u" && window.devicePixelRatio > 0 ? Math.min(3, window.devicePixelRatio) : 1;
    }
    function N() {
      const de = v.value;
      if (!de) return;
      const V = T();
      de.width = Math.round(l.value.width * V), de.height = Math.round(l.value.height * V);
      const W = A(de);
      W && (W.setTransform(1, 0, 0, 1, 0, 0), W.clearRect(0, 0, de.width, de.height), W.scale(V, V), W.lineWidth = 2.2, W.lineCap = "round", W.lineJoin = "round", W.strokeStyle = R_);
    }
    let z = !1, L = null;
    function B(de) {
      const V = v.value, W = V == null ? void 0 : V.getBoundingClientRect();
      if (!V || !W || !W.width) return { x: de.clientX, y: de.clientY };
      const ne = l.value.width / W.width, K = l.value.height / W.height;
      return { x: (de.clientX - W.left) * ne, y: (de.clientY - W.top) * K };
    }
    function O(de) {
      var W, ne, K;
      if (n.disabled) return;
      const V = A(v.value);
      if (V) {
        z = !0, L = B(de);
        try {
          (ne = (W = de.target).setPointerCapture) == null || ne.call(W, de.pointerId);
        } catch {
        }
        V.beginPath(), V.moveTo(L.x, L.y), V.lineTo(L.x + 0.1, L.y + 0.1), V.stroke(), (K = de.preventDefault) == null || K.call(de);
      }
    }
    function U(de) {
      var ne;
      if (!z || !L) return;
      const V = A(v.value);
      if (!V) return;
      const W = B(de);
      V.beginPath(), V.moveTo(L.x, L.y), V.lineTo(W.x, W.y), V.stroke(), L = W, (ne = de.preventDefault) == null || ne.call(de);
    }
    function S() {
      z && (z = !1, L = null, F(v.value, "draw"));
    }
    function F(de, V) {
      if (!de) return;
      let W = "";
      try {
        W = de.toDataURL("image/png");
      } catch {
        W = "";
      }
      const ne = Y4(W);
      ne && (V !== "draw" && (k.value = W), a("update:modelValue", V === "type" ? { png_b64: ne, mode: V, font: _.value } : { png_b64: ne, mode: V }));
    }
    async function I(de, V) {
      const W = document.fonts;
      if (!(!W || typeof W.load != "function"))
        try {
          await W.load(`${de}px ${V}`, "Aa");
        } catch {
        }
    }
    async function G() {
      const de = b.value.trim();
      if (!de) {
        k.value = "", a("update:modelValue", null);
        return;
      }
      const V = Zx(_.value).stack;
      if (await I(Math.round(l.value.height * 0.6), V), b.value.trim() !== de) return;
      const W = document.createElement("canvas"), ne = 2, { width: K, height: ce } = l.value;
      W.width = K * ne, W.height = ce * ne;
      const J = A(W);
      if (!J) return;
      J.scale(ne, ne), J.fillStyle = R_, J.textBaseline = "middle";
      const H = X4(
        (X) => (J.font = `${X}px ${V}`, J.measureText(de).width),
        K - 24,
        ce
      );
      J.font = `${H}px ${V}`, J.fillText(de, 12, ce / 2), F(W, "type");
    }
    function Y(de) {
      n.disabled || de === _.value || (_.value = de, b.value.trim() && G());
    }
    const ie = $(null);
    function me(de) {
      var J;
      const V = de.target, W = (J = V.files) == null ? void 0 : J[0];
      if (V.value = "", !W) return;
      const ne = G4(W);
      if (ne !== "ok") {
        w.value = ne;
        return;
      }
      w.value = "";
      const K = URL.createObjectURL(W), ce = new Image();
      ce.onload = () => {
        URL.revokeObjectURL(K);
        const H = W4(ce.naturalWidth, ce.naturalHeight, uS, cS), X = document.createElement("canvas");
        X.width = H.width, X.height = H.height;
        const we = A(X);
        we && (we.drawImage(ce, 0, 0, H.width, H.height), F(X, "upload"));
      }, ce.onerror = () => {
        URL.revokeObjectURL(K), w.value = "unreadable";
      }, ce.src = K;
    }
    function q() {
      b.value = "", k.value = "", w.value = "", N(), a("update:modelValue", null);
    }
    function C(de) {
      de !== d.value && (d.value = de);
    }
    Xe(d, async (de) => {
      de === "draw" && (await Zt(), N());
    }), Xe(l, () => {
      d.value === "draw" && N();
    }), Wt(() => {
      d.value === "draw" && N();
    }), Ot(() => {
      z = !1;
    });
    const re = E(() => {
      switch (w.value) {
        case "too_big":
          return i("plugin.sig.upload_too_big", { kb: 200 });
        case "bad_type":
          return i("plugin.sig.upload_bad_type");
        case "unreadable":
          return i("plugin.sig.upload_unreadable");
        default:
          return "";
      }
    });
    return (de, V) => (p(), h("div", {
      class: Fe(["fe-ssig", { "is-invalid": e.invalid, "is-disabled": e.disabled }]),
      "data-testid": "surface-signature",
      "data-mode": d.value,
      role: e.label ? "group" : void 0,
      "aria-labelledby": e.label ? `fe-ssig-${e.id}-lbl` : void 0
    }, [
      e.label ? (p(), h("span", {
        key: 0,
        id: `fe-ssig-${e.id}-lbl`,
        class: "fe-cfield__label",
        "data-testid": "surface-signature-label"
      }, [
        Ht(y(e.label), 1),
        e.required ? (p(), h("span", yI, "*")) : D("", !0)
      ], 8, vI)) : D("", !0),
      r.value.length > 1 ? (p(), h("div", gI, [
        (p(!0), h(Ce, null, ot(r.value, (W) => (p(), h("button", {
          key: W,
          type: "button",
          class: Fe(["fe-btn fe-btn--sm", { "fe-btn--primary": W === d.value }]),
          role: "tab",
          "aria-selected": W === d.value ? "true" : "false",
          disabled: e.disabled,
          "data-testid": `surface-signature-mode-${W}`,
          onClick: (ne) => C(W)
        }, y(u(i)(`plugin.sig.mode_${W}`)), 11, bI))), 128))
      ])) : D("", !0),
      d.value === "draw" ? (p(), h("div", {
        key: 2,
        class: "fe-ssig__padwrap",
        style: Yt({ maxWidth: `${l.value.width}px` })
      }, [
        c("canvas", {
          ref_key: "canvas",
          ref: v,
          class: "fe-ssig__canvas",
          style: Yt({ aspectRatio: `${l.value.width} / ${l.value.height}` }),
          "aria-label": u(i)("plugin.sig.draw_hint"),
          "data-testid": "surface-signature-canvas",
          onPointerdown: O,
          onPointermove: U,
          onPointerup: S,
          onPointercancel: S,
          onPointerleave: S
        }, null, 44, kI),
        x.value ? D("", !0) : (p(), h("p", wI, y(u(i)("plugin.sig.draw_hint")), 1))
      ], 4)) : d.value === "type" ? (p(), h("div", _I, [
        c("input", {
          id: `fe-ssig-${e.id}`,
          class: "fe-cfield__input fe-ssig__typed",
          type: "text",
          placeholder: u(i)("plugin.sig.type_placeholder"),
          disabled: e.disabled,
          value: b.value,
          autocomplete: "name",
          "data-testid": "surface-signature-typed",
          onInput: V[0] || (V[0] = (W) => {
            b.value = W.target.value, G();
          })
        }, null, 40, xI),
        f.value.length > 1 ? (p(), h("div", {
          key: 0,
          class: "fe-signfonts",
          role: "group",
          "aria-label": u(i)("plugin.sign.font_label"),
          "data-testid": "surface-signature-fonts"
        }, [
          (p(!0), h(Ce, null, ot(f.value, (W) => (p(), h("button", {
            key: W.key,
            type: "button",
            class: Fe(["fe-signfonts__btn", [W.className, { "is-on": W.key === _.value }]]),
            disabled: e.disabled,
            title: W.name,
            "aria-pressed": W.key === _.value ? "true" : "false",
            "data-testid": `surface-signature-font-${W.key}`,
            onClick: (ne) => Y(W.key)
          }, y(b.value.trim() || W.name), 11, $I))), 128))
        ], 8, SI)) : D("", !0),
        c("div", {
          class: "fe-ssig__preview",
          style: Yt({ maxWidth: `${l.value.width}px`, aspectRatio: `${l.value.width} / ${l.value.height}` })
        }, [
          k.value || M.value ? (p(), h("img", {
            key: 0,
            class: "fe-ssig__img",
            src: k.value || M.value,
            alt: ""
          }, null, 8, TI)) : D("", !0)
        ], 4)
      ])) : (p(), h("div", AI, [
        c("label", EI, [
          c("input", {
            ref_key: "fileInput",
            ref: ie,
            type: "file",
            accept: "image/png,image/jpeg",
            class: "fe-ssig__file",
            disabled: e.disabled,
            "data-testid": "surface-signature-file",
            onChange: me
          }, null, 40, CI),
          Ht(" " + y(u(i)("plugin.sig.upload_pick")), 1)
        ]),
        c("p", zI, y(u(i)("plugin.sig.upload_hint", { kb: 200 })), 1),
        re.value ? (p(), h("p", MI, y(re.value), 1)) : D("", !0),
        k.value || M.value ? (p(), h("div", {
          key: 1,
          class: "fe-ssig__preview",
          style: Yt({ maxWidth: `${l.value.width}px` })
        }, [
          c("img", {
            class: "fe-ssig__img",
            src: k.value || M.value,
            alt: ""
          }, null, 8, PI)
        ], 4)) : D("", !0)
      ])),
      c("div", OI, [
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--sm",
          disabled: e.disabled || !x.value,
          "data-testid": "surface-signature-clear",
          onClick: q
        }, y(u(i)("plugin.sig.clear")), 9, DI),
        x.value ? (p(), h("span", LI, y(u(i)("plugin.sig.signed")), 1)) : D("", !0)
      ])
    ], 10, mI));
  }
});
async function gS(e) {
  const t = await fetch(e.url, {
    headers: e.headers ?? {},
    credentials: e.credentials ?? "same-origin",
    signal: e.signal
  });
  if (!t.ok) {
    const n = await t.text().catch(() => "");
    throw pa(t.status, n, void 0);
  }
  return t;
}
async function RI(e) {
  return (await gS(e)).arrayBuffer();
}
async function kce(e) {
  return (await gS(e)).text();
}
const Hf = "filex", NI = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
function ig(e) {
  const t = String(e ?? "").trim();
  return NI.test(t) ? t.length === 4 ? `#${t[1]}${t[1]}${t[2]}${t[2]}${t[3]}${t[3]}`.toLowerCase() : t.toLowerCase() : "";
}
function II(e, t) {
  const n = ig(e);
  if (!n) return "";
  const a = parseInt(n.slice(1), 16), i = (l) => Math.max(0, Math.min(255, Math.round((a >> l & 255) * t))), r = (l) => l.toString(16).padStart(2, "0");
  return `#${r(i(16))}${r(i(8))}${r(i(0))}`;
}
function bS(e) {
  const t = ig(e);
  if (!t) return "";
  const n = parseInt(t.slice(1), 16), a = (r) => {
    const l = r / 255;
    return l <= 0.04045 ? l / 12.92 : ((l + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * a(n >> 16 & 255) + 0.7152 * a(n >> 8 & 255) + 0.0722 * a(n & 255) > 0.42 ? "#0b0f14" : "#ffffff";
}
function kS(e) {
  const t = ig(e);
  if (!t) return {};
  const n = parseInt(t.slice(1), 16), a = `${n >> 16 & 255}, ${n >> 8 & 255}, ${n & 255}`;
  return {
    "--fe-primary": t,
    "--fe-primary-hover": II(t, 0.85),
    "--fe-text-on-primary": bS(t),
    // ⚠ The TINT and the ink on it, or the accent only half arrives: the
    // button turned orange while the round badge behind the padlock, the
    // focus ring on the PIN box and the row hover stayed the stock blue
    // (measured on the first after-shot of the restored gate). The old
    // Go-rendered page derived exactly these from the same colour
    // (`--px-accent-soft: rgba(r,g,b,0.14)`, `color: var(--px-accent)`), and
    // a translucent tint is right rather than a solid: it composites onto
    // the card in light and in dark without a second value.
    "--fe-primary-soft": `rgba(${a}, 0.14)`,
    "--fe-primary-ink": t
  };
}
function BI(e = {}) {
  const t = $(null), n = $(!1), a = E(() => {
    var _, w;
    return ((w = (_ = t.value) == null ? void 0 : _.name) == null ? void 0 : w.trim()) || Hf;
  }), i = E(() => {
    var _, w;
    return !!((w = (_ = t.value) == null ? void 0 : _.name) != null && w.trim()) && a.value !== Hf;
  }), r = E(() => {
    var _, w;
    return ((w = (_ = t.value) == null ? void 0 : _.logo_url) == null ? void 0 : w.trim()) || "";
  }), l = E(() => {
    var _, w;
    return ((w = (_ = t.value) == null ? void 0 : _.footer_text) == null ? void 0 : w.trim()) || "";
  }), d = E(() => {
    var _;
    return ((_ = t.value) == null ? void 0 : _.hide_powered_by) === !0;
  }), f = E(() => {
    var w;
    const _ = (w = t.value) == null ? void 0 : w.theme;
    return _ === "light" || _ === "dark" ? _ : "auto";
  }), m = E(() => {
    var _;
    return ((_ = t.value) == null ? void 0 : _.locales) ?? [];
  }), v = E(() => {
    var _;
    return kS((_ = t.value) == null ? void 0 : _.accent);
  });
  async function b() {
    const _ = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
    if (!_) return null;
    const w = kl(e.base);
    for (const k of ["/api/public/branding", "/api/branding"])
      try {
        const x = await _(`${w}${k}`, {
          method: "GET",
          headers: { Accept: "application/json" },
          credentials: "same-origin"
        });
        if (!x.ok) continue;
        return t.value = await x.json(), n.value = !0, z0(t.value, { base: e.base, fetchImpl: e.fetchImpl }), t.value;
      } catch {
      }
    return null;
  }
  return { branding: t, loaded: n, name: a, whitelabel: i, logo: r, footerText: l, hidePoweredBy: d, themeDefault: f, locales: m, accentStyle: v, load: b };
}
let Em = null;
function FI(e) {
  return `https://cdn.jsdelivr.net/npm/pdfjs-dist@${e}/legacy/build/pdf.worker.min.mjs`;
}
function UI(e) {
  return Em || (Em = (async () => {
    try {
      const t = await import(
        /* @vite-ignore */
        "./pdf-CaPYsOUo.js"
      ), n = t.default ?? t;
      return n.GlobalWorkerOptions && !n.GlobalWorkerOptions.workerSrc && (n.GlobalWorkerOptions.workerSrc = e || FI(n.version || "5.7.284")), n;
    } catch {
      return null;
    }
  })()), Em;
}
const HI = ["data-testid"], KI = { class: "fe-spdf__propname" }, VI = { class: "fe-spdf__prop" }, jI = ["value", "placeholder", "disabled", "data-testid"], qI = {
  key: 0,
  class: "fe-spdf__prop"
}, WI = ["id", "data-testid"], YI = ["data-testid"], GI = ["id"], XI = { class: "fe-spdf__prop fe-spdf__prop--check" }, JI = ["checked", "disabled", "data-testid"], ZI = { class: "fe-spdf__prop" }, QI = ["id"], e8 = { class: "fe-spdf__prop" }, t8 = ["value", "disabled", "data-testid"], n8 = { class: "fe-spdf__prop" }, a8 = ["value", "disabled", "data-testid"], i8 = { class: "fe-spdf__prop" }, o8 = ["id"], r8 = { class: "fe-spdf__prop" }, s8 = ["id"], l8 = ["data-testid"], u8 = { class: "fe-spdf__dateex-title" }, c8 = { class: "fe-spdf__dateex-value" }, d8 = {
  key: 4,
  class: "fe-spdf__prop"
}, f8 = ["id"], p8 = ["aria-label", "data-testid"], h8 = ["title", "disabled", "aria-pressed", "data-testid", "onClick"], m8 = ["data-testid"], v8 = ["id"], y8 = ["data-testid"], g8 = { class: "fe-spdf__linepreview-title" }, b8 = {
  key: 1,
  class: "fe-spdf__linepreview-line is-none"
}, k8 = ["disabled", "data-testid"], Cm = "*", U_ = /* @__PURE__ */ lt({
  __name: "PdfFieldEditor",
  props: {
    field: {},
    signers: {},
    formats: {},
    dateLabels: {},
    locale: {},
    disabled: { type: Boolean },
    testidPrefix: {},
    stampLines: {}
  },
  emits: ["patch", "remove"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = E(() => n.testidPrefix || "surface-pdf");
    function l(H) {
      return i(`plugin.pdf.type_${H}`);
    }
    function d(H) {
      const X = { ...n.field };
      H(X), a("patch", X);
    }
    function f(H) {
      d((X) => {
        H ? X.label = H : delete X.label;
      });
    }
    function m(H) {
      d((X) => {
        H ? X.assignee = H : delete X.assignee;
      });
    }
    function v(H) {
      d((X) => {
        H ? X.required = !0 : delete X.required;
      });
    }
    function b(H) {
      d((X) => {
        const we = Dv.includes(H) ? H : "any", it = { ...X.rule ?? { kind: "any" }, kind: we };
        we === "any" && !it.min && !it.max ? delete X.rule : X.rule = it;
      });
    }
    function _(H, X) {
      const we = Math.trunc(Number(String(X ?? "").trim()));
      d((it) => {
        const Re = { ...it.rule ?? { kind: "any" } };
        Number.isFinite(we) && we > 0 ? Re[H] = we : delete Re[H], Re.kind === "any" && !Re.min && !Re.max ? delete it.rule : it.rule = Re;
      });
    }
    function w(H) {
      d((X) => {
        H ? X.format = H : delete X.format;
      });
    }
    function k(H) {
      d((X) => {
        X.font = H;
      });
    }
    const x = E(() => eS(n.field.type)), M = E(() => n.field.style ?? "drawn");
    function A(H) {
      d((X) => {
        H === "typed" ? X.style = "typed" : delete X.style;
      });
    }
    const T = E(() => [
      { value: "drawn", label: i("plugin.pdf.style_drawn") },
      { value: "typed", label: i("plugin.pdf.style_typed") }
    ]), N = E(() => n.field.type === "checkbox" ? !1 : x.value ? M.value === "typed" : !0), z = E(() => h4(n.stampLines)), L = E(() => m4(n.field, z.value)), B = E(
      () => z.value.map((H) => ({ value: H.id, label: Gt(H.label, n.locale) || H.id }))
    );
    function O(H) {
      const X = (Array.isArray(H) ? H : [H]).filter(Boolean);
      d((we) => {
        we.lines = X;
      });
    }
    const U = E(
      () => L.value.map((H) => z.value.find((X) => X.id === H)).filter((H) => !!H).map((H) => Gt(v4(H, n.field.assignee), n.locale) || Gt(H.label, n.locale))
    ), S = E(() => i(x.value ? "plugin.pdf.assignee" : "plugin.pdf.filled_by")), F = E(() => [
      { value: Cm, label: i("plugin.pdf.unassigned") },
      ...n.signers.map((H) => ({ value: H.id, label: Gt(H.label, n.locale) || H.id }))
    ]), I = E(
      () => Dv.map((H) => ({ value: H, label: i(`plugin.pdf.rule_kind_${H}`) }))
    ), G = E(() => k4(n.formats)), Y = E(
      () => G.value.map((H) => ({ value: H.id, label: Gt(H.label, n.locale) || H.id, help: H.example }))
    ), ie = E(() => {
      var H;
      return n.field.format ?? ((H = G.value[0]) == null ? void 0 : H.id) ?? "";
    }), me = E(() => _4(G.value)), q = E(() => w4(n.dateLabels));
    function C(H, X) {
      return Sy(q.value[H], n.locale, () => i(X));
    }
    const re = E(() => x4(G.value, ie.value)), de = E(() => {
      var H, X, we;
      return ((H = re.value) == null ? void 0 : H.order) ?? ((we = (X = me.value) == null ? void 0 : X.orders[0]) == null ? void 0 : we.id) ?? "";
    }), V = E(() => {
      var H, X, we;
      return ((H = re.value) == null ? void 0 : H.separator) ?? ((we = (X = me.value) == null ? void 0 : X.separators[0]) == null ? void 0 : we.id) ?? "";
    }), W = E(
      () => {
        var H;
        return (((H = me.value) == null ? void 0 : H.orders) ?? []).map((X) => ({ value: X.id, label: Gt(X.label, n.locale) || X.id }));
      }
    ), ne = E(
      () => {
        var H;
        return (((H = me.value) == null ? void 0 : H.separators) ?? []).map((X) => ({ value: X.id, label: Gt(X.label, n.locale) || X.id }));
      }
    ), K = E(() => $4(de.value, V.value, /* @__PURE__ */ new Date()));
    function ce(H) {
      w(P_(G.value, H, V.value));
    }
    function J(H) {
      w(P_(G.value, de.value, H));
    }
    return (H, X) => {
      var we, it, Re;
      return p(), h("div", {
        class: "fe-spdf__props",
        "data-testid": `${r.value}-editor`
      }, [
        c("span", KI, y(l(e.field.type)), 1),
        c("label", VI, [
          c("span", null, y(u(i)("plugin.pdf.label")), 1),
          c("input", {
            class: "fe-cfield__input fe-spdf__name",
            type: "text",
            value: e.field.label ?? "",
            placeholder: l(e.field.type),
            disabled: e.disabled,
            "data-testid": `${r.value}-label`,
            onInput: X[0] || (X[0] = (Be) => f(Be.target.value))
          }, null, 40, jI)
        ]),
        e.signers.length ? (p(), h("div", qI, [
          c("span", {
            id: `${r.value}-${e.field.id}-assignee-lbl`,
            "data-testid": `${r.value}-assignee-label`
          }, y(S.value), 9, WI),
          tt(ui, {
            options: F.value,
            "model-value": e.field.assignee || Cm,
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-assignee-lbl`,
            "testid-prefix": `${r.value}-assignee`,
            "onUpdate:modelValue": X[1] || (X[1] = (Be) => m(String(Be) === Cm ? "" : String(Be)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ])) : D("", !0),
        x.value ? (p(), h("div", {
          key: 1,
          class: "fe-spdf__prop",
          "data-testid": `${r.value}-style`
        }, [
          c("span", {
            id: `${r.value}-${e.field.id}-style-lbl`
          }, y(u(i)("plugin.pdf.style")), 9, GI),
          tt(ui, {
            options: T.value,
            "model-value": M.value,
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-style-lbl`,
            "testid-prefix": `${r.value}-style`,
            "onUpdate:modelValue": X[2] || (X[2] = (Be) => A(String(Be)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ], 8, YI)) : D("", !0),
        c("label", XI, [
          c("input", {
            type: "checkbox",
            checked: e.field.required === !0,
            disabled: e.disabled,
            "data-testid": `${r.value}-required`,
            onChange: X[3] || (X[3] = (Be) => v(Be.target.checked))
          }, null, 40, JI),
          c("span", null, y(u(i)("plugin.pdf.required")), 1)
        ]),
        e.field.type === "text" ? (p(), h(Ce, { key: 2 }, [
          c("div", ZI, [
            c("span", {
              id: `${r.value}-${e.field.id}-rule-lbl`
            }, y(u(i)("plugin.pdf.rule")), 9, QI),
            tt(ui, {
              options: I.value,
              "model-value": ((we = e.field.rule) == null ? void 0 : we.kind) ?? "any",
              disabled: e.disabled,
              "aria-labelledby": `${r.value}-${e.field.id}-rule-lbl`,
              "testid-prefix": `${r.value}-rule`,
              "onUpdate:modelValue": X[4] || (X[4] = (Be) => b(String(Be)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          c("label", e8, [
            c("span", null, y(u(i)("plugin.pdf.rule_min_label")), 1),
            c("input", {
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "0",
              value: ((it = e.field.rule) == null ? void 0 : it.min) ?? "",
              disabled: e.disabled,
              "data-testid": `${r.value}-rule-min`,
              onInput: X[5] || (X[5] = (Be) => _("min", Be.target.value))
            }, null, 40, t8)
          ]),
          c("label", n8, [
            c("span", null, y(u(i)("plugin.pdf.rule_max_label")), 1),
            c("input", {
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "0",
              value: ((Re = e.field.rule) == null ? void 0 : Re.max) ?? "",
              disabled: e.disabled,
              "data-testid": `${r.value}-rule-max`,
              onInput: X[6] || (X[6] = (Be) => _("max", Be.target.value))
            }, null, 40, a8)
          ])
        ], 64)) : D("", !0),
        e.field.type === "date" && me.value ? (p(), h(Ce, { key: 3 }, [
          c("div", i8, [
            c("span", {
              id: `${r.value}-${e.field.id}-order-lbl`
            }, y(C("order", "plugin.pdf.date_order")), 9, o8),
            tt(ui, {
              options: W.value,
              "model-value": de.value,
              disabled: e.disabled,
              "aria-labelledby": `${r.value}-${e.field.id}-order-lbl`,
              "testid-prefix": `${r.value}-order`,
              "onUpdate:modelValue": X[7] || (X[7] = (Be) => ce(String(Be)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          c("div", r8, [
            c("span", {
              id: `${r.value}-${e.field.id}-sep-lbl`
            }, y(C("separator", "plugin.pdf.date_separator")), 9, s8),
            tt(ui, {
              options: ne.value,
              "model-value": V.value,
              disabled: e.disabled,
              "aria-labelledby": `${r.value}-${e.field.id}-sep-lbl`,
              "testid-prefix": `${r.value}-sep`,
              "onUpdate:modelValue": X[8] || (X[8] = (Be) => J(String(Be)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          c("p", {
            class: "fe-spdf__dateex",
            "data-testid": `${r.value}-date-example`
          }, [
            c("span", u8, y(C("example", "plugin.pdf.date_example")), 1),
            c("bdi", c8, y(K.value), 1)
          ], 8, l8)
        ], 64)) : e.field.type === "date" && Y.value.length ? (p(), h("div", d8, [
          c("span", {
            id: `${r.value}-${e.field.id}-format-lbl`
          }, y(u(i)("plugin.pdf.format")), 9, f8),
          tt(ui, {
            options: Y.value,
            "model-value": ie.value,
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-format-lbl`,
            "testid-prefix": `${r.value}-format`,
            "onUpdate:modelValue": X[9] || (X[9] = (Be) => w(String(Be)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ])) : D("", !0),
        N.value ? (p(), h("div", {
          key: 5,
          class: "fe-signfonts fe-spdf__prop",
          role: "group",
          "aria-label": u(i)("plugin.pdf.font"),
          "data-testid": `${r.value}-fonts`
        }, [
          (p(!0), h(Ce, null, ot(u(pl), (Be) => (p(), h("button", {
            key: Be.key,
            type: "button",
            class: Fe(["fe-signfonts__btn", [Be.className, { "is-on": (e.field.font ?? "caveat") === Be.key }]]),
            title: Be.name,
            disabled: e.disabled,
            "aria-pressed": (e.field.font ?? "caveat") === Be.key ? "true" : "false",
            "data-testid": `${r.value}-font-${Be.key}`,
            onClick: (We) => k(Be.key)
          }, " Aa ", 10, h8))), 128))
        ], 8, p8)) : D("", !0),
        x.value && B.value.length ? (p(), h("div", {
          key: 6,
          class: "fe-spdf__prop fe-spdf__lines",
          "data-testid": `${r.value}-lines`
        }, [
          c("span", {
            id: `${r.value}-${e.field.id}-lines-lbl`
          }, y(u(i)("plugin.pdf.lines")), 9, v8),
          tt(ui, {
            options: B.value,
            "model-value": L.value,
            multi: "",
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-lines-lbl`,
            "testid-prefix": `${r.value}-line`,
            "onUpdate:modelValue": O
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"]),
          c("div", {
            class: "fe-spdf__linepreview",
            "data-testid": `${r.value}-lines-preview`
          }, [
            c("span", g8, y(u(i)("plugin.pdf.lines_preview")), 1),
            U.value.length ? (p(!0), h(Ce, { key: 0 }, ot(U.value, (Be, We) => (p(), h("span", {
              key: We,
              class: "fe-spdf__linepreview-line"
            }, y(Be), 1))), 128)) : (p(), h("span", b8, y(u(i)("plugin.pdf.lines_none")), 1))
          ], 8, y8)
        ], 8, m8)) : D("", !0),
        En(H.$slots, "extra"),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--sm fe-btn--danger",
          disabled: e.disabled,
          "data-testid": `${r.value}-delete`,
          onClick: X[10] || (X[10] = (Be) => a("remove"))
        }, y(u(i)("plugin.pdf.delete")), 9, k8)
      ], 8, HI);
    };
  }
}), w8 = ["data-state", "data-layout"], _8 = {
  key: 0,
  class: "fe-spdf__bar"
}, x8 = ["aria-label"], S8 = ["disabled", "aria-pressed", "data-testid", "onClick"], $8 = {
  key: 0,
  class: "fe-spdf__done",
  "data-testid": "surface-pdf-all-placed"
}, T8 = ["aria-label"], A8 = ["disabled", "aria-pressed", "data-testid", "onClick"], E8 = { class: "fe-spdf__zoom" }, C8 = ["aria-label", "disabled"], z8 = ["aria-label", "disabled"], M8 = ["aria-label", "disabled"], P8 = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info fe-spdf__hint"
}, O8 = {
  key: 2,
  class: "fe-spdf__define",
  "data-testid": "surface-pdf-define"
}, D8 = {
  key: 0,
  class: "fe-spdf__empty",
  "data-testid": "surface-pdf-no-boxes"
}, L8 = ["data-testid"], R8 = {
  class: "fe-spdf__cardno",
  "aria-hidden": "true"
}, N8 = ["aria-label"], I8 = { class: "fe-spdf__addlbl" }, B8 = ["disabled", "data-testid", "onClick"], F8 = {
  key: 3,
  class: "fe-spdf__strip",
  "data-testid": "surface-pdf-strip"
}, U8 = {
  key: 0,
  class: "fe-spdf__props",
  "data-testid": "surface-pdf-selected"
}, H8 = {
  key: 0,
  class: "fe-spdf__propwho"
}, K8 = {
  key: 1,
  class: "fe-spdf__prop"
}, V8 = ["max"], j8 = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info fe-spdf__hint",
  "data-testid": "surface-pdf-place-hint"
}, q8 = {
  key: 2,
  class: "fe-surface__text fe-surface__text--muted fe-spdf__hint",
  "data-testid": "surface-pdf-idle-hint"
}, W8 = {
  key: 4,
  "data-testid": "surface-pdf-selected"
}, Y8 = {
  key: 0,
  class: "fe-spdf__prop"
}, G8 = ["max"], X8 = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, J8 = {
  key: 1,
  class: "fe-surface__unknown",
  role: "alert",
  "data-testid": "surface-pdf-error"
}, Z8 = {
  key: 2,
  class: "fe-spdf__pages"
}, Q8 = ["data-page", "onPointerdown"], eB = ["data-testid", "data-field-type", "role", "tabindex", "title", "onPointerdown", "onClick", "onKeydown"], tB = ["src"], nB = ["value", "placeholder", "aria-label", "inputmode", "maxlength", "aria-invalid", "aria-describedby", "title", "disabled", "data-testid", "onInput"], aB = ["innerHTML"], iB = {
  key: 4,
  class: "fe-spdf__label"
}, oB = {
  key: 0,
  class: "fe-spdf__who"
}, rB = {
  key: 1,
  class: "fe-spdf__who"
}, sB = ["id", "role", "data-testid"], lB = ["onPointerdown"], uB = {
  key: 6,
  class: "fe-spdf__pad",
  "data-testid": "surface-pdf-pad"
}, cB = { class: "fe-surface__text fe-surface__text--muted" }, dB = /* @__PURE__ */ lt({
  __name: "SurfacePdfFields",
  props: {
    id: {},
    src: {},
    mode: {},
    fields: {},
    signers: {},
    signer: {},
    types: {},
    formats: {},
    dateLabels: {},
    modelValue: {},
    locale: {},
    theme: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    api: {},
    fileUrl: { type: Function },
    pdfWorkerUrl: {},
    layout: {},
    pageHeight: {},
    stampLines: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = E(() => n.mode !== "fill"), l = E(() => n.mode === "define"), d = E(() => n.mode === "place"), f = E(() => T4(n.signers)), m = E(() => y4(n.types)), v = $([]);
    let b;
    function _() {
      r.value ? v.value = Array.isArray(n.modelValue) ? uf(n.modelValue) : uf(n.fields) : v.value = E4(uf(n.fields), n.modelValue);
    }
    function w() {
      const pe = r.value ? v.value.map((Le) => ({ ...Le })) : iS(v.value, n.signer);
      b = pe, a("update:modelValue", pe);
    }
    let k = !1;
    function x() {
      if (be) {
        k = !0;
        return;
      }
      _();
    }
    _(), Xe([() => n.fields, () => n.mode, () => n.signer], () => x()), Xe(
      () => n.modelValue,
      (pe) => {
        pe !== b && x();
      }
    );
    const M = E(() => {
      const pe = /* @__PURE__ */ new Map();
      for (const Le of v.value) {
        if (!Lv(Le)) continue;
        const Ue = pe.get(Le.page) ?? [];
        Ue.push(Le), pe.set(Le.page, Ue);
      }
      return pe;
    });
    function A(pe) {
      return A4(f.value, pe.assignee);
    }
    function T(pe) {
      const Le = A(pe), Ue = bS(Le);
      return Ue ? { "--spdf-color": Le, "--spdf-ink": Ue } : { "--spdf-color": Le };
    }
    function N(pe) {
      const Le = f.value.find((Ue) => Ue.id === pe);
      return Le ? Gt(Le.label, n.locale) || Le.id : pe || "";
    }
    function z(pe) {
      return !r.value && aS(pe, n.signer);
    }
    function L(pe) {
      return i(`plugin.pdf.type_${pe}`);
    }
    function B(pe) {
      const Le = (pe.label ?? "").trim();
      if (Le) return Le;
      const Ue = v.value.filter((He) => He.type === pe.type && !(He.label ?? "").trim());
      return Ue.length < 2 ? L(pe.type) : `${L(pe.type)} ${Ue.findIndex((He) => He.id === pe.id) + 1}`;
    }
    const O = $("loading"), U = $([]), S = $(1), F = $(null), I = $(640), G = $(0), Y = E(() => n.layout === "page");
    let ie = null, me = 0, q = null, C = null;
    const re = /* @__PURE__ */ new Map(), de = /* @__PURE__ */ new Map(), V = /* @__PURE__ */ new Map(), W = E(() => {
      if (!Y.value) return I.value;
      const pe = U.value[0];
      return pe ? l4({ width: I.value, height: G.value }, pe) : I.value;
    }), ne = E(() => Math.max(120, Math.round(W.value * S.value)));
    async function K() {
      var Ue, He;
      const pe = n.src ?? {};
      if (pe.path) {
        if (!n.api) throw new Error("no api");
        const wt = await n.api.fetchBlob(pe.path);
        return URL.revokeObjectURL(wt.url), wt.blob.arrayBuffer();
      }
      const Le = pe.url || (pe.ref ? (He = (Ue = n.fileUrl) == null ? void 0 : Ue.call(n, pe.ref)) == null ? void 0 : He.url : "");
      if (!Le) throw new Error("no source");
      return RI({ url: Le, headers: {}, credentials: "same-origin" });
    }
    async function ce() {
      var Le, Ue;
      const pe = ++me;
      O.value = "loading", U.value = [], J();
      try {
        (Le = ie == null ? void 0 : ie.destroy) == null || Le.call(ie);
      } catch {
      }
      ie = null;
      try {
        const He = await UI(n.pdfWorkerUrl ?? void 0);
        if (!He) throw new Error("pdfjs unavailable");
        const wt = await K();
        if (pe !== me) return;
        const et = await He.getDocument({ data: wt }).promise;
        if (pe !== me) {
          (Ue = et.destroy) == null || Ue.call(et);
          return;
        }
        ie = et;
        const oe = [];
        for (let je = 1; je <= et.numPages; je++) {
          const _t = (await et.getPage(je)).getViewport({ scale: 1 });
          oe.push({ num: je, width: _t.width, height: _t.height, rotation: _t.rotation ?? 0 });
        }
        if (pe !== me) return;
        U.value = oe, O.value = "ok", await Zt(), X();
      } catch {
        if (pe !== me) return;
        O.value = "error";
      }
    }
    function J() {
      q == null || q.disconnect(), q = null, re.clear(), de.clear(), V.clear();
    }
    function H(pe, Le) {
      if (!(Le instanceof HTMLDivElement)) return;
      const Ue = re.get(pe);
      Ue !== Le && (Ue && (q == null || q.unobserve(Ue)), re.set(pe, Le), ie && (q ? q.observe(Le) : typeof IntersectionObserver > "u" && we(pe), Ue && (de.delete(pe), V.delete(pe))));
    }
    function X() {
      if (typeof IntersectionObserver > "u") {
        for (const pe of re.keys()) we(pe);
        return;
      }
      q = new IntersectionObserver(
        (pe) => {
          for (const Le of pe) {
            const Ue = Number(Le.target.dataset.page);
            Le.isIntersecting && we(Ue);
          }
        },
        { rootMargin: "200px 0px" }
      );
      for (const pe of re.values()) q.observe(pe);
    }
    async function we(pe) {
      if (!ie || !re.get(pe)) return;
      const Ue = ne.value;
      if (de.get(pe) === Ue) return;
      de.set(pe, Ue);
      const He = U.value.find((je) => je.num === pe);
      if (!He) return;
      const wt = typeof window < "u" && window.devicePixelRatio > 0 ? Math.min(3, window.devicePixelRatio) : 1, et = Ue / He.width * wt, oe = ie;
      try {
        const je = await oe.getPage(pe), Ke = je.getViewport({ scale: et }), _t = document.createElement("canvas");
        _t.className = "fe-spdf__canvas", _t.width = Math.round(Ke.width), _t.height = Math.round(Ke.height);
        const ee = _t.getContext("2d");
        if (!ee || (await je.render({ canvasContext: ee, viewport: Ke }).promise, oe !== ie || de.get(pe) !== Ue)) return;
        const he = re.get(pe);
        if (!he) return;
        const Oe = V.get(pe);
        Oe && Oe.parentNode === he ? he.replaceChild(_t, Oe) : he.prepend(_t), V.set(pe, _t);
      } catch {
        de.get(pe) === Ue && de.delete(pe);
      }
    }
    function it() {
      for (const pe of re.keys())
        de.has(pe) && (de.delete(pe), we(pe));
    }
    Xe(ne, () => it());
    function Re() {
      S.value = Math.min(3, Math.round(S.value * 1.25 * 100) / 100);
    }
    function Be() {
      S.value = Math.max(0.5, Math.round(S.value / 1.25 * 100) / 100);
    }
    function We() {
      S.value = 1;
    }
    function bt() {
      const pe = F.value;
      pe && (I.value = pe.clientWidth || I.value, G.value = pe.clientHeight || G.value, !(typeof ResizeObserver > "u") && (C == null || C.disconnect(), C = new ResizeObserver(() => at()), C.observe(pe)));
    }
    function at() {
      var Ue, He;
      if (be) {
        Ie = !0;
        return;
      }
      const pe = ((Ue = F.value) == null ? void 0 : Ue.clientWidth) ?? 0, Le = ((He = F.value) == null ? void 0 : He.clientHeight) ?? 0;
      pe > 0 && Math.abs(pe - I.value) > 2 && (I.value = pe), Le > 0 && Math.abs(Le - G.value) > 2 && (G.value = Le);
    }
    let Ie = !1;
    Xe(F, () => {
      Zt(bt);
    }), Wt(() => {
      bt(), ce();
    });
    const nt = E(() => {
      const pe = n.src ?? {};
      return [pe.ref ?? "", pe.path ?? "", pe.url ?? ""].join("\0");
    });
    Xe(nt, () => void ce()), Ot(() => {
      var pe;
      me++, J(), C == null || C.disconnect();
      try {
        (pe = ie == null ? void 0 : ie.destroy) == null || pe.call(ie);
      } catch {
      }
      ie = null;
    });
    const dt = $(""), Me = $("");
    let be = null;
    const Ve = $(null);
    function Te(pe, Le) {
      const Ue = Le.getBoundingClientRect();
      return C_({ x: pe.clientX - Ue.left, y: pe.clientY - Ue.top }, { width: Ue.width, height: Ue.height });
    }
    function qe(pe) {
      const Le = re.get(pe.page), Ue = Le && Le.isConnected ? Le : pe.el;
      if (!Ue || !Ue.isConnected) return null;
      const He = Ue.getBoundingClientRect();
      return He.width >= 1 && He.height >= 1 ? He : null;
    }
    function De(pe, Le) {
      return C_({ x: pe.clientX - Le.left, y: pe.clientY - Le.top }, { width: Le.width, height: Le.height });
    }
    function mt(pe) {
      Me.value = Me.value === pe ? "" : pe, dt.value = "";
    }
    function $t(pe) {
      const Le = b4(v.value, pe, {
        assignee: ht(),
        required: !0
      });
      v.value = [...v.value, Le], w();
    }
    function kt(pe) {
      v.value = v.value.map((Le) => Le.id === pe.id ? pe : Le), w();
    }
    function Tt(pe) {
      v.value = v.value.filter((Le) => Le.id !== pe), dt.value === pe && (dt.value = ""), w();
    }
    const xe = E(() => g4(v.value)), Ne = $("");
    function fe(pe) {
      Ne.value = Ne.value === pe ? "" : pe, dt.value = "";
    }
    function Se(pe, Le) {
      const Ue = Ne.value;
      Ue && (v.value = v.value.map((He) => {
        if (He.id !== Ue) return He;
        const wt = { ...He, page: pe, ...el(Le) };
        return delete wt.placed, wt;
      }), Ne.value = "", dt.value = Ue, w());
    }
    function Z() {
      const pe = dt.value;
      pe && (v.value = v.value.map((Le) => Le.id === pe ? { ...Le, placed: !1 } : Le), dt.value = "", w());
    }
    function ge(pe) {
      const Le = N(pe.assignee), Ue = B(pe);
      return Le ? `${Ue} · ${Le}` : Ue;
    }
    function ae(pe, Le) {
      var He, wt;
      if (!r.value || n.disabled) return;
      const Ue = pe.currentTarget;
      if (d.value && Ne.value) {
        be = { kind: "place", page: Le, el: Ue, start: Te(pe, Ue) }, Ve.value = null, tn(), (He = pe.preventDefault) == null || He.call(pe);
        return;
      }
      if (Me.value) {
        be = { kind: "place", page: Le, el: Ue, start: Te(pe, Ue) }, Ve.value = null, tn(), (wt = pe.preventDefault) == null || wt.call(pe);
        return;
      }
      dt.value = "";
    }
    function ve(pe, Le, Ue) {
      var wt;
      if (!r.value || n.disabled) return;
      const He = pe.currentTarget.closest(".fe-spdf__page");
      He && (dt.value = Le.id, Me.value = "", be = { kind: "move", page: Ue, el: He, start: Te(pe, He), id: Le.id, orig: { ...Le } }, tn(), pe.stopPropagation(), (wt = pe.preventDefault) == null || wt.call(pe));
    }
    function le(pe, Le, Ue) {
      var wt;
      if (!r.value || n.disabled) return;
      const He = pe.currentTarget.closest(".fe-spdf__page");
      He && (dt.value = Le.id, be = { kind: "resize", page: Ue, el: He, start: Te(pe, He), id: Le.id, orig: { ...Le } }, tn(), pe.stopPropagation(), (wt = pe.preventDefault) == null || wt.call(pe));
    }
    function _e(pe) {
      if (!be) return;
      const Le = qe(be);
      if (!Le) return;
      const Ue = De(pe, Le);
      if (be.kind === "place") {
        const Ke = Ud(be.start, Ue);
        Ve.value = { page: be.page, ...Ke };
        return;
      }
      if (!be.id || !be.orig) return;
      const He = Ue.x - be.start.x, wt = Ue.y - be.start.y, et = be.orig, oe = be.kind === "move" ? el({ x: et.x + He, y: et.y + wt, w: et.w, h: et.h }) : el({ x: et.x, y: et.y, w: et.w + He, h: et.h + wt }), je = be.id;
      v.value = v.value.map((Ke) => Ke.id === je ? { ...Ke, ...oe } : Ke);
    }
    function Ee(pe) {
      if (!be) return;
      const Le = be;
      be = null, Cn();
      const Ue = qe(Le);
      Ie && (Ie = !1, at());
      const He = Le.kind === "place" || Le.kind === "move" || Le.kind === "resize";
      if (k && (k = !1, He || _()), !Ue) {
        Ve.value = null, (Le.kind === "move" || Le.kind === "resize") && w();
        return;
      }
      if (Le.kind === "place" && d.value && Ne.value) {
        const wt = De(pe, Ue), et = v.value.find((Ke) => Ke.id === Ne.value), je = Math.abs(wt.x - Le.start.x) > 0.01 || Math.abs(wt.y - Le.start.y) > 0.01 ? Ud(Le.start, wt) : { x: wt.x - ((et == null ? void 0 : et.w) ?? 0.2) / 2, y: wt.y - ((et == null ? void 0 : et.h) ?? 0.05) / 2, w: (et == null ? void 0 : et.w) ?? 0.2, h: (et == null ? void 0 : et.h) ?? 0.05 };
        Se(Le.page, je), Ve.value = null;
        return;
      }
      if (Le.kind === "place" && Me.value) {
        const wt = De(pe, Ue), et = Math.abs(wt.x - Le.start.x) > 0.01 || Math.abs(wt.y - Le.start.y) > 0.01, oe = Me.value, je = et ? O_(v.value, oe, Le.page, Ud(Le.start, wt), Ud(Le.start, wt), ht()) : O_(v.value, oe, Le.page, { x: wt.x - Uf[oe].w / 2, y: wt.y - Uf[oe].h / 2 }, void 0, ht());
        v.value = [...v.value, { ...je, label: L(oe) }], dt.value = je.id, Ve.value = null, w();
        return;
      }
      if (Ve.value = null, Le.kind === "move" || Le.kind === "resize") {
        const wt = v.value.find((oe) => oe.id === Le.id), et = Le.orig;
        (!wt || !et || wt.x !== et.x || wt.y !== et.y || wt.w !== et.w || wt.h !== et.h) && w();
      }
    }
    function ht() {
      return f.value.length === 1 ? f.value[0].id : void 0;
    }
    const jt = $(!1);
    function tn() {
      jt.value = !0, window.addEventListener("pointermove", _e), window.addEventListener("pointerup", Ee), window.addEventListener("pointercancel", Ee);
    }
    function Cn() {
      jt.value = !1, window.removeEventListener("pointermove", _e), window.removeEventListener("pointerup", Ee), window.removeEventListener("pointercancel", Ee);
    }
    const Lt = E(() => v.value.find((pe) => pe.id === dt.value) ?? null), At = $(1);
    function zn() {
      if (!Lt.value) return;
      const pe = v.value.length;
      v.value = z4(v.value, dt.value, At.value), v.value.length !== pe && (dt.value = v.value[v.value.length - 1].id, w());
    }
    function Bt() {
      const pe = F.value, Le = Lt.value;
      if (!pe || !Le || be || !Lv(Le)) return;
      const Ue = re.get(Le.page);
      if (!Ue) return;
      const He = Ue.getBoundingClientRect(), wt = pe.getBoundingClientRect();
      if (!He.height || !wt.height) return;
      const et = He.top - wt.top + pe.scrollTop + Le.y * He.height, oe = et + Le.h * He.height, je = 24;
      et < pe.scrollTop + je ? pe.scrollTop = Math.max(0, et - je) : oe > pe.scrollTop + pe.clientHeight - je && (pe.scrollTop = oe - pe.clientHeight + je);
    }
    Xe(dt, () => void Zt(Bt));
    const ft = $("");
    function Dn(pe, Le) {
      v.value = C4(v.value, pe, Le), w();
    }
    function Qn(pe) {
      if (!(r.value || n.disabled || !z(pe)))
        switch (pe.type) {
          case "signature":
          case "initials":
            ft.value = ft.value === pe.id ? "" : pe.id;
            break;
          case "checkbox":
            Dn(pe.id, pe.value !== !0);
            break;
          case "date":
            Dn(pe.id, Rv(pe) ? "" : M4());
            break;
        }
    }
    function Ln(pe, Le) {
      const Ue = Le.target, He = f4(Ue.value, kn(pe));
      He !== Ue.value && (Ue.value = He), Dn(pe.id, He);
    }
    const on = E(() => v.value.find((pe) => pe.id === ft.value) ?? null), In = E(() => {
      var pe;
      return ((pe = on.value) == null ? void 0 : pe.style) === "typed" ? ["type"] : ["draw", "upload"];
    }), la = E(
      () => {
        var pe;
        return ((pe = on.value) == null ? void 0 : pe.style) === "typed" && on.value.font ? [on.value.font] : void 0;
      }
    ), vn = E(() => {
      var Le;
      const pe = (Le = on.value) == null ? void 0 : Le.value;
      return typeof pe == "string" && pe ? { png_b64: pe, mode: "draw" } : null;
    });
    function nn(pe) {
      on.value && Dn(on.value.id, (pe == null ? void 0 : pe.png_b64) ?? "");
    }
    function ln(pe) {
      return typeof pe.value == "string" && pe.value ? `data:image/png;base64,${pe.value}` : "";
    }
    function kn(pe) {
      return pe.type === "text" ? pe.rule ?? null : null;
    }
    function Mn(pe) {
      const Le = kn(pe);
      if (!Le) return "";
      const Ue = [];
      return Le.kind === "number" ? Ue.push(i("plugin.pdf.rule_number")) : Le.kind === "email" && Ue.push(i("plugin.pdf.rule_email")), Le.min && Le.max ? Ue.push(i("plugin.pdf.rule_length", { min: Le.min, max: Le.max })) : Le.min ? Ue.push(i("plugin.pdf.rule_min", { min: Le.min })) : Le.max && Ue.push(i("plugin.pdf.rule_max", { max: Le.max })), Ue.join(" · ");
    }
    function Hn(pe) {
      const Le = kn(pe), Ue = p4(pe.value, Le);
      return !Ue || !Le ? "" : Ue === "min" ? i("plugin.pdf.err_min", { min: Le.min ?? 0 }) : Ue === "max" ? i("plugin.pdf.err_max", { max: Le.max ?? 0 }) : i(`plugin.pdf.err_${Ue}`);
    }
    function rn(pe) {
      return Zx(pe.font).className;
    }
    const Ea = zt("check");
    return (pe, Le) => (p(), h("div", {
      class: Fe(["fe-spdf", {
        "is-edit": r.value,
        "is-fill": !r.value,
        "is-invalid": e.invalid,
        "is-disabled": e.disabled,
        "is-placing": !!Me.value || !!Ne.value,
        "is-define": l.value,
        "fe-spdf--page": Y.value && !l.value
      }]),
      "data-testid": "surface-pdf-fields",
      style: Yt(Y.value ? { "--spdf-h": e.pageHeight || "100%" } : void 0),
      "data-state": O.value,
      "data-layout": Y.value ? "page" : "inline"
    }, [
      l.value ? D("", !0) : (p(), h("div", _8, [
        d.value ? (p(), h("div", {
          key: 0,
          class: "fe-spdf__palette",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.pending")
        }, [
          (p(!0), h(Ce, null, ot(xe.value, (Ue) => (p(), h("button", {
            key: Ue.id,
            type: "button",
            class: Fe(["fe-btn fe-btn--sm", { "fe-btn--primary": Ne.value === Ue.id }]),
            style: Yt({ "--spdf-color": A(Ue) }),
            disabled: e.disabled || O.value !== "ok",
            "aria-pressed": Ne.value === Ue.id ? "true" : "false",
            "data-testid": `surface-pdf-pending-${Ue.id}`,
            onClick: (He) => fe(Ue.id)
          }, y(ge(Ue)), 15, S8))), 128)),
          xe.value.length ? D("", !0) : (p(), h("span", $8, y(u(i)("plugin.pdf.all_placed")), 1))
        ], 8, x8)) : r.value ? (p(), h("div", {
          key: 1,
          class: "fe-spdf__palette",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.palette")
        }, [
          (p(!0), h(Ce, null, ot(m.value, (Ue) => (p(), h("button", {
            key: Ue,
            type: "button",
            class: Fe(["fe-btn fe-btn--sm", { "fe-btn--primary": Me.value === Ue }]),
            disabled: e.disabled || O.value !== "ok",
            "aria-pressed": Me.value === Ue ? "true" : "false",
            "data-testid": `surface-pdf-type-${Ue}`,
            onClick: (He) => mt(Ue)
          }, y(L(Ue)), 11, A8))), 128))
        ], 8, T8)) : D("", !0),
        c("div", E8, [
          c("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "aria-label": u(i)("plugin.pdf.zoom_out"),
            disabled: O.value !== "ok",
            onClick: Be
          }, "−", 8, C8),
          c("button", {
            type: "button",
            class: "fe-btn fe-btn--sm fe-spdf__zoomval",
            "aria-label": u(i)(Y.value ? "plugin.pdf.zoom_fit_page" : "plugin.pdf.zoom_fit"),
            disabled: O.value !== "ok",
            onClick: We
          }, y(Math.round(S.value * 100)) + "% ", 9, z8),
          c("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "aria-label": u(i)("plugin.pdf.zoom_in"),
            disabled: O.value !== "ok",
            onClick: Re
          }, "+", 8, M8)
        ])
      ])),
      r.value && !l.value && !d.value && Me.value ? (p(), h("p", P8, y(u(i)("plugin.pdf.place_hint", { type: L(Me.value) })), 1)) : D("", !0),
      l.value ? (p(), h("div", O8, [
        v.value.length ? D("", !0) : (p(), h("div", D8, y(u(i)("plugin.pdf.no_boxes")), 1)),
        (p(!0), h(Ce, null, ot(v.value, (Ue, He) => (p(), h("div", {
          key: Ue.id,
          class: "fe-spdf__card",
          style: Yt(T(Ue)),
          "data-testid": `surface-pdf-card-${Ue.id}`
        }, [
          c("span", R8, y(He + 1), 1),
          tt(U_, {
            field: Ue,
            signers: f.value,
            formats: e.formats,
            "date-labels": e.dateLabels,
            "stamp-lines": e.stampLines,
            locale: e.locale,
            disabled: e.disabled,
            "testid-prefix": `surface-pdf-card-${Ue.id}`,
            onPatch: kt,
            onRemove: (wt) => Tt(Ue.id)
          }, null, 8, ["field", "signers", "formats", "date-labels", "stamp-lines", "locale", "disabled", "testid-prefix", "onRemove"])
        ], 12, L8))), 128)),
        c("div", {
          class: "fe-spdf__add",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.add_box")
        }, [
          c("span", I8, y(u(i)("plugin.pdf.add_box")), 1),
          (p(!0), h(Ce, null, ot(m.value, (Ue) => (p(), h("button", {
            key: Ue,
            type: "button",
            class: "fe-btn fe-btn--sm",
            disabled: e.disabled,
            "data-testid": `surface-pdf-add-${Ue}`,
            onClick: (He) => $t(Ue)
          }, " + " + y(L(Ue)), 9, B8))), 128))
        ], 8, N8)
      ])) : d.value ? (p(), h("div", F8, [
        Lt.value ? (p(), h("div", U8, [
          c("span", {
            class: "fe-spdf__propname",
            style: Yt({ "--spdf-color": A(Lt.value) })
          }, y(B(Lt.value)), 5),
          N(Lt.value.assignee) ? (p(), h("span", H8, y(N(Lt.value.assignee)), 1)) : D("", !0),
          c("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "data-testid": "surface-pdf-unplace",
            onClick: Z
          }, y(u(i)("plugin.pdf.unplace")), 1),
          U.value.length > 1 ? (p(), h("label", K8, [
            c("span", null, y(u(i)("plugin.pdf.copy_to_page")), 1),
            un(c("input", {
              "onUpdate:modelValue": Le[0] || (Le[0] = (Ue) => At.value = Ue),
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "1",
              max: U.value.length,
              "data-testid": "surface-pdf-copy-page"
            }, null, 8, V8), [
              [
                bn,
                At.value,
                void 0,
                { number: !0 }
              ]
            ]),
            c("button", {
              type: "button",
              class: "fe-btn fe-btn--sm",
              "data-testid": "surface-pdf-copy",
              onClick: zn
            }, y(u(i)("plugin.pdf.copy")), 1)
          ])) : D("", !0),
          c("button", {
            type: "button",
            class: "fe-btn fe-btn--sm fe-btn--danger",
            "data-testid": "surface-pdf-delete",
            onClick: Le[1] || (Le[1] = (Ue) => Tt(Lt.value.id))
          }, y(u(i)("plugin.pdf.delete")), 1)
        ])) : Ne.value ? (p(), h("p", j8, y(u(i)("plugin.pdf.place_box_hint", { name: ge(v.value.find((Ue) => Ue.id === Ne.value) ?? v.value[0]) })), 1)) : (p(), h("p", q8, y(u(i)(xe.value.length ? "plugin.pdf.place_idle" : "plugin.pdf.place_idle_done")), 1))
      ])) : r.value && Lt.value && !jt.value ? (p(), h("div", W8, [
        tt(U_, {
          field: Lt.value,
          signers: f.value,
          formats: e.formats,
          "date-labels": e.dateLabels,
          "stamp-lines": e.stampLines,
          locale: e.locale,
          disabled: e.disabled,
          "testid-prefix": "surface-pdf",
          onPatch: kt,
          onRemove: Le[3] || (Le[3] = (Ue) => Tt(Lt.value.id))
        }, {
          extra: gt(() => [
            U.value.length > 1 ? (p(), h("label", Y8, [
              c("span", null, y(u(i)("plugin.pdf.copy_to_page")), 1),
              un(c("input", {
                "onUpdate:modelValue": Le[2] || (Le[2] = (Ue) => At.value = Ue),
                class: "fe-cfield__input fe-spdf__num",
                type: "number",
                min: "1",
                max: U.value.length,
                "data-testid": "surface-pdf-copy-page"
              }, null, 8, G8), [
                [
                  bn,
                  At.value,
                  void 0,
                  { number: !0 }
                ]
              ]),
              c("button", {
                type: "button",
                class: "fe-btn fe-btn--sm",
                "data-testid": "surface-pdf-copy",
                onClick: zn
              }, y(u(i)("plugin.pdf.copy")), 1)
            ])) : D("", !0)
          ]),
          _: 1
        }, 8, ["field", "signers", "formats", "date-labels", "stamp-lines", "locale", "disabled"])
      ])) : D("", !0),
      l.value ? D("", !0) : (p(), h("div", {
        key: 5,
        ref_key: "containerEl",
        ref: F,
        class: "fe-spdf__scroll"
      }, [
        O.value === "loading" ? (p(), h("p", X8, y(u(i)("plugin.view.loading")), 1)) : O.value === "error" ? (p(), h("p", J8, y(u(i)("plugin.pdf.load_failed")), 1)) : (p(), h("div", Z8, [
          (p(!0), h(Ce, null, ot(U.value, (Ue) => (p(), h("div", {
            key: Ue.num,
            ref_for: !0,
            ref: (He) => H(Ue.num, He),
            class: "fe-spdf__page",
            "data-page": Ue.num,
            style: Yt({ width: `${ne.value}px`, aspectRatio: `${Ue.width} / ${Ue.height}` }),
            onPointerdown: (He) => ae(He, Ue.num)
          }, [
            (p(!0), h(Ce, null, ot(M.value.get(Ue.num) ?? [], (He) => (p(), h("div", {
              key: He.id,
              class: Fe(["fe-spdf__field", [
                `fe-spdf__field--${He.type}`,
                {
                  "is-selected": r.value && dt.value === He.id,
                  "is-mine": z(He),
                  "is-foreign": !r.value && !z(He),
                  "is-filled": u(Rv)(He),
                  "is-required": He.required === !0
                }
              ]]),
              style: Yt({ left: `${He.x * 100}%`, top: `${He.y * 100}%`, width: `${He.w * 100}%`, height: `${He.h * 100}%`, "--spdf-color": A(He) }),
              "data-testid": `surface-pdf-field-${He.id}`,
              "data-field-type": He.type,
              role: z(He) ? "button" : void 0,
              tabindex: z(He) ? 0 : void 0,
              title: r.value || !z(He) ? N(He.assignee) : void 0,
              onPointerdown: (wt) => ve(wt, He, Ue.num),
              onClick: (wt) => Qn(He),
              onKeydown: $a(vt((wt) => Qn(He), ["prevent"]), ["enter"])
            }, [
              (He.type === "signature" || He.type === "initials") && ln(He) ? (p(), h("img", {
                key: 0,
                class: "fe-spdf__sig",
                src: ln(He),
                alt: ""
              }, null, 8, tB)) : He.type === "text" && z(He) ? (p(), h("input", {
                key: 1,
                class: Fe(["fe-spdf__text", rn(He)]),
                type: "text",
                value: typeof He.value == "string" ? He.value : "",
                placeholder: B(He),
                "aria-label": B(He),
                inputmode: u(d4)(kn(He)),
                maxlength: u(Qx)(kn(He)),
                "aria-invalid": Hn(He) ? "true" : void 0,
                "aria-describedby": Mn(He) ? `${e.id}-${He.id}-rule` : void 0,
                title: Mn(He) || void 0,
                disabled: e.disabled,
                "data-testid": `surface-pdf-text-${He.id}`,
                onPointerdown: Le[4] || (Le[4] = vt(() => {
                }, ["stop"])),
                onClick: Le[5] || (Le[5] = vt(() => {
                }, ["stop"])),
                onInput: (wt) => Ln(He, wt)
              }, null, 42, nB)) : He.type === "checkbox" && He.value === !0 ? (p(), h("span", {
                key: 2,
                class: "fe-spdf__check",
                "aria-hidden": "true",
                innerHTML: u(Ea)
              }, null, 8, aB)) : He.type === "date" && typeof He.value == "string" && He.value ? (p(), h("span", {
                key: 3,
                class: Fe(["fe-spdf__val", rn(He)])
              }, y(He.value), 3)) : (p(), h("span", iB, [
                Ht(y(B(He)) + " ", 1),
                z(He) ? (p(), h("small", oB, y(u(i)(`plugin.pdf.tap_${He.type}`)), 1)) : He.assignee && (r.value || !z(He)) ? (p(), h("small", rB, y(N(He.assignee)), 1)) : D("", !0)
              ])),
              !r.value && z(He) && He.type === "text" && (Hn(He) || Mn(He)) ? (p(), h("span", {
                key: 5,
                id: `${e.id}-${He.id}-rule`,
                class: Fe(["fe-spdf__rule", { "is-bad": !!Hn(He) }]),
                role: Hn(He) ? "alert" : void 0,
                "data-testid": `surface-pdf-rule-${He.id}`
              }, y(Hn(He) || Mn(He)), 11, sB)) : D("", !0),
              r.value ? (p(), h("span", {
                key: 6,
                class: "fe-spdf__handle",
                "data-testid": "surface-pdf-handle",
                onPointerdown: (wt) => le(wt, He, Ue.num)
              }, null, 40, lB)) : D("", !0)
            ], 46, eB))), 128)),
            Ve.value && Ve.value.page === Ue.num ? (p(), h("div", {
              key: 0,
              class: "fe-spdf__field fe-spdf__field--ghost",
              style: Yt({ left: `${Ve.value.x * 100}%`, top: `${Ve.value.y * 100}%`, width: `${Ve.value.w * 100}%`, height: `${Ve.value.h * 100}%` })
            }, null, 4)) : D("", !0)
          ], 44, Q8))), 128))
        ]))
      ], 512)),
      !r.value && on.value ? (p(), h("div", uB, [
        c("p", cB, y(u(i)("plugin.pdf.pad_for", { type: B(on.value) })), 1),
        tt(yS, {
          id: `${e.id}-${on.value.id}`,
          "model-value": vn.value,
          modes: In.value,
          font: on.value.font,
          fonts: la.value,
          locale: e.locale,
          disabled: e.disabled,
          width: on.value.type === "initials" ? 240 : void 0,
          height: on.value.type === "initials" ? 120 : void 0,
          "onUpdate:modelValue": nn
        }, null, 8, ["id", "model-value", "modes", "font", "fonts", "locale", "disabled", "width", "height"]),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--sm",
          "data-testid": "surface-pdf-pad-done",
          onClick: Le[6] || (Le[6] = (Ue) => ft.value = "")
        }, y(u(i)("plugin.pdf.pad_done")), 1)
      ])) : D("", !0)
    ], 14, w8));
  }
}), fB = { class: "fe-surface" }, pB = ["data-node"], hB = {
  key: 1,
  class: "fe-surface__divider"
}, mB = {
  key: 2,
  class: "fe-surface__row"
}, vB = ["data-node-type"], yB = {
  key: 14,
  class: "fe-surface__error"
}, gB = /* @__PURE__ */ lt({
  __name: "SurfaceRenderer",
  props: {
    nodes: {},
    locale: {},
    theme: {},
    errors: {},
    values: {},
    api: {},
    plugin: {},
    storages: {},
    startAt: {},
    disabled: { type: Boolean },
    fileUrl: { type: Function },
    pdfWorkerUrl: {},
    invalidKeys: {},
    layout: {},
    pageHeight: {}
  },
  emits: ["update:values", "change", "action"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = () => n.values ?? {};
    function l(x, M) {
      a("update:values", { ...r(), [x]: M });
    }
    function d(x) {
      a("update:values", x), a("change");
    }
    function f(x, M) {
      l(x.id, M), m(x).mode !== "fill" && a("change");
    }
    function m(x) {
      return x.props ?? {};
    }
    function v(x) {
      const M = m(x);
      return Gt(M.text ?? M.value ?? "", n.locale);
    }
    function b(x) {
      const M = String(m(x).tone ?? "");
      return M === "muted" || M === "danger" || M === "info" ? `fe-surface__text--${M}` : "";
    }
    function _(x) {
      return !x.id || !n.errors ? "" : Gt(n.errors[x.id], n.locale);
    }
    function w(x) {
      return typeof x == "string" ? x : "";
    }
    function k(x) {
      return Array.isArray(x) ? x : [];
    }
    return (x, M) => {
      const A = gz("SurfaceRenderer", !0);
      return p(), h("div", fB, [
        (p(!0), h(Ce, null, ot(e.nodes, (T, N) => (p(), h(Ce, {
          key: T.id || N
        }, [
          T.type === "text" ? (p(), h("p", {
            key: 0,
            class: Fe(["fe-surface__text", [b(T), m(T).heading ? "fe-surface__text--heading" : ""]]),
            "data-node": T.id || void 0
          }, y(v(T)), 11, pB)) : T.type === "divider" ? (p(), h("hr", hB)) : T.type === "row" ? (p(), h("div", mB, [
            tt(A, {
              nodes: T.children ?? [],
              locale: e.locale,
              theme: e.theme,
              errors: e.errors,
              values: e.values,
              api: e.api,
              plugin: e.plugin,
              storages: e.storages,
              "start-at": e.startAt,
              disabled: e.disabled,
              "file-url": e.fileUrl,
              "pdf-worker-url": e.pdfWorkerUrl,
              "invalid-keys": e.invalidKeys,
              layout: e.layout,
              "page-height": e.pageHeight,
              "onUpdate:values": M[0] || (M[0] = (z) => a("update:values", z)),
              onChange: M[1] || (M[1] = (z) => a("change")),
              onAction: M[2] || (M[2] = (z) => a("action", z))
            }, null, 8, ["nodes", "locale", "theme", "errors", "values", "api", "plugin", "storages", "start-at", "disabled", "file-url", "pdf-worker-url", "invalid-keys", "layout", "page-height"])
          ])) : T.type === "form" ? (p(), Je(z5, {
            key: 3,
            fields: m(T).fields ?? [],
            values: r(),
            locale: e.locale,
            errors: e.errors,
            invalid: e.invalidKeys,
            disabled: e.disabled,
            "onUpdate:values": d
          }, null, 8, ["fields", "values", "locale", "errors", "invalid", "disabled"])) : T.type === "steps" ? (p(), Je(R5, {
            key: 4,
            items: m(T).items ?? [],
            locale: e.locale
          }, null, 8, ["items", "locale"])) : T.type === "list" ? (p(), Je(KR, {
            key: 5,
            columns: m(T).columns ?? [],
            rows: m(T).rows ?? [],
            empty: m(T).empty,
            locale: e.locale,
            disabled: e.disabled,
            "table-id": e.plugin ? `app.${e.plugin}.${T.id || "list"}` : void 0,
            onAction: M[3] || (M[3] = (z) => a("action", z))
          }, null, 8, ["columns", "rows", "empty", "locale", "disabled", "table-id"])) : T.type === "progress" ? (p(), Je(GR, {
            key: 6,
            value: m(T).value,
            label: m(T).label,
            locale: e.locale
          }, null, 8, ["value", "label", "locale"])) : T.type === "people-picker" && T.id ? (p(), Je(mN, {
            key: 7,
            id: T.id,
            "model-value": k(r()[T.id]),
            multi: m(T).multi === !0,
            "allow-external": m(T).allow_external === !0,
            api: e.api,
            plugin: e.plugin,
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!_(T),
            "onUpdate:modelValue": (z) => l(T.id, z)
          }, null, 8, ["id", "model-value", "multi", "allow-external", "api", "plugin", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : T.type === "pin-input" && T.id ? (p(), Je(bN, {
            key: 8,
            id: T.id,
            length: m(T).length,
            "model-value": w(r()[T.id]),
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!_(T),
            "onUpdate:modelValue": (z) => l(T.id, z)
          }, null, 8, ["id", "length", "model-value", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : T.type === "file-chooser" && T.id ? (p(), Je(iI, {
            key: 9,
            id: T.id,
            kind: m(T).kind,
            "model-value": w(r()[T.id]),
            api: e.api,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            disabled: e.disabled,
            invalid: !!_(T),
            "onUpdate:modelValue": (z) => l(T.id, z)
          }, null, 8, ["id", "kind", "model-value", "api", "storages", "start-at", "locale", "theme", "disabled", "invalid", "onUpdate:modelValue"])) : T.type === "preview" ? (p(), Je(hI, {
            key: 10,
            path: w(m(T).path),
            "file-ref": w(m(T).ref),
            "file-url": e.fileUrl,
            api: e.api,
            locale: e.locale
          }, null, 8, ["path", "file-ref", "file-url", "api", "locale"])) : T.type === "signature-pad" && T.id ? (p(), Je(yS, {
            key: 11,
            id: T.id,
            modes: m(T).modes,
            width: m(T).width,
            height: m(T).height,
            font: m(T).font,
            fonts: m(T).fonts,
            label: u(Gt)(m(T).label ?? "", e.locale),
            required: m(T).required === !0,
            "model-value": u(Cu)(r()[T.id]) ? r()[T.id] : null,
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!_(T),
            "onUpdate:modelValue": (z) => l(T.id, z)
          }, null, 8, ["id", "modes", "width", "height", "font", "fonts", "label", "required", "model-value", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : T.type === "pdf-fields" && T.id ? (p(), Je(dB, {
            key: 12,
            id: T.id,
            src: m(T).src,
            mode: m(T).mode,
            fields: m(T).fields,
            layout: e.layout,
            "page-height": e.pageHeight,
            signers: m(T).signers,
            signer: m(T).signer,
            types: m(T).types,
            formats: m(T).formats,
            "date-labels": m(T).date_labels,
            "stamp-lines": m(T).stamp_lines,
            "model-value": r()[T.id],
            api: e.api,
            "file-url": e.fileUrl,
            "pdf-worker-url": e.pdfWorkerUrl,
            locale: e.locale,
            theme: e.theme,
            disabled: e.disabled,
            invalid: !!_(T),
            "onUpdate:modelValue": (z) => f(T, z)
          }, null, 8, ["id", "src", "mode", "fields", "layout", "page-height", "signers", "signer", "types", "formats", "date-labels", "stamp-lines", "model-value", "api", "file-url", "pdf-worker-url", "locale", "theme", "disabled", "invalid", "onUpdate:modelValue"])) : (p(), h("p", {
            key: 13,
            class: "fe-surface__unknown",
            "data-node-type": T.type
          }, y(u(i)("plugin.view.unsupported", { type: T.type })), 9, vB)),
          _(T) && T.type !== "form" ? (p(), h("p", yB, y(_(T)), 1)) : D("", !0)
        ], 64))), 128))
      ]);
    };
  }
}), bB = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info",
  role: "status"
}, kB = {
  key: 2,
  class: "fe-surface__text fe-surface__text--muted"
}, wB = {
  key: 3,
  class: "fe-surface__error",
  role: "alert"
}, Sp = /* @__PURE__ */ lt({
  __name: "SurfaceConversation",
  props: {
    conv: {},
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    storages: {},
    startAt: {},
    fileUrl: { type: Function },
    toast: {},
    layout: {},
    pageHeight: {}
  },
  setup(e) {
    const t = e, { t: n } = yt(() => t.locale);
    return (a, i) => (p(), h(Ce, null, [
      e.conv.current.value ? (p(), Je(gB, {
        key: 0,
        nodes: e.conv.current.value.nodes ?? [],
        locale: e.locale,
        theme: e.theme,
        errors: e.conv.errors.value,
        values: e.conv.values.value,
        api: e.api,
        plugin: e.plugin,
        storages: e.storages,
        "start-at": e.startAt,
        "file-url": e.fileUrl,
        layout: e.layout,
        "page-height": e.pageHeight,
        "invalid-keys": e.conv.invalidKeys.value,
        disabled: e.conv.busy.value,
        "onUpdate:values": e.conv.updateValues,
        onChange: e.conv.scheduleChange,
        onAction: e.conv.rowAction
      }, null, 8, ["nodes", "locale", "theme", "errors", "values", "api", "plugin", "storages", "start-at", "file-url", "layout", "page-height", "invalid-keys", "disabled", "onUpdate:values", "onChange", "onAction"])) : D("", !0),
      e.toast ? (p(), h("p", bB, y(e.toast), 1)) : D("", !0),
      e.conv.busy.value ? (p(), h("p", kB, y(u(n)("plugin.view.busy")), 1)) : D("", !0),
      e.conv.failure.value ? (p(), h("p", wB, y(e.conv.failure.value), 1)) : D("", !0)
    ], 64));
  }
});
function _B(e) {
  let t = !1;
  return zc(e, (n) => {
    n.type === "steps" && (t = !0);
  }), t;
}
const xB = /* @__PURE__ */ new Set(["back", "prev", "previous", "stepback", "goback", "prevstep", "previousstep"]);
function SB(e) {
  const t = String((e == null ? void 0 : e.id) ?? "").toLowerCase().replace(/[^a-z]/g, "");
  return xB.has(t);
}
function $B(e, t) {
  const n = (e ?? []).filter((l) => l && l.id);
  if (!t)
    return { back: null, others: n, primary: null };
  const a = n.find(SB) ?? null, i = n.filter((l) => l !== a), r = i.find((l) => l.primary === !0) ?? null;
  return { back: a, others: i.filter((l) => l !== r), primary: r };
}
const TB = ["disabled", "data-testid", "onClick"], $p = /* @__PURE__ */ lt({
  __name: "SurfaceFooterButtons",
  props: {
    conv: {},
    locale: {},
    testidPrefix: {},
    small: { type: Boolean }
  },
  setup(e) {
    const t = e, n = E(() => {
      var l;
      return _B((l = t.conv.current.value) == null ? void 0 : l.nodes);
    }), a = E(() => $B(t.conv.footer.value, n.value)), i = E(() => {
      const l = a.value;
      return [...l.back ? [l.back] : [], ...l.others, ...l.primary ? [l.primary] : []];
    });
    function r(l) {
      return n.value ? l === a.value.primary : l.primary === !0;
    }
    return (l, d) => (p(!0), h(Ce, null, ot(i.value, (f) => (p(), h("button", {
      key: f.id,
      type: "button",
      class: Fe(["fe-btn", {
        "fe-btn--sm": e.small,
        "fe-btn--primary": r(f) && !f.danger,
        "fe-btn--danger": f.danger,
        "fe-surface__back": n.value && f === a.value.back
      }]),
      disabled: t.conv.busy.value || f.disabled,
      "data-testid": `${e.testidPrefix}-action-${f.id}`,
      onClick: (m) => t.conv.press(f)
    }, y(u(Gt)(f.label, e.locale)), 11, TB))), 128));
  }
}), wS = 1, AB = "filex:hello", EB = "filex:port", CB = [
  "session.get",
  "file.read",
  "file.save",
  "file.saveAs",
  "ui.dirty",
  "ui.title",
  "ui.toast",
  "ui.confirm",
  "ui.close",
  "clipboard.write",
  "ui.download",
  "engine.call",
  "job.submit",
  "state.get",
  "state.set",
  "license.get",
  "ui.print",
  "coedit.join",
  "coedit.subscribe",
  "coedit.append",
  "coedit.lease",
  "coedit.cursor",
  "coedit.blob.put",
  "coedit.blob.get",
  "coedit.leave"
], fa = {
  /** `file.read({as: 'text'})` refuses a file larger than this; read a stream. */
  maxTextBytes: 32 << 20,
  /** One `state.set` value, as JSON. */
  maxStateBytes: 8192,
  /** A `ui.toast` / `ui.title` text, in characters. */
  maxLineChars: 300,
  /** How long the SDK waits for the host's port. */
  connectTimeoutMs: 1e4,
  /** The largest file `ui.download` hands the person (streamed or not). */
  maxDownloadBytes: 256 << 20,
  /**
   * The largest PDF `ui.print` prints (filex 0.55). Lower than a download:
   * a download can stream to disk, a print is held whole in the page (one
   * Blob) until the print dialog has read it, and a document worth printing
   * is far smaller.
   */
  maxPrintBytes: 64 << 20,
  /**
   * The largest file of an encrypted folder filex hands an app in the clear
   * or takes back from it (filex 0.56, `FileInfo.plaintext`): it is
   * decrypted and encrypted whole in the page, as filex's own explorer does
   * for a file of this size.
   */
  maxEncryptedBytes: 200 << 20
};
function zB(e) {
  return !!e && typeof e == "object" && e.type === AB && typeof e.v == "number";
}
function MB(e) {
  return !!e && typeof e == "object" && typeof e.id == "number" && typeof e.method == "string";
}
function PB(e) {
  return CB.includes(e);
}
const zm = { inFlight: 32, perWindow: 400, windowMs: 1e4 };
class ct extends Error {
  constructor(n, a) {
    super(a || n);
    It(this, "code");
    this.name = "BridgeFailure", this.code = n;
  }
}
function OB(e) {
  if (!e || typeof e != "object") return [];
  const t = [];
  for (const n of Object.values(e))
    (n instanceof ArrayBuffer || typeof ReadableStream < "u" && n instanceof ReadableStream) && t.push(n);
  return t;
}
const DB = /^[a-z][a-z0-9_]{0,39}$/;
function LB(e) {
  if (e instanceof ct) return { code: e.code, message: e.message };
  const t = e ?? {}, n = typeof t.status == "number" ? t.status : 0, a = typeof t.code == "string" && DB.test(t.code) ? t.code : "";
  let i = "failed";
  return n === 404 ? i = "not_found" : n === 413 ? i = "too_large" : n === 400 || n === 422 ? i = "invalid" : n === 409 && a === "read_only" ? i = "read_only" : n === 403 && a === "not_granted" && (i = "not_granted"), { code: i, message: a || i };
}
function RB(e) {
  const t = e.win ?? window;
  let n = null, a = !1, i = 0, r = !1, l = 0;
  const d = /* @__PURE__ */ new Map();
  function f(M) {
    var A;
    if (n) {
      n.onmessage = null;
      try {
        n.close();
      } catch {
      }
      n = null;
      for (const [, T] of d)
        clearTimeout(T.timer), T.reject(new ct("unavailable", "the interface went away"));
      d.clear(), (A = e.onDisconnect) == null || A.call(e, M);
    }
  }
  let m = 0, v = 0, b = 0;
  function _() {
    const M = Date.now();
    return M - v >= zm.windowMs && (v = M, b = 0), b >= zm.perWindow ? !1 : (b++, !0);
  }
  async function w(M, A, T, N) {
    let z, L = [];
    if (!_())
      z = { id: A, error: { code: "unavailable", message: "busy" } };
    else if (!PB(T))
      z = { id: A, error: { code: "unknown_method", message: T } };
    else {
      const B = e.handlers[T];
      if (!B)
        z = { id: A, error: { code: "unavailable", message: `${T} is not offered here` } };
      else if (m >= zm.inFlight)
        z = { id: A, error: { code: "unavailable", message: "busy" } };
      else {
        m++;
        try {
          const O = await B(N);
          z = { id: A, result: O }, L = OB(O);
        } catch (O) {
          z = { id: A, error: LB(O) };
        } finally {
          m--;
        }
      }
    }
    if (M === n)
      try {
        M.postMessage(z, L);
      } catch {
        M.postMessage({ id: A, error: { code: "failed", message: "the answer cannot be sent to the interface" } });
      }
  }
  function k(M) {
    return (A) => {
      const T = A.data;
      if (!(!T || typeof T != "object")) {
        if (typeof T.hid == "number") {
          const N = d.get(T.hid);
          if (!N) return;
          if (d.delete(T.hid), clearTimeout(N.timer), T.error) {
            const z = T.error;
            N.reject(new ct(z.code ?? "failed", z.message));
          } else N.resolve(T.result);
          return;
        }
        MB(T) && w(M, T.id, T.method, T.params);
      }
    };
  }
  function x(M) {
    var z, L;
    if (r || a) return;
    const A = e.frame(), T = A == null ? void 0 : A.contentWindow;
    if (!A || !T || M.source !== T || !zB(M.data) || i > 1) return;
    a = !0;
    const N = new MessageChannel();
    n = N.port1, n.onmessage = k(n), (z = n.start) == null || z.call(n), T.postMessage({ type: EB, v: wS }, "*", [N.port2]), (L = e.onConnect) == null || L.call(e);
  }
  return t.addEventListener("message", x), {
    connected: () => n !== null,
    emit(M, A, T = []) {
      if (n)
        try {
          n.postMessage({ event: M, data: A }, T);
        } catch {
        }
    },
    ask(M, A, T = 6e4) {
      const N = n;
      if (!N) return Promise.reject(new ct("unavailable", "the interface is not connected"));
      const z = ++l;
      return new Promise((L, B) => {
        const O = setTimeout(() => {
          d.delete(z), B(new ct("failed", `the interface did not answer "${M}"`));
        }, T);
        d.set(z, { resolve: L, reject: B, timer: O }), N.postMessage({ hid: z, request: M, params: A });
      });
    },
    frameLoaded() {
      i++, i > 1 && f("reload");
    },
    destroy() {
      r = !0, t.removeEventListener("message", x), f("destroyed");
    }
  };
}
const NB = [
  "theme",
  "palette",
  "density",
  "locale",
  "storageOrder",
  "tour",
  "appState",
  "appStateE2e",
  "appsSeen",
  "openWith"
], IB = ["openWith"], Kf = ["theme", "palette", "density", "locale", "storageOrder"], ic = {
  theme: "filex.theme",
  palette: "filex.palette",
  density: "filex.density",
  locale: "filex.locale",
  // New in 0.45.2 (#57); no earlier reader to stay compatible with.
  storageOrder: "filex.storageOrder"
}, _S = 400, Fv = "filex.session";
let Tp = !1;
function BB() {
  try {
    return localStorage.getItem(Fv) === "1";
  } catch {
    return !1;
  }
}
function $l() {
  return Tp ? !1 : Za.sessionAware ? BB() : !0;
}
function FB(e) {
  try {
    e ? localStorage.setItem(Fv, "1") : localStorage.removeItem(Fv);
  } catch {
  }
  e && (Tp = !1);
}
function wce() {
  Tp = !0;
}
const xS = new Set(Object.values(ic));
function UB(e) {
  xS.add(e);
}
const SS = /* @__PURE__ */ new Set();
function HB(e) {
  SS.add(e);
}
function _ce() {
  FB(!1);
  for (const e of xS)
    try {
      localStorage.removeItem(e);
    } catch {
    }
  for (const e of SS)
    try {
      e();
    } catch {
    }
  Ya = {}, Ap = !1, Nr = {}, ta !== null && clearTimeout(ta), ta = null, Uv();
}
let Za = { surface: "web" }, Ya = {}, Ap = !1, og = !1, Mc = !1;
const Vf = /* @__PURE__ */ new Set(), oc = /* @__PURE__ */ new Set();
function xce(e) {
  Za = { ...e }, og = !0;
}
function Ep() {
  return og;
}
function KB() {
  return Mc;
}
function VB(e) {
  return Mc ? (e(), () => {
  }) : (oc.add(e), () => oc.delete(e));
}
function Uv() {
  Mc = !0;
  const e = [...oc];
  oc.clear();
  for (const t of e)
    try {
      t();
    } catch {
    }
}
function yo() {
  return { ...Ya };
}
function $S() {
  return Ap;
}
function Cp(e) {
  return Vf.add(e), () => Vf.delete(e);
}
function TS() {
  const e = yo();
  for (const t of Vf)
    try {
      t(e);
    } catch {
    }
}
function jf(e) {
  try {
    return localStorage.getItem(ic[e]) ?? "";
  } catch {
    return "";
  }
}
function Rr(e, t) {
  try {
    t ? localStorage.setItem(ic[e], t) : localStorage.removeItem(ic[e]);
  } catch {
  }
}
function jB() {
  const e = {};
  for (const t of Kf) {
    const n = jf(t);
    n && (e[t] = n);
  }
  return e;
}
function AS() {
  return `${kl(Za.base)}/api/me/prefs?surface=${encodeURIComponent(Za.surface)}`;
}
async function rg(e) {
  const t = { Accept: "application/json" };
  e && (t["Content-Type"] = "application/json");
  const n = Za.headers ? await Za.headers() : {};
  return { ...t, ...n };
}
function qB(e) {
  const t = { Accept: "application/json" };
  t["Content-Type"] = "application/json";
  const n = Za.headers ? Za.headers() : {};
  return n && typeof n.then != "function" ? { ...t, ...n } : t;
}
function WB(e) {
  const t = e && typeof e == "object" ? e : {}, n = t.prefs && typeof t.prefs == "object" ? t.prefs : t, a = {};
  for (const i of NB) {
    const r = n[i];
    typeof r == "string" && r && (a[i] = r);
  }
  return a;
}
async function Sce() {
  const e = Za.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!e)
    return Uv(), null;
  Mc = !1;
  try {
    const t = await e(AS(), {
      method: "GET",
      headers: await rg(!1),
      credentials: "same-origin",
      cache: "no-store"
    });
    if (!t.ok) return null;
    if (Ya = WB(await t.json()), Ap = !0, !Object.keys(Ya).length) {
      const n = jB();
      if (delete n.locale, Object.keys(n).length) {
        Ya = n;
        for (const a of Kf) n[a] && (Nr[a] = n[a]);
        ta !== null && clearTimeout(ta), ta = setTimeout(() => {
          vl = zp();
        }, _S);
      }
    }
    for (const n of Kf)
      n === "locale" && !Ya[n] || Rr(n, Ya[n] ?? "");
    return TS(), yo();
  } catch {
    return null;
  } finally {
    Uv();
  }
}
let Nr = {}, ta = null, vl = null;
async function zp(e = !1) {
  ta = null;
  const t = Nr;
  if (Nr = {}, !Object.keys(t).length) return;
  const n = yo();
  for (const l of IB) delete n[l];
  const a = { prefs: n }, i = Za.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!i) return;
  const r = JSON.stringify(a);
  try {
    await i(AS(), {
      method: "PUT",
      headers: e ? qB(!0) : await rg(!0),
      credentials: "same-origin",
      body: r,
      // ⚠ Sent while the page is going away: `keepalive` is what lets the
      // request outlive it. Browsers reject a keepalive body over 64 KB
      // outright, so the flag goes only on documents that fit.
      ...e && r.length < 6e4 ? { keepalive: !0 } : {}
    });
  } catch {
  }
}
function Uo(e, t) {
  Ya = { ...Ya, [e]: t }, Kf.includes(e) && Rr(e, t), Nr = { ...Nr, [e]: t }, ta !== null && clearTimeout(ta), ta = setTimeout(() => {
    vl = zp();
  }, _S);
}
function sg(e, t) {
  Ya = { ...Ya, [e]: t }, TS();
}
async function ES(e, t) {
  const n = Za.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!n) return null;
  try {
    return await n(`${kl(Za.base)}${e}`, {
      method: t.method,
      headers: await rg(t.body !== void 0),
      credentials: "same-origin",
      body: t.body
    });
  } catch {
    return null;
  }
}
async function YB() {
  ta !== null && (clearTimeout(ta), vl = zp()), await vl;
}
function H_() {
  ta !== null && (clearTimeout(ta), vl = zp(!0));
}
typeof window < "u" && (window.addEventListener("pagehide", H_), document.addEventListener("visibilitychange", () => {
  document.visibilityState === "hidden" && H_();
}));
function $ce() {
  Ya = {}, Ap = !1, Tp = !1, Nr = {}, ta !== null && clearTimeout(ta), ta = null, vl = null, Vf.clear(), Mc = !1, oc.clear(), og = !1;
}
function CS() {
  return fc("app_state_max_bytes");
}
const GB = new TextEncoder();
function zS(e) {
  return GB.encode(e).length;
}
function Mp(e) {
  const t = yo()[e];
  if (!t) return {};
  try {
    const n = JSON.parse(t);
    return n && typeof n == "object" && !Array.isArray(n) ? n : {};
  } catch {
    return {};
  }
}
function XB(e, t) {
  const n = Mp("appState")[e];
  return n && Object.prototype.hasOwnProperty.call(n, t) ? n[t] : void 0;
}
class rc extends Error {
}
function MS(e, t) {
  if (!e || e.length > 128 || e === "__proto__" || e === "constructor" || e === "prototype")
    throw new rc("a state key is 1-128 characters");
  const n = t === void 0 ? void 0 : JSON.stringify(t);
  if (n !== void 0 && n.length > fa.maxStateBytes)
    throw new rc(`a state value is at most ${fa.maxStateBytes} bytes as JSON`);
  return n;
}
function JB(e, t, n) {
  const a = MS(t, n), i = Mp("appState"), r = { ...i[e] ?? {} };
  a === void 0 ? delete r[t] : r[t] = JSON.parse(a);
  const l = CS();
  if (l !== void 0 && zS(JSON.stringify(r)) > l)
    throw new rc(`an app keeps at most ${l} bytes`);
  const d = { ...i, [e]: r };
  Object.keys(r).length || delete d[e], Uo("appState", JSON.stringify(d));
}
function ZB(e) {
  const t = Mp("appsSeen")[e];
  return typeof t == "string" ? t : "";
}
function K_(e, t) {
  const n = Mp("appsSeen");
  n[e] !== t && Uo("appsSeen", JSON.stringify({ ...n, [e]: t }));
}
const QB = 1e4, e6 = 1500, t6 = 15 * 6e4, n6 = 600, a6 = 4 << 20, PS = "application/pdf", Ir = [37, 80, 68, 70, 45], i6 = [
  "background-color",
  "color",
  "border-top-color",
  "border-right-color",
  "border-bottom-color",
  "border-left-color",
  "border-top-width",
  "border-right-width",
  "border-bottom-width",
  "border-left-width",
  "border-top-style",
  "border-right-style",
  "border-bottom-style",
  "border-left-style",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-bottom-right-radius",
  "border-bottom-left-radius",
  "font-family",
  "font-size",
  "font-weight",
  "line-height",
  "letter-spacing",
  "padding-top",
  "padding-right",
  "padding-bottom",
  "padding-left"
];
function Fu(e) {
  const t = e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : null;
  return !t || t.byteLength < Ir.length ? !1 : Ir.every((n, a) => t[a] === n);
}
class sa extends Error {
  constructor(n, a) {
    super(a || n);
    It(this, "code");
    this.name = "PrintFailure", this.code = n;
  }
}
function Mm() {
  return new sa("invalid", "the data is not a PDF");
}
function o6(e, t) {
  const n = Math.min(Ir.length - e.byteLength, t.byteLength);
  if (n <= 0) return e;
  const a = new Uint8Array(e.byteLength + n);
  return a.set(e), a.set(t.subarray(0, n), e.byteLength), a;
}
async function r6(e, t) {
  const n = () => new sa("too_large", `at most ${Math.floor(t / 1048576)} MiB`);
  if (e instanceof ArrayBuffer) {
    if (e.byteLength > t) throw n();
    if (!Fu(e)) throw Mm();
    return new Blob([e], { type: PS });
  }
  let a = null, i = [], r = 0, l = 0, d = new Uint8Array(0);
  for await (const f of e) {
    if (!(f instanceof Uint8Array)) throw new sa("invalid", "a PDF stream carries bytes (Uint8Array)");
    if (d.byteLength < Ir.length && (d = o6(d, f), d.byteLength >= Ir.length && !Fu(d)))
      throw Mm();
    if (l += f.byteLength, l > t) throw n();
    i.push(f), r += f.byteLength, r >= a6 && (a = V_(a, i), i = [], r = 0);
  }
  if (!Fu(d)) throw Mm();
  return i.length || !a ? V_(a, i) : a;
}
function V_(e, t) {
  return new Blob(e ? [e, ...t] : t, { type: PS });
}
function s6(e) {
  var i;
  const t = {}, n = (i = e == null ? void 0 : e.ownerDocument) == null ? void 0 : i.defaultView;
  if (!e || !n || typeof n.getComputedStyle != "function") return t;
  const a = n.getComputedStyle(e);
  for (const r of i6) {
    const l = a.getPropertyValue(r).trim();
    l && (t[r] = l);
  }
  return t;
}
async function l6(e) {
  if (typeof Blob > "u" || !(e instanceof Blob) || e.size < Ir.length) return !1;
  try {
    return Fu(await e.slice(0, Ir.length).arrayBuffer());
  } catch {
    return !1;
  }
}
const j_ = "position:absolute;width:1px;height:1px;border:0;opacity:0;pointer-events:none;inset-inline-start:-10000px;top:0";
function u6(e, t) {
  return `display:block;width:${e}px;height:${t}px;border:0;background:transparent;color-scheme:normal`;
}
function q_(e, t, n, a) {
  const i = typeof e == "number" && Number.isFinite(e) ? Math.round(e) : a;
  return Math.min(n, Math.max(t, i));
}
async function c6(e, t, n = {}) {
  var d, f;
  const a = n.win ?? window, i = a.document;
  if ((d = n.signal) != null && d.aborted) throw new sa("cancelled", "the person said no");
  if (!await l6(t)) throw new sa("invalid", "not a PDF");
  let r;
  try {
    r = new URL(e, a.location.href).origin;
  } catch {
    throw new sa("unavailable", "no print page");
  }
  if (!r || r === "null") throw new sa("unavailable", "no print page");
  if ((f = n.signal) != null && f.aborted) throw new sa("cancelled", "the person said no");
  const l = i.createElement("iframe");
  return l.setAttribute("referrerpolicy", "no-referrer"), l.setAttribute("aria-hidden", "true"), l.setAttribute("tabindex", "-1"), l.setAttribute("title", n.label || "print"), l.dataset.testid = "appframe-print", l.style.cssText = j_, l.setAttribute("src", e), new Promise((m, v) => {
    var U;
    let b = !1, _ = !1, w = null, k = null, x = null, M = null, A = null;
    function T() {
      l.style.cssText = j_, l.setAttribute("aria-hidden", "true"), l.setAttribute("tabindex", "-1");
    }
    function N(S) {
      var F;
      if (!b) {
        b = !0, a.removeEventListener("message", O), l.removeEventListener("load", L), (F = n.signal) == null || F.removeEventListener("abort", z);
        for (const I of [w, k, x, M]) I && clearTimeout(I);
        A && (A.port1.onmessage = null), S ? (l.remove(), v(S)) : (T(), m(l));
      }
    }
    function z() {
      try {
        A == null || A.port1.postMessage({ type: "cancel" });
      } catch {
      }
      N(new sa("cancelled", "the person said no"));
    }
    function L() {
      b || A || k || (k = setTimeout(() => {
        A || N(new sa("unavailable", "the print page may not be shown here"));
      }, n.loadGraceMs ?? e6));
    }
    function B(S) {
      var I;
      const F = S.data;
      if (!(b || !F || typeof F != "object")) {
        if (F.state === "ask") {
          if (_) return;
          _ = !0;
          const G = q_(F.width, 24, 480, 96), Y = q_(F.height, 16, 96, 36);
          l.style.cssText = u6(G, Y), l.removeAttribute("aria-hidden"), l.removeAttribute("tabindex"), (I = n.onAsk) == null || I.call(n, { width: G, height: Y }), M = setTimeout(() => {
            try {
              A == null || A.port1.postMessage({ type: "arm" });
            } catch {
            }
          }, n.armMs ?? n6);
          return;
        }
        F.ok === !0 ? N(null) : N(new sa(F.code === "invalid" ? "invalid" : "failed", "the PDF could not be printed"));
      }
    }
    function O(S) {
      const F = l.contentWindow;
      if (b || !F || S.source !== F) return;
      const I = S.data;
      if (!I || typeof I != "object" || I.type !== "filex:print-ready" || A || S.origin !== r) return;
      w && clearTimeout(w), k && clearTimeout(k);
      const G = new MessageChannel();
      A = G, G.port1.onmessage = B, x = setTimeout(() => N(new sa("failed", "the print page did not answer")), n.answerMs ?? t6);
      try {
        F.postMessage({ type: "filex:print", pdf: t, label: n.label ?? "", look: n.look ?? {} }, r, [G.port2]);
      } catch {
        N(new sa("failed", "the PDF could not be handed to the print page"));
      }
    }
    a.addEventListener("message", O), l.addEventListener("load", L), (U = n.signal) == null || U.addEventListener("abort", z), w = setTimeout(() => N(new sa("unavailable", "the print page did not load")), n.readyMs ?? QB), (n.mount ?? i.body).appendChild(l);
  });
}
const Pc = new TextEncoder(), d6 = new TextDecoder();
function Br(e) {
  return new Uint8Array(e);
}
const f6 = Br(Pc.encode("filex-state1")), p6 = Br(Pc.encode("filex-app-state")), h6 = "filex-app-state-v1-key", m6 = "filex-app-state-v1-id", v6 = "filex-app-state-v1", OS = 1, nl = 12, y6 = 16, g6 = 16, b6 = "local";
async function k6() {
  var t, n;
  if (!Ep()) return b6;
  const e = await ES("/api/auth/me", { method: "GET" });
  if (!e || !e.ok) return null;
  try {
    const a = (n = (t = await e.json()) == null ? void 0 : t.user) == null ? void 0 : n.id;
    if (typeof a == "number" && Number.isSafeInteger(a) && a > 0) return `u${a}`;
    if (typeof a == "string" && /^[A-Za-z0-9_-]{1,64}$/.test(a)) return `u${a}`;
  } catch {
  }
  return null;
}
async function w6(e) {
  var n;
  if (((n = e.algorithm) == null ? void 0 : n.name) === "HKDF") return e;
  const t = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: f6 }, e, new Uint8Array(32)));
  try {
    return await crypto.subtle.importKey("raw", t.subarray(0, 32), "HKDF", !1, ["deriveKey", "deriveBits"]);
  } finally {
    t.fill(0);
  }
}
function W_(e, t, n) {
  return { name: "HKDF", hash: "SHA-256", salt: p6, info: Br(Pc.encode(`${e}\0${t}\0${n}`)) };
}
const Hd = /* @__PURE__ */ new WeakMap();
function DS(e) {
  let t = Hd.get(e);
  if (!t) {
    const n = { account: k6().catch(() => null), byApp: /* @__PURE__ */ new Map() };
    n.account.then((a) => {
      a === null && Hd.get(e) === n && Hd.delete(e);
    }), Hd.set(e, n), t = n;
  }
  return t;
}
function Y_(e, t, n) {
  const { byApp: a } = DS(e), i = `${t}\0${n}`;
  let r = a.get(i);
  return r || (r = (async () => {
    const l = await w6(e), d = await crypto.subtle.deriveKey(W_(h6, t, n), l, { name: "AES-GCM", length: 256 }, !1, ["encrypt", "decrypt"]), f = new Uint8Array(await crypto.subtle.deriveBits(W_(m6, t, n), l, g6 * 8));
    return { id: Fo(f), key: d, account: t };
  })(), a.set(i, r), r.catch(() => a.delete(i))), r;
}
async function _6(e, t, n) {
  const a = await DS(e).account;
  if (a === null) return null;
  const i = await Y_(e, a, t);
  return n ? { ...i, previous: await Y_(n, a, t) } : i;
}
function Hv() {
  const e = yo().appStateE2e;
  if (!e) return {};
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" && !Array.isArray(t) ? t : {};
  } catch {
    return {};
  }
}
function LS(e, t) {
  const n = e[t];
  return n && typeof n == "object" && !Array.isArray(n) ? { ...n } : {};
}
function RS(e, t) {
  return Br(Pc.encode(`${v6}\0${t.account}\0${e}\0${t.id}`));
}
async function x6(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(nl)), i = Br(Pc.encode(JSON.stringify(n)));
  try {
    const r = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: a, additionalData: RS(e, t) }, t.key, i)), l = new Uint8Array(1 + nl + r.length);
    return l[0] = OS, l.set(a, 1), l.set(r, 1 + nl), Fo(l);
  } finally {
    i.fill(0);
  }
}
async function G_(e, t, n) {
  if (typeof n != "string") return null;
  const a = po(n);
  if (!a || a.length < 1 + nl + y6 || a[0] !== OS) return null;
  let i;
  try {
    i = new Uint8Array(
      await crypto.subtle.decrypt(
        { name: "AES-GCM", iv: Br(a.subarray(1, 1 + nl)), additionalData: RS(e, t) },
        t.key,
        Br(a.subarray(1 + nl))
      )
    );
  } catch {
    return null;
  }
  try {
    const r = JSON.parse(d6.decode(i));
    return r && typeof r == "object" && !Array.isArray(r) ? r : null;
  } catch {
    return null;
  } finally {
    i.fill(0);
  }
}
async function NS(e, t) {
  const n = LS(Hv(), e);
  if (n[t.id] !== void 0) return await G_(e, t, n[t.id]) ?? {};
  const a = t.previous;
  return a && n[a.id] !== void 0 ? await G_(e, a, n[a.id]) ?? {} : {};
}
async function S6(e, t, n) {
  const a = await NS(e, t);
  return Object.prototype.hasOwnProperty.call(a, n) ? a[n] : void 0;
}
const Kd = /* @__PURE__ */ new Map();
async function $6(e, t, n, a) {
  const i = MS(n, a), l = (Kd.get(e) ?? Promise.resolve()).catch(() => {
  }).then(() => T6(e, t, n, i));
  Kd.set(e, l);
  try {
    await l;
  } finally {
    Kd.get(e) === l && Kd.delete(e);
  }
}
async function T6(e, t, n, a) {
  const i = { ...await NS(e, t) };
  a === void 0 ? delete i[n] : i[n] = JSON.parse(a);
  const r = LS(Hv(), e);
  t.previous && delete r[t.previous.id], Object.keys(i).length ? r[t.id] = await x6(e, t, i) : delete r[t.id];
  const l = CS();
  if (l !== void 0 && zS(JSON.stringify(r)) > l)
    throw new rc(`an app keeps at most ${l} bytes, sealed, in an encrypted folder`);
  const d = { ...Hv(), [e]: r };
  Object.keys(r).length || delete d[e], Uo("appStateE2e", JSON.stringify(d));
}
class IS extends Error {
  constructor() {
    super("the sealed app store needs the account this page is signed in as"), this.name = "LedgerNeedsAccount";
  }
}
async function BS(e, t, n) {
  const a = await _6(e, t, n);
  if (!a) throw new IS();
  return a;
}
class Sr extends Error {
  constructor(t) {
    super(`at most ${t >> 20} MiB in an encrypted folder`), this.limit = t, this.name = "TooLargeToHand";
  }
}
const yl = Math.min(fa.maxEncryptedBytes, Nu);
function A6(e, t) {
  return {
    vault: t ?? null,
    async open(n, a, i = yl) {
      const r = e(n);
      if (!r)
        return await a.cancel().catch(() => {
        }), null;
      const l = _v(r.fmk, r.previous, a, { passPlain: !0 }).getReader(), d = [];
      let f = 0;
      try {
        for (; ; ) {
          const { done: b, value: _ } = await l.read();
          if (b) break;
          if (f += _.byteLength, f > i) throw new Sr(i);
          d.push(_);
        }
      } catch (b) {
        await l.cancel(b).catch(() => {
        });
        for (const _ of d) _.fill(0);
        throw b;
      }
      const m = new Uint8Array(f);
      let v = 0;
      for (const b of d)
        m.set(b, v), v += b.byteLength, b.fill(0);
      return m;
    },
    async seal(n, a, i = yl) {
      if (a.byteLength > i) throw new Sr(i);
      const r = e(n);
      return r ? Tv(r.fmk, a.buffer.byteLength === a.byteLength ? a.buffer : a.slice().buffer) : null;
    },
    async ledger(n, a) {
      const i = e(n);
      return i ? BS(i.fmk, a, i.previous) : null;
    },
    folderKeys(n) {
      return e(n);
    }
  };
}
class qf extends Error {
  constructor(t) {
    super(`vault: ${t}`), this.why = t, this.name = "VaultAppRefused";
  }
}
function E6(e) {
  if (e.buffer instanceof ArrayBuffer && e.byteOffset === 0 && e.byteLength === e.buffer.byteLength) return e;
  const t = new Uint8Array(e.byteLength);
  return t.set(e), e.fill(0), t;
}
function C6(e) {
  return {
    async read(t, n = yl) {
      const a = await e.readForApp(t, n);
      if (a.ok) return { bytes: E6(a.bytes), sig: a.sig };
      if (a.why === "locked") return null;
      throw a.why === "too_large" ? new Sr(n) : new qf(a.why);
    },
    async save(t, n, a, i = yl) {
      if (n.byteLength > i) throw new Sr(i);
      const r = await e.saveForApp(t, n, a);
      if (!r.ok) throw new qf(r.why);
      return { size: r.size, sig: r.sig };
    },
    async ledger(t, n) {
      const a = e.keyForApp(t);
      return a ? BS(a, n) : null;
    }
  };
}
const z6 = {
  txt: "text/plain",
  md: "text/markdown",
  log: "text/plain",
  csv: "text/csv",
  json: "application/json",
  xml: "application/xml",
  html: "text/html",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  bmp: "image/bmp",
  avif: "image/avif",
  svg: "image/svg+xml",
  pdf: "application/pdf",
  mp4: "video/mp4",
  webm: "video/webm",
  mov: "video/quicktime",
  m4v: "video/mp4",
  mp3: "audio/mpeg",
  wav: "audio/wav",
  ogg: "audio/ogg",
  flac: "audio/flac",
  m4a: "audio/mp4",
  aac: "audio/aac",
  opus: "audio/opus"
};
function Ks(e) {
  return z6[(e || "").toLowerCase()] || "application/octet-stream";
}
const FS = "files:e2e-plaintext";
function M6(e) {
  return !!e && e.includes(FS);
}
const Io = "builtin", gl = "onlyoffice", P6 = ["csv"];
function lg(e) {
  return P6.includes(String(e ?? "").toLowerCase());
}
function US(e, t) {
  return !!e && e.type === "file" && (!!(t != null && t.inEncrypted) || u2(e));
}
function HS(e) {
  return `app:${e.plugin}/${e.id}`;
}
function X_(e) {
  return e ? e === Io || e === gl || e.startsWith("app:") ? e : `app:${e}` : null;
}
function df(e) {
  return (e == null ? void 0 : e.id) === gl;
}
function Vs(e) {
  return e ? String(wy(e).ext ?? "").toLowerCase() : "";
}
function KS(e) {
  return e.filter((t) => t.placement === "viewer" && !!t.ui);
}
function O6(e, t) {
  return !t || t.type !== "file" ? [] : KS(e).filter((n) => _y(n.applies ?? {}, [wy(t, n.plugin)]));
}
function D6(e) {
  const t = Ks(e);
  return t === "application/octet-stream" ? "" : t;
}
function L6(e, t, n) {
  const a = D6(n);
  return KS(e).filter(
    (i) => {
      var r;
      return M6((r = i.ui) == null ? void 0 : r.grants) && _y(i.applies ?? {}, [{ kind: "file", ext: n, mime: a, state: c2({ app_state: t.app_state }, i.plugin) }]);
    }
  );
}
function R6(e, t, n) {
  var f;
  const a = typeof t == "string" ? { name: t } : t, i = Pf(a.name ?? ""), r = L6(e, a, i), l = r.length === 0 ? { on: [{ id: Io, view: null }], off: [], custom: !1 } : jS([...r.map((m) => ({ id: HS(m), view: m })), { id: Io, view: null }], (f = n == null ? void 0 : n.rules) == null ? void 0 : f[i]), d = typeof (n == null ? void 0 : n.personal) == "function" ? n.personal(i) : n == null ? void 0 : n.personal;
  return { ...l, kind: i, handler: qS(l.on, n == null ? void 0 : n.choice, d) };
}
function N6(e, t) {
  if (!(t != null && t.e2ePlaintext) || e.type !== "file" || e.encrypted === "vault" || e.encrypted === "file") return !1;
  const n = e.e2e_name_state;
  return n === void 0 || n === "enc" || n === "plain";
}
function I6(e) {
  return { name: String(e.basename ?? ""), ...Array.isArray(e.app_state) ? { app_state: e.app_state } : {} };
}
function B6(e) {
  return !!e && typeof e.e2e_stored == "string";
}
function F6(e, t) {
  return !!(t != null && t.e2ePlaintext) && e.type === "file" && e.encrypted === "vault";
}
function VS(e, t, n, a) {
  if (!t || t.type !== "file") return { on: [], off: [], custom: !1 };
  if (US(t, a)) {
    if (!(t.encrypted === "vault" ? F6(t, a) : N6(t, a))) return { on: [{ id: Io, view: null }], off: [], custom: !1 };
    const { on: l, off: d, custom: f } = R6(e, I6(t), { rules: n });
    return { on: l, off: d, custom: f };
  }
  const i = [
    ...a != null && a.onlyOffice && lg(Vs(t)) ? [{ id: gl, view: null }] : [],
    ...O6(e, t).map((r) => ({ id: HS(r), view: r })),
    { id: Io, view: null }
  ];
  return jS(i, n == null ? void 0 : n[Vs(t)]);
}
function jS(e, t) {
  if (!t) return { on: e, off: [], custom: !1 };
  const n = new Set(t.off ?? []), a = new Map(e.map((d) => [d.id, d])), i = /* @__PURE__ */ new Set(), r = [];
  for (const d of t.order ?? []) {
    const f = a.get(d);
    !f || n.has(d) || i.has(d) || (i.add(d), r.push(f));
  }
  const l = [];
  for (const d of e)
    n.has(d.id) ? l.push(d) : i.has(d.id) || r.push(d);
  return { on: r, off: l, custom: !0 };
}
function zu(e, t, n, a, i, r) {
  return !t || t.type !== "file" ? null : qS(VS(e, t, a, r).on, n, i);
}
function qS(e, t, n) {
  const a = (i) => i ? e.find((r) => r.id === i) ?? null : null;
  return a(X_(t)) ?? a(X_(n)) ?? e[0] ?? null;
}
function Tce(e, t, n, a, i, r) {
  var l;
  return ((l = zu(e, t, n, a, i, r)) == null ? void 0 : l.view) ?? null;
}
const ug = 32, U6 = "", H6 = ["changes", "lock", "release"], al = 12, WS = "filex-oo-sk-v1", YS = "filex-oo-v1", GS = "filex-oo-eph-v1", XS = "filex-oo-blob-v1", K6 = "filex-oo-log", V6 = "filex-oo-eph", j6 = "filex-oo-blob";
function co(e) {
  return new Uint8Array(e).buffer;
}
const sc = new TextEncoder(), q6 = new TextDecoder("utf-8", { fatal: !0 });
function qo(e, ...t) {
  return co(sc.encode(JSON.stringify([e, ...t])));
}
async function Pp(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(al)), i = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: co(a), additionalData: n }, e, co(t))
  ), r = new Uint8Array(al + i.length);
  return r.set(a, 0), r.set(i, al), r;
}
async function Op(e, t, n) {
  if (t.length <= al) return null;
  try {
    const a = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: co(t.slice(0, al)), additionalData: n },
      e,
      co(t.slice(al))
    );
    return new Uint8Array(a);
  } catch {
    return null;
  }
}
function Dp(e) {
  try {
    return Zn(e);
  } catch {
    return null;
  }
}
function JS(e) {
  try {
    return JSON.parse(q6.decode(e));
  } catch {
    return;
  }
}
function W6() {
  return crypto.getRandomValues(new Uint8Array(ug));
}
async function Y6(e, t, n) {
  if (t.length !== ug) throw new Error("e2eoffice: a session key is 32 bytes");
  return Aa(await Pp(e, t, qo(WS, n.sid, n.file)));
}
async function G6(e, t, n) {
  const a = Dp(t);
  if (!a) return null;
  const i = await Op(e, a, qo(WS, n.sid, n.file));
  if (!i || i.length !== ug) return null;
  try {
    return await Kv(i, n.sid);
  } finally {
    i.fill(0);
  }
}
async function Kv(e, t) {
  const n = await crypto.subtle.importKey("raw", co(e), "HKDF", !1, ["deriveKey"]), a = (d) => crypto.subtle.deriveKey(
    { name: "HKDF", hash: "SHA-256", salt: co(sc.encode(t)), info: co(sc.encode(d)) },
    n,
    { name: "AES-GCM", length: 256 },
    !1,
    ["encrypt", "decrypt"]
  ), [i, r, l] = await Promise.all([a(K6), a(V6), a(j6)]);
  return { log: i, eph: r, blob: l };
}
async function X6(e, t, n, a) {
  const i = sc.encode(JSON.stringify({ p: n, b: a }));
  return Aa(await Pp(e, i, qo(YS, t.sid, t.seq, t.client, t.ctr, t.kind)));
}
async function J6(e, t, n) {
  const a = Dp(n);
  if (!a) return null;
  const i = await Op(e, a, qo(YS, t.sid, t.seq, t.client, t.ctr, t.kind));
  if (!i) return null;
  const r = JS(i);
  if (!r || typeof r != "object" || Array.isArray(r)) return null;
  const l = r;
  return typeof l.p != "string" ? null : { prev: l.p, body: l.b };
}
async function Z6(e) {
  const t = Dp(e) ?? new Uint8Array(0), n = new Uint8Array(await crypto.subtle.digest("SHA-256", co(t)));
  return Array.from(n, (a) => a.toString(16).padStart(2, "0")).join("");
}
const Q6 = ["join", "leave", "saved"];
class eF {
  constructor(t, n, a = 0, i = U6) {
    It(this, "seq");
    It(this, "last");
    It(this, "ctrs", /* @__PURE__ */ new Map());
    It(this, "failed", null);
    this.key = t, this.sid = n, this.seq = a, this.last = i;
  }
  /** The last entry taken. */
  get head() {
    return this.seq;
  }
  /** What the next sealed entry has to name as `prev`. */
  get digest() {
    return this.last;
  }
  /** The counter a writer used last (0 = none yet). */
  counter(t) {
    return this.ctrs.get(t) ?? 0;
  }
  async read(t) {
    const n = (r) => (this.failed = r, { ok: !1, seq: t.seq, problem: r });
    if (this.failed) return { ok: !1, seq: t.seq, problem: this.failed };
    if (t.seq !== this.seq + 1) return n("gap");
    if (Q6.includes(t.kind))
      return this.seq = t.seq, { ok: !0, seq: t.seq, kind: t.kind, client: t.client };
    if (!H6.includes(t.kind)) return n("kind");
    const a = t.ctr ?? 0;
    if (typeof t.ct != "string" || a < 1) return n("forged");
    const i = await J6(
      this.key,
      { sid: this.sid, seq: t.seq, client: t.client, ctr: a, kind: t.kind },
      t.ct
    );
    return i ? i.prev !== this.last ? n("chain") : a <= this.counter(t.client) ? n("replay") : (this.ctrs.set(t.client, a), this.last = await Z6(t.ct), this.seq = t.seq, { ok: !0, seq: t.seq, kind: t.kind, client: t.client, body: i.body }) : n("forged");
  }
}
async function tF(e, t, n) {
  const a = sc.encode(JSON.stringify(n));
  return Aa(await Pp(e, a, qo(GS, t.sid, t.client, t.ctr)));
}
async function nF(e, t, n) {
  const a = Dp(n);
  if (!a) return;
  const i = await Op(e, a, qo(GS, t.sid, t.client, t.ctr));
  return i ? JS(i) : void 0;
}
function aF(e, t, n) {
  return Pp(e, n, qo(XS, t.sid, t.name));
}
function iF(e, t, n) {
  return Op(e, n, qo(XS, t.sid, t.name));
}
function Wf() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let n = 0;
  return {
    async add(a) {
      const i = ++n;
      return e.set(i, { ...a, id: i }), i;
    },
    async remove(a) {
      e.delete(a);
    },
    async listPath(a) {
      return [...e.values()].filter((i) => i.path === a).sort((i, r) => (i.id ?? 0) - (r.id ?? 0));
    },
    hold(a) {
      t.set(a, (t.get(a) ?? 0) + 1);
      let i = !1;
      return () => {
        if (i) return;
        i = !0;
        const r = (t.get(a) ?? 1) - 1;
        r > 0 ? t.set(a, r) : t.delete(a);
      };
    },
    async live(a) {
      return t.has(a);
    }
  };
}
const oF = "filex-coedit", Do = "outbox", J_ = "filex-coedit-member:";
function Z_() {
  try {
    return typeof navigator < "u" && navigator.locks ? navigator.locks : void 0;
  } catch {
    return;
  }
}
function Pm(e) {
  return new Promise((t, n) => {
    e.onsuccess = () => t(e.result), e.onerror = () => n(e.error);
  });
}
function rF() {
  const e = Wf(), t = Wf();
  let n = null;
  const a = () => (n || (n = new Promise((i) => {
    try {
      if (typeof indexedDB > "u") return i(null);
      const r = indexedDB.open(oF, 1);
      r.onupgradeneeded = () => {
        r.result.createObjectStore(Do, { keyPath: "id", autoIncrement: !0 }).createIndex("by_path", "path");
      }, r.onsuccess = () => {
        const l = r.result;
        if (l.objectStoreNames.contains(Do)) return i(l);
        l.close(), i(null);
      }, r.onerror = () => i(null), r.onblocked = () => i(null);
    } catch {
      i(null);
    }
  })), n);
  return {
    async add(i) {
      const r = await a();
      if (!r) return e.add(i);
      const l = r.transaction(Do, "readwrite"), { id: d, ...f } = i;
      return Number(await Pm(l.objectStore(Do).add(f)));
    },
    async remove(i) {
      const r = await a();
      if (!r) return e.remove(i);
      await Pm(r.transaction(Do, "readwrite").objectStore(Do).delete(i));
    },
    async listPath(i) {
      const r = await a();
      return r ? (await Pm(r.transaction(Do, "readonly").objectStore(Do).index("by_path").getAll(i))).sort((d, f) => (d.id ?? 0) - (f.id ?? 0)) : e.listPath(i);
    },
    hold(i) {
      const r = t.hold(i), l = Z_();
      if (!l || !i) return r;
      let d = () => {
      };
      const f = new Promise((m) => d = m);
      return l.request(J_ + i, () => f).catch(() => {
      }), () => {
        r(), d();
      };
    },
    async live(i) {
      if (!i) return !1;
      if (await t.live(i)) return !0;
      const r = Z_();
      if (!r) return !1;
      try {
        return await r.request(J_ + i, { ifAvailable: !0 }, (l) => l === null);
      } catch {
        return !1;
      }
    }
  };
}
const il = 12, sF = "filex-coedit-outbox-v1", ZS = new TextEncoder();
function QS(e) {
  return new Uint8Array(ZS.encode(JSON.stringify([sF, e]))).buffer;
}
async function lF(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(il)), i = ZS.encode(JSON.stringify(n)), r = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: a, additionalData: QS(t) }, e, i));
  i.fill(0);
  const l = new Uint8Array(il + r.length);
  return l.set(a, 0), l.set(r, il), Aa(l);
}
async function uF(e, t, n) {
  let a;
  try {
    a = Zn(n);
  } catch {
    return;
  }
  if (!(a.length <= il))
    for (const i of e)
      try {
        const r = await crypto.subtle.decrypt(
          { name: "AES-GCM", iv: a.slice(0, il), additionalData: QS(t) },
          i,
          a.slice(il)
        );
        return JSON.parse(new TextDecoder().decode(r));
      } catch {
      }
}
const cF = [1e3, 2e3, 4e3, 8e3, 15e3, 3e4];
function Q_(e) {
  const t = js(e);
  return t ? t.status === 0 ? !0 : t.code === "coedit_off" || t.code === "coedit_no_secret_key" ? !1 : t.status === 502 || t.status === 503 || t.status === 504 : (e == null ? void 0 : e.said) === !0;
}
const e1 = 1;
function js(e) {
  const t = e ?? {};
  if (typeof t.status != "number") return null;
  let n;
  if (typeof t.detail == "string")
    try {
      const a = JSON.parse(t.detail);
      typeof a.head == "number" && (n = a.head);
    } catch {
    }
  return { status: t.status, code: typeof t.code == "string" ? t.code : "", head: n };
}
function mr(e) {
  if (e instanceof ct) return e;
  const t = js(e);
  if (!t) return new ct("failed", "failed");
  switch (t.code) {
    case "coedit_read_only":
      return new ct("read_only", "read_only");
    case "coedit_too_large":
      return new ct("too_large", "too_large");
    case "coedit_no_blob":
      return new ct("not_found", "not_found");
    case "coedit_blob_exists":
      return new ct("failed", "exists");
    case "coedit_no_lease":
    case "coedit_log_full":
    case "coedit_save_order":
    case "coedit_conflict":
      return new ct("failed", t.code.slice(7));
    case "coedit_gone":
    case "coedit_not_ready":
    case "coedit_nothing_to_watch":
    case "coedit_busy":
      return new ct("unavailable", t.code.slice(7));
    case "coedit_off":
    case "coedit_no_secret_key":
    case "coedit_build":
    case "coedit_file_changed":
    case "coedit_full":
    case "encrypted":
      return new ct("unavailable", t.code);
    case "not_granted":
      return new ct("not_granted", "not_granted");
    case "coedit_invalid":
    case "bad_json":
      return new ct("invalid", "invalid");
  }
  return t.status === 404 ? new ct("not_found", t.code || "not_found") : new ct("failed", /^[a-z][a-z0-9_]{0,39}$/.test(t.code) ? t.code : "failed");
}
const dF = ["changes", "lock", "release"];
function fF(e) {
  try {
    return JSON.parse(e);
  } catch {
    return;
  }
}
function t1(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  return typeof t.client != "string" ? null : {
    client: t.client,
    user: typeof t.user == "string" ? t.user : "",
    name: typeof t.name == "string" ? t.name : "",
    indexUser: typeof t.index_user == "number" ? t.index_user : 0,
    canEdit: t.can_edit === !0
  };
}
class Yf {
  constructor(t, n, a, i, r, l, d, f) {
    It(this, "reader");
    It(this, "t");
    /** The app subscribed from here (null: not yet - entries wait). */
    It(this, "from", null);
    /** Entries read before the app subscribed. */
    It(this, "held", []);
    /** Entries waiting to be read, in order (the reader takes one at a time). */
    It(this, "inbox", []);
    It(this, "reading", !1);
    It(this, "sock", null);
    It(this, "closed", !1);
    It(this, "broken", !1);
    It(this, "ctr", 0);
    It(this, "ephCtr", 0);
    It(this, "ephSeen", /* @__PURE__ */ new Map());
    It(this, "appending", Promise.resolve());
    It(this, "waiters", []);
    /** What the socket said of each entry besides what the reader checks. */
    It(this, "extras", /* @__PURE__ */ new Map());
    It(this, "cursorTimer", null);
    It(this, "cursorNext", null);
    It(this, "cursorLast", 0);
    It(this, "reconnectDelay", 1e3);
    /** The seq of the last `changes` entry the reader took. */
    It(this, "changesSeen", 0);
    It(this, "outbox");
    It(this, "doc", "");
    It(this, "owner", "");
    /** The file's path as the host named it (where its kept changes are found). */
    It(this, "path", "");
    /** Releases this member's lock (lib/coeditOutbox `hold`). */
    It(this, "release", null);
    this.transport = t, this.ev = n, this.sid = a, this.me = i, this.token = r, this.keys = l, this.info = d, this.reader = new eF(l.log, a), this.t = {
      catchUpMs: 15e3,
      cursorGapMs: 200,
      ...f
    }, this.outbox = f.outbox ?? Wf();
  }
  /**
   * Join (or start) the session of the file at `path`. A session whose
   * creator has not stored the base yet is asked again for a while, then
   * `unavailable` (`not_ready`).
   */
  static async join(t, n, a, i = {}) {
    const r = Date.now() + (i.readyWaitMs ?? 2e4), l = (z) => new Promise((L) => (i.setTimeout ?? setTimeout)(L, z)), d = i.outbox ?? Wf(), f = await d.listPath(n).catch(() => []), m = [];
    for (const z of f) await d.live(z.client).catch(() => !1) || m.push(z);
    const v = {};
    i.folder && (v.e2e = !0), m.length > 0 && (v.unsent = { count: m.length });
    let b;
    for (; ; )
      try {
        b = await t.join(n, v);
        break;
      } catch (z) {
        const L = js(z);
        if ((L == null ? void 0 : L.code) === "coedit_not_ready" && Date.now() < r) {
          await l(1e3);
          continue;
        }
        throw mr(z);
      }
    const _ = String(b.session ?? ""), w = t1(b.me), k = String(b.token ?? "");
    if (!/^[0-9a-f]{32}$/.test(_) || !w || !k) throw new ct("failed", "failed");
    const x = String(b.doc ?? ""), M = await Yf.keysOf(t, b, _, w.client, k, x, i), A = new Yf(t, a, _, w, k, M, {
      head: Number(b.head ?? 0),
      changesHead: Number(b.changes_head ?? 0),
      savedThrough: Number(b.saved_through ?? 0),
      created: b.created === !0
    }, i);
    A.doc = x, A.owner = String(b.owner ?? ""), A.path = n, A.release = d.hold(w.client);
    const T = b.socket ?? {};
    A.connect(String(T.url ?? ""), String(T.ticket ?? ""));
    const N = m.filter((z) => z.doc === A.doc && z.owner === A.owner && A.owner !== "");
    if (N.length > 0) {
      const z = b.unsent_words ?? {};
      await A.recover(N, Number(b.head ?? 0), z);
    }
    return A;
  }
  /**
   * The session's three keys. An ordinary folder: the server's key, handed
   * over. An encrypted folder (KeyFolder): the member that started the
   * session makes the key here, seals it with the folder key and gives the
   * server only that; a member that joins opens the one the starter sealed.
   */
  static async keysOf(t, n, a, i, r, l, d) {
    if (n.key_mode === "server" && typeof n.key == "string") {
      const b = Zn(n.key);
      try {
        return await Kv(b, a);
      } finally {
        b.fill(0);
      }
    }
    if (n.key_mode !== "folder" || !d.folder || !l) throw new ct("unavailable", "encrypted");
    const f = d.folder();
    if (!f) throw new ct("unavailable", "locked");
    const m = { sid: a, file: l };
    if (n.created === !0) {
      const b = W6();
      try {
        const _ = await Y6(f.fmk, b, m);
        try {
          await t.call(a, "key", { client: i, token: r, sealed: _ });
        } catch (w) {
          throw mr(w);
        }
        return await Kv(b, a);
      } finally {
        b.fill(0);
      }
    }
    const v = typeof n.sealed_key == "string" ? n.sealed_key : "";
    for (const b of [f.fmk, f.previous]) {
      if (!b || !v) continue;
      const _ = await G6(b, v, m);
      if (_) return _;
    }
    throw new ct("failed", "forged");
  }
  /**
   * The changes of an earlier opening, kept in this browser (lib/coeditOutbox):
   * sent at once when they are this session's and nobody changed the
   * document since; otherwise the person is asked (the server's words), and
   * they are sent on top of what is there now, or thrown away. Sent before
   * the interface reads the log, so its editor opens with them in it.
   */
  async recover(t, n, a) {
    var b, _;
    try {
      await this.until(n);
    } catch {
      return;
    }
    const i = t[0], r = i.sid === this.sid && i.changesBase === this.changesSeen;
    let l = r;
    if (!r) {
      const w = String((i.sid === this.sid ? a.behind : a.ended) ?? "");
      if (!w || !this.t.askUnsent) return;
      const k = await this.t.askUnsent({ text: w, apply: String(a.apply ?? ""), discard: String(a.discard ?? "") }).catch(() => null);
      if (k === null) return;
      l = k;
    }
    if (!l) {
      for (const w of t) w.id !== void 0 && await this.outbox.remove(w.id).catch(() => {
      });
      return;
    }
    const d = ((_ = (b = this.t).folder) == null ? void 0 : _.call(b)) ?? null, f = d ? [d.fmk, d.previous].filter((w) => !!w) : [];
    let m = !1, v = 0;
    try {
      for (const w of t) {
        const k = w.sealed ? await uF(f, w.doc, w.body) : fF(w.body);
        if (w.id !== void 0 && await this.outbox.remove(w.id).catch(() => {
        }), k !== void 0) {
          if (m = m || await this.takeLease(), !m) {
            await this.keep("changes", k);
            continue;
          }
          v = (await this.append("changes", k)).seq;
        }
      }
    } finally {
      m && await this.lease("release", this.changesSeen).catch(() => !1);
    }
    v > 0 && (await this.until(v).catch(() => {
    }), this.info.head = Math.max(this.info.head, v), this.info.changesHead = Math.max(this.info.changesHead, v));
  }
  /** The lease for the changes being recovered, a few tries while another writer holds it. */
  async takeLease() {
    for (let t = 0; t < 10 && !this.closed; t++) {
      if (await this.lease("acquire", this.changesSeen).catch(() => !1)) return !0;
      await new Promise((n) => (this.t.setTimeout ?? setTimeout)(n, 1e3));
    }
    return !1;
  }
  /** What `coedit.join` answers the interface. */
  hello() {
    return { session: this.sid, me: { ...this.me }, ...this.info };
  }
  /** The query a save made in this session adds (`file.save`'s `through`). */
  saveParams(t) {
    return this.closed || !Number.isInteger(t) || t < 0 || t > this.reader.head ? null : { coedit: this.sid, client: this.me.client, token: this.token, through: String(t) };
  }
  /** The entries after `from` go to the interface, in order, then each new one. */
  subscribe(t) {
    if (!Number.isInteger(t) || t < 0) throw new ct("invalid", "from is an entry seq");
    this.from = t;
    const n = this.held;
    this.held = [];
    for (const a of n) a.seq > t && this.ev.entry(a);
  }
  /** Seal an entry at the place this page read last and have the relay place it. */
  append(t, n) {
    if (!dF.includes(t)) return Promise.reject(new ct("invalid", "kind is changes, lock or release"));
    const a = this.appending.then(() => this.place(t, n));
    return this.appending = a.catch(() => {
    }), a;
  }
  async place(t, n) {
    const a = t === "changes" ? await this.keep(t, n) : void 0, i = () => a !== void 0 ? this.outbox.remove(a).catch(() => {
    }) : void 0, r = this.t.retryMs ?? cF;
    let l = 0;
    for (let d = 0; d < 50; ) {
      if (this.closed || this.broken) throw new ct("unavailable", this.broken ? "broken" : "gone");
      const f = this.reader.head, m = ++this.ctr, v = await X6(this.keys.log, { sid: this.sid, seq: f + 1, client: this.me.client, ctr: m, kind: t }, this.reader.digest, n);
      try {
        const b = await this.transport.call(this.sid, "append", { client: this.me.client, token: this.token, kind: t, base: f, ctr: m, ct: v });
        return await i(), { seq: Number(b.seq ?? f + 1) };
      } catch (b) {
        const _ = js(b);
        if ((_ == null ? void 0 : _.code) === "coedit_conflict" && typeof _.head == "number") {
          d++, await this.until(_.head);
          continue;
        }
        if (Q_(b)) {
          await new Promise((w) => (this.t.setTimeout ?? setTimeout)(w, r[Math.min(l, r.length - 1)])), l++;
          continue;
        }
        throw (_ == null ? void 0 : _.code) === "coedit_gone" ? (this.gone(), mr(b)) : (await i(), mr(b));
      }
    }
    throw new ct("unavailable", "busy");
  }
  /** Keep a change in this browser (sealed in an encrypted folder); its record's id. */
  async keep(t, n) {
    var l, d;
    if (t !== "changes" || !this.doc || !this.owner || !this.me.canEdit) return;
    const a = ((d = (l = this.t).folder) == null ? void 0 : d.call(l)) ?? null;
    let i, r = !1;
    if (this.t.folder) {
      if (!a) return;
      i = await lF(a.fmk, this.doc, n), r = !0;
    } else
      i = JSON.stringify(n);
    try {
      return await this.outbox.add({
        doc: this.doc,
        owner: this.owner,
        sid: this.sid,
        client: this.me.client,
        path: this.path,
        changesBase: this.changesSeen,
        at: Date.now(),
        body: i,
        sealed: r
      });
    } catch {
      return;
    }
  }
  /** Resolves once the reader has taken entry `head` (or fails after catchUpMs). */
  until(t) {
    return this.reader.head >= t ? Promise.resolve() : new Promise((n, a) => {
      const i = this.t.setTimeout ?? setTimeout, r = this.t.clearTimeout ?? ((f) => clearTimeout(f)), l = {
        head: t,
        done: () => {
          r(d), n();
        },
        fail: (f) => {
          r(d), a(f);
        }
      }, d = i(() => {
        const f = this.waiters.indexOf(l);
        f >= 0 && this.waiters.splice(f, 1), a(new ct("unavailable", "behind"));
      }, this.t.catchUpMs);
      this.waiters.push(l);
    });
  }
  /** The changes lease: one writer at a time, and only one that has seen every change. */
  async lease(t, n) {
    var a;
    if (t !== "acquire" && t !== "release") throw new ct("invalid", "op is acquire or release");
    try {
      return (await this.transport.call(this.sid, "lease", { client: this.me.client, token: this.token, op: t, changes_seen: n })).granted === !0;
    } catch (i) {
      if (Q_(i)) return !1;
      throw ((a = js(i)) == null ? void 0 : a.code) === "coedit_gone" && this.gone(), mr(i);
    }
  }
  /** A cursor for the others: sealed, not kept, a few a second at most (the last one wins). */
  cursor(t) {
    if (this.closed || !this.me.canEdit || (this.cursorNext = { cursor: t }, this.cursorTimer !== null)) return;
    const n = Math.max(0, this.cursorLast + this.t.cursorGapMs - Date.now()), a = this.t.setTimeout ?? setTimeout;
    this.cursorTimer = a(() => {
      this.cursorTimer = null;
      const i = this.cursorNext;
      this.cursorNext = null, i && this.sendCursor(i.cursor);
    }, n);
  }
  async sendCursor(t) {
    if (!this.sock || this.sock.readyState !== e1) return;
    this.cursorLast = Date.now();
    const n = ++this.ephCtr, a = await tF(this.keys.eph, { sid: this.sid, client: this.me.client, ctr: n }, t);
    this.sock && this.sock.readyState === e1 && this.sock.send(JSON.stringify({ type: "cursor", ctr: n, ct: a }));
  }
  /** Seal and store a blob of the session (the base document, an image). */
  async putBlob(t, n) {
    if (!/^[A-Za-z0-9._-]{1,128}$/.test(t)) throw new ct("invalid", "a blob name");
    const a = await aF(this.keys.blob, { sid: this.sid, name: t }, new Uint8Array(n));
    try {
      await this.transport.putBlob(this.sid, t, { client: this.me.client, token: this.token }, a);
    } catch (i) {
      throw mr(i);
    }
  }
  /** Read and open a blob of the session. */
  async getBlob(t) {
    if (!/^[A-Za-z0-9._-]{1,128}$/.test(t)) throw new ct("invalid", "a blob name");
    let n;
    try {
      n = await this.transport.getBlob(this.sid, t, { client: this.me.client, token: this.token });
    } catch (i) {
      throw mr(i);
    }
    const a = await iF(this.keys.blob, { sid: this.sid, name: t }, new Uint8Array(n));
    if (!a) throw new ct("failed", "forged");
    return a.buffer.slice(a.byteOffset, a.byteOffset + a.byteLength);
  }
  /** Leave the session. `keepalive` for a page that is going away. */
  async leave(t = {}) {
    if (!this.closed) {
      this.close();
      try {
        await this.transport.call(this.sid, "leave", { client: this.me.client, token: this.token }, t);
      } catch {
      }
    }
  }
  /** Stop: no socket, no event, nothing waits. */
  close() {
    var n;
    this.closed = !0, (n = this.release) == null || n.call(this), this.release = null;
    const t = this.sock;
    if (this.sock = null, t) {
      t.onclose = null, t.onmessage = null;
      try {
        t.close(1e3);
      } catch {
      }
    }
    this.cursorTimer !== null && (this.t.clearTimeout ?? ((a) => clearTimeout(a)))(this.cursorTimer), this.cursorTimer = null;
  }
  // -------------------------------------------------------------------------
  // The socket
  // -------------------------------------------------------------------------
  connect(t, n) {
    if (this.closed || !t || !n) return;
    const a = this.t.socket ?? ((r) => new WebSocket(r));
    let i;
    try {
      i = a(`${t}${t.includes("?") ? "&" : "?"}ticket=${encodeURIComponent(n)}`);
    } catch {
      this.reconnectLater();
      return;
    }
    this.sock = i, i.onopen = () => {
      this.reconnectDelay = 1e3, i.send(JSON.stringify({ type: "subscribe", from: this.reader.head + this.inbox.length }));
    }, i.onmessage = (r) => this.onFrame(r.data), i.onclose = () => {
      this.sock === i && (this.sock = null), this.reconnectLater();
    }, i.onerror = () => {
    };
  }
  reconnectLater() {
    if (this.closed || this.broken) return;
    const t = this.reconnectDelay;
    this.reconnectDelay = Math.min(this.reconnectDelay * 2, 3e4), (this.t.setTimeout ?? setTimeout)(() => void this.reconnect(), t);
  }
  async reconnect() {
    var t;
    if (!(this.closed || this.broken || this.sock))
      try {
        const n = await this.transport.call(this.sid, "ticket", { client: this.me.client, token: this.token });
        this.connect(String(n.url ?? ""), String(n.ticket ?? ""));
      } catch (n) {
        if (((t = js(n)) == null ? void 0 : t.code) === "coedit_gone") {
          this.gone();
          return;
        }
        this.reconnectLater();
      }
  }
  onFrame(t) {
    if (this.closed || typeof t != "string") return;
    let n;
    try {
      n = JSON.parse(t);
    } catch {
      return;
    }
    switch (n.type) {
      case "entry":
        n.entry && this.take(n.entry);
        return;
      case "eph":
        this.takeCursor(n);
        return;
      case "ended":
        n.reason === "broken" ? this.stopBroken() : this.gone();
        return;
    }
  }
  take(t) {
    if (typeof t.seq != "number" || typeof t.kind != "string" || typeof t.client != "string") return;
    const n = this.reader.head + this.inbox.length;
    if (t.seq <= n) return;
    this.inbox.push({ seq: t.seq, kind: t.kind, client: t.client, ctr: t.ctr, ct: t.ct });
    const a = { at: typeof t.at == "number" ? t.at : 0, member: t.member, through: t.through };
    this.extras.set(t.seq, a), this.drain();
  }
  async drain() {
    if (!this.reading) {
      this.reading = !0;
      try {
        for (; this.inbox.length > 0 && !this.closed && !this.broken; ) {
          const t = this.inbox.shift(), n = this.extras.get(t.seq) ?? { at: 0 };
          this.extras.delete(t.seq);
          const a = await this.reader.read(t);
          if (!a.ok) {
            this.stopBroken();
            return;
          }
          a.kind === "changes" && (this.changesSeen = a.seq);
          const i = this.entryOf(a.seq, a.kind, a.client, a.body, n);
          i && (this.from === null ? this.held.push(i) : i.seq > this.from && this.ev.entry(i));
          for (const r of [...this.waiters])
            this.reader.head >= r.head && (this.waiters.splice(this.waiters.indexOf(r), 1), r.done());
        }
      } finally {
        this.reading = !1;
      }
    }
  }
  entryOf(t, n, a, i, r) {
    const l = { seq: t, at: r.at, client: a };
    switch (n) {
      case "join": {
        const d = t1(r.member);
        return d ? { ...l, kind: "join", member: d } : null;
      }
      case "leave":
        return { ...l, kind: "leave" };
      case "saved":
        return { ...l, kind: "saved", through: typeof r.through == "number" ? r.through : 0 };
      case "changes":
      case "lock":
      case "release":
        return { ...l, kind: n, body: i };
    }
    return null;
  }
  async takeCursor(t) {
    if (typeof t.client != "string" || typeof t.ctr != "number" || typeof t.ct != "string" || t.client === this.me.client || t.ctr <= (this.ephSeen.get(t.client) ?? 0)) return;
    this.ephSeen.set(t.client, t.ctr);
    const n = await nF(this.keys.eph, { sid: this.sid, client: t.client, ctr: t.ctr }, t.ct);
    n === void 0 || this.closed || this.ev.cursor({ client: t.client, cursor: n });
  }
  /** The membership ended: say so once, stop. */
  gone() {
    if (this.closed) return;
    const t = this.reader.head;
    this.close(), this.rejectWaiters("gone"), this.ev.dropped({ from: t, reason: "gone" });
  }
  /** The log stopped checking out: the editors would build different documents. */
  stopBroken() {
    if (this.broken || this.closed) return;
    this.broken = !0;
    const t = this.reader.head;
    this.close(), this.rejectWaiters("broken"), this.ev.dropped({ from: t, reason: "broken" });
  }
  rejectWaiters(t) {
    for (const n of this.waiters.splice(0)) n.fail(new ct("unavailable", t));
  }
}
const pF = { "data-testid": "plugin-confirm-message" }, e$ = /* @__PURE__ */ lt({
  __name: "PluginConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    title: {},
    message: {},
    danger: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale);
    return (r, l) => (p(), Je(na, {
      open: e.open,
      title: e.title || u(i)("plugin.confirm.title"),
      size: "sm",
      theme: e.theme,
      locale: e.locale,
      onClose: l[2] || (l[2] = (d) => a("close"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          onClick: l[0] || (l[0] = (d) => a("close"))
        }, y(u(i)("plugin.confirm.cancel")), 1),
        c("button", {
          type: "button",
          class: Fe(["fe-btn", e.danger ? "fe-btn--danger" : "fe-btn--primary"]),
          "data-testid": "plugin-confirm-run",
          onClick: l[1] || (l[1] = (d) => a("confirm"))
        }, y(u(i)("plugin.confirm.run")), 3)
      ]),
      default: gt(() => [
        c("p", pF, y(e.message), 1)
      ]),
      _: 1
    }, 8, ["open", "title", "theme", "locale"]));
  }
}), hF = ["data-app", "data-connected"], mF = {
  key: 0,
  class: "fe-appframe__note",
  role: "status",
  "data-testid": "appframe-updated"
}, vF = { class: "fe-appframe__note-text" }, yF = {
  key: 1,
  class: "fe-appframe__note fe-appframe__consent fe-appframe__over",
  role: "alertdialog",
  "aria-live": "assertive",
  "data-testid": "appframe-unsent"
}, gF = { class: "fe-appframe__note-text" }, bF = {
  key: 2,
  class: "fe-appframe__note fe-appframe__consent",
  role: "alertdialog",
  "aria-live": "assertive",
  "data-testid": "appframe-consent"
}, kF = { class: "fe-appframe__note-text" }, wF = ["disabled"], _F = ["role", "aria-live", "aria-hidden", "inert", "data-shown"], xF = { class: "fe-appframe__note-text" }, SF = { "data-testid": "appframe-unsaved" }, $F = ["disabled"], TF = ["disabled"], AF = ["disabled"], n1 = 5e3, a1 = 600, cg = /* @__PURE__ */ lt({
  __name: "AppFrame",
  props: {
    api: {},
    app: {},
    version: {},
    view: {},
    placement: {},
    ui: {},
    files: {},
    savePath: {},
    readOnly: { type: Boolean },
    locale: {},
    theme: {},
    userName: {},
    title: {},
    storages: {},
    startAt: {},
    e2e: {}
  },
  emits: ["connected", "dirty", "title", "toast", "close", "saved", "saved-as", "op"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = yt(() => a.locale), l = xl(), d = $(null);
    let f = null, m = null;
    const v = $(!1), b = $(!1), _ = $(null), w = $(!1), k = $(0), x = $(null), M = E(() => x.value ?? a.ui), A = $(""), T = $(""), N = E(() => a.api.appUIUrl(M.value.url)), z = E(() => new Set(M.value.grants ?? [])), L = E(() => {
      var Q;
      return ((Q = x.value) == null ? void 0 : Q.version) || a.version || a.ui.version || "";
    }), B = E(
      () => a.theme === "dark" || a.theme !== "light" && l.value ? "dark" : "light"
    ), O = [
      "--fe-bg",
      "--fe-bg-elev",
      "--fe-bg-hover",
      "--fe-bg-selected",
      "--fe-border",
      "--fe-border-soft",
      "--fe-border-strong",
      "--fe-text",
      "--fe-text-muted",
      "--fe-text-on-primary",
      "--fe-primary",
      "--fe-primary-hover",
      "--fe-primary-soft",
      "--fe-primary-ink",
      "--fe-danger",
      "--fe-danger-hover",
      "--fe-warning",
      "--fe-ok",
      "--fe-radius",
      "--fe-radius-sm",
      "--fe-radius-md",
      "--fe-radius-lg",
      "--fe-font",
      "--fe-font-mono",
      "--fe-text-xs",
      "--fe-text-sm",
      "--fe-text-md",
      "--fe-shadow",
      "--fe-shadow-sm"
    ];
    function U() {
      const Q = {};
      if (d.value && typeof getComputedStyle == "function") {
        const te = getComputedStyle(d.value);
        for (const ke of O) {
          const Ge = te.getPropertyValue(ke).trim();
          Ge && (Q[ke] = Ge);
        }
      }
      return { mode: B.value, tokens: Q };
    }
    function S(Q) {
      const te = Q.lastIndexOf(".");
      return te > 0 ? Q.slice(te + 1).toLowerCase() : "";
    }
    function F(Q) {
      const te = a.e2e;
      return !te || !z.value.has(FS) ? !1 : Q.encrypted === "folder" || Q.encrypted === "vault" && !!te.vault;
    }
    const I = E(() => (a.files ?? []).some(F));
    function G(Q) {
      return !!a.readOnly || !!Q.readOnly || Ru(Q.encrypted) && !F(Q);
    }
    function Y() {
      const Q = z.value.has("files:write");
      return (a.files ?? []).map((te, ke) => ({
        index: ke,
        name: te.name,
        ext: S(te.name),
        size: te.size ?? 0,
        mime: te.mime ?? "",
        readOnly: !Q || G(te),
        // Only when the server said so: absent means not encrypted.
        ...Ru(te.encrypted) ? { encrypted: te.encrypted } : {},
        ...F(te) ? { plaintext: !0 } : {}
      }));
    }
    function ie() {
      return {
        v: wS,
        app: { name: a.app, version: L.value },
        view: { id: a.view, placement: a.placement },
        locale: a.locale,
        dir: ol(a.locale),
        theme: U(),
        user: { name: a.userName ?? "" },
        files: Y(),
        grants: [...z.value]
      };
    }
    function me(Q) {
      if (!z.value.has(Q)) throw new ct("not_granted", `this app was not granted ${Q}`);
    }
    function q(Q) {
      const te = typeof Q == "number" ? Q : 0, ke = (a.files ?? [])[te];
      if (!Number.isInteger(te) || !ke) throw new ct("not_found", `no file at ${String(Q)}`);
      return ke;
    }
    async function C(Q, te) {
      const ke = typeof te == "string" && te.length < 200 ? te : "";
      if (typeof Q == "string") return new Blob([Q], { type: ke || "text/plain;charset=utf-8" });
      if (Q instanceof ArrayBuffer) return new Blob([Q], { type: ke });
      if (typeof ReadableStream < "u" && Q instanceof ReadableStream) return Q;
      throw new ct("invalid", "save takes a string, an ArrayBuffer or a ReadableStream");
    }
    const re = /* @__PURE__ */ new Map();
    function de(Q, te) {
      const ke = re.get(Q);
      return ke ? `${ke.size}:${ke.modified}` : typeof te.size == "number" && typeof te.modified == "number" ? `${te.size}:${te.modified}` : void 0;
    }
    function V() {
      return new ct("too_large", `at most ${yl >> 20} MiB in an encrypted folder`);
    }
    function W() {
      return new ct("unavailable", "the encrypted folder was locked");
    }
    async function ne() {
      const Q = (a.files ?? []).find(F);
      return !Q || !a.e2e ? null : Q.encrypted === "vault" ? a.e2e.vault ? a.e2e.vault.ledger(Q.path, a.app) : null : a.e2e.ledger(Q.path, a.app);
    }
    function K() {
      return r("appframe.state_no_account");
    }
    async function ce(Q) {
      const te = typeof ReadableStream < "u" && Q instanceof ReadableStream;
      if (typeof Q != "string" && !(Q instanceof ArrayBuffer) && !te)
        throw new ct("invalid", "save takes a string, an ArrayBuffer or a ReadableStream");
      const ke = [];
      let Ge = 0;
      try {
        for await (const Kt of ge(Q)) {
          if (Ge += Kt.byteLength, Ge > yl) throw V();
          ke.push(Kt);
        }
      } catch (Kt) {
        for (const Ft of ke) Ft.fill(0);
        throw Kt;
      }
      const pt = new Uint8Array(Ge);
      let Rt = 0;
      for (const Kt of ke)
        pt.set(Kt, Rt), Rt += Kt.byteLength, Kt.fill(0);
      return pt;
    }
    async function J(Q) {
      const te = a.e2e, ke = a.api.pluginUIRead;
      if (!te || typeof ke != "function") throw new ct("unavailable", "this host does not hand over encrypted files");
      const Ge = await ke(a.app, a.view, Q.path, { e2e: !0 }), pt = Ge.body ?? new Blob([await Ge.arrayBuffer()]).stream();
      try {
        return await te.open(Q.path, pt);
      } catch (Rt) {
        throw Rt instanceof Sr ? V() : new ct("failed", "the file could not be decrypted here");
      }
    }
    const H = /* @__PURE__ */ new Map();
    function X(Q, te) {
      if (Q instanceof ct) return Q;
      if (Q instanceof Sr) return V();
      if (!(Q instanceof qf)) return new ct("failed", te);
      switch (Q.why) {
        case "locked":
          return new ct("unavailable", "the vault was locked");
        case "too_large":
          return V();
        case "gone":
          return new ct("not_found", "the file is not in the vault any more");
        case "read_only":
          return new ct("read_only", "the vault is read-only here");
        case "changed":
          return new ct("failed", "changed");
        case "held":
          return new ct("failed", "vault_locked");
        case "lock_lost":
          return new ct("failed", "vault_lock_lost");
        default:
          return new ct("failed", te);
      }
    }
    async function we(Q) {
      var ke;
      const te = (ke = a.e2e) == null ? void 0 : ke.vault;
      if (!te) throw new ct("unavailable", "this host does not hand over files of a vault");
      try {
        const Ge = await te.read(Q.path);
        return Ge ? (H.set(Q.path, Ge.sig), Ge.bytes) : null;
      } catch (Ge) {
        throw X(Ge, "the file could not be decrypted here");
      }
    }
    async function it(Q, te, ke) {
      var Ft;
      const Ge = (Ft = a.e2e) == null ? void 0 : Ft.vault;
      if (!Ge) throw new ct("unavailable", "the vault was locked");
      const pt = await ce(ke), Rt = pt.byteLength;
      let Kt;
      try {
        Kt = await Ge.save(te.path, pt, H.get(te.path) ?? de(Q, te));
      } catch (dn) {
        throw X(dn, "the vault did not save it");
      } finally {
        pt.fill(0);
      }
      return H.set(te.path, Kt.sig), i("saved", { path: te.path, size: Kt.size, index: Q }), b.value = !1, i("dirty", !1), { saved: !0, size: Rt };
    }
    async function Re(Q, te) {
      const ke = Q.encrypted === "vault" ? await we(Q) : await J(Q);
      if (!ke) throw Q.encrypted === "vault" ? X(new qf("locked"), "") : W();
      const Ge = { name: Q.name, size: ke.byteLength, mime: Q.mime || "" };
      switch (te ?? "stream") {
        case "text": {
          if (ke.byteLength > fa.maxTextBytes)
            throw ke.fill(0), new ct("too_large", "read a file this large as bytes");
          const pt = new TextDecoder().decode(ke);
          return ke.fill(0), { ...Ge, text: pt };
        }
        case "bytes":
          return { ...Ge, bytes: ke.buffer };
        case "stream": {
          const pt = ke;
          return {
            ...Ge,
            stream: new ReadableStream({
              start(Rt) {
                Rt.enqueue(pt), Rt.close();
              }
            })
          };
        }
        default:
          throw ke.fill(0), new ct("invalid", "as is stream, bytes or text");
      }
    }
    async function Be(Q, te, ke, Ge) {
      if (te.encrypted === "vault") return it(Q, te, ke);
      const pt = a.e2e;
      if (!pt) throw W();
      const Rt = await ce(ke), Kt = Rt.byteLength;
      let Ft;
      try {
        Ft = await pt.seal(te.path, Rt);
      } catch ($n) {
        throw $n instanceof Sr ? V() : $n;
      } finally {
        Rt.fill(0);
      }
      if (!Ft) throw W();
      const dn = nn && typeof Ge == "number" ? nn.saveParams(Ge) : null, Jt = await a.api.pluginUISave(a.app, a.view, { path: te.path }, new Blob([Ft], { type: "application/octet-stream" }), {
        e2e: !0,
        expect: de(Q, te),
        ...dn ? { extra: dn } : {}
      });
      return typeof Jt.modified == "number" && re.set(Q, { size: Jt.size, modified: Jt.modified }), i("saved", { path: Jt.path || te.path, size: Jt.size, index: Q }), b.value = !1, i("dirty", !1), { saved: !0, size: Kt };
    }
    function We(Q) {
      if (I.value) throw new ct("unavailable", `${Q} is not offered while a file of an encrypted folder is open`);
    }
    const bt = $(null), at = E(() => {
      const Q = (a.title || "").trim();
      return Q ? Q.toLowerCase().includes(a.app.toLowerCase()) ? Q : `${Q} (${a.app})` : a.app;
    }), Ie = $(null);
    let nt = Number.NEGATIVE_INFINITY, dt = Number.NEGATIVE_INFINITY;
    function Me() {
      const Q = typeof navigator < "u" ? navigator.userActivation : void 0;
      return !!(Q != null && Q.isActive);
    }
    function be() {
      dt = Date.now();
    }
    function Ve() {
      if (!Me()) return !1;
      const Q = Date.now();
      return Q - nt < n1 || Q - dt < n1 ? !1 : (nt = Q, !0);
    }
    async function Te(Q) {
      Ve() || await mt(Q);
    }
    const qe = $(!1);
    let De = null;
    async function mt(Q) {
      if (Ie.value) throw new ct("unavailable", "a question is already on screen");
      if (qe.value = !1, De && clearTimeout(De), De = setTimeout(() => {
        qe.value = !0;
      }, a1), !await new Promise((ke) => {
        Ie.value = { text: Q, resolve: ke };
      })) throw new ct("cancelled");
    }
    function $t() {
      return r("appframe.consent_clipboard", { app: at.value });
    }
    function kt(Q) {
      return r("appframe.consent_job", { app: at.value, action: Q });
    }
    function Tt(Q) {
      return r("appframe.consent_download", { app: at.value, name: Q });
    }
    function xe(Q) {
      return r("appframe.consent_print", { app: at.value, name: Q });
    }
    function Ne() {
      return r("appframe.consent_allow");
    }
    function fe(Q) {
      if (Q && !qe.value) return;
      const te = Ie.value;
      Ie.value = null, De && clearTimeout(De), De = null, te == null || te.resolve(Q);
    }
    function Se(Q) {
      const te = typeof Q == "string" ? Q.trim() : "";
      if (!te || te.length > 255 || te === "." || te === ".." || /[\\/\u0000-\u001f]/.test(te))
        throw new ct("invalid", "name is a file name, without a folder");
      return te;
    }
    function Z() {
      return new ct("too_large", `at most ${fa.maxDownloadBytes >> 20} MiB`);
    }
    async function* ge(Q) {
      if (typeof Q == "string") {
        yield new TextEncoder().encode(Q);
        return;
      }
      if (Q instanceof ArrayBuffer) {
        yield new Uint8Array(Q);
        return;
      }
      const te = Q.getReader();
      let ke = !1;
      try {
        for (; ; ) {
          const Ge = await te.read();
          if (Ge.done) {
            ke = !0;
            return;
          }
          Ge.value && (yield Ge.value);
        }
      } finally {
        ke || await te.cancel().catch(() => {
        });
      }
    }
    async function ae(Q, te, ke) {
      var dn;
      const Ge = window.showSaveFilePicker;
      if (typeof Ge == "function") {
        let Jt = null;
        try {
          Jt = await Ge.call(window, { suggestedName: Q });
        } catch ($n) {
          if (($n == null ? void 0 : $n.name) === "AbortError") throw new ct("cancelled");
          Jt = null;
        }
        if (Jt) {
          const $n = await Jt.createWritable();
          let Bn = 0;
          try {
            for await (const se of ge(te)) {
              if (Bn += se.byteLength, Bn > fa.maxDownloadBytes) throw Z();
              await $n.write(se);
            }
          } catch (se) {
            throw await ((dn = $n.abort) == null ? void 0 : dn.call($n).catch(() => {
            })), se;
          }
          return await $n.close(), { saved: !0, size: Bn };
        }
      }
      const pt = [];
      let Rt = 0;
      for await (const Jt of ge(te)) {
        if (Rt += Jt.byteLength, Rt > fa.maxDownloadBytes) throw Z();
        pt.push(Jt);
      }
      const Kt = URL.createObjectURL(new Blob(pt, { type: ke })), Ft = document.createElement("a");
      Ft.href = Kt, Ft.download = Q, Ft.rel = "noopener", Ft.style.display = "none", document.body.appendChild(Ft);
      try {
        Ft.click();
      } finally {
        Ft.remove(), setTimeout(() => URL.revokeObjectURL(Kt), 6e4);
      }
      return { saved: !0, size: Rt };
    }
    const ve = $(null), le = $(null);
    let _e = null, Ee = null, ht = !1;
    function jt() {
      Ee == null || Ee.abort(), Ee = null, _e == null || _e.remove(), _e = null, ve.value = null;
    }
    function tn() {
      Ee == null || Ee.abort();
    }
    function Cn() {
      const Q = d.value;
      if (!Q) return {};
      const te = document.createElement("span");
      te.className = "fe-btn fe-btn--primary", te.setAttribute("aria-hidden", "true"), te.style.cssText = "position:absolute;visibility:hidden;pointer-events:none;inset-inline-start:0;top:0", te.textContent = r("appframe.consent_allow"), Q.appendChild(te);
      try {
        return s6(te);
      } finally {
        te.remove();
      }
    }
    function Lt() {
      return new ct("too_large", `at most ${fa.maxPrintBytes >> 20} MiB`);
    }
    const At = $(null);
    let zn = !1, Bt = null;
    function ft() {
      var Ge, pt;
      const Q = ((pt = (Ge = a.files) == null ? void 0 : Ge[0]) == null ? void 0 : pt.path) ?? "", te = Q.includes("://") ? eg(Q, !1) ?? "" : "";
      if (te && !kf(te)) return te;
      const ke = a.startAt ?? "";
      return ke.includes("://") && !kf(ke) ? ke : te ? tv(te) : void 0;
    }
    async function Dn(Q) {
      var te;
      if ((te = a.storages) != null && te.length) return a.storages;
      if (Bt) return Bt;
      try {
        const ke = await a.api.index(Q ?? "");
        return Bt = Array.isArray(ke == null ? void 0 : ke.storages) ? ke.storages.filter((Ge) => typeof Ge == "string" && !!Ge) : [], Bt;
      } catch {
        return [];
      }
    }
    async function Qn(Q) {
      if (zn || At.value) throw new ct("unavailable", "a question is already on screen");
      zn = !0;
      try {
        const te = ft(), ke = await Dn(te);
        if (!te && !ke.length) throw new ct("unavailable", "there is no folder to save into here");
        return await new Promise((Ge) => {
          At.value = { name: Q, storages: ke, startAt: te, resolve: Ge };
        });
      } finally {
        zn = !1;
      }
    }
    function Ln(Q) {
      const te = At.value;
      At.value = null, te == null || te.resolve(Q);
    }
    function on(Q) {
      return r("appframe.save_as_title", { app: at.value, name: Q });
    }
    async function In(Q) {
      typeof ReadableStream < "u" && Q instanceof ReadableStream && await Q.cancel().catch(() => {
      });
    }
    async function la(Q) {
      try {
        const ke = (await a.api.pluginActions()).actions.find((pt) => pt.plugin === a.app && pt.id === Q), Ge = ke ? Gt(ke.label, a.locale) : "";
        if (Ge) return Ge;
      } catch {
      }
      return Q;
    }
    const vn = {
      "session.get": () => ie(),
      async "file.read"(Q) {
        me("files:read");
        const te = Q ?? {}, ke = q(te.index);
        if (F(ke)) return Re(ke, te.as);
        const Ge = a.api.pluginUIRead, pt = typeof Ge == "function" ? await Ge(a.app, a.view, ke.path) : await a.api.fetchResponse(ke.path), Rt = Number(pt.headers.get("content-length") ?? ke.size ?? 0) || (ke.size ?? 0), Kt = ke.mime || pt.headers.get("content-type") || "", Ft = { name: ke.name, size: Rt, mime: Kt };
        switch (te.as ?? "stream") {
          case "text": {
            if (Rt > fa.maxTextBytes) throw new ct("too_large", "read a file this large as a stream");
            return { ...Ft, text: await pt.text() };
          }
          case "bytes":
            return { ...Ft, bytes: await pt.arrayBuffer() };
          case "stream":
            return pt.body ? { ...Ft, stream: pt.body } : { ...Ft, bytes: await pt.arrayBuffer() };
          default:
            throw new ct("invalid", "as is stream, bytes or text");
        }
      },
      async "file.save"(Q) {
        me("files:write");
        const te = Q ?? {}, ke = typeof te.index == "number" ? te.index : 0, Ge = q(ke);
        if (G(Ge)) throw new ct("read_only", "this file cannot be saved over here");
        if (F(Ge)) return Be(ke, Ge, te.data, te.through);
        const pt = await C(te.data, te.mime), Rt = ke === 0 && a.savePath ? a.savePath : Ge.path, Kt = nn && typeof te.through == "number" ? nn.saveParams(te.through) : null, Ft = Kt ? await a.api.pluginUISave(a.app, a.view, { path: Rt }, pt, { extra: Kt }) : await a.api.pluginUISave(a.app, a.view, { path: Rt }, pt);
        return i("saved", { path: Ft.path || Rt, size: Ft.size, index: ke }), b.value = !1, i("dirty", !1), { saved: !0, size: Ft.size };
      },
      async "file.saveAs"(Q) {
        me("files:write");
        const te = Q ?? {}, ke = typeof te.name == "string" ? te.name.trim() : "";
        if (!ke || ke.includes("/") || ke.includes("\\") || ke === "." || ke === ".." || ke.length > 255)
          throw new ct("invalid", "name is a file name, without a folder");
        I.value && (typeof ReadableStream < "u" && te.data instanceof ReadableStream && await te.data.cancel().catch(() => {
        }), We("save as"));
        const Ge = await C(te.data, te.mime);
        let pt;
        try {
          pt = await Qn(ke);
        } catch (Kt) {
          throw await In(Ge), Kt;
        }
        if (!pt)
          throw await In(Ge), new ct("cancelled");
        const Rt = await a.api.pluginUISave(a.app, a.view, { dir: pt, name: ke }, Ge);
        return i("saved-as", { path: Rt.path, name: Rt.name, size: Rt.size }), { saved: !0, name: Rt.name, size: Rt.size };
      },
      "ui.dirty"(Q) {
        return b.value = !!(Q != null && Q.dirty), i("dirty", b.value), null;
      },
      "ui.title"(Q) {
        const te = String((Q == null ? void 0 : Q.text) ?? "").slice(0, fa.maxLineChars);
        return i("title", te), null;
      },
      "ui.toast"(Q) {
        const te = Q ?? {}, ke = te.tone === "success" || te.tone === "warning" || te.tone === "error" ? te.tone : "info";
        return i("toast", { text: `${at.value}: ${String(te.text ?? "").slice(0, fa.maxLineChars)}`, tone: ke }), null;
      },
      "ui.confirm"(Q) {
        const te = typeof Q == "object" && Q ? Q : {};
        if (bt.value) throw new ct("unavailable", "a question is already on screen");
        return new Promise((ke) => {
          bt.value = {
            text: String(te.text ?? "").slice(0, 1e3),
            title: te.title ? String(te.title).slice(0, fa.maxLineChars) : void 0,
            danger: !!te.danger,
            resolve: ke
          };
        });
      },
      "ui.close"() {
        return i("close"), null;
      },
      async "clipboard.write"(Q) {
        var ke;
        const te = String((Q == null ? void 0 : Q.text) ?? "");
        if (te.length > 1 << 20) throw new ct("too_large", "at most 1 MiB of text");
        if (typeof navigator > "u" || !((ke = navigator.clipboard) != null && ke.writeText))
          throw new ct("unavailable", "this browser offers no clipboard here");
        if (Ve())
          try {
            return await navigator.clipboard.writeText(te), null;
          } catch (Ge) {
            if ((Ge == null ? void 0 : Ge.name) !== "NotAllowedError") throw Ge;
          }
        return await mt($t()), await navigator.clipboard.writeText(te), null;
      },
      async "ui.download"(Q) {
        me("ui:download");
        const te = Q ?? {}, ke = Se(te.name), Ge = te.data, pt = typeof ReadableStream < "u" && Ge instanceof ReadableStream;
        if (typeof Ge != "string" && !(Ge instanceof ArrayBuffer) && !pt)
          throw new ct("invalid", "download takes a string, an ArrayBuffer or a ReadableStream");
        if ((typeof Ge == "string" ? new Blob([Ge]).size : Ge instanceof ArrayBuffer ? Ge.byteLength : 0) > fa.maxDownloadBytes) throw Z();
        const Kt = typeof te.mime == "string" && /^[\w.+-]+\/[\w.+-]+$/.test(te.mime) ? te.mime : "application/octet-stream";
        try {
          await Te(Tt(ke));
        } catch (Ft) {
          throw pt && await Ge.cancel().catch(() => {
          }), Ft;
        }
        return ae(ke, Ge, Kt);
      },
      /**
       * 0.55: print a PDF the interface hands over (`ui:print`) - the print
       * dialog can save the PDF, so it is the person's call every time: filex
       * asks, and the dialog opens on their click on the row's Allow, a button of
       * the server's print page (lib/printPdf; security review sec055 S9). The
       * PDF is held once, as one Blob: refused at its first bytes when they are
       * not a PDF's and past LIMITS.maxPrintBytes (S10). `unavailable` where the
       * host names no print page, or while another print is being asked about.
       */
      async "ui.print"(Q) {
        me("ui:print");
        const te = Q ?? {}, ke = te.data, Ge = typeof ReadableStream < "u" && ke instanceof ReadableStream, pt = async () => {
          Ge && await ke.cancel().catch(() => {
          });
        };
        let Rt = "";
        try {
          if (Rt = Se(te.name), !(ke instanceof ArrayBuffer) && !Ge)
            throw new ct("invalid", "print takes a PDF as an ArrayBuffer or a ReadableStream");
          if (te.mime !== void 0 && te.mime !== "application/pdf") throw new ct("invalid", "print takes a PDF (application/pdf)");
          if (ke instanceof ArrayBuffer && ke.byteLength > fa.maxPrintBytes) throw Lt();
          if (ke instanceof ArrayBuffer && !Fu(ke)) throw new ct("invalid", "the data is not a PDF");
        } catch (Ft) {
          throw await pt(), Ft;
        }
        const Kt = typeof a.api.printFrameUrl == "function" ? a.api.printFrameUrl() : "";
        if (!Kt)
          throw await pt(), new ct("unavailable", "this host offers no printing");
        if (ht)
          throw await pt(), new ct("unavailable", "another print is waiting for the person");
        ht = !0;
        try {
          let Ft;
          try {
            Ft = await r6(ke instanceof ArrayBuffer ? ke : ge(ke), fa.maxPrintBytes);
          } catch (Jt) {
            throw Jt instanceof sa ? Jt.code === "too_large" ? Lt() : new ct(Jt.code, Jt.message) : Jt;
          }
          jt();
          const dn = new AbortController();
          Ee = dn, ve.value = { text: xe(Rt), shown: !1, width: 0, height: 0 }, await Zt();
          try {
            _e = await c6(Kt, Ft, {
              mount: le.value ?? d.value,
              label: Ne(),
              look: Cn(),
              armMs: a1,
              signal: dn.signal,
              onAsk: ({ width: Jt, height: $n }) => {
                Ee === dn && ve.value && (ve.value = { ...ve.value, shown: !0, width: Jt, height: $n });
              }
            });
          } catch (Jt) {
            throw Ee === dn && (ve.value = null), Jt instanceof sa ? new ct(Jt.code, Jt.message) : Jt;
          }
          return ve.value && (ve.value = { ...ve.value, shown: !1 }), { printed: !0, size: Ft.size };
        } finally {
          ht = !1, Ee = null;
        }
      },
      async "engine.call"(Q) {
        if (!M.value.engine) throw new ct("unavailable", "this app has no module");
        We("the app's module");
        const te = Q ?? {};
        if (typeof te.method != "string" || !te.method) throw new ct("invalid", "method is required");
        return (await a.api.pluginUICall(a.app, a.view, {
          method: te.method,
          params: te.params,
          paths: (a.files ?? []).map((Ge) => Ge.path)
        })).result;
      },
      async "job.submit"(Q) {
        if (!M.value.engine) throw new ct("unavailable", "this app has no module");
        We("the app's module");
        const te = Q ?? {};
        if (typeof te.action != "string" || !te.action) throw new ct("invalid", "action is required");
        Ve() || await mt(kt(await la(te.action)));
        const Ge = (await a.api.pluginActionRun(a.app, te.action, {
          paths: (a.files ?? []).map((pt) => pt.path),
          params: te.params && typeof te.params == "object" ? te.params : {}
        })).op;
        if (!Ge) throw new ct("failed", "nothing was queued");
        return i("op", Ge), { op: Ge };
      },
      /* An encrypted session (the frame holds plaintext of an encrypted folder)
         reads and writes its own sealed store; a locked folder reads as an empty
         one. Any other session: the app's ordinary store, as always. */
      async "state.get"(Q) {
        const te = String((Q == null ? void 0 : Q.key) ?? "");
        if (I.value) {
          const ke = await ne().catch(() => null);
          return ke ? await S6(a.app, ke, te) ?? null : null;
        }
        return XB(a.app, te) ?? null;
      },
      /**
       * 0.52.0: what the app's license says (`LicenseInfo`) - the status, and for a
       * valid license its dates. filex keeps the key and the licensee's name; the
       * app sees neither (only these three fields cross the bridge, whatever the
       * server answers). A free app reads `{status: "free"}`.
       */
      async "license.get"() {
        const Q = await a.api.pluginLicense(a.app), te = { status: String(Q.status ?? "free") };
        return Q.valid_until && (te.valid_until = Q.valid_until), Q.updates_until && (te.updates_until = Q.updates_until), te;
      },
      async "state.set"(Q) {
        const te = Q ?? {};
        try {
          if (I.value) {
            const ke = await ne();
            if (!ke) throw W();
            await $6(a.app, ke, String(te.key ?? ""), te.value);
          } else
            JB(a.app, String(te.key ?? ""), te.value);
        } catch (ke) {
          throw ke instanceof rc ? new ct("too_large", ke.message) : ke instanceof IS ? new ct("unavailable", K()) : ke;
        }
        return null;
      },
      /* ── editing together (0.56, files:co-edit) ─────────────────────────── */
      async "coedit.join"(Q) {
        me("files:co-edit"), me("files:read");
        const ke = q((Q ?? {}).index), Ge = Ru(ke.encrypted), pt = a.e2e;
        if (Ge && (ke.encrypted !== "folder" || !F(ke) || typeof (pt == null ? void 0 : pt.folderKeys) != "function"))
          throw new ct("unavailable", "encrypted");
        const Rt = Ge && (pt != null && pt.folderKeys) ? () => pt.folderKeys(ke.path) : void 0, Kt = kn();
        if (!Kt) throw new ct("unavailable", "this host offers no editing together");
        const Ft = nn;
        nn = null, Ft && await Ft.leave();
        const dn = await Yf.join(Kt, ke.path, {
          entry: (Jt) => m == null ? void 0 : m.emit("coedit.entry", Jt),
          cursor: (Jt) => m == null ? void 0 : m.emit("coedit.cursor", Jt),
          dropped: (Jt) => {
            nn === dn && (nn = null), m == null || m.emit("coedit.dropped", Jt);
          }
        }, { folder: Rt, outbox: Hn(), askUnsent: Ea });
        if (!m)
          throw dn.leave({ keepalive: !0 }), new ct("unavailable", "gone");
        return nn = dn, dn.hello();
      },
      "coedit.subscribe"(Q) {
        const te = Q ?? {};
        return ln().subscribe(Number(te.from ?? 0)), null;
      },
      async "coedit.append"(Q) {
        const te = Q ?? {};
        return ln().append(te.kind, te.body);
      },
      async "coedit.lease"(Q) {
        const te = Q ?? {};
        return { granted: await ln().lease(te.op, Number(te.changesSeen ?? 0)) };
      },
      "coedit.cursor"(Q) {
        return ln().cursor(Q == null ? void 0 : Q.cursor), null;
      },
      async "coedit.blob.put"(Q) {
        const te = ln(), ke = Q ?? {};
        if (!(ke.data instanceof ArrayBuffer)) throw new ct("invalid", "a blob is an ArrayBuffer");
        return await te.putBlob(String(ke.name ?? ""), ke.data), null;
      },
      async "coedit.blob.get"(Q) {
        const ke = String((Q ?? {}).name ?? "");
        return { name: ke, bytes: await ln().getBlob(ke) };
      },
      async "coedit.leave"() {
        const Q = nn;
        return nn = null, await (Q == null ? void 0 : Q.leave()), null;
      }
    };
    let nn = null;
    function ln() {
      if (!nn) throw new ct("unavailable", "not in a session (coedit.join first)");
      return nn;
    }
    function kn() {
      const Q = a.api;
      return typeof Q.coeditJoin != "function" || typeof Q.coeditCall != "function" ? null : {
        join: (te, ke) => Q.coeditJoin(a.app, a.view, te, ke),
        call: (te, ke, Ge, pt) => Q.coeditCall(a.app, a.view, te, ke, Ge, pt),
        putBlob: (te, ke, Ge, pt) => Q.coeditBlobPut(a.app, a.view, te, ke, Ge, pt),
        getBlob: (te, ke, Ge) => Q.coeditBlobGet(a.app, a.view, te, ke, Ge)
      };
    }
    let Mn = null;
    function Hn() {
      return Mn ?? (Mn = rF()), Mn;
    }
    const rn = $(null);
    function Ea(Q) {
      return rn.value ? Promise.resolve(null) : new Promise((te) => {
        rn.value = { ...Q, resolve: te };
      });
    }
    function pe(Q) {
      const te = rn.value;
      rn.value = null, te == null || te.resolve(Q);
    }
    function Le() {
      const Q = nn;
      nn = null, Q && Q.leave({ keepalive: !0 });
    }
    function Ue(Q) {
      const te = bt.value;
      bt.value = null, te == null || te.resolve(Q);
    }
    function He() {
      const Q = document.createElement("iframe");
      return Q.setAttribute("sandbox", "allow-scripts"), Q.setAttribute("referrerpolicy", "no-referrer"), Q.setAttribute("title", a.title || a.app), Q.className = "fe-appframe__frame", Q.dataset.testid = "app-frame", Q.setAttribute("src", N.value), Q;
    }
    function wt() {
      if (et(), !d.value) return;
      const Q = He(), te = RB({
        frame: () => Q,
        handlers: vn,
        onConnect: () => {
          v.value = !0, i("connected");
        },
        onDisconnect: () => {
          v.value = !1;
        }
      });
      Q.addEventListener("load", () => te.frameLoaded()), f = Q, m = te, d.value.appendChild(Q);
    }
    function et() {
      Le(), rn.value && pe(null), m == null || m.destroy(), m = null, jt(), f && (f.remove(), f = null), v.value = !1, b.value = !1, bt.value && Ue(!1), Ie.value && fe(!1), _.value && ee("keep"), At.value && Ln(null);
    }
    let oe = null;
    const je = ["pointerdown", "keydown", "touchstart"];
    Wt(() => {
      Me() && (dt = Date.now());
      for (const te of je) window.addEventListener(te, be, !0);
      window.addEventListener("pagehide", Le), wt(), oe = bP((te, ke) => {
        te !== a.app || !ke || ke === L.value || (A.value = ke, he(ke));
      });
      const Q = L.value;
      if (Q) {
        const te = ZB(a.app);
        te && te !== Q && (T.value = Q), te !== Q && K_(a.app, Q);
      }
    }), Ot(() => {
      for (const Q of je) window.removeEventListener(Q, be, !0);
      window.removeEventListener("pagehide", Le), oe == null || oe(), oe = null, et();
    }), Xe([N, k], () => wt()), Xe(
      () => a.ui,
      () => {
        x.value = null;
      }
    ), Xe(B, () => m == null ? void 0 : m.emit("theme", U())), Xe(
      () => a.locale,
      (Q) => m == null ? void 0 : m.emit("locale", { locale: Q, dir: ol(Q) })
    );
    async function Ke() {
      if (!m || !v.value) return !1;
      try {
        return await m.ask("save"), !0;
      } catch {
        return !1;
      }
    }
    async function _t() {
      if (!b.value || !v.value)
        return Oe(), !0;
      const Q = await new Promise((te) => {
        _.value = te;
      });
      if (Q === "keep") return !1;
      if (Q === "save") {
        w.value = !0;
        try {
          if (!await Ke()) return !1;
        } finally {
          w.value = !1;
        }
      }
      return Oe(), !0;
    }
    function ee(Q) {
      const te = _.value;
      _.value = null, te == null || te(Q);
    }
    function he(Q) {
      m == null || m.emit("app.updated", { version: Q });
    }
    function Oe() {
      m == null || m.emit("close.request");
    }
    function Ye() {
      k.value++;
    }
    async function rt() {
      var ke, Ge;
      if (!await _t()) return;
      const Q = A.value;
      let te = null;
      try {
        const pt = await a.api.pluginActions();
        te = ((ke = pt.views.find((Rt) => Rt.plugin === a.app && Rt.id === a.view && Rt.ui)) == null ? void 0 : ke.ui) ?? ((Ge = pt.actions.find((Rt) => Rt.plugin === a.app && Rt.view === a.view && Rt.ui)) == null ? void 0 : Ge.ui) ?? null;
      } catch {
      }
      A.value = "", T.value = "", te && (x.value = te, K_(a.app, te.version || Q)), Ye();
    }
    function St() {
      A.value = "", T.value = "";
    }
    return t({ requestSave: Ke, confirmClose: _t, notifyUpdated: he, notifyClosing: Oe, reload: Ye, reloadNewer: rt, connected: v, dirty: b }), (Q, te) => (p(), h("div", {
      ref_key: "host",
      ref: d,
      class: Fe(["fe-appframe", `fe-appframe--${e.placement}`]),
      "data-app": e.app,
      "data-connected": v.value ? "true" : "false"
    }, [
      A.value || T.value ? (p(), h("div", mF, [
        c("span", vF, y(A.value ? u(r)("appframe.updated_reload", { app: e.title || e.app }) : u(r)("appframe.updated", { app: e.title || e.app, version: T.value })), 1),
        A.value ? (p(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-reload",
          onClick: rt
        }, y(u(r)("appframe.reload")), 1)) : D("", !0),
        c("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-dismiss",
          onClick: St
        }, y(u(r)("appframe.dismiss")), 1)
      ])) : D("", !0),
      rn.value ? (p(), h("div", yF, [
        c("span", gF, y(rn.value.text), 1),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-unsent-apply",
          onClick: te[0] || (te[0] = (ke) => pe(!0))
        }, y(rn.value.apply), 1),
        c("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-unsent-discard",
          onClick: te[1] || (te[1] = (ke) => pe(!1))
        }, y(rn.value.discard), 1)
      ])) : D("", !0),
      Ie.value ? (p(), h("div", bF, [
        c("span", kF, y(Ie.value.text), 1),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-consent-allow",
          disabled: !qe.value,
          onClick: te[2] || (te[2] = (ke) => fe(!0))
        }, y(u(r)("appframe.consent_allow")), 9, wF),
        c("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-consent-deny",
          onClick: te[3] || (te[3] = (ke) => fe(!1))
        }, y(u(r)("appframe.consent_deny")), 1)
      ])) : D("", !0),
      ve.value ? (p(), h("div", {
        key: 3,
        class: Fe(["fe-appframe__note fe-appframe__consent fe-appframe__print", { "fe-appframe__print--parked": !ve.value.shown }]),
        role: ve.value.shown ? "alertdialog" : void 0,
        "aria-live": ve.value.shown ? "assertive" : void 0,
        "aria-hidden": ve.value.shown ? void 0 : "true",
        inert: ve.value.shown ? void 0 : !0,
        "data-shown": ve.value.shown ? "true" : "false",
        "data-testid": "appframe-print-ask"
      }, [
        c("span", xF, y(ve.value.text), 1),
        c("span", {
          ref_key: "printSlot",
          ref: le,
          class: "fe-appframe__print-slot",
          style: Yt(ve.value.shown ? { width: `${ve.value.width}px`, height: `${ve.value.height}px` } : void 0)
        }, null, 4),
        c("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-print-deny",
          onClick: tn
        }, y(u(r)("appframe.consent_deny")), 1)
      ], 10, _F)) : D("", !0),
      bt.value ? (p(), Je(e$, {
        key: 4,
        open: !0,
        locale: e.locale,
        theme: e.theme,
        title: `${at.value}: ${bt.value.title || u(r)("appframe.confirm_title")}`,
        message: bt.value.text,
        danger: bt.value.danger,
        onClose: te[4] || (te[4] = (ke) => Ue(!1)),
        onConfirm: te[5] || (te[5] = (ke) => Ue(!0))
      }, null, 8, ["locale", "theme", "title", "message", "danger"])) : D("", !0),
      _.value ? (p(), Je(na, {
        key: 5,
        open: !0,
        size: "sm",
        locale: e.locale,
        theme: e.theme,
        busy: w.value,
        title: u(r)("appframe.unsaved_title"),
        onClose: te[9] || (te[9] = (ke) => ee("keep"))
      }, {
        actions: gt(() => [
          c("button", {
            type: "button",
            class: "fe-btn",
            "data-testid": "appframe-keep",
            disabled: w.value,
            onClick: te[6] || (te[6] = (ke) => ee("keep"))
          }, y(u(r)("appframe.keep_open")), 9, $F),
          c("button", {
            type: "button",
            class: "fe-btn fe-btn--danger",
            "data-testid": "appframe-discard",
            disabled: w.value,
            onClick: te[7] || (te[7] = (ke) => ee("discard"))
          }, y(u(r)("appframe.discard")), 9, TF),
          c("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "appframe-save-close",
            disabled: w.value,
            onClick: te[8] || (te[8] = (ke) => ee("save"))
          }, y(u(r)("appframe.save_close")), 9, AF)
        ]),
        default: gt(() => [
          c("p", SF, y(u(r)("appframe.unsaved_text", { app: e.title || e.app })), 1)
        ]),
        _: 1
      }, 8, ["locale", "theme", "busy", "title"])) : D("", !0),
      At.value ? (p(), Je(ag, {
        key: 6,
        open: !0,
        api: e.api,
        locale: e.locale,
        theme: e.theme,
        mode: "save",
        title: on(At.value.name),
        storages: At.value.storages,
        "start-at": At.value.startAt,
        onClose: te[10] || (te[10] = (ke) => Ln(null)),
        onPick: Ln
      }, null, 8, ["api", "locale", "theme", "title", "storages", "start-at"])) : D("", !0)
    ], 10, hF));
  }
}), EF = ["data-testid"], CF = { class: "fe-inspector__heading fe-pinsp__heading" }, zF = ["aria-expanded", "aria-controls", "data-testid"], MF = ["id"], PF = ["id"], OF = {
  key: 0,
  class: "fe-inspector__empty"
}, DF = {
  key: 1,
  class: "fe-surface__error",
  role: "alert"
}, LF = {
  key: 0,
  class: "fe-pinsp__actions"
}, RF = /* @__PURE__ */ lt({
  __name: "PluginInspectorSection",
  props: {
    api: {},
    view: {},
    path: {},
    locale: {},
    theme: {},
    storages: {},
    node: {},
    writable: { type: Boolean },
    userName: {}
  },
  emits: ["op", "toast", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(!1), l = $(!1), d = $(""), f = xp(
      {
        api: n.api,
        plugin: n.view.plugin,
        view: n.view.id,
        path: () => n.path,
        locale: () => n.locale,
        errorText: () => i("plugin.view.error")
      },
      {
        onOp: (k) => a("op", k),
        onOpen: (k) => a("open", k),
        // The conversation ended (a job was queued, or the plugin said `done`):
        // what the section shows next is the view's fresh state.
        onDone: () => void b(),
        onToast: (k) => a("toast", k)
      }
    ), m = E(() => Gt(n.view.label, n.locale) || n.view.id), v = E(() => `fe-plugin-insp-${n.view.plugin}-${n.view.id}`);
    async function b() {
      var k;
      l.value = !0, d.value = "";
      try {
        const x = await n.api.pluginView(n.view.plugin, n.view.id, n.path);
        f.setSurface((x == null ? void 0 : x.surface) ?? null), x != null && x.surface || (d.value = i("plugin.view.error"));
      } catch (x) {
        f.setSurface(null), d.value = ((k = i.foreign) == null ? void 0 : k.call(i, String((x == null ? void 0 : x.message) ?? x))) || i("plugin.view.error");
      } finally {
        l.value = !1;
      }
    }
    const _ = E(
      () => n.node && n.node.type === "file" ? [{
        path: n.node.path,
        name: n.node.basename,
        size: n.node.size,
        mime: n.node.mime_type,
        readOnly: n.writable === !1 || !!n.node.read_only,
        ...n.node.encrypted ? { encrypted: n.node.encrypted } : {}
      }] : []
    );
    function w() {
      r.value = !r.value, !n.view.ui && r.value && !f.current.value && !l.value && b();
    }
    return Xe(
      () => n.path,
      () => {
        r.value = !1, d.value = "", f.setSurface(null);
      }
    ), (k, x) => (p(), h("section", {
      class: "fe-inspector__section fe-pinsp",
      "data-testid": `inspector-plugin-${e.view.plugin}-${e.view.id}`
    }, [
      c("h3", CF, [
        c("button", {
          type: "button",
          class: "fe-pinsp__toggle",
          "aria-expanded": r.value,
          "aria-controls": v.value,
          "data-testid": `inspector-plugin-toggle-${e.view.plugin}-${e.view.id}`,
          onClick: w
        }, [
          (p(), h("svg", {
            class: Fe(["fe-ficon fe-pinsp__chev", { "is-open": r.value }]),
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [...x[2] || (x[2] = [
            c("path", { d: "M9 5l7 7-7 7" }, null, -1)
          ])], 2)),
          c("span", null, y(m.value), 1)
        ], 8, zF)
      ]),
      r.value && e.view.ui ? (p(), h("div", {
        key: 0,
        id: v.value,
        class: "fe-pinsp__body"
      }, [
        (p(), Je(cg, {
          key: e.path,
          api: e.api,
          app: e.view.plugin,
          version: e.view.ui.version,
          view: e.view.id,
          placement: "inspector",
          ui: e.view.ui,
          files: _.value,
          storages: e.storages,
          "start-at": e.path,
          locale: e.locale,
          theme: e.theme,
          title: m.value,
          "user-name": e.userName,
          onToast: x[0] || (x[0] = (M) => a("toast", M.text)),
          onOp: x[1] || (x[1] = (M) => a("op", M))
        }, null, 8, ["api", "app", "version", "view", "ui", "files", "storages", "start-at", "locale", "theme", "title", "user-name"]))
      ], 8, MF)) : r.value ? (p(), h("div", {
        key: 1,
        id: v.value,
        class: "fe-pinsp__body"
      }, [
        l.value ? (p(), h("p", OF, y(u(i)("plugin.view.loading")), 1)) : d.value ? (p(), h("p", DF, y(d.value), 1)) : u(f).current.value ? (p(), h(Ce, { key: 2 }, [
          tt(Sp, {
            conv: u(f),
            locale: e.locale,
            theme: e.theme,
            api: e.api,
            plugin: e.view.plugin,
            storages: e.storages,
            "start-at": e.path
          }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at"]),
          u(f).footer.value.length ? (p(), h("div", LF, [
            tt($p, {
              conv: u(f),
              locale: e.locale,
              "testid-prefix": "inspector-plugin",
              small: ""
            }, null, 8, ["conv", "locale"])
          ])) : D("", !0)
        ], 64)) : D("", !0)
      ], 8, PF)) : D("", !0)
    ], 8, EF));
  }
}), NF = ["aria-label"], IF = { class: "fe-inspector__head" }, BF = ["innerHTML"], FF = { class: "fe-inspector__head-text" }, UF = ["title"], HF = { class: "fe-inspector__caption" }, KF = {
  key: 0,
  class: "fe-inspector__held",
  role: "note",
  "data-testid": "inspector-held"
}, VF = ["title", "aria-label"], jF = ["innerHTML"], qF = ["title", "aria-label"], WF = ["innerHTML"], YF = ["aria-label"], GF = ["aria-selected"], XF = ["aria-selected"], JF = { class: "fe-inspector__scroll" }, ZF = {
  key: 0,
  class: "fe-inspector__section"
}, QF = { class: "fe-inspector__heading" }, eU = {
  key: 0,
  class: "fe-inspector__lock",
  role: "note",
  "data-testid": "inspector-lock"
}, tU = ["data-link-state"], nU = {
  key: 2,
  class: "fe-inspector__unavailable",
  role: "note",
  "data-testid": "inspector-unavailable"
}, aU = {
  key: 3,
  class: "fe-inspector__meta"
}, iU = { class: "fe-inspector__row" }, oU = ["title"], rU = ["src"], sU = { class: "fe-inspector__meta" }, lU = { class: "fe-inspector__row" }, uU = { class: "fe-inspector__row" }, cU = { class: "fe-inspector__pathcell" }, dU = ["title"], fU = ["title", "aria-label"], pU = ["innerHTML"], hU = {
  key: 0,
  class: "fe-inspector__row"
}, mU = { class: "fe-inspector__row" }, vU = {
  key: 1,
  class: "fe-inspector__row"
}, yU = { class: "fe-inspector__mime" }, gU = {
  key: 2,
  class: "fe-inspector__row"
}, bU = { class: "fe-inspector__pathcell" }, kU = { class: "fe-inspector__path" }, wU = ["title", "aria-label"], _U = ["innerHTML"], xU = {
  key: 3,
  class: "fe-inspector__row"
}, SU = { class: "fe-inspector__pathcell" }, $U = ["title"], TU = ["title", "aria-label"], AU = ["innerHTML"], EU = {
  key: 5,
  class: "fe-inspector__empty"
}, CU = {
  key: 1,
  class: "fe-inspector__section",
  "data-testid": "inspector-tags"
}, zU = { class: "fe-inspector__heading" }, MU = {
  key: 3,
  class: "fe-inspector__section"
}, PU = { class: "fe-inspector__heading" }, OU = {
  key: 0,
  class: "fe-inspector__empty"
}, DU = {
  key: 0,
  class: "fe-inspector__empty"
}, LU = {
  key: 1,
  class: "fe-inspector__versions"
}, RU = { class: "fe-inspector__version-main" }, NU = { class: "fe-inspector__version-n" }, IU = { class: "fe-inspector__version-meta" }, BU = {
  key: 0,
  class: "fe-inspector__confirm"
}, FU = { class: "fe-inspector__confirm-q" }, UU = { class: "fe-inspector__check" }, HU = { class: "fe-inspector__confirm-actions" }, KU = ["disabled", "aria-busy", "onClick"], VU = ["disabled"], jU = ["disabled", "onClick"], qU = ["disabled", "aria-busy"], WU = {
  key: 4,
  class: "fe-inspector__section"
}, YU = { class: "fe-inspector__heading" }, GU = { class: "fe-inspector__permrow" }, XU = {
  key: 5,
  class: "fe-inspector__section",
  "data-testid": "inspector-people"
}, JU = { class: "fe-inspector__heading" }, ZU = {
  key: 0,
  class: "fe-inspector__empty"
}, QU = {
  key: 1,
  class: "fe-inspector__people"
}, eH = {
  class: "fe-inspector__avatar",
  "aria-hidden": "true"
}, tH = { class: "fe-inspector__person-main" }, nH = ["title"], aH = { class: "fe-inspector__person-sub" }, iH = {
  key: 6,
  class: "fe-inspector__section",
  "data-testid": "inspector-shares"
}, oH = { class: "fe-inspector__heading" }, rH = {
  key: 0,
  class: "fe-inspector__linkrow"
}, sH = ["innerHTML"], lH = { class: "fe-inspector__linknone" }, uH = ["disabled"], cH = {
  key: 1,
  class: "fe-inspector__empty"
}, dH = {
  key: 2,
  class: "fe-inspector__shares"
}, fH = ["title"], pH = {
  key: 0,
  class: "fe-inspector__badge fe-inspector__badge--pin"
}, hH = {
  key: 1,
  class: "fe-inspector__share-exp"
}, mH = ["title", "aria-label", "onClick"], vH = ["innerHTML"], yH = {
  key: 7,
  class: "fe-inspector__section"
}, gH = { class: "fe-inspector__heading" }, bH = {
  key: 0,
  class: "fe-inspector__countbadge"
}, kH = {
  key: 0,
  class: "fe-inspector__empty"
}, wH = {
  key: 0,
  class: "fe-inspector__empty"
}, _H = {
  key: 1,
  class: "fe-inspector__comments"
}, xH = { class: "fe-inspector__comment-top" }, SH = ["title"], $H = ["title"], TH = ["disabled", "title", "aria-label", "onClick"], AH = { class: "fe-inspector__comment-body" }, EH = ["placeholder", "aria-label", "disabled"], CH = ["disabled"], zH = {
  key: 8,
  class: "fe-inspector__section",
  "data-testid": "inspector-activity-empty"
}, MH = { class: "fe-inspector__empty" }, PH = {
  key: 0,
  class: "fe-inspector__hint"
}, OH = /* @__PURE__ */ lt({
  __name: "InspectorPanel",
  props: {
    api: {},
    nodes: {},
    dirLabel: {},
    dirCount: {},
    dirPerm: { default: "" },
    heldIn: {},
    locale: {},
    narrow: { type: Boolean, default: !1 },
    callerAdmin: { type: Boolean },
    sharing: {},
    inEncrypted: { type: Boolean },
    thumbSrc: { type: Function, default: void 0 },
    tabs: { type: Boolean, default: !0 },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    pluginViews: { default: () => [] },
    theme: {},
    storages: {},
    userName: {}
  },
  emits: ["close", "share-created", "manage-permissions", "toast", "changed", "tags-changed", "open-tag", "plugin-op", "plugin-open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, formatNodeSize: l, nodeSizeHint: d, formatDate: f, nodeDisplayName: m } = yt(
      () => n.locale
    );
    function v(le) {
      if (typeof le.e2e_display_dir != "string" || typeof le.e2e_stored != "string") return le.path;
      const _e = le.path.indexOf("://");
      return `${_e === -1 ? "" : le.path.slice(0, _e + 3)}${le.e2e_display_dir ? `${le.e2e_display_dir}/` : ""}${le.basename}`;
    }
    const b = E(
      () => n.nodes.length === 1 ? n.nodes[0] : null
    ), _ = E(() => n.nodes.length > 1), w = E(() => Lr(Ac(b.value), { t: i, formatDate: f, locale: n.locale })), k = E(() => Ec(b.value, { t: i })), x = E(() => Cc(b.value, { t: i })), M = E(() => {
      var le;
      return ((le = b.value) == null ? void 0 : le.type) === "file";
    }), A = E(
      () => {
        var le;
        return typeof ((le = b.value) == null ? void 0 : le.id) == "number" ? b.value.id : null;
      }
    ), T = E(
      () => n.nodes.reduce((le, _e) => le + (typeof _e.size == "number" ? _e.size : 0), 0)
    ), N = E(() => ({
      size: T.value,
      size_partial: n.nodes.some((le) => le.size_partial === !0)
    })), z = E(() => {
      var _e;
      const le = (_e = b.value) == null ? void 0 : _e.etag;
      return typeof le == "string" && le !== "" ? le : null;
    }), L = E(
      () => b.value && M.value && n.thumbSrc ? n.thumbSrc(b.value) : null
    ), B = E(() => {
      const le = b.value;
      return !le || qu(le) || le.trashed === !0 ? [] : (n.pluginViews ?? []).filter(
        (_e) => _e.placement === "inspector" && xy(_e.applies, [le], _e.plugin)
      );
    }), O = E(() => _.value ? i("inspector.items", { n: n.nodes.length }) : b.value ? m(b.value) : n.dirLabel), U = E(() => {
      if (_.value) return l(N.value);
      const le = b.value;
      if (le) {
        const _e = hv(le, i);
        if (le.type === "dir") return _e;
        const Ee = typeof le.size == "number" ? r(le.size) : "";
        return Ee ? `${_e} · ${Ee}` : _e;
      }
      return i("inspector.folder_items", { n: n.dirCount });
    }), S = E(
      () => {
        var le;
        return L.value && /^(image|video)[/]/.test(String(((le = b.value) == null ? void 0 : le.mime_type) ?? "")) ? L.value : null;
      }
    ), F = E(
      () => ya(b.value && !_.value ? b.value : { type: "dir" })
    ), I = E(
      () => A.value != null && n.apiBase !== void 0 && !_.value
    );
    function G(le) {
      return le.length > 12 ? `${le.slice(0, 12)}…` : le;
    }
    function Y(le) {
      return f(le, { time: !0 }) || "-";
    }
    function ie(le) {
      if (!le) return "-";
      const _e = Date.parse(le);
      return Number.isNaN(_e) ? le : Y(_e);
    }
    async function me(le) {
      try {
        await navigator.clipboard.writeText(le), a("toast", i("inspector.copied"));
      } catch {
        a("toast", le);
      }
    }
    const q = E(() => {
      if (!b.value) return "";
      const le = b.value.perm;
      return typeof le == "string" && le !== "" ? le : n.dirPerm || "";
    }), C = E(() => n.sharing ?? $L), re = E(() => Fx(n.nodes, n.inEncrypted === !0)), de = E(() => q.value === "owner" && C.value.users);
    function V(le) {
      return i(`inspector.perm.${le}`) === `inspector.perm.${le}` ? le : i(`inspector.perm.${le}`);
    }
    const W = $("idle"), ne = $([]), K = $(null), ce = $(!0), J = $(null), H = E(() => J.value !== null), X = $("idle"), we = $([]);
    let it = 0;
    async function Re() {
      const le = ++it;
      if (K.value = null, ne.value = [], we.value = [], b.value && M.value && A.value != null ? (W.value = "loading", Be(le)) : W.value = "hidden", b.value) {
        X.value = "loading";
        const _e = b.value.path;
        try {
          const { shares: Ee } = await n.api.listShares(_e);
          if (le !== it) return;
          we.value = Array.isArray(Ee) ? Ee : [], X.value = "ok";
        } catch {
          if (le !== it) return;
          X.value = "hidden";
        }
      } else
        X.value = "hidden";
    }
    async function Be(le) {
      const _e = A.value;
      if (_e != null)
        try {
          const Ee = await n.api.listVersions(_e);
          if (le !== it) return;
          ne.value = Ee, W.value = "ok";
        } catch (Ee) {
          if (le !== it) return;
          const ht = Ee.status;
          ht === 401 || ht === 403 || ht === 404 ? W.value = "hidden" : W.value = "error";
        }
    }
    function We(le) {
      K.value = le.id, ce.value = !0;
    }
    async function bt(le) {
      const _e = A.value;
      if (!(_e == null || H.value)) {
        J.value = "restore";
        try {
          await n.api.restoreVersion(_e, le.id, ce.value), a("toast", i("inspector.versions.restored")), K.value = null, a("changed"), await Be(++it);
        } catch (Ee) {
          const ht = Ov(Ee);
          a("toast", ht ? Lr(ht, { t: i, formatDate: f, locale: n.locale }) : Ee.message);
        } finally {
          J.value = null;
        }
      }
    }
    async function at() {
      const le = A.value;
      if (!(le == null || H.value)) {
        J.value = "snapshot";
        try {
          await n.api.snapshotVersion(le), a("toast", i("inspector.versions.snapshotted")), await Be(++it);
        } catch (_e) {
          const Ee = _e.status;
          Ee === 404 || Ee === 405 || Ee === 501 ? a("toast", i("inspector.versions.unsupported")) : a("toast", _e.message);
        } finally {
          J.value = null;
        }
      }
    }
    const Ie = $("details"), nt = $("hidden"), dt = $([]);
    let Me = 0;
    async function be() {
      const le = ++Me, _e = b.value;
      if (!n.tabs || !_e) {
        nt.value = "hidden", dt.value = [];
        return;
      }
      nt.value = "loading";
      try {
        const Ee = await n.api.listPermissions(_e.path);
        if (le !== Me) return;
        if (!Ee.storage_rbac) {
          nt.value = "hidden", dt.value = [];
          return;
        }
        dt.value = [...Ee.direct ?? [], ...Ee.inherited ?? []], nt.value = "ok";
      } catch {
        if (le !== Me) return;
        dt.value = [], nt.value = "hidden";
      }
    }
    function Ve(le) {
      return { name: le.user_name, display_name: le.user_display_name, email: le.user_email };
    }
    function Te(le) {
      return _p(Ve(le)) || `#${le.user_id}`;
    }
    function qe(le) {
      return s4(Ve(le), fi(n.locale)) || "?";
    }
    E(() => we.value.length ? we.value[0] : null);
    const De = $(!1);
    async function mt() {
      var _e;
      const le = b.value;
      if (!(!le || De.value || !C.value.links || re.value)) {
        De.value = !0;
        try {
          const ht = ((_e = (await n.api.createShare({ path: le.path })).share) == null ? void 0 : _e.url) ?? "", { shares: jt } = await n.api.listShares(le.path);
          we.value = Array.isArray(jt) ? jt : [], X.value = "ok", ht && (a("share-created", { path: le.path, url: ht }), await me(ht));
        } catch (Ee) {
          a("toast", Ee.message);
        } finally {
          De.value = !1;
        }
      }
    }
    Xe(
      () => [n.nodes.map((le) => le.path).join("|"), n.tabs],
      () => void be(),
      { immediate: !0 }
    );
    const $t = E(
      () => W.value !== "hidden" || kt.value !== "hidden"
    );
    Xe(
      () => n.nodes.map((le) => le.path).join("\0"),
      () => void Re(),
      { immediate: !0 }
    );
    const kt = $("hidden"), Tt = $([]), xe = $("");
    Xe(xe, (le) => {
      const _e = iy(le, fc("comment_max_runes"));
      _e !== le && (xe.value = _e);
    });
    const Ne = $(!1), fe = E(
      () => {
        var le;
        return typeof ((le = b.value) == null ? void 0 : le.id) == "number" ? b.value.id : null;
      }
    );
    let Se = 0;
    async function Z() {
      const le = ++Se, _e = fe.value;
      if (_e == null) {
        kt.value = "hidden", Tt.value = [];
        return;
      }
      kt.value = Tt.value.length > 0 ? "ok" : "loading";
      try {
        const Ee = await n.api.listComments(_e);
        if (le !== Se) return;
        Tt.value = Ee, kt.value = "ok";
      } catch (Ee) {
        if (le !== Se) return;
        Tt.value = [];
        const ht = Ee.status;
        kt.value = ht === 401 || ht === 403 || ht === 404 ? "hidden" : "error";
      }
    }
    async function ge() {
      const le = fe.value, _e = xe.value.trim();
      if (!(le == null || _e === "" || Ne.value)) {
        Ne.value = !0;
        try {
          await n.api.addComment(le, _e), xe.value = "", await Z();
        } catch (Ee) {
          a("toast", Ee.message);
        } finally {
          Ne.value = !1;
        }
      }
    }
    async function ae(le) {
      if (!Ne.value) {
        Ne.value = !0;
        try {
          await n.api.deleteComment(le.id), await Z();
        } catch (_e) {
          a("toast", _e.message);
        } finally {
          Ne.value = !1;
        }
      }
    }
    function ve(le) {
      const _e = Date.parse(le);
      if (Number.isNaN(_e)) return le;
      const Ee = Math.round((_e - Date.now()) / 1e3), ht = Math.abs(Ee), jt = [
        ["year", 31536e3],
        ["month", 2592e3],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60]
      ];
      try {
        const tn = new Intl.RelativeTimeFormat(
          fi(n.locale),
          { numeric: "auto" }
        );
        for (const [Cn, Lt] of jt)
          if (ht >= Lt) return tn.format(Math.trunc(Ee / Lt), Cn);
        return tn.format(Ee, "second");
      } catch {
        return ie(le);
      }
    }
    return Xe(
      () => fe.value,
      () => {
        Tt.value = [], xe.value = "", Z();
      },
      { immediate: !0 }
    ), (le, _e) => (p(), h("aside", {
      class: Fe(["fe-inspector", { "fe-inspector--overlay": e.narrow }]),
      role: "complementary",
      "aria-label": u(i)("inspector.title")
    }, [
      c("header", IF, [
        c("span", {
          class: "fe-inspector__head-icon",
          "aria-hidden": "true",
          innerHTML: F.value
        }, null, 8, BF),
        c("div", FF, [
          c("h2", {
            class: "fe-inspector__title",
            title: O.value
          }, [
            c("bdi", null, y(O.value), 1)
          ], 8, UF),
          c("p", HF, y(U.value), 1),
          e.heldIn ? (p(), h("p", KF, y(u(i)("inspector.held", { where: e.heldIn })), 1)) : D("", !0)
        ]),
        b.value ? (p(), h("button", {
          key: 0,
          type: "button",
          class: "fe-inspector__iconbtn",
          title: u(i)("inspector.copy_name"),
          "aria-label": u(i)("inspector.copy_name"),
          "data-testid": "inspector-copy-name",
          onClick: _e[0] || (_e[0] = (Ee) => me(O.value))
        }, [
          c("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("copy")
          }, null, 8, jF)
        ], 8, VF)) : D("", !0),
        c("button", {
          type: "button",
          class: "fe-inspector__iconbtn fe-inspector__close",
          title: u(i)("inspector.close"),
          "aria-label": u(i)("inspector.close"),
          onClick: _e[1] || (_e[1] = (Ee) => a("close"))
        }, [
          c("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("close")
          }, null, 8, WF)
        ], 8, qF)
      ]),
      e.tabs ? (p(), h("div", {
        key: 0,
        class: "fe-inspector__tabs",
        role: "tablist",
        "aria-label": u(i)("inspector.title")
      }, [
        c("button", {
          type: "button",
          class: Fe(["fe-inspector__tab", { "is-active": Ie.value === "details" }]),
          role: "tab",
          "aria-selected": Ie.value === "details",
          "data-testid": "inspector-tab-details",
          onClick: _e[2] || (_e[2] = (Ee) => Ie.value = "details")
        }, y(u(i)("inspector.tab.details")), 11, GF),
        c("button", {
          type: "button",
          class: Fe(["fe-inspector__tab", { "is-active": Ie.value === "activity" }]),
          role: "tab",
          "aria-selected": Ie.value === "activity",
          "data-testid": "inspector-tab-activity",
          onClick: _e[3] || (_e[3] = (Ee) => Ie.value = "activity")
        }, y(u(i)("inspector.tab.activity")), 11, XF)
      ], 8, YF)) : D("", !0),
      c("div", JF, [
        !e.tabs || Ie.value === "details" ? (p(), h("section", ZF, [
          c("h3", QF, y(u(i)("inspector.section.general")), 1),
          w.value ? (p(), h("p", eU, [
            _e[18] || (_e[18] = c("span", { "aria-hidden": "true" }, "🔒", -1)),
            c("span", null, [
              c("strong", null, y(u(i)("applock.inspector")), 1),
              _e[17] || (_e[17] = c("br", null, null, -1)),
              Ht(y(w.value), 1)
            ])
          ])) : D("", !0),
          k.value ? (p(), h("p", {
            key: 1,
            class: "fe-inspector__linknote",
            role: "note",
            "data-testid": "inspector-symlink",
            "data-link-state": k.value.state
          }, [
            _e[20] || (_e[20] = c("span", { "aria-hidden": "true" }, "🔗", -1)),
            c("span", null, [
              c("strong", null, y(u(i)("symlink.inspector")), 1),
              _e[19] || (_e[19] = c("br", null, null, -1)),
              Ht(y(k.value.why), 1)
            ])
          ], 8, tU)) : D("", !0),
          x.value ? (p(), h("p", nU, [
            _e[23] || (_e[23] = c("span", { "aria-hidden": "true" }, "!", -1)),
            c("span", null, [
              c("strong", null, y(u(i)("unavailable.inspector")), 1),
              _e[22] || (_e[22] = c("br", null, null, -1)),
              Ht(y(x.value.why) + " ", 1),
              x.value.reason ? (p(), h(Ce, { key: 0 }, [
                _e[21] || (_e[21] = c("br", null, null, -1)),
                c("bdi", null, y(x.value.reason), 1)
              ], 64)) : D("", !0)
            ])
          ])) : D("", !0),
          _.value ? (p(), h("dl", aU, [
            c("div", iU, [
              c("dt", null, y(u(i)("inspector.size")), 1),
              c("dd", {
                title: u(d)(N.value)
              }, y(u(l)(N.value)), 9, oU)
            ])
          ])) : b.value ? (p(), h(Ce, { key: 4 }, [
            S.value ? (p(), h("img", {
              key: 0,
              class: "fe-inspector__preview",
              src: S.value,
              alt: "",
              "aria-hidden": "true"
            }, null, 8, rU)) : D("", !0),
            c("dl", sU, [
              c("div", lU, [
                c("dt", null, y(u(i)("inspector.type")), 1),
                c("dd", null, y(u(hv)(b.value, u(i))), 1)
              ]),
              c("div", uU, [
                c("dt", null, y(u(i)("inspector.path")), 1),
                c("dd", cU, [
                  c("span", {
                    class: "fe-inspector__path",
                    title: b.value.path
                  }, [
                    c("bdi", null, y(v(b.value)), 1)
                  ], 8, dU),
                  c("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: _e[4] || (_e[4] = (Ee) => me(b.value.path))
                  }, [
                    c("span", {
                      "aria-hidden": "true",
                      innerHTML: u(zt)("copy")
                    }, null, 8, pU)
                  ], 8, fU)
                ])
              ]),
              M.value ? (p(), h("div", hU, [
                c("dt", null, y(u(i)("inspector.size")), 1),
                c("dd", null, y(u(r)(typeof b.value.size == "number" ? b.value.size : null)), 1)
              ])) : D("", !0),
              c("div", mU, [
                c("dt", null, y(u(i)("inspector.modified")), 1),
                c("dd", null, y(Y(b.value.last_modified)), 1)
              ]),
              M.value && b.value.mime_type ? (p(), h("div", vU, [
                c("dt", null, y(u(i)("inspector.mime")), 1),
                c("dd", yU, y(b.value.mime_type), 1)
              ])) : D("", !0),
              e.callerAdmin && typeof b.value.id == "number" ? (p(), h("div", gU, [
                c("dt", null, y(u(i)("inspector.nodeId")), 1),
                c("dd", bU, [
                  c("span", kU, y(b.value.id), 1),
                  c("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: _e[5] || (_e[5] = (Ee) => me(String(b.value.id)))
                  }, [
                    c("span", {
                      "aria-hidden": "true",
                      innerHTML: u(zt)("copy")
                    }, null, 8, _U)
                  ], 8, wU)
                ])
              ])) : D("", !0),
              z.value ? (p(), h("div", xU, [
                c("dt", null, y(u(i)("inspector.etag")), 1),
                c("dd", SU, [
                  c("span", {
                    class: "fe-inspector__path",
                    title: z.value
                  }, y(G(z.value)), 9, $U),
                  c("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: _e[6] || (_e[6] = (Ee) => me(z.value))
                  }, [
                    c("span", {
                      "aria-hidden": "true",
                      innerHTML: u(zt)("copy")
                    }, null, 8, AU)
                  ], 8, TU)
                ])
              ])) : D("", !0)
            ])
          ], 64)) : (p(), h("p", EU, y(u(i)("inspector.select_hint")), 1))
        ])) : D("", !0),
        I.value && (!e.tabs || Ie.value === "details") ? (p(), h("section", CU, [
          c("h3", zU, y(u(i)("inspector.section.tags")), 1),
          tt(p2, {
            "node-id": A.value,
            locale: e.locale,
            "api-base": e.apiBase,
            "auth-headers": e.authHeaders,
            "auth-credentials": e.authCredentials,
            onChange: _e[7] || (_e[7] = (Ee) => a("tags-changed", Ee)),
            onOpen: _e[8] || (_e[8] = (Ee, ht) => a("open-tag", Ee, ht)),
            onError: _e[9] || (_e[9] = () => a("toast", u(i)("inspector.error")))
          }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
        ])) : D("", !0),
        b.value && (!e.tabs || Ie.value === "details") ? (p(!0), h(Ce, { key: 2 }, ot(B.value, (Ee) => (p(), Je(RF, {
          key: `${Ee.plugin}/${Ee.id}`,
          api: e.api,
          view: Ee,
          path: b.value.path,
          node: b.value,
          locale: e.locale,
          theme: e.theme,
          storages: e.storages,
          "user-name": e.userName,
          onOp: _e[10] || (_e[10] = (ht) => a("plugin-op", ht)),
          onToast: _e[11] || (_e[11] = (ht) => a("toast", ht)),
          onOpen: (ht) => a("plugin-open", { plugin: Ee.plugin, req: ht })
        }, null, 8, ["api", "view", "path", "node", "locale", "theme", "storages", "user-name", "onOpen"]))), 128)) : D("", !0),
        (W.value === "ok" || W.value === "error") && (!e.tabs || Ie.value === "activity") ? (p(), h("section", MU, [
          c("h3", PU, y(u(i)("inspector.section.versions")), 1),
          W.value === "error" ? (p(), h("p", OU, y(u(i)("inspector.error")), 1)) : (p(), h(Ce, { key: 1 }, [
            ne.value.length === 0 ? (p(), h("p", DU, y(u(i)("inspector.versions.empty")), 1)) : (p(), h("ul", LU, [
              (p(!0), h(Ce, null, ot(ne.value, (Ee) => (p(), h("li", {
                key: Ee.id,
                class: "fe-inspector__version"
              }, [
                c("div", RU, [
                  c("span", NU, y(u(i)("inspector.versions.v", { n: Ee.version_n })), 1),
                  c("span", IU, y(ie(Ee.created_at)) + " · " + y(u(r)(Ee.size)), 1)
                ]),
                K.value === Ee.id ? (p(), h("div", BU, [
                  c("p", FU, y(u(i)("inspector.versions.restore_confirm")), 1),
                  c("label", UU, [
                    un(c("input", {
                      "onUpdate:modelValue": _e[12] || (_e[12] = (ht) => ce.value = ht),
                      type: "checkbox"
                    }, null, 512), [
                      [tp, ce.value]
                    ]),
                    Ht(" " + y(u(i)("inspector.versions.snapshot_current")), 1)
                  ]),
                  c("div", HU, [
                    c("button", {
                      type: "button",
                      class: "fe-btn fe-btn--primary fe-btn--sm",
                      disabled: H.value,
                      "aria-busy": J.value === "restore",
                      onClick: (ht) => bt(Ee)
                    }, y(J.value === "restore" ? u(i)("inspector.versions.restoring") : u(i)("inspector.versions.confirm")), 9, KU),
                    c("button", {
                      type: "button",
                      class: "fe-btn fe-btn--sm",
                      disabled: H.value,
                      onClick: _e[13] || (_e[13] = (ht) => K.value = null)
                    }, y(u(i)("inspector.versions.cancel")), 9, VU)
                  ])
                ])) : (p(), h("button", {
                  key: 1,
                  type: "button",
                  class: "fe-btn fe-btn--sm",
                  disabled: H.value,
                  onClick: (ht) => We(Ee)
                }, y(u(i)("inspector.versions.restore")), 9, jU))
              ]))), 128))
            ])),
            c("button", {
              type: "button",
              class: "fe-btn fe-btn--sm fe-inspector__snapshot",
              disabled: H.value,
              "aria-busy": J.value === "snapshot",
              onClick: at
            }, y(J.value === "snapshot" ? u(i)("inspector.versions.snapshotting") : u(i)("inspector.versions.take_snapshot")), 9, qU)
          ], 64))
        ])) : D("", !0),
        b.value && q.value && (!e.tabs || Ie.value === "details") && !(e.tabs && nt.value === "ok") ? (p(), h("section", WU, [
          c("h3", YU, y(u(i)("inspector.section.permissions")), 1),
          c("div", GU, [
            c("span", {
              class: Fe(["fe-inspector__badge", `fe-inspector__badge--${q.value}`])
            }, y(V(q.value)), 3),
            de.value ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              onClick: _e[14] || (_e[14] = (Ee) => a("manage-permissions", b.value))
            }, y(u(i)("inspector.perm.manage")), 1)) : D("", !0)
          ])
        ])) : D("", !0),
        e.tabs && Ie.value === "details" && nt.value === "ok" ? (p(), h("section", XU, [
          c("h3", JU, y(u(i)("inspector.people")), 1),
          dt.value.length === 0 ? (p(), h("p", ZU, y(u(i)("inspector.people.empty")), 1)) : (p(), h("ul", QU, [
            (p(!0), h(Ce, null, ot(dt.value, (Ee) => (p(), h("li", {
              key: `${Ee.id}-${Ee.user_id}`,
              class: "fe-inspector__person"
            }, [
              c("span", eH, y(qe(Ee)), 1),
              c("span", tH, [
                c("span", {
                  class: "fe-inspector__person-name",
                  title: Ee.user_email
                }, y(Te(Ee)), 9, nH),
                c("span", aH, [
                  Ht(y(V(Ee.level)), 1),
                  Ee.inherited ? (p(), h(Ce, { key: 0 }, [
                    Ht(" · " + y(u(i)("inspector.people.inherited")), 1)
                  ], 64)) : D("", !0)
                ])
              ])
            ]))), 128))
          ])),
          de.value && b.value ? (p(), h("button", {
            key: 2,
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: _e[15] || (_e[15] = (Ee) => a("manage-permissions", b.value))
          }, y(u(i)("inspector.people.manage")), 1)) : D("", !0)
        ])) : D("", !0),
        X.value === "ok" && (!e.tabs || Ie.value === "details") ? (p(), h("section", iH, [
          c("h3", oH, y(e.tabs ? u(i)("inspector.link") : u(i)("inspector.section.shares")), 1),
          e.tabs && we.value.length === 0 ? (p(), h("div", rH, [
            c("span", {
              class: "fe-inspector__linkicon",
              "aria-hidden": "true",
              innerHTML: u(zt)("link")
            }, null, 8, sH),
            c("span", lH, y(u(i)("inspector.link.none")), 1),
            C.value.links && !re.value ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              disabled: De.value || !b.value,
              "data-testid": "inspector-create-link",
              onClick: mt
            }, y(u(i)("inspector.link.create")), 9, uH)) : D("", !0)
          ])) : we.value.length === 0 ? (p(), h("p", cH, y(u(i)("inspector.shares.empty")), 1)) : (p(), h("ul", dH, [
            (p(!0), h(Ce, null, ot(we.value, (Ee) => (p(), h("li", {
              key: Ee.uuid,
              class: "fe-inspector__share"
            }, [
              c("span", {
                class: "fe-inspector__share-url",
                title: Ee.url
              }, y(Ee.url), 9, fH),
              Ee.password_pin ? (p(), h("span", pH, "PIN")) : D("", !0),
              Ee.expires_at ? (p(), h("span", hH, y(ie(Ee.expires_at)), 1)) : D("", !0),
              c("button", {
                type: "button",
                class: "fe-inspector__copy",
                title: u(i)("inspector.shares.copy"),
                "aria-label": u(i)("inspector.shares.copy"),
                onClick: (ht) => me(Ee.url)
              }, [
                c("span", {
                  "aria-hidden": "true",
                  innerHTML: u(zt)("copy")
                }, null, 8, vH)
              ], 8, mH)
            ]))), 128))
          ]))
        ])) : D("", !0),
        (kt.value === "ok" || kt.value === "error") && (!e.tabs || Ie.value === "activity") ? (p(), h("section", yH, [
          c("h3", gH, [
            Ht(y(u(i)("inspector.section.comments")) + " ", 1),
            Tt.value.length > 0 ? (p(), h("span", bH, y(Tt.value.length), 1)) : D("", !0)
          ]),
          kt.value === "error" ? (p(), h("p", kH, y(u(i)("inspector.error")), 1)) : (p(), h(Ce, { key: 1 }, [
            Tt.value.length === 0 ? (p(), h("p", wH, y(u(i)("inspector.comments.empty")), 1)) : (p(), h("ul", _H, [
              (p(!0), h(Ce, null, ot(Tt.value, (Ee) => (p(), h("li", {
                key: Ee.id,
                class: "fe-inspector__comment"
              }, [
                c("div", xH, [
                  c("span", {
                    class: "fe-inspector__comment-author",
                    title: Ee.author_name
                  }, y(Ee.author_name || "-"), 9, SH),
                  c("span", {
                    class: "fe-inspector__comment-time",
                    title: ie(Ee.created_at)
                  }, y(ve(Ee.created_at)), 9, $H),
                  Ee.can_delete ? (p(), h("button", {
                    key: 0,
                    type: "button",
                    class: "fe-inspector__comment-del",
                    disabled: Ne.value,
                    title: u(i)("inspector.comments.delete"),
                    "aria-label": u(i)("inspector.comments.delete"),
                    onClick: (ht) => ae(Ee)
                  }, "×", 8, TH)) : D("", !0)
                ]),
                c("p", AH, y(Ee.body), 1)
              ]))), 128))
            ])),
            c("form", {
              class: "fe-inspector__comment-form",
              onSubmit: vt(ge, ["prevent"])
            }, [
              un(c("input", {
                "onUpdate:modelValue": _e[16] || (_e[16] = (Ee) => xe.value = Ee),
                type: "text",
                class: "fe-inspector__comment-input",
                placeholder: u(i)("inspector.comments.placeholder"),
                "aria-label": u(i)("inspector.comments.placeholder"),
                disabled: Ne.value
              }, null, 8, EH), [
                [bn, xe.value]
              ]),
              c("button", {
                type: "submit",
                class: "fe-btn fe-btn--primary fe-btn--sm",
                disabled: Ne.value || xe.value.trim() === ""
              }, y(u(i)("inspector.comments.send")), 9, CH)
            ], 32)
          ], 64))
        ])) : D("", !0),
        e.tabs && Ie.value === "activity" && !$t.value ? (p(), h("section", zH, [
          c("p", MH, y(b.value ? u(i)("inspector.activity.empty") : u(i)("inspector.activity.select")), 1),
          b.value ? (p(), h("p", PH, y(u(i)("inspector.activity.hint")), 1)) : D("", !0)
        ])) : D("", !0)
      ])
    ], 10, NF));
  }
}), Vv = 500, DH = 800, i1 = 10, LH = 'button, a, input, select, textarea, label, [role="checkbox"], [data-fe-control]';
function dg(e, t) {
  return { ctrl: e.ctrlKey || e.metaKey, shift: e.shiftKey, touch: t };
}
function fg(e) {
  return { ctrl: !0, shift: e.shiftKey, check: !0 };
}
function RH(e) {
  const t = e.target;
  if (typeof (t == null ? void 0 : t.closest) != "function") return !1;
  const n = t.closest(LH), a = e.currentTarget;
  return n !== null && (a === null || typeof a.contains != "function" || a.contains(n));
}
function pg(e, t = {}) {
  let n, a = null, i = { clientX: 0, clientY: 0 }, r = !1, l = 0, d = !1;
  function f() {
    n && clearTimeout(n), n = void 0;
  }
  function m(w, k) {
    const x = k.touches[0];
    x && (f(), a = w, r = !1, i = { clientX: x.clientX, clientY: x.clientY }, d = !RH(k), n = setTimeout(() => {
      n = void 0, a !== null && (r = !0, e(a, i));
    }, Vv));
  }
  function v(w) {
    const k = w.touches[0];
    (!k || Math.abs(k.clientX - i.clientX) > i1 || Math.abs(k.clientY - i.clientY) > i1) && (f(), a = null);
  }
  function b(w) {
    f();
    const k = a, x = r, M = k !== null && !x;
    M && (l = Date.now()), a = null, M && d && t.onTap && (w != null && w.cancelable && w.preventDefault(), t.onTap(k)), x && (w != null && w.cancelable) && w.preventDefault(), d = !1;
  }
  function _(w) {
    const k = w.pointerType;
    return k ? k === "touch" : Date.now() - l < DH;
  }
  return Ot(f), { onTouchStart: m, onTouchMove: v, onTouchEnd: b, isTap: _ };
}
const o1 = 5, r1 = 10, NH = 300, s1 = 28;
function IH(e) {
  const t = $(null), n = $(null), a = $(!1);
  let i = null, r = 0;
  function l(M) {
    const A = e.keys();
    for (let T = 0; T < A.length; T++) {
      const N = e.rowEl(A[T]);
      if (!N) continue;
      const z = N.getBoundingClientRect();
      if (M < z.top + z.height / 2) return T;
    }
    return A.length;
  }
  function d(M, A) {
    const T = A.pointerType === "touch";
    if (!T && A.button !== 0) return;
    k();
    const N = e.touchDelayMs ?? Vv, z = {
      key: M,
      pointerId: A.pointerId,
      touch: T,
      startX: A.clientX,
      startY: A.clientY,
      pressed: !T || N <= 0,
      armed: !1
    };
    T && N > 0 && (z.timer = setTimeout(() => {
      i === z && (z.pressed = !0, t.value = M);
    }, N)), i = z, window.addEventListener("pointermove", m), window.addEventListener("pointerup", b), window.addEventListener("pointercancel", w), window.addEventListener("blur", w), window.addEventListener("keydown", _, !0), T && window.addEventListener("touchmove", f, { passive: !1 });
  }
  function f(M) {
    i != null && i.pressed && M.cancelable && M.preventDefault();
  }
  function m(M) {
    var O;
    const A = i;
    if (!A || M.pointerId !== A.pointerId) return;
    const T = M.clientX - A.startX, N = M.clientY - A.startY;
    if (!A.armed) {
      if (!A.pressed) {
        (Math.abs(T) > r1 || Math.abs(N) > r1) && k();
        return;
      }
      if (Math.abs(T) < o1 && Math.abs(N) < o1) return;
      A.armed = !0, t.value = A.key, a.value = !0;
    }
    const z = l(M.clientY), L = e.keys().indexOf(A.key);
    n.value = z === L || z === L + 1 ? null : z;
    const B = (O = e.scroller) == null ? void 0 : O.call(e);
    if (B) {
      const U = B.getBoundingClientRect();
      M.clientY < U.top + s1 ? B.scrollTop -= 12 : M.clientY > U.bottom - s1 && (B.scrollTop += 12);
    }
  }
  function v() {
    const M = (N) => {
      N.cancelable && N.preventDefault(), T();
    }, A = setTimeout(() => T(), 600);
    function T() {
      clearTimeout(A), window.removeEventListener("touchend", M, !0);
    }
    window.addEventListener("touchend", M, { capture: !0, passive: !1 });
  }
  function b(M) {
    var N;
    const A = i;
    if (!A || M.pointerId !== A.pointerId) return;
    const T = n.value;
    if (k(), A.touch && A.pressed && v(), A.armed) {
      r = Date.now(), T !== null && e.onDrop(A.key, T);
      return;
    }
    A.touch && A.pressed && (e.touchDelayMs ?? Vv) > 0 && (r = Date.now(), (N = e.onHold) == null || N.call(e, A.key));
  }
  function _(M) {
    M.key !== "Escape" || !i || (M.preventDefault(), M.stopPropagation(), w());
  }
  function w() {
    const M = (i == null ? void 0 : i.armed) === !0;
    k(), M && (r = Date.now());
  }
  function k() {
    i != null && i.timer && clearTimeout(i.timer), i = null, t.value = null, n.value = null, a.value = !1, window.removeEventListener("pointermove", m), window.removeEventListener("pointerup", b), window.removeEventListener("pointercancel", w), window.removeEventListener("blur", w), window.removeEventListener("keydown", _, !0), window.removeEventListener("touchmove", f);
  }
  function x(M) {
    Date.now() - r < NH && (M.preventDefault(), M.stopPropagation());
  }
  return Ot(k), {
    dragKey: t,
    dropGap: n,
    reordering: a,
    touchActive: () => (i == null ? void 0 : i.touch) === !0,
    onPointerDown: d,
    onClickCapture: x
  };
}
function Wa(e) {
  return e.uid || e.name;
}
function t$(e) {
  return e.map(Wa);
}
function Lp(e) {
  if (typeof e != "string" || !e) return [];
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return [];
  }
  if (!Array.isArray(t)) return [];
  const n = [], a = /* @__PURE__ */ new Set();
  for (const i of t)
    typeof i != "string" || !i || a.has(i) || (a.add(i), n.push(i));
  return n;
}
function BH(e) {
  return e.length ? JSON.stringify(e) : "";
}
function FH(e) {
  return typeof e == "number" && Number.isFinite(e) ? e : null;
}
function UH(e) {
  return e.map((t, n) => ({ s: t, i: n, p: FH(t.sortOrder) })).sort((t, n) => t.p === null || n.p === null ? t.p === n.p ? t.i - n.i : t.p === null ? 1 : -1 : t.p - n.p || t.i - n.i).map((t) => t.s);
}
function HH(e, t) {
  const n = UH(e);
  if (!t.length || n.length < 2) return n;
  const a = /* @__PURE__ */ new Map();
  t.forEach((d, f) => {
    a.has(d) || a.set(d, f);
  });
  const i = (d) => (d.uid ? a.get(d.uid) : void 0) ?? a.get(d.name), r = n.filter((d) => i(d) !== void 0).sort((d, f) => (i(d) ?? 0) - (i(f) ?? 0));
  let l = 0;
  return n.map((d) => i(d) === void 0 ? d : r[l++]);
}
function l1(e, t, n) {
  const a = t$(e), i = a.indexOf(t), r = i + n;
  return i < 0 || n === 0 || r < 0 || r >= a.length ? null : (a.splice(i, 1), a.splice(r, 0, t), a);
}
function KH(e, t, n) {
  const a = t$(e), i = a.indexOf(t);
  if (i < 0) return null;
  const r = Math.max(0, Math.min(a.length, Math.trunc(n)));
  return r === i || r === i + 1 ? null : (a.splice(i, 1), a.splice(r > i ? r - 1 : r, 0, t), a);
}
function u1(e) {
  return e.map((t, n) => ({ s: t, i: n })).sort((t, n) => Dx(t.s.label || t.s.name, n.s.label || n.s.name) || t.i - n.i).map((t) => Wa(t.s));
}
function VH(e, t, n) {
  const a = [...e];
  if (!n.length) return a;
  const i = /* @__PURE__ */ new Map();
  for (const l of t)
    i.set(l.name, Wa(l)), l.uid && i.set(l.uid, Wa(l));
  let r = null;
  for (const l of n) {
    const d = i.get(l);
    if (d !== void 0) {
      r = d;
      continue;
    }
    if (a.includes(l)) continue;
    const f = r === null ? 0 : a.indexOf(r) + 1;
    a.splice(f, 0, l), r = l;
  }
  return a;
}
const No = $([]);
let Ps = null, Om = "";
function jH() {
  return $l() ? Lp(jf("storageOrder")) : [];
}
function qH(e, t) {
  const n = e.length ? VH(e, t, No.value) : [];
  No.value = n;
  const a = BH(n);
  if (!Ep()) {
    Rr("storageOrder", a);
    return;
  }
  if ($S()) {
    c1(a);
    return;
  }
  Rr("storageOrder", a), Om = a, !Ps && (Ps = Cp(() => {
    Ps == null || Ps(), Ps = null, c1(Om), No.value = Lp(Om);
  }));
}
function c1(e) {
  Uo("storageOrder", e), YB();
}
function WH() {
  No.value = jH();
  const e = Cp(() => {
    No.value = Lp(yo().storageOrder);
  });
  return bl() && Ot(e), { saved: No, custom: E(() => No.value.length > 0) };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key !== ic.storageOrder || !$l() || (No.value = Lp(e.newValue));
    });
  } catch {
  }
const YH = {
  class: "fe-stags",
  "data-testid": "storage-tags"
}, GH = ["title"], XH = {
  key: 1,
  class: "fe-stag fe-stag--warn tbl-pill",
  "data-testid": "storage-tag-readonly"
}, JH = {
  key: 2,
  class: "fe-stag tbl-pill",
  "data-testid": "storage-tag-disabled"
}, n$ = /* @__PURE__ */ lt({
  __name: "StorageTags",
  props: {
    driver: {},
    readOnly: { type: Boolean },
    enabled: { type: Boolean, default: void 0 },
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = yt(() => t.locale ?? "en"), a = E(() => {
      if (!t.driver) return "";
      const i = `storages.driver.${t.driver}`, r = n(i);
      return r === i ? t.driver : r;
    });
    return (i, r) => (p(), h("span", YH, [
      e.driver ? (p(), h("span", {
        key: 0,
        class: "fe-stag tbl-pill",
        title: e.driver,
        "data-testid": "storage-tag-driver"
      }, y(a.value), 9, GH)) : D("", !0),
      e.readOnly ? (p(), h("span", XH, y(u(n)("sidenav.storage.readOnly")), 1)) : D("", !0),
      e.enabled === !1 ? (p(), h("span", JH, y(u(n)("conn.list.disabled")), 1)) : D("", !0)
    ]));
  }
}), ZH = ["aria-label"], QH = {
  key: 0,
  class: "fe-sidenav__head"
}, eK = ["aria-expanded", "title", "aria-label"], tK = { class: "fe-sidenav__primary" }, nK = ["title", "aria-label"], aK = { class: "fe-sidenav__new-main" }, iK = {
  key: 0,
  class: "fe-sidenav__text"
}, oK = {
  key: 0,
  class: "fe-sidenav__new-rule",
  "aria-hidden": "true"
}, rK = {
  key: 1,
  class: "fe-sidenav__new-caret",
  "aria-hidden": "true"
}, sK = { class: "fe-sidenav__scroll" }, lK = ["aria-label"], uK = ["aria-current", "title", "aria-label", "data-testid", "onClick"], cK = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, dK = {
  key: 1,
  d: "M3.5 7.5A1.5 1.5 0 0 1 5 6h4l2 2.5h8A1.5 1.5 0 0 1 20.5 10v7.5A1.5 1.5 0 0 1 19 19H5a1.5 1.5 0 0 1-1.5-1.5z"
}, fK = {
  key: 3,
  d: "M12 4l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4-3.9-3.8 5.4-.8z"
}, pK = {
  key: 0,
  class: "fe-sidenav__text"
}, hK = { key: 0 }, mK = ["title", "aria-label"], vK = {
  key: 0,
  class: "fe-sidenav__text"
}, yK = {
  key: 0,
  class: "fe-sidenav__section"
}, gK = { class: "fe-sidenav__heading" }, bK = ["data-testid"], kK = ["aria-label"], wK = ["aria-current", "title", "aria-label", "data-testid", "data-tag-kind", "onClick"], _K = { class: "fe-sidenav__text" }, xK = ["aria-label"], SK = { key: 0 }, $K = { class: "fe-sidenav__hint" }, TK = { key: 1 }, AK = { key: 2 }, EK = ["aria-label"], CK = ["title", "aria-label"], zK = {
  key: 1,
  class: "fe-sidenav__section"
}, MK = {
  key: 0,
  class: "fe-sidenav__heading"
}, PK = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, OK = ["aria-label"], DK = ["title", "aria-label", "data-testid", "onClick", "onContextmenu", "onKeydown", "onPointerdown"], LK = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, RK = {
  key: 0,
  class: "fe-sidenav__text"
}, NK = ["aria-label"], IK = {
  key: 2,
  class: "fe-sidenav__section",
  "data-testid": "sidenav-apps"
}, BK = {
  key: 0,
  class: "fe-sidenav__heading"
}, FK = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, UK = ["aria-label"], HK = ["title", "aria-label", "data-testid", "onClick"], KK = ["innerHTML"], VK = {
  key: 0,
  class: "fe-sidenav__text"
}, jK = { key: 0 }, qK = ["title", "aria-label"], WK = {
  key: 0,
  class: "fe-sidenav__text"
}, YK = {
  key: 3,
  class: "fe-sidenav__section"
}, GK = {
  key: 0,
  class: "fe-sidenav__heading"
}, XK = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, JK = ["aria-label"], ZK = ["title", "aria-label"], QK = {
  key: 0,
  class: "fe-sidenav__text"
}, e9 = { key: 0 }, t9 = ["title", "aria-label"], n9 = {
  key: 0,
  class: "fe-sidenav__text"
}, a9 = {
  key: 1,
  class: "fe-sidenav__quota",
  "data-testid": "sidenav-quota"
}, i9 = {
  key: 0,
  class: "fe-sidenav__quota-label"
}, o9 = ["aria-valuenow", "aria-label", "title"], r9 = {
  key: 1,
  class: "fe-sidenav__quota-text"
}, d1 = 8, s9 = /* @__PURE__ */ lt({
  __name: "SideNav",
  props: {
    expanded: { type: Boolean },
    narrow: { type: Boolean },
    activeView: {},
    activeStorage: {},
    storages: {},
    storageOrderCustom: { type: Boolean },
    sharedStorages: {},
    trashVisible: { type: Boolean },
    draftsVisible: { type: Boolean },
    draftCount: {},
    tags: {},
    tagsLoaded: { type: Boolean },
    activeTag: {},
    activeTagKind: {},
    showConnections: { type: Boolean },
    showMyShares: { type: Boolean },
    showAppStore: { type: Boolean },
    showIdentitySurfaces: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    canRequestFiles: { type: Boolean },
    requestFilesAllowed: { type: Boolean, default: !0 },
    canNewDocument: { type: Boolean },
    quota: {},
    theme: {},
    apps: {}
  },
  emits: ["toggle", "open-view", "open-tag", "open-storage", "open-root", "upload", "new-folder", "new-document", "open-connections", "open-tokens", "open-my-shares", "open-app-store", "open-app", "request-files", "reorder-storages", "close"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, dir: l } = yt(() => n.locale), d = E(() => n.expanded || !!n.narrow), f = E(() => new Set(n.sharedStorages ?? [])), m = /* @__PURE__ */ new Set(["recent", "starred", "shared", "drafts"]), v = E(() => {
      const Me = [
        { key: "home", label: i("sidenav.home") },
        ...n.storages.length <= 1 ? [{ key: "myfiles", label: i("sidenav.myfiles") }] : [],
        { key: "shared", label: i("sidenav.shared") },
        { key: "recent", label: i("sidenav.recent") },
        { key: "starred", label: i("sidenav.starred") }
      ];
      return n.draftsVisible && Me.push({ key: "drafts", label: i("sidenav.drafts") }), n.trashVisible !== !1 && Me.push({ key: "trash", label: i("sidenav.trash") }), n.showIdentitySurfaces === !1 ? Me.filter((be) => !m.has(be.key)) : Me;
    }), b = E(() => n.canWrite !== !1), _ = E(
      () => (n.apps ?? []).map((Me) => ({
        ...Me,
        svg: zt(Me.icon && zt(Me.icon) !== "" ? Me.icon : "plugin")
      }))
    ), w = E(
      () => !!n.activeStorage && n.storages.some((Me) => Me.name === n.activeStorage && Me.readOnly === !0)
    ), k = E(() => !w.value && n.activeView !== "trash");
    function x(Me) {
      const be = n.draftCount ?? 0;
      return Me.key !== "drafts" || be <= 0 ? Me.label : `${Me.label}, ${i("sidenav.drafts.count", { n: be })}`;
    }
    function M(Me) {
      return Me === "myfiles" ? !n.activeView && !n.activeStorage : n.activeView === Me;
    }
    const A = $(!1), T = E(() => n.tags ?? []), N = E(
      () => ["personal", "team"].map((Me) => {
        const be = T.value.filter((Ve) => Ve.kind === Me);
        return { kind: Me, list: be, visible: A.value ? be : be.slice(0, d1) };
      }).filter((Me) => Me.list.length > 0)
    ), z = E(
      () => N.value.reduce((Me, be) => Me + be.list.length - be.visible.length, 0)
    ), L = E(() => N.value.some((Me) => Me.list.length > d1));
    function B(Me) {
      return n.activeView !== "tag" || n.activeTag !== Me.name ? !1 : !n.activeTagKind || n.activeTagKind === Me.kind;
    }
    const O = E(() => !!n.tagsLoaded || T.value.length > 0), U = $(null), S = $(null), F = E(() => {
      const Me = [
        /* ⚠ NO `icon:` on any of these three, and that is the fix rather than an
           omission. `ContextMenu.iconFor` resolves `actionIconSvg(a.icon || a.key)`,
           so an `icon` string is an OVERRIDE — and `'⬆'` / `'📁'` / `'🔗'` are not
           keys, so the lookup missed, the component fell through to its literal
           branch and printed the emoji. Meanwhile `new-document`, which carries no
           override, resolved by key and drew a proper glyph: one menu, two icon
           systems, three rows apart. All three keys have had stroked glyphs in
           `lib/actionIcons.ts` the whole time (`upload`, `new-folder`,
           `request-files`); dropping the override is what reaches them.
           ⚠ Emoji in markup is forbidden here for a reason that is visible in this
           very menu: they are rendered by whatever font the OS ships, so the row
           came out flat-grey on one machine and full-colour on another, at a weight
           that matched nothing beside it. */
        { key: "upload", label: i("drive.new.upload"), disabled: !b.value },
        { key: "new-folder", label: i("drive.new.folder"), disabled: !b.value }
      ];
      return n.canNewDocument && Me.push({ key: "new-document", label: i("drive.new.document"), disabled: !b.value }), n.requestFilesAllowed !== !1 && (Me.push({ divider: !0, key: "new-sep", label: "" }), Me.push({
        key: "request-files",
        label: i("drive.new.request"),
        disabled: !n.canRequestFiles
      })), Me;
    });
    function I() {
      var be, Ve;
      const Me = (be = U.value) == null ? void 0 : be.getBoundingClientRect();
      (Ve = S.value) == null || Ve.show(
        // ⚠ RTL: hangs from the pill's START edge (its right side in RTL).
        { clientX: Me ? Ar(Me, l.value) : 0, clientY: Me ? Me.bottom + 6 : 0 },
        []
      );
    }
    function G(Me) {
      Me.key === "upload" ? a("upload") : Me.key === "new-document" ? a("new-document") : Me.key === "new-folder" ? a("new-folder") : Me.key === "request-files" && a("request-files");
    }
    const Y = E(() => {
      const Me = n.quota;
      return !Me || Me.unlimited || Me.total <= 0 ? 0 : Math.max(0, Math.min(100, Math.round(Me.used / Me.total * 100)));
    }), ie = E(() => {
      const Me = n.quota;
      return Me ? Me.unlimited || Me.total <= 0 ? Me.partial ? i("drive.storage.used_partial", { used: r(Me.used) }) : i("drive.storage.used_unlimited", { used: r(Me.used) }) : i("drive.storage.used", { used: r(Me.used), total: r(Me.total) }) : "";
    }), me = E(() => i("sidenav.close")), q = E(() => n.storages.length > 1), C = /* @__PURE__ */ new Map();
    function re(Me, be) {
      be instanceof HTMLElement ? C.set(Me, be) : C.delete(Me);
    }
    const de = $(null), V = $(null), W = $(""), ne = $(!1);
    function K(Me) {
      return n.storages.findIndex((be) => Wa(be) === Me);
    }
    const ce = E(() => {
      const Me = K(W.value), be = n.storages.length, Ve = n.storages.map(Wa), qe = u1(n.storages).every((De, mt) => De === Ve[mt]);
      return [
        {
          key: "storage-move-up",
          icon: "move-up",
          label: i("sidenav.storage.moveUp"),
          disabled: Me <= 0,
          testid: "sidenav-storage-move-up"
        },
        {
          key: "storage-move-down",
          icon: "move-down",
          label: i("sidenav.storage.moveDown"),
          disabled: Me < 0 || Me >= be - 1,
          testid: "sidenav-storage-move-down"
        },
        { divider: !0, key: "storage-order-sep", label: "" },
        {
          key: "storage-sort-name",
          icon: "sort-name",
          label: i("sidenav.storage.sortName"),
          disabled: qe,
          // ⚠ A greyed row says why, or it reads as broken (ContextAction.title).
          title: qe ? i("sidenav.storage.sortName.done") : void 0,
          testid: "sidenav-storage-sort-name"
        },
        {
          // "Use default order": drop the person's own order and fall back to the
          // administrator's (or, with none, the host's). Not "Reset": nothing of
          // the default is being reset, the person's order is being let go.
          key: "storage-default-order",
          icon: "reset-order",
          label: i("sidenav.storage.defaultOrder"),
          disabled: !n.storageOrderCustom,
          title: n.storageOrderCustom ? void 0 : i("sidenav.storage.defaultOrder.none"),
          testid: "sidenav-storage-default-order"
        }
      ];
    });
    function J(Me, be, Ve = !1) {
      var De, mt;
      if (!q.value) return;
      const Te = Wa(Me);
      W.value = Te, ne.value = Ve;
      let qe = be;
      if (!qe) {
        const $t = (De = C.get(Te)) == null ? void 0 : De.getBoundingClientRect();
        qe = $t ? { clientX: Ar($t, l.value), clientY: $t.bottom + 4 } : { clientX: 0, clientY: 0 };
      }
      (mt = V.value) == null || mt.show(qe, []);
    }
    function H(Me, be) {
      q.value && (be.preventDefault(), be.stopPropagation(), !We.touchActive() && J(Me, { clientX: be.clientX, clientY: be.clientY }));
    }
    let X = null;
    function we(Me = !1) {
      X == null || X();
      const be = (qe) => {
        const De = qe.target, mt = typeof (De == null ? void 0 : De.closest) == "function" && !!De.closest(".fe-ctx-backdrop");
        !Me && !mt || (qe.preventDefault(), qe.stopPropagation(), Te());
      }, Ve = setTimeout(() => Te(), 1e3);
      function Te() {
        clearTimeout(Ve), window.removeEventListener("contextmenu", be, !0), X = null;
      }
      window.addEventListener("contextmenu", be, !0), X = Te;
    }
    Ot(() => X == null ? void 0 : X());
    function it(Me, be) {
      be.key !== "ContextMenu" && !(be.key === "F10" && be.shiftKey) || q.value && (be.preventDefault(), be.stopPropagation(), we(), J(Me, null));
    }
    async function Re(Me, be) {
      var Ve;
      Me !== null && (a("reorder-storages", Me), await Zt(), (Ve = C.get(be)) == null || Ve.focus());
    }
    function Be(Me) {
      const be = W.value;
      Me.key === "storage-move-up" ? Re(l1(n.storages, be, -1), be) : Me.key === "storage-move-down" ? Re(l1(n.storages, be, 1), be) : Me.key === "storage-sort-name" ? Re(u1(n.storages), be) : Me.key === "storage-default-order" && Re([], be);
    }
    const We = IH({
      keys: () => n.storages.map(Wa),
      rowEl: (Me) => C.get(Me),
      scroller: () => {
        var Me;
        return (Me = de.value) == null ? void 0 : Me.querySelector(".fe-sidenav__scroll");
      },
      onDrop: (Me, be) => void Re(KH(n.storages, Me, be), Me),
      onHold: (Me) => {
        const be = n.storages.find((Ve) => Wa(Ve) === Me);
        be && (we(!0), J(be, null, !0));
      }
    }), { dragKey: bt, dropGap: at, reordering: Ie, onClickCapture: nt } = We;
    function dt(Me, be) {
      q.value && We.onPointerDown(Wa(Me), be);
    }
    return (Me, be) => (p(), h("nav", {
      ref_key: "navEl",
      ref: de,
      class: Fe(["fe-sidenav", {
        "fe-sidenav--rail": !e.expanded && !e.narrow,
        "fe-sidenav--drawer": e.narrow,
        "fe-sidenav--reordering": u(Ie)
      }]),
      role: "navigation",
      "aria-label": u(i)("sidenav.title"),
      "data-testid": "sidenav"
    }, [
      e.narrow ? (p(), h("div", QH, [
        c("button", {
          type: "button",
          class: "fe-sidenav__toggle",
          "aria-expanded": d.value,
          title: me.value,
          "aria-label": me.value,
          "data-testid": "sidenav-toggle",
          onClick: be[0] || (be[0] = (Ve) => a("close"))
        }, [...be[9] || (be[9] = [
          c("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            c("path", { d: "M6 6l12 12M18 6L6 18" })
          ], -1)
        ])], 8, eK)
      ])) : D("", !0),
      c("div", tK, [
        k.value ? (p(), h("button", {
          key: 0,
          ref_key: "newBtnEl",
          ref: U,
          type: "button",
          class: "fe-sidenav__new",
          "aria-haspopup": "menu",
          title: u(i)("drive.new"),
          "aria-label": u(i)("drive.new"),
          "data-testid": "sidenav-new",
          onClick: I
        }, [
          c("span", aK, [
            be[10] || (be[10] = c("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              c("path", { d: "M12 5v14M5 12h14" })
            ], -1)),
            d.value ? (p(), h("span", iK, y(u(i)("drive.new")), 1)) : D("", !0)
          ]),
          d.value ? (p(), h("span", oK)) : D("", !0),
          d.value ? (p(), h("span", rK, [...be[11] || (be[11] = [
            c("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              c("path", { d: "M7 10l5 5 5-5" })
            ], -1)
          ])])) : D("", !0)
        ], 8, nK)) : D("", !0)
      ]),
      c("div", sK, [
        c("ul", {
          class: "fe-sidenav__group",
          "aria-label": u(i)("sidenav.views")
        }, [
          (p(!0), h(Ce, null, ot(v.value, (Ve) => (p(), h(Ce, {
            key: Ve.key
          }, [
            c("li", null, [
              c("button", {
                type: "button",
                class: Fe(["fe-sidenav__item", { "is-active": M(Ve.key) }]),
                "aria-current": M(Ve.key) ? "page" : void 0,
                title: x(Ve),
                "aria-label": x(Ve),
                "data-testid": `sidenav-view-${Ve.key}`,
                onClick: (Te) => a("open-view", Ve.key)
              }, [
                (p(), h("svg", cK, [
                  Ve.key === "home" ? (p(), h(Ce, { key: 0 }, [
                    be[12] || (be[12] = c("path", { d: "M4 10.5L12 4l8 6.5" }, null, -1)),
                    be[13] || (be[13] = c("path", { d: "M6 9.8V19a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.8" }, null, -1)),
                    be[14] || (be[14] = c("path", { d: "M10 20v-5.5h4V20" }, null, -1))
                  ], 64)) : Ve.key === "myfiles" ? (p(), h("path", dK)) : Ve.key === "recent" ? (p(), h(Ce, { key: 2 }, [
                    be[15] || (be[15] = c("circle", {
                      cx: "12",
                      cy: "12",
                      r: "8.5"
                    }, null, -1)),
                    be[16] || (be[16] = c("path", { d: "M12 7.5V12l3 2" }, null, -1))
                  ], 64)) : Ve.key === "starred" ? (p(), h("path", fK)) : Ve.key === "shared" ? (p(), h(Ce, { key: 4 }, [
                    be[17] || (be[17] = c("circle", {
                      cx: "17.5",
                      cy: "6.5",
                      r: "2.5"
                    }, null, -1)),
                    be[18] || (be[18] = c("circle", {
                      cx: "6.5",
                      cy: "12",
                      r: "2.5"
                    }, null, -1)),
                    be[19] || (be[19] = c("circle", {
                      cx: "17.5",
                      cy: "17.5",
                      r: "2.5"
                    }, null, -1)),
                    be[20] || (be[20] = c("path", { d: "M8.8 10.8l6.4-3.2M8.8 13.2l6.4 3.2" }, null, -1))
                  ], 64)) : Ve.key === "drafts" ? (p(), h(Ce, { key: 5 }, [
                    be[21] || (be[21] = c("path", { d: "M13.5 4H7a1.5 1.5 0 0 0-1.5 1.5v13A1.5 1.5 0 0 0 7 20h10a1.5 1.5 0 0 0 1.5-1.5V9z" }, null, -1)),
                    be[22] || (be[22] = c("path", { d: "M13.5 4v5h5" }, null, -1)),
                    be[23] || (be[23] = c("path", { d: "M9 15.5l4.8-4.8 1.7 1.7-4.8 4.8H9z" }, null, -1))
                  ], 64)) : (p(), h(Ce, { key: 6 }, [
                    be[24] || (be[24] = c("path", { d: "M4.5 7h15" }, null, -1)),
                    be[25] || (be[25] = c("path", { d: "M9.5 7V5.2A1.2 1.2 0 0 1 10.7 4h2.6a1.2 1.2 0 0 1 1.2 1.2V7" }, null, -1)),
                    be[26] || (be[26] = c("path", { d: "M6.5 7l.9 11.1A1.4 1.4 0 0 0 8.8 19.4h6.4a1.4 1.4 0 0 0 1.4-1.3L17.5 7" }, null, -1))
                  ], 64))
                ])),
                d.value ? (p(), h("span", pK, y(Ve.label), 1)) : D("", !0),
                Ve.key === "drafts" && (e.draftCount ?? 0) > 0 ? (p(), h("span", {
                  key: 1,
                  class: Fe(["fe-sidenav__count", { "fe-sidenav__count--rail": !d.value }]),
                  "aria-hidden": "true",
                  "data-testid": "sidenav-drafts-count"
                }, y(e.draftCount), 3)) : D("", !0)
              ], 10, uK)
            ]),
            Ve.key === "shared" && e.showMyShares ? (p(), h("li", hK, [
              c("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.myshares"),
                "aria-label": u(i)("sidenav.myshares"),
                "data-testid": "sidenav-my-shares",
                onClick: be[1] || (be[1] = (Te) => a("open-my-shares"))
              }, [
                be[27] || (be[27] = c("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  c("path", { d: "M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5" }),
                  c("path", { d: "M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53" })
                ], -1)),
                d.value ? (p(), h("span", vK, y(u(i)("sidenav.myshares")), 1)) : D("", !0)
              ], 8, mK)
            ])) : D("", !0)
          ], 64))), 128))
        ], 8, lK),
        O.value ? (p(), h("div", yK, [
          d.value ? (p(), h(Ce, { key: 0 }, [
            c("p", gK, y(u(i)("sidenav.tags")), 1),
            (p(!0), h(Ce, null, ot(N.value, (Ve) => (p(), h(Ce, {
              key: Ve.kind
            }, [
              c("p", {
                class: "fe-sidenav__subheading",
                "data-testid": `sidenav-tags-${Ve.kind}`
              }, [
                tt(pv, {
                  kind: Ve.kind,
                  size: 12
                }, null, 8, ["kind"]),
                c("span", null, y(u(i)(`sidenav.tags.${Ve.kind}`)), 1)
              ], 8, bK),
              c("ul", {
                class: "fe-sidenav__group",
                "aria-label": `${u(i)("sidenav.tags")} - ${u(i)(`sidenav.tags.${Ve.kind}`)}`
              }, [
                (p(!0), h(Ce, null, ot(Ve.visible, (Te) => (p(), h("li", {
                  key: `${Te.kind}:${Te.name}`
                }, [
                  c("button", {
                    type: "button",
                    class: Fe(["fe-sidenav__item fe-sidenav__item--tag", { "is-active": B(Te) }]),
                    "aria-current": B(Te) ? "page" : void 0,
                    title: u(i)(`tags.chip.${Te.kind}`, { tag: Te.name }),
                    "aria-label": u(i)(`tags.chip.${Te.kind}`, { tag: Te.name }),
                    "data-testid": `sidenav-tag-${Te.name}`,
                    "data-tag-kind": Te.kind,
                    onClick: (qe) => a("open-tag", Te.name, Te.kind)
                  }, [
                    tt(pv, {
                      class: "fe-ficon",
                      kind: Te.kind,
                      size: 16
                    }, null, 8, ["kind"]),
                    c("span", _K, y(Te.name), 1)
                  ], 10, wK)
                ]))), 128))
              ], 8, kK)
            ], 64))), 128)),
            c("ul", {
              class: "fe-sidenav__group",
              "aria-label": u(i)("sidenav.tags")
            }, [
              T.value.length === 0 ? (p(), h("li", SK, [
                c("p", $K, y(u(i)("sidenav.tags.empty")), 1)
              ])) : D("", !0),
              z.value > 0 ? (p(), h("li", TK, [
                c("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-more",
                  onClick: be[2] || (be[2] = (Ve) => A.value = !0)
                }, y(u(i)("sidenav.tags.more", { count: z.value })), 1)
              ])) : A.value && L.value ? (p(), h("li", AK, [
                c("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-less",
                  onClick: be[3] || (be[3] = (Ve) => A.value = !1)
                }, y(u(i)("sidenav.tags.less")), 1)
              ])) : D("", !0)
            ], 8, xK)
          ], 64)) : (p(), h(Ce, { key: 1 }, [
            be[29] || (be[29] = c("hr", {
              class: "fe-sidenav__rule",
              "aria-hidden": "true"
            }, null, -1)),
            c("ul", {
              class: "fe-sidenav__group",
              "aria-label": u(i)("sidenav.tags")
            }, [
              c("li", null, [
                c("button", {
                  type: "button",
                  class: Fe(["fe-sidenav__item", { "is-active": e.activeView === "tag" }]),
                  title: u(i)("sidenav.tags"),
                  "aria-label": u(i)("sidenav.tags"),
                  "data-testid": "sidenav-tags-rail",
                  onClick: be[4] || (be[4] = (Ve) => a("toggle"))
                }, [...be[28] || (be[28] = [
                  c("svg", {
                    class: "fe-ficon",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [
                    c("path", { d: "M4 4.5h7l9 9-6.5 6.5-9-9z" }),
                    c("circle", {
                      cx: "8",
                      cy: "8.5",
                      r: "1.4"
                    })
                  ], -1)
                ])], 10, CK)
              ])
            ], 8, EK)
          ], 64))
        ])) : D("", !0),
        e.storages.length ? (p(), h("div", zK, [
          d.value ? (p(), h("p", MK, y(u(i)("sidenav.storages")), 1)) : (p(), h("hr", PK)),
          c("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.storages"),
            "data-testid": "sidenav-storages",
            onClickCapture: be[5] || (be[5] = //@ts-ignore
            (...Ve) => u(nt) && u(nt)(...Ve))
          }, [
            (p(!0), h(Ce, null, ot(e.storages, (Ve, Te) => (p(), h("li", {
              key: Ve.name,
              class: Fe({
                "is-drop-before": u(at) === Te,
                "is-drop-after": u(at) === e.storages.length && Te === e.storages.length - 1
              })
            }, [
              c("button", {
                ref_for: !0,
                ref: (qe) => re(u(Wa)(Ve), qe),
                type: "button",
                class: Fe(["fe-sidenav__item fe-sidenav__item--storage", {
                  "is-active": !e.activeView && e.activeStorage === Ve.name,
                  "is-dragging": u(bt) === u(Wa)(Ve)
                }]),
                title: f.value.has(Ve.name) ? `${Ve.label || Ve.name} - ${u(i)("sidenav.storage.shared")}` : Ve.label || Ve.name,
                "aria-label": f.value.has(Ve.name) ? `${Ve.label || Ve.name} - ${u(i)("sidenav.storage.shared")}` : Ve.label || Ve.name,
                "data-testid": `sidenav-storage-${Ve.name}`,
                onClick: (qe) => a("open-storage", Ve.name),
                onContextmenu: (qe) => H(Ve, qe),
                onKeydown: (qe) => it(Ve, qe),
                onPointerdown: (qe) => dt(Ve, qe)
              }, [
                (p(), h("svg", LK, [
                  f.value.has(Ve.name) ? (p(), h(Ce, { key: 0 }, [
                    be[30] || (be[30] = c("path", { d: "M3 8.5A1.5 1.5 0 0 1 4.5 7h5L11 9h8.5A1.5 1.5 0 0 1 21 10.5v7A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5z" }, null, -1)),
                    be[31] || (be[31] = c("circle", {
                      cx: "15.6",
                      cy: "13.6",
                      r: "1.6"
                    }, null, -1)),
                    be[32] || (be[32] = c("circle", {
                      cx: "9.4",
                      cy: "15.4",
                      r: "1.6"
                    }, null, -1)),
                    be[33] || (be[33] = c("path", { d: "M10.9 14.7l3.3-.9" }, null, -1))
                  ], 64)) : (p(), h(Ce, { key: 1 }, [
                    be[34] || (be[34] = c("rect", {
                      x: "3",
                      y: "5",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    be[35] || (be[35] = c("rect", {
                      x: "3",
                      y: "13",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    be[36] || (be[36] = c("path", { d: "M6.5 8h.01M6.5 16h.01" }, null, -1))
                  ], 64))
                ])),
                d.value ? (p(), h("span", RK, y(Ve.label || Ve.name), 1)) : D("", !0),
                d.value && f.value.has(Ve.name) ? (p(), h("span", {
                  key: 1,
                  class: "fe-sidenav__tag",
                  role: "img",
                  "aria-label": u(i)("sidenav.storage.shared")
                }, y(u(i)("sidenav.storage.shared")), 9, NK)) : D("", !0),
                d.value && Ve.readOnly ? (p(), Je(n$, {
                  key: 2,
                  "read-only": "",
                  locale: e.locale,
                  class: "fe-sidenav__stags",
                  "data-testid": "sidenav-storage-readonly"
                }, null, 8, ["locale"])) : D("", !0)
              ], 42, DK)
            ], 2))), 128))
          ], 40, OK)
        ])) : D("", !0),
        _.value.length || e.showAppStore ? (p(), h("div", IK, [
          d.value ? (p(), h("p", BK, y(u(i)("sidenav.apps")), 1)) : (p(), h("hr", FK)),
          c("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.apps")
          }, [
            (p(!0), h(Ce, null, ot(_.value, (Ve) => (p(), h("li", {
              key: Ve.key
            }, [
              c("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: Ve.label,
                "aria-label": Ve.label,
                "data-testid": `sidenav-app-${Ve.key}`,
                onClick: (Te) => a("open-app", Ve.key)
              }, [
                c("span", {
                  class: "fe-sidenav__appicon",
                  "aria-hidden": "true",
                  innerHTML: Ve.svg
                }, null, 8, KK),
                d.value ? (p(), h("span", VK, y(Ve.label), 1)) : D("", !0)
              ], 8, HK)
            ]))), 128)),
            e.showAppStore ? (p(), h("li", jK, [
              c("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.appstore"),
                "aria-label": u(i)("sidenav.appstore"),
                "data-testid": "sidenav-app-store",
                onClick: be[6] || (be[6] = (Ve) => a("open-app-store"))
              }, [
                be[37] || (be[37] = c("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  c("path", { d: "M3 9l1.5-5h15L21 9" }),
                  c("path", { d: "M3 9a3 3 0 0 0 6 0a3 3 0 0 0 6 0a3 3 0 0 0 6 0" }),
                  c("path", { d: "M5 11.5V20h14v-8.5" }),
                  c("path", { d: "M10 20v-5h4v5" })
                ], -1)),
                d.value ? (p(), h("span", WK, y(u(i)("sidenav.appstore")), 1)) : D("", !0)
              ], 8, qK)
            ])) : D("", !0)
          ], 8, UK)
        ])) : D("", !0),
        e.showConnections ? (p(), h("div", YK, [
          d.value ? (p(), h("p", GK, y(u(i)("sidenav.connections")), 1)) : (p(), h("hr", XK)),
          c("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.connections")
          }, [
            c("li", null, [
              c("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.connect"),
                "aria-label": u(i)("sidenav.connect"),
                "data-testid": "sidenav-connect",
                onClick: be[7] || (be[7] = (Ve) => a("open-connections"))
              }, [
                be[38] || (be[38] = c("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  c("path", { d: "M9.5 14.5l-2.6 2.6a3.7 3.7 0 0 1-5.2-5.2l2.6-2.6" }),
                  c("path", { d: "M14.5 9.5l2.6-2.6a3.7 3.7 0 0 1 5.2 5.2l-2.6 2.6" }),
                  c("path", { d: "M9 15l6-6" })
                ], -1)),
                d.value ? (p(), h("span", QK, y(u(i)("sidenav.connect")), 1)) : D("", !0)
              ], 8, ZK)
            ]),
            e.showIdentitySurfaces !== !1 ? (p(), h("li", e9, [
              c("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.apikeys"),
                "aria-label": u(i)("sidenav.apikeys"),
                "data-testid": "sidenav-apikeys",
                onClick: be[8] || (be[8] = (Ve) => a("open-tokens"))
              }, [
                be[39] || (be[39] = c("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  c("circle", {
                    cx: "8",
                    cy: "12",
                    r: "3.5"
                  }),
                  c("path", { d: "M11.5 12H21" }),
                  c("path", { d: "M17.5 12v3.2M20 12v2.2" })
                ], -1)),
                d.value ? (p(), h("span", n9, y(u(i)("sidenav.apikeys")), 1)) : D("", !0)
              ], 8, t9)
            ])) : D("", !0)
          ], 8, JK)
        ])) : D("", !0)
      ]),
      e.quota ? (p(), h("div", a9, [
        d.value ? (p(), h("p", i9, y(u(i)("drive.storage.label")), 1)) : D("", !0),
        c("div", {
          class: "fe-sidenav__quota-bar",
          role: "progressbar",
          "aria-valuenow": Y.value,
          "aria-valuemin": "0",
          "aria-valuemax": "100",
          "aria-label": ie.value,
          title: ie.value
        }, [
          c("span", {
            class: "fe-sidenav__quota-fill",
            style: Yt({ width: Y.value + "%" })
          }, null, 4)
        ], 8, o9),
        d.value ? (p(), h("p", r9, y(ie.value), 1)) : D("", !0)
      ])) : D("", !0),
      tt(rl, {
        ref_key: "newMenuRef",
        ref: S,
        locale: e.locale,
        theme: e.theme,
        actions: F.value,
        onSelect: G
      }, null, 8, ["locale", "theme", "actions"]),
      tt(rl, {
        ref_key: "storageMenuRef",
        ref: V,
        locale: e.locale,
        theme: e.theme,
        sheet: ne.value,
        actions: ce.value,
        onSelect: Be
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 10, ZH));
  }
}), l9 = 200;
function f1(e) {
  if (!e || typeof e != "object") return !1;
  const t = e, n = t.e2e_name_state;
  return n === "enc" || n === "locked" || n === "unreadable" ? !0 : typeof t.vault_root == "string" && t.vault_root !== "";
}
function Uu(e, t, n, a) {
  const i = $(null), r = $(!1), l = $(!1);
  let d = null, f = null;
  function m() {
    d && clearTimeout(d), d = null, f == null || f.abort(), f = null;
  }
  async function v(b, _) {
    const w = a();
    if (!w) {
      r.value = !0;
      return;
    }
    const k = new AbortController();
    f = k, l.value = !0;
    try {
      const x = await w(b, _, k.signal);
      if (k.signal.aborted) return;
      i.value = { q: b, names: new Set(x.map((M) => _[M]).filter((M) => typeof M == "string")) }, r.value = !1;
    } catch (x) {
      if ((x == null ? void 0 : x.name) === "AbortError" || k.signal.aborted) return;
      r.value = !0;
    } finally {
      f === k && (f = null, l.value = !1);
    }
  }
  return Xe(
    () => {
      const b = e().trim();
      if (!b) return "";
      const _ = /* @__PURE__ */ new Set();
      for (const w of t())
        f1(w) || _.add(n(w) || "");
      return JSON.stringify([b, [..._].sort()]);
    },
    (b) => {
      if (m(), !b) {
        i.value = null, l.value = !1;
        return;
      }
      const [_, w] = JSON.parse(b);
      if (w.length === 0) {
        i.value = { q: _, names: /* @__PURE__ */ new Set() };
        return;
      }
      l.value = !0, d = setTimeout(() => {
        d = null, v(_, w);
      }, l9);
    },
    { immediate: !0 }
  ), k0() && ny(m), {
    pending: l,
    apply(b) {
      const _ = e().trim();
      if (!_) return b;
      const w = i.value;
      return b.filter((k) => {
        const x = n(k) || "";
        return f1(k) || r.value || !a() ? jx(x, _) : !w || w.q !== _ ? !0 : w.names.has(x);
      });
    }
  };
}
const a$ = "application/x-brf-files", u9 = "application/x-brf-files-src";
let qs = null;
const c9 = 5 * 6e4;
function d9(e, t) {
  qs = { items: e.slice(), origin: t, startedAt: Date.now() };
}
function vr() {
  qs = null;
}
function lc() {
  return qs ? Date.now() - qs.startedAt > c9 ? (qs = null, null) : qs : null;
}
function Xa(e) {
  var t;
  return (t = e.dataTransfer) != null && t.types.includes(a$) ? !0 : lc() !== null;
}
function ff(e) {
  var a;
  const t = (a = e.dataTransfer) == null ? void 0 : a.getData(a$);
  if (t)
    try {
      const i = JSON.parse(t);
      return Array.isArray(i) && i.length > 0 ? i : null;
    } catch {
      return null;
    }
  const n = lc();
  return n && n.items.length > 0 ? n.items : null;
}
function jv(e) {
  var n, a;
  const t = (n = e.dataTransfer) == null ? void 0 : n.getData(u9);
  return t || ((a = lc()) == null ? void 0 : a.origin) || void 0;
}
function Dm(e) {
  const t = f9(e);
  return t === void 0 || t === "none" || t === "csrf";
}
function f9(e) {
  if (!e || typeof e != "object") return;
  const t = e;
  return typeof t.kind == "string" ? t.kind : typeof t.type == "string" ? t.type : void 0;
}
function p9(e, t, n) {
  if (e.type !== "file") return null;
  let a = t;
  try {
    a = new URL(t, typeof location < "u" ? location.href : void 0).toString();
  } catch {
    return null;
  }
  if (!/^https?:/i.test(a)) return null;
  const i = e.basename.replace(/[:\r\n]/g, "_");
  return `${n && n.trim() ? n : "application/octet-stream"}:${i}:${a}`;
}
function h9(e) {
  return e.map((t) => t.path).sort().join("\0");
}
function m9(e, t = {}) {
  const n = t.now ?? (() => Date.now()), a = t.refreshBelowMs ?? 3e4, i = t.usableAboveMs ?? 5e3, r = t.failPauseMs ?? 3e4, l = t.max ?? 32, d = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map();
  let m = null, v = null, b = !0;
  function _(M) {
    const A = d.get(M);
    return A ? A.expiresAt - n() : -1 / 0;
  }
  function w(M) {
    m = M;
    let A;
    try {
      A = e(M);
    } catch (T) {
      A = Promise.reject(T);
    }
    A.then((T) => {
      var N;
      if (T === null) {
        b && (b = !1, d.clear(), (N = t.onUnsupported) == null || N.call(t));
        return;
      }
      for (d.delete(M), d.set(M, { url: T.url, expiresAt: n() + T.ttlMs }); d.size > l; ) {
        const z = d.keys().next().value;
        if (z === void 0) break;
        d.delete(z);
      }
    }).catch(() => {
      f.set(M, n() + r);
    }).finally(() => {
      m = null;
      const T = v;
      v = null, T && k(T);
    });
  }
  function k(M) {
    if (!b || !M || _(M) > a) return;
    const A = f.get(M);
    if (A !== void 0) {
      if (A > n()) return;
      f.delete(M);
    }
    if (m !== M) {
      if (m !== null) {
        v = M;
        return;
      }
      w(M);
    }
  }
  function x(M) {
    const A = d.get(M);
    return A ? (d.delete(M), A.expiresAt - n() > i ? A.url : null) : null;
  }
  return {
    warm: k,
    take: x,
    get supported() {
      return b;
    }
  };
}
function Gf(e) {
  return !!e && e.basename !== ".trash" && !ky(e) && !(typeof e.vault_root == "string" && e.vault_root !== "");
}
function pf(e) {
  return { path: e.path, basename: e.basename, type: e.type };
}
function p1(e, t = {}) {
  return t.inEncryptedFolder || e.length === 0 || !e.every((n) => Gf(n)) ? null : e.map(pf);
}
function h1(e) {
  return !!e && e.type === "file" && Gf(e);
}
function v9(e, t) {
  const { t: n } = t, a = !!e.dropped;
  return e.error === "drop_not_found" ? { kind: "flash", message: n("dragout.not_found") } : e.error === "cancelled" ? { kind: "flash", message: n("dragout.stopped") } : e.error ? a || !t.quiet ? { kind: "flash", message: e.error } : null : a ? e.finished ? { kind: "flash", message: n("dragout.done") } : {
    kind: "hold",
    message: e.files ? n("dragout.downloading_n", { n: e.files }) : n("dragout.downloading"),
    stoppable: t.stoppable
  } : t.quiet ? null : !e.finished && e.done === 0 ? { kind: "flash", message: n("dragout.preparing") } : null;
}
const y9 = ["corrupt", "encrypted", "too_large"], g9 = {
  corrupt: [
    "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
    "M14 2v4a2 2 0 0 0 2 2h4",
    "m14.5 12.5-5 5",
    "m9.5 12.5 5 5"
  ],
  encrypted: ["M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z", "M7 11V7a5 5 0 0 1 10 0v4"],
  too_large: ["M15 3h6v6", "M9 21H3v-6", "M21 3l-7 7", "M3 21l7-7"]
}, m1 = /* @__PURE__ */ new Map();
function b9(e) {
  if (!e || e.type !== "file" || e.thumb_url) return null;
  const t = e.thumb_note;
  return t && y9.includes(t) ? t : null;
}
function hg(e, t) {
  const n = b9(e);
  if (!n) return null;
  let a, i;
  switch (n) {
    case "corrupt":
      a = t.t("thumbNote.corrupt"), i = t.t("thumbNote.corrupt_why");
      break;
    case "encrypted":
      a = t.t("thumbNote.encrypted"), i = t.t("thumbNote.encrypted_why");
      break;
    default:
      a = t.t("thumbNote.too_large"), i = t.t("thumbNote.too_large_why");
  }
  const r = t.t("thumbNote.full", { label: a, why: i }), l = `${n}|${r}`;
  let d = m1.get(l);
  return d || (d = { note: n, label: a, why: i, full: r, paths: g9[n] }, m1.set(l, d)), d;
}
const Os = 8 * 1024, k9 = 4 * 1024 * 1024, w9 = 3, _9 = 24, v1 = 120, x9 = 16, S9 = 8, $9 = 400, T9 = /* @__PURE__ */ new Set(["csv", "tsv"]);
function A9(e) {
  if (e.trashed) return !0;
  const t = e.extra_metadata;
  return !!t && typeof t == "object" && "deleted_at" in t;
}
function Xf(e) {
  if (e.type !== "file" || e.basename === ".trash" || e.mime_type === "inode/storage" || A9(e)) return null;
  const t = e.size ?? 0;
  if (t <= 0 || t > k9) return null;
  const n = (e.extension || "").trim().toLowerCase();
  if (T9.has(n)) return "table";
  const a = vi(e);
  return a === "code" ? "code" : a === "text" ? "text" : null;
}
function mg(e) {
  if (e.type !== "file") return !1;
  switch (vi(e)) {
    case "pdf":
    case "doc":
    case "sheet":
    case "slides":
      return !0;
    default:
      return !1;
  }
}
function i$(e) {
  return e.type === "file" && vi(e) === "video";
}
const E9 = /* @__PURE__ */ new Set([
  "pdf",
  "doc",
  "sheet",
  "slides",
  "text",
  "archive"
]);
function C9(e) {
  return e.type === "file" && E9.has(vi(e));
}
const z9 = /* @__PURE__ */ new Set(["image", "video"]), y1 = /* @__PURE__ */ new Map();
function o$(e) {
  if (e.type !== "file") return null;
  const t = vi(e);
  if (z9.has(t)) return null;
  const n = g2(e);
  if (!n) return null;
  const a = `${t}:${n}`;
  let i = y1.get(a);
  return i || (i = { family: t, label: n }, y1.set(a, i)), i;
}
const M9 = /* @__PURE__ */ new Set([
  "import",
  "export",
  "from",
  "require",
  "include",
  "use",
  "using",
  "package",
  "module",
  "namespace",
  "const",
  "let",
  "var",
  "function",
  "func",
  "fn",
  "def",
  "class",
  "struct",
  "enum",
  "interface",
  "type",
  "impl",
  "trait",
  "public",
  "private",
  "protected",
  "static",
  "async",
  "await",
  "return",
  "if",
  "else",
  "for",
  "while",
  "switch",
  "case",
  "try",
  "catch",
  "select",
  "insert",
  "update",
  "delete",
  "create",
  "alter",
  "drop"
]), P9 = /^(#{1,6}|[-*+]|>|\d+\.)$/;
function O9(e) {
  return e.replace(/[(){}[\];:,.]+$/, "").toLowerCase();
}
function D9(e, t) {
  const n = e.length > v1 ? e.slice(0, v1) : e, a = /^(\s*)(\S+)([\s\S]*)$/.exec(n);
  if (!a) return { indent: "", tint: "", text: n };
  const [, i, r, l] = a;
  return (t === "code" ? M9.has(O9(r)) : P9.test(r)) ? { indent: i, tint: r, text: l } : { indent: "", tint: "", text: n };
}
function L9(e, t) {
  const n = [];
  let a = "", i = !1;
  for (let r = 0; r < e.length; r++) {
    const l = e[r];
    i ? l === '"' ? e[r + 1] === '"' ? (a += '"', r++) : i = !1 : a += l : l === '"' ? i = !0 : l === t ? (n.push(a), a = "") : a += l;
  }
  return n.push(a), n;
}
function R9(e, t) {
  return e === "tsv" ? "	" : !t.includes(",") && t.includes(";") ? ";" : ",";
}
function N9(e, t, n, a) {
  for (let d = 0; d < e.length; d++)
    if (e[d] === 0) return null;
  const i = new TextDecoder("utf-8", { fatal: !1 }).decode(e);
  let r = 0;
  for (const d of i) d === "�" && r++;
  if (i.length > 0 && r / i.length > 0.1) return null;
  const l = i.split(/\r\n|\r|\n/);
  for (a && l.length > 1 && l.pop(); l.length && l[0].trim() === ""; ) l.shift();
  for (; l.length && l[l.length - 1].trim() === ""; ) l.pop();
  if (l.length === 0) return null;
  if (t === "table") {
    const d = R9(n, l[0]), f = l.filter((v) => v.trim() !== "").slice(0, x9).map((v) => L9(v, d).slice(0, S9).map((b) => b.trim().slice(0, 24)));
    if (f.length === 0) return null;
    const m = f.reduce((v, b) => Math.max(v, b.length), 0);
    for (const v of f) for (; v.length < m; ) v.push("");
    return { kind: t, lines: [], rows: f, cols: m };
  }
  return {
    kind: t,
    lines: l.slice(0, _9).map((d) => D9(d, t)),
    rows: [],
    cols: 0
  };
}
const I9 = "\0";
function xu(e) {
  const n = (typeof e.etag == "string" ? e.etag : "") || String(e.last_modified ?? "") || String(e.size ?? "");
  return `${e.path}${I9}${n}`;
}
function r$(e) {
  const t = e.apiBase !== void 0 && typeof e.authHeaders == "function" && typeof IntersectionObserver < "u" && typeof fetch == "function", n = $({}), a = [], i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), l = [], d = /* @__PURE__ */ new Set(), f = /* @__PURE__ */ new WeakMap();
  let m = 0, v = null;
  const b = /* @__PURE__ */ new Map();
  function _(z) {
    const L = t2({ apiBase: e.apiBase }).manager, B = L.includes("?") ? "&" : "?", O = new URLSearchParams({ q: "preview", action: "preview", path: z });
    return `${L}${B}${O.toString()}`;
  }
  function w(z, L) {
    if (a.length >= $9) {
      const B = a.shift();
      if (B) {
        const O = { ...n.value };
        delete O[B], n.value = O;
      }
    }
    a.push(z), n.value = { ...n.value, [z]: L };
  }
  async function k(z) {
    const L = z.body;
    if (!L) {
      const I = new Uint8Array(await z.arrayBuffer());
      return { bytes: I.slice(0, Os), truncated: I.length > Os };
    }
    const B = L.getReader(), O = [];
    let U = 0;
    try {
      for (; U < Os; ) {
        const { done: I, value: G } = await B.read();
        if (I) break;
        G && G.length && (O.push(G), U += G.length);
      }
    } finally {
      try {
        await B.cancel();
      } catch {
      }
    }
    const S = new Uint8Array(Math.min(U, Os));
    let F = 0;
    for (const I of O) {
      if (F >= S.length) break;
      S.set(I.subarray(0, S.length - F), F), F += I.length;
    }
    return { bytes: S, truncated: U >= Os };
  }
  async function x(z, L) {
    const B = xu(z), O = new AbortController();
    d.add(O);
    try {
      const U = e.authHeaders ? await e.authHeaders() : {}, S = await fetch(_(z.path), {
        headers: { ...U, Accept: "*/*", Range: `bytes=0-${Os - 1}` },
        credentials: e.credentials,
        signal: O.signal
      });
      if (!S.ok && S.status !== 206) throw new Error(String(S.status));
      const { bytes: F, truncated: I } = await k(S);
      O.abort();
      const G = (z.extension || "").trim().toLowerCase(), Y = N9(F, L, G, I);
      if (!Y) {
        i.add(B);
        return;
      }
      w(B, Y);
    } catch {
      i.add(B);
    } finally {
      d.delete(O);
    }
  }
  function M() {
    for (; m < w9 && l.length > 0; ) {
      const z = l.shift(), L = Xf(z);
      r.delete(xu(z)), L && (m++, x(z, L).finally(() => {
        m--, M();
      }));
    }
  }
  function A(z) {
    const L = xu(z);
    n.value[L] || i.has(L) || r.has(L) || (r.add(L), l.push(z), M());
  }
  function T() {
    return t ? (v || (v = new IntersectionObserver(
      (z) => {
        for (const L of z) {
          if (!L.isIntersecting) continue;
          const B = b.get(L.target);
          v == null || v.unobserve(L.target), b.delete(L.target), B && A(B);
        }
      },
      { rootMargin: "150px" }
    )), v) : null;
  }
  function N(z) {
    var L;
    return !t || (L = e.disabled) != null && L.call(e) ? null : Xf(z);
  }
  return {
    enabled: t,
    kindFor: N,
    get(z) {
      return t ? n.value[xu(z)] ?? null : null;
    },
    bind(z, L) {
      if (!z || !N(L)) return;
      const B = xu(L);
      if (f.get(z) === B || (f.set(z, B), n.value[B] || i.has(B))) return;
      const O = T();
      O && (b.set(z, L), O.observe(z));
    },
    stats: () => ({
      loaded: a.length,
      inflight: m,
      queued: l.length,
      failed: i.size
    }),
    dispose() {
      v == null || v.disconnect(), v = null, b.clear();
      for (const z of d) z.abort();
      d.clear(), l.length = 0, r.clear();
    }
  };
}
function B9(e, t) {
  if (!e) return { id: "none", label: t.t("group.no_date") };
  const n = /* @__PURE__ */ new Date(), a = Tw(n), i = Tw(e);
  if (i >= a) return { id: "today", label: t.t("group.today") };
  if (i === a - 1) return { id: "yesterday", label: t.t("group.yesterday") };
  if (i > a - 7) return { id: "week", label: t.t("group.this_week") };
  const r = t.zonedYearMonth(e);
  return r === t.zonedYearMonth(n) ? { id: "month", label: t.t("group.this_month") } : { id: `m-${r}`, label: t.formatMonthYear(e) };
}
function vg(e, t) {
  return t !== "relevance" && e === "modified";
}
function yg(e, t) {
  var i;
  const n = [];
  if (!t.active)
    n.push({ id: "all", label: null, items: [...e] });
  else {
    let r = null;
    for (const l of e) {
      const d = ((i = t.aside) == null ? void 0 : i.call(t, l)) ?? null, f = d ? { id: d.id, label: d.label ?? null } : B9(t.dateOf(l), t.labels);
      (!r || r.id !== f.id) && (r = { id: f.id, label: f.label, items: [] }, n.push(r)), r.items.push(l);
    }
  }
  const a = /* @__PURE__ */ new Map();
  for (const r of n)
    r.label && r.items.length && a.set(r.items[0], r.label);
  return {
    active: t.active,
    runs: n,
    headingBefore: (r) => a.get(r) ?? null
  };
}
async function s$(e, t, n = {}) {
  const a = {
    "Content-Type": "application/json",
    ...await (n.authHeaders ?? (() => ({})))()
  }, i = n.apiBase ?? "", r = await fetch(`${i}/api/files/manager/star`, {
    method: "POST",
    headers: a,
    credentials: n.authCredentials ?? "same-origin",
    body: JSON.stringify({ node_id: e, starred: t })
  });
  if (!r.ok) throw pa(r.status, await r.text().catch(() => ""), n.locale);
}
const F9 = ["aria-pressed", "title", "aria-label"], U9 = {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  "aria-hidden": "true"
}, H9 = ["fill"], K9 = {
  key: 0,
  class: "filex-star-label"
}, gg = /* @__PURE__ */ lt({
  __name: "StarButton",
  props: {
    starred: { type: Boolean },
    nodeId: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    compact: { type: Boolean },
    card: { type: Boolean },
    locale: {}
  },
  emits: ["change", "error"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = $(n.starred);
    Xe(() => n.starred, (f) => {
      i.value = f;
    });
    const { t: r } = yt(() => Sa(n.locale)), l = E(() => r(i.value ? "ctx.unstar" : "ctx.star"));
    async function d() {
      const f = !i.value;
      i.value = f;
      try {
        await s$(n.nodeId, f, {
          apiBase: n.apiBase,
          authHeaders: n.authHeaders,
          authCredentials: n.authCredentials,
          locale: Sa(n.locale)
        }), a("change", f);
      } catch (m) {
        i.value = !f, a("error", m instanceof Error ? m.message : String(m));
      }
    }
    return (f, m) => (p(), h("button", {
      type: "button",
      class: Fe(["filex-star-btn", { "is-starred": i.value, "is-compact": e.compact, "is-card": e.card }]),
      "aria-pressed": i.value,
      title: l.value,
      "aria-label": l.value,
      "data-testid": "star-toggle",
      onClick: vt(d, ["stop"])
    }, [
      (p(), h("svg", U9, [
        c("path", {
          fill: i.value ? "currentColor" : "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linejoin": "round",
          d: "M12 2.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 18.27l-6.18 3.23L7 14.63 2 9.76l6.91-1z"
        }, null, 8, H9)
      ])),
      e.compact ? D("", !0) : (p(), h("span", K9, y(l.value), 1))
    ], 10, F9));
  }
}), g1 = "300px";
let so = null;
const Ws = /* @__PURE__ */ new Map();
function V9() {
  return so || (so = new IntersectionObserver(
    (e) => {
      for (const t of e) {
        if (!t.isIntersecting) continue;
        const n = Ws.get(t.target);
        n && (Ws.delete(t.target), so == null || so.unobserve(t.target), n.forEach((a) => a()));
      }
    },
    // `rootMargin` widens the viewport only: a tile in the pane's own scroll
    // box is still cut off at that box's edge. `scrollMargin` widens the
    // scroll boxes too (Chromium 120+; an engine that does not know it
    // ignores it, and the picture is asked for as the tile scrolls in).
    { rootMargin: g1, scrollMargin: g1 }
  )), so;
}
function j9(e, t) {
  if (!e || typeof IntersectionObserver > "u")
    return t(), () => {
    };
  let n = Ws.get(e);
  return n || (n = /* @__PURE__ */ new Set(), Ws.set(e, n), V9().observe(e)), n.add(t), () => {
    const a = Ws.get(e);
    a && (a.delete(t), a.size === 0 && (Ws.delete(e), so == null || so.unobserve(e)));
  };
}
const q9 = ["src"], W9 = {
  key: 2,
  class: "fe-thumb__play",
  "aria-hidden": "true"
}, Y9 = ["aria-label", "data-note"], G9 = {
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  focusable: "false"
}, X9 = ["d"], J9 = ["dir"], Oc = /* @__PURE__ */ lt({
  inheritAttrs: !1,
  __name: "ThumbTile",
  props: {
    node: {},
    srcOf: { type: Function },
    videoBadge: { type: Boolean },
    typeBadge: {},
    note: {}
  },
  setup(e) {
    const t = e, n = $(!1);
    let a = null;
    Wt(() => {
      var N;
      const T = (N = bl()) == null ? void 0 : N.subTree.el;
      a = j9(T == null ? void 0 : T.parentElement, () => {
        n.value = !0;
      });
    }), Ot(() => {
      a == null || a(), _();
    });
    const i = E(() => n.value ? t.srcOf(t.node) : null), r = $(null), l = $(null), d = $(!1), f = $("ltr");
    function m() {
      const T = l.value, N = r.value;
      if (!T || !N) return;
      const z = N.getBoundingClientRect(), L = window.innerWidth, B = window.innerHeight, O = T.offsetWidth, U = T.offsetHeight, S = f.value, F = pc(S === "rtl" ? z.right : z.left, O, L, S);
      let I = z.bottom + 6;
      I + U > B - 8 && (I = Math.max(8, z.top - U - 6)), T.style.insetInlineStart = `${Math.round(S === "rtl" ? L - F - O : F)}px`, T.style.top = `${Math.round(I)}px`, T.style.zIndex = String(yc(N));
    }
    function v(T) {
      r.value && T.target instanceof Node && r.value.contains(T.target) || _();
    }
    function b() {
      d.value || !r.value || (f.value = Ga(r.value), d.value = !0, document.addEventListener("pointerdown", v, !0), window.addEventListener("scroll", _, !0), Zt(m));
    }
    function _() {
      d.value && (d.value = !1, document.removeEventListener("pointerdown", v, !0), window.removeEventListener("scroll", _, !0));
    }
    function w(T) {
      T.pointerType === "mouse" && b();
    }
    function k(T) {
      T.pointerType === "mouse" && _();
    }
    let x = "";
    function M(T) {
      x = T.pointerType;
    }
    function A() {
      if (x === "mouse") {
        b();
        return;
      }
      d.value ? _() : b();
    }
    return (T, N) => (p(), h(Ce, null, [
      i.value ? (p(), h("img", Qm({ key: 0 }, T.$attrs, {
        src: i.value,
        draggable: "false"
      }), null, 16, q9)) : En(T.$slots, "default", { key: 1 }),
      i.value && e.videoBadge ? (p(), h("span", W9)) : D("", !0),
      i.value && e.typeBadge ? (p(), h("span", {
        key: 3,
        class: Fe(["fe-thumb__type", `fe-ftile--${e.typeBadge.family}`, { "fe-thumb__type--long": e.typeBadge.label.length > 4 }]),
        "aria-hidden": "true"
      }, y(e.typeBadge.label), 3)) : D("", !0),
      !i.value && e.note ? (p(), h("span", {
        key: 4,
        ref_key: "mark",
        ref: r,
        class: Fe(["fe-thumb__note", `fe-thumb__note--${e.note.note}`]),
        role: "img",
        "aria-label": e.note.full,
        "data-note": e.note.note,
        "data-testid": "thumb-note",
        onPointerenter: w,
        onPointerleave: k,
        onPointerdown: M,
        onClick: vt(A, ["stop"]),
        onDblclick: N[0] || (N[0] = vt(() => {
        }, ["stop"]))
      }, [
        (p(), h("svg", G9, [
          (p(!0), h(Ce, null, ot(e.note.paths, (z, L) => (p(), h("path", {
            key: L,
            d: z
          }, null, 8, X9))), 128))
        ]))
      ], 42, Y9)) : D("", !0),
      (p(), Je(hi, { to: "body" }, [
        d.value && e.note ? (p(), h("span", {
          key: 0,
          ref_key: "tip",
          ref: l,
          class: "fe-thumb__note-tip",
          dir: f.value,
          role: "tooltip",
          "data-testid": "thumb-note-tip"
        }, y(e.note.full), 9, J9)) : D("", !0)
      ]))
    ], 64));
  }
}), Z9 = ["innerHTML"], Q9 = {
  key: 1,
  class: "fe-fmosaic__stage"
}, e7 = ["innerHTML"], bg = /* @__PURE__ */ lt({
  __name: "FolderMosaic",
  props: {
    node: {},
    srcOf: {},
    shape: { default: "peek" }
  },
  setup(e) {
    const t = e, n = E(() => t.shape === "mini" ? 1 : 3), a = E(
      () => (t.node.preview ?? []).slice(0, n.value).map((r) => {
        const l = r.name.lastIndexOf(".");
        return {
          path: `${t.node.path.replace(/\/+$/, "")}/${r.name}`,
          basename: r.name,
          type: "file",
          extension: l > 0 ? r.name.slice(l + 1).toLowerCase() : void 0,
          thumb_url: r.thumb_url
        };
      })
    ), i = E(() => {
      const [r, l, d] = a.value;
      return d ? [{ it: d, at: 1 }, { it: l, at: 3 }, { it: r, at: 2 }] : l ? [{ it: l, at: 1 }, { it: r, at: 2 }] : r ? [{ it: r, at: 1 }] : [];
    });
    return (r, l) => (p(), h("div", {
      class: Fe(["fe-fmosaic", [`fe-fmosaic--${e.shape}`, `fe-fmosaic--${a.value.length}`]]),
      "aria-hidden": "true",
      "data-fe-mosaic": ""
    }, [
      u(Mr)(e.node) ? (p(), h("span", {
        key: 0,
        class: "fe-fmosaic__glyph fe-grid__icon fe-grid__icon--svg",
        innerHTML: u(sl)()
      }, null, 8, Z9)) : (p(), h("div", Q9, [
        l[0] || (l[0] = c("svg", {
          class: "fe-fmosaic__back",
          viewBox: "0 0 120 88",
          preserveAspectRatio: "none",
          focusable: "false"
        }, [
          c("path", { d: "M0 10a6 6 0 0 1 6-6h27.5a6 6 0 0 1 4.4 1.9L43.6 12H114a6 6 0 0 1 6 6v64a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z" })
        ], -1)),
        (p(!0), h(Ce, null, ot(i.value, (d) => (p(), h("div", {
          key: d.it.path,
          class: Fe(["fe-fmosaic__print", [`fe-fmosaic__print--${d.at}`, { "is-icon": !d.it.thumb_url }]])
        }, [
          tt(Oc, {
            node: d.it,
            "src-of": e.srcOf,
            alt: "",
            class: "fe-fmosaic__img"
          }, {
            default: gt(() => [
              c("span", {
                class: "fe-fmosaic__icon fe-grid__icon--svg",
                innerHTML: u(ya)(d.it)
              }, null, 8, e7)
            ]),
            _: 2
          }, 1032, ["node", "src-of"])
        ], 2))), 128)),
        l[1] || (l[1] = c("svg", {
          class: "fe-fmosaic__front",
          viewBox: "0 0 120 56",
          preserveAspectRatio: "none",
          focusable: "false"
        }, [
          c("path", { d: "M5 0h110a5 5 0 0 1 5 5.4l-3.3 44.6a6 6 0 0 1-6 5.6H9.3a6 6 0 0 1-6-5.6L0 5.4A5 5 0 0 1 5 0z" })
        ], -1))
      ]))
    ], 2));
  }
});
function qv(e) {
  const t = [];
  if (!e) return t;
  const n = /«([^«»]*)»/g;
  let a = 0, i;
  for (; (i = n.exec(e)) !== null; )
    i.index > a && t.push({ text: e.slice(a, i.index), match: !1 }), i[1] && t.push({ text: i[1], match: !0 }), a = i.index + i[0].length;
  return a < e.length && t.push({ text: e.slice(a), match: !1 }), t;
}
function t7(e) {
  return e === "content" || e === "both";
}
function kg(e, t, n) {
  const a = e.dataTransfer;
  if (!(!a || typeof document > "u" || typeof a.setDragImage != "function"))
    try {
      const i = document.createElement("div");
      i.className = "fe-dragghost";
      const r = document.createElement("span");
      if (r.className = "fe-dragghost__name", r.dir = "auto", r.textContent = t, i.appendChild(r), n > 1) {
        const l = document.createElement("span");
        l.className = "fe-dragghost__badge", l.textContent = String(n), i.appendChild(l);
      }
      i.style.position = "fixed", i.style.top = "-1000px", i.style.left = "-1000px", document.body.appendChild(i), a.setDragImage(i, 14, 14), setTimeout(() => i.remove(), 0);
    } catch {
    }
}
const n7 = { class: "fe-gridbox" }, a7 = {
  key: 0,
  class: "fe-grid__refreshing",
  role: "status"
}, i7 = { class: "fe-sr-only" }, o7 = ["aria-label", "aria-busy"], r7 = {
  key: 0,
  class: "fe-grid__heading",
  "aria-hidden": "true"
}, s7 = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive", "onPointerenter", "onPointerleave"], l7 = ["dir"], u7 = {
  key: 0,
  class: "fe-fprev__tint"
}, c7 = ["innerHTML"], d7 = ["aria-label", "innerHTML"], f7 = ["innerHTML"], p7 = {
  key: 1,
  class: "fe-grid__thumb fe-grid__thumb--folder"
}, h7 = { class: "fe-grid__foot" }, m7 = ["aria-label", "innerHTML"], v7 = ["innerHTML"], y7 = ["onClick"], g7 = { class: "fe-grid__main" }, b7 = ["title"], k7 = ["title", "aria-label"], w7 = ["title"], _7 = ["title", "aria-label"], x7 = ["title", "aria-label", "data-link-state"], S7 = ["title", "aria-label"], $7 = ["title"], T7 = ["title"], A7 = {
  key: 0,
  class: "fe-grid__mark"
}, E7 = ["aria-label", "title", "onClick"], C7 = {
  key: 0,
  class: "fe-grid__empty"
}, Wv = /* @__PURE__ */ lt({
  __name: "GridView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    keepBadgeFor: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    sections: { type: Boolean },
    order: {},
    e2eActive: { type: Boolean },
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change", "display-order", "peek", "peek-end"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => n.files.some((Re) => {
      var Be;
      return Re.type === "dir" && (((Be = Re.preview) == null ? void 0 : Be.length) ?? 0) > 0;
    }));
    function r(Re, Be) {
      Re.type === "dir" && a("peek", Re, Be.currentTarget, Be.pointerType);
    }
    const { t: l, formatSize: d, nodeDisplayName: f, formatDate: m, formatMonthYear: v, zonedYearMonth: b, toDate: _ } = yt(() => n.locale);
    function w(Re) {
      return Lr(Ac(Re), { t: l, formatDate: m, locale: n.locale });
    }
    function k(Re) {
      return Ec(Re, { t: l });
    }
    function x(Re) {
      return Cc(Re, { t: l });
    }
    function M(Re) {
      return hg(Re, { t: l });
    }
    const A = E(() => [...n.files].sort(If));
    Xe(
      A,
      (Re) => a("display-order", Re),
      { immediate: !0 }
    );
    const T = E(() => {
      var Re;
      return ((Re = A.value.find((Be) => Be.type === "dir")) == null ? void 0 : Re.path) ?? null;
    }), N = E(() => {
      var Re;
      return ((Re = A.value.find((Be) => Be.type !== "dir")) == null ? void 0 : Re.path) ?? null;
    }), z = $c(), L = E(
      () => yg(A.value, {
        active: vg(z.key.value, n.order),
        dateOf: (Re) => _(Re.last_modified),
        /* Folders keep their own run at the top — the same rule the list follows,
         * and the reason "folders before files" survives a date sort. Here the run
         * is the one that already had a name. */
        aside: (Re) => Re.type === "dir" ? { id: "dirs", label: n.sections ? l("drive.section.folders") : null } : null,
        labels: { t: l, formatMonthYear: v, zonedYearMonth: b }
      })
    );
    function B(Re) {
      return L.value.active ? L.value.headingBefore(Re) : n.sections ? Re.path === T.value ? l("drive.section.folders") : Re.path === N.value ? l("drive.section.files") : null : null;
    }
    function O(Re) {
      return n.thumbSrc ? n.thumbSrc(Re) : Re.thumb_url ?? null;
    }
    const U = r$({
      // Read once: the explorer's `config.apiBase` is fixed for the life of a
      // mounted panel, and `enabled` has to be answerable at construction.
      apiBase: n.apiBase,
      // Wrapped rather than passed, so a parent that re-creates its arrow on each
      // render is still called through the CURRENT prop. ⚠ The builder is async;
      // `createFilePreviews` awaits it (see the note there — a Promise spread into
      // a headers object sends no Authorization and 401s in silence).
      authHeaders: n.authHeaders ? () => n.authHeaders() : void 0,
      credentials: n.authCredentials,
      disabled: () => n.e2eActive === !0
    });
    Ot(() => U.dispose());
    function S(Re) {
      return U.kindFor(Re);
    }
    function F(Re) {
      const Be = U.get(Re);
      return Be ? [Be] : [];
    }
    function I(Re, Be) {
      U.bind(Re instanceof Element ? Re : null, Be);
    }
    function G(Re) {
      return n.starEnabled === !1 ? !1 : n.apiBase !== void 0 && typeof Re.id == "number" && Re.type === "file";
    }
    function Y(Re) {
      return n.selected.has(Re.path);
    }
    function ie(Re, Be) {
      a("click-card", Re, fg(Be));
    }
    function me(Re, Be) {
      a("click-card", Re, dg(Be, ce.isTap(Be)));
    }
    function q(Re) {
      a("dbl-card", Re);
    }
    function C(Re, Be) {
      Be.preventDefault(), Be.stopPropagation(), a("context-card", Re, Be);
    }
    function re(Re, Be) {
      C(Re, Be);
    }
    function de(Re, Be) {
      kg(
        Be,
        f(Re),
        n.selected.has(Re.path) ? n.selected.size : 1
      ), a("item-drag-start", Re, Be);
    }
    const V = $(null);
    function W(Re, Be) {
      Re.type === "dir" && Xa(Be) && (Be.preventDefault(), Be.stopPropagation(), Be.dataTransfer && (Be.dataTransfer.dropEffect = "move"), V.value = Re.path);
    }
    function ne(Re) {
      V.value === Re.path && (V.value = null);
    }
    function K(Re, Be) {
      V.value = null, Re.type === "dir" && Xa(Be) && (Be.preventDefault(), Be.stopPropagation(), a("item-drop-into", Re, Be));
    }
    const ce = pg(
      (Re, Be) => a("context-card", Re, { ...Be, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (Re) => a("click-card", Re, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function J(Re) {
      return m(Re);
    }
    function H(Re) {
      if (Re.type === "dir") return l("node.folder");
      const Be = J(Re.last_modified), We = d(Re.size);
      return Be ? `${We} • ${Be}` : We;
    }
    function X(Re) {
      return Re === "kept" ? "✓" : Re === "syncing" ? "⟳" : Re === "partial" ? "◐" : "☁";
    }
    function we(Re) {
      const Be = Re.snippet;
      return typeof Be == "string" ? Be : "";
    }
    function it(Re) {
      return qv(Re).map((Be) => Be.text).join("");
    }
    return (Re, Be) => (p(), h("div", n7, [
      e.loading && A.value.length > 0 ? (p(), h("div", a7, [
        c("span", i7, y(u(l)("loading")), 1)
      ])) : D("", !0),
      c("div", {
        class: Fe(["fe-grid", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0, "has-folder-previews": i.value }]),
        role: "listbox",
        "aria-multiselectable": "true",
        "aria-label": u(l)("grid.aria"),
        "aria-busy": e.loading ? "true" : void 0
      }, [
        (p(!0), h(Ce, null, ot(A.value, (We) => {
          var bt, at;
          return p(), h(Ce, {
            key: We.path
          }, [
            B(We) ? (p(), h("p", r7, y(B(We)), 1)) : D("", !0),
            c("div", {
              class: Fe(["fe-grid__card", {
                "fe-grid__card--folder": We.type === "dir",
                "fe-grid__card--file": We.type !== "dir",
                "is-selected": Y(We),
                "is-dir": We.type === "dir",
                "is-trash": We.trashed,
                "is-clipped": (bt = e.clipped) == null ? void 0 : bt.has(We.path),
                "is-droptarget": V.value === We.path
              }]),
              tabindex: "0",
              role: "option",
              "aria-selected": Y(We) ? "true" : "false",
              "aria-label": u(f)(We),
              "data-fe-path": We.path,
              draggable: "true",
              onClick: (Ie) => me(We, Ie),
              onDblclick: (Ie) => q(We),
              onContextmenu: (Ie) => C(We, Ie),
              onDragstart: (Ie) => de(We, Ie),
              onDragover: (Ie) => W(We, Ie),
              onDragleave: (Ie) => ne(We),
              onDrop: (Ie) => K(We, Ie),
              onTouchstartPassive: (Ie) => u(ce).onTouchStart(We, Ie),
              onTouchend: Be[4] || (Be[4] = //@ts-ignore
              (...Ie) => u(ce).onTouchEnd && u(ce).onTouchEnd(...Ie)),
              onTouchmovePassive: Be[5] || (Be[5] = //@ts-ignore
              (...Ie) => u(ce).onTouchMove && u(ce).onTouchMove(...Ie)),
              onPointerenter: (Ie) => r(We, Ie),
              onPointerleave: (Ie) => We.type === "dir" && a("peek-end"),
              onPointerdown: Be[6] || (Be[6] = (Ie) => a("peek-end"))
            }, [
              We.type !== "dir" ? (p(), h("div", {
                key: 0,
                class: "fe-grid__thumb",
                ref_for: !0,
                ref: (Ie) => I(Ie, We)
              }, [
                S(We) ? (p(), h(Ce, { key: 0 }, [
                  (p(!0), h(Ce, null, ot(F(We), (Ie) => (p(), h("div", {
                    key: "fprev",
                    class: Fe(["fe-fprev", "fe-fprev--" + Ie.kind]),
                    dir: u(I0)(Ie.kind),
                    style: Yt(Ie.kind === "table" ? { "--fprev-cols": String(Ie.cols) } : void 0),
                    "aria-hidden": "true"
                  }, [
                    Ie.kind === "table" ? (p(!0), h(Ce, { key: 0 }, ot(Ie.rows, (nt, dt) => (p(), h(Ce, { key: dt }, [
                      (p(!0), h(Ce, null, ot(nt, (Me, be) => (p(), h("span", {
                        key: be,
                        class: Fe(["fe-fprev__cell", { "is-head": dt === 0 }])
                      }, y(Me), 3))), 128))
                    ], 64))), 128)) : (p(!0), h(Ce, { key: 1 }, ot(Ie.lines, (nt, dt) => (p(), h("div", {
                      key: dt,
                      class: "fe-fprev__line"
                    }, [
                      nt.tint ? (p(), h("span", u7, y(nt.indent) + y(nt.tint), 1)) : D("", !0),
                      Ht(y(nt.text), 1)
                    ]))), 128))
                  ], 14, l7))), 128)),
                  F(We).length === 0 ? (p(), h("span", {
                    key: 0,
                    class: "fe-grid__icon fe-grid__icon--svg",
                    innerHTML: u(ya)(We)
                  }, null, 8, c7)) : D("", !0)
                ], 64)) : (p(), Je(Oc, {
                  key: 1,
                  node: We,
                  "src-of": O,
                  "video-badge": u(i$)(We),
                  note: M(We),
                  alt: We.basename,
                  class: Fe({
                    "fe-thumb--page": u(mg)(We)
                    /* gorunum:v1-preview — crop a page from its TOP */
                  })
                }, {
                  default: gt(() => [
                    u(Mr)(We) ? (p(), h("span", {
                      key: 0,
                      class: "fe-grid__icon fe-grid__icon--svg",
                      role: "img",
                      "aria-label": u(l)("e2e.badge"),
                      innerHTML: u(sl)()
                    }, null, 8, d7)) : (p(), h("span", {
                      key: 1,
                      class: "fe-grid__icon fe-grid__icon--svg",
                      innerHTML: u(ya)(We)
                    }, null, 8, f7))
                  ]),
                  _: 2
                }, 1032, ["node", "video-badge", "note", "alt", "class"])),
                G(We) ? (p(), h("div", {
                  key: 2,
                  class: "fe-grid__star",
                  onClick: Be[0] || (Be[0] = vt(() => {
                  }, ["stop"])),
                  onDblclick: Be[1] || (Be[1] = vt(() => {
                  }, ["stop"]))
                }, [
                  tt(gg, {
                    starred: !!((at = e.starredIds) != null && at.has(We.id)),
                    "node-id": We.id,
                    "api-base": e.apiBase,
                    "auth-headers": e.authHeaders,
                    "auth-credentials": e.authCredentials,
                    locale: e.locale,
                    compact: "",
                    card: "",
                    onChange: (Ie) => a("star-change", We, Ie)
                  }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
                ], 32)) : D("", !0)
              ], 512)) : i.value ? (p(), h("div", p7, [
                tt(bg, {
                  node: We,
                  "src-of": O
                }, null, 8, ["node"])
              ])) : D("", !0),
              c("div", h7, [
                c("span", {
                  class: Fe(["fe-grid__lead", { "fe-grid__lead--pick": e.selectable }])
                }, [
                  u(Mr)(We) ? (p(), h("span", {
                    key: 0,
                    class: "fe-grid__tile fe-grid__tile--svg",
                    role: "img",
                    "aria-label": u(l)("e2e.badge"),
                    innerHTML: u(sl)()
                  }, null, 8, m7)) : (p(), h("span", {
                    key: 1,
                    class: "fe-grid__tile fe-grid__tile--svg",
                    innerHTML: u(ya)(We)
                  }, null, 8, v7)),
                  e.selectable ? (p(), h("span", {
                    key: 2,
                    class: "fe-item-check",
                    "data-fe-control": "",
                    onClick: vt((Ie) => ie(We, Ie), ["stop"]),
                    onDblclick: Be[2] || (Be[2] = vt(() => {
                    }, ["stop"]))
                  }, [
                    tt(Qy, {
                      on: Y(We),
                      label: u(f)(We)
                    }, null, 8, ["on", "label"])
                  ], 40, y7)) : D("", !0)
                ], 2),
                c("div", g7, [
                  c("div", {
                    class: "fe-grid__label",
                    title: We.basename
                  }, [
                    c("bdi", null, y(u(f)(We)), 1),
                    e.keepBadgeFor && e.keepBadgeFor(We) ? (p(), h("span", {
                      key: 0,
                      class: Fe(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(We)]),
                      title: u(l)("keep.badge_" + e.keepBadgeFor(We)),
                      role: "img",
                      "aria-label": u(l)("keep.badge_" + e.keepBadgeFor(We))
                    }, y(X(e.keepBadgeFor(We))), 11, k7)) : D("", !0)
                  ], 8, b7),
                  c("div", {
                    class: "fe-grid__meta",
                    title: H(We)
                  }, [
                    w(We) ? (p(), h("span", {
                      key: 0,
                      class: "fe-applock",
                      role: "img",
                      title: w(We),
                      "aria-label": w(We),
                      "data-testid": "lock-badge"
                    }, [
                      Be[7] || (Be[7] = c("span", {
                        class: "fe-applock__glyph",
                        "aria-hidden": "true"
                      }, "🔒", -1)),
                      Ht(y(u(l)("applock.badge")), 1)
                    ], 8, _7)) : D("", !0),
                    k(We) ? (p(), h("span", {
                      key: 1,
                      class: Fe(["fe-symlink", "fe-symlink--" + k(We).state]),
                      role: "img",
                      title: k(We).why,
                      "aria-label": k(We).why,
                      "data-testid": "symlink-badge",
                      "data-link-state": k(We).state
                    }, [
                      Be[8] || (Be[8] = c("span", {
                        class: "fe-symlink__glyph",
                        "aria-hidden": "true"
                      }, "🔗", -1)),
                      Ht(y(k(We).badge), 1)
                    ], 10, x7)) : D("", !0),
                    x(We) ? (p(), h("span", {
                      key: 2,
                      class: "fe-unavailable",
                      role: "img",
                      title: x(We).full,
                      "aria-label": x(We).full,
                      "data-testid": "unavailable-badge"
                    }, y(x(We).badge), 9, S7)) : D("", !0),
                    Ht(" " + y(H(We)), 1)
                  ], 8, w7),
                  e.showParentPath && u(xr)(We) ? (p(), h("div", {
                    key: 0,
                    class: "fe-grid__parent",
                    title: u(xr)(We)
                  }, [
                    c("bdi", null, y(u(xr)(We)), 1)
                  ], 8, $7)) : D("", !0),
                  we(We) ? (p(), h("div", {
                    key: 1,
                    class: "fe-grid__snippet",
                    title: it(we(We))
                  }, [
                    (p(!0), h(Ce, null, ot(u(qv)(we(We)), (Ie, nt) => (p(), h(Ce, { key: nt }, [
                      Ie.match ? (p(), h("mark", A7, y(Ie.text), 1)) : (p(), h(Ce, { key: 1 }, [
                        Ht(y(Ie.text), 1)
                      ], 64))
                    ], 64))), 128))
                  ], 8, T7)) : D("", !0)
                ]),
                c("button", {
                  type: "button",
                  class: "fe-grid__menu",
                  "aria-label": u(l)("toolbar.more"),
                  title: u(l)("toolbar.more"),
                  onClick: vt((Ie) => re(We, Ie), ["stop"]),
                  onDblclick: Be[3] || (Be[3] = vt(() => {
                  }, ["stop"]))
                }, "⋮", 40, E7)
              ])
            ], 42, s7)
          ], 64);
        }), 128)),
        !e.loading && e.files.length === 0 ? (p(), h("div", C7, y(u(l)("empty.folder")), 1)) : D("", !0)
      ], 10, o7)
    ]));
  }
}), z7 = {
  class: "fe-home",
  "data-testid": "home-view"
}, M7 = {
  class: "fe-home__section",
  "data-testid": "home-storages"
}, P7 = { class: "fe-home__heading" }, O7 = {
  key: 0,
  class: "fe-home__storages"
}, D7 = ["data-storage", "title", "onClick"], L7 = ["innerHTML"], R7 = { class: "fe-home__storage-main" }, N7 = { class: "fe-home__storage-label" }, I7 = ["data-partial"], B7 = {
  key: 1,
  class: "fe-home__nomatch",
  "data-testid": "home-storages-nomatch"
}, F7 = {
  key: 2,
  class: "fe-state fe-home__state",
  "data-testid": "home-storages-empty"
}, U7 = { class: "fe-state__title" }, H7 = { class: "fe-state__hint" }, K7 = {
  class: "fe-home__section",
  "data-testid": "home-recent"
}, V7 = { class: "fe-home__heading" }, j7 = {
  key: 1,
  class: "fe-home__loading"
}, q7 = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-recent-nomatch"
}, W7 = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-recent-empty"
}, Y7 = { class: "fe-state__title" }, G7 = { class: "fe-state__hint" }, X7 = {
  class: "fe-home__section",
  "data-testid": "home-starred"
}, J7 = { class: "fe-home__heading" }, Z7 = {
  key: 1,
  class: "fe-home__loading"
}, Q7 = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-starred-nomatch"
}, eV = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-starred-empty"
}, tV = { class: "fe-state__title" }, nV = { class: "fe-state__hint" }, aV = /* @__PURE__ */ lt({
  __name: "HomeView",
  props: {
    storages: {},
    recent: {},
    starred: {},
    loading: { type: Boolean },
    locale: {},
    nameFilter: {},
    matchNames: { type: Function },
    thumbSrc: { type: Function }
  },
  emits: ["open-storage", "open-node", "context-node"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r } = yt(() => n.locale), l = E(() => (n.nameFilter ?? "").trim()), d = E(() => l.value !== ""), f = Uu(
      () => l.value,
      () => n.storages,
      (z) => z.label || z.name,
      () => n.matchNames
    ), m = Uu(
      () => l.value,
      () => n.recent,
      (z) => z.basename || "",
      () => n.matchNames
    ), v = Uu(
      () => l.value,
      () => n.starred,
      (z) => z.basename || "",
      () => n.matchNames
    ), b = E(() => f.apply(n.storages)), _ = E(() => m.apply(n.recent)), w = E(() => v.apply(n.starred));
    function k(z, L) {
      return d.value && z > 0 && L === 0;
    }
    const x = /* @__PURE__ */ new Set(), M = ya({ type: "dir", mime_type: "inode/storage" });
    function A(z) {
      return typeof z.usedBytes != "number" || z.usedBytes < 0 ? i("conn.guide.storage") : z.usedPartial ? i("drive.storage.used_partial", { used: r(z.usedBytes) }) : i("drive.storage.used_unlimited", { used: r(z.usedBytes) });
    }
    const T = $({ path: "", at: 0 });
    function N(z) {
      const L = Date.now();
      z.path === T.value.path && L - T.value.at < 700 || (T.value = { path: z.path, at: L }, a("open-node", z));
    }
    return (z, L) => (p(), h("div", z7, [
      c("section", M7, [
        c("h2", P7, y(u(i)("sidenav.storages")), 1),
        b.value.length ? (p(), h("div", O7, [
          (p(!0), h(Ce, null, ot(b.value, (B) => (p(), h("button", {
            key: B.name,
            type: "button",
            class: "fe-home__storage",
            "data-testid": "home-storage-card",
            "data-storage": B.name,
            title: B.label || B.name,
            onClick: (O) => a("open-storage", B.name)
          }, [
            c("span", {
              class: "fe-home__storage-tile",
              "aria-hidden": "true",
              innerHTML: u(M)
            }, null, 8, L7),
            c("span", R7, [
              c("span", N7, y(B.label || B.name), 1),
              c("span", {
                class: "fe-home__storage-meta",
                "data-testid": "home-storage-used",
                "data-partial": B.usedPartial ? "true" : void 0
              }, y(A(B)), 9, I7),
              B.readOnly ? (p(), Je(n$, {
                key: 0,
                "read-only": "",
                locale: e.locale,
                class: "fe-home__storage-ro",
                "data-testid": "home-storage-readonly"
              }, null, 8, ["locale"])) : D("", !0)
            ])
          ], 8, D7))), 128))
        ])) : k(e.storages.length, b.value.length) ? (p(), h("p", B7, y(u(i)("filter.empty.title")), 1)) : (p(), h("div", F7, [
          L[2] || (L[2] = c("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            c("rect", {
              x: "26",
              y: "30",
              width: "68",
              height: "18",
              rx: "5"
            }),
            c("rect", {
              x: "26",
              y: "54",
              width: "68",
              height: "18",
              rx: "5"
            }),
            c("path", { d: "M38 39h.01M38 63h.01" })
          ], -1)),
          c("p", U7, y(u(i)("home.storages.empty")), 1),
          c("p", H7, y(u(i)("home.storages.hint")), 1)
        ]))
      ]),
      c("section", K7, [
        c("h2", V7, y(u(i)("sidenav.recent")), 1),
        _.value.length ? (p(), Je(Wv, {
          key: 0,
          files: _.value,
          selected: u(x),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: N,
          onDblCard: N,
          onContextCard: L[0] || (L[0] = (B, O) => a("context-node", B, O))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (p(), h("p", j7, y(u(i)("loading")), 1)) : k(e.recent.length, _.value.length) ? (p(), h("p", q7, y(u(i)("filter.empty.title")), 1)) : (p(), h("div", W7, [
          L[3] || (L[3] = c("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            c("circle", {
              cx: "60",
              cy: "50",
              r: "28"
            }),
            c("path", { d: "M60 32v18l12 8" })
          ], -1)),
          c("p", Y7, y(u(i)("empty.recent.title")), 1),
          c("p", G7, y(u(i)("empty.recent.hint")), 1)
        ]))
      ]),
      c("section", X7, [
        c("h2", J7, y(u(i)("sidenav.starred")), 1),
        w.value.length ? (p(), Je(Wv, {
          key: 0,
          files: w.value,
          selected: u(x),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: N,
          onDblCard: N,
          onContextCard: L[1] || (L[1] = (B, O) => a("context-node", B, O))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (p(), h("p", Z7, y(u(i)("loading")), 1)) : k(e.starred.length, w.value.length) ? (p(), h("p", Q7, y(u(i)("filter.empty.title")), 1)) : (p(), h("div", eV, [
          L[4] || (L[4] = c("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            c("path", { d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z" })
          ], -1)),
          c("p", tV, y(u(i)("empty.starred.title")), 1),
          c("p", nV, y(u(i)("empty.starred.hint")), 1)
        ]))
      ])
    ]));
  }
}), iV = {
  class: "fe-drafts",
  "data-testid": "drafts-view"
}, oV = { class: "fe-drafts__head" }, rV = { class: "fe-drafts__lead" }, sV = {
  key: 0,
  class: "fe-drafts__count",
  "data-testid": "drafts-count-line"
}, lV = {
  key: 0,
  class: "fe-state",
  "data-testid": "empty-drafts"
}, uV = { class: "fe-state__title" }, cV = { class: "fe-state__hint" }, dV = { class: "fe-drafts__name" }, fV = ["innerHTML"], pV = ["title", "data-testid", "onClick"], hV = { class: "fe-drafts__target" }, mV = /* @__PURE__ */ lt({
  __name: "DraftsView",
  props: {
    drafts: {},
    loading: { type: Boolean },
    limit: {},
    locale: {},
    nameFilter: {},
    matchNames: { type: Function },
    busyKey: {}
  },
  emits: ["open", "save", "delete"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r } = yt(() => n.locale), l = Uu(
      () => n.nameFilter ?? "",
      () => n.drafts,
      (M) => M.name,
      () => n.matchNames
    ), d = E(() => l.apply(n.drafts));
    function f(M) {
      const A = M.lastIndexOf(".");
      return A > 0 ? M.slice(A + 1).toLowerCase() : "";
    }
    function m(M) {
      return ya({ type: "file", basename: M.name, extension: f(M.name) || M.type });
    }
    function v(M) {
      const A = M.target_dir.indexOf("://"), T = (A >= 0 ? M.target_dir.slice(A + 3) : M.target_dir).replace(/^\/+|\/+$/g, "");
      return T ? T.split("/").filter(Boolean).join(" / ") : "/";
    }
    function b(M) {
      return Date.parse(M.modified_at || M.created_at) || 0;
    }
    const _ = E(() => [
      {
        id: "name",
        label: i("col.name"),
        lead: !0,
        sortable: !0,
        width: 280,
        min: 160,
        format: (M) => M.name
      },
      {
        id: "target",
        label: i("drafts.col.target"),
        sortable: !0,
        width: 240,
        format: v,
        title: (M) => M.target
      },
      {
        id: "storage",
        label: i("drafts.col.storage"),
        sortable: !0,
        width: 140,
        format: (M) => M.storage
      },
      {
        id: "modified",
        label: i("col.modified"),
        sortable: !0,
        sortDir: "desc",
        width: 170,
        format: (M) => r(b(M)),
        sortValue: (M) => b(M)
      }
    ]);
    function w(M) {
      const A = n.busyKey === M.key;
      return [
        { key: "open", label: i("ctx.open"), icon: "open", disabled: A },
        { key: "save", label: i("drafts.action.save"), icon: "check", disabled: A },
        { key: "delete", label: i("ctx.delete"), icon: "delete", danger: !0, disabled: A }
      ];
    }
    function k(M, A) {
      M === "open" ? a("open", A) : M === "save" ? a("save", A) : M === "delete" && a("delete", A);
    }
    const x = E(
      () => n.limit && n.limit > 0 ? i("drafts.count_of", { n: n.drafts.length, limit: n.limit }) : ""
    );
    return (M, A) => (p(), h("section", iV, [
      c("header", oV, [
        c("p", rV, y(u(i)("drafts.lead")), 1),
        x.value && e.drafts.length ? (p(), h("p", sV, y(x.value), 1)) : D("", !0)
      ]),
      !e.loading && e.drafts.length === 0 ? (p(), h("div", lV, [
        A[2] || (A[2] = c("svg", {
          class: "fe-state__art",
          viewBox: "0 0 120 100",
          width: "110",
          height: "92",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true"
        }, [
          c("path", { d: "M66 18H38a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h44a6 6 0 0 0 6-6V40z" }),
          c("path", { d: "M66 18v22h22" }),
          c("path", { d: "M50 66l18-18 6 6-18 18H50z" })
        ], -1)),
        c("p", uV, y(u(i)("empty.drafts.title")), 1),
        c("p", cV, y(u(i)("empty.drafts.hint")), 1)
      ])) : (p(), Je(Vr, {
        key: 1,
        "table-id": "explorer.drafts",
        columns: _.value,
        rows: d.value,
        "row-key": "key",
        locale: e.locale,
        loading: e.loading,
        framed: !1,
        empty: u(i)("drafts.no_match"),
        "aria-label": u(i)("node.drafts"),
        "row-attrs": (T) => ({ "data-testid": `draft-row-${T.key}`, "data-draft-name": T.name }),
        "row-actions": w,
        "row-actions-test-id": (T) => `draft-actions-${T.key}`,
        onRowAction: A[0] || (A[0] = (T, N) => k(T, N)),
        onRowDblclick: A[1] || (A[1] = (T) => a("open", T))
      }, {
        "cell-name": gt(({ row: T }) => [
          c("span", dV, [
            c("span", {
              class: "fe-drafts__tile",
              "aria-hidden": "true",
              innerHTML: m(T)
            }, null, 8, fV),
            c("button", {
              type: "button",
              class: "fe-drafts__open",
              title: u(i)("drafts.open_hint", { name: T.name }),
              "data-testid": `draft-open-${T.key}`,
              onClick: vt((N) => a("open", T), ["stop"])
            }, [
              c("bdi", null, y(T.name), 1)
            ], 8, pV)
          ])
        ]),
        "cell-target": gt(({ row: T }) => [
          c("bdi", hV, y(v(T)), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "loading", "empty", "aria-label", "row-attrs", "row-actions-test-id"]))
    ]));
  }
});
function _a(e) {
  if (e.apiBase != null) return e.apiBase.replace(/\/+$/, "");
  const t = e.endpoint ?? "", n = t.indexOf("/api/");
  return n >= 0 ? t.slice(0, n) : "";
}
function vV(e, t) {
  const n = String(t ?? "").trim();
  if (/^https?:\/\/[^/]/i.test(n)) return n.replace(/\/+$/, "");
  const a = _a(e);
  if (/^https?:\/\//i.test(a))
    try {
      const i = new URL(a);
      return i.origin + i.pathname.replace(/\/+$/, "");
    } catch {
      return a;
    }
  return typeof window < "u" && window.location ? window.location.origin + (a.startsWith("/") ? a : "") : a;
}
function yV(e) {
  const t = _l(e), n = _a(e), a = (I) => `${n}${I}`, i = xa([]), r = xa([]), l = xa([]), d = $(null), f = $(null), m = $(null), v = $(!1), b = $(!1), _ = $(null), w = $(null), k = $(null);
  function x(I) {
    return I == null ? void 0 : I.status;
  }
  function M(I) {
    return Er(I, e.locale);
  }
  async function A() {
    v.value = !0, _.value = null;
    try {
      const I = t.capabilities().then((G) => {
        const Y = G == null ? void 0 : G.public_url;
        m.value = typeof Y == "string" && Y ? Y : null;
      }).catch(() => {
        m.value = null;
      });
      try {
        const G = await t.jsonFetch(a("/api/auth/me"));
        d.value = (G == null ? void 0 : G.user) ?? null, f.value = typeof (G == null ? void 0 : G.realm) == "string" && G.realm ? G.realm : null;
      } catch (G) {
        x(G) === 401 && (w.value = !1, k.value = "anonymous"), d.value = null;
      }
      try {
        i.value = await t.jsonFetch(
          a("/api/admin/storage-drivers")
        ), w.value = !0, k.value = null;
      } catch (G) {
        i.value = [], w.value = !1;
        const Y = x(G);
        Y === 403 ? k.value = "none" : Y === 401 ? k.value = "anonymous" : (k.value = "unreachable", _.value = M(G));
      }
      if (w.value)
        try {
          const G = await t.jsonFetch(a("/api/admin/storages"));
          r.value = Array.isArray(G) ? G : [], l.value = r.value.map((Y) => Y.name);
        } catch (G) {
          _.value = M(G);
        }
      else
        try {
          const G = await t.index("");
          l.value = Array.isArray(G == null ? void 0 : G.storages) ? G.storages : [];
        } catch {
          l.value = [];
        }
      await I, b.value = !0;
    } finally {
      v.value = !1;
    }
  }
  async function T(I) {
    const G = await t.jsonFetch(a("/api/admin/storages"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(I)
    });
    return await A(), G;
  }
  async function N(I, G) {
    const Y = await t.jsonFetch(a(`/api/admin/storages/${I}`), {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(G)
    });
    return await A(), Y;
  }
  async function z(I) {
    await t.jsonFetch(a(`/api/admin/storages/${I}`), { method: "DELETE" }), await A();
  }
  async function L(I) {
    try {
      return await t.jsonFetch(a("/api/admin/storages/test"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(I)
      });
    } catch (G) {
      return { ok: !1, error: M(G) };
    }
  }
  function B(I) {
    return i.value.find((G) => G.driver === I);
  }
  function O(I) {
    var G;
    return ((G = B(I)) == null ? void 0 : G.fields) ?? [];
  }
  function U(I) {
    const G = {};
    for (const Y of O(I))
      Y.default !== void 0 && Y.default !== null && (G[Y.key] = Y.default);
    return G;
  }
  function S(I, G) {
    return O(I).filter((Y) => {
      if (!Y.required || Y.default !== void 0) return !1;
      for (const ie of [Y.key, ...Y.aliases ?? []]) {
        const me = G[ie];
        if (me != null && !(typeof me == "string" && me.trim() === ""))
          return !1;
      }
      return !0;
    });
  }
  const F = E(() => i.value.map((I) => I.driver));
  return {
    // state
    drivers: i,
    driverNames: F,
    storages: r,
    visible: l,
    me: d,
    realm: f,
    publicUrl: m,
    loading: v,
    loaded: b,
    error: _,
    canManage: w,
    denial: k,
    // actions
    load: A,
    createStorage: T,
    updateStorage: N,
    deleteStorage: z,
    testStorage: L,
    // descriptor helpers
    descriptor: B,
    fields: O,
    defaults: U,
    missingRequired: S
  };
}
function l$(e) {
  return /^http:\/\//i.test(e);
}
function gV(e, t) {
  const n = e.replace(/\/+$/, "");
  return t ? `${n}/dav/${t}/` : `${n}/dav/`;
}
function bV(e, t) {
  let n;
  try {
    n = new URL(e);
  } catch {
    return e.replace(/^https:/i, "davs:").replace(/^http:/i, "dav:");
  }
  return `${n.protocol === "http:" ? "dav" : "davs"}://${n.host}${n.pathname}`;
}
function kV(e) {
  return ["use", e.letter, e.url, `/user:${e.user}`, e.password, "/persistent:yes"];
}
function wV(e) {
  const [t, n, a, ...i] = kV(e);
  return ["net", t, n, `"${a}"`, ...i].join(" ");
}
const b1 = "HKLM\\SYSTEM\\CurrentControlSet\\Services\\WebClient\\Parameters", _V = 4294967295, xV = 2e7, SV = [
  `reg add "${b1}" /v FileSizeLimitInBytes /t REG_DWORD /d ${_V} /f`,
  `reg add "${b1}" /v FileAttributesLimitInBytes /t REG_DWORD /d ${xV} /f`,
  "net stop webclient && net start webclient"
];
function Fr(e) {
  try {
    return new URL(e).host;
  } catch {
    return e.replace(/^https?:\/\//i, "").replace(/\/+$/, "");
  }
}
function $V(e) {
  try {
    return new URL(e).pathname.replace(/\/+$/, "");
  } catch {
    return "";
  }
}
function TV(e, t) {
  const n = String(e ?? "").trim(), a = String(t ?? "").trim();
  return n && a ? `${a}/${n}` : n;
}
function wg(e, t) {
  return e.user || t("conn.guide.userPlaceholder");
}
const AV = (e, t) => {
  const n = e.origin.replace(/\/+$/, ""), a = gV(n, e.storage), i = wg(e, t), r = t("conn.guide.secretPlaceholder"), l = [
    { label: t("conn.guide.fact.url"), value: a, hint: e.storage ? t("conn.guide.fact.urlStorageHint", { storage: e.storage }) : t("conn.guide.fact.urlRootHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.webdav.userHint") },
    { label: t("conn.guide.fact.password"), value: r, hint: t("conn.guide.webdav.passwordHint"), placeholderOnly: !0 }
  ], d = [
    {
      id: "windows",
      name: "Windows Explorer",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.win.s1"),
            t("conn.guide.webdav.win.s2", { url: a }),
            t("conn.guide.webdav.win.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.win.cmdCaption"),
          code: wV({ letter: "Z:", url: a, user: i, password: r })
        },
        {
          kind: "warn",
          text: t("conn.guide.webdav.win.limits")
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.win.regCaption"),
          code: SV.join(`
`)
        },
        { kind: "note", text: t("conn.guide.webdav.win.https") },
        { kind: "note", text: t("conn.guide.webdav.win.persist") },
        { kind: "note", text: t("conn.guide.webdav.win.service") }
      ]
    },
    {
      id: "macos",
      name: "macOS Finder",
      platform: "macos",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.mac.s1"),
            t("conn.guide.webdav.mac.s2", { url: a }),
            t("conn.guide.webdav.mac.s3")
          ]
        },
        { kind: "note", text: t("conn.guide.webdav.mac.note") }
      ]
    },
    {
      id: "linux",
      name: "Linux (davfs2 / GNOME / KDE)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.webdav.linux.mountCaption"),
          code: [
            `sudo mount -t davfs ${a} /mnt/filex`,
            "",
            `# ${t("conn.guide.webdav.linux.gvfsComment")}`,
            `gio mount ${bV(a)}`
          ].join(`
`)
        },
        {
          kind: "warn",
          text: t("conn.guide.webdav.linux.locks")
        },
        {
          kind: "code",
          caption: "/etc/davfs2/davfs2.conf",
          code: "use_locks 0"
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.webdav.rclone.obscureCaption"),
          code: `rclone obscure "${r}"`
        },
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = webdav",
            `url = ${n}/dav`,
            "vendor = other",
            `user = ${i}`,
            `pass = ${t("conn.guide.webdav.rclone.passPlaceholder")}`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            e.storage ? `rclone lsl filex:${e.storage}` : "rclone lsl filex:<storage>",
            e.storage ? `rclone copy ./local filex:${e.storage}/backup` : "rclone copy ./local filex:<storage>/backup",
            "rclone mount filex: /mnt/filex"
          ].join(`
`)
        }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.duck.s1"),
            t("conn.guide.webdav.duck.s2", { host: Fr(n) }),
            t("conn.guide.webdav.duck.s3", { path: $V(n) + (e.storage ? `/dav/${e.storage}/` : "/dav/") }),
            t("conn.guide.webdav.duck.s4", { user: i })
          ]
        }
      ]
    }
  ], f = [
    { kind: "note", text: t("conn.guide.webdav.note.delete") },
    { kind: "note", text: t("conn.guide.webdav.note.locks") },
    { kind: "note", text: t("conn.guide.webdav.note.permissions") }
  ];
  return l$(n) && f.unshift({ kind: "warn", text: t("conn.guide.webdav.note.http") }), {
    id: "webdav",
    name: "WebDAV",
    summary: t("conn.guide.webdav.summary"),
    facts: l,
    clients: d,
    notes: f
  };
}, EV = (e, t) => {
  const n = (e.s3Endpoint || `${e.origin.replace(/\/+$/, "")}/s3`).replace(/\/+$/, ""), a = e.storage || e.storages[0] || "<bucket>", i = e.s3AccessKeyID || t("conn.guide.s3.keyPlaceholder"), r = e.s3Secret || t("conn.guide.s3.secretPlaceholder"), l = e.s3PathStyle !== !1, d = Fr(n), f = [
    { label: t("conn.guide.s3.fact.endpoint"), value: n, hint: t("conn.guide.s3.fact.endpointHint") },
    { label: t("conn.guide.s3.fact.bucket"), value: a, hint: t("conn.guide.s3.fact.bucketHint") },
    { label: t("conn.guide.s3.fact.key"), value: i, hint: t("conn.guide.s3.fact.keyHint") },
    {
      label: t("conn.guide.s3.fact.secret"),
      value: r,
      hint: t("conn.guide.s3.fact.secretHint"),
      // ⚠ Only real right after minting. filex stores the secret sealed and
      // cannot show it again, and a guide that printed something secret-shaped
      // would be teaching a value that authenticates as nothing.
      placeholderOnly: !e.s3Secret
    },
    { label: t("conn.guide.s3.fact.region"), value: "us-east-1", hint: t("conn.guide.s3.fact.regionHint") },
    {
      label: t("conn.guide.s3.fact.addressing"),
      value: t(l ? "conn.guide.s3.fact.pathStyle" : "conn.guide.s3.fact.virtualHosted"),
      hint: t(l ? "conn.guide.s3.fact.pathStyleHint" : "conn.guide.s3.fact.virtualHostedHint")
    }
  ], m = [
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = s3",
            "provider = Other",
            `endpoint = ${n}`,
            `access_key_id = ${i}`,
            `secret_access_key = ${r}`,
            "region = us-east-1",
            ...l ? ["force_path_style = true"] : []
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            `rclone copy ./local filex:${a}/backup -P`,
            `rclone sync ./local filex:${a}/backup`,
            `rclone mount filex:${a} /mnt/filex`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.rclone.mtime") }
      ]
    },
    {
      id: "awscli",
      name: "AWS CLI",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.aws.configureCaption"),
          code: [
            "aws configure set aws_access_key_id " + i,
            "aws configure set aws_secret_access_key " + r,
            "aws configure set region us-east-1"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.aws.useCaption"),
          code: [
            `aws --endpoint-url ${n} s3 ls`,
            `aws --endpoint-url ${n} s3 cp ./file.pdf s3://${a}/file.pdf`,
            `aws --endpoint-url ${n} s3 sync ./local s3://${a}/backup`,
            `aws --endpoint-url ${n} s3 presign s3://${a}/file.pdf --expires-in 300`
          ].join(`
`)
        },
        ...l ? [
          {
            kind: "note",
            text: t("conn.guide.s3.aws.pathStyle")
          },
          {
            kind: "code",
            caption: "~/.aws/config",
            code: ["[default]", "s3 =", "    addressing_style = path"].join(`
`)
          }
        ] : []
      ]
    },
    {
      id: "restic",
      name: "restic",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.restic.envCaption"),
          code: [
            `export AWS_ACCESS_KEY_ID=${i}`,
            `export AWS_SECRET_ACCESS_KEY=${r}`,
            `export RESTIC_REPOSITORY="s3:${n}/${a}/restic"`,
            "export RESTIC_PASSWORD=…"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.restic.useCaption"),
          code: [
            `restic init${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic backup ~/Documents${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic check --read-data${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic forget --keep-daily 7 --prune${l ? " -o s3.bucket-lookup=path" : ""}`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.restic.verified") }
      ]
    },
    {
      id: "mc",
      name: "MinIO Client (mc)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.mc.aliasCaption"),
          code: `mc alias set filex ${n} ${i} ${r} --api S3v4${l ? " --path on" : ""}`
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.mc.useCaption"),
          code: [
            "mc ls filex",
            `mc cp ./file.pdf filex/${a}/file.pdf`,
            `mc mirror ./local filex/${a}/backup`,
            `mc du filex/${a}`
          ].join(`
`)
        }
      ]
    },
    {
      id: "s3fs",
      name: "s3fs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.s3fs.credsCaption"),
          code: [
            `echo "${i}:${r}" > ~/.passwd-s3fs`,
            "chmod 600 ~/.passwd-s3fs"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.s3fs.mountCaption"),
          code: [
            `s3fs ${a} /mnt/filex \\`,
            "  -o passwd_file=~/.passwd-s3fs \\",
            `  -o url=${n} \\`,
            ...l ? ["  -o use_path_request_style"] : []
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.s3fs.note") }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.s3.duck.s1"),
            t("conn.guide.s3.duck.s2", { host: d }),
            t("conn.guide.s3.duck.s3", { key: i }),
            t("conn.guide.s3.duck.s4")
          ]
        },
        ...l ? [{ kind: "warn", text: t("conn.guide.s3.duck.pathStyle") }] : []
      ]
    },
    {
      id: "sdk",
      name: "SDK (Go / Python / JS)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "boto3",
          code: [
            "import boto3",
            "s3 = boto3.client(",
            '    "s3",',
            `    endpoint_url="${n}",`,
            `    aws_access_key_id="${i}",`,
            `    aws_secret_access_key="${r}",`,
            '    region_name="us-east-1",',
            ...l ? [
              '    config=boto3.session.Config(s3={"addressing_style": "path"}),'
            ] : [],
            ")",
            `print([o["Key"] for o in s3.list_objects_v2(Bucket="${a}").get("Contents", [])])`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.sdk.note") }
      ]
    }
  ], v = [
    { kind: "note", text: t("conn.guide.s3.note.buckets") },
    { kind: "note", text: t("conn.guide.s3.note.permissions") },
    { kind: "note", text: t("conn.guide.s3.note.trash") },
    { kind: "note", text: t("conn.guide.s3.note.mtime") }
  ];
  return l && v.unshift({ kind: "warn", text: t("conn.guide.s3.note.pathStyle") }), l$(n) && v.unshift({ kind: "warn", text: t("conn.guide.s3.note.http") }), {
    id: "s3",
    name: "S3",
    summary: t("conn.guide.s3.summary"),
    facts: f,
    clients: m,
    notes: v
  };
}, CV = (e, t) => {
  const n = e.sftpHost || Fr(e.origin), a = e.sftpPort || 2022, i = e.sftpLogin || wg(e, t), r = e.storage ? `/${e.storage}` : "/<storage>", l = a === 22 ? "" : ` -P ${a}`, d = [
    { label: t("conn.guide.sftp.fact.host"), value: n, hint: t("conn.guide.sftp.fact.hostHint") },
    { label: t("conn.guide.sftp.fact.port"), value: String(a), hint: t("conn.guide.sftp.fact.portHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.sftp.fact.userHint") },
    {
      label: t("conn.guide.sftp.fact.auth"),
      value: e.sftpHasKey ? t("conn.guide.sftp.fact.authKey") : t("conn.guide.sftp.fact.authPassword"),
      hint: t("conn.guide.sftp.fact.authHint"),
      placeholderOnly: !0
    },
    { label: t("conn.guide.sftp.fact.path"), value: r, hint: t("conn.guide.sftp.fact.pathHint") }
  ], f = [
    {
      id: "openssh",
      name: "OpenSSH (sftp / scp)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.sftp.openssh.connectCaption"),
          code: [
            `sftp${l} ${i}@${n}`,
            `scp${l} ./report.pdf ${i}@${n}:${r}/report.pdf`,
            `scp${l} ${i}@${n}:${r}/report.pdf ./`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "~/.ssh/config",
          code: [
            "Host filex",
            `  HostName ${n}`,
            `  Port ${a}`,
            `  User ${i}`,
            "  # IdentityFile ~/.ssh/id_ed25519"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.sftp.openssh.noShell") }
      ]
    },
    {
      id: "key",
      name: t("conn.guide.sftp.key.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.key.s1"),
            t("conn.guide.sftp.key.s2"),
            t("conn.guide.sftp.key.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.sftp.key.genCaption"),
          code: ['ssh-keygen -t ed25519 -C "filex"', "cat ~/.ssh/id_ed25519.pub"].join(`
`)
        },
        // ⚠ The one command people reach for, and the one that cannot work.
        { kind: "warn", text: t("conn.guide.sftp.key.noCopyId") }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.winscp.s1"),
            t("conn.guide.sftp.winscp.s2", { host: n, port: String(a) }),
            t("conn.guide.sftp.winscp.s3", { user: i }),
            t("conn.guide.sftp.winscp.s4")
          ]
        }
      ]
    },
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.filezilla.s1"),
            t("conn.guide.sftp.filezilla.s2", { host: `sftp://${n}`, port: String(a) }),
            t("conn.guide.sftp.filezilla.s3", { user: i })
          ]
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-sftp]",
            "type = sftp",
            `host = ${n}`,
            `port = ${a}`,
            `user = ${i}`,
            "key_file = ~/.ssh/id_ed25519",
            "# filex has no shell, so tell rclone not to look for one:",
            "shell_type = none",
            "md5sum_command = none",
            "sha1sum_command = none"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.sftp.rclone.useCaption"),
          code: [
            "rclone lsd filex-sftp:",
            `rclone copy ./local filex-sftp:${r}/backup -P`,
            `rclone sync ./local filex-sftp:${r}/backup`
          ].join(`
`)
        }
      ]
    },
    {
      id: "sshfs",
      name: "sshfs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.sftp.sshfs.mountCaption"),
          code: [
            `sshfs -p ${a} ${i}@${n}:${r} /mnt/filex`,
            "fusermount -u /mnt/filex"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.sftp.sshfs.note") }
      ]
    }
  ], m = [
    { kind: "note", text: t("conn.guide.sftp.note.storages") },
    { kind: "note", text: t("conn.guide.sftp.note.permissions") },
    { kind: "note", text: t("conn.guide.sftp.note.trash") },
    { kind: "note", text: t("conn.guide.sftp.note.totp") }
  ];
  return e.sftpEnabled === !1 && m.unshift({ kind: "warn", text: t("conn.guide.sftp.note.disabled") }), {
    id: "sftp",
    name: "SFTP",
    summary: t("conn.guide.sftp.summary"),
    facts: d,
    clients: f,
    notes: m
  };
}, zV = (e, t) => {
  const n = e.ftpsHost || Fr(e.origin), a = e.ftpsPort || 2121, i = e.sftpLogin || wg(e, t), r = t("conn.guide.secretPlaceholder"), l = e.storage ? `/${e.storage}` : "/<storage>", d = e.ftpsPasvMin && e.ftpsPasvMax ? `${e.ftpsPasvMin}-${e.ftpsPasvMax}` : "30000-30100", f = [
    { label: t("conn.guide.ftps.fact.host"), value: n, hint: t("conn.guide.ftps.fact.hostHint") },
    { label: t("conn.guide.ftps.fact.port"), value: String(a), hint: t("conn.guide.ftps.fact.portHint") },
    { label: t("conn.guide.ftps.fact.mode"), value: t("conn.guide.ftps.fact.modeValue"), hint: t("conn.guide.ftps.fact.modeHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.ftps.fact.userHint") },
    { label: t("conn.guide.fact.password"), value: r, hint: t("conn.guide.ftps.fact.passwordHint"), placeholderOnly: !0 },
    { label: t("conn.guide.ftps.fact.pasv"), value: d, hint: t("conn.guide.ftps.fact.pasvHint") }
  ], m = [
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.filezilla.s1"),
            t("conn.guide.ftps.filezilla.s2", { host: n, port: String(a) }),
            t("conn.guide.ftps.filezilla.s3", { user: i }),
            t("conn.guide.ftps.filezilla.s4")
          ]
        }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.winscp.s1"),
            t("conn.guide.ftps.winscp.s2", { host: n, port: String(a) }),
            t("conn.guide.ftps.winscp.s3", { user: i })
          ]
        }
      ]
    },
    {
      id: "curl",
      name: "curl",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.ftps.curl.caption"),
          code: [
            `curl --ssl-reqd --ftp-pasv --user ${i} \\`,
            `  -T ./report.pdf "ftp://${n}:${a}${l}/report.pdf"`,
            "",
            `curl --ssl-reqd --ftp-pasv --user ${i} \\`,
            `  -o ./report.pdf "ftp://${n}:${a}${l}/report.pdf"`
          ].join(`
`)
        },
        // ⚠ The flag that matters. Without it curl will happily fall back to
        // plaintext against a server that allows it — this one does not, but
        // the habit is what protects you against the ones that do.
        { kind: "note", text: t("conn.guide.ftps.curl.sslReqd") }
      ]
    },
    {
      id: "lftp",
      name: "lftp",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.lftprc",
          code: [
            "set ftp:ssl-force true",
            "set ftp:ssl-protect-data true",
            "set ftp:passive-mode true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.ftps.lftp.caption"),
          code: [
            `lftp -u ${i} ftp://${n}:${a}`,
            `# then: cd ${l}; put ./report.pdf; ls`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.ftps.lftp.protectData") }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-ftp]",
            "type = ftp",
            `host = ${n}`,
            `port = ${a}`,
            `user = ${i}`,
            '# rclone obscure "<your password>"',
            "pass = …",
            "explicit_tls = true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.ftps.rclone.useCaption"),
          code: [
            "rclone lsd filex-ftp:",
            `rclone copy ./local filex-ftp:${l}/backup -P`
          ].join(`
`)
        }
      ]
    },
    {
      id: "printer",
      name: t("conn.guide.ftps.printer.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.printer.s1", { host: n, port: String(a) }),
            t("conn.guide.ftps.printer.s2", { user: i }),
            t("conn.guide.ftps.printer.s3", { path: l }),
            t("conn.guide.ftps.printer.s4")
          ]
        },
        // ⚠ The honest warning: plenty of scan-to-FTP firmware cannot do TLS
        // at all, and this endpoint will not talk to it. Saying so beats an
        // afternoon spent debugging a device that was never going to connect.
        { kind: "warn", text: t("conn.guide.ftps.printer.noTLS") }
      ]
    }
  ], v = [
    { kind: "warn", text: t("conn.guide.ftps.note.tls") },
    { kind: "note", text: t("conn.guide.ftps.note.passive") },
    { kind: "note", text: t("conn.guide.ftps.note.storages") },
    { kind: "note", text: t("conn.guide.ftps.note.trash") },
    { kind: "note", text: t("conn.guide.ftps.note.prefer") }
  ];
  return e.ftpsSelfSigned && v.push({ kind: "warn", text: t("conn.guide.ftps.note.selfSigned") }), e.ftpsEnabled === !1 && v.unshift({ kind: "warn", text: t("conn.guide.ftps.note.disabled") }), {
    id: "ftps",
    name: "FTPS",
    summary: t("conn.guide.ftps.summary"),
    facts: f,
    clients: m,
    notes: v
  };
}, MV = (e, t) => {
  const n = e.nfsHost || Fr(e.origin), a = e.nfsPort || 2049, i = e.nfsPath || t("conn.guide.nfs.pathPlaceholder"), r = e.nfsReadOnly ? ",ro" : "", l = `nfsvers=3,tcp,port=${a},mountport=${a},nolock${r}`, d = [
    { label: t("conn.guide.nfs.fact.host"), value: n, hint: t("conn.guide.nfs.fact.hostHint") },
    { label: t("conn.guide.nfs.fact.port"), value: String(a), hint: t("conn.guide.nfs.fact.portHint") },
    {
      label: t("conn.guide.nfs.fact.export"),
      value: i,
      hint: t("conn.guide.nfs.fact.exportHint"),
      // ⚠ Only real right after minting: the path is stored hashed and cannot
      // be shown again, and printing something path-shaped would produce a
      // mount line that fails with no clue why.
      placeholderOnly: !e.nfsPath
    },
    { label: t("conn.guide.nfs.fact.options"), value: l, hint: t("conn.guide.nfs.fact.optionsHint") }
  ], f = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.nfs.linux.mountCaption"),
          code: [
            "sudo mkdir -p /mnt/filex",
            `sudo mount -t nfs -o ${l} ${n}:${i} /mnt/filex`,
            "",
            "# and to unmount:",
            "sudo umount /mnt/filex"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "/etc/fstab",
          code: `${n}:${i}  /mnt/filex  nfs  ${l},_netdev,noauto,x-systemd.automount  0  0`
        },
        // ⚠ The warning that belongs next to the fstab line rather than in a
        // document: that file is world-readable on most systems.
        { kind: "warn", text: t("conn.guide.nfs.linux.fstabSecret") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.nfs.mac.mountCaption"),
          code: [
            "sudo mkdir -p /Volumes/filex",
            `sudo mount -t nfs -o vers=3,tcp,port=${a},mountport=${a},nolock${r},resvport ${n}:${i} /Volumes/filex`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.nfs.mac.resvport") }
      ]
    },
    {
      id: "windows",
      name: "Windows (Client for NFS)",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.nfs.win.s1"),
            t("conn.guide.nfs.win.s2"),
            t("conn.guide.nfs.win.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.nfs.win.cmdCaption"),
          code: `mount -o anon nolock ${n}:${i} Z:`
        },
        // ⚠ Windows' client has no way to say "the mount service is on this
        // port", so it only works when filex is on 2049.
        { kind: "warn", text: t("conn.guide.nfs.win.port") }
      ]
    },
    {
      id: "synology",
      name: t("conn.guide.nfs.nas.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.nfs.nas.s1", { host: n, port: String(a) }),
            t("conn.guide.nfs.nas.s2"),
            t("conn.guide.nfs.nas.s3")
          ]
        }
      ]
    }
  ], m = [
    { kind: "warn", text: t("conn.guide.nfs.note.unencrypted") },
    { kind: "warn", text: t("conn.guide.nfs.note.pathIsSecret") },
    { kind: "note", text: t("conn.guide.nfs.note.noPortmapper") },
    { kind: "note", text: t("conn.guide.nfs.note.uid") },
    { kind: "note", text: t("conn.guide.nfs.note.trash") },
    { kind: "note", text: t("conn.guide.nfs.note.revoke") }
  ];
  return e.nfsEnabled === !1 && m.unshift({ kind: "warn", text: t("conn.guide.nfs.note.disabled") }), {
    id: "nfs",
    name: "NFS",
    summary: t("conn.guide.nfs.summary"),
    facts: d,
    clients: f,
    notes: m
  };
}, PV = (e, t) => {
  const n = e.origin.replace(/\/+$/, ""), a = e.storage || e.storages[0] || "main", i = [
    { label: t("conn.guide.mount.fact.url"), value: n, hint: t("conn.guide.mount.fact.urlHint") },
    {
      label: t("conn.guide.mount.fact.token"),
      value: t("conn.guide.mount.fact.tokenPlaceholder"),
      hint: t("conn.guide.mount.fact.tokenHint"),
      // filex never has the plaintext of a token after it is minted, and a
      // fact row that looked like one would be a lie the user pastes.
      placeholderOnly: !0
    },
    { label: t("conn.guide.mount.fact.remote"), value: `${a}://`, hint: t("conn.guide.mount.fact.remoteHint") }
  ], r = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.mountCaption"),
          code: [
            `export FILEX_URL=${n}`,
            "export FILEX_TOKEN=<token>",
            "",
            "mkdir -p ~/filex",
            "filex mount ~/filex",
            "",
            "# one storage only, or a subfolder of it:",
            `filex mount --remote '${a}://' ~/filex`,
            `filex mount --remote '${a}://projects/acme' --read-only ~/acme`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.umountCaption"),
          code: "fusermount -u ~/filex"
        },
        // ⚠ The one that costs an afternoon if it is not said: killing the
        // process leaves a directory where every `ls` hangs.
        { kind: "warn", text: t("conn.guide.mount.linux.umountWarn") },
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.systemdCaption"),
          code: [
            "# ~/.config/systemd/user/filex-mount.service",
            "[Unit]",
            "Description=filex mount",
            "After=network-online.target",
            "",
            "[Service]",
            `Environment=FILEX_URL=${n}`,
            "Environment=FILEX_TOKEN=<token>",
            "ExecStart=%h/.local/bin/filex mount %h/filex",
            "ExecStop=/bin/fusermount -u %h/filex",
            "Restart=on-failure",
            "",
            "[Install]",
            "WantedBy=default.target"
          ].join(`
`)
        }
      ]
    },
    {
      id: "windows",
      name: "Windows",
      platform: "windows",
      blocks: [
        { kind: "note", text: t("conn.guide.mount.win.winfsp") },
        {
          kind: "code",
          caption: t("conn.guide.mount.win.mountCaption"),
          code: [
            `$env:FILEX_URL   = "${n}"`,
            '$env:FILEX_TOKEN = "<token>"',
            "",
            "filex mount Z:"
          ].join(`
`)
        },
        // ⚠ The drive letter is CREATED, not reused — pointing it at one that
        // already exists is the commonest way this fails, and the message the
        // driver gives for it says nothing useful.
        { kind: "warn", text: t("conn.guide.mount.win.freeLetter") },
        { kind: "note", text: t("conn.guide.mount.win.stop") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        // ⚠⚠ A refusal stated up front rather than discovered. macFUSE's Go
        // binding needs a C toolchain filex deliberately does not use, and its
        // licence forbids a commercial program from installing it. Pretending
        // otherwise would mean a command that appears to work and does nothing.
        { kind: "warn", text: t("conn.guide.mount.mac.unsupported") },
        { kind: "note", text: t("conn.guide.mount.mac.alternatives") }
      ]
    }
  ], l = [
    { kind: "note", text: t("conn.guide.mount.note.notASync") },
    { kind: "note", text: t("conn.guide.mount.note.reachable") },
    { kind: "note", text: t("conn.guide.mount.note.wholeFileWrites") },
    { kind: "note", text: t("conn.guide.mount.note.trash") },
    { kind: "note", text: t("conn.guide.mount.note.revoke") }
  ];
  return {
    id: "mount",
    name: "filex mount",
    summary: t("conn.guide.mount.summary"),
    facts: i,
    clients: r,
    notes: l
  };
}, u$ = {
  webdav: AV,
  s3: EV,
  sftp: CV,
  ftps: zV,
  nfs: MV,
  mount: PV
}, OV = {
  webdav: "WebDAV",
  s3: "S3",
  sftp: "SFTP",
  ftps: "FTPS",
  nfs: "NFS",
  mount: "filex mount"
};
function DV(e) {
  return OV[e] || e.toUpperCase();
}
function LV() {
  return Object.keys(u$);
}
function RV(e, t, n) {
  const a = u$[e];
  return a ? a(t, n) : null;
}
const NV = { class: "fe-guide" }, IV = { class: "fe-guide__summary" }, BV = {
  class: "fe-guide__facts",
  "data-testid": "guide-facts"
}, FV = { class: "fe-guide__factlabel" }, UV = { class: "fe-guide__factvalue" }, HV = ["data-testid", "onClick"], KV = {
  key: 0,
  class: "fe-guide__facthint"
}, VV = {
  class: "fe-guide__tabs",
  role: "tablist"
}, jV = ["aria-selected", "data-testid", "onClick"], qV = {
  key: 0,
  class: "fe-guide__body",
  role: "tabpanel"
}, WV = {
  key: 0,
  class: "fe-guide__steps"
}, YV = {
  key: 1,
  class: "fe-guide__codewrap"
}, GV = { class: "fe-guide__codehead" }, XV = { class: "fe-guide__caption" }, JV = ["data-testid", "onClick"], ZV = { class: "fe-guide__code" }, QV = {
  key: 2,
  class: "fe-guide__warn"
}, ej = {
  key: 3,
  class: "fe-guide__note"
}, tj = {
  key: 4,
  class: "fe-guide__text"
}, nj = {
  key: 1,
  class: "fe-guide__notes"
}, aj = { class: "fe-guide__notestitle" }, ij = /* @__PURE__ */ lt({
  __name: "ConnectionGuideView",
  props: {
    guide: {},
    locale: {}
  },
  setup(e) {
    var v;
    const t = e, { t: n } = yt(() => t.locale), a = $(((v = t.guide.clients[0]) == null ? void 0 : v.id) ?? ""), i = $(null);
    let r = null;
    const l = E(
      () => t.guide.clients.find((b) => b.id === a.value) ?? t.guide.clients[0]
    );
    async function d(b, _) {
      let w = !1;
      try {
        await navigator.clipboard.writeText(b), w = !0;
      } catch {
        try {
          const k = document.createElement("textarea");
          k.value = b, k.setAttribute("readonly", ""), k.style.position = "fixed", k.style.opacity = "0", document.body.appendChild(k), k.select(), w = document.execCommand("copy"), document.body.removeChild(k);
        } catch {
          w = !1;
        }
      }
      i.value = w ? _ : null, r && clearTimeout(r), r = setTimeout(() => {
        i.value = null;
      }, 1600);
    }
    function f(b, _) {
      return `${b}-${_}`;
    }
    function m(b) {
      return b.kind === "code";
    }
    return (b, _) => (p(), h("div", NV, [
      c("p", IV, y(e.guide.summary), 1),
      c("section", BV, [
        (p(!0), h(Ce, null, ot(e.guide.facts, (w, k) => (p(), h("div", {
          key: w.label,
          class: "fe-guide__fact"
        }, [
          c("span", FV, y(w.label), 1),
          c("span", UV, [
            c("code", {
              class: Fe({ "fe-guide__ph": w.placeholderOnly })
            }, y(w.value), 3),
            w.placeholderOnly ? D("", !0) : (p(), h("button", {
              key: 0,
              type: "button",
              class: "fe-guide__copy",
              "data-testid": `copy-fact-${k}`,
              onClick: (x) => d(w.value, f("fact", k))
            }, y(i.value === f("fact", k) ? u(n)("conn.guide.copied") : u(n)("conn.guide.copy")), 9, HV))
          ]),
          w.hint ? (p(), h("span", KV, y(w.hint), 1)) : D("", !0)
        ]))), 128))
      ]),
      c("nav", VV, [
        (p(!0), h(Ce, null, ot(e.guide.clients, (w) => (p(), h("button", {
          key: w.id,
          type: "button",
          role: "tab",
          class: Fe(["fe-guide__tab", { "is-active": l.value && w.id === l.value.id }]),
          "aria-selected": l.value && w.id === l.value.id,
          "data-testid": `guide-tab-${w.id}`,
          onClick: (k) => a.value = w.id
        }, y(w.name), 11, jV))), 128))
      ]),
      l.value ? (p(), h("div", qV, [
        (p(!0), h(Ce, null, ot(l.value.blocks, (w, k) => (p(), h(Ce, { key: k }, [
          w.kind === "steps" ? (p(), h("ol", WV, [
            (p(!0), h(Ce, null, ot(w.steps ?? [], (x, M) => (p(), h("li", { key: M }, y(x), 1))), 128))
          ])) : m(w) ? (p(), h("div", YV, [
            c("div", GV, [
              c("span", XV, y(w.caption), 1),
              c("button", {
                type: "button",
                class: "fe-guide__copy",
                "data-testid": `copy-code-${k}`,
                onClick: (x) => d(w.code ?? "", f(l.value.id, k))
              }, y(i.value === f(l.value.id, k) ? u(n)("conn.guide.copied") : u(n)("conn.guide.copy")), 9, JV)
            ]),
            c("pre", ZV, [
              c("code", null, y(w.code), 1)
            ])
          ])) : w.kind === "warn" ? (p(), h("p", QV, y(w.text), 1)) : w.kind === "note" ? (p(), h("p", ej, y(w.text), 1)) : (p(), h("p", tj, y(w.text), 1))
        ], 64))), 128))
      ])) : D("", !0),
      e.guide.notes.length ? (p(), h("section", nj, [
        c("h4", aj, y(u(n)("conn.guide.goodToKnow")), 1),
        (p(!0), h(Ce, null, ot(e.guide.notes, (w, k) => (p(), h("p", {
          key: k,
          class: Fe(w.kind === "warn" ? "fe-guide__warn" : "fe-guide__note")
        }, y(w.text), 3))), 128))
      ])) : D("", !0)
    ]));
  }
});
function oj(e) {
  const t = _l(e), n = _a(e), a = (z) => `${n}${z}`, i = xa([]), r = $(null), l = $(!1), d = $(!1), f = $(null), m = $(null), v = $(null), b = $(null);
  function _(z) {
    return m.value = (z == null ? void 0 : z.hint) ?? null, Er(z, e.locale);
  }
  function w(z) {
    return z == null ? void 0 : z.status;
  }
  async function k() {
    l.value = !0, f.value = null, m.value = null;
    try {
      const z = await t.jsonFetch(
        a("/api/auth/s3-keys")
      );
      i.value = Array.isArray(z == null ? void 0 : z.keys) ? z.keys : [], r.value = {
        endpoint: (z == null ? void 0 : z.endpoint) ?? "",
        enabled: (z == null ? void 0 : z.enabled) !== !1,
        path_style: (z == null ? void 0 : z.path_style) !== !1
      }, v.value = !0;
    } catch (z) {
      i.value = [];
      const L = w(z);
      L === 401 || L === 403 ? v.value = !1 : (v.value = !1, f.value = _(z));
    } finally {
      l.value = !1, d.value = !0;
    }
  }
  async function x(z) {
    f.value = null, m.value = null;
    try {
      const L = await t.jsonFetch(a("/api/auth/s3-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(z)
      });
      return b.value = L, L != null && L.endpoint && (r.value = {
        endpoint: L.endpoint,
        enabled: L.enabled !== !1,
        path_style: L.path_style !== !1
      }), await k(), L;
    } catch (L) {
      return f.value = _(L), null;
    }
  }
  async function M(z, L) {
    f.value = null, m.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/s3-keys/${z}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: L })
      }), await k();
    } catch (B) {
      f.value = _(B);
    }
  }
  async function A(z) {
    var L, B;
    f.value = null, m.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/s3-keys/${z}`), { method: "DELETE" }), ((B = (L = b.value) == null ? void 0 : L.key) == null ? void 0 : B.id) === z && (b.value = null), await k();
    } catch (O) {
      f.value = _(O);
    }
  }
  function T() {
    b.value = null;
  }
  const N = E(() => {
    var L;
    if ((L = b.value) != null && L.key) return b.value.key;
    const z = i.value.filter((B) => !B.disabled_at);
    return z.length ? z.reduce((B, O) => B.created_at >= O.created_at ? B : O) : null;
  });
  return {
    keys: i,
    connection: r,
    loading: l,
    loaded: d,
    error: f,
    errorHint: m,
    canMint: v,
    revealed: b,
    guideKey: N,
    load: k,
    create: x,
    setDisabled: M,
    remove: A,
    dismissSecret: T
  };
}
const rj = {
  class: "fe-s3keys",
  "data-testid": "s3-keys"
}, sj = { class: "fe-s3keys__head" }, lj = { class: "fe-s3keys__title" }, uj = { class: "fe-s3keys__lead" }, cj = {
  key: 0,
  class: "fe-s3keys__warn"
}, dj = {
  key: 1,
  class: "fe-s3keys__muted"
}, fj = {
  key: 2,
  class: "fe-s3keys__warn"
}, pj = {
  key: 3,
  class: "fe-s3keys__hint",
  "data-testid": "s3keys-admin-hint"
}, hj = {
  key: 4,
  class: "fe-s3keys__form"
}, mj = ["placeholder"], vj = ["placeholder", "disabled"], yj = ["disabled"], gj = {
  key: 5,
  class: "fe-s3keys__hint"
}, bj = {
  key: 6,
  class: "fe-s3keys__secret",
  "data-testid": "s3-key-secret"
}, kj = { class: "fe-s3keys__once" }, wj = { class: "fe-s3keys__pair" }, _j = { class: "fe-s3keys__k" }, xj = { class: "fe-s3keys__pair" }, Sj = { class: "fe-s3keys__k" }, $j = {
  key: 7,
  class: "fe-s3keys__muted"
}, Tj = { class: "tbl-mono" }, Aj = /* @__PURE__ */ lt({
  __name: "S3KeysPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Sa(n.config.locale)), { t: r, formatDate: l } = yt(i), {
      keys: d,
      connection: f,
      loading: m,
      error: v,
      errorHint: b,
      canMint: _,
      revealed: w,
      guideKey: k,
      load: x,
      create: M,
      setDisabled: A,
      remove: T,
      dismissSecret: N
    } = oj(n.config), z = $(""), L = $(""), B = E(() => [
      { value: "", label: r("conn.s3keys.everyBucket") },
      ...n.storages.map((ne) => ({ value: ne, label: ne }))
    ]), O = $(""), U = $(!1), S = $(null), F = $(null);
    let I = null;
    function G() {
      var K, ce, J, H, X;
      const ne = f.value;
      ne && a("active", {
        accessKeyID: ((K = k.value) == null ? void 0 : K.access_key_id) ?? "",
        // Only the freshly minted one. Re-emitting a stale secret would put a
        // dead credential into the commands.
        secret: ((J = (ce = w.value) == null ? void 0 : ce.key) == null ? void 0 : J.id) === ((H = k.value) == null ? void 0 : H.id) ? (X = w.value) == null ? void 0 : X.secret : void 0,
        endpoint: ne.endpoint,
        pathStyle: ne.path_style
      });
    }
    Wt(async () => {
      await x(), G();
    });
    async function Y() {
      U.value = !0;
      try {
        await M({
          label: z.value.trim() || r("conn.s3keys.defaultLabel"),
          bucket: L.value.trim() || void 0,
          prefix: O.value.trim() || void 0
        }), z.value = "", G();
      } finally {
        U.value = !1;
      }
    }
    function ie(ne) {
      return [
        {
          key: "toggle",
          label: ne.disabled_at ? r("conn.s3keys.enable") : r("conn.s3keys.disable"),
          icon: ne.disabled_at ? "check" : "lock",
          disabled: U.value
        },
        {
          key: "revoke",
          label: S.value === ne.id ? r("conn.s3keys.confirm") : r("conn.s3keys.revoke"),
          icon: "delete",
          danger: !0,
          disabled: U.value
        }
      ];
    }
    const me = E(() => [
      {
        id: "label",
        label: r("conn.s3keys.col.label"),
        sortable: !0,
        width: 180,
        format: (ne) => ne.label || r("conn.s3keys.noLabel")
      },
      {
        id: "key",
        label: r("conn.s3keys.col.key"),
        sortable: !0,
        width: 200,
        sortValue: (ne) => ne.access_key_id,
        title: (ne) => ne.access_key_id
      },
      { id: "scope", label: r("conn.s3keys.col.scope"), sortable: !0, width: 160, format: W },
      {
        id: "lastUsed",
        label: r("conn.s3keys.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (ne) => ne.last_used_at ? V(ne.last_used_at) : r("conn.s3keys.neverUsed"),
        sortValue: (ne) => ne.last_used_at ? new Date(ne.last_used_at).getTime() : null
      }
    ]);
    function q(ne, K) {
      ne === "toggle" ? C(K) : ne === "revoke" && re(K);
    }
    async function C(ne) {
      U.value = !0;
      try {
        await A(ne.id, !ne.disabled_at), G();
      } finally {
        U.value = !1;
      }
    }
    async function re(ne) {
      if (S.value !== ne.id) {
        S.value = ne.id;
        return;
      }
      S.value = null, U.value = !0;
      try {
        await T(ne.id), G();
      } finally {
        U.value = !1;
      }
    }
    async function de(ne, K) {
      let ce = !1;
      try {
        await navigator.clipboard.writeText(ne), ce = !0;
      } catch {
        try {
          const J = document.createElement("textarea");
          J.value = ne, J.setAttribute("readonly", ""), J.style.position = "fixed", J.style.opacity = "0", document.body.appendChild(J), J.select(), ce = document.execCommand("copy"), document.body.removeChild(J);
        } catch {
          ce = !1;
        }
      }
      ce && (F.value = K, I && clearTimeout(I), I = setTimeout(() => F.value = null, 1600));
    }
    function V(ne) {
      const K = new Date(ne ?? "").getTime();
      return Number.isNaN(K) ? "" : l(K);
    }
    function W(ne) {
      return ne.bucket ? ne.prefix ? `${ne.bucket}/${ne.prefix}` : ne.bucket : r("conn.s3keys.scopeAll");
    }
    return (ne, K) => (p(), h("section", rj, [
      c("header", sj, [
        c("h4", lj, y(u(r)("conn.s3keys.title")), 1),
        c("p", uj, y(u(r)("conn.s3keys.lead")), 1)
      ]),
      u(f) && !u(f).enabled ? (p(), h("p", cj, y(u(r)("conn.s3keys.disabled")), 1)) : D("", !0),
      u(_) === !1 ? (p(), h("p", dj, y(u(r)("conn.s3keys.cannotMint")), 1)) : D("", !0),
      u(v) ? (p(), h("p", fj, y(u(v)), 1)) : D("", !0),
      u(v) && u(b) ? (p(), h("p", pj, y(u(b)), 1)) : D("", !0),
      u(_) ? (p(), h("div", hj, [
        un(c("input", {
          "onUpdate:modelValue": K[0] || (K[0] = (ce) => z.value = ce),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.s3keys.label"),
          "data-testid": "s3-key-label"
        }, null, 8, mj), [
          [bn, z.value]
        ]),
        tt(nc, {
          "model-value": L.value,
          options: B.value,
          "aria-label": u(r)("conn.s3keys.col.scope"),
          testid: "s3-key-bucket",
          "onUpdate:modelValue": K[1] || (K[1] = (ce) => L.value = String(ce))
        }, null, 8, ["model-value", "options", "aria-label"]),
        un(c("input", {
          "onUpdate:modelValue": K[2] || (K[2] = (ce) => O.value = ce),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.s3keys.prefix"),
          disabled: !L.value,
          "data-testid": "s3-key-prefix"
        }, null, 8, vj), [
          [bn, O.value]
        ]),
        c("button", {
          class: "fe-s3keys__btn",
          disabled: U.value,
          "data-testid": "s3-key-mint",
          onClick: Y
        }, y(u(r)("conn.s3keys.mint")), 9, yj)
      ])) : D("", !0),
      u(_) ? (p(), h("p", gj, y(u(r)("conn.s3keys.inheritNote")), 1)) : D("", !0),
      u(w) ? (p(), h("div", bj, [
        c("p", kj, y(u(r)("conn.s3keys.once")), 1),
        c("div", wj, [
          c("span", _j, y(u(r)("conn.s3keys.accessKeyID")), 1),
          c("code", null, y(u(w).key.access_key_id), 1),
          c("button", {
            class: "fe-s3keys__copy",
            onClick: K[3] || (K[3] = (ce) => de(u(w).key.access_key_id, "akid"))
          }, y(F.value === "akid" ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        c("div", xj, [
          c("span", Sj, y(u(r)("conn.s3keys.secret")), 1),
          c("code", null, y(u(w).secret), 1),
          c("button", {
            class: "fe-s3keys__copy",
            onClick: K[4] || (K[4] = (ce) => de(u(w).secret, "secret"))
          }, y(F.value === "secret" ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        c("button", {
          class: "fe-s3keys__dismiss",
          onClick: K[5] || (K[5] = //@ts-ignore
          (...ce) => u(N) && u(N)(...ce))
        }, y(u(r)("conn.s3keys.dismiss")), 1)
      ])) : D("", !0),
      u(m) ? (p(), h("p", $j, "…")) : (p(), Je(Vr, {
        key: 8,
        "table-id": "conn.s3keys",
        columns: me.value,
        rows: u(d),
        "row-key": "id",
        locale: i.value,
        empty: u(r)("conn.s3keys.empty"),
        "row-class": (ce) => ce.disabled_at ? "is-muted" : void 0,
        "row-actions": ie,
        "row-actions-test-id": (ce) => `s3-key-actions-${ce.id}`,
        onRowAction: K[6] || (K[6] = (ce, J) => q(ce, J))
      }, {
        "cell-key": gt(({ row: ce }) => [
          c("code", Tj, y(ce.access_key_id), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ]));
  }
});
function Ej(e) {
  const t = _l(e), n = _a(e), a = (A) => `${n}${A}`, i = xa([]), r = $(null), l = $(!1), d = $(!1), f = $(null), m = $(null);
  function v(A) {
    return Er(A, e.locale);
  }
  function b(A) {
    return A == null ? void 0 : A.status;
  }
  async function _() {
    l.value = !0, f.value = null;
    try {
      const A = await t.jsonFetch(
        a("/api/auth/ssh-keys")
      );
      i.value = Array.isArray(A == null ? void 0 : A.keys) ? A.keys : [], r.value = {
        enabled: (A == null ? void 0 : A.enabled) !== !1,
        host: (A == null ? void 0 : A.host) ?? "",
        port: (A == null ? void 0 : A.port) ?? 2022,
        login: (A == null ? void 0 : A.login) ?? "",
        ftps: A == null ? void 0 : A.ftps
      }, m.value = !0;
    } catch (A) {
      i.value = [], m.value = !1, b(A) !== 401 && b(A) !== 403 && (f.value = v(A));
    } finally {
      l.value = !1, d.value = !0;
    }
  }
  async function w(A, T) {
    f.value = null;
    try {
      return await t.jsonFetch(a("/api/auth/ssh-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key: A, name: T })
      }), await _(), !0;
    } catch (N) {
      return f.value = v(N), !1;
    }
  }
  async function k(A, T) {
    f.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/ssh-keys/${A}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: T })
      }), await _();
    } catch (N) {
      f.value = v(N);
    }
  }
  async function x(A) {
    f.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/ssh-keys/${A}`), { method: "DELETE" }), await _();
    } catch (T) {
      f.value = v(T);
    }
  }
  const M = E(() => i.value.some((A) => !A.disabled_at));
  return { keys: i, connection: r, loading: l, loaded: d, error: f, canAdd: m, hasUsableKey: M, load: _, add: w, setDisabled: k, remove: x };
}
const Cj = {
  key: 0,
  class: "fe-s3keys",
  "data-testid": "ssh-keys"
}, zj = { class: "fe-s3keys__head" }, Mj = { class: "fe-s3keys__title" }, Pj = { class: "fe-s3keys__lead" }, Oj = {
  key: 0,
  class: "fe-s3keys__warn"
}, Dj = {
  key: 1,
  class: "fe-s3keys__muted"
}, Lj = {
  key: 2,
  class: "fe-s3keys__warn"
}, Rj = {
  key: 3,
  class: "fe-sshkeys__form"
}, Nj = ["placeholder"], Ij = { class: "fe-sshkeys__row" }, Bj = ["placeholder"], Fj = ["disabled"], Uj = { class: "fe-s3keys__hint" }, Hj = {
  key: 4,
  class: "fe-s3keys__muted"
}, Kj = { class: "tbl-mono" }, Vj = /* @__PURE__ */ lt({
  __name: "SSHKeysPanel",
  props: {
    config: {},
    keysVisible: { type: Boolean }
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = E(() => n.keysVisible !== !1), i = t, r = E(() => Sa(n.config.locale)), { t: l, formatDate: d } = yt(r), { keys: f, connection: m, loading: v, error: b, canAdd: _, hasUsableKey: w, load: k, add: x, setDisabled: M, remove: A } = Ej(n.config), T = $(""), N = $(""), z = $(!1), L = $(null);
    function B() {
      const me = m.value;
      me && i("active", {
        host: me.host,
        port: me.port,
        login: me.login,
        enabled: me.enabled,
        hasKey: w.value,
        // The FTPS endpoint travels with the SSH facts: for the user this is one
        // question ("how do I reach this from a program?"), and two calls to
        // answer it would be two chances to disagree.
        ftps: me.ftps
      });
    }
    Wt(async () => {
      await k(), B();
    });
    async function O() {
      if (T.value.trim()) {
        z.value = !0;
        try {
          await x(T.value.trim(), N.value.trim() || void 0) && (T.value = "", N.value = ""), B();
        } finally {
          z.value = !1;
        }
      }
    }
    function U(me) {
      return [
        {
          key: "toggle",
          label: me.disabled_at ? l("conn.sshkeys.enable") : l("conn.sshkeys.disable"),
          icon: me.disabled_at ? "check" : "lock",
          disabled: z.value
        },
        {
          key: "remove",
          label: L.value === me.id ? l("conn.sshkeys.confirm") : l("conn.sshkeys.remove"),
          icon: "delete",
          danger: !0,
          disabled: z.value
        }
      ];
    }
    const S = E(() => [
      {
        id: "name",
        label: l("conn.sshkeys.col.name"),
        sortable: !0,
        width: 180,
        format: (me) => me.name || l("conn.sshkeys.noName")
      },
      {
        id: "fingerprint",
        label: l("conn.sshkeys.col.fingerprint"),
        sortable: !0,
        width: 240,
        sortValue: (me) => ie(me),
        title: (me) => ie(me)
      },
      {
        id: "lastUsed",
        label: l("conn.sshkeys.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (me) => me.last_used_at ? Y(me.last_used_at) : l("conn.sshkeys.neverUsed"),
        sortValue: (me) => me.last_used_at ? new Date(me.last_used_at).getTime() : null
      }
    ]);
    function F(me, q) {
      me === "toggle" ? I(q) : me === "remove" && G(q);
    }
    async function I(me) {
      z.value = !0;
      try {
        await M(me.id, !me.disabled_at), B();
      } finally {
        z.value = !1;
      }
    }
    async function G(me) {
      if (L.value !== me.id) {
        L.value = me.id;
        return;
      }
      L.value = null, z.value = !0;
      try {
        await A(me.id), B();
      } finally {
        z.value = !1;
      }
    }
    function Y(me) {
      const q = new Date(me ?? "").getTime();
      return Number.isNaN(q) ? "" : d(q);
    }
    function ie(me) {
      return "SHA256:" + me.fingerprint;
    }
    return (me, q) => a.value ? (p(), h("section", Cj, [
      c("header", zj, [
        c("h4", Mj, y(u(l)("conn.sshkeys.title")), 1),
        c("p", Pj, y(u(l)("conn.sshkeys.lead")), 1)
      ]),
      u(m) && !u(m).enabled ? (p(), h("p", Oj, y(u(l)("conn.sshkeys.disabled")), 1)) : D("", !0),
      u(_) === !1 ? (p(), h("p", Dj, y(u(l)("conn.sshkeys.cannotAdd")), 1)) : D("", !0),
      u(b) ? (p(), h("p", Lj, y(u(b)), 1)) : D("", !0),
      u(_) ? (p(), h("div", Rj, [
        un(c("textarea", {
          "onUpdate:modelValue": q[0] || (q[0] = (C) => T.value = C),
          class: "fe-cfield__input fe-sshkeys__paste",
          rows: "2",
          spellcheck: "false",
          placeholder: u(l)("conn.sshkeys.paste"),
          "data-testid": "ssh-key-input"
        }, null, 8, Nj), [
          [bn, T.value]
        ]),
        c("div", Ij, [
          un(c("input", {
            "onUpdate:modelValue": q[1] || (q[1] = (C) => N.value = C),
            class: "fe-cfield__input",
            placeholder: u(l)("conn.sshkeys.name"),
            "data-testid": "ssh-key-name"
          }, null, 8, Bj), [
            [bn, N.value]
          ]),
          c("button", {
            class: "fe-s3keys__btn",
            disabled: z.value,
            "data-testid": "ssh-key-add",
            onClick: O
          }, y(u(l)("conn.sshkeys.add")), 9, Fj)
        ]),
        c("p", Uj, y(u(l)("conn.sshkeys.noCopyId")), 1)
      ])) : D("", !0),
      u(v) ? (p(), h("p", Hj, "…")) : (p(), Je(Vr, {
        key: 5,
        "table-id": "conn.sshkeys",
        columns: S.value,
        rows: u(f),
        "row-key": "id",
        locale: r.value,
        empty: u(l)("conn.sshkeys.empty"),
        "row-class": (C) => C.disabled_at ? "is-muted" : void 0,
        "row-actions": U,
        "row-actions-test-id": (C) => `ssh-key-actions-${C.id}`,
        onRowAction: q[2] || (q[2] = (C, re) => F(C, re))
      }, {
        "cell-fingerprint": gt(({ row: C }) => [
          c("code", Kj, y(ie(C)), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ])) : D("", !0);
  }
});
function jj(e) {
  const t = _l(e), n = _a(e), a = (N) => `${n}${N}`, i = xa([]), r = $(null), l = $(!1), d = $(!1), f = $(null), m = $(null), v = $(null);
  function b(N) {
    return Er(N, e.locale);
  }
  function _(N) {
    return N == null ? void 0 : N.status;
  }
  async function w() {
    l.value = !0, f.value = null;
    try {
      const N = await t.jsonFetch(
        a("/api/auth/nfs-exports")
      );
      i.value = Array.isArray(N == null ? void 0 : N.exports) ? N.exports : [], r.value = {
        enabled: (N == null ? void 0 : N.enabled) !== !1,
        host: (N == null ? void 0 : N.host) ?? "",
        port: (N == null ? void 0 : N.port) ?? 2049
      }, m.value = !0;
    } catch (N) {
      i.value = [], m.value = !1, _(N) !== 401 && _(N) !== 403 && (f.value = b(N));
    } finally {
      l.value = !1, d.value = !0;
    }
  }
  async function k(N) {
    f.value = null;
    try {
      const z = await t.jsonFetch(a("/api/auth/nfs-exports"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(N)
      });
      return v.value = z, z != null && z.host && (r.value = { enabled: z.enabled !== !1, host: z.host, port: z.port }), await w(), z;
    } catch (z) {
      return f.value = b(z), null;
    }
  }
  async function x(N, z) {
    f.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/nfs-exports/${N}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: z })
      }), await w();
    } catch (L) {
      f.value = b(L);
    }
  }
  async function M(N) {
    var z, L;
    f.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/nfs-exports/${N}`), { method: "DELETE" }), ((L = (z = v.value) == null ? void 0 : z.export) == null ? void 0 : L.id) === N && (v.value = null), await w();
    } catch (B) {
      f.value = b(B);
    }
  }
  function A() {
    v.value = null;
  }
  const T = E(() => {
    var z;
    if ((z = v.value) != null && z.export) return v.value.export;
    const N = i.value.filter((L) => !L.disabled_at);
    return N.length ? N.reduce((L, B) => L.created_at >= B.created_at ? L : B) : null;
  });
  return {
    exports: i,
    connection: r,
    loading: l,
    loaded: d,
    error: f,
    canMint: m,
    revealed: v,
    guideExport: T,
    load: w,
    create: k,
    setDisabled: x,
    remove: M,
    dismissPath: A
  };
}
const qj = {
  class: "fe-s3keys",
  "data-testid": "nfs-exports"
}, Wj = { class: "fe-s3keys__head" }, Yj = { class: "fe-s3keys__title" }, Gj = { class: "fe-s3keys__lead" }, Xj = { class: "fe-s3keys__warn" }, Jj = {
  key: 0,
  class: "fe-s3keys__warn"
}, Zj = {
  key: 1,
  class: "fe-s3keys__muted"
}, Qj = {
  key: 2,
  class: "fe-s3keys__warn"
}, eq = {
  key: 3,
  class: "fe-s3keys__form fe-nfs__form"
}, tq = ["placeholder"], nq = ["placeholder", "disabled"], aq = ["placeholder"], iq = { class: "fe-nfs__ro" }, oq = ["disabled"], rq = {
  key: 4,
  class: "fe-s3keys__hint"
}, sq = {
  key: 5,
  class: "fe-s3keys__secret",
  "data-testid": "nfs-path"
}, lq = { class: "fe-s3keys__once" }, uq = { class: "fe-s3keys__pair" }, cq = {
  key: 6,
  class: "fe-s3keys__muted"
}, dq = /* @__PURE__ */ lt({
  __name: "NFSExportsPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Sa(n.config.locale)), { t: r, formatDate: l } = yt(i), {
      exports: d,
      connection: f,
      loading: m,
      error: v,
      canMint: b,
      revealed: _,
      guideExport: w,
      load: k,
      create: x,
      setDisabled: M,
      remove: A,
      dismissPath: T
    } = jj(n.config), N = $(""), z = $(""), L = E(() => [
      { value: "", label: r("conn.nfs.everyStorage") },
      ...n.storages.map((ce) => ({ value: ce, label: ce }))
    ]), B = $(""), O = $(!0), U = $(""), S = $(!1), F = $(null), I = $(!1);
    let G = null;
    function Y() {
      var J, H;
      const ce = f.value;
      ce && a("active", {
        host: ce.host,
        port: ce.port,
        enabled: ce.enabled,
        // Only the freshly minted path — the stored ones cannot be recovered, and
        // printing a placeholder in a mount line somebody copies would produce a
        // command that fails with no clue why.
        path: (J = _.value) == null ? void 0 : J.path,
        readOnly: ((H = w.value) == null ? void 0 : H.read_only) ?? O.value
      });
    }
    Wt(async () => {
      await k(), Y();
    });
    async function ie() {
      S.value = !0;
      try {
        await x({
          label: N.value.trim() || r("conn.nfs.defaultLabel"),
          storage: z.value.trim() || void 0,
          prefix: B.value.trim() || void 0,
          read_only: O.value,
          allow_cidrs: U.value.trim() || void 0
        }), N.value = "", Y();
      } finally {
        S.value = !1;
      }
    }
    function me(ce) {
      return [
        {
          key: "toggle",
          label: ce.disabled_at ? r("conn.nfs.enable") : r("conn.nfs.disable"),
          icon: ce.disabled_at ? "check" : "lock",
          disabled: S.value
        },
        {
          key: "revoke",
          label: F.value === ce.id ? r("conn.nfs.confirm") : r("conn.nfs.revoke"),
          icon: "delete",
          danger: !0,
          disabled: S.value
        }
      ];
    }
    const q = E(() => [
      {
        id: "label",
        label: r("conn.nfs.col.label"),
        sortable: !0,
        width: 180,
        format: (ce) => ce.label || r("conn.nfs.noLabel")
      },
      { id: "scope", label: r("conn.nfs.col.scope"), sortable: !0, width: 180, format: K },
      {
        id: "mode",
        label: r("conn.nfs.col.mode"),
        sortable: !0,
        width: 120,
        format: (ce) => ce.read_only ? r("conn.nfs.modeRead") : r("conn.nfs.modeWrite")
      },
      {
        id: "lastUsed",
        label: r("conn.nfs.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (ce) => ce.last_used_at ? ne(ce.last_used_at) : r("conn.nfs.neverUsed"),
        sortValue: (ce) => ce.last_used_at ? new Date(ce.last_used_at).getTime() : null
      }
    ]);
    function C(ce, J) {
      ce === "toggle" ? re(J) : ce === "revoke" && de(J);
    }
    async function re(ce) {
      S.value = !0;
      try {
        await M(ce.id, !ce.disabled_at), Y();
      } finally {
        S.value = !1;
      }
    }
    async function de(ce) {
      if (F.value !== ce.id) {
        F.value = ce.id;
        return;
      }
      F.value = null, S.value = !0;
      try {
        await A(ce.id), Y();
      } finally {
        S.value = !1;
      }
    }
    const V = E(() => {
      var X, we, it;
      const ce = f.value, J = (X = _.value) == null ? void 0 : X.path;
      if (!ce || !J) return "";
      const H = (it = (we = _.value) == null ? void 0 : we.export) != null && it.read_only ? ",ro" : "";
      return `sudo mount -t nfs -o nfsvers=3,tcp,port=${ce.port},mountport=${ce.port},nolock${H} ${ce.host}:${J} /mnt/filex`;
    });
    async function W() {
      const ce = V.value;
      if (!ce) return;
      let J = !1;
      try {
        await navigator.clipboard.writeText(ce), J = !0;
      } catch {
        try {
          const H = document.createElement("textarea");
          H.value = ce, H.setAttribute("readonly", ""), H.style.position = "fixed", H.style.opacity = "0", document.body.appendChild(H), H.select(), J = document.execCommand("copy"), document.body.removeChild(H);
        } catch {
          J = !1;
        }
      }
      J && (I.value = !0, G && clearTimeout(G), G = setTimeout(() => I.value = !1, 1600));
    }
    function ne(ce) {
      const J = new Date(ce ?? "").getTime();
      return Number.isNaN(J) ? "" : l(J);
    }
    function K(ce) {
      return ce.storage_name ? ce.prefix ? `${ce.storage_name}/${ce.prefix}` : ce.storage_name : r("conn.nfs.scopeAll");
    }
    return (ce, J) => (p(), h("section", qj, [
      c("header", Wj, [
        c("h4", Yj, y(u(r)("conn.nfs.title")), 1),
        c("p", Gj, y(u(r)("conn.nfs.lead")), 1)
      ]),
      c("p", Xj, y(u(r)("conn.nfs.pathIsSecret")), 1),
      u(f) && !u(f).enabled ? (p(), h("p", Jj, y(u(r)("conn.nfs.disabled")), 1)) : D("", !0),
      u(b) === !1 ? (p(), h("p", Zj, y(u(r)("conn.nfs.cannotMint")), 1)) : D("", !0),
      u(v) ? (p(), h("p", Qj, y(u(v)), 1)) : D("", !0),
      u(b) ? (p(), h("div", eq, [
        un(c("input", {
          "onUpdate:modelValue": J[0] || (J[0] = (H) => N.value = H),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.nfs.label"),
          "data-testid": "nfs-label"
        }, null, 8, tq), [
          [bn, N.value]
        ]),
        tt(nc, {
          "model-value": z.value,
          options: L.value,
          "aria-label": u(r)("conn.nfs.col.scope"),
          testid: "nfs-storage",
          "onUpdate:modelValue": J[1] || (J[1] = (H) => z.value = String(H))
        }, null, 8, ["model-value", "options", "aria-label"]),
        un(c("input", {
          "onUpdate:modelValue": J[2] || (J[2] = (H) => B.value = H),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.nfs.prefix"),
          disabled: !z.value,
          "data-testid": "nfs-prefix"
        }, null, 8, nq), [
          [bn, B.value]
        ]),
        un(c("input", {
          "onUpdate:modelValue": J[3] || (J[3] = (H) => U.value = H),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.nfs.allowCidrs"),
          "data-testid": "nfs-cidrs"
        }, null, 8, aq), [
          [bn, U.value]
        ]),
        c("label", iq, [
          un(c("input", {
            type: "checkbox",
            "onUpdate:modelValue": J[4] || (J[4] = (H) => O.value = H),
            "data-testid": "nfs-readonly"
          }, null, 512), [
            [tp, O.value]
          ]),
          Ht(" " + y(u(r)("conn.nfs.readOnly")), 1)
        ]),
        c("button", {
          class: "fe-s3keys__btn",
          disabled: S.value,
          "data-testid": "nfs-mint",
          onClick: ie
        }, y(u(r)("conn.nfs.mint")), 9, oq)
      ])) : D("", !0),
      u(b) ? (p(), h("p", rq, y(u(r)("conn.nfs.readOnlyHint")), 1)) : D("", !0),
      u(_) ? (p(), h("div", sq, [
        c("p", lq, y(u(r)("conn.nfs.once")), 1),
        c("div", uq, [
          c("code", null, y(V.value), 1),
          c("button", {
            class: "fe-s3keys__copy",
            onClick: W
          }, y(I.value ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        c("button", {
          class: "fe-s3keys__dismiss",
          onClick: J[5] || (J[5] = //@ts-ignore
          (...H) => u(T) && u(T)(...H))
        }, y(u(r)("conn.nfs.dismiss")), 1)
      ])) : D("", !0),
      u(m) ? (p(), h("p", cq, "…")) : (p(), Je(Vr, {
        key: 7,
        "table-id": "conn.nfs",
        columns: q.value,
        rows: u(d),
        "row-key": "id",
        locale: i.value,
        empty: u(r)("conn.nfs.empty"),
        "row-class": (H) => H.disabled_at ? "is-muted" : void 0,
        "row-actions": me,
        "row-actions-test-id": (H) => `nfs-export-actions-${H.id}`,
        onRowAction: J[6] || (J[6] = (H, X) => C(H, X))
      }, null, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ]));
  }
});
function fq(e) {
  const t = _l(e), n = _a(e), a = (A) => `${n}${A}`, i = xa([]), r = $(!1), l = $(!1), d = $(null), f = $(null), m = $(null);
  function v(A) {
    return Er(A, e.locale);
  }
  function b(A) {
    return A == null ? void 0 : A.status;
  }
  async function _() {
    r.value = !0, d.value = null;
    try {
      const A = await t.jsonFetch(a("/api/tokens"));
      i.value = Array.isArray(A == null ? void 0 : A.tokens) ? A.tokens : [], f.value = !0;
    } catch (A) {
      i.value = [];
      const T = b(A);
      f.value = !1, T !== 401 && T !== 403 && (d.value = v(A));
    } finally {
      r.value = !1, l.value = !0;
    }
  }
  async function w(A) {
    d.value = null;
    try {
      const T = await t.jsonFetch(a("/api/tokens"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(A)
      });
      return m.value = T, await _(), T;
    } catch (T) {
      return d.value = v(T), null;
    }
  }
  async function k(A) {
    var T, N;
    d.value = null;
    try {
      await t.jsonFetch(a(`/api/tokens/${A}`), { method: "DELETE" }), ((N = (T = m.value) == null ? void 0 : T.row) == null ? void 0 : N.id) === A && (m.value = null), await _();
    } catch (z) {
      d.value = v(z);
    }
  }
  async function x(A, T) {
    d.value = null;
    try {
      return await t.jsonFetch(a(`/api/tokens/${A}`), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ permissions: T })
      }), await _(), !0;
    } catch (N) {
      return d.value = v(N), !1;
    }
  }
  function M() {
    m.value = null;
  }
  return { tokens: i, loading: r, loaded: l, error: d, canMint: f, revealed: m, load: _, create: w, remove: k, setPermissions: x, dismiss: M };
}
const pq = {
  class: "fe-s3keys",
  "data-testid": "api-tokens"
}, hq = { class: "fe-s3keys__head" }, mq = { class: "fe-s3keys__title" }, vq = { class: "fe-s3keys__lead" }, yq = {
  key: 0,
  class: "fe-s3keys__muted"
}, gq = {
  key: 1,
  class: "fe-s3keys__warn"
}, bq = {
  key: 2,
  class: "fe-s3keys__form"
}, kq = ["placeholder"], wq = ["disabled"], _q = {
  key: 3,
  class: "fe-tokform",
  "data-testid": "token-form-full"
}, xq = ["placeholder"], Sq = { class: "fe-tokform__scopes" }, $q = { class: "fe-tokform__legend" }, Tq = ["onUpdate:modelValue", "data-testid"], Aq = {
  key: 0,
  class: "fe-s3keys__hint fe-tokform__required",
  role: "alert",
  "data-testid": "token-scopes-required"
}, Eq = { class: "fe-tokform__field" }, Cq = {
  id: "token-comments-label",
  class: "fe-tokform__label"
}, zq = { class: "fe-s3keys__hint" }, Mq = { class: "fe-tokform__field" }, Pq = { class: "fe-tokform__label" }, Oq = ["placeholder"], Dq = { class: "fe-tokform__row" }, Lq = { class: "fe-tokform__field fe-tokform__field--narrow" }, Rq = { class: "fe-tokform__label" }, Nq = ["placeholder"], Iq = ["disabled"], Bq = { class: "fe-s3keys__hint" }, Fq = {
  key: 4,
  class: "fe-s3keys__secret",
  "data-testid": "token-secret"
}, Uq = { class: "fe-s3keys__once" }, Hq = { class: "fe-s3keys__pair" }, Kq = {
  key: 5,
  class: "fe-s3keys__muted"
}, Vq = { class: "tbl-mono" }, jq = {
  key: 7,
  class: "fe-s3keys__hint"
}, c$ = /* @__PURE__ */ lt({
  __name: "TokensPanel",
  props: {
    config: {},
    full: { type: Boolean },
    protocol: {},
    host: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Sa(n.config.locale)), { t: r, formatDate: l } = yt(i), { tokens: d, loading: f, error: m, canMint: v, revealed: b, load: _, create: w, remove: k, setPermissions: x, dismiss: M } = fq(
      n.config
    ), A = $(""), T = $(!1), N = $(!1), z = $(null), L = ["read", "write", "delete", "mcp"], B = $({
      read: !0,
      write: !1,
      delete: !1,
      mcp: !1
    }), O = $(""), U = $(null), S = $("read"), F = E(() => [
      { value: "read", label: r("conn.tokens.commentsRead") },
      { value: "rw", label: r("conn.tokens.commentsRw") }
    ]);
    function I(J) {
      var H;
      return ((H = J.permissions) == null ? void 0 : H.comments) === "rw" ? r("conn.tokens.commentsRw") : r("conn.tokens.commentsRead");
    }
    const G = E(() => !L.some((J) => B.value[J]));
    function Y() {
      const J = L.filter((X) => B.value[X]), H = O.value.trim();
      return H && J.push("root:" + H), S.value === "rw" && J.push("comments:rw"), J.join(",");
    }
    Wt(async () => {
      await _(), a("active", { hasToken: d.value.length > 0 });
    });
    function ie() {
      const J = (n.protocol || "").toUpperCase();
      return J ? n.host ? `${J} - ${n.host}` : J : r("conn.tokens.defaultName", { date: (/* @__PURE__ */ new Date()).toISOString().slice(0, 10) });
    }
    function me() {
      return n.protocol ? ie() : r("conn.tokens.namePlaceholder");
    }
    async function q() {
      if (!T.value) {
        T.value = !0, N.value = !1;
        try {
          if (n.full) {
            if (G.value) return;
            const J = Y();
            await w({
              label: A.value.trim() || ie(),
              scopes: J,
              expires_in_days: U.value && U.value > 0 ? U.value : void 0
            }), await _(), a("active", { hasToken: d.value.length > 0 }), A.value = "", O.value = "", S.value = "read";
            return;
          }
          await w({ label: A.value.trim() || ie(), scopes: "read,write,delete" }), await _(), a("active", { hasToken: d.value.length > 0 }), A.value = "";
        } finally {
          T.value = !1;
        }
      }
    }
    const C = E(() => [
      {
        id: "label",
        label: r("conn.tokens.col.label"),
        sortable: !0,
        width: 200,
        format: (J) => J.label || "-"
      },
      { id: "scopes", label: r("conn.tokens.col.scopes"), sortable: !0, width: 200 },
      {
        id: "comments",
        label: r("conn.tokens.col.comments"),
        sortable: !0,
        width: 140,
        format: I
      },
      {
        id: "used",
        label: r("conn.tokens.col.used"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: ce,
        sortValue: (J) => J.last_used_at ? new Date(J.last_used_at).getTime() : null
      }
    ]);
    function re(J) {
      var X;
      const H = ((X = J.permissions) == null ? void 0 : X.comments) === "rw";
      return [
        {
          key: "comments",
          label: r(H ? "conn.tokens.commentsToRead" : "conn.tokens.commentsToRw"),
          icon: "rename",
          disabled: T.value
        },
        {
          key: "revoke",
          label: z.value === J.id ? r("conn.tokens.confirm") : r("conn.tokens.revoke"),
          icon: "delete",
          danger: !0,
          /* The whole control used to be `:disabled="busy"`; the table draws the
             control, so the verb carries it — RowActions greys a button with
             nothing usable behind it. */
          disabled: T.value
        }
      ];
    }
    function de(J, H) {
      J === "revoke" ? W(H) : J === "comments" && V(H);
    }
    async function V(J) {
      var H;
      T.value = !0;
      try {
        await x(J.id, { comments: ((H = J.permissions) == null ? void 0 : H.comments) === "rw" ? "read" : "rw" });
      } finally {
        T.value = !1;
      }
    }
    async function W(J) {
      if (z.value !== J.id) {
        z.value = J.id;
        return;
      }
      z.value = null, T.value = !0;
      try {
        await k(J.id), a("active", { hasToken: d.value.length > 0 });
      } finally {
        T.value = !1;
      }
    }
    async function ne() {
      var J;
      if ((J = b.value) != null && J.token)
        try {
          await navigator.clipboard.writeText(b.value.token), N.value = !0, window.setTimeout(() => N.value = !1, 1600);
        } catch {
        }
    }
    function K(J) {
      const H = new Date(J ?? "").getTime();
      return Number.isNaN(H) ? "" : l(H);
    }
    function ce(J) {
      return J.last_used_at ? K(J.last_used_at) : r("conn.tokens.neverUsed");
    }
    return (J, H) => (p(), h("section", pq, [
      c("header", hq, [
        c("h4", mq, y(u(r)("conn.tokens.title")), 1),
        c("p", vq, y(u(r)("conn.tokens.lead")), 1)
      ]),
      u(v) === !1 ? (p(), h("p", yq, y(u(r)("conn.tokens.cannotMint")), 1)) : D("", !0),
      u(m) ? (p(), h("p", gq, y(u(m)), 1)) : D("", !0),
      u(v) && !e.full ? (p(), h("div", bq, [
        un(c("input", {
          "onUpdate:modelValue": H[0] || (H[0] = (X) => A.value = X),
          class: "fe-cfield__input",
          placeholder: me(),
          "data-testid": "token-label"
        }, null, 8, kq), [
          [bn, A.value]
        ]),
        c("button", {
          class: "fe-s3keys__btn",
          disabled: T.value,
          "data-testid": "token-mint",
          onClick: q
        }, y(u(r)("conn.tokens.mint")), 9, wq)
      ])) : u(v) ? (p(), h("div", _q, [
        un(c("input", {
          "onUpdate:modelValue": H[1] || (H[1] = (X) => A.value = X),
          class: "fe-cfield__input",
          placeholder: me(),
          "data-testid": "token-label"
        }, null, 8, xq), [
          [bn, A.value]
        ]),
        c("fieldset", Sq, [
          c("legend", $q, y(u(r)("conn.tokens.scopes")), 1),
          (p(), h(Ce, null, ot(L, (X) => c("label", {
            key: X,
            class: "fe-tokform__scope"
          }, [
            un(c("input", {
              "onUpdate:modelValue": (we) => B.value[X] = we,
              type: "checkbox",
              "data-testid": `token-scope-${X}`
            }, null, 8, Tq), [
              [tp, B.value[X]]
            ]),
            c("span", null, y(X), 1)
          ])), 64)),
          G.value ? (p(), h("p", Aq, y(u(r)("conn.tokens.scopesRequired")), 1)) : D("", !0)
        ]),
        c("div", Eq, [
          c("span", Cq, y(u(r)("conn.tokens.comments")), 1),
          tt(ui, {
            "model-value": S.value,
            options: F.value,
            "aria-labelledby": "token-comments-label",
            "testid-prefix": "token-comments",
            "onUpdate:modelValue": H[2] || (H[2] = (X) => S.value = X)
          }, null, 8, ["model-value", "options"]),
          c("p", zq, y(u(r)("conn.tokens.commentsHint")), 1)
        ]),
        c("label", Mq, [
          c("span", Pq, y(u(r)("conn.tokens.root")), 1),
          un(c("input", {
            "onUpdate:modelValue": H[3] || (H[3] = (X) => O.value = X),
            class: "fe-cfield__input",
            placeholder: u(r)("conn.tokens.rootPlaceholder"),
            "data-testid": "token-root"
          }, null, 8, Oq), [
            [bn, O.value]
          ])
        ]),
        c("div", Dq, [
          c("label", Lq, [
            c("span", Rq, y(u(r)("conn.tokens.expiry")), 1),
            un(c("input", {
              "onUpdate:modelValue": H[4] || (H[4] = (X) => U.value = X),
              type: "number",
              min: "0",
              class: "fe-cfield__input",
              placeholder: u(r)("conn.tokens.expiryNever"),
              "data-testid": "token-expiry"
            }, null, 8, Nq), [
              [
                bn,
                U.value,
                void 0,
                { number: !0 }
              ]
            ])
          ]),
          c("button", {
            class: "fe-s3keys__btn",
            disabled: T.value || G.value,
            "data-testid": "token-mint",
            onClick: q
          }, y(u(r)("conn.tokens.mint")), 9, Iq)
        ]),
        c("p", Bq, y(u(r)("conn.tokens.capNote")), 1)
      ])) : D("", !0),
      u(b) ? (p(), h("div", Fq, [
        c("p", Uq, y(u(r)("conn.tokens.once")), 1),
        c("div", Hq, [
          c("code", null, y(u(b).token), 1),
          c("button", {
            class: "fe-s3keys__copy",
            onClick: ne
          }, y(N.value ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        c("button", {
          class: "fe-s3keys__dismiss",
          onClick: H[5] || (H[5] = //@ts-ignore
          (...X) => u(M) && u(M)(...X))
        }, y(u(r)("conn.tokens.dismiss")), 1)
      ])) : D("", !0),
      u(f) ? (p(), h("p", Kq, "…")) : (p(), Je(Vr, {
        key: 6,
        "table-id": "conn.tokens",
        columns: C.value,
        rows: u(d),
        "row-key": "id",
        locale: i.value,
        empty: u(r)("conn.tokens.empty"),
        "row-actions": re,
        "row-actions-test-id": (X) => `api-token-actions-${X.id}`,
        onRowAction: H[6] || (H[6] = (X, we) => de(X, we))
      }, {
        "cell-scopes": gt(({ row: X }) => [
          c("code", Vq, y(X.scopes), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-actions-test-id"])),
      u(v) ? (p(), h("p", jq, y(u(r)("conn.tokens.revokeHint")), 1)) : D("", !0)
    ]));
  }
}), qq = { class: "fe-conn__head" }, Wq = { class: "fe-conn__title" }, Yq = { class: "fe-conn__sub" }, Gq = ["aria-label"], Xq = ["innerHTML"], Jq = {
  key: 0,
  class: "fe-conn__error",
  "data-testid": "conn-error"
}, Zq = { class: "fe-conn__body" }, Qq = { class: "fe-conn__guidebar" }, eW = {
  key: 0,
  class: "fe-conn__pick"
}, tW = { class: "fe-cfield__label" }, nW = { class: "fe-conn__pick" }, aW = { class: "fe-cfield__label" }, iW = /* @__PURE__ */ lt({
  __name: "ConnectionsPanel",
  props: {
    config: {},
    closable: { type: Boolean }
  },
  emits: ["close", "error"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Sa(n.config.locale)), { t: r } = yt(i), { visible: l, me: d, realm: f, publicUrl: m, error: v, load: b } = yV(n.config), _ = E(() => {
      var S;
      return TV(((S = d.value) == null ? void 0 : S.email) ?? "", f.value);
    }), w = xl(), k = E(() => {
      const S = n.config.theme ?? "auto";
      return S === "light" || S === "dark" ? S : w.value ? "dark" : "light";
    }), x = LV(), M = $(x[0] ?? "webdav"), A = $(""), T = E(() => x.map((S) => ({ value: S, label: DV(S) }))), N = E(() => [
      { value: "", label: r("conn.guide.allStorages") },
      ...l.value.map((S) => ({ value: S, label: S }))
    ]), z = $(
      null
    ), L = E(() => vV(n.config, m.value)), B = $(
      null
    ), O = $(null), U = E(
      () => {
        var S, F, I, G, Y, ie, me, q, C, re, de, V, W, ne, K, ce, J, H, X, we, it, Re, Be, We, bt, at;
        return RV(
          M.value,
          {
            origin: L.value,
            user: _.value,
            storages: l.value,
            storage: A.value || void 0,
            s3Endpoint: (S = B.value) == null ? void 0 : S.endpoint,
            s3PathStyle: (F = B.value) == null ? void 0 : F.pathStyle,
            s3AccessKeyID: ((I = B.value) == null ? void 0 : I.accessKeyID) || void 0,
            s3Secret: (G = B.value) == null ? void 0 : G.secret,
            sftpHost: ((Y = O.value) == null ? void 0 : Y.host) || void 0,
            sftpPort: (ie = O.value) == null ? void 0 : ie.port,
            sftpEnabled: (me = O.value) == null ? void 0 : me.enabled,
            sftpLogin: ((q = O.value) == null ? void 0 : q.login) || void 0,
            sftpHasKey: (C = O.value) == null ? void 0 : C.hasKey,
            ftpsHost: ((de = (re = O.value) == null ? void 0 : re.ftps) == null ? void 0 : de.host) || void 0,
            ftpsPort: (W = (V = O.value) == null ? void 0 : V.ftps) == null ? void 0 : W.port,
            ftpsEnabled: (K = (ne = O.value) == null ? void 0 : ne.ftps) == null ? void 0 : K.enabled,
            ftpsPasvMin: (J = (ce = O.value) == null ? void 0 : ce.ftps) == null ? void 0 : J.pasv_min,
            ftpsPasvMax: (X = (H = O.value) == null ? void 0 : H.ftps) == null ? void 0 : X.pasv_max,
            ftpsSelfSigned: (it = (we = O.value) == null ? void 0 : we.ftps) == null ? void 0 : it.self_signed,
            nfsHost: ((Re = z.value) == null ? void 0 : Re.host) || void 0,
            nfsPort: (Be = z.value) == null ? void 0 : Be.port,
            nfsEnabled: (We = z.value) == null ? void 0 : We.enabled,
            nfsPath: (bt = z.value) == null ? void 0 : bt.path,
            nfsReadOnly: (at = z.value) == null ? void 0 : at.readOnly
          },
          r
        );
      }
    );
    return Xe(
      () => l.value,
      (S) => {
        !A.value && S.length === 1 && (A.value = S[0]);
      }
    ), Wt(() => {
      b();
    }), Xe(
      () => [n.config.apiBase, n.config.endpoint],
      () => {
        b();
      }
    ), (S, F) => (p(), h("div", {
      class: Fe(["fe-conn", {
        "fe--theme-dark": k.value === "dark",
        "fe--theme-light": k.value === "light"
      }]),
      "data-testid": "connections-panel"
    }, [
      c("header", qq, [
        c("div", null, [
          c("h2", Wq, y(u(r)("conn.title")), 1),
          c("p", Yq, y(u(r)("conn.subtitle", { host: u(Fr)(L.value) })), 1)
        ]),
        e.closable ? (p(), h("button", {
          key: 0,
          type: "button",
          class: "fe-conn__btn",
          "data-testid": "connections-close",
          "aria-label": u(r)("conn.close"),
          onClick: F[0] || (F[0] = (I) => a("close"))
        }, [
          c("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("close")
          }, null, 8, Xq)
        ], 8, Gq)) : D("", !0)
      ]),
      u(v) ? (p(), h("p", Jq, y(u(v)), 1)) : D("", !0),
      c("section", Zq, [
        c("div", Qq, [
          u(x).length > 1 ? (p(), h("label", eW, [
            c("span", tW, y(u(r)("conn.guide.protocol")), 1),
            tt(nc, {
              "model-value": M.value,
              options: T.value,
              testid: "guide-protocol",
              "onUpdate:modelValue": F[1] || (F[1] = (I) => M.value = String(I))
            }, null, 8, ["model-value", "options"])
          ])) : D("", !0),
          c("label", nW, [
            c("span", aW, y(u(r)("conn.guide.storage")), 1),
            tt(nc, {
              "model-value": A.value,
              options: N.value,
              testid: "guide-storage",
              "onUpdate:modelValue": F[2] || (F[2] = (I) => A.value = String(I))
            }, null, 8, ["model-value", "options"])
          ])
        ]),
        M.value === "s3" ? (p(), Je(Aj, {
          key: 0,
          config: e.config,
          storages: u(l),
          onActive: F[3] || (F[3] = (I) => B.value = I)
        }, null, 8, ["config", "storages"])) : D("", !0),
        M.value === "sftp" || M.value === "ftps" ? (p(), Je(Vj, {
          key: 1,
          config: e.config,
          "keys-visible": M.value === "sftp",
          onActive: F[4] || (F[4] = (I) => O.value = I)
        }, null, 8, ["config", "keys-visible"])) : D("", !0),
        M.value === "nfs" ? (p(), Je(dq, {
          key: 2,
          config: e.config,
          storages: u(l),
          onActive: F[5] || (F[5] = (I) => z.value = I)
        }, null, 8, ["config", "storages"])) : D("", !0),
        M.value === "ftps" || M.value === "webdav" || M.value === "mount" ? (p(), Je(c$, {
          key: 3,
          config: e.config,
          protocol: M.value,
          host: u(Fr)(L.value)
        }, null, 8, ["config", "protocol", "host"])) : D("", !0),
        U.value ? (p(), Je(ij, {
          key: 4,
          guide: U.value,
          locale: i.value
        }, null, 8, ["guide", "locale"])) : D("", !0)
      ])
    ], 2));
  }
});
function Ace(e = "") {
  return {
    text: "",
    tags: [],
    excludeTags: [],
    scope: "name",
    filters: { ...Ro, pathBase: e }
  };
}
function k1(e, t) {
  const n = e.trim();
  if (!n) return "";
  const a = /\s/.test(n) ? `"${n}"` : n;
  return `${t ? "-" : ""}tag:${a}`;
}
function Yv(e) {
  const t = [], n = e.text.trim();
  n && t.push(n);
  for (const a of e.tags) {
    const i = k1(a, !1);
    i && t.push(i);
  }
  for (const a of e.excludeTags) {
    const i = k1(a, !0);
    i && t.push(i);
  }
  return t.join(" ");
}
function oW(e, t = Date.now(), n = {}) {
  const a = {};
  e.type && e.type !== "any" && (a.type = e.type === "folder" ? "dir" : e.type);
  const i = Kx(e, t);
  (i == null ? void 0 : i.after) !== void 0 && (a.modified_after = String(Math.floor(i.after))), (i == null ? void 0 : i.before) !== void 0 && (a.modified_before = String(Math.floor(i.before)));
  const r = Vx(e);
  (r == null ? void 0 : r.min) !== void 0 && (a.min_size = String(Math.max(0, Math.floor(r.min)))), (r == null ? void 0 : r.max) !== void 0 && (a.max_size = String(Math.max(0, Math.floor(r.max))));
  const l = (e.pathBase ?? "").replace(/\/+$/, "");
  l && e.pathMode === "here" && (a.under = l), l && e.pathMode === "skip" && (a.not_under = l);
  const d = e.people ?? "any";
  return d === "me" || d === "system" ? a.owner = d : d.startsWith("u:") && (a.owner = d.slice(2)), n.showHidden === !1 && (a.hidden = "false"), a;
}
function Ece(e) {
  return Yv(e) === "";
}
function Cce(e) {
  return ZR(e, { newlines: !0 });
}
function Lm(e, t, n) {
  return typeof n == "boolean" ? n : e >= t;
}
const rW = { class: "fe-shortcuts" }, sW = { class: "fe-shortcuts__heading" }, lW = { class: "fe-shortcuts__table" }, uW = { class: "fe-shortcuts__keys" }, cW = {
  key: 0,
  class: "fe-shortcuts__unbound"
}, dW = { class: "fe-kbd" }, fW = {
  key: 0,
  class: "fe-shortcuts__or",
  "aria-hidden": "true"
}, pW = { class: "fe-shortcuts__desc" }, hW = ["title"], mW = ["innerHTML"], vW = /* @__PURE__ */ lt({
  __name: "ShortcutsHelp",
  props: {
    open: { type: Boolean },
    locale: {}
  },
  emits: ["close", "customize"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = VM(), l = E(() => {
      const d = [], f = /* @__PURE__ */ new Map();
      for (const m of r.value)
        f.has(m.groupKey) || (f.set(m.groupKey, []), d.push(m.groupKey)), f.get(m.groupKey).push(m);
      return d.map((m) => ({ key: m, items: f.get(m) }));
    });
    return (d, f) => (p(), Je(na, {
      open: e.open,
      title: u(i)("shortcuts.title"),
      size: "md",
      onClose: f[2] || (f[2] = (m) => a("close"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: f[0] || (f[0] = (m) => a("customize"))
        }, [
          c("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(zt)("shortcut-settings")
          }, null, 8, mW),
          Ht(" " + y(u(i)("shortcuts.customize")), 1)
        ]),
        c("button", {
          type: "button",
          class: "fe-btn",
          onClick: f[1] || (f[1] = (m) => a("close"))
        }, y(u(i)("viewer.close")), 1)
      ]),
      default: gt(() => [
        c("div", rW, [
          (p(!0), h(Ce, null, ot(l.value, (m) => (p(), h("section", {
            key: m.key,
            class: "fe-shortcuts__group"
          }, [
            c("h3", sW, y(u(i)(m.key)), 1),
            c("div", lW, [
              (p(!0), h(Ce, null, ot(m.items, (v) => (p(), h("div", {
                key: v.id,
                class: "fe-shortcuts__row"
              }, [
                c("span", uW, [
                  v.keys.length === 0 ? (p(), h("span", cW, y(u(i)("shortcuts.settings.unbound")), 1)) : (p(!0), h(Ce, { key: 1 }, ot(v.keys, (b, _) => (p(), h(Ce, { key: b }, [
                    c("kbd", dW, y(b), 1),
                    _ < v.keys.length - 1 ? (p(), h("span", fW, "/")) : D("", !0)
                  ], 64))), 128))
                ]),
                c("span", pW, [
                  Ht(y(u(i)(v.labelKey)) + " ", 1),
                  v.overridden ? (p(), h("span", {
                    key: 0,
                    class: "fe-shortcuts__custom",
                    title: u(i)("shortcuts.settings.customized")
                  }, "●", 8, hW)) : D("", !0)
                ])
              ]))), 128))
            ])
          ]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
});
function d$(e) {
  return !e || typeof e != "object" || e.complete === !0 ? null : e;
}
function yW(e) {
  const t = Math.max(0, e.catalogued_folders ?? 0), n = Math.max(0, e.pending_folders ?? 0);
  if (t + n === 0) return 0;
  const a = Math.floor(t * 100 / (t + n));
  return n > 0 ? Math.min(a, 99) : a;
}
function gW(e) {
  switch (e.reason) {
    case "lazy_on_open":
      return { key: "coverage.lazy_on_open", vars: {} };
    case "lazy_filling":
      return { key: "coverage.lazy_filling", vars: { pct: yW(e) } };
    default:
      return { key: "coverage.first_scan", vars: {} };
  }
}
function bW(e) {
  const t = {};
  if (!Array.isArray(e)) return t;
  for (const n of e)
    !n || typeof n.name != "string" || n.name === "" || (t[n.name] = d$(n.coverage ?? null));
  return t;
}
function kW(e) {
  const { map: t, adapter: n, searching: a, crossStorage: i, admin: r } = e;
  if (a && i) {
    const d = Object.keys(t).filter((f) => t[f] !== null).sort((f, m) => f.localeCompare(m));
    return d.length === 0 ? null : d.length === 1 ? w1(d[0], t[d[0]], r) : { key: "coverage.search_some", vars: { names: d.join(", ") }, offerCatalogAll: !1 };
  }
  const l = t[n];
  return l ? w1(n, l, r) : null;
}
function w1(e, t, n) {
  const a = gW(t);
  return { key: a.key, vars: a.vars, storage: e, offerCatalogAll: n && t.reason === "lazy_on_open" };
}
function wW() {
  let e = 0, t = null, n = Promise.resolve();
  return {
    begin(a, i) {
      return e += 1, { ticket: e, want: a ?? t ?? i };
    },
    going(a) {
      t = a;
    },
    view() {
      return t = null, e += 1, e;
    },
    isNewest(a) {
      return a === e;
    },
    end(a) {
      a === e && (t = null);
    },
    async follow(a) {
      let i;
      const r = new Promise((d) => i = d);
      n = r;
      try {
        await a();
      } finally {
        i();
      }
      let l = r;
      for (; n !== l; )
        l = n, await l;
    }
  };
}
function _W() {
  let e = 0, t = [];
  function n() {
    if (e > 0 || t.length === 0) return;
    const a = t;
    t = [];
    for (const i of a) i();
  }
  return {
    start() {
      e++;
      let a = !1;
      return () => {
        a || (a = !0, e--, n());
      };
    },
    settled(a) {
      return e === 0 ? Promise.resolve(!0) : new Promise((i) => {
        let r;
        const l = () => {
          r !== void 0 && clearTimeout(r), i(!0);
        };
        t.push(l), r = setTimeout(() => {
          t = t.filter((d) => d !== l), i(!1);
        }, Math.max(0, a));
      });
    },
    get count() {
      return e;
    }
  };
}
const Hu = "filex.menuAnswers.v1|", Vd = 1, xW = 1500, SW = 6, $W = 196608, _1 = 7 * 24 * 60 * 60 * 1e3, TW = 3e4, AW = 400, EW = ["allowed", "request", "denied"], CW = ["p", "e:file", "e:folder", "e:new_folder"], Jf = /* @__PURE__ */ new Set();
function jd(e) {
  const t = e.indexOf("://");
  return t > 0 ? e.slice(0, t) : "";
}
function x1(e) {
  const t = e.indexOf("://");
  return t < 0 ? e : e.slice(0, t + 3) + e.slice(t + 3).replace(/^\/+|\/+$/g, "");
}
function Rm(e) {
  const t = e.indexOf("://");
  if (t < 0) return null;
  const n = e.slice(t + 3);
  if (!n) return null;
  const a = n.lastIndexOf("/");
  return e.slice(0, t + 3) + (a < 0 ? "" : n.slice(0, a));
}
function Nm(e) {
  return e === "p" ? "p" : "e";
}
function zW(e, t) {
  return e === "p" ? Array.isArray(t) && t.every((n) => typeof n == "string") : typeof t == "string" && EW.includes(t);
}
function MW(e) {
  let t = 2166136261, n = 1523705862;
  for (let a = 0; a < e.length; a++) {
    const i = e.charCodeAt(a);
    t = Math.imul(t ^ i, 16777619), n = Math.imul(n ^ i, 1540483477);
  }
  return (t >>> 0).toString(16).padStart(8, "0") + (n >>> 0).toString(16).padStart(8, "0");
}
function PW() {
  try {
    const e = globalThis.localStorage;
    if (!e) return null;
    const t = `${Hu}probe`;
    return e.setItem(t, "1"), e.removeItem(t), e;
  } catch {
    return null;
  }
}
function OW(e = {}) {
  const t = e.now ?? (() => Date.now()), n = $(0), a = /* @__PURE__ */ new Map(), i = Math.random().toString(36).slice(2, 8);
  let r = 0, l = `${i}.0`, d = null, f = null, m = {}, v = null, b = !1;
  const _ = () => `${Hu}${d}`, w = (B) => `${Hu}${d}|${encodeURIComponent(B)}`;
  function k(B, O) {
    var I;
    if (!f || !d || !B) return;
    let U = null;
    try {
      U = JSON.parse(f.getItem(w(B)) ?? "null");
    } catch {
      U = null;
    }
    if (!U || U.v !== Vd || !Array.isArray(U.r)) return;
    const S = t(), F = /* @__PURE__ */ new Map();
    for (const G of U.r) {
      if (!Array.isArray(G)) continue;
      const [Y, ie, me] = G;
      if (typeof Y != "string" || typeof me != "number" || S - me > _1) continue;
      const q = Y.slice(0, Y.indexOf("|"));
      !CW.includes(q) || ((I = U.sig) == null ? void 0 : I[Nm(q)]) !== m[Nm(q)] || !zW(q, ie) || O.rows.has(Y) || F.set(Y, [ie, me, "", 1]);
    }
    for (const [G, Y] of O.rows) F.set(G, Y);
    O.rows = F;
  }
  function x(B) {
    let O = a.get(B);
    return O || (O = { sig: { ...m }, rows: /* @__PURE__ */ new Map(), dirty: !1 }, a.set(B, O), k(B, O)), O;
  }
  function M() {
    !f || !d || v || b || (v = setTimeout(N, AW));
  }
  function A(B, O, U) {
    if (!f) return;
    let S = [...O.rows].filter(([, F]) => F[3] === 1).map(([F, I]) => [F, I[0], I[1]]);
    for (; S.length > 0; ) {
      const F = JSON.stringify({ v: Vd, at: U, sig: O.sig, r: S });
      if (F.length <= $W)
        try {
          f.setItem(w(B), F);
          return;
        } catch {
        }
      S = S.slice(Math.ceil(S.length / 2));
    }
    try {
      f.removeItem(w(B));
    } catch {
    }
  }
  function T() {
    try {
      const B = JSON.parse((f == null ? void 0 : f.getItem(_())) ?? "null");
      if (B && B.v === Vd && B.s && typeof B.s == "object") {
        const O = {};
        for (const [U, S] of Object.entries(B.s)) typeof S == "number" && (O[U] = S);
        return O;
      }
    } catch {
    }
    return {};
  }
  function N() {
    if (v && clearTimeout(v), v = null, !f || !d) return;
    const B = t(), O = T();
    for (const [S, F] of a)
      F.dirty && (F.dirty = !1, S && (O[S] = B, A(S, F, B)));
    const U = Object.entries(O).sort((S, F) => F[1] - S[1]);
    for (const [S] of U.slice(SW)) {
      delete O[S];
      try {
        f.removeItem(w(S));
      } catch {
      }
    }
    try {
      f.setItem(_(), JSON.stringify({ v: Vd, at: B, s: O }));
    } catch {
    }
  }
  function z() {
    var U;
    if (!f) return;
    const B = t(), O = [];
    try {
      for (let S = 0; S < f.length; S++) {
        const F = f.key(S);
        if (!F || !F.startsWith(Hu)) continue;
        let I = 0;
        try {
          I = Number((U = JSON.parse(f.getItem(F) ?? "null")) == null ? void 0 : U.at) || 0;
        } catch {
          I = 0;
        }
        B - I > _1 && O.push(F);
      }
      for (const S of O) f.removeItem(S);
    } catch {
    }
  }
  const L = {
    rev: n,
    attach(B, O) {
      if (b) return;
      N();
      const U = B ? MW(B) : null;
      d !== null && U !== d && a.clear(), d = U, f = U ? e.storage ? e.storage() : PW() : null;
      for (const S of ["p", "e"]) m[S] !== void 0 && m[S] !== O[S] && L.sign(S, O[S]);
      if (m = { ...O }, f) {
        z();
        for (const [S, F] of a)
          F.sig = { ...m }, k(S, F), F.dirty = !0;
        M();
      }
      n.value++;
    },
    sign(B, O) {
      if (m[B] !== O) {
        m = { ...m, [B]: O };
        for (const U of a.values()) {
          for (const S of [...U.rows.keys()]) Nm(S.slice(0, S.indexOf("|"))) === B && U.rows.delete(S);
          U.sig = { ...m }, U.dirty = !0;
        }
        M(), n.value++;
      }
    },
    peek(B, O) {
      var U;
      return n.value, (U = x(jd(O)).rows.get(`${B}|${O}`)) == null ? void 0 : U[0];
    },
    fresh(B, O) {
      const U = x(jd(O)).rows.get(`${B}|${O}`);
      return !!U && U[2] === l && t() - U[1] < TW;
    },
    put(B, O, U, S = !0) {
      if (b) return;
      const F = x(jd(O)), I = `${B}|${O}`;
      for (F.rows.delete(I), F.rows.set(I, [U, t(), l, S ? 1 : 0]); F.rows.size > xW; ) {
        const G = F.rows.keys().next().value;
        if (G === void 0) break;
        F.rows.delete(G);
      }
      S && (F.dirty = !0, M());
    },
    stale() {
      r++, l = `${i}.${r}`, n.value++;
    },
    around(B) {
      const O = jd(B);
      if (!O) return [];
      const U = x1(B), S = `${O}://`, F = Rm(U), I = /* @__PURE__ */ new Set([S, U]);
      F !== null && I.add(F);
      const G = [];
      for (const Y of x(O).rows.keys()) {
        const ie = Y.indexOf("|"), me = Y.slice(ie + 1), q = x1(me), C = Rm(q);
        (I.has(q) || C !== null && (I.has(C) || Rm(C) === U)) && G.push({ q: Y.slice(0, ie), path: me });
      }
      return G;
    },
    flush() {
      N();
    },
    forget() {
      v && clearTimeout(v), v = null, a.clear(), d = null, f = null, n.value++;
    },
    dispose() {
      N(), b = !0, Jf.delete(L);
    }
  };
  return Jf.add(L), L;
}
function DW() {
  for (const e of Jf) e.forget();
  try {
    const e = globalThis.localStorage;
    if (!e) return;
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const a = e.key(n);
      a && a.startsWith(Hu) && t.push(a);
    }
    for (const n of t) e.removeItem(n);
  } catch {
  }
}
HB(DW);
typeof window < "u" && typeof window.addEventListener == "function" && window.addEventListener("pagehide", () => {
  for (const e of Jf) e.flush();
});
function hf(e) {
  return typeof e == "number" && Number.isFinite(e) && e >= 0 ? e : null;
}
function f$(e) {
  return !!e && !e.unlimited && e.quota_bytes > 0;
}
function LW(e, t) {
  return !e || f$(e) ? !1 : t.length === 0 || t.some((n) => hf(n.usedBytes) === null);
}
function RW(e, t, n) {
  if (!e) return null;
  if (f$(e))
    return { used: hf(e.used_bytes) ?? 0, total: e.quota_bytes, unlimited: !1, partial: !1 };
  const a = /* @__PURE__ */ new Map();
  for (const m of n ?? []) m && typeof m.name == "string" && a.set(m.name, m);
  const i = t.length ? t : [...a.keys()].map((m) => ({ name: m }));
  let r = 0, l = 0, d = !1;
  const f = /* @__PURE__ */ new Set();
  for (const m of i) {
    if (f.has(m.name)) continue;
    f.add(m.name);
    const v = hf(m.usedBytes), b = v === null ? a.get(m.name) : void 0, _ = v ?? hf(b == null ? void 0 : b.used_bytes);
    if (_ === null) {
      d = !0;
      continue;
    }
    r += _, l++, (v !== null ? m.usedPartial === !0 : d$(b == null ? void 0 : b.coverage) !== null) && (d = !0);
  }
  return !l || r <= 0 ? null : { used: r, total: 0, unlimited: !0, partial: d };
}
const NW = "custom:", Zf = "filex.palette", S1 = "filex.theme", La = "default", p$ = [
  {
    // Stock palette — the maps duplicate variables.css ONLY for the
    // gallery preview; applying this theme clears all overrides.
    id: La,
    nameKey: "theme.name.default",
    light: {
      /* ⚠ Mirrors styles/variables.css exactly — web/tests/api/themeContrast.test.ts
       * fails on any drift. It has drifted before: the stock primary was
       * darkened for contrast and this preview map kept the old blue, so the
       * gallery card advertised a colour the product no longer used. */
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f7f8fb",
      "--fe-bg-hover": "#f3f4f6",
      "--fe-bg-selected": "#eef3ff",
      "--fe-border": "#e5e7eb",
      "--fe-border-soft": "#eef0f4",
      "--fe-border-strong": "#d1d5db",
      "--fe-text": "#1f2937",
      "--fe-text-muted": "#6b7280",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2f6ceb",
      "--fe-primary-hover": "#2559c9",
      "--fe-primary-soft": "#e6ecfa",
      "--fe-primary-ink": "#2559c9",
      "--fe-danger": "#dc2626",
      "--fe-danger-hover": "#b91c1c",
      /* The outward-facing pages, as the stock palette defines them (#74):
       * the share page's ground and card (variables.css `.fe.fe-ppage`) and
       * the sign-in page's (`--fe-login-*`, which are the palette's own
       * sunken ground and surface). Optional for every theme - PAGE_TOKENS
       * below. */
      "--fe-ppage-ground-1": "#f5f7fb",
      "--fe-ppage-ground-2": "#e9edf4",
      "--fe-ppage-card": "#ffffff",
      "--fe-login-ground": "#f7f8fb",
      "--fe-login-card": "#ffffff"
    },
    dark: {
      "--fe-bg": "#15171c",
      "--fe-bg-elev": "#1a1d23",
      "--fe-bg-hover": "#1f232a",
      "--fe-bg-selected": "#1c2740",
      "--fe-border": "#2e333c",
      "--fe-border-soft": "#262a32",
      "--fe-border-strong": "#3d444f",
      "--fe-text": "#e6e8ec",
      "--fe-text-muted": "#888f9b",
      /* Dark ink, not white: white on the button measures 3.16 against the 4.5
       * this file claims. Mirrors styles/variables.css. */
      "--fe-text-on-primary": "#15171c",
      "--fe-primary": "#5b8cff",
      "--fe-primary-hover": "#7ba3ff",
      "--fe-primary-soft": "#1c2740",
      "--fe-primary-ink": "#7ba3ff",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444",
      "--fe-ppage-ground-1": "#12151a",
      "--fe-ppage-ground-2": "#191e25",
      "--fe-ppage-card": "#1f242c",
      "--fe-login-ground": "#1a1d23",
      "--fe-login-card": "#15171c"
    }
  },
  {
    // Night Blue — deep indigo/navy.
    id: "night",
    nameKey: "theme.name.night",
    light: {
      "--fe-bg": "#f6f8fd",
      "--fe-bg-elev": "#edf1fa",
      "--fe-bg-hover": "#e2e9f7",
      "--fe-bg-selected": "#d2ddf4",
      "--fe-border": "#d6deee",
      "--fe-border-soft": "#e3e8f4",
      "--fe-border-strong": "#aebfda",
      "--fe-text": "#151f38",
      "--fe-text-muted": "#49587a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2c4a9e",
      "--fe-primary-hover": "#213a80",
      "--fe-primary-soft": "#e0e6f4",
      "--fe-primary-ink": "#213a80",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0a1024",
      "--fe-bg-elev": "#111a35",
      "--fe-bg-hover": "#1a2547",
      "--fe-bg-selected": "#243665",
      "--fe-border": "#26335a",
      "--fe-border-soft": "#1d2748",
      "--fe-border-strong": "#3c4e84",
      "--fe-text": "#dfe6f7",
      "--fe-text-muted": "#96a5cc",
      "--fe-text-on-primary": "#050b26",
      "--fe-primary": "#6d8dfc",
      "--fe-primary-hover": "#5273f2",
      "--fe-primary-soft": "#182243",
      "--fe-primary-ink": "#6d8dfc",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Forest — calm greens.
    id: "forest",
    nameKey: "theme.name.forest",
    light: {
      "--fe-bg": "#f5faf5",
      "--fe-bg-elev": "#eaf3eb",
      "--fe-bg-hover": "#dcecdf",
      "--fe-bg-selected": "#c8e2ce",
      "--fe-border": "#d2e2d4",
      "--fe-border-soft": "#e0ece1",
      "--fe-border-strong": "#a2c3a8",
      "--fe-text": "#182b1d",
      "--fe-text-muted": "#42604a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2b7a41",
      "--fe-primary-hover": "#226334",
      "--fe-primary-soft": "#dbe9dc",
      "--fe-primary-ink": "#226334",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0d1611",
      "--fe-bg-elev": "#132019",
      "--fe-bg-hover": "#1b2d23",
      "--fe-bg-selected": "#264532",
      "--fe-border": "#28402f",
      "--fe-border-soft": "#1f3225",
      "--fe-border-strong": "#3e5f49",
      "--fe-text": "#dcebe0",
      "--fe-text-muted": "#93b09b",
      "--fe-text-on-primary": "#04180b",
      "--fe-primary": "#54c17a",
      "--fe-primary-hover": "#3fae66",
      "--fe-primary-soft": "#16291d",
      "--fe-primary-ink": "#54c17a",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Amber — warm amber/bronze.
    id: "amber",
    nameKey: "theme.name.amber",
    light: {
      "--fe-bg": "#fdf9f0",
      "--fe-bg-elev": "#f7efdd",
      "--fe-bg-hover": "#f0e3c8",
      "--fe-bg-selected": "#ead6ab",
      "--fe-border": "#e6dabf",
      "--fe-border-soft": "#efe6d3",
      "--fe-border-strong": "#c6b184",
      "--fe-text": "#33270f",
      "--fe-text-muted": "#655631",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#9a4b00",
      "--fe-primary-hover": "#7c3c00",
      "--fe-primary-soft": "#f3e5d7",
      "--fe-primary-ink": "#7c3c00",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#191307",
      "--fe-bg-elev": "#231a0c",
      "--fe-bg-hover": "#2f2312",
      "--fe-bg-selected": "#44331b",
      "--fe-border": "#3b2e17",
      "--fe-border-soft": "#302512",
      "--fe-border-strong": "#5b4a29",
      "--fe-text": "#f2e7d4",
      "--fe-text-muted": "#bda887",
      "--fe-text-on-primary": "#2a1c02",
      "--fe-primary": "#f5a524",
      "--fe-primary-hover": "#ffb84d",
      "--fe-primary-soft": "#31230c",
      "--fe-primary-ink": "#ffb84d",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Lilac — soft purple.
    id: "lilac",
    nameKey: "theme.name.lilac",
    light: {
      "--fe-bg": "#faf7fd",
      "--fe-bg-elev": "#f2ecfa",
      "--fe-bg-hover": "#e8ddf5",
      "--fe-bg-selected": "#dccaf0",
      "--fe-border": "#e1d6ee",
      "--fe-border-soft": "#ebe3f4",
      "--fe-border-strong": "#bda6d9",
      "--fe-text": "#241a33",
      "--fe-text-muted": "#584871",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#7231e0",
      "--fe-primary-hover": "#5f21c4",
      "--fe-primary-soft": "#e9e3fc",
      "--fe-primary-ink": "#5f21c4",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#130f1c",
      "--fe-bg-elev": "#1b1527",
      "--fe-bg-hover": "#261d37",
      "--fe-bg-selected": "#37294f",
      "--fe-border": "#302546",
      "--fe-border-soft": "#261e38",
      "--fe-border-strong": "#4b3a6d",
      "--fe-text": "#e9e2f5",
      "--fe-text-muted": "#a999c5",
      "--fe-text-on-primary": "#180d33",
      "--fe-primary": "#b197fa",
      "--fe-primary-hover": "#9c7cf4",
      "--fe-primary-soft": "#272038",
      "--fe-primary-ink": "#b197fa",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // High Contrast — black/white with strong borders, saturated accents.
    id: "contrast",
    nameKey: "theme.name.contrast",
    light: {
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f2f2f2",
      "--fe-bg-hover": "#e0e0e0",
      "--fe-bg-selected": "#c9dcff",
      "--fe-border": "#5c5c5c",
      "--fe-border-soft": "#5c5c5c",
      "--fe-border-strong": "#000000",
      "--fe-text": "#000000",
      "--fe-text-muted": "#3d3d3d",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#003d99",
      "--fe-primary-hover": "#002a6b",
      "--fe-primary-soft": "#e7edf7",
      "--fe-primary-ink": "#002a6b",
      "--fe-danger": "#a80000",
      "--fe-danger-hover": "#7d0000",
      "--fe-shadow": "0 0 0 1px #000000, 0 10px 32px rgba(0, 0, 0, 0.25)",
      "--fe-shadow-sm": "0 0 0 1px #000000"
    },
    dark: {
      "--fe-bg": "#000000",
      "--fe-bg-elev": "#0d0d0d",
      "--fe-bg-hover": "#212121",
      "--fe-bg-selected": "#003d80",
      "--fe-border": "#8f8f8f",
      "--fe-border-soft": "#8f8f8f",
      "--fe-border-strong": "#ffffff",
      "--fe-text": "#ffffff",
      "--fe-text-muted": "#d6d6d6",
      "--fe-text-on-primary": "#001430",
      "--fe-primary": "#7ab8ff",
      "--fe-primary-hover": "#9ccaff",
      "--fe-primary-soft": "#0e1a29",
      "--fe-primary-ink": "#9ccaff",
      "--fe-danger": "#ff7575",
      "--fe-danger-hover": "#ff9999",
      "--fe-shadow": "0 0 0 1px #ffffff, 0 12px 32px rgba(0, 0, 0, 0.65)",
      "--fe-shadow-sm": "0 0 0 1px #ffffff"
    }
  },
  {
    // Soft Gray — desaturated, quiet neutral.
    id: "gray",
    nameKey: "theme.name.gray",
    light: {
      "--fe-bg": "#f7f7f8",
      "--fe-bg-elev": "#efeff1",
      "--fe-bg-hover": "#e4e4e7",
      "--fe-bg-selected": "#d6d7db",
      "--fe-border": "#dfdfe2",
      "--fe-border-soft": "#e9e9eb",
      "--fe-border-strong": "#b9b9c0",
      "--fe-text": "#26272b",
      "--fe-text-muted": "#585a63",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#4b4b54",
      "--fe-primary-hover": "#38383f",
      "--fe-primary-soft": "#e4e4e6",
      "--fe-primary-ink": "#38383f",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#131316",
      "--fe-bg-elev": "#1b1b1f",
      "--fe-bg-hover": "#26262b",
      "--fe-bg-selected": "#35353c",
      "--fe-border": "#2d2d33",
      "--fe-border-soft": "#242429",
      "--fe-border-strong": "#4a4a52",
      "--fe-text": "#e6e6e9",
      "--fe-text-muted": "#a4a4ad",
      "--fe-text-on-primary": "#17171b",
      "--fe-primary": "#b0b0ba",
      "--fe-primary-hover": "#c4c4cd",
      "--fe-primary-soft": "#242428",
      "--fe-primary-ink": "#c4c4cd",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Terminal Green — phosphor green, monospace face for the full CRT vibe.
    id: "terminal",
    nameKey: "theme.name.terminal",
    light: {
      "--fe-bg": "#f3f9f4",
      "--fe-bg-elev": "#e5f2e8",
      "--fe-bg-hover": "#d5ead9",
      "--fe-bg-selected": "#bce3c6",
      "--fe-border": "#cbe2d1",
      "--fe-border-soft": "#dbebdf",
      "--fe-border-strong": "#94c2a0",
      "--fe-text": "#0c2913",
      "--fe-text-muted": "#31573c",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#116b33",
      "--fe-primary-hover": "#0c5427",
      "--fe-primary-soft": "#dbe9dd",
      "--fe-primary-ink": "#0c5427",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    },
    dark: {
      "--fe-bg": "#050d07",
      "--fe-bg-elev": "#0a1710",
      "--fe-bg-hover": "#112418",
      "--fe-bg-selected": "#1a3a26",
      "--fe-border": "#1c3a2a",
      "--fe-border-soft": "#142b1e",
      "--fe-border-strong": "#316144",
      "--fe-text": "#4fdd8b",
      "--fe-text-muted": "#38a668",
      "--fe-text-on-primary": "#03180a",
      "--fe-primary": "#25c95e",
      "--fe-primary-hover": "#4fdd8b",
      "--fe-primary-soft": "#0c2412",
      "--fe-primary-ink": "#4fdd8b",
      "--fe-danger": "#ff6b62",
      "--fe-danger-hover": "#ff8d86",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    }
  }
], Rp = $([]);
function zce(e) {
  Rp.value = Array.isArray(e) ? e : [], Ho.value !== La && !Dc(Ho.value) && UW(La);
}
function Mce() {
  return { customThemes: Rp };
}
function h$() {
  return [...p$, ...Rp.value];
}
function Dc(e) {
  if (e)
    return p$.find((t) => t.id === e) ?? Rp.value.find((t) => t.id === e);
}
function IW(e, t) {
  return e.name ?? (e.nameKey ? t(e.nameKey) : e.id);
}
function BW() {
  return Array.from(
    new Set(h$().flatMap((e) => [...Object.keys(e.light), ...Object.keys(e.dark)]))
  );
}
function Lc(e) {
  return !!e && (!!Dc(e) || e.startsWith(NW));
}
function m$() {
  if (!$l()) return La;
  try {
    const e = localStorage.getItem(Zf);
    if (Lc(e)) return e;
    const t = localStorage.getItem(S1);
    return t && Dc(t) ? (localStorage.setItem(Zf, t), localStorage.removeItem(S1), t) : La;
  } catch {
    return La;
  }
}
const Ho = $(
  typeof window > "u" ? La : m$()
);
function FW(e) {
  const t = Lc(e) ? e : La;
  Ho.value = t;
  try {
    localStorage.setItem(Zf, t);
  } catch {
  }
  Uo("palette", t);
}
function UW(e) {
  if (!e) return;
  const t = Lc(e) ? e : La;
  Ho.value = t, Rr("palette", t);
}
function Pce(e) {
  e && Lc(e) && (Ho.value = e);
}
function HW() {
  return { themeId: Ho, setTheme: FW };
}
const uc = "filex.thememode";
UB(uc);
const _g = ["host", "auto", "light", "dark"];
function v$() {
  if (!$l()) return "host";
  try {
    const e = localStorage.getItem(uc);
    return e && _g.includes(e) ? e : "host";
  } catch {
    return "host";
  }
}
const Np = $(
  typeof window > "u" ? "host" : v$()
);
function KW(e) {
  const t = _g.includes(e) ? e : "host";
  Np.value = t;
  try {
    t === "host" ? localStorage.removeItem(uc) : localStorage.setItem(uc, t);
  } catch {
  }
}
function Oce() {
  Ho.value = m$(), Np.value = v$();
}
function VW() {
  return { themeMode: Np, setThemeMode: KW };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      if (e.key !== uc || !$l()) return;
      const t = e.newValue;
      Np.value = t && _g.includes(t) ? t : "host";
    });
  } catch {
  }
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key !== Zf || !$l() || (Ho.value = Lc(e.newValue) ? e.newValue : La);
    });
  } catch {
  }
function jW(e, t, n) {
  for (const r of BW()) e.style.removeProperty(r);
  if (t === La) return;
  const a = Dc(t);
  if (!a) return;
  const i = n ? a.dark : a.light;
  for (const [r, l] of Object.entries(i)) e.style.setProperty(r, l);
}
const $1 = "data-filex-theme";
function qd(e) {
  return Object.entries(e).map(([t, n]) => `${t}:${n};`).join("");
}
const xg = ["--fe-ppage-ground-1", "--fe-ppage-ground-2", "--fe-ppage-card"], qW = ["--fe-login-ground", "--fe-login-card"], Dce = [...xg, ...qW], WW = {
  light: {
    "--fe-ppage-ground-1": "color-mix(in srgb, var(--fe-bg) 96%, var(--fe-text))",
    "--fe-ppage-ground-2": "color-mix(in srgb, var(--fe-bg) 90%, var(--fe-text))",
    "--fe-ppage-card": "var(--fe-bg)"
  },
  dark: {
    "--fe-ppage-ground-1": "color-mix(in srgb, var(--fe-bg) 88%, #000000)",
    "--fe-ppage-ground-2": "color-mix(in srgb, var(--fe-bg) 96%, var(--fe-text))",
    "--fe-ppage-card": "color-mix(in srgb, var(--fe-bg) 92%, var(--fe-text))"
  }
};
function T1(e, t) {
  const n = e[t] ?? {}, a = {};
  for (const i of xg) {
    const r = typeof n[i] == "string" ? n[i].trim() : "";
    a[i] = r || WW[t][i];
  }
  return a;
}
const YW = new Set(xg);
function A1(e) {
  const t = {};
  for (const [n, a] of Object.entries(e)) YW.has(n) || (t[n] = a);
  return t;
}
function GW(e) {
  const t = qd(A1(e.light)), n = qd(A1(e.dark)), a = qd(T1(e, "light")), i = qd(T1(e, "dark")), r = [
    ".fe.fe-ppage.fe--theme-dark",
    ":root[data-theme='dark'] .fe.fe-ppage",
    ":root.dark .fe.fe-ppage",
    ".dark .fe.fe-ppage"
  ].join(","), l = [
    ".fe--theme-dark",
    ":root[data-theme='dark'] .fe",
    ".fe.fe--theme-dark",
    ":root.dark",
    ".dark",
    ":root.dark .fe",
    ".dark .fe",
    ".fe-ctx-backdrop--theme-dark",
    ".fe-ctx-backdrop--theme-auto[data-prefers-dark='1']"
  ].join(","), d = [
    ".fe:not(.fe--theme-light)",
    ".fe-ctx-backdrop--theme-auto:not(.fe-ctx-backdrop--theme-light)"
  ].join(",");
  return `/* filex theme: ${e.id} */:root,.fe{${t}}${l}{${n}}@media (prefers-color-scheme: dark){${d}{${n}}}.fe.fe-ppage{${a}}${r}{${i}}@media (prefers-color-scheme: dark){.fe.fe-ppage:not(.fe--theme-light){${i}}}`;
}
function XW(e) {
  if (typeof document > "u") return;
  let t = document.head.querySelector(`style[${$1}]`);
  const n = e === La ? void 0 : Dc(e);
  if (!n) {
    t && (t.textContent = "");
    return;
  }
  t ? t !== document.head.lastElementChild && document.head.appendChild(t) : (t = document.createElement("style"), t.setAttribute($1, ""), document.head.appendChild(t));
  const a = GW(n);
  t.textContent !== a && (t.textContent = a);
}
const JW = {
  key: 0,
  class: "fe-themes__hint"
}, ZW = ["aria-label"], QW = ["aria-selected", "data-theme-id", "onClick"], eY = { class: "fe-themecard__name" }, tY = ["title"], nY = /* @__PURE__ */ lt({
  __name: "ThemePalette",
  props: {
    locale: {},
    dark: { type: Boolean },
    current: {},
    hint: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale);
    function r(l) {
      return n.dark ? l.dark : l.light;
    }
    return (l, d) => (p(), h(Ce, null, [
      e.hint !== !1 ? (p(), h("p", JW, y(u(i)("theme.hint")), 1)) : D("", !0),
      c("div", {
        class: "fe-themes",
        role: "listbox",
        "aria-label": u(i)("theme.title")
      }, [
        (p(!0), h(Ce, null, ot(u(h$)(), (f) => (p(), h("button", {
          key: f.id,
          type: "button",
          class: Fe(["fe-themecard", { "is-selected": f.id === e.current }]),
          role: "option",
          "aria-selected": f.id === e.current,
          "data-theme-id": f.id,
          style: Yt(r(f)),
          onClick: (m) => a("select", f.id)
        }, [
          d[0] || (d[0] = w0('<span class="fe-themecard__preview" aria-hidden="true"><span class="fe-themecard__topbar"><span class="fe-themecard__chip fe-themecard__chip--primary"></span><span class="fe-themecard__chip"></span><span class="fe-themecard__chip fe-themecard__chip--ghost"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot"></span><span class="fe-themecard__line" style="width:62%;"></span></span><span class="fe-themecard__row fe-themecard__row--selected"><span class="fe-themecard__dot fe-themecard__dot--primary"></span><span class="fe-themecard__line" style="width:44%;"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot fe-themecard__dot--muted"></span><span class="fe-themecard__line fe-themecard__line--muted" style="width:74%;"></span></span></span>', 1)),
          c("span", eY, [
            Ht(y(u(IW)(f, u(i))) + " ", 1),
            f.id === e.current ? (p(), h("span", {
              key: 0,
              class: "fe-themecard__check",
              title: u(i)("theme.selected")
            }, "✓", 8, tY)) : D("", !0)
          ])
        ], 14, QW))), 128))
      ], 8, ZW)
    ], 64));
  }
}), aY = ["aria-label"], iY = { class: "fe-thememode__label" }, oY = { class: "fe-thememode__seg" }, rY = ["aria-pressed", "onClick"], sY = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, lY = {
  key: 1,
  d: "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"
}, uY = ["disabled"], cY = /* @__PURE__ */ lt({
  __name: "ThemeGallery",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    dark: { type: Boolean },
    current: {},
    mode: {},
    hostMode: {}
  },
  emits: ["close", "select", "mode"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = [
      { id: "light", labelKey: "theme.mode.light" },
      { id: "dark", labelKey: "theme.mode.dark" },
      { id: "auto", labelKey: "theme.mode.auto" }
    ], l = E(() => n.mode === "host" ? n.hostMode : n.mode), d = La;
    return (f, m) => (p(), Je(na, {
      open: e.open,
      title: u(i)("theme.title"),
      size: "lg",
      theme: e.theme,
      onClose: m[3] || (m[3] = (v) => a("close"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.current === u(d),
          onClick: m[1] || (m[1] = (v) => a("select", u(d)))
        }, y(u(i)("theme.reset")), 9, uY),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: m[2] || (m[2] = (v) => a("close"))
        }, y(u(i)("theme.close")), 1)
      ]),
      default: gt(() => [
        c("div", {
          class: "fe-thememode",
          role: "group",
          "aria-label": u(i)("theme.mode.label")
        }, [
          c("span", iY, y(u(i)("theme.mode.label")), 1),
          c("div", oY, [
            (p(), h(Ce, null, ot(r, (v) => c("button", {
              key: v.id,
              type: "button",
              class: Fe(["fe-thememode__opt", { "is-active": l.value === v.id }]),
              "aria-pressed": l.value === v.id,
              onClick: (b) => a("mode", v.id)
            }, [
              (p(), h("svg", sY, [
                v.id === "light" ? (p(), h(Ce, { key: 0 }, [
                  m[4] || (m[4] = c("circle", {
                    cx: "12",
                    cy: "12",
                    r: "4"
                  }, null, -1)),
                  m[5] || (m[5] = c("path", { d: "M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" }, null, -1))
                ], 64)) : v.id === "dark" ? (p(), h("path", lY)) : (p(), h(Ce, { key: 2 }, [
                  m[6] || (m[6] = c("circle", {
                    cx: "12",
                    cy: "12",
                    r: "9"
                  }, null, -1)),
                  m[7] || (m[7] = c("path", {
                    d: "M12 3a9 9 0 0 1 0 18z",
                    fill: "currentColor",
                    stroke: "none"
                  }, null, -1))
                ], 64))
              ])),
              c("span", null, y(u(i)(v.labelKey)), 1)
            ], 10, rY)), 64))
          ])
        ], 8, aY),
        tt(nY, {
          locale: e.locale,
          dark: e.dark,
          current: e.current,
          onSelect: m[0] || (m[0] = (v) => a("select", v))
        }, null, 8, ["locale", "dark", "current"])
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
});
function dY(e) {
  const t = Symbol("filex-explorer");
  wr(Y0, t), Xe(
    () => e.config().timeZone,
    (i) => fM(t, i),
    { immediate: !0 }
  );
  const n = () => {
    var i;
    return e.config().callerKind ?? ((i = e.capabilities.value) == null ? void 0 : i.caller_kind);
  };
  let a = !1;
  return Xe(
    n,
    (i) => {
      if (i !== "user") {
        Qd(t, null);
        return;
      }
      a || (a = !0, e.fetchMe().then((r) => {
        var d;
        if (n() !== "user") return;
        const l = (d = r == null ? void 0 : r.user) == null ? void 0 : d.timezone;
        Qd(t, typeof l == "string" ? l : null);
      }).catch(() => Qd(t, null)));
    },
    { immediate: !0 }
  ), Ot(() => mM(t)), t;
}
const fY = ["aria-label"], pY = { class: "fe-opc__head" }, hY = ["aria-label"], mY = { class: "fe-opc__body" }, vY = {
  key: 0,
  class: "fe-opc__section",
  "aria-live": "polite"
}, yY = { class: "fe-opc__section-title" }, gY = { class: "fe-opc__list" }, bY = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, kY = ["d"], wY = { class: "fe-opc__mid" }, _Y = ["title"], xY = { class: "fe-opc__sub" }, SY = { class: "fe-opc__kind" }, $Y = ["title"], TY = { class: "fe-opc__state" }, AY = {
  key: 0,
  class: "fe-opc__sub fe-opc__sub--detail",
  "data-testid": "opc-error-detail"
}, EY = ["aria-valuenow"], CY = {
  key: 0,
  class: "fe-opc__spin",
  "aria-hidden": "true"
}, zY = { class: "fe-opc__acts" }, MY = ["onClick"], PY = ["onClick"], OY = ["onClick"], DY = ["aria-label", "onClick"], LY = {
  key: 1,
  class: "fe-opc__section"
}, RY = { class: "fe-opc__section-title" }, NY = { class: "fe-opc__list fe-opc__list--history" }, IY = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, BY = ["d"], FY = { class: "fe-opc__mid" }, UY = ["title"], HY = {
  key: 0,
  class: "fe-opc__sub"
}, KY = ["title"], VY = {
  key: 1,
  class: "fe-opc__sub fe-opc__sub--err"
}, jY = {
  key: 2,
  class: "fe-opc__sub fe-opc__sub--detail",
  "data-testid": "opc-error-detail"
}, qY = ["onClick"], WY = {
  key: 2,
  class: "fe-opc__empty"
}, YY = ["aria-expanded", "aria-label"], GY = ["stroke-dashoffset"], XY = { class: "fe-opc__count" }, JY = {
  key: 0,
  class: "fe-opc__pct"
}, Im = 8.5, ZY = /* @__PURE__ */ lt({
  __name: "OperationsCenter",
  props: {
    center: {},
    locale: {},
    narrow: { type: Boolean }
  },
  setup(e) {
    const t = e, { t: n, formatSize: a } = yt(() => t.locale), i = $(!1), r = $(null), l = E(() => t.center.active.value), d = E(() => t.center.history.value), f = E(() => t.center.hasError.value), m = E(() => t.center.overallPercent.value), v = E(() => t.center.runningCount.value), b = E(() => l.value.length > 0 || i.value && d.value.length > 0);
    Xe(b, (I) => {
      I || (i.value = !1);
    }), Xe(
      () => {
        var I;
        return ((I = t.center.revealRequests) == null ? void 0 : I.value) ?? 0;
      },
      (I, G) => {
        I > G && (i.value = !0);
      }
    );
    const _ = 2 * Math.PI * Im, w = E(() => {
      const I = m.value;
      return I === null ? _ * 0.72 : _ * (1 - Math.min(100, Math.max(0, I)) / 100);
    }), k = E(() => m.value === null && v.value > 0), x = E(() => v.value === 0 || m.value === null ? "" : n("opc.percent", { n: m.value })), M = E(() => n("opc.aria_badge", { n: l.value.length })), A = {
      upload: "M12 16V5M7 9.5 12 5l5 4.5M5 19h14",
      copy: "M9 9h11v11H9zM5 15V4h11",
      move: "M4 12h13M12 6l6 6-6 6",
      delete: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13",
      /* A folder given a new name, and one brought back from the trash. */
      rename: "M4 20h4L18.5 9.5l-4-4L4 16zM13 7l4 4",
      restore: "M9 14 4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11",
      /* A trash entry taken out for good: the bin, crossed. */
      purge: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13M10 11l4 5M14 11l-4 5",
      convert: "M20 8A8 8 0 0 0 6 6L4 8M4 16a8 8 0 0 0 14 2l2-2M20 3v5h-5M4 21v-5h5",
      archive: "M4 8V5h16v3zM5 8h14v12H5zM10 12h4",
      /* "Empty the trash" — the bin, with the lines of what is going. */
      trash: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13M10.5 11v5M13.5 11v5",
      /* "Repair thumbnails" (Admin → Tools): a picture, its frame and its hill. */
      thumbs: "M4 5h16v14H4zM4 16l5-5 4 4 3-3 4 4M15 9.5h.01",
      /* An app-plugin job — the puzzle piece its menu row wears (lib/actionIcons). */
      plugin: "M9.5 4.5a2 2 0 1 1 4 0h3a1.5 1.5 0 0 1 1.5 1.5v3a2 2 0 1 1 0 4v3a1.5 1.5 0 0 1-1.5 1.5h-3a2 2 0 1 1-4 0h-3A1.5 1.5 0 0 1 5 16v-3a2 2 0 1 1 0-4V6a1.5 1.5 0 0 1 1.5-1.5z",
      "archive-create": "M4 8V5h16v3zM5 8h14v12H5zM10 12h4",
      "archive-extract": "M4 8V5h16v3zM5 8h14v12H5zM10 12h4"
    };
    function T(I) {
      return n(`opc.kind.${I.kind}`);
    }
    function N(I) {
      return I.name || T(I);
    }
    function z(I) {
      return I.outputMode === "sibling" ? n("plugin.output.sibling") : I.outputMode === "version" ? n("plugin.output.version") : "";
    }
    function L(I) {
      return I.outputMode === "sibling" ? n("plugin.output.sibling_title") : I.outputMode === "version" ? n("plugin.output.version_title") : "";
    }
    function B(I) {
      return I.status === "running" ? I.cancelling ? n("opc.cancelling") : I.queued ? n("opc.queued") : I.message ? I.message : I.totalBytes && I.totalBytes > 0 ? `${a(I.uploadedBytes ?? 0)} / ${a(I.totalBytes)}` : (I.kind === "archive-create" || I.kind === "archive-extract") && I.percent !== null ? n("opc.percent", { n: I.percent }) : I.itemsTotal && I.itemsTotal > 0 ? n("opc.items", { done: I.itemsDone ?? 0, total: I.itemsTotal }) : I.percent !== null && I.totalCount && I.totalCount > 1 ? `${I.doneCount ?? 0}/${I.totalCount}` : n("opc.status.running") : I.status === "done" ? I.message || n("opc.status.done") : I.status === "aborted" ? n("opc.status.aborted") : I.error || n("opc.status.error");
    }
    function O(I) {
      return I.status === "done" && I.outputs.length > 0;
    }
    function U(I) {
      return n(`opc.status.${I.status === "running" ? "running" : I.status}`);
    }
    function S(I) {
      if (!i.value) return;
      const G = r.value;
      G && I.target instanceof Node && !G.contains(I.target) && (i.value = !1);
    }
    function F(I) {
      i.value && I.key === "Escape" && (i.value = !1);
    }
    return Wt(() => {
      document.addEventListener("mousedown", S), document.addEventListener("keydown", F);
    }), Ot(() => {
      document.removeEventListener("mousedown", S), document.removeEventListener("keydown", F);
    }), (I, G) => b.value ? (p(), h("div", {
      key: 0,
      ref_key: "rootEl",
      ref: r,
      class: Fe(["fe-opc", { "fe-opc--narrow": e.narrow, "fe-opc--open": i.value }])
    }, [
      tt(kr, { name: "fe-opc-pop" }, {
        default: gt(() => [
          i.value ? (p(), h("section", {
            key: 0,
            class: "fe-opc__panel",
            role: "dialog",
            "aria-label": u(n)("opc.title")
          }, [
            c("header", pY, [
              c("strong", null, y(u(n)("opc.title")), 1),
              c("button", {
                type: "button",
                class: "fe-opc__x",
                "aria-label": u(n)("opc.close"),
                onClick: G[0] || (G[0] = (Y) => i.value = !1)
              }, "×", 8, hY)
            ]),
            c("div", mY, [
              l.value.length > 0 ? (p(), h("div", vY, [
                c("h3", yY, y(u(n)("opc.active")), 1),
                c("ul", gY, [
                  (p(!0), h(Ce, null, ot(l.value, (Y) => (p(), h("li", {
                    key: Y.key,
                    class: Fe(["fe-opc__item", `is-${Y.status}`])
                  }, [
                    (p(), h("svg", bY, [
                      c("path", {
                        d: A[Y.kind]
                      }, null, 8, kY)
                    ])),
                    c("div", wY, [
                      c("div", {
                        class: "fe-opc__name",
                        title: N(Y)
                      }, y(N(Y)), 9, _Y),
                      c("div", xY, [
                        c("span", SY, y(T(Y)), 1),
                        z(Y) ? (p(), h(Ce, { key: 0 }, [
                          G[3] || (G[3] = c("span", {
                            class: "fe-opc__dot",
                            "aria-hidden": "true"
                          }, "·", -1)),
                          c("span", {
                            class: "fe-opc__outmode",
                            title: L(Y),
                            "data-testid": "opc-output-mode"
                          }, y(z(Y)), 9, $Y)
                        ], 64)) : D("", !0),
                        G[4] || (G[4] = c("span", {
                          class: "fe-opc__dot",
                          "aria-hidden": "true"
                        }, "·", -1)),
                        c("span", TY, y(B(Y)), 1)
                      ]),
                      Y.status === "error" && Y.errorDetail ? (p(), h("div", AY, y(Y.errorDetail), 1)) : D("", !0),
                      Y.status === "running" && Y.percent !== null ? (p(), h("div", {
                        key: 1,
                        class: "fe-opc__bar",
                        role: "progressbar",
                        "aria-valuenow": Y.percent,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, [
                        c("div", {
                          class: "fe-opc__bar-fill",
                          style: Yt({ width: Y.percent + "%" })
                        }, null, 4)
                      ], 8, EY)) : D("", !0)
                    ]),
                    Y.status === "running" && Y.percent === null && !Y.queued ? (p(), h("span", CY)) : D("", !0),
                    c("div", zY, [
                      Y.status === "running" && Y.cancellable ? (p(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-opc__act",
                        onClick: (ie) => e.center.cancel(Y.key)
                      }, y(u(n)("opc.cancel")), 9, MY)) : D("", !0),
                      O(Y) ? (p(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-opc__act",
                        "data-testid": "opc-open",
                        onClick: (ie) => e.center.open(Y.key)
                      }, y(u(n)("opc.open")), 9, PY)) : D("", !0),
                      Y.status === "error" && Y.retryable ? (p(), h("button", {
                        key: 2,
                        type: "button",
                        class: "fe-opc__act fe-opc__act--retry",
                        onClick: (ie) => e.center.retry(Y.key)
                      }, y(u(n)("opc.retry")), 9, OY)) : D("", !0),
                      Y.status !== "running" ? (p(), h("button", {
                        key: 3,
                        type: "button",
                        class: "fe-opc__x",
                        "aria-label": u(n)("opc.dismiss"),
                        onClick: (ie) => e.center.dismiss(Y.key)
                      }, "×", 8, DY)) : D("", !0)
                    ])
                  ], 2))), 128))
                ])
              ])) : D("", !0),
              d.value.length > 0 ? (p(), h("div", LY, [
                c("h3", RY, [
                  Ht(y(u(n)("opc.history")) + " ", 1),
                  c("button", {
                    type: "button",
                    class: "fe-opc__act",
                    onClick: G[1] || (G[1] = (Y) => e.center.clearHistory())
                  }, y(u(n)("opc.clear")), 1)
                ]),
                c("ul", NY, [
                  (p(!0), h(Ce, null, ot(d.value, (Y) => (p(), h("li", {
                    key: "h-" + Y.key,
                    class: Fe(["fe-opc__item fe-opc__item--history", `is-${Y.status}`])
                  }, [
                    (p(), h("svg", IY, [
                      c("path", {
                        d: A[Y.kind]
                      }, null, 8, BY)
                    ])),
                    c("div", FY, [
                      c("div", {
                        class: "fe-opc__name",
                        title: N(Y)
                      }, y(N(Y)), 9, UY),
                      z(Y) ? (p(), h("div", HY, [
                        c("span", {
                          class: "fe-opc__outmode",
                          title: L(Y),
                          "data-testid": "opc-output-mode"
                        }, y(z(Y)), 9, KY)
                      ])) : D("", !0),
                      Y.status === "error" && Y.error ? (p(), h("div", VY, y(Y.error), 1)) : D("", !0),
                      Y.status === "error" && Y.errorDetail ? (p(), h("div", jY, y(Y.errorDetail), 1)) : D("", !0)
                    ]),
                    O(Y) ? (p(), h("button", {
                      key: 0,
                      type: "button",
                      class: "fe-opc__act",
                      onClick: (ie) => e.center.open(Y.key)
                    }, y(u(n)("opc.open")), 9, qY)) : D("", !0),
                    c("span", {
                      class: Fe(["fe-opc__chip", `is-${Y.status}`])
                    }, y(U(Y)), 3)
                  ], 2))), 128))
                ])
              ])) : D("", !0),
              l.value.length === 0 && d.value.length === 0 ? (p(), h("p", WY, y(u(n)("opc.empty")), 1)) : D("", !0)
            ])
          ], 8, fY)) : D("", !0)
        ]),
        _: 1
      }),
      c("button", {
        type: "button",
        class: Fe(["fe-opc__badge", { "is-error": f.value }]),
        "aria-expanded": i.value,
        "aria-label": M.value,
        onClick: G[2] || (G[2] = (Y) => i.value = !i.value)
      }, [
        (p(), h("svg", {
          class: Fe(["fe-opc__ring", { "fe-opc__ring--spin": k.value }]),
          viewBox: "0 0 22 22",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          c("circle", {
            class: "fe-opc__ring-track",
            cx: "11",
            cy: "11",
            r: Im,
            fill: "none",
            "stroke-width": "2.5"
          }),
          c("circle", {
            class: "fe-opc__ring-fill",
            cx: "11",
            cy: "11",
            r: Im,
            fill: "none",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-dasharray": _,
            "stroke-dashoffset": w.value,
            transform: "rotate(-90 11 11)"
          }, null, 8, GY)
        ], 2)),
        c("span", XY, y(l.value.length), 1),
        x.value ? (p(), h("span", JY, y(x.value), 1)) : D("", !0)
      ], 10, YY)
    ], 2)) : D("", !0);
  }
}), QY = 4e3, E1 = 50;
function eG(e, t, n) {
  const a = t.status !== "running";
  return {
    key: e,
    kind: t.kind,
    name: t.name,
    percent: t.percent,
    status: t.status,
    error: t.error ?? null,
    errorDetail: t.errorDetail ?? null,
    queued: t.queued ?? !1,
    cancelling: t.cancelling ?? !1,
    doneCount: t.doneCount ?? null,
    totalCount: t.totalCount ?? null,
    itemsDone: t.itemsDone ?? null,
    itemsTotal: t.itemsTotal ?? null,
    uploadedBytes: t.uploadedBytes ?? null,
    totalBytes: t.totalBytes ?? null,
    cancellable: t.cancellable ?? !1,
    retryable: t.retryable ?? !1,
    message: t.message ?? null,
    outputs: t.outputs ?? [],
    outputMode: t.outputMode ?? null,
    startedAt: (n == null ? void 0 : n.startedAt) ?? Date.now(),
    settledAt: (n == null ? void 0 : n.settledAt) ?? (a ? Date.now() : null)
  };
}
function tG() {
  const e = $([]), t = $([]), n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map();
  function r(z) {
    const L = i.get(z);
    L !== void 0 && (clearTimeout(L), i.delete(z));
  }
  function l(z, L = {}) {
    r(z);
    const B = e.value.findIndex((U) => U.key === z);
    if (B === -1) return;
    const [O] = e.value.splice(B, 1);
    e.value = [...e.value], a.add(z), L.toHistory !== !1 && (t.value = [{ ...O, settledAt: O.settledAt ?? Date.now() }, ...t.value].slice(
      0,
      E1
    ));
  }
  function d(z) {
    i.has(z) || i.set(
      z,
      setTimeout(() => {
        var B;
        i.delete(z);
        const L = n.get(z);
        l(z), (B = L == null ? void 0 : L.dismiss) == null || B.call(L);
      }, QY)
    );
  }
  function f(z, L) {
    const B = `${z}:`, O = /* @__PURE__ */ new Set();
    let U = [...e.value], S = !1;
    for (const F of L) {
      const I = `${z}:${F.input.id}`;
      if (O.add(I), F.actions && n.set(I, F.actions), a.has(I)) continue;
      const G = U.findIndex((ie) => ie.key === I), Y = eG(I, F.input, G === -1 ? void 0 : U[G]);
      G === -1 ? (U = [Y, ...U], S = !0) : JSON.stringify(U[G]) !== JSON.stringify(Y) && (U[G] = Y, S = !0), (Y.status === "done" || Y.status === "aborted") && d(I);
    }
    for (const F of [...U])
      !F.key.startsWith(B) || O.has(F.key) || F.status !== "error" && (r(F.key), U = U.filter((I) => I.key !== F.key), S = !0, F.status !== "running" && (a.add(F.key), t.value = [{ ...F, settledAt: F.settledAt ?? Date.now() }, ...t.value].slice(
        0,
        E1
      )));
    for (const F of [...a])
      F.startsWith(B) && !O.has(F) && a.delete(F);
    for (const F of [...n.keys()])
      if (F.startsWith(B) && !O.has(F) && !e.value.some((I) => I.key === F)) {
        if (U.some((I) => I.key === F) || t.value.some((I) => I.key === F && I.outputs.length > 0)) continue;
        n.delete(F);
      }
    S && (e.value = U);
  }
  function m(z) {
    var L, B;
    (B = (L = n.get(z)) == null ? void 0 : L.cancel) == null || B.call(L);
  }
  function v(z) {
    var B, O;
    const L = n.get(z);
    l(z), (B = L == null ? void 0 : L.dismiss) == null || B.call(L), (O = L == null ? void 0 : L.retry) == null || O.call(L);
  }
  function b(z) {
    var B;
    const L = n.get(z);
    l(z), (B = L == null ? void 0 : L.dismiss) == null || B.call(L);
  }
  function _(z, L) {
    var U, S;
    const B = e.value.find((F) => F.key === z) ?? t.value.find((F) => F.key === z), O = L ?? (B == null ? void 0 : B.outputs[0]);
    O && ((S = (U = n.get(z)) == null ? void 0 : U.open) == null || S.call(U, O));
  }
  function w() {
    t.value = [];
  }
  const k = $(0);
  function x() {
    k.value += 1;
  }
  const M = E(
    () => e.value.filter((z) => z.status === "running").length
  ), A = E(() => e.value.filter((z) => z.status === "error").length), T = E(() => A.value > 0), N = E(() => {
    const z = e.value.filter((O) => O.status === "running");
    let L = 0, B = 0;
    for (const O of z)
      O.percent !== null && (L += Math.min(1, Math.max(0, O.percent / 100)), B += 1);
    return B === 0 ? null : Math.round(L / B * 100);
  });
  return k0() && ny(() => {
    for (const z of i.values()) clearTimeout(z);
    i.clear();
  }), {
    active: e,
    history: t,
    runningCount: M,
    errorCount: A,
    hasError: T,
    overallPercent: N,
    sync: f,
    cancel: m,
    retry: v,
    dismiss: b,
    open: _,
    clearHistory: w,
    revealRequests: k,
    reveal: x
  };
}
const y$ = "filex.tourDone", C1 = "done", nG = 900, aG = 5e3;
function iG() {
  try {
    return !!localStorage.getItem(y$);
  } catch {
    return !0;
  }
}
function Bm() {
  return iG() || !!yo().tour;
}
let br = null;
function g$() {
  try {
    localStorage.setItem(y$, "1");
  } catch {
  }
  if (!Ep()) return;
  if ($S()) {
    yo().tour || Uo("tour", C1);
    return;
  }
  if (br) return;
  const e = Cp((t) => {
    e(), br = null, t.tour || Uo("tour", C1);
  });
  br = e;
}
function oG(e, t = {}) {
  const n = t.delayMs ?? nG, a = t.accountWaitMs ?? aG;
  let i = !1, r, l, d;
  const f = () => {
    i = !0, r && clearTimeout(r), l && clearTimeout(l), d == null || d();
  };
  if (Bm()) return f;
  const m = () => {
    l && clearTimeout(l), d == null || d(), !(i || Bm()) && (g$(), e());
  };
  return r = setTimeout(() => {
    if (!(i || Bm())) {
      if (!Ep() || KB()) {
        m();
        return;
      }
      l = setTimeout(m, a), d = VB(m);
    }
  }, n), f;
}
function Lce() {
  br == null || br(), br = null;
}
const rG = ["aria-label"], sG = {
  key: 0,
  class: "fe-tabs__scroll"
}, lG = ["aria-selected", "title", "onClick", "onKeydown", "onAuxclick", "onDragstart", "onDragover", "onDragleave", "onDrop"], uG = {
  key: 0,
  class: "fe-tabs__splitdot",
  "aria-hidden": "true"
}, cG = { class: "fe-tabs__label" }, dG = ["aria-label", "title", "onClick"], fG = ["aria-label", "title"], pG = ["aria-label", "title", "aria-pressed"], hG = ["aria-pressed", "title", "aria-label"], mG = /* @__PURE__ */ lt({
  __name: "TabBar",
  props: {
    tabs: {},
    activeId: {},
    locale: {},
    splitEnabled: { type: Boolean },
    splitActive: { type: Boolean },
    inspectorEnabled: { type: Boolean },
    inspectorOpen: { type: Boolean },
    hideTabs: { type: Boolean }
  },
  emits: ["select", "close", "new", "reorder", "toggle-split", "toggle-inspector"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(null), l = $(null);
    function d(k, x) {
      var M;
      r.value = k, x.dataTransfer && (x.dataTransfer.effectAllowed = "move", x.dataTransfer.setData("text/plain", ((M = n.tabs[k]) == null ? void 0 : M.id) ?? ""));
    }
    function f(k, x) {
      r.value !== null && (x.preventDefault(), x.stopPropagation(), x.dataTransfer && (x.dataTransfer.dropEffect = "move"), l.value = k);
    }
    function m(k) {
      l.value === k && (l.value = null);
    }
    function v(k, x) {
      r.value !== null && (x.preventDefault(), x.stopPropagation(), r.value !== k && a("reorder", r.value, k), r.value = null, l.value = null);
    }
    function b() {
      r.value = null, l.value = null;
    }
    function _(k) {
      k.button === 1 && k.preventDefault();
    }
    function w(k, x) {
      x.button === 1 && (x.preventDefault(), x.stopPropagation(), !(n.tabs.length <= 1) && a("close", k));
    }
    return (k, x) => (p(), h("div", {
      class: "fe-tabs",
      role: "tablist",
      "aria-label": u(i)("tabs.strip")
    }, [
      e.hideTabs ? D("", !0) : (p(), h("div", sG, [
        (p(!0), h(Ce, null, ot(e.tabs, (M, A) => (p(), h("div", {
          key: M.id,
          class: Fe(["fe-tabs__tab", {
            "is-active": M.id === e.activeId,
            "is-dragover": l.value === A && r.value !== null && r.value !== A
          }]),
          role: "tab",
          "aria-selected": M.id === e.activeId ? "true" : "false",
          tabindex: "0",
          draggable: "true",
          title: M.label,
          onClick: (T) => a("select", M.id),
          onKeydown: $a(vt((T) => a("select", M.id), ["prevent"]), ["enter"]),
          onMousedown: x[0] || (x[0] = (T) => _(T)),
          onAuxclick: (T) => w(M.id, T),
          onDragstart: (T) => d(A, T),
          onDragover: (T) => f(A, T),
          onDragleave: (T) => m(A),
          onDrop: (T) => v(A, T),
          onDragend: b
        }, [
          M.split ? (p(), h("span", uG)) : D("", !0),
          c("span", cG, [
            c("bdi", null, y(M.label), 1)
          ]),
          e.tabs.length > 1 ? (p(), h("button", {
            key: 1,
            type: "button",
            class: "fe-tabs__close",
            "aria-label": u(i)("tabs.close"),
            title: u(i)("tabs.close"),
            onClick: vt((T) => a("close", M.id), ["stop"])
          }, "×", 8, dG)) : D("", !0)
        ], 42, lG))), 128))
      ])),
      e.hideTabs ? D("", !0) : (p(), h("button", {
        key: 1,
        type: "button",
        class: "fe-tabs__new",
        "aria-label": u(i)("tabs.new"),
        title: u(i)("tabs.new"),
        onClick: x[1] || (x[1] = (M) => a("new"))
      }, "+", 8, fG)),
      e.splitEnabled !== !1 ? (p(), h("button", {
        key: 2,
        type: "button",
        class: Fe(["fe-tabs__split", { "is-active": e.splitActive }]),
        "aria-label": e.splitActive ? u(i)("tabs.split_off") : u(i)("tabs.split"),
        title: e.splitActive ? u(i)("tabs.split_off") : u(i)("tabs.split"),
        "aria-pressed": e.splitActive ? "true" : "false",
        "data-testid": "tabs-split",
        onClick: x[2] || (x[2] = (M) => a("toggle-split"))
      }, [...x[4] || (x[4] = [
        c("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          c("rect", {
            x: "3",
            y: "4",
            width: "18",
            height: "16",
            rx: "2"
          }),
          c("path", { d: "M12 4v16" })
        ], -1)
      ])], 10, pG)) : D("", !0),
      e.inspectorEnabled ? (p(), h("button", {
        key: 3,
        type: "button",
        class: Fe(["fe-tabs__inspector", { "is-active": e.inspectorOpen }]),
        "aria-pressed": e.inspectorOpen ? "true" : "false",
        title: u(i)("toolbar.inspector"),
        "aria-label": u(i)("toolbar.inspector"),
        "data-testid": "tabs-inspector",
        onClick: x[3] || (x[3] = (M) => a("toggle-inspector"))
      }, [...x[5] || (x[5] = [
        c("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          c("circle", {
            cx: "12",
            cy: "12",
            r: "9"
          }),
          c("path", { d: "M12 11v5" }),
          c("circle", {
            cx: "12",
            cy: "7.6",
            r: "1",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 10, hG)) : D("", !0)
    ], 8, rG));
  }
}), b$ = Symbol("filex.e2eLock"), vG = ["width", "height"], yG = { class: "fe-state__title" }, gG = { class: "fe-state__hint" }, bG = ["placeholder", "aria-label", "disabled"], kG = ["disabled"], wG = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, k$ = /* @__PURE__ */ lt({
  __name: "E2eLockScreen",
  props: {
    locale: {},
    busy: { type: Boolean, default: !1 },
    error: { default: "" },
    showRecovery: { type: Boolean, default: !0 },
    compact: { type: Boolean, default: !1 }
  },
  emits: ["unlock", "recovery"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = yt(() => a.locale), l = $("");
    function d() {
      !l.value || a.busy || i("unlock", l.value);
    }
    return t({ clear: () => l.value = "" }), (f, m) => (p(), h("div", {
      class: Fe(["fe-state fe-e2e-lock", { "fe-e2e-lock--compact": e.compact }]),
      "data-testid": "e2e-lock"
    }, [
      (p(), h("svg", {
        class: "fe-state__art",
        viewBox: "0 0 120 100",
        width: e.compact ? 80 : 110,
        height: e.compact ? 67 : 92,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true"
      }, [...m[2] || (m[2] = [
        c("rect", {
          x: "38",
          y: "44",
          width: "44",
          height: "34",
          rx: "6"
        }, null, -1),
        c("path", { d: "M46 44v-8a14 14 0 0 1 28 0v8" }, null, -1),
        c("circle", {
          cx: "60",
          cy: "59",
          r: "3",
          fill: "currentColor",
          stroke: "none"
        }, null, -1),
        c("path", { d: "M60 62v7" }, null, -1)
      ])], 8, vG)),
      c("p", yG, y(u(r)("e2e.locked.title")), 1),
      c("p", gG, y(u(r)("e2e.locked.hint")), 1),
      c("form", {
        class: "fe-e2e-lock__form",
        onSubmit: vt(d, ["prevent"])
      }, [
        un(c("input", {
          "onUpdate:modelValue": m[0] || (m[0] = (v) => l.value = v),
          type: "password",
          class: "fe-input fe-e2e-lock__input",
          placeholder: u(r)("e2e.locked.pw_placeholder"),
          "aria-label": u(r)("e2e.locked.pw_placeholder"),
          autocomplete: "current-password",
          disabled: e.busy
        }, null, 8, bG), [
          [bn, l.value]
        ]),
        c("button", {
          type: "submit",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || !l.value
        }, y(e.busy ? u(r)("e2e.locked.busy") : u(r)("e2e.locked.unlock")), 9, kG)
      ], 32),
      e.error ? (p(), h("p", wG, y(e.error), 1)) : D("", !0),
      e.showRecovery ? (p(), h("button", {
        key: 1,
        type: "button",
        class: "fe-e2e-optlink",
        onClick: m[1] || (m[1] = (v) => i("recovery"))
      }, y(u(r)("e2e.locked.use_recovery")), 1)) : D("", !0)
    ], 2));
  }
}), _G = ["aria-label"], xG = ["aria-current", "title", "aria-label"], SG = ["innerHTML"], $G = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, TG = ["aria-current", "onClick", "onContextmenu", "onDrop"], AG = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, EG = ["aria-expanded", "aria-label", "title"], CG = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, zG = ["onClick"], MG = ["aria-current", "onClick", "onContextmenu", "onDrop"], PG = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, OG = ["aria-expanded", "title", "aria-label"], DG = ["innerHTML"], LG = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, RG = ["onClick"], NG = {
  key: 0,
  class: "fe-breadcrumb__menu-empty"
}, IG = ["title", "aria-label"], BG = ["innerHTML"], FG = ["placeholder", "onKeydown"], UG = 4, HG = /* @__PURE__ */ lt({
  __name: "Breadcrumb",
  props: {
    dirname: {},
    adapter: {},
    rootLabel: {},
    locale: {},
    multiStorageRoot: { type: Boolean },
    rootPath: {},
    subfolders: {}
  },
  emits: ["navigate", "copy-path", "crumb-context", "crumb-drop"],
  setup(e, { emit: t }) {
    const n = e, a = E(() => {
      if (!n.rootPath) return "";
      const K = n.rootPath, ce = K.indexOf("://");
      return (ce >= 0 ? K.slice(ce + 3) : K).replace(/^\/+|\/+$/g, "");
    }), i = E(() => {
      const K = a.value;
      if (!K) return n.rootLabel || n.adapter;
      const ce = K.split("/");
      return ce[ce.length - 1] || n.rootLabel || n.adapter;
    }), { t: r } = yt(() => n.locale), l = Hi(Tc, null), d = t, f = E(() => {
      const K = n.adapter ? `${n.adapter}://` : "", ce = K && n.dirname.startsWith(K) ? n.dirname.slice(K.length) : n.dirname, J = ce.split("/").filter(Boolean), H = (it) => (l == null ? void 0 : l.segmentLabel(it)) ?? null, X = [];
      if (n.rootPath) {
        const it = a.value, Re = ce.replace(/^\/+|\/+$/g, ""), Be = it && (Re === it || Re.startsWith(it + "/")) ? Re.slice(it.length).replace(/^\/+/, "") : "";
        X.push({ label: i.value, adapterPath: n.rootPath });
        let We = it;
        for (const bt of Be.split("/").filter(Boolean))
          We = We ? `${We}/${bt}` : bt, X.push({
            label: Nf(bt, r) || H(`${K}${We}`) || bt,
            adapterPath: `${K}${We}`
          });
        return X;
      }
      n.multiStorageRoot ? (X.push({ label: "/", adapterPath: "" }), n.adapter && X.push({ label: n.rootLabel || n.adapter, adapterPath: K })) : (n.adapter || n.rootLabel) && X.push({
        label: n.rootLabel || n.adapter,
        adapterPath: K
      });
      let we = "";
      for (const it of J) {
        we = we ? `${we}/${it}` : it;
        const Re = Nf(it, r) || H(`${K}${we}`) || it;
        X.push({ label: Re, adapterPath: `${K}${we}` });
      }
      return X;
    }), m = E(() => {
      const K = f.value[0];
      return K && n.multiStorageRoot && K.adapterPath === "" ? K : null;
    }), v = E(
      () => m.value ? f.value.slice(1) : f.value
    ), b = E(() => !!m.value && v.value.length === 0), _ = E(() => v.value.length > UG), w = E(
      () => _.value ? v.value.slice(0, 1) : v.value
    ), k = E(
      () => _.value ? v.value.slice(1, -2) : []
    ), x = E(
      () => _.value ? v.value.slice(-2) : []
    ), M = $(!1), A = $(null), T = $(!1), N = $(null), z = E(() => M.value || T.value);
    function L() {
      M.value = !1, T.value = !1;
    }
    function B(K) {
      L(), d("navigate", K.adapterPath);
    }
    function O() {
      M.value = !1, T.value = !T.value;
    }
    function U(K) {
      var J, H;
      const ce = K.target;
      if (!(ce instanceof Node)) {
        L();
        return;
      }
      (J = A.value) != null && J.contains(ce) || (H = N.value) != null && H.contains(ce) || L();
    }
    function S(K) {
      K.key === "Escape" && (K.stopPropagation(), L());
    }
    Xe(z, (K) => {
      K ? (document.addEventListener("click", U, !0), document.addEventListener("keydown", S, !0)) : (document.removeEventListener("click", U, !0), document.removeEventListener("keydown", S, !0));
    }), Xe(f, L), Ot(() => {
      document.removeEventListener("click", U, !0), document.removeEventListener("keydown", S, !0);
    });
    function F(K) {
      d("navigate", K.adapterPath);
    }
    function I() {
      m.value && F(m.value);
    }
    function G(K) {
      m.value && ie(K, m.value);
    }
    function Y(K) {
      m.value && q(K, m.value);
    }
    function ie(K, ce) {
      K.preventDefault(), K.stopPropagation(), d("crumb-context", {
        x: K.clientX,
        y: K.clientY,
        adapterPath: ce.adapterPath,
        label: ce.label
      });
    }
    function me(K) {
      Xa(K) && (K.preventDefault(), K.stopPropagation(), K.dataTransfer && (K.dataTransfer.dropEffect = "move"));
    }
    function q(K, ce) {
      Xa(K) && (K.preventDefault(), K.stopPropagation(), d("crumb-drop", ce.adapterPath, K));
    }
    const C = $(!1), re = $(""), de = $(null);
    function V() {
      const K = `${n.adapter}://`, ce = n.dirname.startsWith(K) ? n.dirname.slice(K.length) : n.dirname;
      if (n.rootPath) {
        const J = a.value, H = ce.replace(/^\/+|\/+$/g, ""), X = J && (H === J || H.startsWith(J + "/")) ? H.slice(J.length).replace(/^\/+/, "") : "";
        re.value = X ? `/${X}` : "/", C.value = !0, Zt(() => {
          var we, it;
          (we = de.value) == null || we.focus(), (it = de.value) == null || it.select();
        });
        return;
      }
      if (n.multiStorageRoot)
        if (!n.adapter)
          re.value = "/";
        else {
          const J = ce.replace(/^\/+|\/+$/g, "");
          re.value = J ? `/${n.adapter}/${J}` : `/${n.adapter}`;
        }
      else
        re.value = ce;
      C.value = !0, Zt(() => {
        var J, H;
        (J = de.value) == null || J.focus(), (H = de.value) == null || H.select();
      });
    }
    function W() {
      const K = re.value.trim();
      if (C.value = !1, n.rootPath) {
        const J = K.replace(/^\/+|\/+$/g, ""), H = a.value, X = J ? H ? `${H}/${J}` : J : H;
        d("navigate", X ? `${n.adapter}://${X}` : `${n.adapter}://`);
        return;
      }
      if (n.multiStorageRoot) {
        const J = K.replace(/^\/+|\/+$/g, "");
        if (!J) {
          d("navigate", "");
          return;
        }
        const H = J.indexOf("/"), X = H === -1 ? J : J.slice(0, H), we = H === -1 ? "" : J.slice(H + 1);
        d("navigate", we ? `${X}://${we}` : `${X}://`);
        return;
      }
      const ce = K.replace(/^\/+|\/+$/g, "");
      ce && d("navigate", `${n.adapter}://${ce}`);
    }
    function ne() {
      C.value = !1;
    }
    return (K, ce) => (p(), h("nav", {
      class: "fe-breadcrumb",
      "aria-label": u(r)("breadcrumb.aria")
    }, [
      C.value ? un((p(), h("input", {
        key: 1,
        ref_key: "pathInput",
        ref: de,
        "onUpdate:modelValue": ce[1] || (ce[1] = (J) => re.value = J),
        type: "text",
        class: "fe-breadcrumb__input",
        placeholder: u(r)("breadcrumb.path_placeholder"),
        spellcheck: "false",
        autocomplete: "off",
        onKeydown: [
          $a(vt(W, ["prevent"]), ["enter"]),
          $a(vt(ne, ["prevent"]), ["escape"])
        ],
        onBlur: ne
      }, null, 40, FG)), [
        [bn, re.value]
      ]) : (p(), h(Ce, { key: 0 }, [
        m.value ? (p(), h("button", {
          key: 0,
          type: "button",
          class: Fe(["fe-breadcrumb__crumb fe-breadcrumb__home", { "is-last": b.value }]),
          "aria-current": b.value ? "page" : void 0,
          title: u(r)("breadcrumb.root"),
          "aria-label": u(r)("breadcrumb.root"),
          "data-testid": "breadcrumb-home",
          onClick: I,
          onContextmenu: G,
          onDragover: me,
          onDrop: Y
        }, [
          c("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(zt)("home")
          }, null, 8, SG),
          b.value ? D("", !0) : (p(), h("span", $G, "›"))
        ], 42, xG)) : D("", !0),
        (p(!0), h(Ce, null, ot(w.value, (J, H) => (p(), h("button", {
          key: J.adapterPath,
          class: Fe(["fe-breadcrumb__crumb", { "is-last": !_.value && H === w.value.length - 1 }]),
          type: "button",
          "aria-current": !_.value && H === w.value.length - 1 ? "page" : void 0,
          onClick: (X) => F(J),
          onContextmenu: (X) => ie(X, J),
          onDragover: me,
          onDrop: (X) => q(X, J)
        }, [
          c("span", null, [
            c("bdi", null, y(J.label), 1)
          ]),
          _.value || H < w.value.length - 1 ? (p(), h("span", AG, "›")) : D("", !0)
        ], 42, TG))), 128)),
        k.value.length ? (p(), h("span", {
          key: 1,
          ref_key: "moreWrapEl",
          ref: A,
          class: "fe-breadcrumb__more-wrap"
        }, [
          c("button", {
            type: "button",
            class: "fe-breadcrumb__more",
            "aria-haspopup": "menu",
            "aria-expanded": M.value,
            "aria-label": u(r)("breadcrumb.more"),
            title: u(r)("breadcrumb.more"),
            onClick: ce[0] || (ce[0] = (J) => M.value = !M.value)
          }, "…", 8, EG),
          ce[2] || (ce[2] = c("span", {
            class: "fe-breadcrumb__sep",
            "aria-hidden": "true"
          }, "›", -1)),
          M.value ? (p(), h("div", CG, [
            (p(!0), h(Ce, null, ot(k.value, (J) => (p(), h("button", {
              key: J.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (H) => B(J)
            }, [
              c("bdi", null, y(J.label), 1)
            ], 8, zG))), 128))
          ])) : D("", !0)
        ], 512)) : D("", !0),
        (p(!0), h(Ce, null, ot(x.value, (J, H) => (p(), h("button", {
          key: J.adapterPath,
          class: Fe(["fe-breadcrumb__crumb", { "is-last": H === x.value.length - 1 }]),
          type: "button",
          "aria-current": H === x.value.length - 1 ? "page" : void 0,
          onClick: (X) => F(J),
          onContextmenu: (X) => ie(X, J),
          onDragover: me,
          onDrop: (X) => q(X, J)
        }, [
          c("span", null, [
            c("bdi", null, y(J.label), 1)
          ]),
          H < x.value.length - 1 ? (p(), h("span", PG, "›")) : D("", !0)
        ], 42, MG))), 128)),
        e.subfolders ? (p(), h("span", {
          key: 2,
          ref_key: "subWrapEl",
          ref: N,
          class: "fe-breadcrumb__sub-wrap"
        }, [
          c("button", {
            type: "button",
            class: "fe-breadcrumb__sub",
            "aria-haspopup": "menu",
            "aria-expanded": T.value,
            title: u(r)("breadcrumb.subfolders"),
            "aria-label": u(r)("breadcrumb.subfolders"),
            "data-testid": "breadcrumb-subfolders",
            onClick: O
          }, [
            c("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("subfolders")
            }, null, 8, DG)
          ], 8, OG),
          T.value ? (p(), h("div", LG, [
            (p(!0), h(Ce, null, ot(e.subfolders, (J) => (p(), h("button", {
              key: J.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (H) => B(J)
            }, [
              c("bdi", null, y(J.label), 1)
            ], 8, RG))), 128)),
            e.subfolders.length ? D("", !0) : (p(), h("p", NG, y(u(r)("breadcrumb.subfolders.empty")), 1))
          ])) : D("", !0)
        ], 512)) : D("", !0),
        c("button", {
          type: "button",
          class: "fe-breadcrumb__edit",
          title: u(r)("breadcrumb.go_to_path"),
          "aria-label": u(r)("breadcrumb.go_to_path"),
          "data-testid": "breadcrumb-edit-path",
          onClick: V
        }, [
          c("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(zt)("edit-path")
          }, null, 8, BG)
        ], 8, IG)
      ], 64))
    ], 8, _G));
  }
}), KG = ["data-mode"], VG = ["aria-label"], jG = ["aria-expanded", "data-testid", "onClick"], qG = { class: "fe-filterbar__label" }, WG = { class: "fe-filterbar__find" }, YG = ["placeholder", "aria-label", "value", "onKeydown"], GG = {
  key: 2,
  class: "fe-filterbar__count",
  role: "status",
  "data-testid": "filter-count"
}, XG = {
  key: 3,
  class: "fe-filterbar__sort"
}, JG = ["disabled", "title"], ZG = { class: "fe-sr-only" }, QG = {
  key: 0,
  class: "fe-ficon fe-filterbar__sortarrow",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, eX = ["aria-label", "title", "disabled", "aria-expanded"], tX = ["aria-label", "title", "aria-expanded"], nX = ["dir", "role", "aria-label"], aX = {
  key: 0,
  class: "fe-filterpop__rule",
  "aria-hidden": "true"
}, iX = ["disabled", "aria-disabled", "data-testid", "onClick"], oX = ["data-active", "data-testid", "onClick"], rX = ["aria-selected", "data-checked", "data-active", "data-testid", "onClick"], sX = {
  class: "fe-filterpop__tick",
  "aria-hidden": "true"
}, lX = /* @__PURE__ */ lt({
  __name: "FilterBar",
  props: {
    value: {},
    locale: {},
    theme: {},
    shown: {},
    total: {},
    files: {},
    canPaste: { type: Boolean },
    canWrite: { type: Boolean },
    order: {},
    mode: {},
    findLabel: {}
  },
  emits: ["update:value", "new-folder", "upload", "paste", "select-all"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, dir: r } = yt(() => n.locale), l = E(() => (n.mode ?? "full") === "full"), d = E(() => n.findLabel || i("filter.find")), f = ["type", "people", "modified", "size"], m = [
      "any",
      "folder",
      "document",
      "spreadsheet",
      "presentation",
      "pdf",
      "image",
      "video",
      "audio",
      "archive",
      "code"
    ], v = ["any", "today", "7d", "30d", "year"], b = ["any", "lt1", "1to10", "10to100", "gt100"], _ = E(() => ZL(n.files ?? []));
    function w(at) {
      return at === "people" ? _.value.map((Ie) => Ie.value) : at === "type" ? m : at === "modified" ? v : b;
    }
    function k(at, Ie) {
      var nt;
      return at === "people" && Ie.startsWith("u:") ? ((nt = _.value.find((dt) => dt.value === Ie)) == null ? void 0 : nt.name) || Ie.slice(2) : i(`filter.${at}.${Ie}`);
    }
    function x(at) {
      const Ie = at === "people" ? n.value.people ?? "any" : n.value[at];
      return Ie === "any" ? i(`filter.${at}`) : k(at, Ie);
    }
    function M(at) {
      return at === "people" ? n.value.people ?? "any" : n.value[at];
    }
    const A = E(() => HL(n.value)), T = $c(), N = E(() => T.key.value), z = E(() => T.dir.value === "asc"), L = E(() => n.order === "relevance"), B = E(() => L.value ? i("sort.relevance") : i(`col.${N.value}`)), O = E(
      () => L.value ? i("sort.relevance_why") : i(z.value ? "sort.asc" : "sort.desc")
    );
    Xe(() => n.locale, (at) => Vy(at), { immediate: !0 });
    function U(at) {
      T.setSort(at), J(!0);
    }
    function S() {
      L.value || T.toggleSortDir();
    }
    function F() {
      L.value || ce("sort");
    }
    const I = E(() => [
      { key: "new-folder", label: i("toolbar.new_folder"), disabled: n.canWrite === !1 },
      { key: "upload", label: i("toolbar.upload"), disabled: n.canWrite === !1 },
      { key: "paste", label: i("ctx.paste"), disabled: !n.canPaste || n.canWrite === !1 },
      { key: "sep", label: "", divider: !0, disabled: !0 },
      { key: "select-all", label: i("shortcuts.select_all"), disabled: !1 }
    ]);
    function G(at) {
      J(!0), at === "new-folder" ? a("new-folder") : at === "upload" ? a("upload") : at === "paste" ? a("paste") : at === "select-all" && a("select-all");
    }
    const Y = $(null), ie = $({ x: 0, y: 0 }), me = $(null), q = $({});
    function C(at, Ie) {
      q.value[at] = Ie ?? null;
    }
    const re = E(
      () => Y.value && Y.value !== "sort" && Y.value !== "actions" ? Y.value : null
    ), de = E(() => re.value ? w(re.value) : []), V = E(
      () => re.value ? i(`filter.${re.value}`) : Y.value === "actions" ? i("filter.actions") : i("sort.by")
    );
    function W(at) {
      return !!re.value && M(re.value) === at;
    }
    function ne(at) {
      return re.value ? k(re.value, at) : at;
    }
    function K(at) {
      re.value && H(re.value, at);
    }
    async function ce(at) {
      var Me, be, Ve;
      if (Y.value === at) {
        J();
        return;
      }
      const Ie = (Me = q.value[at]) == null ? void 0 : Me.getBoundingClientRect(), nt = Ie ? Ar(Ie, r.value) : 8;
      ie.value = { x: nt, y: Ie ? Ie.bottom + 6 : 8 }, Y.value = at, await Zt();
      const dt = me.value;
      if (dt) {
        const Te = dt.getBoundingClientRect();
        if (ie.value = { ...ie.value, x: pc(nt, Te.width, window.innerWidth, r.value) }, Te.bottom > window.innerHeight - 8) {
          const qe = (be = q.value[at]) == null ? void 0 : be.getBoundingClientRect();
          ie.value = { ...ie.value, y: Math.max(8, (qe ? qe.top : 0) - Te.height - 6) };
        }
        (Ve = dt.querySelector('[data-active="true"]')) == null || Ve.focus();
      }
    }
    function J(at = !1) {
      var nt;
      const Ie = Y.value;
      Y.value = null, at && Ie && ((nt = q.value[Ie]) == null || nt.focus());
    }
    Xe(
      () => n.order,
      (at) => {
        at === "relevance" && Y.value === "sort" && J();
      }
    );
    function H(at, Ie) {
      a("update:value", { ...n.value, [at]: Ie }), J(!0);
    }
    function X() {
      we.value = "", a("update:value", {
        ...n.value,
        type: "any",
        modified: "any",
        size: "any",
        name: "",
        people: "any"
      });
    }
    const we = $(n.value.name ?? "");
    Xe(
      () => n.value.name ?? "",
      (at) => {
        at !== we.value.trim() && (we.value = at);
      }
    );
    let it;
    function Re(at) {
      we.value = at.target.value, it && clearTimeout(it), it = setTimeout(() => {
        a("update:value", { ...n.value, name: we.value.trim() });
      }, 140);
    }
    function Be() {
      it && clearTimeout(it), we.value = "", a("update:value", { ...n.value, name: "" });
    }
    Ot(() => {
      it && clearTimeout(it);
    });
    function We(at) {
      var nt;
      if (!Y.value) return;
      const Ie = at.target;
      (nt = me.value) != null && nt.contains(Ie) || Object.values(q.value).some((dt) => dt == null ? void 0 : dt.contains(Ie)) || J();
    }
    function bt(at) {
      at.key === "Escape" && Y.value && (at.stopPropagation(), J(!0));
    }
    return Wt(() => {
      document.addEventListener("pointerdown", We, !0), document.addEventListener("keydown", bt, !0);
    }), Ot(() => {
      document.removeEventListener("pointerdown", We, !0), document.removeEventListener("keydown", bt, !0);
    }), (at, Ie) => (p(), h("div", {
      class: "fe-filterbar",
      "data-mode": l.value ? "full" : "find",
      "data-testid": "filterbar"
    }, [
      l.value ? (p(), h("div", {
        key: 0,
        class: "fe-filterbar__chips",
        role: "group",
        "aria-label": u(i)("filter.aria")
      }, [
        (p(), h(Ce, null, ot(f, (nt) => c("button", {
          key: nt,
          ref_for: !0,
          ref: (dt) => C(nt, dt),
          type: "button",
          class: Fe(["fe-filterbar__chip", { "is-set": M(nt) !== "any", "is-open": Y.value === nt }]),
          "aria-expanded": Y.value === nt,
          "aria-haspopup": "listbox",
          "data-testid": `filter-${nt}`,
          onClick: (dt) => ce(nt)
        }, [
          c("span", qG, y(x(nt)), 1),
          Ie[3] || (Ie[3] = c("svg", {
            class: "fe-ficon fe-filterbar__caret",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            c("path", { d: "M7 10l5 5 5-5" })
          ], -1))
        ], 10, jG)), 64))
      ], 8, VG)) : D("", !0),
      c("div", WG, [
        Ie[4] || (Ie[4] = c("svg", {
          class: "fe-ficon fe-filterbar__find-glass",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.9",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          c("circle", {
            cx: "11",
            cy: "11",
            r: "6.5"
          }),
          c("path", { d: "M16 16l4.5 4.5" })
        ], -1)),
        c("input", {
          type: "search",
          class: "fe-filterbar__find-input",
          placeholder: d.value,
          "aria-label": d.value,
          value: we.value,
          "data-testid": "filter-find",
          onInput: Re,
          onKeydown: $a(vt(Be, ["stop", "prevent"]), ["esc"])
        }, null, 40, YG)
      ]),
      l.value && A.value > 0 ? (p(), h("button", {
        key: 1,
        type: "button",
        class: "fe-filterbar__clear",
        "data-testid": "filter-clear",
        onClick: X
      }, y(u(i)("filter.clear")), 1)) : D("", !0),
      l.value && A.value > 0 && typeof e.shown == "number" && typeof e.total == "number" ? (p(), h("span", GG, y(u(i)("filter.count", { shown: String(e.shown), total: String(e.total) })), 1)) : D("", !0),
      l.value ? (p(), h("div", XG, [
        c("button", {
          ref: (nt) => C("sort", nt),
          type: "button",
          class: Fe(["fe-filterbar__sortdir", { "is-ranked": L.value }]),
          disabled: L.value,
          title: L.value ? O.value : void 0,
          "data-testid": "sort-dir",
          onClick: Ie[0] || (Ie[0] = (nt) => S())
        }, [
          c("span", null, y(B.value), 1),
          c("span", ZG, ", " + y(O.value), 1),
          L.value ? D("", !0) : (p(), h("svg", QG, [
            z.value ? (p(), h(Ce, { key: 0 }, [
              Ie[5] || (Ie[5] = c("path", { d: "M12 19V5" }, null, -1)),
              Ie[6] || (Ie[6] = c("path", { d: "M5 12l7-7 7 7" }, null, -1))
            ], 64)) : (p(), h(Ce, { key: 1 }, [
              Ie[7] || (Ie[7] = c("path", { d: "M12 5v14" }, null, -1)),
              Ie[8] || (Ie[8] = c("path", { d: "M19 12l-7 7-7-7" }, null, -1))
            ], 64))
          ]))
        ], 10, JG),
        c("button", {
          type: "button",
          class: "fe-filterbar__sortpick",
          "aria-label": L.value ? O.value : u(i)("sort.by"),
          title: L.value ? O.value : u(i)("sort.by"),
          disabled: L.value,
          "aria-haspopup": "menu",
          "aria-expanded": Y.value === "sort",
          "data-testid": "sort-menu",
          onClick: Ie[1] || (Ie[1] = (nt) => F())
        }, [...Ie[9] || (Ie[9] = [
          c("svg", {
            class: "fe-ficon fe-filterbar__caret",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            c("path", { d: "M7 10l5 5 5-5" })
          ], -1)
        ])], 8, eX)
      ])) : D("", !0),
      l.value ? (p(), h("button", {
        key: 4,
        ref: (nt) => C("actions", nt),
        type: "button",
        class: "fe-filterbar__actions",
        "aria-label": u(i)("filter.actions"),
        title: u(i)("filter.actions"),
        "aria-haspopup": "menu",
        "aria-expanded": Y.value === "actions",
        "data-testid": "listing-actions",
        onClick: Ie[2] || (Ie[2] = (nt) => ce("actions"))
      }, [...Ie[10] || (Ie[10] = [
        c("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          c("circle", {
            cx: "12",
            cy: "5.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          c("circle", {
            cx: "12",
            cy: "12",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          c("circle", {
            cx: "12",
            cy: "18.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 8, tX)) : D("", !0),
      (p(), Je(hi, { to: "body" }, [
        Y.value ? (p(), h("div", {
          key: 0,
          ref_key: "panelEl",
          ref: me,
          class: Fe(["fe-filterpop", {
            "fe--theme-light": e.theme === "light",
            "fe--theme-dark": e.theme === "dark",
            "fe-filterpop--sort": Y.value === "sort",
            "fe-filterpop--actions": Y.value === "actions"
          }]),
          dir: u(r),
          role: Y.value === "sort" || Y.value === "actions" ? "menu" : "listbox",
          "aria-label": V.value,
          style: Yt({ left: ie.value.x + "px", top: ie.value.y + "px" })
        }, [
          Y.value === "actions" ? (p(!0), h(Ce, { key: 0 }, ot(I.value, (nt) => (p(), h(Ce, {
            key: nt.key
          }, [
            nt.divider ? (p(), h("hr", aX)) : (p(), h("button", {
              key: 1,
              type: "button",
              class: "fe-filterpop__item",
              role: "menuitem",
              disabled: nt.disabled,
              "aria-disabled": nt.disabled,
              "data-active": "false",
              "data-testid": `listing-action-${nt.key}`,
              onClick: (dt) => G(nt.key)
            }, [
              c("span", null, y(nt.label), 1)
            ], 8, iX))
          ], 64))), 128)) : Y.value === "sort" ? (p(!0), h(Ce, { key: 1 }, ot(u(Ky), (nt) => (p(), h("button", {
            key: nt,
            type: "button",
            class: "fe-filterpop__item",
            role: "menuitem",
            "data-active": N.value === nt ? "true" : "false",
            "data-testid": `sort-opt-${nt}`,
            onClick: (dt) => U(nt)
          }, [
            c("span", null, y(u(i)(`col.${nt}`)), 1)
          ], 8, oX))), 128)) : (p(!0), h(Ce, { key: 2 }, ot(de.value, (nt) => (p(), h("button", {
            key: nt,
            type: "button",
            class: "fe-filterpop__item",
            role: "option",
            "aria-selected": W(nt),
            "data-checked": W(nt) ? "true" : "false",
            "data-active": W(nt) ? "true" : "false",
            "data-testid": `filter-opt-${nt}`,
            onClick: (dt) => K(nt)
          }, [
            c("span", sX, y(W(nt) ? "✓" : ""), 1),
            c("span", null, y(ne(nt)), 1)
          ], 8, rX))), 128))
        ], 14, nX)) : D("", !0)
      ]))
    ], 8, KG));
  }
}), uX = ["aria-label"], cX = ["aria-selected", "title", "aria-label"], dX = ["innerHTML"], fX = ["aria-selected", "title", "aria-label"], pX = ["innerHTML"], hX = ["aria-selected", "title", "aria-label"], mX = ["innerHTML"], vX = /* @__PURE__ */ lt({
  __name: "ViewSwitcher",
  props: {
    viewMode: {},
    locale: {},
    modes: {}
  },
  emits: ["update:viewMode"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale);
    function r(l) {
      return !n.modes || n.modes.includes(l);
    }
    return (l, d) => (p(), h("div", {
      class: "fe-toolbar__view",
      role: "tablist",
      "aria-label": u(i)("toolbar.view_label")
    }, [
      r("list") ? (p(), h("button", {
        key: 0,
        type: "button",
        class: Fe(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "list" }]),
        role: "tab",
        "aria-selected": e.viewMode === "list",
        title: u(i)("toolbar.view.list"),
        "aria-label": u(i)("toolbar.view.list"),
        "data-testid": "view-list",
        onClick: d[0] || (d[0] = (f) => a("update:viewMode", "list"))
      }, [
        c("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(zt)("view-list")
        }, null, 8, dX)
      ], 10, cX)) : D("", !0),
      r("grid") ? (p(), h("button", {
        key: 1,
        type: "button",
        class: Fe(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "grid" }]),
        role: "tab",
        "aria-selected": e.viewMode === "grid",
        title: u(i)("toolbar.view.grid"),
        "aria-label": u(i)("toolbar.view.grid"),
        "data-testid": "view-grid",
        onClick: d[1] || (d[1] = (f) => a("update:viewMode", "grid"))
      }, [
        c("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(zt)("view-grid")
        }, null, 8, pX)
      ], 10, fX)) : D("", !0),
      r("gallery") ? (p(), h("button", {
        key: 2,
        type: "button",
        class: Fe(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "gallery" }]),
        role: "tab",
        "aria-selected": e.viewMode === "gallery",
        title: u(i)("toolbar.view.gallery"),
        "aria-label": u(i)("toolbar.view.gallery"),
        "data-testid": "view-gallery",
        onClick: d[2] || (d[2] = (f) => a("update:viewMode", "gallery"))
      }, [
        c("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(zt)("view-gallery")
        }, null, 8, mX)
      ], 10, hX)) : D("", !0)
    ], 8, uX));
  }
});
function yX(e, t) {
  return typeof e != "number" || !Number.isFinite(e) ? "-" : e <= 0 ? t("trash.days_remaining_due") : t("trash.days_remaining", { n: e });
}
const gX = ["aria-label", "innerHTML"], bX = {
  key: 2,
  class: "fe-list__thumb"
}, kX = ["innerHTML"], wX = { class: "fe-list__name-wrap" }, _X = ["title"], xX = {
  key: 0,
  class: "fe-list__badge"
}, SX = ["title", "aria-label"], $X = {
  key: 0,
  class: "fe-list__snippet"
}, TX = {
  key: 0,
  class: "fe-list__mark"
}, AX = ["title", "aria-label"], EX = { class: "tbl-pill__text" }, CX = ["title", "aria-label", "data-link-state"], zX = { class: "tbl-pill__text" }, MX = ["title", "aria-label"], PX = {
  key: 6,
  class: "fe-list__kind"
}, OX = ["title", "aria-label", "onClick"], DX = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, LX = {
  key: 1,
  class: "fe-colmenu__title"
}, RX = {
  key: 2,
  class: "fe-colmenu__hint"
}, NX = ["onClick"], IX = { class: "fe-colmenu__label" }, BX = ["onClick"], FX = { class: "fe-colmenu__label" }, UX = /* @__PURE__ */ lt({
  __name: "ListView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    keepBadgeFor: { type: Function },
    order: {},
    folderKey: {},
    theme: {},
    thumbSrc: { type: Function },
    trash: { type: Boolean }
  },
  emits: ["click-row", "dbl-row", "context-row", "item-drag-start", "item-drop-into", "star-change", "display-order", "peek", "peek-end"],
  setup(e, { emit: t }) {
    const n = e, a = t, {
      t: i,
      formatNodeSize: r,
      nodeSizeHint: l,
      formatDate: d,
      formatDateFull: f,
      formatMonthYear: m,
      zonedYearMonth: v,
      toDate: b,
      nodeDisplayName: _,
      dir: w
    } = yt(() => n.locale);
    function k(Z) {
      return Lr(Ac(Z), { t: i, formatDate: d, locale: n.locale });
    }
    function x(Z) {
      return Ec(Z, { t: i });
    }
    function M(Z) {
      return Cc(Z, { t: i });
    }
    function A(Z) {
      return hg(Z, { t: i });
    }
    function T(Z) {
      return n.selected.has(Z.path);
    }
    function N(Z, ge) {
      a("click-row", Z, dg(ge, Y.isTap(ge)));
    }
    function z(Z) {
      a("dbl-row", Z);
    }
    function L(Z, ge) {
      ge.preventDefault(), ge.stopPropagation(), a("context-row", Z, ge);
    }
    function B(Z, ge) {
      const ae = ge.currentTarget, ve = ae == null ? void 0 : ae.getBoundingClientRect();
      a("context-row", Z, {
        // ⚠ RTL: the button's START corner — its right one in RTL — so the menu
        // hangs from the control and opens the way the line reads.
        clientX: ve ? Ar(ve, w.value) : ge.clientX,
        clientY: ve ? ve.bottom : ge.clientY,
        preventDefault: () => {
        },
        stopPropagation: () => {
        }
      });
    }
    function O(Z, ge) {
      a("click-row", Z, fg(ge));
    }
    function U(Z, ge) {
      kg(
        ge,
        _(Z),
        n.selected.has(Z.path) ? n.selected.size : 1
      ), a("item-drag-start", Z, ge);
    }
    const S = $(null);
    function F(Z, ge) {
      Z.type === "dir" && Xa(ge) && (ge.preventDefault(), ge.stopPropagation(), ge.dataTransfer && (ge.dataTransfer.dropEffect = "move"), S.value = Z.path);
    }
    function I(Z) {
      S.value === Z.path && (S.value = null);
    }
    function G(Z, ge) {
      S.value = null, Z.type === "dir" && Xa(ge) && (ge.preventDefault(), ge.stopPropagation(), a("item-drop-into", Z, ge));
    }
    const Y = pg(
      (Z, ge) => a("context-row", Z, { ...ge, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (Z) => a("click-row", Z, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function ie(Z) {
      return Z === "kept" ? "✓" : Z === "syncing" ? "⟳" : Z === "partial" ? "◐" : "☁";
    }
    function me(Z) {
      return Z.basename === ".trash" || qu(Z);
    }
    function q(Z) {
      return d(Z, { time: !0 }) || "-";
    }
    function C(Z) {
      return f(Z);
    }
    function re(Z) {
      return me(Z) ? "-" : hv(Z, i);
    }
    function de(Z) {
      return Z.type === "dir" || Xf(Z) ? null : n.thumbSrc ? n.thumbSrc(Z) : Z.thumb_url ?? null;
    }
    const V = E(() => n.files.some((Z) => {
      var ge;
      return Z.type === "dir" && (((ge = Z.preview) == null ? void 0 : ge.length) ?? 0) > 0;
    }));
    function W(Z) {
      return n.thumbSrc ? n.thumbSrc(Z) : Z.thumb_url ?? null;
    }
    const ne = E(() => Ie.value.includes("type"));
    function K(Z) {
      return Z.type === "dir" && !me(Z);
    }
    function ce(Z) {
      var ve;
      if ((ve = Z.extra_metadata) != null && ve.draft)
        return i("node.drafts");
      const ge = xr(Z);
      return [String(Z.storage ?? "").trim(), ge].filter(Boolean).join("/");
    }
    function J(Z) {
      const ge = Z.extra_metadata;
      if (ge != null && ge.purging) return i("trash.purging");
      const ae = ge == null ? void 0 : ge.ttl_days;
      return yX(ae, i);
    }
    function H(Z) {
      const ge = Z.snippet;
      return typeof ge == "string" ? ge : "";
    }
    function X(Z) {
      return t7(Z.matched);
    }
    const we = $c(), it = E(() => we.key.value), Re = E(() => n.order === "relevance");
    Xe(() => n.locale, (Z) => Vy(Z), { immediate: !0 });
    const Be = E(
      () => Re.value ? null : { key: it.value, dir: we.dir.value }
    );
    function We(Z) {
      Re.value || Ky.includes(Z.key) && we.chooseSortKey(Z.key);
    }
    const bt = E(() => {
      if (n.trash) return ["type", "location", "owner", "modified", "remaining", "size"];
      const Z = ["type"];
      return n.showParentPath && Z.push("location"), Z.push("owner", "modified", "size"), n.starEnabled !== !1 && (n.apiBase || n.apiBase === "") && Z.push("star"), Z;
    }), at = Ex(() => n.folderKey ?? ""), Ie = E(
      () => at.order().filter((Z) => Z !== "name" && bt.value.includes(Z) && !at.hidden(Z))
    ), nt = E(() => [
      { id: "name", label: i("col.name"), lead: !0, sortable: !0, class: "fe-list__col--name" },
      { id: "type", label: i("col.type"), sortable: !0, class: "fe-list__col--type", format: re },
      {
        id: "location",
        label: n.trash ? i("col.deleted_from") : i("col.location"),
        class: "fe-list__col--location",
        format: ce,
        title: (Z) => ce(Z) || void 0
      },
      {
        id: "owner",
        label: n.trash ? i("col.deleted_by") : i("col.owner"),
        class: "fe-list__col--owner",
        format: n.trash ? xe : kt,
        title: n.trash ? Ne : Tt
      },
      {
        id: "modified",
        label: n.trash ? i("col.deleted") : i("col.modified"),
        sortable: !0,
        sortDir: "desc",
        class: "fe-list__col--mod",
        format: (Z) => q(Z.last_modified),
        title: (Z) => C(Z.last_modified)
      },
      {
        id: "remaining",
        label: i("col.remaining"),
        class: "fe-list__col--remaining",
        format: J
      },
      {
        id: "size",
        label: i("col.size"),
        sortable: !0,
        class: "fe-list__col--size",
        // A folder the catalog does not cover in full says so: "≥ 1.2 GB", or
        // "—" when nothing below it is known (useLocale formatNodeSize).
        format: (Z) => r(Z),
        title: (Z) => l(Z)
      },
      { id: "star", label: i("col.star"), class: "fe-list__col--star", headerLabel: !1 }
    ]);
    function dt(Z) {
      if (!n.showParentPath || Ie.value.includes("location")) return Z.basename;
      const ge = ce(Z);
      return ge ? `${Z.basename} · ${ge}` : Z.basename;
    }
    function Me(Z) {
      const ge = {
        tabindex: 0,
        "aria-label": _(Z),
        "data-fe-path": Z.path,
        draggable: "true"
      };
      return Z.type === "dir" && (ge.onPointerenter = (ae) => a("peek", Z, ae.currentTarget, ae.pointerType), ge.onPointerleave = () => a("peek-end"), ge.onPointerdown = () => a("peek-end")), ge;
    }
    function be(Z) {
      var ge;
      return {
        "is-dir": Z.type === "dir",
        "is-trash": !!Z.trashed,
        "is-clipped": !!((ge = n.clipped) != null && ge.has(Z.path)),
        "is-droptarget": S.value === Z.path
      };
    }
    const Ve = E(() => aL()), Te = E(() => !!n.folderKey && Av(n.folderKey));
    function qe(Z) {
      rL({
        v: "list",
        ...Re.value ? {} : { k: we.key.value, d: we.dir.value },
        c: at.state()
      }), Z();
    }
    function De(Z) {
      n.folderKey && $x(n.folderKey), Z();
    }
    const mt = E(() => {
      const Z = [], ge = [];
      for (const ae of n.files) (me(ae) ? Z : ge).push(ae);
      return [...Z, ...ge.sort(we.compareInOrder(n.order ?? "sort"))];
    }), $t = E(() => ({ t: i, formatMonthYear: m, zonedYearMonth: v }));
    Xe(
      mt,
      (Z) => a("display-order", Z),
      { immediate: !0 }
    );
    function kt(Z) {
      return wp(Z) ? i("owner.you") : ec(Z) === null ? i("owner.system") : Yy(Z) || i("owner.unknown");
    }
    function Tt(Z) {
      const ge = [kt(Z)];
      JL(Z) && ge.push(i("owner.external"));
      const ae = Z.last_actor_name, ve = Z.last_actor_self === !0, le = Z.last_actor_id;
      if (ve || typeof ae == "string" && ae) {
        const _e = ve ? i("owner.you") : String(ae);
        _e !== ge[0] && ge.push(i("owner.last_actor", { who: _e }));
      } else le === void 0 && ec(Z) !== null && ge.push(i("owner.last_actor", { who: i("owner.system") }));
      return ge.join(" · ");
    }
    function xe(Z) {
      return A_(Z) ? i("owner.you") : T_(Z) === null ? "-" : XL(Z) || i("owner.unknown");
    }
    function Ne(Z) {
      return T_(Z) === null && !A_(Z) ? i("trash.deleted_by_nobody") : xe(Z);
    }
    const fe = E(
      () => yg(mt.value, {
        /* ⚠ `ranked` is half of this and not a detail: over a search's ranked
         * answer the key is still `modified` (nothing cleared it), the listing
         * just is not obeying it — see `lib/dateGroups.groupingActive`. */
        active: vg(it.value, n.order),
        dateOf: (Z) => b(Z.last_modified),
        /* ⚠ Folders are their OWN run, above the first date heading, and that is
         * what lets "folders before files" hold while sorted by date. The rule
         * used to be softened instead — rows sorted by date, folders floating to
         * the top of each bucket — because hoisting them all would have split a
         * bucket in two and drawn "Today" twice, once over the folders and once
         * over the files. A run of their own removes that reason, and a folder has
         * no meaningful modification date to file under anyway. */
        aside: (Z) => me(Z) ? { id: "pinned" } : Z.type === "dir" ? { id: "dirs" } : null,
        labels: $t.value
      }).runs
    ), Se = E(
      () => fe.value.map((Z) => ({ id: Z.id, label: Z.label ?? void 0, items: Z.items }))
    );
    return (Z, ge) => (p(), Je(Vr, {
      rows: mt.value,
      groups: Se.value,
      columns: nt.value,
      "column-store": u(at),
      candidates: bt.value,
      metrics: u(Ax),
      "row-key": (ae) => ae.path,
      locale: e.locale,
      theme: e.theme,
      loading: e.loading,
      empty: u(i)("empty.folder"),
      "aria-label": u(i)("list.aria"),
      framed: !1,
      selectable: "",
      "is-selected": T,
      sort: Be.value,
      "sort-closed": Re.value ? u(i)("sort.relevance_why") : null,
      "row-class": be,
      "row-attrs": Me,
      onSort: We,
      onRowClick: N,
      onRowDblclick: z,
      onRowContextmenu: L,
      onCheckClick: O,
      onRowDragstart: U,
      onRowDragover: F,
      onRowDragleave: I,
      onRowDrop: G,
      onRowTouchstart: ge[2] || (ge[2] = (ae, ve) => u(Y).onTouchStart(ae, ve)),
      onRowTouchend: ge[3] || (ge[3] = (ae) => u(Y).onTouchEnd(ae)),
      onRowTouchmove: ge[4] || (ge[4] = (ae) => u(Y).onTouchMove(ae))
    }, {
      "cell-name": gt(({ row: ae }) => [
        u(Mr)(ae) ? (p(), h("span", {
          key: 0,
          class: "fe-list__icon fe-list__icon--svg",
          role: "img",
          "aria-label": u(i)("e2e.badge"),
          innerHTML: u(sl)()
        }, null, 8, gX)) : ae.type === "dir" && V.value ? (p(), Je(bg, {
          key: 1,
          shape: "mini",
          node: ae,
          "src-of": W,
          class: "fe-list__icon"
        }, null, 8, ["node"])) : (p(), h("span", bX, [
          tt(Oc, {
            node: ae,
            "src-of": de,
            "type-badge": u(o$)(ae),
            note: A(ae),
            class: Fe(["fe-list__icon fe-list__icon--img", { "fe-thumb--page": u(mg)(ae) }]),
            alt: "",
            "aria-hidden": "true"
          }, {
            default: gt(() => [
              c("span", {
                class: "fe-list__icon fe-list__icon--svg",
                "aria-hidden": "true",
                innerHTML: u(ya)(ae)
              }, null, 8, kX)
            ]),
            _: 2
          }, 1032, ["node", "type-badge", "note", "class"])
        ])),
        c("div", wX, [
          c("span", {
            class: "fe-list__name",
            title: dt(ae)
          }, [
            c("bdi", null, y(u(_)(ae)), 1),
            X(ae) ? (p(), h("span", xX, y(u(i)("search.in_content")), 1)) : D("", !0),
            e.keepBadgeFor && e.keepBadgeFor(ae) ? (p(), h("span", {
              key: 1,
              class: Fe(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(ae)]),
              title: u(i)("keep.badge_" + e.keepBadgeFor(ae)),
              role: "img",
              "aria-label": u(i)("keep.badge_" + e.keepBadgeFor(ae))
            }, y(ie(e.keepBadgeFor(ae))), 11, SX)) : D("", !0)
          ], 8, _X),
          H(ae) ? (p(), h("span", $X, [
            (p(!0), h(Ce, null, ot(u(qv)(H(ae)), (ve, le) => (p(), h(Ce, { key: le }, [
              ve.match ? (p(), h("mark", TX, y(ve.text), 1)) : (p(), h(Ce, { key: 1 }, [
                Ht(y(ve.text), 1)
              ], 64))
            ], 64))), 128))
          ])) : D("", !0)
        ]),
        k(ae) ? (p(), h("span", {
          key: 3,
          class: "fe-applock tbl-pill",
          role: "img",
          title: k(ae),
          "aria-label": k(ae),
          "data-testid": "lock-badge"
        }, [
          ge[5] || (ge[5] = c("span", {
            class: "fe-applock__glyph",
            "aria-hidden": "true"
          }, "🔒", -1)),
          c("span", EX, y(u(i)("applock.badge")), 1)
        ], 8, AX)) : D("", !0),
        x(ae) ? (p(), h("span", {
          key: 4,
          class: Fe(["fe-symlink tbl-pill", "fe-symlink--" + x(ae).state]),
          role: "img",
          title: x(ae).why,
          "aria-label": x(ae).why,
          "data-testid": "symlink-badge",
          "data-link-state": x(ae).state
        }, [
          ge[6] || (ge[6] = c("span", {
            class: "fe-symlink__glyph",
            "aria-hidden": "true"
          }, "🔗", -1)),
          c("span", zX, y(x(ae).badge), 1)
        ], 10, CX)) : D("", !0),
        M(ae) ? (p(), h("span", {
          key: 5,
          class: "fe-unavailable",
          role: "img",
          title: M(ae).full,
          "aria-label": M(ae).full,
          "data-testid": "unavailable-badge"
        }, y(M(ae).badge), 9, MX)) : D("", !0),
        K(ae) && !ne.value ? (p(), h("span", PX, y(u(i)("node.folder")), 1)) : D("", !0)
      ]),
      "cell-star": gt(({ row: ae }) => {
        var ve;
        return [
          e.starEnabled !== !1 && typeof ae.id == "number" && ae.type === "file" ? (p(), h("span", {
            key: 0,
            class: "fe-list__star-hit",
            "data-fe-control": "",
            onClick: ge[0] || (ge[0] = vt(() => {
            }, ["stop"])),
            onDblclick: ge[1] || (ge[1] = vt(() => {
            }, ["stop"]))
          }, [
            tt(gg, {
              starred: !!((ve = e.starredIds) != null && ve.has(ae.id)),
              "node-id": ae.id,
              "api-base": e.apiBase,
              "auth-headers": e.authHeaders,
              "auth-credentials": e.authCredentials,
              locale: e.locale,
              compact: "",
              onChange: (le) => a("star-change", ae, le)
            }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
          ], 32)) : D("", !0)
        ];
      }),
      actions: gt(({ row: ae }) => [
        c("button", {
          type: "button",
          class: "fe-list__menu",
          title: u(i)("toolbar.more"),
          "aria-label": u(i)("toolbar.more"),
          onClick: (ve) => B(ae, ve)
        }, [...ge[7] || (ge[7] = [
          c("span", { "aria-hidden": "true" }, "⋮", -1)
        ])], 8, OX)
      ]),
      "colmenu-extra": gt(({ close: ae }) => [
        Te.value || Ve.value > 0 ? (p(), h("div", DX)) : D("", !0),
        Te.value || Ve.value > 0 ? (p(), h("p", LX, y(u(i)("cols.folder_title")), 1)) : D("", !0),
        Te.value || Ve.value > 0 ? (p(), h("p", RX, y(u(i)("cols.folder_hint")), 1)) : D("", !0),
        Te.value ? (p(), h("button", {
          key: 3,
          type: "button",
          class: "fe-colmenu__row",
          onClick: (ve) => De(ae)
        }, [
          c("span", IX, y(u(i)("cols.forget_folder")), 1)
        ], 8, NX)) : D("", !0),
        Ve.value > 0 || Te.value ? (p(), h("button", {
          key: 4,
          type: "button",
          class: "fe-colmenu__row",
          onClick: (ve) => qe(ae)
        }, [
          c("span", FX, y(u(i)("cols.apply_all", { count: Ve.value })), 1)
        ], 8, BX)) : D("", !0)
      ]),
      _: 1
    }, 8, ["rows", "groups", "columns", "column-store", "candidates", "metrics", "row-key", "locale", "theme", "loading", "empty", "aria-label", "sort", "sort-closed"]));
  }
}), HX = ["aria-label", "aria-busy"], KX = {
  key: 0,
  class: "fe-gal__heading",
  "aria-hidden": "true"
}, VX = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], jX = ["dir"], qX = {
  key: 0,
  class: "fe-fprev__tint"
}, WX = ["innerHTML"], YX = ["aria-label", "innerHTML"], GX = ["innerHTML"], XX = ["onClick"], JX = {
  class: "fe-gal__meta",
  "aria-hidden": "true"
}, ZX = {
  key: 0,
  class: "fe-gal__meta-line"
}, QX = ["title"], eJ = ["title"], tJ = {
  key: 0,
  class: "fe-gal__meta-line"
}, nJ = ["title", "aria-label", "data-link-state"], aJ = {
  key: 1,
  class: "fe-gal__meta-line"
}, iJ = ["title", "aria-label"], oJ = {
  key: 2,
  class: "fe-gal__meta-line"
}, rJ = ["title", "aria-label"], sJ = {
  key: 0,
  class: "fe-gal__empty"
}, lJ = /* @__PURE__ */ lt({
  __name: "GalleryView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    order: {},
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, nodeDisplayName: l, formatDate: d, formatMonthYear: f, zonedYearMonth: m, toDate: v } = yt(() => n.locale);
    function b(W) {
      return Lr(Ac(W), { t: i, formatDate: d, locale: n.locale });
    }
    function _(W) {
      return Ec(W, { t: i });
    }
    function w(W) {
      return Cc(W, { t: i });
    }
    function k(W) {
      return hg(W, { t: i });
    }
    const x = $c(), M = E(
      () => yg(n.files, {
        active: vg(x.key.value, n.order),
        dateOf: (W) => v(W.last_modified),
        aside: (W) => W.type === "dir" ? { id: "dirs" } : null,
        labels: { t: i, formatMonthYear: f, zonedYearMonth: m }
      })
    ), A = E(() => n.files.some((W) => {
      var ne;
      return W.type === "dir" && (((ne = W.preview) == null ? void 0 : ne.length) ?? 0) > 0;
    }));
    function T(W) {
      return n.thumbSrc ? n.thumbSrc(W) : W.thumb_url ?? null;
    }
    const N = r$({
      apiBase: n.apiBase,
      authHeaders: n.authHeaders ? () => n.authHeaders() : void 0,
      credentials: n.authCredentials,
      disabled: () => n.e2eActive === !0
    });
    Ot(() => N.dispose());
    function z(W) {
      return N.kindFor(W);
    }
    function L(W) {
      const ne = N.get(W);
      return ne ? [ne] : [];
    }
    function B(W, ne) {
      N.bind(W instanceof Element ? W : null, ne);
    }
    function O(W) {
      return n.starEnabled === !1 ? !1 : n.apiBase !== void 0 && typeof W.id == "number" && W.type === "file";
    }
    function U(W) {
      return n.selected.has(W.path);
    }
    function S(W, ne) {
      a("click-card", W, fg(ne));
    }
    function F(W, ne) {
      a("click-card", W, dg(ne, re.isTap(ne)));
    }
    function I(W) {
      a("dbl-card", W);
    }
    function G(W, ne) {
      ne.preventDefault(), ne.stopPropagation(), a("context-card", W, ne);
    }
    function Y(W, ne) {
      kg(
        ne,
        l(W),
        n.selected.has(W.path) ? n.selected.size : 1
      ), a("item-drag-start", W, ne);
    }
    const ie = $(null);
    function me(W, ne) {
      W.type === "dir" && Xa(ne) && (ne.preventDefault(), ne.stopPropagation(), ne.dataTransfer && (ne.dataTransfer.dropEffect = "move"), ie.value = W.path);
    }
    function q(W) {
      ie.value === W.path && (ie.value = null);
    }
    function C(W, ne) {
      ie.value = null, W.type === "dir" && Xa(ne) && (ne.preventDefault(), ne.stopPropagation(), a("item-drop-into", W, ne));
    }
    const re = pg(
      (W, ne) => a("context-card", W, { ...ne, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (W) => a("click-card", W, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function de(W) {
      return d(W, { time: !0 });
    }
    function V(W) {
      const ne = de(W.last_modified);
      return [W.type === "dir" ? "" : r(W.size), ne].filter((ce) => !!ce).join(" · ");
    }
    return (W, ne) => (p(), h("div", {
      class: Fe(["fe-gal", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0 }]),
      role: "listbox",
      "aria-multiselectable": "true",
      "aria-label": u(i)("gallery.aria"),
      "aria-busy": e.loading ? "true" : void 0
    }, [
      (p(!0), h(Ce, null, ot(e.files, (K) => {
        var ce, J;
        return p(), h(Ce, {
          key: K.path
        }, [
          M.value.headingBefore(K) ? (p(), h("p", KX, y(M.value.headingBefore(K)), 1)) : D("", !0),
          c("div", {
            class: Fe(["fe-gal__card", {
              "is-selected": U(K),
              "is-dir": K.type === "dir",
              "is-trash": K.trashed,
              "is-clipped": (ce = e.clipped) == null ? void 0 : ce.has(K.path),
              "is-droptarget": ie.value === K.path
            }]),
            tabindex: "0",
            role: "option",
            "aria-selected": U(K) ? "true" : "false",
            "aria-label": u(l)(K),
            "data-fe-path": K.path,
            draggable: "true",
            onClick: (H) => F(K, H),
            onDblclick: (H) => I(K),
            onContextmenu: (H) => G(K, H),
            onDragstart: (H) => Y(K, H),
            onDragover: (H) => me(K, H),
            onDragleave: (H) => q(K),
            onDrop: (H) => C(K, H),
            onTouchstartPassive: (H) => u(re).onTouchStart(K, H),
            onTouchend: ne[3] || (ne[3] = //@ts-ignore
            (...H) => u(re).onTouchEnd && u(re).onTouchEnd(...H)),
            onTouchmovePassive: ne[4] || (ne[4] = //@ts-ignore
            (...H) => u(re).onTouchMove && u(re).onTouchMove(...H))
          }, [
            c("div", {
              class: "fe-gal__thumb",
              ref_for: !0,
              ref: (H) => B(H, K)
            }, [
              z(K) ? (p(), h(Ce, { key: 0 }, [
                (p(!0), h(Ce, null, ot(L(K), (H) => (p(), h("div", {
                  key: "fprev",
                  class: Fe(["fe-fprev", "fe-fprev--" + H.kind]),
                  dir: u(I0)(H.kind),
                  style: Yt(H.kind === "table" ? { "--fprev-cols": String(H.cols) } : void 0),
                  "aria-hidden": "true"
                }, [
                  H.kind === "table" ? (p(!0), h(Ce, { key: 0 }, ot(H.rows, (X, we) => (p(), h(Ce, { key: we }, [
                    (p(!0), h(Ce, null, ot(X, (it, Re) => (p(), h("span", {
                      key: Re,
                      class: Fe(["fe-fprev__cell", { "is-head": we === 0 }])
                    }, y(it), 3))), 128))
                  ], 64))), 128)) : (p(!0), h(Ce, { key: 1 }, ot(H.lines, (X, we) => (p(), h("div", {
                    key: we,
                    class: "fe-fprev__line"
                  }, [
                    X.tint ? (p(), h("span", qX, y(X.indent) + y(X.tint), 1)) : D("", !0),
                    Ht(y(X.text), 1)
                  ]))), 128))
                ], 14, jX))), 128)),
                L(K).length === 0 ? (p(), h("span", {
                  key: 0,
                  class: "fe-gal__icon fe-gal__icon--svg",
                  innerHTML: u(ya)(K)
                }, null, 8, WX)) : D("", !0)
              ], 64)) : K.type === "dir" && A.value && !u(Mr)(K) ? (p(), Je(bg, {
                key: 1,
                shape: "fan",
                node: K,
                "src-of": T
              }, null, 8, ["node"])) : (p(), Je(Oc, {
                key: 2,
                node: K,
                "src-of": T,
                "video-badge": u(i$)(K),
                note: k(K),
                alt: K.basename,
                class: Fe({
                  "fe-thumb--page": u(mg)(K)
                  /* gorunum:v1-preview — crop a page from its TOP */
                })
              }, {
                default: gt(() => [
                  u(Mr)(K) ? (p(), h("span", {
                    key: 0,
                    class: "fe-gal__icon fe-gal__icon--svg",
                    role: "img",
                    "aria-label": u(i)("e2e.badge"),
                    innerHTML: u(sl)()
                  }, null, 8, YX)) : (p(), h("span", {
                    key: 1,
                    class: "fe-gal__icon fe-gal__icon--svg",
                    innerHTML: u(ya)(K)
                  }, null, 8, GX))
                ]),
                _: 2
              }, 1032, ["node", "video-badge", "note", "alt", "class"])),
              e.selectable ? (p(), h("span", {
                key: 3,
                class: "fe-item-check fe-gal__check",
                "data-fe-control": "",
                onClick: vt((H) => S(K, H), ["stop"]),
                onDblclick: ne[0] || (ne[0] = vt(() => {
                }, ["stop"]))
              }, [
                tt(Qy, {
                  on: U(K),
                  label: u(l)(K)
                }, null, 8, ["on", "label"])
              ], 40, XX)) : D("", !0),
              O(K) ? (p(), h("div", {
                key: 4,
                class: "fe-gal__star",
                onClick: ne[1] || (ne[1] = vt(() => {
                }, ["stop"])),
                onDblclick: ne[2] || (ne[2] = vt(() => {
                }, ["stop"]))
              }, [
                tt(gg, {
                  starred: !!((J = e.starredIds) != null && J.has(K.id)),
                  "node-id": K.id,
                  "api-base": e.apiBase,
                  "auth-headers": e.authHeaders,
                  "auth-credentials": e.authCredentials,
                  locale: e.locale,
                  compact: "",
                  card: "",
                  onChange: (H) => a("star-change", K, H)
                }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
              ], 32)) : D("", !0),
              c("div", JX, [
                V(K) ? (p(), h("span", ZX, y(V(K)), 1)) : D("", !0),
                e.showParentPath && u(xr)(K) ? (p(), h("span", {
                  key: 1,
                  class: "fe-gal__meta-line fe-gal__meta-line--path",
                  title: u(xr)(K)
                }, [
                  c("bdi", null, y(u(xr)(K)), 1)
                ], 8, QX)) : D("", !0)
              ])
            ], 512),
            c("div", {
              class: "fe-gal__label",
              title: K.basename
            }, [
              c("bdi", null, y(u(l)(K)), 1)
            ], 8, eJ),
            _(K) ? (p(), h("div", tJ, [
              c("span", {
                class: Fe(["fe-symlink", "fe-symlink--" + _(K).state]),
                role: "img",
                title: _(K).why,
                "aria-label": _(K).why,
                "data-testid": "symlink-badge",
                "data-link-state": _(K).state
              }, [
                ne[5] || (ne[5] = c("span", {
                  class: "fe-symlink__glyph",
                  "aria-hidden": "true"
                }, "🔗", -1)),
                Ht(y(_(K).badge), 1)
              ], 10, nJ)
            ])) : D("", !0),
            w(K) ? (p(), h("div", aJ, [
              c("span", {
                class: "fe-unavailable",
                role: "img",
                title: w(K).full,
                "aria-label": w(K).full,
                "data-testid": "unavailable-badge"
              }, y(w(K).badge), 9, iJ)
            ])) : D("", !0),
            b(K) ? (p(), h("div", oJ, [
              b(K) ? (p(), h("span", {
                key: 0,
                class: "fe-applock",
                role: "img",
                title: b(K),
                "aria-label": b(K),
                "data-testid": "lock-badge"
              }, [
                ne[6] || (ne[6] = c("span", {
                  class: "fe-applock__glyph",
                  "aria-hidden": "true"
                }, "🔒", -1)),
                Ht(y(u(i)("applock.badge")), 1)
              ], 8, rJ)) : D("", !0)
            ])) : D("", !0)
          ], 42, VX)
        ], 64);
      }), 128)),
      !e.loading && e.files.length === 0 ? (p(), h("div", sJ, y(u(i)("empty.folder")), 1)) : D("", !0)
    ], 10, HX));
  }
}), uJ = ["dir", "aria-label"], cJ = { class: "fe-fpeek__head" }, dJ = { class: "fe-fpeek__name" }, fJ = {
  key: 0,
  class: "fe-fpeek__count"
}, pJ = {
  key: 0,
  class: "fe-fpeek__loading"
}, hJ = {
  key: 1,
  class: "fe-fpeek__list"
}, mJ = { class: "fe-fpeek__tile" }, vJ = ["innerHTML"], yJ = ["innerHTML"], gJ = ["innerHTML"], bJ = { class: "fe-fpeek__label" }, kJ = {
  key: 2,
  class: "fe-fpeek__more"
}, wJ = /* @__PURE__ */ lt({
  __name: "FolderPeek",
  props: {
    state: {},
    srcOf: { type: Function },
    locale: {}
  },
  setup(e) {
    const t = e, { t: n, dir: a, nodeDisplayName: i } = yt(() => t.locale), r = $(null), l = (m) => {
      if (m.type === "dir" || Xf(m)) return !1;
      const v = vi(m);
      return v === "image" || v === "video" || C9(m);
    }, d = E(() => t.state ? Math.max(0, t.state.total - t.state.items.length) : 0);
    function f() {
      const m = r.value, v = t.state;
      if (!m || !v) return;
      const b = window.innerWidth, _ = window.innerHeight, w = m.offsetWidth, k = m.offsetHeight, x = Ga(m), M = x === "rtl" ? v.anchor.right : v.anchor.left, A = pc(M, w, b, x);
      let T = v.anchor.bottom + 6;
      T + k > _ - 8 && (T = Math.max(8, v.anchor.top - k - 6)), m.style.insetInlineStart = `${Math.round(x === "rtl" ? b - A - w : A)}px`, m.style.top = `${Math.round(T)}px`, m.style.zIndex = String(yc(document.elementFromPoint(v.anchor.left + 1, v.anchor.top + 1)));
    }
    return Xe(
      () => t.state,
      async () => {
        await Zt(), f();
      }
    ), (m, v) => (p(), Je(hi, { to: "body" }, [
      e.state ? (p(), h("div", {
        key: 0,
        ref_key: "box",
        ref: r,
        class: "fe-fpeek",
        dir: u(a),
        role: "tooltip",
        "data-fe-peek": "",
        "aria-label": u(i)(e.state.node)
      }, [
        c("p", cJ, [
          c("bdi", dJ, y(u(i)(e.state.node)), 1),
          e.state.loading ? D("", !0) : (p(), h("span", fJ, y(e.state.total === 0 ? u(n)("peek.empty") : u(n)("peek.items", { n: e.state.total })), 1))
        ]),
        e.state.loading ? (p(), h("p", pJ, y(u(n)("peek.loading")), 1)) : e.state.items.length ? (p(), h("ul", hJ, [
          (p(!0), h(Ce, null, ot(e.state.items, (b) => (p(), h("li", {
            key: b.path,
            class: "fe-fpeek__row"
          }, [
            c("span", mJ, [
              l(b) ? (p(), Je(Oc, {
                key: 0,
                node: b,
                "src-of": e.srcOf,
                "type-badge": u(o$)(b),
                alt: "",
                class: "fe-fpeek__img"
              }, {
                default: gt(() => [
                  c("span", {
                    class: "fe-grid__tile--svg",
                    innerHTML: u(ya)(b)
                  }, null, 8, vJ)
                ]),
                _: 2
              }, 1032, ["node", "src-of", "type-badge"])) : u(Mr)(b) ? (p(), h("span", {
                key: 1,
                class: "fe-grid__tile--svg",
                innerHTML: u(sl)()
              }, null, 8, yJ)) : (p(), h("span", {
                key: 2,
                class: "fe-grid__tile--svg",
                innerHTML: u(ya)(b)
              }, null, 8, gJ))
            ]),
            c("bdi", bJ, y(u(i)(b)), 1)
          ]))), 128))
        ])) : D("", !0),
        !e.state.loading && d.value > 0 ? (p(), h("p", kJ, y(u(n)("peek.more", { n: d.value })), 1)) : D("", !0)
      ], 8, uJ)) : D("", !0)
    ]));
  }
}), _J = 500, xJ = 3e4, SJ = 8;
function $J(e, t = () => !0) {
  const n = xa(null), a = /* @__PURE__ */ new Map();
  let i, r = 0;
  async function l(v) {
    const b = a.get(v);
    if (b && Date.now() - b.at < xJ) return b;
    const w = [...(await e(v)).files ?? []].sort(If), k = { at: Date.now(), items: w.slice(0, SJ), total: w.length };
    return a.set(v, k), k;
  }
  function d(v, b, _ = "mouse") {
    if (v.type !== "dir" || _ !== "mouse" || !b || !t()) return;
    const w = ++r;
    clearTimeout(i), i = setTimeout(async () => {
      if (w !== r) return;
      const k = b.getBoundingClientRect();
      n.value = { node: v, anchor: k, loading: !0, items: [], total: 0 };
      try {
        const x = await l(v.path);
        if (w !== r) return;
        n.value = { node: v, anchor: k, loading: !1, items: x.items, total: x.total };
      } catch {
        w === r && (n.value = null);
      }
    }, _J);
  }
  function f() {
    r++, clearTimeout(i), i = void 0, n.value = null;
  }
  function m(v) {
    v ? a.delete(v) : a.clear();
  }
  return { state: n, enter: d, leave: f, forget: m };
}
const TJ = ["data-pane", "data-testid", "aria-label"], AJ = {
  key: 0,
  class: "fe-subhead"
}, EJ = { class: "fe-subhead__actions" }, CJ = ["title", "aria-label"], zJ = {
  key: 2,
  class: "fe__skeleton",
  role: "status"
}, MJ = { class: "fe-sr-only" }, PJ = {
  key: 0,
  class: "fe-skel-grid",
  "aria-hidden": "true"
}, OJ = {
  key: 1,
  class: "fe-skel-list",
  "aria-hidden": "true"
}, DJ = {
  key: 3,
  class: "fe-state"
}, LJ = { class: "fe-state__title" }, RJ = { class: "fe-state__hint" }, NJ = { class: "fe-state__actions" }, IJ = { class: "fe-state__details" }, BJ = { class: "fe-state__details-summary" }, FJ = { class: "fe-state__details-pre" }, UJ = {
  key: 4,
  class: "fe-state",
  "data-testid": "empty-filtered"
}, HJ = { class: "fe-state__title" }, KJ = { class: "fe-state__hint" }, VJ = { class: "fe-state__actions" }, jJ = { class: "fe-state" }, qJ = { class: "fe-state__title" }, WJ = "application/x-brf-files", YJ = "application/x-brf-files-src", GJ = 500, z1 = /* @__PURE__ */ lt({
  __name: "FilePane",
  props: {
    paneId: {},
    api: {},
    locale: {},
    theme: {},
    focused: { type: Boolean },
    closable: { type: Boolean },
    path: {},
    selfDriven: { type: Boolean },
    qualify: {},
    toUser: {},
    clamp: {},
    rootLabel: {},
    rootPath: {},
    floor: {},
    multiRoot: { type: Boolean },
    virtualRows: {},
    trashVisible: { type: Boolean, default: !0 },
    navOffersTrash: { type: Boolean },
    rows: {},
    loading: { type: Boolean },
    error: {},
    order: {},
    viewMode: {},
    viewModes: {},
    showCrumbs: { type: Boolean, default: !0 },
    showFilterBar: { type: Boolean, default: !0 },
    filterMode: {},
    findLabel: {},
    showViewSwitcher: { type: Boolean, default: !0 },
    crumbSubfolders: {},
    folderKey: {},
    showParentPath: { type: Boolean },
    trash: { type: Boolean },
    clipped: {},
    extraFilters: {},
    extraFiltersOnServer: { type: Boolean },
    canWrite: { type: Boolean },
    canPaste: { type: Boolean },
    selected: {},
    filters: {},
    thumbSrc: {},
    folderPreviews: { type: Boolean },
    keepBadgeFor: {},
    starredIds: {},
    starOverrides: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    bodyOverride: { type: Boolean },
    openTrigger: { default: "double" }
  },
  emits: ["activate", "close", "navigate", "open", "open-trash", "click-row", "context", "clear-selection", "display-order", "item-drag-start", "item-drop-into", "transfer", "update:viewMode", "update:filters", "crumb-context", "copy-path", "crumb-drop", "new-folder", "upload", "paste", "select-all", "clear-filters", "star-change", "retry"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = yt(() => a.locale), l = a.paneId === "main" ? $c() : Rx();
    wr(Nx, l);
    const d = $(""), f = $([]), m = $(!1), v = $(""), b = $("");
    function _(xe) {
      return vi(xe) === "storage";
    }
    const w = Hi(Tc, null), k = Hi(b$, null), x = $(""), M = $(!1), A = $(""), T = E(
      () => a.selfDriven && !!k && !!x.value && k.locked(x.value)
    );
    async function N(xe) {
      if (!(!k || !x.value || M.value)) {
        M.value = !0, A.value = "";
        try {
          const Ne = await k.unlock(x.value, xe);
          Ne ? A.value = Ne : await S(d.value);
        } finally {
          M.value = !1;
        }
      }
    }
    const z = E(() => a.selfDriven ? d.value : a.path ?? ""), L = E(
      () => a.selfDriven ? f.value : a.rows ?? []
    ), B = E(() => a.selfDriven ? m.value : !!a.loading), O = E(() => a.selfDriven ? v.value : a.error ?? ""), U = E(
      () => !!a.multiRoot && !(z.value ?? "").replace(/^\/+|\/+$/g, "")
    );
    async function S(xe) {
      const Ne = a.clamp(xe ?? d.value ?? "");
      m.value = !0, v.value = "";
      try {
        if (a.multiRoot && !Ne) {
          f.value = a.virtualRows ? a.virtualRows() : [], b.value = "", x.value = "", d.value = "", i("navigate", "");
          return;
        }
        const fe = await a.api.index(a.qualify(Ne));
        b.value = fe.perm || "";
        const Se = typeof fe.e2e_root == "string" ? fe.e2e_root : "";
        Se !== x.value && (A.value = ""), x.value = Se;
        const Z = w ? await w.decorate(fe.files, { root: Se || null }) : fe.files;
        f.value = yr(Z), fx(f.value, fe.adapter, fe.dirname, a.trashVisible !== !1, {
          navOffersTrash: a.navOffersTrash
        }) && px(f.value, fe.adapter, a.api), d.value = a.toUser(fe.dirname), i("navigate", d.value);
      } catch (fe) {
        v.value = fe instanceof Error ? fe.message : String(fe);
      } finally {
        m.value = !1;
      }
    }
    a.selfDriven && S(a.path ?? "");
    function F(xe) {
      i("activate"), a.selfDriven ? S(xe) : i("navigate", xe);
    }
    const I = E(
      () => gx(z.value) ? z.value : a.qualify(z.value)
    ), G = E(() => {
      const xe = I.value, Ne = xe.indexOf("://");
      return Ne === -1 ? "" : xe.slice(0, Ne);
    });
    function Y(xe) {
      if (i("activate"), !a.selfDriven) {
        i("navigate", xe);
        return;
      }
      if (a.multiRoot && !xe) {
        S("");
        return;
      }
      S(a.toUser(xe));
    }
    const ie = $J(
      (xe) => a.api.index(xe),
      () => a.folderPreviews !== !1
    );
    function me(xe) {
      return a.thumbSrc ? a.thumbSrc(xe) : xe.thumb_url ?? null;
    }
    function q() {
      ie.leave();
    }
    Xe(L, () => ie.forget()), Wt(() => {
      window.addEventListener("scroll", q, !0), window.addEventListener("dragstart", q, !0), window.addEventListener("keydown", q, !0);
    }), Ot(() => {
      window.removeEventListener("scroll", q, !0), window.removeEventListener("dragstart", q, !0), window.removeEventListener("keydown", q, !0), ie.leave();
    });
    const C = Uu(
      () => qy(a.filters),
      () => L.value,
      (xe) => xe.basename || "",
      () => a.api.matchNames
    ), re = E(() => {
      const xe = C.apply(Pv(L.value, a.filters));
      return l.sortListing(
        a.extraFilters && !a.extraFiltersOnServer ? Pv(xe, a.extraFilters) : xe,
        a.order ?? "sort"
      );
    }), de = E(() => {
      const xe = new Set(a.starredIds ?? []);
      for (const Ne of L.value)
        typeof Ne.id == "number" && Ne.starred === !0 && xe.add(Ne.id);
      for (const [Ne, fe] of a.starOverrides ?? /* @__PURE__ */ new Map())
        fe ? xe.add(Ne) : xe.delete(Ne);
      return xe;
    }), V = E(() => Hs(a.filters) || !!a.extraFilters), W = E(
      () => U.value ? "find" : a.filterMode ?? "full"
    ), ne = E(
      () => U.value ? r("filter.find.storages") : a.findLabel ?? ""
    ), K = E(
      () => L.value.filter((xe) => xe.type === "dir").map((xe) => ({ label: xe.basename, adapterPath: xe.path }))
    );
    let ce = 0;
    function J() {
      return Date.now() - ce < GJ;
    }
    function H(xe, Ne) {
      if (!J()) {
        if (Ne.check) {
          i("activate"), i("click-row", xe, { ctrl: !0, shift: Ne.shift });
          return;
        }
        if (Ne.touch || a.openTrigger === "single") {
          ce = Date.now(), Be(xe);
          return;
        }
        i("activate"), i("click-row", xe, { ctrl: Ne.ctrl, shift: Ne.shift });
      }
    }
    function X(xe) {
      J() || (ce = Date.now(), Be(xe));
    }
    function we(xe, Ne) {
      Ne.preventDefault(), Ne.stopPropagation(), i("activate"), i("context", xe, Ne);
    }
    function it(xe) {
      xe.preventDefault(), xe.stopPropagation(), i("activate"), i("clear-selection"), i("context", null, xe);
    }
    function Re() {
      i("clear-selection");
    }
    function Be(xe) {
      if (i("activate"), xe.basename === ".trash") {
        i("open-trash");
        return;
      }
      if (xe.type === "dir" && a.selfDriven) {
        S(_(xe) ? xe.path : a.toUser(xe.path));
        return;
      }
      i("open", xe);
    }
    function We(xe, Ne) {
      if (!Ne.dataTransfer) return;
      if (_(xe) || U.value || xe.basename === ".trash") {
        Ne.preventDefault();
        return;
      }
      const fe = L.value.filter((Z) => a.selected.has(Z.path) && !_(Z)).filter((Z) => {
        var ge;
        return !((ge = a.clipped) != null && ge.has(Z.path));
      }).map((Z) => ({ path: Z.path, basename: Z.basename, type: Z.type })), Se = fe.length > 0 ? fe : [{ path: xe.path, basename: xe.basename, type: xe.type }];
      Ne.dataTransfer.setData(WJ, JSON.stringify(Se)), Ne.dataTransfer.setData(YJ, I.value), Ne.dataTransfer.setData("text/plain", Se.map((Z) => Z.path).join(`
`)), Ne.dataTransfer.effectAllowed = "move", i("item-drag-start", xe, Ne);
    }
    const bt = $(!1);
    function at(xe) {
      return Xa(xe);
    }
    function Ie(xe, Ne) {
      const fe = ff(xe);
      if (!fe || !Ne) return;
      const Se = jv(xe), Z = fe.map((ge) => ge.path).filter((ge) => ge && ge !== Ne && !Ne.startsWith(ge + "/"));
      Z.length !== 0 && (xe.preventDefault(), xe.stopPropagation(), i("transfer", { sources: Z, targetWire: Ne, originWire: Se }));
    }
    function nt(xe, Ne) {
      bt.value = !1, !(xe.type !== "dir" || _(xe)) && at(Ne) && i("item-drop-into", xe, Ne);
    }
    function dt(xe) {
      !at(xe) || U.value || (xe.preventDefault(), xe.stopPropagation(), xe.dataTransfer && (xe.dataTransfer.dropEffect = "move"), bt.value = !0);
    }
    function Me() {
      bt.value = !1;
    }
    function be(xe) {
      bt.value = !1, !(!at(xe) || U.value) && Ie(xe, I.value);
    }
    function Ve() {
      return a.selfDriven ? S() : Promise.resolve();
    }
    function Te() {
      const xe = (z.value ?? "").replace(/^\/+|\/+$/g, ""), Ne = (a.floor || "").replace(/^\/+|\/+$/g, "");
      if (!xe || xe === Ne) return;
      const fe = xe.lastIndexOf("/");
      F(fe === -1 ? "" : xe.slice(0, fe));
    }
    function qe() {
      return z.value;
    }
    function De() {
      return re.value.filter((xe) => !_(xe));
    }
    function mt() {
      return L.value.length;
    }
    function $t() {
      return L.value.map((xe) => xe.path);
    }
    function kt() {
      return a.selfDriven ? b.value : "";
    }
    function Tt() {
      return a.selfDriven ? x.value : "";
    }
    return t({ reload: Ve, goUp: Te, getPath: qe, visibleNodes: De, loadFolder: S, rowCount: mt, rowPaths: $t, dirPerm: kt, e2eRoot: Tt }), Xe(z, () => {
      bt.value = !1;
    }), (xe, Ne) => (p(), h("section", {
      class: Fe(["fe__primary fe-pane", {
        "fe-pane--focus": e.focused,
        "fe-pane--split": e.paneId === "split",
        "fe-pane--dropover": bt.value
      }]),
      "data-pane": e.paneId,
      "data-testid": `pane-${e.paneId}`,
      role: "region",
      "aria-label": e.paneId === "split" ? u(r)("split.pane") : u(r)("toolbar.view_label"),
      onPointerdownCapture: Ne[18] || (Ne[18] = (fe) => i("activate"))
    }, [
      e.showCrumbs || xe.$slots.heading || e.showViewSwitcher || e.closable ? (p(), h("div", AJ, [
        En(xe.$slots, "heading", {}, () => [
          e.showCrumbs ? (p(), Je(HG, {
            key: 0,
            dirname: I.value,
            adapter: G.value,
            "root-label": e.rootLabel || G.value,
            locale: e.locale,
            "multi-storage-root": e.multiRoot,
            "root-path": e.rootPath,
            subfolders: e.crumbSubfolders ?? K.value,
            onNavigate: Y,
            onCopyPath: Ne[0] || (Ne[0] = (fe) => i("copy-path", fe)),
            onCrumbContext: Ne[1] || (Ne[1] = (fe) => i("crumb-context", fe)),
            onCrumbDrop: Ne[2] || (Ne[2] = (fe, Se) => i("crumb-drop", fe, Se))
          }, null, 8, ["dirname", "adapter", "root-label", "locale", "multi-storage-root", "root-path", "subfolders"])) : D("", !0)
        ]),
        c("div", EJ, [
          e.showViewSwitcher ? (p(), Je(vX, {
            key: 0,
            "view-mode": e.viewMode,
            locale: e.locale,
            modes: e.viewModes,
            "onUpdate:viewMode": Ne[3] || (Ne[3] = (fe) => {
              i("activate"), i("update:viewMode", fe);
            })
          }, null, 8, ["view-mode", "locale", "modes"])) : D("", !0),
          e.closable ? (p(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only fe-pane__close",
            title: u(r)("split.close"),
            "aria-label": u(r)("split.close"),
            "data-testid": "pane-close",
            onClick: Ne[4] || (Ne[4] = (fe) => i("close"))
          }, [...Ne[19] || (Ne[19] = [
            c("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              c("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, CJ)) : D("", !0)
        ])
      ])) : D("", !0),
      Ne[25] || (Ne[25] = c("div", { class: "fe-selbar-slot" }, null, -1)),
      e.showFilterBar ? (p(), Je(lX, {
        key: 1,
        value: e.filters,
        locale: e.locale,
        theme: e.theme,
        mode: W.value,
        "find-label": ne.value,
        order: e.order,
        shown: re.value.length,
        total: L.value.length,
        files: L.value,
        "can-paste": e.canPaste,
        "can-write": e.canWrite,
        "onUpdate:value": Ne[5] || (Ne[5] = (fe) => {
          i("activate"), i("update:filters", fe);
        }),
        onNewFolder: Ne[6] || (Ne[6] = (fe) => {
          i("activate"), i("new-folder");
        }),
        onUpload: Ne[7] || (Ne[7] = (fe) => {
          i("activate"), i("upload");
        }),
        onPaste: Ne[8] || (Ne[8] = (fe) => {
          i("activate"), i("paste");
        }),
        onSelectAll: Ne[9] || (Ne[9] = (fe) => {
          i("activate"), i("select-all");
        })
      }, null, 8, ["value", "locale", "theme", "mode", "find-label", "order", "shown", "total", "files", "can-paste", "can-write"])) : D("", !0),
      En(xe.$slots, "banners"),
      c("div", {
        class: Fe(["fe__body", { "is-dropover": bt.value }]),
        onClick: vt(Re, ["self"]),
        onContextmenu: it,
        onDragover: dt,
        onDragleave: Me,
        onDrop: be
      }, [
        e.bodyOverride ? En(xe.$slots, "body", { key: 0 }) : T.value ? (p(), Je(k$, {
          key: 1,
          compact: "",
          locale: e.locale,
          busy: M.value,
          error: A.value,
          onUnlock: N,
          onRecovery: Ne[10] || (Ne[10] = (fe) => {
            var Se;
            return (Se = u(k)) == null ? void 0 : Se.recovery(x.value);
          })
        }, null, 8, ["locale", "busy", "error"])) : B.value && L.value.length === 0 ? (p(), h("div", zJ, [
          c("span", MJ, y(u(r)("loading")), 1),
          e.viewMode !== "list" ? (p(), h("div", PJ, [
            (p(), h(Ce, null, ot(8, (fe) => c("div", {
              key: fe,
              class: "fe-skel-card"
            }, [...Ne[20] || (Ne[20] = [
              c("div", { class: "fe-skel fe-skel--thumb" }, null, -1),
              c("div", { class: "fe-skel fe-skel--label" }, null, -1)
            ])])), 64))
          ])) : (p(), h("div", OJ, [
            (p(), h(Ce, null, ot(8, (fe) => c("div", {
              key: fe,
              class: "fe-skel-row"
            }, [...Ne[21] || (Ne[21] = [
              c("div", { class: "fe-skel fe-skel--icon" }, null, -1),
              c("div", { class: "fe-skel fe-skel--name" }, null, -1),
              c("div", { class: "fe-skel fe-skel--size" }, null, -1),
              c("div", { class: "fe-skel fe-skel--date" }, null, -1)
            ])])), 64))
          ]))
        ])) : O.value && L.value.length === 0 ? (p(), h("div", DJ, [
          Ne[22] || (Ne[22] = w0('<svg class="fe-state__art" viewBox="0 0 120 100" width="110" height="92" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="60" cy="50" r="28"></circle><path d="M60 36v18"></path><circle cx="60" cy="63" r="1.8" fill="currentColor" stroke="none"></circle><path d="M24 88h72" stroke-dasharray="3 5"></path></svg>', 1)),
          c("p", LJ, y(u(r)("error.title")), 1),
          c("p", RJ, y(u(r)("error.hint")), 1),
          c("div", NJ, [
            c("button", {
              type: "button",
              class: "fe-btn fe-btn--primary",
              onClick: Ne[11] || (Ne[11] = (fe) => e.selfDriven ? S() : i("retry"))
            }, y(u(r)("error.retry")), 1)
          ]),
          c("details", IJ, [
            c("summary", BJ, y(u(r)("error.details")), 1),
            c("pre", FJ, y(O.value), 1)
          ])
        ])) : !B.value && V.value && re.value.length === 0 && L.value.length > 0 ? (p(), h("div", UJ, [
          Ne[23] || (Ne[23] = c("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "110",
            height: "92",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            c("path", { d: "M26 28h68L68 58v24l-16 8V58z" })
          ], -1)),
          c("p", HJ, y(u(r)("filter.empty.title")), 1),
          c("p", KJ, y(u(r)("filter.empty.hint")), 1),
          c("div", VJ, [
            c("button", {
              type: "button",
              class: "fe-btn",
              onClick: Ne[12] || (Ne[12] = (fe) => i("clear-filters"))
            }, y(u(r)("filter.clear")), 1)
          ])
        ])) : !B.value && L.value.length === 0 ? En(xe.$slots, "empty", { key: 5 }, () => [
          c("div", jJ, [
            Ne[24] || (Ne[24] = c("svg", {
              class: "fe-state__art",
              viewBox: "0 0 120 100",
              width: "110",
              height: "92",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              c("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" })
            ], -1)),
            c("p", qJ, y(u(r)("empty.folder")), 1)
          ])
        ]) : e.viewMode === "list" ? (p(), Je(UX, {
          key: 6,
          files: re.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          trash: e.trash,
          locale: e.locale,
          loading: B.value,
          "folder-key": e.folderKey,
          theme: e.theme,
          "thumb-src": e.thumbSrc,
          "keep-badge-for": e.keepBadgeFor,
          "starred-ids": de.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickRow: H,
          onDisplayOrder: Ne[13] || (Ne[13] = (fe) => i("display-order", fe)),
          onDblRow: X,
          onContextRow: we,
          onItemDragStart: We,
          onItemDropInto: nt,
          onStarChange: Ne[14] || (Ne[14] = (fe, Se) => i("star-change", fe, Se)),
          onPeek: u(ie).enter,
          onPeekEnd: q
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "trash", "locale", "loading", "folder-key", "theme", "thumb-src", "keep-badge-for", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials", "onPeek"])) : e.viewMode === "grid" ? (p(), Je(Wv, {
          key: 7,
          files: re.value,
          order: e.order,
          sections: !0,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: B.value,
          "keep-badge-for": e.keepBadgeFor,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": de.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: H,
          onDisplayOrder: Ne[15] || (Ne[15] = (fe) => i("display-order", fe)),
          onDblCard: X,
          onContextCard: we,
          onItemDragStart: We,
          onItemDropInto: nt,
          onStarChange: Ne[16] || (Ne[16] = (fe, Se) => i("star-change", fe, Se)),
          onPeek: u(ie).enter,
          onPeekEnd: q
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "keep-badge-for", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials", "onPeek"])) : (p(), Je(lJ, {
          key: 8,
          files: re.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: B.value,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": de.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: H,
          onDblCard: X,
          onContextCard: we,
          onItemDragStart: We,
          onItemDropInto: nt,
          onStarChange: Ne[17] || (Ne[17] = (fe, Se) => i("star-change", fe, Se))
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"]))
      ], 34),
      tt(wJ, {
        state: u(ie).state.value,
        "src-of": me,
        locale: e.locale
      }, null, 8, ["state", "locale"])
    ], 42, TJ));
  }
});
function XJ(e) {
  const t = $([]), n = $(""), a = E(
    () => t.value.find((M) => M.id === n.value) ?? null
  ), i = E(() => t.value.findIndex((M) => M.id === n.value)), r = E(() => t.value.length > 1);
  function l() {
    if (!e.storageKey) return !1;
    try {
      const M = localStorage.getItem(e.storageKey);
      if (!M) return !1;
      const A = JSON.parse(M);
      if (!A || !Array.isArray(A.tabs) || A.tabs.length === 0) return !1;
      const T = [];
      for (const N of A.tabs) {
        if (!N || typeof N.path != "string") continue;
        const z = typeof N.viewMode == "string" && N.viewMode ? N.viewMode : "list", L = N.split, B = L && typeof L == "object" && typeof L.path == "string" ? {
          path: L.path,
          viewMode: typeof L.viewMode == "string" && L.viewMode ? L.viewMode : void 0
        } : null;
        T.push({
          id: typeof N.id == "string" && N.id ? N.id : Gs(),
          path: N.path,
          viewMode: z,
          split: B
        });
      }
      return T.length === 0 ? !1 : (t.value = T, n.value = T.some((N) => N.id === A.active) ? String(A.active) : T[0].id, !0);
    } catch {
      return !1;
    }
  }
  function d() {
    if (e.storageKey)
      try {
        localStorage.setItem(
          e.storageKey,
          JSON.stringify({ v: 1, active: n.value, tabs: t.value })
        );
      } catch {
      }
  }
  Xe([t, n], d, { deep: !0 });
  function f(M, A) {
    if (t.value.length > 0) return;
    const T = { id: Gs(), path: M, viewMode: A, split: null };
    t.value = [T], n.value = T.id;
  }
  function m(M) {
    const A = a.value;
    A && (M.path !== void 0 && (A.path = M.path), M.viewMode !== void 0 && (A.viewMode = M.viewMode));
  }
  function v(M, A) {
    const T = { id: Gs(), path: M, viewMode: A.viewMode, split: A.split ?? null }, N = i.value;
    return t.value.splice(N === -1 ? t.value.length : N + 1, 0, T), A.background || (n.value = T.id), T;
  }
  function b(M) {
    if (t.value.length <= 1) return null;
    const A = t.value.findIndex((z) => z.id === M);
    if (A === -1) return null;
    const T = t.value[A].id === n.value;
    if (t.value.splice(A, 1), !T) return null;
    const N = t.value[Math.min(A, t.value.length - 1)];
    return n.value = N.id, N;
  }
  function _(M) {
    const A = t.value.find((T) => T.id === M);
    return !A || A.id === n.value ? null : (n.value = A.id, A);
  }
  function w(M) {
    if (t.value.length < 2) return null;
    const A = i.value === -1 ? 0 : i.value, T = t.value[(A + M + t.value.length) % t.value.length];
    return _(T.id);
  }
  function k(M, A) {
    if (M === A || M < 0 || A < 0 || M >= t.value.length || A >= t.value.length) return;
    const T = [...t.value], [N] = T.splice(M, 1);
    T.splice(A, 0, N), t.value = T;
  }
  function x(M) {
    const A = a.value;
    A && (A.split = M);
  }
  return {
    tabs: t,
    activeId: n,
    activeTab: a,
    activeIndex: i,
    hasMultiple: r,
    restore: l,
    seed: f,
    syncActive: m,
    openTab: v,
    closeTab: b,
    activate: _,
    step: w,
    move: k,
    setSplit: x
  };
}
function w$(e, t) {
  const n = e.lastIndexOf(".");
  return n <= 0 ? `${e} (${t})` : `${e.slice(0, n)} (${t})${e.slice(n)}`;
}
function JJ(e, t) {
  if (e.length !== t.length) return !1;
  for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
  return !0;
}
async function ZJ(e, t, n, a) {
  if (!t) return null;
  for (const i of a) {
    if (JJ(i, n)) continue;
    const r = await z2(e, t, i);
    if (r !== null) return ji(r) ? null : r;
  }
  return null;
}
async function QJ(e, t, n) {
  var r;
  const a = Sl(e);
  return a.kind === "file" || a.kind === "dir" ? a.encoded ?? null : a.kind !== "long" && a.kind !== "longdir" ? null : (((r = await n.readSidecar(t, `${a.hash}.fxl.name`)) == null ? void 0 : r.trim()) ?? "") || null;
}
async function eZ(e, t, n, a) {
  const i = [], r = [{ wire: t, id: e.rootId }];
  for (; r.length; ) {
    if (n.stopped()) return;
    const d = r.shift();
    let f;
    try {
      f = await n.list(d.wire);
    } catch {
      a.failed++;
      continue;
    }
    i.push({ ...d, rows: f });
    for (const m of f)
      m.type === "dir" && r.push({ wire: m.path, id: await vv(e, d.id, m.basename) });
  }
  const l = i.map((d) => d.id);
  for (const d of i.reverse()) {
    const f = new Set(d.rows.map((m) => m.basename));
    for (const m of d.rows) {
      if (n.stopped()) return;
      const v = m.basename;
      if (v === ha) continue;
      const b = await M2(e, v, d.id, (M) => n.readSidecar(d.wire, M));
      if (b.state === "enc" || b.state === "sidecar") continue;
      a.seen++;
      const _ = await ZJ(e, await QJ(v, d.wire, n), d.id, l), w = _ ?? (b.state === "plain" ? v : null);
      if (w === null || ji(w)) {
        a.failed++;
        continue;
      }
      const k = m.type === "dir" ? { dirId: await vv(e, d.id, v) } : {};
      let x = await yv(e, w, d.id, k);
      for (let M = 2; f.has(x.stored) && M < 100; M++)
        x = await yv(e, w$(w, M), d.id, k);
      if (f.has(x.stored)) {
        a.failed++;
        continue;
      }
      try {
        x.sidecar && await n.writeSidecar(d.wire, x.sidecar.name, x.sidecar.content), await n.rename(d.wire, m, x.stored), f.delete(v), f.add(x.stored), a.renamed++, _ !== null && (a.repaired = (a.repaired ?? 0) + 1);
      } catch {
        a.failed++;
      }
    }
  }
}
function M1(e) {
  return typeof e.size != "number" || typeof e.last_modified != "number" ? null : `${e.size}:${e.last_modified}`;
}
async function tZ(e, t, n, a) {
  const i = [], r = [e], l = (d) => d.replace(/\/+$/, "") === e.replace(/\/+$/, "");
  for (; r.length; ) {
    if (t.stopped()) return;
    const d = r.shift();
    let f;
    try {
      f = await t.list(d);
    } catch {
      n.failed++;
      continue;
    }
    for (const m of f) {
      if (m.type === "dir") {
        r.push(m.path);
        continue;
      }
      l(d) && m.basename === ha || Sl(m.basename).kind !== "sidecar" && i.push({ dir: d, row: m });
    }
  }
  n.total = i.length;
  for (const { dir: d, row: f } of i) {
    if (t.stopped()) return;
    try {
      if (cl(await t.head(f.path))) {
        n.skipped++;
        continue;
      }
      if (typeof f.size == "number" && f.size > a.maxBytes) {
        t.writeLarge && await t.writeLarge(d, f, M1(f)) ? (n.done++, n.large = (n.large ?? 0) + 1) : n.tooBig++;
        continue;
      }
      const m = await t.read(f.path);
      if (m.byteLength > a.maxBytes) {
        n.tooBig++;
        continue;
      }
      const v = await t.encrypt(m);
      await t.write(d, f, new Blob([v], { type: "application/octet-stream" }), M1(f)), n.done++;
    } catch {
      n.failed++;
    }
  }
}
const Gv = /* @__PURE__ */ new Set(), Xv = $(0);
function nZ(e) {
  return Gv.add(e), Xv.value++, () => {
    Gv.delete(e) && Xv.value++;
  };
}
function aZ(e, t) {
  Xv.value;
  for (const n of Gv) {
    const a = n(e, t);
    if (a) return a;
  }
  return null;
}
const iZ = {
  key: 0,
  class: "fe-e2e-form",
  "data-testid": "e2e-too-big"
}, oZ = { class: "fe-e2e-rk__lead" }, rZ = { class: "fe-e2e-big__steps" }, sZ = { class: "fe-e2e-big__cmd" }, lZ = { "data-testid": "e2e-too-big-command" }, uZ = { class: "fe-e2e-names__hint" }, cZ = /* @__PURE__ */ lt({
  __name: "E2eTooBigModal",
  props: {
    open: { type: Boolean },
    locale: {},
    info: {}
  },
  emits: ["close", "download"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r } = yt(() => n.locale), l = $(!1);
    Xe(
      () => n.open,
      (m) => {
        m && (l.value = !1);
      }
    );
    const d = E(() => {
      const m = n.info;
      if (!m) return "";
      const v = r(m.limit);
      return m.size !== null ? i("e2e.big.lead", { name: m.name, size: r(m.size), limit: v }) : i("e2e.big.lead_grew", { name: m.name, limit: v });
    });
    async function f() {
      var v;
      const m = (v = n.info) == null ? void 0 : v.command;
      if (m)
        try {
          await navigator.clipboard.writeText(m), l.value = !0;
        } catch {
        }
    }
    return (m, v) => (p(), Je(na, {
      open: e.open,
      title: u(i)("e2e.big.title"),
      size: "sm",
      onClose: v[2] || (v[2] = (b) => a("close"))
    }, {
      actions: gt(() => {
        var b;
        return [
          c("button", {
            type: "button",
            class: "fe-btn",
            onClick: v[0] || (v[0] = (_) => a("close"))
          }, y(u(i)("e2e.big.close")), 1),
          c("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "e2e-too-big-download",
            onClick: v[1] || (v[1] = (_) => a("download"))
          }, y(((b = e.info) == null ? void 0 : b.encrypted.kind) === "folder" ? u(i)("e2e.big.download_folder") : u(i)("e2e.big.download_file")), 1)
        ];
      }),
      default: gt(() => [
        e.info ? (p(), h("div", iZ, [
          c("p", oZ, y(d.value), 1),
          c("p", null, y(u(i)("e2e.big.instead")), 1),
          c("ol", rZ, [
            c("li", null, y(e.info.encrypted.kind === "file" ? u(i)("e2e.big.step_file") : u(i)("e2e.big.step_folder")), 1),
            c("li", null, [
              Ht(y(u(i)("e2e.big.step_run")) + " ", 1),
              c("span", sZ, [
                c("code", lZ, y(e.info.command), 1),
                c("button", {
                  type: "button",
                  class: "fe-e2e-optlink",
                  "data-testid": "e2e-too-big-copy",
                  onClick: f
                }, y(l.value ? u(i)("e2e.big.copied") : u(i)("e2e.big.copy")), 1)
              ])
            ])
          ]),
          c("p", uZ, y(u(i)("e2e.big.other_ways")), 1)
        ])) : D("", !0)
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), dZ = "filexfxe", _$ = 1, Qf = ".fxe", x$ = 64 * 1024, fZ = [], mf = new TextEncoder().encode(dZ), cc = 13, pZ = 32;
function S$(e) {
  return typeof e == "string" && e.length > Qf.length && e.toLowerCase().endsWith(Qf);
}
function hZ() {
  const e = crypto.getRandomValues(new Uint8Array(4));
  return `encrypted-${Array.from(e, (t) => t.toString(16).padStart(2, "0")).join("")}${Qf}`;
}
function mZ(e) {
  return /^encrypted-[0-9a-f]{8}\.fxe$/i.test(e);
}
function P1(e, t) {
  return t ? hZ() : `${e}${Qf}`;
}
function Sg(e) {
  const t = { v: 2, salt: e.salt, iter: e.iter, verify: e.verify, fmk: "wrapped", fmk_pw: e.fmk_pw };
  return e.rk && (t.rk = e.rk), e.esc && (t.esc = e.esc), t;
}
function O1(e) {
  return !!e.rk && typeof e.rk.salt == "string" && typeof e.rk.blob == "string";
}
function $$(e) {
  const t = new TextEncoder().encode(JSON.stringify(e));
  if (t.length === 0 || t.length > x$) throw new Error("e2e: the .fxe header is too large");
  const n = new Uint8Array(cc + t.length);
  return n.set(mf, 0), n[8] = _$, new DataView(n.buffer).setUint32(9, t.length, !1), n.set(t, cc), n;
}
function vZ(e) {
  if (e.length < mf.length) return !1;
  for (let t = 0; t < mf.length; t++) if (e[t] !== mf[t]) return !1;
  return !0;
}
class $r extends Error {
  constructor(t) {
    super(t), this.name = "FxeFormatError";
  }
}
function yZ(e) {
  if (e.length < cc || !vZ(e)) throw new $r("e2e: not a filex encrypted file (.fxe)");
  if (e[8] !== _$) throw new $r(`e2e: unsupported .fxe version ${e[8]} - a newer filex wrote it`);
  const t = new DataView(e.buffer, e.byteOffset, e.byteLength).getUint32(9, !1);
  if (t === 0 || t > x$) throw new $r("e2e: the .fxe header length is out of range");
  return t;
}
function D1(e, t) {
  if (typeof e != "string" || e.length === 0) return !1;
  try {
    const n = Zn(e);
    return t === void 0 || n.length === t;
  } catch {
    return !1;
  }
}
function gZ(e, t) {
  var r, l, d, f, m;
  let n;
  try {
    n = JSON.parse(new TextDecoder("utf-8", { fatal: !0 }).decode(e));
  } catch {
    throw new $r("e2e: the .fxe header is not readable");
  }
  const a = (v) => new $r(`e2e: the .fxe header is damaged (${v})`);
  if (!n || typeof n != "object" || Array.isArray(n)) throw a("not an object");
  if (!D1(n.salt)) throw a("salt");
  if (typeof n.iter != "number" || !Number.isInteger(n.iter) || n.iter < 1 || n.iter > q2) throw a("iter");
  if (typeof n.verify != "string") throw a("verify");
  if (n.fmk !== "wrapped" || typeof n.fmk_pw != "string") throw a("fmk");
  if (n.rk !== void 0 && (typeof n.rk != "object" || typeof ((r = n.rk) == null ? void 0 : r.salt) != "string" || typeof ((l = n.rk) == null ? void 0 : l.blob) != "string"))
    throw a("rk");
  if (n.esc !== void 0 && (typeof n.esc != "object" || typeof ((d = n.esc) == null ? void 0 : d.kid) != "string" || typeof ((f = n.esc) == null ? void 0 : f.alg) != "string" || typeof ((m = n.esc) == null ? void 0 : m.blob) != "string"))
    throw a("esc");
  if (typeof n.dek != "string" || typeof n.name != "string") throw a("dek/name");
  if (!bc(n.chunk)) throw a("chunk");
  if (!D1(n.nonce, Pr)) throw a("nonce");
  if (typeof n.size != "number" || !Number.isSafeInteger(n.size) || n.size < 0) throw a("size");
  const i = [];
  if (n.req !== void 0) {
    if (!Array.isArray(n.req) || n.req.some((v) => typeof v != "string")) throw a("req");
    for (const v of n.req) fZ.includes(v) || i.push(v);
  }
  return { header: n, unsupported: i, prefixLength: t };
}
async function bZ(e) {
  const t = new cp(e);
  try {
    const n = await t.read(cc), a = yZ(n), i = await t.read(a);
    if (i.length < a) throw new $r("e2e: the .fxe file is truncated");
    return { parsed: gZ(i, cc + a), body: t.rest() };
  } catch (n) {
    throw await t.cancel().catch(() => {
    }), n;
  }
}
async function kZ(e, t) {
  const n = await r_(t, e.dek);
  if (!n || n.length !== pZ) return null;
  let a;
  try {
    a = await dp(new Uint8Array(n));
  } finally {
    n.fill(0);
  }
  const i = await r_(t, e.name);
  if (!i) return null;
  let r;
  try {
    r = new TextDecoder("utf-8", { fatal: !0 }).decode(i);
  } catch {
    return null;
  }
  return ji(r) ? null : { header: e, fmk: t, dek: a, name: r.normalize("NFC") };
}
async function wZ(e, t) {
  const n = Sg(e);
  let a;
  if ("password" in t) {
    const r = await nx(n, t.password);
    if ("error" in r) return { error: r.error };
    a = r.fmk;
  } else if ("recoveryKey" in t) {
    if (a = await ax(n, t.recoveryKey), !a) return { error: "wrong" };
  } else if (a = await ix(n, t.escrowKey), !a) return { error: "wrong" };
  const i = await kZ(e, a);
  return i ? { key: i } : { error: "damaged" };
}
function _Z(e, t) {
  return { ...e, header: t };
}
async function xZ(e, t, n, a, i = {}) {
  const r = (e ?? "").normalize("NFC"), l = ji(r);
  if (l) throw new Error(`e2e: invalid name (${l})`);
  if ((a ?? "").length < Df)
    throw new Error(`e2e: the password must be at least ${Df} characters`);
  if (!Number.isSafeInteger(t) || t < 0) throw new Error("e2e: bad file size");
  const d = i.chunkLog2 ?? mo;
  if (!bc(d)) throw new Error("e2e: bad chunk size");
  const f = await $v(a, {
    escrowPublicKey: i.escrowPublicKey ?? null,
    iterations: i.iterations
  }), m = F2();
  let v, b;
  try {
    v = await o_(f.fmk, m), b = await dp(m);
  } finally {
    m.fill(0);
  }
  const _ = N2(), w = f.marker, k = {
    salt: w.salt,
    iter: w.iter,
    verify: w.verify,
    fmk: "wrapped",
    fmk_pw: w.fmk_pw,
    ...w.rk ? { rk: w.rk } : {},
    ...w.esc ? { esc: w.esc } : {},
    dek: v,
    name: await o_(f.fmk, new TextEncoder().encode(r)),
    chunk: d,
    nonce: Aa(_),
    size: t
  }, x = $$(k), M = n.pipeThrough(
    I2(b, _, d, { expectSize: t, onProgress: i.onProgress })
  );
  return {
    header: k,
    stream: wc(x, M),
    size: x.length + zy(t, d),
    recoveryKey: f.recoveryKey,
    key: { header: k, fmk: f.fmk, dek: b, name: r }
  };
}
function Fm(e, t) {
  const n = e.header;
  return t.pipeThrough(B2(e.dek, Zn(n.nonce), n.chunk, { expectSize: n.size }));
}
async function SZ(e, t, n) {
  const a = await lx(Sg(e), t, n);
  if (a.fmk !== "wrapped" || !a.fmk_pw) throw new sn("e2e: the password slot did not re-seal");
  return { ...e, salt: a.salt, iter: a.iter, verify: a.verify, fmk: "wrapped", fmk_pw: a.fmk_pw };
}
function $Z(e, t) {
  const n = $$(e);
  return { stream: wc(n, t), size: n.length + zy(e.size, e.chunk) };
}
const ci = 1024 * 1024 * 1024;
function T$() {
  if (typeof window > "u") return null;
  const e = window;
  return typeof e.showSaveFilePicker == "function" && e.isSecureContext !== !1 ? e.showSaveFilePicker.bind(window) : null;
}
function TZ() {
  return T$() !== null;
}
class Rs extends Error {
  constructor() {
    super("save cancelled"), this.name = "SaveCancelled";
  }
}
class vf extends Error {
  constructor() {
    super("the save dialog needs a click"), this.name = "SaveNeedsGesture";
  }
}
class qa extends Error {
  constructor(t, n) {
    super(`e2e: ${t} bytes is more than this browser can save from memory (${n})`), this.size = t, this.limit = n, this.name = "SaveTooLarge";
  }
}
async function Um(e, t) {
  const n = T$();
  if (n) {
    let a;
    try {
      a = await n({ suggestedName: e });
    } catch (i) {
      const r = i == null ? void 0 : i.name;
      throw r === "AbortError" ? new Rs() : r === "SecurityError" || r === "NotAllowedError" ? new vf() : i;
    }
    return AZ(e, a);
  }
  if (t !== void 0 && t > ci) throw new qa(t, ci);
  return EZ(e);
}
function AZ(e, t) {
  let n = null;
  return {
    kind: "fsa",
    name: e,
    async write(a) {
      var l;
      n = await t.createWritable();
      const i = n, r = a.getReader();
      try {
        for (; ; ) {
          const { done: d, value: f } = await r.read();
          if (d) break;
          await i.write(f);
        }
        await i.close();
      } catch (d) {
        throw await i.abort(d).catch(() => {
        }), await r.cancel(d).catch(() => {
        }), await ((l = t.remove) == null ? void 0 : l.call(t).catch(() => {
        })), d;
      }
    },
    async discard() {
      var a;
      n && await n.abort().catch(() => {
      }), await ((a = t.remove) == null ? void 0 : a.call(t).catch(() => {
      }));
    }
  };
}
function EZ(e) {
  return {
    kind: "blob",
    name: e,
    async write(t, n) {
      const a = [];
      let i = 0;
      const r = t.getReader();
      try {
        for (; ; ) {
          const { done: m, value: v } = await r.read();
          if (m) break;
          if (i += v.length, i > ci) throw new qa(i, ci);
          a.push(new Blob([v]));
        }
      } catch (m) {
        throw await r.cancel(m).catch(() => {
        }), m;
      }
      const l = new Blob(a, { type: (n == null ? void 0 : n.mime) || "application/octet-stream" }), d = URL.createObjectURL(l), f = document.createElement("a");
      f.href = d, f.download = e, f.rel = "noopener", document.body.appendChild(f), f.click(), f.remove(), setTimeout(() => URL.revokeObjectURL(d), 6e4);
    },
    async discard() {
    }
  };
}
const ma = 4294967295, yf = 65535, CZ = new TextEncoder();
let Hm = null;
function zZ() {
  if (Hm) return Hm;
  const e = new Uint32Array(256);
  for (let t = 0; t < 256; t++) {
    let n = t;
    for (let a = 0; a < 8; a++) n = n & 1 ? 3988292384 ^ n >>> 1 : n >>> 1;
    e[t] = n >>> 0;
  }
  return Hm = e, e;
}
function MZ(e, t = 0) {
  const n = zZ();
  let a = (t ^ ma) >>> 0;
  for (let i = 0; i < e.length; i++) a = n[(a ^ e[i]) & 255] ^ a >>> 8;
  return (a ^ ma) >>> 0;
}
class Tr {
  constructor(t) {
    It(this, "buf");
    It(this, "dv");
    It(this, "o", 0);
    this.buf = new Uint8Array(t), this.dv = new DataView(this.buf.buffer);
  }
  u16(t) {
    return this.dv.setUint16(this.o, t, !0), this.o += 2, this;
  }
  u32(t) {
    return this.dv.setUint32(this.o, t >>> 0, !0), this.o += 4, this;
  }
  u64(t) {
    return this.dv.setUint32(this.o, t % 2 ** 32, !0), this.dv.setUint32(this.o + 4, Math.floor(t / 2 ** 32), !0), this.o += 8, this;
  }
  bytes(t) {
    return this.buf.set(t, this.o), this.o += t.length, this;
  }
  done() {
    if (this.o !== this.buf.length) throw new Error(`zip: record size ${this.o} != ${this.buf.length}`);
    return this.buf;
  }
}
function PZ(e) {
  const t = e.getFullYear();
  return t < 1980 ? { time: 0, date: 33 } : {
    time: e.getHours() << 11 | e.getMinutes() << 5 | Math.floor(e.getSeconds() / 2),
    date: Math.min(t, 2107) - 1980 << 9 | e.getMonth() + 1 << 5 | e.getDate()
  };
}
const A$ = 2048, E$ = 8, C$ = 813, OZ = 33188, DZ = 16877;
function LZ(e) {
  const t = e.zip64Local ? 20 : 0, n = new Tr(30 + e.name.length + t).u32(67324752).u16(e.zip64Local ? 45 : 20).u16(A$ | (e.dir ? 0 : E$)).u16(0).u16(e.time).u16(e.date).u32(0).u32(e.zip64Local ? ma : 0).u32(e.zip64Local ? ma : 0).u16(e.name.length).u16(t).bytes(e.name);
  return e.zip64Local && n.u16(1).u16(16).u64(0).u64(0), n.done();
}
function RZ(e) {
  return e.zip64Local ? new Tr(24).u32(134695760).u32(e.crc).u64(e.size).u64(e.size).done() : new Tr(16).u32(134695760).u32(e.crc).u32(e.size).u32(e.size).done();
}
function NZ(e, t) {
  const n = t || e.size >= ma, a = t || e.offset >= ma, i = n || a ? 4 + (n ? 16 : 0) + (a ? 8 : 0) : 0, r = new Tr(46 + e.name.length + i).u32(33639248).u16(C$).u16(n || a || e.zip64Local ? 45 : 20).u16(A$ | (e.dir ? 0 : E$)).u16(0).u16(e.time).u16(e.date).u32(e.crc).u32(n ? ma : e.size).u32(n ? ma : e.size).u16(e.name.length).u16(i).u16(0).u16(0).u16(0).u32((e.dir ? DZ : OZ) * 65536 + (e.dir ? 16 : 0) >>> 0).u32(a ? ma : e.offset).bytes(e.name);
  return i && (r.u16(1).u16(i - 4), n && r.u64(e.size).u64(e.size), a && r.u64(e.offset)), r.done();
}
function IZ(e, t, n, a) {
  const i = [], r = a || e >= yf || t >= ma || n >= ma;
  if (r) {
    const l = t + n;
    i.push(
      new Tr(56).u32(101075792).u64(44).u16(C$).u16(45).u32(0).u32(0).u64(e).u64(e).u64(n).u64(t).done()
    ), i.push(new Tr(20).u32(117853008).u32(0).u64(l).u32(1).done());
  }
  return i.push(
    new Tr(22).u32(101010256).u16(0).u16(0).u16(r ? yf : e).u16(r ? yf : e).u32(r ? ma : n).u32(r ? ma : t).u16(0).done()
  ), i;
}
function BZ(e, t) {
  const n = e.replace(/\\/g, "/").split("/").filter((a) => a !== "" && a !== ".");
  if (n.length === 0 || n.some((a) => a === "..")) throw new Error(`zip: unsafe entry name ${JSON.stringify(e)}`);
  return n.join("/") + (t ? "/" : "");
}
async function* FZ(e, t) {
  const n = !!t.forceZip64, a = [];
  let i = 0;
  const r = (f) => {
    var m;
    return i += f.length, (m = t.onProgress) == null || m.call(t, i), f;
  };
  for await (const f of e) {
    const m = f.name.endsWith("/") && !f.data, v = CZ.encode(BZ(f.name, m));
    if (v.length > yf) throw new Error("zip: entry name too long");
    const { time: b, date: _ } = PZ(f.mtime ?? /* @__PURE__ */ new Date()), w = {
      name: v,
      dir: m,
      zip64Local: !m && (n || f.sizeHint === void 0 || f.sizeHint >= ma),
      crc: 0,
      size: 0,
      offset: i,
      time: b,
      date: _
    };
    if (yield r(LZ(w)), !m && f.data) {
      const x = (typeof f.data == "function" ? await f.data() : f.data).getReader();
      try {
        for (; ; ) {
          const { done: M, value: A } = await x.read();
          if (M) break;
          !A || A.length === 0 || (w.crc = MZ(A, w.crc), w.size += A.length, yield r(A));
        }
      } catch (M) {
        throw await x.cancel(M).catch(() => {
        }), M;
      } finally {
        x.releaseLock();
      }
      if (!w.zip64Local && w.size >= ma) throw new Error(`zip: ${f.name} grew past its size hint and 4 GiB`);
      yield r(RZ(w));
    }
    a.push(w);
  }
  const l = i;
  for (const f of a) yield r(NZ(f, n));
  const d = i - l;
  for (const f of IZ(a.length, l, d, n)) yield r(f);
}
function UZ(e, t = {}) {
  const n = FZ(e, t);
  return new ReadableStream({
    async pull(a) {
      const { value: i, done: r } = await n.next();
      r ? a.close() : a.enqueue(i);
    },
    async cancel() {
      await n.return(void 0);
    }
  });
}
function L1(e, t) {
  let n = null;
  const a = () => n ?? (n = new cp(e));
  let i = 0, r = new Uint8Array(0), l = 0, d = !1;
  return {
    size: t,
    async read(f, m) {
      if (d) throw new Error("upload source cancelled");
      if (f < i || f > l || m < f || m > t)
        throw new Error(`upload source: cannot read [${f}, ${m}) after [${i}, ${l})`);
      const v = r.subarray(f - i);
      if (m > l) {
        const b = await a().read(m - l);
        if (b.length < m - l) throw new Error("upload source: the stream ended early");
        const _ = new Uint8Array(v.length + b.length);
        _.set(v, 0), _.set(b, v.length), r = _, l = m;
      } else
        r = v.slice();
      return i = f, new Blob([r.subarray(0, m - f)]);
    },
    cancel() {
      d || (d = !0, (n ? n.cancel() : e.cancel()).catch(() => {
      }));
    }
  };
}
async function R1(e, t, n = "application/octet-stream") {
  const a = [], i = e.getReader();
  for (; ; ) {
    const { done: r, value: l } = await i.read();
    if (r) break;
    a.push(new Blob([l]));
  }
  return new File(a, t, { type: n });
}
const HZ = [
  "fxe-encrypt",
  "fxe-request",
  "fxe-download-raw",
  "fxe-remove",
  "fxe-password",
  "e2e-download-encrypted"
];
function KZ(e) {
  return HZ.includes(e);
}
function Ri(e) {
  return !!e && e.type === "file" && S$(typeof e.e2e_stored == "string" ? e.e2e_stored : e.basename);
}
function z$(e, t) {
  const n = e.length === 1 ? e[0] : null;
  return !n || n.type !== "file" || Ri(n) || t.inEncrypted || n.e2e_root || !t.canWrite ? null : n;
}
function VZ(e, t) {
  const n = e.lastIndexOf(".");
  return n <= 0 ? `${e} (${t})` : `${e.slice(0, n)} (${t})${e.slice(n)}`;
}
function jZ(e) {
  const { api: t, t: n } = e, a = /* @__PURE__ */ new Map(), i = $(0), r = /* @__PURE__ */ new Map();
  function l() {
    for (const fe of r.values()) URL.revokeObjectURL(fe);
    r.clear();
  }
  Ot(() => {
    l(), a.clear();
  });
  const d = $(null), f = $(!1), m = $(null), v = $(null), b = $(null), _ = $("open"), w = $(!1), k = $(null), x = $(null), M = $(!1), A = $(!0), T = $("off"), N = $(null), z = $(null), L = $(!1), B = $(null), O = $(null);
  async function U(fe) {
    const Se = await t.authHeaders(), Z = await fetch(t.previewUrl(fe), {
      headers: Se,
      credentials: t.credentialsMode(),
      cache: "no-store"
    });
    if (!Z.ok) {
      const ge = await Z.text().catch(() => "");
      throw pa(Z.status, ge, e.locale());
    }
    if (!Z.body) throw new Error("e2e: this browser cannot read a download as a stream");
    return Z.body;
  }
  async function S(fe) {
    const Se = await t.index(fe);
    return new Set((Se.files ?? []).map((Z) => Z.basename));
  }
  function F(fe, Se) {
    if (!Se.has(fe)) return fe;
    for (let Z = 2; Z < 1e3; Z++) {
      const ge = VZ(fe, Z);
      if (!Se.has(ge)) return ge;
    }
    throw new Error("e2e: no free name");
  }
  async function I(fe, Se, Z, ge, ae, ve = {}) {
    const le = new File([], Se, { type: "application/octet-stream" }), { fields: _e, signal: Ee } = ve;
    if (Ee != null && Ee.aborted)
      throw await Z.cancel().catch(() => {
      }), new DOMException("Aborted by user", "AbortError");
    if (ge > e.chunked.threshold()) {
      const jt = L1(Z, ge);
      let tn = null;
      const Cn = () => tn == null ? void 0 : tn.cancel();
      Ee == null || Ee.addEventListener("abort", Cn);
      try {
        await e.chunked.uploadFile({
          path: fe,
          file: le,
          source: jt,
          commitQuery: _e,
          onProgress: (Lt) => {
            tn = Lt, Ee != null && Ee.aborted && Lt.cancel(), ae == null || ae(Lt.uploadedBytes);
          }
        });
        return;
      } catch (Lt) {
        if (!vy(Lt)) throw Lt;
        if (ge > ci)
          throw await Z.cancel().catch(() => {
          }), new qa(ge, ci);
      } finally {
        Ee == null || Ee.removeEventListener("abort", Cn);
      }
    }
    const ht = await R1(Z, Se);
    if (ht.size !== ge) throw new Error("e2e: the upload came out a different size than it should");
    if (Ee != null && Ee.aborted) throw new DOMException("Aborted by user", "AbortError");
    await t.uploadMultipart(fe, [ht], (jt) => ae == null ? void 0 : ae(Math.round(jt / 100 * ge)), _e);
  }
  async function G(fe) {
    const Se = Oa(fe);
    if (t.endpoints.deleteAsync) {
      const { op: Z } = await t.deleteAsync([fe], Se);
      e.registerOp(Z);
      return;
    }
    await t.deleteItems(Se, [fe]);
  }
  function Y(fe) {
    return fe instanceof Error && fe.message ? fe.message : String(fe);
  }
  function ie(fe) {
    return fe instanceof $r ? n("e2e.fxe.not_readable") : fe instanceof sn ? n("e2e.fxe.damaged") : Y(fe);
  }
  async function me(fe) {
    const { parsed: Se, body: Z } = await bZ(await U(fe));
    return { header: Se.header, unsupported: Se.unsupported, body: Z };
  }
  function q(fe, Se) {
    return fe.header.dek === Se.dek && fe.header.nonce === Se.nonce && fe.header.size === Se.size;
  }
  function C(fe) {
    var Se;
    return i.value, (Se = a.get(fe)) == null ? void 0 : Se.name;
  }
  function re(fe, Se) {
    const Z = fe.length === 1 ? fe[0] : null, ge = !!Z && Ri(Z), ae = z$(fe, Se) !== null, ve = Se.encryptAnswer ?? "allowed";
    return [
      {
        key: "fxe-encrypt",
        label: n("e2e.fxe.ctx_encrypt"),
        icon: "lock",
        hidden: !ae || ve !== "allowed"
      },
      /* wiring:e2 policy — the same place, where encrypting needs an approval. */
      {
        key: "fxe-request",
        label: n("e2e.request.ctx"),
        icon: "lock",
        hidden: !ae || ve !== "request"
      },
      { key: "fxe-download-raw", label: n("e2e.fxe.ctx_download_raw"), icon: "download", hidden: !ge },
      {
        key: "e2e-download-encrypted",
        label: n("e2e.dl.ctx_encrypted_copy"),
        icon: "download",
        hidden: ge || fe.length === 0 || !Se.unlockedEncryptedCopy
      },
      { key: "fxe-password", label: n("e2e.fxe.ctx_password"), icon: "lock", hidden: !ge || !Se.canWrite },
      { key: "fxe-remove", label: n("e2e.fxe.ctx_remove"), icon: "restore", hidden: !ge || !Se.canWrite }
    ];
  }
  function de(fe) {
    d.value = fe, m.value = null, v.value = null;
  }
  function V() {
    f.value || (d.value = null);
  }
  async function W(fe, Se) {
    for (const Z of await t.listVersions(Se)) await t.purgeVersion(Z.id);
    await t.deleteItems(Oa(fe.path), [fe.path]);
    try {
      await t.purgeTrash(Se);
    } catch (Z) {
      if (Z.status !== 404) throw Z;
    }
  }
  async function ne(fe) {
    const Se = d.value;
    if (!(!Se || f.value)) {
      f.value = !0, m.value = null, v.value = 0;
      try {
        const Z = Oa(Se.path), ge = typeof Se.size == "number" ? Se.size : NaN;
        if (!Number.isSafeInteger(ge) || ge < 0) throw new Error(n("e2e.fxe.size_unknown"));
        const ae = fe.purge === !0;
        if (ae && typeof Se.id != "number") throw new Error(n("e2e.fxe.purge_no_id"));
        if (ji(Se.basename)) throw new Error(n("e2e.fxe.bad_name"));
        const ve = await S(Z);
        let le = P1(Se.basename, fe.hideName);
        if (fe.hideName)
          for (let ht = 0; ve.has(le) && ht < 20; ht++) le = P1(Se.basename, !0);
        else
          le = `${F(Se.basename, new Set([...ve].filter(S$).map((ht) => ht.slice(0, -4))))}.fxe`;
        if (ji(le)) throw new Error(n("e2e.fxe.name_too_long"));
        const _e = await xZ(Se.basename, ge, await U(Se.path), fe.password, {
          escrowPublicKey: e.escrowPublicKey()
        });
        await I(Z, le, _e.stream, _e.size, (ht) => {
          v.value = _e.size > 0 ? Math.min(100, Math.round(ht / _e.size * 100)) : 100;
        });
        const Ee = Fs(Z, le);
        if (a.set(Ee, _e.key), i.value++, ae) {
          try {
            await W(Se, Se.id);
          } catch (ht) {
            d.value = null, e.emitError(Y(ht), "fxe-purge-original"), e.toast(n("e2e.fxe.purge_failed", { name: Se.basename, reason: Y(ht) }), !0), e.showRecoveryKey(_e.recoveryKey, Se.basename), await e.reload();
            return;
          }
          d.value = null, e.showRecoveryKey(_e.recoveryKey, Se.basename), e.toast(n("e2e.fxe.purged", { name: Se.basename })), await e.reload();
          return;
        }
        try {
          await G(Se.path);
        } catch (ht) {
          d.value = null, e.emitError(Y(ht), "fxe-trash-original"), e.toast(n("e2e.fxe.original_kept", { name: Se.basename }), !0), e.showRecoveryKey(_e.recoveryKey, Se.basename), await e.reload();
          return;
        }
        d.value = null, e.showRecoveryKey(_e.recoveryKey, Se.basename), e.toast(n("e2e.fxe.encrypted", { name: Se.basename })), await e.reload();
      } catch (Z) {
        m.value = Z instanceof qa ? n("e2e.fxe.upload_too_big") : Y(Z), e.emitError(Y(Z), "fxe-encrypt");
      } finally {
        f.value = !1, v.value = null;
      }
    }
  }
  function K(fe, Se) {
    b.value = fe, _.value = Se, k.value = null, M.value = !1, x.value = null, A.value = !0, T.value = "off", N.value = null, a.has(fe.path) || ce(fe);
  }
  async function ce(fe) {
    var Se, Z, ge;
    try {
      const { header: ae, body: ve } = await me(fe.path);
      if (await ve.cancel().catch(() => {
      }), ((Se = b.value) == null ? void 0 : Se.path) !== fe.path) return;
      A.value = O1(ae), T.value = Q2(Sg(ae), ((Z = e.escrowKid) == null ? void 0 : Z.call(e)) ?? null), N.value = ((ge = ae.esc) == null ? void 0 : ge.kid) ?? null;
    } catch {
    }
  }
  async function J(fe, Se) {
    const Z = await t.e2eEscrowChallenge(fe), ge = new Uint8Array(
      await crypto.subtle.decrypt({ name: "RSA-OAEP" }, Se, Zn(Z.challenge).buffer)
    );
    await t.e2eEscrowUsed({ path: fe, id: Z.id, nonce: Aa(ge) });
  }
  function H() {
    w.value || (b.value = null, M.value = !1);
  }
  async function X(fe) {
    const Se = a.get(fe.path);
    if (!Se) {
      K(fe, "open");
      return;
    }
    try {
      await nt(fe, Se);
    } catch (Z) {
      Ie(fe, Z, "fxe-open");
    }
  }
  async function we(fe) {
    if (await at(fe)) return;
    const Se = a.get(fe.path);
    if (!Se) {
      K(fe, "download");
      return;
    }
    try {
      await dt(fe, Se);
    } catch (Z) {
      if (Z instanceof vf) {
        K(fe, "download"), M.value = !0;
        return;
      }
      Ie(fe, Z, "fxe-download");
    }
  }
  function it(fe) {
    K(fe, "remove");
  }
  function Re(fe) {
    return `"${fe.replace(/(["\\$`])/g, "\\$1")}"`;
  }
  function Be(fe, Se, Z) {
    var ae;
    const ge = Qs(fe.path);
    O.value = {
      name: ((ae = a.get(fe.path)) == null ? void 0 : ae.name) ?? fe.basename,
      size: Se,
      limit: Z,
      encrypted: { kind: "file", path: fe.path },
      command: `filex decrypt ${Re(ge)}`
    };
  }
  function We(fe, Se, Z, ge) {
    const ae = Qs(Se) || "filex";
    O.value = {
      name: fe,
      size: Z,
      limit: ge,
      encrypted: { kind: "folder", path: Se },
      command: `filex decrypt ${Re(`${ae}.zip`)}`
    };
  }
  function bt() {
    O.value = null;
  }
  async function at(fe) {
    var ge;
    if (TZ()) return !1;
    const Se = (ge = a.get(fe.path)) == null ? void 0 : ge.header.size;
    let Z = typeof Se == "number" ? Se : null;
    if (Z === null) {
      if (typeof fe.size != "number" || fe.size <= ci) return !1;
      try {
        const { header: ae, body: ve } = await me(fe.path);
        await ve.cancel().catch(() => {
        }), Z = ae.size;
      } catch {
        return !1;
      }
    }
    return Z <= ci ? !1 : (Be(fe, Z, ci), !0);
  }
  function Ie(fe, Se, Z) {
    if (!(Se instanceof Rs)) {
      if (Se instanceof qa) {
        Be(fe, Se.size, Se.limit);
        return;
      }
      Se instanceof sn && (a.delete(fe.path), i.value++), e.emitError(Y(Se), Z), e.toast(ie(Se), !0);
    }
  }
  async function nt(fe, Se) {
    const { header: Z, body: ge } = await me(fe.path);
    if (!q(Se, Z))
      throw await ge.cancel().catch(() => {
      }), new sn("e2e: the file changed since it was opened");
    if (Z.size > ci)
      throw await ge.cancel().catch(() => {
      }), new qa(Z.size, ci);
    const ae = Pf(Se.name), ve = await R1(Fm(Se, ge), Se.name, Ks(ae)), le = r.get(fe.path);
    le && URL.revokeObjectURL(le);
    const _e = URL.createObjectURL(ve);
    r.set(fe.path, _e), e.openPreview(
      { ...fe, basename: Se.name, extension: ae, mime_type: Ks(ae), size: Z.size, fxe_name: Se.name },
      _e
    );
  }
  async function dt(fe, Se, Z) {
    const ge = await Um(Se.name, Se.header.size);
    let ae = !1;
    try {
      const { header: ve, body: le } = await me(fe.path);
      if (!q(Se, ve))
        throw await le.cancel().catch(() => {
        }), new sn("e2e: the file changed since it was opened");
      ae = !0, await ge.write(Fm(Se, le), { mime: Ks(Pf(Se.name)) }), e.toast(n("e2e.fxe.downloaded", { name: Se.name }));
    } catch (ve) {
      throw ae || await ge.discard(), ve;
    }
  }
  async function Me(fe, Se) {
    const Z = Oa(fe.path), { header: ge, body: ae } = await me(fe.path);
    if (!q(Se, ge))
      throw await ae.cancel().catch(() => {
      }), new sn("e2e: the file changed since it was opened");
    const ve = F(Se.name, await S(Z));
    x.value = 0, await I(Z, ve, Fm(Se, ae), ge.size, (le) => {
      x.value = ge.size > 0 ? Math.min(100, Math.round(le / ge.size * 100)) : 100;
    }), await G(fe.path), a.delete(fe.path), i.value++, e.toast(n("e2e.fxe.removed", { name: ve })), await e.reload();
  }
  async function be(fe = {}) {
    const Se = b.value;
    if (!(!Se || w.value)) {
      w.value = !0, k.value = null;
      try {
        let Z = a.get(Se.path);
        if (!Z || fe.password || fe.recoveryKey || fe.escrowKey) {
          let ge;
          if (fe.escrowKey)
            try {
              ge = { escrowKey: await G2(fe.escrowKey) };
            } catch {
              k.value = n("e2e.recover.bad_escrow_key");
              return;
            }
          else fe.recoveryKey ? ge = { recoveryKey: fe.recoveryKey } : ge = { password: fe.password ?? "" };
          const { header: ae, unsupported: ve, body: le } = await me(Se.path);
          if (await le.cancel().catch(() => {
          }), A.value = O1(ae), ve.length > 0) {
            k.value = n("e2e.fxe.unsupported", { features: ve.join(", ") });
            return;
          }
          const _e = await wZ(ae, ge);
          if ("error" in _e) {
            k.value = _e.error === "damaged" ? n("e2e.fxe.damaged") : "escrowKey" in ge ? n("e2e.fxe.wrong_escrow") : "recoveryKey" in ge ? n("e2e.fxe.wrong_recovery") : n("e2e.fxe.wrong_password");
            return;
          }
          if ("escrowKey" in ge) {
            try {
              await J(Se.path, ge.escrowKey);
            } catch (Ee) {
              k.value = n("e2e.fxe.escrow_notify_failed"), e.emitError(Y(Ee), "fxe-escrow-notify");
              return;
            }
            e.toast(n("e2e.fxe.escrow_done"));
          }
          Z = _e.key, a.set(Se.path, Z), i.value++;
        }
        if (_.value === "open")
          await nt(Se, Z), b.value = null;
        else if (_.value === "download") {
          try {
            await dt(Se, Z);
          } catch (ge) {
            if (ge instanceof vf) {
              M.value = !0;
              return;
            }
            throw ge;
          }
          b.value = null, M.value = !1;
        } else
          await Me(Se, Z), b.value = null;
      } catch (Z) {
        if (Z instanceof Rs) return;
        if (Z instanceof qa && _.value === "download") {
          b.value = null, Be(Se, Z.size, Z.limit);
          return;
        }
        k.value = Z instanceof qa ? n("e2e.dl.too_big", { size: xe(Z.size), limit: xe(Z.limit) }) : ie(Z), Z instanceof sn && (a.delete(Se.path), i.value++), e.emitError(Y(Z), `fxe-${_.value}`);
      } finally {
        w.value = !1, x.value = null;
      }
    }
  }
  function Ve(fe) {
    z.value = fe, B.value = null;
  }
  function Te() {
    L.value || (z.value = null);
  }
  async function qe(fe) {
    const Se = z.value;
    if (!Se || L.value) return;
    if (!fe.proof) {
      B.value = n("e2e.password.current_required");
      return;
    }
    L.value = !0, B.value = null;
    const Z = "recoveryKey" in fe.proof ? "recovery_key" : "password";
    try {
      const { header: ge, unsupported: ae, body: ve } = await me(Se.path);
      if (ae.length > 0) {
        await ve.cancel().catch(() => {
        }), B.value = n("e2e.fxe.unsupported", { features: ae.join(", ") });
        return;
      }
      let le;
      try {
        le = await SZ(ge, fe.proof, fe.newPassword);
      } catch (ht) {
        if (await ve.cancel().catch(() => {
        }), ht instanceof sn) {
          B.value = n(Z === "recovery_key" ? "e2e.password.wrong_recovery" : "e2e.password.wrong_current");
          return;
        }
        throw ht;
      }
      const _e = $Z(le, ve);
      await I(Oa(Se.path), Qs(Se.path), _e.stream, _e.size);
      const Ee = a.get(Se.path);
      Ee && a.set(Se.path, _Z(Ee, le)), i.value++, z.value = null, e.toast(n("e2e.fxe.password_done")), await e.reload();
    } catch (ge) {
      B.value = n("e2e.password.failed"), e.emitError(Y(ge), "fxe-password");
    } finally {
      L.value = !1;
    }
  }
  async function De(fe, Se, Z, ge) {
    const ae = (le) => {
      ge ? We(fe.basename, ge, le.size, le.limit) : e.toast(n("e2e.dl.too_big", { size: xe(le.size), limit: xe(le.limit) }), !0);
    };
    let ve;
    try {
      ve = await Um(fe.basename, fe.size);
    } catch (le) {
      le instanceof qa ? ae(le) : Ie(fe, le, "e2e-download");
      return;
    }
    try {
      const le = _v(Se, Z, await U(fe.path), { passPlain: !0 });
      await ve.write(le, { mime: Ks(fe.extension) });
    } catch (le) {
      if (await ve.discard(), le instanceof Rs) return;
      if (le instanceof qa) {
        ae(le);
        return;
      }
      e.emitError(Y(le), "e2e-download"), e.toast(n("e2e.download.failed"), !0);
    }
  }
  async function mt(fe, Se) {
    let Z;
    try {
      Z = await Um(Se.zipName);
    } catch (Ee) {
      if (Ee instanceof Rs) return;
      if (Ee instanceof vf) {
        e.toast(n("e2e.dl.click_again"), !0);
        return;
      }
      throw Ee;
    }
    let ge = 0;
    const ae = (Ee, ht) => ({
      name: ht,
      sizeHint: typeof Ee.size == "number" ? Ee.size : void 0,
      mtime: typeof Ee.last_modified == "number" ? new Date(Ee.last_modified) : void 0,
      data: async () => _v(Se.fmk, Se.previous, await U(Ee.path), {
        passPlain: !0,
        onPlain: () => ge++
      })
    }), ve = (Ee) => (Ee.e2e_name_state === "locked" || Ee.e2e_name_state === "unreadable") && typeof Ee.e2e_stored == "string" ? Ee.e2e_stored : Ee.basename;
    async function* le(Ee, ht) {
      yield { name: `${ht}/` };
      const jt = await t.index(Ee.path), tn = await Se.decorate(jt.files ?? [], { root: Se.root }), Cn = /* @__PURE__ */ new Set();
      for (const Lt of tn) {
        if (Lt.basename === ha || typeof Lt.e2e_stored != "string" && Lt.basename === ha) continue;
        const At = F(ve(Lt), Cn);
        Cn.add(At), Lt.type === "dir" ? yield* le(Lt, `${ht}/${At}`) : yield ae(Lt, `${ht}/${At}`);
      }
    }
    async function* _e() {
      const Ee = /* @__PURE__ */ new Set();
      for (const ht of fe) {
        const jt = F(ve(ht), Ee);
        Ee.add(jt), ht.type === "dir" ? yield* le(ht, jt) : yield ae(ht, jt);
      }
    }
    e.toast(n("e2e.dl.zip_started", { name: Se.zipName }));
    try {
      await Z.write(UZ(_e()), { mime: "application/zip" }), e.toast(
        ge > 0 ? n("e2e.dl.zip_done_plain", { name: Se.zipName, n: ge }) : n("e2e.dl.zip_done", { name: Se.zipName })
      );
    } catch (Ee) {
      if (await Z.discard(), Ee instanceof Rs) return;
      if (Ee instanceof qa) {
        We(Se.zipName, Se.root, null, Ee.limit);
        return;
      }
      e.emitError(Y(Ee), "e2e-download-zip"), e.toast(Ee instanceof sn ? n("e2e.dl.zip_damaged") : n("e2e.download.failed"), !0);
    }
  }
  async function $t(fe, Se) {
    const Z = await i_(Se, fe.size, fe.stream());
    return L1(Z.stream, Z.size);
  }
  async function kt(fe, Se, Z, ge = {}) {
    const ae = fe.size;
    if (typeof ae != "number" || !Number.isSafeInteger(ae) || ae < 0)
      throw new Error("e2e: unknown file size");
    const ve = await i_(Se, ae, await U(fe.path)), le = ge.onProgress ? (_e) => ge.onProgress(ve.size > 0 ? Math.min(1, _e / ve.size) : 1) : void 0;
    try {
      await I(Oa(fe.path), fe.basename, ve.stream, ve.size, le, {
        fields: { e2e_convert: "1", ...Z ? { expect: Z } : {} },
        signal: ge.signal
      });
    } catch (_e) {
      if (_e instanceof qa) return !1;
      throw _e;
    }
    return !0;
  }
  async function Tt(fe, Se, Z) {
    const ge = new cp(await U(fe.path)), ae = await ge.read(cD);
    if (!cl(ae))
      return await ge.cancel().catch(() => {
      }), !1;
    const ve = await cx(ae.buffer, Se, Z);
    if (!ve)
      return await ge.cancel().catch(() => {
      }), !0;
    const le = typeof fe.size == "number" ? fe.size : NaN;
    if (!Number.isSafeInteger(le))
      throw await ge.cancel().catch(() => {
      }), new Error("e2e: unknown file size");
    const _e = typeof fe.e2e_stored == "string" ? fe.e2e_stored : fe.basename;
    return await I(Oa(fe.path), _e, wc(new Uint8Array(ve), ge.rest()), le), !0;
  }
  const { formatSize: xe } = yt(() => e.locale() ?? "en");
  async function Ne(fe, Se, Z) {
    var ae;
    const ge = Se[0];
    switch (fe) {
      case "fxe-encrypt":
        return ge && de(ge), !0;
      case "fxe-request":
        return ge && ((ae = e.requestEncrypt) == null || ae.call(e, ge)), !0;
      case "fxe-download-raw":
        return ge && window.open(t.downloadUrl(ge.path), "_blank"), !0;
      case "fxe-password":
        return ge && Ve(ge), !0;
      case "fxe-remove":
        return ge && it(ge), !0;
      case "e2e-download-encrypted":
        return await Z(Se), !0;
    }
    return !1;
  }
  return {
    ringVer: i,
    realName: C,
    isHiddenFxeName: mZ,
    menuRows: re,
    dispatch: Ne,
    // encrypt
    encryptTarget: d,
    encryptBusy: f,
    encryptError: m,
    encryptProgress: v,
    startEncrypt: de,
    closeEncrypt: V,
    submitEncrypt: ne,
    // open / download / remove
    unlockTarget: b,
    unlockIntent: _,
    unlockBusy: w,
    unlockError: k,
    unlockProgress: x,
    unlockNeedsSave: M,
    unlockHasRecovery: A,
    unlockEscrow: T,
    unlockEscrowKid: N,
    open: X,
    download: we,
    startRemove: it,
    closeUnlock: H,
    submitUnlock: be,
    // password
    pwTarget: z,
    pwBusy: L,
    pwError: B,
    // too big for this browser
    tooBig: O,
    closeTooBig: bt,
    startPassword: Ve,
    closePassword: Te,
    submitPassword: qe,
    // encrypted folders
    downloadFolderFile: De,
    downloadDecryptedZip: mt,
    folderUploadSource: $t,
    convertLarge: kt,
    rewrapLarge: Tt,
    revokeAll: l
  };
}
function qZ(e, t) {
  const n = String(t ?? "").replace(/\/+$/, "");
  return n === e ? "" : n.slice(e.length + 1);
}
function WZ(e) {
  const t = new Set(YZ()), n = _0({}), a = $(0);
  let i = null, r = null;
  function l(x) {
    t.has(x) || (t.add(x), N1([...t]));
  }
  function d(x) {
    t.delete(x) && N1([...t]);
  }
  function f(x) {
    const M = String(x ?? "").replace(/\/+$/, "");
    let A = null;
    for (const T of [...(i == null ? void 0 : i.openRoots()) ?? [], ...t])
      (M === T || M.startsWith(T + "/")) && (!A || T.length > A.length) && (A = T);
    return A;
  }
  function m() {
    return [.../* @__PURE__ */ new Set([...(i == null ? void 0 : i.openRoots()) ?? [], ...t])];
  }
  const v = { strips: n, version: a, rootOf: f, remember: l };
  function b() {
    return i ? Promise.resolve(i) : (r || (r = import("./e2eVaultEngine-B4ESsXSr.js").then(
      (x) => i = x.createVaultEngine(e, v),
      (x) => {
        throw r = null, x;
      }
    )), r);
  }
  function _(x) {
    return !!x && typeof x.vault_root == "string" && !!x.vault_root;
  }
  function w(x) {
    if (i) {
      i.lock(x);
      return;
    }
    e.dropKeys(x), e.onLocked(x, "manual");
  }
  function k() {
    i == null || i.onPageHide();
  }
  return {
    version: a,
    strips: n,
    rootOf: f,
    roots: m,
    isVaultRow: _,
    forget: d,
    relOf: qZ,
    isOpen: (x) => !!(i != null && i.isOpen(x)),
    permOf: (x) => i == null ? void 0 : i.permOf(x),
    node: (...x) => (i == null ? void 0 : i.node(...x)) ?? null,
    rows: (...x) => (i == null ? void 0 : i.rows(...x)) ?? null,
    search: (...x) => (i == null ? void 0 : i.search(...x)) ?? null,
    close: (...x) => i == null ? void 0 : i.close(...x),
    closeAll: (...x) => i == null ? void 0 : i.closeAll(...x),
    touch: (...x) => i == null ? void 0 : i.touch(...x),
    onVisible: () => i == null ? void 0 : i.onVisible(),
    onEvent: (...x) => i == null ? void 0 : i.onEvent(...x),
    dismiss: (...x) => i == null ? void 0 : i.dismiss(...x),
    lock: w,
    onPageHide: k,
    open: async (...x) => (await b()).open(...x),
    create: async (...x) => (await b()).create(...x),
    readBytes: async (...x) => (await b()).readBytes(...x),
    readUrl: async (...x) => (await b()).readUrl(...x),
    /** filex 0.56 (#189): an app's interface reads / saves a file of an open
     *  vault (lib/appPlaintext createAppVaultDoor). No engine: no vault is
     *  open, so nothing is loaded for it. */
    readForApp: async (...x) => i ? i.readForApp(...x) : { ok: !1, why: "locked" },
    saveForApp: async (...x) => i ? i.saveForApp(...x) : { ok: !1, why: "locked" },
    keyForApp: (...x) => (i == null ? void 0 : i.keyForApp(...x)) ?? null,
    download: async (...x) => (await b()).download(...x),
    upload: async (...x) => (await b()).upload(...x),
    mkdir: async (...x) => (await b()).mkdir(...x),
    rename: async (...x) => (await b()).rename(...x),
    move: async (...x) => (await b()).move(...x),
    copy: async (...x) => (await b()).copy(...x),
    remove: async (...x) => (await b()).remove(...x),
    takeOver: async (...x) => (await b()).takeOver(...x),
    continueFromShown: async (...x) => (await b()).continueFromShown(...x),
    /** The person's idle time (minutes, 1-10), kept on the server. */
    idlePrefs: {
      get: async () => (await b()).idlePrefs.get(),
      set: async (x) => (await b()).idlePrefs.set(x)
    }
  };
}
const M$ = "filex.e2e.vaults", P$ = 200;
function YZ() {
  try {
    const e = typeof localStorage > "u" ? null : localStorage.getItem(M$), t = e ? JSON.parse(e) : [];
    return Array.isArray(t) ? t.filter((n) => typeof n == "string" && n.includes("://")).slice(-P$) : [];
  } catch {
    return [];
  }
}
function N1(e) {
  try {
    typeof localStorage < "u" && localStorage.setItem(M$, JSON.stringify(e.slice(-P$)));
  } catch {
  }
}
const GZ = {
  class: "fe-e2e-names__hint",
  "data-testid": "e2e-request-lead"
}, XZ = { class: "fe-field" }, JZ = { class: "fe-field__label" }, ZZ = ["placeholder", "disabled"], QZ = {
  key: 0,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "e2e-request-error"
}, eQ = ["disabled"], tQ = ["disabled", "aria-busy"], nQ = /* @__PURE__ */ lt({
  __name: "E2eRequestModal",
  props: {
    open: { type: Boolean },
    locale: {},
    api: {},
    path: {},
    kind: {},
    name: {}
  },
  emits: ["close", "sent"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = E(
      () => n.kind === "file" ? i("e2e.request.lead_file") : n.kind === "folder" ? i("e2e.request.lead_folder") : i("e2e.request.lead")
    ), l = E(() => fc("e2e_request_reason_max_runes")), d = $("");
    Xe(d, (b) => {
      const _ = iy(b, l.value);
      _ !== b && (d.value = _);
    });
    const f = $(!1), m = $(null);
    Xe(
      () => n.open,
      (b) => {
        b && (d.value = "", m.value = null);
      }
    );
    async function v() {
      if (f.value) return;
      const b = d.value.trim();
      if (!b) {
        m.value = i("e2e.request.reason_required");
        return;
      }
      f.value = !0, m.value = null;
      try {
        const _ = await n.api.e2eRequest({ path: n.path, kind: n.kind, reason: b });
        a("sent", _);
      } catch (_) {
        m.value = U0(_, i("e2e.request.failed"), { t: i }).text;
      } finally {
        f.value = !1;
      }
    }
    return (b, _) => (p(), Je(na, {
      open: e.open,
      locale: e.locale,
      title: u(i)("e2e.request.title", { name: e.name }),
      size: "sm",
      busy: f.value,
      onClose: _[2] || (_[2] = (w) => a("close"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          disabled: f.value,
          onClick: _[1] || (_[1] = (w) => a("close"))
        }, y(u(i)("modal.newfolder.cancel")), 9, eQ),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: f.value,
          "aria-busy": f.value ? "true" : void 0,
          "data-testid": "e2e-request-send",
          onClick: v
        }, y(f.value ? u(i)("e2e.request.sending") : u(i)("e2e.request.send")), 9, tQ)
      ]),
      default: gt(() => [
        c("form", {
          class: "fe-e2e-form",
          "data-testid": "e2e-request",
          onSubmit: vt(v, ["prevent"])
        }, [
          c("p", GZ, y(r.value), 1),
          c("label", XZ, [
            c("span", JZ, y(u(i)("e2e.request.reason")), 1),
            un(c("textarea", {
              "onUpdate:modelValue": _[0] || (_[0] = (w) => d.value = w),
              class: "fe-input",
              rows: "4",
              placeholder: u(i)("e2e.request.reason_placeholder"),
              disabled: f.value,
              "data-testid": "e2e-request-reason"
            }, null, 8, ZZ), [
              [bn, d.value]
            ])
          ]),
          m.value ? (p(), h("p", QZ, y(m.value), 1)) : D("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "locale", "title", "busy"]));
  }
}), aQ = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function I1(e) {
  if (typeof e != "string" || !e) return;
  const t = Date.parse(e);
  return Number.isFinite(t) ? t : void 0;
}
function iQ(e, t) {
  var w;
  const n = String((e == null ? void 0 : e.path) ?? "").replace(/^\/+/, "");
  if (!n) return null;
  const a = t.storages ?? [], i = typeof e.storage == "string" && e.storage ? e.storage : a.length === 1 ? a[0].name : "";
  if (t.multiStorageRoot && !i) return null;
  const r = String(e.name ?? n.split("/").pop() ?? ""), l = e.type === "dir", d = e.type === "symlink", f = typeof e.size == "number" ? e.size : 0, m = typeof e.id == "number" ? e.id : void 0, v = typeof e.perm == "string" && aQ.has(e.perm) ? e.perm : void 0, b = ((w = a.find((k) => k.name === i)) == null ? void 0 : w.readOnly) === !0, _ = typeof e.read_only == "boolean" ? e.read_only : b;
  return {
    type: l ? "dir" : "file",
    id: m,
    /* tablo:t1 — ⚠⚠ THE DATE. A node row carries `backend_mtime` (what the
       storage says) and `db_mtime` (what our last scan recorded) as RFC3339
       strings; `FileNode.last_modified` is unix MILLISECONDS. Nothing mapped
       between the two, so every row from Recent, Starred and a tag view
       arrived with no date at all — measured on Recent: eleven rows, eleven em
       dashes in the Modified column, and a Modified column header you could
       click that then sorted nothing. It also made the date grouping this view
       is supposed to show impossible, because every row fell in the "No date"
       bucket. Storage first: `backend_mtime` is the file's own truth and
       `db_mtime` only says when we last looked at it. */
    last_modified: I1(e.backend_mtime) ?? I1(e.db_mtime),
    path: i ? `${i}://${n}` : n,
    basename: r,
    extension: l ? "" : r.includes(".") ? (r.split(".").pop() || "").toLowerCase() : "",
    storage: i,
    visibility: "private",
    size: f,
    file_size: f,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    ...v ? { perm: v } : {},
    read_only: _,
    /* #207 (0.54) — whether the row is starred is the row's own fact: the
       server puts `starred: true` on every listing and view row it answers
       (handlers/meta.go), and the explorer no longer fetches a star list of
       its own to match ids against. Dropped here, every Starred / Recent /
       tag / Home row read as unstarred, so the menu offered "Star" on a file
       in Starred and the inline star was hollow. */
    ...e.starred === !0 ? { starred: !0 } : {},
    /* ...and WHY it will not open, under the folder listing's own name: the
       node row carries the reason the sync recorded (`link_state`, migration
       00098), so the badge here says "Outside storage" exactly where the
       folder says it. A row without one reads as the general "Link". */
    ...d ? {
      symlink: !0,
      ...typeof e.link_state == "string" && e.link_state ? { link_state: e.link_state } : {}
    } : {},
    /* issue #104 - an entry the storage could not answer for. The raw node
       row carries the flag and the storage's answer under the same names the
       folder listing uses, so Recent, Starred, a tag view and Home badge it
       and refuse it exactly as the folder does (lib/unavailable). */
    ...e.unavailable === !0 ? {
      unavailable: !0,
      ...typeof e.unavailable_reason == "string" ? { unavailable_reason: e.unavailable_reason } : {}
    } : {},
    // ⚠⚠ The SERVER's `thumb_url`, never one built here. It used to be
    // `/api/files/thumb/<id>` for every file, and the endpoint answers
    // `404 "not ready"` for everything it has not rendered — a docx, a
    // markdown note, a diagram: opening Recent with ten such files fired ten
    // requests and all ten 404'd (2026-09-21). The rows now carry the URL
    // exactly when there is an image behind it (handlers/meta.go, the folder
    // listing's rule), so a file with none is never asked about.
    thumb_url: !l && typeof e.thumb_url == "string" && e.thumb_url ? e.thumb_url : void 0,
    /* wiring:e2 names — the encrypted folder the row sits in (the server
       answers it for rows outside a folder listing). The explorer's name view
       reads it to name the row, and openNode to open it in its folder. */
    ...typeof e.e2e_root == "string" && e.e2e_root ? { e2e_root: e.e2e_root } : {},
    /* #189 - how the file is end-to-end encrypted, as the SERVER stamps the
       row (`folder` / `vault` / `file`, handlers/meta.go, the folder
       listing's rule). An app's interface opened from Recent, Starred, a tag
       view or Home is handed it as is (FileInfo.encrypted); dropped here, it
       was told an encrypted file is not. */
    ...Ru(e.encrypted) ? { encrypted: e.encrypted } : {},
    extra_metadata: {}
  };
}
const oQ = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function rQ(e) {
  return typeof e == "string" && oQ.has(e);
}
function sQ(e, t) {
  return rQ(t) ? e.map((n) => typeof n.perm == "string" ? n : { ...n, perm: t }) : e;
}
function lQ(e, t) {
  if (!e)
    return t || void 0;
}
function Km(e, t) {
  return e.openInHost && t.type === "file" ? "host" : "page";
}
class O$ extends Error {
}
const uQ = 1500;
function D$(e) {
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" ? t : {};
  } catch {
    return {};
  }
}
async function cQ(e) {
  return D$(await e.text().catch(() => ""));
}
async function dQ(e, t = uQ) {
  var d, f, m, v;
  const n = e.sleep ?? ((b) => new Promise((_) => setTimeout(_, b))), a = await e.start(), i = await a.text().catch(() => ""), r = D$(i);
  let l;
  if (a.status === 409 && r.code === "BUSY") {
    const b = r.job;
    if (!(b != null && b.running))
      throw new O$(typeof r.message == "string" && r.message ? r.message : String(r.error ?? "busy"));
    (d = e.onBusy) == null || d.call(e, typeof r.message == "string" ? r.message : ""), l = b;
  } else if (a.ok)
    l = r;
  else
    throw pa(a.status, i, e.locale);
  for ((f = e.onStart) == null || f.call(e, l); l.running; ) {
    if ((m = e.onProgress) == null || m.call(e, l), await n(t), (v = e.stopped) != null && v.call(e)) return null;
    try {
      const b = await e.status(), _ = b.ok ? await cQ(b) : {};
      typeof _.running == "boolean" && (l = _);
    } catch {
    }
  }
  return l;
}
function B1(e) {
  const t = String(e ?? "").indexOf("://");
  return t === -1 ? "" : e.slice(0, t);
}
function F1(e, t, n = "auto") {
  const a = B1(t), i = e.some((r) => {
    const l = B1(r);
    return l !== "" && a !== "" && l !== a;
  });
  return n === "copy" ? { kind: "copy", cross: i } : n === "move" ? { kind: "move", cross: i } : { kind: i ? "copy" : "move", cross: i };
}
function L$(e) {
  return e.split("?")[0].replace(/\/manager$/, "/archive/download");
}
const U1 = "/api/files/manager";
function R$(e, t) {
  if (/^https?:\/\//i.test(t)) return t;
  const n = e.split("?")[0];
  if (n.endsWith(U1)) return ay(n.slice(0, -U1.length), t);
  const a = /^(https?:\/\/[^/]+)/i.exec(n);
  return a ? a[1] + t : t;
}
async function fQ(e, t, n) {
  const a = L$(e.endpoints.manager);
  return e.jsonFetch(a, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(n ? { paths: t, name: n } : { paths: t })
  });
}
async function pQ(e, t) {
  const n = await e.jsonFetch(
    L$(e.endpoints.manager),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ paths: [t], mode: "file" })
    }
  );
  if (!n || n.mode !== "file" || typeof n.url != "string") return null;
  const a = Number(n.ttl_seconds);
  return {
    url: R$(e.endpoints.manager, n.url),
    ttlMs: Number.isFinite(a) && a > 0 ? a * 1e3 : 6e4
  };
}
const hQ = 6e4;
function mQ(e, t = document) {
  const n = t.createElement("iframe");
  n.hidden = !0, n.setAttribute("aria-hidden", "true"), n.style.display = "none", n.src = e, t.body.appendChild(n), setTimeout(() => n.remove(), hQ);
}
async function vQ(e, t, n = {}) {
  const a = await fQ(e, t, n.name);
  return mQ(
    R$(e.endpoints.manager, a.url),
    n.doc ?? document
  ), a;
}
function N$(e) {
  return String(e.path ?? "").replace(/^\/+|\/+$/g, "");
}
function Jv(e, t) {
  return typeof e.storage == "string" && e.storage ? e.storage : typeof e.storage_name == "string" && e.storage_name ? e.storage_name : t.configured.length === 1 && t.configured[0] ? t.configured[0] : t.current || "";
}
function gf(e, t) {
  const n = String(e.path ?? "").replace(/^\/+/, ""), a = typeof e.storage == "string" && e.storage ? e.storage : t, i = String(e.name ?? n.split("/").pop() ?? ""), r = i.lastIndexOf("."), l = typeof e.backend_mtime == "string" ? e.backend_mtime : e.updated_at, d = typeof l == "string" ? Date.parse(l) : NaN;
  return {
    id: typeof e.id == "number" ? e.id : void 0,
    path: a ? `${a}://${n}` : n,
    basename: i,
    relativePath: n,
    type: e.type === "dir" ? "dir" : "file",
    extension: r > 0 ? i.slice(r + 1).toLowerCase() : "",
    size: typeof e.size == "number" ? e.size : 0,
    // ⚠ Left UNSET when the row carries no parseable timestamp rather than
    // defaulted to 0 or to now: `matchesModified` treats a missing timestamp
    // as "unknown" and drops the row from a date filter, which is the honest
    // answer. Stamping it with `Date.now()` would file every such file under
    // "Today".
    last_modified: Number.isNaN(d) ? void 0 : d,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    /* The content snippet the hit came with, so a content match can show why
       it matched. Undefined on name-only hits, exactly as the backend sends. */
    snippet: typeof e.snippet == "string" && e.snippet ? e.snippet : void 0,
    /* Owner, so the People filter and the Owner column mean the same thing in a
       content result as they do in a folder listing. Undefined rather than
       guessed when the backend does not send it. */
    owner_id: typeof e.owner_id == "number" ? e.owner_id : void 0,
    owner_name: typeof e.owner_name == "string" ? e.owner_name : void 0,
    owner_self: e.owner_self === !0 ? !0 : void 0,
    /* wiring:e2 names — the encrypted folder the hit sits in (the server
       answers it); the explorer's name view reads it. */
    ...typeof e.e2e_root == "string" && e.e2e_root ? { e2e_root: e.e2e_root } : {},
    /* #189 - how the hit is end-to-end encrypted, as the server stamps it
       (`folder` / `vault` / `file`); an app's interface opened from a
       search result is handed it as is (FileInfo.encrypted). */
    ...Ru(e.encrypted) ? { encrypted: e.encrypted } : {}
  };
}
function yQ(e, t) {
  const n = Jv(e, t);
  if (!N$(e) || !n) return null;
  const a = gf(e, n);
  return {
    path: a.path,
    basename: a.basename,
    type: a.type,
    ...a.e2e_root ? { e2e_root: a.e2e_root } : {},
    ...a.encrypted ? { encrypted: a.encrypted } : {}
  };
}
function Rce(e, t) {
  var i;
  const n = [], a = /* @__PURE__ */ new Map();
  for (const r of e) {
    const l = ((i = r.account) == null ? void 0 : i.id) ?? "";
    let d = a.get(l);
    d || (d = { account: r.account, hits: [] }, a.set(l, d), n.push(d)), d.hits.length < t && d.hits.push(r);
  }
  return n;
}
function gQ(e) {
  if (!e) return [];
  const t = e.items;
  if (t && t.length > 0) {
    const n = [];
    let a = !1;
    for (let i = 0; i < t.length; i++) {
      const r = t[i];
      if (!r || r.kind !== "file") continue;
      a = !0;
      const l = r.webkitGetAsEntry ?? r.getAsEntry, d = typeof l == "function" ? l.call(r) : null;
      if (d && d.isDirectory) {
        n.push({ kind: "entry", entry: d });
        continue;
      }
      const f = r.getAsFile();
      f ? n.push({ kind: "file", file: f }) : d && d.isFile && n.push({ kind: "entry", entry: d });
    }
    if (a) return n;
  }
  return Array.from(e.files ?? []).map((n) => ({ kind: "file", file: n }));
}
function bQ(e) {
  return new Promise((t, n) => {
    if (typeof e.file != "function") {
      n(new Error("not a file entry"));
      return;
    }
    e.file(t, n);
  });
}
async function kQ(e) {
  if (typeof e.createReader != "function") throw new Error("not a folder entry");
  const t = e.createReader(), n = [];
  for (; ; ) {
    const a = await new Promise((i, r) => t.readEntries(i, r));
    if (a.length === 0) return n;
    n.push(...a);
  }
}
function wQ(e, t) {
  return e ? `${e}/${t}` : t;
}
async function _Q(e) {
  const t = { dirs: [], files: [], unreadable: [] }, n = async (a, i) => {
    const r = wQ(i, a.name);
    if (a.isDirectory) {
      let l;
      try {
        l = await kQ(a);
      } catch {
        t.unreadable.push(r);
        return;
      }
      t.dirs.push(r);
      for (const d of l) await n(d, r);
      return;
    }
    if (a.isFile)
      try {
        t.files.push({ file: await bQ(a), dir: i });
      } catch {
        t.unreadable.push(r);
      }
  };
  for (const a of e)
    a.kind === "file" ? t.files.push({ file: a.file, dir: "" }) : await n(a.entry, "");
  return t;
}
function xQ(e) {
  const t = /* @__PURE__ */ new Set();
  for (const { dir: n } of e.files)
    for (let a = n; a; a = a.includes("/") ? a.slice(0, a.lastIndexOf("/")) : "") t.add(a);
  return e.dirs.filter((n) => !t.has(n));
}
async function SQ(e, t, n) {
  const a = /* @__PURE__ */ new Map([["", t]]);
  for (const r of e.dirs) {
    const l = r.lastIndexOf("/"), d = a.get(l === -1 ? "" : r.slice(0, l));
    if (d !== void 0)
      try {
        a.set(r, await n.mkdir(d, r.slice(l + 1)));
      } catch (f) {
        n.failed(r, f);
      }
  }
  const i = /* @__PURE__ */ new Map();
  for (const { file: r, dir: l } of e.files) {
    const d = i.get(l);
    d ? d.push(r) : i.set(l, [r]);
  }
  for (const [r, l] of i) {
    const d = a.get(r);
    if (d !== void 0)
      try {
        await n.upload(l, d);
      } catch (f) {
        n.failed(r || l[0].name, f);
      }
  }
}
function $Q(e, t) {
  return Object.defineProperty(e, "webkitRelativePath", { value: t, configurable: !0 }), e;
}
const TQ = { class: "fe-field" }, AQ = { class: "fe-field__label" }, EQ = ["onKeydown"], CQ = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, zQ = ["innerHTML"], MQ = ["innerHTML"], PQ = ["disabled"], OQ = ["disabled", "aria-busy"], DQ = /* @__PURE__ */ lt({
  __name: "NewFolderModal",
  props: {
    open: { type: Boolean },
    locale: {},
    encryptedOption: { type: Boolean },
    encryptedRequest: { type: Boolean },
    error: {},
    busy: { type: Boolean }
  },
  emits: ["close", "submit", "encrypted", "request-encrypted"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(""), l = $(null);
    Xe(() => n.open, (f) => {
      f && (r.value = "", l.value = null);
    }), Xe(
      () => n.error,
      (f) => {
        f && (l.value = f);
      }
    );
    function d() {
      if (n.busy) return;
      const f = r.value.trim();
      if (!f) {
        l.value = i("modal.newfolder.placeholder");
        return;
      }
      if (/[\\/]/.test(f) || f === "." || f === "..") {
        l.value = i("modal.newfolder.invalid");
        return;
      }
      if (ip(f)) {
        l.value = i("names.reserved", { name: f });
        return;
      }
      a("submit", f);
    }
    return (f, m) => (p(), Je(na, {
      open: e.open,
      title: u(i)("modal.newfolder.title"),
      size: "sm",
      busy: e.busy,
      onClose: m[4] || (m[4] = (v) => a("close"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: m[3] || (m[3] = (v) => a("close"))
        }, y(u(i)("modal.newfolder.cancel")), 9, PQ),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: d
        }, y(e.busy ? u(i)("modal.newfolder.creating") : u(i)("modal.newfolder.create")), 9, OQ)
      ]),
      default: gt(() => [
        c("form", {
          onSubmit: vt(d, ["prevent"])
        }, [
          c("label", TQ, [
            c("span", AQ, y(u(i)("modal.newfolder.placeholder")), 1),
            un(c("input", {
              "onUpdate:modelValue": m[0] || (m[0] = (v) => r.value = v),
              type: "text",
              class: "fe-input",
              autocomplete: "off",
              onKeydown: $a(vt(d, ["prevent"]), ["enter"])
            }, null, 40, EQ), [
              [bn, r.value]
            ])
          ]),
          l.value ? (p(), h("p", CQ, y(l.value), 1)) : D("", !0),
          e.encryptedOption !== !1 ? (p(), h("button", {
            key: 1,
            type: "button",
            class: "fe-e2e-optlink",
            onClick: m[1] || (m[1] = (v) => a("encrypted"))
          }, [
            c("span", {
              class: "fe-e2e-optlink__icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("lock")
            }, null, 8, zQ),
            Ht(" " + y(u(i)("e2e.create.option")), 1)
          ])) : e.encryptedRequest ? (p(), h("button", {
            key: 2,
            type: "button",
            class: "fe-e2e-optlink",
            "data-testid": "e2e-request-option",
            onClick: m[2] || (m[2] = (v) => a("request-encrypted"))
          }, [
            c("span", {
              class: "fe-e2e-optlink__icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("lock")
            }, null, 8, MQ),
            Ht(" " + y(u(i)("e2e.request.option")), 1)
          ])) : D("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), LQ = { class: "fe-field__hint" }, RQ = { class: "fe-field" }, NQ = { class: "fe-field__label" }, IQ = ["disabled"], BQ = {
  key: 0,
  class: "fe-form__error"
}, FQ = ["disabled"], UQ = ["disabled", "aria-busy"], HQ = /* @__PURE__ */ lt({
  __name: "ArchiveExtractModal",
  props: {
    open: { type: Boolean },
    locale: {},
    archiveName: {},
    suggestedFolder: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(""), l = $("");
    Xe(() => n.open, (f) => {
      f && (r.value = n.suggestedFolder, l.value = "");
    });
    function d() {
      if (!n.busy) {
        if (!r.value.trim() || /[\\/]/.test(r.value)) {
          l.value = i("archive.invalid_folder");
          return;
        }
        a("submit", { folder: r.value.trim() });
      }
    }
    return (f, m) => (p(), Je(na, {
      open: e.open,
      title: u(i)("archive.extract_title"),
      size: "sm",
      busy: e.busy,
      onClose: m[2] || (m[2] = (v) => a("close"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: m[1] || (m[1] = (v) => a("close"))
        }, y(u(i)("archive.cancel")), 9, FQ),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: d
        }, y(e.busy ? u(i)("archive.extracting") : u(i)("archive.extract_to_folder")), 9, UQ)
      ]),
      default: gt(() => [
        c("form", {
          class: "fe-form",
          onSubmit: vt(d, ["prevent"])
        }, [
          c("p", LQ, y(e.archiveName), 1),
          c("label", RQ, [
            c("span", NQ, y(u(i)("archive.destination_folder")), 1),
            un(c("input", {
              "onUpdate:modelValue": m[0] || (m[0] = (v) => r.value = v),
              class: "fe-input",
              autocomplete: "off",
              disabled: e.busy
            }, null, 8, IQ), [
              [bn, r.value]
            ])
          ]),
          l.value || e.error ? (p(), h("p", BQ, y(l.value || e.error), 1)) : D("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), KQ = { class: "fe-field__hint" }, VQ = { class: "fe-field" }, jQ = { class: "fe-field__label" }, qQ = ["disabled"], WQ = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, YQ = ["disabled"], GQ = ["disabled", "aria-busy"], XQ = /* @__PURE__ */ lt({
  __name: "ArchivePasswordModal",
  props: {
    open: { type: Boolean },
    locale: {},
    archiveName: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $("");
    Xe(() => n.open, (d) => {
      d && (r.value = "");
    });
    function l() {
      !r.value || n.busy || a("submit", r.value);
    }
    return (d, f) => (p(), Je(na, {
      open: e.open,
      title: u(i)("archive.password_title"),
      size: "sm",
      busy: e.busy,
      onClose: f[2] || (f[2] = (m) => a("close"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: f[1] || (f[1] = (m) => a("close"))
        }, y(u(i)("archive.cancel")), 9, YQ),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || !r.value,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: l
        }, y(e.busy ? u(i)("archive.opening") : u(i)("archive.continue")), 9, GQ)
      ]),
      default: gt(() => [
        c("form", {
          class: "fe-form",
          onSubmit: vt(l, ["prevent"])
        }, [
          c("p", KQ, y(e.archiveName), 1),
          c("label", VQ, [
            c("span", jQ, y(u(i)("archive.password_required")), 1),
            un(c("input", {
              "onUpdate:modelValue": f[0] || (f[0] = (m) => r.value = m),
              class: "fe-input",
              type: "password",
              autocomplete: "off",
              "data-1p-ignore": "",
              "data-bwignore": "true",
              "data-lpignore": "true",
              autofocus: "",
              disabled: e.busy
            }, null, 8, qQ), [
              [bn, r.value]
            ])
          ]),
          e.error ? (p(), h("p", WQ, y(e.error), 1)) : D("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), JQ = {
  class: "fe-draftq",
  "data-testid": "draft-taken-dialog"
}, ZQ = { class: "fe-draftq__body" }, QQ = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, eee = ["disabled"], tee = ["disabled", "aria-busy"], H1 = /* @__PURE__ */ lt({
  __name: "DraftConflictModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    name: {},
    suggested: {},
    folder: {},
    busy: { type: Boolean },
    error: {},
    kind: {}
  },
  emits: ["cancel", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = () => n.kind === "upload";
    return (l, d) => (p(), Je(na, {
      open: e.open,
      locale: e.locale,
      theme: e.theme,
      title: u(i)("draft.taken.title"),
      size: "sm",
      busy: e.busy,
      onClose: d[2] || (d[2] = (f) => a("cancel"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          "data-testid": "draft-taken-cancel",
          onClick: d[0] || (d[0] = (f) => a("cancel"))
        }, y(u(i)("modal.rename.cancel")), 9, eee),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          "data-testid": "draft-taken-confirm",
          onClick: d[1] || (d[1] = (f) => a("confirm"))
        }, y(u(i)(r() ? "upload.taken.confirm" : "draft.taken.confirm", { name: e.suggested })), 9, tee)
      ]),
      default: gt(() => [
        c("div", JQ, [
          c("p", ZQ, y(u(i)(r() ? "upload.taken.body" : "draft.taken.body", { name: e.name, folder: e.folder, suggested: e.suggested })), 1),
          e.error ? (p(), h("p", QQ, y(e.error), 1)) : D("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "locale", "theme", "title", "busy"]));
  }
});
function nee(e, t) {
  const n = $(!1), a = $(null), i = $(null);
  let r = null;
  function l(v) {
    i.value = null, a.value = null;
    const b = r;
    r = null, b == null || b(v);
  }
  async function d(v) {
    const b = e();
    if (!b) return null;
    n.value = !0;
    try {
      const _ = await b.save(v.key);
      if (_.saved) return { path: _.path, name: _.name, targetDir: _.targetDir };
      i.value = {
        key: v.key,
        name: _.name,
        suggested: _.suggested,
        folder: H0(_.targetDir)
      }, a.value = null;
    } finally {
      n.value = !1;
    }
    return new Promise((_) => {
      r = _;
    });
  }
  async function f() {
    const v = i.value, b = e();
    if (!(!v || !b || n.value)) {
      n.value = !0, a.value = null;
      try {
        const _ = await b.save(v.key, v.suggested);
        if (_.saved) {
          l({ path: _.path, name: _.name, targetDir: _.targetDir });
          return;
        }
        i.value = { ...v, name: _.name || v.name, suggested: _.suggested };
      } catch (_) {
        a.value = t(_);
      } finally {
        n.value = !1;
      }
    }
  }
  function m() {
    n.value || l(null);
  }
  return { busy: n, error: a, question: i, save: d, confirm: f, cancel: m };
}
const aee = ["onKeydown"], iee = {
  key: 0,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "rename-error"
}, oee = ["disabled"], ree = ["disabled", "aria-busy"], see = /* @__PURE__ */ lt({
  __name: "RenameModal",
  props: {
    open: { type: Boolean },
    locale: {},
    currentName: {},
    error: {},
    busy: { type: Boolean }
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(""), l = $(null);
    Xe(
      () => [n.open, n.currentName],
      ([m, v]) => {
        m && (r.value = v, l.value = n.error ?? null);
      }
    ), Xe(
      () => n.error,
      (m) => {
        l.value = m ?? null;
      },
      { immediate: !0 }
    );
    function d() {
      l.value = null;
    }
    function f() {
      if (n.busy) return;
      const m = r.value.trim();
      if (m) {
        if (/[\\/]/.test(m) || m === "." || m === "..") {
          l.value = i("modal.newfolder.invalid");
          return;
        }
        if (ip(m)) {
          l.value = i("names.reserved", { name: m });
          return;
        }
        a("submit", m);
      }
    }
    return (m, v) => (p(), Je(na, {
      open: e.open,
      title: u(i)("modal.rename.title"),
      size: "sm",
      busy: e.busy,
      onClose: v[2] || (v[2] = (b) => a("close"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: v[1] || (v[1] = (b) => a("close"))
        }, y(u(i)("modal.rename.cancel")), 9, oee),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: f
        }, y(e.busy ? u(i)("modal.rename.saving") : u(i)("modal.rename.save")), 9, ree)
      ]),
      default: gt(() => [
        c("form", {
          onSubmit: vt(f, ["prevent"])
        }, [
          un(c("input", {
            "onUpdate:modelValue": v[0] || (v[0] = (b) => r.value = b),
            type: "text",
            class: "fe-input",
            autocomplete: "off",
            onInput: d,
            onKeydown: $a(vt(f, ["prevent"]), ["enter"])
          }, null, 40, aee), [
            [bn, r.value]
          ]),
          l.value ? (p(), h("p", iee, y(l.value), 1)) : D("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), lee = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, uee = ["disabled"], cee = ["disabled", "aria-busy"], dee = /* @__PURE__ */ lt({
  __name: "DeleteConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    count: {},
    error: {},
    busy: { type: Boolean },
    permanent: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale);
    function r() {
      n.busy || a("confirm");
    }
    return (l, d) => (p(), Je(na, {
      open: e.open,
      title: e.permanent ? u(i)("modal.delete.permanent_title") : u(i)("modal.delete.title"),
      size: "sm",
      busy: e.busy,
      onClose: d[1] || (d[1] = (f) => a("close"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: d[0] || (d[0] = (f) => a("close"))
        }, y(u(i)("modal.delete.cancel")), 9, uee),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--danger",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: r
        }, y(e.busy ? u(i)(e.permanent ? "modal.delete.permanent_working" : "modal.delete.working") : u(i)(e.permanent ? "modal.delete.permanent_confirm" : "modal.delete.confirm")), 9, cee)
      ]),
      default: gt(() => [
        c("p", null, y(e.permanent ? u(i)("modal.delete.permanent_message", { count: e.count }) : u(i)("modal.delete.message", { count: e.count })), 1),
        e.error ? (p(), h("p", lee, y(e.error), 1)) : D("", !0)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
});
function fee(e, t) {
  return e && e.queued ? t("toast.undo_queued") : e && e.summary ? e.summary : t("toast.undone");
}
function K1(e, t, n) {
  return !e || e.source === t ? !0 : e.source === "drag-out-stopping" ? n === "end" : !1;
}
function V1(e, t, n, a) {
  return (e == null ? void 0 : e.kind) === "plain" ? t === "running" ? e.running : e.done : t === "running" ? a("toast.undoing") : fee(n, a);
}
function Vm(e, t = {}) {
  const n = $(!1), a = $(null);
  let i = 0;
  Xe(e, (l, d) => {
    !l || d || (i++, n.value = !1, a.value = null);
  });
  function r(l) {
    return l === i && e.value;
  }
  return {
    busy: n,
    error: a,
    begin() {
      return n.value ? null : (n.value = !0, a.value = null, i);
    },
    end(l) {
      l === i && (n.value = !1);
    },
    refuse(l, d) {
      var f;
      return r(l) ? (a.value = d, !0) : ((f = t.say) == null || f.call(t, d), !1);
    },
    inDialog: r
  };
}
const pee = 3e3, hee = 20;
function mee(e) {
  const t = e.last_sync_error || void 0;
  switch (e.last_sync_state) {
    case "ok":
      return { status: "ok" };
    case "failed":
    case "error":
      return t ? { status: "failed", error: t } : { status: "failed" };
    case "aborted":
      return { status: "aborted" };
    default:
      return { status: "unknown" };
  }
}
function vee(e) {
  const t = e.pollMs ?? pee, n = e.giveUpAfter ?? hee, a = /* @__PURE__ */ new Map(), i = $(0);
  let r, l = !1, d = !1, f = 0;
  const m = /* @__PURE__ */ new Set();
  function v() {
    d || r !== void 0 || l || a.size === 0 || (r = setTimeout(() => {
      r = void 0, b();
    }, t));
  }
  async function b() {
    if (d || a.size === 0) return;
    l = !0;
    let w = null;
    try {
      w = await e.list(), f = 0;
    } catch {
      f++;
    } finally {
      l = !1;
    }
    if (d) return;
    const k = w === null && f >= n;
    if (w !== null || k) {
      for (const [x, M] of a) {
        const A = w == null ? void 0 : w.find((N) => N.id === M.id), T = M.settle.filter((N) => !N(A, k));
        T.length === 0 ? a.delete(x) : M.settle = T;
      }
      i.value++;
    }
    v();
  }
  function _(w, k, x) {
    return d ? Promise.resolve(null) : new Promise((M) => {
      const A = (L) => {
        m.delete(A), M(L);
      };
      m.add(A);
      const T = `${k}:${w}`, N = (L, B) => {
        const O = x(L, B);
        return O === void 0 ? !1 : (A(O), !0);
      }, z = a.get(T);
      z ? z.settle.push(N) : a.set(T, { id: w, kind: k, settle: [N] }), i.value++, v();
    });
  }
  return {
    scan: (w) => _(w, "scan", (k, x) => x ? { status: "unknown" } : k ? k.running ? void 0 : mee(k) : { status: "gone" }),
    deletion: (w) => _(w, "deletion", (k, x) => x ? !1 : k ? void 0 : !0),
    watching(w) {
      return i.value, a.has(`deletion:${w}`) ? "deletion" : a.has(`scan:${w}`) ? "scan" : null;
    },
    stop() {
      d = !0, r !== void 0 && clearTimeout(r), r = void 0, a.clear(), i.value++;
      for (const w of [...m]) w(null);
    }
  };
}
const yee = ["aria-label"], gee = ["aria-selected", "tabindex", "disabled", "data-testid", "data-section", "onClick", "onKeydown"], bee = { class: "fe-sections__label" }, kee = ["data-testid"], I$ = /* @__PURE__ */ lt({
  __name: "SurfaceSections",
  props: {
    sections: {},
    active: {},
    locale: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(
      () => n.sections.filter((d) => d && typeof d.id == "string" && d.id).map((d) => ({
        id: d.id,
        label: Gt(d.label, n.locale) || d.id,
        count: typeof d.count == "number" && Number.isFinite(d.count) ? d.count : null
      }))
    );
    function r(d) {
      n.disabled || d === n.active || a("select", d);
    }
    function l(d, f) {
      var w, k;
      if (!["ArrowRight", "ArrowLeft", "Home", "End"].includes(d.key)) return;
      d.preventDefault();
      const v = i.value.length;
      if (!v) return;
      let b = f;
      d.key === "ArrowRight" ? b = (f + 1) % v : d.key === "ArrowLeft" ? b = (f - 1 + v) % v : d.key === "Home" ? b = 0 : d.key === "End" && (b = v - 1);
      const _ = (w = d.currentTarget.parentElement) == null ? void 0 : w.querySelectorAll('[role="tab"]');
      (k = _ == null ? void 0 : _[b]) == null || k.focus(), r(i.value[b].id);
    }
    return (d, f) => (p(), h("nav", {
      class: "fe-sections",
      role: "tablist",
      "aria-label": e.label,
      "data-testid": "surface-sections"
    }, [
      (p(!0), h(Ce, null, ot(i.value, (m, v) => (p(), h("button", {
        key: m.id,
        type: "button",
        role: "tab",
        class: Fe(["fe-sections__tab", { "is-active": m.id === e.active }]),
        "aria-selected": m.id === e.active ? "true" : "false",
        tabindex: m.id === e.active || !e.active && v === 0 ? 0 : -1,
        disabled: e.disabled,
        "data-testid": `surface-section-${m.id}`,
        "data-section": m.id,
        onClick: (b) => r(m.id),
        onKeydown: (b) => l(b, v)
      }, [
        c("span", bee, y(m.label), 1),
        m.count !== null ? (p(), h("span", {
          key: 0,
          class: "fe-sections__count",
          "data-testid": `surface-section-count-${m.id}`
        }, y(m.count), 9, kee)) : D("", !0)
      ], 42, gee))), 128))
    ], 8, yee));
  }
}), wee = {
  class: "fe-plugin-view",
  "data-testid": "plugin-view"
}, _ee = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted",
  role: "status",
  "data-testid": "plugin-view-opening"
}, xee = ["disabled"], See = /* @__PURE__ */ lt({
  __name: "PluginViewModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    view: {},
    surface: {},
    path: {},
    paths: {},
    storages: {},
    startAt: {},
    size: {},
    label: {}
  },
  emits: ["close", "op", "toast", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = xp(
      {
        api: n.api,
        plugin: n.plugin,
        view: n.view,
        path: () => n.path,
        paths: () => n.paths,
        locale: () => n.locale,
        errorText: () => i("plugin.view.error")
      },
      {
        onOp: (b) => a("op", b),
        onDone: () => a("close"),
        onToast: (b) => a("toast", b),
        onOpen: (b) => a("open", b)
      }
    );
    Xe(
      () => n.surface,
      (b) => r.setSurface(b),
      { immediate: !0 }
    );
    const l = r.current, d = E(() => {
      var b;
      return Gt((b = l.value) == null ? void 0 : b.title, n.locale) || n.label || n.view;
    }), f = E(() => {
      var b;
      return ((b = l.value) == null ? void 0 : b.sections) ?? [];
    });
    async function m(b) {
      var _, w;
      if (!(!b || b === ((_ = l.value) == null ? void 0 : _.section)))
        try {
          const k = await n.api.pluginView(n.plugin, n.view, n.path, b);
          k != null && k.surface && r.setSurface(k.surface);
        } catch (k) {
          a("toast", ((w = i.foreign) == null ? void 0 : w.call(i, String((k == null ? void 0 : k.message) ?? ""))) || i("plugin.view.error"));
        }
    }
    const v = E(() => {
      var _;
      if (n.size) return n.size;
      const b = (_ = l.value) == null ? void 0 : _.size;
      return b === "sm" || b === "lg" || b === "xl" ? b : "md";
    });
    return (b, _) => (p(), Je(na, {
      open: e.open,
      title: d.value,
      size: v.value,
      theme: e.theme,
      locale: e.locale,
      busy: u(r).busy.value,
      onClose: _[1] || (_[1] = (w) => a("close"))
    }, {
      actions: gt(() => [
        u(r).footer.value.length ? D("", !0) : (p(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn",
          disabled: u(r).busy.value,
          "data-testid": "plugin-view-close",
          onClick: _[0] || (_[0] = (w) => a("close"))
        }, y(u(i)("plugin.view.close")), 9, xee)),
        tt($p, {
          conv: u(r),
          locale: e.locale,
          "testid-prefix": "plugin-view"
        }, null, 8, ["conv", "locale"])
      ]),
      default: gt(() => {
        var w;
        return [
          c("div", wee, [
            u(l) ? D("", !0) : (p(), h("p", _ee, y(u(i)("plugin.view.loading")), 1)),
            f.value.length ? (p(), Je(I$, {
              key: 1,
              sections: f.value,
              active: (w = u(l)) == null ? void 0 : w.section,
              locale: e.locale,
              label: d.value,
              disabled: u(r).busy.value,
              onSelect: m
            }, null, 8, ["sections", "active", "locale", "label", "disabled"])) : D("", !0),
            tt(Sp, {
              conv: u(r),
              locale: e.locale,
              theme: e.theme,
              api: e.api,
              plugin: e.plugin,
              storages: e.storages,
              "start-at": e.startAt
            }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at"])
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "title", "size", "theme", "locale", "busy"]));
  }
}), $ee = { class: "fe-appframe-modal__body" }, Tee = /* @__PURE__ */ lt({
  __name: "AppFrameModal",
  props: {
    api: {},
    locale: {},
    theme: {},
    plugin: {},
    view: {},
    placement: {},
    ui: {},
    label: {},
    files: {},
    userName: {},
    storages: {},
    startAt: {}
  },
  emits: ["close", "toast", "op"],
  setup(e, { emit: t }) {
    const n = t, a = $(null), i = $("");
    async function r() {
      a.value && !await a.value.confirmClose() || n("close");
    }
    return (l, d) => (p(), Je(na, {
      open: !0,
      size: e.placement === "home" ? "xl" : "lg",
      title: i.value ? `${e.label} - ${i.value}` : e.label,
      locale: e.locale,
      theme: e.theme,
      "close-on-backdrop": !1,
      "data-testid": "app-frame-modal",
      onClose: r
    }, {
      default: gt(() => [
        c("div", $ee, [
          tt(cg, {
            ref_key: "frame",
            ref: a,
            api: e.api,
            app: e.plugin,
            version: e.ui.version,
            view: e.view,
            placement: e.placement,
            ui: e.ui,
            files: e.files,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            "user-name": e.userName,
            title: e.label,
            onTitle: d[0] || (d[0] = (f) => i.value = f),
            onToast: d[1] || (d[1] = (f) => n("toast", f.text)),
            onOp: d[2] || (d[2] = (f) => n("op", f)),
            onClose: r
          }, null, 8, ["api", "app", "version", "view", "placement", "ui", "files", "storages", "start-at", "locale", "theme", "user-name", "title"])
        ])
      ]),
      _: 1
    }, 8, ["size", "title", "locale", "theme"]));
  }
}), Rc = $(0);
function B$() {
  const e = yo().openWith;
  if (!e) return {};
  try {
    const t = JSON.parse(e);
    if (!t || typeof t != "object" || Array.isArray(t)) return {};
    const n = {};
    for (const [a, i] of Object.entries(t))
      typeof i == "string" && $g(a) && Tg(i, a) && (n[a] = i);
    return n;
  } catch {
    return {};
  }
}
function $g(e) {
  return /^[a-z0-9][a-z0-9_+-]{0,31}$/.test(e);
}
function Tg(e, t) {
  return e === gl ? t === void 0 || lg(t) : e === "builtin" || /^app:[a-z0-9][a-z0-9_-]{0,31}\/[a-z0-9][a-z0-9_.-]{0,63}$/.test(e);
}
function Aee() {
  return Rc.value, B$();
}
function Eee(e) {
  return e ? Aee()[e.toLowerCase()] ?? null : null;
}
async function F$(e, t) {
  const n = await ES(e, t);
  if (!(!n || !n.ok))
    try {
      const a = await n.json();
      if (!a || !a.choices || typeof a.choices != "object" || Array.isArray(a.choices)) return;
      const i = {};
      for (const [r, l] of Object.entries(a.choices))
        typeof l == "string" && $g(r) && Tg(l, r) && (i[r] = l);
      sg("openWith", JSON.stringify(i)), Rc.value++;
    } catch {
    }
}
function Cee(e, t) {
  const n = e.toLowerCase();
  if (!$g(n) || t !== null && !Tg(t, n)) return;
  const a = B$();
  t === null ? delete a[n] : a[n] = t, sg("openWith", JSON.stringify(a)), Rc.value++;
  const i = `/api/me/open-with/${encodeURIComponent(n)}`;
  F$(i, t === null ? { method: "DELETE" } : { method: "PUT", body: JSON.stringify({ handler: t }) });
}
function Nce() {
  sg("openWith", "{}"), Rc.value++, F$("/api/me/open-with", { method: "DELETE" });
}
function zee() {
  return Cp(() => {
    Rc.value++;
  });
}
const Mee = {
  class: "fe-openwith",
  "data-testid": "open-with-dialog"
}, Pee = { class: "fe-openwith__lead" }, Oee = {
  key: 0,
  class: "fe-openwith__always"
}, Dee = {
  key: 1,
  class: "fe-openwith__hint"
}, Lee = ["disabled"], Ree = /* @__PURE__ */ lt({
  __name: "OpenWithDialog",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    name: {},
    kind: {},
    handlers: {},
    current: {},
    remembered: {}
  },
  emits: ["cancel", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(null), l = $(!1);
    Xe(
      () => n.open,
      (v) => {
        var b;
        v && (r.value = n.current ?? ((b = n.handlers[0]) == null ? void 0 : b.id) ?? null, l.value = !!n.remembered && n.remembered === r.value);
      },
      { immediate: !0 }
    );
    function d(v) {
      return df(v) ? i("openWith.onlyoffice") : v.view ? Gt(v.view.label, n.locale) || v.view.plugin : i("openWith.builtin");
    }
    const f = E(
      () => n.handlers.map((v) => ({
        value: v.id,
        label: d(v),
        help: v.id === n.current ? i("openWith.now") : void 0
      }))
    );
    function m() {
      r.value && a("open", r.value, l.value && !!n.kind);
    }
    return (v, b) => (p(), Je(na, {
      open: e.open,
      locale: e.locale,
      theme: e.theme,
      title: u(i)("openWith.title"),
      size: "sm",
      onClose: b[3] || (b[3] = (_) => a("cancel"))
    }, {
      actions: gt(() => [
        c("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "open-with-cancel",
          onClick: b[2] || (b[2] = (_) => a("cancel"))
        }, y(u(i)("modal.rename.cancel")), 1),
        c("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !r.value,
          "data-testid": "open-with-open",
          onClick: m
        }, y(u(i)("openWith.open")), 9, Lee)
      ]),
      default: gt(() => [
        c("div", Mee, [
          c("p", Pee, y(u(i)("openWith.lead", { name: e.name })), 1),
          tt(ui, {
            "model-value": r.value,
            "onUpdate:modelValue": b[0] || (b[0] = (_) => r.value = typeof _ == "string" ? _ : null),
            options: f.value,
            "aria-label": u(i)("openWith.title"),
            "testid-prefix": "open-with-choice"
          }, null, 8, ["model-value", "options", "aria-label"]),
          e.kind ? (p(), h("label", Oee, [
            un(c("input", {
              "onUpdate:modelValue": b[1] || (b[1] = (_) => l.value = _),
              type: "checkbox",
              "data-testid": "open-with-always"
            }, null, 512), [
              [tp, l.value]
            ]),
            c("span", null, y(u(i)("openWith.always", { ext: "." + e.kind })), 1)
          ])) : D("", !0),
          e.kind ? (p(), h("p", Dee, y(u(i)("openWith.hint")), 1)) : D("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "locale", "theme", "title"]));
  }
});
function U$(e) {
  if (!e) return null;
  if (typeof HTMLElement < "u" && e instanceof HTMLElement) return e;
  const t = e.$el;
  return typeof HTMLElement < "u" && t instanceof HTMLElement ? t : null;
}
function Ag() {
  if (typeof window > "u") return { width: 0, height: 0 };
  const e = typeof document < "u" ? document.documentElement : null, t = e && e.clientWidth > 0 ? e.clientWidth : window.innerWidth, n = e && e.clientHeight > 0 ? e.clientHeight : window.innerHeight;
  return { width: t, height: n };
}
function Eg(e, t, n = {}) {
  const a = n.dir === "rtl", i = a ? "left" : "right", r = n.gutter ?? 8, l = Math.round(e.bottom + (n.gap ?? 6)), d = Math.round(a ? e.left ?? 0 : t.width - e.right), f = Math.max(200, t.height - l - r), m = `${n.maxHeight ? Math.min(n.maxHeight, f) : f}px`;
  if (!n.width) return { top: `${l}px`, [i]: `${d}px`, maxHeight: m };
  const v = Math.max(0, Math.min(n.width, t.width - r * 2)), b = Math.min(Math.max(d, r), t.width - v - r);
  return { top: `${l}px`, [i]: `${Math.round(b)}px`, width: `${Math.round(v)}px`, maxHeight: m };
}
function Lo(e) {
  return typeof e == "string" ? e : "";
}
function Nee(e, t) {
  const n = { title: Lo(e.title), body: Lo(e.body) }, a = e.e2e;
  if (!a || typeof t != "function" || !Array.isArray(a.names)) return n;
  const i = a.names.map((l) => {
    let d = null;
    try {
      d = t(Lo(l == null ? void 0 : l.wire), Lo(l == null ? void 0 : l.root));
    } catch {
      d = null;
    }
    return d ? l.part === "path" ? Lo(d.path) : Lo(d.name) : Lo(l == null ? void 0 : l.locked);
  }), r = (l, d) => Array.isArray(l) ? l.map((f) => typeof (f == null ? void 0 : f.name) == "number" ? i[f.name] ?? "" : Lo(f == null ? void 0 : f.text)).join("") : d;
  return { title: r(a.title, n.title), body: r(a.body, n.body) };
}
function Iee() {
  function e(t) {
    return Nee(t, aZ);
  }
  return { notificationText: e };
}
const ep = ".trash";
function j1(e, t) {
  const n = (a) => {
    const i = String(a ?? ""), r = i.indexOf("://");
    return r < 0 ? i : `${i.slice(0, r + 3)}${i.slice(r + 3).replace(/^\/+/, "")}`;
  };
  return n(e) === n(t);
}
function Bee(e) {
  let t = String(e ?? "").trim().replace(/\\/g, "/");
  const n = t.indexOf("://");
  return n >= 0 && (t = t.slice(n + 3)), t.replace(/^\/+/, "").replace(/\/+$/, "");
}
function Fee(e) {
  const t = e.lastIndexOf("/");
  return t < 0 ? "" : e.slice(0, t);
}
function H$(e) {
  var i, r, l;
  if (!e || !e.kind || e.kind === "none") return { kind: "none" };
  if (e.kind === "share") {
    const d = String(e.id ?? "").trim();
    return d ? { kind: "share", token: d } : { kind: "none" };
  }
  if (e.kind === "app") {
    const d = String(((i = e.open) == null ? void 0 : i.plugin) ?? "").trim(), f = String(((r = e.open) == null ? void 0 : r.view) ?? "").trim(), m = String(((l = e.open) == null ? void 0 : l.section) ?? "").trim();
    return !d || !f ? { kind: "none" } : { kind: "app", plugin: d, view: f, ...m ? { section: m } : {} };
  }
  const t = String(e.storage ?? "").trim(), n = Bee(e.path);
  if (e.kind === "trash")
    return t && n ? { kind: "trash", select: `${t}://${n}` } : { kind: "trash" };
  if (!t) return { kind: "none" };
  const a = Uee(e);
  return e.kind === "dir" ? { kind: "folder", storage: t, folder: n, ...a ? { open: a } : {} } : e.kind === "file" ? n ? {
    kind: "folder",
    storage: t,
    folder: Fee(n),
    select: `${t}://${n}`,
    ...a ? { open: a } : {}
  } : { kind: "folder", storage: t, folder: "", ...a ? { open: a } : {} } : { kind: "none" };
}
function Uee(e) {
  const t = e.open;
  if (!t || typeof t != "object") return;
  const n = String(t.plugin ?? "").trim(), a = String(t.action ?? "").trim(), i = String(t.view ?? "").trim();
  if (!(!n || !a && !i))
    return { plugin: n, ...a ? { action: a } : {}, ...i ? { view: i } : {} };
}
function Hee(e) {
  return H$(e).kind !== "none";
}
function Kee(e) {
  return typeof e.opens == "boolean" ? e.opens : Hee(e.target);
}
function Zv(e) {
  return e.kind === "trash" ? ep : e.kind !== "folder" ? "" : e.folder ? `${e.storage}/${e.folder}` : e.storage;
}
function Vee(e) {
  return e.kind === "trash" ? ep : e.kind !== "folder" ? "" : `${e.storage}://${e.folder}`;
}
function Ice(e) {
  const t = String(e ?? "").replace(/^#/, "").replace(/^\/+/, "");
  if (!t) return "";
  let n = t;
  try {
    n = decodeURI(t);
  } catch {
  }
  const a = n.indexOf("/");
  return a < 0 ? `${n}://` : `${n.slice(0, a)}://${n.slice(a + 1)}`;
}
function Bce(e) {
  if (e.kind === "app")
    return {
      name: "app-home",
      params: { plugin: e.plugin, view: e.view },
      query: e.section ? { section: e.section } : {},
      hash: ""
    };
  if (e.kind === "folder") {
    const t = e.select ? { select: e.select } : {};
    return e.open && (t.app = e.open.plugin, e.open.action ? t.appAction = e.open.action : e.open.view && (t.appView = e.open.view)), {
      name: "explore",
      query: t,
      // vue-router wants the '#'; the explorer encodes segment-by-segment, so
      // we hand over the readable form and let the browser escape it.
      hash: `#${Zv(e)}`
    };
  }
  return e.kind === "trash" ? {
    name: "explore",
    query: e.select ? { select: e.select } : {},
    hash: `#${Zv(e)}`
  } : null;
}
function K$(e, t = "") {
  return `${t.replace(/\/+$/, "")}/s/${encodeURIComponent(e)}`;
}
function Fce(e, t = "/", n = "") {
  if (e.kind === "share") return K$(e.token, n);
  const a = `${String(t || "/").replace(/\/+$/, "")}/`;
  if (e.kind === "app") {
    const l = `${a}app/${encodeURIComponent(e.plugin)}/${encodeURIComponent(e.view)}`;
    return e.section ? `${l}?section=${encodeURIComponent(e.section)}` : l;
  }
  if (e.kind !== "folder" && e.kind !== "trash") return "";
  const i = [];
  e.select && i.push(`select=${encodeURIComponent(e.select)}`), e.kind === "folder" && e.open && (i.push(`app=${encodeURIComponent(e.open.plugin)}`), e.open.action ? i.push(`appAction=${encodeURIComponent(e.open.action)}`) : e.open.view && i.push(`appView=${encodeURIComponent(e.open.view)}`));
  const r = Zv(e);
  return `${a}explore${i.length ? `?${i.join("&")}` : ""}${r ? `#${r}` : ""}`;
}
const jee = { class: "fx-nrow__body" }, qee = { class: "fx-nrow__meta" }, Wee = { class: "fx-nrow__when" }, Yee = { class: "fx-nrow__title" }, Gee = {
  key: 0,
  class: "fx-nrow__body-text"
}, V$ = /* @__PURE__ */ lt({
  __name: "NotificationRow",
  props: {
    item: {},
    locale: {}
  },
  emits: ["open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), { notificationText: r } = Iee(), l = E(() => r(n.item)), d = E(() => Kee(n.item)), f = E(() => !n.item.read_at), m = E(() => Z0(n.item.created_at, n.locale, { time: !0 }) || "-");
    function v(_) {
      const w = `notifications.severity.${_}`, k = i(w);
      return k === w ? _ : k;
    }
    function b(_) {
      return _ === "critical" || _ === "error" ? "danger" : _ === "warning" ? "warning" : "info";
    }
    return (_, w) => (p(), Je(Ii(d.value ? "button" : "div"), {
      type: d.value ? "button" : void 0,
      class: Fe(["fx-nrow", { "is-unread": f.value, "has-target": d.value, "is-static": !d.value }]),
      title: d.value ? u(i)("notifications.openTarget") : void 0,
      "data-testid": "notification-row",
      "data-clickable": d.value ? "yes" : "no",
      "data-notification-id": e.item.id,
      onClick: w[0] || (w[0] = (k) => d.value ? a("open", e.item) : void 0)
    }, {
      default: gt(() => [
        w[1] || (w[1] = c("span", {
          class: "fx-nrow__dot",
          "aria-hidden": "true"
        }, null, -1)),
        c("span", jee, [
          c("span", qee, [
            c("span", {
              class: Fe(["fx-nrow__sev", `is-${b(e.item.severity)}`])
            }, y(v(e.item.severity)), 3),
            c("span", Wee, y(m.value), 1)
          ]),
          c("span", Yee, y(l.value.title), 1),
          l.value.body ? (p(), h("span", Gee, y(l.value.body), 1)) : D("", !0)
        ])
      ]),
      _: 1
    }, 8, ["type", "class", "title", "data-clickable", "data-notification-id"]));
  }
}), q1 = 99;
function Xee(e) {
  const t = Math.floor(Number(e ?? 0));
  return !Number.isFinite(t) || t <= 0 ? "" : t > q1 ? `${q1}+` : String(t);
}
function Uce(e) {
  const t = Math.floor(Number(e ?? 0));
  return Number.isFinite(t) && t > 0 ? t : 0;
}
const Jee = {
  key: 0,
  class: "fx-badge",
  "aria-hidden": "true",
  "data-testid": "unread-badge"
}, j$ = /* @__PURE__ */ lt({
  __name: "UnreadBadge",
  props: {
    count: {}
  },
  setup(e) {
    const t = e, n = E(() => Xee(t.count));
    return (a, i) => n.value ? (p(), h("span", Jee, y(n.value), 1)) : D("", !0);
  }
}), Zee = ["innerHTML"], Qee = { class: "fx-bell__heading" }, ete = ["innerHTML"], tte = {
  key: 0,
  class: "fx-bell__empty"
}, nte = { class: "fx-bell__foot" }, ate = ["onClick"], ite = ["href", "onClick"], jm = 360, ote = /* @__PURE__ */ lt({
  __name: "NotificationBell",
  props: {
    feed: {},
    locale: {},
    manageHref: {}
  },
  emits: ["open", "manage"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = E(() => Math.max(0, n.feed.unreadCount || 0)), l = E(
      () => r.value > 0 ? `${i("notifications.bell")} - ${i("notifications.unreadCount", { n: r.value })}` : i("notifications.bell")
    ), d = $(null), f = $({
      top: "0px",
      right: "0px",
      width: `${jm}px`,
      maxHeight: "420px"
    });
    function m() {
      const x = U$(d.value), M = x == null ? void 0 : x.getBoundingClientRect();
      if (!M) return;
      const A = Eg(
        M,
        Ag(),
        // The list scrolls inside the panel; 520 keeps ~6 rows on a laptop and
        // the head + foot visible on a phone. ⚠ RTL: flush with the bell's END
        // edge — its left one in a right-to-left header.
        { width: jm, maxHeight: 520, dir: Ga(x) }
      );
      f.value = { top: A.top, right: A.right, left: A.left, width: A.width ?? `${jm}px`, maxHeight: A.maxHeight };
    }
    function v() {
      m(), n.feed.refreshFeed();
    }
    async function b(x, M) {
      M(), x.read_at || await n.feed.markRead(x.id).catch(() => {
      }), a("open", x);
    }
    function _(x) {
      x(), n.feed.openPanel();
    }
    function w(x) {
      x(), a("manage");
    }
    const k = E(() => n.feed.feed.slice(0, 15));
    return (x, M) => (p(), Je(u(xz), { class: "fx-bell" }, {
      default: gt(({ open: A, close: T }) => [
        tt(u(Sz), {
          ref_key: "btnEl",
          ref: d,
          class: Fe(["fx-bell__btn", { "is-open": A }]),
          title: l.value,
          "aria-label": l.value,
          "data-testid": "notification-bell",
          onClick: m,
          onKeydown: m
        }, {
          default: gt(() => [
            c("span", {
              class: "fx-bell__icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("bell")
            }, null, 8, Zee),
            tt(j$, { count: r.value }, null, 8, ["count"])
          ]),
          _: 1
        }, 8, ["class", "title", "aria-label"]),
        (p(), Je(hi, { to: "body" }, [
          tt(u($z), {
            class: "fx-bell__panel",
            style: Yt({ top: f.value.top, right: f.value.right, left: f.value.left, width: f.value.width }),
            "data-testid": "notification-panel"
          }, {
            default: gt(() => [
              c("div", {
                class: "fx-bell__head",
                onVnodeMounted: v
              }, [
                c("span", Qee, y(u(i)("notifications.title")), 1),
                e.feed.hasUnread ? (p(), h("button", {
                  key: 0,
                  type: "button",
                  class: "fx-bell__markall",
                  "data-testid": "notification-mark-all",
                  onClick: M[0] || (M[0] = (N) => e.feed.markAllRead())
                }, [
                  c("span", {
                    class: "fx-bell__markall-icon",
                    "aria-hidden": "true",
                    innerHTML: u(zt)("check")
                  }, null, 8, ete),
                  Ht(" " + y(u(i)("notifications.markAllRead")), 1)
                ])) : D("", !0)
              ], 512),
              c("ul", {
                class: "fx-bell__list",
                style: Yt({ maxHeight: f.value.maxHeight }),
                "data-testid": "notification-list"
              }, [
                !k.value.length && !e.feed.feedLoading ? (p(), h("li", tte, y(u(i)("notifications.empty")), 1)) : D("", !0),
                (p(!0), h(Ce, null, ot(k.value, (N) => (p(), h("li", {
                  key: N.id
                }, [
                  tt(V$, {
                    item: N,
                    locale: e.locale,
                    onOpen: (z) => b(z, T)
                  }, null, 8, ["item", "locale", "onOpen"])
                ]))), 128))
              ], 4),
              c("div", nte, [
                c("button", {
                  type: "button",
                  class: "fx-bell__all",
                  "data-testid": "notification-view-all",
                  onClick: (N) => _(T)
                }, y(u(i)("notifications.viewAll")), 9, ate),
                e.manageHref ? (p(), h("a", {
                  key: 0,
                  href: e.manageHref,
                  class: "fx-bell__manage",
                  "data-testid": "notification-manage",
                  onClick: vt((N) => w(T), ["prevent"])
                }, y(u(i)("notifications.manageAdmin")), 9, ite)) : D("", !0)
              ])
            ]),
            _: 2
          }, 1032, ["style"])
        ]))
      ]),
      _: 1
    }));
  }
}), rte = ["aria-label"], ste = { class: "fx-nall__sheet" }, lte = { class: "fx-nall__head" }, ute = { class: "fx-nall__title" }, cte = {
  class: "fx-nall__title-icon",
  "aria-hidden": "true"
}, dte = ["innerHTML"], fte = { class: "fx-nall__tools" }, pte = ["aria-pressed"], hte = ["aria-label"], mte = ["innerHTML"], vte = {
  key: 0,
  class: "fx-nall__error",
  "data-testid": "notifications-screen-error"
}, yte = {
  class: "fx-nall__list",
  "data-testid": "notifications-screen-list"
}, gte = {
  key: 0,
  class: "fx-nall__empty"
}, bte = ["title", "aria-label", "onClick"], kte = ["innerHTML"], wte = {
  key: 1,
  class: "fx-nall__foot",
  "data-testid": "notifications-screen-pager"
}, _te = ["disabled"], xte = { class: "fx-nall__count" }, Ste = ["disabled"], $te = /* @__PURE__ */ lt({
  __name: "NotificationsPanel",
  props: {
    feed: {},
    locale: {}
  },
  emits: ["open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = E(() => Math.floor(n.feed.mineOffset / n.feed.mineLimit) + 1), l = E(() => Math.max(1, Math.ceil(n.feed.mineTotal / n.feed.mineLimit)));
    function d(_) {
      _ < 1 || _ > l.value || (n.feed.setMinePage(_), n.feed.fetchMine());
    }
    function f() {
      n.feed.setMineUnreadFilter(!n.feed.mineUnreadOnly), n.feed.fetchMine();
    }
    async function m(_) {
      n.feed.closePanel(), _.read_at || await n.feed.markRead(_.id).catch(() => {
      }), a("open", _);
    }
    async function v(_) {
      _.read_at || await n.feed.markRead(_.id).catch(() => {
      });
    }
    function b(_) {
      _.key === "Escape" && n.feed.closePanel();
    }
    return Xe(
      () => n.feed.panelOpen,
      (_) => {
        _ ? window.addEventListener("keydown", b) : window.removeEventListener("keydown", b);
      },
      { immediate: !0 }
    ), Ot(() => window.removeEventListener("keydown", b)), (_, w) => (p(), Je(hi, { to: "body" }, [
      e.feed.panelOpen ? (p(), h("div", {
        key: 0,
        class: "fx-nall",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": u(i)("notifications.title"),
        "data-testid": "notifications-screen"
      }, [
        c("div", {
          class: "fx-nall__scrim",
          onClick: w[0] || (w[0] = vt((k) => e.feed.closePanel(), ["self"]))
        }),
        c("section", ste, [
          c("header", lte, [
            c("span", ute, [
              c("span", cte, [
                c("span", {
                  innerHTML: u(zt)("bell")
                }, null, 8, dte),
                tt(j$, {
                  count: e.feed.unreadCount
                }, null, 8, ["count"])
              ]),
              Ht(" " + y(u(i)("notifications.title")), 1)
            ]),
            c("div", fte, [
              c("button", {
                type: "button",
                class: Fe(["fx-nall__tool", { "is-on": e.feed.mineUnreadOnly }]),
                "aria-pressed": e.feed.mineUnreadOnly,
                "data-testid": "notifications-screen-unread",
                onClick: f
              }, y(u(i)("notifications.unreadOnly")), 11, pte),
              e.feed.hasUnread ? (p(), h("button", {
                key: 0,
                type: "button",
                class: "fx-nall__tool",
                "data-testid": "notifications-screen-mark-all",
                onClick: w[1] || (w[1] = (k) => e.feed.markAllRead())
              }, y(u(i)("notifications.markAllRead")), 1)) : D("", !0),
              c("button", {
                type: "button",
                class: "fx-nall__close",
                "aria-label": u(i)("modal.close"),
                "data-testid": "notifications-screen-close",
                onClick: w[2] || (w[2] = (k) => e.feed.closePanel())
              }, [
                c("span", {
                  "aria-hidden": "true",
                  innerHTML: u(zt)("close")
                }, null, 8, mte)
              ], 8, hte)
            ])
          ]),
          e.feed.mineError ? (p(), h("p", vte, y(e.feed.mineError), 1)) : D("", !0),
          c("ul", yte, [
            !e.feed.mine.length && !e.feed.mineLoading ? (p(), h("li", gte, y(u(i)("notifications.empty")), 1)) : D("", !0),
            (p(!0), h(Ce, null, ot(e.feed.mine, (k) => (p(), h("li", {
              key: k.id,
              class: "fx-nall__item"
            }, [
              tt(V$, {
                item: k,
                locale: e.locale,
                onOpen: m
              }, null, 8, ["item", "locale"]),
              k.read_at ? D("", !0) : (p(), h("button", {
                key: 0,
                type: "button",
                class: "fx-nall__read",
                title: u(i)("notifications.markRead"),
                "aria-label": u(i)("notifications.markRead"),
                "data-testid": "notifications-screen-mark-one",
                onClick: (x) => v(k)
              }, [
                c("span", {
                  "aria-hidden": "true",
                  innerHTML: u(zt)("check")
                }, null, 8, kte)
              ], 8, bte))
            ]))), 128))
          ]),
          l.value > 1 ? (p(), h("footer", wte, [
            c("button", {
              type: "button",
              class: "fx-nall__page",
              disabled: r.value <= 1,
              onClick: w[3] || (w[3] = (k) => d(r.value - 1))
            }, y(u(i)("common.prev")), 9, _te),
            c("span", xte, y(u(i)("notifications.pageOf", { page: r.value, pages: l.value, total: e.feed.mineTotal })), 1),
            c("button", {
              type: "button",
              class: "fx-nall__page",
              disabled: r.value >= l.value,
              onClick: w[4] || (w[4] = (k) => d(r.value + 1))
            }, y(u(i)("common.next")), 9, Ste)
          ])) : D("", !0)
        ])
      ], 8, rte)) : D("", !0)
    ]));
  }
}), Tte = "filex", Ate = "0.0.0";
function Hce(e) {
  return /^[0-9a-f]{8,}$/i.test(e) ? e.slice(0, 7) : e;
}
function q$(e) {
  const t = String(e ?? "").trim();
  return !t || t === Ate ? "" : `${Tte} ${t}`;
}
const Ete = {
  key: 0,
  class: "fe-version",
  "data-testid": "product-version"
}, Cte = /* @__PURE__ */ lt({
  __name: "ProductVersion",
  props: {
    version: {}
  },
  setup(e) {
    const t = e, n = E(() => q$(t.version));
    return (a, i) => n.value ? (p(), h("p", Ete, [
      c("bdi", null, y(n.value), 1)
    ])) : D("", !0);
  }
}), zte = {
  class: "fx-account__face",
  "aria-hidden": "true"
}, Mte = ["src"], Pte = {
  key: 1,
  class: "fx-account__initial"
}, Ote = {
  key: 2,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  focusable: "false"
}, Dte = { class: "fx-acctmenu__who" }, Lte = ["data-testid", "onClick"], Rte = ["innerHTML"], Nte = { class: "fx-acctmenu__label" }, Ite = /* @__PURE__ */ lt({
  __name: "AccountMenu",
  props: {
    actions: {},
    user: {},
    version: {},
    locale: {},
    fallbackLabel: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => _p(n.user ?? null)), r = E(() => {
      var b;
      return (((b = n.user) == null ? void 0 : b.avatar_url) || "").trim();
    }), l = E(() => {
      const b = i.value;
      return b ? [...b][0].toLocaleUpperCase(fi(n.locale)) : "";
    }), d = E(() => i.value || n.fallbackLabel), f = $(null), m = $({ top: "0px", right: "0px" });
    function v() {
      const b = U$(f.value), _ = b == null ? void 0 : b.getBoundingClientRect();
      if (!_) return;
      const { top: w, right: k, left: x } = Eg(
        _,
        Ag(),
        { dir: Ga(b) }
      );
      m.value = { top: w, right: k, left: x };
    }
    return (b, _) => (p(), Je(u(Tz), {
      as: "div",
      class: "fx-account"
    }, {
      default: gt(({ open: w }) => [
        tt(u(Az), {
          ref_key: "btnEl",
          ref: f,
          class: Fe(["fx-account__btn", { "is-open": w }]),
          title: d.value,
          "aria-label": d.value,
          "data-testid": "explore-account",
          onClick: v,
          onKeydown: v
        }, {
          default: gt(() => [
            c("span", zte, [
              r.value ? (p(), h("img", {
                key: 0,
                class: "fx-account__img",
                src: r.value,
                alt: ""
              }, null, 8, Mte)) : l.value ? (p(), h("span", Pte, y(l.value), 1)) : (p(), h("svg", Ote, [..._[0] || (_[0] = [
                c("circle", {
                  cx: "12",
                  cy: "8.5",
                  r: "3.5"
                }, null, -1),
                c("path", { d: "M5.5 19.5a6.5 6.5 0 0 1 13 0" }, null, -1)
              ])]))
            ]),
            _[1] || (_[1] = c("svg", {
              class: "fx-account__chev",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              c("path", { d: "M7 10l5 5 5-5" })
            ], -1))
          ]),
          _: 1
        }, 8, ["class", "title", "aria-label"]),
        (p(), Je(hi, { to: "body" }, [
          tt(kr, {
            "enter-active-class": "fx-acct-in",
            "leave-active-class": "fx-acct-out"
          }, {
            default: gt(() => [
              tt(u(Ez), {
                class: "fx-acctmenu",
                style: Yt({ top: m.value.top, right: m.value.right, left: m.value.left }),
                "data-testid": "explore-account-menu"
              }, {
                default: gt(() => [
                  c("p", Dte, y(d.value), 1),
                  (p(!0), h(Ce, null, ot(e.actions, (k) => (p(), Je(u(Cz), {
                    key: k.key
                  }, {
                    default: gt(({ active: x }) => [
                      c("button", {
                        type: "button",
                        class: Fe(["fx-acctmenu__item", { "is-active": x, "is-separated": k.separated }]),
                        "data-testid": `explore-${k.key}`,
                        onClick: (M) => a("select", k.key)
                      }, [
                        c("span", {
                          class: "fx-acctmenu__icon",
                          "aria-hidden": "true",
                          innerHTML: u(zt)(k.icon || k.key)
                        }, null, 8, Rte),
                        c("span", Nte, y(k.label), 1)
                      ], 10, Lte)
                    ]),
                    _: 2
                  }, 1024))), 128)),
                  u(q$)(e.version) ? (p(), Je(Cte, {
                    key: 0,
                    version: e.version,
                    class: "fx-acctmenu__version"
                  }, null, 8, ["version"])) : D("", !0)
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]))
      ]),
      _: 1
    }));
  }
});
function W1(e, t) {
  const n = t.replace(/\/+$/, ""), a = (i, r) => ({
    method: i,
    headers: { "Content-Type": "application/json" },
    ...r === void 0 ? {} : { body: JSON.stringify(r) }
  });
  return {
    updateProfile: (i) => e(`${n}/api/auth/profile`, a("PATCH", i)),
    checkAccount: (i) => e(`${n}/api/auth/account/check`, a("POST", i)),
    changePassword: async (i, r) => {
      await e(`${n}/api/auth/password`, a("POST", { current_password: i, new_password: r }));
    },
    enrollTotp: () => e(`${n}/api/auth/totp/enroll`, a("POST")),
    verifyTotp: async (i) => {
      await e(`${n}/api/auth/totp/verify`, a("POST", { code: i }));
    },
    disableTotp: async (i) => {
      await e(`${n}/api/auth/totp/disable`, a("POST", { code: i }));
    },
    quota: () => e(`${n}/api/files/quota/me`),
    notificationSettings: () => e(`${n}/api/notifications/settings`),
    updateNotificationSettings: (i) => e(`${n}/api/notifications/settings`, a("PATCH", i)),
    pluginActions: () => e(`${n}/api/files/plugins/actions`),
    vaultIdle: async () => (await e(`${n}/api/files/e2e/vault/prefs`)).idle_minutes,
    setVaultIdle: async (i) => (await e(`${n}/api/files/e2e/vault/prefs`, a("PUT", { idle_minutes: i }))).idle_minutes
  };
}
const Bte = 50, Fte = 15e3;
function Ute(e) {
  const t = e.transport, n = e.errorText ?? ((ie) => ie instanceof Error ? ie.message : String(ie)), a = () => {
    var ie;
    return ((ie = e.alsoStamp) == null ? void 0 : ie.call(e)) ?? [];
  }, i = $([]), r = $(!1), l = $([]), d = $(0), f = $(25), m = $(0), v = $(!1), b = $(!1), _ = $(null);
  let w = 0;
  const k = $(!1);
  let x = null, M = 0;
  const A = $(0), T = E(() => A.value > 0);
  async function N() {
    const ie = ++M;
    r.value = !0;
    try {
      const [me, q] = await Promise.all([
        t.list({ unread: !1, limit: Bte, offset: 0 }),
        t.unreadCount()
      ]);
      return ie !== M || (i.value = me.items ?? [], A.value = q, x = q), !0;
    } catch {
      return !1;
    } finally {
      ie === M && (r.value = !1);
    }
  }
  async function z() {
    try {
      A.value = await t.unreadCount();
    } catch {
    }
  }
  async function L() {
    await z(), x !== A.value && await N();
  }
  async function B(ie) {
    const me = Math.max(0, Math.floor(Number(ie) || 0));
    A.value = me, x !== me && await N();
  }
  async function O() {
    const ie = ++w;
    b.value = !0, _.value = null;
    try {
      const me = await t.list({
        unread: v.value,
        limit: f.value,
        offset: m.value
      });
      if (ie !== w) return;
      l.value = me.items ?? [], d.value = me.total ?? 0;
    } catch (me) {
      if (ie !== w) return;
      _.value = n(me);
    } finally {
      ie === w && (b.value = !1);
    }
  }
  function U(ie) {
    m.value = Math.max(0, (ie - 1) * f.value);
  }
  function S(ie) {
    v.value = ie, m.value = 0;
  }
  function F() {
    k.value = !0, m.value = 0, O();
  }
  function I() {
    k.value = !1;
  }
  async function G(ie) {
    var de;
    await t.markRead(ie);
    const me = (/* @__PURE__ */ new Date()).toISOString(), q = (V) => V.id === ie && !V.read_at ? { ...V, read_at: me } : V, C = [i, l, ...a()], re = C.some((V) => V.value.some((W) => W.id === ie && !W.read_at));
    for (const V of C) V.value = V.value.map(q);
    re && A.value > 0 && (A.value -= 1, x !== null && x > 0 && (x -= 1)), (de = e.onRead) == null || de.call(e);
  }
  async function Y() {
    var q;
    await t.markAllRead();
    const ie = (/* @__PURE__ */ new Date()).toISOString(), me = (C) => ({ ...C, read_at: C.read_at ?? ie });
    for (const C of [i, l, ...a()]) C.value = C.value.map(me);
    A.value = 0, x !== null && (x = 0), (q = e.onRead) == null || q.call(e), k.value && v.value && (m.value = 0, O());
  }
  return {
    feed: i,
    feedLoading: r,
    unreadCount: A,
    hasUnread: T,
    mine: l,
    mineTotal: d,
    mineLimit: f,
    mineOffset: m,
    mineUnreadOnly: v,
    mineLoading: b,
    mineError: _,
    panelOpen: k,
    refreshFeed: N,
    fetchUnread: z,
    syncUnread: L,
    acceptCount: B,
    fetchMine: O,
    setMinePage: U,
    setMineUnreadFilter: S,
    openPanel: F,
    closePanel: I,
    markRead: G,
    markAllRead: Y
  };
}
function Hte(e, t) {
  const n = `${t.replace(/\/+$/, "")}/api/notifications`;
  return {
    async list(a) {
      const i = [];
      return a.unread && i.push("unread=true"), a.limit != null && i.push(`limit=${encodeURIComponent(String(a.limit))}`), a.offset != null && i.push(`offset=${encodeURIComponent(String(a.offset))}`), await e(
        i.length ? `${n}?${i.join("&")}` : n
      ) ?? { items: [], total: 0 };
    },
    async unreadCount() {
      const a = await e(`${n}/unread-count`);
      return Math.max(0, Number((a == null ? void 0 : a.count) ?? 0) || 0);
    },
    async markRead(a) {
      await e(`${n}/${encodeURIComponent(String(a))}/read`, { method: "POST" });
    },
    async markAllRead() {
      await e(`${n}/read-all`, { method: "POST" });
    }
  };
}
const Kte = ["view-list", "view-grid", "view-gallery", "inspector", "nav"], Qv = "fe:";
function Vte(e, t, n = {}) {
  const a = new Set(n.omit ?? []), i = [...e];
  t.filter((r) => !r.divider && !a.has(r.key)).forEach(
    (r, l) => i.push({
      key: `${Qv}${r.key}`,
      label: r.label,
      icon: r.icon || r.key,
      separated: l === 0
    })
  );
  for (const r of n.tail ?? []) i.push({ ...r, separated: r.separated ?? !0 });
  return i;
}
function jte(e) {
  return e.startsWith(Qv) ? e.slice(Qv.length) : null;
}
function Jn(e) {
  return x0({ loader: e, suspensible: !1 });
}
const qte = ["dir"], Wte = ["title", "aria-label"], Yte = { class: "fe__stack" }, Gte = { class: "fe__panes" }, Xte = {
  key: 0,
  class: "fe-search-cut",
  role: "status"
}, Jte = {
  key: 1,
  class: "fe-search-cut fe-nav-more",
  role: "status",
  "data-testid": "nav-more"
}, Zte = ["disabled", "aria-busy"], Qte = {
  key: 2,
  class: "fe-coverage",
  role: "status",
  "data-testid": "catalog-coverage"
}, ene = { class: "fe-coverage__text" }, tne = ["disabled", "aria-busy"], nne = {
  key: 3,
  class: "fe__presence"
}, ane = ["title"], ine = {
  key: 4,
  class: "fe-e2e-upgrade",
  role: "alert"
}, one = { class: "fe-e2e-upgrade__text" }, rne = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, sne = { class: "fe-e2e-upgrade__actions" }, lne = ["disabled"], une = ["disabled"], cne = {
  key: 5,
  class: "fe-e2e-upgrade fe-e2e-upgrade--escrow",
  role: "alert"
}, dne = { class: "fe-e2e-upgrade__text" }, fne = { class: "fe-e2e-upgrade__escrow" }, pne = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, hne = {
  key: 1,
  class: "fe-e2e-upgrade__pw"
}, mne = ["disabled"], vne = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, yne = { class: "fe-e2e-upgrade__actions" }, gne = ["disabled"], bne = ["disabled"], kne = {
  key: 6,
  class: "fe-e2e-upgrade fe-e2e-upgrade--names",
  role: "status",
  "data-testid": "e2e-convert-strip"
}, wne = { class: "fe-e2e-upgrade__text" }, _ne = { key: 0 }, xne = {
  key: 1,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-convert-progress"
}, Sne = {
  key: 2,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-convert-large"
}, $ne = {
  key: 3,
  class: "fe-form__error",
  role: "alert"
}, Tne = { class: "fe-e2e-upgrade__actions" }, Ane = {
  key: 7,
  class: "fe-e2e-upgrade fe-e2e-upgrade--names",
  role: "status",
  "data-testid": "e2e-names-progress-strip"
}, Ene = { class: "fe-e2e-upgrade__text" }, Cne = { key: 0 }, zne = {
  key: 1,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-names-progress"
}, Mne = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, Pne = { class: "fe-e2e-upgrade__actions" }, One = {
  key: 8,
  class: "fe-e2e-upgrade fe-e2e-upgrade--rekey",
  role: "status",
  "data-testid": "e2e-rekey-offer"
}, Dne = { class: "fe-e2e-upgrade__text" }, Lne = {
  key: 0,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-rekey-progress"
}, Rne = {
  key: 1,
  class: "fe-form__error",
  role: "alert"
}, Nne = { class: "fe-e2e-upgrade__actions" }, Ine = ["disabled"], Bne = {
  key: 10,
  class: "fe-e2e-strip",
  role: "status"
}, Fne = ["innerHTML"], Une = { class: "fe-e2e-strip__label" }, Hne = {
  class: "fe-e2e-strip__names",
  "data-testid": "e2e-names-status"
}, Kne = ["disabled"], Vne = {
  key: 11,
  class: "fe-trashbar"
}, jne = { class: "fe-trashbar__text" }, qne = {
  key: 0,
  class: "fe-trashbar__count",
  "data-testid": "trash-summary"
}, Wne = {
  key: 0,
  class: "fe-trashbar__shown"
}, Yne = ["disabled"], Gne = {
  key: 2,
  class: "fe-trashbar__progress",
  role: "status",
  "aria-live": "polite"
}, Xne = ["disabled"], Jne = {
  key: 2,
  class: "fe-state"
}, Zne = { class: "fe-state__title" }, Qne = { class: "fe-state__path" }, eae = { class: "fe-state__hint" }, tae = { class: "fe-state__actions" }, nae = {
  key: 0,
  class: "fe-state"
}, aae = { class: "fe-state__title" }, iae = { class: "fe-state__hint" }, oae = ["data-testid"], rae = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, sae = {
  key: 1,
  d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z"
}, lae = { class: "fe-state__title" }, uae = { class: "fe-state__hint" }, cae = {
  key: 2,
  class: "fe-state"
}, dae = { class: "fe-state__title" }, fae = { class: "fe-state__hint" }, pae = {
  key: 3,
  class: "fe-state"
}, hae = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, mae = { key: 0 }, vae = { class: "fe-state__title" }, yae = {
  key: 0,
  class: "fe-state__hint"
}, gae = {
  key: 1,
  class: "fe-state__actions"
}, bae = { class: "fe-overlay__head" }, kae = { class: "fe-overlay__title" }, wae = ["title", "aria-label"], _ae = {
  key: 1,
  class: "fe__dragover"
}, xae = { class: "fe__dragover-card" }, Sae = ["innerHTML"], $ae = ["title", "aria-label"], Tae = {
  key: 3,
  class: "fe-keep-strip",
  role: "status",
  "aria-live": "polite"
}, Aae = { class: "fe-keep-strip__label" }, Eae = {
  key: 0,
  class: "fe-keep-strip__bar",
  "aria-hidden": "true"
}, Cae = {
  key: 0,
  "data-testid": "trash-empty-count"
}, zae = {
  key: 1,
  class: "fe-form__error",
  role: "alert"
}, Mae = {
  key: 2,
  role: "status"
}, Pae = ["disabled"], Oae = { class: "fe-recents__header" }, Dae = ["aria-label"], Lae = { class: "fe-modal__head" }, Rae = { class: "fe-modal__title" }, Nae = ["aria-label"], Iae = { class: "fe-modal__body" }, Bae = { class: "fe-toast__msg" }, Y1 = "brf-file-explorer:view-mode", Wd = 250, G1 = 3, X1 = "user-settings", Fae = 800, J1 = "filex.inspector", Z1 = "filex.sidenav", Q1 = 250, Su = 100, Uae = 500, Hae = 2e3, li = 2500, pn = 6e3, Yd = 10 * 60 * 1e3, e0 = 200, qm = "brf-file-explorer:path", Kae = 40, Vae = "application/x-brf-files", jae = 8 * 1024 * 1024, qae = 10, Wae = "/files/edit", t0 = "filex.tabs", Yae = "https://docs.filex.sh/E2E-ENCRYPTION#what-escrow-can-and-cannot-do", Gae = 6e4, Xae = 2e3, Kce = /* @__PURE__ */ lt({
  __name: "FileExplorer",
  props: {
    config: {}
  },
  emits: ["share-created", "file-opened", "error", "upload-progress", "selection-change", "navigate", "refresh", "open-my-shares", "open-app-store", "open-app-home"],
  setup(e, { expose: t, emit: n }) {
    var iw;
    const a = () => import("./E2eVaultStrip-CS8sosAX.js"), i = x0(a), r = Jn(() => import("./PreviewModal-DAyqlznB.js")), l = Jn(() => import("./QuickLook-02uwu3Bg.js")), d = Jn(() => import("./UserSettingsDialog-BIVU66tc.js")), f = Jn(() => import("./TimeZoneDialog-GBAgkDd_.js")), m = Jn(() => import("./PermissionsModal-t8yXmoFA.js")), v = Jn(() => import("./AdvancedSearch-MAzeaKAz.js")), b = Jn(() => import("./CommandPalette-BjRWq-b4.js")), _ = Jn(() => import("./NewDocumentModal-CU8dcL5p.js")), w = Jn(() => import("./ArchiveCreateModal-CvHkhmt9.js")), k = Jn(() => import("./OnboardingTour-B1vkBsJ-.js")), x = Jn(() => import("./ShortcutSettings-DxwC5tKr.js")), M = Jn(() => import("./EncryptedFolderModal-Dpl9K7Eu.js")), A = Jn(() => import("./E2eSettingsModal-D37bS_Cj.js")), T = Jn(() => import("./E2eChangePasswordModal-BzzMcOA8.js")), N = Jn(() => import("./RecoveryKeyModal-2RdOHVat.js")), z = Jn(() => import("./E2eRecoveryUnlockModal-QbJ16dgQ.js")), L = Jn(() => import("./E2eFileEncryptModal-BmxUsJwB.js")), B = Jn(() => import("./E2eFileUnlockModal-rEPysouS.js")), O = e, U = n, S = _l(O.config), F = $(null), I = E(
      () => {
        var o;
        return O.config.permissions ?? ((o = F.value) == null ? void 0 : o.permissions);
      }
    ), G = E(
      () => {
        var o;
        return O.config.permissions ? O.config.permissionsByFolder : (o = F.value) == null ? void 0 : o.byFolder;
      }
    );
    let Y = Promise.resolve();
    function ie() {
      O.config.permissions || (Y = S.myPermissions().then(
        (o) => {
          F.value = o && !o.admin ? { permissions: o.permissions, byFolder: o.byFolder } : null;
        },
        () => {
          F.value = null;
        }
      ));
    }
    Wt(ie);
    const me = $(""), q = E(() => Sa(me.value || O.config.locale));
    wr(Q0, () => q.value), Xe(q, (o) => Vy(o), { immediate: !0 });
    const { t: C, formatDate: re, dir: de } = yt(q), V = WZ({
      http: {
        endpoints: S.endpoints,
        authHeaders: (o) => S.authHeaders(o),
        credentialsMode: () => S.credentialsMode(),
        downloadUrl: (o) => S.downloadUrl(o),
        acceptLanguage: () => fi(q.value)
      },
      headersNow: () => S.authHeadersSync(),
      t: (o, s) => C(o, s),
      toast: (o, s) => Vt({ message: o }, s ? pn : li),
      emitError: (o, s) => U("error", { message: o, context: { op: s } }),
      // The lock's holder says which client: the desktop app is the explorer that
      // was handed the shell's hooks.
      clientKind: () => O.config.desktopSync || O.config.dragOut ? "desktop" : "web",
      dropKeys: (o) => BC(o),
      formatCount: (o) => new Intl.NumberFormat(fi(q.value)).format(o),
      onLocked: (o, s) => FC(o, s),
      onChanged: (o) => UC(o),
      onLockSoon: (o, s) => PC(o, s),
      askName: (o) => ne(o)
    }), W = $(null);
    function ne(o) {
      return new Promise((s) => {
        W.value = { ...o, resolve: s };
      });
    }
    function K(o) {
      const s = W.value;
      W.value = null, s == null || s.resolve(o);
    }
    function ce(o) {
      return V.rootOf(o) ?? o;
    }
    function J(o) {
      const s = String(o ?? "").replace(/\/+$/, ""), g = V.rootOf(s);
      if (!g || !V.isOpen(g)) return null;
      const P = V.rows(s) ? s : g, R = V.permOf(g);
      return {
        adapter: P.slice(0, P.indexOf("://")),
        storages: [],
        dirname: P,
        read_only: !1,
        ...R ? { perm: R } : {},
        e2e_root: g,
        e2e_vault_root: g,
        files: yr(V.rows(P) ?? [])
      };
    }
    function H(o) {
      const s = String(o.dirname ?? "").replace(/\/+$/, ""), g = typeof o.e2e_vault_root == "string" && o.e2e_vault_root ? o.e2e_vault_root : V.rootOf(s);
      return g ? { ...o, e2e_vault_root: g, files: [] } : o;
    }
    const X = {
      ...S,
      index: async (o) => {
        const s = J(o);
        if (s) return s;
        const g = V.rootOf(String(o ?? ""));
        return H(await S.index(g ?? o));
      }
    }, we = () => Promise.reject(new Error("vault: not asked")), it = {
      ...S,
      listShares: (o) => V.rootOf(o) ? we() : S.listShares(o),
      listPermissions: (o) => V.rootOf(o) ? we() : S.listPermissions(o),
      createShare: (o) => V.rootOf(o.path) ? we() : S.createShare(o)
    };
    function Re() {
      typeof document < "u" && document.visibilityState === "visible" && V.onVisible();
    }
    Wt(() => {
      typeof document < "u" && document.addEventListener("visibilitychange", Re), typeof window < "u" && window.addEventListener("pagehide", V.onPageHide);
    }), Ot(() => {
      typeof document < "u" && document.removeEventListener("visibilitychange", Re), typeof window < "u" && window.removeEventListener("pagehide", V.onPageHide), V.closeAll("manual");
    });
    const Be = xP(S, {
      reload: () => xt(),
      onVault: (o) => V.onEvent(o),
      onAccess: (o) => LA(o)
    }), We = Be.presenceUsers, bt = Be.degraded;
    function at(o) {
      const s = (o || "").replace(/^\/+|\/+$/g, "");
      if (s === ".trash" || s.startsWith(".trash/")) return null;
      const g = Nt(s);
      return !g || !g.includes("://") || g.startsWith("://") ? null : V.rootOf(g) ?? g;
    }
    Wt(() => {
      Be.start(), Be.subscribe(at(De.value));
    }), Ot(() => Be.stop());
    const Ie = TP(O.config.apiBase, S), nt = RM(O.config, S), dt = /* @__PURE__ */ new Map(), Me = l2(O.config, S, {
      onSettled: (o) => {
        var P, R;
        const s = dt.get(o.id);
        if (dt.delete(o.id), o.op_type === "trash-empty") {
          xt();
          return;
        }
        const g = Bh.get(o.id);
        if (g) {
          Bh.delete(o.id), iu(g, !1);
          const j = o.summary || (o.status === "error" ? $f(o, C).text : "");
          j && o.status !== "cancelled" && Vt({ message: j }, o.status === "done" ? li : pn), At.value && $i();
          return;
        }
        if (o.status === "cancelled") {
          const j = o.op_type === "archive-extract" ? C("archive.extraction_cancelled", { count: o.progress_done }) : C("opc.status.aborted");
          Qe(j);
        } else if (o.op_type === "restore" && o.summary)
          Vt({ message: o.summary }, o.status === "done" ? li : pn);
        else if (o.status === "error")
          Qe($f(o, C).text);
        else if (s)
          nd(o.op_type === "rename" ? s.message : `${s.message} (${o.progress_total})`, s.fn);
        else if (o.op_type === "plugin") {
          Qe(o.message || C("plugin.done", { label: $T(o) }));
          const j = Ux(o, { busy: !!mn.value || !!Ca.value });
          if (j) {
            Hp(j.plugin, j.open), (P = Xt.value) == null || P.reload();
            return;
          }
        } else if (o.op_type === "rename")
          Qe(C("toast.renamed"));
        else if (o.op_type === "restore")
          Qe(C("toast.restored", { n: o.progress_done }));
        else {
          const j = o.op_type === "archive-create" ? C("archive.created") : o.op_type === "archive-extract" ? C("archive.extraction_completed") : o.op_type === "copy" ? C("toast.copied") : o.op_type === "move" ? C("toast.moved") : C("toast.deleted");
          Qe(o.op_type.startsWith("archive-") ? j : `${j} (${o.progress_total})`);
        }
        xt(), (R = Xt.value) == null || R.reload();
      }
    }), be = $(!1), Ve = (O.config.rootPath || "").trim(), Te = Ve.replace("://", "/").replace(/^\/+|\/+$/g, ""), qe = Te || O.config.initialPath || "", De = $(qe), mt = wW(), $t = (o) => mt.isNewest(o), kt = $(O.config.defaultAdapter || "brf"), Tt = $(qe), xe = $([]), Ne = $(""), fe = $(!1), Se = $(""), Z = $("");
    let ge;
    function ae() {
      xt(ge);
    }
    const ve = $(
      (() => {
        try {
          const o = localStorage.getItem(Y1);
          if (o === "list" || o === "grid" || o === "gallery") return o;
        } catch {
        }
        return O.config.viewMode ?? "list";
      })()
    ), le = $("comfortable"), _e = $(""), Ee = $(!1), ht = $({}), jt = $({});
    let tn = null;
    function Cn() {
      if (!tn) {
        const o = _a(O.config);
        tn = vee({
          list: async () => {
            const s = await S.jsonFetch(`${o}/api/admin/storages`);
            return Array.isArray(s) ? s : [];
          }
        });
      }
      return tn;
    }
    function Lt(o) {
      return !!o && o in jt.value;
    }
    const At = $(!1), zn = $(""), Bt = E(() => At.value), ft = $(""), Dn = $(""), Qn = E(
      () => ft.value !== "" && ft.value !== "trash" && ft.value !== "home"
    ), Ln = E(
      () => ft.value === "recent" || ft.value === "starred" || ft.value === "shared" || ft.value === "tag"
    ), on = E(() => O.config.rememberFolderView !== !1), In = E(() => {
      if (!on.value) return "";
      const o = String(De.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!o) return nL;
      const [s, ...g] = o.split("/"), P = (O.config.storages ?? []).find((R) => R.name === s);
      return f_((P == null ? void 0 : P.uid) || s, g.join("/"));
    });
    function la() {
      const o = bp().v;
      if (o) return o;
      if (!Ls())
        try {
          const s = localStorage.getItem(Y1);
          if (s === "list" || s === "grid" || s === "gallery") return s;
        } catch {
        }
      return O.config.viewMode ?? "list";
    }
    ny(
      zx(() => {
        Ls() && nn(In.value);
      })
    );
    let vn = null;
    function nn(o) {
      if (!o && on.value) return;
      iL(o);
      const s = o ? lL(o) : {}, g = s.v ?? la();
      if (g !== ve.value && (ve.value = g), s.k) x_(s.k, s.d ?? fl(s.k));
      else {
        const P = jy();
        x_(P.key, P.dir);
      }
      vn = { key: o, v: ve.value, k: w_(), d: __() };
    }
    Wt(() => {
      _L({
        apiBase: O.config.apiBase ?? "",
        headers: Xn,
        credentials: S.credentialsMode()
      });
    }), Xe(
      [In, () => Ls()],
      ([o, s]) => {
        s && nn(o);
      },
      { immediate: !0, flush: "post" }
    ), Xe(
      () => [In.value, ve.value, w_(), __()],
      ([o, s, g, P]) => {
        if (!Ls() || !vn || vn.key !== o) return;
        const R = {};
        s !== vn.v && (R.v = s), (g !== vn.k || P !== vn.d) && (R.k = g, R.d = P), vn = { key: o, v: s, k: g, d: P }, Object.keys(R).length && (o ? Sx(o, R) : on.value || Tx(R));
      },
      /* ⚠⚠ `post`, and registered AFTER the applier: a navigation changes
       * `currentFolderKey`, which both watchers depend on. Pre-flush this would
       * run first, while the view state is still the folder you LEFT, and record
       * that folder's setup against the one you arrived in. */
      { flush: "post" }
    ), Xe(
      () => Av(In.value),
      (o, s) => {
        s && !o && Ls() && nn(In.value);
      }
    );
    const ln = $(""), kn = $(""), Mn = {
      home: ".home",
      recent: ".recent",
      starred: ".starred",
      shared: ".shared",
      drafts: ".drafts"
    };
    function Hn(o) {
      if (!gx(o)) return null;
      const s = String(o ?? "").replace(/^\/+|\/+$/g, ""), g = JD(s);
      return g ? { kind: "tag", tag: g, tagKind: XD(s) } : { kind: s.slice(1), tag: "", tagKind: "" };
    }
    const rn = E(() => {
      if (!wn.value) return "";
      const o = O.config.storages ?? [];
      return o.length === 1 ? o[0].name : "";
    }), Ea = E(() => {
      const o = (De.value ?? "").replace(/^\/+|\/+$/g, "");
      return Te && o === Te || rn.value && o === rn.value ? !1 : o.length > 0;
    }), pe = E(() => ft.value && ft.value !== "trash" ? !0 : wn.value ? !(De.value ?? "").replace(/^\/+|\/+$/g, "") : !1), Le = E(
      () => ft.value === "home" ? "find" : "full"
    );
    function Ue() {
      if (At.value) {
        xt(zn.value);
        return;
      }
      if (ft.value) {
        xt(Dn.value);
        return;
      }
      const o = (De.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!o || o === Te || rn.value && o === rn.value) return;
      const s = o.lastIndexOf("/");
      let g = s === -1 ? "" : o.slice(0, s);
      Te && !(g === Te || g.startsWith(Te + "/")) && (g = Te), xt(g);
    }
    const He = $([]), wt = E(
      () => (He.value.length ? He.value : xe.value).filter((o) => o.type !== "dir")
    ), et = E(() => {
      var P;
      const o = wt.value, s = (P = cn.value) == null ? void 0 : P.path, g = s ? o.findIndex((R) => R.path === s) : -1;
      return { index: g === -1 ? 0 : g + 1, total: g === -1 ? 0 : o.length };
    });
    async function oe(o) {
      const s = wt.value, g = s.findIndex((R) => {
        var j;
        return R.path === ((j = cn.value) == null ? void 0 : j.path);
      });
      if (g === -1) return;
      const P = s[g + o];
      if (P) {
        if (Ri(P) && !Qt.value && !P.e2e_root) {
          oa.value = !1, Pt.open(P);
          return;
        }
        if (qn.value && P.type === "file")
          try {
            await Md(P);
          } catch {
            Qe(C("e2e.decrypt_failed"));
            return;
          }
        cn.value = P;
      }
    }
    function je(o) {
      const s = Date.now(), g = /* @__PURE__ */ new Set([...xe.value, ...He.value]);
      cn.value && g.add(cn.value);
      for (const P of g)
        P.path === o.path && (typeof o.size == "number" && (P.size = o.size), P.last_modified = s);
    }
    const Ke = Iw(() => He.value.length ? He.value : xe.value);
    Xe(
      () => [...Ke.selected.value],
      () => {
        U(
          "selection-change",
          /* wiring:e2 names — `basename` stays what the server calls the item
             (hosts pass it back to the API); an encrypted-names row adds its
             plaintext as `display_name` for a host that draws it. */
          Ke.nodes.value.map((s) => ({
            path: s.path,
            basename: sf(s),
            type: s.type,
            ...s.e2e_stored ? { display_name: s.basename } : {}
          }))
        );
        const o = Ke.nodes.value.filter((s) => s.type === "file");
        Be.setFocus(o.length === 1 && !V.isVaultRow(o[0]) ? sf(o[0]) : null);
      }
    );
    const _t = $({ mode: null, items: [], sourcePath: null }), ee = $(null);
    let he = null;
    function Oe() {
      return he || (S.endpoints.capabilities ? (he = (async () => {
        for (let o = 1; o <= G1; o++)
          try {
            ee.value = await S.capabilities();
            return;
          } catch (s) {
            if (o === G1) {
              U("error", {
                message: `capabilities: ${(s == null ? void 0 : s.message) ?? String(s)}`,
                context: { what: "capabilities", attempts: o }
              });
              return;
            }
            await new Promise((g) => setTimeout(g, 200 * o));
          }
      })(), he) : (he = Promise.resolve(), he));
    }
    const Ye = $(!1);
    let rt = null;
    function St() {
      return rt || (rt = S.jsonFetch(`${_a(O.config)}/api/auth/me`), rt.catch(() => {
        rt = null;
      })), rt;
    }
    const Q = dY({
      config: () => O.config,
      capabilities: ee,
      fetchMe: () => St()
    }), te = O.config.notifications ? _0(
      Ute({
        // The server says each row in the language on screen (`lang=`).
        transport: Hte(S.jsonFetch, _a(O.config)),
        errorText: (o) => (o == null ? void 0 : o.message) || C("inspector.error"),
        onRead: () => {
          var o, s;
          return (s = (o = O.config.notifications) == null ? void 0 : o.onRead) == null ? void 0 : s.call(o);
        }
      })
    ) : null;
    let ke = null;
    Wt(() => {
      var s;
      const o = O.config.notifications;
      !te || !o || (te.refreshFeed(), o.poll !== !1 && (ke = setInterval(() => void te.syncUnread(), Fte)), (s = o.onUnread) == null || s.call(o, (g) => void te.acceptCount(g)));
    }), Ot(() => {
      ke && clearInterval(ke), ke = null;
    }), Xe(q, () => {
      te && (te.refreshFeed(), te.panelOpen && te.fetchMine());
    });
    const Ge = E(() => {
      var g, P, R;
      const o = (P = (g = O.config.notifications) == null ? void 0 : g.manage) == null ? void 0 : P.href;
      return o && (ba.value || ((R = Bn.value) == null ? void 0 : R.role) === "admin") ? o : void 0;
    });
    function pt() {
      var o, s;
      (s = (o = O.config.notifications) == null ? void 0 : o.manage) == null || s.open();
    }
    let Rt = () => {
    };
    const Kt = new Promise((o) => {
      Rt = o;
    });
    async function Ft(o) {
      var P;
      if (await Kt, o.kind === "none") return !1;
      if (o.kind === "share")
        return window.open(K$(o.token, _a(O.config)), "_blank", "noopener"), !0;
      if (o.kind === "app")
        return await Oe(), await aa.refresh(), await Ng(`${o.plugin}/${o.view}`), !0;
      const s = Vee(o);
      if (!s) return !1;
      s === ep ? await xt(ep) : await xt(wn.value ? ko(s) : Fa(s));
      const g = o.select;
      if (g) {
        const R = xe.value.find((j) => j1(j.path, g));
        if (R) {
          Ke.click(R.path), await Zt();
          const j = Array.from(((P = xn.value) == null ? void 0 : P.querySelectorAll("[data-fe-path]")) ?? []).find(
            (ue) => j1(ue.getAttribute("data-fe-path"), g)
          );
          j == null || j.scrollIntoView({ block: "center" });
        }
      }
      if (o.kind === "folder" && o.open) {
        const R = o.select || s;
        await Up({ plugin: o.open.plugin, action: o.open.action, view: o.open.view, path: R });
      }
      return !0;
    }
    function dn(o) {
      Ft(H$(o.target));
    }
    function Jt() {
      St().then((o) => {
        const s = o == null ? void 0 : o.user;
        if (!s) return;
        const g = typeof s.locale == "string" ? s.locale.trim() : "";
        if (g) {
          me.value = g;
          return;
        }
        const P = String(O.config.locale ?? "").trim();
        P && W1(S.jsonFetch, _a(O.config)).updateProfile({ locale: P }).catch(() => {
        });
      }).catch(() => {
      });
    }
    let $n = !1;
    Xe(
      () => {
        var o;
        return (O.config.callerKind ?? ((o = ee.value) == null ? void 0 : o.caller_kind)) === "user";
      },
      (o) => {
        if (!o) {
          me.value = "";
          return;
        }
        $n || ($n = !0, Jt());
      },
      { immediate: !0 }
    ), Xe(
      () => O.config.locale,
      () => {
        me.value = "";
      }
    );
    const Bn = $(((iw = O.config.account) == null ? void 0 : iw.person) ?? null);
    Wt(() => {
      !O.config.account || O.config.account.person || St().then((o) => {
        Bn.value = (o == null ? void 0 : o.user) ?? null;
      }).catch(() => {
      });
    });
    const se = $([]);
    let ye = null;
    function Pe(o) {
      if (!O.config.account) return;
      const s = o.detail;
      !s || !Array.isArray(s.items) || (s.claimed = !0, o.stopPropagation(), se.value = s.items, ye = typeof s.run == "function" ? s.run : null);
    }
    Wt(() => {
      var o;
      return (o = xn.value) == null ? void 0 : o.addEventListener("fe:header-menu", Pe);
    }), Ot(() => {
      var o;
      return (o = xn.value) == null ? void 0 : o.removeEventListener("fe:header-menu", Pe);
    });
    const ut = E(() => {
      const o = O.config.account;
      if (!o) return [];
      const s = Bn.value, g = typeof o.actions == "function" ? o.actions(s) : o.actions ?? [], P = o.settings ? [{ key: X1, label: C("userSettings.open"), icon: "account" }, ...g] : g, R = typeof o.tail == "function" ? o.tail(s) : o.tail ?? [], j = Kte.filter(($e) => $e !== "inspector" || O.config.showInfoPanel !== !1), ue = o.settings ? Mt : [];
      return Vte(P, se.value, {
        omit: [...j, ...ue, ...o.omit ?? []],
        tail: R
      });
    });
    function Pn(o) {
      var g, P;
      const s = jte(o);
      if (s !== null) {
        ye == null || ye(s);
        return;
      }
      if (o === X1 && ((g = O.config.account) != null && g.settings)) {
        yn.value = !0;
        return;
      }
      (P = O.config.account) == null || P.select(o, Bn.value);
    }
    const Mt = ["theme", "density", "timezone"], yn = $(!1), Ra = {
      get locale() {
        return String(q.value);
      },
      get user() {
        return Bn.value;
      },
      get isAdmin() {
        var o;
        return ((o = Bn.value) == null ? void 0 : o.role) === "admin";
      },
      get demoReadOnly() {
        var o;
        return ((o = ee.value) == null ? void 0 : o.demo_mode) === !0;
      },
      get capabilities() {
        return ee.value;
      },
      api: W1(S.jsonFetch, _a(O.config)),
      setUser(o) {
        Bn.value = { ...Bn.value ?? {}, ...o };
      },
      toast(o, s) {
        Vt({ message: s }, o === "success" ? li : pn);
      },
      errorText: (o, s) => (o == null ? void 0 : o.message) || s,
      zone: hM(Q),
      mode: {
        get: () => {
          const o = ou.value === "host" ? O.config.theme || "auto" : ou.value;
          return o === "light" || o === "dark" ? o : "auto";
        },
        set: (o) => hk(o)
      }
    }, Yi = E(
      () => {
        var o, s;
        return ((o = ee.value) == null ? void 0 : o.share_link_max_days) ?? ((s = ee.value) == null ? void 0 : s.share_max_ttl_days) ?? 0;
      }
    ), yi = E(() => {
      var o, s;
      return typeof O.config.plugins == "boolean" ? O.config.plugins : ((s = (o = ee.value) == null ? void 0 : o.app_plugins) == null ? void 0 : s.enabled) === !0;
    }), aa = fP(S, () => yi.value), mn = $(null);
    let Tl = 0;
    const Ip = $(!1);
    let Bp;
    Ot(() => clearTimeout(Bp));
    function cT(o) {
      const s = ++Tl;
      return mn.value = { ...o, surface: null, ticket: s }, Ip.value = !1, clearTimeout(Bp), Bp = setTimeout(() => {
        Nc(s) && (Ip.value = !0);
      }, Fae), s;
    }
    const dT = E(
      () => !!mn.value && (mn.value.surface !== null || Ip.value)
    );
    function Nc(o) {
      var s;
      return o > 0 && ((s = mn.value) == null ? void 0 : s.ticket) === o;
    }
    const Ca = $(null);
    function fT(o) {
      return o.filter((s) => s.type === "file").map((s) => ({
        path: s.path,
        name: s.basename,
        size: s.size,
        mime: s.mime_type,
        readOnly: !!s.read_only || !Zi(s),
        ...s.encrypted ? { encrypted: s.encrypted } : {}
      }));
    }
    const Al = E(() => yi.value ? aa.views.value : []), El = E(() => yi.value ? aa.openRules.value : {}), Og = E(() => ({ onlyOffice: !!Wo.value }));
    function jr(o) {
      return { ...Og.value, inEncrypted: Qt.value || V.isVaultRow(o), e2ePlaintext: !!Fp(o) };
    }
    function Fp(o) {
      var P;
      if (jn.value, !o || o.type !== "file" || Ri(o) || ((P = ee.value) == null ? void 0 : P.apps_e2e_plaintext) !== !0) return null;
      if (V.isVaultRow(o)) return pT(o);
      if (o.encrypted && o.encrypted !== "folder") return null;
      const s = typeof o.e2e_root == "string" && o.e2e_root || (Qt.value ? Et.value : null), g = Ut.rootOf(o.path, s);
      return !g || !an.has(g) ? null : g;
    }
    function pT(o) {
      V.version.value;
      const s = typeof o.vault_root == "string" ? o.vault_root : "";
      return s && V.isOpen(s) ? s : null;
    }
    function Cl(o, s, g) {
      const P = zu(Al.value, o, s, El.value, zl(o), jr(o));
      return P != null && P.view ? (gi.value = s, Ia.value = g === "edit" && Zi(o) ? "edit" : "view", cn.value = o, oa.value = !0, U("file-opened", { path: o.path, basename: o.basename }), Na(o), !0) : !1;
    }
    function Dg(o) {
      return VS(Al.value, o, El.value, jr(o));
    }
    function zl(o) {
      return o ? Eee(Vs(o)) : null;
    }
    const gi = $(null), Lg = E(
      () => zu(
        Al.value,
        cn.value,
        gi.value,
        El.value,
        zl(cn.value),
        jr(cn.value)
      )
    ), Rg = E(() => {
      var o;
      return ((o = Lg.value) == null ? void 0 : o.view) ?? null;
    }), hT = E(() => df(Lg.value));
    function mT(o) {
      return df(o) ? C("ctx.open_with", { app: "ONLYOFFICE" }) : o.view ? C("ctx.open_with", { app: Gt(o.view.label, q.value) || o.view.plugin }) : C("ctx.open_with_builtin");
    }
    function vT(o) {
      var P;
      if (o.length !== 1) return [];
      const { on: s } = Dg(o[0]), g = !US(o[0], jr(o[0])) && ((P = o[0]) == null ? void 0 : P.type) === "file" && lg(Vs(o[0])) && !Og.value.onlyOffice ? [
        {
          key: `open-with:${gl}`,
          label: C("ctx.open_with", { app: "ONLYOFFICE" }),
          icon: "open",
          testid: `ctx-open-with-${gl}`,
          ...gm(!1, ba.value, C("ctx.needs_onlyoffice"))
        }
      ].filter((R) => !R.hidden) : [];
      return s.length < 2 && g.length === 0 ? [] : [
        ...s.map((R) => ({ key: `open-with:${R.id}`, label: mT(R), icon: "open", testid: `ctx-open-with-${R.id}` })),
        ...g,
        ...s.length < 2 ? [] : [{ key: "open-with-choose", label: C("ctx.open_with_choose"), icon: "open", testid: "ctx-open-with-choose" }]
      ];
    }
    const za = $(null), yT = E(() => Dg(za.value).on), gT = E(
      () => za.value && !B6(za.value) ? Vs(za.value) : ""
    ), bT = E(() => {
      var s;
      const o = za.value;
      return o ? ((s = zu(Al.value, o, null, El.value, zl(o), jr(o))) == null ? void 0 : s.id) ?? null : null;
    });
    function kT(o, s) {
      const g = za.value;
      if (!g) return;
      const P = Vs(g);
      if (za.value = null, s && P && Cee(P, o), (qn.value || V.isVaultRow(g)) && Fp(g)) {
        (o === Io || !Cl(g, o, "edit")) && (gi.value = Io, xs(g));
        return;
      }
      fd(g), gi.value = o, o !== "builtin" && Zi(g) && (Ia.value = "edit");
    }
    const wT = zee();
    Ot(wT);
    const _T = E(
      () => yi.value ? aa.views.value.filter((o) => o.placement === "inspector") : []
    ), xT = E(
      () => yi.value ? aa.views.value.filter((o) => o.placement === "home").map((o) => ({ key: `${o.plugin}/${o.id}`, label: Gt(o.label, q.value) || o.id, icon: o.icon })) : []
    );
    async function Ng(o) {
      const s = aa.views.value.find((g) => `${g.plugin}/${g.id}` === o);
      if (s) {
        if (bo(), O.config.appHomePage === !0) {
          U("open-app-home", { plugin: s.plugin, view: s.id });
          return;
        }
        if (s.ui) {
          Ca.value = {
            plugin: s.plugin,
            view: s.id,
            placement: "home",
            ui: s.ui,
            label: Gt(s.label, q.value) || s.plugin,
            files: []
          };
          return;
        }
        try {
          const g = await S.pluginView(s.plugin, s.id);
          if (!(g != null && g.surface)) {
            Qe(C("plugin.view.error"));
            return;
          }
          mn.value = { plugin: s.plugin, view: s.id, surface: g.surface, size: "xl" };
        } catch (g) {
          Qe((g == null ? void 0 : g.message) || C("plugin.view.error"));
        }
      }
    }
    const bi = $(null);
    function ST(o) {
      return yi.value ? lP(aa.actions.value, o, {
        locale: q.value,
        trash: Bt.value,
        e2e: Qt.value,
        readOnly: fe.value || wb(o),
        // The level each row answers with — the same one the built-in verbs
        // read — so an app's row a viewer could only be refused is not offered.
        permOf: (s) => dh(s),
        hasIcon: (s) => zt(s) !== "",
        // Greyed rows with the reason are an ADMINISTRATOR's (the server sends
        // `gated` to them only; asked here too, so no other caller draws one).
        needWords: ba.value ? (s) => nP(s, C) : void 0
      }) : [];
    }
    function $T(o) {
      return o.label || o.action || C("opc.kind.plugin");
    }
    function TT(o) {
      var s;
      if (!(!o.plugin || !o.action))
        return (s = aa.actions.value.find((g) => g.plugin === o.plugin && g.id === o.action)) == null ? void 0 : s.output_mode;
    }
    async function Ig(o, s) {
      const g = aa.byKey(o);
      if (!g || s.length === 0) return;
      if (Gt(g.confirm, q.value)) {
        bi.value = { action: g, targets: s };
        return;
      }
      await Fg(g, s);
    }
    async function AT() {
      const o = bi.value;
      bi.value = null, o && await Fg(o.action, o.targets);
    }
    function Bg(o, s) {
      var $e, Ae, st;
      const g = o.view, P = O.config.pluginPageBase;
      if (!g || P === void 0) return !1;
      const R = { plugin: o.plugin, view: g, path: ($e = s[0]) == null ? void 0 : $e.path }, j = s2(P, R);
      if (((st = (Ae = O.config).openPluginPage) == null ? void 0 : st.call(Ae, { ...R, url: j })) === !0) return !0;
      const ue = window.open(j, "_blank");
      if (!ue)
        return Qe(C("plugin.page_view.blocked")), !1;
      try {
        ue.opener = null;
      } catch {
      }
      return !0;
    }
    function Ml(o, s, g = {}) {
      const P = O.config.refusalToasts !== !1, R = Ov(o);
      R ? P && Qe(Lr(R, { t: C, formatDate: re, locale: q.value })) : !g.inDialog && P && Vt({ message: g.words ?? Gn(o) }, pn), U("error", { message: (o == null ? void 0 : o.message) ?? String(o), context: s });
    }
    function Pl(o, s, g, P, R = Gn(g)) {
      Ml(g, P, { inDialog: o.refuse(s, R), words: R });
    }
    function Gn(o, s = C("toast.failed")) {
      return U0(o, s, { t: C, callerAdmin: ba.value }).text;
    }
    async function Fg(o, s) {
      var j;
      const g = Gt(o.label, q.value);
      if (Ef(o.view_placement) && Bg(o, s)) return;
      if (o.ui) {
        Ca.value = {
          plugin: o.plugin,
          view: o.view || o.id,
          placement: "modal",
          ui: o.ui,
          label: g || o.plugin,
          files: fT(s)
        };
        return;
      }
      const P = {
        plugin: o.plugin,
        view: o.view || o.id,
        path: (j = s[0]) == null ? void 0 : j.path,
        paths: s.map((ue) => ue.path),
        label: g
      }, R = o.view ? cT(P) : 0;
      try {
        const ue = await aa.run(o, s);
        if (ue.surface) {
          if (o.view && !Nc(R)) return;
          mn.value = { ...P, surface: ue.surface, ticket: R || ++Tl };
          return;
        }
        Nc(R) && (mn.value = null), ue.op && Ol(ue.op, g);
      } catch (ue) {
        Nc(R) && (mn.value = null);
        const $e = ue, Ae = Ov($e);
        Ae ? Qe(Lr(Ae, { t: C, formatDate: re, locale: q.value })) : Vt({ message: Gn($e, C("plugin.failed", { label: g })) }, pn);
      }
    }
    function Ol(o, s) {
      Me.register(o);
      const g = s || (typeof o.label == "string" ? o.label : "") || C("opc.kind.plugin");
      Qe(C("plugin.queued", { label: g }));
    }
    async function Up(o) {
      if (!o.plugin || !o.path) return !1;
      if (await Oe(), !yi.value)
        return U("error", {
          message: "app plugins are off on this instance - deep link ignored",
          context: { what: "openAppTarget", plugin: o.plugin, path: o.path }
        }), !1;
      await aa.refresh();
      const s = xe.value.find((P) => P.path === o.path) ?? { path: o.path, basename: o.path.split("/").pop() ?? o.path, type: "file" };
      if (o.action) {
        const P = aa.byKey(`plugin:${o.plugin}/${o.action}`);
        return P ? (await Ig($y(P), [s]), !0) : (Qe(C("plugin.not_applicable")), U("error", {
          message: `no such plugin action: ${o.plugin}/${o.action}`,
          context: { what: "openAppTarget", path: o.path }
        }), !1);
      }
      if (!o.view) return !1;
      const g = aa.actions.value.find((P) => P.plugin === o.plugin && P.view === o.view);
      if (g && Ef(g.view_placement) && Bg(g, [s]))
        return !0;
      try {
        const P = await S.pluginView(o.plugin, o.view, o.path);
        return P != null && P.surface ? (mn.value = { plugin: o.plugin, view: o.view, surface: P.surface, path: o.path }, !0) : (Qe(C("plugin.view.error")), !1);
      } catch (P) {
        return Qe((P == null ? void 0 : P.message) || C("plugin.view.error")), !1;
      }
    }
    async function Hp(o, s) {
      if (!o || !(s != null && s.path)) return;
      mn.value = null;
      const g = s.path.indexOf("://"), P = g === -1 ? "" : s.path.slice(0, g), R = Fa(s.path).replace(/^\/+|\/+$/g, ""), j = R.lastIndexOf("/"), ue = j === -1 ? "" : R.slice(0, j), $e = wn.value && P ? ue ? `${P}/${ue}` : P : ue;
      try {
        await xt($e);
      } catch {
      }
      await Up({ plugin: o, action: s.action, view: s.view, path: s.path });
    }
    async function ET(o, s) {
      const g = s.indexOf("://"), P = g === -1 ? "" : s.slice(0, g), R = Fa(s).replace(/^\/+|\/+$/g, ""), j = R.lastIndexOf("/"), ue = j === -1 ? "" : R.slice(0, j), $e = wn.value && P ? ue ? `${P}/${ue}` : P : ue;
      await xt($e);
      const Ae = xe.value.find((st) => st.path === s);
      if (Ae) {
        Ke.click(Ae.path);
        return;
      }
      Qe(C("plugin.output_missing"));
    }
    const qr = $(/* @__PURE__ */ new Map()), Wr = $(!1), Dl = $(!1), Ll = $(null), Ug = $(0);
    function Hg(o) {
      return typeof o.id != "number" ? !1 : qr.value.get(o.id) ?? o.starred === !0;
    }
    function Kp(o, s) {
      const g = new Map(qr.value);
      g.set(o, s), qr.value = g;
    }
    const Kg = E(() => {
      const o = /* @__PURE__ */ new Set();
      for (const s of xe.value) Hg(s) && o.add(s.id);
      for (const [s, g] of qr.value) g && o.add(s);
      return o;
    });
    function Vg(o, s) {
      typeof o.id == "number" && Kp(o.id, s);
    }
    function Vp(o) {
      return is.value ? o.filter((s) => typeof s.id == "number" && s.type === "file") : [];
    }
    function jg(o) {
      const s = Vp(o);
      return s.length > 0 && s.every((g) => Hg(g));
    }
    async function qg(o) {
      const s = Vp(o);
      if (s.length === 0) return;
      const g = !jg(s), P = {
        apiBase: O.config.apiBase ?? "",
        authHeaders: () => Xn(),
        authCredentials: S.credentialsMode()
      };
      for (const j of s) Kp(j.id, g);
      let R = 0;
      await Promise.all(
        s.map(async (j) => {
          try {
            await s$(j.id, g, P);
          } catch {
            R += 1, Kp(j.id, !g);
          }
        })
      ), R > 0 && Qe(C("star.failed")), ft.value === "starred" && await Wl("starred");
    }
    async function Na(o) {
      if (typeof o.id == "number")
        try {
          const s = O.config.apiBase ?? "";
          await fetch(`${s}/api/files/manager/recent`, {
            method: "POST",
            headers: await Xn({ "Content-Type": "application/json" }),
            credentials: S.credentialsMode(),
            body: JSON.stringify({ node_id: o.id })
          }), Ug.value += 1;
        } catch {
        }
    }
    function CT(o) {
      typeof o.id == "number" && (Ll.value = o, Dl.value = !0);
    }
    function zT(o, s = "") {
      Dl.value = !1, ls(o, s);
    }
    function MT() {
      uh(), ft.value === "tag" && ln.value && ls(ln.value, kn.value);
    }
    const PT = h3(MT);
    Ot(PT);
    function OT(o) {
      const s = Wc(o) ?? {
        type: "file",
        path: o.path,
        basename: o.name,
        extension: (o.name.split(".").pop() || "").toLowerCase(),
        id: o.id
      };
      Wr.value = !1, Ha(s);
    }
    function DT(o, s) {
      const g = Wc(o);
      g && (Wr.value = !1, Oh(g, s));
    }
    const Wo = E(() => {
      var s, g, P;
      if (O.config.onlyOfficeBase) return O.config.onlyOfficeBase;
      const o = (g = (s = ee.value) == null ? void 0 : s.external) == null ? void 0 : g.onlyoffice;
      return o && !ev(o) ? null : ((P = ee.value) == null ? void 0 : P.onlyoffice_url) || null;
    }), ba = E(() => {
      var o;
      return ((o = ee.value) == null ? void 0 : o.caller_admin) === !0;
    });
    function Ic(o) {
      var s, g;
      return ((g = (s = ee.value) == null ? void 0 : s.queued) == null ? void 0 : g.includes(o)) === !0;
    }
    const Wg = E(() => Wo.value && S.endpoints.onlyOfficeConfig || null), Rl = E(() => {
      var g, P, R;
      const o = O.config.drawioUrl || O.config.drawioBase;
      if (o) return o;
      const s = (P = (g = ee.value) == null ? void 0 : g.external) == null ? void 0 : P.drawio;
      return s && !ev(s) ? null : ((R = ee.value) == null ? void 0 : R.drawio_url) || null;
    }), Yg = E(() => {
      var o;
      return ((o = ee.value) == null ? void 0 : o.newdoc_types) ?? null;
    }), LT = E(() => {
      const o = Yg.value;
      return !o || o.length === 0 ? !1 : o.some(
        (s) => s.requires === "onlyoffice" ? !!Wo.value : s.requires === "drawio" ? !!Rl.value : !0
      );
    }), Yo = E(() => {
      var o;
      return !!((o = ee.value) != null && o.drafts);
    }), Yr = $(0), jp = $([]), qp = $(0), Wp = $(!1), Go = $(null);
    async function Yp() {
      if (!Yo.value) {
        Yr.value = 0;
        return;
      }
      try {
        const { count: o, limit: s } = await S.drafts.count();
        Yr.value = o, qp.value = s;
      } catch {
      }
    }
    async function Gg() {
      Wp.value = !0;
      try {
        const o = await S.drafts.list();
        jp.value = o.drafts, qp.value = o.limit, Yr.value = o.count;
      } catch (o) {
        jp.value = [];
        const s = Gn(o);
        U("error", { message: s, context: { op: "nav-view:drafts" } }), Qe(s);
      } finally {
        Wp.value = !1;
      }
    }
    async function Nl() {
      ft.value === "drafts" ? await Gg() : await Yp();
    }
    Xe(Yo, (o) => void (o ? Yp() : Yr.value = 0), { immediate: !0 });
    function RT(o) {
      const s = o.lastIndexOf(".");
      return s > 0 ? o.slice(s + 1).toLowerCase() : "";
    }
    function Xg(o, s = null) {
      const g = {
        type: "file",
        path: o.path,
        basename: o.name,
        extension: RT(o.name),
        storage: o.storage,
        size: o.size,
        file_size: o.size,
        mime_type: o.mime ?? "",
        visibility: "private",
        extra_metadata: {}
      };
      if (Km(O.config, g) === "host") {
        U("file-opened", { path: g.path, basename: g.basename });
        return;
      }
      ts.value = o.type ? { path: g.path, ext: o.type } : null, gi.value = s, cn.value = g, Ia.value = "edit", oa.value = !0;
    }
    function Jg(o) {
      Qe(C("draft.saved_to", { name: o.name, folder: H0(o.targetDir) }));
    }
    const Gi = nee(() => Yo.value ? S.drafts : null, (o) => Gn(o));
    async function NT(o) {
      if (!Go.value) {
        Go.value = o.key;
        try {
          const s = await Gi.save(o);
          s && (Jg(s), await Nl());
        } catch (s) {
          Vt({ message: Gn(s) }, pn);
        } finally {
          Go.value = null;
        }
      }
    }
    async function IT(o) {
      if (!Go.value) {
        Go.value = o.key;
        try {
          await S.drafts.discard(o.key), Qe(C("draft.discarded", { name: o.name })), await Nl();
        } catch (s) {
          Vt({ message: Gn(s) }, pn);
        } finally {
          Go.value = null;
        }
      }
    }
    function BT(o) {
      Jg(o), Nl(), !ft.value && !At.value && xt();
    }
    function FT() {
      var s;
      const o = ((s = cn.value) == null ? void 0 : s.basename) ?? "";
      Qe(C("draft.discarded", { name: o })), Nl();
    }
    function UT() {
      Il.value = !1, Wl("drafts");
    }
    const Kn = $([]), Zg = $(null), ia = $(!1), Il = $(!1), Xi = $(!1), ua = $(!1), oa = $(!1), Bc = $(!1), Xo = $(!1), Gr = $(!1), Bl = $([]), go = $(null), Xr = $(""), Gp = $(!1), Jo = $(/* @__PURE__ */ new Set()), ki = $(""), Jr = $(!1), Zr = $(""), Zo = $(null), HT = E(() => {
      var o;
      return Bl.value.length !== 1 ? "archive" : ((o = Bl.value[0]) == null ? void 0 : o.basename.replace(/\.[^.]+$/, "")) || "archive";
    }), KT = ["zip", "7z", "tar", "tar.gz", "tar.bz2", "tar.xz"], Fl = E(() => {
      var s, g;
      return (((g = (s = ee.value) == null ? void 0 : s.archive) == null ? void 0 : g.allowed_formats) ?? []).filter((P) => KT.includes(P));
    }), VT = E(() => {
      var s, g;
      const o = (g = (s = ee.value) == null ? void 0 : s.archive) == null ? void 0 : g.default_format;
      return o && Fl.value.includes(o) ? o : Fl.value.includes("7z") ? "7z" : Fl.value[0] ?? "zip";
    }), jT = E(() => {
      var o, s;
      return ((s = (o = ee.value) == null ? void 0 : o.archive) == null ? void 0 : s.encryption) !== !1;
    }), qT = E(
      () => {
        var o;
        return (((o = go.value) == null ? void 0 : o.basename) || "archive").replace(/\.(tar\.(gz|bz2|xz)|zip|7z|rar|tgz|gz|bz2|xz)$/i, "") || "archive";
      }
    ), Qo = $(null), Qr = Vm(Xi), es = Vm(ia), ka = Vm(ua), { busy: WT, error: YT } = Qr, { busy: GT, error: XT } = es, { busy: JT, error: ZT } = ka, wi = $(!1), cn = $(null), Ia = $("edit"), ts = $(null), QT = E(
      () => {
        var o;
        return ts.value && ((o = cn.value) == null ? void 0 : o.path) === ts.value.path ? ts.value.ext : null;
      }
    );
    Xe(oa, (o) => {
      o || (ts.value = null), !o && Yo.value && cn.value && gw(cn.value.path) && Nl();
    });
    const ns = $(!1), _i = $(null), as = $(!1), Fc = $("move"), Uc = $([]), eA = E(() => (V.version.value, as.value, V.roots())), tA = E(() => {
      const o = Uc.value[0];
      return o ? V.rootOf(o.path) : null;
    }), Hc = $(!1), xi = $(
      (() => {
        try {
          return localStorage.getItem(J1) === "1";
        } catch {
          return !1;
        }
      })()
    );
    function Xp(o) {
      try {
        localStorage.setItem(J1, o ? "1" : "0");
      } catch {
      }
    }
    function Jp() {
      xi.value = !xi.value, Xp(xi.value);
    }
    function nA() {
      xi.value || (xi.value = !0, Xp(!0));
    }
    function Qg() {
      xi.value && (xi.value = !1, Xp(!1));
    }
    const aA = E(() => CL(O.config.uiProfile)), Ul = E(() => aA.value === "simple"), eb = E(() => O.config.showInfoPanel !== !1), Hl = $(
      (() => {
        try {
          const o = localStorage.getItem(Z1);
          if (o === "1") return !0;
          if (o === "0") return !1;
        } catch {
        }
        return !0;
      })()
    );
    function iA(o) {
      try {
        localStorage.setItem(Z1, o ? "1" : "0");
      } catch {
      }
    }
    const er = $(!1), Kl = E(() => O.config.sideNav ?? !Ve), Zp = E(
      () => Kl.value && (Pa.value ? er.value : !0)
    ), tb = E(
      () => Kl.value && O.config.trashVisible !== !1
    ), oA = E(
      () => Pa.value ? er.value : Hl.value
    );
    function nb() {
      if (Kl.value) {
        if (Pa.value) {
          er.value = !er.value;
          return;
        }
        Hl.value = !Hl.value, iA(Hl.value);
      }
    }
    function bo() {
      er.value = !1;
    }
    const Qp = $([]), rA = E(() => O.config.connections ?? !Ul.value), sA = E(() => O.config.mySharesVisible === !0), Kc = E(
      () => {
        var o;
        return (O.config.callerKind ?? ((o = ee.value) == null ? void 0 : o.caller_kind)) === "app";
      }
    ), is = E(() => !Kc.value), eh = $(!1);
    let ab = 0;
    Xe(
      () => [O.config.appStorePage === !0, Kc.value],
      async ([o, s]) => {
        const g = ++ab;
        if (!Bx(o, s)) {
          eh.value = !1;
          return;
        }
        const P = await S.appStoreStatus();
        g === ab && (eh.value = S_(o, s, P));
      },
      { immediate: !0 }
    );
    const lA = E(() => S_(O.config.appStorePage === !0, Kc.value, { visible: eh.value })), os = $(!1), Vl = $(!1);
    function uA() {
      Vl.value = !1, os.value = !0;
    }
    function cA() {
      Kc.value || (os.value = !1, Vl.value = !0);
    }
    function Vc() {
      os.value = !1, Vl.value = !1;
    }
    const dA = E(() => os.value || Vl.value);
    function fA(o) {
      const s = o instanceof Error ? o.message : String(o);
      U("error", { message: s, context: { op: "connections" } }), Qe(s);
    }
    const th = E(
      () => Ul.value ? ["list", "grid"] : void 0
    );
    bz(() => {
      Ul.value && ve.value === "gallery" && (ve.value = "grid");
    });
    const rs = $({ ...Ro }), ss = $(null), jc = $("name"), pA = E(
      () => _e.value || Ln.value ? "relevance" : "sort"
    );
    function hA() {
      ss.value = null, ib({ ...Ro });
    }
    function ib(o) {
      rs.value = o, Ke.clear();
    }
    Xe(
      () => `${De.value}|${ft.value}`,
      () => {
        Hs(rs.value) && (rs.value = { ...Ro }), _e.value || (ss.value = null);
      }
    );
    const jl = $(!1), ob = $([]);
    Xe(jl, async (o) => {
      o && (ob.value = await Gw({
        apiBase: O.config.apiBase ?? "",
        authHeaders: () => Xn(),
        authCredentials: S.credentialsMode()
      }));
    });
    const rb = $(""), mA = E(() => !0);
    function nh(o = ss.value) {
      return oW(o ?? Ro, Date.now(), { showHidden: Iu.value });
    }
    const sb = $(!1);
    async function lb(o, s, g, P = nh()) {
      var ue;
      if (o === "name") {
        const $e = await Gk(g, s), Ae = $e ?? await S.search(g, s, P);
        return {
          rows: yr(await Ut.decorate(Ae.files, { root: Ae.e2e_root || null })),
          truncated: Lm(Ae.files.length, Wd, Ae.truncated),
          local: !!$e
        };
      }
      const R = await S.globalSearchPage(s, { limit: Q1, scope: o, narrow: P }), j = kt.value || ((ue = (O.config.storages ?? [])[0]) == null ? void 0 : ue.name) || "";
      return {
        rows: yr(await Ut.decorate(R.hits.map(($e) => gf($e, j)))),
        truncated: Lm(R.hits.length, Q1, R.truncated),
        local: !1
      };
    }
    function vA() {
      const o = De.value ?? "";
      return wn.value ? ad(o) : Nt(o);
    }
    async function yA(o) {
      const s = Yv(o), { rows: g, truncated: P, local: R } = await lb(o.scope, s, vA(), nh(o.filters));
      return {
        count: (R && Hs(o.filters) ? Pv(g, o.filters) : g).length,
        capped: P
      };
    }
    function gA(o) {
      rb.value = Nt(De.value ?? "") || "", ub.value = o, jl.value = !0;
    }
    const ub = $("");
    function bA(o) {
      jl.value = !1, jc.value = o.scope, ss.value = Hs(o.filters) ? { ...o.filters } : null;
      const s = Yv(o);
      s === _e.value ? xt() : _e.value = s;
    }
    function kA(o) {
      ss.value = null, jc.value = "name", ft.value !== "home" && (_e.value = o);
    }
    const cb = E(() => {
      if (ft.value || pe.value) return "";
      const o = kt.value;
      if (!o) return "";
      const s = (O.config.storages ?? []).find((g) => g.name === o);
      return (s == null ? void 0 : s.label) || o;
    }), ah = $("");
    function wA(o) {
      ah.value = o, cd.value = !0;
    }
    const qc = $(void 0);
    function _A() {
      const o = Nt(De.value);
      if (!o || !Tb.value) return;
      const s = De.value.split("/").filter(Boolean);
      _i.value = {
        path: o,
        basename: s.length ? s[s.length - 1] : kt.value,
        type: "dir"
      }, qc.value = "drop", ns.value = !0;
    }
    function xA(o) {
      U("share-created", { path: o.path, url: o.url, pin: null }), Qe(C("inspector.copied"));
    }
    const ih = $(null), db = $(null), SA = E(() => RW(ih.value, sh.value, db.value));
    async function fb() {
      if (!is.value) {
        ih.value = null;
        return;
      }
      const o = await S.quotaMe();
      ih.value = o, db.value = LW(o, sh.value) ? await S.storageUsage() : null;
    }
    function Wc(o) {
      return iQ(o, {
        storages: O.config.storages ?? [],
        multiStorageRoot: wn.value
      });
    }
    const Ji = $(null), ql = $(!1), Yc = E(() => {
      if (!Ln.value) return "";
      const o = In.value;
      if (!o || !Av(o)) return "";
      const s = xx(o);
      return s != null && s.k ? `${s.d === "desc" ? "-" : ""}${s.k}` : "";
    });
    Xe(Yc, (o, s) => {
      o === s || !Ln.value || (ft.value === "tag" && ln.value ? ls(ln.value, kn.value) : (ft.value === "recent" || ft.value === "starred" || ft.value === "shared") && Wl(ft.value));
    });
    async function Gc(o, s = 0) {
      const g = O.config.apiBase ?? "", P = new URLSearchParams({ limit: String(Su), offset: String(s) });
      Yc.value && P.set("sort", Yc.value);
      const R = o === "shared" ? `${g}/api/files/manager/shared-with-me?${P}` : o === "starred" ? `${g}/api/files/manager/star/list?${P}` : `${g}/api/files/manager/recent?${P}`, j = await fetch(R, {
        headers: await Xn(),
        // ⚠ NOT 'include' — with a bearer token this is cross-origin for every
        // embedder serving the UI from another origin (the desktop app): a credentialed
        // cross-origin request cannot be answered with `ACAO: *`.
        credentials: S.credentialsMode()
      });
      if (!j.ok) throw new Error(String(j.status));
      const ue = await j.json(), $e = (st) => ({
        rows: st,
        total: typeof (ue == null ? void 0 : ue.total) == "number" ? ue.total : s + st.length,
        truncated: (ue == null ? void 0 : ue.truncated) === !0
      });
      if (o === "shared")
        return Qp.value = Array.isArray(ue == null ? void 0 : ue.storages) ? ue.storages : [], $e(await Ut.decorate(Array.isArray(ue == null ? void 0 : ue.files) ? ue.files : []));
      const Ae = Array.isArray(ue == null ? void 0 : ue.nodes) ? ue.nodes : [];
      return $e(await Ut.decorate(Ae.map(Wc).filter((st) => st !== null)));
    }
    async function $A() {
      const o = Ji.value;
      if (!o || !o.truncated || ql.value) return;
      ql.value = !0;
      const s = De.value;
      try {
        const g = o.kind === "tag" ? await vb(ln.value, kn.value, o.next) : await Gc(o.kind, o.next);
        if (De.value !== s) return;
        xe.value = [...xe.value, ...g.rows], Ji.value = { kind: o.kind, total: g.total, truncated: g.truncated, next: o.next + Su };
      } catch (g) {
        Qe(g instanceof Error ? g.message : String(g));
      } finally {
        ql.value = !1;
      }
    }
    const pb = $([]), hb = $([]), oh = $(!1), mb = WH(), rh = E(() => HH(O.config.storages ?? [], mb.saved.value));
    function TA(o) {
      qH(o, rh.value);
    }
    const sh = E(
      () => rh.value.map(
        (o) => o.usedPartial !== void 0 || !(o.name in ht.value) ? o : { ...o, usedPartial: ht.value[o.name] !== null }
      )
    );
    async function AA() {
      oh.value = !0;
      try {
        const [o, s] = await Promise.all([
          Gc("recent").then((g) => g.rows).catch(() => []),
          Gc("starred").then((g) => g.rows).catch(() => [])
        ]);
        pb.value = o, hb.value = s;
      } finally {
        oh.value = !1;
      }
    }
    async function Wl(o) {
      bo();
      const s = mt.view();
      if (o === "home") {
        ft.value || (Dn.value = De.value ?? ""), ft.value = "home", ln.value = "", kn.value = "", At.value = !1, Et.value = "", Xc(), Ke.clear(), xe.value = [], Tt.value = Mn.home, De.value = Mn.home, kt.value = "", await AA();
        return;
      }
      if (o === "tag") {
        ln.value && await ls(ln.value, kn.value);
        return;
      }
      if (o === "drafts") {
        ft.value || (Dn.value = De.value ?? ""), ft.value = "drafts", ln.value = "", kn.value = "", At.value = !1, Et.value = "", Xc(), Ke.clear(), xe.value = [], Tt.value = Mn.drafts, De.value = Mn.drafts, kt.value = "", await Gg();
        return;
      }
      if (o === "trash") {
        HA(), await $i(), ft.value = "trash", ln.value = "", kn.value = "";
        return;
      }
      be.value = !0, ft.value || (Dn.value = De.value ?? ""), ft.value = o, ln.value = "", kn.value = "", At.value = !1, Et.value = "", Xc(), Ke.clear(), Tt.value = Mn[o], De.value = Mn[o], Ji.value = null;
      try {
        const g = await Gc(o);
        if (!$t(s)) return;
        xe.value = g.rows, Ji.value = { kind: o, total: g.total, truncated: g.truncated, next: Su }, kt.value = "";
      } catch (g) {
        if (!$t(s)) return;
        const P = g instanceof Error ? g.message : String(g);
        xe.value = [], U("error", { message: P, context: { op: `nav-view:${o}` } }), Qe(P);
      } finally {
        $t(s) && (be.value = !1);
      }
    }
    async function vb(o, s, g) {
      const P = await v3(
        o,
        {
          apiBase: O.config.apiBase ?? "",
          authHeaders: () => Xn(),
          authCredentials: S.credentialsMode()
        },
        { limit: Su, offset: g, kind: s, sort: Yc.value }
      );
      return { rows: await Ut.decorate(P.rows.map(Wc).filter((j) => j !== null)), total: P.total, truncated: P.truncated };
    }
    async function ls(o, s = "") {
      bo();
      const g = String(o ?? "").trim();
      if (!g) return;
      const P = mt.view();
      be.value = !0, ft.value || (Dn.value = De.value ?? ""), ft.value = "tag", ln.value = g, kn.value = s, At.value = !1, Et.value = "", Xc(), Ke.clear();
      const R = GD(g, s);
      Tt.value = R, De.value = R, Ji.value = null;
      try {
        const j = await vb(g, s, 0);
        if (!$t(P)) return;
        xe.value = j.rows, Ji.value = { kind: "tag", total: j.total, truncated: j.truncated, next: Su }, kt.value = "";
      } catch (j) {
        if (!$t(P)) return;
        const ue = j instanceof Error ? j.message : String(j);
        xe.value = [], U("error", { message: ue, context: { op: `nav-view:tag:${s ? `${s}:` : ""}${g}` } }), Qe(ue);
      } finally {
        $t(P) && (be.value = !1);
      }
    }
    const yb = $([]), lh = $(!1);
    async function uh(o = !1) {
      Zp.value && (yb.value = await Gw({
        apiBase: O.config.apiBase ?? "",
        authHeaders: () => Xn(),
        authCredentials: S.credentialsMode(),
        force: o
      }), lh.value = !0);
    }
    function EA(o) {
      if (o === "myfiles") {
        bo(), xt("");
        return;
      }
      Wl(o);
    }
    function gb(o) {
      bo(), xt(wn.value ? o : "");
    }
    async function CA() {
      try {
        const o = O.config.apiBase ?? "", s = await fetch(`${o}/api/files/manager/shared-with-me?limit=1`, {
          headers: await Xn(),
          credentials: S.credentialsMode()
        });
        if (!s.ok) return;
        const g = await s.json();
        Qp.value = Array.isArray(g == null ? void 0 : g.storages) ? g.storages : [];
      } catch {
      }
    }
    function ch(o) {
      const s = (o ?? "").replace(/^\/+|\/+$/g, "");
      if (!s) return wn.value ? C("breadcrumb.root") : kt.value || C("breadcrumb.root");
      const g = s.split("/").pop() || s, P = Nf(g, C);
      return P || (Ut.segmentLabel(Nt(s)) ?? g);
    }
    function zA(o) {
      _i.value = o, ns.value = !0;
    }
    function Yl(o) {
      return fe.value ? !1 : o === void 0 || o === "editor" || o === "owner";
    }
    function Xc() {
      Ne.value = "", fe.value = !1;
    }
    const MA = E(() => !!ft.value && ft.value !== "trash");
    function dh(o) {
      return typeof o.perm == "string" ? o.perm : lQ(MA.value, Ne.value);
    }
    function bb(o) {
      if (o.read_only === !0) return !0;
      const s = typeof o.storage == "string" ? o.storage : "";
      return s ? (O.config.storages ?? []).some((g) => g.name === s && g.readOnly === !0) : !1;
    }
    function Zi(o) {
      return Yl(dh(o)) && !bb(o);
    }
    const kb = { none: 0, viewer: 1, editor: 2, owner: 3 };
    function PA(o) {
      if (o.length === 0) return Ne.value;
      let s, g = !1;
      for (const P of o) {
        const R = dh(P);
        if (R === void 0) {
          g = !0;
          continue;
        }
        (s === void 0 || (kb[R] ?? 0) < (kb[s] ?? 0)) && (s = R);
      }
      return s ?? (g ? void 0 : Ne.value);
    }
    function wb(o) {
      return o.some(bb);
    }
    const Gl = _W(), Ma = OW();
    Ot(() => Ma.dispose());
    function fh() {
      var s;
      const o = (s = ee.value) == null ? void 0 : s.e2e_policy;
      return {
        p: [...G.value ?? []].sort().join(","),
        e: o ? `${o.available}|${o.policy}` : ""
      };
    }
    async function OA() {
      var P, R, j;
      if (await Promise.all([Oe(), Y]), !((P = ee.value) != null && P.e2e_policy) && !((R = G.value) != null && R.length)) return;
      let o;
      try {
        o = (j = await St()) == null ? void 0 : j.user;
      } catch {
        o = null;
      }
      const s = _a(O.config) || (typeof location < "u" ? location.origin : ""), g = o && typeof o.id == "number" ? [s, o.id, o.provider_id ?? "", Te].join("|") : null;
      Ma.attach(g, fh()), mh();
    }
    Wt(() => void OA());
    const Jc = $({}), Zc = /* @__PURE__ */ new Set();
    let ph = 0;
    Xe(
      () => [I.value, G.value],
      () => {
        ph++, Zc.clear(), Jc.value = {}, Ma.sign("p", fh().p);
      }
    );
    function _b(o) {
      const s = G.value;
      if (!(s != null && s.length)) return;
      const g = o.filter(($e) => !Ma.fresh("p", $e) && !Zc.has($e));
      if (!g.length) return;
      g.forEach(($e) => Zc.add($e));
      const P = [...s], R = ph, j = ($e, Ae) => {
        if (R !== ph) return;
        const st = { ...Jc.value };
        g.forEach((Ze, Dt) => {
          st[Ze] = $e[Dt] ?? [], Ma.put("p", Ze, st[Ze], Ae), Zc.delete(Ze);
        }), Jc.value = st;
      }, ue = g.some(($e) => xb($e) === void 0) ? Gl.start() : () => {
      };
      S.allowedAt(g, P).then(
        ($e) => j($e, !0),
        () => j(g.map(() => P), !1)
      ).finally(ue);
    }
    function xb(o) {
      return Jc.value[o] ?? Ma.peek("p", o);
    }
    function Xl(o, s) {
      var P;
      const g = [...new Set(s.map(ce))];
      return !I.value || !g.length || !((P = G.value) != null && P.includes(o)) ? nu(o) : (_b(g), g.every((R) => {
        var j;
        return ((j = xb(R)) == null ? void 0 : j.includes(o)) ?? !1;
      }));
    }
    const Qc = $({}), ed = /* @__PURE__ */ new Set();
    let hh = 0;
    function DA() {
      hh++, ed.clear(), Qc.value = {}, Ma.sign("e", fh().e);
    }
    Xe(
      () => {
        var o, s, g, P;
        return [
          I.value,
          G.value,
          (s = (o = ee.value) == null ? void 0 : o.e2e_policy) == null ? void 0 : s.available,
          (P = (g = ee.value) == null ? void 0 : g.e2e_policy) == null ? void 0 : P.policy
        ];
      },
      DA
    );
    function Jl(o, s) {
      return `${s}:${o}`;
    }
    async function Sb(o) {
      const s = o.filter((ue) => {
        const $e = Jl(ue.path, ue.kind);
        return !Ma.fresh(`e:${ue.kind}`, ue.path) && !ed.has($e);
      });
      if (!s.length) return;
      for (const ue of s) ed.add(Jl(ue.path, ue.kind));
      const g = hh, R = s.some((ue) => $b(ue.path, ue.kind) === void 0) ? Gl.start() : () => {
      };
      let j = !1;
      try {
        const ue = await S.e2eAllowedAt(s, {
          onFailed: () => {
            j = !0;
          }
        });
        if (g !== hh) return;
        const $e = { ...Qc.value };
        s.forEach((Ae, st) => {
          const Ze = Jl(Ae.path, Ae.kind);
          $e[Ze] = ue[st] ?? "allowed", Ma.put(`e:${Ae.kind}`, Ae.path, $e[Ze], !j), ed.delete(Ze);
        }), Qc.value = $e;
      } finally {
        R();
      }
    }
    function $b(o, s) {
      return Qc.value[Jl(o, s)] ?? Ma.peek(`e:${s}`, o);
    }
    function mh() {
      var ue, $e;
      if (At.value || ft.value || Se.value || Z.value) return;
      const o = Nt(De.value ?? "");
      if (!o.includes("://") || V.rootOf(o)) return;
      const s = !!((ue = ee.value) != null && ue.e2e_policy) && !Qt.value, g = !!I.value && !!(($e = G.value) != null && $e.length);
      if (!s && !g) return;
      const P = /* @__PURE__ */ new Set(), R = /* @__PURE__ */ new Map(), j = (Ae, st) => {
        if (Ae === "p")
          g && P.add(st);
        else if (s) {
          const Ze = Ae.slice(2);
          R.set(Jl(st, Ze), { path: st, kind: Ze });
        }
      };
      j("p", o), j("e:new_folder", o);
      for (const Ae of xe.value.slice(0, Uae))
        !Ae || typeof Ae.path != "string" || !Ae.path.includes("://") || qu(Ae) || V.isVaultRow(Ae) || (j("p", Ae.path), !(!Zi(Ae) || Ae.e2e || Ae.e2e_root) && (Ae.type === "dir" ? j("e:folder", Ae.path) : Ri(Ae) || j("e:file", Ae.path)));
      for (const Ae of Ma.around(o)) j(Ae.q, Ae.path);
      P.size && _b([...P].slice(0, 1e3)), R.size && Sb([...R.values()].slice(0, 1e3));
    }
    let us = null;
    function LA(o) {
      if (Ma.stale(), o.resync) {
        mh();
        return;
      }
      us || (us = setTimeout(
        () => {
          us = null, ie(), xt();
        },
        o.all ? Math.random() * Hae : 0
      ));
    }
    Ot(() => {
      us && clearTimeout(us), us = null;
    });
    function vh(o, s) {
      var R;
      const g = ce(o);
      return ((R = ee.value) == null ? void 0 : R.e2e_policy) ? (Sb([{ path: g, kind: s }]), $b(g, s) ?? "denied") : "allowed";
    }
    const ni = E(
      () => Yl(Ne.value) && Xl("files.create", De.value ? [Nt(De.value)] : [])
    ), td = E(
      () => ni.value && !pe.value && !At.value
    ), Tb = E(
      () => vd(De.value ? [Nt(De.value)] : []).uploadLinks
    ), RA = E(
      () => _i.value && I.value ? vd([_i.value.path]) : void 0
    ), yh = $(null), xn = $(null), Ab = $(null), Pa = $(!1), Eb = $(!1);
    let cs, ai;
    function gh(o) {
      Eb.value = !!(o && "matches" in o && o.matches);
    }
    Wt(() => {
      var o;
      typeof ResizeObserver < "u" && xn.value && (cs = new ResizeObserver((s) => {
        var P, R, j;
        const g = ((R = (P = s[0]) == null ? void 0 : P.contentRect) == null ? void 0 : R.width) ?? ((j = xn.value) == null ? void 0 : j.clientWidth) ?? 0;
        Pa.value = g > 0 && g < 560;
      }), cs.observe(xn.value)), typeof window < "u" && window.matchMedia && (ai = window.matchMedia("(pointer: coarse)"), gh(ai), (o = ai.addEventListener) == null || o.call(ai, "change", gh));
    }), Ot(() => {
      var o;
      cs == null || cs.disconnect(), cs = void 0, (o = ai == null ? void 0 : ai.removeEventListener) == null || o.call(ai, "change", gh), ai = void 0;
    });
    const ca = $(null);
    let Ba, ds = null;
    function Vt(o, s) {
      ca.value = o, Ba && clearTimeout(Ba), Ba = setTimeout(Cb, s);
    }
    function Qe(o) {
      Vt({ message: o }, li);
    }
    function Cb() {
      Ba = void 0, ca.value = null;
      const o = ds;
      ds = null, o && Vt({ message: o.message, source: "drag-out" }, o.ms);
    }
    Ot(() => {
      Ba && clearTimeout(Ba), Ba = void 0, ds = null;
    });
    const Si = E(() => {
      if (ft.value || Bt.value || Se.value) return null;
      const o = !!_e.value, s = Fa(Tt.value).replace(/^\/+|\/+$/g, "") === "";
      return kW({
        map: ht.value,
        adapter: kt.value,
        searching: o,
        crossStorage: o && s && Object.keys(ht.value).length > 1,
        admin: ba.value
      });
    });
    async function NA(o) {
      if (!o || Lt(o)) return;
      jt.value = { ...jt.value, [o]: 0 };
      const s = () => {
        const { [o]: R, ...j } = jt.value;
        jt.value = j;
      };
      let g;
      try {
        const R = _a(O.config), j = await S.jsonFetch(`${R}/api/admin/storages`), ue = Array.isArray(j) ? j.find((Ae) => Ae.name === o) : void 0;
        if (!ue) throw new Error("no such storage");
        const $e = await S.jsonFetch(`${R}/api/admin/storages/${ue.id}/sync`, { method: "POST" });
        g = ue.id, jt.value = { ...jt.value, [o]: g }, Qe(($e == null ? void 0 : $e.status) === "running" ? C("coverage.catalog_joined", { storage: o }) : C("coverage.catalog_started"));
      } catch (R) {
        s(), Vt({ message: Gn(R) }, pn);
        return;
      }
      const P = await Cn().scan(g);
      s(), P !== null && (P.status === "ok" ? (Qe(C("coverage.catalog_done", { storage: o })), await xt()) : P.status === "failed" ? Vt({ message: C("coverage.catalog_failed", { storage: o }) }, pn) : P.status === "aborted" ? Vt({ message: C("coverage.catalog_stopped", { storage: o }) }, pn) : P.status === "gone" ? Vt({ message: C("coverage.catalog_gone", { storage: o }) }, pn) : Vt({ message: C("coverage.catalog_unfollowed", { storage: o }) }, pn));
    }
    function nd(o, s) {
      Vt({ message: o, actionLabel: C("toast.undo"), action: s, after: { kind: "undo" } }, 8e3);
    }
    function bh() {
      Ba && clearTimeout(Ba), Cb();
    }
    async function IA() {
      const o = ca.value, s = o == null ? void 0 : o.action;
      if (Ba && clearTimeout(Ba), Ba = void 0, ca.value = null, !o || !s) return;
      const g = o.after ?? { kind: "undo" }, P = g.kind === "plain", R = P && o.source ? "drag-out-stopping" : void 0;
      Vt({ message: V1(g, "running", void 0, C), source: R }, Yd);
      try {
        const j = await s();
        Vt({ message: V1(g, "done", j, C), source: R }, li), P || await xt();
      } catch (j) {
        P ? Vt({ message: Gn(j) }, pn) : Qe(C("toast.undo_failed"));
      }
    }
    const wn = E(() => O.config.multiStorageRoot === !0);
    function BA(o) {
      const s = o.replace(/^\/+|\/+$/g, "");
      if (!s) return { adapter: "", rel: "" };
      const g = s.indexOf("/");
      return g === -1 ? { adapter: s, rel: "" } : { adapter: s.slice(0, g), rel: s.slice(g + 1) };
    }
    function ad(o) {
      if (o.includes("://")) return o;
      const { adapter: s, rel: g } = BA(o);
      return s ? g ? `${s}://${g}` : `${s}://` : "";
    }
    function ko(o) {
      const s = o.indexOf("://");
      if (s === -1) return o.replace(/^\/+|\/+$/g, "");
      const g = o.slice(0, s), P = o.slice(s + 3).replace(/^\/+|\/+$/g, "");
      return P ? `${g}/${P}` : g;
    }
    function zb() {
      return (O.config.storages ?? []).map((s) => ({
        type: "dir",
        path: s.name,
        // virtual path (no adapter prefix)
        basename: s.label || s.name,
        extension: "",
        storage: s.name,
        visibility: "private",
        file_size: 0,
        mime_type: "inode/storage",
        extra_metadata: { driver: s.driver, readOnly: s.readOnly }
      }));
    }
    function Mb() {
      var o;
      VD(!Iu.value), xt(), (o = Xt.value) == null || o.reload();
    }
    function Pb() {
      xt(), fb(), U("refresh");
    }
    function xt(o) {
      return mt.follow(() => FA(o));
    }
    async function FA(o) {
      var $e;
      Ee.value = !1;
      const { ticket: s, want: g } = mt.begin(o, De.value ?? "");
      Be.connected.value || Ma.stale();
      const P = Hn(g);
      if (P) {
        if (!(P.kind === "trash" ? O.config.trashVisible !== !1 : Kl.value))
          return xh(""), await xt("");
        P.kind === "tag" ? await ls(P.tag, P.tagKind) : await Wl(P.kind);
        return;
      }
      const R = String(De.value ?? "").replace(/^\/+|\/+$/g, ""), j = (Ae) => {
        String(Ae ?? "").replace(/^\/+|\/+$/g, "") !== R && (Ke.clear(), He.value = []);
      };
      be.value = !0, At.value = !1, ft.value = "", ln.value = "", kn.value = "";
      let ue = g;
      mt.going(g);
      try {
        if (Se.value = "", Z.value = "", Te) {
          const fn = String(ue).replace(/^\/+|\/+$/g, "");
          (!fn || !(fn === Te || fn.startsWith(Te + "/"))) && (ue = Te);
        }
        if (wn.value && !ad(ue)) {
          if (rn.value) return await xt(rn.value);
          j(""), De.value = "", kt.value = "", Tt.value = "", Et.value = "", xe.value = zb();
          return;
        }
        const Ae = wn.value ? ad(ue) : Nt(ue), st = V.rootOf(Ae);
        if (st) {
          const fn = String(Ae).replace(/\/+$/, "");
          if (V.isOpen(st)) {
            const _n = V.rows(fn) ? fn : st, Li = _e.value ? V.search(_n, _e.value) : V.rows(_n);
            if (!$t(s)) return;
            V.touch(_n), Ee.value = !1, kt.value = _n.slice(0, _n.indexOf("://")), Tt.value = _n, Ne.value = V.permOf(st) || "", fe.value = !!(($e = V.strips[st]) != null && $e.readOnly), Et.value = st;
            const ja = zi(_n);
            j(ja), xe.value = yr(Li ?? []), De.value = ja;
            return;
          }
          if (fn !== st) return await xt(zi(st));
        }
        const Dt = !!_e.value && jc.value !== "name" ? await lb(jc.value, _e.value, Ae) : null;
        let Sn = !1;
        const Ct = Dt ? {
          adapter: kt.value,
          storages: (O.config.storages ?? []).map((fn) => fn.name),
          dirname: Tt.value,
          read_only: !1,
          files: Dt.rows,
          truncated: Dt.truncated
        } : _e.value ? await (async () => {
          const fn = await Gk(Ae, _e.value);
          return Sn = !!fn, fn ?? await S.search(Ae, _e.value, nh());
        })() : await S.index(Ae);
        if (!Dt && !_e.value && typeof Ct.e2e_vault_root == "string" && Ct.e2e_vault_root) {
          const fn = Ct.e2e_vault_root.replace(/\/+$/, "");
          if (String(Ct.dirname ?? "").replace(/\/+$/, "") !== fn)
            return $t(s) ? await xt(zi(fn)) : void 0;
          Ct.files = [];
        }
        if (Ct.files = await Ut.decorate(Ct.files, {
          root: typeof Ct.e2e_root == "string" && Ct.e2e_root ? Ct.e2e_root : null
        }), !$t(s)) return;
        Ct.files = sQ(Ct.files, Ct.perm), Ee.value = !!_e.value && Lm(Ct.files.length, Wd, Ct.truncated), sb.value = !!_e.value && (Dt ? Dt.local : Sn), Array.isArray(Ct.storage_info) && (ht.value = bW(Ct.storage_info)), kt.value = Ct.adapter, Tt.value = Ct.dirname, Ne.value = Ct.perm || "", fe.value = Ct.read_only === !0, Et.value = typeof Ct.e2e_root == "string" ? Ct.e2e_root : "";
        {
          const fn = String(Ct.dirname ?? "").replace(/\/+$/, ""), _n = typeof Ct.e2e_root == "string" ? Ct.e2e_root.replace(/\/+$/, "") : "";
          V.rootOf(fn) === fn && _n !== fn && V.forget(fn);
        }
        const Va = wn.value ? ko(Ct.dirname) : Fa(Ct.dirname);
        j(Va), xe.value = yr(Ct.files), fx(xe.value, Ct.adapter, Ct.dirname, O.config.trashVisible !== !1, {
          isSearchResult: !!_e.value,
          navOffersTrash: tb.value
        }) && px(xe.value, Ct.adapter, S), De.value = Va, mh();
      } catch (Ae) {
        if (!$t(s)) return;
        const st = Ae instanceof Error ? Ae.message : String(Ae), Ze = Ae.status;
        if (Ze === 404 || Ze === 403) {
          Se.value = String(ue), j(String(ue)), Et.value = "", xe.value = [], U("error", { message: st, context: { path: o } });
          return;
        }
        Z.value = st, ge = typeof ue == "string" ? ue : void 0, U("error", { message: st, context: { path: o } }), xe.value.length > 0 && Qe(st);
      } finally {
        $t(s) && (be.value = !1), mt.end(s);
      }
    }
    function Fa(o) {
      const s = o.indexOf("://");
      return s === -1 ? o : o.slice(s + 3);
    }
    function UA() {
      Se.value = "", xh(""), xt("");
    }
    const id = $(null), wo = $(!1), od = $(!1), Zl = $(!1), kh = $(null);
    let Ob = !1;
    Ot(() => {
      Ob = !0, tn == null || tn.stop();
    });
    async function HA() {
      try {
        const o = await fetch(`${O.config.apiBase ?? ""}/api/admin/protection`, {
          headers: await Xn(),
          credentials: S.credentialsMode()
        });
        if (!o.ok) {
          id.value = null, wo.value = !1;
          return;
        }
        const s = await o.json(), g = s == null ? void 0 : s.trash_retention_days;
        id.value = typeof g == "number" && g > 0 ? g : null, wo.value = !0;
      } catch {
      }
    }
    const KA = E(
      () => id.value !== null ? C("trash.retention", { days: id.value }) : C("trash.retention_unknown")
    ), fs = $(null), rd = $("");
    let wh = 0;
    async function VA() {
      fs.value = null, rd.value = "", Zl.value = !0;
      const o = ++wh;
      try {
        const s = await S.trashEmptyPreview();
        o === wh && (fs.value = s);
      } catch (s) {
        o === wh && (rd.value = Er(s, q.value));
      }
    }
    const Db = E(() => {
      const o = kh.value;
      return o != null && o.running ? o.summary ?? "" : "";
    });
    async function jA() {
      if (Zl.value = !1, !wo.value || od.value) return;
      const o = S.endpoints.trashEmpty;
      if (o) {
        od.value = !0;
        try {
          const s = await dQ({
            start: async () => fetch(S.withScreenLang(o), {
              method: "POST",
              headers: await Xn(),
              credentials: S.credentialsMode()
            }),
            status: async () => fetch(S.withScreenLang(o), { headers: await Xn(), credentials: S.credentialsMode() }),
            locale: q.value,
            /* The run is an ops row: it goes into the operations centre (progress,
             * Cancel) the moment the server names it — a run done within the wait
             * as well, like any other operation the person started. */
            onStart: (g) => {
              g.op_id && Me.register({
                id: g.op_id,
                kind: "trash-empty",
                status: g.running ? g.queued ? "pending" : "running" : g.cancelled ? "cancelled" : "ok",
                total: g.total ?? 0,
                done: g.scanned ?? 0
              });
            },
            onProgress: (g) => {
              kh.value = g;
            },
            onBusy: (g) => {
              g && Qe(g);
            },
            stopped: () => Ob
          });
          if (s === null || (At.value && await $i(), !s.started_at || !s.summary)) return;
          Vt({ message: s.summary }, s.error || s.failed ? pn : li);
        } catch (s) {
          if (s instanceof O$) {
            Qe(s.message);
            return;
          }
          const g = Er(s, q.value);
          U("error", { message: (s == null ? void 0 : s.message) ?? String(s), context: { op: "trash:empty" } }), Qe(g);
        } finally {
          kh.value = null, od.value = !1;
        }
      }
    }
    const ps = $(0), _o = $(0), sd = $(""), ld = $(!1), qA = E(() => {
      const o = new Intl.NumberFormat(fi(q.value));
      return C("trash.shown_of", { shown: o.format(_o.value), total: o.format(ps.value) });
    });
    function Lb(o) {
      return o.map(
        (s) => ({
          type: "file",
          id: s.id,
          /* Which storage's trash it is in: a permanent delete is one job per
             storage, and each job's rows are the ones it deletes. */
          storage_id: s.storage_id,
          /* ⚠ The ORIGINAL path, which the server sends with its leading
             slash: `depo:///x.txt` put an empty segment in the Location
             column ("depo/"), so it is dropped here. */
          path: s.storage_name ? `${s.storage_name}://${s.path.replace(/^\/+/, "")}` : s.path,
          basename: s.name,
          extension: s.name.includes(".") && s.name.split(".").pop() || "",
          storage: s.storage_name || "",
          visibility: "private",
          /* tablo:t1 — ⚠ BOTH. Every view reads `size` (the Size column, the
             info panel); only the upload code reads `file_size`. Setting one of
             the two left every trashed row with a blank Size cell. */
          size: s.size,
          file_size: s.size,
          mime_type: s.mime || "",
          /* The date the Trash's date column prints and sorts by — WHEN it was
             deleted. A trashed row has no modification date to show, and the
             column read "—" for every row. */
          last_modified: Date.parse(s.deleted_at) || void 0,
          extra_metadata: {
            deleted_at: s.deleted_at,
            ttl_days: s.ttl_days ?? null,
            /* A permanent delete is on its way for it (purgeSelection). */
            purging: ys.value.has(s.id),
            /* #71 — a discarded draft of the asker's: its Location reads
               "Drafts" (ListView), which is where Restore puts it back. */
            ...s.draft ? { draft: !0 } : {}
          },
          /* Who put it here — the Trash draws it where a folder draws the
             owner. Keys absent when nobody is named, as the listing sends. */
          ...s.deleted_by_id !== void 0 ? { deleted_by_id: s.deleted_by_id } : {},
          ...s.deleted_by_name ? { deleted_by_name: s.deleted_by_name } : {},
          ...s.deleted_by_self ? { deleted_by_self: !0 } : {},
          /* wiring:e2 names — the encrypted folder it was deleted from. */
          ...s.e2e_root ? { e2e_root: s.e2e_root } : {}
        })
      );
    }
    async function $i() {
      const o = mt.view(), s = At.value;
      be.value = !0, zn.value = kt.value || "", At.value = !0, Et.value = "", s || Ke.clear();
      try {
        const g = await S.listTrash(void 0, { limit: e0 }), P = await Ut.decorate(Lb(g.entries));
        if (!$t(o)) return;
        xe.value = P, _o.value = g.entries.length, ps.value = g.total, sd.value = g.summary ?? "", Tt.value = ".trash", De.value = ".trash";
      } catch (g) {
        if (!$t(o)) return;
        const P = g instanceof Error ? g.message : String(g);
        U("error", { message: P, context: { op: "trash-list" } }), Qe(P);
      } finally {
        $t(o) && (be.value = !1);
      }
    }
    async function WA() {
      if (ld.value || _o.value >= ps.value) return;
      const o = _o.value;
      ld.value = !0;
      try {
        const s = await S.listTrash(void 0, { limit: e0, offset: o }), g = await Ut.decorate(Lb(s.entries));
        if (!At.value || _o.value !== o) return;
        xe.value = [...xe.value, ...g], _o.value = o + s.entries.length, ps.value = s.total, sd.value = s.summary ?? "";
      } catch (s) {
        Vt({ message: Gn(s) }, pn);
      } finally {
        ld.value = !1;
      }
    }
    function Nt(o) {
      if (o && o.includes("://")) return o;
      if (wn.value) {
        const s = ad(o ?? "");
        return s || (kt.value ? `${kt.value}://` : "");
      }
      return o ? `${kt.value}://${o.replace(/^\/+/, "")}` : `${kt.value}://`;
    }
    function Ti(o) {
      const s = o.indexOf("://"), g = (s === -1 ? o : o.slice(s + 3)).replace(/\/+$/, ""), P = g.lastIndexOf("/");
      return P === -1 ? g : g.slice(P + 1);
    }
    function Qi(o) {
      const s = o.indexOf("://"), g = s === -1 ? "" : o.slice(0, s + 3), P = (s === -1 ? o : o.slice(s + 3)).replace(/\/+$/, ""), R = P.lastIndexOf("/");
      return R === -1 ? g : g + P.slice(0, R);
    }
    function _h(o, s) {
      const g = (P) => {
        const R = P.indexOf("://"), j = R === -1 ? "" : P.slice(0, R + 3), ue = (R === -1 ? P : P.slice(R + 3)).replace(/\/+$/, "");
        return j + ue;
      };
      return g(o) === g(s);
    }
    function Ua(o, s) {
      return o ? o.endsWith("://") || o.endsWith("/") ? o + s : `${o}/${s}` : s;
    }
    async function Rb(o, s) {
      try {
        const g = await S.index(s), P = new Set((g.files ?? []).map((R) => String(R.basename ?? "").toLowerCase()));
        return o.some((R) => P.has(Ti(R).toLowerCase()));
      } catch {
        return !0;
      }
    }
    function Nb(o, s, g, P, R) {
      if (!P || !g || R) return;
      const j = s.map((ue) => Ua(g, Ti(ue)));
      j.length !== 0 && dt.set(o, {
        message: C("toast.moved"),
        fn: async () => {
          const { op: ue } = await S.moveAsync(j, P, g);
          return Me.register(ue), { queued: !0 };
        }
      });
    }
    Xe(
      () => _e.value,
      () => void xt()
    );
    function ud() {
      return O.config.pathPersist ?? "hash";
    }
    function Ib() {
      const o = ud();
      return o === "hash" || o === "hash+localStorage";
    }
    function YA(o) {
      try {
        return decodeURIComponent(o);
      } catch {
        return o;
      }
    }
    function Bb() {
      try {
        return localStorage.getItem(qm) || "";
      } catch {
        return "";
      }
    }
    function Fb() {
      const o = window.location.hash || "";
      return o.startsWith("#") ? YA(o.slice(1)).replace(/^\/+|\/+$/g, "") : "";
    }
    function GA() {
      if (typeof window > "u") return "";
      const o = ud();
      if (o === "none") return "";
      if (o === "localStorage") return Bb();
      const s = Fb();
      return s || o === "hash" ? s : qe ? "" : Bb();
    }
    function xh(o) {
      if (typeof window > "u") return;
      const s = ud();
      if (s === "none") return;
      if (s === "localStorage" || s === "hash+localStorage") {
        try {
          o ? localStorage.setItem(qm, o) : localStorage.removeItem(qm);
        } catch {
        }
        if (s === "localStorage") return;
      }
      const g = o ? o.split("/").map(encodeURIComponent).join("/") : "", P = g ? `#${g}` : "";
      (window.location.hash || "") !== P && history.replaceState(
        history.state,
        "",
        P || window.location.pathname + window.location.search
      );
    }
    function Ub() {
      if (!Ib()) return;
      const o = Fb();
      o && o !== De.value && xt(o);
    }
    Xe(De, (o) => {
      const s = V.rootOf(Nt(o)) ? zi(V.rootOf(Nt(o))) : o;
      xh(s), U("navigate", { path: s }), Be.subscribe(at(o));
    }), t({
      reload: () => xt(),
      /* App plugins — a notification's `target.open` lands here (see the
         function's own note for why this is a method and not a prop). */
      openAppTarget: Up,
      /* A notification's destination, carried out in this explorer — the desktop
         app hands a clicked OS notification here (see the function's note). */
      revealNotification: Ft
    }), Wt(async () => {
      var s;
      sp();
      const o = GA();
      try {
        await xt(o || void 0);
      } finally {
        Rt();
      }
      await Zt(), (s = xn.value) == null || s.focus(), CA(), uh(), fb(), Xe(Zp, (g) => {
        g && !lh.value && uh();
      }), Ib() && window.addEventListener("hashchange", Ub), S.endpoints.opsList && Me.startPolling(), Oe();
    });
    const cd = $(!1), dd = $(!1);
    function Sh() {
      return { configured: (O.config.storages ?? []).map((o) => o.name), current: kt.value };
    }
    function hs(o) {
      const s = O.config.accountSearch, g = o.account;
      return !s || !g || g.id === s.self.id ? null : g;
    }
    function Ql(o) {
      return yQ(o, hs(o) ? { configured: [], current: "" } : Sh());
    }
    async function XA(o) {
      var R;
      if (!o.some((j) => typeof j.e2e_root == "string" && j.e2e_root)) return o;
      const s = kt.value || ((R = (O.config.storages ?? [])[0]) == null ? void 0 : R.name) || "", g = await Promise.all(
        o.map((j) => Ut.decorate([gf(j, s)]).then((ue) => ue[0] ?? null))
      ), P = [];
      return o.forEach((j, ue) => {
        const $e = g[ue];
        $e && P.push($e.e2e_stored ? { ...j, name: $e.basename, e2e_display_dir: $e.e2e_display_dir } : j);
      }), P;
    }
    async function JA(o) {
      const s = S.globalSearch(o, { limit: 8, scope: "all" }).then(XA), g = O.config.accountSearch;
      if (!g) return s;
      let P = [];
      try {
        P = await g.others() ?? [];
      } catch {
        P = [];
      }
      if (P.length === 0) return s;
      const R = [g.self, ...P], j = await Promise.allSettled([
        s,
        ...P.map(($e) => g.search($e.id, o, { limit: 8, scope: "all" }))
      ]), ue = [];
      return j.forEach(($e, Ae) => {
        if (!($e.status !== "fulfilled" || !Array.isArray($e.value)))
          for (const st of $e.value) ue.push({ ...st, account: R[Ae] });
      }), ue;
    }
    async function ZA(o) {
      const s = N$(o);
      if (!s) return;
      const g = o.type === "dir", P = s.lastIndexOf("/"), R = g ? s : P === -1 ? "" : s.slice(0, P);
      let j = R;
      if (wn.value) {
        const Ae = Jv(o, Sh());
        if (!Ae) return;
        j = R ? `${Ae}/${R}` : Ae;
      }
      if (await xt(j), g) return;
      const ue = String(o.name ?? s.slice(P + 1)), $e = xe.value.find((Ae) => Ae.type === "file" && Ae.basename === ue);
      $e && (Ke.click($e.path), Ha($e));
    }
    function $h(o) {
      return (s) => U("error", { message: (s == null ? void 0 : s.message) ?? String(s), context: { op: o } });
    }
    function QA(o) {
      const s = hs(o), g = O.config.accountSearch;
      if (s && g) {
        const P = Ql(o);
        P && Promise.resolve(g.open(s.id, pf(P))).catch($h("search-open"));
        return;
      }
      ZA(o);
    }
    function eE(o, s) {
      const g = Ql(o);
      if (!g || s === "drag" && !Gf(g)) return !1;
      if (hs(o)) {
        const P = O.config.accountSearch;
        return s === "download" ? !!(P != null && P.download) : !!(P != null && P.dragStart);
      }
      return s === "download" ? !0 : !!ri.value || g.type === "file" && (Dm(O.config.auth) || ak.value);
    }
    function tE(o) {
      if (hs(o)) return;
      const s = Ql(o);
      s && h1(s) && rk(s.path);
    }
    function nE(o) {
      const s = Ql(o);
      if (!s) return;
      const g = hs(o);
      if (g) {
        const P = O.config.accountSearch;
        P != null && P.download && Promise.resolve(P.download(g.id, pf(s))).catch($h("search-download"));
        return;
      }
      yd([gf(o, Jv(o, Sh()))]);
    }
    function aE(o, s) {
      const g = Ql(o);
      if (!g || !s.dataTransfer || !Gf(g)) {
        s.preventDefault();
        return;
      }
      s.dataTransfer.effectAllowed = "copy";
      const P = hs(o);
      if (P) {
        const R = O.config.accountSearch;
        s.preventDefault(), R != null && R.dragStart && Promise.resolve(R.dragStart(P.id, [pf(g)])).catch($h("drag-out"));
        return;
      }
      nk(s, [g], null, typeof o.mime == "string" ? o.mime : void 0, !1);
    }
    function iE() {
      vr(), gs();
    }
    YM(xn, {
      onDelete: () => {
        if (At.value && !Tn.value && !wo.value) {
          Ke.isEmpty.value || Qe(C("toast.trash_retention"));
          return;
        }
        if (Tn.value) {
          const o = Vn.nodes.value;
          o.length && (xo.value = o, wi.value = !0, ua.value = !0);
        } else Ke.isEmpty.value || (wi.value = !1, ua.value = !0);
      },
      onRename: () => {
        if (Tn.value) {
          const o = Vn.nodes.value;
          o.length === 1 && (Qo.value = o[0], wi.value = !0, Xi.value = !0);
        } else Ke.nodes.value.length === 1 && (Qo.value = Ke.nodes.value[0], wi.value = !1, Xi.value = !0);
      },
      onSelectAll: () => Tn.value ? Vn.selectAll() : Ke.selectAll(),
      onOpen: () => {
        if (Tn.value) {
          const s = Vn.nodes.value[0];
          s && pC("split", s);
          return;
        }
        const o = Ke.nodes.value[0];
        o && Ha(o);
      },
      onClose: () => {
        var o;
        if (ia.value = !1, Xi.value = !1, ua.value = !1, cn.value && gw(cn.value.path) || (oa.value = !1), (o = yh.value) == null || o.hide(), bh(), dA.value) {
          Vc();
          return;
        }
        if (er.value) {
          bo();
          return;
        }
        Pa.value && Qg();
      },
      onFocusSearch: () => {
        var o;
        return (o = Ab.value) == null ? void 0 : o.focusSearch();
      },
      onCut: () => Tn.value ? Ck() : xE(),
      onCopy: () => Tn.value ? zk() : SE(),
      onPaste: () => Tn.value ? void Mk() : void Yb(),
      onGoUp: () => {
        var o;
        return Tn.value ? (o = Xt.value) == null ? void 0 : o.goUp() : Ue();
      },
      /* cila:c wiring */
      onPathJump: () => {
        ah.value = "", cd.value = !0;
      },
      onShowHelp: () => {
        dd.value = !0;
      },
      /* /cila:c wiring */
      onQuickLook: () => JE(),
      onToggleHidden: () => Mb(),
      onStar: () => void qg(Ke.nodes.value),
      onToggleInspector: () => Jp(),
      /* wiring:d1 — tab actions (registry: tab-new/close/next/prev) */
      onTabNew: () => Gh(),
      onTabClose: () => gk(Yh.value),
      onTabNext: () => rC(),
      onTabPrev: () => sC(),
      /* /wiring:d1 */
      /* tus:t1 — the menu verbs, routed through the SAME dispatcher the right-click
       * menu and the toolbar use (dispatchItemAction), so a key and a click cannot
       * drift apart. The ones that act on a selection do nothing without one, which
       * is what the menu does too. */
      onNewFolder: () => {
        ia.value = !0;
      },
      onUpload: () => So(),
      onRefresh: () => void xt(),
      onDownload: () => void Ei("download", ra()),
      onPreview: () => void Ei("preview", ra()),
      /* The share dialog is a door that makes links: the key opens it only where
         the menu offers Share (a role without any sharing permission gets
         nothing from the key either). */
      onShare: () => {
        const o = ra();
        yE("access", o) && Ei("access", o);
      },
      onTags: () => void Ei("tags", ra()),
      onOpenTab: () => void Ei("open-tab", ra()),
      onCopyPath: () => {
        const o = ra()[0];
        o && kd(o.path);
      },
      onCopyId: () => void Ei("copy-id", ra()),
      onRestore: () => void Ei("restore", ra()),
      /* /tus:t1 */
      hasSelection: () => !Ke.isEmpty.value
    });
    function ra() {
      return Tn.value ? Vn.nodes.value : Ke.nodes.value;
    }
    function Ha(o) {
      if (o.basename === ".trash") {
        $i();
        return;
      }
      const s = Ec(o, { t: C });
      if (s) {
        Vt({ message: s.why }, 8e3);
        return;
      }
      const g = Cc(o, { t: C });
      if (g) {
        Vt({ message: g.full }, 8e3);
        return;
      }
      if (o.type === "dir") {
        const j = wn.value ? ko(o.path) : Fa(o.path);
        xt(j);
        return;
      }
      if (V.isVaultRow(o) && o.type === "file") {
        if (Cl(o, null, "edit")) return;
        xs(o);
        return;
      }
      if (Ri(o) && !Qt.value && !o.e2e_root) {
        Pt.open(o);
        return;
      }
      if (o.type === "file" && !Qt.value && typeof o.e2e_root == "string" && o.e2e_root) {
        const j = Oa(o.path);
        xt(wn.value ? ko(j) : Fa(j));
        return;
      }
      if (qn.value && o.type === "file") {
        if (Cl(o, null, "edit")) return;
        xs(o);
        return;
      }
      if (fu.value && o.type === "file") return;
      if (Km(O.config, o) === "host") {
        U("file-opened", { path: o.path, basename: o.basename }), Na(o);
        return;
      }
      const P = (o.extension || "").toLowerCase();
      Ia.value = Zi(o) ? rE(P) : "view", gi.value = null;
      const R = zu(Al.value, o, null, El.value, zl(o), jr(o));
      R != null && R.view && Zi(o) ? Ia.value = "edit" : df(R) && (Ia.value = "view"), cn.value = o, oa.value = !0, U("file-opened", { path: o.path, basename: o.basename }), Na(o);
    }
    const oE = /* @__PURE__ */ new Set([
      "drawio",
      "dio",
      "pdf",
      "epub",
      "ipynb",
      "tiff",
      "tif",
      "psd",
      "mmd",
      "mermaid",
      "glb",
      "gltf",
      "obj",
      "stl",
      "fbx",
      "3ds",
      "zip",
      "rar",
      "7z",
      "tar",
      "gz",
      "tgz",
      "jpg",
      "jpeg",
      "png",
      "webp",
      "gif",
      "bmp",
      "avif",
      "svg",
      "heic",
      "mp4",
      "webm",
      "mov",
      "mkv",
      "m4v",
      "ogv",
      "mp3",
      "wav",
      "ogg",
      "flac",
      "m4a",
      "aac",
      "opus"
    ]);
    function rE(o) {
      return bw(o) || oE.has(o) ? "view" : "edit";
    }
    const Th = $(!1);
    async function sE(o) {
      if (Th.value) return;
      const s = o ?? Ke.nodes.value;
      if (s.length !== 0) {
        Th.value = !0;
        try {
          if (At.value) {
            const R = s.map((ue) => ue.id).filter((ue) => typeof ue == "number");
            if (Ic("restore")) {
              const { ops: ue, summary: $e } = await S.restoreQueued(R);
              for (const Ae of ue) Me.register(Ae);
              $e && Qe($e), Ke.clear();
              return;
            }
            const j = await S.restoreBatch(R);
            Vt({ message: j.summary }, j.failed ? pn : li), Ke.clear(), await $i();
            return;
          }
          if (!S.endpoints.restore) return;
          const g = s.map((R) => R.path), { restored: P } = await S.restore(g);
          Qe(C("toast.restored", { n: P })), Ke.clear(), await xt();
        } catch (g) {
          Vt({ message: Gn(g) }, pn), U("error", { message: g.message, context: { op: "restore" } });
        } finally {
          Th.value = !1;
        }
      }
    }
    function fd(o) {
      if (V.isVaultRow(o) && o.type === "file") {
        if (Cl(o, null, "view")) return;
        xs(o);
        return;
      }
      if (Ri(o) && !Qt.value && !o.e2e_root) {
        Pt.open(o);
        return;
      }
      if (qn.value && o.type === "file") {
        if (Cl(o, null, "view")) return;
        xs(o);
        return;
      }
      Ia.value = "view", gi.value = null, cn.value = o, oa.value = !0, Na(o);
    }
    function lE(o) {
      if (o.type === "dir") {
        const ue = wn.value ? ko(o.path) : Fa(o.path);
        xt(ue);
        return;
      }
      if (Ri(o) && !Qt.value && !o.e2e_root) {
        Pt.open(o);
        return;
      }
      if (Qt.value) {
        qn.value && xs(o);
        return;
      }
      if (O.config.openInHost) {
        Ha(o);
        return;
      }
      if (!Zi(o)) {
        fd(o);
        return;
      }
      const s = (o.extension || "").toLowerCase(), g = O.config.openPageBase;
      if (!g) {
        Ha(o);
        return;
      }
      const P = fk(g), R = P.includes("?") ? "&" : "?", j = `${P}${R}path=${encodeURIComponent(o.path)}&type=${encodeURIComponent(s)}&mode=edit`;
      window.open(j, "_blank", "noopener"), U("file-opened", { path: o.path, basename: o.basename }), Na(o);
    }
    const Ai = $("selection"), Ah = $(""), xo = $([]), uE = $(""), cE = E(() => {
      const o = ra();
      return o.length === 0 ? "none" : o.length === 1 ? o[0].type === "dir" ? "single-dir" : "single-file" : "multi";
    });
    async function Eh(o) {
      const s = ra();
      if (o === "open") {
        s[0] && Ha(s[0]);
        return;
      }
      await Ei(o, s);
    }
    const ii = E(() => O.config.desktopSync ?? null), pd = $([]);
    let Hb = !1;
    async function tr() {
      if (!ii.value) return;
      const o = Hb ? () => {
      } : Gl.start();
      try {
        pd.value = await ii.value.kept(), Hb = !0;
      } catch {
      } finally {
        o();
      }
    }
    const ms = $(null);
    async function Kb() {
      const o = ii.value;
      if (o != null && o.status)
        try {
          ms.value = (await o.status()).active ?? null;
        } catch {
          ms.value = null;
        }
    }
    let vs = null, Ch = !0;
    function dE() {
      vs || !Ch || (vs = setTimeout(() => {
        vs = null, Ch && (Kb(), tr());
      }, 300));
    }
    Wt(() => {
      var o, s;
      tr(), Kb(), (s = (o = ii.value) == null ? void 0 : o.onChange) == null || s.call(o, dE);
    }), Ot(() => {
      Ch = !1, vs && (clearTimeout(vs), vs = null);
    });
    function eu(o) {
      const s = String(o.path ?? "");
      return s.includes("://") ? s.replace(/\/+$/, "") : `${s}://`;
    }
    function hd(o, s) {
      return s.endsWith("://") ? o.startsWith(s) && o !== s : o === s ? !1 : o.startsWith(s + "/");
    }
    function zh(o) {
      return pd.value.some((s) => s.remote === o) ? "kept" : pd.value.some((s) => hd(o, s.remote)) ? "inherited" : pd.value.some((s) => hd(s.remote, o)) ? "partial" : "none";
    }
    function Vb(o) {
      if (!ii.value || Bt.value || o.basename === ".trash") return null;
      const s = eu(o), g = ms.value;
      if (g && (s === g.remote || hd(s, g.remote) || hd(g.remote, s)))
        return "syncing";
      const P = zh(s);
      return P === "kept" || P === "inherited" ? "kept" : P === "partial" ? "partial" : "cloud";
    }
    const fE = E(() => {
      const o = ms.value;
      if (!o) return "";
      const s = o.remote.endsWith("://") ? o.remote.slice(0, -3) : o.remote.slice(o.remote.lastIndexOf("/") + 1);
      return o.phase === "transfer" && o.total > 0 ? C("keep.strip_transfer", {
        name: s,
        done: String(o.done),
        total: String(o.total),
        pct: String(Math.min(100, Math.round(o.done * 100 / o.total)))
      }) : o.phase === "settling" ? C("keep.strip_settling", { name: s }) : C("keep.strip_inventory", { name: s });
    }), jb = E(() => {
      const o = ms.value;
      return !o || o.phase !== "transfer" || o.total <= 0 ? null : Math.min(100, Math.round(o.done * 100 / o.total));
    });
    function Mh(o) {
      var R, j, ue;
      const s = ii.value, g = o.length === 1 && (((R = o[0]) == null ? void 0 : R.type) === "dir" || ((j = o[0]) == null ? void 0 : j.type) === "file");
      if (!s || !g || Bt.value || Qt.value || ((ue = o[0]) == null ? void 0 : ue.e2e) === !0) return [];
      const P = zh(eu(o[0]));
      return [
        { divider: !0, key: "sep-keep", label: "" },
        { key: "keep-local", label: C("ctx.keep_local"), hidden: P === "kept" || P === "inherited" },
        { key: "keep-online", label: C("ctx.keep_online"), hidden: P !== "kept" },
        { key: "keep-inherited", label: C("ctx.keep_inherited"), disabled: !0, hidden: P !== "inherited" },
        { key: "keep-reveal", label: C("ctx.keep_reveal"), hidden: P !== "kept" && P !== "inherited" }
      ];
    }
    const Ph = $([]);
    let md = 0;
    async function tu(o, s) {
      var P;
      const g = ++md;
      if (s.length > 0 && (Wb.value, Gl.count > 0 && typeof window < "u")) {
        const R = (j) => {
          j.type === "keydown" && j.key !== "Escape" || g === md && md++;
        };
        window.addEventListener("pointerdown", R, !0), window.addEventListener("keydown", R, !0);
        try {
          await Gl.settled(Kae);
        } finally {
          window.removeEventListener("pointerdown", R, !0), window.removeEventListener("keydown", R, !0);
        }
      }
      g === md && ((P = yh.value) == null || P.show(o, s));
    }
    async function Oh(o, s) {
      Ai.value = "selection", tr(), Ke.has(o.path) || (Ke.click(o.path), await Zt()), Ph.value = Ke.nodes.value.length ? [] : [o];
      const g = Ke.nodes.value.length ? Ke.nodes.value : [o];
      await tu({ clientX: s.clientX, clientY: s.clientY }, g);
    }
    function pE(o) {
      o.preventDefault(), Ai.value = "selection", Ke.clear(), Ph.value = [], tu({ clientX: o.clientX, clientY: o.clientY }, []);
    }
    function hE(o) {
      Ai.value = "breadcrumb", Ah.value = o.adapterPath, uE.value = o.label, tu({ clientX: o.x, clientY: o.y }, []);
    }
    async function qb(o, s, g) {
      if (tr(), o === "split") {
        si.value = "split";
        const P = Vn.nodes.value;
        s && !Vn.has(s.path) && (Vn.click(s.path), await Zt());
        const R = Vn.nodes.value;
        xo.value = s ? R.length > 0 ? R : P.length > 0 ? P : [s] : [], Ai.value = "pane", await tu({ clientX: g.clientX, clientY: g.clientY }, xo.value);
        return;
      }
      if (si.value = "main", Ai.value = "selection", !s) {
        Ke.clear(), tu({ clientX: g.clientX, clientY: g.clientY }, []);
        return;
      }
      await Oh(s, g);
    }
    const Wb = E(() => {
      if (Ai.value === "breadcrumb")
        return [
          { key: "open", label: C("ctx.open") },
          { key: "copy-path", label: C("breadcrumb.copy_path") }
        ];
      if (Ai.value === "pane") {
        const j = xo.value;
        return j.length === 0 ? [
          { key: "new-folder", label: C("toolbar.new_folder") },
          { key: "paste", label: C("ctx.paste"), disabled: !_t.value.mode }
        ] : au(j);
      }
      const o = Ke.nodes.value.length ? Ke.nodes.value : Ph.value, s = o.length > 0, g = o.length === 1;
      if (Bt.value)
        return s ? [
          { key: "restore", label: C("ctx.restore"), hidden: !nu("files.create") },
          ...wo.value ? [
            { divider: !0, key: "sep1", label: "" },
            { key: "delete", label: C("ctx.delete_perm"), danger: !0, hidden: !nu("files.purge") }
          ] : []
        ] : [];
      const P = (De.value ?? "").replace(/^\/+|\/+$/g, "");
      if (wn.value && P === "")
        return s ? g ? [
          { key: "open", label: C("ctx.open") },
          { key: "open-tab", label: C("ctx.open_new_tab") },
          // A whole storage can be kept too — that IS the "sync everything"
          // shape, and it is one pair, not one per subfolder.
          ...Mh(o)
        ] : [] : [];
      if (!s) {
        const j = [
          {
            key: "toggle-hidden",
            label: Iu.value ? C("ctx.hide_hidden") : C("ctx.show_hidden")
          }
        ];
        return Yl(Ne.value) ? [
          { key: "new-folder", label: C("toolbar.new_folder") },
          { key: "paste", label: C("ctx.paste"), disabled: !_t.value.mode },
          ...j
        ] : j;
      }
      return au(o);
    });
    function nu(o) {
      const s = I.value;
      return !s || s.includes(o);
    }
    const mE = {
      rename: ["files.rename"],
      cut: ["files.move"],
      "move-to": ["files.move"],
      delete: ["files.delete"],
      download: ["files.download"],
      convert: ["files.create"],
      "copy-to": ["files.create"],
      paste: ["files.create", "files.move"],
      tags: ["files.tag"],
      /* wiring:e2 policy — the four rows that START an encryption make something,
         a key file or a `.fxe`, and the server asks files.create for that beside
         files.encrypt (backend perm.FilesEncrypt: "carved out of files.create,
         which the same write needs as well"). A place can allow the one and deny
         the other; the row is then hidden, not offered to be refused. */
      "fxe-encrypt": ["files.create"],
      "fxe-request": ["files.create"],
      "e2e-convert": ["files.create"],
      "e2e-request": ["files.create"]
    };
    function vd(o) {
      return TL((s) => Xl(s, o));
    }
    function vE(o, s) {
      if (!I.value || s.length > 0 && s.every((P) => V.isVaultRow(P))) return o;
      const g = s.map((P) => P.path);
      return o.map((P) => {
        if (P.key === "access") {
          const j = s.length > 0 && s.every((ue) => ue.type === "dir");
          return AL(vd(g), j) ? P : { ...P, hidden: !0 };
        }
        const R = mE[P.key];
        return R && !R.some((j) => Xl(j, g)) ? { ...P, hidden: !0 } : P;
      });
    }
    function yE(o, s) {
      return au(s).some((g) => g.key === o && !g.hidden && !g.disabled);
    }
    function au(o) {
      const s = vE(bE(o), o);
      return o.some(Yx) ? s.map((g) => g.divider || g.key === "details" ? g : { ...g, disabled: !0 }) : s;
    }
    function gE(o) {
      var j;
      const s = String(o[0].vault_root ?? ""), g = o.length === 1, P = g && o[0].type === "file", R = Yl(V.permOf(s)) && !((j = V.strips[s]) != null && j.readOnly) && Xl("files.create", [s]) && Xl("files.delete", [s]);
      return [
        { key: "preview", label: C("ctx.preview"), hidden: !g, disabled: !P },
        { key: "download", label: C("ctx.download"), disabled: o.length === 0 },
        { key: "details", label: C("ctx.details") },
        { divider: !0, key: "sep1", label: "", hidden: !R },
        { key: "rename", label: C("ctx.rename"), hidden: !g || !R },
        { key: "cut", label: C("ctx.cut"), hidden: !R },
        { key: "copy", label: C("ctx.copy") },
        { key: "paste", label: C("ctx.paste"), hidden: !R, disabled: !_t.value.mode },
        { divider: !0, key: "sep2", label: "", hidden: !R },
        { key: "delete", label: C("ctx.delete"), danger: !0, hidden: !R }
      ];
    }
    function bE(o) {
      var fn, _n, Li, ja;
      if (o.length > 0 && o.every((Nd) => V.isVaultRow(Nd))) return gE(o);
      const s = o.length > 0, g = o.length === 1;
      if (o.some(qu))
        return g ? [
          { key: "open", label: C("ctx.open") },
          { key: "open-tab", label: C("ctx.open_new_tab") },
          ...Mh(o)
        ] : [];
      const P = g && ((fn = o[0]) == null ? void 0 : fn.type) === "file", R = C("ctx.tags_menu"), j = g && Dh(o[0]), ue = g && typeof ((_n = o[0]) == null ? void 0 : _n.id) == "number", $e = Vp(o).length > 0, Ae = jg(o), st = PA(o), Ze = Yl(st) && !wb(o), Dt = C("shortcuts.share"), Sn = String(((Li = o[0]) == null ? void 0 : Li.extension) ?? "").toLowerCase(), Ct = P ? bw(Sn) ? gm(!!Wo.value, ba.value, C("ctx.needs_onlyoffice")) : Sn === "drawio" || Sn === "dio" ? gm(!!Rl.value, ba.value, C("ctx.needs_drawio")) : {} : {}, Va = z$(o, { canWrite: Ze, inEncrypted: Qt.value });
      return [
        { key: "open", label: C("ctx.open"), ...Ct, hidden: !g || Ct.hidden === !0 },
        { key: "open-tab", label: C("ctx.open_new_tab"), hidden: !g || ((ja = o[0]) == null ? void 0 : ja.type) !== "dir" },
        { key: "preview", label: C("ctx.preview"), hidden: !g, disabled: !P },
        /* tasi:m1 — Download works on ANY selection now. It used to disappear the
           moment a second row was ticked, because the only implementation was one
           `window.open` per node and the browser blocks the second popup; there is
           one streaming archive behind it now (lib/downloadSelection), and the
           server expands a selected folder itself, so a lone folder is a zip too.
           Inside an encrypted folder the server has no plaintext to zip: the zip
           is made in this tab (below), and a LOCKED folder downloads one row at
           a time. */
        /* wiring:e2 fxe — inside an unlocked encrypted folder a selection of any
           size downloads DECRYPTED now (a zip made in this tab); the ciphertext is
           "Download encrypted copy" below. */
        { key: "download", label: C("ctx.download"), hidden: !s || fu.value && !g, disabled: !s },
        /* wiring:e2 fxe — single encrypted files, and the ciphertext copy.
           wiring:e2 policy — "Encrypt with E2EE…" asks the answer for the file it
           would encrypt, and becomes "Request encryption…" under the approval
           policy (useE2eFiles menuRows). */
        ...Pt.menuRows(o, {
          canWrite: Ze,
          inEncrypted: Qt.value,
          unlockedEncryptedCopy: qn.value || g && aw(o[0]) !== null,
          encryptAnswer: Va ? vh(Va.path, "file") : void 0
        }),
        { key: "archive-create", label: C("ctx.archive_create"), hidden: !s || g && j || !Ze || Qt.value || Fl.value.length === 0, disabled: !s },
        { key: "archive-extract", label: C("ctx.archive_extract"), hidden: !j || !Ze || Qt.value, disabled: !j },
        { key: "archive-extract-here", icon: "archive-extract", label: C("archive.extract_here"), hidden: !j || !Ze || Qt.value, disabled: !j },
        /* tasi:m1 — VISIBLE and grey above a multi-selection, not gone. Sharing
           really is one item at a time (a share link addresses one node), and the
           row now says so in its tooltip; vanishing taught the reader that filex
           cannot share the thing they are looking at. */
        {
          key: "access",
          label: Dt,
          hidden: !s || !Ze || Fx(o, Qt.value),
          disabled: !g,
          title: g ? void 0 : C("ctx.access.one_only")
        },
        { key: "details", label: C("ctx.details"), hidden: !s },
        /* wiring:e2 convert — encrypt a folder that already exists, in place.
           wiring:e2 policy — offered where the policy lets this account encrypt
           that folder; where it wants an approval, the menu asks for one. */
        { key: "e2e-convert", label: C("e2e.convert.ctx"), icon: "lock", hidden: !Zk(o, Ze, "allowed") },
        { key: "e2e-request", label: C("e2e.request.ctx"), icon: "lock", hidden: !Zk(o, Ze, "request") },
        /* ⚠ "Copy node id" is NOT here any more (owner's call, 2026-09-13): it is a
           developer's handle on a support ticket, not an everyday verb, and this
           list is rendered by BOTH the right-click menu and the selection bar — so
           one row put it in front of everyone, twice. It lives in the details
           panel now, beside Path and ETag, which is where the other technical
           facts about a file already are. The `copy-id` case below stays: the
           panel dispatches it. */
        { divider: !0, key: "sep1", label: "", hidden: !Ze },
        { key: "rename", label: C("ctx.rename"), hidden: !g || !Ze, disabled: !g },
        { key: "cut", label: C("ctx.cut"), hidden: !s || !Ze, disabled: !s },
        { key: "copy", label: C("ctx.copy"), hidden: !s, disabled: !s },
        /* tasi:m1 — "somewhere else", without the clipboard. Cut+paste has always
           been able to do this, but only by navigating away from the rows you had
           just picked; these two ask WHERE in a dialog and leave the listing where
           it is.
           ⚠ `icon:` is not decoration here — `actionIconSvg` answers '' for a key
           it does not know, and a bar button with no glyph is an empty 28px box.
           They borrow the clipboard verbs' marks, which is what they are. */
        { key: "move-to", label: C("ctx.move_to"), icon: "cut", hidden: !s || !Ze, disabled: !s },
        { key: "copy-to", label: C("ctx.copy_to"), icon: "copy", hidden: !s, disabled: !s },
        /* Paste needs a destination folder; a virtual view (Recent / Starred /
           Shared / a tag / Home) has none, so it is the one write verb the row
           menu does not carry there — every per-row verb above and below does. */
        { key: "paste", label: C("ctx.paste"), hidden: !Ze || pe.value, disabled: !_t.value.mode },
        { divider: !0, key: "sep-meta", label: "", hidden: !ue && !$e },
        /* yildiz:s1 — "star must be an action, like a tag" (owner, v0.30.0).
           Beside Tags on purpose: they are the same kind of verb, and this is the
           ONLY star a grid/gallery user reaches with the keyboard. Works on a
           multi-selection; the label follows the selection's state. */
        {
          key: "star",
          label: C(Ae ? "ctx.unstar" : "ctx.star"),
          icon: Ae ? "unstar" : "star",
          hidden: !$e
        },
        { key: "tags", label: R, hidden: !ue, disabled: !ue },
        /* App plugins — one row per action whose `applies` rule accepts the
           selection, under its own `sep-plugins` divider; `[]` when the feature
           is off, in the trash, or inside an encrypted folder (lib/pluginMenu). */
        ...vT(o),
        ...ST(o),
        ...Mh(o),
        { divider: !0, key: "sep2", label: "", hidden: !Ze },
        { key: "delete", label: C("ctx.delete"), danger: !0, hidden: !s || !Ze, disabled: !s }
      ];
    }
    const kE = /* @__PURE__ */ new Set(["zip", "7z", "rar", "tar", "gz", "tgz", "bz2", "tbz2", "xz", "txz"]);
    function Dh(o) {
      return !!o && o.type === "file" && kE.has((o.extension || "").toLowerCase());
    }
    const wE = E(() => {
      const o = ra();
      if (Tn.value) return o.length ? au(o).filter((g) => g.key !== "archive-extract-here") : [];
      if (Bt.value)
        return o.length === 0 ? [] : [
          { key: "restore", label: C("ctx.restore"), hidden: !nu("files.create") },
          ...wo.value ? [{ key: "delete", label: C("ctx.delete_perm"), danger: !0, hidden: !nu("files.purge") }] : []
        ];
      const s = (De.value ?? "").replace(/^\/+|\/+$/g, "");
      return wn.value && s === "" ? o.length === 1 ? [{ key: "open", label: C("ctx.open") }] : [] : o.length === 0 ? [] : au(o).filter((g) => g.key !== "archive-extract-here");
    });
    async function _E(o, s) {
      if (Ai.value === "breadcrumb") {
        o.key === "open" ? xt(Fa(Ah.value)) : o.key === "copy-path" && await kd(Ah.value);
        return;
      }
      if (Ai.value === "pane") {
        await Ei(o.key, xo.value);
        return;
      }
      await Ei(o.key, s);
    }
    function oi() {
      return Ai.value === "pane" || Tn.value;
    }
    async function Ei(o, s) {
      var g, P;
      if (aP(o)) {
        await Ig(o, s);
        return;
      }
      if (o === "open-with-choose") {
        s[0] && (za.value = s[0]);
        return;
      }
      if (o.startsWith("open-with:")) {
        const R = s[0];
        if (R) {
          const j = o.slice(10);
          fd(R), gi.value = j, j !== "builtin" && Zi(R) && (Ia.value = "edit");
        }
        return;
      }
      if (KZ(o)) {
        await Pt.dispatch(o, s, (R) => yd(R, { encrypted: !0 }));
        return;
      }
      switch (o) {
        case "clear-selection":
          Tn.value ? Vn.clear() : Ke.clear();
          return;
        case "open":
          s[0] && lE(s[0]);
          break;
        case "preview":
          s[0] && fd(s[0]);
          break;
        case "e2e-convert":
          s[0] && ZC(s[0]);
          break;
        case "e2e-request":
          s[0] && Qh(s[0].path, "folder", s[0].basename);
          break;
        case "download":
          await yd(s);
          break;
        case "archive-create":
          if (s.length === 0) break;
          Bl.value = s, Jr.value = oi(), Xr.value = Jr.value ? Nt(((g = Xt.value) == null ? void 0 : g.getPath()) ?? "") : Nt(De.value), ki.value = "", Bc.value = !0;
          break;
        case "archive-extract":
          if (!s[0] || !Dh(s[0])) break;
          go.value = s[0], Jr.value = oi(), Xr.value = Qi(s[0].path), ki.value = "", Xo.value = !0;
          break;
        case "archive-extract-here":
          if (!s[0] || !Dh(s[0])) break;
          go.value = s[0], Jr.value = oi(), Xr.value = Qi(s[0].path), ki.value = "", await Ih(s[0], Xr.value, Jr.value);
          break;
        case "move-to":
        case "copy-to":
          if (s.length === 0) break;
          Fc.value = o === "move-to" ? "move" : "copy", Uc.value = s, Hc.value = !1, as.value = !0;
          break;
        case "keep-local": {
          const R = ii.value;
          if (!R || !s[0]) break;
          const j = eu(s[0]);
          try {
            await R.keep(j, s[0].type === "file" ? "file" : "dir"), await tr(), zh(j) !== "none" && Qe(C("keep.started"));
          } catch (ue) {
            await tr(), Qe(`${C("keep.failed")}: ${String((ue == null ? void 0 : ue.message) ?? ue)}`);
          }
          break;
        }
        case "keep-online": {
          const R = ii.value;
          if (!R || !s[0]) break;
          try {
            await R.unkeep(eu(s[0]));
          } catch {
          }
          await tr();
          break;
        }
        case "keep-reveal": {
          const R = ii.value;
          R && s[0] && R.reveal(eu(s[0]));
          break;
        }
        case "access":
          s[0] && (_i.value = s[0], ns.value = !0);
          break;
        case "details":
          nA();
          break;
        case "copy-id":
          if (s[0] && typeof s[0].id == "number") {
            const R = s[0].id;
            (P = navigator.clipboard) == null || P.writeText(String(R)).then(
              () => Qe(C("toast.node_id_copied", { id: R })),
              () => Qe(`#${R}`)
            );
          }
          break;
        case "star":
          await qg(s);
          break;
        case "tags":
          s[0] && CT(s[0]);
          break;
        case "rename":
          s[0] && (Qo.value = s[0], wi.value = oi(), Xi.value = !0);
          break;
        case "cut":
          oi() ? Ck() : (_t.value = { mode: "cut", items: s, sourcePath: De.value }, Qe(C("toast.cut_ready")));
          break;
        case "copy":
          oi() ? zk() : (_t.value = { mode: "copy", items: s, sourcePath: De.value }, Qe(C("toast.copy_ready")));
          break;
        case "paste":
          oi() ? await Mk() : await Yb();
          break;
        case "delete": {
          const R = oi();
          R && (xo.value = s), wi.value = R, ua.value = !0;
          break;
        }
        case "restore":
          s.length > 0 && await sE(s);
          break;
        case "toggle-hidden":
          Mb();
          break;
        case "new-folder":
          wi.value = oi(), ia.value = !0;
          break;
        case "duplicate":
          s[0] && await $E(s[0]);
          break;
        case "open-tab":
          s[0] && bk(s[0]);
          break;
      }
    }
    function xE() {
      Ke.isEmpty.value || (_t.value = { mode: "cut", items: Ke.nodes.value, sourcePath: De.value }, Qe(C("toast.cut")));
    }
    function SE() {
      Ke.isEmpty.value || (_t.value = { mode: "copy", items: Ke.nodes.value, sourcePath: De.value }, Qe(C("toast.copied")));
    }
    let Lh = !1;
    async function Yb() {
      const o = _t.value;
      if (!(!o.mode || o.items.length === 0 || Lh)) {
        Lh = !0;
        try {
          const s = o.items.map((Ae) => Ae.path), g = o.sourcePath || "";
          if (o.mode === "cut" && g === De.value) {
            Qe(C("toast.same_folder_cut"));
            return;
          }
          const R = Nt(De.value), j = Uk(s, R);
          if (j === "cross") {
            Qe(C("e2e.vault.cross"));
            return;
          }
          if (j === "inside") {
            (o.mode === "cut" ? await V.move(s, R) : await V.copy(s, R)) && o.mode === "cut" && (_t.value = { mode: null, items: [], sourcePath: null });
            return;
          }
          const ue = F1(s, R, o.mode === "cut" ? "move" : "copy"), $e = await lm(o.mode === "cut" ? "move" : "copy", s, R, Nt(g) || void 0);
          if ($e) {
            $e.undo && $e.ops.length && dt.set($e.ops[$e.ops.length - 1].id, { message: C("toast.moved"), fn: $e.undo }), $e.ops.length && Qe(o.mode === "cut" ? C("split.move_queued") : C("split.copy_queued")), _t.value = { mode: null, items: [], sourcePath: null };
            return;
          }
          if (o.mode === "cut") {
            const Ae = Nt(g) || void 0, st = await Rb(s, R), { op: Ze } = await S.moveAsync(s, R, Ae);
            Nb(Ze.id, s, R, Ae, st), Me.register(Ze), Qe(
              st ? C("toast.move_kept_both") : ue.cross ? C("split.cross_move") : C("split.move_queued")
            );
          } else {
            const { op: Ae } = await S.copy(s, R);
            Me.register(Ae), Qe(ue.cross ? C("split.cross_copy") : C("split.copy_queued"));
          }
          _t.value = { mode: null, items: [], sourcePath: null };
        } catch (s) {
          Ml(s, { op: "paste" });
        } finally {
          Lh = !1;
        }
      }
    }
    async function $E(o) {
      try {
        const { op: s } = await S.copy([o.path], Nt(De.value));
        Me.register(s);
      } catch (s) {
        Ml(s, { op: "duplicate" });
      }
    }
    function TE(o) {
      if (V.isVaultRow(o)) {
        V.download([o]);
        return;
      }
      if (qn.value) {
        DC(o);
        return;
      }
      const s = S.downloadUrl(o.path);
      window.open(s, "_blank");
    }
    const Rh = $(!1);
    async function yd(o, s = {}) {
      if (o.length !== 0) {
        if (o.every((g) => V.isVaultRow(g))) {
          await V.download(o);
          return;
        }
        if (!(!s.encrypted && await uz(o))) {
          if (o.length === 1 && o[0].type === "file") {
            if (s.encrypted) {
              window.open(S.downloadUrl(o[0].path), "_blank");
              return;
            }
            TE(o[0]);
            return;
          }
          if (!Rh.value) {
            Rh.value = !0, Vt({ message: C("toast.archive.preparing") }, Yd);
            try {
              const g = await vQ(S, o.map((R) => R.path)), P = o.length === 1 && o[0].e2e_stored ? `${o[0].basename}.zip` : g.name;
              Qe(C("toast.archive.started", { name: P, count: String(g.files) }));
            } catch (g) {
              const P = g;
              Vt({ message: P.status === 409 ? C("toast.archive.empty") : Gn(g) }, pn), U("error", { message: P.message, context: { op: "archive-download" } });
            } finally {
              Rh.value = !1;
            }
          }
        }
      }
    }
    async function AE(o) {
      var R;
      const s = Uc.value;
      if (!o || s.length === 0) {
        as.value = !1;
        return;
      }
      const g = Fc.value === "move", P = oi() ? Nt(((R = Xt.value) == null ? void 0 : R.getPath()) ?? "") : Nt(De.value);
      Hc.value = !0;
      try {
        const j = await ws(s.map(($e) => $e.path), o, P || void 0, g ? "move" : "copy"), ue = Ut.segmentLabel(o) ?? tl(o, o);
        j === "queued" ? Qe(g ? C("toast.moved_to", { name: ue }) : C("toast.copied_to", { name: ue })) : j === "nothing" && Qe(C("toast.already_there", { name: ue })), g && (j === "queued" || j === "done") && (oi() ? Vn.clear() : Ke.clear());
      } finally {
        Hc.value = !1, as.value = !1;
      }
    }
    async function EE(o) {
      Il.value = !1;
      const s = o.app ? `${o.app.plugin}/${o.app.view}` : null;
      if (o.draft) {
        Yr.value += 1, Xg(o.draft, s), Yp();
        return;
      }
      const g = o.path.slice(0, o.path.lastIndexOf("/"));
      g && g !== Nt(De.value) ? await xt(g) : await xt();
      const P = o.name.lastIndexOf("."), R = xe.value.find((j) => j.path === o.path) ?? {
        type: "file",
        path: o.path,
        basename: o.name,
        extension: P > 0 ? o.name.slice(P + 1).toLowerCase() : ""
      };
      if (Km(O.config, R) === "host") {
        U("file-opened", { path: R.path, basename: R.basename }), Na(R);
        return;
      }
      ts.value = o.ext ? { path: R.path, ext: o.ext } : null, gi.value = s, cn.value = R, Ia.value = Zi(R) ? "edit" : "view", oa.value = !0, U("file-opened", { path: R.path, basename: R.basename }), Na(R);
    }
    function CE(o) {
      const s = o == null ? void 0 : o.detail;
      if (s)
        try {
          return JSON.parse(s).code;
        } catch {
          return;
        }
    }
    function Nh(o) {
      const s = o == null ? void 0 : o.detail;
      if (s)
        try {
          const g = JSON.parse(s), P = {
            PASSWORD_REQUIRED: "archive.password_required",
            BAD_PASSWORD: "archive.bad_password",
            TARGET_EXISTS: "archive.target_exists",
            PASSWORD_CHARSET: "archive.password_charset",
            UNSUPPORTED_FORMAT: "archive.error_unsupported",
            ARCHIVE_LIMIT_EXCEEDED: "archive.error_limit",
            PROVIDER_UNAVAILABLE: "archive.error_unavailable"
          };
          if (g.code && P[g.code]) return C(P[g.code]);
          if (g.error) return g.error;
        } catch {
        }
      return (o == null ? void 0 : o.message) || C("toast.failed");
    }
    async function zE(o) {
      Gp.value = !0, ki.value = "";
      try {
        const { op: s } = await S.archiveCreate({
          dest: Ua(Xr.value, o.name),
          sources: Bl.value.map((g) => g.path),
          format: o.format,
          password: o.password,
          encrypt_filenames: o.encrypt_filenames,
          compression: o.compression,
          solid: o.solid,
          dictionary_size_mb: o.dictionary_size_mb
        });
        Me.register(s), Bc.value = !1, su.reveal(), Qe(C("archive.queued"));
      } catch (s) {
        ki.value = Nh(s), U("error", { message: ki.value, context: { op: "archive-create" } });
      } finally {
        Gp.value = !1;
      }
    }
    async function Ih(o, s, g, P) {
      var ue, $e;
      if (Jo.value.has(o.path)) {
        Qe(C("archive.already_preparing", { name: o.basename }));
        return;
      }
      Jo.value = new Set(Jo.value).add(o.path), ki.value = "";
      const R = C("archive.preparing_extract", { name: o.basename }), j = setTimeout(() => {
        !Xo.value && !Gr.value && Vt({ message: R }, Yd);
      }, 600);
      try {
        const Ae = await S.archiveExtract(o.path, {
          dest: s,
          password: P
        });
        if (Xo.value = !1, Gr.value = !1, Zo.value = null, Zr.value = "", Ae.op) {
          Me.register(Ae.op), su.reveal(), Qe(C("archive.extraction_queued"));
          return;
        }
        g ? await ((ue = Xt.value) == null ? void 0 : ue.reload()) : await xt(), Qe(C("archive.extracted", { count: Ae.count ?? 0 }));
      } catch (Ae) {
        const st = CE(Ae);
        if (st === "PASSWORD_REQUIRED" || st === "BAD_PASSWORD") {
          Zo.value = { target: o, dest: s, inPane: g }, Zr.value = st === "BAD_PASSWORD" ? C("archive.bad_password") : "", Xo.value = !1, Gr.value = !0;
          return;
        }
        const Ze = Nh(Ae);
        Gr.value ? Zr.value = Ze : Xo.value ? ki.value = Ze : Vt({ message: Ze }, 6e3);
      } finally {
        clearTimeout(j), (($e = ca.value) == null ? void 0 : $e.message) === R && (ca.value = null);
        const Ae = new Set(Jo.value);
        Ae.delete(o.path), Jo.value = Ae;
      }
    }
    async function ME(o) {
      const s = go.value;
      s && await Ih(
        s,
        Ua(Xr.value, o.folder),
        Jr.value
      );
    }
    async function PE(o) {
      const s = Zo.value;
      s && (Zr.value = "", await Ih(s.target, s.dest, s.inPane, o));
    }
    function OE() {
      Gr.value = !1, Zo.value = null, Zr.value = "";
    }
    async function DE(o) {
      try {
        await S.opsCancel(o), await Me.poll();
      } catch (s) {
        const g = Me.ops.value.find((R) => R.id === o), P = (g == null ? void 0 : g.op_type) === "archive-create" || (g == null ? void 0 : g.op_type) === "archive-extract";
        Vt({ message: P ? Nh(s) : Gn(s, C("plugin.cancel_failed")) }, pn);
      }
    }
    async function LE(o) {
      var P, R;
      const s = es.begin();
      if (s === null) return;
      const g = wi.value;
      try {
        const j = Nt(g ? ((P = Xt.value) == null ? void 0 : P.getPath()) ?? "" : De.value);
        if (V.rootOf(j)) {
          await V.mkdir(j, o) && (ia.value = !1, es.end(s));
          return;
        }
        await Gb(j, o), ia.value = !1, es.end(s), g ? await ((R = Xt.value) == null ? void 0 : R.reload()) : await xt();
      } catch (j) {
        Pl(es, s, j, { op: "newfolder" });
      } finally {
        es.end(s);
      }
    }
    async function Gb(o, s) {
      const g = await Yk(o, s, { isDir: !0 });
      return await S.newFolder(o, g), Ua(o, g);
    }
    async function RE(o) {
      var R, j;
      const s = Qo.value;
      if (!s) return;
      const g = Qr.begin();
      if (g === null) return;
      const P = wi.value;
      try {
        const ue = Nt(P ? ((R = Xt.value) == null ? void 0 : R.getPath()) ?? "" : De.value), $e = s.path;
        if (V.rootOf($e)) {
          await V.rename($e, o) && (Xi.value = !1, Qo.value = null, Qr.end(g));
          return;
        }
        const Ae = sf(s), st = await Yk(
          Qi($e),
          o,
          s.type === "dir" ? { keepIdOf: $e } : {}
        ), Ze = s.type === "dir" && Ic("rename");
        let Dt;
        Ze ? Dt = (await S.renameQueued(ue, $e, st)).op : await S.rename(ue, $e, st), Xi.value = !1, Qo.value = null, Qr.end(g);
        const Sn = Ua(Qi($e), st), Ct = st && st !== Ae ? async () => {
          if (!Ze) {
            await S.rename(ue, Sn, Ae);
            return;
          }
          const Va = (await S.renameQueued(ue, Sn, Ae)).op;
          return Va && Me.register(Va), { queued: !0 };
        } : null;
        if (Dt) {
          Ct && dt.set(Dt.id, { message: C("toast.renamed"), fn: Ct }), Me.register(Dt), Qe(C("toast.rename_queued", { name: o }));
          return;
        }
        P ? await ((j = Xt.value) == null ? void 0 : j.reload()) : await xt(), Ct && nd(C("toast.renamed"), Ct);
      } catch (ue) {
        const $e = ue, Ae = ue instanceof Wk ? C("e2e.names.bad_name", { name: o }) : $e.status === 409 ? C("newdoc.err.exists", { name: o }) : Gn(ue);
        Pl(Qr, g, ue, { op: "rename" }, Ae);
      } finally {
        Qr.end(g);
      }
    }
    const ys = $(/* @__PURE__ */ new Set()), Bh = /* @__PURE__ */ new Map();
    function iu(o, s) {
      const g = new Set(ys.value);
      for (const P of o)
        s ? g.add(P) : g.delete(P);
      ys.value = g;
      for (const P of xe.value) {
        const R = P.id, j = P.extra_metadata;
        typeof R == "number" && o.includes(R) && j && (j.purging = s);
      }
    }
    async function NE() {
      const o = Ke.nodes.value.map((Ae) => Ae.id).filter((Ae) => typeof Ae == "number");
      if (o.length === 0) {
        ua.value = !1;
        return;
      }
      const s = o.filter((Ae) => !ys.value.has(Ae));
      if (s.length === 0) {
        ua.value = !1, Qe(C("trash.row_busy"));
        return;
      }
      const g = ka.begin();
      if (g === null) return;
      const P = Ic("purge");
      iu(s, !0);
      let R;
      try {
        R = await S.purgeBatch(s, { queued: P });
      } catch (Ae) {
        iu(s, !1), ka.end(g), Pl(ka, g, Ae, { op: "purge" });
        return;
      }
      ka.end(g);
      const j = R.ops ?? [];
      j.length === 0 && iu(s, !1);
      const ue = (Ae) => {
        var st;
        return (st = xe.value.find((Ze) => Ze.id === Ae)) == null ? void 0 : st.storage_id;
      }, $e = /* @__PURE__ */ new Set();
      for (const Ae of j) {
        Me.register(Ae);
        const st = Ae.storage_id, Ze = j.length === 1 ? s : s.filter((Dt) => ue(Dt) === st);
        for (const Dt of Ze) $e.add(Dt);
        Bh.set(Ae.id, Ze);
      }
      if (j.length > 1 && iu(s.filter((Ae) => !$e.has(Ae)), !1), R.done === 0) {
        Pl(ka, g, new Error(R.summary), { op: "purge" }, R.summary);
        return;
      }
      ua.value = !1, Ke.clear(), Vt({ message: R.summary }, R.failed ? pn : li), j.length === 0 && At.value && await $i();
    }
    async function IE() {
      var $e, Ae, st;
      if (ka.busy.value) return;
      if (At.value) {
        if (!wo.value) {
          ua.value = !1, Qe(C("toast.trash_retention"));
          return;
        }
        await NE();
        return;
      }
      const o = wi.value, s = o ? xo.value : Ke.nodes.value, g = Nt(o ? (($e = Xt.value) == null ? void 0 : $e.getPath()) ?? "" : De.value), P = s.map((Ze) => Ze.path);
      if (P.length === 0) {
        ua.value = !1;
        return;
      }
      if (V.rootOf(P[0])) {
        const Ze = ka.begin();
        if (Ze === null) return;
        try {
          await V.remove(P) && (ua.value = !1, o || Ke.clear());
        } finally {
          ka.end(Ze);
        }
        return;
      }
      const R = s.map((Ze) => Ze.id).filter((Ze) => typeof Ze == "number"), j = S.endpoints.trashRestore && R.length === s.length ? async () => {
        const Ze = await S.restoreBatch(R);
        if (Ze.done === 0) throw new Error(Ze.summary);
        return { summary: Ze.summary };
      } : null, ue = ka.begin();
      if (ue !== null)
        try {
          if (S.endpoints.deleteAsync) {
            const { op: Ze } = await S.deleteAsync(P, g);
            j && dt.set(Ze.id, { message: C("toast.trashed"), fn: j }), Me.register(Ze), Qe(C("toast.delete_queued")), ua.value = !1, ka.end(ue);
          } else
            await S.deleteItems(g, P), ua.value = !1, ka.end(ue), o ? await ((Ae = Xt.value) == null ? void 0 : Ae.reload()) : await xt(), j && nd(C("toast.trashed"), j);
          o ? (st = Xt.value) == null || st.reload() : Ke.clear();
        } catch (Ze) {
          Pl(ka, ue, Ze, { op: "delete" });
        } finally {
          ka.end(ue);
        }
    }
    function So() {
      var o;
      if (!ni.value) {
        Qe(C("toast.read_only_here"));
        return;
      }
      (o = Zg.value) == null || o.click();
    }
    function BE(o) {
      const s = o.target, g = s.files ? Array.from(s.files) : [];
      s.value = "", Fh(g);
    }
    async function Fh(o, s, g = {}) {
      if (o.length === 0) return;
      const P = s ?? Nt(De.value);
      if (V.rootOf(P)) {
        if (!V.isOpen(V.rootOf(P))) {
          Qe(C("e2e.upload.locked"));
          return;
        }
        await V.upload(P, o);
        return;
      }
      if (fu.value) {
        Qe(C("e2e.upload.locked"));
        return;
      }
      if (qn.value) {
        const R = await LC(o, P);
        if (o = R.files, o.length === 0) return;
        if (R.sidecars.length > 0)
          try {
            await S.uploadMultipart(P, R.sidecars);
          } catch (j) {
            U("error", { message: j.message, context: { op: "e2e-name-sidecar" } }), Qe(C("e2e.names.write_failed"));
            return;
          }
      }
      for (const R of o) {
        const j = Dk.get(R);
        if (j) {
          await Uh(R, P, j) || Qe(C("e2e.upload.streaming_unsupported"));
          continue;
        }
        if (nt.shouldChunk(R)) {
          const ue = nt.resumableFor(P, R);
          if (ue && Qe(
            C("upload.resuming", {
              name: nr.get(R) ?? R.name,
              percent: R.size > 0 ? Math.round(ue.offset / R.size * 100) : 0
            })
          ), await Uh(R, P)) continue;
        }
        await Jb(R, P);
      }
      g.reload !== !1 && await xt();
    }
    function Xb() {
      return Qt.value ? `${Et.value}|${qn.value ? "open" : "locked"}` : "";
    }
    async function FE(o, s) {
      const g = Xb(), P = await _Q(o);
      for (const ue of P.unreadable) Qe(C("upload.failed", { name: ue }));
      if (P.dirs.length === 0) {
        await Fh(P.files.map((ue) => ue.file), s);
        return;
      }
      const R = V.rootOf(s);
      if (R) {
        if (!V.isOpen(R)) {
          Qe(C("e2e.upload.locked"));
          return;
        }
        const ue = P.files.map(({ file: $e, dir: Ae }) => Ae ? $Q($e, `${Ae}/${$e.name}`) : $e);
        ue.length > 0 && await V.upload(s, ue);
        for (const $e of xQ(P)) {
          const Ae = $e.lastIndexOf("/");
          await V.mkdir(Ae === -1 ? s : Ua(s, $e.slice(0, Ae)), $e.slice(Ae + 1));
        }
        return;
      }
      if (fu.value) {
        Qe(C("e2e.upload.locked"));
        return;
      }
      const j = (ue) => Xb() === g ? ue() : Promise.reject(new Error("the encrypted folder was left during the upload"));
      await SQ(P, s, {
        mkdir: (ue, $e) => j(() => Gb(ue, $e)),
        upload: (ue, $e) => j(() => Fh(ue, $e, { reload: !1 })),
        failed: (ue, $e) => {
          Qe(C("upload.failed", { name: ue })), U("error", { message: $e.message, context: { op: "upload", file: ue } });
        }
      }), await xt();
    }
    async function Jb(o, s) {
      const g = Gs(), P = s ?? Nt(De.value);
      Kn.value = [
        ...Kn.value,
        { id: g, file: o, displayName: nr.get(o), path: P, totalBytes: o.size, uploadedBytes: 0, percent: 0, status: "uploading", cancel() {
        } }
      ];
      const R = (j) => {
        const ue = Kn.value.findIndex((Ae) => Ae.id === g);
        if (ue === -1) return;
        const $e = [...Kn.value];
        $e[ue] = { ...$e[ue], ...j }, Kn.value = $e;
      };
      try {
        await S.uploadMultipart(P, [o], (j) => {
          R({ percent: j, uploadedBytes: Math.round(j / 100 * o.size) }), U("upload-progress", { uploadId: g, percent: j, done: j >= 100 });
        }), R({ percent: 100, uploadedBytes: o.size, status: "done" }), U("upload-progress", { uploadId: g, percent: 100, done: !0 });
      } catch (j) {
        const ue = j.message;
        R({ status: "error", error: ue }), Qe(C("upload.failed", { name: o.name })), U("error", {
          message: ue,
          context: { op: "upload", file: o.name }
        });
      }
    }
    async function Uh(o, s, g) {
      const P = Gs();
      let R = !1;
      const j = ($e) => {
        if (!R) {
          Kn.value = [...Kn.value, { ...$e, id: P, displayName: nr.get(o) }], R = !0;
          return;
        }
        const Ae = Kn.value.findIndex((st) => st.id === P);
        if (Ae !== -1) {
          const st = [...Kn.value];
          st[Ae] = { ...$e, id: P, displayName: nr.get(o) }, Kn.value = st;
        }
      }, ue = s ?? Nt(De.value);
      try {
        return await nt.uploadFile({
          path: ue,
          file: o,
          source: g,
          onProgress: ($e) => {
            !R && $e.status !== "uploading" && $e.uploadedBytes <= 0 || (j($e), U("upload-progress", {
              uploadId: $e.uploadId ?? P,
              percent: $e.percent,
              done: $e.status === "done"
            }));
          }
        }), !0;
      } catch ($e) {
        if (vy($e))
          return R && (Kn.value = Kn.value.filter((st) => st.id !== P)), !1;
        const Ae = $e.message;
        return R || (Kn.value = [
          ...Kn.value,
          {
            id: P,
            file: o,
            displayName: nr.get(o),
            path: ue,
            totalBytes: o.size,
            uploadedBytes: 0,
            percent: 0,
            status: "error",
            error: Ae,
            cancel() {
            }
          }
        ], R = !0), Qe(C("upload.failed", { name: nr.get(o) ?? o.name })), U("error", { message: Ae, context: { op: "upload", file: o.name } }), !0;
      }
    }
    const $o = $(0), To = $(!1);
    function Hh(o) {
      const s = o.dataTransfer;
      if (!s || s.types && s.types.includes(Vae) || lc()) return !1;
      if (s.items && s.items.length > 0) {
        let g = !1;
        for (const P of Array.from(s.items))
          if (P.kind === "file") {
            g = !0;
            break;
          }
        return g;
      }
      return s.types ? s.types.includes("Files") : !1;
    }
    function UE(o) {
      Hh(o) && (o.preventDefault(), $o.value++, To.value = !0);
    }
    function HE() {
      $o.value = Math.max(0, $o.value - 1), $o.value === 0 && (To.value = !1);
    }
    function KE(o) {
      if (Xa(o)) {
        o.preventDefault();
        return;
      }
      Hh(o) && o.preventDefault();
    }
    function VE(o) {
      if (Xa(o)) {
        const g = jv(o) || "", P = Nt(De.value), R = ff(o);
        if (R && g && P && g !== P && !At.value && ni.value) {
          o.preventDefault(), $o.value = 0, To.value = !1, vr(), gs(), ws(R.map((j) => j.path), P, g);
          return;
        }
      }
      if (Xa(o)) {
        $o.value = 0, To.value = !1, vr(), gs();
        return;
      }
      if (!Hh(o)) {
        $o.value = 0, To.value = !1;
        return;
      }
      if (o.preventDefault(), $o.value = 0, To.value = !1, !ni.value) {
        Qe(C("toast.read_only_here"));
        return;
      }
      const s = gQ(o.dataTransfer);
      s.length !== 0 && FE(s, Nt(De.value));
    }
    function Zb(o) {
      var s;
      (s = o.dataTransfer) != null && s.types.includes("Files") && o.preventDefault();
    }
    function Qb(o) {
      const s = xn.value, g = o.target;
      s && g && !s.contains(g) && o.preventDefault();
    }
    Wt(() => {
      var o, s;
      window.addEventListener("dragover", Zb), window.addEventListener("drop", Qb), window.addEventListener("pointerup", gd), window.addEventListener("blur", gd), (s = (o = ri.value) == null ? void 0 : o.onProgress) == null || s.call(o, (g) => {
        var R;
        if (!g) return;
        const P = v9(g, { quiet: jh, stoppable: !!((R = ri.value) != null && R.stop), t: C });
        if (P) {
          if (P.kind === "flash") {
            const j = g.error && g.error !== "cancelled" ? pn : li;
            K1(ca.value, "drag-out", "end") ? (ds = null, Vt({ message: P.message, source: "drag-out" }, j)) : ds = { message: P.message, ms: j };
            return;
          }
          K1(ca.value, "drag-out", "hold") && (ds = null, Vt(
            P.stoppable ? {
              message: P.message,
              actionLabel: C("dragout.stop"),
              action: () => {
                var j, ue;
                return (ue = (j = ri.value) == null ? void 0 : j.stop) == null ? void 0 : ue.call(j);
              },
              after: { kind: "plain", running: C("dragout.stopping"), done: C("dragout.stopped") },
              source: "drag-out"
            } : { message: P.message, source: "drag-out" },
            Yd
          ));
        }
      });
    });
    function gd() {
      lc() && vr();
    }
    function gs() {
      var o;
      (o = ri.value) != null && o.cancel && Promise.resolve(ri.value.cancel()).catch(() => {
      });
    }
    Ot(() => {
      window.removeEventListener("dragover", Zb), window.removeEventListener("drop", Qb), window.removeEventListener("hashchange", Ub), window.removeEventListener("pointerup", gd), window.removeEventListener("blur", gd);
    });
    const Kh = E(() => {
      const o = new Set(_t.value.mode === "cut" ? _t.value.items.map((s) => s.path) : []);
      if (At.value && ys.value.size)
        for (const s of xe.value) {
          const g = s.id;
          typeof g == "number" && ys.value.has(g) && o.add(s.path);
        }
      return o;
    });
    function ek(o, s, g) {
      (o === "split" ? Vn : Ke).click(s.path, g);
    }
    function tk(o, s, g) {
      var $e;
      if (!g.dataTransfer) return;
      if (s.basename === ".trash") {
        g.preventDefault();
        return;
      }
      const P = o === "split" ? Vn.nodes.value : Ke.nodes.value, R = Nt(o === "split" ? (($e = Xt.value) == null ? void 0 : $e.getPath()) ?? "" : De.value), ue = (P.some((Ae) => Ae.path === s.path) ? P : [s]).filter((Ae) => !Kh.value.has(Ae.path)).filter((Ae) => Ae.basename !== ".trash");
      ue.length !== 0 && nk(g, ue, R, s.mime_type, Jh(o));
    }
    function nk(o, s, g, P, R) {
      const j = p1(s, { inEncryptedFolder: R });
      if (j) {
        if (ri.value) {
          o.preventDefault(), g !== null && d9(j, g), Promise.resolve(ri.value.start(j)).catch((ue) => {
            vr(), gs(), U("error", { message: ue.message, context: { op: "drag-out" } });
          }), uk(j);
          return;
        }
        if (j.length === 1 && j[0] && o.dataTransfer) {
          const ue = j[0], $e = Dm(O.config.auth) ? S.downloadUrl(ue.path) : ik.take(ue.path), Ae = $e ? p9(ue, $e, P) : null;
          Ae && o.dataTransfer.setData("DownloadURL", Ae);
        }
      }
    }
    const ak = $(!0), ik = m9((o) => pQ(S, o), {
      onUnsupported: () => {
        ak.value = !1;
      }
    }), ok = E(() => !ri.value && !Dm(O.config.auth));
    function rk(o) {
      !o || !ok.value || Bt.value || ik.warm(o);
    }
    function bd(o) {
      if (o.pointerType === "touch" || !ok.value) return;
      const s = o.target, g = s && typeof s.closest == "function" ? s.closest("[data-fe-path]") : null, P = g == null ? void 0 : g.getAttribute("data-fe-path");
      if (!P) return;
      const R = xe.value.find((j) => j.path === P) ?? lu.value.find((j) => j.path === P);
      R && h1(R) && rk(R.path);
    }
    Wt(() => {
      var o, s;
      (o = xn.value) == null || o.addEventListener("pointerover", bd, { passive: !0 }), (s = xn.value) == null || s.addEventListener("pointerdown", bd, { capture: !0, passive: !0 });
    }), Ot(() => {
      var o, s;
      (o = xn.value) == null || o.removeEventListener("pointerover", bd), (s = xn.value) == null || s.removeEventListener("pointerdown", bd, { capture: !0 });
    });
    const ri = E(() => O.config.dragOut ?? null), sk = $(""), Vh = $(!1);
    let jh = !1, lk;
    Xe(
      () => Ke.selected.value,
      () => {
        if (!ri.value) return;
        clearTimeout(lk);
        const o = Ke.nodes.value;
        if (o.length === 0 || o.length > qae || o.some((P) => P.type !== "file")) return;
        const s = p1(o, { inEncryptedFolder: Qt.value });
        !s || o.reduce((P, R) => P + (R.size ?? 0), 0) > jae || (lk = setTimeout(() => void uk(s, !0), 400));
      },
      { deep: !0 }
    );
    async function uk(o, s = !1) {
      const g = ri.value;
      if (!g || Vh.value) return;
      const P = h9(o);
      if (P !== sk.value) {
        Vh.value = !0, jh = s;
        try {
          const R = await g.prepare(o);
          R != null && R.ready ? (sk.value = P, s || Qe(C("dragout.ready"))) : R != null && R.error && !s && Qe(R.error);
        } catch (R) {
          U("error", { message: R.message, context: { op: "drag-out-prepare" } });
        } finally {
          Vh.value = !1, jh = !1;
        }
      }
    }
    async function jE(o, s, g, P) {
      try {
        const R = P ?? Nt(De.value), j = await lm("move", o, s, R);
        if (j)
          return j.undo && j.ops.length && dt.set(j.ops[j.ops.length - 1].id, { message: C("toast.moved"), fn: j.undo }), j.ops.length && Qe(C("split.move_queued")), Ke.clear(), "queued";
        const ue = await Rb(o, s);
        if (S.endpoints.moveAsync) {
          const { op: $e } = await S.moveAsync(o, s, R);
          Nb($e.id, o, s, R, ue), Me.register($e), Qe(C(ue ? "toast.move_kept_both" : "split.move_queued"));
        } else if (await S.move(R, o, s), await xt(), ue)
          Qe(C("toast.move_kept_both"));
        else {
          const $e = o.map((Ae) => Ua(s, Ti(Ae)));
          nd(C("toast.moved"), async () => {
            await S.move(s, $e, R);
          });
        }
        return Ke.clear(), S.endpoints.moveAsync ? "queued" : "done";
      } catch (R) {
        return Ml(R, { op: g, targetDir: s }), "refused";
      }
    }
    async function ck(o, s) {
      if (o.type !== "dir") return;
      const g = ff(s);
      if (!g || g.length === 0) return;
      vr(), gs();
      const P = o.path, R = g.map((j) => j.path).filter((j) => j && j !== P && !P.startsWith(j + "/") && !_h(Qi(j), P));
      R.length !== 0 && await ws(R, P, Pk(s));
    }
    async function dk(o, s) {
      const g = ff(s);
      if (!g || g.length === 0) return;
      vr(), gs();
      const P = o, R = g.map((j) => j.path).filter((j) => j && j !== P && !P.startsWith(j + "/") && !_h(Qi(j), P));
      R.length !== 0 && await ws(R, P, Pk(s));
    }
    function qE(o) {
      o.cancel();
    }
    function WE(o) {
      Kn.value = Kn.value.filter((s) => s.id !== o.id);
    }
    function YE(o) {
      if (wn.value && !o) {
        xt("");
        return;
      }
      if (wn.value) {
        xt(ko(o));
        return;
      }
      xt(Fa(o));
    }
    async function kd(o) {
      try {
        await navigator.clipboard.writeText(o), Qe(C("breadcrumb.copy_path"));
      } catch {
      }
    }
    function Xn(o = {}) {
      return S.authHeaders({ ...o });
    }
    function fk(o) {
      if (/^[a-z][a-z0-9+.-]*:\/\//i.test(o)) return o;
      const s = O.config.apiBase;
      if (!s) return o;
      try {
        return new URL(o, s.endsWith("/") ? s : `${s}/`).toString();
      } catch {
        return o;
      }
    }
    const pk = E(
      () => O.config.viewerBaseUrl ? fk(O.config.viewerBaseUrl) : ay(O.config.apiBase, Wae)
    ), wd = $(!1), { themeId: _d, setTheme: GE } = HW(), { themeMode: ou, setThemeMode: hk } = VW(), gn = E(
      () => ou.value === "host" ? O.config.theme || "auto" : ou.value
    );
    xL({ locale: q, theme: gn });
    const XE = xl(), qh = E(
      () => gn.value === "dark" || gn.value !== "light" && XE.value
    );
    Xe(
      [_d, qh, xn],
      () => {
        XW(_d.value), xn.value && jW(xn.value, _d.value, qh.value);
      },
      { immediate: !0 }
    );
    const ru = $(!1), eo = $(!1), Ci = $(null);
    function JE() {
      if (eo.value) {
        eo.value = !1;
        return;
      }
      const o = Ke.nodes.value, s = o.length === 1 ? o[0] : null;
      if (!(!s || s.type !== "file" || s.basename === ".trash")) {
        if (Ri(s) && !Qt.value && !s.e2e_root) {
          Pt.open(s);
          return;
        }
        if (Qt.value) {
          if (!qn.value) return;
          (async () => {
            try {
              await Md(s);
            } catch {
              Qe(C("e2e.decrypt_failed"));
              return;
            }
            Ci.value = s, eo.value = !0, Na(s);
          })();
          return;
        }
        Ci.value = s, eo.value = !0, Na(s);
      }
    }
    function ZE(o) {
      const s = xe.value.filter((j) => j.type === "file");
      if (s.length === 0) return;
      const g = Ci.value;
      let P = g ? s.findIndex((j) => j.path === g.path) : -1;
      P = P === -1 ? o > 0 ? 0 : s.length - 1 : (P + o + s.length) % s.length;
      const R = s[P];
      !R || R.path === (g == null ? void 0 : g.path) || Ke.click(R.path);
    }
    function QE() {
      const o = Ci.value;
      eo.value = !1, o && Ha(o);
    }
    Xe(
      () => Ke.nodes.value,
      (o) => {
        var g, P;
        if (!eo.value) return;
        const s = o.length === 1 && o[0].type === "file" ? o[0] : null;
        if (s && s.path !== ((g = Ci.value) == null ? void 0 : g.path) && qn.value) {
          (async () => {
            try {
              await Md(s);
            } catch {
            }
            Ci.value = s, Na(s);
          })();
          return;
        }
        s && s.path !== ((P = Ci.value) == null ? void 0 : P.path) && (Ci.value = s, Na(s));
      }
    );
    const su = tG();
    function eC(o) {
      Kn.value = Kn.value.filter((P) => P.id !== o.id);
      const s = o.file, g = o.path || Nt(De.value);
      (async () => {
        if (nt.shouldChunk(s) && await Uh(s, g)) {
          await xt();
          return;
        }
        await Jb(s, g), await xt();
      })();
    }
    const xd = $(!1);
    let Sd;
    function Wh() {
      xd.value = !0;
    }
    function tC() {
      var o;
      xd.value = !1, g$(), (o = xn.value) == null || o.focus();
    }
    function mk() {
      Wh();
    }
    Wt(() => {
      var o;
      (o = xn.value) == null || o.addEventListener("fe:tour-restart", mk), Sd = oG(() => {
        xd.value || Wh();
      });
    }), Ot(() => {
      var o;
      Sd == null || Sd(), (o = xn.value) == null || o.removeEventListener("fe:tour-restart", mk);
    });
    function nC() {
      return ud() === "none" ? null : Ve ? `${t0}:${Ve}` : t0;
    }
    const Fn = XJ({ storageKey: nC() }), aC = Fn.restore(), Yh = Fn.activeId, to = E(() => {
      var o;
      return ((o = Fn.activeTab.value) == null ? void 0 : o.split) ?? null;
    });
    function iC(o) {
      const s = (o || "").replace(/^\/+|\/+$/g, ""), g = Nf(s.split("/").pop() || s, C);
      if (g) return g;
      if (!s) return wn.value ? C("breadcrumb.root") : kt.value || C("breadcrumb.root");
      const P = Ut.segmentLabel(Nt(s));
      return P !== null ? P : s.split("/").pop() || s;
    }
    const vk = E(
      () => Fn.tabs.value.map((o) => ({ id: o.id, label: iC(o.path), split: !!o.split }))
    ), yk = E(
      () => (
        /* gezinti:g1 — the simple profile has no tab strip at all, not even once a
           second tab exists: tabs were the first thing #14 named as power-user
           chrome. The tab STATE is untouched, so switching the profile back brings
           the strip and its tabs straight back. */
        !Ul.value && (Fn.hasMultiple.value || O.config.tabStrip !== "auto" && vk.value.length > 0)
      )
    );
    Xe(De, (o) => Fn.syncActive({ path: o })), Xe(ve, (o) => Fn.syncActive({ viewMode: o })), Wt(() => {
      aC || Fn.seed(De.value ?? "", ve.value);
    });
    function $d(o) {
      !on.value && o.viewMode && o.viewMode !== ve.value && (ve.value = o.viewMode);
      const s = () => nn(In.value);
      if (o.path === ".trash") {
        $i().then(s, s);
        return;
      }
      xt(o.path).then(s, s);
    }
    function oC(o) {
      const s = Fn.activate(o);
      s && $d(s);
    }
    function Gh() {
      Fn.openTab(De.value ?? "", { viewMode: ve.value, background: !1 });
    }
    function gk(o) {
      const s = Fn.closeTab(o);
      s && $d(s);
    }
    function rC() {
      const o = Fn.step(1);
      o && $d(o);
    }
    function sC() {
      const o = Fn.step(-1);
      o && $d(o);
    }
    function bk(o) {
      if (o.type !== "dir" || o.basename === ".trash") return;
      const s = wn.value ? ko(o.path) : Fa(o.path);
      Fn.openTab(s, { viewMode: ve.value, background: !0 });
    }
    function kk(o) {
      if (o.button !== 1) return;
      const s = o.target, g = s && typeof s.closest == "function" ? s.closest("[data-fe-path]") : null, P = g == null ? void 0 : g.getAttribute("data-fe-path");
      if (!P) return;
      const R = xe.value.find((j) => j.path === P);
      !R || R.type !== "dir" || R.basename === ".trash" || (o.preventDefault(), bk(R));
    }
    function wk(o) {
      if (o.button !== 1) return;
      const s = o.target;
      s && typeof s.closest == "function" && s.closest("[data-fe-path]") && o.preventDefault();
    }
    Wt(() => {
      var o, s;
      (o = xn.value) == null || o.addEventListener("auxclick", kk), (s = xn.value) == null || s.addEventListener("mousedown", wk);
    }), Ot(() => {
      var o, s;
      (o = xn.value) == null || o.removeEventListener("auxclick", kk), (s = xn.value) == null || s.removeEventListener("mousedown", wk);
    });
    const lC = $(null), Xt = $(null), lu = $([]), Vn = Iw(
      () => {
        var o;
        return lu.value.length ? lu.value : ((o = Xt.value) == null ? void 0 : o.visibleNodes()) ?? [];
      }
    ), uu = $({ ...Ro }), uC = E(() => {
      var R;
      if (!on.value) return "";
      const o = String(((R = Xt.value) == null ? void 0 : R.getPath()) ?? "").replace(/^\/+|\/+$/g, "");
      if (!o) return "";
      const [s, ...g] = o.split("/"), P = (O.config.storages ?? []).find((j) => j.name === s);
      return f_((P == null ? void 0 : P.uid) || s, g.join("/"));
    }), cC = E(
      () => yk.value || eb.value || cu.value
    ), Td = E(() => ft.value === "home" ? "home" : ft.value === "drafts" ? "drafts" : be.value && xe.value.length === 0 ? "" : Se.value ? "notfound" : Z.value && xe.value.length === 0 ? "" : fu.value ? "locked" : ""), cu = E(() => !Pa.value && !Ul.value), bs = E(
      () => !!to.value && cu.value
      /* gezinti:g1 */
    );
    function _k() {
      if (to.value) {
        Fn.setSplit(null), si.value = "main";
        return;
      }
      cu.value && Fn.setSplit({ path: De.value ?? "", viewMode: ve.value });
    }
    function dC() {
      Fn.setSplit(null), si.value = "main";
    }
    function fC(o) {
      Fn.setSplit({ ...to.value ?? {}, path: o }), Hs(uu.value) && (uu.value = { ...Ro }), Vn.clear(), lu.value = [];
    }
    function pC(o, s) {
      var g;
      if (s.type === "dir" && s.basename !== ".trash") {
        (g = Xt.value) == null || g.loadFolder(
          /* A multi-storage drive row's path is already the wire form for that
             storage's root; a real row needs converting. The predicate comes from
             `lib/fileIcons`, which is that concept's one home. */
          vi(s) === "storage" ? s.path : zi(s.path)
        );
        return;
      }
      Ha(s);
    }
    function hC() {
      si.value = "main", $i();
    }
    const xk = E(() => {
      var o;
      return ((o = to.value) == null ? void 0 : o.viewMode) ?? ve.value;
    });
    function Sk(o) {
      to.value && Fn.setSplit({ ...to.value, viewMode: o });
    }
    const Xh = E(
      () => Tn.value ? xk.value : ve.value
    );
    function $k(o) {
      Tn.value ? Sk(o) : ve.value = o;
    }
    const si = $("main");
    function mC() {
      si.value = "main";
    }
    Xe(bs, (o) => {
      o || (si.value = "main");
    });
    const Tn = E(() => si.value === "split" && bs.value), vC = E(() => bs.value && si.value === "main"), Ad = E(() => Tn.value ? "split" : "main"), ks = $(null);
    function Jh(o) {
      var s;
      return o === "split" ? !!((s = Xt.value) != null && s.e2eRoot()) : Qt.value;
    }
    const Tk = E(
      () => {
        var o;
        return Tn.value ? ((o = Xt.value) == null ? void 0 : o.getPath()) ?? "" : De.value ?? "";
      }
    );
    function yC(o) {
      var s;
      return o === "split" ? ((s = Xt.value) == null ? void 0 : s.getPath()) ?? "" : De.value ?? "";
    }
    function gC(o) {
      var s;
      return o === "split" ? ((s = Xt.value) == null ? void 0 : s.rowPaths()) ?? [] : xe.value.map((g) => g.path);
    }
    Xe(
      () => ra(),
      (o) => {
        o.length && (ks.value = {
          nodes: o,
          pane: Ad.value,
          path: Tk.value,
          // Where the item was when it was selected: a held item keeps the
          // folder it came from, whatever folder the pane shows now.
          inEncrypted: Jh(Ad.value)
        });
      },
      { deep: !1 }
    );
    const Ed = E(() => {
      const o = ks.value;
      if (!o || !o.nodes.length || o.pane === "split" && !bs.value) return !1;
      if (yC(o.pane) !== o.path) return !0;
      const s = new Set(gC(o.pane));
      return o.nodes.some((g) => s.has(g.path));
    });
    Xe(Ed, (o) => {
      o || (ks.value = null);
    });
    const bC = E(() => ra().length === 0 && Ed.value), Ak = E(() => {
      var s;
      const o = ra();
      return o.length ? o : Ed.value ? ((s = ks.value) == null ? void 0 : s.nodes) ?? [] : [];
    }), kC = E(() => {
      const o = Ak.value;
      return o.length === 1 && I.value ? vd([o[0].path]) : void 0;
    }), wC = E(
      () => {
        var o;
        return ra().length ? Jh(Ad.value) : Ed.value && ((o = ks.value) == null ? void 0 : o.inEncrypted) === !0;
      }
    ), _C = E(
      () => {
        var o;
        return bC.value ? ch(((o = ks.value) == null ? void 0 : o.path) ?? "") : "";
      }
    ), xC = E(() => ch(Tk.value)), SC = E(
      () => {
        var o;
        return Tn.value ? ((o = Xt.value) == null ? void 0 : o.rowCount()) ?? 0 : xe.value.length;
      }
    ), $C = E(
      () => {
        var o;
        return Tn.value ? ((o = Xt.value) == null ? void 0 : o.dirPerm()) ?? "" : Ne.value;
      }
    );
    function zi(o) {
      return wn.value ? ko(o) : Fa(o);
    }
    function Ek(o) {
      const s = String(o ?? "").replace(/^\/+|\/+$/g, "");
      return Te && (!s || !(s === Te || s.startsWith(Te + "/"))) ? Te : s;
    }
    function Ck() {
      var s;
      const o = Vn.nodes.value;
      o.length !== 0 && (_t.value = { mode: "cut", items: o, sourcePath: ((s = Xt.value) == null ? void 0 : s.getPath()) ?? "" }, Qe(C("toast.cut")));
    }
    function zk() {
      var s;
      const o = Vn.nodes.value;
      o.length !== 0 && (_t.value = { mode: "copy", items: o, sourcePath: ((s = Xt.value) == null ? void 0 : s.getPath()) ?? "" }, Qe(C("toast.copied")));
    }
    async function Mk() {
      const o = _t.value, s = Xt.value;
      if (!o.mode || o.items.length === 0 || !s) return;
      const g = Nt(s.getPath() ?? ""), P = Nt(o.sourcePath || "") || void 0;
      if (o.mode === "cut" && P === g) {
        Qe(C("toast.same_folder_cut"));
        return;
      }
      await ws(o.items.map((R) => R.path), g, P, o.mode === "copy" ? "copy" : "move"), _t.value = { mode: null, items: [], sourcePath: null };
    }
    function Pk(o) {
      return jv(o);
    }
    async function ws(o, s, g, P = "auto") {
      var Ae, st, Ze;
      const R = o.filter(
        (Dt) => Dt && Dt !== s && !s.startsWith(Dt + "/") && !_h(Qi(Dt), s)
      );
      if (R.length === 0 || !s) return "nothing";
      const j = Uk(R, s);
      if (j === "cross")
        return Qe(C("e2e.vault.cross")), "refused";
      if (j === "inside") {
        const Dt = P === "copy" ? await V.copy(R, s) : await V.move(R, s);
        return (Ae = Xt.value) == null || Ae.reload(), Dt ? "done" : "refused";
      }
      const ue = F1(R, s, P);
      let $e;
      if (ue.kind === "copy")
        try {
          if (await lm("copy", R, s))
            return Qe(C("split.copy_queued")), (st = Xt.value) == null || st.reload(), "queued";
          const { op: Sn } = await S.copy(R, s);
          Me.register(Sn), Qe(ue.cross ? C("split.cross_copy") : C("split.copy_queued")), $e = "queued";
        } catch (Dt) {
          return Ml(Dt, { op: "transfer", targetWire: s }), "refused";
        }
      else
        ue.cross && Qe(C("split.cross_move")), $e = await jE(R, s, "move-transfer", g);
      return (Ze = Xt.value) == null || Ze.reload(), $e;
    }
    function Ok(o) {
      ws(o.sources, o.targetWire, o.originWire);
    }
    const an = FD(), jn = $(0), Dk = /* @__PURE__ */ new WeakMap(), Pt = jZ({
      api: S,
      chunked: nt,
      locale: () => q.value,
      t: (o, s) => C(o, s),
      toast: (o, s) => Vt({ message: o }, s ? pn : li),
      emitError: (o, s) => U("error", { message: o, context: { op: s } }),
      escrowPublicKey: () => lr.value,
      escrowKid: () => Ka.value,
      registerOp: (o) => Me.register(o),
      reload: () => xt(),
      openPreview: (o, s) => {
        no.set(o.path, s), Ia.value = "view", cn.value = o, oa.value = !0, U("file-opened", { path: o.path, basename: o.basename }), o.fxe_name && (xe.value = xe.value.map((g) => g.path === o.path ? { ...g, fxe_name: o.fxe_name } : g));
      },
      showRecoveryKey: (o, s) => {
        Eo.value = o, Co.value = s, rr.value = "file", Ao.value = !0;
      },
      /* wiring:e2 policy — "Request encryption…" on a plain file. */
      requestEncrypt: (o) => Qh(o.path, "file", o.basename)
    }), du = E(() => {
      var o;
      return !!((o = cn.value) != null && o.fxe_name);
    }), Ut = zL({
      api: S,
      ring: an,
      lockedLabel: () => C("e2e.names.locked_item"),
      unreadableLabel: () => C("e2e.names.unreadable_item"),
      fileName: (o) => Pt.realName(o)
    });
    wr(Tc, Ut);
    const TC = nZ((o, s) => {
      Ut.version.value;
      const g = Ut.rootOf(o, s);
      if (!g || !an.names(g)) return null;
      const P = Ut.segmentLabel(o);
      return !P || P === "…" ? null : { name: P, path: Ut.displayPath(o) };
    });
    Ot(TC);
    const nr = /* @__PURE__ */ new WeakMap(), Lk = $([]), Et = $(""), no = /* @__PURE__ */ new Map(), Qt = E(() => !!Et.value && !At.value), qn = E(() => (jn.value, Qt.value && an.has(Et.value))), fu = E(() => (jn.value, Qt.value && !an.has(Et.value))), Cd = $(!1), Zh = $(""), ar = $(!1), ir = $(!1), Rk = E(
      () => ia.value && !Qt.value && ni.value ? vh(Nt(De.value), "new_folder") : "denied"
    ), or = $(null);
    function Qh(o, s, g) {
      or.value = { path: o, kind: s, name: g };
    }
    function AC() {
      ia.value = !1, Qh(Nt(De.value), "new_folder", ch(De.value));
    }
    function EC(o) {
      or.value = null, Qe(o.created ? C("e2e.request.sent") : C("e2e.request.already"));
    }
    const en = $(null), zd = $(!1), em = $(!1), ao = $(null), Ao = $(!1), Eo = $(""), rr = $("created"), Co = $(""), _s = $(!1), sr = $(""), pu = $(!1), zo = $(!1), hu = $("unlock"), Mi = $(""), Pi = $(!1), Oi = $(""), lr = E(
      () => {
        var o, s;
        return ((s = (o = ee.value) == null ? void 0 : o.e2e_escrow) == null ? void 0 : s.public_key) || null;
      }
    ), Ka = E(
      () => {
        var o, s;
        return ((s = (o = ee.value) == null ? void 0 : o.e2e_escrow) == null ? void 0 : s.kid) || null;
      }
    );
    function tm() {
      return an.get(Et.value) ?? null;
    }
    function nm() {
      for (const o of no.values()) URL.revokeObjectURL(o);
      no.clear();
    }
    Ot(nm);
    async function Nk(o, s) {
      var $e;
      let g = "";
      try {
        const { blob: Ae, url: st } = await S.fetchBlob(Ua(o, ha), { fresh: !0 });
        URL.revokeObjectURL(st), g = await Ae.text();
      } catch {
        return C("e2e.unlock.marker_missing");
      }
      const P = Lf(g);
      if (!P) return C("e2e.unlock.marker_missing");
      const R = o === Et.value;
      if (P.unsupported.length > 0)
        return R && (Lk.value = P.unsupported), C("e2e.unlock.unsupported", { features: P.unsupported.join(", ") });
      const j = P.marker;
      R && (en.value = j);
      const ue = await nx(j, s);
      return "error" in ue ? ue.error === "damaged" ? C("e2e.unlock.damaged") : C("e2e.unlock.wrong") : await Ik(o, j, ue.fmk) ? (R && (j.v === 1 ? (sr.value = s, _s.value = !0) : s_(j, Ka.value) === "offer" && (Mi.value = s, hu.value = "unlock", Oi.value = "", zo.value = !0)), R && await xt(), ($e = Xt.value) == null || $e.reload(), null) : Or(j) ? C("e2e.vault.open_failed") : C("e2e.names.key_failed");
    }
    async function CC(o) {
      if (!(!o || Cd.value || !Et.value)) {
        Cd.value = !0, Zh.value = "";
        try {
          const s = await Nk(Et.value, o);
          s && (Zh.value = s);
        } finally {
          Cd.value = !1;
        }
      }
    }
    wr(b$, {
      locked: (o) => (jn.value, !an.has(o)),
      unlock: Nk,
      recovery: (o) => {
        si.value = "main", xt(zi(o)).then(() => {
          Et.value === o && Vk();
        });
      }
    });
    async function Ik(o, s, g) {
      if (Or(s)) {
        an.set(o, g, null, null), Ut.setMarker(o, s), jn.value++, a().catch(() => {
        });
        try {
          await V.open(o, s, g, { perm: o === Et.value && Ne.value || void 0 });
        } catch (j) {
          return an.lock(o), jn.value++, U("error", { message: (j == null ? void 0 : j.message) ?? String(j), context: { op: "e2e-vault-open" } }), !1;
        }
        return !0;
      }
      let P = null;
      if (Ui(s) && (P = await CD(s, g), !P))
        return !1;
      let R = null;
      return Zs(s) && (R = await LD(s, g), !R) ? !1 : (an.set(o, g, P, R), Ut.setMarker(o, s), jn.value++, !0);
    }
    function am() {
      if (!Et.value) return;
      const o = Et.value;
      V.isOpen(o) && V.close(o, "manual"), an.lock(o), Ut.forget(o), jn.value++, nm();
      const s = Kk(o);
      Di.value = !1, As = null, Ts.value = !1, s ? Vt({ message: s }, pn) : Qe(C("e2e.locked_toast")), xt();
    }
    function Bk(o) {
      return Ks(o.extension);
    }
    async function Md(o) {
      const s = no.get(o.path);
      if (s) return s;
      if (V.isVaultRow(o)) {
        const ue = await V.readUrl(o.path, Bk(o));
        return no.set(o.path, ue), ue;
      }
      const g = tm();
      if (!g) return null;
      const P = await S.fetchArrayBuffer(o.path);
      if (!cl(P)) return null;
      const R = await BD(g, an.previous(Et.value), P), j = URL.createObjectURL(new Blob([R], { type: Bk(o) }));
      return no.set(o.path, j), j;
    }
    function Pd(o) {
      return no.get(o) ?? S.previewUrl(o);
    }
    async function xs(o) {
      try {
        await Md(o);
      } catch {
        Qe(C("e2e.decrypt_failed"));
        return;
      }
      Ia.value = "view", gi.value = Io, cn.value = o, oa.value = !0, U("file-opened", { path: o.path, basename: o.basename }), Na(o);
    }
    const zC = A6(
      (o) => {
        const s = Ut.rootOf(o, Qt.value ? Et.value : null), g = s ? an.get(s) : void 0;
        return s && g ? { fmk: g, previous: an.previous(s) ?? null } : null;
      },
      /* a vault's file: the vault engine reads and writes it (useE2eVault). */
      C6(V)
    ), mu = $(!1);
    function MC(o) {
      mu.value = o;
      const s = cn.value;
      o && s && V.isVaultRow(s) && V.touch(s.path), o || Fk();
    }
    Xe(oa, (o) => {
      o || (mu.value = !1, Fk());
    });
    let vu = null;
    function PC(o, s) {
      const g = cn.value;
      if (!oa.value || !g || !Us(g.path, o) || !mu.value || !s.app_lock_soon || !s.app_lock_soon_keep) return;
      const P = s.app_lock_kept || s.app_lock_soon_keep;
      vu = {
        message: s.app_lock_soon,
        actionLabel: s.app_lock_soon_keep,
        action: () => V.touch(o),
        after: { kind: "plain", running: P, done: P }
      }, Vt(vu, Gae);
    }
    function Fk() {
      var o;
      vu && ((o = ca.value) == null ? void 0 : o.message) === vu.message && bh(), vu = null;
    }
    const OC = E(() => Rg.value && Fp(cn.value) ? zC : null);
    async function DC(o) {
      if (V.isVaultRow(o)) {
        await V.download([o]);
        return;
      }
      const s = tm();
      if (!s) {
        Qe(C("e2e.download.failed"));
        return;
      }
      await Pt.downloadFolderFile(o, s, an.previous(Et.value), Et.value);
    }
    async function LC(o, s) {
      const g = tm();
      if (!g) return { files: [], sidecars: [] };
      const P = [], R = [];
      await sm(s);
      const j = !!Ut.writesEncrypted(s);
      for (const ue of o)
        if (ue.name !== ha) {
          if (j && ji(ue.name)) {
            Qe(C("e2e.names.bad_name", { name: ue.name }));
            continue;
          }
          try {
            const $e = ue.size > Nu ? await Pt.folderUploadSource(ue, g) : null, Ae = $e ? null : await Tv(g, await ue.arrayBuffer());
            let st = ue.name;
            if (j) {
              const Dt = await Ut.nameForWrite(s, ue.name);
              if (!Dt) throw new Error("e2e: the folder name key is missing");
              st = Dt.stored, Dt.sidecar && R.push(new File([Dt.sidecar.content], Dt.sidecar.name, { type: "text/plain" }));
            }
            const Ze = new File(Ae ? [Ae] : [], st, { type: "application/octet-stream" });
            $e && Dk.set(Ze, $e), j && nr.set(Ze, ue.name), P.push(Ze);
          } catch ($e) {
            U("error", { message: $e.message, context: { op: "e2e-encrypt" } });
          }
        }
      return { files: P, sidecars: R };
    }
    async function RC(o) {
      if (Qt.value) {
        Qe(C("e2e.create.nested"));
        return;
      }
      if (o.level === "vault") {
        await NC(o);
        return;
      }
      ir.value = !0;
      let s = !1;
      try {
        const g = Nt(De.value);
        await S.newFolder(g, o.name), s = !0;
        const { marker: P, fmk: R, recoveryKey: j, names: ue } = await $v(o.password, {
          escrowPublicKey: lr.value,
          encryptNames: o.level === "names"
        }), $e = new File([JSON.stringify(P)], ha, {
          type: "application/json"
        }), Ae = Ua(g, o.name);
        await S.uploadMultipart(Ae, [$e]), an.set(Ae, R, ue ?? null), Ut.setMarker(Ae, P), jn.value++, ar.value = !1, Eo.value = j, Co.value = o.name, rr.value = "created", Ao.value = !0, await xt();
      } catch (g) {
        U("error", { message: g.message, context: { op: "e2e-create" } }), Vt({ message: Gn(g, C("e2e.create.failed")) }, pn), s && await xt();
      } finally {
        ir.value = !1;
      }
    }
    async function NC(o) {
      var s;
      if (((s = ee.value) == null ? void 0 : s.e2e_vault) !== !0) {
        Vt({ message: C("e2e.create.failed") }, pn);
        return;
      }
      ir.value = !0;
      try {
        const g = Nt(De.value), P = Ua(g, o.name), R = await xD(o.password, {
          escrowPublicKey: lr.value,
          packLog2: o.packLog2
        });
        await V.create(P, R.marker, R.index), an.set(P, R.fmk, null, null), Ut.setMarker(P, R.marker), jn.value++, a().catch(() => {
        }), await V.open(P, R.marker, R.fmk, { justMade: !0, perm: Ne.value || void 0 }), ar.value = !1, Eo.value = R.recoveryKey, Co.value = o.name, rr.value = "created", Ao.value = !0, await xt();
      } catch (g) {
        U("error", { message: g.message, context: { op: "e2e-vault-create" } }), Vt({ message: Gn(g, C("e2e.create.failed")) }, pn);
      } finally {
        ir.value = !1;
      }
    }
    function Uk(o, s) {
      const g = V.rootOf(s), P = o.map((R) => V.rootOf(R));
      return !g && P.every((R) => !R) ? "none" : g && V.isOpen(g) && P.every((R) => R === g) ? "inside" : "cross";
    }
    const im = E(() => {
      V.version.value;
      const o = Et.value;
      return o ? V.strips[o] ?? null : null;
    }), yu = E(() => !!cn.value && V.isVaultRow(cn.value)), IC = E(() => [...Ke.nodes.value, ...xo.value].some((o) => V.isVaultRow(o)));
    function om(o, s) {
      return !!o && (o === s || o.startsWith(s + "/"));
    }
    function Hk(o, s) {
      var g;
      for (const [P, R] of [...no])
        om(P, o) && ((s || P !== ((g = cn.value) == null ? void 0 : g.path)) && URL.revokeObjectURL(R), no.delete(P));
    }
    let rm = "";
    function Kk(o) {
      const s = cn.value;
      if (!oa.value || !s || !Us(s.path, o)) return "";
      const g = mu.value;
      return oa.value = !1, mu.value = !1, g ? C("e2e.app_closed_unsaved", { name: s.basename }) : "";
    }
    function BC(o) {
      var s;
      an.lock(o), Ut.forget(o), jn.value++, rm = Kk(o), om((s = Ci.value) == null ? void 0 : s.path, o) && (eo.value = !1), Hk(o, !0);
    }
    function FC(o, s) {
      var P;
      const g = rm;
      if (rm = "", s === "idle") {
        const R = C("e2e.vault.locked_idle_toast", { name: Ti(o) });
        Vt({ message: g ? `${R} ${g}` : R }, g ? 12e3 : 8e3);
      } else g && Vt({ message: g }, pn);
      (Et.value === o || om(Nt(De.value), o)) && (Di.value = !1, xt(zi(o))), (P = Xt.value) == null || P.reload();
    }
    function UC(o) {
      var s;
      Hk(o, !1), Et.value === o && xt(), (s = Xt.value) == null || s.reload();
    }
    async function HC(o) {
      if (!(!en.value || !Et.value)) {
        em.value = !0, ao.value = null;
        try {
          let s = null;
          if (o.mode === "recovery") {
            if (s = await ax(en.value, o.value), !s) {
              ao.value = C("e2e.recover.wrong_recovery");
              return;
            }
          } else {
            let g;
            try {
              g = await G2(o.value);
            } catch {
              ao.value = C("e2e.recover.bad_escrow_key");
              return;
            }
            if (s = await ix(en.value, g), !s) {
              ao.value = C("e2e.recover.wrong_escrow");
              return;
            }
            try {
              const P = await S.e2eEscrowChallenge(Et.value), R = new Uint8Array(
                await crypto.subtle.decrypt(
                  { name: "RSA-OAEP" },
                  g,
                  Zn(P.challenge).buffer
                )
              );
              await S.e2eEscrowUsed({
                path: Et.value,
                id: P.id,
                nonce: Aa(R)
              });
            } catch (P) {
              ao.value = C("e2e.recover.notify_failed"), U("error", {
                message: P.message,
                context: { op: "e2e-escrow-notify" }
              });
              return;
            }
          }
          if (!await Ik(Et.value, en.value, s)) {
            ao.value = C("e2e.names.key_failed");
            return;
          }
          zd.value = !1, Qe(
            o.mode === "escrow" ? C("e2e.recover.escrow_done") : C("e2e.recover.recovery_done")
          ), await xt(), o.mode === "recovery" && (As = o.value, ew("reset"));
        } catch (s) {
          ao.value = s.message;
        } finally {
          em.value = !1;
        }
      }
    }
    async function Vk() {
      if (!en.value && Et.value)
        try {
          const { blob: o, url: s } = await S.fetchBlob(Ua(Et.value, ha), { fresh: !0 });
          URL.revokeObjectURL(s);
          const g = Lf(await o.text());
          en.value = g && g.unsupported.length === 0 ? g.marker : null;
        } catch {
          en.value = null;
        }
      ao.value = null, zd.value = !0;
    }
    async function KC() {
      if (!(!en.value || !Et.value || !sr.value)) {
        pu.value = !0;
        try {
          const o = await SD(en.value, sr.value, {
            escrowPublicKey: lr.value
          }), s = new File([JSON.stringify(o.marker)], ha, {
            type: "application/json"
          });
          await S.uploadMultipart(Et.value, [s]), en.value = o.marker, Ut.setMarker(Et.value, o.marker), _s.value = !1, sr.value = "", Eo.value = o.recoveryKey, Co.value = Ti(Et.value), rr.value = "upgraded", Ao.value = !0;
        } catch (o) {
          U("error", { message: o.message, context: { op: "e2e-upgrade" } }), Qe(C("e2e.upgrade.failed"));
        } finally {
          pu.value = !1;
        }
      }
    }
    const jk = E(() => s_(en.value, Ka.value));
    function VC() {
      hu.value = "manual", Mi.value = "", Oi.value = "", zo.value = !0;
    }
    async function Mo(o) {
      const s = new File([JSON.stringify(o)], ha, { type: "application/json" });
      await S.uploadMultipart(Et.value, [s]), en.value = o, Ut.setMarker(Et.value, o);
    }
    async function qk() {
      const o = en.value, s = lr.value;
      if (!(!o || !s || !Et.value || Pi.value)) {
        if (!Mi.value) {
          Oi.value = C("e2e.escrowoffer.password_required");
          return;
        }
        Pi.value = !0, Oi.value = "";
        try {
          const g = await $D(o, Mi.value, s);
          await Mo(g), zo.value = !1, Mi.value = "", Qe(C("e2e.escrowoffer.done"));
        } catch (g) {
          (g == null ? void 0 : g.name) === "E2eDecryptError" ? Oi.value = C("e2e.escrowoffer.wrong_password") : (Oi.value = C("e2e.escrowoffer.failed"), U("error", { message: g.message, context: { op: "e2e-escrow-offer" } }));
        } finally {
          Pi.value = !1;
        }
      }
    }
    async function jC() {
      const o = en.value;
      if (!(!o || !Et.value || Pi.value)) {
        Pi.value = !0;
        try {
          await Mo(TD(o, (/* @__PURE__ */ new Date()).toISOString())), zo.value = !1, Mi.value = "", Qe(C("e2e.escrowoffer.declined_toast"));
        } catch (s) {
          Oi.value = C("e2e.escrowoffer.decline_failed"), U("error", { message: s.message, context: { op: "e2e-escrow-decline" } });
        } finally {
          Pi.value = !1;
        }
      }
    }
    function qC() {
      zo.value = !1, Mi.value = "", Oi.value = "";
    }
    function WC() {
      _s.value = !1, sr.value = "";
    }
    class Wk extends Error {
      constructor(s) {
        super(`e2e: invalid name (${s})`), this.problem = s, this.name = "E2eNameRefused";
      }
    }
    async function Yk(o, s, g = {}) {
      if (await sm(o), !Ut.writesEncrypted(o)) return s;
      const P = ji(s);
      if (P) throw new Wk(P);
      const R = await Ut.nameForWrite(o, s, g);
      return R ? (R.sidecar && await S.uploadMultipart(o, [
        new File([R.sidecar.content], R.sidecar.name, { type: "text/plain" })
      ]), R.stored) : s;
    }
    async function sm(o) {
      const s = Et.value;
      if (!s) return;
      const g = o.replace(/\/+$/, ""), P = s.replace(/\/+$/, "");
      (g === P || g.startsWith(P.endsWith("://") ? P : `${P}/`)) && await Ut.markerFor(s);
    }
    async function lm(o, s, g, P) {
      await sm(g);
      const R = Ut.writesEncrypted(g);
      if (!R || !an.names(R) || !s.every((Ze) => Ut.rootOf(Ze) === R)) return null;
      const j = [], ue = [], $e = (Ze, Dt) => Ze.replace(/\/+$/, "") === Dt.replace(/\/+$/, "");
      let Ae = /* @__PURE__ */ new Set();
      try {
        Ae = new Set(((await S.index(g)).files ?? []).map((Ze) => Ze.basename));
      } catch {
      }
      for (const Ze of s) {
        const Dt = Qi(Ze);
        if (o === "move" && $e(Dt, g)) continue;
        const Sn = Ti(Ze), Ct = await Ut.plainNameOf(Ze);
        if (!Ct || Ct.state === "unreadable" || Ct.name === null)
          throw new Error(C("e2e.names.move_unreadable"));
        const fn = await YC(Ze) ? { keepIdOf: Ze } : {};
        let _n = await Ut.nameForWrite(g, Ct.name, fn);
        if (!_n) return null;
        for (let ja = 2; o === "copy" && Ae.has(_n.stored) && ja < 100; ja++)
          _n = await Ut.nameForWrite(g, w$(Ct.name, ja), fn);
        if (Ae.has(_n.stored)) throw new Error(C("e2e.names.move_taken", { name: Ct.name }));
        Ae.add(_n.stored), _n.sidecar && await S.uploadMultipart(g, [
          new File([_n.sidecar.content], _n.sidecar.name, { type: "text/plain" })
        ]);
        const { op: Li } = await S.transferNamed(o, Ze, g, _n.stored, P);
        Me.register(Li), j.push(Li), ue.push({ moved: Ua(g, _n.stored), origin: Dt, name: Sn });
      }
      return { ops: j, undo: o === "move" ? async () => {
        for (const Ze of ue) {
          const { op: Dt } = await S.transferNamed("move", Ze.moved, Ze.origin, Ze.name);
          Me.register(Dt);
        }
        return { queued: !0 };
      } : null };
    }
    async function YC(o) {
      var P;
      const s = xe.value.find((R) => R.path === o) ?? (((P = Xt.value) == null ? void 0 : P.visibleNodes()) ?? []).find((R) => R.path === o);
      if (s) return s.type === "dir";
      const g = Sl(Ti(o)).kind;
      if (g === "dir" || g === "longdir") return !0;
      if (g === "file" || g === "long") return !1;
      try {
        return ((await S.index(Qi(o))).files ?? []).some((j) => j.path === o && j.type === "dir");
      } catch {
        return !1;
      }
    }
    async function Gk(o, s) {
      const g = Ut.writesEncrypted(o);
      if (!g) return null;
      const P = o.indexOf("://"), j = {
        adapter: P === -1 ? kt.value : o.slice(0, P),
        storages: (O.config.storages ?? []).map((st) => st.name),
        dirname: o,
        read_only: !1,
        files: [],
        e2e_root: g
      };
      if (!an.names(g)) return j;
      const ue = [], $e = [o];
      let Ae = 0;
      for (; $e.length > 0 && ue.length < Wd && Ae < Xae; ) {
        const st = $e.shift();
        Ae++;
        let Ze;
        try {
          Ze = await S.index(st);
        } catch {
          continue;
        }
        const Dt = yr(await Ut.decorate(Ze.files ?? [], { root: g }));
        for (const Sn of Dt)
          if (Sn.type === "dir" && $e.push(Sn.path), jx(Sn.basename, s) && ue.push(Sn), ue.length >= Wd) break;
      }
      return { ...j, files: ue, truncated: $e.length > 0 };
    }
    const Di = $(!1);
    Xe(Et, async (o, s) => {
      if (o === s) return;
      if (_s.value = !1, sr.value = "", zo.value = !1, Mi.value = "", Di.value = !1, ur.value = "", cr.value = null, Lk.value = [], !o) {
        en.value = null;
        return;
      }
      const g = Ut.markerCached(o);
      if (en.value = g === void 0 ? null : g, g === void 0) {
        const P = await Ut.markerFor(o);
        Et.value === o && (en.value = P);
      }
    });
    const io = $(!1), ur = $(""), cr = $(null);
    let Ss = !1;
    const Od = E(() => (jn.value, PD(en.value))), Xk = E(() => Od.value !== "content"), GC = E(() => (jn.value, OD(en.value))), XC = E(
      () => Xk.value ? xe.value.filter((o) => o.e2e_name_state === "plain" || o.e2e_name_state === "unreadable").length : 0
    );
    async function Dd() {
      var P;
      const o = Et.value, s = o ? an.get(o) : void 0;
      let g = en.value;
      if (!o || !s || !g || io.value) return !1;
      Di.value = !1, io.value = !0, ur.value = "", Ss = !1;
      try {
        if (!Ui(g)) {
          const $e = await l_(g, s);
          await Mo($e.marker), an.setNames(o, $e.names), jn.value++, g = $e.marker;
        }
        const R = an.names(o);
        if (!R) throw new Error("e2e: the folder name key is missing");
        cr.value = { renamed: 0, failed: 0, seen: 0 };
        const j = cr.value;
        if (await eZ(R, o, {
          list: async ($e) => (await S.index($e)).files ?? [],
          readSidecar: async ($e, Ae) => {
            try {
              return new TextDecoder().decode(await S.fetchArrayBuffer(Fs($e, Ae)));
            } catch {
              return null;
            }
          },
          writeSidecar: async ($e, Ae, st) => {
            await S.uploadMultipart($e, [new File([st], Ae, { type: "text/plain" })]);
          },
          // A folder rename is a job of the queue where the server has one: the
          // queue keeps order, so a folder is renamed after its contents.
          rename: async ($e, Ae, st) => {
            if (Ae.type === "dir" && Ic("rename")) {
              const Ze = (await S.renameQueued($e, Ae.path, st)).op;
              Ze && Me.register(Ze);
            } else
              await S.rename($e, Ae.path, st);
          },
          stopped: () => Ss
        }, j), Ss)
          return Qe(C("e2e.names.stopped", { n: j.renamed })), !1;
        if (j.failed > 0)
          return ur.value = C("e2e.names.partial", { n: j.failed }), !1;
        const ue = en.value ?? g;
        return (P = ue.names) != null && P.pending && await Mo(zD(ue)), cr.value = null, Qe(C("e2e.names.done", { n: j.renamed })), !0;
      } catch (R) {
        return ur.value = C("e2e.names.failed"), U("error", { message: R.message, context: { op: "e2e-names" } }), !1;
      } finally {
        io.value = !1, await xt();
      }
    }
    const dr = $(null), Po = $(!1), fr = $(""), oo = $(null);
    let Ld = !1, gu = null;
    const $s = $(null), Jk = E(() => (jn.value, c_(en.value)));
    function JC(o, s) {
      const g = o.length === 1 ? o[0] : null;
      return !!g && g.type === "dir" && s && !Qt.value && !g.e2e && !g.e2e_root && !Bt.value && typeof crypto < "u" && !!crypto.subtle;
    }
    function Zk(o, s, g) {
      return JC(o, s) && vh(o[0].path, "folder") === g;
    }
    function ZC(o) {
      dr.value = o, ar.value = !0;
    }
    async function QC(o) {
      const s = [o];
      for (; s.length; ) {
        const g = s.shift(), P = await S.index(g);
        if (g !== o && typeof P.e2e_root == "string" && P.e2e_root) return !0;
        for (const R of P.files ?? [])
          if (R.type === "dir") {
            if (R.e2e) return !0;
            s.push(R.path);
          }
      }
      return !1;
    }
    async function ez(o) {
      const s = dr.value;
      if (!s) return;
      const g = s.path;
      ir.value = !0;
      try {
        if (await QC(g)) {
          Qe(C("e2e.convert.nested"));
          return;
        }
        const P = await $v(o.password, { escrowPublicKey: lr.value });
        let R = P.marker, j = null;
        if (o.level === "names") {
          const ue = await l_(R, P.fmk);
          R = ue.marker, j = ue.names;
        }
        R = RD(R, void 0, o.cleanup ?? { versions: !1, trash: !1 }), await S.uploadMultipart(g, [
          new File([JSON.stringify(R)], ha, { type: "application/json" })
        ]), an.set(g, P.fmk, j), Ut.setMarker(g, R), jn.value++, ar.value = !1, dr.value = null, Eo.value = P.recoveryKey, Co.value = o.name, rr.value = "created", Ao.value = !0, await xt(zi(g)), await Zt(), Et.value === g && (en.value = R, Qk());
      } catch (P) {
        U("error", { message: P.message, context: { op: "e2e-convert" } }), Vt({ message: Gn(P, C("e2e.convert.failed")) }, pn);
      } finally {
        ir.value = !1;
      }
    }
    async function Qk() {
      var j, ue, $e;
      const o = Et.value, s = o ? an.get(o) : void 0, g = en.value;
      if (!o || !s || !g || !c_(g) || Po.value) return;
      Po.value = !0, fr.value = "", Ld = !1;
      const P = new AbortController();
      gu = P, oo.value = { total: 0, done: 0, skipped: 0, tooBig: 0, failed: 0 };
      const R = oo.value;
      try {
        if (await tZ(
          o,
          {
            list: async (Ze) => (await S.index(Ze)).files ?? [],
            head: (Ze) => S.fetchHead(Ze, 16),
            read: (Ze) => S.fetchArrayBuffer(Ze),
            write: async (Ze, Dt, Sn, Ct) => {
              await S.uploadMultipart(
                Ze,
                [new File([Sn], Dt.basename, { type: "application/octet-stream" })],
                void 0,
                { e2e_convert: "1", ...Ct ? { expect: Ct } : {} }
              );
            },
            encrypt: (Ze) => Tv(s, Ze),
            /* wiring:e2 convert - over 200 MB: STREAM (0x02), streamed both ways. */
            writeLarge: async (Ze, Dt, Sn) => {
              $s.value = { name: Dt.basename, percent: 0 };
              try {
                return await Pt.convertLarge(Dt, s, Sn, {
                  signal: P.signal,
                  onProgress: (Ct) => {
                    $s.value = { name: Dt.basename, percent: Math.floor(Ct * 100) };
                  }
                });
              } finally {
                $s.value = null;
              }
            },
            stopped: () => Ld
          },
          R,
          { maxBytes: Nu }
        ), Ld) {
          Qe(C("e2e.convert.stopped", { n: R.done }));
          return;
        }
        if (R.tooBig > 0 && R.failed === 0) {
          fr.value = C("e2e.convert.too_large_here", { n: R.tooBig });
          return;
        }
        if (R.failed + R.tooBig > 0) {
          fr.value = C("e2e.convert.partial", { n: R.failed + R.tooBig });
          return;
        }
        if ((ue = (j = en.value) == null ? void 0 : j.names) != null && ue.pending && !await Dd()) return;
        const Ae = en.value ?? g, st = ($e = Ae.conv) == null ? void 0 : $e.cleanup;
        await Mo(ND(Ae)), oo.value = null;
        try {
          const Ze = await S.e2eCleanup({ path: o, versions: !!(st != null && st.versions), trash: !!(st != null && st.trash) });
          Qe(
            C("e2e.convert.done", {
              n: R.done + R.skipped,
              versions: Ze.versions_deleted,
              trash: Ze.trash_purged
            })
          );
        } catch (Ze) {
          Qe(C("e2e.convert.cleanup_failed")), U("error", { message: Ze.message, context: { op: "e2e-convert-cleanup" } });
        }
      } catch (Ae) {
        fr.value = Gn(Ae, C("e2e.convert.failed")), U("error", { message: Ae.message, context: { op: "e2e-convert" } });
      } finally {
        Po.value = !1, gu = null, await xt();
      }
    }
    function tz() {
      Ld = !0, gu == null || gu.abort();
    }
    function nz() {
      Di.value = !1, ew("change");
    }
    function az() {
      Di.value = !1, VC();
    }
    const Ts = $(!1), um = $("change"), bu = $(!1), pr = $(null);
    let As = null;
    const hr = $(!1), ku = $(""), Es = $(null), iz = E(() => (jn.value, Zs(en.value))), oz = E(() => !!en.value && sx(en.value));
    function ew(o) {
      um.value = o, pr.value = null, Ts.value = !0;
    }
    function rz() {
      if (!bu.value) {
        if (um.value === "reset") {
          am();
          return;
        }
        Ts.value = !1;
      }
    }
    async function sz(o) {
      const s = Et.value, g = en.value;
      if (!s || !g || bu.value) return;
      const P = o.proof ?? (As ? { recoveryKey: As } : null);
      if (!P) {
        pr.value = C("e2e.password.current_required");
        return;
      }
      const R = "recoveryKey" in P ? "recovery_key" : "password";
      bu.value = !0, pr.value = null;
      try {
        if (!o.rotate) {
          const ue = await lx(g, P, o.newPassword);
          await Mo(ue), As = null, Ts.value = !1, Qe(C("e2e.password.done"));
          return;
        }
        const j = await DD(g, P, o.newPassword, {
          escrowPublicKey: lr.value
        });
        await Mo(j.marker), _s.value = !1, sr.value = "", an.set(s, j.fmk, j.names ?? an.names(s) ?? null, j.previous), jn.value++, nm(), As = null, Ts.value = !1, j.recoveryKeyIsNew && (Eo.value = j.recoveryKey, Co.value = Ti(s), rr.value = "replaced", Ao.value = !0), await nw();
      } catch (j) {
        j instanceof sn ? pr.value = C(R === "recovery_key" ? "e2e.password.wrong_recovery" : "e2e.password.wrong_current") : j instanceof ux ? pr.value = C("e2e.password.escrow_blocked") : (pr.value = C("e2e.password.failed"), U("error", { message: j.message, context: { op: "e2e-password" } }));
      } finally {
        bu.value = !1;
      }
    }
    async function lz(o, s, g) {
      const P = new File([g], s, { type: "application/octet-stream" });
      if (nt.shouldChunk(P)) {
        await nt.uploadFile({ path: o, file: P });
        return;
      }
      await S.uploadMultipart(o, [P]);
    }
    async function tw(o, s, g) {
      const P = Es.value;
      let R;
      try {
        R = await S.index(o);
      } catch {
        P.failed++;
        return;
      }
      for (const j of R.files ?? [])
        if (j.basename !== ha) {
          if (j.type === "dir") {
            await tw(j.path, s, g);
            continue;
          }
          try {
            if ((j.size ?? 0) > Nu) {
              await Pt.rewrapLarge(j, s, g) && P.done++;
              continue;
            }
            const ue = await S.fetchArrayBuffer(j.path);
            if (!cl(ue)) continue;
            const $e = await cx(ue, s, g);
            $e && await lz(o, j.basename, $e), P.done++;
          } catch {
            P.failed++;
          }
        }
    }
    async function nw() {
      const o = Et.value, s = o ? an.get(o) : void 0, g = o ? an.previous(o) : void 0;
      if (!(!o || !s || !g || hr.value)) {
        hr.value = !0, ku.value = "", Es.value = { done: 0, failed: 0 };
        try {
          await tw(o, g, s);
          const P = Es.value;
          if (P.failed > 0) {
            ku.value = C("e2e.password.rekey_partial", { n: P.failed });
            return;
          }
          const R = en.value;
          R && Zs(R) && await Mo(ID(R)), an.dropPrevious(o), jn.value++, Qe(C("e2e.password.rekey_done", { n: P.done }));
        } catch (P) {
          ku.value = C("e2e.password.failed"), U("error", { message: P.message, context: { op: "e2e-rekey" } });
        } finally {
          hr.value = !1, await xt();
        }
      }
    }
    function Rd(o) {
      return o.replace(/\/+$/, "");
    }
    function aw(o) {
      if (!o || o.type !== "dir" || o.e2e !== !0) return null;
      const s = Rd(o.path);
      return an.roots().find((g) => Rd(g) === s) ?? null;
    }
    async function uz(o) {
      const s = o.length === 1 ? o[0] : null;
      if (s && Ri(s) && !Qt.value && !s.e2e_root)
        return await Pt.download(s), !0;
      let g = null;
      if (qn.value ? g = Et.value : s && (g = aw(s)), !g && o.length > 0) {
        const ue = o.map((Ae) => Ut.rootOf(Ae.path, Ae.e2e_root ?? null)), $e = ue[0];
        $e && ue.every((Ae) => Ae === $e) && (g = an.roots().find((Ae) => Rd(Ae) === Rd($e)) ?? null);
      }
      if (!g) return !1;
      const P = an.get(g);
      if (!P) return !1;
      if (s && s.type === "file")
        return await Pt.downloadFolderFile(s, P, an.previous(g), g), !0;
      const R = Ut.segmentLabel(Nt(De.value)) ?? Ti(Nt(De.value)), j = `${s ? s.basename : R || "filex"}.zip`;
      return await Pt.downloadDecryptedZip(o, {
        root: g,
        fmk: P,
        previous: an.previous(g),
        decorate: (ue, $e) => Ut.decorate(ue, $e),
        zipName: j
      }), !0;
    }
    function cz() {
      const o = Pt.tooBig.value;
      if (Pt.closeTooBig(), !o) return;
      if (o.encrypted.kind === "file") {
        window.open(S.downloadUrl(o.encrypted.path), "_blank");
        return;
      }
      const s = { path: o.encrypted.path, basename: Ti(o.encrypted.path), type: "dir" };
      yd([s], { encrypted: !0 });
    }
    function dz() {
      Ao.value = !1, Eo.value = "", Co.value = "";
    }
    return (o, s) => {
      var g, P, R, j, ue, $e, Ae, st, Ze, Dt, Sn, Ct, Va, fn, _n, Li, ja, Nd, ow, rw, sw, lw, uw, cw, dw, fw, pw, hw, mw;
      return p(), h("div", {
        ref_key: "rootEl",
        ref: xn,
        class: Fe(["fe", {
          "fe--theme-light": gn.value === "light",
          "fe--theme-dark": gn.value === "dark",
          "fe--is-dragover": To.value,
          "fe--density-compact": le.value === "compact",
          "fe--narrow": Pa.value
        }]),
        dir: u(de),
        tabindex: "-1",
        onDragenter: UE,
        onDragover: KE,
        onDragleave: HE,
        onDrop: VE,
        onContextmenu: pE
      }, [
        tt(c3, {
          ref_key: "toolbarRef",
          ref: Ab,
          "view-mode": Xh.value,
          "search-query": _e.value,
          "trash-active": Bt.value,
          actions: wE.value,
          "selection-mode": cE.value,
          "selection-count": ra().length,
          "selection-pane": Ad.value,
          "paste-enabled": !!_t.value.mode,
          "can-go-up": Ea.value,
          "at-virtual-root": pe.value,
          "can-write": ni.value,
          locale: q.value,
          narrow: Pa.value,
          theme: gn.value,
          "inspector-open": xi.value,
          "nav-open": oA.value,
          "nav-enabled": Kl.value,
          "view-modes": th.value,
          "scope-label": cb.value,
          "brand-name": (g = e.config.brand) == null ? void 0 : g.name,
          "brand-mark-url": (P = e.config.brand) == null ? void 0 : P.markUrl,
          "search-escalates": ft.value === "home",
          onOpenPalette: wA,
          onToggleInspector: Jp,
          onToggleNav: nb,
          onOpenTheme: s[0] || (s[0] = (ze) => wd.value = !0),
          "onUpdate:viewMode": s[1] || (s[1] = (ze) => $k(ze)),
          "onUpdate:searchQuery": kA,
          onOpenAdvancedSearch: gA,
          "onUpdate:density": s[2] || (s[2] = (ze) => le.value = ze),
          onOpenShortcutSettings: s[3] || (s[3] = (ze) => ru.value = !0),
          onOpenTimezone: s[4] || (s[4] = (ze) => Ye.value = !0),
          onNewFolder: s[5] || (s[5] = (ze) => ia.value = !0),
          onUpload: So,
          onRefresh: Pb,
          onGoUp: Ue,
          onAction: Eh,
          onOpenRecents: s[6] || (s[6] = (ze) => Wr.value = !0)
        }, kz({
          "header-actions": gt(() => {
            var ze;
            return [
              u(te) ? (p(), Je(ote, {
                key: 0,
                feed: u(te),
                locale: q.value,
                "manage-href": Ge.value,
                onOpen: dn,
                onManage: pt
              }, null, 8, ["feed", "locale", "manage-href"])) : D("", !0),
              e.config.account ? (p(), Je(Ite, {
                key: 1,
                actions: ut.value,
                user: Bn.value,
                version: (ze = ee.value) == null ? void 0 : ze.release,
                locale: q.value,
                "fallback-label": u(C)("explore.account"),
                onSelect: Pn
              }, null, 8, ["actions", "user", "version", "locale", "fallback-label"])) : D("", !0),
              En(o.$slots, "header-actions")
            ];
          }),
          _: 2
        }, [
          o.$slots.brand ? {
            name: "brand",
            fn: gt(() => [
              En(o.$slots, "brand")
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["view-mode", "search-query", "trash-active", "actions", "selection-mode", "selection-count", "selection-pane", "paste-enabled", "can-go-up", "at-virtual-root", "can-write", "locale", "narrow", "theme", "inspector-open", "nav-open", "nav-enabled", "view-modes", "scope-label", "brand-name", "brand-mark-url", "search-escalates", "onOpenPalette", "onToggleInspector", "onToggleNav", "onUpdate:searchQuery", "onOpenAdvancedSearch", "onRefresh"]),
        c("div", {
          class: Fe([
            "fe__main",
            { "fe__main--split": bs.value }
            /* wiring:d1 */
          ])
        }, [
          Zp.value ? (p(), Je(s9, {
            key: 0,
            expanded: Hl.value,
            narrow: Pa.value,
            "active-view": ft.value,
            "active-tag": ln.value,
            "active-tag-kind": kn.value,
            tags: yb.value,
            "tags-loaded": lh.value,
            "active-storage": kt.value,
            storages: rh.value,
            "storage-order-custom": u(mb).custom.value,
            onReorderStorages: TA,
            "shared-storages": Qp.value,
            "trash-visible": e.config.trashVisible !== !1,
            "drafts-visible": Yo.value && is.value,
            "draft-count": Yr.value,
            "show-connections": rA.value,
            "show-my-shares": sA.value,
            "show-identity-surfaces": is.value,
            "can-write": ni.value && !pe.value && !Bt.value,
            locale: q.value,
            "can-request-files": ni.value && !pe.value && !Bt.value && !ft.value && !Qt.value,
            "request-files-allowed": Tb.value,
            "can-new-document": LT.value && !Bt.value && !ft.value && !Qt.value,
            onNewDocument: s[7] || (s[7] = (ze) => Il.value = !0),
            quota: SA.value,
            theme: gn.value,
            onRequestFiles: _A,
            onToggle: nb,
            onClose: bo,
            onOpenView: EA,
            onOpenTag: ls,
            onOpenStorage: gb,
            onUpload: So,
            onNewFolder: s[8] || (s[8] = (ze) => ia.value = !0),
            onOpenConnections: uA,
            onOpenTokens: cA,
            onOpenMyShares: s[9] || (s[9] = (ze) => U("open-my-shares")),
            "show-app-store": lA.value,
            onOpenAppStore: s[10] || (s[10] = (ze) => U("open-app-store")),
            apps: xT.value,
            onOpenApp: Ng
          }, null, 8, ["expanded", "narrow", "active-view", "active-tag", "active-tag-kind", "tags", "tags-loaded", "active-storage", "storages", "storage-order-custom", "shared-storages", "trash-visible", "drafts-visible", "draft-count", "show-connections", "show-my-shares", "show-identity-surfaces", "can-write", "locale", "can-request-files", "request-files-allowed", "can-new-document", "quota", "theme", "onRequestFiles", "onOpenView", "show-app-store", "apps"])) : D("", !0),
          Pa.value && er.value ? (p(), h("button", {
            key: 1,
            type: "button",
            class: "fe-sidenav__scrim",
            title: u(C)("sidenav.close"),
            "aria-label": u(C)("sidenav.close"),
            onClick: bo
          }, null, 8, Wte)) : D("", !0),
          c("div", Yte, [
            cC.value ? (p(), Je(mG, {
              key: 0,
              tabs: vk.value,
              "active-id": u(Yh),
              locale: q.value,
              "hide-tabs": !yk.value,
              "split-enabled": cu.value,
              "split-active": !!to.value,
              "inspector-enabled": eb.value,
              "inspector-open": xi.value,
              onSelect: oC,
              onClose: gk,
              onNew: Gh,
              onReorder: s[11] || (s[11] = (ze, Wn) => u(Fn).move(ze, Wn)),
              onToggleSplit: _k,
              onToggleInspector: Jp
            }, null, 8, ["tabs", "active-id", "locale", "hide-tabs", "split-enabled", "split-active", "inspector-enabled", "inspector-open"])) : D("", !0),
            c("div", Gte, [
              tt(z1, {
                "pane-id": "main",
                ref_key: "mainPaneRef",
                ref: lC,
                api: X,
                locale: q.value,
                theme: gn.value,
                focused: vC.value,
                path: De.value,
                qualify: Nt,
                "to-user": zi,
                clamp: Ek,
                "root-path": u(Ve),
                floor: u(Te),
                "multi-root": wn.value,
                rows: xe.value,
                loading: be.value,
                error: Z.value,
                order: pA.value,
                "view-mode": ve.value,
                "view-modes": th.value,
                "open-trigger": O.config.openTrigger,
                "show-crumbs": ft.value !== "home",
                "filter-mode": Le.value,
                "find-label": ft.value === "home" ? u(C)("filter.find.home") : "",
                "show-view-switcher": ft.value !== "home",
                "folder-key": In.value,
                "show-parent-path": !!_e.value || Qn.value,
                trash: Bt.value,
                clipped: Kh.value,
                "extra-filters": ss.value,
                "extra-filters-on-server": !sb.value,
                "can-write": ni.value && !Bt.value,
                "can-paste": !!_t.value.mode,
                selected: u(Ke).selected.value,
                filters: rs.value,
                "thumb-src": u(Ie).src,
                "folder-previews": ((R = ee.value) == null ? void 0 : R.folder_previews) !== !1,
                "keep-badge-for": ii.value ? Vb : void 0,
                "starred-ids": Kg.value,
                "star-overrides": qr.value,
                "star-enabled": is.value,
                "api-base": O.config.apiBase ?? "",
                "auth-headers": () => Xn(),
                "auth-credentials": u(S).credentialsMode(),
                "e2e-active": Qt.value,
                "body-override": Td.value !== "",
                onActivate: mC,
                onNavigate: YE,
                onOpen: Ha,
                onOpenTrash: s[22] || (s[22] = () => $i()),
                onClickRow: s[23] || (s[23] = (ze, Wn) => ek("main", ze, Wn)),
                onContext: s[24] || (s[24] = (ze, Wn) => qb("main", ze, Wn)),
                onClearSelection: s[25] || (s[25] = (ze) => u(Ke).clear()),
                onDisplayOrder: s[26] || (s[26] = (ze) => He.value = ze),
                onItemDragStart: s[27] || (s[27] = (ze, Wn) => tk("main", ze, Wn)),
                onItemDropInto: ck,
                onTransfer: Ok,
                "onUpdate:viewMode": s[28] || (s[28] = (ze) => ve.value = ze),
                "onUpdate:filters": ib,
                onCrumbContext: hE,
                onCopyPath: kd,
                onCrumbDrop: dk,
                onNewFolder: s[29] || (s[29] = (ze) => ia.value = !0),
                onUpload: So,
                onPaste: s[30] || (s[30] = (ze) => Eh("paste")),
                onSelectAll: s[31] || (s[31] = (ze) => u(Ke).selectAll()),
                onClearFilters: hA,
                onStarChange: Vg,
                onRetry: ae
              }, {
                banners: gt(() => [
                  _e.value && Ee.value && !ft.value && !Bt.value ? (p(), h("div", Xte, y(u(C)("search.truncated")), 1)) : D("", !0),
                  Ji.value && Ji.value.truncated && Ln.value && !_e.value ? (p(), h("div", Jte, [
                    c("span", null, y(u(C)("nav.more_shown", { shown: xe.value.length, total: Ji.value.total })), 1),
                    c("button", {
                      type: "button",
                      class: "fe-coverage__action",
                      "data-testid": "nav-more-load",
                      disabled: ql.value,
                      "aria-busy": ql.value ? "true" : void 0,
                      onClick: $A
                    }, y(u(C)("nav.load_more")), 9, Zte)
                  ])) : D("", !0),
                  Si.value ? (p(), h("div", Qte, [
                    c("span", ene, y(Lt(Si.value.storage) ? u(C)("coverage.cataloging", { storage: Si.value.storage ?? "" }) : u(C)(Si.value.key, Si.value.vars)), 1),
                    Si.value.offerCatalogAll ? (p(), h("button", {
                      key: 0,
                      type: "button",
                      class: "fe-coverage__action",
                      "data-testid": "catalog-coverage-all",
                      disabled: Lt(Si.value.storage),
                      "aria-busy": Lt(Si.value.storage) ? "true" : void 0,
                      onClick: s[12] || (s[12] = (ze) => NA(Si.value.storage))
                    }, y(Lt(Si.value.storage) ? u(C)("coverage.catalog_running") : u(C)("coverage.catalog_all")), 9, tne)) : D("", !0)
                  ])) : D("", !0),
                  u(We).length || u(bt) ? (p(), h("div", nne, [
                    u(We).length ? (p(), Je(KP, {
                      key: 0,
                      users: u(We),
                      locale: q.value
                    }, null, 8, ["users", "locale"])) : D("", !0),
                    u(bt) ? (p(), h("span", {
                      key: 1,
                      class: "fe-connbadge",
                      role: "status",
                      title: u(C)("conn.tooltip")
                    }, [
                      s[111] || (s[111] = c("span", {
                        class: "fe-connbadge__dot",
                        "aria-hidden": "true"
                      }, null, -1)),
                      Ht(" " + y(u(C)("conn.offline")), 1)
                    ], 8, ane)) : D("", !0)
                  ])) : D("", !0),
                  _s.value ? (p(), h("div", ine, [
                    c("div", one, [
                      c("strong", null, y(u(C)("e2e.upgrade.title")), 1),
                      c("p", null, y(u(C)("e2e.upgrade.body")), 1),
                      Ka.value ? (p(), h("p", rne, y(u(C)("e2e.upgrade.escrow_note")), 1)) : D("", !0)
                    ]),
                    c("div", sne, [
                      c("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: pu.value,
                        onClick: WC
                      }, y(u(C)("e2e.upgrade.decline")), 9, lne),
                      c("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: pu.value,
                        onClick: KC
                      }, y(pu.value ? u(C)("e2e.upgrade.busy") : u(C)("e2e.upgrade.accept")), 9, une)
                    ])
                  ])) : D("", !0),
                  zo.value ? (p(), h("div", cne, [
                    c("div", dne, [
                      c("strong", null, y(u(C)("e2e.escrowoffer.title")), 1),
                      c("p", null, y(u(C)("e2e.escrowoffer.body")), 1),
                      c("p", fne, [
                        Ht(y(u(C)("e2e.escrowoffer.consequence")) + " ", 1),
                        c("a", {
                          href: Yae,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, y(u(C)("e2e.escrowoffer.learn_more")), 1)
                      ]),
                      Ka.value ? (p(), h("p", pne, [
                        Ht(y(u(C)("e2e.recover.escrow_kid")) + ": ", 1),
                        c("code", null, y(Ka.value), 1)
                      ])) : D("", !0),
                      hu.value === "manual" ? (p(), h("label", hne, [
                        c("span", null, y(u(C)("e2e.escrowoffer.password_label")), 1),
                        un(c("input", {
                          "onUpdate:modelValue": s[13] || (s[13] = (ze) => Mi.value = ze),
                          type: "password",
                          class: "fe-input",
                          autocomplete: "current-password",
                          disabled: Pi.value,
                          onKeyup: $a(qk, ["enter"])
                        }, null, 40, mne), [
                          [bn, Mi.value]
                        ])
                      ])) : D("", !0),
                      Oi.value ? (p(), h("p", vne, y(Oi.value), 1)) : D("", !0)
                    ]),
                    c("div", yne, [
                      c("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: Pi.value,
                        onClick: s[14] || (s[14] = (ze) => hu.value === "manual" ? qC() : jC())
                      }, y(hu.value === "manual" ? u(C)("e2e.escrowoffer.cancel") : u(C)("e2e.escrowoffer.decline")), 9, gne),
                      c("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: Pi.value,
                        onClick: qk
                      }, y(Pi.value ? u(C)("e2e.escrowoffer.busy") : u(C)("e2e.escrowoffer.accept")), 9, bne)
                    ])
                  ])) : D("", !0),
                  qn.value && (Jk.value || Po.value || fr.value) ? (p(), h("div", kne, [
                    c("div", wne, [
                      c("strong", null, y(Po.value ? u(C)("e2e.convert.busy") : u(C)("e2e.convert.resume_title")), 1),
                      Po.value ? D("", !0) : (p(), h("p", _ne, y(u(C)("e2e.convert.resume_body")), 1)),
                      oo.value ? (p(), h("p", xne, y(u(C)("e2e.convert.progress", {
                        n: oo.value.done + oo.value.skipped,
                        total: oo.value.total,
                        failed: oo.value.failed + oo.value.tooBig
                      })), 1)) : D("", !0),
                      $s.value ? (p(), h("p", Sne, y(u(C)("e2e.convert.large_progress", { name: $s.value.name, percent: $s.value.percent })), 1)) : D("", !0),
                      fr.value ? (p(), h("p", $ne, y(fr.value), 1)) : D("", !0)
                    ]),
                    c("div", Tne, [
                      Po.value ? (p(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn",
                        "data-testid": "e2e-convert-stop",
                        onClick: tz
                      }, y(u(C)("e2e.names.stop")), 1)) : (p(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-convert-resume",
                        onClick: Qk
                      }, y(u(C)("e2e.names.resume")), 1))
                    ])
                  ])) : D("", !0),
                  qn.value && !Jk.value && !Po.value && (Od.value === "pending" || io.value || ur.value) ? (p(), h("div", Ane, [
                    c("div", Ene, [
                      c("strong", null, y(io.value ? u(C)("e2e.names.busy") : u(C)("e2e.names.resume_title")), 1),
                      io.value ? D("", !0) : (p(), h("p", Cne, y(u(C)("e2e.names.resume_body")), 1)),
                      cr.value ? (p(), h("p", zne, y(u(C)("e2e.names.progress", { n: cr.value.renamed, failed: cr.value.failed })), 1)) : D("", !0),
                      ur.value ? (p(), h("p", Mne, y(ur.value), 1)) : D("", !0)
                    ]),
                    c("div", Pne, [
                      io.value ? (p(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn",
                        "data-testid": "e2e-names-stop",
                        onClick: s[15] || (s[15] = (ze) => wz(Ss) ? Ss.value = !0 : Ss = !0)
                      }, y(u(C)("e2e.names.stop")), 1)) : (p(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-names-resume",
                        onClick: Dd
                      }, y(u(C)("e2e.names.resume")), 1))
                    ])
                  ])) : D("", !0),
                  qn.value && (iz.value || hr.value) ? (p(), h("div", One, [
                    c("div", Dne, [
                      c("strong", null, y(u(C)("e2e.password.resume_title")), 1),
                      c("p", null, y(u(C)("e2e.password.resume_body")), 1),
                      Es.value ? (p(), h("p", Lne, y(u(C)("e2e.password.progress", { n: Es.value.done, failed: Es.value.failed })), 1)) : D("", !0),
                      ku.value ? (p(), h("p", Rne, y(ku.value), 1)) : D("", !0)
                    ]),
                    c("div", Nne, [
                      c("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-rekey-resume",
                        disabled: hr.value,
                        onClick: nw
                      }, y(hr.value ? u(C)("e2e.password.busy") : u(C)("e2e.names.resume")), 9, Ine)
                    ])
                  ])) : D("", !0),
                  qn.value && im.value ? (p(), Je(u(i), {
                    key: 9,
                    locale: q.value,
                    state: im.value,
                    onSettings: s[16] || (s[16] = (ze) => Di.value = !0),
                    onLock: am,
                    onTakeOver: s[17] || (s[17] = (ze) => u(V).takeOver(Et.value)),
                    onContinue: s[18] || (s[18] = (ze) => u(V).continueFromShown(Et.value)),
                    onDismiss: s[19] || (s[19] = (ze) => u(V).dismiss(Et.value))
                  }, null, 8, ["locale", "state"])) : D("", !0),
                  qn.value && !im.value ? (p(), h("div", Bne, [
                    c("span", {
                      class: "fe-e2e-strip__icon",
                      "aria-hidden": "true",
                      innerHTML: u(zt)("lock")
                    }, null, 8, Fne),
                    c("span", Une, y(u(C)("e2e.strip.label")), 1),
                    c("span", Hne, y(Xk.value ? u(C)("e2e.level.names") : u(C)("e2e.level.content")), 1),
                    c("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      "data-testid": "e2e-settings-open",
                      disabled: hr.value || io.value,
                      onClick: s[20] || (s[20] = (ze) => Di.value = !0)
                    }, y(u(C)("e2e.settings.open")), 9, Kne),
                    c("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      onClick: am
                    }, y(u(C)("e2e.strip.lock")), 1)
                  ])) : D("", !0),
                  At.value && !be.value ? (p(), h("div", Vne, [
                    c("p", jne, y(KA.value), 1),
                    sd.value ? (p(), h("p", qne, [
                      Ht(y(sd.value), 1),
                      _o.value < ps.value ? (p(), h("span", Wne, " · " + y(qA.value), 1)) : D("", !0)
                    ])) : D("", !0),
                    _o.value < ps.value ? (p(), h("button", {
                      key: 1,
                      type: "button",
                      class: "fe-btn fe-trashbar__more",
                      "data-testid": "trash-more",
                      disabled: ld.value,
                      onClick: WA
                    }, y(u(C)("trash.show_more")), 9, Yne)) : D("", !0),
                    Db.value ? (p(), h("p", Gne, y(Db.value), 1)) : D("", !0),
                    wo.value ? (p(), h("button", {
                      key: 3,
                      type: "button",
                      class: "fe-btn fe-btn--danger fe-trashbar__action",
                      disabled: xe.value.length === 0 || od.value,
                      "data-testid": "trash-empty",
                      onClick: VA
                    }, y(u(C)("trash.empty_action")), 9, Xne)) : D("", !0)
                  ])) : D("", !0)
                ]),
                body: gt(() => [
                  Td.value === "home" ? (p(), Je(aV, {
                    key: 0,
                    storages: sh.value,
                    recent: pb.value,
                    starred: hb.value,
                    loading: oh.value,
                    locale: q.value,
                    "match-names": u(S).matchNames,
                    "name-filter": rs.value.name ?? "",
                    "thumb-src": u(Ie).src,
                    onOpenStorage: gb,
                    onOpenNode: Ha,
                    onContextNode: Oh
                  }, null, 8, ["storages", "recent", "starred", "loading", "locale", "match-names", "name-filter", "thumb-src"])) : Td.value === "drafts" ? (p(), Je(mV, {
                    key: 1,
                    drafts: jp.value,
                    loading: Wp.value,
                    limit: qp.value,
                    locale: q.value,
                    "name-filter": rs.value.name ?? "",
                    "match-names": u(S).matchNames,
                    "busy-key": Go.value,
                    onOpen: s[21] || (s[21] = (ze) => Xg(ze)),
                    onSave: NT,
                    onDelete: IT
                  }, null, 8, ["drafts", "loading", "limit", "locale", "name-filter", "match-names", "busy-key"])) : Td.value === "notfound" ? (p(), h("div", Jne, [
                    s[112] || (s[112] = c("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      c("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }),
                      c("path", { d: "M52 55c0-4.6 3.6-8 8-8s8 3.4 8 8c0 5.5-8 4.8-8 11" }),
                      c("circle", {
                        cx: "60",
                        cy: "73",
                        r: "1.6",
                        fill: "currentColor",
                        stroke: "none"
                      })
                    ], -1)),
                    c("p", Zne, y(u(C)("notFound.title")), 1),
                    c("p", Qne, y(Se.value), 1),
                    c("p", eae, y(u(C)("notFound.desc")), 1),
                    c("div", tae, [
                      c("button", {
                        type: "button",
                        class: "fe-btn",
                        onClick: UA
                      }, y(u(C)("notFound.goRoot")), 1)
                    ])
                  ])) : (p(), Je(k$, {
                    key: 3,
                    locale: q.value,
                    busy: Cd.value,
                    error: Zh.value,
                    onUnlock: CC,
                    onRecovery: Vk
                  }, null, 8, ["locale", "busy", "error"]))
                ]),
                empty: gt(() => [
                  _e.value ? (p(), h("div", nae, [
                    s[113] || (s[113] = c("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      c("circle", {
                        cx: "52",
                        cy: "44",
                        r: "22"
                      }),
                      c("path", { d: "M68 61l20 20" }),
                      c("path", { d: "M46 38l12 12M58 38l-12 12" })
                    ], -1)),
                    c("p", aae, y(u(C)("empty.search.title")), 1),
                    c("p", iae, y(u(C)("empty.search.hint")), 1)
                  ])) : ft.value && ft.value !== "trash" ? (p(), h("div", {
                    key: 1,
                    class: "fe-state",
                    "data-testid": `empty-${ft.value}`
                  }, [
                    (p(), h("svg", rae, [
                      ft.value === "recent" ? (p(), h(Ce, { key: 0 }, [
                        s[114] || (s[114] = c("circle", {
                          cx: "60",
                          cy: "50",
                          r: "28"
                        }, null, -1)),
                        s[115] || (s[115] = c("path", { d: "M60 32v18l12 8" }, null, -1))
                      ], 64)) : ft.value === "starred" ? (p(), h("path", sae)) : ft.value === "tag" ? (p(), h(Ce, { key: 2 }, [
                        s[116] || (s[116] = c("path", { d: "M30 30h24l32 32-24 24-32-32z" }, null, -1)),
                        s[117] || (s[117] = c("circle", {
                          cx: "43",
                          cy: "43",
                          r: "4.5"
                        }, null, -1))
                      ], 64)) : (p(), h(Ce, { key: 3 }, [
                        s[118] || (s[118] = c("circle", {
                          cx: "84",
                          cy: "34",
                          r: "9"
                        }, null, -1)),
                        s[119] || (s[119] = c("circle", {
                          cx: "36",
                          cy: "52",
                          r: "9"
                        }, null, -1)),
                        s[120] || (s[120] = c("circle", {
                          cx: "84",
                          cy: "70",
                          r: "9"
                        }, null, -1)),
                        s[121] || (s[121] = c("path", { d: "M44.5 47.5l31-9M44.5 56.5l31 9" }, null, -1))
                      ], 64))
                    ])),
                    c("p", lae, y(ft.value === "tag" ? u(C)("empty.tag.title", { tag: ln.value }) : u(C)(`empty.${ft.value}.title`)), 1),
                    c("p", uae, y(ft.value === "tag" ? u(C)("empty.tag.hint") : u(C)(`empty.${ft.value}.hint`)), 1)
                  ], 8, oae)) : At.value ? (p(), h("div", cae, [
                    s[122] || (s[122] = c("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      c("path", { d: "M38 34l4 48a6 6 0 0 0 6 5.6h24a6 6 0 0 0 6-5.6l4-48" }),
                      c("path", { d: "M32 34h56" }),
                      c("path", { d: "M50 34v-6a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v6" }),
                      c("path", {
                        d: "M52 44v32M60 44v32M68 44v32",
                        opacity: "0.5"
                      })
                    ], -1)),
                    c("p", dae, y(u(C)("empty.trash.title")), 1),
                    c("p", fae, y(u(C)("empty.trash.hint")), 1)
                  ])) : (p(), h("div", pae, [
                    (p(), h("svg", hae, [
                      s[124] || (s[124] = c("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }, null, -1)),
                      td.value ? (p(), h("g", mae, [...s[123] || (s[123] = [
                        c("path", {
                          d: "M60 50v14",
                          "stroke-dasharray": "3 4"
                        }, null, -1),
                        c("path", { d: "M53 59l7 8 7-8" }, null, -1)
                      ])])) : D("", !0)
                    ])),
                    c("p", vae, y(u(C)("empty.folder")), 1),
                    td.value ? (p(), h("p", yae, y(u(C)("empty.hint")), 1)) : D("", !0),
                    td.value ? (p(), h("div", gae, [
                      c("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        onClick: So
                      }, y(u(C)("empty.upload")), 1)
                    ])) : D("", !0)
                  ]))
                ]),
                _: 1
              }, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "rows", "loading", "error", "order", "view-mode", "view-modes", "open-trigger", "show-crumbs", "filter-mode", "find-label", "show-view-switcher", "folder-key", "show-parent-path", "trash", "clipped", "extra-filters", "extra-filters-on-server", "can-write", "can-paste", "selected", "filters", "thumb-src", "folder-previews", "keep-badge-for", "starred-ids", "star-overrides", "star-enabled", "api-base", "auth-headers", "auth-credentials", "e2e-active", "body-override"]),
              bs.value && to.value ? (p(), Je(z1, {
                ref_key: "splitPaneRef",
                ref: Xt,
                key: "split-" + u(Yh),
                "pane-id": "split",
                "self-driven": "",
                closable: "",
                api: X,
                locale: q.value,
                theme: gn.value,
                focused: Tn.value,
                path: to.value.path,
                qualify: Nt,
                "to-user": zi,
                clamp: Ek,
                "root-path": u(Ve),
                floor: u(Te),
                "multi-root": wn.value,
                "virtual-rows": zb,
                "trash-visible": e.config.trashVisible !== !1,
                "nav-offers-trash": tb.value,
                "view-mode": xk.value,
                "view-modes": th.value,
                "open-trigger": O.config.openTrigger,
                clipped: Kh.value,
                "can-write": ni.value,
                "can-paste": !!_t.value.mode,
                selected: u(Vn).selected.value,
                filters: uu.value,
                "folder-key": uC.value,
                "thumb-src": u(Ie).src,
                "folder-previews": ((j = ee.value) == null ? void 0 : j.folder_previews) !== !1,
                "keep-badge-for": ii.value ? Vb : void 0,
                "starred-ids": Kg.value,
                "star-overrides": qr.value,
                "star-enabled": is.value,
                "api-base": O.config.apiBase ?? "",
                "auth-headers": () => Xn(),
                "auth-credentials": u(S).credentialsMode(),
                onActivate: s[32] || (s[32] = (ze) => si.value = "split"),
                onClose: dC,
                onNavigate: fC,
                onOpen: Ha,
                onOpenTrash: hC,
                onClickRow: s[33] || (s[33] = (ze, Wn) => ek("split", ze, Wn)),
                onContext: s[34] || (s[34] = (ze, Wn) => qb("split", ze, Wn)),
                onClearSelection: s[35] || (s[35] = (ze) => u(Vn).clear()),
                onDisplayOrder: s[36] || (s[36] = (ze) => lu.value = ze),
                onItemDragStart: s[37] || (s[37] = (ze, Wn) => tk("split", ze, Wn)),
                onItemDropInto: ck,
                onTransfer: Ok,
                "onUpdate:viewMode": Sk,
                "onUpdate:filters": s[38] || (s[38] = (ze) => uu.value = ze),
                onCopyPath: kd,
                onCrumbDrop: dk,
                onNewFolder: s[39] || (s[39] = (ze) => ia.value = !0),
                onUpload: So,
                onPaste: s[40] || (s[40] = (ze) => Eh("paste")),
                onSelectAll: s[41] || (s[41] = (ze) => u(Vn).selectAll()),
                onClearFilters: s[42] || (s[42] = (ze) => uu.value = { ...u(Ro) }),
                onStarChange: Vg
              }, null, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "trash-visible", "nav-offers-trash", "view-mode", "view-modes", "open-trigger", "clipped", "can-write", "can-paste", "selected", "filters", "folder-key", "thumb-src", "folder-previews", "keep-badge-for", "starred-ids", "star-overrides", "star-enabled", "api-base", "auth-headers", "auth-credentials"])) : D("", !0)
            ])
          ]),
          xi.value ? (p(), Je(OH, {
            key: 2,
            api: it,
            nodes: Ak.value,
            "dir-label": xC.value,
            "dir-count": SC.value,
            "dir-perm": $C.value,
            "held-in": _C.value,
            locale: q.value,
            narrow: Pa.value,
            "caller-admin": ba.value,
            sharing: kC.value,
            "in-encrypted": wC.value,
            "thumb-src": u(Ie).src,
            "api-base": O.config.apiBase ?? "",
            "auth-headers": () => Xn(),
            "auth-credentials": u(S).credentialsMode(),
            "plugin-views": _T.value,
            theme: gn.value,
            storages: (O.config.storages ?? []).map((ze) => ze.name),
            "user-name": O.config.userName || "",
            onPluginOp: s[43] || (s[43] = (ze) => Ol(ze)),
            onPluginOpen: s[44] || (s[44] = (ze) => Hp(ze.plugin, ze.req)),
            onOpenTag: zT,
            onClose: Qg,
            onShareCreated: xA,
            onManagePermissions: zA,
            onToast: Qe,
            onChanged: s[45] || (s[45] = () => {
              var ze;
              return Tn.value ? void ((ze = Xt.value) == null ? void 0 : ze.reload()) : void xt();
            })
          }, null, 8, ["api", "nodes", "dir-label", "dir-count", "dir-perm", "held-in", "locale", "narrow", "caller-admin", "sharing", "in-encrypted", "thumb-src", "api-base", "auth-headers", "auth-credentials", "plugin-views", "theme", "storages", "user-name", "onOpenTag", "onShareCreated"])) : D("", !0)
        ], 2),
        os.value || Vl.value ? (p(), h("div", {
          key: 0,
          class: "fe-overlay",
          "data-testid": "explorer-overlay",
          onClick: vt(Vc, ["self"])
        }, [
          c("div", {
            class: "fe-overlay__card",
            onClick: s[46] || (s[46] = vt(() => {
            }, ["stop"]))
          }, [
            os.value ? (p(), Je(iW, {
              key: 0,
              config: e.config,
              closable: "",
              onClose: Vc,
              onError: fA
            }, null, 8, ["config"])) : (p(), h(Ce, { key: 1 }, [
              c("header", bae, [
                c("h2", kae, y(u(C)("sidenav.apikeys")), 1),
                c("button", {
                  type: "button",
                  class: "fe-overlay__close",
                  title: u(C)("overlay.close"),
                  "aria-label": u(C)("overlay.close"),
                  onClick: Vc
                }, " × ", 8, wae)
              ]),
              tt(c$, {
                config: e.config,
                full: ""
              }, null, 8, ["config"])
            ], 64))
          ])
        ])) : D("", !0),
        To.value ? (p(), h("div", _ae, [
          c("div", xae, [
            c("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("upload")
            }, null, 8, Sae),
            c("p", null, y(u(C)("dropzone.hint")), 1)
          ])
        ])) : D("", !0),
        tt(e4, {
          jobs: Kn.value,
          locale: q.value,
          center: u(su),
          onCancel: qE,
          onDismiss: WE,
          onRetry: eC
        }, null, 8, ["jobs", "locale", "center"]),
        tt(n4, {
          ops: u(Me).ops.value,
          locale: q.value,
          center: u(su),
          "output-mode-of": TT,
          "caller-admin": ba.value,
          onCancel: DE,
          onDismiss: s[47] || (s[47] = (ze) => u(Me).dismiss(ze)),
          onOpen: ET
        }, null, 8, ["ops", "locale", "center", "caller-admin"]),
        tt(ZY, {
          center: u(su),
          locale: q.value,
          narrow: Pa.value
        }, null, 8, ["center", "locale", "narrow"]),
        Pa.value && td.value ? (p(), h("button", {
          key: 2,
          type: "button",
          class: "fe-fab",
          title: u(C)("toolbar.upload"),
          "aria-label": u(C)("toolbar.upload"),
          onClick: So
        }, [...s[125] || (s[125] = [
          c("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            c("path", { d: "M12 5v14M5 12h14" })
          ], -1)
        ])], 8, $ae)) : D("", !0),
        ms.value ? (p(), h("div", Tae, [
          s[126] || (s[126] = c("span", {
            class: "fe-keep-strip__icon",
            "aria-hidden": "true"
          }, "⟳", -1)),
          c("span", Aae, y(fE.value), 1),
          jb.value !== null ? (p(), h("div", Eae, [
            c("div", {
              class: "fe-keep-strip__fill",
              style: Yt({ width: jb.value + "%" })
            }, null, 4)
          ])) : D("", !0)
        ])) : D("", !0),
        tt(rl, {
          ref_key: "ctxRef",
          ref: yh,
          locale: q.value,
          theme: gn.value,
          sheet: Eb.value,
          actions: Wb.value,
          onSelect: _E
        }, null, 8, ["locale", "theme", "sheet", "actions"]),
        tt(u(_), {
          open: Il.value,
          locale: q.value,
          theme: gn.value,
          api: u(S),
          types: Yg.value,
          "current-path": Nt(De.value),
          storages: (O.config.storages ?? []).map((ze) => ze.name),
          "only-office-ready": !!Wo.value,
          "drawio-ready": !!Rl.value,
          "can-configure": ba.value,
          "withheld-words": ((ue = ee.value) == null ? void 0 : ue.newdoc_withheld) ?? null,
          drafts: Yo.value,
          onClose: s[48] || (s[48] = (ze) => Il.value = !1),
          onOpenDrafts: UT,
          onCreated: EE,
          onError: s[49] || (s[49] = (ze) => U("error", { message: ze.message, context: { op: "newdoc" } }))
        }, null, 8, ["open", "locale", "theme", "api", "types", "current-path", "storages", "only-office-ready", "drawio-ready", "can-configure", "withheld-words", "drafts"]),
        tt(DQ, {
          open: ia.value,
          locale: q.value,
          "encrypted-option": Rk.value === "allowed",
          "encrypted-request": Rk.value === "request",
          busy: u(GT),
          error: u(XT),
          onClose: s[50] || (s[50] = (ze) => ia.value = !1),
          onSubmit: LE,
          onEncrypted: s[51] || (s[51] = (ze) => {
            ia.value = !1, ar.value = !0;
          }),
          onRequestEncrypted: AC
        }, null, 8, ["open", "locale", "encrypted-option", "encrypted-request", "busy", "error"]),
        tt(u(w), {
          open: Bc.value,
          locale: q.value,
          count: Bl.value.length,
          "suggested-name": HT.value,
          "default-format": VT.value,
          "allowed-formats": Fl.value,
          encryption: jT.value,
          busy: Gp.value,
          "request-error": ki.value,
          onClose: s[52] || (s[52] = (ze) => Bc.value = !1),
          onSubmit: zE
        }, null, 8, ["open", "locale", "count", "suggested-name", "default-format", "allowed-formats", "encryption", "busy", "request-error"]),
        tt(HQ, {
          open: Xo.value,
          locale: q.value,
          "archive-name": (($e = go.value) == null ? void 0 : $e.basename) || "",
          "suggested-folder": qT.value,
          busy: !!go.value && Jo.value.has(go.value.path),
          error: ki.value,
          onClose: s[53] || (s[53] = (ze) => Xo.value = !1),
          onSubmit: ME
        }, null, 8, ["open", "locale", "archive-name", "suggested-folder", "busy", "error"]),
        tt(XQ, {
          open: Gr.value,
          locale: q.value,
          "archive-name": ((Ae = Zo.value) == null ? void 0 : Ae.target.basename) || ((st = go.value) == null ? void 0 : st.basename) || "",
          busy: !!Zo.value && Jo.value.has(Zo.value.target.path),
          error: Zr.value,
          onClose: OE,
          onSubmit: PE
        }, null, 8, ["open", "locale", "archive-name", "busy", "error"]),
        tt(ag, {
          open: as.value,
          api: X,
          "vault-roots": eA.value,
          "vault-from": tA.value,
          locale: q.value,
          mode: Fc.value,
          busy: Hc.value,
          storages: (O.config.storages ?? []).map((ze) => ze.name),
          "start-at": Nt(Tn.value ? ((Ze = Xt.value) == null ? void 0 : Ze.getPath()) ?? "" : De.value),
          moving: Fc.value === "move" ? Uc.value.filter((ze) => ze.type === "dir").map((ze) => ze.path) : [],
          onClose: s[54] || (s[54] = (ze) => as.value = !1),
          onPick: AE
        }, null, 8, ["open", "api", "vault-roots", "vault-from", "locale", "mode", "busy", "storages", "start-at", "moving"]),
        tt(u(M), {
          open: ar.value,
          locale: q.value,
          busy: ir.value,
          "escrow-kid": Ka.value,
          existing: dr.value ? dr.value.basename : null,
          "vault-available": ((Dt = ee.value) == null ? void 0 : Dt.e2e_vault) === !0,
          onClose: s[55] || (s[55] = (ze) => {
            ar.value = !1, dr.value = null;
          }),
          onSubmit: s[56] || (s[56] = (ze) => dr.value ? ez(ze) : RC(ze))
        }, null, 8, ["open", "locale", "busy", "escrow-kid", "existing", "vault-available"]),
        tt(nQ, {
          open: !!or.value,
          locale: q.value,
          api: u(S),
          path: ((Sn = or.value) == null ? void 0 : Sn.path) ?? "",
          kind: ((Ct = or.value) == null ? void 0 : Ct.kind) ?? "folder",
          name: ((Va = or.value) == null ? void 0 : Va.name) ?? "",
          onClose: s[57] || (s[57] = (ze) => or.value = null),
          onSent: EC
        }, null, 8, ["open", "locale", "api", "path", "kind", "name"]),
        tt(u(N), {
          open: Ao.value,
          locale: q.value,
          "recovery-key": Eo.value,
          "folder-name": Co.value,
          "escrow-kid": Ka.value,
          variant: rr.value,
          onClose: dz
        }, null, 8, ["open", "locale", "recovery-key", "folder-name", "escrow-kid", "variant"]),
        tt(u(A), {
          open: Di.value,
          locale: q.value,
          level: Od.value,
          "can-raise": GC.value,
          "plain-named": XC.value,
          "escrow-state": jk.value === "n/a" || zo.value ? "n/a" : jk.value,
          busy: io.value,
          onClose: s[58] || (s[58] = (ze) => Di.value = !1),
          onRaiseLevel: Dd,
          onFixNames: Dd,
          onChangePassword: nz,
          onEscrow: az
        }, null, 8, ["open", "locale", "level", "can-raise", "plain-named", "escrow-state", "busy"]),
        tt(u(T), {
          open: Ts.value,
          locale: q.value,
          mode: um.value,
          "needs-rekey": oz.value,
          vault: Od.value === "vault",
          "has-recovery": u(u_)(en.value),
          "has-escrow": u(Z2)(en.value),
          busy: bu.value,
          error: pr.value,
          onClose: rz,
          onSubmit: sz
        }, null, 8, ["open", "locale", "mode", "needs-rekey", "vault", "has-recovery", "has-escrow", "busy", "error"]),
        tt(u(z), {
          open: zd.value,
          locale: q.value,
          "has-recovery": u(u_)(en.value),
          "escrow-state": u(Q2)(en.value, Ka.value),
          "escrow-kid": ((_n = (fn = en.value) == null ? void 0 : fn.esc) == null ? void 0 : _n.kid) || Ka.value,
          busy: em.value,
          error: ao.value,
          onClose: s[59] || (s[59] = (ze) => zd.value = !1),
          onSubmit: HC
        }, null, 8, ["open", "locale", "has-recovery", "escrow-state", "escrow-kid", "busy", "error"]),
        tt(u(L), {
          open: !!u(Pt).encryptTarget.value,
          locale: q.value,
          "file-name": ((Li = u(Pt).encryptTarget.value) == null ? void 0 : Li.basename) ?? "",
          busy: u(Pt).encryptBusy.value,
          error: u(Pt).encryptError.value,
          progress: u(Pt).encryptProgress.value,
          "escrow-kid": Ka.value,
          "can-purge": ba.value,
          "not-owner": !!u(Pt).encryptTarget.value && !u(wp)(u(Pt).encryptTarget.value),
          "owner-name": u(Pt).encryptTarget.value ? u(Yy)(u(Pt).encryptTarget.value) : "",
          onClose: s[60] || (s[60] = (ze) => u(Pt).closeEncrypt()),
          onSubmit: s[61] || (s[61] = (ze) => u(Pt).submitEncrypt(ze))
        }, null, 8, ["open", "locale", "file-name", "busy", "error", "progress", "escrow-kid", "can-purge", "not-owner", "owner-name"]),
        tt(u(B), {
          open: !!u(Pt).unlockTarget.value,
          locale: q.value,
          intent: u(Pt).unlockIntent.value,
          "file-name": u(Pt).unlockTarget.value ? u(Pt).realName(u(Pt).unlockTarget.value.path) ?? u(Pt).unlockTarget.value.basename : "",
          known: !!u(Pt).unlockTarget.value && !!u(Pt).realName(u(Pt).unlockTarget.value.path),
          "has-recovery": u(Pt).unlockHasRecovery.value,
          busy: u(Pt).unlockBusy.value,
          error: u(Pt).unlockError.value,
          progress: u(Pt).unlockProgress.value,
          "needs-save": u(Pt).unlockNeedsSave.value,
          "escrow-state": u(Pt).unlockEscrow.value,
          "escrow-kid": u(Pt).unlockEscrowKid.value || Ka.value,
          onClose: s[62] || (s[62] = (ze) => u(Pt).closeUnlock()),
          onSubmit: s[63] || (s[63] = (ze) => u(Pt).submitUnlock(ze))
        }, null, 8, ["open", "locale", "intent", "file-name", "known", "has-recovery", "busy", "error", "progress", "needs-save", "escrow-state", "escrow-kid"]),
        tt(cZ, {
          open: !!u(Pt).tooBig.value,
          locale: q.value,
          info: u(Pt).tooBig.value,
          onClose: s[64] || (s[64] = (ze) => u(Pt).closeTooBig()),
          onDownload: cz
        }, null, 8, ["open", "locale", "info"]),
        tt(u(T), {
          open: !!u(Pt).pwTarget.value,
          locale: q.value,
          mode: "change",
          subject: "file",
          "needs-rekey": !1,
          "has-recovery": !0,
          "has-escrow": !1,
          busy: u(Pt).pwBusy.value,
          error: u(Pt).pwError.value,
          onClose: s[65] || (s[65] = (ze) => u(Pt).closePassword()),
          onSubmit: s[66] || (s[66] = (ze) => u(Pt).submitPassword(ze))
        }, null, 8, ["open", "locale", "busy", "error"]),
        tt(see, {
          open: Xi.value,
          locale: q.value,
          "current-name": ((ja = Qo.value) == null ? void 0 : ja.basename) || "",
          error: u(YT),
          busy: u(WT),
          onClose: s[67] || (s[67] = (ze) => Xi.value = !1),
          onSubmit: RE
        }, null, 8, ["open", "locale", "current-name", "error", "busy"]),
        tt(na, {
          open: Zl.value,
          title: u(C)("trash.empty_confirm_title"),
          size: "sm",
          onClose: s[69] || (s[69] = (ze) => Zl.value = !1)
        }, {
          actions: gt(() => [
            c("button", {
              type: "button",
              class: "fe-btn",
              onClick: s[68] || (s[68] = (ze) => Zl.value = !1)
            }, y(u(C)("modal.delete.cancel")), 1),
            c("button", {
              type: "button",
              class: "fe-btn fe-btn--danger",
              "data-testid": "trash-empty-confirm",
              disabled: !fs.value || fs.value.count === 0,
              onClick: jA
            }, y(u(C)("trash.empty_action")), 9, Pae)
          ]),
          default: gt(() => [
            fs.value ? (p(), h("p", Cae, y(fs.value.summary), 1)) : rd.value ? (p(), h("p", zae, y(rd.value), 1)) : (p(), h("p", Mae, y(u(C)("trash.empty_counting")), 1))
          ]),
          _: 1
        }, 8, ["open", "title"]),
        tt(dee, {
          open: ua.value,
          locale: q.value,
          count: u(Ke).size.value,
          permanent: At.value || IC.value,
          busy: u(JT),
          error: u(ZT),
          onClose: s[70] || (s[70] = (ze) => ua.value = !1),
          onConfirm: IE
        }, null, 8, ["open", "locale", "count", "permanent", "busy", "error"]),
        tt(u(r), {
          open: oa.value,
          locale: q.value,
          file: cn.value,
          theme: gn.value,
          "preview-url": (ze) => Pd(ze),
          "download-url": (ze) => qn.value || du.value || u(V).rootOf(ze) ? Pd(ze) : u(S).downloadUrl(ze),
          "only-office-base": Qt.value || du.value || yu.value ? null : Wo.value,
          "only-office-config-endpoint": Wg.value,
          "can-configure": ba.value,
          "new-tab-enabled": !Qt.value && !du.value && !yu.value,
          "save-text-endpoint": Qt.value || du.value || yu.value ? null : u(S).endpoints.saveText || null,
          "archive-list-endpoint": yu.value ? null : u(S).endpoints.archiveList || null,
          "open-mode": Ia.value,
          "open-as": QT.value,
          "auth-headers": () => Xn({ "Content-Type": "application/json" }),
          "auth-credentials": u(S).credentialsMode(),
          "drawio-url": Rl.value,
          "pdf-worker-url": O.config.pdfWorkerUrl || null,
          "pdf-save-url": O.config.pdfSaveUrl || null,
          "viewer-base-url": pk.value,
          index: et.value.index,
          total: et.value.total,
          "nav-enabled": et.value.total > 1,
          "share-enabled": !Qt.value && !du.value && !yu.value,
          onShare: s[71] || (s[71] = (ze) => {
            const Wn = ze ?? cn.value;
            Wn && (_i.value = Wn, qc.value = void 0, ns.value = !0);
          }),
          "api-base": O.config.apiBase ?? "",
          "drafts-endpoint": Yo.value ? u(S).draftsBase : null,
          "app-viewer": Rg.value,
          "app-e2e": OC.value,
          "in-office": hT.value,
          api: u(S),
          "user-name": O.config.userName || "",
          storages: (O.config.storages ?? []).map((ze) => ze.name),
          onToast: Qe,
          onOp: s[72] || (s[72] = (ze) => Ol(ze)),
          onNav: oe,
          onDraftSaved: BT,
          onDraftDiscarded: FT,
          onSaved: je,
          onAppDirty: MC,
          onClose: s[73] || (s[73] = (ze) => oa.value = !1)
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "can-configure", "new-tab-enabled", "save-text-endpoint", "archive-list-endpoint", "open-mode", "open-as", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "pdf-save-url", "viewer-base-url", "index", "total", "nav-enabled", "share-enabled", "api-base", "drafts-endpoint", "app-viewer", "app-e2e", "in-office", "api", "user-name", "storages", "onAppDirty"]),
        tt(Ree, {
          open: !!za.value,
          locale: q.value,
          theme: gn.value,
          name: ((Nd = za.value) == null ? void 0 : Nd.basename) ?? "",
          kind: gT.value,
          handlers: yT.value,
          current: bT.value,
          remembered: za.value ? zl(za.value) : null,
          onCancel: s[74] || (s[74] = (ze) => za.value = null),
          onOpen: kT
        }, null, 8, ["open", "locale", "theme", "name", "kind", "handlers", "current", "remembered"]),
        tt(H1, {
          open: !!W.value,
          kind: "upload",
          locale: q.value,
          theme: gn.value,
          name: ((ow = W.value) == null ? void 0 : ow.name) ?? "",
          suggested: ((rw = W.value) == null ? void 0 : rw.suggested) ?? "",
          folder: ((sw = W.value) == null ? void 0 : sw.folder) ?? "",
          onCancel: s[75] || (s[75] = (ze) => K(!1)),
          onConfirm: s[76] || (s[76] = (ze) => K(!0))
        }, null, 8, ["open", "locale", "theme", "name", "suggested", "folder"]),
        tt(H1, {
          open: !!u(Gi).question.value,
          locale: q.value,
          theme: gn.value,
          name: ((lw = u(Gi).question.value) == null ? void 0 : lw.name) ?? "",
          suggested: ((uw = u(Gi).question.value) == null ? void 0 : uw.suggested) ?? "",
          folder: ((cw = u(Gi).question.value) == null ? void 0 : cw.folder) ?? "",
          busy: u(Gi).busy.value,
          error: u(Gi).error.value,
          onCancel: u(Gi).cancel,
          onConfirm: u(Gi).confirm
        }, null, 8, ["open", "locale", "theme", "name", "suggested", "folder", "busy", "error", "onCancel", "onConfirm"]),
        Ca.value ? (p(), Je(Tee, {
          key: `${Ca.value.plugin}/${Ca.value.view}`,
          api: u(S),
          locale: q.value,
          theme: gn.value,
          plugin: Ca.value.plugin,
          view: Ca.value.view,
          placement: Ca.value.placement,
          ui: Ca.value.ui,
          label: Ca.value.label,
          files: Ca.value.files,
          "user-name": O.config.userName || "",
          storages: (O.config.storages ?? []).map((ze) => ze.name),
          "start-at": Nt(Tn.value ? ((dw = Xt.value) == null ? void 0 : dw.getPath()) ?? "" : De.value),
          onClose: s[77] || (s[77] = (ze) => Ca.value = null),
          onToast: Qe,
          onOp: s[78] || (s[78] = (ze) => Ol(ze))
        }, null, 8, ["api", "locale", "theme", "plugin", "view", "placement", "ui", "label", "files", "user-name", "storages", "start-at"])) : D("", !0),
        mn.value ? (p(), Je(See, {
          key: 5,
          open: dT.value,
          api: u(S),
          locale: q.value,
          theme: gn.value,
          plugin: mn.value.plugin,
          view: mn.value.view,
          surface: mn.value.surface,
          path: mn.value.path,
          paths: mn.value.paths,
          size: mn.value.size,
          label: mn.value.label,
          storages: (O.config.storages ?? []).map((ze) => ze.name),
          "start-at": Nt(Tn.value ? ((fw = Xt.value) == null ? void 0 : fw.getPath()) ?? "" : De.value),
          onClose: s[79] || (s[79] = (ze) => mn.value = null),
          onOp: s[80] || (s[80] = (ze) => Ol(ze)),
          onToast: Qe,
          onOpen: s[81] || (s[81] = (ze) => {
            var Wn;
            return Hp(((Wn = mn.value) == null ? void 0 : Wn.plugin) ?? "", ze);
          })
        }, null, 8, ["open", "api", "locale", "theme", "plugin", "view", "surface", "path", "paths", "size", "label", "storages", "start-at"])) : D("", !0),
        tt(e$, {
          open: !!bi.value,
          locale: q.value,
          theme: gn.value,
          title: bi.value ? u(Gt)(bi.value.action.label, q.value) : "",
          message: bi.value ? u(Gt)(bi.value.action.confirm, q.value) : "",
          danger: ((pw = bi.value) == null ? void 0 : pw.action.danger) === !0,
          onClose: s[82] || (s[82] = (ze) => bi.value = null),
          onConfirm: AT
        }, null, 8, ["open", "locale", "theme", "title", "message", "danger"]),
        ns.value && _i.value ? (p(), Je(u(m), {
          key: 6,
          api: u(S),
          path: _i.value.path,
          "is-dir": _i.value.type === "dir",
          locale: q.value,
          "share-max-ttl-days": Yi.value,
          "initial-tab": qc.value,
          "mail-ready": (mw = (hw = ee.value) == null ? void 0 : hw.mail) == null ? void 0 : mw.ready,
          "can-configure": ba.value,
          perm: _i.value.perm || Ne.value,
          sharing: RA.value,
          onClose: s[83] || (s[83] = (ze) => {
            ns.value = !1, qc.value = void 0;
          })
        }, null, 8, ["api", "path", "is-dir", "locale", "share-max-ttl-days", "initial-tab", "mail-ready", "can-configure", "perm", "sharing"])) : D("", !0),
        tt(kr, { name: "fe-modal" }, {
          default: gt(() => [
            Wr.value ? (p(), h("div", {
              key: 0,
              class: Fe(["fe fe-modal__backdrop fe-recents__backdrop", {
                "fe--theme-light": gn.value === "light",
                "fe--theme-dark": gn.value === "dark"
              }]),
              onClick: s[87] || (s[87] = (ze) => Wr.value = !1)
            }, [
              c("div", {
                class: "fe-recents__panel",
                onClick: s[86] || (s[86] = vt(() => {
                }, ["stop"]))
              }, [
                c("div", Oae, [
                  c("strong", null, y(u(C)("recents.title")), 1),
                  c("button", {
                    class: "fe-recents__close",
                    "aria-label": u(C)("recents.close"),
                    onClick: s[84] || (s[84] = (ze) => Wr.value = !1)
                  }, "×", 8, Dae)
                ]),
                tt(UL, {
                  locale: q.value,
                  "api-base": O.config.apiBase ?? "",
                  "auth-headers": () => Xn(),
                  "auth-credentials": u(S).credentialsMode(),
                  limit: 20,
                  "refresh-key": Ug.value,
                  onOpen: OT,
                  onContext: DT,
                  onError: s[85] || (s[85] = (ze) => U("error", { message: ze, context: { op: "recents" } }))
                }, null, 8, ["locale", "api-base", "auth-headers", "auth-credentials", "refresh-key"])
              ])
            ], 2)) : D("", !0)
          ]),
          _: 1
        }),
        tt(kr, { name: "fe-modal" }, {
          default: gt(() => [
            Dl.value && Ll.value && typeof Ll.value.id == "number" ? (p(), h("div", {
              key: 0,
              class: "fe-modal__backdrop",
              onClick: s[92] || (s[92] = (ze) => Dl.value = !1)
            }, [
              c("div", {
                class: "fe-modal__card fe-modal__card--md",
                onClick: s[91] || (s[91] = vt(() => {
                }, ["stop"]))
              }, [
                c("header", Lae, [
                  c("h2", Rae, y(u(C)("tags.title")) + " - " + y(Ll.value.basename), 1),
                  c("button", {
                    class: "fe-modal__close",
                    "aria-label": u(C)("tags.close"),
                    onClick: s[88] || (s[88] = (ze) => Dl.value = !1)
                  }, "×", 8, Nae)
                ]),
                c("div", Iae, [
                  tt(p2, {
                    "node-id": Ll.value.id,
                    locale: q.value,
                    "api-base": O.config.apiBase ?? "",
                    "auth-headers": () => Xn(),
                    "auth-credentials": u(S).credentialsMode(),
                    onOpen: s[89] || (s[89] = (ze) => {
                    }),
                    onError: s[90] || (s[90] = (ze) => U("error", { message: ze, context: { op: "tags" } }))
                  }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
                ])
              ])
            ])) : D("", !0)
          ]),
          _: 1
        }),
        tt(u(v), {
          open: jl.value,
          locale: q.value,
          theme: gn.value,
          "initial-query": ub.value,
          "folder-label": cb.value,
          "path-base": rb.value,
          "content-search": mA.value,
          count: yA,
          "known-tags": ob.value,
          onClose: s[93] || (s[93] = (ze) => jl.value = !1),
          onSubmit: bA
        }, null, 8, ["open", "locale", "theme", "initial-query", "folder-label", "path-base", "content-search", "known-tags"]),
        tt(u(b), {
          "initial-query": ah.value,
          open: cd.value,
          locale: q.value,
          files: xe.value,
          "view-mode": ve.value,
          "can-write": ni.value && !pe.value && !Bt.value,
          "can-go-up": Ea.value,
          "global-search": JA,
          "hit-can": eE,
          onClose: s[94] || (s[94] = (ze) => cd.value = !1),
          onOpenHit: QA,
          onDownloadHit: nE,
          onDragHit: aE,
          onWarmHit: tE,
          onDropInside: iE,
          onOpenNode: Ha,
          onNavigate: s[95] || (s[95] = (ze) => xt(ze)),
          onNewFolder: s[96] || (s[96] = (ze) => ia.value = !0),
          onUpload: So,
          onToggleView: s[97] || (s[97] = (ze) => $k(Xh.value === "list" ? "grid" : Xh.value === "grid" ? "gallery" : "list")),
          onOpenTrash: $i,
          onRefresh: Pb,
          onGoUp: Ue,
          onOpenTheme: s[98] || (s[98] = (ze) => wd.value = !0),
          onOpenShortcutSettings: s[99] || (s[99] = (ze) => ru.value = !0),
          onStartTour: s[100] || (s[100] = (ze) => Wh()),
          "split-enabled": cu.value,
          onTabNew: s[101] || (s[101] = (ze) => Gh()),
          onSplitToggle: s[102] || (s[102] = (ze) => _k())
        }, null, 8, ["initial-query", "open", "locale", "files", "view-mode", "can-write", "can-go-up", "hit-can", "onOpenHit", "onDownloadHit", "onDragHit", "onWarmHit", "onDropInside", "onRefresh", "split-enabled"]),
        tt(vW, {
          open: dd.value,
          locale: q.value,
          onClose: s[103] || (s[103] = (ze) => dd.value = !1),
          onCustomize: s[104] || (s[104] = (ze) => {
            dd.value = !1, ru.value = !0;
          })
        }, null, 8, ["open", "locale"]),
        yn.value ? (p(), Je(u(d), {
          key: 7,
          modelValue: yn.value,
          "onUpdate:modelValue": s[105] || (s[105] = (ze) => yn.value = ze),
          host: Ra
        }, null, 8, ["modelValue"])) : D("", !0),
        u(te) ? (p(), Je($te, {
          key: 8,
          feed: u(te),
          locale: q.value,
          onOpen: dn
        }, null, 8, ["feed", "locale"])) : D("", !0),
        tt(cY, {
          open: wd.value,
          locale: q.value,
          theme: gn.value,
          dark: qh.value,
          current: u(_d),
          mode: u(ou),
          "host-mode": e.config.theme || "auto",
          onClose: s[106] || (s[106] = (ze) => wd.value = !1),
          onSelect: u(GE),
          onMode: s[107] || (s[107] = (ze) => u(hk)(ze))
        }, null, 8, ["open", "locale", "theme", "dark", "current", "mode", "host-mode", "onSelect"]),
        c("input", {
          ref_key: "fileInputEl",
          ref: Zg,
          type: "file",
          multiple: "",
          class: "fe__file-input",
          onChange: BE
        }, null, 544),
        tt(kr, { name: "fe-toast" }, {
          default: gt(() => [
            ca.value ? (p(), h("div", {
              key: 0,
              class: Fe(["fe-toast", { "fe-toast--action": !!ca.value.actionLabel }]),
              role: "status",
              onClick: bh
            }, [
              c("span", Bae, y(ca.value.message), 1),
              ca.value.actionLabel && ca.value.action ? (p(), h("button", {
                key: 0,
                type: "button",
                class: "fe-toast__action",
                onClick: vt(IA, ["stop"])
              }, y(ca.value.actionLabel), 1)) : D("", !0)
            ], 2)) : D("", !0)
          ]),
          _: 1
        }),
        tt(u(f), {
          open: Ye.value,
          locale: q.value,
          theme: gn.value,
          onClose: s[108] || (s[108] = (ze) => Ye.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        tt(u(x), {
          open: ru.value,
          locale: q.value,
          theme: gn.value,
          onClose: s[109] || (s[109] = (ze) => ru.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        tt(u(l), {
          open: eo.value,
          locale: q.value,
          file: Ci.value,
          theme: gn.value,
          "preview-url": (ze) => Pd(ze),
          "download-url": (ze) => qn.value || u(V).rootOf(ze) ? Pd(ze) : u(S).downloadUrl(ze),
          "only-office-base": Qt.value ? null : Wo.value,
          "only-office-config-endpoint": Wg.value,
          "can-configure": ba.value,
          "auth-headers": () => Xn({ "Content-Type": "application/json" }),
          "auth-credentials": u(S).credentialsMode(),
          "drawio-url": Rl.value,
          "pdf-worker-url": O.config.pdfWorkerUrl || null,
          "viewer-base-url": pk.value,
          onClose: s[110] || (s[110] = (ze) => eo.value = !1),
          onNav: ZE,
          onOpenFull: QE
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "can-configure", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "viewer-base-url"]),
        tt(u(k), {
          open: xd.value,
          locale: q.value,
          root: xn.value,
          theme: gn.value,
          onClose: tC
        }, null, 8, ["open", "locale", "root", "theme"])
      ], 42, qte);
    };
  }
});
/*! @license DOMPurify 3.4.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.2/LICENSE */
const {
  entries: W$,
  setPrototypeOf: n0,
  isFrozen: Jae,
  getPrototypeOf: Zae,
  getOwnPropertyDescriptor: Qae
} = Object;
let {
  freeze: ga,
  seal: Qa,
  create: Ns
} = Object, {
  apply: ey,
  construct: ty
} = typeof Reflect < "u" && Reflect;
ga || (ga = function(t) {
  return t;
});
Qa || (Qa = function(t) {
  return t;
});
ey || (ey = function(t, n) {
  for (var a = arguments.length, i = new Array(a > 2 ? a - 2 : 0), r = 2; r < a; r++)
    i[r - 2] = arguments[r];
  return t.apply(n, i);
});
ty || (ty = function(t) {
  for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    a[i - 1] = arguments[i];
  return new t(...a);
});
const $u = Un(Array.prototype.forEach), eie = Un(Array.prototype.lastIndexOf), a0 = Un(Array.prototype.pop), Tu = Un(Array.prototype.push), tie = Un(Array.prototype.splice), da = Array.isArray, Mu = Un(String.prototype.toLowerCase), Wm = Un(String.prototype.toString), i0 = Un(String.prototype.match), Ds = Un(String.prototype.replace), o0 = Un(String.prototype.indexOf), nie = Un(String.prototype.trim), aie = Un(Number.prototype.toString), iie = Un(Boolean.prototype.toString), r0 = typeof BigInt > "u" ? null : Un(BigInt.prototype.toString), s0 = typeof Symbol > "u" ? null : Un(Symbol.prototype.toString), On = Un(Object.prototype.hasOwnProperty), Au = Un(Object.prototype.toString), ea = Un(RegExp.prototype.test), Gd = oie(TypeError);
function Un(e) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      a[i - 1] = arguments[i];
    return ey(e, t, a);
  };
}
function oie(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return ty(e, n);
  };
}
function qt(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Mu;
  if (n0 && n0(e, null), !da(t))
    return e;
  let a = t.length;
  for (; a--; ) {
    let i = t[a];
    if (typeof i == "string") {
      const r = n(i);
      r !== i && (Jae(t) || (t[a] = r), i = r);
    }
    e[i] = !0;
  }
  return e;
}
function rie(e) {
  for (let t = 0; t < e.length; t++)
    On(e, t) || (e[t] = null);
  return e;
}
function wa(e) {
  const t = Ns(null);
  for (const [n, a] of W$(e))
    On(e, n) && (da(a) ? t[n] = rie(a) : a && typeof a == "object" && a.constructor === Object ? t[n] = wa(a) : t[n] = a);
  return t;
}
function sie(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return aie(e);
    case "boolean":
      return iie(e);
    case "bigint":
      return r0 ? r0(e) : "0";
    case "symbol":
      return s0 ? s0(e) : "Symbol()";
    case "undefined":
      return Au(e);
    case "function":
    case "object": {
      if (e === null)
        return Au(e);
      const t = e, n = Is(t, "toString");
      if (typeof n == "function") {
        const a = n(t);
        return typeof a == "string" ? a : Au(a);
      }
      return Au(e);
    }
    default:
      return Au(e);
  }
}
function Is(e, t) {
  for (; e !== null; ) {
    const a = Qae(e, t);
    if (a) {
      if (a.get)
        return Un(a.get);
      if (typeof a.value == "function")
        return Un(a.value);
    }
    e = Zae(e);
  }
  function n() {
    return null;
  }
  return n;
}
function lie(e) {
  try {
    return ea(e, ""), !0;
  } catch {
    return !1;
  }
}
const l0 = ga(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Ym = ga(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Gm = ga(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), uie = ga(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Xm = ga(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), cie = ga(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), u0 = ga(["#text"]), c0 = ga(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Jm = ga(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), d0 = ga(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Xd = ga(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), die = Qa(/\{\{[\w\W]*|[\w\W]*\}\}/gm), fie = Qa(/<%[\w\W]*|[\w\W]*%>/gm), pie = Qa(/\$\{[\w\W]*/gm), hie = Qa(/^data-[\-\w.\u00B7-\uFFFF]+$/), mie = Qa(/^aria-[\-\w]+$/), Y$ = Qa(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), vie = Qa(/^(?:\w+script|data):/i), yie = Qa(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), G$ = Qa(/^html$/i), gie = Qa(/^[a-z][.\w]*(-[.\w]+)+$/i);
var f0 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: mie,
  ATTR_WHITESPACE: yie,
  CUSTOM_ELEMENT: gie,
  DATA_ATTR: hie,
  DOCTYPE_NAME: G$,
  ERB_EXPR: fie,
  IS_ALLOWED_URI: Y$,
  IS_SCRIPT_OR_DATA: vie,
  MUSTACHE_EXPR: die,
  TMPLIT_EXPR: pie
});
const Eu = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, bie = function() {
  return typeof window > "u" ? null : window;
}, kie = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let a = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (a = n.getAttribute(i));
  const r = "dompurify" + (a ? "#" + a : "");
  try {
    return t.createPolicy(r, {
      createHTML(l) {
        return l;
      },
      createScriptURL(l) {
        return l;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + r + " could not be created."), null;
  }
}, p0 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function X$() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : bie();
  const t = (et) => X$(et);
  if (t.version = "3.4.2", t.removed = [], !e || !e.document || e.document.nodeType !== Eu.document || !e.Element)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const a = n, i = a.currentScript, {
    DocumentFragment: r,
    HTMLTemplateElement: l,
    Node: d,
    Element: f,
    NodeFilter: m,
    NamedNodeMap: v = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: b,
    DOMParser: _,
    trustedTypes: w
  } = e, k = f.prototype, x = Is(k, "cloneNode"), M = Is(k, "remove"), A = Is(k, "nextSibling"), T = Is(k, "childNodes"), N = Is(k, "parentNode");
  if (typeof l == "function") {
    const et = n.createElement("template");
    et.content && et.content.ownerDocument && (n = et.content.ownerDocument);
  }
  let z, L = "";
  const {
    implementation: B,
    createNodeIterator: O,
    createDocumentFragment: U,
    getElementsByTagName: S
  } = n, {
    importNode: F
  } = a;
  let I = p0();
  t.isSupported = typeof W$ == "function" && typeof N == "function" && B && B.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: G,
    ERB_EXPR: Y,
    TMPLIT_EXPR: ie,
    DATA_ATTR: me,
    ARIA_ATTR: q,
    IS_SCRIPT_OR_DATA: C,
    ATTR_WHITESPACE: re,
    CUSTOM_ELEMENT: de
  } = f0;
  let {
    IS_ALLOWED_URI: V
  } = f0, W = null;
  const ne = qt({}, [...l0, ...Ym, ...Gm, ...Xm, ...u0]);
  let K = null;
  const ce = qt({}, [...c0, ...Jm, ...d0, ...Xd]);
  let J = Object.seal(Ns(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), H = null, X = null;
  const we = Object.seal(Ns(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let it = !0, Re = !0, Be = !1, We = !0, bt = !1, at = !0, Ie = !1, nt = !1, dt = !1, Me = !1, be = !1, Ve = !1, Te = !0, qe = !1;
  const De = "user-content-";
  let mt = !0, $t = !1, kt = {}, Tt = null;
  const xe = qt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Ne = null;
  const fe = qt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Se = null;
  const Z = qt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), ge = "http://www.w3.org/1998/Math/MathML", ae = "http://www.w3.org/2000/svg", ve = "http://www.w3.org/1999/xhtml";
  let le = ve, _e = !1, Ee = null;
  const ht = qt({}, [ge, ae, ve], Wm);
  let jt = qt({}, ["mi", "mo", "mn", "ms", "mtext"]), tn = qt({}, ["annotation-xml"]);
  const Cn = qt({}, ["title", "style", "font", "a", "script"]);
  let Lt = null;
  const At = ["application/xhtml+xml", "text/html"], zn = "text/html";
  let Bt = null, ft = null;
  const Dn = n.createElement("form"), Qn = function(oe) {
    return oe instanceof RegExp || oe instanceof Function;
  }, Ln = function() {
    let oe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (ft && ft === oe)
      return;
    (!oe || typeof oe != "object") && (oe = {}), oe = wa(oe), Lt = // eslint-disable-next-line unicorn/prefer-includes
    At.indexOf(oe.PARSER_MEDIA_TYPE) === -1 ? zn : oe.PARSER_MEDIA_TYPE, Bt = Lt === "application/xhtml+xml" ? Wm : Mu, W = On(oe, "ALLOWED_TAGS") && da(oe.ALLOWED_TAGS) ? qt({}, oe.ALLOWED_TAGS, Bt) : ne, K = On(oe, "ALLOWED_ATTR") && da(oe.ALLOWED_ATTR) ? qt({}, oe.ALLOWED_ATTR, Bt) : ce, Ee = On(oe, "ALLOWED_NAMESPACES") && da(oe.ALLOWED_NAMESPACES) ? qt({}, oe.ALLOWED_NAMESPACES, Wm) : ht, Se = On(oe, "ADD_URI_SAFE_ATTR") && da(oe.ADD_URI_SAFE_ATTR) ? qt(wa(Z), oe.ADD_URI_SAFE_ATTR, Bt) : Z, Ne = On(oe, "ADD_DATA_URI_TAGS") && da(oe.ADD_DATA_URI_TAGS) ? qt(wa(fe), oe.ADD_DATA_URI_TAGS, Bt) : fe, Tt = On(oe, "FORBID_CONTENTS") && da(oe.FORBID_CONTENTS) ? qt({}, oe.FORBID_CONTENTS, Bt) : xe, H = On(oe, "FORBID_TAGS") && da(oe.FORBID_TAGS) ? qt({}, oe.FORBID_TAGS, Bt) : wa({}), X = On(oe, "FORBID_ATTR") && da(oe.FORBID_ATTR) ? qt({}, oe.FORBID_ATTR, Bt) : wa({}), kt = On(oe, "USE_PROFILES") ? oe.USE_PROFILES && typeof oe.USE_PROFILES == "object" ? wa(oe.USE_PROFILES) : oe.USE_PROFILES : !1, it = oe.ALLOW_ARIA_ATTR !== !1, Re = oe.ALLOW_DATA_ATTR !== !1, Be = oe.ALLOW_UNKNOWN_PROTOCOLS || !1, We = oe.ALLOW_SELF_CLOSE_IN_ATTR !== !1, bt = oe.SAFE_FOR_TEMPLATES || !1, at = oe.SAFE_FOR_XML !== !1, Ie = oe.WHOLE_DOCUMENT || !1, Me = oe.RETURN_DOM || !1, be = oe.RETURN_DOM_FRAGMENT || !1, Ve = oe.RETURN_TRUSTED_TYPE || !1, dt = oe.FORCE_BODY || !1, Te = oe.SANITIZE_DOM !== !1, qe = oe.SANITIZE_NAMED_PROPS || !1, mt = oe.KEEP_CONTENT !== !1, $t = oe.IN_PLACE || !1, V = lie(oe.ALLOWED_URI_REGEXP) ? oe.ALLOWED_URI_REGEXP : Y$, le = typeof oe.NAMESPACE == "string" ? oe.NAMESPACE : ve, jt = On(oe, "MATHML_TEXT_INTEGRATION_POINTS") && oe.MATHML_TEXT_INTEGRATION_POINTS && typeof oe.MATHML_TEXT_INTEGRATION_POINTS == "object" ? wa(oe.MATHML_TEXT_INTEGRATION_POINTS) : qt({}, ["mi", "mo", "mn", "ms", "mtext"]), tn = On(oe, "HTML_INTEGRATION_POINTS") && oe.HTML_INTEGRATION_POINTS && typeof oe.HTML_INTEGRATION_POINTS == "object" ? wa(oe.HTML_INTEGRATION_POINTS) : qt({}, ["annotation-xml"]);
    const je = On(oe, "CUSTOM_ELEMENT_HANDLING") && oe.CUSTOM_ELEMENT_HANDLING && typeof oe.CUSTOM_ELEMENT_HANDLING == "object" ? wa(oe.CUSTOM_ELEMENT_HANDLING) : Ns(null);
    if (J = Ns(null), On(je, "tagNameCheck") && Qn(je.tagNameCheck) && (J.tagNameCheck = je.tagNameCheck), On(je, "attributeNameCheck") && Qn(je.attributeNameCheck) && (J.attributeNameCheck = je.attributeNameCheck), On(je, "allowCustomizedBuiltInElements") && typeof je.allowCustomizedBuiltInElements == "boolean" && (J.allowCustomizedBuiltInElements = je.allowCustomizedBuiltInElements), bt && (Re = !1), be && (Me = !0), kt && (W = qt({}, u0), K = Ns(null), kt.html === !0 && (qt(W, l0), qt(K, c0)), kt.svg === !0 && (qt(W, Ym), qt(K, Jm), qt(K, Xd)), kt.svgFilters === !0 && (qt(W, Gm), qt(K, Jm), qt(K, Xd)), kt.mathMl === !0 && (qt(W, Xm), qt(K, d0), qt(K, Xd))), we.tagCheck = null, we.attributeCheck = null, On(oe, "ADD_TAGS") && (typeof oe.ADD_TAGS == "function" ? we.tagCheck = oe.ADD_TAGS : da(oe.ADD_TAGS) && (W === ne && (W = wa(W)), qt(W, oe.ADD_TAGS, Bt))), On(oe, "ADD_ATTR") && (typeof oe.ADD_ATTR == "function" ? we.attributeCheck = oe.ADD_ATTR : da(oe.ADD_ATTR) && (K === ce && (K = wa(K)), qt(K, oe.ADD_ATTR, Bt))), On(oe, "ADD_URI_SAFE_ATTR") && da(oe.ADD_URI_SAFE_ATTR) && qt(Se, oe.ADD_URI_SAFE_ATTR, Bt), On(oe, "FORBID_CONTENTS") && da(oe.FORBID_CONTENTS) && (Tt === xe && (Tt = wa(Tt)), qt(Tt, oe.FORBID_CONTENTS, Bt)), On(oe, "ADD_FORBID_CONTENTS") && da(oe.ADD_FORBID_CONTENTS) && (Tt === xe && (Tt = wa(Tt)), qt(Tt, oe.ADD_FORBID_CONTENTS, Bt)), mt && (W["#text"] = !0), Ie && qt(W, ["html", "head", "body"]), W.table && (qt(W, ["tbody"]), delete H.tbody), oe.TRUSTED_TYPES_POLICY) {
      if (typeof oe.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Gd('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof oe.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Gd('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      z = oe.TRUSTED_TYPES_POLICY, L = z.createHTML("");
    } else
      z === void 0 && (z = kie(w, i)), z !== null && typeof L == "string" && (L = z.createHTML(""));
    ga && ga(oe), ft = oe;
  }, on = qt({}, [...Ym, ...Gm, ...uie]), In = qt({}, [...Xm, ...cie]), la = function(oe) {
    let je = N(oe);
    (!je || !je.tagName) && (je = {
      namespaceURI: le,
      tagName: "template"
    });
    const Ke = Mu(oe.tagName), _t = Mu(je.tagName);
    return Ee[oe.namespaceURI] ? oe.namespaceURI === ae ? je.namespaceURI === ve ? Ke === "svg" : je.namespaceURI === ge ? Ke === "svg" && (_t === "annotation-xml" || jt[_t]) : !!on[Ke] : oe.namespaceURI === ge ? je.namespaceURI === ve ? Ke === "math" : je.namespaceURI === ae ? Ke === "math" && tn[_t] : !!In[Ke] : oe.namespaceURI === ve ? je.namespaceURI === ae && !tn[_t] || je.namespaceURI === ge && !jt[_t] ? !1 : !In[Ke] && (Cn[Ke] || !on[Ke]) : !!(Lt === "application/xhtml+xml" && Ee[oe.namespaceURI]) : !1;
  }, vn = function(oe) {
    Tu(t.removed, {
      element: oe
    });
    try {
      N(oe).removeChild(oe);
    } catch {
      M(oe);
    }
  }, nn = function(oe, je) {
    try {
      Tu(t.removed, {
        attribute: je.getAttributeNode(oe),
        from: je
      });
    } catch {
      Tu(t.removed, {
        attribute: null,
        from: je
      });
    }
    if (je.removeAttribute(oe), oe === "is")
      if (Me || be)
        try {
          vn(je);
        } catch {
        }
      else
        try {
          je.setAttribute(oe, "");
        } catch {
        }
  }, ln = function(oe) {
    let je = null, Ke = null;
    if (dt)
      oe = "<remove></remove>" + oe;
    else {
      const he = i0(oe, /^[\r\n\t ]+/);
      Ke = he && he[0];
    }
    Lt === "application/xhtml+xml" && le === ve && (oe = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + oe + "</body></html>");
    const _t = z ? z.createHTML(oe) : oe;
    if (le === ve)
      try {
        je = new _().parseFromString(_t, Lt);
      } catch {
      }
    if (!je || !je.documentElement) {
      je = B.createDocument(le, "template", null);
      try {
        je.documentElement.innerHTML = _e ? L : _t;
      } catch {
      }
    }
    const ee = je.body || je.documentElement;
    return oe && Ke && ee.insertBefore(n.createTextNode(Ke), ee.childNodes[0] || null), le === ve ? S.call(je, Ie ? "html" : "body")[0] : Ie ? je.documentElement : ee;
  }, kn = function(oe) {
    return O.call(
      oe.ownerDocument || oe,
      oe,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, Mn = function(oe) {
    return oe instanceof b && (typeof oe.nodeName != "string" || typeof oe.textContent != "string" || typeof oe.removeChild != "function" || !(oe.attributes instanceof v) || typeof oe.removeAttribute != "function" || typeof oe.setAttribute != "function" || typeof oe.namespaceURI != "string" || typeof oe.insertBefore != "function" || typeof oe.hasChildNodes != "function");
  }, Hn = function(oe) {
    return typeof d == "function" && oe instanceof d;
  };
  function rn(et, oe, je) {
    $u(et, (Ke) => {
      Ke.call(t, oe, je, ft);
    });
  }
  const Ea = function(oe) {
    let je = null;
    if (rn(I.beforeSanitizeElements, oe, null), Mn(oe))
      return vn(oe), !0;
    const Ke = Bt(oe.nodeName);
    if (rn(I.uponSanitizeElement, oe, {
      tagName: Ke,
      allowedTags: W
    }), at && oe.hasChildNodes() && !Hn(oe.firstElementChild) && ea(/<[/\w!]/g, oe.innerHTML) && ea(/<[/\w!]/g, oe.textContent) || at && oe.namespaceURI === ve && Ke === "style" && Hn(oe.firstElementChild) || oe.nodeType === Eu.progressingInstruction || at && oe.nodeType === Eu.comment && ea(/<[/\w]/g, oe.data))
      return vn(oe), !0;
    if (H[Ke] || !(we.tagCheck instanceof Function && we.tagCheck(Ke)) && !W[Ke]) {
      if (!H[Ke] && Ue(Ke) && (J.tagNameCheck instanceof RegExp && ea(J.tagNameCheck, Ke) || J.tagNameCheck instanceof Function && J.tagNameCheck(Ke)))
        return !1;
      if (mt && !Tt[Ke]) {
        const _t = N(oe) || oe.parentNode, ee = T(oe) || oe.childNodes;
        if (ee && _t) {
          const he = ee.length;
          for (let Oe = he - 1; Oe >= 0; --Oe) {
            const Ye = x(ee[Oe], !0);
            _t.insertBefore(Ye, A(oe));
          }
        }
      }
      return vn(oe), !0;
    }
    return oe instanceof f && !la(oe) || (Ke === "noscript" || Ke === "noembed" || Ke === "noframes") && ea(/<\/no(script|embed|frames)/i, oe.innerHTML) ? (vn(oe), !0) : (bt && oe.nodeType === Eu.text && (je = oe.textContent, $u([G, Y, ie], (_t) => {
      je = Ds(je, _t, " ");
    }), oe.textContent !== je && (Tu(t.removed, {
      element: oe.cloneNode()
    }), oe.textContent = je)), rn(I.afterSanitizeElements, oe, null), !1);
  }, pe = function(oe, je, Ke) {
    if (X[je] || Te && (je === "id" || je === "name") && (Ke in n || Ke in Dn))
      return !1;
    const _t = K[je] || we.attributeCheck instanceof Function && we.attributeCheck(je, oe);
    if (!(Re && !X[je] && ea(me, je))) {
      if (!(it && ea(q, je))) {
        if (!_t || X[je]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Ue(oe) && (J.tagNameCheck instanceof RegExp && ea(J.tagNameCheck, oe) || J.tagNameCheck instanceof Function && J.tagNameCheck(oe)) && (J.attributeNameCheck instanceof RegExp && ea(J.attributeNameCheck, je) || J.attributeNameCheck instanceof Function && J.attributeNameCheck(je, oe)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            je === "is" && J.allowCustomizedBuiltInElements && (J.tagNameCheck instanceof RegExp && ea(J.tagNameCheck, Ke) || J.tagNameCheck instanceof Function && J.tagNameCheck(Ke)))
          ) return !1;
        } else if (!Se[je]) {
          if (!ea(V, Ds(Ke, re, ""))) {
            if (!((je === "src" || je === "xlink:href" || je === "href") && oe !== "script" && o0(Ke, "data:") === 0 && Ne[oe])) {
              if (!(Be && !ea(C, Ds(Ke, re, "")))) {
                if (Ke)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Le = qt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Ue = function(oe) {
    return !Le[Mu(oe)] && ea(de, oe);
  }, He = function(oe) {
    rn(I.beforeSanitizeAttributes, oe, null);
    const {
      attributes: je
    } = oe;
    if (!je || Mn(oe))
      return;
    const Ke = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let _t = je.length;
    for (; _t--; ) {
      const ee = je[_t], {
        name: he,
        namespaceURI: Oe,
        value: Ye
      } = ee, rt = Bt(he), St = Ye;
      let Q = he === "value" ? St : nie(St);
      if (Ke.attrName = rt, Ke.attrValue = Q, Ke.keepAttr = !0, Ke.forceKeepAttr = void 0, rn(I.uponSanitizeAttribute, oe, Ke), Q = Ke.attrValue, qe && (rt === "id" || rt === "name") && o0(Q, De) !== 0 && (nn(he, oe), Q = De + Q), at && ea(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Q)) {
        nn(he, oe);
        continue;
      }
      if (rt === "attributename" && i0(Q, "href")) {
        nn(he, oe);
        continue;
      }
      if (Ke.forceKeepAttr)
        continue;
      if (!Ke.keepAttr) {
        nn(he, oe);
        continue;
      }
      if (!We && ea(/\/>/i, Q)) {
        nn(he, oe);
        continue;
      }
      bt && $u([G, Y, ie], (ke) => {
        Q = Ds(Q, ke, " ");
      });
      const te = Bt(oe.nodeName);
      if (!pe(te, rt, Q)) {
        nn(he, oe);
        continue;
      }
      if (z && typeof w == "object" && typeof w.getAttributeType == "function" && !Oe)
        switch (w.getAttributeType(te, rt)) {
          case "TrustedHTML": {
            Q = z.createHTML(Q);
            break;
          }
          case "TrustedScriptURL": {
            Q = z.createScriptURL(Q);
            break;
          }
        }
      if (Q !== St)
        try {
          Oe ? oe.setAttributeNS(Oe, he, Q) : oe.setAttribute(he, Q), Mn(oe) ? vn(oe) : a0(t.removed);
        } catch {
          nn(he, oe);
        }
    }
    rn(I.afterSanitizeAttributes, oe, null);
  }, wt = function(oe) {
    let je = null;
    const Ke = kn(oe);
    for (rn(I.beforeSanitizeShadowDOM, oe, null); je = Ke.nextNode(); )
      rn(I.uponSanitizeShadowNode, je, null), Ea(je), He(je), je.content instanceof r && wt(je.content);
    rn(I.afterSanitizeShadowDOM, oe, null);
  };
  return t.sanitize = function(et) {
    let oe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, je = null, Ke = null, _t = null, ee = null;
    if (_e = !et, _e && (et = "<!-->"), typeof et != "string" && !Hn(et) && (et = sie(et), typeof et != "string"))
      throw Gd("dirty is not a string, aborting");
    if (!t.isSupported)
      return et;
    if (nt || Ln(oe), t.removed = [], typeof et == "string" && ($t = !1), $t) {
      const Ye = et.nodeName;
      if (typeof Ye == "string") {
        const rt = Bt(Ye);
        if (!W[rt] || H[rt])
          throw Gd("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (et instanceof d)
      je = ln("<!---->"), Ke = je.ownerDocument.importNode(et, !0), Ke.nodeType === Eu.element && Ke.nodeName === "BODY" || Ke.nodeName === "HTML" ? je = Ke : je.appendChild(Ke);
    else {
      if (!Me && !bt && !Ie && // eslint-disable-next-line unicorn/prefer-includes
      et.indexOf("<") === -1)
        return z && Ve ? z.createHTML(et) : et;
      if (je = ln(et), !je)
        return Me ? null : Ve ? L : "";
    }
    je && dt && vn(je.firstChild);
    const he = kn($t ? et : je);
    for (; _t = he.nextNode(); )
      Ea(_t), He(_t), _t.content instanceof r && wt(_t.content);
    if ($t)
      return et;
    if (Me) {
      if (bt) {
        je.normalize();
        let Ye = je.innerHTML;
        $u([G, Y, ie], (rt) => {
          Ye = Ds(Ye, rt, " ");
        }), je.innerHTML = Ye;
      }
      if (be)
        for (ee = U.call(je.ownerDocument); je.firstChild; )
          ee.appendChild(je.firstChild);
      else
        ee = je;
      return (K.shadowroot || K.shadowrootmode) && (ee = F.call(a, ee, !0)), ee;
    }
    let Oe = Ie ? je.outerHTML : je.innerHTML;
    return Ie && W["!doctype"] && je.ownerDocument && je.ownerDocument.doctype && je.ownerDocument.doctype.name && ea(G$, je.ownerDocument.doctype.name) && (Oe = "<!DOCTYPE " + je.ownerDocument.doctype.name + `>
` + Oe), bt && $u([G, Y, ie], (Ye) => {
      Oe = Ds(Oe, Ye, " ");
    }), z && Ve ? z.createHTML(Oe) : Oe;
  }, t.setConfig = function() {
    let et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Ln(et), nt = !0;
  }, t.clearConfig = function() {
    ft = null, nt = !1;
  }, t.isValidAttribute = function(et, oe, je) {
    ft || Ln({});
    const Ke = Bt(et), _t = Bt(oe);
    return pe(Ke, _t, je);
  }, t.addHook = function(et, oe) {
    typeof oe == "function" && Tu(I[et], oe);
  }, t.removeHook = function(et, oe) {
    if (oe !== void 0) {
      const je = eie(I[et], oe);
      return je === -1 ? void 0 : tie(I[et], je, 1)[0];
    }
    return a0(I[et]);
  }, t.removeHooks = function(et) {
    I[et] = [];
  }, t.removeAllHooks = function() {
    I = p0();
  }, t;
}
var wie = X$();
const _ie = [
  "a",
  "abbr",
  "b",
  "bdi",
  "bdo",
  "blockquote",
  "br",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "i",
  "img",
  "ins",
  "kbd",
  "li",
  "mark",
  "ol",
  "p",
  "picture",
  "pre",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "small",
  "source",
  "span",
  "strike",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "tt",
  "u",
  "ul",
  "var",
  "wbr"
], xie = [
  "abbr",
  "align",
  "alt",
  "cite",
  "class",
  "colspan",
  "datetime",
  "dir",
  "height",
  "href",
  "id",
  "lang",
  "loading",
  "media",
  "open",
  "rel",
  "reversed",
  "rowspan",
  "scope",
  "span",
  "src",
  "srcset",
  "start",
  "style",
  "target",
  "title",
  "valign",
  "width"
], Sie = [
  "script",
  "iframe",
  "frame",
  "frameset",
  "object",
  "embed",
  "applet",
  "form",
  "input",
  "button",
  "select",
  "option",
  "textarea",
  "base",
  "meta",
  "link",
  "noscript",
  "template",
  "portal",
  "dialog"
], $ie = ["action", "formaction", "srcdoc", "ping", "background", "poster"], Tie = {
  document: {
    ALLOWED_TAGS: _ie,
    ALLOWED_ATTR: xie,
    // Ids a document brings are prefixed (`user-content-…`) so they can never
    // shadow a global the page reads (DOM clobbering).
    SANITIZE_NAMED_PROPS: !0
  },
  code: {
    ALLOWED_TAGS: ["span", "br"],
    ALLOWED_ATTR: ["class"]
  },
  diagram: {
    USE_PROFILES: { svg: !0, svgFilters: !0, html: !0 },
    // What Mermaid itself keeps when it sanitizes its output: HTML labels
    // live in <foreignObject> (an HTML integration point for them), and text
    // anchoring needs dominant-baseline.
    ADD_TAGS: ["foreignobject"],
    ADD_ATTR: ["dominant-baseline"],
    HTML_INTEGRATION_POINTS: { foreignobject: !0 }
  },
  math: {
    USE_PROFILES: { html: !0, mathMl: !0 }
  }
};
let Zm = null;
function Aie() {
  if (Zm) return Zm;
  if (typeof window > "u") return null;
  const e = wie(window);
  return e.isSupported ? (e.addHook("uponSanitizeAttribute", (t, n) => {
    if (n.attrName === "style") {
      const a = Eie(n.attrValue);
      a === "" ? n.keepAttr = !1 : n.attrValue = a;
    }
  }), e.addHook("uponSanitizeElement", (t, n) => {
    n.tagName === "style" && t.textContent && (t.textContent = Cie(t.textContent));
  }), e.addHook("afterSanitizeAttributes", (t) => {
    if (t.tagName === "A") {
      const n = t.getAttribute("target");
      n && n !== "_blank" && t.removeAttribute("target"), t.getAttribute("target") === "_blank" && t.setAttribute("rel", "noopener noreferrer");
    }
  }), Zm = e, e) : null;
}
function Eie(e) {
  return e.split(";").map((t) => t.trim()).filter((t) => t !== "" && !zie(t)).join("; ");
}
function Cie(e) {
  return /\\/.test(e) ? "" : e.replace(/@import[^;]*;?/gi, "").replace(/url\s*\(\s*(['"]?)(?!#)[^)]*\)/gi, "none").replace(/image-set\s*\([^)]*\)/gi, "none").replace(/expression\s*\(/gi, "x(");
}
function zie(e) {
  return /\\/.test(e) || /expression\s*\(|@import|behavior\s*:|-moz-binding|image-set\s*\(|javascript:/i.test(e) ? !0 : (e.match(/url\s*\(\s*(['"]?)([^)'"]*)/gi) ?? []).some((n) => !/url\s*\(\s*['"]?#/i.test(n));
}
function Mie(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function Pie(e, t = "document") {
  const n = Aie();
  if (!n) return Mie(e);
  const a = {
    ...Tie[t],
    FORBID_TAGS: Sie,
    FORBID_ATTR: $ie,
    ALLOW_UNKNOWN_PROTOCOLS: !1,
    RETURN_TRUSTED_TYPE: !1
  };
  return String(n.sanitize(e, a));
}
let Jd = null;
function Oie() {
  return Jd || (Jd = import(
    /* @vite-ignore */
    "markdown-it"
  ).then((e) => {
    const t = e, n = t.default ?? t;
    return new n({ html: !0, linkify: !0, breaks: !0, typographer: !0 });
  }).catch(() => (Jd = null, null))), Jd;
}
async function Vce(e) {
  const t = await Oie();
  return t ? Pie(t.render(e), "document") : null;
}
const Die = "/web-apps/apps/api/documents/api.js", Lie = "/?embed=1&proto=json", Rie = 1e4;
function Nie(e) {
  return e.trim().replace(/\/+$/, "");
}
function Iie(e, t) {
  return new Promise((n) => {
    const a = document.createElement("script");
    let i = !1;
    const r = (d) => {
      i || (i = !0, clearTimeout(l), a.remove(), n(d));
    }, l = setTimeout(() => r("timeout"), t);
    a.async = !0, a.src = e, a.onload = () => r("load"), a.onerror = () => r("error"), document.head.appendChild(a);
  });
}
function Bie(e, t) {
  return new Promise((n) => {
    let a = null;
    try {
      a = new URL(e, window.location.href).origin;
    } catch {
      a = null;
    }
    const i = document.createElement("iframe");
    i.setAttribute("aria-hidden", "true"), i.style.cssText = "position:absolute;inset-inline-start:-9999px;width:1px;height:1px;border:0";
    let r = !1;
    const l = (m) => {
      r || (r = !0, clearTimeout(f), window.removeEventListener("message", d), i.remove(), n(m));
    }, d = (m) => {
      if (a && m.origin !== a) return;
      let v = m.data;
      if (typeof v == "string")
        try {
          v = JSON.parse(v);
        } catch {
          return;
        }
      v && typeof v == "object" && v.event === "init" && l("ready");
    };
    window.addEventListener("message", d);
    const f = setTimeout(() => l("timeout"), t);
    i.src = e, document.body.appendChild(i);
  });
}
async function Fie(e) {
  try {
    return await fetch(e, { mode: "no-cors", cache: "no-store" }), !0;
  } catch {
    return !1;
  }
}
const Uie = {
  loadScript: Iie,
  loadFramed: Bie,
  reachable: Fie,
  hasDocsAPI: () => {
    var e;
    return !!((e = window.DocsAPI) != null && e.DocEditor);
  },
  pageProtocol: () => window.location.protocol,
  now: () => typeof performance < "u" ? performance.now() : Date.now()
};
function Hie(e, t) {
  const n = Nie(t);
  return n ? e === "onlyoffice" ? n + Die : e === "drawio" ? n + Lie : "" : "";
}
async function jce(e, t, n = {}) {
  const a = { ...Uie, ...n.deps ?? {} }, i = n.timeoutMs ?? Rie, r = Hie(e, t ?? ""), l = e === "onlyoffice" ? "script" : e === "drawio" ? "iframe" : "none";
  if (!r)
    return { service: e, state: "skipped", url: "", ms: 0, mechanism: l };
  if (a.pageProtocol() === "https:" && r.startsWith("http://"))
    return { service: e, state: "blocked-mixed-content", url: r, ms: 0, mechanism: l };
  const d = a.now(), f = () => Math.round(a.now() - d);
  if (l === "script") {
    const m = await a.loadScript(r, i);
    if (m === "timeout") return { service: e, state: "timeout", url: r, ms: f(), mechanism: l };
    if (m === "load")
      return {
        service: e,
        state: a.hasDocsAPI() ? "ok" : "wrong-content",
        url: r,
        ms: f(),
        mechanism: l
      };
    const v = await a.reachable(r);
    return {
      service: e,
      state: v ? "wrong-content" : "unreachable",
      url: r,
      ms: f(),
      mechanism: l
    };
  }
  if (l === "iframe") {
    if (await a.loadFramed(r, i) === "ready") return { service: e, state: "ok", url: r, ms: f(), mechanism: l };
    const v = await a.reachable(r);
    return {
      service: e,
      state: v ? "wrong-content" : "unreachable",
      url: r,
      ms: f(),
      mechanism: l
    };
  }
  return { service: e, state: "skipped", url: "", ms: 0, mechanism: l };
}
function qce(e) {
  return e ? e.replace(/diagnose$/, "session") : null;
}
async function Wce(e, t, n) {
  try {
    const a = await e(t, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "state", ...n })
    });
    if (!a.ok) return null;
    const i = await a.json();
    return { stale: i.stale === !0, known: i.known === !0 };
  } catch {
    return null;
  }
}
function Yce(e, t) {
  return e || t.pending ? "ask" : "reload";
}
function Gce(e, t) {
  return /(^|\/|:\/\/)\.filex-open\//.test(e) ? t.replace(/^[0-9a-f]{12}-/, "") : t;
}
const Kie = {
  viewBox: "0 0 32 32",
  "aria-hidden": "true"
}, h0 = /* @__PURE__ */ lt({
  __name: "LogoMark",
  setup(e) {
    return (t, n) => (p(), h("svg", Kie, [...n[0] || (n[0] = [
      c("rect", {
        width: "32",
        height: "32",
        rx: "7",
        fill: "var(--fe-primary, #2f6ceb)"
      }, null, -1),
      c("path", {
        d: "M7 11a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V11z",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linejoin": "round"
      }, null, -1),
      c("path", {
        d: "M11.5 17.5l3 2.5 5.5-6",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])]));
  }
});
function Xce(e) {
  return e.trim().toLowerCase();
}
const Vie = 250;
function Jce(e, t = Vie) {
  let n = 0, a = null;
  return (i) => {
    const r = ++n;
    return a && (clearTimeout(a.timer), a.resolve(null), a = null), new Promise((l) => {
      a = { timer: setTimeout(() => {
        a = null, e(i).then(
          (f) => l(r === n ? f ?? {} : null),
          () => l(null)
        );
      }, t), resolve: l };
    });
  };
}
function Zce(e) {
  var n;
  let t = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data;
  if (!t) {
    const a = e == null ? void 0 : e.detail;
    if (typeof a == "string" && a.trim().startsWith("{"))
      try {
        t = JSON.parse(a);
      } catch {
        t = void 0;
      }
  }
  return !t || typeof t.field != "string" || typeof t.message != "string" ? null : { field: t.field, message: t.message };
}
const J$ = "filex.density";
function Qce(e) {
  if (!(e !== "comfortable" && e !== "compact")) {
    Rr("density", e);
    try {
      window.dispatchEvent(new CustomEvent("filex:density", { detail: e }));
    } catch {
    }
  }
}
function ede() {
  try {
    return localStorage.getItem(J$) === "compact" ? "compact" : "comfortable";
  } catch {
    return "comfortable";
  }
}
function tde(e) {
  try {
    localStorage.setItem(J$, e);
  } catch {
  }
  Uo("density", e);
  try {
    window.dispatchEvent(new CustomEvent("filex:density", { detail: e }));
  } catch {
  }
}
async function jie(e, { maxPx: t, maxBytes: n }) {
  const a = await qie(e), i = Math.min(a.width, a.height), r = Math.min(t, i), l = document.createElement("canvas");
  l.width = r, l.height = r;
  const d = l.getContext("2d");
  if (!d) throw new Error("canvas unavailable");
  d.fillStyle = "#ffffff", d.fillRect(0, 0, r, r), d.drawImage(
    a,
    (a.width - i) / 2,
    (a.height - i) / 2,
    i,
    i,
    0,
    0,
    r,
    r
  );
  for (const f of [0.85, 0.7, 0.55, 0.4]) {
    const m = l.toDataURL("image/jpeg", f);
    if (m.length <= n) return m;
  }
  if (r > 64)
    return jie(e, { maxPx: Math.floor(r / 2), maxBytes: n });
  throw new Error("image too large");
}
async function qie(e) {
  if (typeof createImageBitmap == "function")
    return createImageBitmap(e);
  const t = URL.createObjectURL(e);
  try {
    return await new Promise((n, a) => {
      const i = new Image();
      i.onload = () => n(i), i.onerror = () => a(new Error("decode failed")), i.src = t;
    });
  } finally {
    URL.revokeObjectURL(t);
  }
}
const nde = [
  "file.uploaded",
  "file.updated",
  "file.upload_failed",
  "file.infected",
  "file.deleted",
  "file.trashed",
  "file.moved",
  "archive.created",
  "archive.extracted",
  "share.created",
  "drop.received",
  "comment.added",
  "e2e.escrow_used",
  "e2e.password_changed",
  "e2e.request_created",
  "e2e.request_decided",
  "plugin.notice",
  // One person's held notifications, told together (backend notify/digest.go).
  // A target receives it only when it ticks it; the person's own switch mutes
  // their digests, and it has no "urgent" switch of its own (DIGEST_EVENT).
  "notification.digest"
], ade = "notification.digest";
function Z$(e) {
  return e.replace(/\./g, "_");
}
function ide(e) {
  return `webhooks.events.${Z$(e)}`;
}
function ode(e) {
  return `userSettings.notifications.events.${Z$(e)}`;
}
const Wie = "filex.notify.push";
function m0(e) {
  const t = e.replace(/-/g, "+").replace(/_/g, "/").replace(/=+$/, ""), n = t + "=".repeat((4 - t.length % 4) % 4), a = atob(n), i = new Uint8Array(a.length);
  for (let r = 0; r < a.length; r++) i[r] = a.charCodeAt(r);
  return i;
}
const Yie = [
  [/Edg(e|A|iOS)?\//, "Edge"],
  [/OPR\/|Opera/, "Opera"],
  [/SamsungBrowser\//, "Samsung Internet"],
  [/Firefox\/|FxiOS\//, "Firefox"],
  [/Chrome\/|CriOS\//, "Chrome"],
  [/Safari\//, "Safari"]
], Gie = [
  [/iPhone/, "iPhone"],
  [/iPad/, "iPad"],
  [/Android/, "Android"],
  [/CrOS/, "ChromeOS"],
  [/Windows/, "Windows"],
  [/Mac OS X|Macintosh/, "macOS"],
  [/Linux/, "Linux"]
];
function Xie(e) {
  const t = (n) => {
    var a;
    return ((a = n.find(([i]) => i.test(e))) == null ? void 0 : a[1]) ?? "";
  };
  return [t(Yie), t(Gie)].filter(Boolean).join(" · ");
}
async function Jie(e) {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e));
  return Array.from(new Uint8Array(t), (n) => n.toString(16).padStart(2, "0")).join("");
}
function Zie() {
  try {
    return typeof localStorage > "u" ? null : localStorage;
  } catch {
    return null;
  }
}
function v0(e, t) {
  var i;
  const n = (i = e.options) == null ? void 0 : i.applicationServerKey;
  if (!n) return !1;
  const a = new Uint8Array(n);
  if (a.length !== t.length) return !1;
  for (let r = 0; r < t.length; r++) if (a[r] !== t[r]) return !1;
  return !0;
}
function Qie(e, t) {
  var a, i;
  const n = e.toJSON();
  return {
    endpoint: n.endpoint ?? e.endpoint,
    keys: { p256dh: ((a = n.keys) == null ? void 0 : a.p256dh) ?? "", auth: ((i = n.keys) == null ? void 0 : i.auth) ?? "" },
    label: t
  };
}
async function eoe(e) {
  if (!e || !e.pushManager) return null;
  if (e.active) return e;
  const t = e.installing ?? e.waiting;
  return t ? (await new Promise((n) => {
    const a = setTimeout(n, 1e4);
    t.addEventListener("statechange", () => {
      t.state === "activated" && (clearTimeout(a), n());
    });
  }), e.active ? e : null) : null;
}
function rde(e, t) {
  const n = t.storage === void 0 ? Zie() : t.storage, a = t.userId ? `${Wie}.${t.userId}` : "", i = t.sha256 ?? Jie, r = t.userAgent ?? (typeof navigator > "u" ? "" : navigator.userAgent ?? "");
  let l = null;
  const d = () => t.notification !== void 0 ? t.notification : typeof window < "u" && "Notification" in window ? window.Notification : null, f = () => t.supported ? t.supported() : typeof window < "u" && "PushManager" in window && typeof navigator < "u" && "serviceWorker" in navigator && d() !== null, m = () => {
    const L = d();
    return !L || !f() ? "unsupported" : L.permission ?? "default";
  }, v = () => {
    if (!a || !n) return !1;
    try {
      return n.getItem(a) === "1";
    } catch {
      return !1;
    }
  }, b = (L) => {
    if (!(!a || !n))
      try {
        L ? n.setItem(a, "1") : n.removeItem(a);
      } catch {
      }
  }, _ = async () => {
    try {
      l = await e.status();
    } catch {
      l = null;
    }
    return l;
  }, w = async () => {
    if (!f()) return null;
    try {
      const L = await t.registration();
      return L != null && L.pushManager ? await L.pushManager.getSubscription() : null;
    } catch {
      return null;
    }
  }, k = async (L) => {
    const B = await eoe(await t.registration());
    if (!B) throw new Error("no service worker");
    const O = m0(L);
    let U = await B.pushManager.getSubscription();
    U && !v0(U, O) && (await U.unsubscribe().catch(() => !1), U = null), U || (U = await B.pushManager.subscribe({ userVisibleOnly: !0, applicationServerKey: O })), await e.subscribe(Qie(U, Xie(r)));
  };
  async function x() {
    var S;
    const L = await _();
    let B = null;
    const O = L ? await w() : null;
    if (O && L)
      try {
        const F = await i(O.endpoint);
        B = ((S = L.devices.find((I) => I.endpoint_hash === F)) == null ? void 0 : S.id) ?? null;
      } catch {
        B = null;
      }
    const U = m();
    return { supported: f(), permission: U, status: L, on: B !== null && U === "granted", thisDevice: B };
  }
  async function M() {
    const L = d();
    if (!L || !f()) return x();
    let B = L.permission;
    if (B === "default") {
      const U = await Promise.resolve(L.requestPermission());
      B = typeof U == "string" ? U : L.permission;
    }
    if (B !== "granted") return x();
    const O = l ?? await _();
    return !(O != null && O.available) || !O.public_key || (await k(O.public_key), b(!0)), x();
  }
  async function A() {
    b(!1);
    const L = await w();
    return L && (await e.forget(L.endpoint).catch(() => {
    }), await L.unsubscribe().catch(() => !1)), x();
  }
  async function T(L) {
    const B = await x();
    if (await e.remove(L), B.thisDevice === L) {
      b(!1);
      const O = await w();
      await (O == null ? void 0 : O.unsubscribe().catch(() => !1));
    }
    return x();
  }
  async function N() {
    if (!v() || m() !== "granted") return;
    const L = await _();
    if (!(!(L != null && L.available) || !L.public_key))
      try {
        const B = await w();
        if (B && v0(B, m0(L.public_key))) {
          const O = await i(B.endpoint);
          if (L.devices.some((U) => U.endpoint_hash === O)) return;
        }
        await k(L.public_key);
      } catch {
      }
  }
  async function z() {
    const L = await w();
    L && (await e.forget(L.endpoint).catch(() => {
    }), await L.unsubscribe().catch(() => !1));
  }
  return {
    state: x,
    enable: M,
    disable: A,
    remove: T,
    test: () => e.test(),
    reconcile: N,
    forgetDevice: z
  };
}
function Ys(e) {
  return !e.sections && typeof e.href == "string";
}
function toe(e) {
  const t = [];
  for (const n of e) {
    if (Ys(n)) {
      t.push(n);
      continue;
    }
    const a = (n.sections ?? []).filter((i) => i.items.length > 0);
    a.length > 0 && t.push({ ...n, sections: a });
  }
  return t;
}
function noe(e) {
  return Ys(e) ? e.active === !0 : (e.sections ?? []).some((t) => t.items.some((n) => n.active === !0));
}
function aoe(e, t, n) {
  if (n <= 0) return null;
  switch (e) {
    case "ArrowDown":
      return Math.min(t + 1, n - 1);
    case "ArrowUp":
      return Math.max(t - 1, 0);
    case "Home":
      return 0;
    case "End":
      return n - 1;
    default:
      return null;
  }
}
function ioe(e, t, n, a = "ltr") {
  if (n <= 0) return null;
  const i = wf(e, a);
  return i !== 0 ? (t + i + n) % n : e === "Home" ? 0 : e === "End" ? n - 1 : null;
}
function ooe(e) {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.defaultPrevented;
}
const roe = ["aria-label"], soe = {
  key: 0,
  class: "fx-mega__bar"
}, loe = ["href", "aria-current", "data-mega-top", "data-testid", "onClick", "onKeydown"], uoe = ["aria-expanded", "aria-controls", "data-mega-top", "data-testid", "onClick", "onKeydown"], coe = ["id", "data-mega-panel", "data-testid", "onKeydown"], doe = ["data-testid"], foe = ["id"], poe = ["aria-labelledby"], hoe = ["href", "aria-current", "data-testid", "onClick"], moe = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, voe = ["innerHTML"], yoe = { class: "fx-mega__text" }, goe = { class: "fx-mega__label" }, boe = {
  key: 0,
  class: "fx-mega__hint"
}, koe = {
  key: 1,
  class: "fx-mega__list"
}, woe = ["href", "aria-current", "data-testid", "onClick"], _oe = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, xoe = { class: "fx-mega__text" }, Soe = { class: "fx-mega__label" }, $oe = ["aria-labelledby", "data-testid"], Toe = ["id"], Aoe = ["data-testid"], Eoe = ["id"], Coe = ["aria-labelledby"], zoe = ["href", "aria-current", "data-testid", "onClick"], Moe = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, Poe = ["innerHTML"], Ooe = { class: "fx-mega__text" }, Doe = { class: "fx-mega__label" }, sde = /* @__PURE__ */ lt({
  __name: "MegaMenu",
  props: {
    entries: {},
    label: {},
    mode: { default: "bar" }
  },
  emits: ["navigate"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = `fx-mega-${Math.random().toString(36).slice(2, 10)}`, r = E(() => toe(n.entries)), l = $(null), d = $(null), f = (B) => `${i}-${B.id}`, m = (B, O) => `${i}-${B.id}-${O}`;
    function v() {
      d.value = null;
    }
    function b(B) {
      d.value = d.value === B ? null : B;
    }
    function _() {
      var B;
      return Array.from(((B = l.value) == null ? void 0 : B.querySelectorAll("[data-mega-top]")) ?? []);
    }
    function w(B) {
      var U;
      const O = (U = l.value) == null ? void 0 : U.querySelector(`[data-mega-panel="${B}"]`);
      return Array.from((O == null ? void 0 : O.querySelectorAll("a.fx-mega__item")) ?? []);
    }
    function k(B) {
      var O;
      return ((O = l.value) == null ? void 0 : O.querySelector(`[data-mega-top="${B}"]`)) ?? null;
    }
    async function x(B, O) {
      var S;
      d.value = B, await Zt();
      const U = w(B);
      (S = O === "first" ? U[0] : U[U.length - 1]) == null || S.focus();
    }
    function M(B, O, U) {
      var I;
      const S = _(), F = ioe(B.key, O, S.length, Ga(l.value));
      if (F !== null) {
        B.preventDefault(), v(), (I = S[F]) == null || I.focus();
        return;
      }
      Ys(U) || (B.key === "ArrowDown" ? (B.preventDefault(), x(U.id, "first")) : B.key === "ArrowUp" ? (B.preventDefault(), x(U.id, "last")) : B.key === "Escape" && d.value === U.id && (B.preventDefault(), v()));
    }
    function A(B, O) {
      var I, G, Y;
      if (B.key === "Escape") {
        B.preventDefault(), B.stopPropagation(), v(), (I = k(O.id)) == null || I.focus();
        return;
      }
      const U = w(O.id), S = U.indexOf(document.activeElement);
      if (S < 0) return;
      if (B.key === "ArrowUp" && S === 0) {
        B.preventDefault(), (G = k(O.id)) == null || G.focus();
        return;
      }
      const F = aoe(B.key, S, U.length);
      F !== null && (B.preventDefault(), (Y = U[F]) == null || Y.focus());
    }
    function T(B, O) {
      !O.href || !ooe(B) || (B.preventDefault(), v(), a("navigate", { id: O.id, href: O.href }));
    }
    function N(B) {
      const O = B.relatedTarget;
      O && l.value && !l.value.contains(O) && v();
    }
    function z(B) {
      if (d.value === null) return;
      const O = B.target;
      O && l.value && !l.value.contains(O) && v();
    }
    Wt(() => document.addEventListener("pointerdown", z, !0)), Ot(() => document.removeEventListener("pointerdown", z, !0));
    const L = E(
      () => r.value.flatMap(
        (B) => Ys(B) ? B.active ? [B.id] : [] : (B.sections ?? []).flatMap((O) => O.items.filter((U) => U.active).map((U) => U.id))
      ).join("|")
    );
    return Xe(L, v), (B, O) => (p(), h("nav", {
      ref_key: "root",
      ref: l,
      class: Fe(["fx-mega", `fx-mega--${e.mode}`]),
      "aria-label": e.label,
      "data-testid": "mega-menu",
      onFocusout: N
    }, [
      e.mode === "bar" ? (p(), h("ul", soe, [
        (p(!0), h(Ce, null, ot(r.value, (U, S) => (p(), h("li", {
          key: U.id,
          class: "fx-mega__top"
        }, [
          u(Ys)(U) ? (p(), h("a", {
            key: 0,
            href: U.href,
            class: Fe(["fx-mega__toplink", U.active && "is-current"]),
            "aria-current": U.active ? "page" : void 0,
            "data-mega-top": U.id,
            "data-testid": `nav-${U.id}`,
            onClick: (F) => T(F, U),
            onKeydown: (F) => M(F, S, U)
          }, y(U.label), 43, loe)) : (p(), h(Ce, { key: 1 }, [
            c("button", {
              type: "button",
              class: Fe(["fx-mega__topbtn", d.value === U.id && "is-open", u(noe)(U) && "is-current"]),
              "aria-expanded": d.value === U.id ? "true" : "false",
              "aria-controls": f(U),
              "data-mega-top": U.id,
              "data-testid": `nav-top-${U.id}`,
              onClick: (F) => b(U.id),
              onKeydown: (F) => M(F, S, U)
            }, [
              c("span", null, y(U.label), 1),
              O[0] || (O[0] = c("svg", {
                class: "fx-mega__chev",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true"
              }, [
                c("path", { d: "m6 9 6 6 6-6" })
              ], -1))
            ], 42, uoe),
            un(c("div", {
              id: f(U),
              class: "fx-mega__panel",
              "data-mega-panel": U.id,
              "data-testid": `nav-panel-${U.id}`,
              onKeydown: (F) => A(F, U)
            }, [
              (p(!0), h(Ce, null, ot(U.sections, (F) => (p(), h("div", {
                key: F.id,
                class: "fx-mega__section",
                "data-testid": `nav-group-${F.id}`
              }, [
                c("p", {
                  id: m(U, F.id),
                  class: "fx-mega__heading"
                }, y(F.label), 9, foe),
                c("ul", {
                  class: "fx-mega__items",
                  "aria-labelledby": m(U, F.id)
                }, [
                  (p(!0), h(Ce, null, ot(F.items, (I) => (p(), h("li", {
                    key: I.id
                  }, [
                    c("a", {
                      href: I.href,
                      class: Fe(["fx-mega__item", I.active && "is-current"]),
                      "aria-current": I.active ? "page" : void 0,
                      "data-testid": `nav-${I.id}`,
                      onClick: (G) => T(G, I)
                    }, [
                      c("span", moe, [
                        I.iconName ? (p(), h("span", {
                          key: 0,
                          class: "fx-mega__glyph",
                          innerHTML: u(zt)(I.iconName)
                        }, null, 8, voe)) : I.icon ? (p(), Je(Ii(I.icon), {
                          key: 1,
                          class: "fx-mega__glyph"
                        })) : D("", !0)
                      ]),
                      c("span", yoe, [
                        c("span", goe, y(I.label), 1),
                        I.hint ? (p(), h("span", boe, y(I.hint), 1)) : D("", !0)
                      ])
                    ], 10, hoe)
                  ]))), 128))
                ], 8, poe)
              ], 8, doe))), 128))
            ], 40, coe), [
              [_z, d.value === U.id]
            ])
          ], 64))
        ]))), 128))
      ])) : (p(), h("div", koe, [
        (p(!0), h(Ce, null, ot(r.value, (U) => (p(), h(Ce, {
          key: U.id
        }, [
          u(Ys)(U) ? (p(), h("a", {
            key: 0,
            href: U.href,
            class: Fe(["fx-mega__item", "fx-mega__item--top", U.active && "is-current"]),
            "aria-current": U.active ? "page" : void 0,
            "data-testid": `nav-${U.id}`,
            onClick: (S) => T(S, U)
          }, [
            c("span", _oe, [
              U.icon ? (p(), Je(Ii(U.icon), {
                key: 0,
                class: "fx-mega__glyph"
              })) : D("", !0)
            ]),
            c("span", xoe, [
              c("span", Soe, y(U.label), 1)
            ])
          ], 10, woe)) : (p(), h("section", {
            key: 1,
            class: "fx-mega__group",
            "aria-labelledby": f(U),
            "data-testid": `nav-top-${U.id}`
          }, [
            c("p", {
              id: f(U),
              class: "fx-mega__grouphead"
            }, y(U.label), 9, Toe),
            (p(!0), h(Ce, null, ot(U.sections, (S) => (p(), h("div", {
              key: S.id,
              class: "fx-mega__section",
              "data-testid": `nav-group-${S.id}`
            }, [
              c("p", {
                id: m(U, S.id),
                class: "fx-mega__heading"
              }, y(S.label), 9, Eoe),
              c("ul", {
                class: "fx-mega__items",
                "aria-labelledby": m(U, S.id)
              }, [
                (p(!0), h(Ce, null, ot(S.items, (F) => (p(), h("li", {
                  key: F.id
                }, [
                  c("a", {
                    href: F.href,
                    class: Fe(["fx-mega__item", F.active && "is-current"]),
                    "aria-current": F.active ? "page" : void 0,
                    "data-testid": `nav-${F.id}`,
                    onClick: (I) => T(I, F)
                  }, [
                    c("span", Moe, [
                      F.iconName ? (p(), h("span", {
                        key: 0,
                        class: "fx-mega__glyph",
                        innerHTML: u(zt)(F.iconName)
                      }, null, 8, Poe)) : F.icon ? (p(), Je(Ii(F.icon), {
                        key: 1,
                        class: "fx-mega__glyph"
                      })) : D("", !0)
                    ]),
                    c("span", Ooe, [
                      c("span", Doe, y(F.label), 1)
                    ])
                  ], 10, zoe)
                ]))), 128))
              ], 8, Coe)
            ], 8, Aoe))), 128))
          ], 8, $oe))
        ], 64))), 128))
      ]))
    ], 42, roe));
  }
}), Loe = [
  "page",
  "setting",
  "app",
  "user",
  "group",
  "key",
  "storage",
  "share",
  "file"
], Roe = {
  file: "file",
  user: "user",
  app: "app",
  key: "key",
  group: "group",
  storage: "storage",
  setting: "setting"
}, Noe = ["file", "user", "app", "key", "group", "storage", "setting"], Ioe = 6, Q$ = 3, eT = 25;
function y0(e) {
  return lo(e ?? "").split(/\s+/).filter((t) => t.length > 0);
}
function tT(e) {
  const t = (e ?? "").replace(/^\s+/, ""), n = /^([A-Za-z]+)\s*:/.exec(t);
  if (n) {
    const i = n[1].toLowerCase(), r = Roe[i];
    if (r) {
      const l = t.slice(n[0].length).trim();
      return { kind: r, prefix: i, text: l, words: y0(l) };
    }
  }
  const a = t.trim();
  return { kind: null, prefix: "", text: a, words: y0(a) };
}
function g0(e, t) {
  const n = tT(e);
  return t ? `${t}:${n.text}` : n.text;
}
function Boe(e, t) {
  return t === 0 ? !0 : !/[\p{L}\p{N}]/u.test(e[t - 1]);
}
function Zd(e, t, n) {
  if (!e) return 0;
  const a = e.indexOf(t);
  return a < 0 ? 0 : a === 0 ? n : Boe(e, a) ? Math.round(n * 0.8) : Math.round(n * 0.5);
}
function Foe(e, t) {
  if (t.length === 0) return 0;
  const n = lo(e.label ?? ""), a = (e.terms ?? []).map((f) => lo(f)), i = (e.aliases ?? []).map((f) => lo(f)), r = lo(e.detail ?? "");
  let l = 0;
  for (const f of t) {
    let m = Zd(n, f, 100);
    for (const v of a) m = Math.max(m, Zd(v, f, 70));
    for (const v of i) m = Math.max(m, Zd(v, f, 50));
    if (m = Math.max(m, Zd(r, f, 25)), m <= 0) return e.found ? 1 : -1;
    l += m;
  }
  const d = t.join(" ");
  return n === d ? l += 300 : a.includes(d) ? l += 200 : i.includes(d) ? l += 150 : n.startsWith(d) && (l += 80), l -= Math.min(n.length, 60) / 10, l;
}
function Uoe(e, t) {
  if (t.length === 0) return !1;
  const n = t.join(" ");
  return lo(e.label ?? "") === n ? !0 : (e.terms ?? []).some((a) => lo(a) === n);
}
function Hoe(e, t, n = {}) {
  if (t.words.length === 0) return [];
  const a = /* @__PURE__ */ new Map();
  for (const l of e) {
    if (t.kind && l.kind !== t.kind) continue;
    const d = Foe(l, t.words);
    if (d < 0) continue;
    const f = a.get(l.kind) ?? [];
    f.push({ item: l, score: d }), a.set(l.kind, f);
  }
  const i = [], r = [];
  for (const l of Loe) {
    const d = a.get(l);
    if (!d || d.length === 0) continue;
    d.sort((v, b) => b.score - v.score);
    const f = n[l] ?? (t.kind ? eT : l === "file" ? Q$ : Ioe), m = { kind: l, items: d.slice(0, f).map((v) => v.item), total: d.length };
    (Uoe(d[0].item, t.words) ? i : r).push(m);
  }
  return [...i, ...r];
}
function lde(e) {
  return e.flatMap((t) => t.items);
}
const Koe = ["aria-label", "aria-expanded"], Voe = ["innerHTML"], joe = {
  key: 0,
  class: "fx-psearch__trigger-text"
}, qoe = {
  key: 1,
  class: "fx-psearch__kbd"
}, Woe = ["aria-modal", "aria-label"], Yoe = { class: "fx-psearch__field" }, Goe = ["aria-label"], Xoe = ["innerHTML"], Joe = ["innerHTML"], Zoe = ["aria-label", "aria-expanded", "aria-activedescendant", "placeholder"], Qoe = ["aria-label"], ere = ["innerHTML"], tre = ["aria-label"], nre = ["aria-labelledby", "data-testid"], are = ["id"], ire = ["id", "aria-selected", "data-testid", "data-id", "onMouseenter", "onClick"], ore = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, rre = ["innerHTML"], sre = { class: "fx-psearch__text" }, lre = { class: "fx-psearch__label" }, ure = {
  key: 0,
  class: "fx-psearch__detail"
}, cre = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, dre = ["innerHTML"], fre = { class: "fx-psearch__text" }, pre = { class: "fx-psearch__label" }, hre = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, mre = ["innerHTML"], vre = { class: "fx-psearch__text" }, yre = { class: "fx-psearch__label" }, gre = ["aria-label", "title", "onClick"], bre = ["innerHTML"], kre = {
  key: 0,
  class: "fx-psearch__note"
}, wre = {
  key: 1,
  class: "fx-psearch__note",
  "data-testid": "panel-search-empty"
}, _re = {
  key: 2,
  class: "fx-psearch__note fx-psearch__note--warn",
  role: "alert",
  "data-testid": "panel-search-failed"
}, xre = { class: "fx-psearch__foot" }, Sre = { class: "fx-psearch__foot-label" }, $re = ["aria-pressed", "data-testid", "onClick"], Tre = {
  class: "fe-sr-only",
  role: "status",
  "aria-live": "polite"
}, b0 = 2, Are = 200, ude = /* @__PURE__ */ lt({
  __name: "PanelSearch",
  props: {
    locale: {},
    compact: { type: Boolean, default: !1 },
    items: {},
    remote: { type: Function, default: void 0 },
    files: { type: Function, default: void 0 },
    recent: { default: void 0 },
    shortcut: { type: Boolean, default: !0 }
  },
  emits: ["choose"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = yt(() => a.locale), l = `fx-psearch-${Math.random().toString(36).slice(2, 10)}`, d = `${l}-list`, f = $(null), m = $(null), v = $(null), b = $(null), _ = $(!1), w = $(""), k = $(0), x = $(null), M = $(80), A = E(() => tT(w.value)), T = $([]), N = $([]), z = $(!1), L = $(!1);
    let B, O = 0;
    function U(Te) {
      B && clearTimeout(B);
      const qe = ++O;
      if (Te.text.length < b0 || !a.remote && !a.files) {
        T.value = [], N.value = [], z.value = !1, L.value = !1;
        return;
      }
      z.value = !0, B = setTimeout(() => void S(Te, qe), Are);
    }
    async function S(Te, qe) {
      const De = !!a.remote && Te.kind !== "file" && Te.kind !== "page" && Te.kind !== "setting", mt = !!a.files && (Te.kind === null || Te.kind === "file"), $t = Te.kind === "file" ? eT : Q$, [kt, Tt] = await Promise.allSettled([
        De && a.remote ? a.remote(Te) : Promise.resolve([]),
        mt && a.files ? a.files(Te.text, $t) : Promise.resolve([])
      ]);
      qe === O && (T.value = kt.status === "fulfilled" ? kt.value.map((xe) => ({ ...xe, found: !0 })) : [], N.value = Tt.status === "fulfilled" ? Tt.value.map((xe) => ({ ...xe, kind: "file", found: !0 })) : [], L.value = kt.status === "rejected" || Tt.status === "rejected", z.value = !1);
    }
    Xe(w, () => {
      k.value = 0, U(A.value);
    });
    const F = $([]);
    async function I() {
      if (a.recent)
        try {
          F.value = await a.recent.list();
        } catch {
        }
    }
    function G(Te) {
      const qe = Te.trim();
      !qe || !a.recent || (F.value = [{ id: `local-${qe}`, query: qe }, ...F.value.filter((De) => De.query !== qe)], a.recent.add(qe).then(I, () => {
      }));
    }
    async function Y(Te) {
      var qe;
      F.value = F.value.filter((De) => De.id !== Te.id), k.value >= re.value.length && (k.value = Math.max(0, re.value.length - 1));
      try {
        await ((qe = a.recent) == null ? void 0 : qe.remove(Te.id));
      } catch {
        await I();
      }
    }
    async function ie() {
      var Te, qe;
      F.value = [], k.value = 0;
      try {
        await ((Te = a.recent) == null ? void 0 : Te.clear());
      } catch {
        await I();
      }
      (qe = v.value) == null || qe.focus();
    }
    const me = {
      page: "panelsearch.group.page",
      setting: "panelsearch.group.setting",
      app: "panelsearch.group.app",
      user: "panelsearch.group.user",
      group: "panelsearch.group.group",
      key: "panelsearch.group.key",
      storage: "panelsearch.group.storage",
      share: "panelsearch.group.share",
      file: "panelsearch.group.file"
    }, q = E(() => !!a.files && A.value.kind === null && A.value.text.length >= b0), C = E(() => {
      let Te = 0;
      const qe = [], De = A.value;
      if (De.words.length === 0)
        return De.kind === null && F.value.length && qe.push({
          key: "recent",
          heading: r("panelsearch.group.recent"),
          rows: F.value.map(($t) => ({ type: "recent", id: `recent:${$t.id}`, index: Te++, entry: $t }))
        }), qe;
      const mt = Hoe([...a.items, ...T.value, ...N.value], De);
      for (const $t of mt)
        qe.push({
          key: $t.kind,
          heading: r(me[$t.kind]),
          rows: $t.items.map((kt) => ({ type: "item", id: `item:${kt.id}`, index: Te++, item: kt }))
        });
      if (q.value) {
        const $t = qe.find((Tt) => Tt.key === "file"), kt = { type: "files-all", id: "files-all", index: Te++ };
        $t ? $t.rows.push(kt) : qe.push({ key: "file", heading: r(me.file), rows: [kt] });
      }
      return qe;
    }), re = E(() => C.value.flatMap((Te) => Te.rows)), de = (Te) => `${l}-opt-${Te}`, V = E(() => re.value.length && k.value < re.value.length ? de(k.value) : void 0), W = E(() => {
      if (!_.value || A.value.words.length === 0) return "";
      if (z.value) return r("panelsearch.searching");
      const Te = re.value.filter((qe) => qe.type === "item").length;
      return Te === 0 ? r("panelsearch.empty", { q: A.value.text }) : r("panelsearch.count", { n: Te });
    }), ne = E(
      () => A.value.words.length > 0 && !z.value && re.value.every((Te) => Te.type !== "item")
    );
    function K(Te) {
      if (Te.kind === "file") {
        const qe = Te.label ?? "", De = qe.lastIndexOf(".");
        return ya({
          type: Te.isDir ? "dir" : "file",
          basename: qe,
          extension: !Te.isDir && De > 0 ? qe.slice(De + 1) : ""
        });
      }
      return zt(Te.iconName ?? ce[Te.kind]);
    }
    const ce = {
      page: "goto",
      setting: "admin",
      app: "plugin",
      user: "account",
      group: "account",
      key: "lock",
      storage: "connect",
      share: "link",
      file: "open"
    };
    function J() {
      const Te = f.value;
      if (!(!Te || typeof window > "u")) {
        if (M.value = yc([Te]), a.compact) {
          x.value = null;
          return;
        }
        x.value = Eg(
          Te.getBoundingClientRect(),
          Ag(),
          { width: 560, gutter: 16, gap: 6, maxHeight: 620, dir: Ga(Te) }
        );
      }
    }
    const H = E(() => {
      const Te = { zIndex: String(M.value) };
      return x.value && (Te.top = x.value.top, Te.right = x.value.right, Te.left = x.value.left, Te.width = x.value.width, Te.maxHeight = x.value.maxHeight), Te;
    });
    async function X(Te) {
      var qe, De;
      _.value || (J(), _.value = !0, I()), typeof Te == "string" && (w.value = Te), await Zt(), (qe = v.value) == null || qe.focus(), typeof Te != "string" && ((De = v.value) == null || De.select());
    }
    function we(Te) {
      _.value && (_.value = !1, B && clearTimeout(B), z.value = !1, Te && Zt(() => {
        var qe;
        return (qe = f.value) == null ? void 0 : qe.focus();
      }));
    }
    function it(Te) {
      Te.key.length === 1 && !Te.ctrlKey && !Te.metaKey && !Te.altKey && Te.key !== " " ? (Te.preventDefault(), X(Te.key)) : Te.key === "ArrowDown" && (Te.preventDefault(), X());
    }
    function Re(Te) {
      if (Te) {
        if (Te.type === "recent") {
          w.value = Te.entry.query, Zt(() => {
            var qe;
            return (qe = v.value) == null ? void 0 : qe.focus();
          });
          return;
        }
        if (Te.type === "files-all") {
          w.value = g0(w.value, "file"), Zt(() => {
            var qe;
            return (qe = v.value) == null ? void 0 : qe.focus();
          });
          return;
        }
        G(w.value), we(!1), i("choose", Te.item);
      }
    }
    function Be(Te) {
      w.value = g0(w.value, Te), Zt(() => {
        var qe;
        return (qe = v.value) == null ? void 0 : qe.focus();
      });
    }
    function We() {
      w.value = "", Zt(() => {
        var Te;
        return (Te = v.value) == null ? void 0 : Te.focus();
      });
    }
    function bt(Te) {
      const qe = re.value.length;
      qe && (k.value = (k.value + Te + qe) % qe, Zt(() => {
        var mt;
        const De = (mt = b.value) == null ? void 0 : mt.querySelector(`#${de(k.value)}`);
        De && typeof De.scrollIntoView == "function" && De.scrollIntoView({ block: "nearest" });
      }));
    }
    function at(Te) {
      switch (Te.key) {
        case "ArrowDown":
          Te.preventDefault(), bt(1);
          break;
        case "ArrowUp":
          Te.preventDefault(), bt(-1);
          break;
        case "Enter":
          if (Te.isComposing) return;
          Te.preventDefault(), Re(re.value[k.value] ?? re.value[0]);
          break;
        case "Escape":
          Te.preventDefault(), Te.stopPropagation(), we(!0);
          break;
        case "Delete": {
          const qe = re.value[k.value];
          w.value === "" && (qe == null ? void 0 : qe.type) === "recent" && (Te.preventDefault(), Y(qe.entry));
          break;
        }
      }
    }
    function Ie(Te) {
      var qe, De;
      return Te ? !!((qe = m.value) != null && qe.contains(Te) || (De = f.value) != null && De.contains(Te)) : !1;
    }
    function nt(Te) {
      if (a.compact) return;
      const qe = Te.relatedTarget;
      qe && !Ie(qe) && we(!1);
    }
    function dt(Te) {
      !_.value || a.compact || Ie(Te.target) || we(!1);
    }
    function Me(Te) {
      var qe, De;
      !a.shortcut || Te.defaultPrevented || r2(Te, "palette") && (a2(Te.target) && !Ie(Te.target) || (Te.preventDefault(), _.value ? ((qe = v.value) == null || qe.focus(), (De = v.value) == null || De.select()) : X()));
    }
    function be() {
      _.value && J();
    }
    Wt(() => {
      document.addEventListener("keydown", Me), document.addEventListener("pointerdown", dt, !0), window.addEventListener("resize", be);
    }), Ot(() => {
      B && clearTimeout(B), document.removeEventListener("keydown", Me), document.removeEventListener("pointerdown", dt, !0), window.removeEventListener("resize", be);
    });
    const Ve = E(() => a.shortcut ? by("palette") : "");
    return t({ openPanel: X, close: we }), (Te, qe) => (p(), h("div", {
      class: Fe(["fx-psearch", e.compact ? "fx-psearch--compact" : "fx-psearch--box"])
    }, [
      c("button", {
        ref_key: "trigger",
        ref: f,
        type: "button",
        class: "fx-psearch__trigger",
        "aria-label": u(r)("panelsearch.label"),
        "aria-haspopup": "dialog",
        "aria-expanded": _.value ? "true" : "false",
        "data-testid": "panel-search-open",
        onClick: qe[0] || (qe[0] = (De) => _.value ? we(!0) : X()),
        onKeydown: it
      }, [
        c("span", {
          class: "fx-psearch__glyph",
          "aria-hidden": "true",
          innerHTML: u(zt)("search")
        }, null, 8, Voe),
        e.compact ? D("", !0) : (p(), h("span", joe, y(u(r)("panelsearch.trigger")), 1)),
        !e.compact && Ve.value ? (p(), h("kbd", qoe, y(Ve.value), 1)) : D("", !0)
      ], 40, Koe),
      (p(), Je(hi, { to: "body" }, [
        _.value ? (p(), h("div", {
          key: 0,
          ref_key: "layer",
          ref: m,
          class: Fe(["fx-psearch__layer", e.compact ? "fx-psearch__layer--full" : "fx-psearch__layer--drop"]),
          style: Yt(H.value),
          role: "dialog",
          "aria-modal": e.compact ? "true" : void 0,
          "aria-label": u(r)("panelsearch.label"),
          "data-testid": "panel-search",
          onFocusout: nt
        }, [
          c("div", Yoe, [
            e.compact ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "fx-psearch__iconbtn",
              "aria-label": u(r)("panelsearch.close"),
              "data-testid": "panel-search-close",
              onClick: qe[1] || (qe[1] = (De) => we(!0))
            }, [
              c("span", {
                class: "fx-psearch__glyph",
                "aria-hidden": "true",
                innerHTML: u(zt)("close")
              }, null, 8, Xoe)
            ], 8, Goe)) : (p(), h("span", {
              key: 1,
              class: "fx-psearch__glyph fx-psearch__glyph--field",
              "aria-hidden": "true",
              innerHTML: u(zt)("search")
            }, null, 8, Joe)),
            un(c("input", {
              ref_key: "inputEl",
              ref: v,
              "onUpdate:modelValue": qe[2] || (qe[2] = (De) => w.value = De),
              type: "text",
              class: "fx-psearch__input",
              role: "combobox",
              "aria-label": u(r)("panelsearch.label"),
              "aria-autocomplete": "list",
              "aria-expanded": re.value.length > 0 ? "true" : "false",
              "aria-controls": d,
              "aria-activedescendant": V.value,
              placeholder: u(r)("panelsearch.placeholder"),
              autocomplete: "off",
              autocapitalize: "off",
              spellcheck: "false",
              enterkeyhint: "search",
              "data-testid": "panel-search-input",
              onKeydown: at
            }, null, 40, Zoe), [
              [bn, w.value]
            ]),
            w.value ? (p(), h("button", {
              key: 2,
              type: "button",
              class: "fx-psearch__iconbtn",
              "aria-label": u(r)("panelsearch.clear"),
              "data-testid": "panel-search-clear",
              onClick: We
            }, [
              c("span", {
                class: "fx-psearch__glyph",
                "aria-hidden": "true",
                innerHTML: u(zt)("close")
              }, null, 8, ere)
            ], 8, Qoe)) : D("", !0)
          ]),
          c("div", {
            id: d,
            ref_key: "listEl",
            ref: b,
            class: "fx-psearch__list",
            role: "listbox",
            "aria-label": u(r)("panelsearch.results")
          }, [
            (p(!0), h(Ce, null, ot(C.value, (De) => (p(), h("div", {
              key: De.key,
              class: "fx-psearch__group",
              role: "group",
              "aria-labelledby": `${l}-h-${De.key}`,
              "data-testid": `panel-search-group-${De.key}`
            }, [
              c("div", {
                id: `${l}-h-${De.key}`,
                class: "fx-psearch__heading",
                role: "presentation"
              }, y(De.heading), 9, are),
              (p(!0), h(Ce, null, ot(De.rows, (mt) => (p(), h("div", {
                id: de(mt.index),
                key: mt.id,
                class: Fe(["fx-psearch__row", mt.index === k.value && "is-active"]),
                role: "option",
                "aria-selected": mt.index === k.value ? "true" : "false",
                "data-testid": mt.type === "item" ? `panel-search-row-${mt.item.kind}` : `panel-search-${mt.type}`,
                "data-id": mt.type === "item" ? mt.item.id : void 0,
                onMousedown: qe[3] || (qe[3] = vt(() => {
                }, ["prevent"])),
                onMouseenter: ($t) => k.value = mt.index,
                onClick: ($t) => Re(mt)
              }, [
                mt.type === "item" ? (p(), h(Ce, { key: 0 }, [
                  c("span", ore, [
                    mt.item.icon && mt.item.kind !== "file" ? (p(), Je(Ii(mt.item.icon), {
                      key: 0,
                      class: "fx-psearch__svg"
                    })) : (p(), h("span", {
                      key: 1,
                      class: "fx-psearch__svg",
                      innerHTML: K(mt.item)
                    }, null, 8, rre))
                  ]),
                  c("span", sre, [
                    c("span", lre, [
                      c("bdi", null, y(mt.item.label), 1)
                    ]),
                    mt.item.detail ? (p(), h("span", ure, [
                      c("bdi", null, y(mt.item.detail), 1)
                    ])) : D("", !0)
                  ])
                ], 64)) : mt.type === "files-all" ? (p(), h(Ce, { key: 1 }, [
                  c("span", cre, [
                    c("span", {
                      class: "fx-psearch__svg",
                      innerHTML: u(zt)("search")
                    }, null, 8, dre)
                  ]),
                  c("span", fre, [
                    c("span", pre, y(u(r)("panelsearch.files_all", { q: A.value.text })), 1)
                  ])
                ], 64)) : (p(), h(Ce, { key: 2 }, [
                  c("span", hre, [
                    c("span", {
                      class: "fx-psearch__svg",
                      innerHTML: u(zt)("search")
                    }, null, 8, mre)
                  ]),
                  c("span", vre, [
                    c("span", yre, [
                      c("bdi", null, y(mt.entry.query), 1)
                    ])
                  ]),
                  c("button", {
                    type: "button",
                    class: "fx-psearch__iconbtn fx-psearch__remove",
                    tabindex: "-1",
                    "aria-label": u(r)("panelsearch.recent_remove"),
                    title: u(r)("panelsearch.recent_remove"),
                    "data-testid": "panel-search-recent-remove",
                    onClick: vt(($t) => Y(mt.entry), ["stop"])
                  }, [
                    c("span", {
                      class: "fx-psearch__glyph",
                      "aria-hidden": "true",
                      innerHTML: u(zt)("close")
                    }, null, 8, bre)
                  ], 8, gre)
                ], 64))
              ], 42, ire))), 128))
            ], 8, nre))), 128)),
            z.value && re.value.length === 0 ? (p(), h("p", kre, y(u(r)("panelsearch.searching")), 1)) : ne.value ? (p(), h("p", wre, y(u(r)("panelsearch.empty", { q: A.value.text })), 1)) : D("", !0),
            L.value ? (p(), h("p", _re, y(u(r)("panelsearch.failed")), 1)) : D("", !0)
          ], 8, tre),
          c("div", xre, [
            c("span", Sre, y(u(r)("panelsearch.prefixes")), 1),
            (p(!0), h(Ce, null, ot(u(Noe), (De) => (p(), h("button", {
              key: De,
              type: "button",
              class: Fe(["fx-psearch__chip", A.value.prefix === De && "is-on"]),
              "aria-pressed": A.value.prefix === De ? "true" : "false",
              "data-testid": `panel-search-prefix-${De}`,
              onMousedown: qe[4] || (qe[4] = vt(() => {
              }, ["prevent"])),
              onClick: (mt) => Be(A.value.prefix === De ? "" : De)
            }, y(De) + ":", 43, $re))), 128)),
            A.value.words.length === 0 && A.value.kind === null && F.value.length ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "fx-psearch__clearall",
              "data-testid": "panel-search-recent-clear",
              onMousedown: qe[5] || (qe[5] = vt(() => {
              }, ["prevent"])),
              onClick: ie
            }, y(u(r)("panelsearch.recent_clear")), 33)) : D("", !0)
          ]),
          c("p", Tre, y(W.value), 1)
        ], 46, Woe)) : D("", !0)
      ]))
    ], 2));
  }
});
function nT(e, t = {}) {
  return e === "app" ? "wide" : e === "folder" ? t.list ? "wide" : "form" : e === "drop" ? "form" : "gate";
}
function Ere(e, t) {
  const n = (t ?? []).map((r) => r.trim().replace(/^\./, "").toLowerCase()).filter(Boolean);
  if (!n.length) return !0;
  const a = e.lastIndexOf("."), i = a > 0 || a === 0 && e.length > 1 ? e.slice(a + 1).toLowerCase() : "";
  return n.includes(i);
}
function Cre(e, t, n) {
  const a = { accepted: [], refused: [] }, i = (t == null ? void 0 : t.max_file_size_mb) ?? 0;
  let r = t != null && t.max_files && t.max_files > 0 ? t.max_files : 1 / 0;
  typeof n == "number" && Number.isFinite(n) && (r = Math.min(r, Math.max(0, n)));
  for (const l of e)
    Ere(l.name, t == null ? void 0 : t.allowed_ext) ? i > 0 && l.size > i * 1024 * 1024 ? a.refused.push({ file: l, reason: { code: "too_large", name: l.name, mb: i } }) : a.accepted.length >= r ? a.refused.push({ file: l, reason: { code: "too_many", count: r } }) : a.accepted.push(l) : a.refused.push({ file: l, reason: { code: "ext", name: l.name } });
  return a;
}
class zre extends Error {
  constructor(t, n, a) {
    super(a || n || String(t)), this.status = t, this.code = n, this.name = "PublicLinkError";
  }
}
function Cg(e, t, n) {
  const a = (e ?? "").replace(/\/+$/, "");
  return (i = "") => `${a}${t}${encodeURIComponent(n)}${i}`;
}
function Mre(e, t) {
  return Cg(e, "/api/public/s/", t);
}
function Pre(e, t) {
  return Cg(e, "/api/public/d/", t);
}
function zg(e, t) {
  return Cg(e, "/api/p/", t);
}
function aT(e, t) {
  const n = (...i) => (t.fetchImpl ?? fetch)(...i);
  async function a(i, r = {}) {
    const l = { Accept: "application/json", "Accept-Language": t.locale() };
    r.body !== void 0 && (l["Content-Type"] = "application/json");
    const d = await n(e(i), {
      method: r.method ?? "GET",
      headers: l,
      credentials: "same-origin",
      cache: "no-store",
      body: r.body !== void 0 ? JSON.stringify(r.body) : void 0
    });
    let f = null;
    try {
      f = await d.json();
    } catch {
      f = null;
    }
    if (!d.ok) {
      const m = f ?? {};
      throw new zre(d.status, m.error ?? "", m.message);
    }
    return { status: d.status, body: f };
  }
  return {
    /** What the link is and what the visitor may see of it. */
    info: (i = "") => a(i).then((r) => r.body),
    pin: (i) => a("/pin", { method: "POST", body: { pin: i } }).then((r) => r.body),
    /**
     * The app's opening screen.
     *
     * ⚠ There is no `/view` route: an open is `POST /event
     * {"event":"open"}`, because the opening surface and every later one are
     * the same call to the app. One endpoint, one code path in the plugin.
     */
    open: () => a("/event", { method: "POST", body: { event: "open", state: {}, data: {} } }).then(
      (i) => i.body
    ),
    /** `{surface}`, or `{op}` when the server queued a job (202). */
    event: async (i) => {
      var l, d, f;
      const r = await a("/event", {
        method: "POST",
        body: i
      });
      return r.status === 202 || (l = r.body) != null && l.accepted ? { op: { accepted: !0, job_id: (d = r.body) == null ? void 0 : d.job_id }, job_id: (f = r.body) == null ? void 0 : f.job_id } : { surface: r.body.surface };
    },
    /** Where the browser loads an exposed copy from (`pub:N`). */
    fileUrl: (i) => e(`/file/${encodeURIComponent(i)}`),
    /**
     * The same copy, asked for as a DOWNLOAD — the Download button's link.
     * ⚠ Kept apart from `fileUrl` because only this one counts as a download
     * (handlers/public_api.go serveExposed): the page's own viewer loads the
     * document to SHOW it, and the owner ruled on 2026-09-21 that looking at
     * a signing link is not downloading it.
     */
    fileDownloadUrl: (i) => e(`/file/${encodeURIComponent(i)}?download=1`),
    url: e
  };
}
function Mg(e, t) {
  const n = aT(e, t), a = $("loading"), i = $(null), r = $(""), l = $(""), d = $(""), f = $(""), m = $(""), v = $(""), b = xp(
    {
      api: { pluginViewEvent: (T, N, z) => n.event(z) },
      plugin: "",
      view: "",
      locale: t.locale,
      errorText: t.errorText
    },
    {
      onOp: (T) => {
        d.value = String(T.job_id ?? ""), a.value = "accepted";
      },
      onDone: () => {
        a.value !== "accepted" && (a.value = "done");
      },
      onToast: (T) => {
        f.value = T;
      }
    }
  );
  function _(T) {
    const N = T;
    (N == null ? void 0 : N.status) === 404 ? (a.value = "not_found", v.value = "not_found") : (N == null ? void 0 : N.status) === 410 ? (a.value = "gone", v.value = "gone") : (a.value = "error", v.value = "error", m.value = Vi(t.locale(), String((T == null ? void 0 : T.message) ?? T)) || t.errorText());
  }
  async function w() {
    try {
      const T = await n.open(), N = T == null ? void 0 : T.surface;
      if (!N) {
        a.value = "error", m.value = t.errorText();
        return;
      }
      b.setSurface(N), a.value = N.done ? "done" : "ready";
    } catch (T) {
      if ((T == null ? void 0 : T.status) === 401) {
        a.value = "pin";
        return;
      }
      _(T);
    }
  }
  function k(T) {
    return (T == null ? void 0 : T.expired) === !0 || (T == null ? void 0 : T.revoked) === !0;
  }
  async function x(T = "") {
    var N, z, L, B;
    a.value = "loading", m.value = "", v.value = "";
    try {
      i.value = await n.info(T);
    } catch (O) {
      _(O);
      return;
    }
    if (k(i.value)) {
      a.value = "gone", v.value = "gone";
      return;
    }
    if ((N = i.value) != null && N.needs_pin && !((z = i.value) != null && z.unlocked)) {
      a.value = "pin", r.value = ((L = i.value) == null ? void 0 : L.locked) === !0 ? "locked" : "";
      return;
    }
    if ((B = t.hasSurface) != null && B.call(t, i.value)) {
      await w();
      return;
    }
    a.value = "ready";
  }
  const M = $(!1);
  async function A(T) {
    var N;
    if (!M.value) {
      r.value = "", l.value = "", M.value = !0;
      try {
        i.value = await n.pin(T.trim()), k(i.value) ? (a.value = "gone", v.value = "gone") : (N = t.hasSurface) != null && N.call(t, i.value) ? await w() : a.value = "ready";
      } catch (z) {
        const L = z;
        (L == null ? void 0 : L.status) === 429 ? (r.value = "locked", l.value = Vi(t.locale(), L.message ?? "")) : (L == null ? void 0 : L.status) === 401 || (L == null ? void 0 : L.status) === 403 ? r.value = "wrong" : _(z);
      } finally {
        M.value = !1;
      }
    }
  }
  return {
    status: a,
    info: i,
    reason: v,
    pinFailure: r,
    lockMessage: l,
    pinBusy: M,
    failure: m,
    toast: f,
    jobId: d,
    conv: b,
    load: x,
    submitPin: A,
    fileUrl: n.fileUrl,
    fileDownloadUrl: n.fileDownloadUrl,
    /**
     * A `FileRefResolver` for the surface renderer: the URL, plus the name
     * and type the link's own `files[]` already told us.
     *
     * ⚠ The renderer needs the mime to decide how to draw the thing (a
     * picture, an embedded PDF, a link). Handing it a bare URL makes every
     * exposed copy render as "something to download", which is what a
     * `preview` node is specifically not for.
     */
    resolveFile: (T) => {
      var L, B;
      const N = (B = (L = i.value) == null ? void 0 : L.app) == null ? void 0 : B.files, z = N == null ? void 0 : N.find((O) => O.ref === T);
      return { url: n.fileUrl(T), name: z == null ? void 0 : z.name, mime: z == null ? void 0 : z.mime };
    },
    url: n.url
  };
}
function Ore(e, t, n = {}) {
  const a = (e ?? "").replace(/\/+$/, ""), i = encodeURIComponent(t);
  return n.path ? `${a}/s/${i}/f/${n.path.split("/").map(encodeURIComponent).join("/")}?download=1` : `${a}/s/${i}?${n.zip ? "zip=1" : "download=1"}`;
}
function Dre(e, t) {
  return `${(e ?? "").replace(/\/+$/, "")}/s/${encodeURIComponent(t)}?nojs=1`;
}
function Lre(e, t) {
  return {
    ...Mg(Mre(t.base, e), {
      ...t,
      hasSurface: (a) => (a == null ? void 0 : a.kind) === "app"
    }),
    downloadUrl: (a = {}) => Ore(t.base, e, a),
    noJsUrl: () => Dre(t.base, e)
  };
}
const Rre = /* @__PURE__ */ new Set([504, 524]);
function Nre(e, t) {
  const n = Mg(Pre(t.base, e), t), a = $([]);
  function i(d, f, m) {
    a.value = a.value.map((v, b) => b >= d && b < f ? { ...v, ...m } : v);
  }
  function r(d, f, m) {
    const v = f + d.length;
    return new Promise((b) => {
      let _;
      try {
        _ = new XMLHttpRequest();
      } catch {
        i(f, v, { state: "failed", error: t.errorText() }), b();
        return;
      }
      _.open("POST", n.url("/upload")), _.withCredentials = !0, _.setRequestHeader("Accept", "application/json"), _.setRequestHeader("Accept-Language", t.locale()), _.upload.onprogress = (M) => {
        M.lengthComputable && M.total > 0 && i(f, v, { percent: Math.round(M.loaded / M.total * 100) });
      };
      let w = !1;
      _.upload.onload = () => {
        w = !0, i(f, v, { state: "saving", percent: 100 });
      };
      const k = () => i(f, v, { state: "unconfirmed", error: (t.unansweredText ?? t.errorText)() });
      _.onload = () => {
        var M;
        if (_.status >= 200 && _.status < 300)
          i(f, v, { state: "done", percent: 100 });
        else {
          let A = "";
          try {
            A = String(((M = JSON.parse(_.responseText)) == null ? void 0 : M.message) ?? "");
          } catch {
            A = "";
          }
          !A && w && Rre.has(_.status) ? k() : i(f, v, { state: "failed", error: A || t.errorText() });
        }
        b();
      }, _.onerror = () => {
        w ? k() : i(f, v, { state: "failed", error: t.errorText() }), b();
      };
      const x = new FormData();
      for (const M of d) x.append("file", M, M.name);
      m && x.append("uploader_name", m), _.send(x);
    });
  }
  async function l(d, f = {}) {
    const m = n.info.value, { accepted: v, refused: b } = Cre(Array.from(d), m == null ? void 0 : m.limits, (m == null ? void 0 : m.uploads_left) ?? null), _ = f.refusedText ?? (() => t.errorText());
    if (a.value = [
      ...a.value,
      ...b.map(({ file: k, reason: x }) => ({
        name: k.name,
        size: k.size,
        percent: -1,
        state: "refused",
        error: _(x)
      }))
    ], !v.length) return;
    const w = a.value.length;
    a.value = [
      ...a.value,
      ...v.map((k) => ({ name: k.name, size: k.size, percent: -1, state: "sending" }))
    ], await r(v, w, (f.name ?? "").trim()), await n.load();
  }
  return { ...n, uploads: a, upload: l };
}
function cde(e, t, n = "") {
  return zg(e, t)(n);
}
function dde(e, t) {
  return aT(zg(t.base, e), t);
}
function fde(e, t) {
  return Mg(zg(t.base, e), { ...t, hasSurface: () => !0 });
}
const iT = Symbol("filex-public-text");
function oT(e) {
  const t = $({}), n = $(""), a = $(!1);
  let i = 0;
  async function r(l) {
    const d = ++i;
    a.value = !1;
    const f = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
    try {
      if (!f) return;
      const m = await f(`${kl(e.base)}/api/public/strings?lang=${encodeURIComponent(l)}`, {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      });
      if (!m.ok) return;
      const v = await m.json();
      if (d !== i) return;
      t.value = v != null && v.strings && typeof v.strings == "object" ? v.strings : {}, n.value = (v == null ? void 0 : v.lang) || l;
    } catch {
    } finally {
      d === i && (a.value = !0);
    }
  }
  return Xe(e.locale, (l) => void r(l), { immediate: !0 }), { table: t, lang: n, ready: a };
}
function rT(e) {
  wr(iT, e);
}
const Ire = ["count", "n"];
function sT(e, t, n, a = {}) {
  let i;
  const r = Ire.find((l) => l in a);
  if (r !== void 0) {
    const l = cy(t || "en", Number(a[r]));
    l !== "other" && (i = e[`${n}_${l}`]);
  }
  return i = i || e[n] || "", Object.entries(a).reduce((l, [d, f]) => l.replaceAll(`{${d}}`, String(f)), i);
}
function Pg(e) {
  const t = Hi(iT, null), n = E(() => (t == null ? void 0 : t.table.value) ?? {}), a = E(() => (t == null ? void 0 : t.lang.value) || (e ? e() : "") || "en"), i = E(() => (t == null ? void 0 : t.ready.value) ?? !0);
  function r(l, d = {}) {
    const f = sT(n.value, a.value, l, d);
    return f ? Vi(a.value, f) : "";
  }
  return { pt: r, ready: i };
}
const Bre = { class: "fe-ppage__state" }, Fre = { class: "fe-ppage__state-title" }, Ure = { class: "fe-surface__text fe-surface__text--muted" }, Hre = {
  class: "fe-ppage__srlabel",
  for: "fe-ppage-pin"
}, Kre = ["maxlength", "disabled", "aria-invalid"], Vre = {
  key: 0,
  class: "fe-ppage__error",
  role: "alert",
  "data-testid": "public-page-pin-error"
}, jre = ["disabled"], qre = /* @__PURE__ */ lt({
  __name: "PublicPinGate",
  props: {
    locale: {},
    busy: { type: Boolean },
    failure: {},
    lockMessage: {},
    maxLength: {}
  },
  emits: ["submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = yt(() => n.locale), r = $(""), l = $(null), d = () => n.failure === "wrong" ? i("plugin.page.pin_wrong") : n.failure === "locked" ? i("plugin.page.pin_locked") : "";
    Xe(
      () => n.failure,
      async (m) => {
        var v;
        m === "wrong" && (r.value = "", await Zt(), (v = l.value) == null || v.focus());
      }
    ), Wt(() => {
      var m;
      return (m = l.value) == null ? void 0 : m.focus();
    });
    function f() {
      var m;
      if (!(n.busy || n.failure === "locked")) {
        if (!r.value.trim()) {
          (m = l.value) == null || m.focus();
          return;
        }
        a("submit", r.value);
      }
    }
    return (m, v) => (p(), h("form", {
      class: "fe-ppage__pin",
      "data-testid": "public-page-pin",
      onSubmit: vt(f, ["prevent"])
    }, [
      c("div", Bre, [
        c("h2", Fre, y(u(i)("plugin.page.pin_title")), 1),
        c("p", Ure, y(u(i)("plugin.page.pin_hint")), 1)
      ]),
      c("label", Hre, y(u(i)("plugin.pin.label")), 1),
      un(c("input", {
        id: "fe-ppage-pin",
        ref_key: "input",
        ref: l,
        "onUpdate:modelValue": v[0] || (v[0] = (b) => r.value = b),
        class: Fe(["fe-cfield__input fe-ppage__pinput", { "is-invalid": !!d() }]),
        type: "text",
        inputmode: "numeric",
        autocomplete: "one-time-code",
        spellcheck: "false",
        maxlength: e.maxLength && e.maxLength > 0 ? e.maxLength : void 0,
        disabled: e.busy || e.failure === "locked",
        "aria-invalid": d() ? "true" : void 0,
        "data-testid": "public-page-pin-input"
      }, null, 10, Kre), [
        [bn, r.value]
      ]),
      d() ? (p(), h("p", Vre, [
        Ht(y(d()), 1),
        e.lockMessage ? (p(), h(Ce, { key: 0 }, [
          Ht(" (" + y(e.lockMessage) + ")", 1)
        ], 64)) : D("", !0)
      ])) : D("", !0),
      c("button", {
        type: "submit",
        class: "fe-btn fe-btn--primary",
        disabled: e.busy || e.failure === "locked",
        "data-testid": "public-page-pin-submit"
      }, y(u(i)("plugin.page.pin_submit")), 9, jre)
    ], 32));
  }
}), Wre = {
  key: 0,
  class: "fe-plang",
  role: "group",
  "data-testid": "public-language"
}, Yre = ["lang", "aria-pressed", "title", "data-testid", "onClick"], Gre = {
  key: 0,
  class: "fe-plang__src"
}, Xre = /* @__PURE__ */ lt({
  __name: "PublicLanguagePicker",
  props: {
    modelValue: {},
    pluginNote: { type: Function }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => (ei.value, _r())), r = E(() => i.value.length > 1);
    return (l, d) => r.value ? (p(), h("div", Wre, [
      (p(!0), h(Ce, null, ot(i.value, (f) => (p(), h("button", {
        key: f.code,
        type: "button",
        class: Fe(["fe-plang__btn", { "is-on": f.code === n.modelValue }]),
        lang: f.code,
        "aria-pressed": f.code === n.modelValue ? "true" : "false",
        title: f.source === "plugin" && f.plugin && e.pluginNote ? e.pluginNote(f.plugin) : void 0,
        "data-testid": `public-language-${f.code}`,
        onClick: (m) => a("update:modelValue", f.code)
      }, [
        Ht(y(f.label) + " ", 1),
        f.source === "plugin" && f.plugin ? (p(), h("small", Gre, y(f.plugin), 1)) : D("", !0)
      ], 10, Yre))), 128))
    ])) : D("", !0);
  }
}), Jre = ["dir", "data-state", "data-layout"], Zre = {
  class: "fe-ppage__brand",
  "data-testid": "public-brand"
}, Qre = ["src", "alt"], ese = { class: "fe-ppage__brandname" }, tse = ["data-badge"], nse = {
  key: 0,
  class: "fe-ppage__spinner"
}, ase = ["stroke-width"], ise = {
  key: 1,
  d: "M4.5 12.5l5 5 10-11"
}, ose = {
  key: 1,
  class: "fe-ppage__head"
}, rse = {
  key: 0,
  class: "fe-ppage__title",
  "data-testid": "public-page-title"
}, sse = {
  key: 1,
  class: "fe-ppage__subject",
  "data-testid": "public-page-subject"
}, lse = {
  key: 2,
  class: "fe-ppage__meta",
  "data-testid": "public-page-meta"
}, use = { key: 0 }, cse = {
  key: 1,
  "aria-hidden": "true"
}, dse = { key: 2 }, fse = {
  key: 3,
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-page-loading"
}, pse = {
  key: 6,
  class: "fe-ppage__state fe-ppage__state--ok",
  "data-testid": "public-page-accepted"
}, hse = { class: "fe-ppage__state-title" }, mse = { class: "fe-surface__text" }, vse = {
  key: 7,
  class: "fe-ppage__state fe-ppage__state--ok",
  "data-testid": "public-page-done"
}, yse = { class: "fe-ppage__state-title" }, gse = { class: "fe-surface__text" }, bse = {
  key: 8,
  class: "fe-ppage__state",
  "data-testid": "public-page-error"
}, kse = { class: "fe-ppage__state-title" }, wse = {
  key: 0,
  class: "fe-ppage__error"
}, _se = {
  key: 9,
  class: "fe-ppage__state",
  "data-testid": "public-page-unavailable"
}, xse = { class: "fe-ppage__state-title" }, Sse = { class: "fe-surface__text fe-surface__text--muted" }, $se = { class: "fe-ppage__foot" }, Tse = {
  key: 0,
  class: "fe-ppage__footline",
  "data-testid": "public-footer-text"
}, Ase = {
  key: 1,
  class: "fe-ppage__footmark",
  "data-testid": "public-footer-powered"
}, Ese = ["src"], lT = /* @__PURE__ */ lt({
  __name: "PublicShell",
  props: {
    status: {},
    locale: {},
    theme: {},
    brandName: {},
    logoUrl: {},
    accentStyle: {},
    footerText: {},
    hidePoweredBy: { type: Boolean },
    layout: {},
    badge: {},
    title: {},
    subject: {},
    expiresAt: {},
    visitsLeft: {},
    pinMax: {},
    pinBusy: { type: Boolean },
    pinFailure: {},
    lockMessage: {},
    failure: {},
    embedded: { type: Boolean }
  },
  emits: ["pin", "retry", "update:locale"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r, dir: l } = yt(() => n.locale), { pt: d } = Pg(() => String(n.locale)), f = E(() => n.status === "ready"), m = E(() => f.value ? n.layout ?? "form" : "gate"), v = E(
      () => n.theme === "dark" ? "fe--theme-dark" : n.theme === "light" ? "fe--theme-light" : ""
    ), b = E(() => {
      if (!n.expiresAt) return "";
      const A = Date.parse(n.expiresAt);
      return Number.isFinite(A) ? d("expires", { when: r(A, { time: !0 }) }) : "";
    }), _ = E(() => {
      const A = n.visitsLeft;
      return A == null || !Number.isFinite(A) ? "" : d("visits_left", { count: A });
    }), w = E(() => n.status === "pin" ? "lock" : n.status === "accepted" || n.status === "done" ? "check" : n.status === "loading" ? "loading" : f.value ? n.badge ?? "" : "alert"), k = E(
      () => w.value === "check" ? "fe-ppage__badge--ok" : w.value === "alert" ? "fe-ppage__badge--err" : ""
    ), x = E(() => !n.logoUrl && n.brandName === Hf);
    function M(A) {
      return d("language_from", { app: A });
    }
    return (A, T) => (p(), h("div", {
      class: Fe(["fe fe-ppage", [v.value, `fe-ppage--${m.value}`]]),
      dir: u(l),
      style: Yt(e.accentStyle),
      "data-testid": "public-page",
      "data-state": e.status,
      "data-layout": m.value
    }, [
      c("header", Zre, [
        e.logoUrl ? (p(), h("img", {
          key: 0,
          class: "fe-ppage__logo",
          src: e.logoUrl,
          alt: e.brandName
        }, null, 8, Qre)) : x.value ? (p(), Je(h0, {
          key: 1,
          class: "fe-ppage__logo"
        })) : D("", !0),
        c("span", ese, y(e.brandName), 1)
      ]),
      (p(), Je(Ii(e.embedded ? "div" : "main"), { class: "fe-ppage__card" }, {
        default: gt(() => [
          w.value ? (p(), h("div", {
            key: 0,
            class: Fe(["fe-ppage__badge", k.value]),
            "data-testid": "public-page-badge",
            "data-badge": w.value,
            "aria-hidden": "true"
          }, [
            w.value === "loading" ? (p(), h("span", nse)) : (p(), h("svg", {
              key: 1,
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": w.value === "check" ? 2 : 1.8,
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              w.value === "lock" ? (p(), h(Ce, { key: 0 }, [
                T[3] || (T[3] = c("rect", {
                  x: "4.5",
                  y: "10.5",
                  width: "15",
                  height: "9.5",
                  rx: "2"
                }, null, -1)),
                T[4] || (T[4] = c("path", { d: "M8 10.5V7a4 4 0 0 1 8 0v3.5" }, null, -1)),
                T[5] || (T[5] = c("path", { d: "M12 14.5v2" }, null, -1))
              ], 64)) : w.value === "check" ? (p(), h("path", ise)) : w.value === "alert" ? (p(), h(Ce, { key: 2 }, [
                T[6] || (T[6] = c("path", { d: "M10.3 4.2 2.6 17.9a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0z" }, null, -1)),
                T[7] || (T[7] = c("path", { d: "M12 9.5v4.5" }, null, -1)),
                T[8] || (T[8] = c("path", { d: "M12 17.4h.01" }, null, -1))
              ], 64)) : w.value === "folder" ? (p(), h(Ce, { key: 3 }, [
                T[9] || (T[9] = c("path", { d: "M3.5 7a2 2 0 0 1 2-2h4l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V7z" }, null, -1)),
                T[10] || (T[10] = c("path", { d: "M12 10.5V16" }, null, -1)),
                T[11] || (T[11] = c("path", { d: "M9.5 13.5 12 16l2.5-2.5" }, null, -1))
              ], 64)) : (p(), h(Ce, { key: 4 }, [
                T[12] || (T[12] = c("path", { d: "M7 3.5h7l4 4V20a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 20V5A1.5 1.5 0 0 1 7.5 3.5z" }, null, -1)),
                T[13] || (T[13] = c("path", { d: "M13.5 3.5V8H18" }, null, -1)),
                T[14] || (T[14] = c("path", { d: "M12 11.5V17" }, null, -1)),
                T[15] || (T[15] = c("path", { d: "M9.5 14.5 12 17l2.5-2.5" }, null, -1))
              ], 64))
            ], 8, ase))
          ], 10, tse)) : D("", !0),
          (e.title || e.subject) && f.value ? (p(), h("header", ose, [
            e.title ? (p(), h("h1", rse, [
              c("bdi", null, y(e.title), 1)
            ])) : D("", !0),
            e.subject ? (p(), h("p", sse, y(e.subject), 1)) : D("", !0)
          ])) : D("", !0),
          (b.value || _.value) && f.value ? (p(), h("p", lse, [
            b.value ? (p(), h("span", use, y(b.value), 1)) : D("", !0),
            b.value && _.value ? (p(), h("span", cse, "·")) : D("", !0),
            _.value ? (p(), h("span", dse, y(_.value), 1)) : D("", !0)
          ])) : D("", !0),
          e.status === "loading" ? (p(), h("p", fse, y(u(i)("plugin.page.loading")), 1)) : e.status === "pin" ? (p(), Je(qre, {
            key: 4,
            locale: e.locale,
            busy: e.pinBusy,
            failure: e.pinFailure,
            "lock-message": e.lockMessage,
            "max-length": e.pinMax ?? void 0,
            onSubmit: T[0] || (T[0] = (N) => a("pin", N))
          }, null, 8, ["locale", "busy", "failure", "lock-message", "max-length"])) : f.value ? En(A.$slots, "default", { key: 5 }) : e.status === "accepted" ? (p(), h("div", pse, [
            En(A.$slots, "accepted", {}, () => [
              c("h2", hse, y(u(i)("plugin.page.accepted_title")), 1),
              c("p", mse, y(u(i)("plugin.page.accepted_text")), 1)
            ])
          ])) : e.status === "done" ? (p(), h("div", vse, [
            En(A.$slots, "done", {}, () => [
              c("h2", yse, y(u(i)("plugin.page.done_title")), 1),
              c("p", gse, y(u(i)("plugin.page.done_text")), 1)
            ])
          ])) : e.status === "error" ? (p(), h("div", bse, [
            c("h2", kse, y(u(i)("plugin.page.error_title")), 1),
            e.failure ? (p(), h("p", wse, y(e.failure), 1)) : D("", !0),
            c("button", {
              type: "button",
              class: "fe-btn fe-btn--primary",
              onClick: T[1] || (T[1] = (N) => a("retry"))
            }, y(u(i)("plugin.page.retry")), 1)
          ])) : (p(), h("div", _se, [
            c("h2", xse, y(u(i)("plugin.page.unavailable_title")), 1),
            c("p", Sse, y(u(i)("plugin.page.unavailable_text")), 1)
          ])),
          En(A.$slots, "extra")
        ]),
        _: 3
      })),
      c("footer", $se, [
        tt(Xre, {
          "model-value": String(e.locale),
          "plugin-note": M,
          "onUpdate:modelValue": T[2] || (T[2] = (N) => a("update:locale", N))
        }, null, 8, ["model-value"]),
        e.footerText ? (p(), h("p", Tse, y(e.footerText), 1)) : D("", !0),
        e.hidePoweredBy ? D("", !0) : (p(), h("span", Ase, [
          e.logoUrl ? (p(), h("img", {
            key: 0,
            src: e.logoUrl,
            alt: ""
          }, null, 8, Ese)) : x.value ? (p(), Je(h0, { key: 1 })) : D("", !0),
          Ht(" " + y(u(d)("served_by", { name: e.brandName })), 1)
        ]))
      ])
    ], 14, Jre));
  }
}), Cse = {
  key: 0,
  class: "fe-ppage__actions"
}, zse = {
  key: 1,
  class: "fe-ppage__appfiles",
  "data-testid": "public-page-files"
}, Mse = { class: "fe-surface__text" }, Pse = {
  key: 0,
  class: "fe-ppage__filesize"
}, Ose = ["href", "title", "data-testid"], Dse = {
  key: 1,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-unavailable"
}, Lse = {
  key: 0,
  class: "fe-surface__text"
}, Rse = {
  class: "fe-surface__text fe-surface__text--muted",
  role: "status"
}, Nse = {
  key: 2,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-folder"
}, Ise = {
  key: 0,
  class: "fe-surface__text"
}, Bse = {
  key: 1,
  class: "fe-ppage__crumbs",
  "data-testid": "public-share-crumbs"
}, Fse = { class: "fe-ppage__crumb" }, Use = {
  key: 2,
  class: "fe-ppage__files",
  "data-testid": "public-share-entries"
}, Hse = ["data-dir"], Kse = ["data-testid", "onClick"], Vse = ["href", "data-testid"], jse = {
  key: 2,
  class: "fe-ppage__filesize"
}, qse = {
  key: 3,
  class: "fe-ppage__filesize"
}, Wse = { class: "fe-ppage__actions" }, Yse = ["href"], Gse = ["href"], Xse = {
  key: 3,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-file"
}, Jse = ["src", "alt"], Zse = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-share-fileline"
}, Qse = { key: 0 }, ele = {
  key: 1,
  class: "fe-ppage__filesize"
}, tle = ["href"], uT = /* @__PURE__ */ lt({
  __name: "PublicShareBody",
  props: {
    link: {},
    locale: {},
    theme: {}
  },
  emits: ["navigate"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, formatDate: l } = yt(() => n.locale), { pt: d } = Pg(() => String(n.locale)), f = E(() => n.link.info.value), m = E(() => {
      var M;
      return ((M = f.value) == null ? void 0 : M.kind) ?? "file";
    }), v = E(() => {
      var M;
      return ((M = f.value) == null ? void 0 : M.node) ?? null;
    }), b = E(() => {
      var M;
      return ((M = f.value) == null ? void 0 : M.app) ?? null;
    }), _ = E(() => {
      var M;
      return ((M = f.value) == null ? void 0 : M.entries) ?? [];
    }), w = E(() => {
      var M;
      return ((M = f.value) == null ? void 0 : M.unavailable) === !0;
    }), k = E(() => {
      var M;
      return (((M = v.value) == null ? void 0 : M.mime) ?? "").startsWith("image/");
    }), x = E(() => {
      var T;
      const M = (((T = f.value) == null ? void 0 : T.path) ?? "").replace(/\/+$/, "");
      if (!M) return null;
      const A = M.lastIndexOf("/");
      return A <= 0 ? "" : M.slice(0, A);
    });
    return (M, A) => {
      var T, N, z, L, B, O, U, S, F, I, G, Y, ie, me;
      return m.value === "app" ? (p(), h(Ce, { key: 0 }, [
        tt(Sp, {
          conv: e.link.conv,
          locale: e.locale,
          theme: e.theme,
          "file-url": e.link.resolveFile,
          toast: e.link.toast.value,
          layout: "page",
          "page-height": "min(80vh, 1000px)"
        }, null, 8, ["conv", "locale", "theme", "file-url", "toast"]),
        e.link.conv.footer.value.length ? (p(), h("div", Cse, [
          tt($p, {
            conv: e.link.conv,
            locale: e.locale,
            "testid-prefix": "public-page"
          }, null, 8, ["conv", "locale"])
        ])) : D("", !0),
        (N = (T = b.value) == null ? void 0 : T.files) != null && N.length ? (p(), h("section", zse, [
          (p(!0), h(Ce, null, ot(((z = b.value) == null ? void 0 : z.files) ?? [], (q) => (p(), h("div", {
            key: q.ref,
            class: "fe-ppage__file-one fe-ppage__appfile"
          }, [
            c("p", Mse, [
              c("strong", null, y(q.name), 1),
              q.size ? (p(), h("span", Pse, " · " + y(u(r)(q.size)), 1)) : D("", !0)
            ]),
            c("a", {
              class: "fe-btn",
              href: e.link.fileDownloadUrl(q.ref),
              download: "",
              title: u(i)("plugin.page.open_file", { name: q.name }),
              "data-testid": `public-page-file-${q.ref}`
            }, y(u(i)("ctx.download")), 9, Ose)
          ]))), 128))
        ])) : D("", !0)
      ], 64)) : w.value ? (p(), h("div", Dse, [
        (L = v.value) != null && L.name ? D("", !0) : (p(), h("p", Lse, [
          c("strong", null, y((B = f.value) == null ? void 0 : B.subject), 1)
        ])),
        c("p", Rse, y(u(d)("err_unavailable_body")), 1)
      ])) : m.value === "folder" ? (p(), h("div", Nse, [
        (O = v.value) != null && O.name ? D("", !0) : (p(), h("p", Ise, [
          c("strong", null, y((U = f.value) == null ? void 0 : U.subject), 1)
        ])),
        (S = f.value) != null && S.path ? (p(), h("nav", Bse, [
          c("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: A[0] || (A[0] = (q) => a("navigate", x.value ?? ""))
          }, y(u(d)("folder_up")), 1),
          c("span", Fse, y((F = f.value) == null ? void 0 : F.path), 1)
        ])) : D("", !0),
        _.value.length ? (p(), h("ul", Use, [
          (p(!0), h(Ce, null, ot(_.value, (q) => (p(), h("li", {
            key: q.path,
            class: "fe-ppage__file",
            "data-dir": q.is_dir ? "1" : void 0
          }, [
            q.is_dir ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "fe-ppage__entry",
              "data-testid": `public-entry-${q.name}`,
              onClick: (C) => a("navigate", q.path)
            }, [
              c("bdi", null, y(q.name), 1)
            ], 8, Kse)) : (p(), h("a", {
              key: 1,
              href: q.url || e.link.downloadUrl({ path: q.path }),
              class: "fe-ppage__entry",
              "data-testid": `public-entry-${q.name}`,
              download: ""
            }, [
              c("bdi", null, y(q.name), 1)
            ], 8, Vse)),
            !q.is_dir && q.size !== void 0 ? (p(), h("span", jse, y(u(r)(q.size)), 1)) : D("", !0),
            q.modified ? (p(), h("span", qse, y(u(l)(q.modified)), 1)) : D("", !0)
          ], 8, Hse))), 128))
        ])) : D("", !0),
        c("div", Wse, [
          c("a", {
            class: "fe-btn fe-btn--primary",
            href: e.link.downloadUrl({ zip: !0 }),
            "data-testid": "public-share-zip"
          }, y(u(d)("folder_zip")), 9, Yse),
          _.value.length ? D("", !0) : (p(), h("a", {
            key: 0,
            class: "fe-btn",
            href: e.link.noJsUrl(),
            "data-testid": "public-share-browse"
          }, y(u(d)("browse")), 9, Gse))
        ])
      ])) : (p(), h("div", Xse, [
        k.value ? (p(), h("img", {
          key: 0,
          class: "fe-ppage__shot",
          src: e.link.downloadUrl(),
          alt: ((I = v.value) == null ? void 0 : I.name) ?? ""
        }, null, 8, Jse)) : D("", !0),
        c("p", Zse, [
          (G = v.value) != null && G.name ? D("", !0) : (p(), h("strong", Qse, y((Y = f.value) == null ? void 0 : Y.subject), 1)),
          ((ie = v.value) == null ? void 0 : ie.size) !== void 0 ? (p(), h("span", ele, y(u(r)((me = v.value) == null ? void 0 : me.size)), 1)) : D("", !0)
        ]),
        c("a", {
          class: "fe-btn fe-btn--primary",
          href: e.link.downloadUrl(),
          "data-testid": "public-share-download"
        }, y(u(i)("ctx.download")), 9, tle)
      ]));
    };
  }
}), nle = {
  class: "fe-pdrop",
  "data-testid": "public-request"
}, ale = {
  key: 0,
  class: "fe-surface__text",
  "data-testid": "public-request-folder"
}, ile = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-request-lead"
}, ole = {
  key: 1,
  class: "fe-pdrop__who",
  "data-testid": "public-request-name"
}, rle = { class: "fe-pdrop__wholabel" }, sle = ["maxlength", "placeholder", "disabled"], lle = ["onKeydown"], ule = { class: "fe-pdrop__lead" }, cle = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, dle = ["accept", "disabled"], fle = {
  key: 2,
  class: "fe-ppage__meta",
  "data-testid": "public-request-limits"
}, ple = {
  key: 0,
  "aria-hidden": "true"
}, hle = {
  key: 3,
  class: "fe-pdrop__list",
  "data-testid": "public-request-uploads"
}, mle = ["data-state"], vle = { class: "fe-pdrop__name" }, yle = { class: "fe-ppage__filesize" }, gle = ["value"], ble = {
  class: "fe-pdrop__saving",
  role: "status"
}, kle = {
  key: 2,
  class: "fe-pdrop__ok"
}, wle = {
  key: 3,
  class: "fe-pdrop__unconfirmed",
  role: "status"
}, _le = {
  key: 4,
  class: "fe-surface__error"
}, xle = /* @__PURE__ */ lt({
  __name: "PublicRequestBody",
  props: {
    info: {},
    uploads: {},
    locale: {},
    disabled: { type: Boolean },
    hideFolder: { type: Boolean }
  },
  emits: ["files"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = $(""), r = E(() => {
      var N, z;
      return ((z = (N = n.info) == null ? void 0 : N.limits) == null ? void 0 : z.ask_name) === !0;
    });
    function l(N) {
      a("files", N, r.value ? i.value.trim() : "");
    }
    const { formatSize: d } = yt(() => n.locale), { pt: f } = Pg(() => String(n.locale)), m = E(() => {
      var z, L;
      const N = (L = (z = n.info) == null ? void 0 : z.limits) == null ? void 0 : L.name_max;
      return typeof N == "number" && N > 0 ? N : void 0;
    }), v = $(null), b = $(!1), _ = E(() => {
      var N;
      return ((N = n.info) == null ? void 0 : N.limits) ?? {};
    }), w = E(() => {
      const N = _.value.allowed_ext ?? [];
      return N.length ? N.map((z) => `.${z.replace(/^\./, "")}`).join(",") : void 0;
    }), k = E(() => {
      var O;
      const N = [], z = _.value.max_file_size_mb;
      z && z > 0 && N.push(f("drop_limit_size", { mb: z }));
      const L = _.value.allowed_ext ?? [];
      L.length && N.push(f("drop_limit_ext", { types: L.map((U) => U.toUpperCase()).join(", ") }));
      const B = (O = n.info) == null ? void 0 : O.uploads_left;
      return B != null && Number.isFinite(B) && N.push(f("files_left", { count: B })), N;
    }), x = E(() => {
      var z;
      const N = (z = n.info) == null ? void 0 : z.uploads_left;
      return N != null && Number.isFinite(N) && N <= 0;
    });
    function M() {
      var N;
      n.disabled || x.value || (N = v.value) == null || N.click();
    }
    function A(N) {
      const z = N.target, L = Array.from(z.files ?? []);
      L.length && l(L), z.value = "";
    }
    function T(N) {
      var L;
      if (b.value = !1, n.disabled || x.value) return;
      const z = Array.from(((L = N.dataTransfer) == null ? void 0 : L.files) ?? []);
      z.length && l(z);
    }
    return (N, z) => {
      var L, B;
      return p(), h("div", nle, [
        (L = e.info) != null && L.folder && !e.hideFolder ? (p(), h("p", ale, [
          c("strong", null, y((B = e.info) == null ? void 0 : B.folder), 1)
        ])) : D("", !0),
        c("p", ile, y(u(f)("drop_sub")), 1),
        r.value && !x.value ? (p(), h("label", ole, [
          c("span", rle, y(u(f)("drop_name_label")), 1),
          un(c("input", {
            "onUpdate:modelValue": z[0] || (z[0] = (O) => i.value = O),
            class: "fe-pdrop__whoinput",
            type: "text",
            maxlength: m.value,
            autocomplete: "name",
            placeholder: u(f)("drop_name_ph"),
            disabled: e.disabled,
            "data-testid": "public-request-name-input"
          }, null, 8, sle), [
            [bn, i.value]
          ])
        ])) : D("", !0),
        c("div", {
          class: Fe(["fe-pdrop__zone", { "is-over": b.value, "is-disabled": e.disabled || x.value }]),
          role: "button",
          tabindex: "0",
          "data-testid": "public-request-drop",
          onClick: M,
          onKeydown: [
            $a(vt(M, ["prevent"]), ["enter"]),
            $a(vt(M, ["prevent"]), ["space"])
          ],
          onDragover: z[1] || (z[1] = vt((O) => b.value = !0, ["prevent"])),
          onDragleave: z[2] || (z[2] = (O) => b.value = !1),
          onDrop: vt(T, ["prevent"])
        }, [
          z[3] || (z[3] = c("svg", {
            class: "fe-pdrop__icon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.7",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            c("path", { d: "M4 14.9A7 7 0 1 1 15.7 8h1.8a4.5 4.5 0 0 1 2.5 8.2" }),
            c("path", { d: "M12 12v9" }),
            c("path", { d: "m16 16-4-4-4 4" })
          ], -1)),
          c("p", ule, y(x.value ? u(f)("request_full") : u(f)("drop_zone_big")), 1),
          x.value ? D("", !0) : (p(), h("p", cle, y(u(f)("drop_zone_hint")), 1)),
          c("input", {
            ref_key: "input",
            ref: v,
            class: "fe-pdrop__input",
            type: "file",
            multiple: "",
            accept: w.value,
            disabled: e.disabled || x.value,
            "data-testid": "public-request-input",
            onChange: A
          }, null, 40, dle)
        ], 42, lle),
        k.value.length ? (p(), h("p", fle, [
          (p(!0), h(Ce, null, ot(k.value, (O, U) => (p(), h(Ce, { key: U }, [
            U ? (p(), h("span", ple, "·")) : D("", !0),
            c("span", null, y(O), 1)
          ], 64))), 128))
        ])) : D("", !0),
        e.uploads.length ? (p(), h("ul", hle, [
          (p(!0), h(Ce, null, ot(e.uploads, (O, U) => (p(), h("li", {
            key: `${O.name}-${U}`,
            class: "fe-pdrop__item",
            "data-state": O.state
          }, [
            c("span", vle, [
              c("bdi", null, y(O.name), 1)
            ]),
            c("span", yle, y(u(d)(O.size)), 1),
            O.state === "sending" ? (p(), h("progress", {
              key: 0,
              class: "fe-pdrop__bar",
              max: 100,
              value: O.percent >= 0 ? O.percent : void 0
            }, null, 8, gle)) : O.state === "saving" ? (p(), h(Ce, { key: 1 }, [
              z[4] || (z[4] = c("progress", {
                class: "fe-pdrop__bar",
                max: 100
              }, null, -1)),
              c("span", ble, y(u(f)("upload_saving")), 1)
            ], 64)) : O.state === "done" ? (p(), h("span", kle, y(u(f)("upload_done")), 1)) : O.state === "unconfirmed" ? (p(), h("span", wle, y(O.error || u(f)("upload_unanswered")), 1)) : (p(), h("span", _le, y(O.error || u(f)("drop_err_generic")), 1))
          ], 8, mle))), 128))
        ])) : D("", !0)
      ]);
    };
  }
}), pde = /* @__PURE__ */ lt({
  __name: "PublicLinkPage",
  props: {
    kind: {},
    token: {},
    base: {},
    locale: {},
    theme: {}
  },
  setup(e) {
    const t = e, n = $(""), a = E(() => {
      if (t.locale) return String(t.locale);
      if (n.value) return n.value;
      const S = Ki(jf("locale"));
      return S && bf(S) ? S : M0();
    });
    function i(S) {
      const F = Ki(S);
      !F || !bf(F) || (n.value = F, Rr("locale", F));
    }
    const { t: r } = yt(() => a.value), l = oT({ base: t.base ?? Ku(), locale: () => a.value });
    rT(l);
    const d = $(!1);
    Xe(
      () => l.ready.value,
      (S) => {
        S && (d.value = !0);
      },
      { immediate: !0 }
    );
    function f(S, F = {}) {
      return sT(l.table.value, l.lang.value || a.value, S, F);
    }
    const m = t.base ?? Ku(), v = BI({ base: m }), b = xl(), _ = E(() => {
      const S = t.theme && t.theme !== "auto" ? t.theme : jf("theme") || v.themeDefault.value;
      return S === "light" || S === "dark" ? S : b.value ? "dark" : "light";
    }), w = {
      base: m,
      locale: () => a.value,
      errorText: () => r("plugin.view.error")
    }, k = t.kind === "share" ? Lre(t.token ?? "", w) : null, x = t.kind === "request" ? Nre(t.token ?? "", {
      ...w,
      errorText: () => f("drop_err_generic"),
      unansweredText: () => f("upload_unanswered")
    }) : null;
    function M(S) {
      return S.code === "ext" ? f("drop_err_ext", { name: S.name }) : S.code === "too_large" ? f("drop_err_too_large", { name: S.name, mb: S.mb }) : S.count <= 0 ? f("request_full") : f("drop_err_too_many", { count: S.count });
    }
    const A = k ?? x, T = E(() => (k == null ? void 0 : k.info.value) ?? null), N = E(() => (x == null ? void 0 : x.info.value) ?? null), z = E(() => {
      var I, G, Y, ie, me;
      const S = (I = T.value) == null ? void 0 : I.app, F = Gt((G = k == null ? void 0 : k.conv.current.value) == null ? void 0 : G.title, a.value);
      return S ? F || Gt(S.title, a.value) || "" : ((ie = (Y = T.value) == null ? void 0 : Y.node) == null ? void 0 : ie.name) || ((me = N.value) == null ? void 0 : me.folder) || "";
    }), L = E(() => {
      var F;
      const S = ((F = A.info.value) == null ? void 0 : F.subject) ?? "";
      return S && S !== z.value ? S : "";
    }), B = E(
      () => {
        var S, F, I;
        return nT(((S = T.value) == null ? void 0 : S.kind) ?? (x ? "drop" : ""), {
          list: (((I = (F = T.value) == null ? void 0 : F.entries) == null ? void 0 : I.length) ?? 0) > 0
        });
      }
    ), O = E(() => {
      var F;
      if (x) return "";
      const S = (F = T.value) == null ? void 0 : F.kind;
      return S === "folder" ? "folder" : S === "app" ? "" : "file";
    });
    function U(S) {
      A.load(S ? `?path=${encodeURIComponent(S)}` : "");
    }
    return Xe(z, (S) => {
      S && typeof document < "u" && (document.title = S);
    }), Xe(
      a,
      (S) => {
        typeof document < "u" && (document.documentElement.lang = S);
      },
      { immediate: !0 }
    ), Xe(a, () => {
      var S;
      A.status.value === "ready" && ((S = T.value) == null ? void 0 : S.kind) === "app" && (A.conv.current.value ? A.conv.post("change") : A.load());
    }), Wt(() => {
      if (v.load(), !t.token) {
        A.status.value = "not_found";
        return;
      }
      A.load();
    }), (S, F) => {
      var I, G, Y, ie;
      return p(), Je(lT, {
        status: d.value ? u(A).status.value : "loading",
        locale: a.value,
        theme: _.value,
        "brand-name": u(v).name.value,
        "logo-url": u(v).logo.value,
        "accent-style": u(v).accentStyle.value,
        "footer-text": u(v).footerText.value,
        "hide-powered-by": u(v).hidePoweredBy.value,
        layout: B.value,
        badge: O.value,
        title: z.value,
        subject: L.value,
        "expires-at": ((I = u(A).info.value) == null ? void 0 : I.expires_at) ?? null,
        "visits-left": ((G = T.value) == null ? void 0 : G.visits_left) ?? ((Y = N.value) == null ? void 0 : Y.uploads_left) ?? null,
        "pin-max": ((ie = u(A).info.value) == null ? void 0 : ie.pin_max) ?? null,
        "pin-busy": u(A).pinBusy.value,
        "pin-failure": u(A).pinFailure.value,
        "lock-message": u(A).lockMessage.value,
        failure: u(A).failure.value,
        onPin: F[1] || (F[1] = (me) => u(A).submitPin(me)),
        onRetry: F[2] || (F[2] = () => u(A).load()),
        "onUpdate:locale": i
      }, {
        default: gt(() => [
          u(k) ? (p(), Je(uT, {
            key: 0,
            link: u(k),
            locale: a.value,
            theme: _.value,
            onNavigate: U
          }, null, 8, ["link", "locale", "theme"])) : u(x) ? (p(), Je(xle, {
            key: 1,
            info: N.value,
            uploads: u(x).uploads.value,
            locale: a.value,
            "hide-folder": "",
            onFiles: F[0] || (F[0] = (me, q) => u(x).upload(me, { name: q, refusedText: M }))
          }, null, 8, ["info", "uploads", "locale"])) : D("", !0)
        ]),
        _: 1
      }, 8, ["status", "locale", "theme", "brand-name", "logo-url", "accent-style", "footer-text", "hide-powered-by", "layout", "badge", "title", "subject", "expires-at", "visits-left", "pin-max", "pin-busy", "pin-failure", "lock-message", "failure"]);
    };
  }
}), Sle = {
  class: "fe-ppreview",
  inert: "",
  "data-testid": "public-link-preview"
}, hde = /* @__PURE__ */ lt({
  __name: "PublicLinkPreview",
  props: {
    brandName: {},
    logoUrl: {},
    accent: {},
    footerText: {},
    hidePoweredBy: { type: Boolean },
    locale: {},
    theme: {},
    sample: {}
  },
  setup(e) {
    const t = e, n = E(() => t.sample ?? { name: "report-2026.pdf", size: 124e4, mime: "application/pdf" }), a = E(() => ({
      kind: "file",
      node: { name: n.value.name, size: n.value.size, mime: n.value.mime ?? "application/pdf" }
    })), i = E(
      () => ({
        info: $(a.value),
        downloadUrl: () => "#",
        noJsUrl: () => "#"
      })
    ), r = E(() => {
      var l;
      return ((l = t.brandName) == null ? void 0 : l.trim()) || Hf;
    });
    return rT(oT({ base: Ku(), locale: () => String(t.locale) })), (l, d) => {
      var f, m;
      return p(), h("div", Sle, [
        tt(lT, {
          status: "ready",
          locale: e.locale,
          theme: e.theme ?? "light",
          "brand-name": r.value,
          "logo-url": ((f = e.logoUrl) == null ? void 0 : f.trim()) || "",
          "accent-style": u(kS)(e.accent),
          "footer-text": ((m = e.footerText) == null ? void 0 : m.trim()) || "",
          "hide-powered-by": e.hidePoweredBy === !0,
          layout: u(nT)("file"),
          badge: "file",
          title: n.value.name,
          embedded: ""
        }, {
          default: gt(() => [
            tt(uT, {
              link: i.value,
              locale: e.locale,
              theme: e.theme ?? "light"
            }, null, 8, ["link", "locale", "theme"])
          ]),
          _: 1
        }, 8, ["locale", "theme", "brand-name", "logo-url", "accent-style", "footer-text", "hide-powered-by", "layout", "title"])
      ]);
    };
  }
}), $le = {
  key: 0,
  class: "fe-apppage__bar"
}, Tle = {
  class: "fe-apppage__title",
  "data-testid": "plugin-page-title"
}, Ale = ["title"], Ele = ["href"], Cle = {
  key: 0,
  class: "fe-surface__text",
  role: "status"
}, zle = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "plugin-page-loading"
}, Mle = {
  key: 1,
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "plugin-page-loading"
}, Ple = ["data-job"], Ole = {
  class: "fe-apppage__state-title",
  "data-testid": "plugin-page-job-title"
}, Dle = ["role"], Lle = { class: "fe-apppage__state-actions" }, Rle = ["href"], Nle = ["href"], Ile = {
  key: 4,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-done"
}, Ble = { class: "fe-apppage__state-title" }, Fle = { class: "fe-surface__text" }, Ule = { class: "fe-apppage__state-actions" }, Hle = ["href"], Kle = {
  key: 5,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-error"
}, Vle = { class: "fe-apppage__state-title" }, jle = {
  key: 0,
  class: "fe-surface__error"
}, qle = { class: "fe-apppage__state-actions" }, Wle = ["href"], Yle = {
  key: 4,
  class: "fe-apppage__foot"
}, mde = /* @__PURE__ */ lt({
  __name: "PluginPageView",
  props: {
    locale: {},
    theme: {},
    api: {},
    userName: {},
    plugin: {},
    view: {},
    path: {},
    storages: {},
    startAt: {},
    backHref: {},
    opsHref: {},
    mountBase: {},
    frame: {},
    section: {}
  },
  emits: ["op", "section"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = yt(() => a.locale), l = E(() => a.frame === "embedded"), d = E(() => l.value ? "div" : "main"), f = $("loading"), m = $(""), v = $(""), b = $("running"), _ = $(""), w = $(/* @__PURE__ */ new Set());
    function k(re) {
      const de = Bw(re, {
        plugin: a.plugin,
        base: a.mountBase,
        placementOf: (V) => w.value.has(V) ? "page" : void 0
      });
      if (!de.href) return !1;
      try {
        return window.location.assign(de.href), !0;
      } catch {
        return !1;
      }
    }
    function x(re) {
      if (re.status === "done") {
        _.value = re.message ?? "";
        const de = Ux(re);
        if (de && k(de.open)) {
          b.value = "opening";
          return;
        }
        b.value = "done";
        return;
      }
      _.value = $f(re, r).text, b.value = "failed";
    }
    const M = l2({}, a.api, { onSettled: x });
    function A(re) {
      var de;
      b.value = "running", _.value = "", (de = a.api.endpoints) != null && de.opsList && M.register(re);
    }
    const T = E(() => {
      switch (b.value) {
        case "done":
          return r("plugin.page_view.finished_title");
        case "failed":
          return r("plugin.page_view.failed_title");
        case "opening":
          return r("plugin.page_view.opening_title");
        default:
          return r("plugin.page_view.queued_title");
      }
    }), N = E(() => b.value === "running" ? r("plugin.page_view.queued_text") : b.value === "done" ? _.value || r("plugin.page_view.finished_text") : _.value), z = xp(
      {
        api: a.api,
        plugin: a.plugin,
        view: a.view,
        path: () => a.path,
        locale: () => a.locale,
        errorText: () => r("plugin.view.error")
      },
      {
        // ⚠ `onOp` fires BEFORE `onDone` (usePluginSurface posts them in that
        // order), so the queued state has to be set after both — otherwise
        // `onDone` would overwrite it with "finished" and the person would never
        // see that a job is running.
        /**
         * v3 §3.0 — "go to this file, and start that screen on it".
         *
         * ⚠ A real navigation, not a tab: this IS a whole page, and the person
         * asked to be taken to a document. The address is the explorer deep link
         * a notification already uses, so the placement question is answered
         * where it is answerable — the explorer knows which of the plugin's
         * views is a `page` and opens that one in its own tab.
         */
        onOpen: (re) => {
          const de = Bw(re, { plugin: a.plugin, base: a.mountBase });
          if (de.href)
            try {
              if (de.newTab) {
                const V = window.open(de.href, "_blank");
                V ? V.opener = null : window.location.assign(de.href);
              } else
                window.location.assign(de.href);
            } catch {
            }
        },
        onOp: (re) => {
          i("op", re), f.value = "queued", A(re);
        },
        onDone: () => {
          f.value !== "queued" && (f.value = "done");
        },
        onToast: (re) => v.value = re
      }
    ), L = z.current, B = E(() => {
      var re;
      return Gt((re = L.value) == null ? void 0 : re.title, a.locale) || a.view;
    }), O = $(a.section ?? ""), U = E(() => {
      var re;
      return ((re = L.value) == null ? void 0 : re.sections) ?? [];
    }), S = E(() => {
      var re;
      return ((re = L.value) == null ? void 0 : re.section) || O.value;
    });
    function F(re) {
      !re || re === S.value || (O.value = re, i("section", re), I());
    }
    Xe(
      () => a.section,
      (re) => {
        const de = re ?? "";
        de !== O.value && (O.value = de, I());
      }
    );
    async function I() {
      var re;
      L.value || (f.value = "loading"), m.value = "";
      try {
        const de = O.value ? await a.api.pluginView(a.plugin, a.view, a.path, O.value) : await a.api.pluginView(a.plugin, a.view, a.path);
        if (!(de != null && de.surface)) {
          m.value = r("plugin.view.error"), f.value = "error";
          return;
        }
        z.setSurface(de.surface), f.value = "surface";
        const V = de.surface.section ?? "";
        !O.value && V && (O.value = V, i("section", V, { replace: !0 }));
      } catch (de) {
        m.value = ((re = r.foreign) == null ? void 0 : re.call(r, String((de == null ? void 0 : de.message) ?? ""))) || r("plugin.view.error"), f.value = "error";
      }
    }
    const G = $(null), Y = $("page"), ie = $(!1), me = E(
      () => a.path ? [{ path: a.path, name: a.path.split("/").pop() || a.path }] : []
    );
    async function q() {
      try {
        const re = await a.api.pluginActions();
        w.value = new Set(
          (re.actions ?? []).filter((W) => W.plugin === a.plugin && W.view && Ef(W.view_placement)).map((W) => W.view)
        );
        const de = re.views.find((W) => W.plugin === a.plugin && W.id === a.view && W.ui);
        if (de != null && de.ui) {
          G.value = de.ui, Y.value = de.placement === "home" ? "home" : "page";
          return;
        }
        const V = re.actions.find((W) => W.plugin === a.plugin && W.view === a.view && W.ui);
        V != null && V.ui && (G.value = V.ui);
      } catch {
      } finally {
        ie.value = !0;
      }
    }
    Wt(async () => {
      await q(), G.value || I();
    }), t({ reload: I });
    const C = E(() => {
      var de;
      let re = !1;
      return zc((de = z.current.value) == null ? void 0 : de.nodes, (V) => {
        var W;
        V.type === "pdf-fields" && ((W = V.props) == null ? void 0 : W.mode) !== "define" && (re = !0);
      }), re;
    });
    return (re, de) => (p(), h("div", {
      class: Fe(["fe fe-apppage", [
        e.theme === "dark" ? "fe--theme-dark" : e.theme === "light" ? "fe--theme-light" : "",
        { "is-doc": C.value && !l.value, "fe-apppage--embedded": l.value }
      ]]),
      "data-testid": "plugin-page"
    }, [
      l.value ? D("", !0) : (p(), h("header", $le, [
        c("h1", Tle, y(B.value), 1),
        e.path ? (p(), h("p", {
          key: 0,
          class: "fe-apppage__path",
          title: e.path
        }, y(e.path), 9, Ale)) : D("", !0),
        e.backHref ? (p(), h("a", {
          key: 1,
          class: "fe-btn fe-apppage__back",
          href: e.backHref,
          "data-testid": "plugin-page-back"
        }, y(u(r)("plugin.page_view.back")), 9, Ele)) : D("", !0)
      ])),
      G.value ? (p(), Je(Ii(d.value), {
        key: 1,
        class: "fe-apppage__body fe-apppage__body--ui"
      }, {
        default: gt(() => [
          tt(cg, {
            api: e.api,
            app: e.plugin,
            version: G.value.version,
            view: e.view,
            placement: Y.value,
            ui: G.value,
            files: me.value,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            title: B.value,
            "user-name": e.userName,
            onToast: de[0] || (de[0] = (V) => v.value = V.text),
            onOp: de[1] || (de[1] = (V) => i("op", V))
          }, null, 8, ["api", "app", "version", "view", "placement", "ui", "files", "storages", "start-at", "locale", "theme", "title", "user-name"]),
          v.value ? (p(), h("p", Cle, y(v.value), 1)) : D("", !0)
        ]),
        _: 1
      })) : ie.value ? (p(), Je(Ii(d.value), {
        key: 3,
        class: "fe-apppage__body"
      }, {
        default: gt(() => [
          f.value === "surface" && U.value.length ? (p(), Je(I$, {
            key: 0,
            sections: U.value,
            active: S.value,
            locale: e.locale,
            label: B.value,
            disabled: u(z).busy.value,
            onSelect: F
          }, null, 8, ["sections", "active", "locale", "label", "disabled"])) : D("", !0),
          f.value === "loading" ? (p(), h("p", Mle, y(u(r)("plugin.view.loading")), 1)) : f.value === "surface" ? (p(), Je(Sp, {
            key: 2,
            conv: u(z),
            locale: e.locale,
            theme: e.theme,
            api: e.api,
            plugin: e.plugin,
            storages: e.storages,
            "start-at": e.startAt,
            toast: v.value,
            layout: l.value ? "inline" : "page"
          }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at", "toast", "layout"])) : f.value === "queued" ? (p(), h("div", {
            key: 3,
            class: "fe-apppage__state",
            "data-testid": "plugin-page-queued",
            "data-job": b.value
          }, [
            c("h2", Ole, y(T.value), 1),
            c("p", {
              class: Fe(b.value === "failed" ? "fe-surface__error" : "fe-surface__text"),
              role: b.value === "failed" ? "alert" : "status",
              "data-testid": "plugin-page-job-text"
            }, y(N.value), 11, Dle),
            c("div", Lle, [
              e.opsHref ? (p(), h("a", {
                key: 0,
                class: "fe-btn fe-btn--primary",
                href: e.opsHref,
                "data-testid": "plugin-page-ops"
              }, y(u(r)("plugin.page_view.open_ops")), 9, Rle)) : D("", !0),
              e.backHref ? (p(), h("a", {
                key: 1,
                class: "fe-btn",
                href: e.backHref
              }, y(u(r)("plugin.page_view.back")), 9, Nle)) : D("", !0)
            ])
          ], 8, Ple)) : f.value === "done" ? (p(), h("div", Ile, [
            c("h2", Ble, y(u(r)("plugin.page_view.done_title")), 1),
            c("p", Fle, y(u(r)("plugin.page_view.done_text")), 1),
            c("div", Ule, [
              e.backHref ? (p(), h("a", {
                key: 0,
                class: "fe-btn fe-btn--primary",
                href: e.backHref
              }, y(u(r)("plugin.page_view.back")), 9, Hle)) : D("", !0)
            ])
          ])) : (p(), h("div", Kle, [
            c("h2", Vle, y(u(r)("plugin.page_view.error_title")), 1),
            m.value ? (p(), h("p", jle, y(m.value), 1)) : D("", !0),
            c("div", qle, [
              c("button", {
                type: "button",
                class: "fe-btn",
                onClick: de[2] || (de[2] = (V) => I())
              }, y(u(r)("plugin.page_view.retry")), 1),
              e.backHref ? (p(), h("a", {
                key: 0,
                class: "fe-btn",
                href: e.backHref
              }, y(u(r)("plugin.page_view.back")), 9, Wle)) : D("", !0)
            ])
          ]))
        ]),
        _: 1
      })) : (p(), Je(Ii(d.value), {
        key: 2,
        class: "fe-apppage__body"
      }, {
        default: gt(() => [
          c("p", zle, y(u(r)("plugin.view.loading")), 1)
        ]),
        _: 1
      })),
      f.value === "surface" && u(z).footer.value.length ? (p(), h("footer", Yle, [
        tt($p, {
          conv: u(z),
          locale: e.locale,
          "testid-prefix": "plugin-page"
        }, null, 8, ["conv", "locale"])
      ])) : D("", !0)
    ], 2));
  }
});
function vde(e) {
  const t = e.trim().toLowerCase();
  return t === "7z" ? "7z" : t.toUpperCase();
}
const Gle = {
  key: 0,
  class: "fe-connlost",
  role: "status",
  "aria-live": "polite",
  "data-testid": "connection-notice"
}, Xle = { class: "fe-connlost__text" }, yde = /* @__PURE__ */ lt({
  __name: "ConnectionNotice",
  props: {
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = yt(() => t.locale ?? "en");
    return (a, i) => u(TM) ? (p(), h("div", Gle, [
      i[0] || (i[0] = c("span", {
        class: "fe-connlost__dot",
        "aria-hidden": "true"
      }, null, -1)),
      c("span", Xle, y(u(n)("err.network")), 1)
    ])) : D("", !0);
  }
});
export {
  nc as $,
  Hie as A,
  CP as B,
  U0 as C,
  EP as D,
  Wce as E,
  j0 as F,
  gue as G,
  Hf as H,
  zee as I,
  Aee as J,
  VS as K,
  dce as L,
  s4 as M,
  _r as N,
  xl as O,
  bue as P,
  Vue as Q,
  vP as R,
  jue as S,
  aL as T,
  gm as U,
  Cte as V,
  nde as W,
  _p as X,
  nY as Y,
  Kue as Z,
  na as _,
  sue as a,
  Rce as a$,
  Cee as a0,
  ui as a1,
  Nce as a2,
  ode as a3,
  gl as a4,
  Jce as a5,
  Vi as a6,
  jie as a7,
  Zce as a8,
  HW as a9,
  by as aA,
  a2 as aB,
  r2 as aC,
  Bue as aD,
  Iue as aE,
  V2 as aF,
  pD as aG,
  Df as aH,
  Ly as aI,
  Y0 as aJ,
  V0 as aK,
  lM as aL,
  uM as aM,
  dM as aN,
  kue as aO,
  Z0 as aP,
  _ue as aQ,
  $L as aR,
  ZR as aS,
  Er as aT,
  Ro as aU,
  Cce as aV,
  Ace as aW,
  Ece as aX,
  Yv as aY,
  pv as aZ,
  Oue as a_,
  FW as aa,
  Af as ab,
  Tx as ac,
  tde as ad,
  ade as ae,
  ede as af,
  ip as ag,
  kN as ah,
  ag as ai,
  hv as aj,
  v2 as ak,
  vi as al,
  hl as am,
  wf as an,
  hue as ao,
  vue as ap,
  mS as aq,
  VM as ar,
  Tue as as,
  Hr as at,
  Aue as au,
  Eue as av,
  Cue as aw,
  i2 as ax,
  vc as ay,
  zue as az,
  Fo as b,
  eT as b$,
  t7 as b0,
  qv as b1,
  vde as b2,
  Vie as b3,
  Pz as b4,
  Ite as b5,
  $0 as b6,
  Io as b7,
  nM as b8,
  jo as b9,
  Kte as bA,
  Ax as bB,
  Qv as bC,
  Bte as bD,
  d_ as bE,
  Kce as bF,
  z1 as bG,
  u$ as bH,
  qW as bI,
  Kf as bJ,
  h0 as bK,
  WM as bL,
  Hu as bM,
  sde as bN,
  uL as bO,
  que as bP,
  dq as bQ,
  Fte as bR,
  ote as bS,
  V$ as bT,
  $te as bU,
  P6 as bV,
  ZY as bW,
  Dce as bX,
  Q$ as bY,
  Ioe as bZ,
  Loe as b_,
  NW as ba,
  ij as bb,
  yde as bc,
  iW as bd,
  Rie as be,
  Jx as bf,
  La as bg,
  km as bh,
  J$ as bi,
  hQ as bj,
  eM as bk,
  Zz as bl,
  Qz as bm,
  Yn as bn,
  Vr as bo,
  pp as bp,
  W2 as bq,
  gc as br,
  vD as bs,
  ha as bt,
  fp as bu,
  Nu as bv,
  of as bw,
  mo as bx,
  Py as by,
  sn as bz,
  bw as c,
  pM as c$,
  Roe as c0,
  Noe as c1,
  lf as c2,
  Dv as c3,
  uP as c4,
  GM as c5,
  _S as c6,
  NB as c7,
  ic as c8,
  Tte as c9,
  dB as cA,
  gB as cB,
  yS as cC,
  Ix as cD,
  p$ as cE,
  Zf as cF,
  uc as cG,
  Tf as cH,
  Du as cI,
  oM as cJ,
  y$ as cK,
  ep as cL,
  mG as cM,
  p2 as cN,
  cY as cO,
  c$ as cP,
  EL as cQ,
  q1 as cR,
  j$ as cS,
  Wie as cT,
  cce as cU,
  fce as cV,
  uce as cW,
  R$ as cX,
  kS as cY,
  Iz as cZ,
  Vte as c_,
  xg as ca,
  iT as cb,
  ude as cc,
  mde as cd,
  Xre as ce,
  zre as cf,
  pde as cg,
  hde as ch,
  qre as ci,
  xle as cj,
  uT as ck,
  lT as cl,
  nL as cm,
  UL as cn,
  V5 as co,
  Aj as cp,
  Fv as cq,
  U4 as cr,
  pl as cs,
  Vj as ct,
  pee as cu,
  F4 as cv,
  E5 as cw,
  n$ as cx,
  Sp as cy,
  $p as cz,
  Gce as d,
  B2 as d$,
  hM as d0,
  Pue as d1,
  sM as d2,
  $D as d3,
  h$ as d4,
  Eg as d5,
  pce as d6,
  Ku as d7,
  O6 as d8,
  wy as d9,
  _u as dA,
  iy as dB,
  Yue as dC,
  nce as dD,
  Ev as dE,
  Zue as dF,
  oce as dG,
  qM as dH,
  oS as dI,
  xce as dJ,
  TM as dK,
  xue as dL,
  Sue as dM,
  _a as dN,
  vV as dO,
  bW as dP,
  d$ as dQ,
  gW as dR,
  kW as dS,
  yW as dT,
  wx as dU,
  $v as dV,
  xZ as dW,
  FD as dX,
  Lue as dY,
  Ute as dZ,
  vee as d_,
  _y as da,
  xy as db,
  Qce as dc,
  Pce as dd,
  f4 as de,
  UW as df,
  jW as dg,
  rL as dh,
  L$ as di,
  _L as dj,
  hL as dk,
  m0 as dl,
  ng as dm,
  zV as dn,
  RV as dp,
  MV as dq,
  EV as dr,
  CV as ds,
  AV as dt,
  Jue as du,
  SZ as dv,
  pc as dw,
  el as dx,
  Sl as dy,
  DW as dz,
  tM as e,
  vg as e$,
  I2 as e0,
  rde as e1,
  yo as e2,
  B9 as e3,
  TD as e4,
  Rf as e5,
  _v as e6,
  Fm as e7,
  M2 as e8,
  bp as e9,
  Z$ as eA,
  Zv as eB,
  Vee as eC,
  jte as eD,
  sS as eE,
  iS as eF,
  l4 as eG,
  YB as eH,
  lo as eI,
  Ex as eJ,
  Av as eK,
  f_ as eL,
  Uue as eM,
  xx as eN,
  $x as eO,
  _ce as eP,
  lS as eQ,
  yM as eR,
  wD as eS,
  xM as eT,
  yce as eU,
  mce as eV,
  tce as eW,
  mp as eX,
  GW as eY,
  zP as eZ,
  yg as e_,
  FI as ea,
  OM as eb,
  UH as ec,
  b4 as ed,
  Vo as ee,
  xN as ef,
  sce as eg,
  M0 as eh,
  Xie as ei,
  Q3 as ej,
  Ga as ek,
  vQ as el,
  SN as em,
  KH as en,
  rue as eo,
  vv as ep,
  yp as eq,
  Bs as er,
  Tv as es,
  i_ as et,
  yv as eu,
  C0 as ev,
  noe as ew,
  Q2 as ex,
  X2 as ey,
  s_ as ez,
  ya as f,
  T0 as f$,
  LV as f0,
  TV as f1,
  Nv as f2,
  f$ as f3,
  bf as f4,
  cl as f5,
  $l as f6,
  _B as f7,
  I4 as f8,
  yQ as f9,
  ooe as fA,
  l$ as fB,
  aP as fC,
  tc as fD,
  Cu as fE,
  vy as fF,
  f3 as fG,
  Yx as fH,
  hce as fI,
  Ur as fJ,
  N0 as fK,
  Jz as fL,
  Ux as fM,
  ml as fN,
  AM as fO,
  tl as fP,
  Wx as fQ,
  r4 as fR,
  Ec as fS,
  DM as fT,
  oue as fU,
  UI as fV,
  oT as fW,
  Ow as fX,
  jf as fY,
  jB as fZ,
  ol as f_,
  Jv as fa,
  gf as fb,
  Fr as fc,
  Sce as fd,
  G2 as fe,
  _D as ff,
  $N as fg,
  bS as fh,
  kw as fi,
  nv as fj,
  Ar as fk,
  cP as fl,
  tg as fm,
  SB as fn,
  wl as fo,
  mue as fp,
  ev as fq,
  aS as fr,
  Ys as fs,
  QR as ft,
  jM as fu,
  Hee as fv,
  df as fw,
  rp as fx,
  Ef as fy,
  Lv as fz,
  gw as g,
  Lp as g$,
  E0 as g0,
  iue as g1,
  Bz as g2,
  np as g3,
  ei as g4,
  Ac as g5,
  a4 as g6,
  i4 as g7,
  Lr as g8,
  Ov as g9,
  Fce as gA,
  Bce as gB,
  Nee as gC,
  Hte as gD,
  oG as gE,
  lg as gF,
  Cp as gG,
  VB as gH,
  zx as gI,
  qx as gJ,
  t4 as gK,
  ww as gL,
  HS as gM,
  JM as gN,
  Vs as gO,
  Bw as gP,
  Eee as gQ,
  HH as gR,
  zg as gS,
  Uoe as gT,
  Foe as gU,
  Hoe as gV,
  lde as gW,
  y0 as gX,
  eg as gY,
  Nue as gZ,
  tT as g_,
  R4 as ga,
  ly as gb,
  g$ as gc,
  Z2 as gd,
  Ui as ge,
  u_ as gf,
  QD as gg,
  o2 as gh,
  Xw as gi,
  Gue as gj,
  Xue as gk,
  l1 as gl,
  B6 as gm,
  ji as gn,
  LW as go,
  av as gp,
  Gy as gq,
  ig as gr,
  uf as gs,
  Ki as gt,
  Fw as gu,
  X_ as gv,
  c4 as gw,
  Xce as gx,
  iv as gy,
  ov as gz,
  H0 as h,
  Oce as h$,
  gce as h0,
  Tce as h1,
  zu as h2,
  vce as h3,
  R6 as h4,
  Lz as h5,
  $y as h6,
  d2 as h7,
  tP as h8,
  lP as h9,
  oL as hA,
  U$ as hB,
  y_ as hC,
  Gz as hD,
  pue as hE,
  nZ as hF,
  Rz as hG,
  HB as hH,
  UB as hI,
  _Z as hJ,
  mM as hK,
  Sx as hL,
  FB as hM,
  wue as hN,
  Wue as hO,
  $Z as hP,
  fQ as hQ,
  Pre as hR,
  ice as hS,
  $ue as hT,
  aue as hU,
  $ce as hV,
  Lce as hW,
  aZ as hX,
  t2 as hY,
  lL as hZ,
  H$ as h_,
  XM as ha,
  s2 as hb,
  Sy as hc,
  iM as hd,
  cy as he,
  yue as hf,
  Ep as hg,
  $S as hh,
  KB as hi,
  sp as hj,
  jce as hk,
  q$ as hl,
  rT as hm,
  xL as hn,
  toe as ho,
  n2 as hp,
  nT as hq,
  aT as hr,
  dde as hs,
  T1 as ht,
  cde as hu,
  sT as hv,
  Ice as hw,
  Dz as hx,
  gp as hy,
  bZ as hz,
  kf as i,
  S0 as i$,
  CL as i0,
  cm as i1,
  Kee as i2,
  p4 as i3,
  d4 as i4,
  Qx as i5,
  tZ as i6,
  eZ as i7,
  lue as i8,
  j1 as i9,
  V4 as iA,
  due as iB,
  cue as iC,
  ioe as iD,
  aoe as iE,
  $B as iF,
  L4 as iG,
  RW as iH,
  Wa as iI,
  sD as iJ,
  B4 as iK,
  P4 as iL,
  L_ as iM,
  uue as iN,
  XW as iO,
  N5 as iP,
  kx as iQ,
  rce as iR,
  I5 as iS,
  cv as iT,
  Hz as iU,
  Dc as iV,
  IW as iW,
  cM as iX,
  M4 as iY,
  iL as iZ,
  Bm as i_,
  Uo as ia,
  qH as ib,
  wce as ic,
  fc as id,
  fue as ie,
  Qd as ig,
  ace as ih,
  Que as ii,
  zce as ij,
  Hue as ik,
  fM as il,
  sL as im,
  Rr as io,
  Nz as ip,
  z0 as iq,
  B5 as ir,
  KW as is,
  II as it,
  Ore as iu,
  K$ as iv,
  Dre as iw,
  Mre as ix,
  Hce as iy,
  Zx as iz,
  nee as j,
  Um as j$,
  yX as j0,
  mQ as j1,
  Cc as j2,
  ay as j3,
  wZ as j4,
  CD as j5,
  ix as j6,
  Fue as j7,
  ax as j8,
  g4 as j9,
  WH as jA,
  SL as jB,
  XJ as jC,
  VW as jD,
  fq as jE,
  RM as jF,
  W1 as jG,
  ex as jH,
  lce as jI,
  wL as jJ,
  Ls as jK,
  fL as jL,
  KS as jM,
  Jy as jN,
  ide as jO,
  ece as jP,
  bce as jQ,
  g0 as jR,
  Tw as jS,
  My as jT,
  K2 as jU,
  Due as jV,
  kce as jW,
  RI as jX,
  XQ as jY,
  Aa as jZ,
  w$ as j_,
  Uce as ja,
  Xee as jb,
  nue as jc,
  SD as jd,
  dm as je,
  yV as jf,
  Mce as jg,
  _l as jh,
  YM as ji,
  Mue as jj,
  jj as jk,
  Iee as jl,
  tG as jm,
  l2 as jn,
  fP as jo,
  xp as jp,
  BI as jq,
  Mg as jr,
  fde as js,
  Nre as jt,
  Lre as ju,
  Pg as jv,
  IH as jw,
  oj as jx,
  Ej as jy,
  Iw as jz,
  zt as k,
  Rs as k0,
  vf as k1,
  qa as k2,
  Ks as k3,
  UZ as k4,
  Or as k5,
  Rue as k6,
  qZ as k7,
  Gt as l,
  gg as m,
  cg as n,
  qce as o,
  H1 as p,
  R0 as q,
  pa as r,
  Vce as s,
  Pie as t,
  yt as u,
  AP as v,
  tue as w,
  fi as x,
  Sa as y,
  Yce as z
};
//# sourceMappingURL=index-DAGrP0vE.js.map
